(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire65d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire65d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1bxDW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cQmdI"));

});
parcelRegister("cQmdI", function(module, exports) {
/** @license React v16.10.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $b6jnv = parcelRequire("b6jnv");
var $959b93d03a0ea2ba$var$n = "function" === typeof Symbol && Symbol.for, $959b93d03a0ea2ba$var$p = $959b93d03a0ea2ba$var$n ? Symbol.for("react.element") : 60103, $959b93d03a0ea2ba$var$q = $959b93d03a0ea2ba$var$n ? Symbol.for("react.portal") : 60106, $959b93d03a0ea2ba$var$r = $959b93d03a0ea2ba$var$n ? Symbol.for("react.fragment") : 60107, $959b93d03a0ea2ba$var$t = $959b93d03a0ea2ba$var$n ? Symbol.for("react.strict_mode") : 60108, $959b93d03a0ea2ba$var$u = $959b93d03a0ea2ba$var$n ? Symbol.for("react.profiler") : 60114, $959b93d03a0ea2ba$var$v = $959b93d03a0ea2ba$var$n ? Symbol.for("react.provider") : 60109, $959b93d03a0ea2ba$var$w = $959b93d03a0ea2ba$var$n ? Symbol.for("react.context") : 60110, $959b93d03a0ea2ba$var$x = $959b93d03a0ea2ba$var$n ? Symbol.for("react.forward_ref") : 60112, $959b93d03a0ea2ba$var$y = $959b93d03a0ea2ba$var$n ? Symbol.for("react.suspense") : 60113, $959b93d03a0ea2ba$var$aa = $959b93d03a0ea2ba$var$n ? Symbol.for("react.suspense_list") : 60120, $959b93d03a0ea2ba$var$ba = $959b93d03a0ea2ba$var$n ? Symbol.for("react.memo") : 60115, $959b93d03a0ea2ba$var$ca = $959b93d03a0ea2ba$var$n ? Symbol.for("react.lazy") : 60116;
$959b93d03a0ea2ba$var$n && Symbol.for("react.fundamental");
$959b93d03a0ea2ba$var$n && Symbol.for("react.responder");
$959b93d03a0ea2ba$var$n && Symbol.for("react.scope");
var $959b93d03a0ea2ba$var$z = "function" === typeof Symbol && Symbol.iterator;
function $959b93d03a0ea2ba$var$A(a) {
    for(var b = a.message, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, d = 1; d < arguments.length; d++)c += "&args[]=" + encodeURIComponent(arguments[d]);
    a.message = "Minified React error #" + b + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";
    return a;
}
var $959b93d03a0ea2ba$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $959b93d03a0ea2ba$var$C = {};
function $959b93d03a0ea2ba$var$D(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $959b93d03a0ea2ba$var$C;
    this.updater = c || $959b93d03a0ea2ba$var$B;
}
$959b93d03a0ea2ba$var$D.prototype.isReactComponent = {};
$959b93d03a0ea2ba$var$D.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw $959b93d03a0ea2ba$var$A(Error(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$959b93d03a0ea2ba$var$D.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $959b93d03a0ea2ba$var$E() {}
$959b93d03a0ea2ba$var$E.prototype = $959b93d03a0ea2ba$var$D.prototype;
function $959b93d03a0ea2ba$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $959b93d03a0ea2ba$var$C;
    this.updater = c || $959b93d03a0ea2ba$var$B;
}
var $959b93d03a0ea2ba$var$G = $959b93d03a0ea2ba$var$F.prototype = new $959b93d03a0ea2ba$var$E;
$959b93d03a0ea2ba$var$G.constructor = $959b93d03a0ea2ba$var$F;
$b6jnv($959b93d03a0ea2ba$var$G, $959b93d03a0ea2ba$var$D.prototype);
$959b93d03a0ea2ba$var$G.isPureReactComponent = !0;
var $959b93d03a0ea2ba$var$H = {
    current: null
}, $959b93d03a0ea2ba$var$I = {
    suspense: null
}, $959b93d03a0ea2ba$var$J = {
    current: null
}, $959b93d03a0ea2ba$var$K = Object.prototype.hasOwnProperty, $959b93d03a0ea2ba$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $959b93d03a0ea2ba$var$M(a, b, c) {
    var d, e = {}, g = null, l = null;
    if (null != b) for(d in void 0 !== b.ref && (l = b.ref), void 0 !== b.key && (g = "" + b.key), b)$959b93d03a0ea2ba$var$K.call(b, d) && !$959b93d03a0ea2ba$var$L.hasOwnProperty(d) && (e[d] = b[d]);
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        for(var k = Array(f), m = 0; m < f; m++)k[m] = arguments[m + 2];
        e.children = k;
    }
    if (a && a.defaultProps) for(d in f = a.defaultProps, f)void 0 === e[d] && (e[d] = f[d]);
    return {
        $$typeof: $959b93d03a0ea2ba$var$p,
        type: a,
        key: g,
        ref: l,
        props: e,
        _owner: $959b93d03a0ea2ba$var$J.current
    };
}
function $959b93d03a0ea2ba$var$da(a, b) {
    return {
        $$typeof: $959b93d03a0ea2ba$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $959b93d03a0ea2ba$var$N(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $959b93d03a0ea2ba$var$p;
}
function $959b93d03a0ea2ba$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $959b93d03a0ea2ba$var$O = /\/+/g, $959b93d03a0ea2ba$var$P = [];
function $959b93d03a0ea2ba$var$Q(a, b, c, d) {
    if ($959b93d03a0ea2ba$var$P.length) {
        var e = $959b93d03a0ea2ba$var$P.pop();
        e.result = a;
        e.keyPrefix = b;
        e.func = c;
        e.context = d;
        e.count = 0;
        return e;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: d,
        count: 0
    };
}
function $959b93d03a0ea2ba$var$R(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $959b93d03a0ea2ba$var$P.length && $959b93d03a0ea2ba$var$P.push(a);
}
function $959b93d03a0ea2ba$var$S(a, b, c, d) {
    var e = typeof a;
    if ("undefined" === e || "boolean" === e) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(e){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $959b93d03a0ea2ba$var$p:
                case $959b93d03a0ea2ba$var$q:
                    g = !0;
            }
    }
    if (g) return c(d, a, "" === b ? "." + $959b93d03a0ea2ba$var$T(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var l = 0; l < a.length; l++){
        e = a[l];
        var f = b + $959b93d03a0ea2ba$var$T(e, l);
        g += $959b93d03a0ea2ba$var$S(e, f, c, d);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $959b93d03a0ea2ba$var$z && a[$959b93d03a0ea2ba$var$z] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), l = 0; !(e = a.next()).done;)e = e.value, f = b + $959b93d03a0ea2ba$var$T(e, l++), g += $959b93d03a0ea2ba$var$S(e, f, c, d);
    else if ("object" === e) throw c = "" + a, $959b93d03a0ea2ba$var$A(Error(31), "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, "");
    return g;
}
function $959b93d03a0ea2ba$var$U(a, b, c) {
    return null == a ? 0 : $959b93d03a0ea2ba$var$S(a, "", b, c);
}
function $959b93d03a0ea2ba$var$T(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $959b93d03a0ea2ba$var$escape(a.key) : b.toString(36);
}
function $959b93d03a0ea2ba$var$ea(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $959b93d03a0ea2ba$var$fa(a, b, c) {
    var d = a.result, e = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $959b93d03a0ea2ba$var$V(a, d, c, function(a) {
        return a;
    }) : null != a && ($959b93d03a0ea2ba$var$N(a) && (a = $959b93d03a0ea2ba$var$da(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($959b93d03a0ea2ba$var$O, "$&/") + "/") + c)), d.push(a));
}
function $959b93d03a0ea2ba$var$V(a, b, c, d, e) {
    var g = "";
    null != c && (g = ("" + c).replace($959b93d03a0ea2ba$var$O, "$&/") + "/");
    b = $959b93d03a0ea2ba$var$Q(b, g, d, e);
    $959b93d03a0ea2ba$var$U(a, $959b93d03a0ea2ba$var$fa, b);
    $959b93d03a0ea2ba$var$R(b);
}
function $959b93d03a0ea2ba$var$W() {
    var a = $959b93d03a0ea2ba$var$H.current;
    if (null === a) throw $959b93d03a0ea2ba$var$A(Error(321));
    return a;
}
var $959b93d03a0ea2ba$var$X = {
    Children: {
        map: function(a, b, c) {
            if (null == a) return a;
            var d = [];
            $959b93d03a0ea2ba$var$V(a, d, null, b, c);
            return d;
        },
        forEach: function(a, b, c) {
            if (null == a) return a;
            b = $959b93d03a0ea2ba$var$Q(null, null, b, c);
            $959b93d03a0ea2ba$var$U(a, $959b93d03a0ea2ba$var$ea, b);
            $959b93d03a0ea2ba$var$R(b);
        },
        count: function(a) {
            return $959b93d03a0ea2ba$var$U(a, function() {
                return null;
            }, null);
        },
        toArray: function(a) {
            var b = [];
            $959b93d03a0ea2ba$var$V(a, b, null, function(a) {
                return a;
            });
            return b;
        },
        only: function(a) {
            if (!$959b93d03a0ea2ba$var$N(a)) throw $959b93d03a0ea2ba$var$A(Error(143));
            return a;
        }
    },
    createRef: function() {
        return {
            current: null
        };
    },
    Component: $959b93d03a0ea2ba$var$D,
    PureComponent: $959b93d03a0ea2ba$var$F,
    createContext: function(a, b) {
        void 0 === b && (b = null);
        a = {
            $$typeof: $959b93d03a0ea2ba$var$w,
            _calculateChangedBits: b,
            _currentValue: a,
            _currentValue2: a,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        a.Provider = {
            $$typeof: $959b93d03a0ea2ba$var$v,
            _context: a
        };
        return a.Consumer = a;
    },
    forwardRef: function(a) {
        return {
            $$typeof: $959b93d03a0ea2ba$var$x,
            render: a
        };
    },
    lazy: function(a) {
        return {
            $$typeof: $959b93d03a0ea2ba$var$ca,
            _ctor: a,
            _status: -1,
            _result: null
        };
    },
    memo: function(a, b) {
        return {
            $$typeof: $959b93d03a0ea2ba$var$ba,
            type: a,
            compare: void 0 === b ? null : b
        };
    },
    useCallback: function(a, b) {
        return $959b93d03a0ea2ba$var$W().useCallback(a, b);
    },
    useContext: function(a, b) {
        return $959b93d03a0ea2ba$var$W().useContext(a, b);
    },
    useEffect: function(a, b) {
        return $959b93d03a0ea2ba$var$W().useEffect(a, b);
    },
    useImperativeHandle: function(a, b, c) {
        return $959b93d03a0ea2ba$var$W().useImperativeHandle(a, b, c);
    },
    useDebugValue: function() {},
    useLayoutEffect: function(a, b) {
        return $959b93d03a0ea2ba$var$W().useLayoutEffect(a, b);
    },
    useMemo: function(a, b) {
        return $959b93d03a0ea2ba$var$W().useMemo(a, b);
    },
    useReducer: function(a, b, c) {
        return $959b93d03a0ea2ba$var$W().useReducer(a, b, c);
    },
    useRef: function(a) {
        return $959b93d03a0ea2ba$var$W().useRef(a);
    },
    useState: function(a) {
        return $959b93d03a0ea2ba$var$W().useState(a);
    },
    Fragment: $959b93d03a0ea2ba$var$r,
    Profiler: $959b93d03a0ea2ba$var$u,
    StrictMode: $959b93d03a0ea2ba$var$t,
    Suspense: $959b93d03a0ea2ba$var$y,
    unstable_SuspenseList: $959b93d03a0ea2ba$var$aa,
    createElement: $959b93d03a0ea2ba$var$M,
    cloneElement: function(a, b, c) {
        if (null === a || void 0 === a) throw $959b93d03a0ea2ba$var$A(Error(267), a);
        var d = $b6jnv({}, a.props), e = a.key, g = a.ref, l = a._owner;
        if (null != b) {
            void 0 !== b.ref && (g = b.ref, l = $959b93d03a0ea2ba$var$J.current);
            void 0 !== b.key && (e = "" + b.key);
            if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
            for(k in b)$959b93d03a0ea2ba$var$K.call(b, k) && !$959b93d03a0ea2ba$var$L.hasOwnProperty(k) && (d[k] = void 0 === b[k] && void 0 !== f ? f[k] : b[k]);
        }
        var k = arguments.length - 2;
        if (1 === k) d.children = c;
        else if (1 < k) {
            f = Array(k);
            for(var m = 0; m < k; m++)f[m] = arguments[m + 2];
            d.children = f;
        }
        return {
            $$typeof: $959b93d03a0ea2ba$var$p,
            type: a.type,
            key: e,
            ref: g,
            props: d,
            _owner: l
        };
    },
    createFactory: function(a) {
        var b = $959b93d03a0ea2ba$var$M.bind(null, a);
        b.type = a;
        return b;
    },
    isValidElement: $959b93d03a0ea2ba$var$N,
    version: "16.10.0",
    unstable_withSuspenseConfig: function(a, b) {
        var c = $959b93d03a0ea2ba$var$I.suspense;
        $959b93d03a0ea2ba$var$I.suspense = void 0 === b ? null : b;
        try {
            a();
        } finally{
            $959b93d03a0ea2ba$var$I.suspense = c;
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: $959b93d03a0ea2ba$var$H,
        ReactCurrentBatchConfig: $959b93d03a0ea2ba$var$I,
        ReactCurrentOwner: $959b93d03a0ea2ba$var$J,
        IsSomeRendererActing: {
            current: !1
        },
        assign: $b6jnv
    }
}, $959b93d03a0ea2ba$var$Y = {
    default: $959b93d03a0ea2ba$var$X
}, $959b93d03a0ea2ba$var$Z = $959b93d03a0ea2ba$var$Y && $959b93d03a0ea2ba$var$X || $959b93d03a0ea2ba$var$Y;
module.exports = $959b93d03a0ea2ba$var$Z.default || $959b93d03a0ea2ba$var$Z;

});
parcelRegister("b6jnv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $814f495adec83164$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $814f495adec83164$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $814f495adec83164$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $814f495adec83164$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $814f495adec83164$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $814f495adec83164$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $814f495adec83164$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($814f495adec83164$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($814f495adec83164$var$getOwnPropertySymbols) {
            symbols = $814f495adec83164$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($814f495adec83164$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("3y7YU", function(module, exports) {
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $1bxDW = parcelRequire("1bxDW");

var $b6jnv = parcelRequire("b6jnv");

var $cMXW6 = parcelRequire("cMXW6");
function $295abd054c1837dd$var$ba(a, b, c, d, e, f, g, h) {
    if (!a) {
        a = void 0;
        if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var l = [
                c,
                d,
                e,
                f,
                g,
                h
            ], k = 0;
            a = Error(b.replace(/%s/g, function() {
                return l[k++];
            }));
            a.name = "Invariant Violation";
        }
        a.framesToPop = 1;
        throw a;
    }
}
function $295abd054c1837dd$var$x(a) {
    for(var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++)c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
    $295abd054c1837dd$var$ba(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}
$1bxDW || $295abd054c1837dd$var$x("227");
function $295abd054c1837dd$var$ca(a, b, c, d, e, f, g, h, l) {
    var k = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, k);
    } catch (m) {
        this.onError(m);
    }
}
var $295abd054c1837dd$var$da = !1, $295abd054c1837dd$var$ea = null, $295abd054c1837dd$var$fa = !1, $295abd054c1837dd$var$ha = null, $295abd054c1837dd$var$ia = {
    onError: function(a) {
        $295abd054c1837dd$var$da = !0;
        $295abd054c1837dd$var$ea = a;
    }
};
function $295abd054c1837dd$var$ja(a, b, c, d, e, f, g, h, l) {
    $295abd054c1837dd$var$da = !1;
    $295abd054c1837dd$var$ea = null;
    $295abd054c1837dd$var$ca.apply($295abd054c1837dd$var$ia, arguments);
}
function $295abd054c1837dd$var$ka(a, b, c, d, e, f, g, h, l) {
    $295abd054c1837dd$var$ja.apply(this, arguments);
    if ($295abd054c1837dd$var$da) {
        if ($295abd054c1837dd$var$da) {
            var k = $295abd054c1837dd$var$ea;
            $295abd054c1837dd$var$da = !1;
            $295abd054c1837dd$var$ea = null;
        } else $295abd054c1837dd$var$x("198"), k = void 0;
        $295abd054c1837dd$var$fa || ($295abd054c1837dd$var$fa = !0, $295abd054c1837dd$var$ha = k);
    }
}
var $295abd054c1837dd$var$la = null, $295abd054c1837dd$var$ma = {};
function $295abd054c1837dd$var$na() {
    if ($295abd054c1837dd$var$la) for(var a in $295abd054c1837dd$var$ma){
        var b = $295abd054c1837dd$var$ma[a], c = $295abd054c1837dd$var$la.indexOf(a);
        -1 < c || $295abd054c1837dd$var$x("96", a);
        if (!$295abd054c1837dd$var$oa[c]) {
            b.extractEvents || $295abd054c1837dd$var$x("97", a);
            $295abd054c1837dd$var$oa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                $295abd054c1837dd$var$pa.hasOwnProperty(h) && $295abd054c1837dd$var$x("99", h);
                $295abd054c1837dd$var$pa[h] = f;
                var l = f.phasedRegistrationNames;
                if (l) {
                    for(e in l)l.hasOwnProperty(e) && $295abd054c1837dd$var$qa(l[e], g, h);
                    e = !0;
                } else f.registrationName ? ($295abd054c1837dd$var$qa(f.registrationName, g, h), e = !0) : e = !1;
                e || $295abd054c1837dd$var$x("98", d, a);
            }
        }
    }
}
function $295abd054c1837dd$var$qa(a, b, c) {
    $295abd054c1837dd$var$ra[a] && $295abd054c1837dd$var$x("100", a);
    $295abd054c1837dd$var$ra[a] = b;
    $295abd054c1837dd$var$sa[a] = b.eventTypes[c].dependencies;
}
var $295abd054c1837dd$var$oa = [], $295abd054c1837dd$var$pa = {}, $295abd054c1837dd$var$ra = {}, $295abd054c1837dd$var$sa = {}, $295abd054c1837dd$var$ta = null, $295abd054c1837dd$var$ua = null, $295abd054c1837dd$var$va = null;
function $295abd054c1837dd$var$wa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $295abd054c1837dd$var$va(c);
    $295abd054c1837dd$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
function $295abd054c1837dd$var$xa(a, b) {
    null == b && $295abd054c1837dd$var$x("30");
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $295abd054c1837dd$var$ya(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $295abd054c1837dd$var$za = null;
function $295abd054c1837dd$var$Aa(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$295abd054c1837dd$var$wa(a, b[d], c[d]);
        else b && $295abd054c1837dd$var$wa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
var $295abd054c1837dd$var$Ba = {
    injectEventPluginOrder: function(a) {
        $295abd054c1837dd$var$la && $295abd054c1837dd$var$x("101");
        $295abd054c1837dd$var$la = Array.prototype.slice.call(a);
        $295abd054c1837dd$var$na();
    },
    injectEventPluginsByName: function(a) {
        var b = !1, c;
        for(c in a)if (a.hasOwnProperty(c)) {
            var d = a[c];
            $295abd054c1837dd$var$ma.hasOwnProperty(c) && $295abd054c1837dd$var$ma[c] === d || ($295abd054c1837dd$var$ma[c] && $295abd054c1837dd$var$x("102", c), $295abd054c1837dd$var$ma[c] = d, b = !0);
        }
        b && $295abd054c1837dd$var$na();
    }
};
function $295abd054c1837dd$var$Ca(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $295abd054c1837dd$var$ta(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    c && "function" !== typeof c && $295abd054c1837dd$var$x("231", b, typeof c);
    return c;
}
function $295abd054c1837dd$var$Da(a) {
    null !== a && ($295abd054c1837dd$var$za = $295abd054c1837dd$var$xa($295abd054c1837dd$var$za, a));
    a = $295abd054c1837dd$var$za;
    $295abd054c1837dd$var$za = null;
    if (a && ($295abd054c1837dd$var$ya(a, $295abd054c1837dd$var$Aa), $295abd054c1837dd$var$za && $295abd054c1837dd$var$x("95"), $295abd054c1837dd$var$fa)) throw a = $295abd054c1837dd$var$ha, $295abd054c1837dd$var$fa = !1, $295abd054c1837dd$var$ha = null, a;
}
var $295abd054c1837dd$var$Ea = Math.random().toString(36).slice(2), $295abd054c1837dd$var$Fa = "__reactInternalInstance$" + $295abd054c1837dd$var$Ea, $295abd054c1837dd$var$Ga = "__reactEventHandlers$" + $295abd054c1837dd$var$Ea;
function $295abd054c1837dd$var$Ha(a) {
    if (a[$295abd054c1837dd$var$Fa]) return a[$295abd054c1837dd$var$Fa];
    for(; !a[$295abd054c1837dd$var$Fa];)if (a.parentNode) a = a.parentNode;
    else return null;
    a = a[$295abd054c1837dd$var$Fa];
    return 5 === a.tag || 6 === a.tag ? a : null;
}
function $295abd054c1837dd$var$Ia(a) {
    a = a[$295abd054c1837dd$var$Fa];
    return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
}
function $295abd054c1837dd$var$Ja(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    $295abd054c1837dd$var$x("33");
}
function $295abd054c1837dd$var$Ka(a) {
    return a[$295abd054c1837dd$var$Ga] || null;
}
function $295abd054c1837dd$var$La(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $295abd054c1837dd$var$Ma(a, b, c) {
    if (b = $295abd054c1837dd$var$Ca(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $295abd054c1837dd$var$xa(c._dispatchListeners, b), c._dispatchInstances = $295abd054c1837dd$var$xa(c._dispatchInstances, a);
}
function $295abd054c1837dd$var$Na(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $295abd054c1837dd$var$La(b);
        for(b = c.length; 0 < b--;)$295abd054c1837dd$var$Ma(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$295abd054c1837dd$var$Ma(c[b], "bubbled", a);
    }
}
function $295abd054c1837dd$var$Oa(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $295abd054c1837dd$var$Ca(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $295abd054c1837dd$var$xa(c._dispatchListeners, b), c._dispatchInstances = $295abd054c1837dd$var$xa(c._dispatchInstances, a));
}
function $295abd054c1837dd$var$Pa(a) {
    a && a.dispatchConfig.registrationName && $295abd054c1837dd$var$Oa(a._targetInst, null, a);
}
function $295abd054c1837dd$var$Qa(a) {
    $295abd054c1837dd$var$ya(a, $295abd054c1837dd$var$Na);
}
var $295abd054c1837dd$var$Ra = !("undefined" === typeof window || !window.document || !window.document.createElement);
function $295abd054c1837dd$var$Sa(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $295abd054c1837dd$var$Ta = {
    animationend: $295abd054c1837dd$var$Sa("Animation", "AnimationEnd"),
    animationiteration: $295abd054c1837dd$var$Sa("Animation", "AnimationIteration"),
    animationstart: $295abd054c1837dd$var$Sa("Animation", "AnimationStart"),
    transitionend: $295abd054c1837dd$var$Sa("Transition", "TransitionEnd")
}, $295abd054c1837dd$var$Ua = {}, $295abd054c1837dd$var$Va = {};
$295abd054c1837dd$var$Ra && ($295abd054c1837dd$var$Va = document.createElement("div").style, "AnimationEvent" in window || (delete $295abd054c1837dd$var$Ta.animationend.animation, delete $295abd054c1837dd$var$Ta.animationiteration.animation, delete $295abd054c1837dd$var$Ta.animationstart.animation), "TransitionEvent" in window || delete $295abd054c1837dd$var$Ta.transitionend.transition);
function $295abd054c1837dd$var$Wa(a) {
    if ($295abd054c1837dd$var$Ua[a]) return $295abd054c1837dd$var$Ua[a];
    if (!$295abd054c1837dd$var$Ta[a]) return a;
    var b = $295abd054c1837dd$var$Ta[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $295abd054c1837dd$var$Va) return $295abd054c1837dd$var$Ua[a] = b[c];
    return a;
}
var $295abd054c1837dd$var$Xa = $295abd054c1837dd$var$Wa("animationend"), $295abd054c1837dd$var$Ya = $295abd054c1837dd$var$Wa("animationiteration"), $295abd054c1837dd$var$Za = $295abd054c1837dd$var$Wa("animationstart"), $295abd054c1837dd$var$$a = $295abd054c1837dd$var$Wa("transitionend"), $295abd054c1837dd$var$ab = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $295abd054c1837dd$var$bb = null, $295abd054c1837dd$var$cb = null, $295abd054c1837dd$var$db = null;
function $295abd054c1837dd$var$eb() {
    if ($295abd054c1837dd$var$db) return $295abd054c1837dd$var$db;
    var a, b = $295abd054c1837dd$var$cb, c = b.length, d, e = "value" in $295abd054c1837dd$var$bb ? $295abd054c1837dd$var$bb.value : $295abd054c1837dd$var$bb.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $295abd054c1837dd$var$db = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $295abd054c1837dd$var$fb() {
    return !0;
}
function $295abd054c1837dd$var$gb() {
    return !1;
}
function $295abd054c1837dd$var$y(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $295abd054c1837dd$var$fb : $295abd054c1837dd$var$gb;
    this.isPropagationStopped = $295abd054c1837dd$var$gb;
    return this;
}
$b6jnv($295abd054c1837dd$var$y.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $295abd054c1837dd$var$fb);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $295abd054c1837dd$var$fb);
    },
    persist: function() {
        this.isPersistent = $295abd054c1837dd$var$fb;
    },
    isPersistent: $295abd054c1837dd$var$gb,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $295abd054c1837dd$var$gb;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$295abd054c1837dd$var$y.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$295abd054c1837dd$var$y.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $b6jnv(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $b6jnv({}, d.Interface, a);
    c.extend = d.extend;
    $295abd054c1837dd$var$hb(c);
    return c;
};
$295abd054c1837dd$var$hb($295abd054c1837dd$var$y);
function $295abd054c1837dd$var$ib(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $295abd054c1837dd$var$jb(a) {
    a instanceof this || $295abd054c1837dd$var$x("279");
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $295abd054c1837dd$var$hb(a) {
    a.eventPool = [];
    a.getPooled = $295abd054c1837dd$var$ib;
    a.release = $295abd054c1837dd$var$jb;
}
var $295abd054c1837dd$var$kb = $295abd054c1837dd$var$y.extend({
    data: null
}), $295abd054c1837dd$var$lb = $295abd054c1837dd$var$y.extend({
    data: null
}), $295abd054c1837dd$var$mb = [
    9,
    13,
    27,
    32
], $295abd054c1837dd$var$nb = $295abd054c1837dd$var$Ra && "CompositionEvent" in window, $295abd054c1837dd$var$ob = null;
$295abd054c1837dd$var$Ra && "documentMode" in document && ($295abd054c1837dd$var$ob = document.documentMode);
var $295abd054c1837dd$var$pb = $295abd054c1837dd$var$Ra && "TextEvent" in window && !$295abd054c1837dd$var$ob, $295abd054c1837dd$var$qb = $295abd054c1837dd$var$Ra && (!$295abd054c1837dd$var$nb || $295abd054c1837dd$var$ob && 8 < $295abd054c1837dd$var$ob && 11 >= $295abd054c1837dd$var$ob), $295abd054c1837dd$var$rb = String.fromCharCode(32), $295abd054c1837dd$var$sb = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $295abd054c1837dd$var$tb = !1;
function $295abd054c1837dd$var$ub(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $295abd054c1837dd$var$mb.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $295abd054c1837dd$var$vb(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $295abd054c1837dd$var$wb = !1;
function $295abd054c1837dd$var$xb(a, b) {
    switch(a){
        case "compositionend":
            return $295abd054c1837dd$var$vb(b);
        case "keypress":
            if (32 !== b.which) return null;
            $295abd054c1837dd$var$tb = !0;
            return $295abd054c1837dd$var$rb;
        case "textInput":
            return a = b.data, a === $295abd054c1837dd$var$rb && $295abd054c1837dd$var$tb ? null : a;
        default:
            return null;
    }
}
function $295abd054c1837dd$var$yb(a, b) {
    if ($295abd054c1837dd$var$wb) return "compositionend" === a || !$295abd054c1837dd$var$nb && $295abd054c1837dd$var$ub(a, b) ? (a = $295abd054c1837dd$var$eb(), $295abd054c1837dd$var$db = $295abd054c1837dd$var$cb = $295abd054c1837dd$var$bb = null, $295abd054c1837dd$var$wb = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $295abd054c1837dd$var$qb && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $295abd054c1837dd$var$zb = {
    eventTypes: $295abd054c1837dd$var$sb,
    extractEvents: function(a, b, c, d) {
        var e = void 0;
        var f = void 0;
        if ($295abd054c1837dd$var$nb) b: {
            switch(a){
                case "compositionstart":
                    e = $295abd054c1837dd$var$sb.compositionStart;
                    break b;
                case "compositionend":
                    e = $295abd054c1837dd$var$sb.compositionEnd;
                    break b;
                case "compositionupdate":
                    e = $295abd054c1837dd$var$sb.compositionUpdate;
                    break b;
            }
            e = void 0;
        }
        else $295abd054c1837dd$var$wb ? $295abd054c1837dd$var$ub(a, c) && (e = $295abd054c1837dd$var$sb.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = $295abd054c1837dd$var$sb.compositionStart);
        e ? ($295abd054c1837dd$var$qb && "ko" !== c.locale && ($295abd054c1837dd$var$wb || e !== $295abd054c1837dd$var$sb.compositionStart ? e === $295abd054c1837dd$var$sb.compositionEnd && $295abd054c1837dd$var$wb && (f = $295abd054c1837dd$var$eb()) : ($295abd054c1837dd$var$bb = d, $295abd054c1837dd$var$cb = "value" in $295abd054c1837dd$var$bb ? $295abd054c1837dd$var$bb.value : $295abd054c1837dd$var$bb.textContent, $295abd054c1837dd$var$wb = !0)), e = $295abd054c1837dd$var$kb.getPooled(e, b, c, d), f ? e.data = f : (f = $295abd054c1837dd$var$vb(c), null !== f && (e.data = f)), $295abd054c1837dd$var$Qa(e), f = e) : f = null;
        (a = $295abd054c1837dd$var$pb ? $295abd054c1837dd$var$xb(a, c) : $295abd054c1837dd$var$yb(a, c)) ? (b = $295abd054c1837dd$var$lb.getPooled($295abd054c1837dd$var$sb.beforeInput, b, c, d), b.data = a, $295abd054c1837dd$var$Qa(b)) : b = null;
        return null === f ? b : null === b ? f : [
            f,
            b
        ];
    }
}, $295abd054c1837dd$var$Ab = null, $295abd054c1837dd$var$Bb = null, $295abd054c1837dd$var$Cb = null;
function $295abd054c1837dd$var$Db(a) {
    if (a = $295abd054c1837dd$var$ua(a)) {
        "function" !== typeof $295abd054c1837dd$var$Ab && $295abd054c1837dd$var$x("280");
        var b = $295abd054c1837dd$var$ta(a.stateNode);
        $295abd054c1837dd$var$Ab(a.stateNode, a.type, b);
    }
}
function $295abd054c1837dd$var$Eb(a) {
    $295abd054c1837dd$var$Bb ? $295abd054c1837dd$var$Cb ? $295abd054c1837dd$var$Cb.push(a) : $295abd054c1837dd$var$Cb = [
        a
    ] : $295abd054c1837dd$var$Bb = a;
}
function $295abd054c1837dd$var$Fb() {
    if ($295abd054c1837dd$var$Bb) {
        var a = $295abd054c1837dd$var$Bb, b = $295abd054c1837dd$var$Cb;
        $295abd054c1837dd$var$Cb = $295abd054c1837dd$var$Bb = null;
        $295abd054c1837dd$var$Db(a);
        if (b) for(a = 0; a < b.length; a++)$295abd054c1837dd$var$Db(b[a]);
    }
}
function $295abd054c1837dd$var$Gb(a, b) {
    return a(b);
}
function $295abd054c1837dd$var$Hb(a, b, c) {
    return a(b, c);
}
function $295abd054c1837dd$var$Ib() {}
var $295abd054c1837dd$var$Jb = !1;
function $295abd054c1837dd$var$Kb(a, b) {
    if ($295abd054c1837dd$var$Jb) return a(b);
    $295abd054c1837dd$var$Jb = !0;
    try {
        return $295abd054c1837dd$var$Gb(a, b);
    } finally{
        if ($295abd054c1837dd$var$Jb = !1, null !== $295abd054c1837dd$var$Bb || null !== $295abd054c1837dd$var$Cb) $295abd054c1837dd$var$Ib(), $295abd054c1837dd$var$Fb();
    }
}
var $295abd054c1837dd$var$Lb = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $295abd054c1837dd$var$Mb(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$295abd054c1837dd$var$Lb[a.type] : "textarea" === b ? !0 : !1;
}
function $295abd054c1837dd$var$Nb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $295abd054c1837dd$var$Ob(a) {
    if (!$295abd054c1837dd$var$Ra) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
function $295abd054c1837dd$var$Pb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $295abd054c1837dd$var$Qb(a) {
    var b = $295abd054c1837dd$var$Pb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $295abd054c1837dd$var$Rb(a) {
    a._valueTracker || (a._valueTracker = $295abd054c1837dd$var$Qb(a));
}
function $295abd054c1837dd$var$Sb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $295abd054c1837dd$var$Pb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
var $295abd054c1837dd$var$Tb = $1bxDW.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$295abd054c1837dd$var$Tb.hasOwnProperty("ReactCurrentDispatcher") || ($295abd054c1837dd$var$Tb.ReactCurrentDispatcher = {
    current: null
});
var $295abd054c1837dd$var$Ub = /^(.*)[\\\/]/, $295abd054c1837dd$var$z = "function" === typeof Symbol && Symbol.for, $295abd054c1837dd$var$Vb = $295abd054c1837dd$var$z ? Symbol.for("react.element") : 60103, $295abd054c1837dd$var$Wb = $295abd054c1837dd$var$z ? Symbol.for("react.portal") : 60106, $295abd054c1837dd$var$Xb = $295abd054c1837dd$var$z ? Symbol.for("react.fragment") : 60107, $295abd054c1837dd$var$Yb = $295abd054c1837dd$var$z ? Symbol.for("react.strict_mode") : 60108, $295abd054c1837dd$var$Zb = $295abd054c1837dd$var$z ? Symbol.for("react.profiler") : 60114, $295abd054c1837dd$var$$b = $295abd054c1837dd$var$z ? Symbol.for("react.provider") : 60109, $295abd054c1837dd$var$ac = $295abd054c1837dd$var$z ? Symbol.for("react.context") : 60110, $295abd054c1837dd$var$bc = $295abd054c1837dd$var$z ? Symbol.for("react.concurrent_mode") : 60111, $295abd054c1837dd$var$cc = $295abd054c1837dd$var$z ? Symbol.for("react.forward_ref") : 60112, $295abd054c1837dd$var$dc = $295abd054c1837dd$var$z ? Symbol.for("react.suspense") : 60113, $295abd054c1837dd$var$ec = $295abd054c1837dd$var$z ? Symbol.for("react.memo") : 60115, $295abd054c1837dd$var$fc = $295abd054c1837dd$var$z ? Symbol.for("react.lazy") : 60116, $295abd054c1837dd$var$gc = "function" === typeof Symbol && Symbol.iterator;
function $295abd054c1837dd$var$hc(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $295abd054c1837dd$var$gc && a[$295abd054c1837dd$var$gc] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $295abd054c1837dd$var$ic(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $295abd054c1837dd$var$bc:
            return "ConcurrentMode";
        case $295abd054c1837dd$var$Xb:
            return "Fragment";
        case $295abd054c1837dd$var$Wb:
            return "Portal";
        case $295abd054c1837dd$var$Zb:
            return "Profiler";
        case $295abd054c1837dd$var$Yb:
            return "StrictMode";
        case $295abd054c1837dd$var$dc:
            return "Suspense";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $295abd054c1837dd$var$ac:
            return "Context.Consumer";
        case $295abd054c1837dd$var$$b:
            return "Context.Provider";
        case $295abd054c1837dd$var$cc:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $295abd054c1837dd$var$ec:
            return $295abd054c1837dd$var$ic(a.type);
        case $295abd054c1837dd$var$fc:
            if (a = 1 === a._status ? a._result : null) return $295abd054c1837dd$var$ic(a);
    }
    return null;
}
function $295abd054c1837dd$var$jc(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $295abd054c1837dd$var$ic(a.type);
                c = null;
                d && (c = $295abd054c1837dd$var$ic(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($295abd054c1837dd$var$Ub, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
var $295abd054c1837dd$var$kc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $295abd054c1837dd$var$lc = Object.prototype.hasOwnProperty, $295abd054c1837dd$var$mc = {}, $295abd054c1837dd$var$nc = {};
function $295abd054c1837dd$var$oc(a) {
    if ($295abd054c1837dd$var$lc.call($295abd054c1837dd$var$nc, a)) return !0;
    if ($295abd054c1837dd$var$lc.call($295abd054c1837dd$var$mc, a)) return !1;
    if ($295abd054c1837dd$var$kc.test(a)) return $295abd054c1837dd$var$nc[a] = !0;
    $295abd054c1837dd$var$mc[a] = !0;
    return !1;
}
function $295abd054c1837dd$var$pc(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $295abd054c1837dd$var$qc(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $295abd054c1837dd$var$pc(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $295abd054c1837dd$var$C(a, b, c, d, e) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
}
var $295abd054c1837dd$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 0, !1, a, null);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $295abd054c1837dd$var$D[b] = new $295abd054c1837dd$var$C(b, 1, !1, a[1], null);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 2, !1, a.toLowerCase(), null);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 3, !1, a.toLowerCase(), null);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 3, !0, a, null);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 4, !1, a, null);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 6, !1, a, null);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 5, !1, a.toLowerCase(), null);
});
var $295abd054c1837dd$var$rc = /[\-:]([a-z])/g;
function $295abd054c1837dd$var$sc(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($295abd054c1837dd$var$rc, $295abd054c1837dd$var$sc);
    $295abd054c1837dd$var$D[b] = new $295abd054c1837dd$var$C(b, 1, !1, a, null);
});
"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($295abd054c1837dd$var$rc, $295abd054c1837dd$var$sc);
    $295abd054c1837dd$var$D[b] = new $295abd054c1837dd$var$C(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($295abd054c1837dd$var$rc, $295abd054c1837dd$var$sc);
    $295abd054c1837dd$var$D[b] = new $295abd054c1837dd$var$C(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $295abd054c1837dd$var$D[a] = new $295abd054c1837dd$var$C(a, 1, !1, a.toLowerCase(), null);
});
function $295abd054c1837dd$var$tc(a, b, c, d) {
    var e = $295abd054c1837dd$var$D.hasOwnProperty(b) ? $295abd054c1837dd$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($295abd054c1837dd$var$qc(b, c, e, d) && (c = null), d || null === e ? $295abd054c1837dd$var$oc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function $295abd054c1837dd$var$uc(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $295abd054c1837dd$var$vc(a, b) {
    var c = b.checked;
    return $b6jnv({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $295abd054c1837dd$var$wc(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $295abd054c1837dd$var$uc(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $295abd054c1837dd$var$xc(a, b) {
    b = b.checked;
    null != b && $295abd054c1837dd$var$tc(a, "checked", b, !1);
}
function $295abd054c1837dd$var$yc(a, b) {
    $295abd054c1837dd$var$xc(a, b);
    var c = $295abd054c1837dd$var$uc(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $295abd054c1837dd$var$zc(a, b.type, c) : b.hasOwnProperty("defaultValue") && $295abd054c1837dd$var$zc(a, b.type, $295abd054c1837dd$var$uc(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $295abd054c1837dd$var$Ac(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $295abd054c1837dd$var$zc(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $295abd054c1837dd$var$Bc = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $295abd054c1837dd$var$Cc(a, b, c) {
    a = $295abd054c1837dd$var$y.getPooled($295abd054c1837dd$var$Bc.change, a, b, c);
    a.type = "change";
    $295abd054c1837dd$var$Eb(c);
    $295abd054c1837dd$var$Qa(a);
    return a;
}
var $295abd054c1837dd$var$Dc = null, $295abd054c1837dd$var$Ec = null;
function $295abd054c1837dd$var$Fc(a) {
    $295abd054c1837dd$var$Da(a);
}
function $295abd054c1837dd$var$Gc(a) {
    var b = $295abd054c1837dd$var$Ja(a);
    if ($295abd054c1837dd$var$Sb(b)) return a;
}
function $295abd054c1837dd$var$Hc(a, b) {
    if ("change" === a) return b;
}
var $295abd054c1837dd$var$Ic = !1;
$295abd054c1837dd$var$Ra && ($295abd054c1837dd$var$Ic = $295abd054c1837dd$var$Ob("input") && (!document.documentMode || 9 < document.documentMode));
function $295abd054c1837dd$var$Jc() {
    $295abd054c1837dd$var$Dc && ($295abd054c1837dd$var$Dc.detachEvent("onpropertychange", $295abd054c1837dd$var$Kc), $295abd054c1837dd$var$Ec = $295abd054c1837dd$var$Dc = null);
}
function $295abd054c1837dd$var$Kc(a) {
    "value" === a.propertyName && $295abd054c1837dd$var$Gc($295abd054c1837dd$var$Ec) && (a = $295abd054c1837dd$var$Cc($295abd054c1837dd$var$Ec, a, $295abd054c1837dd$var$Nb(a)), $295abd054c1837dd$var$Kb($295abd054c1837dd$var$Fc, a));
}
function $295abd054c1837dd$var$Lc(a, b, c) {
    "focus" === a ? ($295abd054c1837dd$var$Jc(), $295abd054c1837dd$var$Dc = b, $295abd054c1837dd$var$Ec = c, $295abd054c1837dd$var$Dc.attachEvent("onpropertychange", $295abd054c1837dd$var$Kc)) : "blur" === a && $295abd054c1837dd$var$Jc();
}
function $295abd054c1837dd$var$Mc(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $295abd054c1837dd$var$Gc($295abd054c1837dd$var$Ec);
}
function $295abd054c1837dd$var$Nc(a, b) {
    if ("click" === a) return $295abd054c1837dd$var$Gc(b);
}
function $295abd054c1837dd$var$Oc(a, b) {
    if ("input" === a || "change" === a) return $295abd054c1837dd$var$Gc(b);
}
var $295abd054c1837dd$var$Pc = {
    eventTypes: $295abd054c1837dd$var$Bc,
    _isInputEventSupported: $295abd054c1837dd$var$Ic,
    extractEvents: function(a, b, c, d) {
        var e = b ? $295abd054c1837dd$var$Ja(b) : window, f = void 0, g = void 0, h = e.nodeName && e.nodeName.toLowerCase();
        "select" === h || "input" === h && "file" === e.type ? f = $295abd054c1837dd$var$Hc : $295abd054c1837dd$var$Mb(e) ? $295abd054c1837dd$var$Ic ? f = $295abd054c1837dd$var$Oc : (f = $295abd054c1837dd$var$Mc, g = $295abd054c1837dd$var$Lc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = $295abd054c1837dd$var$Nc);
        if (f && (f = f(a, b))) return $295abd054c1837dd$var$Cc(f, c, d);
        g && g(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $295abd054c1837dd$var$zc(e, "number", e.value);
    }
}, $295abd054c1837dd$var$Qc = $295abd054c1837dd$var$y.extend({
    view: null,
    detail: null
}), $295abd054c1837dd$var$Rc = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $295abd054c1837dd$var$Sc(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $295abd054c1837dd$var$Rc[a]) ? !!b[a] : !1;
}
function $295abd054c1837dd$var$Tc() {
    return $295abd054c1837dd$var$Sc;
}
var $295abd054c1837dd$var$Uc = 0, $295abd054c1837dd$var$Vc = 0, $295abd054c1837dd$var$Wc = !1, $295abd054c1837dd$var$Xc = !1, $295abd054c1837dd$var$Yc = $295abd054c1837dd$var$Qc.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $295abd054c1837dd$var$Tc,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $295abd054c1837dd$var$Uc;
        $295abd054c1837dd$var$Uc = a.screenX;
        return $295abd054c1837dd$var$Wc ? "mousemove" === a.type ? a.screenX - b : 0 : ($295abd054c1837dd$var$Wc = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $295abd054c1837dd$var$Vc;
        $295abd054c1837dd$var$Vc = a.screenY;
        return $295abd054c1837dd$var$Xc ? "mousemove" === a.type ? a.screenY - b : 0 : ($295abd054c1837dd$var$Xc = !0, 0);
    }
}), $295abd054c1837dd$var$Zc = $295abd054c1837dd$var$Yc.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $295abd054c1837dd$var$$c = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $295abd054c1837dd$var$ad = {
    eventTypes: $295abd054c1837dd$var$$c,
    extractEvents: function(a, b, c, d) {
        var e = "mouseover" === a || "pointerover" === a, f = "mouseout" === a || "pointerout" === a;
        if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;
        e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
        f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? $295abd054c1837dd$var$Ha(b) : null) : f = null;
        if (f === b) return null;
        var g = void 0, h = void 0, l = void 0, k = void 0;
        if ("mouseout" === a || "mouseover" === a) g = $295abd054c1837dd$var$Yc, h = $295abd054c1837dd$var$$c.mouseLeave, l = $295abd054c1837dd$var$$c.mouseEnter, k = "mouse";
        else if ("pointerout" === a || "pointerover" === a) g = $295abd054c1837dd$var$Zc, h = $295abd054c1837dd$var$$c.pointerLeave, l = $295abd054c1837dd$var$$c.pointerEnter, k = "pointer";
        var m = null == f ? e : $295abd054c1837dd$var$Ja(f);
        e = null == b ? e : $295abd054c1837dd$var$Ja(b);
        a = g.getPooled(h, f, c, d);
        a.type = k + "leave";
        a.target = m;
        a.relatedTarget = e;
        c = g.getPooled(l, b, c, d);
        c.type = k + "enter";
        c.target = e;
        c.relatedTarget = m;
        d = b;
        if (f && d) a: {
            b = f;
            e = d;
            k = 0;
            for(g = b; g; g = $295abd054c1837dd$var$La(g))k++;
            g = 0;
            for(l = e; l; l = $295abd054c1837dd$var$La(l))g++;
            for(; 0 < k - g;)b = $295abd054c1837dd$var$La(b), k--;
            for(; 0 < g - k;)e = $295abd054c1837dd$var$La(e), g--;
            for(; k--;){
                if (b === e || b === e.alternate) break a;
                b = $295abd054c1837dd$var$La(b);
                e = $295abd054c1837dd$var$La(e);
            }
            b = null;
        }
        else b = null;
        e = b;
        for(b = []; f && f !== e;){
            k = f.alternate;
            if (null !== k && k === e) break;
            b.push(f);
            f = $295abd054c1837dd$var$La(f);
        }
        for(f = []; d && d !== e;){
            k = d.alternate;
            if (null !== k && k === e) break;
            f.push(d);
            d = $295abd054c1837dd$var$La(d);
        }
        for(d = 0; d < b.length; d++)$295abd054c1837dd$var$Oa(b[d], "bubbled", a);
        for(d = f.length; 0 < d--;)$295abd054c1837dd$var$Oa(f[d], "captured", c);
        return [
            a,
            c
        ];
    }
};
function $295abd054c1837dd$var$bd(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $295abd054c1837dd$var$cd = Object.prototype.hasOwnProperty;
function $295abd054c1837dd$var$dd(a, b) {
    if ($295abd054c1837dd$var$bd(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$295abd054c1837dd$var$cd.call(b, c[d]) || !$295abd054c1837dd$var$bd(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $295abd054c1837dd$var$ed(a) {
    var b = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        if (0 !== (b.effectTag & 2)) return 1;
        for(; b.return;)if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
    return 3 === b.tag ? 2 : 3;
}
function $295abd054c1837dd$var$fd(a) {
    2 !== $295abd054c1837dd$var$ed(a) && $295abd054c1837dd$var$x("188");
}
function $295abd054c1837dd$var$gd(a) {
    var b = a.alternate;
    if (!b) return b = $295abd054c1837dd$var$ed(a), 3 === b && $295abd054c1837dd$var$x("188"), 1 === b ? null : a;
    for(var c = a, d = b;;){
        var e = c.return, f = e ? e.alternate : null;
        if (!e || !f) break;
        if (e.child === f.child) {
            for(var g = e.child; g;){
                if (g === c) return $295abd054c1837dd$var$fd(e), a;
                if (g === d) return $295abd054c1837dd$var$fd(e), b;
                g = g.sibling;
            }
            $295abd054c1837dd$var$x("188");
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            g = !1;
            for(var h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                g || $295abd054c1837dd$var$x("189");
            }
        }
        c.alternate !== d && $295abd054c1837dd$var$x("190");
    }
    3 !== c.tag && $295abd054c1837dd$var$x("188");
    return c.stateNode.current === c ? a : b;
}
function $295abd054c1837dd$var$hd(a) {
    a = $295abd054c1837dd$var$gd(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
var $295abd054c1837dd$var$id = $295abd054c1837dd$var$y.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $295abd054c1837dd$var$jd = $295abd054c1837dd$var$y.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $295abd054c1837dd$var$kd = $295abd054c1837dd$var$Qc.extend({
    relatedTarget: null
});
function $295abd054c1837dd$var$ld(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $295abd054c1837dd$var$md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $295abd054c1837dd$var$nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $295abd054c1837dd$var$od = $295abd054c1837dd$var$Qc.extend({
    key: function(a) {
        if (a.key) {
            var b = $295abd054c1837dd$var$md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $295abd054c1837dd$var$ld(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $295abd054c1837dd$var$nd[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $295abd054c1837dd$var$Tc,
    charCode: function(a) {
        return "keypress" === a.type ? $295abd054c1837dd$var$ld(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $295abd054c1837dd$var$ld(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $295abd054c1837dd$var$pd = $295abd054c1837dd$var$Yc.extend({
    dataTransfer: null
}), $295abd054c1837dd$var$qd = $295abd054c1837dd$var$Qc.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $295abd054c1837dd$var$Tc
}), $295abd054c1837dd$var$rd = $295abd054c1837dd$var$y.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $295abd054c1837dd$var$sd = $295abd054c1837dd$var$Yc.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $295abd054c1837dd$var$td = [
    [
        "abort",
        "abort"
    ],
    [
        $295abd054c1837dd$var$Xa,
        "animationEnd"
    ],
    [
        $295abd054c1837dd$var$Ya,
        "animationIteration"
    ],
    [
        $295abd054c1837dd$var$Za,
        "animationStart"
    ],
    [
        "canplay",
        "canPlay"
    ],
    [
        "canplaythrough",
        "canPlayThrough"
    ],
    [
        "drag",
        "drag"
    ],
    [
        "dragenter",
        "dragEnter"
    ],
    [
        "dragexit",
        "dragExit"
    ],
    [
        "dragleave",
        "dragLeave"
    ],
    [
        "dragover",
        "dragOver"
    ],
    [
        "durationchange",
        "durationChange"
    ],
    [
        "emptied",
        "emptied"
    ],
    [
        "encrypted",
        "encrypted"
    ],
    [
        "ended",
        "ended"
    ],
    [
        "error",
        "error"
    ],
    [
        "gotpointercapture",
        "gotPointerCapture"
    ],
    [
        "load",
        "load"
    ],
    [
        "loadeddata",
        "loadedData"
    ],
    [
        "loadedmetadata",
        "loadedMetadata"
    ],
    [
        "loadstart",
        "loadStart"
    ],
    [
        "lostpointercapture",
        "lostPointerCapture"
    ],
    [
        "mousemove",
        "mouseMove"
    ],
    [
        "mouseout",
        "mouseOut"
    ],
    [
        "mouseover",
        "mouseOver"
    ],
    [
        "playing",
        "playing"
    ],
    [
        "pointermove",
        "pointerMove"
    ],
    [
        "pointerout",
        "pointerOut"
    ],
    [
        "pointerover",
        "pointerOver"
    ],
    [
        "progress",
        "progress"
    ],
    [
        "scroll",
        "scroll"
    ],
    [
        "seeking",
        "seeking"
    ],
    [
        "stalled",
        "stalled"
    ],
    [
        "suspend",
        "suspend"
    ],
    [
        "timeupdate",
        "timeUpdate"
    ],
    [
        "toggle",
        "toggle"
    ],
    [
        "touchmove",
        "touchMove"
    ],
    [
        $295abd054c1837dd$var$$a,
        "transitionEnd"
    ],
    [
        "waiting",
        "waiting"
    ],
    [
        "wheel",
        "wheel"
    ]
], $295abd054c1837dd$var$ud = {}, $295abd054c1837dd$var$vd = {};
function $295abd054c1837dd$var$wd(a, b) {
    var c = a[0];
    a = a[1];
    var d = "on" + (a[0].toUpperCase() + a.slice(1));
    b = {
        phasedRegistrationNames: {
            bubbled: d,
            captured: d + "Capture"
        },
        dependencies: [
            c
        ],
        isInteractive: b
    };
    $295abd054c1837dd$var$ud[a] = b;
    $295abd054c1837dd$var$vd[c] = b;
}
[
    [
        "blur",
        "blur"
    ],
    [
        "cancel",
        "cancel"
    ],
    [
        "click",
        "click"
    ],
    [
        "close",
        "close"
    ],
    [
        "contextmenu",
        "contextMenu"
    ],
    [
        "copy",
        "copy"
    ],
    [
        "cut",
        "cut"
    ],
    [
        "auxclick",
        "auxClick"
    ],
    [
        "dblclick",
        "doubleClick"
    ],
    [
        "dragend",
        "dragEnd"
    ],
    [
        "dragstart",
        "dragStart"
    ],
    [
        "drop",
        "drop"
    ],
    [
        "focus",
        "focus"
    ],
    [
        "input",
        "input"
    ],
    [
        "invalid",
        "invalid"
    ],
    [
        "keydown",
        "keyDown"
    ],
    [
        "keypress",
        "keyPress"
    ],
    [
        "keyup",
        "keyUp"
    ],
    [
        "mousedown",
        "mouseDown"
    ],
    [
        "mouseup",
        "mouseUp"
    ],
    [
        "paste",
        "paste"
    ],
    [
        "pause",
        "pause"
    ],
    [
        "play",
        "play"
    ],
    [
        "pointercancel",
        "pointerCancel"
    ],
    [
        "pointerdown",
        "pointerDown"
    ],
    [
        "pointerup",
        "pointerUp"
    ],
    [
        "ratechange",
        "rateChange"
    ],
    [
        "reset",
        "reset"
    ],
    [
        "seeked",
        "seeked"
    ],
    [
        "submit",
        "submit"
    ],
    [
        "touchcancel",
        "touchCancel"
    ],
    [
        "touchend",
        "touchEnd"
    ],
    [
        "touchstart",
        "touchStart"
    ],
    [
        "volumechange",
        "volumeChange"
    ]
].forEach(function(a) {
    $295abd054c1837dd$var$wd(a, !0);
});
$295abd054c1837dd$var$td.forEach(function(a) {
    $295abd054c1837dd$var$wd(a, !1);
});
var $295abd054c1837dd$var$xd = {
    eventTypes: $295abd054c1837dd$var$ud,
    isInteractiveTopLevelEventType: function(a) {
        a = $295abd054c1837dd$var$vd[a];
        return void 0 !== a && !0 === a.isInteractive;
    },
    extractEvents: function(a, b, c, d) {
        var e = $295abd054c1837dd$var$vd[a];
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $295abd054c1837dd$var$ld(c)) return null;
            case "keydown":
            case "keyup":
                a = $295abd054c1837dd$var$od;
                break;
            case "blur":
            case "focus":
                a = $295abd054c1837dd$var$kd;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $295abd054c1837dd$var$Yc;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $295abd054c1837dd$var$pd;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $295abd054c1837dd$var$qd;
                break;
            case $295abd054c1837dd$var$Xa:
            case $295abd054c1837dd$var$Ya:
            case $295abd054c1837dd$var$Za:
                a = $295abd054c1837dd$var$id;
                break;
            case $295abd054c1837dd$var$$a:
                a = $295abd054c1837dd$var$rd;
                break;
            case "scroll":
                a = $295abd054c1837dd$var$Qc;
                break;
            case "wheel":
                a = $295abd054c1837dd$var$sd;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $295abd054c1837dd$var$jd;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $295abd054c1837dd$var$Zc;
                break;
            default:
                a = $295abd054c1837dd$var$y;
        }
        b = a.getPooled(e, b, c, d);
        $295abd054c1837dd$var$Qa(b);
        return b;
    }
}, $295abd054c1837dd$var$yd = $295abd054c1837dd$var$xd.isInteractiveTopLevelEventType, $295abd054c1837dd$var$zd = [];
function $295abd054c1837dd$var$Ad(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d;
        for(d = c; d.return;)d = d.return;
        d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        if (!d) break;
        a.ancestors.push(c);
        c = $295abd054c1837dd$var$Ha(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $295abd054c1837dd$var$Nb(a.nativeEvent);
        d = a.topLevelType;
        for(var f = a.nativeEvent, g = null, h = 0; h < $295abd054c1837dd$var$oa.length; h++){
            var l = $295abd054c1837dd$var$oa[h];
            l && (l = l.extractEvents(d, b, f, e)) && (g = $295abd054c1837dd$var$xa(g, l));
        }
        $295abd054c1837dd$var$Da(g);
    }
}
var $295abd054c1837dd$var$Bd = !0;
function $295abd054c1837dd$var$E(a, b) {
    if (!b) return null;
    var c = ($295abd054c1837dd$var$yd(a) ? $295abd054c1837dd$var$Cd : $295abd054c1837dd$var$Dd).bind(null, a);
    b.addEventListener(a, c, !1);
}
function $295abd054c1837dd$var$Ed(a, b) {
    if (!b) return null;
    var c = ($295abd054c1837dd$var$yd(a) ? $295abd054c1837dd$var$Cd : $295abd054c1837dd$var$Dd).bind(null, a);
    b.addEventListener(a, c, !0);
}
function $295abd054c1837dd$var$Cd(a, b) {
    $295abd054c1837dd$var$Hb($295abd054c1837dd$var$Dd, a, b);
}
function $295abd054c1837dd$var$Dd(a, b) {
    if ($295abd054c1837dd$var$Bd) {
        var c = $295abd054c1837dd$var$Nb(b);
        c = $295abd054c1837dd$var$Ha(c);
        null === c || "number" !== typeof c.tag || 2 === $295abd054c1837dd$var$ed(c) || (c = null);
        if ($295abd054c1837dd$var$zd.length) {
            var d = $295abd054c1837dd$var$zd.pop();
            d.topLevelType = a;
            d.nativeEvent = b;
            d.targetInst = c;
            a = d;
        } else a = {
            topLevelType: a,
            nativeEvent: b,
            targetInst: c,
            ancestors: []
        };
        try {
            $295abd054c1837dd$var$Kb($295abd054c1837dd$var$Ad, a);
        } finally{
            a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > $295abd054c1837dd$var$zd.length && $295abd054c1837dd$var$zd.push(a);
        }
    }
}
var $295abd054c1837dd$var$Fd = {}, $295abd054c1837dd$var$Gd = 0, $295abd054c1837dd$var$Hd = "_reactListenersID" + ("" + Math.random()).slice(2);
function $295abd054c1837dd$var$Id(a) {
    Object.prototype.hasOwnProperty.call(a, $295abd054c1837dd$var$Hd) || (a[$295abd054c1837dd$var$Hd] = $295abd054c1837dd$var$Gd++, $295abd054c1837dd$var$Fd[a[$295abd054c1837dd$var$Hd]] = {});
    return $295abd054c1837dd$var$Fd[a[$295abd054c1837dd$var$Hd]];
}
function $295abd054c1837dd$var$Jd(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $295abd054c1837dd$var$Kd(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $295abd054c1837dd$var$Ld(a, b) {
    var c = $295abd054c1837dd$var$Kd(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $295abd054c1837dd$var$Kd(c);
    }
}
function $295abd054c1837dd$var$Md(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $295abd054c1837dd$var$Md(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $295abd054c1837dd$var$Nd() {
    for(var a = window, b = $295abd054c1837dd$var$Jd(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $295abd054c1837dd$var$Jd(a.document);
    }
    return b;
}
function $295abd054c1837dd$var$Od(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $295abd054c1837dd$var$Pd() {
    var a = $295abd054c1837dd$var$Nd();
    if ($295abd054c1837dd$var$Od(a)) {
        if ("selectionStart" in a) var b = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            b = (b = a.ownerDocument) && b.defaultView || window;
            var c = b.getSelection && b.getSelection();
            if (c && 0 !== c.rangeCount) {
                b = c.anchorNode;
                var d = c.anchorOffset, e = c.focusNode;
                c = c.focusOffset;
                try {
                    b.nodeType, e.nodeType;
                } catch (A) {
                    b = null;
                    break a;
                }
                var f = 0, g = -1, h = -1, l = 0, k = 0, m = a, p = null;
                b: for(;;){
                    for(var t;;){
                        m !== b || 0 !== d && 3 !== m.nodeType || (g = f + d);
                        m !== e || 0 !== c && 3 !== m.nodeType || (h = f + c);
                        3 === m.nodeType && (f += m.nodeValue.length);
                        if (null === (t = m.firstChild)) break;
                        p = m;
                        m = t;
                    }
                    for(;;){
                        if (m === a) break b;
                        p === b && ++l === d && (g = f);
                        p === e && ++k === c && (h = f);
                        if (null !== (t = m.nextSibling)) break;
                        m = p;
                        p = m.parentNode;
                    }
                    m = t;
                }
                b = -1 === g || -1 === h ? null : {
                    start: g,
                    end: h
                };
            } else b = null;
        }
        b = b || {
            start: 0,
            end: 0
        };
    } else b = null;
    return {
        focusedElem: a,
        selectionRange: b
    };
}
function $295abd054c1837dd$var$Qd(a) {
    var b = $295abd054c1837dd$var$Nd(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $295abd054c1837dd$var$Md(c.ownerDocument.documentElement, c)) {
        if (null !== d && $295abd054c1837dd$var$Od(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $295abd054c1837dd$var$Ld(c, f);
                var g = $295abd054c1837dd$var$Ld(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $295abd054c1837dd$var$Rd = $295abd054c1837dd$var$Ra && "documentMode" in document && 11 >= document.documentMode, $295abd054c1837dd$var$Sd = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $295abd054c1837dd$var$Td = null, $295abd054c1837dd$var$Ud = null, $295abd054c1837dd$var$Vd = null, $295abd054c1837dd$var$Wd = !1;
function $295abd054c1837dd$var$Xd(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($295abd054c1837dd$var$Wd || null == $295abd054c1837dd$var$Td || $295abd054c1837dd$var$Td !== $295abd054c1837dd$var$Jd(c)) return null;
    c = $295abd054c1837dd$var$Td;
    "selectionStart" in c && $295abd054c1837dd$var$Od(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $295abd054c1837dd$var$Vd && $295abd054c1837dd$var$dd($295abd054c1837dd$var$Vd, c) ? null : ($295abd054c1837dd$var$Vd = c, a = $295abd054c1837dd$var$y.getPooled($295abd054c1837dd$var$Sd.select, $295abd054c1837dd$var$Ud, a, b), a.type = "select", a.target = $295abd054c1837dd$var$Td, $295abd054c1837dd$var$Qa(a), a);
}
var $295abd054c1837dd$var$Yd = {
    eventTypes: $295abd054c1837dd$var$Sd,
    extractEvents: function(a, b, c, d) {
        var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument, f;
        if (!(f = !e)) {
            a: {
                e = $295abd054c1837dd$var$Id(e);
                f = $295abd054c1837dd$var$sa.onSelect;
                for(var g = 0; g < f.length; g++){
                    var h = f[g];
                    if (!e.hasOwnProperty(h) || !e[h]) {
                        e = !1;
                        break a;
                    }
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $295abd054c1837dd$var$Ja(b) : window;
        switch(a){
            case "focus":
                if ($295abd054c1837dd$var$Mb(e) || "true" === e.contentEditable) $295abd054c1837dd$var$Td = e, $295abd054c1837dd$var$Ud = b, $295abd054c1837dd$var$Vd = null;
                break;
            case "blur":
                $295abd054c1837dd$var$Vd = $295abd054c1837dd$var$Ud = $295abd054c1837dd$var$Td = null;
                break;
            case "mousedown":
                $295abd054c1837dd$var$Wd = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $295abd054c1837dd$var$Wd = !1, $295abd054c1837dd$var$Xd(c, d);
            case "selectionchange":
                if ($295abd054c1837dd$var$Rd) break;
            case "keydown":
            case "keyup":
                return $295abd054c1837dd$var$Xd(c, d);
        }
        return null;
    }
};
$295abd054c1837dd$var$Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$295abd054c1837dd$var$ta = $295abd054c1837dd$var$Ka;
$295abd054c1837dd$var$ua = $295abd054c1837dd$var$Ia;
$295abd054c1837dd$var$va = $295abd054c1837dd$var$Ja;
$295abd054c1837dd$var$Ba.injectEventPluginsByName({
    SimpleEventPlugin: $295abd054c1837dd$var$xd,
    EnterLeaveEventPlugin: $295abd054c1837dd$var$ad,
    ChangeEventPlugin: $295abd054c1837dd$var$Pc,
    SelectEventPlugin: $295abd054c1837dd$var$Yd,
    BeforeInputEventPlugin: $295abd054c1837dd$var$zb
});
function $295abd054c1837dd$var$Zd(a) {
    var b = "";
    $1bxDW.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $295abd054c1837dd$var$$d(a, b) {
    a = $b6jnv({
        children: void 0
    }, b);
    if (b = $295abd054c1837dd$var$Zd(b.children)) a.children = b;
    return a;
}
function $295abd054c1837dd$var$ae(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $295abd054c1837dd$var$uc(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $295abd054c1837dd$var$be(a, b) {
    null != b.dangerouslySetInnerHTML && $295abd054c1837dd$var$x("91");
    return $b6jnv({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $295abd054c1837dd$var$ce(a, b) {
    var c = b.value;
    null == c && (c = b.defaultValue, b = b.children, null != b && (null != c && $295abd054c1837dd$var$x("92"), Array.isArray(b) && (1 >= b.length || $295abd054c1837dd$var$x("93"), b = b[0]), c = b), null == c && (c = ""));
    a._wrapperState = {
        initialValue: $295abd054c1837dd$var$uc(c)
    };
}
function $295abd054c1837dd$var$de(a, b) {
    var c = $295abd054c1837dd$var$uc(b.value), d = $295abd054c1837dd$var$uc(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $295abd054c1837dd$var$ee(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && (a.value = b);
}
var $295abd054c1837dd$var$fe = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $295abd054c1837dd$var$ge(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $295abd054c1837dd$var$he(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $295abd054c1837dd$var$ge(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $295abd054c1837dd$var$ie = void 0, $295abd054c1837dd$var$je = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $295abd054c1837dd$var$fe.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $295abd054c1837dd$var$ie = $295abd054c1837dd$var$ie || document.createElement("div");
        $295abd054c1837dd$var$ie.innerHTML = "<svg>" + b + "</svg>";
        for(b = $295abd054c1837dd$var$ie.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $295abd054c1837dd$var$ke(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $295abd054c1837dd$var$le = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $295abd054c1837dd$var$me = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($295abd054c1837dd$var$le).forEach(function(a) {
    $295abd054c1837dd$var$me.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $295abd054c1837dd$var$le[b] = $295abd054c1837dd$var$le[a];
    });
});
function $295abd054c1837dd$var$ne(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $295abd054c1837dd$var$le.hasOwnProperty(a) && $295abd054c1837dd$var$le[a] ? ("" + b).trim() : b + "px";
}
function $295abd054c1837dd$var$oe(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $295abd054c1837dd$var$ne(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $295abd054c1837dd$var$pe = $b6jnv({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $295abd054c1837dd$var$qe(a, b) {
    b && ($295abd054c1837dd$var$pe[a] && (null != b.children || null != b.dangerouslySetInnerHTML) && $295abd054c1837dd$var$x("137", a, ""), null != b.dangerouslySetInnerHTML && (null != b.children && $295abd054c1837dd$var$x("60"), "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML || $295abd054c1837dd$var$x("61")), null != b.style && "object" !== typeof b.style && $295abd054c1837dd$var$x("62", ""));
}
function $295abd054c1837dd$var$re(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $295abd054c1837dd$var$se(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $295abd054c1837dd$var$Id(a);
    b = $295abd054c1837dd$var$sa[b];
    for(var d = 0; d < b.length; d++){
        var e = b[d];
        if (!c.hasOwnProperty(e) || !c[e]) {
            switch(e){
                case "scroll":
                    $295abd054c1837dd$var$Ed("scroll", a);
                    break;
                case "focus":
                case "blur":
                    $295abd054c1837dd$var$Ed("focus", a);
                    $295abd054c1837dd$var$Ed("blur", a);
                    c.blur = !0;
                    c.focus = !0;
                    break;
                case "cancel":
                case "close":
                    $295abd054c1837dd$var$Ob(e) && $295abd054c1837dd$var$Ed(e, a);
                    break;
                case "invalid":
                case "submit":
                case "reset":
                    break;
                default:
                    -1 === $295abd054c1837dd$var$ab.indexOf(e) && $295abd054c1837dd$var$E(e, a);
            }
            c[e] = !0;
        }
    }
}
function $295abd054c1837dd$var$te() {}
var $295abd054c1837dd$var$ue = null, $295abd054c1837dd$var$ve = null;
function $295abd054c1837dd$var$we(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $295abd054c1837dd$var$xe(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $295abd054c1837dd$var$ye = "function" === typeof setTimeout ? setTimeout : void 0, $295abd054c1837dd$var$ze = "function" === typeof clearTimeout ? clearTimeout : void 0, $295abd054c1837dd$var$Ae = $cMXW6.unstable_scheduleCallback, $295abd054c1837dd$var$Be = $cMXW6.unstable_cancelCallback;
function $295abd054c1837dd$var$Ce(a, b, c, d, e) {
    a[$295abd054c1837dd$var$Ga] = e;
    "input" === c && "radio" === e.type && null != e.name && $295abd054c1837dd$var$xc(a, e);
    $295abd054c1837dd$var$re(c, d);
    d = $295abd054c1837dd$var$re(c, e);
    for(var f = 0; f < b.length; f += 2){
        var g = b[f], h = b[f + 1];
        "style" === g ? $295abd054c1837dd$var$oe(a, h) : "dangerouslySetInnerHTML" === g ? $295abd054c1837dd$var$je(a, h) : "children" === g ? $295abd054c1837dd$var$ke(a, h) : $295abd054c1837dd$var$tc(a, g, h, d);
    }
    switch(c){
        case "input":
            $295abd054c1837dd$var$yc(a, e);
            break;
        case "textarea":
            $295abd054c1837dd$var$de(a, e);
            break;
        case "select":
            b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? $295abd054c1837dd$var$ae(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? $295abd054c1837dd$var$ae(a, !!e.multiple, e.defaultValue, !0) : $295abd054c1837dd$var$ae(a, !!e.multiple, e.multiple ? [] : "", !1));
    }
}
function $295abd054c1837dd$var$De(a) {
    for(a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
function $295abd054c1837dd$var$Ee(a) {
    for(a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;)a = a.nextSibling;
    return a;
}
new Set;
var $295abd054c1837dd$var$Fe = [], $295abd054c1837dd$var$Ge = -1;
function $295abd054c1837dd$var$F(a) {
    0 > $295abd054c1837dd$var$Ge || (a.current = $295abd054c1837dd$var$Fe[$295abd054c1837dd$var$Ge], $295abd054c1837dd$var$Fe[$295abd054c1837dd$var$Ge] = null, $295abd054c1837dd$var$Ge--);
}
function $295abd054c1837dd$var$G(a, b) {
    $295abd054c1837dd$var$Ge++;
    $295abd054c1837dd$var$Fe[$295abd054c1837dd$var$Ge] = a.current;
    a.current = b;
}
var $295abd054c1837dd$var$He = {}, $295abd054c1837dd$var$H = {
    current: $295abd054c1837dd$var$He
}, $295abd054c1837dd$var$I = {
    current: !1
}, $295abd054c1837dd$var$Ie = $295abd054c1837dd$var$He;
function $295abd054c1837dd$var$Je(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $295abd054c1837dd$var$He;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $295abd054c1837dd$var$J(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $295abd054c1837dd$var$Ke(a) {
    $295abd054c1837dd$var$F($295abd054c1837dd$var$I, a);
    $295abd054c1837dd$var$F($295abd054c1837dd$var$H, a);
}
function $295abd054c1837dd$var$Le(a) {
    $295abd054c1837dd$var$F($295abd054c1837dd$var$I, a);
    $295abd054c1837dd$var$F($295abd054c1837dd$var$H, a);
}
function $295abd054c1837dd$var$Me(a, b, c) {
    $295abd054c1837dd$var$H.current !== $295abd054c1837dd$var$He && $295abd054c1837dd$var$x("168");
    $295abd054c1837dd$var$G($295abd054c1837dd$var$H, b, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$I, c, a);
}
function $295abd054c1837dd$var$Ne(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)e in a || $295abd054c1837dd$var$x("108", $295abd054c1837dd$var$ic(b) || "Unknown", e);
    return $b6jnv({}, c, d);
}
function $295abd054c1837dd$var$Oe(a) {
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || $295abd054c1837dd$var$He;
    $295abd054c1837dd$var$Ie = $295abd054c1837dd$var$H.current;
    $295abd054c1837dd$var$G($295abd054c1837dd$var$H, b, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$I, $295abd054c1837dd$var$I.current, a);
    return !0;
}
function $295abd054c1837dd$var$Pe(a, b, c) {
    var d = a.stateNode;
    d || $295abd054c1837dd$var$x("169");
    c ? (b = $295abd054c1837dd$var$Ne(a, b, $295abd054c1837dd$var$Ie), d.__reactInternalMemoizedMergedChildContext = b, $295abd054c1837dd$var$F($295abd054c1837dd$var$I, a), $295abd054c1837dd$var$F($295abd054c1837dd$var$H, a), $295abd054c1837dd$var$G($295abd054c1837dd$var$H, b, a)) : $295abd054c1837dd$var$F($295abd054c1837dd$var$I, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$I, c, a);
}
var $295abd054c1837dd$var$Qe = null, $295abd054c1837dd$var$Re = null;
function $295abd054c1837dd$var$Se(a) {
    return function(b) {
        try {
            return a(b);
        } catch (c) {}
    };
}
function $295abd054c1837dd$var$Te(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $295abd054c1837dd$var$Qe = $295abd054c1837dd$var$Se(function(a) {
            return b.onCommitFiberRoot(c, a);
        });
        $295abd054c1837dd$var$Re = $295abd054c1837dd$var$Se(function(a) {
            return b.onCommitFiberUnmount(c, a);
        });
    } catch (d) {}
    return !0;
}
function $295abd054c1837dd$var$Ue(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.contextDependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $295abd054c1837dd$var$K(a, b, c, d) {
    return new $295abd054c1837dd$var$Ue(a, b, c, d);
}
function $295abd054c1837dd$var$Ve(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $295abd054c1837dd$var$We(a) {
    if ("function" === typeof a) return $295abd054c1837dd$var$Ve(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $295abd054c1837dd$var$cc) return 11;
        if (a === $295abd054c1837dd$var$ec) return 14;
    }
    return 2;
}
function $295abd054c1837dd$var$Xe(a, b) {
    var c = a.alternate;
    null === c ? (c = $295abd054c1837dd$var$K(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    c.contextDependencies = a.contextDependencies;
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $295abd054c1837dd$var$Ye(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $295abd054c1837dd$var$Ve(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $295abd054c1837dd$var$Xb:
            return $295abd054c1837dd$var$Ze(c.children, e, f, b);
        case $295abd054c1837dd$var$bc:
            return $295abd054c1837dd$var$$e(c, e | 3, f, b);
        case $295abd054c1837dd$var$Yb:
            return $295abd054c1837dd$var$$e(c, e | 2, f, b);
        case $295abd054c1837dd$var$Zb:
            return a = $295abd054c1837dd$var$K(12, c, b, e | 4), a.elementType = $295abd054c1837dd$var$Zb, a.type = $295abd054c1837dd$var$Zb, a.expirationTime = f, a;
        case $295abd054c1837dd$var$dc:
            return a = $295abd054c1837dd$var$K(13, c, b, e), a.elementType = $295abd054c1837dd$var$dc, a.type = $295abd054c1837dd$var$dc, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $295abd054c1837dd$var$$b:
                    g = 10;
                    break a;
                case $295abd054c1837dd$var$ac:
                    g = 9;
                    break a;
                case $295abd054c1837dd$var$cc:
                    g = 11;
                    break a;
                case $295abd054c1837dd$var$ec:
                    g = 14;
                    break a;
                case $295abd054c1837dd$var$fc:
                    g = 16;
                    d = null;
                    break a;
            }
            $295abd054c1837dd$var$x("130", null == a ? a : typeof a, "");
    }
    b = $295abd054c1837dd$var$K(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $295abd054c1837dd$var$Ze(a, b, c, d) {
    a = $295abd054c1837dd$var$K(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $295abd054c1837dd$var$$e(a, b, c, d) {
    a = $295abd054c1837dd$var$K(8, a, d, b);
    b = 0 === (b & 1) ? $295abd054c1837dd$var$Yb : $295abd054c1837dd$var$bc;
    a.elementType = b;
    a.type = b;
    a.expirationTime = c;
    return a;
}
function $295abd054c1837dd$var$af(a, b, c) {
    a = $295abd054c1837dd$var$K(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $295abd054c1837dd$var$bf(a, b, c) {
    b = $295abd054c1837dd$var$K(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $295abd054c1837dd$var$cf(a, b) {
    a.didError = !1;
    var c = a.earliestPendingTime;
    0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);
    $295abd054c1837dd$var$df(b, a);
}
function $295abd054c1837dd$var$ef(a, b) {
    a.didError = !1;
    if (0 === b) a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0;
    else {
        b < a.latestPingedTime && (a.latestPingedTime = 0);
        var c = a.latestPendingTime;
        0 !== c && (c > b ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > b && (a.earliestPendingTime = a.latestPendingTime));
        c = a.earliestSuspendedTime;
        0 === c ? $295abd054c1837dd$var$cf(a, b) : b < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, $295abd054c1837dd$var$cf(a, b)) : b > c && $295abd054c1837dd$var$cf(a, b);
    }
    $295abd054c1837dd$var$df(0, a);
}
function $295abd054c1837dd$var$ff(a, b) {
    a.didError = !1;
    a.latestPingedTime >= b && (a.latestPingedTime = 0);
    var c = a.earliestPendingTime, d = a.latestPendingTime;
    c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);
    c = a.earliestSuspendedTime;
    d = a.latestSuspendedTime;
    0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);
    $295abd054c1837dd$var$df(b, a);
}
function $295abd054c1837dd$var$gf(a, b) {
    var c = a.earliestPendingTime;
    a = a.earliestSuspendedTime;
    c > b && (b = c);
    a > b && (b = a);
    return b;
}
function $295abd054c1837dd$var$df(a, b) {
    var c = b.earliestSuspendedTime, d = b.latestSuspendedTime, e = b.earliestPendingTime, f = b.latestPingedTime;
    e = 0 !== e ? e : f;
    0 === e && (0 === a || d < a) && (e = d);
    a = e;
    0 !== a && c > a && (a = c);
    b.nextExpirationTimeToWorkOn = e;
    b.expirationTime = a;
}
function $295abd054c1837dd$var$L(a, b) {
    if (a && a.defaultProps) {
        b = $b6jnv({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
function $295abd054c1837dd$var$hf(a) {
    var b = a._result;
    switch(a._status){
        case 1:
            return b;
        case 2:
            throw b;
        case 0:
            throw b;
        default:
            a._status = 0;
            b = a._ctor;
            b = b();
            b.then(function(b) {
                0 === a._status && (b = b.default, a._status = 1, a._result = b);
            }, function(b) {
                0 === a._status && (a._status = 2, a._result = b);
            });
            switch(a._status){
                case 1:
                    return a._result;
                case 2:
                    throw a._result;
            }
            a._result = b;
            throw b;
    }
}
var $295abd054c1837dd$var$jf = (new $1bxDW.Component).refs;
function $295abd054c1837dd$var$kf(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b6jnv({}, b, c);
    a.memoizedState = c;
    d = a.updateQueue;
    null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var $295abd054c1837dd$var$tf = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? 2 === $295abd054c1837dd$var$ed(a) : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $295abd054c1837dd$var$lf();
        d = $295abd054c1837dd$var$mf(d, a);
        var e = $295abd054c1837dd$var$nf(d);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $295abd054c1837dd$var$of();
        $295abd054c1837dd$var$pf(a, e);
        $295abd054c1837dd$var$qf(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $295abd054c1837dd$var$lf();
        d = $295abd054c1837dd$var$mf(d, a);
        var e = $295abd054c1837dd$var$nf(d);
        e.tag = $295abd054c1837dd$var$rf;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $295abd054c1837dd$var$of();
        $295abd054c1837dd$var$pf(a, e);
        $295abd054c1837dd$var$qf(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $295abd054c1837dd$var$lf();
        c = $295abd054c1837dd$var$mf(c, a);
        var d = $295abd054c1837dd$var$nf(c);
        d.tag = $295abd054c1837dd$var$sf;
        void 0 !== b && null !== b && (d.callback = b);
        $295abd054c1837dd$var$of();
        $295abd054c1837dd$var$pf(a, d);
        $295abd054c1837dd$var$qf(a, c);
    }
};
function $295abd054c1837dd$var$uf(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$295abd054c1837dd$var$dd(c, d) || !$295abd054c1837dd$var$dd(e, f) : !0;
}
function $295abd054c1837dd$var$vf(a, b, c) {
    var d = !1, e = $295abd054c1837dd$var$He;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $295abd054c1837dd$var$M(f) : (e = $295abd054c1837dd$var$J(b) ? $295abd054c1837dd$var$Ie : $295abd054c1837dd$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $295abd054c1837dd$var$Je(a, e) : $295abd054c1837dd$var$He);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $295abd054c1837dd$var$tf;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $295abd054c1837dd$var$wf(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $295abd054c1837dd$var$tf.enqueueReplaceState(b, b.state, null);
}
function $295abd054c1837dd$var$xf(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $295abd054c1837dd$var$jf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $295abd054c1837dd$var$M(f) : (f = $295abd054c1837dd$var$J(b) ? $295abd054c1837dd$var$Ie : $295abd054c1837dd$var$H.current, e.context = $295abd054c1837dd$var$Je(a, f));
    f = a.updateQueue;
    null !== f && ($295abd054c1837dd$var$yf(a, f, c, e, d), e.state = a.memoizedState);
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($295abd054c1837dd$var$kf(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $295abd054c1837dd$var$tf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && ($295abd054c1837dd$var$yf(a, f, c, e, d), e.state = a.memoizedState));
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $295abd054c1837dd$var$zf = Array.isArray;
function $295abd054c1837dd$var$Af(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            var d = void 0;
            c && (1 !== c.tag && $295abd054c1837dd$var$x("309"), d = c.stateNode);
            d || $295abd054c1837dd$var$x("147", a);
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $295abd054c1837dd$var$jf && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        "string" !== typeof a && $295abd054c1837dd$var$x("284");
        c._owner || $295abd054c1837dd$var$x("290", a);
    }
    return a;
}
function $295abd054c1837dd$var$Bf(a, b) {
    "textarea" !== a.type && $295abd054c1837dd$var$x("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function $295abd054c1837dd$var$Cf(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b, c) {
        a = $295abd054c1837dd$var$Xe(a, b, c);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $295abd054c1837dd$var$af(c, a.mode, d), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function l(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $295abd054c1837dd$var$Af(a, b, c), d.return = a, d;
        d = $295abd054c1837dd$var$Ye(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $295abd054c1837dd$var$Af(a, b, c);
        d.return = a;
        return d;
    }
    function k(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $295abd054c1837dd$var$bf(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || [], d);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $295abd054c1837dd$var$Ze(c, a.mode, d, f), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $295abd054c1837dd$var$af("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $295abd054c1837dd$var$Vb:
                    return c = $295abd054c1837dd$var$Ye(b.type, b.key, b.props, null, a.mode, c), c.ref = $295abd054c1837dd$var$Af(a, null, b), c.return = a, c;
                case $295abd054c1837dd$var$Wb:
                    return b = $295abd054c1837dd$var$bf(b, a.mode, c), b.return = a, b;
            }
            if ($295abd054c1837dd$var$zf(b) || $295abd054c1837dd$var$hc(b)) return b = $295abd054c1837dd$var$Ze(b, a.mode, c, null), b.return = a, b;
            $295abd054c1837dd$var$Bf(a, b);
        }
        return null;
    }
    function t(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $295abd054c1837dd$var$Vb:
                    return c.key === e ? c.type === $295abd054c1837dd$var$Xb ? m(a, b, c.props.children, d, e) : l(a, b, c, d) : null;
                case $295abd054c1837dd$var$Wb:
                    return c.key === e ? k(a, b, c, d) : null;
            }
            if ($295abd054c1837dd$var$zf(c) || $295abd054c1837dd$var$hc(c)) return null !== e ? null : m(a, b, c, d, null);
            $295abd054c1837dd$var$Bf(a, c);
        }
        return null;
    }
    function A(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $295abd054c1837dd$var$Vb:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $295abd054c1837dd$var$Xb ? m(b, a, d.props.children, e, d.key) : l(b, a, d, e);
                case $295abd054c1837dd$var$Wb:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
            }
            if ($295abd054c1837dd$var$zf(d) || $295abd054c1837dd$var$hc(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $295abd054c1837dd$var$Bf(b, d);
        }
        return null;
    }
    function v(e, g, h, k) {
        for(var l = null, m = null, q = g, u = g = 0, B = null; null !== q && u < h.length; u++){
            q.index > u ? (B = q, q = null) : B = q.sibling;
            var w = t(e, q, h[u], k);
            if (null === w) {
                null === q && (q = B);
                break;
            }
            a && q && null === w.alternate && b(e, q);
            g = f(w, g, u);
            null === m ? l = w : m.sibling = w;
            m = w;
            q = B;
        }
        if (u === h.length) return c(e, q), l;
        if (null === q) {
            for(; u < h.length; u++)if (q = p(e, h[u], k)) g = f(q, g, u), null === m ? l = q : m.sibling = q, m = q;
            return l;
        }
        for(q = d(e, q); u < h.length; u++)if (B = A(q, e, u, h[u], k)) a && null !== B.alternate && q.delete(null === B.key ? u : B.key), g = f(B, g, u), null === m ? l = B : m.sibling = B, m = B;
        a && q.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function R(e, g, h, k) {
        var l = $295abd054c1837dd$var$hc(h);
        "function" !== typeof l && $295abd054c1837dd$var$x("150");
        h = l.call(h);
        null == h && $295abd054c1837dd$var$x("151");
        for(var m = l = null, q = g, u = g = 0, B = null, w = h.next(); null !== q && !w.done; u++, w = h.next()){
            q.index > u ? (B = q, q = null) : B = q.sibling;
            var v = t(e, q, w.value, k);
            if (null === v) {
                q || (q = B);
                break;
            }
            a && q && null === v.alternate && b(e, q);
            g = f(v, g, u);
            null === m ? l = v : m.sibling = v;
            m = v;
            q = B;
        }
        if (w.done) return c(e, q), l;
        if (null === q) {
            for(; !w.done; u++, w = h.next())w = p(e, w.value, k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
            return l;
        }
        for(q = d(e, q); !w.done; u++, w = h.next())w = A(q, e, u, w.value, k), null !== w && (a && null !== w.alternate && q.delete(null === w.key ? u : w.key), g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
        a && q.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $295abd054c1837dd$var$Xb && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $295abd054c1837dd$var$Vb:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            if (7 === k.tag ? f.type === $295abd054c1837dd$var$Xb : k.elementType === f.type) {
                                c(a, k.sibling);
                                d = e(k, f.type === $295abd054c1837dd$var$Xb ? f.props.children : f.props, h);
                                d.ref = $295abd054c1837dd$var$Af(a, k, f);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, k);
                                break;
                            }
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $295abd054c1837dd$var$Xb ? (d = $295abd054c1837dd$var$Ze(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $295abd054c1837dd$var$Ye(f.type, f.key, f.props, null, a.mode, h), h.ref = $295abd054c1837dd$var$Af(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $295abd054c1837dd$var$Wb:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || [], h);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $295abd054c1837dd$var$bf(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = $295abd054c1837dd$var$af(f, a.mode, h), d.return = a, a = d), g(a);
        if ($295abd054c1837dd$var$zf(f)) return v(a, d, f, h);
        if ($295abd054c1837dd$var$hc(f)) return R(a, d, f, h);
        l && $295abd054c1837dd$var$Bf(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                h = a.type, $295abd054c1837dd$var$x("152", h.displayName || h.name || "Component");
        }
        return c(a, d);
    };
}
var $295abd054c1837dd$var$Df = $295abd054c1837dd$var$Cf(!0), $295abd054c1837dd$var$Ef = $295abd054c1837dd$var$Cf(!1), $295abd054c1837dd$var$Ff = {}, $295abd054c1837dd$var$N = {
    current: $295abd054c1837dd$var$Ff
}, $295abd054c1837dd$var$Gf = {
    current: $295abd054c1837dd$var$Ff
}, $295abd054c1837dd$var$Hf = {
    current: $295abd054c1837dd$var$Ff
};
function $295abd054c1837dd$var$If(a) {
    a === $295abd054c1837dd$var$Ff && $295abd054c1837dd$var$x("174");
    return a;
}
function $295abd054c1837dd$var$Jf(a, b) {
    $295abd054c1837dd$var$G($295abd054c1837dd$var$Hf, b, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$Gf, a, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$N, $295abd054c1837dd$var$Ff, a);
    var c = b.nodeType;
    switch(c){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $295abd054c1837dd$var$he(null, "");
            break;
        default:
            c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = $295abd054c1837dd$var$he(b, c);
    }
    $295abd054c1837dd$var$F($295abd054c1837dd$var$N, a);
    $295abd054c1837dd$var$G($295abd054c1837dd$var$N, b, a);
}
function $295abd054c1837dd$var$Kf(a) {
    $295abd054c1837dd$var$F($295abd054c1837dd$var$N, a);
    $295abd054c1837dd$var$F($295abd054c1837dd$var$Gf, a);
    $295abd054c1837dd$var$F($295abd054c1837dd$var$Hf, a);
}
function $295abd054c1837dd$var$Lf(a) {
    $295abd054c1837dd$var$If($295abd054c1837dd$var$Hf.current);
    var b = $295abd054c1837dd$var$If($295abd054c1837dd$var$N.current);
    var c = $295abd054c1837dd$var$he(b, a.type);
    b !== c && ($295abd054c1837dd$var$G($295abd054c1837dd$var$Gf, a, a), $295abd054c1837dd$var$G($295abd054c1837dd$var$N, c, a));
}
function $295abd054c1837dd$var$Mf(a) {
    $295abd054c1837dd$var$Gf.current === a && ($295abd054c1837dd$var$F($295abd054c1837dd$var$N, a), $295abd054c1837dd$var$F($295abd054c1837dd$var$Gf, a));
}
var $295abd054c1837dd$var$Nf = 0, $295abd054c1837dd$var$Of = 2, $295abd054c1837dd$var$Pf = 4, $295abd054c1837dd$var$Qf = 8, $295abd054c1837dd$var$Rf = 16, $295abd054c1837dd$var$Sf = 32, $295abd054c1837dd$var$Tf = 64, $295abd054c1837dd$var$Uf = 128, $295abd054c1837dd$var$Vf = $295abd054c1837dd$var$Tb.ReactCurrentDispatcher, $295abd054c1837dd$var$Wf = 0, $295abd054c1837dd$var$Xf = null, $295abd054c1837dd$var$O = null, $295abd054c1837dd$var$P = null, $295abd054c1837dd$var$Yf = null, $295abd054c1837dd$var$Q = null, $295abd054c1837dd$var$Zf = null, $295abd054c1837dd$var$$f = 0, $295abd054c1837dd$var$ag = null, $295abd054c1837dd$var$bg = 0, $295abd054c1837dd$var$cg = !1, $295abd054c1837dd$var$dg = null, $295abd054c1837dd$var$eg = 0;
function $295abd054c1837dd$var$fg() {
    $295abd054c1837dd$var$x("321");
}
function $295abd054c1837dd$var$gg(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$295abd054c1837dd$var$bd(a[c], b[c])) return !1;
    return !0;
}
function $295abd054c1837dd$var$hg(a, b, c, d, e, f) {
    $295abd054c1837dd$var$Wf = f;
    $295abd054c1837dd$var$Xf = b;
    $295abd054c1837dd$var$P = null !== a ? a.memoizedState : null;
    $295abd054c1837dd$var$Vf.current = null === $295abd054c1837dd$var$P ? $295abd054c1837dd$var$ig : $295abd054c1837dd$var$jg;
    b = c(d, e);
    if ($295abd054c1837dd$var$cg) {
        do $295abd054c1837dd$var$cg = !1, $295abd054c1837dd$var$eg += 1, $295abd054c1837dd$var$P = null !== a ? a.memoizedState : null, $295abd054c1837dd$var$Zf = $295abd054c1837dd$var$Yf, $295abd054c1837dd$var$ag = $295abd054c1837dd$var$Q = $295abd054c1837dd$var$O = null, $295abd054c1837dd$var$Vf.current = $295abd054c1837dd$var$jg, b = c(d, e);
        while ($295abd054c1837dd$var$cg);
        $295abd054c1837dd$var$dg = null;
        $295abd054c1837dd$var$eg = 0;
    }
    $295abd054c1837dd$var$Vf.current = $295abd054c1837dd$var$kg;
    a = $295abd054c1837dd$var$Xf;
    a.memoizedState = $295abd054c1837dd$var$Yf;
    a.expirationTime = $295abd054c1837dd$var$$f;
    a.updateQueue = $295abd054c1837dd$var$ag;
    a.effectTag |= $295abd054c1837dd$var$bg;
    a = null !== $295abd054c1837dd$var$O && null !== $295abd054c1837dd$var$O.next;
    $295abd054c1837dd$var$Wf = 0;
    $295abd054c1837dd$var$Zf = $295abd054c1837dd$var$Q = $295abd054c1837dd$var$Yf = $295abd054c1837dd$var$P = $295abd054c1837dd$var$O = $295abd054c1837dd$var$Xf = null;
    $295abd054c1837dd$var$$f = 0;
    $295abd054c1837dd$var$ag = null;
    $295abd054c1837dd$var$bg = 0;
    a && $295abd054c1837dd$var$x("300");
    return b;
}
function $295abd054c1837dd$var$lg() {
    $295abd054c1837dd$var$Vf.current = $295abd054c1837dd$var$kg;
    $295abd054c1837dd$var$Wf = 0;
    $295abd054c1837dd$var$Zf = $295abd054c1837dd$var$Q = $295abd054c1837dd$var$Yf = $295abd054c1837dd$var$P = $295abd054c1837dd$var$O = $295abd054c1837dd$var$Xf = null;
    $295abd054c1837dd$var$$f = 0;
    $295abd054c1837dd$var$ag = null;
    $295abd054c1837dd$var$bg = 0;
    $295abd054c1837dd$var$cg = !1;
    $295abd054c1837dd$var$dg = null;
    $295abd054c1837dd$var$eg = 0;
}
function $295abd054c1837dd$var$mg() {
    var a = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
    };
    null === $295abd054c1837dd$var$Q ? $295abd054c1837dd$var$Yf = $295abd054c1837dd$var$Q = a : $295abd054c1837dd$var$Q = $295abd054c1837dd$var$Q.next = a;
    return $295abd054c1837dd$var$Q;
}
function $295abd054c1837dd$var$ng() {
    if (null !== $295abd054c1837dd$var$Zf) $295abd054c1837dd$var$Q = $295abd054c1837dd$var$Zf, $295abd054c1837dd$var$Zf = $295abd054c1837dd$var$Q.next, $295abd054c1837dd$var$O = $295abd054c1837dd$var$P, $295abd054c1837dd$var$P = null !== $295abd054c1837dd$var$O ? $295abd054c1837dd$var$O.next : null;
    else {
        null === $295abd054c1837dd$var$P && $295abd054c1837dd$var$x("310");
        $295abd054c1837dd$var$O = $295abd054c1837dd$var$P;
        var a = {
            memoizedState: $295abd054c1837dd$var$O.memoizedState,
            baseState: $295abd054c1837dd$var$O.baseState,
            queue: $295abd054c1837dd$var$O.queue,
            baseUpdate: $295abd054c1837dd$var$O.baseUpdate,
            next: null
        };
        $295abd054c1837dd$var$Q = null === $295abd054c1837dd$var$Q ? $295abd054c1837dd$var$Yf = a : $295abd054c1837dd$var$Q.next = a;
        $295abd054c1837dd$var$P = $295abd054c1837dd$var$O.next;
    }
    return $295abd054c1837dd$var$Q;
}
function $295abd054c1837dd$var$og(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $295abd054c1837dd$var$pg(a) {
    var b = $295abd054c1837dd$var$ng(), c = b.queue;
    null === c && $295abd054c1837dd$var$x("311");
    c.lastRenderedReducer = a;
    if (0 < $295abd054c1837dd$var$eg) {
        var d = c.dispatch;
        if (null !== $295abd054c1837dd$var$dg) {
            var e = $295abd054c1837dd$var$dg.get(c);
            if (void 0 !== e) {
                $295abd054c1837dd$var$dg.delete(c);
                var f = b.memoizedState;
                do f = a(f, e.action), e = e.next;
                while (null !== e);
                $295abd054c1837dd$var$bd(f, b.memoizedState) || ($295abd054c1837dd$var$qg = !0);
                b.memoizedState = f;
                b.baseUpdate === c.last && (b.baseState = f);
                c.lastRenderedState = f;
                return [
                    f,
                    d
                ];
            }
        }
        return [
            b.memoizedState,
            d
        ];
    }
    d = c.last;
    var g = b.baseUpdate;
    f = b.baseState;
    null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
    if (null !== d) {
        var h = e = null, l = d, k = !1;
        do {
            var m = l.expirationTime;
            m < $295abd054c1837dd$var$Wf ? (k || (k = !0, h = g, e = f), m > $295abd054c1837dd$var$$f && ($295abd054c1837dd$var$$f = m)) : f = l.eagerReducer === a ? l.eagerState : a(f, l.action);
            g = l;
            l = l.next;
        }while (null !== l && l !== d);
        k || (h = g, e = f);
        $295abd054c1837dd$var$bd(f, b.memoizedState) || ($295abd054c1837dd$var$qg = !0);
        b.memoizedState = f;
        b.baseUpdate = h;
        b.baseState = e;
        c.lastRenderedState = f;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $295abd054c1837dd$var$rg(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    null === $295abd054c1837dd$var$ag ? ($295abd054c1837dd$var$ag = {
        lastEffect: null
    }, $295abd054c1837dd$var$ag.lastEffect = a.next = a) : (b = $295abd054c1837dd$var$ag.lastEffect, null === b ? $295abd054c1837dd$var$ag.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, $295abd054c1837dd$var$ag.lastEffect = a));
    return a;
}
function $295abd054c1837dd$var$sg(a, b, c, d) {
    var e = $295abd054c1837dd$var$mg();
    $295abd054c1837dd$var$bg |= a;
    e.memoizedState = $295abd054c1837dd$var$rg(b, c, void 0, void 0 === d ? null : d);
}
function $295abd054c1837dd$var$tg(a, b, c, d) {
    var e = $295abd054c1837dd$var$ng();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $295abd054c1837dd$var$O) {
        var g = $295abd054c1837dd$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $295abd054c1837dd$var$gg(d, g.deps)) {
            $295abd054c1837dd$var$rg($295abd054c1837dd$var$Nf, c, f, d);
            return;
        }
    }
    $295abd054c1837dd$var$bg |= a;
    e.memoizedState = $295abd054c1837dd$var$rg(b, c, f, d);
}
function $295abd054c1837dd$var$ug(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $295abd054c1837dd$var$vg() {}
function $295abd054c1837dd$var$wg(a, b, c) {
    25 > $295abd054c1837dd$var$eg || $295abd054c1837dd$var$x("301");
    var d = a.alternate;
    if (a === $295abd054c1837dd$var$Xf || null !== d && d === $295abd054c1837dd$var$Xf) {
        if ($295abd054c1837dd$var$cg = !0, a = {
            expirationTime: $295abd054c1837dd$var$Wf,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, null === $295abd054c1837dd$var$dg && ($295abd054c1837dd$var$dg = new Map), c = $295abd054c1837dd$var$dg.get(b), void 0 === c) $295abd054c1837dd$var$dg.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    } else {
        $295abd054c1837dd$var$of();
        var e = $295abd054c1837dd$var$lf();
        e = $295abd054c1837dd$var$mf(e, a);
        var f = {
            expirationTime: e,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, g = b.last;
        if (null === g) f.next = f;
        else {
            var h = g.next;
            null !== h && (f.next = h);
            g.next = f;
        }
        b.last = f;
        if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
            var l = b.lastRenderedState, k = d(l, c);
            f.eagerReducer = d;
            f.eagerState = k;
            if ($295abd054c1837dd$var$bd(k, l)) return;
        } catch (m) {} finally{}
        $295abd054c1837dd$var$qf(a, e);
    }
}
var $295abd054c1837dd$var$kg = {
    readContext: $295abd054c1837dd$var$M,
    useCallback: $295abd054c1837dd$var$fg,
    useContext: $295abd054c1837dd$var$fg,
    useEffect: $295abd054c1837dd$var$fg,
    useImperativeHandle: $295abd054c1837dd$var$fg,
    useLayoutEffect: $295abd054c1837dd$var$fg,
    useMemo: $295abd054c1837dd$var$fg,
    useReducer: $295abd054c1837dd$var$fg,
    useRef: $295abd054c1837dd$var$fg,
    useState: $295abd054c1837dd$var$fg,
    useDebugValue: $295abd054c1837dd$var$fg
}, $295abd054c1837dd$var$ig = {
    readContext: $295abd054c1837dd$var$M,
    useCallback: function(a, b) {
        $295abd054c1837dd$var$mg().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $295abd054c1837dd$var$M,
    useEffect: function(a, b) {
        return $295abd054c1837dd$var$sg(516, $295abd054c1837dd$var$Uf | $295abd054c1837dd$var$Tf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $295abd054c1837dd$var$sg(4, $295abd054c1837dd$var$Pf | $295abd054c1837dd$var$Sf, $295abd054c1837dd$var$ug.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $295abd054c1837dd$var$sg(4, $295abd054c1837dd$var$Pf | $295abd054c1837dd$var$Sf, a, b);
    },
    useMemo: function(a, b) {
        var c = $295abd054c1837dd$var$mg();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $295abd054c1837dd$var$mg();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $295abd054c1837dd$var$wg.bind(null, $295abd054c1837dd$var$Xf, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $295abd054c1837dd$var$mg();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: function(a) {
        var b = $295abd054c1837dd$var$mg();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: $295abd054c1837dd$var$og,
            lastRenderedState: a
        };
        a = a.dispatch = $295abd054c1837dd$var$wg.bind(null, $295abd054c1837dd$var$Xf, a);
        return [
            b.memoizedState,
            a
        ];
    },
    useDebugValue: $295abd054c1837dd$var$vg
}, $295abd054c1837dd$var$jg = {
    readContext: $295abd054c1837dd$var$M,
    useCallback: function(a, b) {
        var c = $295abd054c1837dd$var$ng();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $295abd054c1837dd$var$gg(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useContext: $295abd054c1837dd$var$M,
    useEffect: function(a, b) {
        return $295abd054c1837dd$var$tg(516, $295abd054c1837dd$var$Uf | $295abd054c1837dd$var$Tf, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $295abd054c1837dd$var$tg(4, $295abd054c1837dd$var$Pf | $295abd054c1837dd$var$Sf, $295abd054c1837dd$var$ug.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $295abd054c1837dd$var$tg(4, $295abd054c1837dd$var$Pf | $295abd054c1837dd$var$Sf, a, b);
    },
    useMemo: function(a, b) {
        var c = $295abd054c1837dd$var$ng();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $295abd054c1837dd$var$gg(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $295abd054c1837dd$var$pg,
    useRef: function() {
        return $295abd054c1837dd$var$ng().memoizedState;
    },
    useState: function(a) {
        return $295abd054c1837dd$var$pg($295abd054c1837dd$var$og, a);
    },
    useDebugValue: $295abd054c1837dd$var$vg
}, $295abd054c1837dd$var$xg = null, $295abd054c1837dd$var$yg = null, $295abd054c1837dd$var$zg = !1;
function $295abd054c1837dd$var$Ag(a, b) {
    var c = $295abd054c1837dd$var$K(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $295abd054c1837dd$var$Bg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $295abd054c1837dd$var$Cg(a) {
    if ($295abd054c1837dd$var$zg) {
        var b = $295abd054c1837dd$var$yg;
        if (b) {
            var c = b;
            if (!$295abd054c1837dd$var$Bg(a, b)) {
                b = $295abd054c1837dd$var$De(c);
                if (!b || !$295abd054c1837dd$var$Bg(a, b)) {
                    a.effectTag |= 2;
                    $295abd054c1837dd$var$zg = !1;
                    $295abd054c1837dd$var$xg = a;
                    return;
                }
                $295abd054c1837dd$var$Ag($295abd054c1837dd$var$xg, c);
            }
            $295abd054c1837dd$var$xg = a;
            $295abd054c1837dd$var$yg = $295abd054c1837dd$var$Ee(b);
        } else a.effectTag |= 2, $295abd054c1837dd$var$zg = !1, $295abd054c1837dd$var$xg = a;
    }
}
function $295abd054c1837dd$var$Dg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 18 !== a.tag;)a = a.return;
    $295abd054c1837dd$var$xg = a;
}
function $295abd054c1837dd$var$Eg(a) {
    if (a !== $295abd054c1837dd$var$xg) return !1;
    if (!$295abd054c1837dd$var$zg) return $295abd054c1837dd$var$Dg(a), $295abd054c1837dd$var$zg = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$295abd054c1837dd$var$xe(b, a.memoizedProps)) for(b = $295abd054c1837dd$var$yg; b;)$295abd054c1837dd$var$Ag(a, b), b = $295abd054c1837dd$var$De(b);
    $295abd054c1837dd$var$Dg(a);
    $295abd054c1837dd$var$yg = $295abd054c1837dd$var$xg ? $295abd054c1837dd$var$De(a.stateNode) : null;
    return !0;
}
function $295abd054c1837dd$var$Fg() {
    $295abd054c1837dd$var$yg = $295abd054c1837dd$var$xg = null;
    $295abd054c1837dd$var$zg = !1;
}
var $295abd054c1837dd$var$Gg = $295abd054c1837dd$var$Tb.ReactCurrentOwner, $295abd054c1837dd$var$qg = !1;
function $295abd054c1837dd$var$S(a, b, c, d) {
    b.child = null === a ? $295abd054c1837dd$var$Ef(b, null, c, d) : $295abd054c1837dd$var$Df(b, a.child, c, d);
}
function $295abd054c1837dd$var$Hg(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $295abd054c1837dd$var$Ig(b, e);
    d = $295abd054c1837dd$var$hg(a, b, c, d, f, e);
    if (null !== a && !$295abd054c1837dd$var$qg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $295abd054c1837dd$var$Jg(a, b, e);
    b.effectTag |= 1;
    $295abd054c1837dd$var$S(a, b, d, e);
    return b.child;
}
function $295abd054c1837dd$var$Kg(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$295abd054c1837dd$var$Ve(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $295abd054c1837dd$var$Lg(a, b, g, d, e, f);
        a = $295abd054c1837dd$var$Ye(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $295abd054c1837dd$var$dd, c(e, d) && a.ref === b.ref)) return $295abd054c1837dd$var$Jg(a, b, f);
    b.effectTag |= 1;
    a = $295abd054c1837dd$var$Xe(g, d, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $295abd054c1837dd$var$Lg(a, b, c, d, e, f) {
    return null !== a && $295abd054c1837dd$var$dd(a.memoizedProps, d) && a.ref === b.ref && ($295abd054c1837dd$var$qg = !1, e < f) ? $295abd054c1837dd$var$Jg(a, b, f) : $295abd054c1837dd$var$Mg(a, b, c, d, f);
}
function $295abd054c1837dd$var$Ng(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $295abd054c1837dd$var$Mg(a, b, c, d, e) {
    var f = $295abd054c1837dd$var$J(c) ? $295abd054c1837dd$var$Ie : $295abd054c1837dd$var$H.current;
    f = $295abd054c1837dd$var$Je(b, f);
    $295abd054c1837dd$var$Ig(b, e);
    c = $295abd054c1837dd$var$hg(a, b, c, d, f, e);
    if (null !== a && !$295abd054c1837dd$var$qg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $295abd054c1837dd$var$Jg(a, b, e);
    b.effectTag |= 1;
    $295abd054c1837dd$var$S(a, b, c, e);
    return b.child;
}
function $295abd054c1837dd$var$Og(a, b, c, d, e) {
    if ($295abd054c1837dd$var$J(c)) {
        var f = !0;
        $295abd054c1837dd$var$Oe(b);
    } else f = !1;
    $295abd054c1837dd$var$Ig(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $295abd054c1837dd$var$vf(b, c, d, e), $295abd054c1837dd$var$xf(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var l = g.context, k = c.contextType;
        "object" === typeof k && null !== k ? k = $295abd054c1837dd$var$M(k) : (k = $295abd054c1837dd$var$J(c) ? $295abd054c1837dd$var$Ie : $295abd054c1837dd$var$H.current, k = $295abd054c1837dd$var$Je(b, k));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $295abd054c1837dd$var$wf(b, g, d, k);
        $295abd054c1837dd$var$Pg = !1;
        var t = b.memoizedState;
        l = g.state = t;
        var A = b.updateQueue;
        null !== A && ($295abd054c1837dd$var$yf(b, A, d, g, e), l = b.memoizedState);
        h !== d || t !== l || $295abd054c1837dd$var$I.current || $295abd054c1837dd$var$Pg ? ("function" === typeof m && ($295abd054c1837dd$var$kf(b, c, m, d), l = b.memoizedState), (h = $295abd054c1837dd$var$Pg || $295abd054c1837dd$var$uf(b, c, h, d, t, l, k)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = l), g.props = d, g.state = l, g.context = k, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : $295abd054c1837dd$var$L(b.type, h), l = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = $295abd054c1837dd$var$M(k) : (k = $295abd054c1837dd$var$J(c) ? $295abd054c1837dd$var$Ie : $295abd054c1837dd$var$H.current, k = $295abd054c1837dd$var$Je(b, k)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || l !== k) && $295abd054c1837dd$var$wf(b, g, d, k), $295abd054c1837dd$var$Pg = !1, l = b.memoizedState, t = g.state = l, A = b.updateQueue, null !== A && ($295abd054c1837dd$var$yf(b, A, d, g, e), t = b.memoizedState), h !== d || l !== t || $295abd054c1837dd$var$I.current || $295abd054c1837dd$var$Pg ? ("function" === typeof m && ($295abd054c1837dd$var$kf(b, c, m, d), t = b.memoizedState), (m = $295abd054c1837dd$var$Pg || $295abd054c1837dd$var$uf(b, c, h, d, l, t, k)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, t, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, t, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = t), g.props = d, g.state = t, g.context = k, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && l === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $295abd054c1837dd$var$Qg(a, b, c, d, f, e);
}
function $295abd054c1837dd$var$Qg(a, b, c, d, e, f) {
    $295abd054c1837dd$var$Ng(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $295abd054c1837dd$var$Pe(b, c, !1), $295abd054c1837dd$var$Jg(a, b, f);
    d = b.stateNode;
    $295abd054c1837dd$var$Gg.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $295abd054c1837dd$var$Df(b, a.child, null, f), b.child = $295abd054c1837dd$var$Df(b, null, h, f)) : $295abd054c1837dd$var$S(a, b, h, f);
    b.memoizedState = d.state;
    e && $295abd054c1837dd$var$Pe(b, c, !0);
    return b.child;
}
function $295abd054c1837dd$var$Rg(a) {
    var b = a.stateNode;
    b.pendingContext ? $295abd054c1837dd$var$Me(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $295abd054c1837dd$var$Me(a, b.context, !1);
    $295abd054c1837dd$var$Jf(a, b.containerInfo);
}
function $295abd054c1837dd$var$Sg(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = b.memoizedState;
    if (0 === (b.effectTag & 64)) {
        f = null;
        var g = !1;
    } else f = {
        timedOutAt: null !== f ? f.timedOutAt : 0
    }, g = !0, b.effectTag &= -65;
    if (null === a) {
        if (g) {
            var h = e.fallback;
            a = $295abd054c1837dd$var$Ze(null, d, 0, null);
            0 === (b.mode & 1) && (a.child = null !== b.memoizedState ? b.child.child : b.child);
            d = $295abd054c1837dd$var$Ze(h, d, c, null);
            a.sibling = d;
            c = a;
            c.return = d.return = b;
        } else c = d = $295abd054c1837dd$var$Ef(b, null, e.children, c);
    } else null !== a.memoizedState ? (d = a.child, h = d.sibling, g ? (c = e.fallback, e = $295abd054c1837dd$var$Xe(d, d.pendingProps, 0), 0 === (b.mode & 1) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== d.child && (e.child = g)), d = e.sibling = $295abd054c1837dd$var$Xe(h, c, h.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = $295abd054c1837dd$var$Df(b, d.child, e.children, c)) : (h = a.child, g ? (g = e.fallback, e = $295abd054c1837dd$var$Ze(null, d, 0, null), e.child = h, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = $295abd054c1837dd$var$Ze(g, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = $295abd054c1837dd$var$Df(b, h, e.children, c)), b.stateNode = a.stateNode;
    b.memoizedState = f;
    b.child = c;
    return d;
}
function $295abd054c1837dd$var$Jg(a, b, c) {
    null !== a && (b.contextDependencies = a.contextDependencies);
    if (b.childExpirationTime < c) return null;
    null !== a && b.child !== a.child && $295abd054c1837dd$var$x("153");
    if (null !== b.child) {
        a = b.child;
        c = $295abd054c1837dd$var$Xe(a, a.pendingProps, a.expirationTime);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $295abd054c1837dd$var$Xe(a, a.pendingProps, a.expirationTime), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $295abd054c1837dd$var$Tg(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $295abd054c1837dd$var$I.current) $295abd054c1837dd$var$qg = !0;
        else if (d < c) {
            $295abd054c1837dd$var$qg = !1;
            switch(b.tag){
                case 3:
                    $295abd054c1837dd$var$Rg(b);
                    $295abd054c1837dd$var$Fg();
                    break;
                case 5:
                    $295abd054c1837dd$var$Lf(b);
                    break;
                case 1:
                    $295abd054c1837dd$var$J(b.type) && $295abd054c1837dd$var$Oe(b);
                    break;
                case 4:
                    $295abd054c1837dd$var$Jf(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    $295abd054c1837dd$var$Ug(b, b.memoizedProps.value);
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        d = b.child.childExpirationTime;
                        if (0 !== d && d >= c) return $295abd054c1837dd$var$Sg(a, b, c);
                        b = $295abd054c1837dd$var$Jg(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
            }
            return $295abd054c1837dd$var$Jg(a, b, c);
        }
    } else $295abd054c1837dd$var$qg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            var e = $295abd054c1837dd$var$Je(b, $295abd054c1837dd$var$H.current);
            $295abd054c1837dd$var$Ig(b, c);
            e = $295abd054c1837dd$var$hg(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                $295abd054c1837dd$var$lg();
                if ($295abd054c1837dd$var$J(d)) {
                    var f = !0;
                    $295abd054c1837dd$var$Oe(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $295abd054c1837dd$var$kf(b, d, g, a);
                e.updater = $295abd054c1837dd$var$tf;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $295abd054c1837dd$var$xf(b, d, a, c);
                b = $295abd054c1837dd$var$Qg(null, b, d, !0, f, c);
            } else b.tag = 0, $295abd054c1837dd$var$S(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            f = b.pendingProps;
            a = $295abd054c1837dd$var$hf(e);
            b.type = a;
            e = b.tag = $295abd054c1837dd$var$We(a);
            f = $295abd054c1837dd$var$L(a, f);
            g = void 0;
            switch(e){
                case 0:
                    g = $295abd054c1837dd$var$Mg(null, b, a, f, c);
                    break;
                case 1:
                    g = $295abd054c1837dd$var$Og(null, b, a, f, c);
                    break;
                case 11:
                    g = $295abd054c1837dd$var$Hg(null, b, a, f, c);
                    break;
                case 14:
                    g = $295abd054c1837dd$var$Kg(null, b, a, $295abd054c1837dd$var$L(a.type, f), d, c);
                    break;
                default:
                    $295abd054c1837dd$var$x("306", a, "");
            }
            return g;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $295abd054c1837dd$var$L(d, e), $295abd054c1837dd$var$Mg(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $295abd054c1837dd$var$L(d, e), $295abd054c1837dd$var$Og(a, b, d, e, c);
        case 3:
            $295abd054c1837dd$var$Rg(b);
            d = b.updateQueue;
            null === d && $295abd054c1837dd$var$x("282");
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $295abd054c1837dd$var$yf(b, d, b.pendingProps, null, c);
            d = b.memoizedState.element;
            if (d === e) $295abd054c1837dd$var$Fg(), b = $295abd054c1837dd$var$Jg(a, b, c);
            else {
                e = b.stateNode;
                if (e = (null === a || null === a.child) && e.hydrate) $295abd054c1837dd$var$yg = $295abd054c1837dd$var$Ee(b.stateNode.containerInfo), $295abd054c1837dd$var$xg = b, e = $295abd054c1837dd$var$zg = !0;
                e ? (b.effectTag |= 2, b.child = $295abd054c1837dd$var$Ef(b, null, d, c)) : ($295abd054c1837dd$var$S(a, b, d, c), $295abd054c1837dd$var$Fg());
                b = b.child;
            }
            return b;
        case 5:
            return $295abd054c1837dd$var$Lf(b), null === a && $295abd054c1837dd$var$Cg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $295abd054c1837dd$var$xe(d, e) ? g = null : null !== f && $295abd054c1837dd$var$xe(d, f) && (b.effectTag |= 16), $295abd054c1837dd$var$Ng(a, b), 1 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($295abd054c1837dd$var$S(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $295abd054c1837dd$var$Cg(b), null;
        case 13:
            return $295abd054c1837dd$var$Sg(a, b, c);
        case 4:
            return $295abd054c1837dd$var$Jf(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $295abd054c1837dd$var$Df(b, null, d, c) : $295abd054c1837dd$var$S(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $295abd054c1837dd$var$L(d, e), $295abd054c1837dd$var$Hg(a, b, d, e, c);
        case 7:
            return $295abd054c1837dd$var$S(a, b, b.pendingProps, c), b.child;
        case 8:
            return $295abd054c1837dd$var$S(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $295abd054c1837dd$var$S(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                $295abd054c1837dd$var$Ug(b, f);
                if (null !== g) {
                    var h = g.value;
                    f = $295abd054c1837dd$var$bd(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;
                    if (0 === f) {
                        if (g.children === e.children && !$295abd054c1837dd$var$I.current) {
                            b = $295abd054c1837dd$var$Jg(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var l = h.contextDependencies;
                        if (null !== l) {
                            g = h.child;
                            for(var k = l.first; null !== k;){
                                if (k.context === d && 0 !== (k.observedBits & f)) {
                                    1 === h.tag && (k = $295abd054c1837dd$var$nf(c), k.tag = $295abd054c1837dd$var$sf, $295abd054c1837dd$var$pf(h, k));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    k = h.alternate;
                                    null !== k && k.expirationTime < c && (k.expirationTime = c);
                                    k = c;
                                    for(var m = h.return; null !== m;){
                                        var p = m.alternate;
                                        if (m.childExpirationTime < k) m.childExpirationTime = k, null !== p && p.childExpirationTime < k && (p.childExpirationTime = k);
                                        else if (null !== p && p.childExpirationTime < k) p.childExpirationTime = k;
                                        else break;
                                        m = m.return;
                                    }
                                    l.expirationTime < c && (l.expirationTime = c);
                                    break;
                                }
                                k = k.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $295abd054c1837dd$var$S(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $295abd054c1837dd$var$Ig(b, c), e = $295abd054c1837dd$var$M(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $295abd054c1837dd$var$S(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $295abd054c1837dd$var$L(e, b.pendingProps), f = $295abd054c1837dd$var$L(e.type, f), $295abd054c1837dd$var$Kg(a, b, e, f, d, c);
        case 15:
            return $295abd054c1837dd$var$Lg(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $295abd054c1837dd$var$L(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $295abd054c1837dd$var$J(d) ? (a = !0, $295abd054c1837dd$var$Oe(b)) : a = !1, $295abd054c1837dd$var$Ig(b, c), $295abd054c1837dd$var$vf(b, d, e, c), $295abd054c1837dd$var$xf(b, d, e, c), $295abd054c1837dd$var$Qg(null, b, d, !0, a, c);
    }
    $295abd054c1837dd$var$x("156");
}
var $295abd054c1837dd$var$Vg = {
    current: null
}, $295abd054c1837dd$var$Wg = null, $295abd054c1837dd$var$Xg = null, $295abd054c1837dd$var$Yg = null;
function $295abd054c1837dd$var$Ug(a, b) {
    var c = a.type._context;
    $295abd054c1837dd$var$G($295abd054c1837dd$var$Vg, c._currentValue, a);
    c._currentValue = b;
}
function $295abd054c1837dd$var$Zg(a) {
    var b = $295abd054c1837dd$var$Vg.current;
    $295abd054c1837dd$var$F($295abd054c1837dd$var$Vg, a);
    a.type._context._currentValue = b;
}
function $295abd054c1837dd$var$Ig(a, b) {
    $295abd054c1837dd$var$Wg = a;
    $295abd054c1837dd$var$Yg = $295abd054c1837dd$var$Xg = null;
    var c = a.contextDependencies;
    null !== c && c.expirationTime >= b && ($295abd054c1837dd$var$qg = !0);
    a.contextDependencies = null;
}
function $295abd054c1837dd$var$M(a, b) {
    if ($295abd054c1837dd$var$Yg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $295abd054c1837dd$var$Yg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        null === $295abd054c1837dd$var$Xg ? (null === $295abd054c1837dd$var$Wg && $295abd054c1837dd$var$x("308"), $295abd054c1837dd$var$Xg = b, $295abd054c1837dd$var$Wg.contextDependencies = {
            first: b,
            expirationTime: 0
        }) : $295abd054c1837dd$var$Xg = $295abd054c1837dd$var$Xg.next = b;
    }
    return a._currentValue;
}
var $295abd054c1837dd$var$$g = 0, $295abd054c1837dd$var$rf = 1, $295abd054c1837dd$var$sf = 2, $295abd054c1837dd$var$ah = 3, $295abd054c1837dd$var$Pg = !1;
function $295abd054c1837dd$var$bh(a) {
    return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $295abd054c1837dd$var$ch(a) {
    return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $295abd054c1837dd$var$nf(a) {
    return {
        expirationTime: a,
        tag: $295abd054c1837dd$var$$g,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
    };
}
function $295abd054c1837dd$var$dh(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function $295abd054c1837dd$var$pf(a, b) {
    var c = a.alternate;
    if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = $295abd054c1837dd$var$bh(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = $295abd054c1837dd$var$bh(a.memoizedState), e = c.updateQueue = $295abd054c1837dd$var$bh(c.memoizedState)) : d = a.updateQueue = $295abd054c1837dd$var$ch(e) : null === e && (e = c.updateQueue = $295abd054c1837dd$var$ch(d));
    null === e || d === e ? $295abd054c1837dd$var$dh(d, b) : null === d.lastUpdate || null === e.lastUpdate ? ($295abd054c1837dd$var$dh(d, b), $295abd054c1837dd$var$dh(e, b)) : ($295abd054c1837dd$var$dh(d, b), e.lastUpdate = b);
}
function $295abd054c1837dd$var$eh(a, b) {
    var c = a.updateQueue;
    c = null === c ? a.updateQueue = $295abd054c1837dd$var$bh(a.memoizedState) : $295abd054c1837dd$var$fh(a, c);
    null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function $295abd054c1837dd$var$fh(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = $295abd054c1837dd$var$ch(b));
    return b;
}
function $295abd054c1837dd$var$gh(a, b, c, d, e, f) {
    switch(c.tag){
        case $295abd054c1837dd$var$rf:
            return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
        case $295abd054c1837dd$var$ah:
            a.effectTag = a.effectTag & -2049 | 64;
        case $295abd054c1837dd$var$$g:
            a = c.payload;
            e = "function" === typeof a ? a.call(f, d, e) : a;
            if (null === e || void 0 === e) break;
            return $b6jnv({}, d, e);
        case $295abd054c1837dd$var$sf:
            $295abd054c1837dd$var$Pg = !0;
    }
    return d;
}
function $295abd054c1837dd$var$yf(a, b, c, d, e) {
    $295abd054c1837dd$var$Pg = !1;
    b = $295abd054c1837dd$var$fh(a, b);
    for(var f = b.baseState, g = null, h = 0, l = b.firstUpdate, k = f; null !== l;){
        var m = l.expirationTime;
        m < e ? (null === g && (g = l, f = k), h < m && (h = m)) : (k = $295abd054c1837dd$var$gh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = l : (b.lastEffect.nextEffect = l, b.lastEffect = l)));
        l = l.next;
    }
    m = null;
    for(l = b.firstCapturedUpdate; null !== l;){
        var p = l.expirationTime;
        p < e ? (null === m && (m = l, null === g && (f = k)), h < p && (h = p)) : (k = $295abd054c1837dd$var$gh(a, b, l, k, c, d), null !== l.callback && (a.effectTag |= 32, l.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = l : (b.lastCapturedEffect.nextEffect = l, b.lastCapturedEffect = l)));
        l = l.next;
    }
    null === g && (b.lastUpdate = null);
    null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;
    null === g && null === m && (f = k);
    b.baseState = f;
    b.firstUpdate = g;
    b.firstCapturedUpdate = m;
    a.expirationTime = h;
    a.memoizedState = k;
}
function $295abd054c1837dd$var$hh(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    $295abd054c1837dd$var$ih(b.firstEffect, c);
    b.firstEffect = b.lastEffect = null;
    $295abd054c1837dd$var$ih(b.firstCapturedEffect, c);
    b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function $295abd054c1837dd$var$ih(a, b) {
    for(; null !== a;){
        var c = a.callback;
        if (null !== c) {
            a.callback = null;
            var d = b;
            "function" !== typeof c && $295abd054c1837dd$var$x("191", c);
            c.call(d);
        }
        a = a.nextEffect;
    }
}
function $295abd054c1837dd$var$jh(a, b) {
    return {
        value: a,
        source: b,
        stack: $295abd054c1837dd$var$jc(b)
    };
}
function $295abd054c1837dd$var$kh(a) {
    a.effectTag |= 4;
}
var $295abd054c1837dd$var$lh = void 0, $295abd054c1837dd$var$mh = void 0, $295abd054c1837dd$var$nh = void 0, $295abd054c1837dd$var$oh = void 0;
$295abd054c1837dd$var$lh = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$295abd054c1837dd$var$mh = function() {};
$295abd054c1837dd$var$nh = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $295abd054c1837dd$var$If($295abd054c1837dd$var$N.current);
        a = null;
        switch(c){
            case "input":
                f = $295abd054c1837dd$var$vc(g, f);
                d = $295abd054c1837dd$var$vc(g, d);
                a = [];
                break;
            case "option":
                f = $295abd054c1837dd$var$$d(g, f);
                d = $295abd054c1837dd$var$$d(g, d);
                a = [];
                break;
            case "select":
                f = $b6jnv({}, f, {
                    value: void 0
                });
                d = $b6jnv({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $295abd054c1837dd$var$be(g, f);
                d = $295abd054c1837dd$var$be(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $295abd054c1837dd$var$te);
        }
        $295abd054c1837dd$var$qe(c, d);
        g = c = void 0;
        var h = null;
        for(c in f)if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) {
            if ("style" === c) {
                var l = f[c];
                for(g in l)l.hasOwnProperty(g) && (h || (h = {}), h[g] = "");
            } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && ($295abd054c1837dd$var$ra.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
        }
        for(c in d){
            var k = d[c];
            l = null != f ? f[c] : void 0;
            if (d.hasOwnProperty(c) && k !== l && (null != k || null != l)) {
                if ("style" === c) {
                    if (l) {
                        for(g in l)!l.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (h || (h = {}), h[g] = "");
                        for(g in k)k.hasOwnProperty(g) && l[g] !== k[g] && (h || (h = {}), h[g] = k[g]);
                    } else h || (a || (a = []), a.push(c, h)), h = k;
                } else "dangerouslySetInnerHTML" === c ? (k = k ? k.__html : void 0, l = l ? l.__html : void 0, null != k && l !== k && (a = a || []).push(c, "" + k)) : "children" === c ? l === k || "string" !== typeof k && "number" !== typeof k || (a = a || []).push(c, "" + k) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && ($295abd054c1837dd$var$ra.hasOwnProperty(c) ? (null != k && $295abd054c1837dd$var$se(e, c), a || l === k || (a = [])) : (a = a || []).push(c, k));
            }
        }
        h && (a = a || []).push("style", h);
        e = a;
        (b.updateQueue = e) && $295abd054c1837dd$var$kh(b);
    }
};
$295abd054c1837dd$var$oh = function(a, b, c, d) {
    c !== d && $295abd054c1837dd$var$kh(b);
};
var $295abd054c1837dd$var$ph = "function" === typeof WeakSet ? WeakSet : Set;
function $295abd054c1837dd$var$qh(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $295abd054c1837dd$var$jc(c));
    null !== c && $295abd054c1837dd$var$ic(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $295abd054c1837dd$var$ic(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $295abd054c1837dd$var$rh(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $295abd054c1837dd$var$sh(a, c);
        }
        else b.current = null;
    }
}
function $295abd054c1837dd$var$th(a, b, c) {
    c = c.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) !== $295abd054c1837dd$var$Nf) {
                var e = d.destroy;
                d.destroy = void 0;
                void 0 !== e && e();
            }
            (d.tag & b) !== $295abd054c1837dd$var$Nf && (e = d.create, d.destroy = e());
            d = d.next;
        }while (d !== c);
    }
}
function $295abd054c1837dd$var$uh(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d.style.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $295abd054c1837dd$var$ne("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if (13 === c.tag && null !== c.memoizedState) {
            d = c.child.sibling;
            d.return = c;
            c = d;
            continue;
        } else if (null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $295abd054c1837dd$var$vh(a) {
    "function" === typeof $295abd054c1837dd$var$Re && $295abd054c1837dd$var$Re(a);
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            var b = a.updateQueue;
            if (null !== b && (b = b.lastEffect, null !== b)) {
                var c = b = b.next;
                do {
                    var d = c.destroy;
                    if (void 0 !== d) {
                        var e = a;
                        try {
                            d();
                        } catch (f) {
                            $295abd054c1837dd$var$sh(e, f);
                        }
                    }
                    c = c.next;
                }while (c !== b);
            }
            break;
        case 1:
            $295abd054c1837dd$var$rh(a);
            b = a.stateNode;
            if ("function" === typeof b.componentWillUnmount) try {
                b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
            } catch (f) {
                $295abd054c1837dd$var$sh(a, f);
            }
            break;
        case 5:
            $295abd054c1837dd$var$rh(a);
            break;
        case 4:
            $295abd054c1837dd$var$wh(a);
    }
}
function $295abd054c1837dd$var$xh(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $295abd054c1837dd$var$yh(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($295abd054c1837dd$var$xh(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        $295abd054c1837dd$var$x("160");
        c = void 0;
    }
    var d = b = void 0;
    switch(c.tag){
        case 5:
            b = c.stateNode;
            d = !1;
            break;
        case 3:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        case 4:
            b = c.stateNode.containerInfo;
            d = !0;
            break;
        default:
            $295abd054c1837dd$var$x("161");
    }
    c.effectTag & 16 && ($295abd054c1837dd$var$ke(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $295abd054c1837dd$var$xh(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    for(var e = a;;){
        if (5 === e.tag || 6 === e.tag) {
            if (c) {
                if (d) {
                    var f = b, g = e.stateNode, h = c;
                    8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
                } else b.insertBefore(e.stateNode, c);
            } else d ? (g = b, h = e.stateNode, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = $295abd054c1837dd$var$te)) : b.appendChild(e.stateNode);
        } else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
        }
        if (e === a) break;
        for(; null === e.sibling;){
            if (null === e.return || e.return === a) return;
            e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
    }
}
function $295abd054c1837dd$var$wh(a) {
    for(var b = a, c = !1, d = void 0, e = void 0;;){
        if (!c) {
            c = b.return;
            a: for(;;){
                null === c && $295abd054c1837dd$var$x("160");
                switch(c.tag){
                    case 5:
                        d = c.stateNode;
                        e = !1;
                        break a;
                    case 3:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                    case 4:
                        d = c.stateNode.containerInfo;
                        e = !0;
                        break a;
                }
                c = c.return;
            }
            c = !0;
        }
        if (5 === b.tag || 6 === b.tag) {
            a: for(var f = b, g = f;;)if ($295abd054c1837dd$var$vh(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;
            else {
                if (g === f) break;
                for(; null === g.sibling;){
                    if (null === g.return || g.return === f) break a;
                    g = g.return;
                }
                g.sibling.return = g.return;
                g = g.sibling;
            }
            e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
        } else if (4 === b.tag) {
            if (null !== b.child) {
                d = b.stateNode.containerInfo;
                e = !0;
                b.child.return = b;
                b = b.child;
                continue;
            }
        } else if ($295abd054c1837dd$var$vh(b), null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return;
            b = b.return;
            4 === b.tag && (c = !1);
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
}
function $295abd054c1837dd$var$zh(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $295abd054c1837dd$var$th($295abd054c1837dd$var$Pf, $295abd054c1837dd$var$Qf, b);
            break;
        case 1:
            break;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps;
                a = null !== a ? a.memoizedProps : d;
                var e = b.type, f = b.updateQueue;
                b.updateQueue = null;
                null !== f && $295abd054c1837dd$var$Ce(c, f, e, a, d, b);
            }
            break;
        case 6:
            null === b.stateNode && $295abd054c1837dd$var$x("162");
            b.stateNode.nodeValue = b.memoizedProps;
            break;
        case 3:
            break;
        case 12:
            break;
        case 13:
            c = b.memoizedState;
            d = void 0;
            a = b;
            null === c ? d = !1 : (d = !0, a = b.child, 0 === c.timedOutAt && (c.timedOutAt = $295abd054c1837dd$var$lf()));
            null !== a && $295abd054c1837dd$var$uh(a, d);
            c = b.updateQueue;
            if (null !== c) {
                b.updateQueue = null;
                var g = b.stateNode;
                null === g && (g = b.stateNode = new $295abd054c1837dd$var$ph);
                c.forEach(function(a) {
                    var c = $295abd054c1837dd$var$Ah.bind(null, b, a);
                    g.has(a) || (g.add(a), a.then(c, c));
                });
            }
            break;
        case 17:
            break;
        default:
            $295abd054c1837dd$var$x("163");
    }
}
var $295abd054c1837dd$var$Bh = "function" === typeof WeakMap ? WeakMap : Map;
function $295abd054c1837dd$var$Ch(a, b, c) {
    c = $295abd054c1837dd$var$nf(c);
    c.tag = $295abd054c1837dd$var$ah;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $295abd054c1837dd$var$Dh(d);
        $295abd054c1837dd$var$qh(a, b);
    };
    return c;
}
function $295abd054c1837dd$var$Eh(a, b, c) {
    c = $295abd054c1837dd$var$nf(c);
    c.tag = $295abd054c1837dd$var$ah;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $295abd054c1837dd$var$Fh ? $295abd054c1837dd$var$Fh = new Set([
            this
        ]) : $295abd054c1837dd$var$Fh.add(this));
        var c = b.value, e = b.stack;
        $295abd054c1837dd$var$qh(a, b);
        this.componentDidCatch(c, {
            componentStack: null !== e ? e : ""
        });
    });
    return c;
}
function $295abd054c1837dd$var$Gh(a) {
    switch(a.tag){
        case 1:
            $295abd054c1837dd$var$J(a.type) && $295abd054c1837dd$var$Ke(a);
            var b = a.effectTag;
            return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 3:
            return $295abd054c1837dd$var$Kf(a), $295abd054c1837dd$var$Le(a), b = a.effectTag, 0 !== (b & 64) && $295abd054c1837dd$var$x("285"), a.effectTag = b & -2049 | 64, a;
        case 5:
            return $295abd054c1837dd$var$Mf(a), null;
        case 13:
            return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 18:
            return null;
        case 4:
            return $295abd054c1837dd$var$Kf(a), null;
        case 10:
            return $295abd054c1837dd$var$Zg(a), null;
        default:
            return null;
    }
}
var $295abd054c1837dd$var$Hh = $295abd054c1837dd$var$Tb.ReactCurrentDispatcher, $295abd054c1837dd$var$Ih = $295abd054c1837dd$var$Tb.ReactCurrentOwner, $295abd054c1837dd$var$Jh = 1073741822, $295abd054c1837dd$var$Kh = !1, $295abd054c1837dd$var$T = null, $295abd054c1837dd$var$Lh = null, $295abd054c1837dd$var$U = 0, $295abd054c1837dd$var$Mh = -1, $295abd054c1837dd$var$Nh = !1, $295abd054c1837dd$var$V = null, $295abd054c1837dd$var$Oh = !1, $295abd054c1837dd$var$Ph = null, $295abd054c1837dd$var$Qh = null, $295abd054c1837dd$var$Rh = null, $295abd054c1837dd$var$Fh = null;
function $295abd054c1837dd$var$Sh() {
    if (null !== $295abd054c1837dd$var$T) for(var a = $295abd054c1837dd$var$T.return; null !== a;){
        var b = a;
        switch(b.tag){
            case 1:
                var c = b.type.childContextTypes;
                null !== c && void 0 !== c && $295abd054c1837dd$var$Ke(b);
                break;
            case 3:
                $295abd054c1837dd$var$Kf(b);
                $295abd054c1837dd$var$Le(b);
                break;
            case 5:
                $295abd054c1837dd$var$Mf(b);
                break;
            case 4:
                $295abd054c1837dd$var$Kf(b);
                break;
            case 10:
                $295abd054c1837dd$var$Zg(b);
        }
        a = a.return;
    }
    $295abd054c1837dd$var$Lh = null;
    $295abd054c1837dd$var$U = 0;
    $295abd054c1837dd$var$Mh = -1;
    $295abd054c1837dd$var$Nh = !1;
    $295abd054c1837dd$var$T = null;
}
function $295abd054c1837dd$var$Th() {
    for(; null !== $295abd054c1837dd$var$V;){
        var a = $295abd054c1837dd$var$V.effectTag;
        a & 16 && $295abd054c1837dd$var$ke($295abd054c1837dd$var$V.stateNode, "");
        if (a & 128) {
            var b = $295abd054c1837dd$var$V.alternate;
            null !== b && (b = b.ref, null !== b && ("function" === typeof b ? b(null) : b.current = null));
        }
        switch(a & 14){
            case 2:
                $295abd054c1837dd$var$yh($295abd054c1837dd$var$V);
                $295abd054c1837dd$var$V.effectTag &= -3;
                break;
            case 6:
                $295abd054c1837dd$var$yh($295abd054c1837dd$var$V);
                $295abd054c1837dd$var$V.effectTag &= -3;
                $295abd054c1837dd$var$zh($295abd054c1837dd$var$V.alternate, $295abd054c1837dd$var$V);
                break;
            case 4:
                $295abd054c1837dd$var$zh($295abd054c1837dd$var$V.alternate, $295abd054c1837dd$var$V);
                break;
            case 8:
                a = $295abd054c1837dd$var$V, $295abd054c1837dd$var$wh(a), a.return = null, a.child = null, a.memoizedState = null, a.updateQueue = null, a = a.alternate, null !== a && (a.return = null, a.child = null, a.memoizedState = null, a.updateQueue = null);
        }
        $295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect;
    }
}
function $295abd054c1837dd$var$Uh() {
    for(; null !== $295abd054c1837dd$var$V;){
        if ($295abd054c1837dd$var$V.effectTag & 256) a: {
            var a = $295abd054c1837dd$var$V.alternate, b = $295abd054c1837dd$var$V;
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    $295abd054c1837dd$var$th($295abd054c1837dd$var$Of, $295abd054c1837dd$var$Nf, b);
                    break a;
                case 1:
                    if (b.effectTag & 256 && null !== a) {
                        var c = a.memoizedProps, d = a.memoizedState;
                        a = b.stateNode;
                        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $295abd054c1837dd$var$L(b.type, c), d);
                        a.__reactInternalSnapshotBeforeUpdate = b;
                    }
                    break a;
                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                    break a;
                default:
                    $295abd054c1837dd$var$x("163");
            }
        }
        $295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect;
    }
}
function $295abd054c1837dd$var$Vh(a, b) {
    for(; null !== $295abd054c1837dd$var$V;){
        var c = $295abd054c1837dd$var$V.effectTag;
        if (c & 36) {
            var d = $295abd054c1837dd$var$V.alternate, e = $295abd054c1837dd$var$V, f = b;
            switch(e.tag){
                case 0:
                case 11:
                case 15:
                    $295abd054c1837dd$var$th($295abd054c1837dd$var$Rf, $295abd054c1837dd$var$Sf, e);
                    break;
                case 1:
                    var g = e.stateNode;
                    if (e.effectTag & 4) {
                        if (null === d) g.componentDidMount();
                        else {
                            var h = e.elementType === e.type ? d.memoizedProps : $295abd054c1837dd$var$L(e.type, d.memoizedProps);
                            g.componentDidUpdate(h, d.memoizedState, g.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                    d = e.updateQueue;
                    null !== d && $295abd054c1837dd$var$hh(e, d, g, f);
                    break;
                case 3:
                    d = e.updateQueue;
                    if (null !== d) {
                        g = null;
                        if (null !== e.child) switch(e.child.tag){
                            case 5:
                                g = e.child.stateNode;
                                break;
                            case 1:
                                g = e.child.stateNode;
                        }
                        $295abd054c1837dd$var$hh(e, d, g, f);
                    }
                    break;
                case 5:
                    f = e.stateNode;
                    null === d && e.effectTag & 4 && $295abd054c1837dd$var$we(e.type, e.memoizedProps) && f.focus();
                    break;
                case 6:
                    break;
                case 4:
                    break;
                case 12:
                    break;
                case 13:
                    break;
                case 17:
                    break;
                default:
                    $295abd054c1837dd$var$x("163");
            }
        }
        c & 128 && (e = $295abd054c1837dd$var$V.ref, null !== e && (f = $295abd054c1837dd$var$V.stateNode, "function" === typeof e ? e(f) : e.current = f));
        c & 512 && ($295abd054c1837dd$var$Ph = a);
        $295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect;
    }
}
function $295abd054c1837dd$var$Wh(a, b) {
    $295abd054c1837dd$var$Rh = $295abd054c1837dd$var$Qh = $295abd054c1837dd$var$Ph = null;
    var c = $295abd054c1837dd$var$W;
    $295abd054c1837dd$var$W = !0;
    do {
        if (b.effectTag & 512) {
            var d = !1, e = void 0;
            try {
                var f = b;
                $295abd054c1837dd$var$th($295abd054c1837dd$var$Uf, $295abd054c1837dd$var$Nf, f);
                $295abd054c1837dd$var$th($295abd054c1837dd$var$Nf, $295abd054c1837dd$var$Tf, f);
            } catch (g) {
                d = !0, e = g;
            }
            d && $295abd054c1837dd$var$sh(b, e);
        }
        b = b.nextEffect;
    }while (null !== b);
    $295abd054c1837dd$var$W = c;
    c = a.expirationTime;
    0 !== c && $295abd054c1837dd$var$Xh(a, c);
    $295abd054c1837dd$var$X || $295abd054c1837dd$var$W || $295abd054c1837dd$var$Yh(1073741823, !1);
}
function $295abd054c1837dd$var$of() {
    null !== $295abd054c1837dd$var$Qh && $295abd054c1837dd$var$Be($295abd054c1837dd$var$Qh);
    null !== $295abd054c1837dd$var$Rh && $295abd054c1837dd$var$Rh();
}
function $295abd054c1837dd$var$Zh(a, b) {
    $295abd054c1837dd$var$Oh = $295abd054c1837dd$var$Kh = !0;
    a.current === b && $295abd054c1837dd$var$x("177");
    var c = a.pendingCommitExpirationTime;
    0 === c && $295abd054c1837dd$var$x("261");
    a.pendingCommitExpirationTime = 0;
    var d = b.expirationTime, e = b.childExpirationTime;
    $295abd054c1837dd$var$ef(a, e > d ? e : d);
    $295abd054c1837dd$var$Ih.current = null;
    d = void 0;
    1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;
    $295abd054c1837dd$var$ue = $295abd054c1837dd$var$Bd;
    $295abd054c1837dd$var$ve = $295abd054c1837dd$var$Pd();
    $295abd054c1837dd$var$Bd = !1;
    for($295abd054c1837dd$var$V = d; null !== $295abd054c1837dd$var$V;){
        e = !1;
        var f = void 0;
        try {
            $295abd054c1837dd$var$Uh();
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $295abd054c1837dd$var$V && $295abd054c1837dd$var$x("178"), $295abd054c1837dd$var$sh($295abd054c1837dd$var$V, f), null !== $295abd054c1837dd$var$V && ($295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect));
    }
    for($295abd054c1837dd$var$V = d; null !== $295abd054c1837dd$var$V;){
        e = !1;
        f = void 0;
        try {
            $295abd054c1837dd$var$Th();
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $295abd054c1837dd$var$V && $295abd054c1837dd$var$x("178"), $295abd054c1837dd$var$sh($295abd054c1837dd$var$V, f), null !== $295abd054c1837dd$var$V && ($295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect));
    }
    $295abd054c1837dd$var$Qd($295abd054c1837dd$var$ve);
    $295abd054c1837dd$var$ve = null;
    $295abd054c1837dd$var$Bd = !!$295abd054c1837dd$var$ue;
    $295abd054c1837dd$var$ue = null;
    a.current = b;
    for($295abd054c1837dd$var$V = d; null !== $295abd054c1837dd$var$V;){
        e = !1;
        f = void 0;
        try {
            $295abd054c1837dd$var$Vh(a, c);
        } catch (h) {
            e = !0, f = h;
        }
        e && (null === $295abd054c1837dd$var$V && $295abd054c1837dd$var$x("178"), $295abd054c1837dd$var$sh($295abd054c1837dd$var$V, f), null !== $295abd054c1837dd$var$V && ($295abd054c1837dd$var$V = $295abd054c1837dd$var$V.nextEffect));
    }
    if (null !== d && null !== $295abd054c1837dd$var$Ph) {
        var g = $295abd054c1837dd$var$Wh.bind(null, a, d);
        $295abd054c1837dd$var$Qh = $cMXW6.unstable_runWithPriority($cMXW6.unstable_NormalPriority, function() {
            return $295abd054c1837dd$var$Ae(g);
        });
        $295abd054c1837dd$var$Rh = g;
    }
    $295abd054c1837dd$var$Kh = $295abd054c1837dd$var$Oh = !1;
    "function" === typeof $295abd054c1837dd$var$Qe && $295abd054c1837dd$var$Qe(b.stateNode);
    c = b.expirationTime;
    b = b.childExpirationTime;
    b = b > c ? b : c;
    0 === b && ($295abd054c1837dd$var$Fh = null);
    $295abd054c1837dd$var$$h(a, b);
}
function $295abd054c1837dd$var$ai(a) {
    for(;;){
        var b = a.alternate, c = a.return, d = a.sibling;
        if (0 === (a.effectTag & 1024)) {
            $295abd054c1837dd$var$T = a;
            a: {
                var e = b;
                b = a;
                var f = $295abd054c1837dd$var$U;
                var g = b.pendingProps;
                switch(b.tag){
                    case 2:
                        break;
                    case 16:
                        break;
                    case 15:
                    case 0:
                        break;
                    case 1:
                        $295abd054c1837dd$var$J(b.type) && $295abd054c1837dd$var$Ke(b);
                        break;
                    case 3:
                        $295abd054c1837dd$var$Kf(b);
                        $295abd054c1837dd$var$Le(b);
                        g = b.stateNode;
                        g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null);
                        if (null === e || null === e.child) $295abd054c1837dd$var$Eg(b), b.effectTag &= -3;
                        $295abd054c1837dd$var$mh(b);
                        break;
                    case 5:
                        $295abd054c1837dd$var$Mf(b);
                        var h = $295abd054c1837dd$var$If($295abd054c1837dd$var$Hf.current);
                        f = b.type;
                        if (null !== e && null != b.stateNode) $295abd054c1837dd$var$nh(e, b, f, g, h), e.ref !== b.ref && (b.effectTag |= 128);
                        else if (g) {
                            var l = $295abd054c1837dd$var$If($295abd054c1837dd$var$N.current);
                            if ($295abd054c1837dd$var$Eg(b)) {
                                g = b;
                                e = g.stateNode;
                                var k = g.type, m = g.memoizedProps, p = h;
                                e[$295abd054c1837dd$var$Fa] = g;
                                e[$295abd054c1837dd$var$Ga] = m;
                                f = void 0;
                                h = k;
                                switch(h){
                                    case "iframe":
                                    case "object":
                                        $295abd054c1837dd$var$E("load", e);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(k = 0; k < $295abd054c1837dd$var$ab.length; k++)$295abd054c1837dd$var$E($295abd054c1837dd$var$ab[k], e);
                                        break;
                                    case "source":
                                        $295abd054c1837dd$var$E("error", e);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $295abd054c1837dd$var$E("error", e);
                                        $295abd054c1837dd$var$E("load", e);
                                        break;
                                    case "form":
                                        $295abd054c1837dd$var$E("reset", e);
                                        $295abd054c1837dd$var$E("submit", e);
                                        break;
                                    case "details":
                                        $295abd054c1837dd$var$E("toggle", e);
                                        break;
                                    case "input":
                                        $295abd054c1837dd$var$wc(e, m);
                                        $295abd054c1837dd$var$E("invalid", e);
                                        $295abd054c1837dd$var$se(p, "onChange");
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        $295abd054c1837dd$var$E("invalid", e);
                                        $295abd054c1837dd$var$se(p, "onChange");
                                        break;
                                    case "textarea":
                                        $295abd054c1837dd$var$ce(e, m), $295abd054c1837dd$var$E("invalid", e), $295abd054c1837dd$var$se(p, "onChange");
                                }
                                $295abd054c1837dd$var$qe(h, m);
                                k = null;
                                for(f in m)m.hasOwnProperty(f) && (l = m[f], "children" === f ? "string" === typeof l ? e.textContent !== l && (k = [
                                    "children",
                                    l
                                ]) : "number" === typeof l && e.textContent !== "" + l && (k = [
                                    "children",
                                    "" + l
                                ]) : $295abd054c1837dd$var$ra.hasOwnProperty(f) && null != l && $295abd054c1837dd$var$se(p, f));
                                switch(h){
                                    case "input":
                                        $295abd054c1837dd$var$Rb(e);
                                        $295abd054c1837dd$var$Ac(e, m, !0);
                                        break;
                                    case "textarea":
                                        $295abd054c1837dd$var$Rb(e);
                                        $295abd054c1837dd$var$ee(e, m);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" === typeof m.onClick && (e.onclick = $295abd054c1837dd$var$te);
                                }
                                f = k;
                                g.updateQueue = f;
                                g = null !== f ? !0 : !1;
                                g && $295abd054c1837dd$var$kh(b);
                            } else {
                                m = b;
                                p = f;
                                e = g;
                                k = 9 === h.nodeType ? h : h.ownerDocument;
                                l === $295abd054c1837dd$var$fe.html && (l = $295abd054c1837dd$var$ge(p));
                                l === $295abd054c1837dd$var$fe.html ? "script" === p ? (e = k.createElement("div"), e.innerHTML = "<script>\x3c/script>", k = e.removeChild(e.firstChild)) : "string" === typeof e.is ? k = k.createElement(p, {
                                    is: e.is
                                }) : (k = k.createElement(p), "select" === p && (p = k, e.multiple ? p.multiple = !0 : e.size && (p.size = e.size))) : k = k.createElementNS(l, p);
                                e = k;
                                e[$295abd054c1837dd$var$Fa] = m;
                                e[$295abd054c1837dd$var$Ga] = g;
                                $295abd054c1837dd$var$lh(e, b, !1, !1);
                                p = e;
                                k = f;
                                m = g;
                                var t = h, A = $295abd054c1837dd$var$re(k, m);
                                switch(k){
                                    case "iframe":
                                    case "object":
                                        $295abd054c1837dd$var$E("load", p);
                                        h = m;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(h = 0; h < $295abd054c1837dd$var$ab.length; h++)$295abd054c1837dd$var$E($295abd054c1837dd$var$ab[h], p);
                                        h = m;
                                        break;
                                    case "source":
                                        $295abd054c1837dd$var$E("error", p);
                                        h = m;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $295abd054c1837dd$var$E("error", p);
                                        $295abd054c1837dd$var$E("load", p);
                                        h = m;
                                        break;
                                    case "form":
                                        $295abd054c1837dd$var$E("reset", p);
                                        $295abd054c1837dd$var$E("submit", p);
                                        h = m;
                                        break;
                                    case "details":
                                        $295abd054c1837dd$var$E("toggle", p);
                                        h = m;
                                        break;
                                    case "input":
                                        $295abd054c1837dd$var$wc(p, m);
                                        h = $295abd054c1837dd$var$vc(p, m);
                                        $295abd054c1837dd$var$E("invalid", p);
                                        $295abd054c1837dd$var$se(t, "onChange");
                                        break;
                                    case "option":
                                        h = $295abd054c1837dd$var$$d(p, m);
                                        break;
                                    case "select":
                                        p._wrapperState = {
                                            wasMultiple: !!m.multiple
                                        };
                                        h = $b6jnv({}, m, {
                                            value: void 0
                                        });
                                        $295abd054c1837dd$var$E("invalid", p);
                                        $295abd054c1837dd$var$se(t, "onChange");
                                        break;
                                    case "textarea":
                                        $295abd054c1837dd$var$ce(p, m);
                                        h = $295abd054c1837dd$var$be(p, m);
                                        $295abd054c1837dd$var$E("invalid", p);
                                        $295abd054c1837dd$var$se(t, "onChange");
                                        break;
                                    default:
                                        h = m;
                                }
                                $295abd054c1837dd$var$qe(k, h);
                                l = void 0;
                                var v = k, R = p, u = h;
                                for(l in u)if (u.hasOwnProperty(l)) {
                                    var q = u[l];
                                    "style" === l ? $295abd054c1837dd$var$oe(R, q) : "dangerouslySetInnerHTML" === l ? (q = q ? q.__html : void 0, null != q && $295abd054c1837dd$var$je(R, q)) : "children" === l ? "string" === typeof q ? ("textarea" !== v || "" !== q) && $295abd054c1837dd$var$ke(R, q) : "number" === typeof q && $295abd054c1837dd$var$ke(R, "" + q) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($295abd054c1837dd$var$ra.hasOwnProperty(l) ? null != q && $295abd054c1837dd$var$se(t, l) : null != q && $295abd054c1837dd$var$tc(R, l, q, A));
                                }
                                switch(k){
                                    case "input":
                                        $295abd054c1837dd$var$Rb(p);
                                        $295abd054c1837dd$var$Ac(p, m, !1);
                                        break;
                                    case "textarea":
                                        $295abd054c1837dd$var$Rb(p);
                                        $295abd054c1837dd$var$ee(p, m);
                                        break;
                                    case "option":
                                        null != m.value && p.setAttribute("value", "" + $295abd054c1837dd$var$uc(m.value));
                                        break;
                                    case "select":
                                        h = p;
                                        h.multiple = !!m.multiple;
                                        p = m.value;
                                        null != p ? $295abd054c1837dd$var$ae(h, !!m.multiple, p, !1) : null != m.defaultValue && $295abd054c1837dd$var$ae(h, !!m.multiple, m.defaultValue, !0);
                                        break;
                                    default:
                                        "function" === typeof h.onClick && (p.onclick = $295abd054c1837dd$var$te);
                                }
                                (g = $295abd054c1837dd$var$we(f, g)) && $295abd054c1837dd$var$kh(b);
                                b.stateNode = e;
                            }
                            null !== b.ref && (b.effectTag |= 128);
                        } else null === b.stateNode && $295abd054c1837dd$var$x("166");
                        break;
                    case 6:
                        e && null != b.stateNode ? $295abd054c1837dd$var$oh(e, b, e.memoizedProps, g) : ("string" !== typeof g && null === b.stateNode && $295abd054c1837dd$var$x("166"), e = $295abd054c1837dd$var$If($295abd054c1837dd$var$Hf.current), $295abd054c1837dd$var$If($295abd054c1837dd$var$N.current), $295abd054c1837dd$var$Eg(b) ? (g = b, f = g.stateNode, e = g.memoizedProps, f[$295abd054c1837dd$var$Fa] = g, (g = f.nodeValue !== e) && $295abd054c1837dd$var$kh(b)) : (f = b, g = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(g), g[$295abd054c1837dd$var$Fa] = b, f.stateNode = g));
                        break;
                    case 11:
                        break;
                    case 13:
                        g = b.memoizedState;
                        if (0 !== (b.effectTag & 64)) {
                            b.expirationTime = f;
                            $295abd054c1837dd$var$T = b;
                            break a;
                        }
                        g = null !== g;
                        f = null !== e && null !== e.memoizedState;
                        null !== e && !g && f && (e = e.child.sibling, null !== e && (h = b.firstEffect, null !== h ? (b.firstEffect = e, e.nextEffect = h) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));
                        if (g || f) b.effectTag |= 4;
                        break;
                    case 7:
                        break;
                    case 8:
                        break;
                    case 12:
                        break;
                    case 4:
                        $295abd054c1837dd$var$Kf(b);
                        $295abd054c1837dd$var$mh(b);
                        break;
                    case 10:
                        $295abd054c1837dd$var$Zg(b);
                        break;
                    case 9:
                        break;
                    case 14:
                        break;
                    case 17:
                        $295abd054c1837dd$var$J(b.type) && $295abd054c1837dd$var$Ke(b);
                        break;
                    case 18:
                        break;
                    default:
                        $295abd054c1837dd$var$x("156");
                }
                $295abd054c1837dd$var$T = null;
            }
            b = a;
            if (1 === $295abd054c1837dd$var$U || 1 !== b.childExpirationTime) {
                g = 0;
                for(f = b.child; null !== f;)e = f.expirationTime, h = f.childExpirationTime, e > g && (g = e), h > g && (g = h), f = f.sibling;
                b.childExpirationTime = g;
            }
            if (null !== $295abd054c1837dd$var$T) return $295abd054c1837dd$var$T;
            null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
        } else {
            a = $295abd054c1837dd$var$Gh(a, $295abd054c1837dd$var$U);
            if (null !== a) return a.effectTag &= 1023, a;
            null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
        }
        if (null !== d) return d;
        if (null !== c) a = c;
        else break;
    }
    return null;
}
function $295abd054c1837dd$var$bi(a) {
    var b = $295abd054c1837dd$var$Tg(a.alternate, a, $295abd054c1837dd$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $295abd054c1837dd$var$ai(a));
    $295abd054c1837dd$var$Ih.current = null;
    return b;
}
function $295abd054c1837dd$var$ci(a, b) {
    $295abd054c1837dd$var$Kh && $295abd054c1837dd$var$x("243");
    $295abd054c1837dd$var$of();
    $295abd054c1837dd$var$Kh = !0;
    var c = $295abd054c1837dd$var$Hh.current;
    $295abd054c1837dd$var$Hh.current = $295abd054c1837dd$var$kg;
    var d = a.nextExpirationTimeToWorkOn;
    if (d !== $295abd054c1837dd$var$U || a !== $295abd054c1837dd$var$Lh || null === $295abd054c1837dd$var$T) $295abd054c1837dd$var$Sh(), $295abd054c1837dd$var$Lh = a, $295abd054c1837dd$var$U = d, $295abd054c1837dd$var$T = $295abd054c1837dd$var$Xe($295abd054c1837dd$var$Lh.current, null, $295abd054c1837dd$var$U), a.pendingCommitExpirationTime = 0;
    var e = !1;
    do {
        try {
            if (b) for(; null !== $295abd054c1837dd$var$T && !$295abd054c1837dd$var$di();)$295abd054c1837dd$var$T = $295abd054c1837dd$var$bi($295abd054c1837dd$var$T);
            else for(; null !== $295abd054c1837dd$var$T;)$295abd054c1837dd$var$T = $295abd054c1837dd$var$bi($295abd054c1837dd$var$T);
        } catch (u) {
            if ($295abd054c1837dd$var$Yg = $295abd054c1837dd$var$Xg = $295abd054c1837dd$var$Wg = null, $295abd054c1837dd$var$lg(), null === $295abd054c1837dd$var$T) e = !0, $295abd054c1837dd$var$Dh(u);
            else {
                null === $295abd054c1837dd$var$T && $295abd054c1837dd$var$x("271");
                var f = $295abd054c1837dd$var$T, g = f.return;
                if (null === g) e = !0, $295abd054c1837dd$var$Dh(u);
                else {
                    a: {
                        var h = a, l = g, k = f, m = u;
                        g = $295abd054c1837dd$var$U;
                        k.effectTag |= 1024;
                        k.firstEffect = k.lastEffect = null;
                        if (null !== m && "object" === typeof m && "function" === typeof m.then) {
                            var p = m;
                            m = l;
                            var t = -1, A = -1;
                            do {
                                if (13 === m.tag) {
                                    var v = m.alternate;
                                    if (null !== v && (v = v.memoizedState, null !== v)) {
                                        A = 10 * (1073741822 - v.timedOutAt);
                                        break;
                                    }
                                    v = m.pendingProps.maxDuration;
                                    if ("number" === typeof v) {
                                        if (0 >= v) t = 0;
                                        else if (-1 === t || v < t) t = v;
                                    }
                                }
                                m = m.return;
                            }while (null !== m);
                            m = l;
                            do {
                                if (v = 13 === m.tag) v = void 0 === m.memoizedProps.fallback ? !1 : null === m.memoizedState;
                                if (v) {
                                    l = m.updateQueue;
                                    null === l ? (l = new Set, l.add(p), m.updateQueue = l) : l.add(p);
                                    if (0 === (m.mode & 1)) {
                                        m.effectTag |= 64;
                                        k.effectTag &= -1957;
                                        1 === k.tag && (null === k.alternate ? k.tag = 17 : (g = $295abd054c1837dd$var$nf(1073741823), g.tag = $295abd054c1837dd$var$sf, $295abd054c1837dd$var$pf(k, g)));
                                        k.expirationTime = 1073741823;
                                        break a;
                                    }
                                    k = h;
                                    l = g;
                                    var R = k.pingCache;
                                    null === R ? (R = k.pingCache = new $295abd054c1837dd$var$Bh, v = new Set, R.set(p, v)) : (v = R.get(p), void 0 === v && (v = new Set, R.set(p, v)));
                                    v.has(l) || (v.add(l), k = $295abd054c1837dd$var$ei.bind(null, k, p, l), p.then(k, k));
                                    -1 === t ? h = 1073741823 : (-1 === A && (A = 10 * (1073741822 - $295abd054c1837dd$var$gf(h, g)) - 5E3), h = A + t);
                                    0 <= h && $295abd054c1837dd$var$Mh < h && ($295abd054c1837dd$var$Mh = h);
                                    m.effectTag |= 2048;
                                    m.expirationTime = g;
                                    break a;
                                }
                                m = m.return;
                            }while (null !== m);
                            m = Error(($295abd054c1837dd$var$ic(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $295abd054c1837dd$var$jc(k));
                        }
                        $295abd054c1837dd$var$Nh = !0;
                        m = $295abd054c1837dd$var$jh(m, k);
                        h = l;
                        do {
                            switch(h.tag){
                                case 3:
                                    h.effectTag |= 2048;
                                    h.expirationTime = g;
                                    g = $295abd054c1837dd$var$Ch(h, m, g);
                                    $295abd054c1837dd$var$eh(h, g);
                                    break a;
                                case 1:
                                    if (t = m, A = h.type, k = h.stateNode, 0 === (h.effectTag & 64) && ("function" === typeof A.getDerivedStateFromError || null !== k && "function" === typeof k.componentDidCatch && (null === $295abd054c1837dd$var$Fh || !$295abd054c1837dd$var$Fh.has(k)))) {
                                        h.effectTag |= 2048;
                                        h.expirationTime = g;
                                        g = $295abd054c1837dd$var$Eh(h, t, g);
                                        $295abd054c1837dd$var$eh(h, g);
                                        break a;
                                    }
                            }
                            h = h.return;
                        }while (null !== h);
                    }
                    $295abd054c1837dd$var$T = $295abd054c1837dd$var$ai(f);
                    continue;
                }
            }
        }
        break;
    }while (1);
    $295abd054c1837dd$var$Kh = !1;
    $295abd054c1837dd$var$Hh.current = c;
    $295abd054c1837dd$var$Yg = $295abd054c1837dd$var$Xg = $295abd054c1837dd$var$Wg = null;
    $295abd054c1837dd$var$lg();
    if (e) $295abd054c1837dd$var$Lh = null, a.finishedWork = null;
    else if (null !== $295abd054c1837dd$var$T) a.finishedWork = null;
    else {
        c = a.current.alternate;
        null === c && $295abd054c1837dd$var$x("281");
        $295abd054c1837dd$var$Lh = null;
        if ($295abd054c1837dd$var$Nh) {
            e = a.latestPendingTime;
            f = a.latestSuspendedTime;
            g = a.latestPingedTime;
            if (0 !== e && e < d || 0 !== f && f < d || 0 !== g && g < d) {
                $295abd054c1837dd$var$ff(a, d);
                $295abd054c1837dd$var$fi(a, c, d, a.expirationTime, -1);
                return;
            }
            if (!a.didError && b) {
                a.didError = !0;
                d = a.nextExpirationTimeToWorkOn = d;
                b = a.expirationTime = 1073741823;
                $295abd054c1837dd$var$fi(a, c, d, b, -1);
                return;
            }
        }
        b && -1 !== $295abd054c1837dd$var$Mh ? ($295abd054c1837dd$var$ff(a, d), b = 10 * (1073741822 - $295abd054c1837dd$var$gf(a, d)), b < $295abd054c1837dd$var$Mh && ($295abd054c1837dd$var$Mh = b), b = 10 * (1073741822 - $295abd054c1837dd$var$lf()), b = $295abd054c1837dd$var$Mh - b, $295abd054c1837dd$var$fi(a, c, d, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = d, a.finishedWork = c);
    }
}
function $295abd054c1837dd$var$sh(a, b) {
    for(var c = a.return; null !== c;){
        switch(c.tag){
            case 1:
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $295abd054c1837dd$var$Fh || !$295abd054c1837dd$var$Fh.has(d))) {
                    a = $295abd054c1837dd$var$jh(b, a);
                    a = $295abd054c1837dd$var$Eh(c, a, 1073741823);
                    $295abd054c1837dd$var$pf(c, a);
                    $295abd054c1837dd$var$qf(c, 1073741823);
                    return;
                }
                break;
            case 3:
                a = $295abd054c1837dd$var$jh(b, a);
                a = $295abd054c1837dd$var$Ch(c, a, 1073741823);
                $295abd054c1837dd$var$pf(c, a);
                $295abd054c1837dd$var$qf(c, 1073741823);
                return;
        }
        c = c.return;
    }
    3 === a.tag && (c = $295abd054c1837dd$var$jh(b, a), c = $295abd054c1837dd$var$Ch(a, c, 1073741823), $295abd054c1837dd$var$pf(a, c), $295abd054c1837dd$var$qf(a, 1073741823));
}
function $295abd054c1837dd$var$mf(a, b) {
    var c = $cMXW6.unstable_getCurrentPriorityLevel(), d = void 0;
    if (0 === (b.mode & 1)) d = 1073741823;
    else if ($295abd054c1837dd$var$Kh && !$295abd054c1837dd$var$Oh) d = $295abd054c1837dd$var$U;
    else {
        switch(c){
            case $cMXW6.unstable_ImmediatePriority:
                d = 1073741823;
                break;
            case $cMXW6.unstable_UserBlockingPriority:
                d = 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1);
                break;
            case $cMXW6.unstable_NormalPriority:
                d = 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1);
                break;
            case $cMXW6.unstable_LowPriority:
            case $cMXW6.unstable_IdlePriority:
                d = 1;
                break;
            default:
                $295abd054c1837dd$var$x("313");
        }
        null !== $295abd054c1837dd$var$Lh && d === $295abd054c1837dd$var$U && --d;
    }
    c === $cMXW6.unstable_UserBlockingPriority && (0 === $295abd054c1837dd$var$gi || d < $295abd054c1837dd$var$gi) && ($295abd054c1837dd$var$gi = d);
    return d;
}
function $295abd054c1837dd$var$ei(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    if (null !== $295abd054c1837dd$var$Lh && $295abd054c1837dd$var$U === c) $295abd054c1837dd$var$Lh = null;
    else if (b = a.earliestSuspendedTime, d = a.latestSuspendedTime, 0 !== b && c <= b && c >= d) {
        a.didError = !1;
        b = a.latestPingedTime;
        if (0 === b || b > c) a.latestPingedTime = c;
        $295abd054c1837dd$var$df(c, a);
        c = a.expirationTime;
        0 !== c && $295abd054c1837dd$var$Xh(a, c);
    }
}
function $295abd054c1837dd$var$Ah(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = $295abd054c1837dd$var$lf();
    b = $295abd054c1837dd$var$mf(b, a);
    a = $295abd054c1837dd$var$hi(a, b);
    null !== a && ($295abd054c1837dd$var$cf(a, b), b = a.expirationTime, 0 !== b && $295abd054c1837dd$var$Xh(a, b));
}
function $295abd054c1837dd$var$hi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    return e;
}
function $295abd054c1837dd$var$qf(a, b) {
    a = $295abd054c1837dd$var$hi(a, b);
    null !== a && (!$295abd054c1837dd$var$Kh && 0 !== $295abd054c1837dd$var$U && b > $295abd054c1837dd$var$U && $295abd054c1837dd$var$Sh(), $295abd054c1837dd$var$cf(a, b), $295abd054c1837dd$var$Kh && !$295abd054c1837dd$var$Oh && $295abd054c1837dd$var$Lh === a || $295abd054c1837dd$var$Xh(a, a.expirationTime), $295abd054c1837dd$var$ii > $295abd054c1837dd$var$ji && ($295abd054c1837dd$var$ii = 0, $295abd054c1837dd$var$x("185")));
}
function $295abd054c1837dd$var$ki(a, b, c, d, e) {
    return $cMXW6.unstable_runWithPriority($cMXW6.unstable_ImmediatePriority, function() {
        return a(b, c, d, e);
    });
}
var $295abd054c1837dd$var$li = null, $295abd054c1837dd$var$Y = null, $295abd054c1837dd$var$mi = 0, $295abd054c1837dd$var$ni = void 0, $295abd054c1837dd$var$W = !1, $295abd054c1837dd$var$oi = null, $295abd054c1837dd$var$Z = 0, $295abd054c1837dd$var$gi = 0, $295abd054c1837dd$var$pi = !1, $295abd054c1837dd$var$qi = null, $295abd054c1837dd$var$X = !1, $295abd054c1837dd$var$ri = !1, $295abd054c1837dd$var$si = null, $295abd054c1837dd$var$ti = $cMXW6.unstable_now(), $295abd054c1837dd$var$ui = 1073741822 - ($295abd054c1837dd$var$ti / 10 | 0), $295abd054c1837dd$var$vi = $295abd054c1837dd$var$ui, $295abd054c1837dd$var$ji = 50, $295abd054c1837dd$var$ii = 0, $295abd054c1837dd$var$wi = null;
function $295abd054c1837dd$var$xi() {
    $295abd054c1837dd$var$ui = 1073741822 - (($cMXW6.unstable_now() - $295abd054c1837dd$var$ti) / 10 | 0);
}
function $295abd054c1837dd$var$yi(a, b) {
    if (0 !== $295abd054c1837dd$var$mi) {
        if (b < $295abd054c1837dd$var$mi) return;
        null !== $295abd054c1837dd$var$ni && $cMXW6.unstable_cancelCallback($295abd054c1837dd$var$ni);
    }
    $295abd054c1837dd$var$mi = b;
    a = $cMXW6.unstable_now() - $295abd054c1837dd$var$ti;
    $295abd054c1837dd$var$ni = $cMXW6.unstable_scheduleCallback($295abd054c1837dd$var$zi, {
        timeout: 10 * (1073741822 - b) - a
    });
}
function $295abd054c1837dd$var$fi(a, b, c, d, e) {
    a.expirationTime = d;
    0 !== e || $295abd054c1837dd$var$di() ? 0 < e && (a.timeoutHandle = $295abd054c1837dd$var$ye($295abd054c1837dd$var$Ai.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
}
function $295abd054c1837dd$var$Ai(a, b, c) {
    a.pendingCommitExpirationTime = c;
    a.finishedWork = b;
    $295abd054c1837dd$var$xi();
    $295abd054c1837dd$var$vi = $295abd054c1837dd$var$ui;
    $295abd054c1837dd$var$Bi(a, c);
}
function $295abd054c1837dd$var$$h(a, b) {
    a.expirationTime = b;
    a.finishedWork = null;
}
function $295abd054c1837dd$var$lf() {
    if ($295abd054c1837dd$var$W) return $295abd054c1837dd$var$vi;
    $295abd054c1837dd$var$Ci();
    if (0 === $295abd054c1837dd$var$Z || 1 === $295abd054c1837dd$var$Z) $295abd054c1837dd$var$xi(), $295abd054c1837dd$var$vi = $295abd054c1837dd$var$ui;
    return $295abd054c1837dd$var$vi;
}
function $295abd054c1837dd$var$Xh(a, b) {
    null === a.nextScheduledRoot ? (a.expirationTime = b, null === $295abd054c1837dd$var$Y ? ($295abd054c1837dd$var$li = $295abd054c1837dd$var$Y = a, a.nextScheduledRoot = a) : ($295abd054c1837dd$var$Y = $295abd054c1837dd$var$Y.nextScheduledRoot = a, $295abd054c1837dd$var$Y.nextScheduledRoot = $295abd054c1837dd$var$li)) : b > a.expirationTime && (a.expirationTime = b);
    $295abd054c1837dd$var$W || ($295abd054c1837dd$var$X ? $295abd054c1837dd$var$ri && ($295abd054c1837dd$var$oi = a, $295abd054c1837dd$var$Z = 1073741823, $295abd054c1837dd$var$Di(a, 1073741823, !1)) : 1073741823 === b ? $295abd054c1837dd$var$Yh(1073741823, !1) : $295abd054c1837dd$var$yi(a, b));
}
function $295abd054c1837dd$var$Ci() {
    var a = 0, b = null;
    if (null !== $295abd054c1837dd$var$Y) for(var c = $295abd054c1837dd$var$Y, d = $295abd054c1837dd$var$li; null !== d;){
        var e = d.expirationTime;
        if (0 === e) {
            (null === c || null === $295abd054c1837dd$var$Y) && $295abd054c1837dd$var$x("244");
            if (d === d.nextScheduledRoot) {
                $295abd054c1837dd$var$li = $295abd054c1837dd$var$Y = d.nextScheduledRoot = null;
                break;
            } else if (d === $295abd054c1837dd$var$li) $295abd054c1837dd$var$li = e = d.nextScheduledRoot, $295abd054c1837dd$var$Y.nextScheduledRoot = e, d.nextScheduledRoot = null;
            else if (d === $295abd054c1837dd$var$Y) {
                $295abd054c1837dd$var$Y = c;
                $295abd054c1837dd$var$Y.nextScheduledRoot = $295abd054c1837dd$var$li;
                d.nextScheduledRoot = null;
                break;
            } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;
            d = c.nextScheduledRoot;
        } else {
            e > a && (a = e, b = d);
            if (d === $295abd054c1837dd$var$Y) break;
            if (1073741823 === a) break;
            c = d;
            d = d.nextScheduledRoot;
        }
    }
    $295abd054c1837dd$var$oi = b;
    $295abd054c1837dd$var$Z = a;
}
var $295abd054c1837dd$var$Ei = !1;
function $295abd054c1837dd$var$di() {
    return $295abd054c1837dd$var$Ei ? !0 : $cMXW6.unstable_shouldYield() ? $295abd054c1837dd$var$Ei = !0 : !1;
}
function $295abd054c1837dd$var$zi() {
    try {
        if (!$295abd054c1837dd$var$di() && null !== $295abd054c1837dd$var$li) {
            $295abd054c1837dd$var$xi();
            var a = $295abd054c1837dd$var$li;
            do {
                var b = a.expirationTime;
                0 !== b && $295abd054c1837dd$var$ui <= b && (a.nextExpirationTimeToWorkOn = $295abd054c1837dd$var$ui);
                a = a.nextScheduledRoot;
            }while (a !== $295abd054c1837dd$var$li);
        }
        $295abd054c1837dd$var$Yh(0, !0);
    } finally{
        $295abd054c1837dd$var$Ei = !1;
    }
}
function $295abd054c1837dd$var$Yh(a, b) {
    $295abd054c1837dd$var$Ci();
    if (b) for($295abd054c1837dd$var$xi(), $295abd054c1837dd$var$vi = $295abd054c1837dd$var$ui; null !== $295abd054c1837dd$var$oi && 0 !== $295abd054c1837dd$var$Z && a <= $295abd054c1837dd$var$Z && !($295abd054c1837dd$var$Ei && $295abd054c1837dd$var$ui > $295abd054c1837dd$var$Z);)$295abd054c1837dd$var$Di($295abd054c1837dd$var$oi, $295abd054c1837dd$var$Z, $295abd054c1837dd$var$ui > $295abd054c1837dd$var$Z), $295abd054c1837dd$var$Ci(), $295abd054c1837dd$var$xi(), $295abd054c1837dd$var$vi = $295abd054c1837dd$var$ui;
    else for(; null !== $295abd054c1837dd$var$oi && 0 !== $295abd054c1837dd$var$Z && a <= $295abd054c1837dd$var$Z;)$295abd054c1837dd$var$Di($295abd054c1837dd$var$oi, $295abd054c1837dd$var$Z, !1), $295abd054c1837dd$var$Ci();
    b && ($295abd054c1837dd$var$mi = 0, $295abd054c1837dd$var$ni = null);
    0 !== $295abd054c1837dd$var$Z && $295abd054c1837dd$var$yi($295abd054c1837dd$var$oi, $295abd054c1837dd$var$Z);
    $295abd054c1837dd$var$ii = 0;
    $295abd054c1837dd$var$wi = null;
    if (null !== $295abd054c1837dd$var$si) for(a = $295abd054c1837dd$var$si, $295abd054c1837dd$var$si = null, b = 0; b < a.length; b++){
        var c = a[b];
        try {
            c._onComplete();
        } catch (d) {
            $295abd054c1837dd$var$pi || ($295abd054c1837dd$var$pi = !0, $295abd054c1837dd$var$qi = d);
        }
    }
    if ($295abd054c1837dd$var$pi) throw a = $295abd054c1837dd$var$qi, $295abd054c1837dd$var$qi = null, $295abd054c1837dd$var$pi = !1, a;
}
function $295abd054c1837dd$var$Bi(a, b) {
    $295abd054c1837dd$var$W && $295abd054c1837dd$var$x("253");
    $295abd054c1837dd$var$oi = a;
    $295abd054c1837dd$var$Z = b;
    $295abd054c1837dd$var$Di(a, b, !1);
    $295abd054c1837dd$var$Yh(1073741823, !1);
}
function $295abd054c1837dd$var$Di(a, b, c) {
    $295abd054c1837dd$var$W && $295abd054c1837dd$var$x("245");
    $295abd054c1837dd$var$W = !0;
    if (c) {
        var d = a.finishedWork;
        null !== d ? $295abd054c1837dd$var$Fi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $295abd054c1837dd$var$ze(d)), $295abd054c1837dd$var$ci(a, c), d = a.finishedWork, null !== d && ($295abd054c1837dd$var$di() ? a.finishedWork = d : $295abd054c1837dd$var$Fi(a, d, b)));
    } else d = a.finishedWork, null !== d ? $295abd054c1837dd$var$Fi(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, $295abd054c1837dd$var$ze(d)), $295abd054c1837dd$var$ci(a, c), d = a.finishedWork, null !== d && $295abd054c1837dd$var$Fi(a, d, b));
    $295abd054c1837dd$var$W = !1;
}
function $295abd054c1837dd$var$Fi(a, b, c) {
    var d = a.firstBatch;
    if (null !== d && d._expirationTime >= c && (null === $295abd054c1837dd$var$si ? $295abd054c1837dd$var$si = [
        d
    ] : $295abd054c1837dd$var$si.push(d), d._defer)) {
        a.finishedWork = b;
        a.expirationTime = 0;
        return;
    }
    a.finishedWork = null;
    a === $295abd054c1837dd$var$wi ? $295abd054c1837dd$var$ii++ : ($295abd054c1837dd$var$wi = a, $295abd054c1837dd$var$ii = 0);
    $cMXW6.unstable_runWithPriority($cMXW6.unstable_ImmediatePriority, function() {
        $295abd054c1837dd$var$Zh(a, b);
    });
}
function $295abd054c1837dd$var$Dh(a) {
    null === $295abd054c1837dd$var$oi && $295abd054c1837dd$var$x("246");
    $295abd054c1837dd$var$oi.expirationTime = 0;
    $295abd054c1837dd$var$pi || ($295abd054c1837dd$var$pi = !0, $295abd054c1837dd$var$qi = a);
}
function $295abd054c1837dd$var$Gi(a, b) {
    var c = $295abd054c1837dd$var$X;
    $295abd054c1837dd$var$X = !0;
    try {
        return a(b);
    } finally{
        ($295abd054c1837dd$var$X = c) || $295abd054c1837dd$var$W || $295abd054c1837dd$var$Yh(1073741823, !1);
    }
}
function $295abd054c1837dd$var$Hi(a, b) {
    if ($295abd054c1837dd$var$X && !$295abd054c1837dd$var$ri) {
        $295abd054c1837dd$var$ri = !0;
        try {
            return a(b);
        } finally{
            $295abd054c1837dd$var$ri = !1;
        }
    }
    return a(b);
}
function $295abd054c1837dd$var$Ii(a, b, c) {
    $295abd054c1837dd$var$X || $295abd054c1837dd$var$W || 0 === $295abd054c1837dd$var$gi || ($295abd054c1837dd$var$Yh($295abd054c1837dd$var$gi, !1), $295abd054c1837dd$var$gi = 0);
    var d = $295abd054c1837dd$var$X;
    $295abd054c1837dd$var$X = !0;
    try {
        return $cMXW6.unstable_runWithPriority($cMXW6.unstable_UserBlockingPriority, function() {
            return a(b, c);
        });
    } finally{
        ($295abd054c1837dd$var$X = d) || $295abd054c1837dd$var$W || $295abd054c1837dd$var$Yh(1073741823, !1);
    }
}
function $295abd054c1837dd$var$Ji(a, b, c, d, e) {
    var f = b.current;
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            2 === $295abd054c1837dd$var$ed(c) && 1 === c.tag || $295abd054c1837dd$var$x("170");
            var g = c;
            do {
                switch(g.tag){
                    case 3:
                        g = g.stateNode.context;
                        break b;
                    case 1:
                        if ($295abd054c1837dd$var$J(g.type)) {
                            g = g.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                g = g.return;
            }while (null !== g);
            $295abd054c1837dd$var$x("171");
            g = void 0;
        }
        if (1 === c.tag) {
            var h = c.type;
            if ($295abd054c1837dd$var$J(h)) {
                c = $295abd054c1837dd$var$Ne(c, h, g);
                break a;
            }
        }
        c = g;
    } else c = $295abd054c1837dd$var$He;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = e;
    e = $295abd054c1837dd$var$nf(d);
    e.payload = {
        element: a
    };
    b = void 0 === b ? null : b;
    null !== b && (e.callback = b);
    $295abd054c1837dd$var$of();
    $295abd054c1837dd$var$pf(f, e);
    $295abd054c1837dd$var$qf(f, d);
    return d;
}
function $295abd054c1837dd$var$Ki(a, b, c, d) {
    var e = b.current, f = $295abd054c1837dd$var$lf();
    e = $295abd054c1837dd$var$mf(f, e);
    return $295abd054c1837dd$var$Ji(a, b, c, e, d);
}
function $295abd054c1837dd$var$Li(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $295abd054c1837dd$var$Mi(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $295abd054c1837dd$var$Wb,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$295abd054c1837dd$var$Ab = function(a, b, c) {
    switch(b){
        case "input":
            $295abd054c1837dd$var$yc(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $295abd054c1837dd$var$Ka(d);
                        e || $295abd054c1837dd$var$x("90");
                        $295abd054c1837dd$var$Sb(d);
                        $295abd054c1837dd$var$yc(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $295abd054c1837dd$var$de(a, c);
            break;
        case "select":
            b = c.value, null != b && $295abd054c1837dd$var$ae(a, !!c.multiple, b, !1);
    }
};
function $295abd054c1837dd$var$Ni(a) {
    var b = 1073741822 - 25 * (((1073741822 - $295abd054c1837dd$var$lf() + 500) / 25 | 0) + 1);
    b >= $295abd054c1837dd$var$Jh && (b = $295abd054c1837dd$var$Jh - 1);
    this._expirationTime = $295abd054c1837dd$var$Jh = b;
    this._root = a;
    this._callbacks = this._next = null;
    this._hasChildren = this._didComplete = !1;
    this._children = null;
    this._defer = !0;
}
$295abd054c1837dd$var$Ni.prototype.render = function(a) {
    this._defer || $295abd054c1837dd$var$x("250");
    this._hasChildren = !0;
    this._children = a;
    var b = this._root._internalRoot, c = this._expirationTime, d = new $295abd054c1837dd$var$Oi;
    $295abd054c1837dd$var$Ji(a, b, null, c, d._onCommit);
    return d;
};
$295abd054c1837dd$var$Ni.prototype.then = function(a) {
    if (this._didComplete) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$295abd054c1837dd$var$Ni.prototype.commit = function() {
    var a = this._root._internalRoot, b = a.firstBatch;
    this._defer && null !== b || $295abd054c1837dd$var$x("251");
    if (this._hasChildren) {
        var c = this._expirationTime;
        if (b !== this) {
            this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));
            for(var d = null, e = b; e !== this;)d = e, e = e._next;
            null === d && $295abd054c1837dd$var$x("251");
            d._next = e._next;
            this._next = b;
            a.firstBatch = this;
        }
        this._defer = !1;
        $295abd054c1837dd$var$Bi(a, c);
        b = this._next;
        this._next = null;
        b = a.firstBatch = b;
        null !== b && b._hasChildren && b.render(b._children);
    } else this._next = null, this._defer = !1;
};
$295abd054c1837dd$var$Ni.prototype._onComplete = function() {
    if (!this._didComplete) {
        this._didComplete = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++)(0, a[b])();
    }
};
function $295abd054c1837dd$var$Oi() {
    this._callbacks = null;
    this._didCommit = !1;
    this._onCommit = this._onCommit.bind(this);
}
$295abd054c1837dd$var$Oi.prototype.then = function(a) {
    if (this._didCommit) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$295abd054c1837dd$var$Oi.prototype._onCommit = function() {
    if (!this._didCommit) {
        this._didCommit = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++){
            var c = a[b];
            "function" !== typeof c && $295abd054c1837dd$var$x("191", c);
            c();
        }
    }
};
function $295abd054c1837dd$var$Pi(a, b, c) {
    b = $295abd054c1837dd$var$K(3, null, null, b ? 3 : 0);
    a = {
        current: b,
        containerInfo: a,
        pendingChildren: null,
        pingCache: null,
        earliestPendingTime: 0,
        latestPendingTime: 0,
        earliestSuspendedTime: 0,
        latestSuspendedTime: 0,
        latestPingedTime: 0,
        didError: !1,
        pendingCommitExpirationTime: 0,
        finishedWork: null,
        timeoutHandle: -1,
        context: null,
        pendingContext: null,
        hydrate: c,
        nextExpirationTimeToWorkOn: 0,
        expirationTime: 0,
        firstBatch: null,
        nextScheduledRoot: null
    };
    this._internalRoot = b.stateNode = a;
}
$295abd054c1837dd$var$Pi.prototype.render = function(a, b) {
    var c = this._internalRoot, d = new $295abd054c1837dd$var$Oi;
    b = void 0 === b ? null : b;
    null !== b && d.then(b);
    $295abd054c1837dd$var$Ki(a, c, null, d._onCommit);
    return d;
};
$295abd054c1837dd$var$Pi.prototype.unmount = function(a) {
    var b = this._internalRoot, c = new $295abd054c1837dd$var$Oi;
    a = void 0 === a ? null : a;
    null !== a && c.then(a);
    $295abd054c1837dd$var$Ki(null, b, null, c._onCommit);
    return c;
};
$295abd054c1837dd$var$Pi.prototype.legacy_renderSubtreeIntoContainer = function(a, b, c) {
    var d = this._internalRoot, e = new $295abd054c1837dd$var$Oi;
    c = void 0 === c ? null : c;
    null !== c && e.then(c);
    $295abd054c1837dd$var$Ki(b, d, a, e._onCommit);
    return e;
};
$295abd054c1837dd$var$Pi.prototype.createBatch = function() {
    var a = new $295abd054c1837dd$var$Ni(this), b = a._expirationTime, c = this._internalRoot, d = c.firstBatch;
    if (null === d) c.firstBatch = a, a._next = null;
    else {
        for(c = null; null !== d && d._expirationTime >= b;)c = d, d = d._next;
        a._next = d;
        null !== c && (c._next = a);
    }
    return a;
};
function $295abd054c1837dd$var$Qi(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
$295abd054c1837dd$var$Gb = $295abd054c1837dd$var$Gi;
$295abd054c1837dd$var$Hb = $295abd054c1837dd$var$Ii;
$295abd054c1837dd$var$Ib = function() {
    $295abd054c1837dd$var$W || 0 === $295abd054c1837dd$var$gi || ($295abd054c1837dd$var$Yh($295abd054c1837dd$var$gi, !1), $295abd054c1837dd$var$gi = 0);
};
function $295abd054c1837dd$var$Ri(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $295abd054c1837dd$var$Pi(a, !1, b);
}
function $295abd054c1837dd$var$Si(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        if ("function" === typeof e) {
            var g = e;
            e = function() {
                var a = $295abd054c1837dd$var$Li(f._internalRoot);
                g.call(a);
            };
        }
        null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    } else {
        f = c._reactRootContainer = $295abd054c1837dd$var$Ri(c, d);
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $295abd054c1837dd$var$Li(f._internalRoot);
                h.call(a);
            };
        }
        $295abd054c1837dd$var$Hi(function() {
            null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
        });
    }
    return $295abd054c1837dd$var$Li(f._internalRoot);
}
function $295abd054c1837dd$var$Ti(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    $295abd054c1837dd$var$Qi(b) || $295abd054c1837dd$var$x("200");
    return $295abd054c1837dd$var$Mi(a, b, null, c);
}
var $295abd054c1837dd$var$Vi = {
    createPortal: $295abd054c1837dd$var$Ti,
    findDOMNode: function(a) {
        if (null == a) return null;
        if (1 === a.nodeType) return a;
        var b = a._reactInternalFiber;
        void 0 === b && ("function" === typeof a.render ? $295abd054c1837dd$var$x("188") : $295abd054c1837dd$var$x("268", Object.keys(a)));
        a = $295abd054c1837dd$var$hd(b);
        a = null === a ? null : a.stateNode;
        return a;
    },
    hydrate: function(a, b, c) {
        $295abd054c1837dd$var$Qi(b) || $295abd054c1837dd$var$x("200");
        return $295abd054c1837dd$var$Si(null, a, b, !0, c);
    },
    render: function(a, b, c) {
        $295abd054c1837dd$var$Qi(b) || $295abd054c1837dd$var$x("200");
        return $295abd054c1837dd$var$Si(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function(a, b, c, d) {
        $295abd054c1837dd$var$Qi(c) || $295abd054c1837dd$var$x("200");
        (null == a || void 0 === a._reactInternalFiber) && $295abd054c1837dd$var$x("38");
        return $295abd054c1837dd$var$Si(a, b, c, !1, d);
    },
    unmountComponentAtNode: function(a) {
        $295abd054c1837dd$var$Qi(a) || $295abd054c1837dd$var$x("40");
        return a._reactRootContainer ? ($295abd054c1837dd$var$Hi(function() {
            $295abd054c1837dd$var$Si(null, null, a, !1, function() {
                a._reactRootContainer = null;
            });
        }), !0) : !1;
    },
    unstable_createPortal: function() {
        return $295abd054c1837dd$var$Ti.apply(void 0, arguments);
    },
    unstable_batchedUpdates: $295abd054c1837dd$var$Gi,
    unstable_interactiveUpdates: $295abd054c1837dd$var$Ii,
    flushSync: function(a, b) {
        $295abd054c1837dd$var$W && $295abd054c1837dd$var$x("187");
        var c = $295abd054c1837dd$var$X;
        $295abd054c1837dd$var$X = !0;
        try {
            return $295abd054c1837dd$var$ki(a, b);
        } finally{
            $295abd054c1837dd$var$X = c, $295abd054c1837dd$var$Yh(1073741823, !1);
        }
    },
    unstable_createRoot: $295abd054c1837dd$var$Ui,
    unstable_flushControlled: function(a) {
        var b = $295abd054c1837dd$var$X;
        $295abd054c1837dd$var$X = !0;
        try {
            $295abd054c1837dd$var$ki(a);
        } finally{
            ($295abd054c1837dd$var$X = b) || $295abd054c1837dd$var$W || $295abd054c1837dd$var$Yh(1073741823, !1);
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        Events: [
            $295abd054c1837dd$var$Ia,
            $295abd054c1837dd$var$Ja,
            $295abd054c1837dd$var$Ka,
            $295abd054c1837dd$var$Ba.injectEventPluginsByName,
            $295abd054c1837dd$var$pa,
            $295abd054c1837dd$var$Qa,
            function(a) {
                $295abd054c1837dd$var$ya(a, $295abd054c1837dd$var$Pa);
            },
            $295abd054c1837dd$var$Eb,
            $295abd054c1837dd$var$Fb,
            $295abd054c1837dd$var$Dd,
            $295abd054c1837dd$var$Da
        ]
    }
};
function $295abd054c1837dd$var$Ui(a, b) {
    $295abd054c1837dd$var$Qi(a) || $295abd054c1837dd$var$x("299", "unstable_createRoot");
    return new $295abd054c1837dd$var$Pi(a, !0, null != b && !0 === b.hydrate);
}
(function(a) {
    var b = a.findFiberByHostInstance;
    return $295abd054c1837dd$var$Te($b6jnv({}, a, {
        overrideProps: null,
        currentDispatcherRef: $295abd054c1837dd$var$Tb.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $295abd054c1837dd$var$hd(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        }
    }));
})({
    findFiberByHostInstance: $295abd054c1837dd$var$Ha,
    bundleType: 0,
    version: "16.8.6",
    rendererPackageName: "react-dom"
});
var $295abd054c1837dd$var$Wi = {
    default: $295abd054c1837dd$var$Vi
}, $295abd054c1837dd$var$Xi = $295abd054c1837dd$var$Wi && $295abd054c1837dd$var$Vi || $295abd054c1837dd$var$Wi;
module.exports = $295abd054c1837dd$var$Xi.default || $295abd054c1837dd$var$Xi;

});
parcelRegister("cMXW6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9wxFm"));

});
parcelRegister("9wxFm", function(module, exports) {
/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $6ef1379668e10703$var$d = null, $6ef1379668e10703$var$e = !1, $6ef1379668e10703$var$g = 3, $6ef1379668e10703$var$k = -1, $6ef1379668e10703$var$l = -1, $6ef1379668e10703$var$m = !1, $6ef1379668e10703$var$n = !1;
function $6ef1379668e10703$var$p() {
    if (!$6ef1379668e10703$var$m) {
        var a = $6ef1379668e10703$var$d.expirationTime;
        $6ef1379668e10703$var$n ? $6ef1379668e10703$var$q() : $6ef1379668e10703$var$n = !0;
        $6ef1379668e10703$var$r($6ef1379668e10703$var$t, a);
    }
}
function $6ef1379668e10703$var$u() {
    var a = $6ef1379668e10703$var$d, b = $6ef1379668e10703$var$d.next;
    if ($6ef1379668e10703$var$d === b) $6ef1379668e10703$var$d = null;
    else {
        var c = $6ef1379668e10703$var$d.previous;
        $6ef1379668e10703$var$d = c.next = b;
        b.previous = c;
    }
    a.next = a.previous = null;
    c = a.callback;
    b = a.expirationTime;
    a = a.priorityLevel;
    var f = $6ef1379668e10703$var$g, Q = $6ef1379668e10703$var$l;
    $6ef1379668e10703$var$g = a;
    $6ef1379668e10703$var$l = b;
    try {
        var h = c();
    } finally{
        $6ef1379668e10703$var$g = f, $6ef1379668e10703$var$l = Q;
    }
    if ("function" === typeof h) {
        if (h = {
            callback: h,
            priorityLevel: a,
            expirationTime: b,
            next: null,
            previous: null
        }, null === $6ef1379668e10703$var$d) $6ef1379668e10703$var$d = h.next = h.previous = h;
        else {
            c = null;
            a = $6ef1379668e10703$var$d;
            do {
                if (a.expirationTime >= b) {
                    c = a;
                    break;
                }
                a = a.next;
            }while (a !== $6ef1379668e10703$var$d);
            null === c ? c = $6ef1379668e10703$var$d : c === $6ef1379668e10703$var$d && ($6ef1379668e10703$var$d = h, $6ef1379668e10703$var$p());
            b = c.previous;
            b.next = c.previous = h;
            h.next = c;
            h.previous = b;
        }
    }
}
function $6ef1379668e10703$var$v() {
    if (-1 === $6ef1379668e10703$var$k && null !== $6ef1379668e10703$var$d && 1 === $6ef1379668e10703$var$d.priorityLevel) {
        $6ef1379668e10703$var$m = !0;
        try {
            do $6ef1379668e10703$var$u();
            while (null !== $6ef1379668e10703$var$d && 1 === $6ef1379668e10703$var$d.priorityLevel);
        } finally{
            $6ef1379668e10703$var$m = !1, null !== $6ef1379668e10703$var$d ? $6ef1379668e10703$var$p() : $6ef1379668e10703$var$n = !1;
        }
    }
}
function $6ef1379668e10703$var$t(a) {
    $6ef1379668e10703$var$m = !0;
    var b = $6ef1379668e10703$var$e;
    $6ef1379668e10703$var$e = a;
    try {
        if (a) for(; null !== $6ef1379668e10703$var$d;){
            var c = module.exports.unstable_now();
            if ($6ef1379668e10703$var$d.expirationTime <= c) do $6ef1379668e10703$var$u();
            while (null !== $6ef1379668e10703$var$d && $6ef1379668e10703$var$d.expirationTime <= c);
            else break;
        }
        else if (null !== $6ef1379668e10703$var$d) do $6ef1379668e10703$var$u();
        while (null !== $6ef1379668e10703$var$d && !$6ef1379668e10703$var$w());
    } finally{
        $6ef1379668e10703$var$m = !1, $6ef1379668e10703$var$e = b, null !== $6ef1379668e10703$var$d ? $6ef1379668e10703$var$p() : $6ef1379668e10703$var$n = !1, $6ef1379668e10703$var$v();
    }
}
var $6ef1379668e10703$var$x = Date, $6ef1379668e10703$var$y = "function" === typeof setTimeout ? setTimeout : void 0, $6ef1379668e10703$var$z = "function" === typeof clearTimeout ? clearTimeout : void 0, $6ef1379668e10703$var$A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0, $6ef1379668e10703$var$B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0, $6ef1379668e10703$var$C, $6ef1379668e10703$var$D;
function $6ef1379668e10703$var$E(a) {
    $6ef1379668e10703$var$C = $6ef1379668e10703$var$A(function(b) {
        $6ef1379668e10703$var$z($6ef1379668e10703$var$D);
        a(b);
    });
    $6ef1379668e10703$var$D = $6ef1379668e10703$var$y(function() {
        $6ef1379668e10703$var$B($6ef1379668e10703$var$C);
        a(module.exports.unstable_now());
    }, 100);
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6ef1379668e10703$var$F = performance;
    module.exports.unstable_now = function() {
        return $6ef1379668e10703$var$F.now();
    };
} else module.exports.unstable_now = function() {
    return $6ef1379668e10703$var$x.now();
};
var $6ef1379668e10703$var$r, $6ef1379668e10703$var$q, $6ef1379668e10703$var$w, $6ef1379668e10703$var$G = null;
"undefined" !== typeof window ? $6ef1379668e10703$var$G = window : "undefined" !== typeof $parcel$global && ($6ef1379668e10703$var$G = $parcel$global);
if ($6ef1379668e10703$var$G && $6ef1379668e10703$var$G._schedMock) {
    var $6ef1379668e10703$var$H = $6ef1379668e10703$var$G._schedMock;
    $6ef1379668e10703$var$r = $6ef1379668e10703$var$H[0];
    $6ef1379668e10703$var$q = $6ef1379668e10703$var$H[1];
    $6ef1379668e10703$var$w = $6ef1379668e10703$var$H[2];
    module.exports.unstable_now = $6ef1379668e10703$var$H[3];
} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6ef1379668e10703$var$I = null, $6ef1379668e10703$var$J = function(a) {
        if (null !== $6ef1379668e10703$var$I) try {
            $6ef1379668e10703$var$I(a);
        } finally{
            $6ef1379668e10703$var$I = null;
        }
    };
    $6ef1379668e10703$var$r = function(a) {
        null !== $6ef1379668e10703$var$I ? setTimeout($6ef1379668e10703$var$r, 0, a) : ($6ef1379668e10703$var$I = a, setTimeout($6ef1379668e10703$var$J, 0, !1));
    };
    $6ef1379668e10703$var$q = function() {
        $6ef1379668e10703$var$I = null;
    };
    $6ef1379668e10703$var$w = function() {
        return !1;
    };
} else {
    "undefined" !== typeof console && ("function" !== typeof $6ef1379668e10703$var$A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof $6ef1379668e10703$var$B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    var $6ef1379668e10703$var$K = null, $6ef1379668e10703$var$L = !1, $6ef1379668e10703$var$M = -1, $6ef1379668e10703$var$N = !1, $6ef1379668e10703$var$O = !1, $6ef1379668e10703$var$P = 0, $6ef1379668e10703$var$R = 33, $6ef1379668e10703$var$S = 33;
    $6ef1379668e10703$var$w = function() {
        return $6ef1379668e10703$var$P <= module.exports.unstable_now();
    };
    var $6ef1379668e10703$var$T = new MessageChannel, $6ef1379668e10703$var$U = $6ef1379668e10703$var$T.port2;
    $6ef1379668e10703$var$T.port1.onmessage = function() {
        $6ef1379668e10703$var$L = !1;
        var a = $6ef1379668e10703$var$K, b = $6ef1379668e10703$var$M;
        $6ef1379668e10703$var$K = null;
        $6ef1379668e10703$var$M = -1;
        var c = module.exports.unstable_now(), f = !1;
        if (0 >= $6ef1379668e10703$var$P - c) {
            if (-1 !== b && b <= c) f = !0;
            else {
                $6ef1379668e10703$var$N || ($6ef1379668e10703$var$N = !0, $6ef1379668e10703$var$E($6ef1379668e10703$var$V));
                $6ef1379668e10703$var$K = a;
                $6ef1379668e10703$var$M = b;
                return;
            }
        }
        if (null !== a) {
            $6ef1379668e10703$var$O = !0;
            try {
                a(f);
            } finally{
                $6ef1379668e10703$var$O = !1;
            }
        }
    };
    var $6ef1379668e10703$var$V = function(a) {
        if (null !== $6ef1379668e10703$var$K) {
            $6ef1379668e10703$var$E($6ef1379668e10703$var$V);
            var b = a - $6ef1379668e10703$var$P + $6ef1379668e10703$var$S;
            b < $6ef1379668e10703$var$S && $6ef1379668e10703$var$R < $6ef1379668e10703$var$S ? (8 > b && (b = 8), $6ef1379668e10703$var$S = b < $6ef1379668e10703$var$R ? $6ef1379668e10703$var$R : b) : $6ef1379668e10703$var$R = b;
            $6ef1379668e10703$var$P = a + $6ef1379668e10703$var$S;
            $6ef1379668e10703$var$L || ($6ef1379668e10703$var$L = !0, $6ef1379668e10703$var$U.postMessage(void 0));
        } else $6ef1379668e10703$var$N = !1;
    };
    $6ef1379668e10703$var$r = function(a, b) {
        $6ef1379668e10703$var$K = a;
        $6ef1379668e10703$var$M = b;
        $6ef1379668e10703$var$O || 0 > b ? $6ef1379668e10703$var$U.postMessage(void 0) : $6ef1379668e10703$var$N || ($6ef1379668e10703$var$N = !0, $6ef1379668e10703$var$E($6ef1379668e10703$var$V));
    };
    $6ef1379668e10703$var$q = function() {
        $6ef1379668e10703$var$K = null;
        $6ef1379668e10703$var$L = !1;
        $6ef1379668e10703$var$M = -1;
    };
}
module.exports.unstable_ImmediatePriority = 1;
module.exports.unstable_UserBlockingPriority = 2;
module.exports.unstable_NormalPriority = 3;
module.exports.unstable_IdlePriority = 5;
module.exports.unstable_LowPriority = 4;
module.exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6ef1379668e10703$var$g, f = $6ef1379668e10703$var$k;
    $6ef1379668e10703$var$g = a;
    $6ef1379668e10703$var$k = module.exports.unstable_now();
    try {
        return b();
    } finally{
        $6ef1379668e10703$var$g = c, $6ef1379668e10703$var$k = f, $6ef1379668e10703$var$v();
    }
};
module.exports.unstable_next = function(a) {
    switch($6ef1379668e10703$var$g){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6ef1379668e10703$var$g;
    }
    var c = $6ef1379668e10703$var$g, f = $6ef1379668e10703$var$k;
    $6ef1379668e10703$var$g = b;
    $6ef1379668e10703$var$k = module.exports.unstable_now();
    try {
        return a();
    } finally{
        $6ef1379668e10703$var$g = c, $6ef1379668e10703$var$k = f, $6ef1379668e10703$var$v();
    }
};
module.exports.unstable_scheduleCallback = function(a, b) {
    var c = -1 !== $6ef1379668e10703$var$k ? $6ef1379668e10703$var$k : module.exports.unstable_now();
    if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = c + b.timeout;
    else switch($6ef1379668e10703$var$g){
        case 1:
            b = c + -1;
            break;
        case 2:
            b = c + 250;
            break;
        case 5:
            b = c + 1073741823;
            break;
        case 4:
            b = c + 1E4;
            break;
        default:
            b = c + 5E3;
    }
    a = {
        callback: a,
        priorityLevel: $6ef1379668e10703$var$g,
        expirationTime: b,
        next: null,
        previous: null
    };
    if (null === $6ef1379668e10703$var$d) $6ef1379668e10703$var$d = a.next = a.previous = a, $6ef1379668e10703$var$p();
    else {
        c = null;
        var f = $6ef1379668e10703$var$d;
        do {
            if (f.expirationTime > b) {
                c = f;
                break;
            }
            f = f.next;
        }while (f !== $6ef1379668e10703$var$d);
        null === c ? c = $6ef1379668e10703$var$d : c === $6ef1379668e10703$var$d && ($6ef1379668e10703$var$d = a, $6ef1379668e10703$var$p());
        b = c.previous;
        b.next = c.previous = a;
        a.next = c;
        a.previous = b;
    }
    return a;
};
module.exports.unstable_cancelCallback = function(a) {
    var b = a.next;
    if (null !== b) {
        if (b === a) $6ef1379668e10703$var$d = null;
        else {
            a === $6ef1379668e10703$var$d && ($6ef1379668e10703$var$d = b);
            var c = a.previous;
            c.next = b;
            b.previous = c;
        }
        a.next = a.previous = null;
    }
};
module.exports.unstable_wrapCallback = function(a) {
    var b = $6ef1379668e10703$var$g;
    return function() {
        var c = $6ef1379668e10703$var$g, f = $6ef1379668e10703$var$k;
        $6ef1379668e10703$var$g = b;
        $6ef1379668e10703$var$k = module.exports.unstable_now();
        try {
            return a.apply(this, arguments);
        } finally{
            $6ef1379668e10703$var$g = c, $6ef1379668e10703$var$k = f, $6ef1379668e10703$var$v();
        }
    };
};
module.exports.unstable_getCurrentPriorityLevel = function() {
    return $6ef1379668e10703$var$g;
};
module.exports.unstable_shouldYield = function() {
    return !$6ef1379668e10703$var$e && (null !== $6ef1379668e10703$var$d && $6ef1379668e10703$var$d.expirationTime < $6ef1379668e10703$var$l || $6ef1379668e10703$var$w());
};
module.exports.unstable_continueExecution = function() {
    null !== $6ef1379668e10703$var$d && $6ef1379668e10703$var$p();
};
module.exports.unstable_pauseExecution = function() {};
module.exports.unstable_getFirstCallbackNode = function() {
    return $6ef1379668e10703$var$d;
};

});



parcelRegister("7dzZ9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5415a93e08b11fa1$var$ReactIs, $5415a93e08b11fa1$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hWefA"))();

});
parcelRegister("hWefA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $cL286 = parcelRequire("cL286");
function $d0f2e848464bbdd9$var$emptyFunction() {}
function $d0f2e848464bbdd9$var$emptyFunctionWithReset() {}
$d0f2e848464bbdd9$var$emptyFunctionWithReset.resetWarningCache = $d0f2e848464bbdd9$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $cL286) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d0f2e848464bbdd9$var$emptyFunctionWithReset,
        resetWarningCache: $d0f2e848464bbdd9$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("cL286", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $949b86b54f7ca407$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $949b86b54f7ca407$var$ReactPropTypesSecret;

});



parcelRegister("2Yevj", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $229c6f8f08d4c6cb$export$2b8d127b894957b9; }, function (v) { return $229c6f8f08d4c6cb$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $229c6f8f08d4c6cb$export$cea3a54a6425200c; }, function (v) { return $229c6f8f08d4c6cb$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $229c6f8f08d4c6cb$export$a7c73072b1a182ae; }, function (v) { return $229c6f8f08d4c6cb$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $229c6f8f08d4c6cb$export$9f27bc3417b4524d; }, function (v) { return $229c6f8f08d4c6cb$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $229c6f8f08d4c6cb$export$db77ccec0bb4ccac; }, function (v) { return $229c6f8f08d4c6cb$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $229c6f8f08d4c6cb$export$8392c0c9d3dcbd35; }, function (v) { return $229c6f8f08d4c6cb$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $229c6f8f08d4c6cb$export$ffb0004e005737fa; }, function (v) { return $229c6f8f08d4c6cb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $229c6f8f08d4c6cb$export$b624eff549462981; }, function (v) { return $229c6f8f08d4c6cb$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $229c6f8f08d4c6cb$export$7897aa7841a5380c; }, function (v) { return $229c6f8f08d4c6cb$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $229c6f8f08d4c6cb$export$602eac185826482c; }, function (v) { return $229c6f8f08d4c6cb$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $229c6f8f08d4c6cb$export$e2c29f18771995cb; }, function (v) { return $229c6f8f08d4c6cb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $229c6f8f08d4c6cb$export$5f8d39834fd61797; }, function (v) { return $229c6f8f08d4c6cb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $229c6f8f08d4c6cb$export$74bf444e3cd11ea5; }, function (v) { return $229c6f8f08d4c6cb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $229c6f8f08d4c6cb$export$92387174baf9b227; }, function (v) { return $229c6f8f08d4c6cb$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $229c6f8f08d4c6cb$export$ec112efeb987d9c6; }, function (v) { return $229c6f8f08d4c6cb$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $229c6f8f08d4c6cb$export$b706b080d889d2c9; }, function (v) { return $229c6f8f08d4c6cb$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $229c6f8f08d4c6cb$export$5be5a87408f70ddc; }, function (v) { return $229c6f8f08d4c6cb$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $229c6f8f08d4c6cb$export$45a5e7f76e0caa8d; }, function (v) { return $229c6f8f08d4c6cb$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $229c6f8f08d4c6cb$export$455c2e768291efa6; }, function (v) { return $229c6f8f08d4c6cb$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $229c6f8f08d4c6cb$export$9522e17588c12572; }, function (v) { return $229c6f8f08d4c6cb$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $229c6f8f08d4c6cb$export$2110ac352bb060b9; }, function (v) { return $229c6f8f08d4c6cb$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $229c6f8f08d4c6cb$export$56885ab8b9c456ab; }, function (v) { return $229c6f8f08d4c6cb$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $229c6f8f08d4c6cb$export$d927fcb6adf8f9de; }, function (v) { return $229c6f8f08d4c6cb$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $229c6f8f08d4c6cb$export$b82d16f27459e05a; }, function (v) { return $229c6f8f08d4c6cb$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $229c6f8f08d4c6cb$export$522c17b4f5e123e8; }, function (v) { return $229c6f8f08d4c6cb$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $229c6f8f08d4c6cb$export$1aabd8a0274ecfd6; }, function (v) { return $229c6f8f08d4c6cb$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $229c6f8f08d4c6cb$export$9b621391a187a31a; }, function (v) { return $229c6f8f08d4c6cb$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $229c6f8f08d4c6cb$export$f5bbd400c2f4426f; }, function (v) { return $229c6f8f08d4c6cb$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $229c6f8f08d4c6cb$export$2b8d127b894957b9;
var $229c6f8f08d4c6cb$export$cea3a54a6425200c;
var $229c6f8f08d4c6cb$export$a7c73072b1a182ae;
var $229c6f8f08d4c6cb$export$9f27bc3417b4524d;
var $229c6f8f08d4c6cb$export$db77ccec0bb4ccac;
var $229c6f8f08d4c6cb$export$8392c0c9d3dcbd35;
var $229c6f8f08d4c6cb$export$ffb0004e005737fa;
var $229c6f8f08d4c6cb$export$b624eff549462981;
var $229c6f8f08d4c6cb$export$7897aa7841a5380c;
var $229c6f8f08d4c6cb$export$602eac185826482c;
var $229c6f8f08d4c6cb$export$e2c29f18771995cb;
var $229c6f8f08d4c6cb$export$5f8d39834fd61797;
var $229c6f8f08d4c6cb$export$74bf444e3cd11ea5;
var $229c6f8f08d4c6cb$export$92387174baf9b227;
var $229c6f8f08d4c6cb$export$ec112efeb987d9c6;
var $229c6f8f08d4c6cb$export$b706b080d889d2c9;
var $229c6f8f08d4c6cb$export$5be5a87408f70ddc;
var $229c6f8f08d4c6cb$export$45a5e7f76e0caa8d;
var $229c6f8f08d4c6cb$export$455c2e768291efa6;
var $229c6f8f08d4c6cb$export$9522e17588c12572;
var $229c6f8f08d4c6cb$export$2110ac352bb060b9;
var $229c6f8f08d4c6cb$export$56885ab8b9c456ab;
var $229c6f8f08d4c6cb$export$d927fcb6adf8f9de;
var $229c6f8f08d4c6cb$export$b82d16f27459e05a;
var $229c6f8f08d4c6cb$export$522c17b4f5e123e8;
var $229c6f8f08d4c6cb$export$1aabd8a0274ecfd6;
var $229c6f8f08d4c6cb$export$9b621391a187a31a;
var $229c6f8f08d4c6cb$export$f5bbd400c2f4426f;
'use strict';
var $229c6f8f08d4c6cb$var$b = "function" === typeof Symbol && Symbol.for, $229c6f8f08d4c6cb$var$c = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.element") : 60103, $229c6f8f08d4c6cb$var$d = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.portal") : 60106, $229c6f8f08d4c6cb$var$e = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.fragment") : 60107, $229c6f8f08d4c6cb$var$f = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.strict_mode") : 60108, $229c6f8f08d4c6cb$var$g = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.profiler") : 60114, $229c6f8f08d4c6cb$var$h = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.provider") : 60109, $229c6f8f08d4c6cb$var$k = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.context") : 60110, $229c6f8f08d4c6cb$var$l = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.async_mode") : 60111, $229c6f8f08d4c6cb$var$m = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.concurrent_mode") : 60111, $229c6f8f08d4c6cb$var$n = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.forward_ref") : 60112, $229c6f8f08d4c6cb$var$p = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.suspense") : 60113, $229c6f8f08d4c6cb$var$q = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.suspense_list") : 60120, $229c6f8f08d4c6cb$var$r = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.memo") : 60115, $229c6f8f08d4c6cb$var$t = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.lazy") : 60116, $229c6f8f08d4c6cb$var$v = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.block") : 60121, $229c6f8f08d4c6cb$var$w = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.fundamental") : 60117, $229c6f8f08d4c6cb$var$x = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.responder") : 60118, $229c6f8f08d4c6cb$var$y = $229c6f8f08d4c6cb$var$b ? Symbol.for("react.scope") : 60119;
function $229c6f8f08d4c6cb$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $229c6f8f08d4c6cb$var$c:
                switch(a = a.type, a){
                    case $229c6f8f08d4c6cb$var$l:
                    case $229c6f8f08d4c6cb$var$m:
                    case $229c6f8f08d4c6cb$var$e:
                    case $229c6f8f08d4c6cb$var$g:
                    case $229c6f8f08d4c6cb$var$f:
                    case $229c6f8f08d4c6cb$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $229c6f8f08d4c6cb$var$k:
                            case $229c6f8f08d4c6cb$var$n:
                            case $229c6f8f08d4c6cb$var$t:
                            case $229c6f8f08d4c6cb$var$r:
                            case $229c6f8f08d4c6cb$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $229c6f8f08d4c6cb$var$d:
                return u;
        }
    }
}
function $229c6f8f08d4c6cb$var$A(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$m;
}
$229c6f8f08d4c6cb$export$2b8d127b894957b9 = $229c6f8f08d4c6cb$var$l;
$229c6f8f08d4c6cb$export$cea3a54a6425200c = $229c6f8f08d4c6cb$var$m;
$229c6f8f08d4c6cb$export$a7c73072b1a182ae = $229c6f8f08d4c6cb$var$k;
$229c6f8f08d4c6cb$export$9f27bc3417b4524d = $229c6f8f08d4c6cb$var$h;
$229c6f8f08d4c6cb$export$db77ccec0bb4ccac = $229c6f8f08d4c6cb$var$c;
$229c6f8f08d4c6cb$export$8392c0c9d3dcbd35 = $229c6f8f08d4c6cb$var$n;
$229c6f8f08d4c6cb$export$ffb0004e005737fa = $229c6f8f08d4c6cb$var$e;
$229c6f8f08d4c6cb$export$b624eff549462981 = $229c6f8f08d4c6cb$var$t;
$229c6f8f08d4c6cb$export$7897aa7841a5380c = $229c6f8f08d4c6cb$var$r;
$229c6f8f08d4c6cb$export$602eac185826482c = $229c6f8f08d4c6cb$var$d;
$229c6f8f08d4c6cb$export$e2c29f18771995cb = $229c6f8f08d4c6cb$var$g;
$229c6f8f08d4c6cb$export$5f8d39834fd61797 = $229c6f8f08d4c6cb$var$f;
$229c6f8f08d4c6cb$export$74bf444e3cd11ea5 = $229c6f8f08d4c6cb$var$p;
$229c6f8f08d4c6cb$export$92387174baf9b227 = function(a) {
    return $229c6f8f08d4c6cb$var$A(a) || $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$l;
};
$229c6f8f08d4c6cb$export$ec112efeb987d9c6 = $229c6f8f08d4c6cb$var$A;
$229c6f8f08d4c6cb$export$b706b080d889d2c9 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$k;
};
$229c6f8f08d4c6cb$export$5be5a87408f70ddc = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$h;
};
$229c6f8f08d4c6cb$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $229c6f8f08d4c6cb$var$c;
};
$229c6f8f08d4c6cb$export$455c2e768291efa6 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$n;
};
$229c6f8f08d4c6cb$export$9522e17588c12572 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$e;
};
$229c6f8f08d4c6cb$export$2110ac352bb060b9 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$t;
};
$229c6f8f08d4c6cb$export$56885ab8b9c456ab = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$r;
};
$229c6f8f08d4c6cb$export$d927fcb6adf8f9de = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$d;
};
$229c6f8f08d4c6cb$export$b82d16f27459e05a = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$g;
};
$229c6f8f08d4c6cb$export$522c17b4f5e123e8 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$f;
};
$229c6f8f08d4c6cb$export$1aabd8a0274ecfd6 = function(a) {
    return $229c6f8f08d4c6cb$var$z(a) === $229c6f8f08d4c6cb$var$p;
};
$229c6f8f08d4c6cb$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $229c6f8f08d4c6cb$var$e || a === $229c6f8f08d4c6cb$var$m || a === $229c6f8f08d4c6cb$var$g || a === $229c6f8f08d4c6cb$var$f || a === $229c6f8f08d4c6cb$var$p || a === $229c6f8f08d4c6cb$var$q || "object" === typeof a && null !== a && (a.$$typeof === $229c6f8f08d4c6cb$var$t || a.$$typeof === $229c6f8f08d4c6cb$var$r || a.$$typeof === $229c6f8f08d4c6cb$var$h || a.$$typeof === $229c6f8f08d4c6cb$var$k || a.$$typeof === $229c6f8f08d4c6cb$var$n || a.$$typeof === $229c6f8f08d4c6cb$var$w || a.$$typeof === $229c6f8f08d4c6cb$var$x || a.$$typeof === $229c6f8f08d4c6cb$var$y || a.$$typeof === $229c6f8f08d4c6cb$var$v);
};
$229c6f8f08d4c6cb$export$f5bbd400c2f4426f = $229c6f8f08d4c6cb$var$z;

});

parcelRegister("frurs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b3e0fdc343047a3f$export$71511d61b312f219; });

var $4E6oY = parcelRequire("4E6oY");
function $b3e0fdc343047a3f$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $4E6oY._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("4E6oY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $361fdd202bde9443$export$71511d61b312f219; });
function $361fdd202bde9443$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("QHj9z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09e6737ecd4f4b3a$export$71511d61b312f219; });
function $09e6737ecd4f4b3a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $09e6737ecd4f4b3a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $09e6737ecd4f4b3a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("1X5R2", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("krCrj", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    function n(n, t, r) {
        switch(r.length){
            case 0:
                return n.call(t);
            case 1:
                return n.call(t, r[0]);
            case 2:
                return n.call(t, r[0], r[1]);
            case 3:
                return n.call(t, r[0], r[1], r[2]);
        }
        return n.apply(t, r);
    }
    function t(n, t, r, e) {
        for(var u = -1, i = null == n ? 0 : n.length; ++u < i;){
            var o = n[u];
            t(e, o, r(o), n);
        }
        return e;
    }
    function r(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e && t(n[r], r, n) !== !1;);
        return n;
    }
    function e(n, t) {
        for(var r = null == n ? 0 : n.length; r-- && t(n[r], r, n) !== !1;);
        return n;
    }
    function u(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e;)if (!t(n[r], r, n)) return !1;
        return !0;
    }
    function i(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length, u = 0, i = []; ++r < e;){
            var o = n[r];
            t(o, r, n) && (i[u++] = o);
        }
        return i;
    }
    function o(n, t) {
        return !!(null == n ? 0 : n.length) && y(n, t, 0) > -1;
    }
    function f(n, t, r) {
        for(var e = -1, u = null == n ? 0 : n.length; ++e < u;)if (r(t, n[e])) return !0;
        return !1;
    }
    function c(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length, u = Array(e); ++r < e;)u[r] = t(n[r], r, n);
        return u;
    }
    function a(n, t) {
        for(var r = -1, e = t.length, u = n.length; ++r < e;)n[u + r] = t[r];
        return n;
    }
    function l(n, t, r, e) {
        var u = -1, i = null == n ? 0 : n.length;
        for(e && i && (r = n[++u]); ++u < i;)r = t(r, n[u], u, n);
        return r;
    }
    function s(n, t, r, e) {
        var u = null == n ? 0 : n.length;
        for(e && u && (r = n[--u]); u--;)r = t(r, n[u], u, n);
        return r;
    }
    function h(n, t) {
        for(var r = -1, e = null == n ? 0 : n.length; ++r < e;)if (t(n[r], r, n)) return !0;
        return !1;
    }
    function p(n) {
        return n.split("");
    }
    function _(n) {
        return n.match($t) || [];
    }
    function v(n, t, r) {
        var e;
        return r(n, function(n, r, u) {
            if (t(n, r, u)) return e = r, !1;
        }), e;
    }
    function g(n, t, r, e) {
        for(var u = n.length, i = r + (e ? 1 : -1); e ? i-- : ++i < u;)if (t(n[i], i, n)) return i;
        return -1;
    }
    function y(n, t, r) {
        return t === t ? Z(n, t, r) : g(n, b, r);
    }
    function d(n, t, r, e) {
        for(var u = r - 1, i = n.length; ++u < i;)if (e(n[u], t)) return u;
        return -1;
    }
    function b(n) {
        return n !== n;
    }
    function w(n, t) {
        var r = null == n ? 0 : n.length;
        return r ? k(n, t) / r : Cn;
    }
    function m(n) {
        return function(t) {
            return null == t ? X : t[n];
        };
    }
    function x(n) {
        return function(t) {
            return null == n ? X : n[t];
        };
    }
    function j(n, t, r, e, u) {
        return u(n, function(n, u, i) {
            r = e ? (e = !1, n) : t(r, n, u, i);
        }), r;
    }
    function A(n, t) {
        var r = n.length;
        for(n.sort(t); r--;)n[r] = n[r].value;
        return n;
    }
    function k(n, t) {
        for(var r, e = -1, u = n.length; ++e < u;){
            var i = t(n[e]);
            i !== X && (r = r === X ? i : r + i);
        }
        return r;
    }
    function O(n, t) {
        for(var r = -1, e = Array(n); ++r < n;)e[r] = t(r);
        return e;
    }
    function I(n, t) {
        return c(t, function(t) {
            return [
                t,
                n[t]
            ];
        });
    }
    function R(n) {
        return n ? n.slice(0, H(n) + 1).replace(Lt, "") : n;
    }
    function z(n) {
        return function(t) {
            return n(t);
        };
    }
    function E(n, t) {
        return c(t, function(t) {
            return n[t];
        });
    }
    function S(n, t) {
        return n.has(t);
    }
    function W(n, t) {
        for(var r = -1, e = n.length; ++r < e && y(t, n[r], 0) > -1;);
        return r;
    }
    function L(n, t) {
        for(var r = n.length; r-- && y(t, n[r], 0) > -1;);
        return r;
    }
    function C(n, t) {
        for(var r = n.length, e = 0; r--;)n[r] === t && ++e;
        return e;
    }
    function U(n) {
        return "\\" + Yr[n];
    }
    function B(n, t) {
        return null == n ? X : n[t];
    }
    function T(n) {
        return Nr.test(n);
    }
    function $(n) {
        return Pr.test(n);
    }
    function D(n) {
        for(var t, r = []; !(t = n.next()).done;)r.push(t.value);
        return r;
    }
    function M(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n, e) {
            r[++t] = [
                e,
                n
            ];
        }), r;
    }
    function F(n, t) {
        return function(r) {
            return n(t(r));
        };
    }
    function N(n, t) {
        for(var r = -1, e = n.length, u = 0, i = []; ++r < e;){
            var o = n[r];
            o !== t && o !== cn || (n[r] = cn, i[u++] = r);
        }
        return i;
    }
    function P(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n) {
            r[++t] = n;
        }), r;
    }
    function q(n) {
        var t = -1, r = Array(n.size);
        return n.forEach(function(n) {
            r[++t] = [
                n,
                n
            ];
        }), r;
    }
    function Z(n, t, r) {
        for(var e = r - 1, u = n.length; ++e < u;)if (n[e] === t) return e;
        return -1;
    }
    function K(n, t, r) {
        for(var e = r + 1; e--;)if (n[e] === t) return e;
        return e;
    }
    function V(n) {
        return T(n) ? J(n) : _e(n);
    }
    function G(n) {
        return T(n) ? Y(n) : p(n);
    }
    function H(n) {
        for(var t = n.length; t-- && Ct.test(n.charAt(t)););
        return t;
    }
    function J(n) {
        for(var t = Mr.lastIndex = 0; Mr.test(n);)++t;
        return t;
    }
    function Y(n) {
        return n.match(Mr) || [];
    }
    function Q(n) {
        return n.match(Fr) || [];
    }
    var X, nn = "4.17.21", tn = 200, rn = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", en = "Expected a function", un = "Invalid `variable` option passed into `_.template`", on = "__lodash_hash_undefined__", fn = 500, cn = "__lodash_placeholder__", an = 1, ln = 2, sn = 4, hn = 1, pn = 2, _n = 1, vn = 2, gn = 4, yn = 8, dn = 16, bn = 32, wn = 64, mn = 128, xn = 256, jn = 512, An = 30, kn = "...", On = 800, In = 16, Rn = 1, zn = 2, En = 3, Sn = 1 / 0, Wn = 9007199254740991, Ln = 1.7976931348623157e308, Cn = NaN, Un = 4294967295, Bn = Un - 1, Tn = Un >>> 1, $n = [
        [
            "ary",
            mn
        ],
        [
            "bind",
            _n
        ],
        [
            "bindKey",
            vn
        ],
        [
            "curry",
            yn
        ],
        [
            "curryRight",
            dn
        ],
        [
            "flip",
            jn
        ],
        [
            "partial",
            bn
        ],
        [
            "partialRight",
            wn
        ],
        [
            "rearg",
            xn
        ]
    ], Dn = "[object Arguments]", Mn = "[object Array]", Fn = "[object AsyncFunction]", Nn = "[object Boolean]", Pn = "[object Date]", qn = "[object DOMException]", Zn = "[object Error]", Kn = "[object Function]", Vn = "[object GeneratorFunction]", Gn = "[object Map]", Hn = "[object Number]", Jn = "[object Null]", Yn = "[object Object]", Qn = "[object Promise]", Xn = "[object Proxy]", nt = "[object RegExp]", tt = "[object Set]", rt = "[object String]", et = "[object Symbol]", ut = "[object Undefined]", it = "[object WeakMap]", ot = "[object WeakSet]", ft = "[object ArrayBuffer]", ct = "[object DataView]", at = "[object Float32Array]", lt = "[object Float64Array]", st = "[object Int8Array]", ht = "[object Int16Array]", pt = "[object Int32Array]", _t = "[object Uint8Array]", vt = "[object Uint8ClampedArray]", gt = "[object Uint16Array]", yt = "[object Uint32Array]", dt = /\b__p \+= '';/g, bt = /\b(__p \+=) '' \+/g, wt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mt = /&(?:amp|lt|gt|quot|#39);/g, xt = /[&<>"']/g, jt = RegExp(mt.source), At = RegExp(xt.source), kt = /<%-([\s\S]+?)%>/g, Ot = /<%([\s\S]+?)%>/g, It = /<%=([\s\S]+?)%>/g, Rt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zt = /^\w*$/, Et = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, St = /[\\^$.*+?()[\]{}|]/g, Wt = RegExp(St.source), Lt = /^\s+/, Ct = /\s/, Ut = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Bt = /\{\n\/\* \[wrapped with (.+)\] \*/, Tt = /,? & /, $t = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Dt = /[()=,{}\[\]\/\s]/, Mt = /\\(\\)?/g, Ft = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Nt = /\w*$/, Pt = /^[-+]0x[0-9a-f]+$/i, qt = /^0b[01]+$/i, Zt = /^\[object .+?Constructor\]$/, Kt = /^0o[0-7]+$/i, Vt = /^(?:0|[1-9]\d*)$/, Gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ht = /($^)/, Jt = /['\n\r\u2028\u2029\\]/g, Yt = "\\ud800-\\udfff", Qt = "\\u0300-\\u036f", Xt = "\\ufe20-\\ufe2f", nr = "\\u20d0-\\u20ff", tr = Qt + Xt + nr, rr = "\\u2700-\\u27bf", er = "a-z\\xdf-\\xf6\\xf8-\\xff", ur = "\\xac\\xb1\\xd7\\xf7", ir = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", or = "\\u2000-\\u206f", fr = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cr = "A-Z\\xc0-\\xd6\\xd8-\\xde", ar = "\\ufe0e\\ufe0f", lr = ur + ir + or + fr, sr = "['\u2019]", hr = "[" + Yt + "]", pr = "[" + lr + "]", _r = "[" + tr + "]", vr = "\\d+", gr = "[" + rr + "]", yr = "[" + er + "]", dr = "[^" + Yt + lr + vr + rr + er + cr + "]", br = "\\ud83c[\\udffb-\\udfff]", wr = "(?:" + _r + "|" + br + ")", mr = "[^" + Yt + "]", xr = "(?:\\ud83c[\\udde6-\\uddff]){2}", jr = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ar = "[" + cr + "]", kr = "\\u200d", Or = "(?:" + yr + "|" + dr + ")", Ir = "(?:" + Ar + "|" + dr + ")", Rr = "(?:" + sr + "(?:d|ll|m|re|s|t|ve))?", zr = "(?:" + sr + "(?:D|LL|M|RE|S|T|VE))?", Er = wr + "?", Sr = "[" + ar + "]?", Wr = "(?:" + kr + "(?:" + [
        mr,
        xr,
        jr
    ].join("|") + ")" + Sr + Er + ")*", Lr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Cr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ur = Sr + Er + Wr, Br = "(?:" + [
        gr,
        xr,
        jr
    ].join("|") + ")" + Ur, Tr = "(?:" + [
        mr + _r + "?",
        _r,
        xr,
        jr,
        hr
    ].join("|") + ")", $r = RegExp(sr, "g"), Dr = RegExp(_r, "g"), Mr = RegExp(br + "(?=" + br + ")|" + Tr + Ur, "g"), Fr = RegExp([
        Ar + "?" + yr + "+" + Rr + "(?=" + [
            pr,
            Ar,
            "$"
        ].join("|") + ")",
        Ir + "+" + zr + "(?=" + [
            pr,
            Ar + Or,
            "$"
        ].join("|") + ")",
        Ar + "?" + Or + "+" + Rr,
        Ar + "+" + zr,
        Cr,
        Lr,
        vr,
        Br
    ].join("|"), "g"), Nr = RegExp("[" + kr + Yt + tr + ar + "]"), Pr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qr = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ], Zr = -1, Kr = {};
    Kr[at] = Kr[lt] = Kr[st] = Kr[ht] = Kr[pt] = Kr[_t] = Kr[vt] = Kr[gt] = Kr[yt] = !0, Kr[Dn] = Kr[Mn] = Kr[ft] = Kr[Nn] = Kr[ct] = Kr[Pn] = Kr[Zn] = Kr[Kn] = Kr[Gn] = Kr[Hn] = Kr[Yn] = Kr[nt] = Kr[tt] = Kr[rt] = Kr[it] = !1;
    var Vr = {};
    Vr[Dn] = Vr[Mn] = Vr[ft] = Vr[ct] = Vr[Nn] = Vr[Pn] = Vr[at] = Vr[lt] = Vr[st] = Vr[ht] = Vr[pt] = Vr[Gn] = Vr[Hn] = Vr[Yn] = Vr[nt] = Vr[tt] = Vr[rt] = Vr[et] = Vr[_t] = Vr[vt] = Vr[gt] = Vr[yt] = !0, Vr[Zn] = Vr[Kn] = Vr[it] = !1;
    var Gr = {
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010a": "C",
        "\u010c": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010b": "c",
        "\u010d": "c",
        "\u010e": "D",
        "\u0110": "D",
        "\u010f": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011a": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011b": "e",
        "\u011c": "G",
        "\u011e": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011d": "g",
        "\u011f": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012a": "I",
        "\u012c": "I",
        "\u012e": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012b": "i",
        "\u012d": "i",
        "\u012f": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013b": "L",
        "\u013d": "L",
        "\u013f": "L",
        "\u0141": "L",
        "\u013a": "l",
        "\u013c": "l",
        "\u013e": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014a": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014b": "n",
        "\u014c": "O",
        "\u014e": "O",
        "\u0150": "O",
        "\u014d": "o",
        "\u014f": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015a": "S",
        "\u015c": "S",
        "\u015e": "S",
        "\u0160": "S",
        "\u015b": "s",
        "\u015d": "s",
        "\u015f": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016a": "U",
        "\u016c": "U",
        "\u016e": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016b": "u",
        "\u016d": "u",
        "\u016f": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017b": "Z",
        "\u017d": "Z",
        "\u017a": "z",
        "\u017c": "z",
        "\u017e": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017f": "s"
    }, Hr = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, Jr = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    }, Yr = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    }, Qr = parseFloat, Xr = parseInt, ne = "object" == typeof $parcel$global && $parcel$global && $parcel$global.Object === Object && $parcel$global, te = "object" == typeof self && self && self.Object === Object && self, re = ne || te || Function("return this")(), ee = exports && !exports.nodeType && exports, ue = ee && true && module && !module.nodeType && module, ie = ue && ue.exports === ee, oe = ie && ne.process, fe = function() {
        try {
            var n = ue && ue.require && ue.require("util").types;
            return n ? n : oe && oe.binding && oe.binding("util");
        } catch (n) {}
    }(), ce = fe && fe.isArrayBuffer, ae = fe && fe.isDate, le = fe && fe.isMap, se = fe && fe.isRegExp, he = fe && fe.isSet, pe = fe && fe.isTypedArray, _e = m("length"), ve = x(Gr), ge = x(Hr), ye = x(Jr), de = function p(x) {
        function Z(n) {
            if (cc(n) && !bh(n) && !(n instanceof Ct)) {
                if (n instanceof Y) return n;
                if (bl.call(n, "__wrapped__")) return eo(n);
            }
            return new Y(n);
        }
        function J() {}
        function Y(n, t) {
            this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = X;
        }
        function Ct(n) {
            this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Un, this.__views__ = [];
        }
        function $t() {
            var n = new Ct(this.__wrapped__);
            return n.__actions__ = Tu(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Tu(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Tu(this.__views__), n;
        }
        function Yt() {
            if (this.__filtered__) {
                var n = new Ct(this);
                n.__dir__ = -1, n.__filtered__ = !0;
            } else n = this.clone(), n.__dir__ *= -1;
            return n;
        }
        function Qt() {
            var n = this.__wrapped__.value(), t = this.__dir__, r = bh(n), e = t < 0, u = r ? n.length : 0, i = Oi(0, u, this.__views__), o = i.start, f = i.end, c = f - o, a = e ? f : o - 1, l = this.__iteratees__, s = l.length, h = 0, p = Hl(c, this.__takeCount__);
            if (!r || !e && u == c && p == c) return wu(n, this.__actions__);
            var _ = [];
            n: for(; c-- && h < p;){
                a += t;
                for(var v = -1, g = n[a]; ++v < s;){
                    var y = l[v], d = y.iteratee, b = y.type, w = d(g);
                    if (b == zn) g = w;
                    else if (!w) {
                        if (b == Rn) continue n;
                        break n;
                    }
                }
                _[h++] = g;
            }
            return _;
        }
        function Xt(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function nr() {
            this.__data__ = is ? is(null) : {}, this.size = 0;
        }
        function tr(n) {
            var t = this.has(n) && delete this.__data__[n];
            return this.size -= t ? 1 : 0, t;
        }
        function rr(n) {
            var t = this.__data__;
            if (is) {
                var r = t[n];
                return r === on ? X : r;
            }
            return bl.call(t, n) ? t[n] : X;
        }
        function er(n) {
            var t = this.__data__;
            return is ? t[n] !== X : bl.call(t, n);
        }
        function ur(n, t) {
            var r = this.__data__;
            return this.size += this.has(n) ? 0 : 1, r[n] = is && t === X ? on : t, this;
        }
        function ir(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function or() {
            this.__data__ = [], this.size = 0;
        }
        function fr(n) {
            var t = this.__data__, r = Wr(t, n);
            return !(r < 0) && (r == t.length - 1 ? t.pop() : Ll.call(t, r, 1), --this.size, !0);
        }
        function cr(n) {
            var t = this.__data__, r = Wr(t, n);
            return r < 0 ? X : t[r][1];
        }
        function ar(n) {
            return Wr(this.__data__, n) > -1;
        }
        function lr(n, t) {
            var r = this.__data__, e = Wr(r, n);
            return e < 0 ? (++this.size, r.push([
                n,
                t
            ])) : r[e][1] = t, this;
        }
        function sr(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.clear(); ++t < r;){
                var e = n[t];
                this.set(e[0], e[1]);
            }
        }
        function hr() {
            this.size = 0, this.__data__ = {
                hash: new Xt,
                map: new (ts || ir),
                string: new Xt
            };
        }
        function pr(n) {
            var t = xi(this, n).delete(n);
            return this.size -= t ? 1 : 0, t;
        }
        function _r(n) {
            return xi(this, n).get(n);
        }
        function vr(n) {
            return xi(this, n).has(n);
        }
        function gr(n, t) {
            var r = xi(this, n), e = r.size;
            return r.set(n, t), this.size += r.size == e ? 0 : 1, this;
        }
        function yr(n) {
            var t = -1, r = null == n ? 0 : n.length;
            for(this.__data__ = new sr; ++t < r;)this.add(n[t]);
        }
        function dr(n) {
            return this.__data__.set(n, on), this;
        }
        function br(n) {
            return this.__data__.has(n);
        }
        function wr(n) {
            this.size = (this.__data__ = new ir(n)).size;
        }
        function mr() {
            this.__data__ = new ir, this.size = 0;
        }
        function xr(n) {
            var t = this.__data__, r = t.delete(n);
            return this.size = t.size, r;
        }
        function jr(n) {
            return this.__data__.get(n);
        }
        function Ar(n) {
            return this.__data__.has(n);
        }
        function kr(n, t) {
            var r = this.__data__;
            if (r instanceof ir) {
                var e = r.__data__;
                if (!ts || e.length < tn - 1) return e.push([
                    n,
                    t
                ]), this.size = ++r.size, this;
                r = this.__data__ = new sr(e);
            }
            return r.set(n, t), this.size = r.size, this;
        }
        function Or(n, t) {
            var r = bh(n), e = !r && dh(n), u = !r && !e && mh(n), i = !r && !e && !u && Oh(n), o = r || e || u || i, f = o ? O(n.length, hl) : [], c = f.length;
            for(var a in n)!t && !bl.call(n, a) || o && ("length" == a || u && ("offset" == a || "parent" == a) || i && ("buffer" == a || "byteLength" == a || "byteOffset" == a) || Ci(a, c)) || f.push(a);
            return f;
        }
        function Ir(n) {
            var t = n.length;
            return t ? n[tu(0, t - 1)] : X;
        }
        function Rr(n, t) {
            return Xi(Tu(n), Mr(t, 0, n.length));
        }
        function zr(n) {
            return Xi(Tu(n));
        }
        function Er(n, t, r) {
            (r === X || Gf(n[t], r)) && (r !== X || t in n) || Br(n, t, r);
        }
        function Sr(n, t, r) {
            var e = n[t];
            bl.call(n, t) && Gf(e, r) && (r !== X || t in n) || Br(n, t, r);
        }
        function Wr(n, t) {
            for(var r = n.length; r--;)if (Gf(n[r][0], t)) return r;
            return -1;
        }
        function Lr(n, t, r, e) {
            return ys(n, function(n, u, i) {
                t(e, n, r(n), i);
            }), e;
        }
        function Cr(n, t) {
            return n && $u(t, Pc(t), n);
        }
        function Ur(n, t) {
            return n && $u(t, qc(t), n);
        }
        function Br(n, t, r) {
            "__proto__" == t && Tl ? Tl(n, t, {
                configurable: !0,
                enumerable: !0,
                value: r,
                writable: !0
            }) : n[t] = r;
        }
        function Tr(n, t) {
            for(var r = -1, e = t.length, u = il(e), i = null == n; ++r < e;)u[r] = i ? X : Mc(n, t[r]);
            return u;
        }
        function Mr(n, t, r) {
            return n === n && (r !== X && (n = n <= r ? n : r), t !== X && (n = n >= t ? n : t)), n;
        }
        function Fr(n, t, e, u, i, o) {
            var f, c = t & an, a = t & ln, l = t & sn;
            if (e && (f = i ? e(n, u, i, o) : e(n)), f !== X) return f;
            if (!fc(n)) return n;
            var s = bh(n);
            if (s) {
                if (f = zi(n), !c) return Tu(n, f);
            } else {
                var h = zs(n), p = h == Kn || h == Vn;
                if (mh(n)) return Iu(n, c);
                if (h == Yn || h == Dn || p && !i) {
                    if (f = a || p ? {} : Ei(n), !c) return a ? Mu(n, Ur(f, n)) : Du(n, Cr(f, n));
                } else {
                    if (!Vr[h]) return i ? n : {};
                    f = Si(n, h, c);
                }
            }
            o || (o = new wr);
            var _ = o.get(n);
            if (_) return _;
            o.set(n, f), kh(n) ? n.forEach(function(r) {
                f.add(Fr(r, t, e, r, n, o));
            }) : jh(n) && n.forEach(function(r, u) {
                f.set(u, Fr(r, t, e, u, n, o));
            });
            var v = l ? a ? di : yi : a ? qc : Pc, g = s ? X : v(n);
            return r(g || n, function(r, u) {
                g && (u = r, r = n[u]), Sr(f, u, Fr(r, t, e, u, n, o));
            }), f;
        }
        function Nr(n) {
            var t = Pc(n);
            return function(r) {
                return Pr(r, n, t);
            };
        }
        function Pr(n, t, r) {
            var e = r.length;
            if (null == n) return !e;
            for(n = ll(n); e--;){
                var u = r[e], i = t[u], o = n[u];
                if (o === X && !(u in n) || !i(o)) return !1;
            }
            return !0;
        }
        function Gr(n, t, r) {
            if ("function" != typeof n) throw new pl(en);
            return Ws(function() {
                n.apply(X, r);
            }, t);
        }
        function Hr(n, t, r, e) {
            var u = -1, i = o, a = !0, l = n.length, s = [], h = t.length;
            if (!l) return s;
            r && (t = c(t, z(r))), e ? (i = f, a = !1) : t.length >= tn && (i = S, a = !1, t = new yr(t));
            n: for(; ++u < l;){
                var p = n[u], _ = null == r ? p : r(p);
                if (p = e || 0 !== p ? p : 0, a && _ === _) {
                    for(var v = h; v--;)if (t[v] === _) continue n;
                    s.push(p);
                } else i(t, _, e) || s.push(p);
            }
            return s;
        }
        function Jr(n, t) {
            var r = !0;
            return ys(n, function(n, e, u) {
                return r = !!t(n, e, u);
            }), r;
        }
        function Yr(n, t, r) {
            for(var e = -1, u = n.length; ++e < u;){
                var i = n[e], o = t(i);
                if (null != o && (f === X ? o === o && !bc(o) : r(o, f))) var f = o, c = i;
            }
            return c;
        }
        function ne(n, t, r, e) {
            var u = n.length;
            for(r = kc(r), r < 0 && (r = -r > u ? 0 : u + r), e = e === X || e > u ? u : kc(e), e < 0 && (e += u), e = r > e ? 0 : Oc(e); r < e;)n[r++] = t;
            return n;
        }
        function te(n, t) {
            var r = [];
            return ys(n, function(n, e, u) {
                t(n, e, u) && r.push(n);
            }), r;
        }
        function ee(n, t, r, e, u) {
            var i = -1, o = n.length;
            for(r || (r = Li), u || (u = []); ++i < o;){
                var f = n[i];
                t > 0 && r(f) ? t > 1 ? ee(f, t - 1, r, e, u) : a(u, f) : e || (u[u.length] = f);
            }
            return u;
        }
        function ue(n, t) {
            return n && bs(n, t, Pc);
        }
        function oe(n, t) {
            return n && ws(n, t, Pc);
        }
        function fe(n, t) {
            return i(t, function(t) {
                return uc(n[t]);
            });
        }
        function _e(n, t) {
            t = ku(t, n);
            for(var r = 0, e = t.length; null != n && r < e;)n = n[no(t[r++])];
            return r && r == e ? n : X;
        }
        function de(n, t, r) {
            var e = t(n);
            return bh(n) ? e : a(e, r(n));
        }
        function we(n) {
            return null == n ? n === X ? ut : Jn : Bl && Bl in ll(n) ? ki(n) : Ki(n);
        }
        function me(n, t) {
            return n > t;
        }
        function xe(n, t) {
            return null != n && bl.call(n, t);
        }
        function je(n, t) {
            return null != n && t in ll(n);
        }
        function Ae(n, t, r) {
            return n >= Hl(t, r) && n < Gl(t, r);
        }
        function ke(n, t, r) {
            for(var e = r ? f : o, u = n[0].length, i = n.length, a = i, l = il(i), s = 1 / 0, h = []; a--;){
                var p = n[a];
                a && t && (p = c(p, z(t))), s = Hl(p.length, s), l[a] = !r && (t || u >= 120 && p.length >= 120) ? new yr(a && p) : X;
            }
            p = n[0];
            var _ = -1, v = l[0];
            n: for(; ++_ < u && h.length < s;){
                var g = p[_], y = t ? t(g) : g;
                if (g = r || 0 !== g ? g : 0, !(v ? S(v, y) : e(h, y, r))) {
                    for(a = i; --a;){
                        var d = l[a];
                        if (!(d ? S(d, y) : e(n[a], y, r))) continue n;
                    }
                    v && v.push(y), h.push(g);
                }
            }
            return h;
        }
        function Oe(n, t, r, e) {
            return ue(n, function(n, u, i) {
                t(e, r(n), u, i);
            }), e;
        }
        function Ie(t, r, e) {
            r = ku(r, t), t = Gi(t, r);
            var u = null == t ? t : t[no(jo(r))];
            return null == u ? X : n(u, t, e);
        }
        function Re(n) {
            return cc(n) && we(n) == Dn;
        }
        function ze(n) {
            return cc(n) && we(n) == ft;
        }
        function Ee(n) {
            return cc(n) && we(n) == Pn;
        }
        function Se(n, t, r, e, u) {
            return n === t || (null == n || null == t || !cc(n) && !cc(t) ? n !== n && t !== t : We(n, t, r, e, Se, u));
        }
        function We(n, t, r, e, u, i) {
            var o = bh(n), f = bh(t), c = o ? Mn : zs(n), a = f ? Mn : zs(t);
            c = c == Dn ? Yn : c, a = a == Dn ? Yn : a;
            var l = c == Yn, s = a == Yn, h = c == a;
            if (h && mh(n)) {
                if (!mh(t)) return !1;
                o = !0, l = !1;
            }
            if (h && !l) return i || (i = new wr), o || Oh(n) ? pi(n, t, r, e, u, i) : _i(n, t, c, r, e, u, i);
            if (!(r & hn)) {
                var p = l && bl.call(n, "__wrapped__"), _ = s && bl.call(t, "__wrapped__");
                if (p || _) {
                    var v = p ? n.value() : n, g = _ ? t.value() : t;
                    return i || (i = new wr), u(v, g, r, e, i);
                }
            }
            return !!h && (i || (i = new wr), vi(n, t, r, e, u, i));
        }
        function Le(n) {
            return cc(n) && zs(n) == Gn;
        }
        function Ce(n, t, r, e) {
            var u = r.length, i = u, o = !e;
            if (null == n) return !i;
            for(n = ll(n); u--;){
                var f = r[u];
                if (o && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
            }
            for(; ++u < i;){
                f = r[u];
                var c = f[0], a = n[c], l = f[1];
                if (o && f[2]) {
                    if (a === X && !(c in n)) return !1;
                } else {
                    var s = new wr;
                    if (e) var h = e(a, l, c, n, t, s);
                    if (!(h === X ? Se(l, a, hn | pn, e, s) : h)) return !1;
                }
            }
            return !0;
        }
        function Ue(n) {
            return !(!fc(n) || Di(n)) && (uc(n) ? kl : Zt).test(to(n));
        }
        function Be(n) {
            return cc(n) && we(n) == nt;
        }
        function Te(n) {
            return cc(n) && zs(n) == tt;
        }
        function $e(n) {
            return cc(n) && oc(n.length) && !!Kr[we(n)];
        }
        function De(n) {
            return "function" == typeof n ? n : null == n ? La : "object" == typeof n ? bh(n) ? Ze(n[0], n[1]) : qe(n) : Fa(n);
        }
        function Me(n) {
            if (!Mi(n)) return Vl(n);
            var t = [];
            for(var r in ll(n))bl.call(n, r) && "constructor" != r && t.push(r);
            return t;
        }
        function Fe(n) {
            if (!fc(n)) return Zi(n);
            var t = Mi(n), r = [];
            for(var e in n)("constructor" != e || !t && bl.call(n, e)) && r.push(e);
            return r;
        }
        function Ne(n, t) {
            return n < t;
        }
        function Pe(n, t) {
            var r = -1, e = Hf(n) ? il(n.length) : [];
            return ys(n, function(n, u, i) {
                e[++r] = t(n, u, i);
            }), e;
        }
        function qe(n) {
            var t = ji(n);
            return 1 == t.length && t[0][2] ? Ni(t[0][0], t[0][1]) : function(r) {
                return r === n || Ce(r, n, t);
            };
        }
        function Ze(n, t) {
            return Bi(n) && Fi(t) ? Ni(no(n), t) : function(r) {
                var e = Mc(r, n);
                return e === X && e === t ? Nc(r, n) : Se(t, e, hn | pn);
            };
        }
        function Ke(n, t, r, e, u) {
            n !== t && bs(t, function(i, o) {
                if (u || (u = new wr), fc(i)) Ve(n, t, o, r, Ke, e, u);
                else {
                    var f = e ? e(Ji(n, o), i, o + "", n, t, u) : X;
                    f === X && (f = i), Er(n, o, f);
                }
            }, qc);
        }
        function Ve(n, t, r, e, u, i, o) {
            var f = Ji(n, r), c = Ji(t, r), a = o.get(c);
            if (a) return Er(n, r, a), X;
            var l = i ? i(f, c, r + "", n, t, o) : X, s = l === X;
            if (s) {
                var h = bh(c), p = !h && mh(c), _ = !h && !p && Oh(c);
                l = c, h || p || _ ? bh(f) ? l = f : Jf(f) ? l = Tu(f) : p ? (s = !1, l = Iu(c, !0)) : _ ? (s = !1, l = Wu(c, !0)) : l = [] : gc(c) || dh(c) ? (l = f, dh(f) ? l = Rc(f) : fc(f) && !uc(f) || (l = Ei(c))) : s = !1;
            }
            s && (o.set(c, l), u(l, c, e, i, o), o.delete(c)), Er(n, r, l);
        }
        function Ge(n, t) {
            var r = n.length;
            if (r) return t += t < 0 ? r : 0, Ci(t, r) ? n[t] : X;
        }
        function He(n, t, r) {
            t = t.length ? c(t, function(n) {
                return bh(n) ? function(t) {
                    return _e(t, 1 === n.length ? n[0] : n);
                } : n;
            }) : [
                La
            ];
            var e = -1;
            return t = c(t, z(mi())), A(Pe(n, function(n, r, u) {
                return {
                    criteria: c(t, function(t) {
                        return t(n);
                    }),
                    index: ++e,
                    value: n
                };
            }), function(n, t) {
                return Cu(n, t, r);
            });
        }
        function Je(n, t) {
            return Ye(n, t, function(t, r) {
                return Nc(n, r);
            });
        }
        function Ye(n, t, r) {
            for(var e = -1, u = t.length, i = {}; ++e < u;){
                var o = t[e], f = _e(n, o);
                r(f, o) && fu(i, ku(o, n), f);
            }
            return i;
        }
        function Qe(n) {
            return function(t) {
                return _e(t, n);
            };
        }
        function Xe(n, t, r, e) {
            var u = e ? d : y, i = -1, o = t.length, f = n;
            for(n === t && (t = Tu(t)), r && (f = c(n, z(r))); ++i < o;)for(var a = 0, l = t[i], s = r ? r(l) : l; (a = u(f, s, a, e)) > -1;)f !== n && Ll.call(f, a, 1), Ll.call(n, a, 1);
            return n;
        }
        function nu(n, t) {
            for(var r = n ? t.length : 0, e = r - 1; r--;){
                var u = t[r];
                if (r == e || u !== i) {
                    var i = u;
                    Ci(u) ? Ll.call(n, u, 1) : yu(n, u);
                }
            }
            return n;
        }
        function tu(n, t) {
            return n + Nl(Ql() * (t - n + 1));
        }
        function ru(n, t, r, e) {
            for(var u = -1, i = Gl(Fl((t - n) / (r || 1)), 0), o = il(i); i--;)o[e ? i : ++u] = n, n += r;
            return o;
        }
        function eu(n, t) {
            var r = "";
            if (!n || t < 1 || t > Wn) return r;
            do t % 2 && (r += n), t = Nl(t / 2), t && (n += n);
            while (t);
            return r;
        }
        function uu(n, t) {
            return Ls(Vi(n, t, La), n + "");
        }
        function iu(n) {
            return Ir(ra(n));
        }
        function ou(n, t) {
            var r = ra(n);
            return Xi(r, Mr(t, 0, r.length));
        }
        function fu(n, t, r, e) {
            if (!fc(n)) return n;
            t = ku(t, n);
            for(var u = -1, i = t.length, o = i - 1, f = n; null != f && ++u < i;){
                var c = no(t[u]), a = r;
                if ("__proto__" === c || "constructor" === c || "prototype" === c) return n;
                if (u != o) {
                    var l = f[c];
                    a = e ? e(l, c, f) : X, a === X && (a = fc(l) ? l : Ci(t[u + 1]) ? [] : {});
                }
                Sr(f, c, a), f = f[c];
            }
            return n;
        }
        function cu(n) {
            return Xi(ra(n));
        }
        function au(n, t, r) {
            var e = -1, u = n.length;
            t < 0 && (t = -t > u ? 0 : u + t), r = r > u ? u : r, r < 0 && (r += u), u = t > r ? 0 : r - t >>> 0, t >>>= 0;
            for(var i = il(u); ++e < u;)i[e] = n[e + t];
            return i;
        }
        function lu(n, t) {
            var r;
            return ys(n, function(n, e, u) {
                return r = t(n, e, u), !r;
            }), !!r;
        }
        function su(n, t, r) {
            var e = 0, u = null == n ? e : n.length;
            if ("number" == typeof t && t === t && u <= Tn) {
                for(; e < u;){
                    var i = e + u >>> 1, o = n[i];
                    null !== o && !bc(o) && (r ? o <= t : o < t) ? e = i + 1 : u = i;
                }
                return u;
            }
            return hu(n, t, La, r);
        }
        function hu(n, t, r, e) {
            var u = 0, i = null == n ? 0 : n.length;
            if (0 === i) return 0;
            t = r(t);
            for(var o = t !== t, f = null === t, c = bc(t), a = t === X; u < i;){
                var l = Nl((u + i) / 2), s = r(n[l]), h = s !== X, p = null === s, _ = s === s, v = bc(s);
                if (o) var g = e || _;
                else g = a ? _ && (e || h) : f ? _ && h && (e || !p) : c ? _ && h && !p && (e || !v) : !p && !v && (e ? s <= t : s < t);
                g ? u = l + 1 : i = l;
            }
            return Hl(i, Bn);
        }
        function pu(n, t) {
            for(var r = -1, e = n.length, u = 0, i = []; ++r < e;){
                var o = n[r], f = t ? t(o) : o;
                if (!r || !Gf(f, c)) {
                    var c = f;
                    i[u++] = 0 === o ? 0 : o;
                }
            }
            return i;
        }
        function _u(n) {
            return "number" == typeof n ? n : bc(n) ? Cn : +n;
        }
        function vu(n) {
            if ("string" == typeof n) return n;
            if (bh(n)) return c(n, vu) + "";
            if (bc(n)) return vs ? vs.call(n) : "";
            var t = n + "";
            return "0" == t && 1 / n == -Sn ? "-0" : t;
        }
        function gu(n, t, r) {
            var e = -1, u = o, i = n.length, c = !0, a = [], l = a;
            if (r) c = !1, u = f;
            else if (i >= tn) {
                var s = t ? null : ks(n);
                if (s) return P(s);
                c = !1, u = S, l = new yr;
            } else l = t ? [] : a;
            n: for(; ++e < i;){
                var h = n[e], p = t ? t(h) : h;
                if (h = r || 0 !== h ? h : 0, c && p === p) {
                    for(var _ = l.length; _--;)if (l[_] === p) continue n;
                    t && l.push(p), a.push(h);
                } else u(l, p, r) || (l !== a && l.push(p), a.push(h));
            }
            return a;
        }
        function yu(n, t) {
            return t = ku(t, n), n = Gi(n, t), null == n || delete n[no(jo(t))];
        }
        function du(n, t, r, e) {
            return fu(n, t, r(_e(n, t)), e);
        }
        function bu(n, t, r, e) {
            for(var u = n.length, i = e ? u : -1; (e ? i-- : ++i < u) && t(n[i], i, n););
            return r ? au(n, e ? 0 : i, e ? i + 1 : u) : au(n, e ? i + 1 : 0, e ? u : i);
        }
        function wu(n, t) {
            var r = n;
            return r instanceof Ct && (r = r.value()), l(t, function(n, t) {
                return t.func.apply(t.thisArg, a([
                    n
                ], t.args));
            }, r);
        }
        function mu(n, t, r) {
            var e = n.length;
            if (e < 2) return e ? gu(n[0]) : [];
            for(var u = -1, i = il(e); ++u < e;)for(var o = n[u], f = -1; ++f < e;)f != u && (i[u] = Hr(i[u] || o, n[f], t, r));
            return gu(ee(i, 1), t, r);
        }
        function xu(n, t, r) {
            for(var e = -1, u = n.length, i = t.length, o = {}; ++e < u;)r(o, n[e], e < i ? t[e] : X);
            return o;
        }
        function ju(n) {
            return Jf(n) ? n : [];
        }
        function Au(n) {
            return "function" == typeof n ? n : La;
        }
        function ku(n, t) {
            return bh(n) ? n : Bi(n, t) ? [
                n
            ] : Cs(Ec(n));
        }
        function Ou(n, t, r) {
            var e = n.length;
            return r = r === X ? e : r, !t && r >= e ? n : au(n, t, r);
        }
        function Iu(n, t) {
            if (t) return n.slice();
            var r = n.length, e = zl ? zl(r) : new n.constructor(r);
            return n.copy(e), e;
        }
        function Ru(n) {
            var t = new n.constructor(n.byteLength);
            return new Rl(t).set(new Rl(n)), t;
        }
        function zu(n, t) {
            return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.byteLength);
        }
        function Eu(n) {
            var t = new n.constructor(n.source, Nt.exec(n));
            return t.lastIndex = n.lastIndex, t;
        }
        function Su(n) {
            return _s ? ll(_s.call(n)) : {};
        }
        function Wu(n, t) {
            return new n.constructor(t ? Ru(n.buffer) : n.buffer, n.byteOffset, n.length);
        }
        function Lu(n, t) {
            if (n !== t) {
                var r = n !== X, e = null === n, u = n === n, i = bc(n), o = t !== X, f = null === t, c = t === t, a = bc(t);
                if (!f && !a && !i && n > t || i && o && c && !f && !a || e && o && c || !r && c || !u) return 1;
                if (!e && !i && !a && n < t || a && r && u && !e && !i || f && r && u || !o && u || !c) return -1;
            }
            return 0;
        }
        function Cu(n, t, r) {
            for(var e = -1, u = n.criteria, i = t.criteria, o = u.length, f = r.length; ++e < o;){
                var c = Lu(u[e], i[e]);
                if (c) {
                    if (e >= f) return c;
                    return c * ("desc" == r[e] ? -1 : 1);
                }
            }
            return n.index - t.index;
        }
        function Uu(n, t, r, e) {
            for(var u = -1, i = n.length, o = r.length, f = -1, c = t.length, a = Gl(i - o, 0), l = il(c + a), s = !e; ++f < c;)l[f] = t[f];
            for(; ++u < o;)(s || u < i) && (l[r[u]] = n[u]);
            for(; a--;)l[f++] = n[u++];
            return l;
        }
        function Bu(n, t, r, e) {
            for(var u = -1, i = n.length, o = -1, f = r.length, c = -1, a = t.length, l = Gl(i - f, 0), s = il(l + a), h = !e; ++u < l;)s[u] = n[u];
            for(var p = u; ++c < a;)s[p + c] = t[c];
            for(; ++o < f;)(h || u < i) && (s[p + r[o]] = n[u++]);
            return s;
        }
        function Tu(n, t) {
            var r = -1, e = n.length;
            for(t || (t = il(e)); ++r < e;)t[r] = n[r];
            return t;
        }
        function $u(n, t, r, e) {
            var u = !r;
            r || (r = {});
            for(var i = -1, o = t.length; ++i < o;){
                var f = t[i], c = e ? e(r[f], n[f], f, r, n) : X;
                c === X && (c = n[f]), u ? Br(r, f, c) : Sr(r, f, c);
            }
            return r;
        }
        function Du(n, t) {
            return $u(n, Is(n), t);
        }
        function Mu(n, t) {
            return $u(n, Rs(n), t);
        }
        function Fu(n, r) {
            return function(e, u) {
                var i = bh(e) ? t : Lr, o = r ? r() : {};
                return i(e, n, mi(u, 2), o);
            };
        }
        function Nu(n) {
            return uu(function(t, r) {
                var e = -1, u = r.length, i = u > 1 ? r[u - 1] : X, o = u > 2 ? r[2] : X;
                for(i = n.length > 3 && "function" == typeof i ? (u--, i) : X, o && Ui(r[0], r[1], o) && (i = u < 3 ? X : i, u = 1), t = ll(t); ++e < u;){
                    var f = r[e];
                    f && n(t, f, e, i);
                }
                return t;
            });
        }
        function Pu(n, t) {
            return function(r, e) {
                if (null == r) return r;
                if (!Hf(r)) return n(r, e);
                for(var u = r.length, i = t ? u : -1, o = ll(r); (t ? i-- : ++i < u) && e(o[i], i, o) !== !1;);
                return r;
            };
        }
        function qu(n) {
            return function(t, r, e) {
                for(var u = -1, i = ll(t), o = e(t), f = o.length; f--;){
                    var c = o[n ? f : ++u];
                    if (r(i[c], c, i) === !1) break;
                }
                return t;
            };
        }
        function Zu(n, t, r) {
            function e() {
                return (this && this !== re && this instanceof e ? i : n).apply(u ? r : this, arguments);
            }
            var u = t & _n, i = Gu(n);
            return e;
        }
        function Ku(n) {
            return function(t) {
                t = Ec(t);
                var r = T(t) ? G(t) : X, e = r ? r[0] : t.charAt(0), u = r ? Ou(r, 1).join("") : t.slice(1);
                return e[n]() + u;
            };
        }
        function Vu(n) {
            return function(t) {
                return l(Ra(ca(t).replace($r, "")), n, "");
            };
        }
        function Gu(n) {
            return function() {
                var t = arguments;
                switch(t.length){
                    case 0:
                        return new n;
                    case 1:
                        return new n(t[0]);
                    case 2:
                        return new n(t[0], t[1]);
                    case 3:
                        return new n(t[0], t[1], t[2]);
                    case 4:
                        return new n(t[0], t[1], t[2], t[3]);
                    case 5:
                        return new n(t[0], t[1], t[2], t[3], t[4]);
                    case 6:
                        return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                    case 7:
                        return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                }
                var r = gs(n.prototype), e = n.apply(r, t);
                return fc(e) ? e : r;
            };
        }
        function Hu(t, r, e) {
            function u() {
                for(var o = arguments.length, f = il(o), c = o, a = wi(u); c--;)f[c] = arguments[c];
                var l = o < 3 && f[0] !== a && f[o - 1] !== a ? [] : N(f, a);
                return o -= l.length, o < e ? oi(t, r, Qu, u.placeholder, X, f, l, X, X, e - o) : n(this && this !== re && this instanceof u ? i : t, this, f);
            }
            var i = Gu(t);
            return u;
        }
        function Ju(n) {
            return function(t, r, e) {
                var u = ll(t);
                if (!Hf(t)) {
                    var i = mi(r, 3);
                    t = Pc(t), r = function(n) {
                        return i(u[n], n, u);
                    };
                }
                var o = n(t, r, e);
                return o > -1 ? u[i ? t[o] : o] : X;
            };
        }
        function Yu(n) {
            return gi(function(t) {
                var r = t.length, e = r, u = Y.prototype.thru;
                for(n && t.reverse(); e--;){
                    var i = t[e];
                    if ("function" != typeof i) throw new pl(en);
                    if (u && !o && "wrapper" == bi(i)) var o = new Y([], !0);
                }
                for(e = o ? e : r; ++e < r;){
                    i = t[e];
                    var f = bi(i), c = "wrapper" == f ? Os(i) : X;
                    o = c && $i(c[0]) && c[1] == (mn | yn | bn | xn) && !c[4].length && 1 == c[9] ? o[bi(c[0])].apply(o, c[3]) : 1 == i.length && $i(i) ? o[f]() : o.thru(i);
                }
                return function() {
                    var n = arguments, e = n[0];
                    if (o && 1 == n.length && bh(e)) return o.plant(e).value();
                    for(var u = 0, i = r ? t[u].apply(this, n) : e; ++u < r;)i = t[u].call(this, i);
                    return i;
                };
            });
        }
        function Qu(n, t, r, e, u, i, o, f, c, a) {
            function l() {
                for(var y = arguments.length, d = il(y), b = y; b--;)d[b] = arguments[b];
                if (_) var w = wi(l), m = C(d, w);
                if (e && (d = Uu(d, e, u, _)), i && (d = Bu(d, i, o, _)), y -= m, _ && y < a) return oi(n, t, Qu, l.placeholder, r, d, N(d, w), f, c, a - y);
                var x = h ? r : this, j = p ? x[n] : n;
                return y = d.length, f ? d = Hi(d, f) : v && y > 1 && d.reverse(), s && c < y && (d.length = c), this && this !== re && this instanceof l && (j = g || Gu(j)), j.apply(x, d);
            }
            var s = t & mn, h = t & _n, p = t & vn, _ = t & (yn | dn), v = t & jn, g = p ? X : Gu(n);
            return l;
        }
        function Xu(n, t) {
            return function(r, e) {
                return Oe(r, n, t(e), {});
            };
        }
        function ni(n, t) {
            return function(r, e) {
                var u;
                if (r === X && e === X) return t;
                if (r !== X && (u = r), e !== X) {
                    if (u === X) return e;
                    "string" == typeof r || "string" == typeof e ? (r = vu(r), e = vu(e)) : (r = _u(r), e = _u(e)), u = n(r, e);
                }
                return u;
            };
        }
        function ti(t) {
            return gi(function(r) {
                return r = c(r, z(mi())), uu(function(e) {
                    var u = this;
                    return t(r, function(t) {
                        return n(t, u, e);
                    });
                });
            });
        }
        function ri(n, t) {
            t = t === X ? " " : vu(t);
            var r = t.length;
            if (r < 2) return r ? eu(t, n) : t;
            var e = eu(t, Fl(n / V(t)));
            return T(t) ? Ou(G(e), 0, n).join("") : e.slice(0, n);
        }
        function ei(t, r, e, u) {
            function i() {
                for(var r = -1, c = arguments.length, a = -1, l = u.length, s = il(l + c), h = this && this !== re && this instanceof i ? f : t; ++a < l;)s[a] = u[a];
                for(; c--;)s[a++] = arguments[++r];
                return n(h, o ? e : this, s);
            }
            var o = r & _n, f = Gu(t);
            return i;
        }
        function ui(n) {
            return function(t, r, e) {
                return e && "number" != typeof e && Ui(t, r, e) && (r = e = X), t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), e = e === X ? t < r ? 1 : -1 : Ac(e), ru(t, r, e, n);
            };
        }
        function ii(n) {
            return function(t, r) {
                return "string" == typeof t && "string" == typeof r || (t = Ic(t), r = Ic(r)), n(t, r);
            };
        }
        function oi(n, t, r, e, u, i, o, f, c, a) {
            var l = t & yn, s = l ? o : X, h = l ? X : o, p = l ? i : X, _ = l ? X : i;
            t |= l ? bn : wn, t &= ~(l ? wn : bn), t & gn || (t &= ~(_n | vn));
            var v = [
                n,
                t,
                u,
                p,
                s,
                _,
                h,
                f,
                c,
                a
            ], g = r.apply(X, v);
            return $i(n) && Ss(g, v), g.placeholder = e, Yi(g, n, t);
        }
        function fi(n) {
            var t = al[n];
            return function(n, r) {
                if (n = Ic(n), r = null == r ? 0 : Hl(kc(r), 292), r && Zl(n)) {
                    var e = (Ec(n) + "e").split("e");
                    return e = (Ec(t(e[0] + "e" + (+e[1] + r))) + "e").split("e"), +(e[0] + "e" + (+e[1] - r));
                }
                return t(n);
            };
        }
        function ci(n) {
            return function(t) {
                var r = zs(t);
                return r == Gn ? M(t) : r == tt ? q(t) : I(t, n(t));
            };
        }
        function ai(n, t, r, e, u, i, o, f) {
            var c = t & vn;
            if (!c && "function" != typeof n) throw new pl(en);
            var a = e ? e.length : 0;
            if (a || (t &= ~(bn | wn), e = u = X), o = o === X ? o : Gl(kc(o), 0), f = f === X ? f : kc(f), a -= u ? u.length : 0, t & wn) {
                var l = e, s = u;
                e = u = X;
            }
            var h = c ? X : Os(n), p = [
                n,
                t,
                r,
                e,
                u,
                l,
                s,
                i,
                o,
                f
            ];
            if (h && qi(p, h), n = p[0], t = p[1], r = p[2], e = p[3], u = p[4], f = p[9] = p[9] === X ? c ? 0 : n.length : Gl(p[9] - a, 0), !f && t & (yn | dn) && (t &= ~(yn | dn)), t && t != _n) _ = t == yn || t == dn ? Hu(n, t, f) : t != bn && t != (_n | bn) || u.length ? Qu.apply(X, p) : ei(n, t, r, e);
            else var _ = Zu(n, t, r);
            return Yi((h ? ms : Ss)(_, p), n, t);
        }
        function li(n, t, r, e) {
            return n === X || Gf(n, gl[r]) && !bl.call(e, r) ? t : n;
        }
        function si(n, t, r, e, u, i) {
            return fc(n) && fc(t) && (i.set(t, n), Ke(n, t, X, si, i), i.delete(t)), n;
        }
        function hi(n) {
            return gc(n) ? X : n;
        }
        function pi(n, t, r, e, u, i) {
            var o = r & hn, f = n.length, c = t.length;
            if (f != c && !(o && c > f)) return !1;
            var a = i.get(n), l = i.get(t);
            if (a && l) return a == t && l == n;
            var s = -1, p = !0, _ = r & pn ? new yr : X;
            for(i.set(n, t), i.set(t, n); ++s < f;){
                var v = n[s], g = t[s];
                if (e) var y = o ? e(g, v, s, t, n, i) : e(v, g, s, n, t, i);
                if (y !== X) {
                    if (y) continue;
                    p = !1;
                    break;
                }
                if (_) {
                    if (!h(t, function(n, t) {
                        if (!S(_, t) && (v === n || u(v, n, r, e, i))) return _.push(t);
                    })) {
                        p = !1;
                        break;
                    }
                } else if (v !== g && !u(v, g, r, e, i)) {
                    p = !1;
                    break;
                }
            }
            return i.delete(n), i.delete(t), p;
        }
        function _i(n, t, r, e, u, i, o) {
            switch(r){
                case ct:
                    if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                    n = n.buffer, t = t.buffer;
                case ft:
                    return !(n.byteLength != t.byteLength || !i(new Rl(n), new Rl(t)));
                case Nn:
                case Pn:
                case Hn:
                    return Gf(+n, +t);
                case Zn:
                    return n.name == t.name && n.message == t.message;
                case nt:
                case rt:
                    return n == t + "";
                case Gn:
                    var f = M;
                case tt:
                    var c = e & hn;
                    if (f || (f = P), n.size != t.size && !c) return !1;
                    var a = o.get(n);
                    if (a) return a == t;
                    e |= pn, o.set(n, t);
                    var l = pi(f(n), f(t), e, u, i, o);
                    return o.delete(n), l;
                case et:
                    if (_s) return _s.call(n) == _s.call(t);
            }
            return !1;
        }
        function vi(n, t, r, e, u, i) {
            var o = r & hn, f = yi(n), c = f.length;
            if (c != yi(t).length && !o) return !1;
            for(var a = c; a--;){
                var l = f[a];
                if (!(o ? l in t : bl.call(t, l))) return !1;
            }
            var s = i.get(n), h = i.get(t);
            if (s && h) return s == t && h == n;
            var p = !0;
            i.set(n, t), i.set(t, n);
            for(var _ = o; ++a < c;){
                l = f[a];
                var v = n[l], g = t[l];
                if (e) var y = o ? e(g, v, l, t, n, i) : e(v, g, l, n, t, i);
                if (!(y === X ? v === g || u(v, g, r, e, i) : y)) {
                    p = !1;
                    break;
                }
                _ || (_ = "constructor" == l);
            }
            if (p && !_) {
                var d = n.constructor, b = t.constructor;
                d != b && "constructor" in n && "constructor" in t && !("function" == typeof d && d instanceof d && "function" == typeof b && b instanceof b) && (p = !1);
            }
            return i.delete(n), i.delete(t), p;
        }
        function gi(n) {
            return Ls(Vi(n, X, _o), n + "");
        }
        function yi(n) {
            return de(n, Pc, Is);
        }
        function di(n) {
            return de(n, qc, Rs);
        }
        function bi(n) {
            for(var t = n.name + "", r = fs[t], e = bl.call(fs, t) ? r.length : 0; e--;){
                var u = r[e], i = u.func;
                if (null == i || i == n) return u.name;
            }
            return t;
        }
        function wi(n) {
            return (bl.call(Z, "placeholder") ? Z : n).placeholder;
        }
        function mi() {
            var n = Z.iteratee || Ca;
            return n = n === Ca ? De : n, arguments.length ? n(arguments[0], arguments[1]) : n;
        }
        function xi(n, t) {
            var r = n.__data__;
            return Ti(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
        }
        function ji(n) {
            for(var t = Pc(n), r = t.length; r--;){
                var e = t[r], u = n[e];
                t[r] = [
                    e,
                    u,
                    Fi(u)
                ];
            }
            return t;
        }
        function Ai(n, t) {
            var r = B(n, t);
            return Ue(r) ? r : X;
        }
        function ki(n) {
            var t = bl.call(n, Bl), r = n[Bl];
            try {
                n[Bl] = X;
                var e = !0;
            } catch (n) {}
            var u = xl.call(n);
            return e && (t ? n[Bl] = r : delete n[Bl]), u;
        }
        function Oi(n, t, r) {
            for(var e = -1, u = r.length; ++e < u;){
                var i = r[e], o = i.size;
                switch(i.type){
                    case "drop":
                        n += o;
                        break;
                    case "dropRight":
                        t -= o;
                        break;
                    case "take":
                        t = Hl(t, n + o);
                        break;
                    case "takeRight":
                        n = Gl(n, t - o);
                }
            }
            return {
                start: n,
                end: t
            };
        }
        function Ii(n) {
            var t = n.match(Bt);
            return t ? t[1].split(Tt) : [];
        }
        function Ri(n, t, r) {
            t = ku(t, n);
            for(var e = -1, u = t.length, i = !1; ++e < u;){
                var o = no(t[e]);
                if (!(i = null != n && r(n, o))) break;
                n = n[o];
            }
            return i || ++e != u ? i : (u = null == n ? 0 : n.length, !!u && oc(u) && Ci(o, u) && (bh(n) || dh(n)));
        }
        function zi(n) {
            var t = n.length, r = new n.constructor(t);
            return t && "string" == typeof n[0] && bl.call(n, "index") && (r.index = n.index, r.input = n.input), r;
        }
        function Ei(n) {
            return "function" != typeof n.constructor || Mi(n) ? {} : gs(El(n));
        }
        function Si(n, t, r) {
            var e = n.constructor;
            switch(t){
                case ft:
                    return Ru(n);
                case Nn:
                case Pn:
                    return new e(+n);
                case ct:
                    return zu(n, r);
                case at:
                case lt:
                case st:
                case ht:
                case pt:
                case _t:
                case vt:
                case gt:
                case yt:
                    return Wu(n, r);
                case Gn:
                    return new e;
                case Hn:
                case rt:
                    return new e(n);
                case nt:
                    return Eu(n);
                case tt:
                    return new e;
                case et:
                    return Su(n);
            }
        }
        function Wi(n, t) {
            var r = t.length;
            if (!r) return n;
            var e = r - 1;
            return t[e] = (r > 1 ? "& " : "") + t[e], t = t.join(r > 2 ? ", " : " "), n.replace(Ut, "{\n/* [wrapped with " + t + "] */\n");
        }
        function Li(n) {
            return bh(n) || dh(n) || !!(Cl && n && n[Cl]);
        }
        function Ci(n, t) {
            var r = typeof n;
            return t = null == t ? Wn : t, !!t && ("number" == r || "symbol" != r && Vt.test(n)) && n > -1 && n % 1 == 0 && n < t;
        }
        function Ui(n, t, r) {
            if (!fc(r)) return !1;
            var e = typeof t;
            return !!("number" == e ? Hf(r) && Ci(t, r.length) : "string" == e && t in r) && Gf(r[t], n);
        }
        function Bi(n, t) {
            if (bh(n)) return !1;
            var r = typeof n;
            return !("number" != r && "symbol" != r && "boolean" != r && null != n && !bc(n)) || zt.test(n) || !Rt.test(n) || null != t && n in ll(t);
        }
        function Ti(n) {
            var t = typeof n;
            return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== n : null === n;
        }
        function $i(n) {
            var t = bi(n), r = Z[t];
            if ("function" != typeof r || !(t in Ct.prototype)) return !1;
            if (n === r) return !0;
            var e = Os(r);
            return !!e && n === e[0];
        }
        function Di(n) {
            return !!ml && ml in n;
        }
        function Mi(n) {
            var t = n && n.constructor;
            return n === ("function" == typeof t && t.prototype || gl);
        }
        function Fi(n) {
            return n === n && !fc(n);
        }
        function Ni(n, t) {
            return function(r) {
                return null != r && r[n] === t && (t !== X || n in ll(r));
            };
        }
        function Pi(n) {
            var t = Cf(n, function(n) {
                return r.size === fn && r.clear(), n;
            }), r = t.cache;
            return t;
        }
        function qi(n, t) {
            var r = n[1], e = t[1], u = r | e, i = u < (_n | vn | mn), o = e == mn && r == yn || e == mn && r == xn && n[7].length <= t[8] || e == (mn | xn) && t[7].length <= t[8] && r == yn;
            if (!i && !o) return n;
            e & _n && (n[2] = t[2], u |= r & _n ? 0 : gn);
            var f = t[3];
            if (f) {
                var c = n[3];
                n[3] = c ? Uu(c, f, t[4]) : f, n[4] = c ? N(n[3], cn) : t[4];
            }
            return f = t[5], f && (c = n[5], n[5] = c ? Bu(c, f, t[6]) : f, n[6] = c ? N(n[5], cn) : t[6]), f = t[7], f && (n[7] = f), e & mn && (n[8] = null == n[8] ? t[8] : Hl(n[8], t[8])), null == n[9] && (n[9] = t[9]), n[0] = t[0], n[1] = u, n;
        }
        function Zi(n) {
            var t = [];
            if (null != n) for(var r in ll(n))t.push(r);
            return t;
        }
        function Ki(n) {
            return xl.call(n);
        }
        function Vi(t, r, e) {
            return r = Gl(r === X ? t.length - 1 : r, 0), function() {
                for(var u = arguments, i = -1, o = Gl(u.length - r, 0), f = il(o); ++i < o;)f[i] = u[r + i];
                i = -1;
                for(var c = il(r + 1); ++i < r;)c[i] = u[i];
                return c[r] = e(f), n(t, this, c);
            };
        }
        function Gi(n, t) {
            return t.length < 2 ? n : _e(n, au(t, 0, -1));
        }
        function Hi(n, t) {
            for(var r = n.length, e = Hl(t.length, r), u = Tu(n); e--;){
                var i = t[e];
                n[e] = Ci(i, r) ? u[i] : X;
            }
            return n;
        }
        function Ji(n, t) {
            if (("constructor" !== t || "function" != typeof n[t]) && "__proto__" != t) return n[t];
        }
        function Yi(n, t, r) {
            var e = t + "";
            return Ls(n, Wi(e, ro(Ii(e), r)));
        }
        function Qi(n) {
            var t = 0, r = 0;
            return function() {
                var e = Jl(), u = In - (e - r);
                if (r = e, u > 0) {
                    if (++t >= On) return arguments[0];
                } else t = 0;
                return n.apply(X, arguments);
            };
        }
        function Xi(n, t) {
            var r = -1, e = n.length, u = e - 1;
            for(t = t === X ? e : t; ++r < t;){
                var i = tu(r, u), o = n[i];
                n[i] = n[r], n[r] = o;
            }
            return n.length = t, n;
        }
        function no(n) {
            if ("string" == typeof n || bc(n)) return n;
            var t = n + "";
            return "0" == t && 1 / n == -Sn ? "-0" : t;
        }
        function to(n) {
            if (null != n) {
                try {
                    return dl.call(n);
                } catch (n) {}
                try {
                    return n + "";
                } catch (n) {}
            }
            return "";
        }
        function ro(n, t) {
            return r($n, function(r) {
                var e = "_." + r[0];
                t & r[1] && !o(n, e) && n.push(e);
            }), n.sort();
        }
        function eo(n) {
            if (n instanceof Ct) return n.clone();
            var t = new Y(n.__wrapped__, n.__chain__);
            return t.__actions__ = Tu(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
        }
        function uo(n, t, r) {
            t = (r ? Ui(n, t, r) : t === X) ? 1 : Gl(kc(t), 0);
            var e = null == n ? 0 : n.length;
            if (!e || t < 1) return [];
            for(var u = 0, i = 0, o = il(Fl(e / t)); u < e;)o[i++] = au(n, u, u += t);
            return o;
        }
        function io(n) {
            for(var t = -1, r = null == n ? 0 : n.length, e = 0, u = []; ++t < r;){
                var i = n[t];
                i && (u[e++] = i);
            }
            return u;
        }
        function oo() {
            var n = arguments.length;
            if (!n) return [];
            for(var t = il(n - 1), r = arguments[0], e = n; e--;)t[e - 1] = arguments[e];
            return a(bh(r) ? Tu(r) : [
                r
            ], ee(t, 1));
        }
        function fo(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), au(n, t < 0 ? 0 : t, e)) : [];
        }
        function co(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, 0, t < 0 ? 0 : t)) : [];
        }
        function ao(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !0, !0) : [];
        }
        function lo(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !0) : [];
        }
        function so(n, t, r, e) {
            var u = null == n ? 0 : n.length;
            return u ? (r && "number" != typeof r && Ui(n, t, r) && (r = 0, e = u), ne(n, t, r, e)) : [];
        }
        function ho(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = null == r ? 0 : kc(r);
            return u < 0 && (u = Gl(e + u, 0)), g(n, mi(t, 3), u);
        }
        function po(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = e - 1;
            return r !== X && (u = kc(r), u = r < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), g(n, mi(t, 3), u, !0);
        }
        function _o(n) {
            return (null == n ? 0 : n.length) ? ee(n, 1) : [];
        }
        function vo(n) {
            return (null == n ? 0 : n.length) ? ee(n, Sn) : [];
        }
        function go(n, t) {
            return (null == n ? 0 : n.length) ? (t = t === X ? 1 : kc(t), ee(n, t)) : [];
        }
        function yo(n) {
            for(var t = -1, r = null == n ? 0 : n.length, e = {}; ++t < r;){
                var u = n[t];
                e[u[0]] = u[1];
            }
            return e;
        }
        function bo(n) {
            return n && n.length ? n[0] : X;
        }
        function wo(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = null == r ? 0 : kc(r);
            return u < 0 && (u = Gl(e + u, 0)), y(n, t, u);
        }
        function mo(n) {
            return (null == n ? 0 : n.length) ? au(n, 0, -1) : [];
        }
        function xo(n, t) {
            return null == n ? "" : Kl.call(n, t);
        }
        function jo(n) {
            var t = null == n ? 0 : n.length;
            return t ? n[t - 1] : X;
        }
        function Ao(n, t, r) {
            var e = null == n ? 0 : n.length;
            if (!e) return -1;
            var u = e;
            return r !== X && (u = kc(r), u = u < 0 ? Gl(e + u, 0) : Hl(u, e - 1)), t === t ? K(n, t, u) : g(n, b, u, !0);
        }
        function ko(n, t) {
            return n && n.length ? Ge(n, kc(t)) : X;
        }
        function Oo(n, t) {
            return n && n.length && t && t.length ? Xe(n, t) : n;
        }
        function Io(n, t, r) {
            return n && n.length && t && t.length ? Xe(n, t, mi(r, 2)) : n;
        }
        function Ro(n, t, r) {
            return n && n.length && t && t.length ? Xe(n, t, X, r) : n;
        }
        function zo(n, t) {
            var r = [];
            if (!n || !n.length) return r;
            var e = -1, u = [], i = n.length;
            for(t = mi(t, 3); ++e < i;){
                var o = n[e];
                t(o, e, n) && (r.push(o), u.push(e));
            }
            return nu(n, u), r;
        }
        function Eo(n) {
            return null == n ? n : Xl.call(n);
        }
        function So(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (r && "number" != typeof r && Ui(n, t, r) ? (t = 0, r = e) : (t = null == t ? 0 : kc(t), r = r === X ? e : kc(r)), au(n, t, r)) : [];
        }
        function Wo(n, t) {
            return su(n, t);
        }
        function Lo(n, t, r) {
            return hu(n, t, mi(r, 2));
        }
        function Co(n, t) {
            var r = null == n ? 0 : n.length;
            if (r) {
                var e = su(n, t);
                if (e < r && Gf(n[e], t)) return e;
            }
            return -1;
        }
        function Uo(n, t) {
            return su(n, t, !0);
        }
        function Bo(n, t, r) {
            return hu(n, t, mi(r, 2), !0);
        }
        function To(n, t) {
            if (null == n ? 0 : n.length) {
                var r = su(n, t, !0) - 1;
                if (Gf(n[r], t)) return r;
            }
            return -1;
        }
        function $o(n) {
            return n && n.length ? pu(n) : [];
        }
        function Do(n, t) {
            return n && n.length ? pu(n, mi(t, 2)) : [];
        }
        function Mo(n) {
            var t = null == n ? 0 : n.length;
            return t ? au(n, 1, t) : [];
        }
        function Fo(n, t, r) {
            return n && n.length ? (t = r || t === X ? 1 : kc(t), au(n, 0, t < 0 ? 0 : t)) : [];
        }
        function No(n, t, r) {
            var e = null == n ? 0 : n.length;
            return e ? (t = r || t === X ? 1 : kc(t), t = e - t, au(n, t < 0 ? 0 : t, e)) : [];
        }
        function Po(n, t) {
            return n && n.length ? bu(n, mi(t, 3), !1, !0) : [];
        }
        function qo(n, t) {
            return n && n.length ? bu(n, mi(t, 3)) : [];
        }
        function Zo(n) {
            return n && n.length ? gu(n) : [];
        }
        function Ko(n, t) {
            return n && n.length ? gu(n, mi(t, 2)) : [];
        }
        function Vo(n, t) {
            return t = "function" == typeof t ? t : X, n && n.length ? gu(n, X, t) : [];
        }
        function Go(n) {
            if (!n || !n.length) return [];
            var t = 0;
            return n = i(n, function(n) {
                if (Jf(n)) return t = Gl(n.length, t), !0;
            }), O(t, function(t) {
                return c(n, m(t));
            });
        }
        function Ho(t, r) {
            if (!t || !t.length) return [];
            var e = Go(t);
            return null == r ? e : c(e, function(t) {
                return n(r, X, t);
            });
        }
        function Jo(n, t) {
            return xu(n || [], t || [], Sr);
        }
        function Yo(n, t) {
            return xu(n || [], t || [], fu);
        }
        function Qo(n) {
            var t = Z(n);
            return t.__chain__ = !0, t;
        }
        function Xo(n, t) {
            return t(n), n;
        }
        function nf(n, t) {
            return t(n);
        }
        function tf() {
            return Qo(this);
        }
        function rf() {
            return new Y(this.value(), this.__chain__);
        }
        function ef() {
            this.__values__ === X && (this.__values__ = jc(this.value()));
            var n = this.__index__ >= this.__values__.length;
            return {
                done: n,
                value: n ? X : this.__values__[this.__index__++]
            };
        }
        function uf() {
            return this;
        }
        function of(n) {
            for(var t, r = this; r instanceof J;){
                var e = eo(r);
                e.__index__ = 0, e.__values__ = X, t ? u.__wrapped__ = e : t = e;
                var u = e;
                r = r.__wrapped__;
            }
            return u.__wrapped__ = n, t;
        }
        function ff() {
            var n = this.__wrapped__;
            if (n instanceof Ct) {
                var t = n;
                return this.__actions__.length && (t = new Ct(this)), t = t.reverse(), t.__actions__.push({
                    func: nf,
                    args: [
                        Eo
                    ],
                    thisArg: X
                }), new Y(t, this.__chain__);
            }
            return this.thru(Eo);
        }
        function cf() {
            return wu(this.__wrapped__, this.__actions__);
        }
        function af(n, t, r) {
            var e = bh(n) ? u : Jr;
            return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
        }
        function lf(n, t) {
            return (bh(n) ? i : te)(n, mi(t, 3));
        }
        function sf(n, t) {
            return ee(yf(n, t), 1);
        }
        function hf(n, t) {
            return ee(yf(n, t), Sn);
        }
        function pf(n, t, r) {
            return r = r === X ? 1 : kc(r), ee(yf(n, t), r);
        }
        function _f(n, t) {
            return (bh(n) ? r : ys)(n, mi(t, 3));
        }
        function vf(n, t) {
            return (bh(n) ? e : ds)(n, mi(t, 3));
        }
        function gf(n, t, r, e) {
            n = Hf(n) ? n : ra(n), r = r && !e ? kc(r) : 0;
            var u = n.length;
            return r < 0 && (r = Gl(u + r, 0)), dc(n) ? r <= u && n.indexOf(t, r) > -1 : !!u && y(n, t, r) > -1;
        }
        function yf(n, t) {
            return (bh(n) ? c : Pe)(n, mi(t, 3));
        }
        function df(n, t, r, e) {
            return null == n ? [] : (bh(t) || (t = null == t ? [] : [
                t
            ]), r = e ? X : r, bh(r) || (r = null == r ? [] : [
                r
            ]), He(n, t, r));
        }
        function bf(n, t, r) {
            var e = bh(n) ? l : j, u = arguments.length < 3;
            return e(n, mi(t, 4), r, u, ys);
        }
        function wf(n, t, r) {
            var e = bh(n) ? s : j, u = arguments.length < 3;
            return e(n, mi(t, 4), r, u, ds);
        }
        function mf(n, t) {
            return (bh(n) ? i : te)(n, Uf(mi(t, 3)));
        }
        function xf(n) {
            return (bh(n) ? Ir : iu)(n);
        }
        function jf(n, t, r) {
            return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), (bh(n) ? Rr : ou)(n, t);
        }
        function Af(n) {
            return (bh(n) ? zr : cu)(n);
        }
        function kf(n) {
            if (null == n) return 0;
            if (Hf(n)) return dc(n) ? V(n) : n.length;
            var t = zs(n);
            return t == Gn || t == tt ? n.size : Me(n).length;
        }
        function Of(n, t, r) {
            var e = bh(n) ? h : lu;
            return r && Ui(n, t, r) && (t = X), e(n, mi(t, 3));
        }
        function If(n, t) {
            if ("function" != typeof t) throw new pl(en);
            return n = kc(n), function() {
                if (--n < 1) return t.apply(this, arguments);
            };
        }
        function Rf(n, t, r) {
            return t = r ? X : t, t = n && null == t ? n.length : t, ai(n, mn, X, X, X, X, t);
        }
        function zf(n, t) {
            var r;
            if ("function" != typeof t) throw new pl(en);
            return n = kc(n), function() {
                return --n > 0 && (r = t.apply(this, arguments)), n <= 1 && (t = X), r;
            };
        }
        function Ef(n, t, r) {
            t = r ? X : t;
            var e = ai(n, yn, X, X, X, X, X, t);
            return e.placeholder = Ef.placeholder, e;
        }
        function Sf(n, t, r) {
            t = r ? X : t;
            var e = ai(n, dn, X, X, X, X, X, t);
            return e.placeholder = Sf.placeholder, e;
        }
        function Wf(n, t, r) {
            function e(t) {
                var r = h, e = p;
                return h = p = X, d = t, v = n.apply(e, r);
            }
            function u(n) {
                return d = n, g = Ws(f, t), b ? e(n) : v;
            }
            function i(n) {
                var r = n - y, e = n - d, u = t - r;
                return w ? Hl(u, _ - e) : u;
            }
            function o(n) {
                var r = n - y, e = n - d;
                return y === X || r >= t || r < 0 || w && e >= _;
            }
            function f() {
                var n = fh();
                return o(n) ? c(n) : (g = Ws(f, i(n)), X);
            }
            function c(n) {
                return g = X, m && h ? e(n) : (h = p = X, v);
            }
            function a() {
                g !== X && As(g), d = 0, h = y = p = g = X;
            }
            function l() {
                return g === X ? v : c(fh());
            }
            function s() {
                var n = fh(), r = o(n);
                if (h = arguments, p = this, y = n, r) {
                    if (g === X) return u(y);
                    if (w) return As(g), g = Ws(f, t), e(y);
                }
                return g === X && (g = Ws(f, t)), v;
            }
            var h, p, _, v, g, y, d = 0, b = !1, w = !1, m = !0;
            if ("function" != typeof n) throw new pl(en);
            return t = Ic(t) || 0, fc(r) && (b = !!r.leading, w = "maxWait" in r, _ = w ? Gl(Ic(r.maxWait) || 0, t) : _, m = "trailing" in r ? !!r.trailing : m), s.cancel = a, s.flush = l, s;
        }
        function Lf(n) {
            return ai(n, jn);
        }
        function Cf(n, t) {
            if ("function" != typeof n || null != t && "function" != typeof t) throw new pl(en);
            var r = function() {
                var e = arguments, u = t ? t.apply(this, e) : e[0], i = r.cache;
                if (i.has(u)) return i.get(u);
                var o = n.apply(this, e);
                return r.cache = i.set(u, o) || i, o;
            };
            return r.cache = new (Cf.Cache || sr), r;
        }
        function Uf(n) {
            if ("function" != typeof n) throw new pl(en);
            return function() {
                var t = arguments;
                switch(t.length){
                    case 0:
                        return !n.call(this);
                    case 1:
                        return !n.call(this, t[0]);
                    case 2:
                        return !n.call(this, t[0], t[1]);
                    case 3:
                        return !n.call(this, t[0], t[1], t[2]);
                }
                return !n.apply(this, t);
            };
        }
        function Bf(n) {
            return zf(2, n);
        }
        function Tf(n, t) {
            if ("function" != typeof n) throw new pl(en);
            return t = t === X ? t : kc(t), uu(n, t);
        }
        function $f(t, r) {
            if ("function" != typeof t) throw new pl(en);
            return r = null == r ? 0 : Gl(kc(r), 0), uu(function(e) {
                var u = e[r], i = Ou(e, 0, r);
                return u && a(i, u), n(t, this, i);
            });
        }
        function Df(n, t, r) {
            var e = !0, u = !0;
            if ("function" != typeof n) throw new pl(en);
            return fc(r) && (e = "leading" in r ? !!r.leading : e, u = "trailing" in r ? !!r.trailing : u), Wf(n, t, {
                leading: e,
                maxWait: t,
                trailing: u
            });
        }
        function Mf(n) {
            return Rf(n, 1);
        }
        function Ff(n, t) {
            return ph(Au(t), n);
        }
        function Nf() {
            if (!arguments.length) return [];
            var n = arguments[0];
            return bh(n) ? n : [
                n
            ];
        }
        function Pf(n) {
            return Fr(n, sn);
        }
        function qf(n, t) {
            return t = "function" == typeof t ? t : X, Fr(n, sn, t);
        }
        function Zf(n) {
            return Fr(n, an | sn);
        }
        function Kf(n, t) {
            return t = "function" == typeof t ? t : X, Fr(n, an | sn, t);
        }
        function Vf(n, t) {
            return null == t || Pr(n, t, Pc(t));
        }
        function Gf(n, t) {
            return n === t || n !== n && t !== t;
        }
        function Hf(n) {
            return null != n && oc(n.length) && !uc(n);
        }
        function Jf(n) {
            return cc(n) && Hf(n);
        }
        function Yf(n) {
            return n === !0 || n === !1 || cc(n) && we(n) == Nn;
        }
        function Qf(n) {
            return cc(n) && 1 === n.nodeType && !gc(n);
        }
        function Xf(n) {
            if (null == n) return !0;
            if (Hf(n) && (bh(n) || "string" == typeof n || "function" == typeof n.splice || mh(n) || Oh(n) || dh(n))) return !n.length;
            var t = zs(n);
            if (t == Gn || t == tt) return !n.size;
            if (Mi(n)) return !Me(n).length;
            for(var r in n)if (bl.call(n, r)) return !1;
            return !0;
        }
        function nc(n, t) {
            return Se(n, t);
        }
        function tc(n, t, r) {
            r = "function" == typeof r ? r : X;
            var e = r ? r(n, t) : X;
            return e === X ? Se(n, t, X, r) : !!e;
        }
        function rc(n) {
            if (!cc(n)) return !1;
            var t = we(n);
            return t == Zn || t == qn || "string" == typeof n.message && "string" == typeof n.name && !gc(n);
        }
        function ec(n) {
            return "number" == typeof n && Zl(n);
        }
        function uc(n) {
            if (!fc(n)) return !1;
            var t = we(n);
            return t == Kn || t == Vn || t == Fn || t == Xn;
        }
        function ic(n) {
            return "number" == typeof n && n == kc(n);
        }
        function oc(n) {
            return "number" == typeof n && n > -1 && n % 1 == 0 && n <= Wn;
        }
        function fc(n) {
            var t = typeof n;
            return null != n && ("object" == t || "function" == t);
        }
        function cc(n) {
            return null != n && "object" == typeof n;
        }
        function ac(n, t) {
            return n === t || Ce(n, t, ji(t));
        }
        function lc(n, t, r) {
            return r = "function" == typeof r ? r : X, Ce(n, t, ji(t), r);
        }
        function sc(n) {
            return vc(n) && n != +n;
        }
        function hc(n) {
            if (Es(n)) throw new fl(rn);
            return Ue(n);
        }
        function pc(n) {
            return null === n;
        }
        function _c(n) {
            return null == n;
        }
        function vc(n) {
            return "number" == typeof n || cc(n) && we(n) == Hn;
        }
        function gc(n) {
            if (!cc(n) || we(n) != Yn) return !1;
            var t = El(n);
            if (null === t) return !0;
            var r = bl.call(t, "constructor") && t.constructor;
            return "function" == typeof r && r instanceof r && dl.call(r) == jl;
        }
        function yc(n) {
            return ic(n) && n >= -Wn && n <= Wn;
        }
        function dc(n) {
            return "string" == typeof n || !bh(n) && cc(n) && we(n) == rt;
        }
        function bc(n) {
            return "symbol" == typeof n || cc(n) && we(n) == et;
        }
        function wc(n) {
            return n === X;
        }
        function mc(n) {
            return cc(n) && zs(n) == it;
        }
        function xc(n) {
            return cc(n) && we(n) == ot;
        }
        function jc(n) {
            if (!n) return [];
            if (Hf(n)) return dc(n) ? G(n) : Tu(n);
            if (Ul && n[Ul]) return D(n[Ul]());
            var t = zs(n);
            return (t == Gn ? M : t == tt ? P : ra)(n);
        }
        function Ac(n) {
            if (!n) return 0 === n ? n : 0;
            if (n = Ic(n), n === Sn || n === -Sn) return (n < 0 ? -1 : 1) * Ln;
            return n === n ? n : 0;
        }
        function kc(n) {
            var t = Ac(n), r = t % 1;
            return t === t ? r ? t - r : t : 0;
        }
        function Oc(n) {
            return n ? Mr(kc(n), 0, Un) : 0;
        }
        function Ic(n) {
            if ("number" == typeof n) return n;
            if (bc(n)) return Cn;
            if (fc(n)) {
                var t = "function" == typeof n.valueOf ? n.valueOf() : n;
                n = fc(t) ? t + "" : t;
            }
            if ("string" != typeof n) return 0 === n ? n : +n;
            n = R(n);
            var r = qt.test(n);
            return r || Kt.test(n) ? Xr(n.slice(2), r ? 2 : 8) : Pt.test(n) ? Cn : +n;
        }
        function Rc(n) {
            return $u(n, qc(n));
        }
        function zc(n) {
            return n ? Mr(kc(n), -Wn, Wn) : 0 === n ? n : 0;
        }
        function Ec(n) {
            return null == n ? "" : vu(n);
        }
        function Sc(n, t) {
            var r = gs(n);
            return null == t ? r : Cr(r, t);
        }
        function Wc(n, t) {
            return v(n, mi(t, 3), ue);
        }
        function Lc(n, t) {
            return v(n, mi(t, 3), oe);
        }
        function Cc(n, t) {
            return null == n ? n : bs(n, mi(t, 3), qc);
        }
        function Uc(n, t) {
            return null == n ? n : ws(n, mi(t, 3), qc);
        }
        function Bc(n, t) {
            return n && ue(n, mi(t, 3));
        }
        function Tc(n, t) {
            return n && oe(n, mi(t, 3));
        }
        function $c(n) {
            return null == n ? [] : fe(n, Pc(n));
        }
        function Dc(n) {
            return null == n ? [] : fe(n, qc(n));
        }
        function Mc(n, t, r) {
            var e = null == n ? X : _e(n, t);
            return e === X ? r : e;
        }
        function Fc(n, t) {
            return null != n && Ri(n, t, xe);
        }
        function Nc(n, t) {
            return null != n && Ri(n, t, je);
        }
        function Pc(n) {
            return Hf(n) ? Or(n) : Me(n);
        }
        function qc(n) {
            return Hf(n) ? Or(n, !0) : Fe(n);
        }
        function Zc(n, t) {
            var r = {};
            return t = mi(t, 3), ue(n, function(n, e, u) {
                Br(r, t(n, e, u), n);
            }), r;
        }
        function Kc(n, t) {
            var r = {};
            return t = mi(t, 3), ue(n, function(n, e, u) {
                Br(r, e, t(n, e, u));
            }), r;
        }
        function Vc(n, t) {
            return Gc(n, Uf(mi(t)));
        }
        function Gc(n, t) {
            if (null == n) return {};
            var r = c(di(n), function(n) {
                return [
                    n
                ];
            });
            return t = mi(t), Ye(n, r, function(n, r) {
                return t(n, r[0]);
            });
        }
        function Hc(n, t, r) {
            t = ku(t, n);
            var e = -1, u = t.length;
            for(u || (u = 1, n = X); ++e < u;){
                var i = null == n ? X : n[no(t[e])];
                i === X && (e = u, i = r), n = uc(i) ? i.call(n) : i;
            }
            return n;
        }
        function Jc(n, t, r) {
            return null == n ? n : fu(n, t, r);
        }
        function Yc(n, t, r, e) {
            return e = "function" == typeof e ? e : X, null == n ? n : fu(n, t, r, e);
        }
        function Qc(n, t, e) {
            var u = bh(n), i = u || mh(n) || Oh(n);
            if (t = mi(t, 4), null == e) {
                var o = n && n.constructor;
                e = i ? u ? new o : [] : fc(n) && uc(o) ? gs(El(n)) : {};
            }
            return (i ? r : ue)(n, function(n, r, u) {
                return t(e, n, r, u);
            }), e;
        }
        function Xc(n, t) {
            return null == n || yu(n, t);
        }
        function na(n, t, r) {
            return null == n ? n : du(n, t, Au(r));
        }
        function ta(n, t, r, e) {
            return e = "function" == typeof e ? e : X, null == n ? n : du(n, t, Au(r), e);
        }
        function ra(n) {
            return null == n ? [] : E(n, Pc(n));
        }
        function ea(n) {
            return null == n ? [] : E(n, qc(n));
        }
        function ua(n, t, r) {
            return r === X && (r = t, t = X), r !== X && (r = Ic(r), r = r === r ? r : 0), t !== X && (t = Ic(t), t = t === t ? t : 0), Mr(Ic(n), t, r);
        }
        function ia(n, t, r) {
            return t = Ac(t), r === X ? (r = t, t = 0) : r = Ac(r), n = Ic(n), Ae(n, t, r);
        }
        function oa(n, t, r) {
            if (r && "boolean" != typeof r && Ui(n, t, r) && (t = r = X), r === X && ("boolean" == typeof t ? (r = t, t = X) : "boolean" == typeof n && (r = n, n = X)), n === X && t === X ? (n = 0, t = 1) : (n = Ac(n), t === X ? (t = n, n = 0) : t = Ac(t)), n > t) {
                var e = n;
                n = t, t = e;
            }
            if (r || n % 1 || t % 1) {
                var u = Ql();
                return Hl(n + u * (t - n + Qr("1e-" + ((u + "").length - 1))), t);
            }
            return tu(n, t);
        }
        function fa(n) {
            return Qh(Ec(n).toLowerCase());
        }
        function ca(n) {
            return n = Ec(n), n && n.replace(Gt, ve).replace(Dr, "");
        }
        function aa(n, t, r) {
            n = Ec(n), t = vu(t);
            var e = n.length;
            r = r === X ? e : Mr(kc(r), 0, e);
            var u = r;
            return r -= t.length, r >= 0 && n.slice(r, u) == t;
        }
        function la(n) {
            return n = Ec(n), n && At.test(n) ? n.replace(xt, ge) : n;
        }
        function sa(n) {
            return n = Ec(n), n && Wt.test(n) ? n.replace(St, "\\$&") : n;
        }
        function ha(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            if (!t || e >= t) return n;
            var u = (t - e) / 2;
            return ri(Nl(u), r) + n + ri(Fl(u), r);
        }
        function pa(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            return t && e < t ? n + ri(t - e, r) : n;
        }
        function _a(n, t, r) {
            n = Ec(n), t = kc(t);
            var e = t ? V(n) : 0;
            return t && e < t ? ri(t - e, r) + n : n;
        }
        function va(n, t, r) {
            return r || null == t ? t = 0 : t && (t = +t), Yl(Ec(n).replace(Lt, ""), t || 0);
        }
        function ga(n, t, r) {
            return t = (r ? Ui(n, t, r) : t === X) ? 1 : kc(t), eu(Ec(n), t);
        }
        function ya() {
            var n = arguments, t = Ec(n[0]);
            return n.length < 3 ? t : t.replace(n[1], n[2]);
        }
        function da(n, t, r) {
            return r && "number" != typeof r && Ui(n, t, r) && (t = r = X), (r = r === X ? Un : r >>> 0) ? (n = Ec(n), n && ("string" == typeof t || null != t && !Ah(t)) && (t = vu(t), !t && T(n)) ? Ou(G(n), 0, r) : n.split(t, r)) : [];
        }
        function ba(n, t, r) {
            return n = Ec(n), r = null == r ? 0 : Mr(kc(r), 0, n.length), t = vu(t), n.slice(r, r + t.length) == t;
        }
        function wa(n, t, r) {
            var e = Z.templateSettings;
            r && Ui(n, t, r) && (t = X), n = Ec(n), t = Sh({}, t, e, li);
            var u, i, o = Sh({}, t.imports, e.imports, li), f = Pc(o), c = E(o, f), a = 0, l = t.interpolate || Ht, s = "__p += '", h = sl((t.escape || Ht).source + "|" + l.source + "|" + (l === It ? Ft : Ht).source + "|" + (t.evaluate || Ht).source + "|$", "g"), p = "//# sourceURL=" + (bl.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Zr + "]") + "\n";
            n.replace(h, function(t, r, e, o, f, c) {
                return e || (e = o), s += n.slice(a, c).replace(Jt, U), r && (u = !0, s += "' +\n__e(" + r + ") +\n'"), f && (i = !0, s += "';\n" + f + ";\n__p += '"), e && (s += "' +\n((__t = (" + e + ")) == null ? '' : __t) +\n'"), a = c + t.length, t;
            }), s += "';\n";
            var _ = bl.call(t, "variable") && t.variable;
            if (_) {
                if (Dt.test(_)) throw new fl(un);
            } else s = "with (obj) {\n" + s + "\n}\n";
            s = (i ? s.replace(dt, "") : s).replace(bt, "$1").replace(wt, "$1;"), s = "function(" + (_ || "obj") + ") {\n" + (_ ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (u ? ", __e = _.escape" : "") + (i ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + s + "return __p\n}";
            var v = Xh(function() {
                return cl(f, p + "return " + s).apply(X, c);
            });
            if (v.source = s, rc(v)) throw v;
            return v;
        }
        function ma(n) {
            return Ec(n).toLowerCase();
        }
        function xa(n) {
            return Ec(n).toUpperCase();
        }
        function ja(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return R(n);
            if (!n || !(t = vu(t))) return n;
            var e = G(n), u = G(t);
            return Ou(e, W(e, u), L(e, u) + 1).join("");
        }
        function Aa(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return n.slice(0, H(n) + 1);
            if (!n || !(t = vu(t))) return n;
            var e = G(n);
            return Ou(e, 0, L(e, G(t)) + 1).join("");
        }
        function ka(n, t, r) {
            if (n = Ec(n), n && (r || t === X)) return n.replace(Lt, "");
            if (!n || !(t = vu(t))) return n;
            var e = G(n);
            return Ou(e, W(e, G(t))).join("");
        }
        function Oa(n, t) {
            var r = An, e = kn;
            if (fc(t)) {
                var u = "separator" in t ? t.separator : u;
                r = "length" in t ? kc(t.length) : r, e = "omission" in t ? vu(t.omission) : e;
            }
            n = Ec(n);
            var i = n.length;
            if (T(n)) {
                var o = G(n);
                i = o.length;
            }
            if (r >= i) return n;
            var f = r - V(e);
            if (f < 1) return e;
            var c = o ? Ou(o, 0, f).join("") : n.slice(0, f);
            if (u === X) return c + e;
            if (o && (f += c.length - f), Ah(u)) {
                if (n.slice(f).search(u)) {
                    var a, l = c;
                    for(u.global || (u = sl(u.source, Ec(Nt.exec(u)) + "g")), u.lastIndex = 0; a = u.exec(l);)var s = a.index;
                    c = c.slice(0, s === X ? f : s);
                }
            } else if (n.indexOf(vu(u), f) != f) {
                var h = c.lastIndexOf(u);
                h > -1 && (c = c.slice(0, h));
            }
            return c + e;
        }
        function Ia(n) {
            return n = Ec(n), n && jt.test(n) ? n.replace(mt, ye) : n;
        }
        function Ra(n, t, r) {
            return n = Ec(n), t = r ? X : t, t === X ? $(n) ? Q(n) : _(n) : n.match(t) || [];
        }
        function za(t) {
            var r = null == t ? 0 : t.length, e = mi();
            return t = r ? c(t, function(n) {
                if ("function" != typeof n[1]) throw new pl(en);
                return [
                    e(n[0]),
                    n[1]
                ];
            }) : [], uu(function(e) {
                for(var u = -1; ++u < r;){
                    var i = t[u];
                    if (n(i[0], this, e)) return n(i[1], this, e);
                }
            });
        }
        function Ea(n) {
            return Nr(Fr(n, an));
        }
        function Sa(n) {
            return function() {
                return n;
            };
        }
        function Wa(n, t) {
            return null == n || n !== n ? t : n;
        }
        function La(n) {
            return n;
        }
        function Ca(n) {
            return De("function" == typeof n ? n : Fr(n, an));
        }
        function Ua(n) {
            return qe(Fr(n, an));
        }
        function Ba(n, t) {
            return Ze(n, Fr(t, an));
        }
        function Ta(n, t, e) {
            var u = Pc(t), i = fe(t, u);
            null != e || fc(t) && (i.length || !u.length) || (e = t, t = n, n = this, i = fe(t, Pc(t)));
            var o = !(fc(e) && "chain" in e && !e.chain), f = uc(n);
            return r(i, function(r) {
                var e = t[r];
                n[r] = e, f && (n.prototype[r] = function() {
                    var t = this.__chain__;
                    if (o || t) {
                        var r = n(this.__wrapped__);
                        return (r.__actions__ = Tu(this.__actions__)).push({
                            func: e,
                            args: arguments,
                            thisArg: n
                        }), r.__chain__ = t, r;
                    }
                    return e.apply(n, a([
                        this.value()
                    ], arguments));
                });
            }), n;
        }
        function $a() {
            return re._ === this && (re._ = Al), this;
        }
        function Da() {}
        function Ma(n) {
            return n = kc(n), uu(function(t) {
                return Ge(t, n);
            });
        }
        function Fa(n) {
            return Bi(n) ? m(no(n)) : Qe(n);
        }
        function Na(n) {
            return function(t) {
                return null == n ? X : _e(n, t);
            };
        }
        function Pa() {
            return [];
        }
        function qa() {
            return !1;
        }
        function Za() {
            return {};
        }
        function Ka() {
            return "";
        }
        function Va() {
            return !0;
        }
        function Ga(n, t) {
            if (n = kc(n), n < 1 || n > Wn) return [];
            var r = Un, e = Hl(n, Un);
            t = mi(t), n -= Un;
            for(var u = O(e, t); ++r < n;)t(r);
            return u;
        }
        function Ha(n) {
            return bh(n) ? c(n, no) : bc(n) ? [
                n
            ] : Tu(Cs(Ec(n)));
        }
        function Ja(n) {
            var t = ++wl;
            return Ec(n) + t;
        }
        function Ya(n) {
            return n && n.length ? Yr(n, La, me) : X;
        }
        function Qa(n, t) {
            return n && n.length ? Yr(n, mi(t, 2), me) : X;
        }
        function Xa(n) {
            return w(n, La);
        }
        function nl(n, t) {
            return w(n, mi(t, 2));
        }
        function tl(n) {
            return n && n.length ? Yr(n, La, Ne) : X;
        }
        function rl(n, t) {
            return n && n.length ? Yr(n, mi(t, 2), Ne) : X;
        }
        function el(n) {
            return n && n.length ? k(n, La) : 0;
        }
        function ul(n, t) {
            return n && n.length ? k(n, mi(t, 2)) : 0;
        }
        x = null == x ? re : be.defaults(re.Object(), x, be.pick(re, qr));
        var il = x.Array, ol = x.Date, fl = x.Error, cl = x.Function, al = x.Math, ll = x.Object, sl = x.RegExp, hl = x.String, pl = x.TypeError, _l = il.prototype, vl = cl.prototype, gl = ll.prototype, yl = x["__core-js_shared__"], dl = vl.toString, bl = gl.hasOwnProperty, wl = 0, ml = function() {
            var n = /[^.]+$/.exec(yl && yl.keys && yl.keys.IE_PROTO || "");
            return n ? "Symbol(src)_1." + n : "";
        }(), xl = gl.toString, jl = dl.call(ll), Al = re._, kl = sl("^" + dl.call(bl).replace(St, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ol = ie ? x.Buffer : X, Il = x.Symbol, Rl = x.Uint8Array, zl = Ol ? Ol.allocUnsafe : X, El = F(ll.getPrototypeOf, ll), Sl = ll.create, Wl = gl.propertyIsEnumerable, Ll = _l.splice, Cl = Il ? Il.isConcatSpreadable : X, Ul = Il ? Il.iterator : X, Bl = Il ? Il.toStringTag : X, Tl = function() {
            try {
                var n = Ai(ll, "defineProperty");
                return n({}, "", {}), n;
            } catch (n) {}
        }(), $l = x.clearTimeout !== re.clearTimeout && x.clearTimeout, Dl = ol && ol.now !== re.Date.now && ol.now, Ml = x.setTimeout !== re.setTimeout && x.setTimeout, Fl = al.ceil, Nl = al.floor, Pl = ll.getOwnPropertySymbols, ql = Ol ? Ol.isBuffer : X, Zl = x.isFinite, Kl = _l.join, Vl = F(ll.keys, ll), Gl = al.max, Hl = al.min, Jl = ol.now, Yl = x.parseInt, Ql = al.random, Xl = _l.reverse, ns = Ai(x, "DataView"), ts = Ai(x, "Map"), rs = Ai(x, "Promise"), es = Ai(x, "Set"), us = Ai(x, "WeakMap"), is = Ai(ll, "create"), os = us && new us, fs = {}, cs = to(ns), as = to(ts), ls = to(rs), ss = to(es), hs = to(us), ps = Il ? Il.prototype : X, _s = ps ? ps.valueOf : X, vs = ps ? ps.toString : X, gs = function() {
            function n() {}
            return function(t) {
                if (!fc(t)) return {};
                if (Sl) return Sl(t);
                n.prototype = t;
                var r = new n;
                return n.prototype = X, r;
            };
        }();
        Z.templateSettings = {
            escape: kt,
            evaluate: Ot,
            interpolate: It,
            variable: "",
            imports: {
                _: Z
            }
        }, Z.prototype = J.prototype, Z.prototype.constructor = Z, Y.prototype = gs(J.prototype), Y.prototype.constructor = Y, Ct.prototype = gs(J.prototype), Ct.prototype.constructor = Ct, Xt.prototype.clear = nr, Xt.prototype.delete = tr, Xt.prototype.get = rr, Xt.prototype.has = er, Xt.prototype.set = ur, ir.prototype.clear = or, ir.prototype.delete = fr, ir.prototype.get = cr, ir.prototype.has = ar, ir.prototype.set = lr, sr.prototype.clear = hr, sr.prototype.delete = pr, sr.prototype.get = _r, sr.prototype.has = vr, sr.prototype.set = gr, yr.prototype.add = yr.prototype.push = dr, yr.prototype.has = br, wr.prototype.clear = mr, wr.prototype.delete = xr, wr.prototype.get = jr, wr.prototype.has = Ar, wr.prototype.set = kr;
        var ys = Pu(ue), ds = Pu(oe, !0), bs = qu(), ws = qu(!0), ms = os ? function(n, t) {
            return os.set(n, t), n;
        } : La, xs = Tl ? function(n, t) {
            return Tl(n, "toString", {
                configurable: !0,
                enumerable: !1,
                value: Sa(t),
                writable: !0
            });
        } : La, js = uu, As = $l || function(n) {
            return re.clearTimeout(n);
        }, ks = es && 1 / P(new es([
            ,
            -0
        ]))[1] == Sn ? function(n) {
            return new es(n);
        } : Da, Os = os ? function(n) {
            return os.get(n);
        } : Da, Is = Pl ? function(n) {
            return null == n ? [] : (n = ll(n), i(Pl(n), function(t) {
                return Wl.call(n, t);
            }));
        } : Pa, Rs = Pl ? function(n) {
            for(var t = []; n;)a(t, Is(n)), n = El(n);
            return t;
        } : Pa, zs = we;
        (ns && zs(new ns(new ArrayBuffer(1))) != ct || ts && zs(new ts) != Gn || rs && zs(rs.resolve()) != Qn || es && zs(new es) != tt || us && zs(new us) != it) && (zs = function(n) {
            var t = we(n), r = t == Yn ? n.constructor : X, e = r ? to(r) : "";
            if (e) switch(e){
                case cs:
                    return ct;
                case as:
                    return Gn;
                case ls:
                    return Qn;
                case ss:
                    return tt;
                case hs:
                    return it;
            }
            return t;
        });
        var Es = yl ? uc : qa, Ss = Qi(ms), Ws = Ml || function(n, t) {
            return re.setTimeout(n, t);
        }, Ls = Qi(xs), Cs = Pi(function(n) {
            var t = [];
            return 46 === n.charCodeAt(0) && t.push(""), n.replace(Et, function(n, r, e, u) {
                t.push(e ? u.replace(Mt, "$1") : r || n);
            }), t;
        }), Us = uu(function(n, t) {
            return Jf(n) ? Hr(n, ee(t, 1, Jf, !0)) : [];
        }), Bs = uu(function(n, t) {
            var r = jo(t);
            return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), mi(r, 2)) : [];
        }), Ts = uu(function(n, t) {
            var r = jo(t);
            return Jf(r) && (r = X), Jf(n) ? Hr(n, ee(t, 1, Jf, !0), X, r) : [];
        }), $s = uu(function(n) {
            var t = c(n, ju);
            return t.length && t[0] === n[0] ? ke(t) : [];
        }), Ds = uu(function(n) {
            var t = jo(n), r = c(n, ju);
            return t === jo(r) ? t = X : r.pop(), r.length && r[0] === n[0] ? ke(r, mi(t, 2)) : [];
        }), Ms = uu(function(n) {
            var t = jo(n), r = c(n, ju);
            return t = "function" == typeof t ? t : X, t && r.pop(), r.length && r[0] === n[0] ? ke(r, X, t) : [];
        }), Fs = uu(Oo), Ns = gi(function(n, t) {
            var r = null == n ? 0 : n.length, e = Tr(n, t);
            return nu(n, c(t, function(n) {
                return Ci(n, r) ? +n : n;
            }).sort(Lu)), e;
        }), Ps = uu(function(n) {
            return gu(ee(n, 1, Jf, !0));
        }), qs = uu(function(n) {
            var t = jo(n);
            return Jf(t) && (t = X), gu(ee(n, 1, Jf, !0), mi(t, 2));
        }), Zs = uu(function(n) {
            var t = jo(n);
            return t = "function" == typeof t ? t : X, gu(ee(n, 1, Jf, !0), X, t);
        }), Ks = uu(function(n, t) {
            return Jf(n) ? Hr(n, t) : [];
        }), Vs = uu(function(n) {
            return mu(i(n, Jf));
        }), Gs = uu(function(n) {
            var t = jo(n);
            return Jf(t) && (t = X), mu(i(n, Jf), mi(t, 2));
        }), Hs = uu(function(n) {
            var t = jo(n);
            return t = "function" == typeof t ? t : X, mu(i(n, Jf), X, t);
        }), Js = uu(Go), Ys = uu(function(n) {
            var t = n.length, r = t > 1 ? n[t - 1] : X;
            return r = "function" == typeof r ? (n.pop(), r) : X, Ho(n, r);
        }), Qs = gi(function(n) {
            var t = n.length, r = t ? n[0] : 0, e = this.__wrapped__, u = function(t) {
                return Tr(t, n);
            };
            return !(t > 1 || this.__actions__.length) && e instanceof Ct && Ci(r) ? (e = e.slice(r, +r + (t ? 1 : 0)), e.__actions__.push({
                func: nf,
                args: [
                    u
                ],
                thisArg: X
            }), new Y(e, this.__chain__).thru(function(n) {
                return t && !n.length && n.push(X), n;
            })) : this.thru(u);
        }), Xs = Fu(function(n, t, r) {
            bl.call(n, r) ? ++n[r] : Br(n, r, 1);
        }), nh = Ju(ho), th = Ju(po), rh = Fu(function(n, t, r) {
            bl.call(n, r) ? n[r].push(t) : Br(n, r, [
                t
            ]);
        }), eh = uu(function(t, r, e) {
            var u = -1, i = "function" == typeof r, o = Hf(t) ? il(t.length) : [];
            return ys(t, function(t) {
                o[++u] = i ? n(r, t, e) : Ie(t, r, e);
            }), o;
        }), uh = Fu(function(n, t, r) {
            Br(n, r, t);
        }), ih = Fu(function(n, t, r) {
            n[r ? 0 : 1].push(t);
        }, function() {
            return [
                [],
                []
            ];
        }), oh = uu(function(n, t) {
            if (null == n) return [];
            var r = t.length;
            return r > 1 && Ui(n, t[0], t[1]) ? t = [] : r > 2 && Ui(t[0], t[1], t[2]) && (t = [
                t[0]
            ]), He(n, ee(t, 1), []);
        }), fh = Dl || function() {
            return re.Date.now();
        }, ch = uu(function(n, t, r) {
            var e = _n;
            if (r.length) {
                var u = N(r, wi(ch));
                e |= bn;
            }
            return ai(n, e, t, r, u);
        }), ah = uu(function(n, t, r) {
            var e = _n | vn;
            if (r.length) {
                var u = N(r, wi(ah));
                e |= bn;
            }
            return ai(t, e, n, r, u);
        }), lh = uu(function(n, t) {
            return Gr(n, 1, t);
        }), sh = uu(function(n, t, r) {
            return Gr(n, Ic(t) || 0, r);
        });
        Cf.Cache = sr;
        var hh = js(function(t, r) {
            r = 1 == r.length && bh(r[0]) ? c(r[0], z(mi())) : c(ee(r, 1), z(mi()));
            var e = r.length;
            return uu(function(u) {
                for(var i = -1, o = Hl(u.length, e); ++i < o;)u[i] = r[i].call(this, u[i]);
                return n(t, this, u);
            });
        }), ph = uu(function(n, t) {
            return ai(n, bn, X, t, N(t, wi(ph)));
        }), _h = uu(function(n, t) {
            return ai(n, wn, X, t, N(t, wi(_h)));
        }), vh = gi(function(n, t) {
            return ai(n, xn, X, X, X, t);
        }), gh = ii(me), yh = ii(function(n, t) {
            return n >= t;
        }), dh = Re(function() {
            return arguments;
        }()) ? Re : function(n) {
            return cc(n) && bl.call(n, "callee") && !Wl.call(n, "callee");
        }, bh = il.isArray, wh = ce ? z(ce) : ze, mh = ql || qa, xh = ae ? z(ae) : Ee, jh = le ? z(le) : Le, Ah = se ? z(se) : Be, kh = he ? z(he) : Te, Oh = pe ? z(pe) : $e, Ih = ii(Ne), Rh = ii(function(n, t) {
            return n <= t;
        }), zh = Nu(function(n, t) {
            if (Mi(t) || Hf(t)) return $u(t, Pc(t), n), X;
            for(var r in t)bl.call(t, r) && Sr(n, r, t[r]);
        }), Eh = Nu(function(n, t) {
            $u(t, qc(t), n);
        }), Sh = Nu(function(n, t, r, e) {
            $u(t, qc(t), n, e);
        }), Wh = Nu(function(n, t, r, e) {
            $u(t, Pc(t), n, e);
        }), Lh = gi(Tr), Ch = uu(function(n, t) {
            n = ll(n);
            var r = -1, e = t.length, u = e > 2 ? t[2] : X;
            for(u && Ui(t[0], t[1], u) && (e = 1); ++r < e;)for(var i = t[r], o = qc(i), f = -1, c = o.length; ++f < c;){
                var a = o[f], l = n[a];
                (l === X || Gf(l, gl[a]) && !bl.call(n, a)) && (n[a] = i[a]);
            }
            return n;
        }), Uh = uu(function(t) {
            return t.push(X, si), n(Mh, X, t);
        }), Bh = Xu(function(n, t, r) {
            null != t && "function" != typeof t.toString && (t = xl.call(t)), n[t] = r;
        }, Sa(La)), Th = Xu(function(n, t, r) {
            null != t && "function" != typeof t.toString && (t = xl.call(t)), bl.call(n, t) ? n[t].push(r) : n[t] = [
                r
            ];
        }, mi), $h = uu(Ie), Dh = Nu(function(n, t, r) {
            Ke(n, t, r);
        }), Mh = Nu(function(n, t, r, e) {
            Ke(n, t, r, e);
        }), Fh = gi(function(n, t) {
            var r = {};
            if (null == n) return r;
            var e = !1;
            t = c(t, function(t) {
                return t = ku(t, n), e || (e = t.length > 1), t;
            }), $u(n, di(n), r), e && (r = Fr(r, an | ln | sn, hi));
            for(var u = t.length; u--;)yu(r, t[u]);
            return r;
        }), Nh = gi(function(n, t) {
            return null == n ? {} : Je(n, t);
        }), Ph = ci(Pc), qh = ci(qc), Zh = Vu(function(n, t, r) {
            return t = t.toLowerCase(), n + (r ? fa(t) : t);
        }), Kh = Vu(function(n, t, r) {
            return n + (r ? "-" : "") + t.toLowerCase();
        }), Vh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + t.toLowerCase();
        }), Gh = Ku("toLowerCase"), Hh = Vu(function(n, t, r) {
            return n + (r ? "_" : "") + t.toLowerCase();
        }), Jh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + Qh(t);
        }), Yh = Vu(function(n, t, r) {
            return n + (r ? " " : "") + t.toUpperCase();
        }), Qh = Ku("toUpperCase"), Xh = uu(function(t, r) {
            try {
                return n(t, X, r);
            } catch (n) {
                return rc(n) ? n : new fl(n);
            }
        }), np = gi(function(n, t) {
            return r(t, function(t) {
                t = no(t), Br(n, t, ch(n[t], n));
            }), n;
        }), tp = Yu(), rp = Yu(!0), ep = uu(function(n, t) {
            return function(r) {
                return Ie(r, n, t);
            };
        }), up = uu(function(n, t) {
            return function(r) {
                return Ie(n, r, t);
            };
        }), ip = ti(c), op = ti(u), fp = ti(h), cp = ui(), ap = ui(!0), lp = ni(function(n, t) {
            return n + t;
        }, 0), sp = fi("ceil"), hp = ni(function(n, t) {
            return n / t;
        }, 1), pp = fi("floor"), _p = ni(function(n, t) {
            return n * t;
        }, 1), vp = fi("round"), gp = ni(function(n, t) {
            return n - t;
        }, 0);
        return Z.after = If, Z.ary = Rf, Z.assign = zh, Z.assignIn = Eh, Z.assignInWith = Sh, Z.assignWith = Wh, Z.at = Lh, Z.before = zf, Z.bind = ch, Z.bindAll = np, Z.bindKey = ah, Z.castArray = Nf, Z.chain = Qo, Z.chunk = uo, Z.compact = io, Z.concat = oo, Z.cond = za, Z.conforms = Ea, Z.constant = Sa, Z.countBy = Xs, Z.create = Sc, Z.curry = Ef, Z.curryRight = Sf, Z.debounce = Wf, Z.defaults = Ch, Z.defaultsDeep = Uh, Z.defer = lh, Z.delay = sh, Z.difference = Us, Z.differenceBy = Bs, Z.differenceWith = Ts, Z.drop = fo, Z.dropRight = co, Z.dropRightWhile = ao, Z.dropWhile = lo, Z.fill = so, Z.filter = lf, Z.flatMap = sf, Z.flatMapDeep = hf, Z.flatMapDepth = pf, Z.flatten = _o, Z.flattenDeep = vo, Z.flattenDepth = go, Z.flip = Lf, Z.flow = tp, Z.flowRight = rp, Z.fromPairs = yo, Z.functions = $c, Z.functionsIn = Dc, Z.groupBy = rh, Z.initial = mo, Z.intersection = $s, Z.intersectionBy = Ds, Z.intersectionWith = Ms, Z.invert = Bh, Z.invertBy = Th, Z.invokeMap = eh, Z.iteratee = Ca, Z.keyBy = uh, Z.keys = Pc, Z.keysIn = qc, Z.map = yf, Z.mapKeys = Zc, Z.mapValues = Kc, Z.matches = Ua, Z.matchesProperty = Ba, Z.memoize = Cf, Z.merge = Dh, Z.mergeWith = Mh, Z.method = ep, Z.methodOf = up, Z.mixin = Ta, Z.negate = Uf, Z.nthArg = Ma, Z.omit = Fh, Z.omitBy = Vc, Z.once = Bf, Z.orderBy = df, Z.over = ip, Z.overArgs = hh, Z.overEvery = op, Z.overSome = fp, Z.partial = ph, Z.partialRight = _h, Z.partition = ih, Z.pick = Nh, Z.pickBy = Gc, Z.property = Fa, Z.propertyOf = Na, Z.pull = Fs, Z.pullAll = Oo, Z.pullAllBy = Io, Z.pullAllWith = Ro, Z.pullAt = Ns, Z.range = cp, Z.rangeRight = ap, Z.rearg = vh, Z.reject = mf, Z.remove = zo, Z.rest = Tf, Z.reverse = Eo, Z.sampleSize = jf, Z.set = Jc, Z.setWith = Yc, Z.shuffle = Af, Z.slice = So, Z.sortBy = oh, Z.sortedUniq = $o, Z.sortedUniqBy = Do, Z.split = da, Z.spread = $f, Z.tail = Mo, Z.take = Fo, Z.takeRight = No, Z.takeRightWhile = Po, Z.takeWhile = qo, Z.tap = Xo, Z.throttle = Df, Z.thru = nf, Z.toArray = jc, Z.toPairs = Ph, Z.toPairsIn = qh, Z.toPath = Ha, Z.toPlainObject = Rc, Z.transform = Qc, Z.unary = Mf, Z.union = Ps, Z.unionBy = qs, Z.unionWith = Zs, Z.uniq = Zo, Z.uniqBy = Ko, Z.uniqWith = Vo, Z.unset = Xc, Z.unzip = Go, Z.unzipWith = Ho, Z.update = na, Z.updateWith = ta, Z.values = ra, Z.valuesIn = ea, Z.without = Ks, Z.words = Ra, Z.wrap = Ff, Z.xor = Vs, Z.xorBy = Gs, Z.xorWith = Hs, Z.zip = Js, Z.zipObject = Jo, Z.zipObjectDeep = Yo, Z.zipWith = Ys, Z.entries = Ph, Z.entriesIn = qh, Z.extend = Eh, Z.extendWith = Sh, Ta(Z, Z), Z.add = lp, Z.attempt = Xh, Z.camelCase = Zh, Z.capitalize = fa, Z.ceil = sp, Z.clamp = ua, Z.clone = Pf, Z.cloneDeep = Zf, Z.cloneDeepWith = Kf, Z.cloneWith = qf, Z.conformsTo = Vf, Z.deburr = ca, Z.defaultTo = Wa, Z.divide = hp, Z.endsWith = aa, Z.eq = Gf, Z.escape = la, Z.escapeRegExp = sa, Z.every = af, Z.find = nh, Z.findIndex = ho, Z.findKey = Wc, Z.findLast = th, Z.findLastIndex = po, Z.findLastKey = Lc, Z.floor = pp, Z.forEach = _f, Z.forEachRight = vf, Z.forIn = Cc, Z.forInRight = Uc, Z.forOwn = Bc, Z.forOwnRight = Tc, Z.get = Mc, Z.gt = gh, Z.gte = yh, Z.has = Fc, Z.hasIn = Nc, Z.head = bo, Z.identity = La, Z.includes = gf, Z.indexOf = wo, Z.inRange = ia, Z.invoke = $h, Z.isArguments = dh, Z.isArray = bh, Z.isArrayBuffer = wh, Z.isArrayLike = Hf, Z.isArrayLikeObject = Jf, Z.isBoolean = Yf, Z.isBuffer = mh, Z.isDate = xh, Z.isElement = Qf, Z.isEmpty = Xf, Z.isEqual = nc, Z.isEqualWith = tc, Z.isError = rc, Z.isFinite = ec, Z.isFunction = uc, Z.isInteger = ic, Z.isLength = oc, Z.isMap = jh, Z.isMatch = ac, Z.isMatchWith = lc, Z.isNaN = sc, Z.isNative = hc, Z.isNil = _c, Z.isNull = pc, Z.isNumber = vc, Z.isObject = fc, Z.isObjectLike = cc, Z.isPlainObject = gc, Z.isRegExp = Ah, Z.isSafeInteger = yc, Z.isSet = kh, Z.isString = dc, Z.isSymbol = bc, Z.isTypedArray = Oh, Z.isUndefined = wc, Z.isWeakMap = mc, Z.isWeakSet = xc, Z.join = xo, Z.kebabCase = Kh, Z.last = jo, Z.lastIndexOf = Ao, Z.lowerCase = Vh, Z.lowerFirst = Gh, Z.lt = Ih, Z.lte = Rh, Z.max = Ya, Z.maxBy = Qa, Z.mean = Xa, Z.meanBy = nl, Z.min = tl, Z.minBy = rl, Z.stubArray = Pa, Z.stubFalse = qa, Z.stubObject = Za, Z.stubString = Ka, Z.stubTrue = Va, Z.multiply = _p, Z.nth = ko, Z.noConflict = $a, Z.noop = Da, Z.now = fh, Z.pad = ha, Z.padEnd = pa, Z.padStart = _a, Z.parseInt = va, Z.random = oa, Z.reduce = bf, Z.reduceRight = wf, Z.repeat = ga, Z.replace = ya, Z.result = Hc, Z.round = vp, Z.runInContext = p, Z.sample = xf, Z.size = kf, Z.snakeCase = Hh, Z.some = Of, Z.sortedIndex = Wo, Z.sortedIndexBy = Lo, Z.sortedIndexOf = Co, Z.sortedLastIndex = Uo, Z.sortedLastIndexBy = Bo, Z.sortedLastIndexOf = To, Z.startCase = Jh, Z.startsWith = ba, Z.subtract = gp, Z.sum = el, Z.sumBy = ul, Z.template = wa, Z.times = Ga, Z.toFinite = Ac, Z.toInteger = kc, Z.toLength = Oc, Z.toLower = ma, Z.toNumber = Ic, Z.toSafeInteger = zc, Z.toString = Ec, Z.toUpper = xa, Z.trim = ja, Z.trimEnd = Aa, Z.trimStart = ka, Z.truncate = Oa, Z.unescape = Ia, Z.uniqueId = Ja, Z.upperCase = Yh, Z.upperFirst = Qh, Z.each = _f, Z.eachRight = vf, Z.first = bo, Ta(Z, function() {
            var n = {};
            return ue(Z, function(t, r) {
                bl.call(Z.prototype, r) || (n[r] = t);
            }), n;
        }(), {
            chain: !1
        }), Z.VERSION = nn, r([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(n) {
            Z[n].placeholder = Z;
        }), r([
            "drop",
            "take"
        ], function(n, t) {
            Ct.prototype[n] = function(r) {
                r = r === X ? 1 : Gl(kc(r), 0);
                var e = this.__filtered__ && !t ? new Ct(this) : this.clone();
                return e.__filtered__ ? e.__takeCount__ = Hl(r, e.__takeCount__) : e.__views__.push({
                    size: Hl(r, Un),
                    type: n + (e.__dir__ < 0 ? "Right" : "")
                }), e;
            }, Ct.prototype[n + "Right"] = function(t) {
                return this.reverse()[n](t).reverse();
            };
        }), r([
            "filter",
            "map",
            "takeWhile"
        ], function(n, t) {
            var r = t + 1, e = r == Rn || r == En;
            Ct.prototype[n] = function(n) {
                var t = this.clone();
                return t.__iteratees__.push({
                    iteratee: mi(n, 3),
                    type: r
                }), t.__filtered__ = t.__filtered__ || e, t;
            };
        }), r([
            "head",
            "last"
        ], function(n, t) {
            var r = "take" + (t ? "Right" : "");
            Ct.prototype[n] = function() {
                return this[r](1).value()[0];
            };
        }), r([
            "initial",
            "tail"
        ], function(n, t) {
            var r = "drop" + (t ? "" : "Right");
            Ct.prototype[n] = function() {
                return this.__filtered__ ? new Ct(this) : this[r](1);
            };
        }), Ct.prototype.compact = function() {
            return this.filter(La);
        }, Ct.prototype.find = function(n) {
            return this.filter(n).head();
        }, Ct.prototype.findLast = function(n) {
            return this.reverse().find(n);
        }, Ct.prototype.invokeMap = uu(function(n, t) {
            return "function" == typeof n ? new Ct(this) : this.map(function(r) {
                return Ie(r, n, t);
            });
        }), Ct.prototype.reject = function(n) {
            return this.filter(Uf(mi(n)));
        }, Ct.prototype.slice = function(n, t) {
            n = kc(n);
            var r = this;
            return r.__filtered__ && (n > 0 || t < 0) ? new Ct(r) : (n < 0 ? r = r.takeRight(-n) : n && (r = r.drop(n)), t !== X && (t = kc(t), r = t < 0 ? r.dropRight(-t) : r.take(t - n)), r);
        }, Ct.prototype.takeRightWhile = function(n) {
            return this.reverse().takeWhile(n).reverse();
        }, Ct.prototype.toArray = function() {
            return this.take(Un);
        }, ue(Ct.prototype, function(n, t) {
            var r = /^(?:filter|find|map|reject)|While$/.test(t), e = /^(?:head|last)$/.test(t), u = Z[e ? "take" + ("last" == t ? "Right" : "") : t], i = e || /^find/.test(t);
            u && (Z.prototype[t] = function() {
                var t = this.__wrapped__, o = e ? [
                    1
                ] : arguments, f = t instanceof Ct, c = o[0], l = f || bh(t), s = function(n) {
                    var t = u.apply(Z, a([
                        n
                    ], o));
                    return e && h ? t[0] : t;
                };
                l && r && "function" == typeof c && 1 != c.length && (f = l = !1);
                var h = this.__chain__, p = !!this.__actions__.length, _ = i && !h, v = f && !p;
                if (!i && l) {
                    t = v ? t : new Ct(this);
                    var g = n.apply(t, o);
                    return g.__actions__.push({
                        func: nf,
                        args: [
                            s
                        ],
                        thisArg: X
                    }), new Y(g, h);
                }
                return _ && v ? n.apply(this, o) : (g = this.thru(s), _ ? e ? g.value()[0] : g.value() : g);
            });
        }), r([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(n) {
            var t = _l[n], r = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", e = /^(?:pop|shift)$/.test(n);
            Z.prototype[n] = function() {
                var n = arguments;
                if (e && !this.__chain__) {
                    var u = this.value();
                    return t.apply(bh(u) ? u : [], n);
                }
                return this[r](function(r) {
                    return t.apply(bh(r) ? r : [], n);
                });
            };
        }), ue(Ct.prototype, function(n, t) {
            var r = Z[t];
            if (r) {
                var e = r.name + "";
                bl.call(fs, e) || (fs[e] = []), fs[e].push({
                    name: t,
                    func: r
                });
            }
        }), fs[Qu(X, vn).name] = [
            {
                name: "wrapper",
                func: X
            }
        ], Ct.prototype.clone = $t, Ct.prototype.reverse = Yt, Ct.prototype.value = Qt, Z.prototype.at = Qs, Z.prototype.chain = tf, Z.prototype.commit = rf, Z.prototype.next = ef, Z.prototype.plant = of, Z.prototype.reverse = ff, Z.prototype.toJSON = Z.prototype.valueOf = Z.prototype.value = cf, Z.prototype.first = Z.prototype.head, Ul && (Z.prototype[Ul] = uf), Z;
    }, be = de();
    "function" == typeof define && "object" == typeof define.amd && define.amd ? (re._ = be, define(function() {
        return be;
    })) : ue ? ((ue.exports = be)._ = be, ee._ = be) : re._ = be;
}).call(this);

});

parcelRegister("UF13C", function(module, exports) {

var $fYV7F = parcelRequire("fYV7F");

var $ixDgv = parcelRequire("ixDgv");
/** Built-in value reference. */ var $0aa50c0305e22c55$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $0aa50c0305e22c55$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $0aa50c0305e22c55$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $0aa50c0305e22c55$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $0aa50c0305e22c55$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $0aa50c0305e22c55$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $0aa50c0305e22c55$var$push.apply(otherArgs, array);
        if (start != lastIndex) $0aa50c0305e22c55$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $0aa50c0305e22c55$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $0aa50c0305e22c55$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $ixDgv, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($fYV7F.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($0aa50c0305e22c55$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $0aa50c0305e22c55$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $0aa50c0305e22c55$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $fYV7F.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $fYV7F.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$fYV7F.skipFixed[name])) {
            var data = $fYV7F.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $0aa50c0305e22c55$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$fYV7F.skipRearg[name]) ? rearg(func, $fYV7F.methodRearg[name] || $fYV7F.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $fYV7F.aliasToReal[name] || name, methodName = $fYV7F.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $0aa50c0305e22c55$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $0aa50c0305e22c55$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $0aa50c0305e22c55$var$baseArity(rearg($0aa50c0305e22c55$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $fYV7F.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($fYV7F.mutate.array[realName]) wrapped = $0aa50c0305e22c55$var$wrapImmutable(func, $0aa50c0305e22c55$var$cloneArray);
            else if ($fYV7F.mutate.object[realName]) wrapped = $0aa50c0305e22c55$var$wrapImmutable(func, $0aa50c0305e22c55$var$createCloner(func));
            else if ($fYV7F.mutate.set[realName]) wrapped = $0aa50c0305e22c55$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($fYV7F.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $fYV7F.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($fYV7F.aryMethod[aryKey], function(key) {
            var func = _[$fYV7F.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($fYV7F.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $0aa50c0305e22c55$var$baseConvert;

});
parcelRegister("fYV7F", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", function () { return $ba28c4fbd5c488f0$export$bd0f5e6e44efa6b4; }, function (v) { return $ba28c4fbd5c488f0$export$bd0f5e6e44efa6b4 = v; });
$parcel$export(module.exports, "aryMethod", function () { return $ba28c4fbd5c488f0$export$85c665b4d7da9cb4; }, function (v) { return $ba28c4fbd5c488f0$export$85c665b4d7da9cb4 = v; });
$parcel$export(module.exports, "aryRearg", function () { return $ba28c4fbd5c488f0$export$42564e045b285e32; }, function (v) { return $ba28c4fbd5c488f0$export$42564e045b285e32 = v; });
$parcel$export(module.exports, "iterateeAry", function () { return $ba28c4fbd5c488f0$export$81e17196e6a22b07; }, function (v) { return $ba28c4fbd5c488f0$export$81e17196e6a22b07 = v; });
$parcel$export(module.exports, "iterateeRearg", function () { return $ba28c4fbd5c488f0$export$30975ceb42167ebd; }, function (v) { return $ba28c4fbd5c488f0$export$30975ceb42167ebd = v; });
$parcel$export(module.exports, "methodRearg", function () { return $ba28c4fbd5c488f0$export$8ceb0ad7e94d3801; }, function (v) { return $ba28c4fbd5c488f0$export$8ceb0ad7e94d3801 = v; });
$parcel$export(module.exports, "methodSpread", function () { return $ba28c4fbd5c488f0$export$fbaeb3f87df3cf26; }, function (v) { return $ba28c4fbd5c488f0$export$fbaeb3f87df3cf26 = v; });
$parcel$export(module.exports, "mutate", function () { return $ba28c4fbd5c488f0$export$57e795267c26e600; }, function (v) { return $ba28c4fbd5c488f0$export$57e795267c26e600 = v; });
$parcel$export(module.exports, "realToAlias", function () { return $ba28c4fbd5c488f0$export$1eb71a7e27943e71; }, function (v) { return $ba28c4fbd5c488f0$export$1eb71a7e27943e71 = v; });
$parcel$export(module.exports, "remap", function () { return $ba28c4fbd5c488f0$export$aee1dbae5de2db9d; }, function (v) { return $ba28c4fbd5c488f0$export$aee1dbae5de2db9d = v; });
$parcel$export(module.exports, "skipFixed", function () { return $ba28c4fbd5c488f0$export$87ffbe4821a5d5e0; }, function (v) { return $ba28c4fbd5c488f0$export$87ffbe4821a5d5e0 = v; });
$parcel$export(module.exports, "skipRearg", function () { return $ba28c4fbd5c488f0$export$b4d07413ce528c90; }, function (v) { return $ba28c4fbd5c488f0$export$b4d07413ce528c90 = v; });
/** Used to map aliases to their real names. */ var $ba28c4fbd5c488f0$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $ba28c4fbd5c488f0$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $ba28c4fbd5c488f0$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $ba28c4fbd5c488f0$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $ba28c4fbd5c488f0$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $ba28c4fbd5c488f0$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $ba28c4fbd5c488f0$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $ba28c4fbd5c488f0$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $ba28c4fbd5c488f0$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $ba28c4fbd5c488f0$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $ba28c4fbd5c488f0$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $ba28c4fbd5c488f0$export$b4d07413ce528c90;
$ba28c4fbd5c488f0$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$ba28c4fbd5c488f0$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$ba28c4fbd5c488f0$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$ba28c4fbd5c488f0$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$ba28c4fbd5c488f0$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$ba28c4fbd5c488f0$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$ba28c4fbd5c488f0$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$ba28c4fbd5c488f0$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$ba28c4fbd5c488f0$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $ba28c4fbd5c488f0$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$ba28c4fbd5c488f0$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$ba28c4fbd5c488f0$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$ba28c4fbd5c488f0$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("ixDgv", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("9zQbc", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $6f8fdbbe048638b5$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $6f8fdbbe048638b5$export$a6c7ac8248d6e38a; });

var $3vC7t = parcelRequire("3vC7t");

var $iZ4XC = parcelRequire("iZ4XC");

var $1bxDW = parcelRequire("1bxDW");

var $fkde6 = parcelRequire("fkde6");
parcelRequire("7dzZ9");


var $kabSK = parcelRequire("kabSK");

var $1rbX6 = parcelRequire("1rbX6");

var $jbXRd = parcelRequire("jbXRd");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6f8fdbbe048638b5$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fkde6.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6f8fdbbe048638b5$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fkde6.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
var $6f8fdbbe048638b5$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6f8fdbbe048638b5$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fkde6.createLocation)(to, null, null, currentLocation) : to;
};
var $6f8fdbbe048638b5$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6f8fdbbe048638b5$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).forwardRef;
if (typeof $6f8fdbbe048638b5$var$forwardRef === "undefined") $6f8fdbbe048638b5$var$forwardRef = $6f8fdbbe048638b5$var$forwardRefShim;
function $6f8fdbbe048638b5$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6f8fdbbe048638b5$var$LinkAnchor = $6f8fdbbe048638b5$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1rbX6.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $kabSK.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6f8fdbbe048638b5$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6f8fdbbe048638b5$var$forwardRefShim !== $6f8fdbbe048638b5$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6f8fdbbe048638b5$export$a6c7ac8248d6e38a = $6f8fdbbe048638b5$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6f8fdbbe048638b5$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1rbX6.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.__RouterContext).Consumer, null, function(context) {
        !context && (0, $jbXRd.default)(false);
        var history = context.history;
        var location = $6f8fdbbe048638b5$var$normalizeToLocation($6f8fdbbe048638b5$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $kabSK.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6f8fdbbe048638b5$var$resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6f8fdbbe048638b5$var$forwardRefShim !== $6f8fdbbe048638b5$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(component, props);
    });
});
var $6f8fdbbe048638b5$var$toType, $6f8fdbbe048638b5$var$refType;
var $6f8fdbbe048638b5$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6f8fdbbe048638b5$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).forwardRef;
if (typeof $6f8fdbbe048638b5$var$forwardRef$1 === "undefined") $6f8fdbbe048638b5$var$forwardRef$1 = $6f8fdbbe048638b5$var$forwardRefShim$1;
function $6f8fdbbe048638b5$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6f8fdbbe048638b5$export$b0d92dbee9b5b60d = $6f8fdbbe048638b5$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1rbX6.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.__RouterContext).Consumer, null, function(context) {
        !context && (0, $jbXRd.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6f8fdbbe048638b5$var$normalizeToLocation($6f8fdbbe048638b5$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $3vC7t.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? $6f8fdbbe048638b5$var$joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, $kabSK.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, $kabSK.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6f8fdbbe048638b5$var$forwardRefShim$1 !== $6f8fdbbe048638b5$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($6f8fdbbe048638b5$export$a6c7ac8248d6e38a, props);
    });
});
var $6f8fdbbe048638b5$var$ariaCurrentType;

});
parcelRegister("3vC7t", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $28e1d612cf189a2c$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $28e1d612cf189a2c$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Redirect", function () { return $28e1d612cf189a2c$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $28e1d612cf189a2c$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $28e1d612cf189a2c$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Switch", function () { return $28e1d612cf189a2c$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "withRouter", function () { return $28e1d612cf189a2c$export$369b6b2b30582e8e; });
$parcel$export(module.exports, "useHistory", function () { return $28e1d612cf189a2c$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $28e1d612cf189a2c$export$45d76561a5302f2b; });

var $iZ4XC = parcelRequire("iZ4XC");

var $1bxDW = parcelRequire("1bxDW");
parcelRequire("7dzZ9");

var $fkde6 = parcelRequire("fkde6");


var $kySqF = parcelRequire("kySqF");

var $jbXRd = parcelRequire("jbXRd");

var $kabSK = parcelRequire("kabSK");

var $icYiz = parcelRequire("icYiz");
parcelRequire("aI3q1");

var $1rbX6 = parcelRequire("1rbX6");

var $Sjkfs = parcelRequire("Sjkfs");
// TODO: Replace with React.createContext once we can assume React 16+
var $28e1d612cf189a2c$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $kySqF.default)();
    context.displayName = name;
    return context;
};
var $28e1d612cf189a2c$export$c213558b66925821 = /*#__PURE__*/ $28e1d612cf189a2c$var$createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var $28e1d612cf189a2c$var$createNamedContext$1 = function createNamedContext(name) {
    var context = (0, $kySqF.default)();
    context.displayName = name;
    return context;
};
var $28e1d612cf189a2c$export$63baa8ccbe60bb07 = /*#__PURE__*/ $28e1d612cf189a2c$var$createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var $28e1d612cf189a2c$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $28e1d612cf189a2c$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fkde6.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
var $28e1d612cf189a2c$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $28e1d612cf189a2c$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $jbXRd.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $28e1d612cf189a2c$var$messageType;
var $28e1d612cf189a2c$var$cache = {};
var $28e1d612cf189a2c$var$cacheLimit = 10000;
var $28e1d612cf189a2c$var$cacheCount = 0;
function $28e1d612cf189a2c$var$compilePath(path) {
    if ($28e1d612cf189a2c$var$cache[path]) return $28e1d612cf189a2c$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($icYiz))).compile(path);
    if ($28e1d612cf189a2c$var$cacheCount < $28e1d612cf189a2c$var$cacheLimit) {
        $28e1d612cf189a2c$var$cache[path] = generator;
        $28e1d612cf189a2c$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $28e1d612cf189a2c$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $28e1d612cf189a2c$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $28e1d612cf189a2c$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $jbXRd.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $fkde6.createLocation)(computedMatch ? typeof to === "string" ? $28e1d612cf189a2c$export$82476f982757e71e(to, computedMatch.params) : (0, $kabSK.default)({}, to, {
            pathname: $28e1d612cf189a2c$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $fkde6.createLocation)(prevProps.to);
                if (!(0, $fkde6.locationsAreEqual)(prevLocation, (0, $kabSK.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $28e1d612cf189a2c$var$cache$1 = {};
var $28e1d612cf189a2c$var$cacheLimit$1 = 10000;
var $28e1d612cf189a2c$var$cacheCount$1 = 0;
function $28e1d612cf189a2c$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $28e1d612cf189a2c$var$cache$1[cacheKey] || ($28e1d612cf189a2c$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($icYiz)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($28e1d612cf189a2c$var$cacheCount$1 < $28e1d612cf189a2c$var$cacheLimit$1) {
        pathCache[path] = result;
        $28e1d612cf189a2c$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $28e1d612cf189a2c$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $28e1d612cf189a2c$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $28e1d612cf189a2c$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Children.count(children) === 0;
}
function $28e1d612cf189a2c$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $28e1d612cf189a2c$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $jbXRd.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $28e1d612cf189a2c$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $kabSK.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
function $28e1d612cf189a2c$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $28e1d612cf189a2c$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $kabSK.default)({}, location, {
        pathname: $28e1d612cf189a2c$var$addLeadingSlash(basename) + location.pathname
    });
}
function $28e1d612cf189a2c$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $28e1d612cf189a2c$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $kabSK.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $28e1d612cf189a2c$var$createURL(location) {
    return typeof location === "string" ? location : (0, $fkde6.createPath)(location);
}
function $28e1d612cf189a2c$var$staticHandler(methodName) {
    return function() {
        (0, $jbXRd.default)(false);
    };
}
function $28e1d612cf189a2c$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $28e1d612cf189a2c$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $28e1d612cf189a2c$var$noop;
        };
        _this.handleBlock = function() {
            return $28e1d612cf189a2c$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $28e1d612cf189a2c$var$addBasename(basename, (0, $fkde6.createLocation)(location));
        context.url = $28e1d612cf189a2c$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1rbX6.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $28e1d612cf189a2c$var$addLeadingSlash(basename + $28e1d612cf189a2c$var$createURL(path));
            },
            action: "POP",
            location: $28e1d612cf189a2c$var$stripBasename(basename, (0, $fkde6.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $28e1d612cf189a2c$var$staticHandler("go"),
            goBack: $28e1d612cf189a2c$var$staticHandler("goBack"),
            goForward: $28e1d612cf189a2c$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$55185c17a0fcbe46, (0, $kabSK.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $28e1d612cf189a2c$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $iZ4XC.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $jbXRd.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $28e1d612cf189a2c$export$81336c211d5ff295(location.pathname, (0, $kabSK.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $28e1d612cf189a2c$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1rbX6.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($28e1d612cf189a2c$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $jbXRd.default)(false);
            return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(Component, (0, $kabSK.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($Sjkfs)))(C, Component);
}
var $28e1d612cf189a2c$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).useContext;
function $28e1d612cf189a2c$export$3420e1dc2c4a518c() {
    return $28e1d612cf189a2c$var$useContext($28e1d612cf189a2c$export$c213558b66925821);
}
function $28e1d612cf189a2c$export$45d76561a5302f2b() {
    return $28e1d612cf189a2c$var$useContext($28e1d612cf189a2c$export$63baa8ccbe60bb07).location;
}
function $28e1d612cf189a2c$export$99eaa27ddbbb95ef() {
    var match = $28e1d612cf189a2c$var$useContext($28e1d612cf189a2c$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $28e1d612cf189a2c$export$632be4bb944c1bc7(path) {
    var location = $28e1d612cf189a2c$export$45d76561a5302f2b();
    var match = $28e1d612cf189a2c$var$useContext($28e1d612cf189a2c$export$63baa8ccbe60bb07).match;
    return path ? $28e1d612cf189a2c$export$81336c211d5ff295(location.pathname, path) : match;
}
var $28e1d612cf189a2c$var$global, $28e1d612cf189a2c$var$key, $28e1d612cf189a2c$var$buildNames, $28e1d612cf189a2c$var$initialBuildName, $28e1d612cf189a2c$var$secondaryBuildName;

});
parcelRegister("iZ4XC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd21c590a8d13ee2$export$2e2bcd8739ae039; });

var $hXw9K = parcelRequire("hXw9K");
function $dd21c590a8d13ee2$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $hXw9K.default)(t, o);
}

});
parcelRegister("hXw9K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d130e3eb2ebfdd6f$export$2e2bcd8739ae039; });
function $d130e3eb2ebfdd6f$export$2e2bcd8739ae039(t, e) {
    return $d130e3eb2ebfdd6f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d130e3eb2ebfdd6f$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fkde6", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $b282fbca508dd4d0$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $b282fbca508dd4d0$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $b282fbca508dd4d0$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b282fbca508dd4d0$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $b282fbca508dd4d0$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b282fbca508dd4d0$export$2b76ad033c6e6d08; });

var $kabSK = parcelRequire("kabSK");

var $3S9pm = parcelRequire("3S9pm");

var $d447Z = parcelRequire("d447Z");


var $jbXRd = parcelRequire("jbXRd");
function $b282fbca508dd4d0$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $b282fbca508dd4d0$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $b282fbca508dd4d0$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $b282fbca508dd4d0$var$stripBasename(path, prefix) {
    return $b282fbca508dd4d0$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $b282fbca508dd4d0$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $b282fbca508dd4d0$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $b282fbca508dd4d0$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $b282fbca508dd4d0$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $kabSK.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $3S9pm.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $b282fbca508dd4d0$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $d447Z.default)(a.state, b.state);
}
function $b282fbca508dd4d0$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $b282fbca508dd4d0$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b282fbca508dd4d0$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $b282fbca508dd4d0$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $b282fbca508dd4d0$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $b282fbca508dd4d0$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $b282fbca508dd4d0$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $b282fbca508dd4d0$var$PopStateEvent = 'popstate';
var $b282fbca508dd4d0$var$HashChangeEvent = 'hashchange';
function $b282fbca508dd4d0$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $b282fbca508dd4d0$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$b282fbca508dd4d0$var$canUseDOM && (0, $jbXRd.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $b282fbca508dd4d0$var$supportsHistory();
    var needsHashChangeListener = !$b282fbca508dd4d0$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b282fbca508dd4d0$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $b282fbca508dd4d0$var$stripTrailingSlash($b282fbca508dd4d0$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $b282fbca508dd4d0$var$stripBasename(path, basename);
        return $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $b282fbca508dd4d0$var$createTransitionManager();
    function setState(nextState) {
        (0, $kabSK.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($b282fbca508dd4d0$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($b282fbca508dd4d0$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($b282fbca508dd4d0$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $b282fbca508dd4d0$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($b282fbca508dd4d0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($b282fbca508dd4d0$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($b282fbca508dd4d0$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($b282fbca508dd4d0$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $b282fbca508dd4d0$var$HashChangeEvent$1 = 'hashchange';
var $b282fbca508dd4d0$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $b282fbca508dd4d0$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $b282fbca508dd4d0$var$stripLeadingSlash,
        decodePath: $b282fbca508dd4d0$var$addLeadingSlash
    },
    slash: {
        encodePath: $b282fbca508dd4d0$var$addLeadingSlash,
        decodePath: $b282fbca508dd4d0$var$addLeadingSlash
    }
};
function $b282fbca508dd4d0$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $b282fbca508dd4d0$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $b282fbca508dd4d0$var$pushHashPath(path) {
    window.location.hash = path;
}
function $b282fbca508dd4d0$var$replaceHashPath(path) {
    window.location.replace($b282fbca508dd4d0$var$stripHash(window.location.href) + '#' + path);
}
function $b282fbca508dd4d0$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$b282fbca508dd4d0$var$canUseDOM && (0, $jbXRd.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $b282fbca508dd4d0$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $b282fbca508dd4d0$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $b282fbca508dd4d0$var$stripTrailingSlash($b282fbca508dd4d0$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $b282fbca508dd4d0$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($b282fbca508dd4d0$var$getHashPath());
        if (basename) path = $b282fbca508dd4d0$var$stripBasename(path, basename);
        return $b282fbca508dd4d0$export$90c043f1c57770b8(path);
    }
    var transitionManager = $b282fbca508dd4d0$var$createTransitionManager();
    function setState(nextState) {
        (0, $kabSK.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $b282fbca508dd4d0$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $b282fbca508dd4d0$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $b282fbca508dd4d0$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($b282fbca508dd4d0$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($b282fbca508dd4d0$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $b282fbca508dd4d0$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $b282fbca508dd4d0$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $b282fbca508dd4d0$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $b282fbca508dd4d0$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $b282fbca508dd4d0$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b282fbca508dd4d0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b282fbca508dd4d0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b282fbca508dd4d0$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($b282fbca508dd4d0$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $b282fbca508dd4d0$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $b282fbca508dd4d0$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $b282fbca508dd4d0$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($b282fbca508dd4d0$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($b282fbca508dd4d0$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($b282fbca508dd4d0$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $b282fbca508dd4d0$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $b282fbca508dd4d0$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $b282fbca508dd4d0$var$createTransitionManager();
    function setState(nextState) {
        (0, $kabSK.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $b282fbca508dd4d0$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $b282fbca508dd4d0$export$90c043f1c57770b8(entry, undefined, createKey()) : $b282fbca508dd4d0$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $b282fbca508dd4d0$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $b282fbca508dd4d0$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $b282fbca508dd4d0$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("kabSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaddf5532fa8d3a6$export$2e2bcd8739ae039; });
function $eaddf5532fa8d3a6$export$2e2bcd8739ae039() {
    return $eaddf5532fa8d3a6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eaddf5532fa8d3a6$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3S9pm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d1db67b3ffd64c5$export$2e2bcd8739ae039; });
function $2d1db67b3ffd64c5$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $2d1db67b3ffd64c5$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $2d1db67b3ffd64c5$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $2d1db67b3ffd64c5$var$isAbsolute(to);
    var isFromAbs = from && $2d1db67b3ffd64c5$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $2d1db67b3ffd64c5$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $2d1db67b3ffd64c5$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $2d1db67b3ffd64c5$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $2d1db67b3ffd64c5$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$2d1db67b3ffd64c5$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $2d1db67b3ffd64c5$export$2e2bcd8739ae039 = $2d1db67b3ffd64c5$var$resolvePathname;

});

parcelRegister("d447Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $982ed9c6be04efb6$export$2e2bcd8739ae039; });
function $982ed9c6be04efb6$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $982ed9c6be04efb6$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $982ed9c6be04efb6$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $982ed9c6be04efb6$var$valueOf(a);
        var bValue = $982ed9c6be04efb6$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $982ed9c6be04efb6$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $982ed9c6be04efb6$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $982ed9c6be04efb6$export$2e2bcd8739ae039 = $982ed9c6be04efb6$var$valueEqual;

});

parcelRegister("jbXRd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df8d79d1bad1146f$export$2e2bcd8739ae039; });
var $df8d79d1bad1146f$var$isProduction = true;
var $df8d79d1bad1146f$var$prefix = 'Invariant failed';
function $df8d79d1bad1146f$var$invariant(condition, message) {
    if (condition) return;
    if ($df8d79d1bad1146f$var$isProduction) throw new Error($df8d79d1bad1146f$var$prefix);
    else throw new Error($df8d79d1bad1146f$var$prefix + ": " + (message || ''));
}
var $df8d79d1bad1146f$export$2e2bcd8739ae039 = $df8d79d1bad1146f$var$invariant;

});


parcelRegister("kySqF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef81342107f1ac47$export$2e2bcd8739ae039; });

var $1bxDW = parcelRequire("1bxDW");

var $iZ4XC = parcelRequire("iZ4XC");

var $7dzZ9 = parcelRequire("7dzZ9");

var $ef81342107f1ac47$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ef81342107f1ac47$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
function $ef81342107f1ac47$var$getUniqueId() {
    var key = '__global_unique_id__';
    return $ef81342107f1ac47$var$commonjsGlobal[key] = ($ef81342107f1ac47$var$commonjsGlobal[key] || 0) + 1;
}
function $ef81342107f1ac47$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ef81342107f1ac47$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ef81342107f1ac47$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ef81342107f1ac47$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + $ef81342107f1ac47$var$getUniqueId() + '__';
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $iZ4XC.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $ef81342107f1ac47$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ef81342107f1ac47$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : $ef81342107f1ac47$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $1bxDW.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $iZ4XC.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ef81342107f1ac47$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ef81342107f1ac47$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ef81342107f1ac47$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $1bxDW.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $ef81342107f1ac47$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext || $ef81342107f1ac47$var$createReactContext;
var $ef81342107f1ac47$export$2e2bcd8739ae039 = $ef81342107f1ac47$var$index;

});

parcelRegister("icYiz", function(module, exports) {

var $arqxo = parcelRequire("arqxo");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $d4181efdd1e7fd89$var$pathToRegexp;
module.exports.parse = $d4181efdd1e7fd89$var$parse;
module.exports.compile = $d4181efdd1e7fd89$var$compile;
module.exports.tokensToFunction = $d4181efdd1e7fd89$var$tokensToFunction;
module.exports.tokensToRegExp = $d4181efdd1e7fd89$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $d4181efdd1e7fd89$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $d4181efdd1e7fd89$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $d4181efdd1e7fd89$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $d4181efdd1e7fd89$var$escapeGroup(pattern) : asterisk ? '.*' : $d4181efdd1e7fd89$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $d4181efdd1e7fd89$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $d4181efdd1e7fd89$var$escapeString(delimiter) + ']+?';
    return $d4181efdd1e7fd89$var$escapeString(prevText) + '|(?:(?!' + $d4181efdd1e7fd89$var$escapeString(prevText) + ')[^' + $d4181efdd1e7fd89$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $d4181efdd1e7fd89$var$compile(str, options) {
    return $d4181efdd1e7fd89$var$tokensToFunction($d4181efdd1e7fd89$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $d4181efdd1e7fd89$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $d4181efdd1e7fd89$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $d4181efdd1e7fd89$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $d4181efdd1e7fd89$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $d4181efdd1e7fd89$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($arqxo(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $d4181efdd1e7fd89$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $d4181efdd1e7fd89$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $d4181efdd1e7fd89$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $d4181efdd1e7fd89$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $d4181efdd1e7fd89$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($d4181efdd1e7fd89$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $d4181efdd1e7fd89$var$flags(options));
    return $d4181efdd1e7fd89$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$stringToRegexp(path, keys, options) {
    return $d4181efdd1e7fd89$var$tokensToRegExp($d4181efdd1e7fd89$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$tokensToRegExp(tokens, keys, options) {
    if (!$arqxo(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $d4181efdd1e7fd89$var$escapeString(token);
        else {
            var prefix = $d4181efdd1e7fd89$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $d4181efdd1e7fd89$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $d4181efdd1e7fd89$var$attachKeys(new RegExp('^' + route, $d4181efdd1e7fd89$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $d4181efdd1e7fd89$var$pathToRegexp(path, keys, options) {
    if (!$arqxo(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $d4181efdd1e7fd89$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($arqxo(path)) return $d4181efdd1e7fd89$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $d4181efdd1e7fd89$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("arqxo", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("aI3q1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2Yevj"));

});

parcelRegister("1rbX6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10c1958aabee8dac$export$2e2bcd8739ae039; });
function $10c1958aabee8dac$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("Sjkfs", function(module, exports) {
'use strict';

var $aI3q1 = parcelRequire("aI3q1");
var $0a3408eb578c99cd$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0a3408eb578c99cd$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0a3408eb578c99cd$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0a3408eb578c99cd$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0a3408eb578c99cd$var$TYPE_STATICS = {};
$0a3408eb578c99cd$var$TYPE_STATICS[$aI3q1.ForwardRef] = $0a3408eb578c99cd$var$FORWARD_REF_STATICS;
function $0a3408eb578c99cd$var$getStatics(component) {
    if ($aI3q1.isMemo(component)) return $0a3408eb578c99cd$var$MEMO_STATICS;
    return $0a3408eb578c99cd$var$TYPE_STATICS[component['$$typeof']] || $0a3408eb578c99cd$var$REACT_STATICS;
}
var $0a3408eb578c99cd$var$defineProperty = Object.defineProperty;
var $0a3408eb578c99cd$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0a3408eb578c99cd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0a3408eb578c99cd$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0a3408eb578c99cd$var$getPrototypeOf = Object.getPrototypeOf;
var $0a3408eb578c99cd$var$objectPrototype = Object.prototype;
function $0a3408eb578c99cd$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($0a3408eb578c99cd$var$objectPrototype) {
            var inheritedComponent = $0a3408eb578c99cd$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0a3408eb578c99cd$var$objectPrototype) $0a3408eb578c99cd$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $0a3408eb578c99cd$var$getOwnPropertyNames(sourceComponent);
        if ($0a3408eb578c99cd$var$getOwnPropertySymbols) keys = keys.concat($0a3408eb578c99cd$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $0a3408eb578c99cd$var$getStatics(targetComponent);
        var sourceStatics = $0a3408eb578c99cd$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$0a3408eb578c99cd$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $0a3408eb578c99cd$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $0a3408eb578c99cd$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $0a3408eb578c99cd$var$hoistNonReactStatics;

});



parcelRegister("8f5i0", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6003d3cab6c5e55b$export$a143d493d941bafc; }, function (v) { return $6003d3cab6c5e55b$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $6003d3cab6c5e55b$export$e4cf37d7f6fb9e0a; }, function (v) { return $6003d3cab6c5e55b$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6003d3cab6c5e55b$export$f99ded8fe4b79145; }, function (v) { return $6003d3cab6c5e55b$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $6003d3cab6c5e55b$export$599f31c3813fae4d; }, function (v) { return $6003d3cab6c5e55b$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6003d3cab6c5e55b$export$a143d493d941bafc;
var $6003d3cab6c5e55b$export$e4cf37d7f6fb9e0a;
var $6003d3cab6c5e55b$export$f99ded8fe4b79145;
var $6003d3cab6c5e55b$export$599f31c3813fae4d;
'use strict';

var $4G7yA = parcelRequire("4G7yA");

var $cRxnA = parcelRequire("cRxnA");
const $6003d3cab6c5e55b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6003d3cab6c5e55b$export$a143d493d941bafc = $6003d3cab6c5e55b$var$Buffer;
$6003d3cab6c5e55b$export$e4cf37d7f6fb9e0a = $6003d3cab6c5e55b$var$SlowBuffer;
$6003d3cab6c5e55b$export$f99ded8fe4b79145 = 50;
const $6003d3cab6c5e55b$var$K_MAX_LENGTH = 0x7fffffff;
$6003d3cab6c5e55b$export$599f31c3813fae4d = $6003d3cab6c5e55b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6003d3cab6c5e55b$var$Buffer.TYPED_ARRAY_SUPPORT = $6003d3cab6c5e55b$var$typedArraySupport();
if (!$6003d3cab6c5e55b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6003d3cab6c5e55b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6003d3cab6c5e55b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6003d3cab6c5e55b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6003d3cab6c5e55b$var$createBuffer(length) {
    if (length > $6003d3cab6c5e55b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6003d3cab6c5e55b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6003d3cab6c5e55b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6003d3cab6c5e55b$var$allocUnsafe(arg);
    }
    return $6003d3cab6c5e55b$var$from(arg, encodingOrOffset, length);
}
$6003d3cab6c5e55b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6003d3cab6c5e55b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6003d3cab6c5e55b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6003d3cab6c5e55b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6003d3cab6c5e55b$var$isInstance(value, ArrayBuffer) || value && $6003d3cab6c5e55b$var$isInstance(value.buffer, ArrayBuffer)) return $6003d3cab6c5e55b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6003d3cab6c5e55b$var$isInstance(value, SharedArrayBuffer) || value && $6003d3cab6c5e55b$var$isInstance(value.buffer, SharedArrayBuffer))) return $6003d3cab6c5e55b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6003d3cab6c5e55b$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6003d3cab6c5e55b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6003d3cab6c5e55b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6003d3cab6c5e55b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6003d3cab6c5e55b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6003d3cab6c5e55b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6003d3cab6c5e55b$var$Buffer, Uint8Array);
function $6003d3cab6c5e55b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6003d3cab6c5e55b$var$alloc(size, fill, encoding) {
    $6003d3cab6c5e55b$var$assertSize(size);
    if (size <= 0) return $6003d3cab6c5e55b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6003d3cab6c5e55b$var$createBuffer(size).fill(fill, encoding) : $6003d3cab6c5e55b$var$createBuffer(size).fill(fill);
    return $6003d3cab6c5e55b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6003d3cab6c5e55b$var$Buffer.alloc = function(size, fill, encoding) {
    return $6003d3cab6c5e55b$var$alloc(size, fill, encoding);
};
function $6003d3cab6c5e55b$var$allocUnsafe(size) {
    $6003d3cab6c5e55b$var$assertSize(size);
    return $6003d3cab6c5e55b$var$createBuffer(size < 0 ? 0 : $6003d3cab6c5e55b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6003d3cab6c5e55b$var$Buffer.allocUnsafe = function(size) {
    return $6003d3cab6c5e55b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6003d3cab6c5e55b$var$Buffer.allocUnsafeSlow = function(size) {
    return $6003d3cab6c5e55b$var$allocUnsafe(size);
};
function $6003d3cab6c5e55b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6003d3cab6c5e55b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6003d3cab6c5e55b$var$byteLength(string, encoding) | 0;
    let buf = $6003d3cab6c5e55b$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6003d3cab6c5e55b$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6003d3cab6c5e55b$var$checked(array.length) | 0;
    const buf = $6003d3cab6c5e55b$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6003d3cab6c5e55b$var$fromArrayView(arrayView) {
    if ($6003d3cab6c5e55b$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6003d3cab6c5e55b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6003d3cab6c5e55b$var$fromArrayLike(arrayView);
}
function $6003d3cab6c5e55b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6003d3cab6c5e55b$var$Buffer.prototype);
    return buf;
}
function $6003d3cab6c5e55b$var$fromObject(obj) {
    if ($6003d3cab6c5e55b$var$Buffer.isBuffer(obj)) {
        const len = $6003d3cab6c5e55b$var$checked(obj.length) | 0;
        const buf = $6003d3cab6c5e55b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6003d3cab6c5e55b$var$numberIsNaN(obj.length)) return $6003d3cab6c5e55b$var$createBuffer(0);
        return $6003d3cab6c5e55b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6003d3cab6c5e55b$var$fromArrayLike(obj.data);
}
function $6003d3cab6c5e55b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6003d3cab6c5e55b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6003d3cab6c5e55b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6003d3cab6c5e55b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6003d3cab6c5e55b$var$Buffer.alloc(+length);
}
$6003d3cab6c5e55b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6003d3cab6c5e55b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6003d3cab6c5e55b$var$Buffer.compare = function compare(a, b) {
    if ($6003d3cab6c5e55b$var$isInstance(a, Uint8Array)) a = $6003d3cab6c5e55b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6003d3cab6c5e55b$var$isInstance(b, Uint8Array)) b = $6003d3cab6c5e55b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(a) || !$6003d3cab6c5e55b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6003d3cab6c5e55b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6003d3cab6c5e55b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6003d3cab6c5e55b$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6003d3cab6c5e55b$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6003d3cab6c5e55b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(buf)) buf = $6003d3cab6c5e55b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6003d3cab6c5e55b$var$byteLength(string, encoding) {
    if ($6003d3cab6c5e55b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6003d3cab6c5e55b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6003d3cab6c5e55b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6003d3cab6c5e55b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6003d3cab6c5e55b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6003d3cab6c5e55b$var$Buffer.byteLength = $6003d3cab6c5e55b$var$byteLength;
function $6003d3cab6c5e55b$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6003d3cab6c5e55b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6003d3cab6c5e55b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6003d3cab6c5e55b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6003d3cab6c5e55b$var$latin1Slice(this, start, end);
        case 'base64':
            return $6003d3cab6c5e55b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6003d3cab6c5e55b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6003d3cab6c5e55b$var$Buffer.prototype._isBuffer = true;
function $6003d3cab6c5e55b$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6003d3cab6c5e55b$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6003d3cab6c5e55b$var$swap(this, i, i + 1);
    return this;
};
$6003d3cab6c5e55b$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6003d3cab6c5e55b$var$swap(this, i, i + 3);
        $6003d3cab6c5e55b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6003d3cab6c5e55b$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6003d3cab6c5e55b$var$swap(this, i, i + 7);
        $6003d3cab6c5e55b$var$swap(this, i + 1, i + 6);
        $6003d3cab6c5e55b$var$swap(this, i + 2, i + 5);
        $6003d3cab6c5e55b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6003d3cab6c5e55b$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6003d3cab6c5e55b$var$utf8Slice(this, 0, length);
    return $6003d3cab6c5e55b$var$slowToString.apply(this, arguments);
};
$6003d3cab6c5e55b$var$Buffer.prototype.toLocaleString = $6003d3cab6c5e55b$var$Buffer.prototype.toString;
$6003d3cab6c5e55b$var$Buffer.prototype.equals = function equals(b) {
    if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6003d3cab6c5e55b$var$Buffer.compare(this, b) === 0;
};
$6003d3cab6c5e55b$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6003d3cab6c5e55b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6003d3cab6c5e55b$var$customInspectSymbol) $6003d3cab6c5e55b$var$Buffer.prototype[$6003d3cab6c5e55b$var$customInspectSymbol] = $6003d3cab6c5e55b$var$Buffer.prototype.inspect;
$6003d3cab6c5e55b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6003d3cab6c5e55b$var$isInstance(target, Uint8Array)) target = $6003d3cab6c5e55b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6003d3cab6c5e55b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6003d3cab6c5e55b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6003d3cab6c5e55b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6003d3cab6c5e55b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6003d3cab6c5e55b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6003d3cab6c5e55b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6003d3cab6c5e55b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6003d3cab6c5e55b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6003d3cab6c5e55b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6003d3cab6c5e55b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6003d3cab6c5e55b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6003d3cab6c5e55b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6003d3cab6c5e55b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6003d3cab6c5e55b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6003d3cab6c5e55b$var$utf8Write(buf, string, offset, length) {
    return $6003d3cab6c5e55b$var$blitBuffer($6003d3cab6c5e55b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6003d3cab6c5e55b$var$asciiWrite(buf, string, offset, length) {
    return $6003d3cab6c5e55b$var$blitBuffer($6003d3cab6c5e55b$var$asciiToBytes(string), buf, offset, length);
}
function $6003d3cab6c5e55b$var$base64Write(buf, string, offset, length) {
    return $6003d3cab6c5e55b$var$blitBuffer($6003d3cab6c5e55b$var$base64ToBytes(string), buf, offset, length);
}
function $6003d3cab6c5e55b$var$ucs2Write(buf, string, offset, length) {
    return $6003d3cab6c5e55b$var$blitBuffer($6003d3cab6c5e55b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6003d3cab6c5e55b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6003d3cab6c5e55b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6003d3cab6c5e55b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6003d3cab6c5e55b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6003d3cab6c5e55b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6003d3cab6c5e55b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6003d3cab6c5e55b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6003d3cab6c5e55b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4G7yA.fromByteArray(buf);
    else return $4G7yA.fromByteArray(buf.slice(start, end));
}
function $6003d3cab6c5e55b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6003d3cab6c5e55b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6003d3cab6c5e55b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6003d3cab6c5e55b$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6003d3cab6c5e55b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6003d3cab6c5e55b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6003d3cab6c5e55b$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6003d3cab6c5e55b$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6003d3cab6c5e55b$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6003d3cab6c5e55b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6003d3cab6c5e55b$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6003d3cab6c5e55b$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6003d3cab6c5e55b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6003d3cab6c5e55b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6003d3cab6c5e55b$var$Buffer.prototype.readUintLE = $6003d3cab6c5e55b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUintBE = $6003d3cab6c5e55b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUint8 = $6003d3cab6c5e55b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUint16LE = $6003d3cab6c5e55b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUint16BE = $6003d3cab6c5e55b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUint32LE = $6003d3cab6c5e55b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readUint32BE = $6003d3cab6c5e55b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6003d3cab6c5e55b$var$Buffer.prototype.readBigUInt64LE = $6003d3cab6c5e55b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6003d3cab6c5e55b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6003d3cab6c5e55b$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6003d3cab6c5e55b$var$Buffer.prototype.readBigUInt64BE = $6003d3cab6c5e55b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6003d3cab6c5e55b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6003d3cab6c5e55b$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6003d3cab6c5e55b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6003d3cab6c5e55b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6003d3cab6c5e55b$var$Buffer.prototype.readBigInt64LE = $6003d3cab6c5e55b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6003d3cab6c5e55b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6003d3cab6c5e55b$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6003d3cab6c5e55b$var$Buffer.prototype.readBigInt64BE = $6003d3cab6c5e55b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6003d3cab6c5e55b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6003d3cab6c5e55b$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6003d3cab6c5e55b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return $cRxnA.read(this, offset, true, 23, 4);
};
$6003d3cab6c5e55b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 4, this.length);
    return $cRxnA.read(this, offset, false, 23, 4);
};
$6003d3cab6c5e55b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 8, this.length);
    return $cRxnA.read(this, offset, true, 52, 8);
};
$6003d3cab6c5e55b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkOffset(offset, 8, this.length);
    return $cRxnA.read(this, offset, false, 52, 8);
};
function $6003d3cab6c5e55b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6003d3cab6c5e55b$var$Buffer.prototype.writeUintLE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6003d3cab6c5e55b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUintBE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6003d3cab6c5e55b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUint8 = $6003d3cab6c5e55b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUint16LE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUint16BE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUint32LE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeUint32BE = $6003d3cab6c5e55b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6003d3cab6c5e55b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6003d3cab6c5e55b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6003d3cab6c5e55b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6003d3cab6c5e55b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6003d3cab6c5e55b$var$Buffer.prototype.writeBigUInt64LE = $6003d3cab6c5e55b$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6003d3cab6c5e55b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6003d3cab6c5e55b$var$Buffer.prototype.writeBigUInt64BE = $6003d3cab6c5e55b$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6003d3cab6c5e55b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6003d3cab6c5e55b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6003d3cab6c5e55b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6003d3cab6c5e55b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeBigInt64LE = $6003d3cab6c5e55b$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6003d3cab6c5e55b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6003d3cab6c5e55b$var$Buffer.prototype.writeBigInt64BE = $6003d3cab6c5e55b$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6003d3cab6c5e55b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6003d3cab6c5e55b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6003d3cab6c5e55b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cRxnA.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6003d3cab6c5e55b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6003d3cab6c5e55b$var$writeFloat(this, value, offset, true, noAssert);
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6003d3cab6c5e55b$var$writeFloat(this, value, offset, false, noAssert);
};
function $6003d3cab6c5e55b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6003d3cab6c5e55b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cRxnA.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6003d3cab6c5e55b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6003d3cab6c5e55b$var$writeDouble(this, value, offset, true, noAssert);
};
$6003d3cab6c5e55b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6003d3cab6c5e55b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6003d3cab6c5e55b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6003d3cab6c5e55b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6003d3cab6c5e55b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6003d3cab6c5e55b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6003d3cab6c5e55b$var$Buffer.isBuffer(val) ? val : $6003d3cab6c5e55b$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6003d3cab6c5e55b$var$errors = {};
function $6003d3cab6c5e55b$var$E(sym, getMessage, Base) {
    $6003d3cab6c5e55b$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$6003d3cab6c5e55b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6003d3cab6c5e55b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6003d3cab6c5e55b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6003d3cab6c5e55b$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6003d3cab6c5e55b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6003d3cab6c5e55b$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6003d3cab6c5e55b$var$checkBounds(buf, offset, byteLength) {
    $6003d3cab6c5e55b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6003d3cab6c5e55b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6003d3cab6c5e55b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6003d3cab6c5e55b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6003d3cab6c5e55b$var$checkBounds(buf, offset, byteLength);
}
function $6003d3cab6c5e55b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6003d3cab6c5e55b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6003d3cab6c5e55b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6003d3cab6c5e55b$var$validateNumber(value, type);
        throw new $6003d3cab6c5e55b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6003d3cab6c5e55b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6003d3cab6c5e55b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6003d3cab6c5e55b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6003d3cab6c5e55b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6003d3cab6c5e55b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6003d3cab6c5e55b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6003d3cab6c5e55b$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6003d3cab6c5e55b$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6003d3cab6c5e55b$var$base64ToBytes(str) {
    return $4G7yA.toByteArray($6003d3cab6c5e55b$var$base64clean(str));
}
function $6003d3cab6c5e55b$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6003d3cab6c5e55b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6003d3cab6c5e55b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6003d3cab6c5e55b$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6003d3cab6c5e55b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6003d3cab6c5e55b$var$BufferBigIntNotDefined : fn;
}
function $6003d3cab6c5e55b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("4G7yA", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3680f248e8a1c800$export$d622b2ad8d90c771; }, function (v) { return $3680f248e8a1c800$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3680f248e8a1c800$export$6100ba28696e12de; }, function (v) { return $3680f248e8a1c800$export$6100ba28696e12de = v; });
var $3680f248e8a1c800$export$a48f0734ac7c2329;
var $3680f248e8a1c800$export$d622b2ad8d90c771;
var $3680f248e8a1c800$export$6100ba28696e12de;
'use strict';
$3680f248e8a1c800$export$a48f0734ac7c2329 = $3680f248e8a1c800$var$byteLength;
$3680f248e8a1c800$export$d622b2ad8d90c771 = $3680f248e8a1c800$var$toByteArray;
$3680f248e8a1c800$export$6100ba28696e12de = $3680f248e8a1c800$var$fromByteArray;
var $3680f248e8a1c800$var$lookup = [];
var $3680f248e8a1c800$var$revLookup = [];
var $3680f248e8a1c800$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3680f248e8a1c800$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3680f248e8a1c800$var$i = 0, $3680f248e8a1c800$var$len = $3680f248e8a1c800$var$code.length; $3680f248e8a1c800$var$i < $3680f248e8a1c800$var$len; ++$3680f248e8a1c800$var$i){
    $3680f248e8a1c800$var$lookup[$3680f248e8a1c800$var$i] = $3680f248e8a1c800$var$code[$3680f248e8a1c800$var$i];
    $3680f248e8a1c800$var$revLookup[$3680f248e8a1c800$var$code.charCodeAt($3680f248e8a1c800$var$i)] = $3680f248e8a1c800$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3680f248e8a1c800$var$revLookup['-'.charCodeAt(0)] = 62;
$3680f248e8a1c800$var$revLookup['_'.charCodeAt(0)] = 63;
function $3680f248e8a1c800$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3680f248e8a1c800$var$byteLength(b64) {
    var lens = $3680f248e8a1c800$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3680f248e8a1c800$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3680f248e8a1c800$var$toByteArray(b64) {
    var tmp;
    var lens = $3680f248e8a1c800$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3680f248e8a1c800$var$Arr($3680f248e8a1c800$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i)] << 18 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i)] << 2 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i)] << 10 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3680f248e8a1c800$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3680f248e8a1c800$var$tripletToBase64(num) {
    return $3680f248e8a1c800$var$lookup[num >> 18 & 0x3F] + $3680f248e8a1c800$var$lookup[num >> 12 & 0x3F] + $3680f248e8a1c800$var$lookup[num >> 6 & 0x3F] + $3680f248e8a1c800$var$lookup[num & 0x3F];
}
function $3680f248e8a1c800$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3680f248e8a1c800$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3680f248e8a1c800$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3680f248e8a1c800$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3680f248e8a1c800$var$lookup[tmp >> 2] + $3680f248e8a1c800$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3680f248e8a1c800$var$lookup[tmp >> 10] + $3680f248e8a1c800$var$lookup[tmp >> 4 & 0x3F] + $3680f248e8a1c800$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("cRxnA", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $95d453bc19b00632$export$aafa59e2e03f2942; }, function (v) { return $95d453bc19b00632$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $95d453bc19b00632$export$68d8715fc104d294; }, function (v) { return $95d453bc19b00632$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $95d453bc19b00632$export$aafa59e2e03f2942;
var $95d453bc19b00632$export$68d8715fc104d294;
$95d453bc19b00632$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$95d453bc19b00632$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3Mgi6", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('unable to locate global object');
};
var global = getGlobal();
module.exports = exports = global.fetch;
// Needed for TypeScript and Webpack.
if (global.fetch) exports.default = global.fetch.bind(global);
exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

});

parcelRegister("4JjTn", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $371acb963cf1627b$export$5f828d93ff035aa8; }, function (v) { return $371acb963cf1627b$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $371acb963cf1627b$export$cd94982b18c6332c; }, function (v) { return $371acb963cf1627b$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $371acb963cf1627b$export$1d518568e4f529b0; }, function (v) { return $371acb963cf1627b$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $371acb963cf1627b$export$5285b6d41c912b41; }, function (v) { return $371acb963cf1627b$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $371acb963cf1627b$export$2fb37efbf6ae0c0e; }, function (v) { return $371acb963cf1627b$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $371acb963cf1627b$export$ab85ecd77ce6a5cd; }, function (v) { return $371acb963cf1627b$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $371acb963cf1627b$export$da39cf97e1eb7c91; }, function (v) { return $371acb963cf1627b$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $371acb963cf1627b$export$52a9039d7177394f; }, function (v) { return $371acb963cf1627b$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $371acb963cf1627b$export$f7201db400317331; }, function (v) { return $371acb963cf1627b$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $371acb963cf1627b$export$448fa22aedc9dbca; }, function (v) { return $371acb963cf1627b$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $371acb963cf1627b$export$b80c7ba289c8fa56; }, function (v) { return $371acb963cf1627b$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $371acb963cf1627b$export$26e5786e8ac8e530; }, function (v) { return $371acb963cf1627b$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $371acb963cf1627b$export$bdd223f16383713e; }, function (v) { return $371acb963cf1627b$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $371acb963cf1627b$export$20533d26f07f1ee0; }, function (v) { return $371acb963cf1627b$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $371acb963cf1627b$export$2f64596b8cbf08b4; }, function (v) { return $371acb963cf1627b$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $371acb963cf1627b$export$2ce6d8d0e8b04e1a; }, function (v) { return $371acb963cf1627b$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $371acb963cf1627b$export$12ada9414fbc594c; }, function (v) { return $371acb963cf1627b$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $371acb963cf1627b$export$f5e7e39d57cd9700; }, function (v) { return $371acb963cf1627b$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $371acb963cf1627b$export$36b6d6ef312eab39; }, function (v) { return $371acb963cf1627b$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $371acb963cf1627b$export$58a258485f1e49f6; }, function (v) { return $371acb963cf1627b$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $371acb963cf1627b$export$dedd8dc3dc62b370; }, function (v) { return $371acb963cf1627b$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $371acb963cf1627b$export$971862a2fcb1bb40; }, function (v) { return $371acb963cf1627b$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $371acb963cf1627b$export$c6ff6a88acbeaf40; }, function (v) { return $371acb963cf1627b$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $371acb963cf1627b$export$fdc27893e98845cc; }, function (v) { return $371acb963cf1627b$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $371acb963cf1627b$export$6671fb9a1323bed; }, function (v) { return $371acb963cf1627b$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $371acb963cf1627b$export$d74daf141a551db; }, function (v) { return $371acb963cf1627b$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $371acb963cf1627b$export$45df7cae684751af; }, function (v) { return $371acb963cf1627b$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $371acb963cf1627b$export$1db683ad541682f6; }, function (v) { return $371acb963cf1627b$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $371acb963cf1627b$export$6f65485f87568e37; }, function (v) { return $371acb963cf1627b$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $371acb963cf1627b$export$91a8e56769aeb334; }, function (v) { return $371acb963cf1627b$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $371acb963cf1627b$export$2d4117e99c2179e4; }, function (v) { return $371acb963cf1627b$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $371acb963cf1627b$export$512823e338ddb1b7; }, function (v) { return $371acb963cf1627b$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $371acb963cf1627b$export$9d0e0c0c4a8d30f3; }, function (v) { return $371acb963cf1627b$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $371acb963cf1627b$export$b9d55ff329113abd; }, function (v) { return $371acb963cf1627b$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $371acb963cf1627b$export$7efb24e2fddf99b9; }, function (v) { return $371acb963cf1627b$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $371acb963cf1627b$export$bb1abf2ce84fc7e8; }, function (v) { return $371acb963cf1627b$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $371acb963cf1627b$export$2f7171e78e524d5e; }, function (v) { return $371acb963cf1627b$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $371acb963cf1627b$export$e1d879b482f37d98; }, function (v) { return $371acb963cf1627b$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $371acb963cf1627b$export$1a988e7317c65621; }, function (v) { return $371acb963cf1627b$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $371acb963cf1627b$export$5f828d93ff035aa8;
var $371acb963cf1627b$export$cd94982b18c6332c;
var $371acb963cf1627b$export$1d518568e4f529b0;
var $371acb963cf1627b$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $371acb963cf1627b$export$2fb37efbf6ae0c0e;
var $371acb963cf1627b$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $371acb963cf1627b$export$da39cf97e1eb7c91;
var $371acb963cf1627b$export$52a9039d7177394f;
var $371acb963cf1627b$export$f7201db400317331;
var $371acb963cf1627b$export$448fa22aedc9dbca;
var $371acb963cf1627b$export$b80c7ba289c8fa56;
var $371acb963cf1627b$export$26e5786e8ac8e530;
var $371acb963cf1627b$export$bdd223f16383713e;
var $371acb963cf1627b$export$20533d26f07f1ee0;
var $371acb963cf1627b$export$2f64596b8cbf08b4;
var $371acb963cf1627b$export$2ce6d8d0e8b04e1a;
var $371acb963cf1627b$export$12ada9414fbc594c;
var $371acb963cf1627b$export$f5e7e39d57cd9700;
var $371acb963cf1627b$export$36b6d6ef312eab39;
var $371acb963cf1627b$export$58a258485f1e49f6;
var $371acb963cf1627b$export$dedd8dc3dc62b370;
var $371acb963cf1627b$export$971862a2fcb1bb40;
var $371acb963cf1627b$export$c6ff6a88acbeaf40;
var $371acb963cf1627b$export$fdc27893e98845cc;
var $371acb963cf1627b$export$6671fb9a1323bed;
var $371acb963cf1627b$export$d74daf141a551db;
var $371acb963cf1627b$export$45df7cae684751af;
var $371acb963cf1627b$export$1db683ad541682f6;
var $371acb963cf1627b$export$6f65485f87568e37;
var $371acb963cf1627b$export$91a8e56769aeb334;
var $371acb963cf1627b$export$2d4117e99c2179e4;
var $371acb963cf1627b$export$512823e338ddb1b7;
var $371acb963cf1627b$export$9d0e0c0c4a8d30f3;
var $371acb963cf1627b$export$b9d55ff329113abd;
var $371acb963cf1627b$export$7efb24e2fddf99b9;
var $371acb963cf1627b$export$bb1abf2ce84fc7e8;
var $371acb963cf1627b$export$2f7171e78e524d5e;
var $371acb963cf1627b$export$e1d879b482f37d98;
var $371acb963cf1627b$export$1a988e7317c65621;
'use strict';

$371acb963cf1627b$export$5f828d93ff035aa8 = $371acb963cf1627b$export$cd94982b18c6332c = $371acb963cf1627b$export$1d518568e4f529b0 = $371acb963cf1627b$export$5285b6d41c912b41 = (parcelRequire("9FI1O"));

$371acb963cf1627b$export$2fb37efbf6ae0c0e = $371acb963cf1627b$export$ab85ecd77ce6a5cd = (parcelRequire("3KMVQ"));

$371acb963cf1627b$export$da39cf97e1eb7c91 = $371acb963cf1627b$export$52a9039d7177394f = (parcelRequire("kJE7u"));

var $xqD8r = parcelRequire("xqD8r");
var $371acb963cf1627b$var$algoKeys = Object.keys($xqD8r);
var $371acb963cf1627b$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($371acb963cf1627b$var$algoKeys);
$371acb963cf1627b$export$f7201db400317331 = function() {
    return $371acb963cf1627b$var$hashes;
};

var $4tG8V = parcelRequire("4tG8V");
$371acb963cf1627b$export$448fa22aedc9dbca = $4tG8V.pbkdf2;
$371acb963cf1627b$export$b80c7ba289c8fa56 = $4tG8V.pbkdf2Sync;

var $AW5CM = parcelRequire("AW5CM");
$371acb963cf1627b$export$26e5786e8ac8e530 = $AW5CM.Cipher;
$371acb963cf1627b$export$bdd223f16383713e = $AW5CM.createCipher;
$371acb963cf1627b$export$20533d26f07f1ee0 = $AW5CM.Cipheriv;
$371acb963cf1627b$export$2f64596b8cbf08b4 = $AW5CM.createCipheriv;
$371acb963cf1627b$export$2ce6d8d0e8b04e1a = $AW5CM.Decipher;
$371acb963cf1627b$export$12ada9414fbc594c = $AW5CM.createDecipher;
$371acb963cf1627b$export$f5e7e39d57cd9700 = $AW5CM.Decipheriv;
$371acb963cf1627b$export$36b6d6ef312eab39 = $AW5CM.createDecipheriv;
$371acb963cf1627b$export$58a258485f1e49f6 = $AW5CM.getCiphers;
$371acb963cf1627b$export$dedd8dc3dc62b370 = $AW5CM.listCiphers;

var $fX8f5 = parcelRequire("fX8f5");
$371acb963cf1627b$export$971862a2fcb1bb40 = $fX8f5.DiffieHellmanGroup;
$371acb963cf1627b$export$c6ff6a88acbeaf40 = $fX8f5.createDiffieHellmanGroup;
$371acb963cf1627b$export$fdc27893e98845cc = $fX8f5.getDiffieHellman;
$371acb963cf1627b$export$6671fb9a1323bed = $fX8f5.createDiffieHellman;
$371acb963cf1627b$export$d74daf141a551db = $fX8f5.DiffieHellman;

var $5z5tv = parcelRequire("5z5tv");
$371acb963cf1627b$export$45df7cae684751af = $5z5tv.createSign;
$371acb963cf1627b$export$1db683ad541682f6 = $5z5tv.Sign;
$371acb963cf1627b$export$6f65485f87568e37 = $5z5tv.createVerify;
$371acb963cf1627b$export$91a8e56769aeb334 = $5z5tv.Verify;

$371acb963cf1627b$export$2d4117e99c2179e4 = (parcelRequire("ccnYK"));

var $apyZB = parcelRequire("apyZB");
$371acb963cf1627b$export$512823e338ddb1b7 = $apyZB.publicEncrypt;
$371acb963cf1627b$export$9d0e0c0c4a8d30f3 = $apyZB.privateEncrypt;
$371acb963cf1627b$export$b9d55ff329113abd = $apyZB.publicDecrypt;
$371acb963cf1627b$export$7efb24e2fddf99b9 = $apyZB.privateDecrypt;

var $crqwP = parcelRequire("crqwP");
$371acb963cf1627b$export$bb1abf2ce84fc7e8 = $crqwP.randomFill;
$371acb963cf1627b$export$2f7171e78e524d5e = $crqwP.randomFillSync;
$371acb963cf1627b$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$371acb963cf1627b$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("9FI1O", function(module, exports) {

var $3iXjX = parcelRequire("3iXjX");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $70aa18775d07da3b$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $70aa18775d07da3b$var$MAX_UINT32 = 4294967295;
function $70aa18775d07da3b$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $BUCDt = parcelRequire("BUCDt");
var $70aa18775d07da3b$require$Buffer = $BUCDt.Buffer;
var $70aa18775d07da3b$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($70aa18775d07da3b$var$crypto && $70aa18775d07da3b$var$crypto.getRandomValues) module.exports = $70aa18775d07da3b$var$randomBytes;
else module.exports = $70aa18775d07da3b$var$oldBrowser;
function $70aa18775d07da3b$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $70aa18775d07da3b$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $70aa18775d07da3b$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $70aa18775d07da3b$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $70aa18775d07da3b$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $70aa18775d07da3b$var$crypto.getRandomValues(bytes.slice(generated, generated + $70aa18775d07da3b$var$MAX_BYTES));
        else $70aa18775d07da3b$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $3iXjX.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("3iXjX", function(module, exports) {
// shim for using process in browser
var $2681116858823cd2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2681116858823cd2$var$cachedSetTimeout;
var $2681116858823cd2$var$cachedClearTimeout;
function $2681116858823cd2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2681116858823cd2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2681116858823cd2$var$cachedSetTimeout = setTimeout;
        else $2681116858823cd2$var$cachedSetTimeout = $2681116858823cd2$var$defaultSetTimout;
    } catch (e) {
        $2681116858823cd2$var$cachedSetTimeout = $2681116858823cd2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2681116858823cd2$var$cachedClearTimeout = clearTimeout;
        else $2681116858823cd2$var$cachedClearTimeout = $2681116858823cd2$var$defaultClearTimeout;
    } catch (e) {
        $2681116858823cd2$var$cachedClearTimeout = $2681116858823cd2$var$defaultClearTimeout;
    }
})();
function $2681116858823cd2$var$runTimeout(fun) {
    if ($2681116858823cd2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2681116858823cd2$var$cachedSetTimeout === $2681116858823cd2$var$defaultSetTimout || !$2681116858823cd2$var$cachedSetTimeout) && setTimeout) {
        $2681116858823cd2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2681116858823cd2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2681116858823cd2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2681116858823cd2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2681116858823cd2$var$runClearTimeout(marker) {
    if ($2681116858823cd2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2681116858823cd2$var$cachedClearTimeout === $2681116858823cd2$var$defaultClearTimeout || !$2681116858823cd2$var$cachedClearTimeout) && clearTimeout) {
        $2681116858823cd2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2681116858823cd2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2681116858823cd2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2681116858823cd2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2681116858823cd2$var$queue = [];
var $2681116858823cd2$var$draining = false;
var $2681116858823cd2$var$currentQueue;
var $2681116858823cd2$var$queueIndex = -1;
function $2681116858823cd2$var$cleanUpNextTick() {
    if (!$2681116858823cd2$var$draining || !$2681116858823cd2$var$currentQueue) return;
    $2681116858823cd2$var$draining = false;
    if ($2681116858823cd2$var$currentQueue.length) $2681116858823cd2$var$queue = $2681116858823cd2$var$currentQueue.concat($2681116858823cd2$var$queue);
    else $2681116858823cd2$var$queueIndex = -1;
    if ($2681116858823cd2$var$queue.length) $2681116858823cd2$var$drainQueue();
}
function $2681116858823cd2$var$drainQueue() {
    if ($2681116858823cd2$var$draining) return;
    var timeout = $2681116858823cd2$var$runTimeout($2681116858823cd2$var$cleanUpNextTick);
    $2681116858823cd2$var$draining = true;
    var len = $2681116858823cd2$var$queue.length;
    while(len){
        $2681116858823cd2$var$currentQueue = $2681116858823cd2$var$queue;
        $2681116858823cd2$var$queue = [];
        while(++$2681116858823cd2$var$queueIndex < len)if ($2681116858823cd2$var$currentQueue) $2681116858823cd2$var$currentQueue[$2681116858823cd2$var$queueIndex].run();
        $2681116858823cd2$var$queueIndex = -1;
        len = $2681116858823cd2$var$queue.length;
    }
    $2681116858823cd2$var$currentQueue = null;
    $2681116858823cd2$var$draining = false;
    $2681116858823cd2$var$runClearTimeout(timeout);
}
$2681116858823cd2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2681116858823cd2$var$queue.push(new $2681116858823cd2$var$Item(fun, args));
    if ($2681116858823cd2$var$queue.length === 1 && !$2681116858823cd2$var$draining) $2681116858823cd2$var$runTimeout($2681116858823cd2$var$drainQueue);
};
// v8 likes predictible objects
function $2681116858823cd2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2681116858823cd2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2681116858823cd2$var$process.title = 'browser';
$2681116858823cd2$var$process.browser = true;
$2681116858823cd2$var$process.env = {};
$2681116858823cd2$var$process.argv = [];
$2681116858823cd2$var$process.version = ''; // empty string to avoid regexp issues
$2681116858823cd2$var$process.versions = {};
function $2681116858823cd2$var$noop() {}
$2681116858823cd2$var$process.on = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.addListener = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.once = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.off = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.removeListener = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.removeAllListeners = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.emit = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.prependListener = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.prependOnceListener = $2681116858823cd2$var$noop;
$2681116858823cd2$var$process.listeners = function(name) {
    return [];
};
$2681116858823cd2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2681116858823cd2$var$process.cwd = function() {
    return '/';
};
$2681116858823cd2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2681116858823cd2$var$process.umask = function() {
    return 0;
};

});

parcelRegister("BUCDt", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $8f5i0 = parcelRequire("8f5i0");
var $071f60cbe5466641$var$Buffer = $8f5i0.Buffer;
// alternative to using Object.keys for old browsers
function $071f60cbe5466641$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($071f60cbe5466641$var$Buffer.from && $071f60cbe5466641$var$Buffer.alloc && $071f60cbe5466641$var$Buffer.allocUnsafe && $071f60cbe5466641$var$Buffer.allocUnsafeSlow) module.exports = $8f5i0;
else {
    // Copy properties from require('buffer')
    $071f60cbe5466641$var$copyProps($8f5i0, module.exports);
    module.exports.Buffer = $071f60cbe5466641$var$SafeBuffer;
}
function $071f60cbe5466641$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $071f60cbe5466641$var$Buffer(arg, encodingOrOffset, length);
}
$071f60cbe5466641$var$SafeBuffer.prototype = Object.create($071f60cbe5466641$var$Buffer.prototype);
// Copy static methods from Buffer
$071f60cbe5466641$var$copyProps($071f60cbe5466641$var$Buffer, $071f60cbe5466641$var$SafeBuffer);
$071f60cbe5466641$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $071f60cbe5466641$var$Buffer(arg, encodingOrOffset, length);
};
$071f60cbe5466641$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $071f60cbe5466641$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$071f60cbe5466641$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $071f60cbe5466641$var$Buffer(size);
};
$071f60cbe5466641$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8f5i0.SlowBuffer(size);
};

});


parcelRegister("3KMVQ", function(module, exports) {
'use strict';

var $bVy58 = parcelRequire("bVy58");

var $cqxFF = parcelRequire("cqxFF");

var $fboL1 = parcelRequire("fboL1");

var $3qMts = parcelRequire("3qMts");

var $c7vVf = parcelRequire("c7vVf");
function $2bbb9fd33bfcf9d8$var$Hash(hash) {
    $c7vVf.call(this, 'digest');
    this._hash = hash;
}
$bVy58($2bbb9fd33bfcf9d8$var$Hash, $c7vVf);
$2bbb9fd33bfcf9d8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2bbb9fd33bfcf9d8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $cqxFF();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $fboL1();
    return new $2bbb9fd33bfcf9d8$var$Hash($3qMts(alg));
};

});
parcelRegister("bVy58", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("cqxFF", function(module, exports) {
'use strict';

var $bVy58 = parcelRequire("bVy58");

var $5EoX1 = parcelRequire("5EoX1");

var $BUCDt = parcelRequire("BUCDt");
var $90c2081e9b6b6048$require$Buffer = $BUCDt.Buffer;
var $90c2081e9b6b6048$var$ARRAY16 = new Array(16);
function $90c2081e9b6b6048$var$MD5() {
    $5EoX1.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$bVy58($90c2081e9b6b6048$var$MD5, $5EoX1);
$90c2081e9b6b6048$var$MD5.prototype._update = function() {
    var M = $90c2081e9b6b6048$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $90c2081e9b6b6048$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $90c2081e9b6b6048$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $90c2081e9b6b6048$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $90c2081e9b6b6048$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $90c2081e9b6b6048$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $90c2081e9b6b6048$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $90c2081e9b6b6048$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $90c2081e9b6b6048$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $90c2081e9b6b6048$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $90c2081e9b6b6048$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $90c2081e9b6b6048$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $90c2081e9b6b6048$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $90c2081e9b6b6048$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $90c2081e9b6b6048$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $90c2081e9b6b6048$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $90c2081e9b6b6048$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $90c2081e9b6b6048$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $90c2081e9b6b6048$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $90c2081e9b6b6048$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $90c2081e9b6b6048$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $90c2081e9b6b6048$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $90c2081e9b6b6048$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $90c2081e9b6b6048$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $90c2081e9b6b6048$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $90c2081e9b6b6048$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $90c2081e9b6b6048$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $90c2081e9b6b6048$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $90c2081e9b6b6048$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $90c2081e9b6b6048$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $90c2081e9b6b6048$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $90c2081e9b6b6048$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $90c2081e9b6b6048$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $90c2081e9b6b6048$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $90c2081e9b6b6048$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $90c2081e9b6b6048$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $90c2081e9b6b6048$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $90c2081e9b6b6048$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $90c2081e9b6b6048$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $90c2081e9b6b6048$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $90c2081e9b6b6048$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $90c2081e9b6b6048$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $90c2081e9b6b6048$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $90c2081e9b6b6048$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $90c2081e9b6b6048$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $90c2081e9b6b6048$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $90c2081e9b6b6048$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $90c2081e9b6b6048$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $90c2081e9b6b6048$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $90c2081e9b6b6048$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $90c2081e9b6b6048$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $90c2081e9b6b6048$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $90c2081e9b6b6048$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $90c2081e9b6b6048$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $90c2081e9b6b6048$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $90c2081e9b6b6048$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $90c2081e9b6b6048$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $90c2081e9b6b6048$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $90c2081e9b6b6048$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $90c2081e9b6b6048$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $90c2081e9b6b6048$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $90c2081e9b6b6048$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $90c2081e9b6b6048$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $90c2081e9b6b6048$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $90c2081e9b6b6048$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$90c2081e9b6b6048$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $90c2081e9b6b6048$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $90c2081e9b6b6048$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $90c2081e9b6b6048$var$fnF(a, b, c, d, m, k, s) {
    return $90c2081e9b6b6048$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $90c2081e9b6b6048$var$fnG(a, b, c, d, m, k, s) {
    return $90c2081e9b6b6048$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $90c2081e9b6b6048$var$fnH(a, b, c, d, m, k, s) {
    return $90c2081e9b6b6048$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $90c2081e9b6b6048$var$fnI(a, b, c, d, m, k, s) {
    return $90c2081e9b6b6048$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $90c2081e9b6b6048$var$MD5;

});
parcelRegister("5EoX1", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $41d40aebb783549b$require$Buffer = $BUCDt.Buffer;

var $aR9XM = parcelRequire("aR9XM");
var $41d40aebb783549b$require$Transform = $aR9XM.Transform;

var $bVy58 = parcelRequire("bVy58");
function $41d40aebb783549b$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$41d40aebb783549b$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $41d40aebb783549b$var$HashBase(blockSize) {
    $41d40aebb783549b$require$Transform.call(this);
    this._block = $41d40aebb783549b$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$bVy58($41d40aebb783549b$var$HashBase, $41d40aebb783549b$require$Transform);
$41d40aebb783549b$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$41d40aebb783549b$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$41d40aebb783549b$var$HashBase.prototype.update = function(data, encoding) {
    $41d40aebb783549b$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$41d40aebb783549b$require$Buffer.isBuffer(data)) data = $41d40aebb783549b$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$41d40aebb783549b$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$41d40aebb783549b$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$41d40aebb783549b$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $41d40aebb783549b$var$HashBase;

});
parcelRegister("aR9XM", function(module, exports) {

exports = module.exports = (parcelRequire("eHaR5"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("2HQXg"));

exports.Duplex = (parcelRequire("SmnH1"));

exports.Transform = (parcelRequire("ecjlu"));

exports.PassThrough = (parcelRequire("NHJdp"));

exports.finished = (parcelRequire("khBQN"));

exports.pipeline = (parcelRequire("77cYF"));

});
parcelRegister("eHaR5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3iXjX = parcelRequire("3iXjX");
'use strict';
module.exports = $ab2d8076101be907$var$Readable;
/*<replacement>*/ var $ab2d8076101be907$var$Duplex;
/*</replacement>*/ $ab2d8076101be907$var$Readable.ReadableState = $ab2d8076101be907$var$ReadableState;

var $cOXur = parcelRequire("cOXur");
var $ab2d8076101be907$require$EE = $cOXur.EventEmitter;
var $ab2d8076101be907$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $6URTI = parcelRequire("6URTI");

var $8f5i0 = parcelRequire("8f5i0");
var $ab2d8076101be907$require$Buffer = $8f5i0.Buffer;
var $ab2d8076101be907$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $ab2d8076101be907$var$_uint8ArrayToBuffer(chunk) {
    return $ab2d8076101be907$require$Buffer.from(chunk);
}
function $ab2d8076101be907$var$_isUint8Array(obj) {
    return $ab2d8076101be907$require$Buffer.isBuffer(obj) || obj instanceof $ab2d8076101be907$var$OurUint8Array;
}

var $fVZIf = parcelRequire("fVZIf");
var $ab2d8076101be907$var$debug;
if ($fVZIf && $fVZIf.debuglog) $ab2d8076101be907$var$debug = $fVZIf.debuglog('stream');
else $ab2d8076101be907$var$debug = function debug() {};

var $gB3wC = parcelRequire("gB3wC");

var $8ldX1 = parcelRequire("8ldX1");

var $bBnkr = parcelRequire("bBnkr");
var $ab2d8076101be907$var$getHighWaterMark = $bBnkr.getHighWaterMark;

var $8QIe8 = parcelRequire("8QIe8");
var $ab2d8076101be907$require$_require$codes = $8QIe8.codes;
var $ab2d8076101be907$var$ERR_INVALID_ARG_TYPE = $ab2d8076101be907$require$_require$codes.ERR_INVALID_ARG_TYPE, $ab2d8076101be907$var$ERR_STREAM_PUSH_AFTER_EOF = $ab2d8076101be907$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $ab2d8076101be907$var$ERR_METHOD_NOT_IMPLEMENTED = $ab2d8076101be907$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ab2d8076101be907$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $ab2d8076101be907$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $ab2d8076101be907$var$StringDecoder;
var $ab2d8076101be907$var$createReadableStreamAsyncIterator;
var $ab2d8076101be907$var$from;

(parcelRequire("bVy58"))($ab2d8076101be907$var$Readable, $6URTI);
var $ab2d8076101be907$var$errorOrDestroy = $8ldX1.errorOrDestroy;
var $ab2d8076101be907$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $ab2d8076101be907$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $ab2d8076101be907$var$ReadableState(options, stream, isDuplex) {
    $ab2d8076101be907$var$Duplex = $ab2d8076101be907$var$Duplex || (parcelRequire("SmnH1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $ab2d8076101be907$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $ab2d8076101be907$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $gB3wC();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$ab2d8076101be907$var$StringDecoder) $ab2d8076101be907$var$StringDecoder = (parcelRequire("fggZn")).StringDecoder;
        this.decoder = new $ab2d8076101be907$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $ab2d8076101be907$var$Readable(options) {
    $ab2d8076101be907$var$Duplex = $ab2d8076101be907$var$Duplex || (parcelRequire("SmnH1"));
    if (!(this instanceof $ab2d8076101be907$var$Readable)) return new $ab2d8076101be907$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $ab2d8076101be907$var$Duplex;
    this._readableState = new $ab2d8076101be907$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $6URTI.call(this);
}
Object.defineProperty($ab2d8076101be907$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$ab2d8076101be907$var$Readable.prototype.destroy = $8ldX1.destroy;
$ab2d8076101be907$var$Readable.prototype._undestroy = $8ldX1.undestroy;
$ab2d8076101be907$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$ab2d8076101be907$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $ab2d8076101be907$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $ab2d8076101be907$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$ab2d8076101be907$var$Readable.prototype.unshift = function(chunk) {
    return $ab2d8076101be907$var$readableAddChunk(this, chunk, null, true, false);
};
function $ab2d8076101be907$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $ab2d8076101be907$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $ab2d8076101be907$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $ab2d8076101be907$var$chunkInvalid(state, chunk);
        if (er) $ab2d8076101be907$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $ab2d8076101be907$require$Buffer.prototype) chunk = $ab2d8076101be907$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $ab2d8076101be907$var$errorOrDestroy(stream, new $ab2d8076101be907$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $ab2d8076101be907$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $ab2d8076101be907$var$errorOrDestroy(stream, new $ab2d8076101be907$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $ab2d8076101be907$var$addChunk(stream, state, chunk, false);
                    else $ab2d8076101be907$var$maybeReadMore(stream, state);
                } else $ab2d8076101be907$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $ab2d8076101be907$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $ab2d8076101be907$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $ab2d8076101be907$var$emitReadable(stream);
    }
    $ab2d8076101be907$var$maybeReadMore(stream, state);
}
function $ab2d8076101be907$var$chunkInvalid(state, chunk) {
    var er;
    if (!$ab2d8076101be907$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $ab2d8076101be907$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$ab2d8076101be907$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$ab2d8076101be907$var$Readable.prototype.setEncoding = function(enc) {
    if (!$ab2d8076101be907$var$StringDecoder) $ab2d8076101be907$var$StringDecoder = (parcelRequire("fggZn")).StringDecoder;
    var decoder = new $ab2d8076101be907$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $ab2d8076101be907$var$MAX_HWM = 0x40000000;
function $ab2d8076101be907$var$computeNewHighWaterMark(n) {
    if (n >= $ab2d8076101be907$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $ab2d8076101be907$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ab2d8076101be907$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $ab2d8076101be907$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$ab2d8076101be907$var$Readable.prototype.read = function(n) {
    $ab2d8076101be907$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $ab2d8076101be907$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $ab2d8076101be907$var$endReadable(this);
        else $ab2d8076101be907$var$emitReadable(this);
        return null;
    }
    n = $ab2d8076101be907$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $ab2d8076101be907$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $ab2d8076101be907$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $ab2d8076101be907$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $ab2d8076101be907$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $ab2d8076101be907$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $ab2d8076101be907$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $ab2d8076101be907$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $ab2d8076101be907$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $ab2d8076101be907$var$onEofChunk(stream, state) {
    $ab2d8076101be907$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $ab2d8076101be907$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $ab2d8076101be907$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $ab2d8076101be907$var$emitReadable(stream) {
    var state = stream._readableState;
    $ab2d8076101be907$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $ab2d8076101be907$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $3iXjX.nextTick($ab2d8076101be907$var$emitReadable_, stream);
    }
}
function $ab2d8076101be907$var$emitReadable_(stream) {
    var state = stream._readableState;
    $ab2d8076101be907$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $ab2d8076101be907$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $ab2d8076101be907$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $3iXjX.nextTick($ab2d8076101be907$var$maybeReadMore_, stream, state);
    }
}
function $ab2d8076101be907$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $ab2d8076101be907$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$ab2d8076101be907$var$Readable.prototype._read = function(n) {
    $ab2d8076101be907$var$errorOrDestroy(this, new $ab2d8076101be907$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$ab2d8076101be907$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $ab2d8076101be907$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $3iXjX.stdout && dest !== $3iXjX.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $3iXjX.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $ab2d8076101be907$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $ab2d8076101be907$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $ab2d8076101be907$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $ab2d8076101be907$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $ab2d8076101be907$var$debug('ondata');
        var ret = dest.write(chunk);
        $ab2d8076101be907$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $ab2d8076101be907$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $ab2d8076101be907$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $ab2d8076101be907$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($ab2d8076101be907$var$EElistenerCount(dest, 'error') === 0) $ab2d8076101be907$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $ab2d8076101be907$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $ab2d8076101be907$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $ab2d8076101be907$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $ab2d8076101be907$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $ab2d8076101be907$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $ab2d8076101be907$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $ab2d8076101be907$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $ab2d8076101be907$var$flow(src);
        }
    };
}
$ab2d8076101be907$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $ab2d8076101be907$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$ab2d8076101be907$var$Readable.prototype.on = function(ev, fn) {
    var res = $6URTI.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $ab2d8076101be907$var$debug('on readable', state.length, state.reading);
            if (state.length) $ab2d8076101be907$var$emitReadable(this);
            else if (!state.reading) $3iXjX.nextTick($ab2d8076101be907$var$nReadingNextTick, this);
        }
    }
    return res;
};
$ab2d8076101be907$var$Readable.prototype.addListener = $ab2d8076101be907$var$Readable.prototype.on;
$ab2d8076101be907$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $6URTI.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3iXjX.nextTick($ab2d8076101be907$var$updateReadableListening, this);
    return res;
};
$ab2d8076101be907$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $6URTI.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $3iXjX.nextTick($ab2d8076101be907$var$updateReadableListening, this);
    return res;
};
function $ab2d8076101be907$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $ab2d8076101be907$var$nReadingNextTick(self1) {
    $ab2d8076101be907$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$ab2d8076101be907$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $ab2d8076101be907$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $ab2d8076101be907$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $ab2d8076101be907$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $3iXjX.nextTick($ab2d8076101be907$var$resume_, stream, state);
    }
}
function $ab2d8076101be907$var$resume_(stream, state) {
    $ab2d8076101be907$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $ab2d8076101be907$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$ab2d8076101be907$var$Readable.prototype.pause = function() {
    $ab2d8076101be907$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $ab2d8076101be907$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $ab2d8076101be907$var$flow(stream) {
    var state = stream._readableState;
    $ab2d8076101be907$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$ab2d8076101be907$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $ab2d8076101be907$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $ab2d8076101be907$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $ab2d8076101be907$var$kProxyEvents.length; n++)stream.on($ab2d8076101be907$var$kProxyEvents[n], this.emit.bind(this, $ab2d8076101be907$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $ab2d8076101be907$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $ab2d8076101be907$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($ab2d8076101be907$var$createReadableStreamAsyncIterator === undefined) $ab2d8076101be907$var$createReadableStreamAsyncIterator = (parcelRequire("fPe62"));
    return $ab2d8076101be907$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($ab2d8076101be907$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($ab2d8076101be907$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($ab2d8076101be907$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$ab2d8076101be907$var$Readable._fromList = $ab2d8076101be907$var$fromList;
Object.defineProperty($ab2d8076101be907$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ab2d8076101be907$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $ab2d8076101be907$var$endReadable(stream) {
    var state = stream._readableState;
    $ab2d8076101be907$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $3iXjX.nextTick($ab2d8076101be907$var$endReadableNT, state, stream);
    }
}
function $ab2d8076101be907$var$endReadableNT(state, stream) {
    $ab2d8076101be907$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $ab2d8076101be907$var$Readable.from = function(iterable, opts) {
    if ($ab2d8076101be907$var$from === undefined) $ab2d8076101be907$var$from = (parcelRequire("5UpIZ"));
    return $ab2d8076101be907$var$from($ab2d8076101be907$var$Readable, iterable, opts);
};
function $ab2d8076101be907$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("cOXur", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $95584d07ca7a7a0f$var$R = typeof Reflect === 'object' ? Reflect : null;
var $95584d07ca7a7a0f$var$ReflectApply = $95584d07ca7a7a0f$var$R && typeof $95584d07ca7a7a0f$var$R.apply === 'function' ? $95584d07ca7a7a0f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $95584d07ca7a7a0f$var$ReflectOwnKeys;
if ($95584d07ca7a7a0f$var$R && typeof $95584d07ca7a7a0f$var$R.ownKeys === 'function') $95584d07ca7a7a0f$var$ReflectOwnKeys = $95584d07ca7a7a0f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $95584d07ca7a7a0f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $95584d07ca7a7a0f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $95584d07ca7a7a0f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $95584d07ca7a7a0f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $95584d07ca7a7a0f$var$EventEmitter() {
    $95584d07ca7a7a0f$var$EventEmitter.init.call(this);
}
module.exports = $95584d07ca7a7a0f$var$EventEmitter;
module.exports.once = $95584d07ca7a7a0f$var$once;
// Backwards-compat with node 0.10.x
$95584d07ca7a7a0f$var$EventEmitter.EventEmitter = $95584d07ca7a7a0f$var$EventEmitter;
$95584d07ca7a7a0f$var$EventEmitter.prototype._events = undefined;
$95584d07ca7a7a0f$var$EventEmitter.prototype._eventsCount = 0;
$95584d07ca7a7a0f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $95584d07ca7a7a0f$var$defaultMaxListeners = 10;
function $95584d07ca7a7a0f$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($95584d07ca7a7a0f$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $95584d07ca7a7a0f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $95584d07ca7a7a0f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $95584d07ca7a7a0f$var$defaultMaxListeners = arg;
    }
});
$95584d07ca7a7a0f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$95584d07ca7a7a0f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $95584d07ca7a7a0f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $95584d07ca7a7a0f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $95584d07ca7a7a0f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$95584d07ca7a7a0f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $95584d07ca7a7a0f$var$_getMaxListeners(this);
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $95584d07ca7a7a0f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $95584d07ca7a7a0f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$95584d07ca7a7a0f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $95584d07ca7a7a0f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $95584d07ca7a7a0f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $95584d07ca7a7a0f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $95584d07ca7a7a0f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$95584d07ca7a7a0f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $95584d07ca7a7a0f$var$_addListener(this, type, listener, false);
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.on = $95584d07ca7a7a0f$var$EventEmitter.prototype.addListener;
$95584d07ca7a7a0f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $95584d07ca7a7a0f$var$_addListener(this, type, listener, true);
};
function $95584d07ca7a7a0f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $95584d07ca7a7a0f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $95584d07ca7a7a0f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$95584d07ca7a7a0f$var$EventEmitter.prototype.once = function once(type, listener) {
    $95584d07ca7a7a0f$var$checkListener(listener);
    this.on(type, $95584d07ca7a7a0f$var$_onceWrap(this, type, listener));
    return this;
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $95584d07ca7a7a0f$var$checkListener(listener);
    this.prependListener(type, $95584d07ca7a7a0f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$95584d07ca7a7a0f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $95584d07ca7a7a0f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $95584d07ca7a7a0f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.off = $95584d07ca7a7a0f$var$EventEmitter.prototype.removeListener;
$95584d07ca7a7a0f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $95584d07ca7a7a0f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $95584d07ca7a7a0f$var$unwrapListeners(evlistener) : $95584d07ca7a7a0f$var$arrayClone(evlistener, evlistener.length);
}
$95584d07ca7a7a0f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $95584d07ca7a7a0f$var$_listeners(this, type, true);
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $95584d07ca7a7a0f$var$_listeners(this, type, false);
};
$95584d07ca7a7a0f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $95584d07ca7a7a0f$var$listenerCount.call(emitter, type);
};
$95584d07ca7a7a0f$var$EventEmitter.prototype.listenerCount = $95584d07ca7a7a0f$var$listenerCount;
function $95584d07ca7a7a0f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$95584d07ca7a7a0f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $95584d07ca7a7a0f$var$ReflectOwnKeys(this._events) : [];
};
function $95584d07ca7a7a0f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $95584d07ca7a7a0f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $95584d07ca7a7a0f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $95584d07ca7a7a0f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $95584d07ca7a7a0f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $95584d07ca7a7a0f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $95584d07ca7a7a0f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $95584d07ca7a7a0f$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $95584d07ca7a7a0f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("6URTI", function(module, exports) {

module.exports = (parcelRequire("cOXur")).EventEmitter;

});

parcelRegister("fVZIf", function(module, exports) {
"use strict";

});

parcelRegister("gB3wC", function(module, exports) {
'use strict';
function $c152d60851e0242f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c152d60851e0242f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c152d60851e0242f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c152d60851e0242f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c152d60851e0242f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c152d60851e0242f$var$_defineProperty(obj, key, value) {
    key = $c152d60851e0242f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c152d60851e0242f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c152d60851e0242f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c152d60851e0242f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c152d60851e0242f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c152d60851e0242f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c152d60851e0242f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c152d60851e0242f$var$_toPropertyKey(arg) {
    var key = $c152d60851e0242f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c152d60851e0242f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8f5i0 = parcelRequire("8f5i0");
var $c152d60851e0242f$var$Buffer = $8f5i0.Buffer;

var $fVZIf = parcelRequire("fVZIf");
var $c152d60851e0242f$var$inspect = $fVZIf.inspect;
var $c152d60851e0242f$var$custom = $c152d60851e0242f$var$inspect && $c152d60851e0242f$var$inspect.custom || 'inspect';
function $c152d60851e0242f$var$copyBuffer(src, target, offset) {
    $c152d60851e0242f$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $c152d60851e0242f$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $c152d60851e0242f$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $c152d60851e0242f$var$Buffer.alloc(0);
                var ret = $c152d60851e0242f$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $c152d60851e0242f$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $c152d60851e0242f$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $c152d60851e0242f$var$custom,
            value: function value(_, options) {
                return $c152d60851e0242f$var$inspect(this, $c152d60851e0242f$var$_objectSpread($c152d60851e0242f$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("8ldX1", function(module, exports) {

var $3iXjX = parcelRequire("3iXjX");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $612b1b3eb6500fbc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $3iXjX.nextTick($612b1b3eb6500fbc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $3iXjX.nextTick($612b1b3eb6500fbc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $3iXjX.nextTick($612b1b3eb6500fbc$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $3iXjX.nextTick($612b1b3eb6500fbc$var$emitErrorAndCloseNT, _this, err);
            } else $3iXjX.nextTick($612b1b3eb6500fbc$var$emitCloseNT, _this);
        } else if (cb) {
            $3iXjX.nextTick($612b1b3eb6500fbc$var$emitCloseNT, _this);
            cb(err);
        } else $3iXjX.nextTick($612b1b3eb6500fbc$var$emitCloseNT, _this);
    });
    return this;
}
function $612b1b3eb6500fbc$var$emitErrorAndCloseNT(self, err) {
    $612b1b3eb6500fbc$var$emitErrorNT(self, err);
    $612b1b3eb6500fbc$var$emitCloseNT(self);
}
function $612b1b3eb6500fbc$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $612b1b3eb6500fbc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $612b1b3eb6500fbc$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $612b1b3eb6500fbc$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $612b1b3eb6500fbc$var$destroy,
    undestroy: $612b1b3eb6500fbc$var$undestroy,
    errorOrDestroy: $612b1b3eb6500fbc$var$errorOrDestroy
};

});

parcelRegister("bBnkr", function(module, exports) {
'use strict';

var $87253efb44af0970$var$ERR_INVALID_OPT_VALUE = (parcelRequire("8QIe8")).codes.ERR_INVALID_OPT_VALUE;
function $87253efb44af0970$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $87253efb44af0970$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $87253efb44af0970$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $87253efb44af0970$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $87253efb44af0970$var$getHighWaterMark
};

});
parcelRegister("8QIe8", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $67157c99ed594f9d$export$e45cb6485273080e; }, function (v) { return $67157c99ed594f9d$export$e45cb6485273080e = v; });
var $67157c99ed594f9d$export$e45cb6485273080e;
'use strict';
function $67157c99ed594f9d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $67157c99ed594f9d$var$codes = {};
function $67157c99ed594f9d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $67157c99ed594f9d$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $67157c99ed594f9d$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $67157c99ed594f9d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $67157c99ed594f9d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $67157c99ed594f9d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $67157c99ed594f9d$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$67157c99ed594f9d$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$67157c99ed594f9d$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $67157c99ed594f9d$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($67157c99ed594f9d$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($67157c99ed594f9d$var$oneOf(expected, 'type'));
    else {
        var type = $67157c99ed594f9d$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($67157c99ed594f9d$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$67157c99ed594f9d$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$67157c99ed594f9d$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$67157c99ed594f9d$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$67157c99ed594f9d$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$67157c99ed594f9d$export$e45cb6485273080e = $67157c99ed594f9d$var$codes;

});


parcelRegister("SmnH1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $3iXjX = parcelRequire("3iXjX");
'use strict';
/*<replacement>*/ var $0a3667b08dee2a5c$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $0a3667b08dee2a5c$var$Duplex;

var $eHaR5 = parcelRequire("eHaR5");

var $2HQXg = parcelRequire("2HQXg");

(parcelRequire("bVy58"))($0a3667b08dee2a5c$var$Duplex, $eHaR5);
// Allow the keys array to be GC'ed.
var $0a3667b08dee2a5c$var$keys = $0a3667b08dee2a5c$var$objectKeys($2HQXg.prototype);
for(var $0a3667b08dee2a5c$var$v = 0; $0a3667b08dee2a5c$var$v < $0a3667b08dee2a5c$var$keys.length; $0a3667b08dee2a5c$var$v++){
    var $0a3667b08dee2a5c$var$method = $0a3667b08dee2a5c$var$keys[$0a3667b08dee2a5c$var$v];
    if (!$0a3667b08dee2a5c$var$Duplex.prototype[$0a3667b08dee2a5c$var$method]) $0a3667b08dee2a5c$var$Duplex.prototype[$0a3667b08dee2a5c$var$method] = $2HQXg.prototype[$0a3667b08dee2a5c$var$method];
}
function $0a3667b08dee2a5c$var$Duplex(options) {
    if (!(this instanceof $0a3667b08dee2a5c$var$Duplex)) return new $0a3667b08dee2a5c$var$Duplex(options);
    $eHaR5.call(this, options);
    $2HQXg.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $0a3667b08dee2a5c$var$onend);
        }
    }
}
Object.defineProperty($0a3667b08dee2a5c$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($0a3667b08dee2a5c$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($0a3667b08dee2a5c$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $0a3667b08dee2a5c$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $3iXjX.nextTick($0a3667b08dee2a5c$var$onEndNT, this);
}
function $0a3667b08dee2a5c$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($0a3667b08dee2a5c$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("2HQXg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $3iXjX = parcelRequire("3iXjX");
'use strict';
module.exports = $1f88acab948369f0$var$Writable;
/* <replacement> */ function $1f88acab948369f0$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $1f88acab948369f0$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $1f88acab948369f0$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $1f88acab948369f0$var$Duplex;
/*</replacement>*/ $1f88acab948369f0$var$Writable.WritableState = $1f88acab948369f0$var$WritableState;

/*<replacement>*/ var $1f88acab948369f0$var$internalUtil = {
    deprecate: (parcelRequire("iopiP"))
};

var $6URTI = parcelRequire("6URTI");

var $8f5i0 = parcelRequire("8f5i0");
var $1f88acab948369f0$require$Buffer = $8f5i0.Buffer;
var $1f88acab948369f0$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1f88acab948369f0$var$_uint8ArrayToBuffer(chunk) {
    return $1f88acab948369f0$require$Buffer.from(chunk);
}
function $1f88acab948369f0$var$_isUint8Array(obj) {
    return $1f88acab948369f0$require$Buffer.isBuffer(obj) || obj instanceof $1f88acab948369f0$var$OurUint8Array;
}

var $8ldX1 = parcelRequire("8ldX1");

var $bBnkr = parcelRequire("bBnkr");
var $1f88acab948369f0$var$getHighWaterMark = $bBnkr.getHighWaterMark;

var $8QIe8 = parcelRequire("8QIe8");
var $1f88acab948369f0$require$_require$codes = $8QIe8.codes;
var $1f88acab948369f0$var$ERR_INVALID_ARG_TYPE = $1f88acab948369f0$require$_require$codes.ERR_INVALID_ARG_TYPE, $1f88acab948369f0$var$ERR_METHOD_NOT_IMPLEMENTED = $1f88acab948369f0$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1f88acab948369f0$var$ERR_MULTIPLE_CALLBACK = $1f88acab948369f0$require$_require$codes.ERR_MULTIPLE_CALLBACK, $1f88acab948369f0$var$ERR_STREAM_CANNOT_PIPE = $1f88acab948369f0$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $1f88acab948369f0$var$ERR_STREAM_DESTROYED = $1f88acab948369f0$require$_require$codes.ERR_STREAM_DESTROYED, $1f88acab948369f0$var$ERR_STREAM_NULL_VALUES = $1f88acab948369f0$require$_require$codes.ERR_STREAM_NULL_VALUES, $1f88acab948369f0$var$ERR_STREAM_WRITE_AFTER_END = $1f88acab948369f0$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $1f88acab948369f0$var$ERR_UNKNOWN_ENCODING = $1f88acab948369f0$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $1f88acab948369f0$var$errorOrDestroy = $8ldX1.errorOrDestroy;

(parcelRequire("bVy58"))($1f88acab948369f0$var$Writable, $6URTI);
function $1f88acab948369f0$var$nop() {}

function $1f88acab948369f0$var$WritableState(options, stream, isDuplex) {
    $1f88acab948369f0$var$Duplex = $1f88acab948369f0$var$Duplex || (parcelRequire("SmnH1"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $1f88acab948369f0$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $1f88acab948369f0$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $1f88acab948369f0$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $1f88acab948369f0$var$CorkedRequest(this);
}
$1f88acab948369f0$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($1f88acab948369f0$var$WritableState.prototype, 'buffer', {
            get: $1f88acab948369f0$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $1f88acab948369f0$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $1f88acab948369f0$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($1f88acab948369f0$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($1f88acab948369f0$var$realHasInstance.call(this, object)) return true;
            if (this !== $1f88acab948369f0$var$Writable) return false;
            return object && object._writableState instanceof $1f88acab948369f0$var$WritableState;
        }
    });
} else $1f88acab948369f0$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $1f88acab948369f0$var$Writable(options) {
    $1f88acab948369f0$var$Duplex = $1f88acab948369f0$var$Duplex || (parcelRequire("SmnH1"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $1f88acab948369f0$var$Duplex;
    if (!isDuplex && !$1f88acab948369f0$var$realHasInstance.call($1f88acab948369f0$var$Writable, this)) return new $1f88acab948369f0$var$Writable(options);
    this._writableState = new $1f88acab948369f0$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $6URTI.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$1f88acab948369f0$var$Writable.prototype.pipe = function() {
    $1f88acab948369f0$var$errorOrDestroy(this, new $1f88acab948369f0$var$ERR_STREAM_CANNOT_PIPE());
};
function $1f88acab948369f0$var$writeAfterEnd(stream, cb) {
    var er = new $1f88acab948369f0$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $1f88acab948369f0$var$errorOrDestroy(stream, er);
    $3iXjX.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $1f88acab948369f0$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $1f88acab948369f0$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $1f88acab948369f0$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $1f88acab948369f0$var$errorOrDestroy(stream, er);
        $3iXjX.nextTick(cb, er);
        return false;
    }
    return true;
}
$1f88acab948369f0$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $1f88acab948369f0$var$_isUint8Array(chunk);
    if (isBuf && !$1f88acab948369f0$require$Buffer.isBuffer(chunk)) chunk = $1f88acab948369f0$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $1f88acab948369f0$var$nop;
    if (state.ending) $1f88acab948369f0$var$writeAfterEnd(this, cb);
    else if (isBuf || $1f88acab948369f0$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $1f88acab948369f0$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$1f88acab948369f0$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1f88acab948369f0$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1f88acab948369f0$var$clearBuffer(this, state);
    }
};
$1f88acab948369f0$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $1f88acab948369f0$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($1f88acab948369f0$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $1f88acab948369f0$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $1f88acab948369f0$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($1f88acab948369f0$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1f88acab948369f0$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $1f88acab948369f0$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $1f88acab948369f0$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $1f88acab948369f0$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1f88acab948369f0$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1f88acab948369f0$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $3iXjX.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $3iXjX.nextTick($1f88acab948369f0$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $1f88acab948369f0$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $1f88acab948369f0$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $1f88acab948369f0$var$finishMaybe(stream, state);
    }
}
function $1f88acab948369f0$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $1f88acab948369f0$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $1f88acab948369f0$var$ERR_MULTIPLE_CALLBACK();
    $1f88acab948369f0$var$onwriteStateUpdate(state);
    if (er) $1f88acab948369f0$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $1f88acab948369f0$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1f88acab948369f0$var$clearBuffer(stream, state);
        if (sync) $3iXjX.nextTick($1f88acab948369f0$var$afterWrite, stream, state, finished, cb);
        else $1f88acab948369f0$var$afterWrite(stream, state, finished, cb);
    }
}
function $1f88acab948369f0$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $1f88acab948369f0$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $1f88acab948369f0$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $1f88acab948369f0$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $1f88acab948369f0$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $1f88acab948369f0$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $1f88acab948369f0$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $1f88acab948369f0$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$1f88acab948369f0$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $1f88acab948369f0$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$1f88acab948369f0$var$Writable.prototype._writev = null;
$1f88acab948369f0$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $1f88acab948369f0$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($1f88acab948369f0$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $1f88acab948369f0$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $1f88acab948369f0$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $1f88acab948369f0$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $1f88acab948369f0$var$finishMaybe(stream, state);
    });
}
function $1f88acab948369f0$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $3iXjX.nextTick($1f88acab948369f0$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1f88acab948369f0$var$finishMaybe(stream, state) {
    var need = $1f88acab948369f0$var$needFinish(state);
    if (need) {
        $1f88acab948369f0$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $1f88acab948369f0$var$endWritable(stream, state, cb) {
    state.ending = true;
    $1f88acab948369f0$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $3iXjX.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $1f88acab948369f0$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($1f88acab948369f0$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$1f88acab948369f0$var$Writable.prototype.destroy = $8ldX1.destroy;
$1f88acab948369f0$var$Writable.prototype._undestroy = $8ldX1.undestroy;
$1f88acab948369f0$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("iopiP", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $d63e1873825db2fd$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $d63e1873825db2fd$var$deprecate(fn, msg) {
    if ($d63e1873825db2fd$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($d63e1873825db2fd$var$config('throwDeprecation')) throw new Error(msg);
            else if ($d63e1873825db2fd$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $d63e1873825db2fd$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("fggZn", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $b1c5874f0d196361$export$63a7aa211a91ed69; }, function (v) { return $b1c5874f0d196361$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $b1c5874f0d196361$export$63a7aa211a91ed69;
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $b1c5874f0d196361$require$Buffer = $BUCDt.Buffer;
/*</replacement>*/ var $b1c5874f0d196361$var$isEncoding = $b1c5874f0d196361$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $b1c5874f0d196361$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $b1c5874f0d196361$var$normalizeEncoding(enc) {
    var nenc = $b1c5874f0d196361$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($b1c5874f0d196361$require$Buffer.isEncoding === $b1c5874f0d196361$var$isEncoding || !$b1c5874f0d196361$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$b1c5874f0d196361$export$63a7aa211a91ed69 = $b1c5874f0d196361$var$StringDecoder;
function $b1c5874f0d196361$var$StringDecoder(encoding) {
    this.encoding = $b1c5874f0d196361$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $b1c5874f0d196361$var$utf16Text;
            this.end = $b1c5874f0d196361$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $b1c5874f0d196361$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $b1c5874f0d196361$var$base64Text;
            this.end = $b1c5874f0d196361$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $b1c5874f0d196361$var$simpleWrite;
            this.end = $b1c5874f0d196361$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $b1c5874f0d196361$require$Buffer.allocUnsafe(nb);
}
$b1c5874f0d196361$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$b1c5874f0d196361$var$StringDecoder.prototype.end = $b1c5874f0d196361$var$utf8End;
// Returns only complete characters in a Buffer
$b1c5874f0d196361$var$StringDecoder.prototype.text = $b1c5874f0d196361$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$b1c5874f0d196361$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $b1c5874f0d196361$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $b1c5874f0d196361$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $b1c5874f0d196361$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b1c5874f0d196361$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b1c5874f0d196361$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $b1c5874f0d196361$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $b1c5874f0d196361$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $b1c5874f0d196361$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $b1c5874f0d196361$var$utf8Text(buf, i) {
    var total = $b1c5874f0d196361$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $b1c5874f0d196361$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $b1c5874f0d196361$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $b1c5874f0d196361$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $b1c5874f0d196361$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $b1c5874f0d196361$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $b1c5874f0d196361$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $b1c5874f0d196361$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("fPe62", function(module, exports) {

var $3iXjX = parcelRequire("3iXjX");
'use strict';
var $b8568daee8923470$var$_Object$setPrototypeO;
function $b8568daee8923470$var$_defineProperty(obj, key, value) {
    key = $b8568daee8923470$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8568daee8923470$var$_toPropertyKey(arg) {
    var key = $b8568daee8923470$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $b8568daee8923470$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $khBQN = parcelRequire("khBQN");
var $b8568daee8923470$var$kLastResolve = Symbol('lastResolve');
var $b8568daee8923470$var$kLastReject = Symbol('lastReject');
var $b8568daee8923470$var$kError = Symbol('error');
var $b8568daee8923470$var$kEnded = Symbol('ended');
var $b8568daee8923470$var$kLastPromise = Symbol('lastPromise');
var $b8568daee8923470$var$kHandlePromise = Symbol('handlePromise');
var $b8568daee8923470$var$kStream = Symbol('stream');
function $b8568daee8923470$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $b8568daee8923470$var$readAndResolve(iter) {
    var resolve = iter[$b8568daee8923470$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$b8568daee8923470$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$b8568daee8923470$var$kLastPromise] = null;
            iter[$b8568daee8923470$var$kLastResolve] = null;
            iter[$b8568daee8923470$var$kLastReject] = null;
            resolve($b8568daee8923470$var$createIterResult(data, false));
        }
    }
}
function $b8568daee8923470$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $3iXjX.nextTick($b8568daee8923470$var$readAndResolve, iter);
}
function $b8568daee8923470$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$b8568daee8923470$var$kEnded]) {
                resolve($b8568daee8923470$var$createIterResult(undefined, true));
                return;
            }
            iter[$b8568daee8923470$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $b8568daee8923470$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $b8568daee8923470$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($b8568daee8923470$var$_Object$setPrototypeO = {
    get stream () {
        return this[$b8568daee8923470$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$b8568daee8923470$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$b8568daee8923470$var$kEnded]) return Promise.resolve($b8568daee8923470$var$createIterResult(undefined, true));
        if (this[$b8568daee8923470$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $3iXjX.nextTick(function() {
                if (_this[$b8568daee8923470$var$kError]) reject(_this[$b8568daee8923470$var$kError]);
                else resolve($b8568daee8923470$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$b8568daee8923470$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($b8568daee8923470$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$b8568daee8923470$var$kStream].read();
            if (data !== null) return Promise.resolve($b8568daee8923470$var$createIterResult(data, false));
            promise = new Promise(this[$b8568daee8923470$var$kHandlePromise]);
        }
        this[$b8568daee8923470$var$kLastPromise] = promise;
        return promise;
    }
}, $b8568daee8923470$var$_defineProperty($b8568daee8923470$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $b8568daee8923470$var$_defineProperty($b8568daee8923470$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$b8568daee8923470$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($b8568daee8923470$var$createIterResult(undefined, true));
        });
    });
}), $b8568daee8923470$var$_Object$setPrototypeO), $b8568daee8923470$var$AsyncIteratorPrototype);
var $b8568daee8923470$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($b8568daee8923470$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kStream, {
        value: stream,
        writable: true
    }), $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kLastResolve, {
        value: null,
        writable: true
    }), $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kLastReject, {
        value: null,
        writable: true
    }), $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kError, {
        value: null,
        writable: true
    }), $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $b8568daee8923470$var$_defineProperty(_Object$create, $b8568daee8923470$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$b8568daee8923470$var$kStream].read();
            if (data) {
                iterator[$b8568daee8923470$var$kLastPromise] = null;
                iterator[$b8568daee8923470$var$kLastResolve] = null;
                iterator[$b8568daee8923470$var$kLastReject] = null;
                resolve($b8568daee8923470$var$createIterResult(data, false));
            } else {
                iterator[$b8568daee8923470$var$kLastResolve] = resolve;
                iterator[$b8568daee8923470$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$b8568daee8923470$var$kLastPromise] = null;
    $khBQN(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$b8568daee8923470$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$b8568daee8923470$var$kLastPromise] = null;
                iterator[$b8568daee8923470$var$kLastResolve] = null;
                iterator[$b8568daee8923470$var$kLastReject] = null;
                reject(err);
            }
            iterator[$b8568daee8923470$var$kError] = err;
            return;
        }
        var resolve = iterator[$b8568daee8923470$var$kLastResolve];
        if (resolve !== null) {
            iterator[$b8568daee8923470$var$kLastPromise] = null;
            iterator[$b8568daee8923470$var$kLastResolve] = null;
            iterator[$b8568daee8923470$var$kLastReject] = null;
            resolve($b8568daee8923470$var$createIterResult(undefined, true));
        }
        iterator[$b8568daee8923470$var$kEnded] = true;
    });
    stream.on('readable', $b8568daee8923470$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $b8568daee8923470$var$createReadableStreamAsyncIterator;

});
parcelRegister("khBQN", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $ec42c17f5459460e$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("8QIe8")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ec42c17f5459460e$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ec42c17f5459460e$var$noop() {}
function $ec42c17f5459460e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $ec42c17f5459460e$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $ec42c17f5459460e$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ec42c17f5459460e$var$once(callback || $ec42c17f5459460e$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ec42c17f5459460e$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ec42c17f5459460e$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($ec42c17f5459460e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $ec42c17f5459460e$var$eos;

});


parcelRegister("5UpIZ", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("ecjlu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $a56131560fea633a$var$Transform;

var $8QIe8 = parcelRequire("8QIe8");
var $a56131560fea633a$require$_require$codes = $8QIe8.codes;
var $a56131560fea633a$var$ERR_METHOD_NOT_IMPLEMENTED = $a56131560fea633a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a56131560fea633a$var$ERR_MULTIPLE_CALLBACK = $a56131560fea633a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $a56131560fea633a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $a56131560fea633a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $a56131560fea633a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $a56131560fea633a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $SmnH1 = parcelRequire("SmnH1");

(parcelRequire("bVy58"))($a56131560fea633a$var$Transform, $SmnH1);
function $a56131560fea633a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $a56131560fea633a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $a56131560fea633a$var$Transform(options) {
    if (!(this instanceof $a56131560fea633a$var$Transform)) return new $a56131560fea633a$var$Transform(options);
    $SmnH1.call(this, options);
    this._transformState = {
        afterTransform: $a56131560fea633a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $a56131560fea633a$var$prefinish);
}
function $a56131560fea633a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $a56131560fea633a$var$done(_this, er, data);
    });
    else $a56131560fea633a$var$done(this, null, null);
}
$a56131560fea633a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $SmnH1.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$a56131560fea633a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $a56131560fea633a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$a56131560fea633a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$a56131560fea633a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$a56131560fea633a$var$Transform.prototype._destroy = function(err, cb) {
    $SmnH1.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $a56131560fea633a$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $a56131560fea633a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $a56131560fea633a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("NHJdp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $09567f3e31ecb5a2$var$PassThrough;

var $ecjlu = parcelRequire("ecjlu");

(parcelRequire("bVy58"))($09567f3e31ecb5a2$var$PassThrough, $ecjlu);
function $09567f3e31ecb5a2$var$PassThrough(options) {
    if (!(this instanceof $09567f3e31ecb5a2$var$PassThrough)) return new $09567f3e31ecb5a2$var$PassThrough(options);
    $ecjlu.call(this, options);
}
$09567f3e31ecb5a2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("77cYF", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $52e340e2e32e11d1$var$eos;
function $52e340e2e32e11d1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $8QIe8 = parcelRequire("8QIe8");
var $52e340e2e32e11d1$require$_require$codes = $8QIe8.codes;
var $52e340e2e32e11d1$var$ERR_MISSING_ARGS = $52e340e2e32e11d1$require$_require$codes.ERR_MISSING_ARGS, $52e340e2e32e11d1$var$ERR_STREAM_DESTROYED = $52e340e2e32e11d1$require$_require$codes.ERR_STREAM_DESTROYED;
function $52e340e2e32e11d1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $52e340e2e32e11d1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $52e340e2e32e11d1$var$destroyer(stream, reading, writing, callback) {
    callback = $52e340e2e32e11d1$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($52e340e2e32e11d1$var$eos === undefined) $52e340e2e32e11d1$var$eos = (parcelRequire("khBQN"));
    $52e340e2e32e11d1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($52e340e2e32e11d1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $52e340e2e32e11d1$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $52e340e2e32e11d1$var$call(fn) {
    fn();
}
function $52e340e2e32e11d1$var$pipe(from, to) {
    return from.pipe(to);
}
function $52e340e2e32e11d1$var$popCallback(streams) {
    if (!streams.length) return $52e340e2e32e11d1$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $52e340e2e32e11d1$var$noop;
    return streams.pop();
}
function $52e340e2e32e11d1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $52e340e2e32e11d1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $52e340e2e32e11d1$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $52e340e2e32e11d1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($52e340e2e32e11d1$var$call);
            if (reading) return;
            destroys.forEach($52e340e2e32e11d1$var$call);
            callback(error);
        });
    });
    return streams.reduce($52e340e2e32e11d1$var$pipe);
}
module.exports = $52e340e2e32e11d1$var$pipeline;

});




parcelRegister("fboL1", function(module, exports) {
'use strict';

var $8f5i0 = parcelRequire("8f5i0");
var $b0db1668c7aa698c$require$Buffer = $8f5i0.Buffer;

var $bVy58 = parcelRequire("bVy58");

var $1jMdX = parcelRequire("1jMdX");
var $b0db1668c7aa698c$var$ARRAY16 = new Array(16);
var $b0db1668c7aa698c$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $b0db1668c7aa698c$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $b0db1668c7aa698c$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $b0db1668c7aa698c$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $b0db1668c7aa698c$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $b0db1668c7aa698c$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $b0db1668c7aa698c$var$RIPEMD160() {
    $1jMdX.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$bVy58($b0db1668c7aa698c$var$RIPEMD160, $1jMdX);
$b0db1668c7aa698c$var$RIPEMD160.prototype._update = function() {
    var words = $b0db1668c7aa698c$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $b0db1668c7aa698c$var$fn1(al, bl, cl, dl, el, words[$b0db1668c7aa698c$var$zl[i]], $b0db1668c7aa698c$var$hl[0], $b0db1668c7aa698c$var$sl[i]);
            tr = $b0db1668c7aa698c$var$fn5(ar, br, cr, dr, er, words[$b0db1668c7aa698c$var$zr[i]], $b0db1668c7aa698c$var$hr[0], $b0db1668c7aa698c$var$sr[i]);
        } else if (i < 32) {
            tl = $b0db1668c7aa698c$var$fn2(al, bl, cl, dl, el, words[$b0db1668c7aa698c$var$zl[i]], $b0db1668c7aa698c$var$hl[1], $b0db1668c7aa698c$var$sl[i]);
            tr = $b0db1668c7aa698c$var$fn4(ar, br, cr, dr, er, words[$b0db1668c7aa698c$var$zr[i]], $b0db1668c7aa698c$var$hr[1], $b0db1668c7aa698c$var$sr[i]);
        } else if (i < 48) {
            tl = $b0db1668c7aa698c$var$fn3(al, bl, cl, dl, el, words[$b0db1668c7aa698c$var$zl[i]], $b0db1668c7aa698c$var$hl[2], $b0db1668c7aa698c$var$sl[i]);
            tr = $b0db1668c7aa698c$var$fn3(ar, br, cr, dr, er, words[$b0db1668c7aa698c$var$zr[i]], $b0db1668c7aa698c$var$hr[2], $b0db1668c7aa698c$var$sr[i]);
        } else if (i < 64) {
            tl = $b0db1668c7aa698c$var$fn4(al, bl, cl, dl, el, words[$b0db1668c7aa698c$var$zl[i]], $b0db1668c7aa698c$var$hl[3], $b0db1668c7aa698c$var$sl[i]);
            tr = $b0db1668c7aa698c$var$fn2(ar, br, cr, dr, er, words[$b0db1668c7aa698c$var$zr[i]], $b0db1668c7aa698c$var$hr[3], $b0db1668c7aa698c$var$sr[i]);
        } else {
            tl = $b0db1668c7aa698c$var$fn5(al, bl, cl, dl, el, words[$b0db1668c7aa698c$var$zl[i]], $b0db1668c7aa698c$var$hl[4], $b0db1668c7aa698c$var$sl[i]);
            tr = $b0db1668c7aa698c$var$fn1(ar, br, cr, dr, er, words[$b0db1668c7aa698c$var$zr[i]], $b0db1668c7aa698c$var$hr[4], $b0db1668c7aa698c$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $b0db1668c7aa698c$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $b0db1668c7aa698c$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$b0db1668c7aa698c$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $b0db1668c7aa698c$require$Buffer.alloc ? $b0db1668c7aa698c$require$Buffer.alloc(20) : new $b0db1668c7aa698c$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $b0db1668c7aa698c$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $b0db1668c7aa698c$var$fn1(a, b, c, d, e, m, k, s) {
    return $b0db1668c7aa698c$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $b0db1668c7aa698c$var$fn2(a, b, c, d, e, m, k, s) {
    return $b0db1668c7aa698c$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $b0db1668c7aa698c$var$fn3(a, b, c, d, e, m, k, s) {
    return $b0db1668c7aa698c$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $b0db1668c7aa698c$var$fn4(a, b, c, d, e, m, k, s) {
    return $b0db1668c7aa698c$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $b0db1668c7aa698c$var$fn5(a, b, c, d, e, m, k, s) {
    return $b0db1668c7aa698c$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $b0db1668c7aa698c$var$RIPEMD160;

});
parcelRegister("1jMdX", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $0f5cf915cdf9107a$require$Buffer = $BUCDt.Buffer;

var $aR9XM = parcelRequire("aR9XM");
var $0f5cf915cdf9107a$require$Transform = $aR9XM.Transform;

var $bVy58 = parcelRequire("bVy58");
function $0f5cf915cdf9107a$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$0f5cf915cdf9107a$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $0f5cf915cdf9107a$var$HashBase(blockSize) {
    $0f5cf915cdf9107a$require$Transform.call(this);
    this._block = $0f5cf915cdf9107a$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$bVy58($0f5cf915cdf9107a$var$HashBase, $0f5cf915cdf9107a$require$Transform);
$0f5cf915cdf9107a$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0f5cf915cdf9107a$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0f5cf915cdf9107a$var$HashBase.prototype.update = function(data, encoding) {
    $0f5cf915cdf9107a$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$0f5cf915cdf9107a$require$Buffer.isBuffer(data)) data = $0f5cf915cdf9107a$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$0f5cf915cdf9107a$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$0f5cf915cdf9107a$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$0f5cf915cdf9107a$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $0f5cf915cdf9107a$var$HashBase;

});


parcelRegister("3qMts", function(module, exports) {
var $27f966bfb9d5c921$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $27f966bfb9d5c921$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$27f966bfb9d5c921$var$exports.sha = (parcelRequire("2Yo6P"));

$27f966bfb9d5c921$var$exports.sha1 = (parcelRequire("77kcg"));

$27f966bfb9d5c921$var$exports.sha224 = (parcelRequire("gnF2k"));

$27f966bfb9d5c921$var$exports.sha256 = (parcelRequire("3xPYA"));

$27f966bfb9d5c921$var$exports.sha384 = (parcelRequire("5ucsi"));

$27f966bfb9d5c921$var$exports.sha512 = (parcelRequire("geuxd"));

});
parcelRegister("2Yo6P", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $bVy58 = parcelRequire("bVy58");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $22a3e2ece3cb1ffe$require$Buffer = $BUCDt.Buffer;
var $22a3e2ece3cb1ffe$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $22a3e2ece3cb1ffe$var$W = new Array(80);
function $22a3e2ece3cb1ffe$var$Sha() {
    this.init();
    this._w = $22a3e2ece3cb1ffe$var$W;
    $kiUCX.call(this, 64, 56);
}
$bVy58($22a3e2ece3cb1ffe$var$Sha, $kiUCX);
$22a3e2ece3cb1ffe$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $22a3e2ece3cb1ffe$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $22a3e2ece3cb1ffe$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $22a3e2ece3cb1ffe$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$22a3e2ece3cb1ffe$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $22a3e2ece3cb1ffe$var$rotl5(a) + $22a3e2ece3cb1ffe$var$ft(s, b, c, d) + e + W[j] + $22a3e2ece3cb1ffe$var$K[s] | 0;
        e = d;
        d = c;
        c = $22a3e2ece3cb1ffe$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$22a3e2ece3cb1ffe$var$Sha.prototype._hash = function() {
    var H = $22a3e2ece3cb1ffe$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $22a3e2ece3cb1ffe$var$Sha;

});
parcelRegister("kiUCX", function(module, exports) {

var $BUCDt = parcelRequire("BUCDt");
var $ec816a1520319b02$require$Buffer = $BUCDt.Buffer;
// prototype class for hash functions
function $ec816a1520319b02$var$Hash(blockSize, finalSize) {
    this._block = $ec816a1520319b02$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$ec816a1520319b02$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $ec816a1520319b02$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$ec816a1520319b02$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$ec816a1520319b02$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $ec816a1520319b02$var$Hash;

});


parcelRegister("77kcg", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $bVy58 = parcelRequire("bVy58");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $52e8da87604d301d$require$Buffer = $BUCDt.Buffer;
var $52e8da87604d301d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $52e8da87604d301d$var$W = new Array(80);
function $52e8da87604d301d$var$Sha1() {
    this.init();
    this._w = $52e8da87604d301d$var$W;
    $kiUCX.call(this, 64, 56);
}
$bVy58($52e8da87604d301d$var$Sha1, $kiUCX);
$52e8da87604d301d$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $52e8da87604d301d$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $52e8da87604d301d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $52e8da87604d301d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $52e8da87604d301d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$52e8da87604d301d$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $52e8da87604d301d$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $52e8da87604d301d$var$rotl5(a) + $52e8da87604d301d$var$ft(s, b, c, d) + e + W[j] + $52e8da87604d301d$var$K[s] | 0;
        e = d;
        d = c;
        c = $52e8da87604d301d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$52e8da87604d301d$var$Sha1.prototype._hash = function() {
    var H = $52e8da87604d301d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $52e8da87604d301d$var$Sha1;

});

parcelRegister("gnF2k", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $bVy58 = parcelRequire("bVy58");

var $3xPYA = parcelRequire("3xPYA");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $becea05975fd3f68$require$Buffer = $BUCDt.Buffer;
var $becea05975fd3f68$var$W = new Array(64);
function $becea05975fd3f68$var$Sha224() {
    this.init();
    this._w = $becea05975fd3f68$var$W // new Array(64)
    ;
    $kiUCX.call(this, 64, 56);
}
$bVy58($becea05975fd3f68$var$Sha224, $3xPYA);
$becea05975fd3f68$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$becea05975fd3f68$var$Sha224.prototype._hash = function() {
    var H = $becea05975fd3f68$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $becea05975fd3f68$var$Sha224;

});
parcelRegister("3xPYA", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $bVy58 = parcelRequire("bVy58");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $294cc588fecdb4a9$require$Buffer = $BUCDt.Buffer;
var $294cc588fecdb4a9$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $294cc588fecdb4a9$var$W = new Array(64);
function $294cc588fecdb4a9$var$Sha256() {
    this.init();
    this._w = $294cc588fecdb4a9$var$W // new Array(64)
    ;
    $kiUCX.call(this, 64, 56);
}
$bVy58($294cc588fecdb4a9$var$Sha256, $kiUCX);
$294cc588fecdb4a9$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $294cc588fecdb4a9$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $294cc588fecdb4a9$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $294cc588fecdb4a9$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $294cc588fecdb4a9$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $294cc588fecdb4a9$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $294cc588fecdb4a9$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$294cc588fecdb4a9$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $294cc588fecdb4a9$var$gamma1(W[i - 2]) + W[i - 7] + $294cc588fecdb4a9$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $294cc588fecdb4a9$var$sigma1(e) + $294cc588fecdb4a9$var$ch(e, f, g) + $294cc588fecdb4a9$var$K[j] + W[j] | 0;
        var T2 = $294cc588fecdb4a9$var$sigma0(a) + $294cc588fecdb4a9$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$294cc588fecdb4a9$var$Sha256.prototype._hash = function() {
    var H = $294cc588fecdb4a9$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $294cc588fecdb4a9$var$Sha256;

});


parcelRegister("5ucsi", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $geuxd = parcelRequire("geuxd");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $3fe96a7b74b4b871$require$Buffer = $BUCDt.Buffer;
var $3fe96a7b74b4b871$var$W = new Array(160);
function $3fe96a7b74b4b871$var$Sha384() {
    this.init();
    this._w = $3fe96a7b74b4b871$var$W;
    $kiUCX.call(this, 128, 112);
}
$bVy58($3fe96a7b74b4b871$var$Sha384, $geuxd);
$3fe96a7b74b4b871$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$3fe96a7b74b4b871$var$Sha384.prototype._hash = function() {
    var H = $3fe96a7b74b4b871$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $3fe96a7b74b4b871$var$Sha384;

});
parcelRegister("geuxd", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $kiUCX = parcelRequire("kiUCX");

var $BUCDt = parcelRequire("BUCDt");
var $bd15a3b1ba797b65$require$Buffer = $BUCDt.Buffer;
var $bd15a3b1ba797b65$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $bd15a3b1ba797b65$var$W = new Array(160);
function $bd15a3b1ba797b65$var$Sha512() {
    this.init();
    this._w = $bd15a3b1ba797b65$var$W;
    $kiUCX.call(this, 128, 112);
}
$bVy58($bd15a3b1ba797b65$var$Sha512, $kiUCX);
$bd15a3b1ba797b65$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $bd15a3b1ba797b65$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $bd15a3b1ba797b65$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $bd15a3b1ba797b65$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $bd15a3b1ba797b65$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $bd15a3b1ba797b65$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $bd15a3b1ba797b65$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $bd15a3b1ba797b65$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $bd15a3b1ba797b65$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $bd15a3b1ba797b65$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$bd15a3b1ba797b65$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $bd15a3b1ba797b65$var$Gamma0(xh, xl);
        var gamma0l = $bd15a3b1ba797b65$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $bd15a3b1ba797b65$var$Gamma1(xh, xl);
        var gamma1l = $bd15a3b1ba797b65$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $bd15a3b1ba797b65$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $bd15a3b1ba797b65$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $bd15a3b1ba797b65$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $bd15a3b1ba797b65$var$maj(ah, bh, ch);
        var majl = $bd15a3b1ba797b65$var$maj(al, bl, cl);
        var sigma0h = $bd15a3b1ba797b65$var$sigma0(ah, al);
        var sigma0l = $bd15a3b1ba797b65$var$sigma0(al, ah);
        var sigma1h = $bd15a3b1ba797b65$var$sigma1(eh, el);
        var sigma1l = $bd15a3b1ba797b65$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $bd15a3b1ba797b65$var$K[j];
        var Kil = $bd15a3b1ba797b65$var$K[j + 1];
        var chh = $bd15a3b1ba797b65$var$Ch(eh, fh, gh);
        var chl = $bd15a3b1ba797b65$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $bd15a3b1ba797b65$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $bd15a3b1ba797b65$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $bd15a3b1ba797b65$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $bd15a3b1ba797b65$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $bd15a3b1ba797b65$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $bd15a3b1ba797b65$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $bd15a3b1ba797b65$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $bd15a3b1ba797b65$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $bd15a3b1ba797b65$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $bd15a3b1ba797b65$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $bd15a3b1ba797b65$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $bd15a3b1ba797b65$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $bd15a3b1ba797b65$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $bd15a3b1ba797b65$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $bd15a3b1ba797b65$var$getCarry(this._hl, hl) | 0;
};
$bd15a3b1ba797b65$var$Sha512.prototype._hash = function() {
    var H = $bd15a3b1ba797b65$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $bd15a3b1ba797b65$var$Sha512;

});



parcelRegister("c7vVf", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $8d2ee6926b17f6c2$require$Buffer = $BUCDt.Buffer;

var $2fkCS = parcelRequire("2fkCS");
var $8d2ee6926b17f6c2$require$Transform = $2fkCS.Transform;

var $fggZn = parcelRequire("fggZn");
var $8d2ee6926b17f6c2$require$StringDecoder = $fggZn.StringDecoder;

var $bVy58 = parcelRequire("bVy58");
function $8d2ee6926b17f6c2$var$CipherBase(hashMode) {
    $8d2ee6926b17f6c2$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$bVy58($8d2ee6926b17f6c2$var$CipherBase, $8d2ee6926b17f6c2$require$Transform);
var $8d2ee6926b17f6c2$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $8d2ee6926b17f6c2$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($8d2ee6926b17f6c2$require$Buffer.prototype instanceof Uint8Array || $8d2ee6926b17f6c2$require$Buffer.TYPED_ARRAY_SUPPORT);
function $8d2ee6926b17f6c2$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $8d2ee6926b17f6c2$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $8d2ee6926b17f6c2$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($8d2ee6926b17f6c2$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $8d2ee6926b17f6c2$require$Buffer.alloc(0);
        var res = $8d2ee6926b17f6c2$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($8d2ee6926b17f6c2$var$useUint8Array && data instanceof Uint8Array) return $8d2ee6926b17f6c2$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($8d2ee6926b17f6c2$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $8d2ee6926b17f6c2$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$8d2ee6926b17f6c2$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $8d2ee6926b17f6c2$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$8d2ee6926b17f6c2$var$CipherBase.prototype.setAutoPadding = function() {};
$8d2ee6926b17f6c2$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$8d2ee6926b17f6c2$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$8d2ee6926b17f6c2$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$8d2ee6926b17f6c2$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$8d2ee6926b17f6c2$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$8d2ee6926b17f6c2$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $8d2ee6926b17f6c2$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$8d2ee6926b17f6c2$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $8d2ee6926b17f6c2$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $8d2ee6926b17f6c2$var$CipherBase;

});
parcelRegister("2fkCS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $1a2cfb5d753160d7$var$Stream;

var $cOXur = parcelRequire("cOXur");
var $1a2cfb5d753160d7$require$EE = $cOXur.EventEmitter;

var $bVy58 = parcelRequire("bVy58");
$bVy58($1a2cfb5d753160d7$var$Stream, $1a2cfb5d753160d7$require$EE);

$1a2cfb5d753160d7$var$Stream.Readable = (parcelRequire("eHaR5"));

$1a2cfb5d753160d7$var$Stream.Writable = (parcelRequire("2HQXg"));

$1a2cfb5d753160d7$var$Stream.Duplex = (parcelRequire("SmnH1"));

$1a2cfb5d753160d7$var$Stream.Transform = (parcelRequire("ecjlu"));

$1a2cfb5d753160d7$var$Stream.PassThrough = (parcelRequire("NHJdp"));

$1a2cfb5d753160d7$var$Stream.finished = (parcelRequire("khBQN"));

$1a2cfb5d753160d7$var$Stream.pipeline = (parcelRequire("77cYF"));
// Backwards-compat with node 0.4.x
$1a2cfb5d753160d7$var$Stream.Stream = $1a2cfb5d753160d7$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $1a2cfb5d753160d7$var$Stream() {
    $1a2cfb5d753160d7$require$EE.call(this);
}
$1a2cfb5d753160d7$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1a2cfb5d753160d7$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("kJE7u", function(module, exports) {
'use strict';

var $bVy58 = parcelRequire("bVy58");

var $80P0j = parcelRequire("80P0j");

var $c7vVf = parcelRequire("c7vVf");

var $BUCDt = parcelRequire("BUCDt");
var $f1872193ad08843e$require$Buffer = $BUCDt.Buffer;

var $8Lgwn = parcelRequire("8Lgwn");

var $fboL1 = parcelRequire("fboL1");

var $3qMts = parcelRequire("3qMts");
var $f1872193ad08843e$var$ZEROS = $f1872193ad08843e$require$Buffer.alloc(128);
function $f1872193ad08843e$var$Hmac(alg, key) {
    $c7vVf.call(this, 'digest');
    if (typeof key === 'string') key = $f1872193ad08843e$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $fboL1() : $3qMts(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $f1872193ad08843e$require$Buffer.concat([
        key,
        $f1872193ad08843e$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $f1872193ad08843e$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $f1872193ad08843e$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $fboL1() : $3qMts(alg);
    this._hash.update(ipad);
}
$bVy58($f1872193ad08843e$var$Hmac, $c7vVf);
$f1872193ad08843e$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$f1872193ad08843e$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $fboL1() : $3qMts(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $f1872193ad08843e$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $80P0j($8Lgwn, key);
    return new $f1872193ad08843e$var$Hmac(alg, key);
};

});
parcelRegister("80P0j", function(module, exports) {
'use strict';

var $bVy58 = parcelRequire("bVy58");

var $BUCDt = parcelRequire("BUCDt");
var $5d55e32a7b4d9904$require$Buffer = $BUCDt.Buffer;

var $c7vVf = parcelRequire("c7vVf");
var $5d55e32a7b4d9904$var$ZEROS = $5d55e32a7b4d9904$require$Buffer.alloc(128);
var $5d55e32a7b4d9904$var$blocksize = 64;
function $5d55e32a7b4d9904$var$Hmac(alg, key) {
    $c7vVf.call(this, 'digest');
    if (typeof key === 'string') key = $5d55e32a7b4d9904$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $5d55e32a7b4d9904$var$blocksize) key = alg(key);
    else if (key.length < $5d55e32a7b4d9904$var$blocksize) key = $5d55e32a7b4d9904$require$Buffer.concat([
        key,
        $5d55e32a7b4d9904$var$ZEROS
    ], $5d55e32a7b4d9904$var$blocksize);
    var ipad = this._ipad = $5d55e32a7b4d9904$require$Buffer.allocUnsafe($5d55e32a7b4d9904$var$blocksize);
    var opad = this._opad = $5d55e32a7b4d9904$require$Buffer.allocUnsafe($5d55e32a7b4d9904$var$blocksize);
    for(var i = 0; i < $5d55e32a7b4d9904$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$bVy58($5d55e32a7b4d9904$var$Hmac, $c7vVf);
$5d55e32a7b4d9904$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$5d55e32a7b4d9904$var$Hmac.prototype._final = function() {
    var h = this._alg($5d55e32a7b4d9904$require$Buffer.concat(this._hash));
    return this._alg($5d55e32a7b4d9904$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $5d55e32a7b4d9904$var$Hmac;

});

parcelRegister("8Lgwn", function(module, exports) {

var $cqxFF = parcelRequire("cqxFF");
module.exports = function(buffer) {
    return new $cqxFF().update(buffer).digest();
};

});


parcelRegister("xqD8r", function(module, exports) {
'use strict';

module.exports = (parcelRequire("amrQM"));

});
parcelRegister("amrQM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("4tG8V", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $342a8f8ddb842e5b$export$448fa22aedc9dbca; }, function (v) { return $342a8f8ddb842e5b$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $342a8f8ddb842e5b$export$b80c7ba289c8fa56; }, function (v) { return $342a8f8ddb842e5b$export$b80c7ba289c8fa56 = v; });
var $342a8f8ddb842e5b$export$448fa22aedc9dbca;
var $342a8f8ddb842e5b$export$b80c7ba289c8fa56;
'use strict';

$342a8f8ddb842e5b$export$448fa22aedc9dbca = (parcelRequire("3zwyx"));

$342a8f8ddb842e5b$export$b80c7ba289c8fa56 = (parcelRequire("hpUfU"));

});
parcelRegister("3zwyx", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $299de4f3663ff153$require$Buffer = $BUCDt.Buffer;

var $hHqPa = parcelRequire("hHqPa");

var $6Bt3w = parcelRequire("6Bt3w");

var $hpUfU = parcelRequire("hpUfU");

var $bTeq7 = parcelRequire("bTeq7");
var $299de4f3663ff153$var$ZERO_BUF;
var $299de4f3663ff153$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $299de4f3663ff153$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $299de4f3663ff153$var$checks = [];
var $299de4f3663ff153$var$nextTick;
function $299de4f3663ff153$var$getNextTick() {
    if ($299de4f3663ff153$var$nextTick) return $299de4f3663ff153$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $299de4f3663ff153$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $299de4f3663ff153$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $299de4f3663ff153$var$nextTick = $parcel$global.setImmediate;
    else $299de4f3663ff153$var$nextTick = $parcel$global.setTimeout;
    return $299de4f3663ff153$var$nextTick;
}
function $299de4f3663ff153$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $299de4f3663ff153$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $299de4f3663ff153$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $299de4f3663ff153$require$Buffer.from(res);
    });
}
function $299de4f3663ff153$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$299de4f3663ff153$var$subtle || !$299de4f3663ff153$var$subtle.importKey || !$299de4f3663ff153$var$subtle.deriveBits) return Promise.resolve(false);
    if ($299de4f3663ff153$var$checks[algo] !== undefined) return $299de4f3663ff153$var$checks[algo];
    $299de4f3663ff153$var$ZERO_BUF = $299de4f3663ff153$var$ZERO_BUF || $299de4f3663ff153$require$Buffer.alloc(8);
    var prom = $299de4f3663ff153$var$browserPbkdf2($299de4f3663ff153$var$ZERO_BUF, $299de4f3663ff153$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $299de4f3663ff153$var$checks[algo] = prom;
    return prom;
}
function $299de4f3663ff153$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $299de4f3663ff153$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $299de4f3663ff153$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $299de4f3663ff153$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $299de4f3663ff153$var$getNextTick()(function() {
            var out;
            try {
                out = $hpUfU(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $hHqPa(iterations, keylen);
    password = $bTeq7(password, $6Bt3w, 'Password');
    salt = $bTeq7(salt, $6Bt3w, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $299de4f3663ff153$var$resolvePromise($299de4f3663ff153$var$checkNative(algo).then(function(resp) {
        if (resp) return $299de4f3663ff153$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $hpUfU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("hHqPa", function(module, exports) {
'use strict';
var $ce2b42901b2607fd$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $ce2b42901b2607fd$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("6Bt3w", function(module, exports) {

var $3iXjX = parcelRequire("3iXjX");
'use strict';
var $4cecbca289c996a0$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $4cecbca289c996a0$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $4cecbca289c996a0$var$pVersionMajor = parseInt($3iXjX.version.split('.')[0].slice(1), 10);
    $4cecbca289c996a0$var$defaultEncoding = $4cecbca289c996a0$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $4cecbca289c996a0$var$defaultEncoding = 'utf-8';
module.exports = $4cecbca289c996a0$var$defaultEncoding;

});

parcelRegister("hpUfU", function(module, exports) {
'use strict';

var $awDJ3 = parcelRequire("awDJ3");

var $jjat5 = parcelRequire("jjat5");

var $3qMts = parcelRequire("3qMts");

var $BUCDt = parcelRequire("BUCDt");
var $cae068a797992dc0$require$Buffer = $BUCDt.Buffer;

var $hHqPa = parcelRequire("hHqPa");

var $6Bt3w = parcelRequire("6Bt3w");

var $bTeq7 = parcelRequire("bTeq7");
var $cae068a797992dc0$var$ZEROS = $cae068a797992dc0$require$Buffer.alloc(128);
var $cae068a797992dc0$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $cae068a797992dc0$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $cae068a797992dc0$var$rmd160Func(data) {
    return new $jjat5().update(data).digest();
}
function $cae068a797992dc0$var$getDigest(alg) {
    function shaFunc(data) {
        return $3qMts(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $cae068a797992dc0$var$rmd160Func;
    if (alg === 'md5') return $awDJ3;
    return shaFunc;
}
function $cae068a797992dc0$var$Hmac(alg, key, saltLen) {
    var hash = $cae068a797992dc0$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $cae068a797992dc0$require$Buffer.concat([
        key,
        $cae068a797992dc0$var$ZEROS
    ], blocksize);
    var ipad = $cae068a797992dc0$require$Buffer.allocUnsafe(blocksize + $cae068a797992dc0$var$sizes[alg]);
    var opad = $cae068a797992dc0$require$Buffer.allocUnsafe(blocksize + $cae068a797992dc0$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $cae068a797992dc0$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $cae068a797992dc0$var$sizes[alg];
}
$cae068a797992dc0$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $cae068a797992dc0$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $hHqPa(iterations, keylen);
    password = $bTeq7(password, $6Bt3w, 'Password');
    salt = $bTeq7(salt, $6Bt3w, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $cae068a797992dc0$var$mapping[lowerDigest] || lowerDigest;
    var size = $cae068a797992dc0$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $cae068a797992dc0$var$Hmac(mappedDigest, password, salt.length);
    var DK = $cae068a797992dc0$require$Buffer.allocUnsafe(keylen);
    var block1 = $cae068a797992dc0$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $cae068a797992dc0$var$pbkdf2;

});
parcelRegister("awDJ3", function(module, exports) {
'use strict';

var $deXIn = parcelRequire("deXIn");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $7a9bb54240f923b3$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $7a9bb54240f923b3$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $7a9bb54240f923b3$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $7a9bb54240f923b3$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $7a9bb54240f923b3$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $7a9bb54240f923b3$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $7a9bb54240f923b3$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $7a9bb54240f923b3$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $7a9bb54240f923b3$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $7a9bb54240f923b3$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $7a9bb54240f923b3$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $7a9bb54240f923b3$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $7a9bb54240f923b3$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $7a9bb54240f923b3$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $7a9bb54240f923b3$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $7a9bb54240f923b3$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $7a9bb54240f923b3$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $7a9bb54240f923b3$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $7a9bb54240f923b3$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $7a9bb54240f923b3$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $7a9bb54240f923b3$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $7a9bb54240f923b3$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $7a9bb54240f923b3$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $7a9bb54240f923b3$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $7a9bb54240f923b3$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $7a9bb54240f923b3$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $7a9bb54240f923b3$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $7a9bb54240f923b3$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $7a9bb54240f923b3$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $7a9bb54240f923b3$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $7a9bb54240f923b3$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $7a9bb54240f923b3$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $7a9bb54240f923b3$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $7a9bb54240f923b3$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $7a9bb54240f923b3$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $7a9bb54240f923b3$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $7a9bb54240f923b3$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $7a9bb54240f923b3$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $7a9bb54240f923b3$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $7a9bb54240f923b3$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $7a9bb54240f923b3$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $7a9bb54240f923b3$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $7a9bb54240f923b3$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $7a9bb54240f923b3$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $7a9bb54240f923b3$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $7a9bb54240f923b3$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $7a9bb54240f923b3$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $7a9bb54240f923b3$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $7a9bb54240f923b3$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $7a9bb54240f923b3$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $7a9bb54240f923b3$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $7a9bb54240f923b3$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $7a9bb54240f923b3$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $7a9bb54240f923b3$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $7a9bb54240f923b3$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $7a9bb54240f923b3$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $7a9bb54240f923b3$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $7a9bb54240f923b3$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $7a9bb54240f923b3$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $7a9bb54240f923b3$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $7a9bb54240f923b3$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $7a9bb54240f923b3$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $7a9bb54240f923b3$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $7a9bb54240f923b3$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $7a9bb54240f923b3$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $7a9bb54240f923b3$var$safe_add(a, olda);
        b = $7a9bb54240f923b3$var$safe_add(b, oldb);
        c = $7a9bb54240f923b3$var$safe_add(c, oldc);
        d = $7a9bb54240f923b3$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $7a9bb54240f923b3$var$md5_cmn(q, a, b, x, s, t) {
    return $7a9bb54240f923b3$var$safe_add($7a9bb54240f923b3$var$bit_rol($7a9bb54240f923b3$var$safe_add($7a9bb54240f923b3$var$safe_add(a, q), $7a9bb54240f923b3$var$safe_add(x, t)), s), b);
}
function $7a9bb54240f923b3$var$md5_ff(a, b, c, d, x, s, t) {
    return $7a9bb54240f923b3$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $7a9bb54240f923b3$var$md5_gg(a, b, c, d, x, s, t) {
    return $7a9bb54240f923b3$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $7a9bb54240f923b3$var$md5_hh(a, b, c, d, x, s, t) {
    return $7a9bb54240f923b3$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $7a9bb54240f923b3$var$md5_ii(a, b, c, d, x, s, t) {
    return $7a9bb54240f923b3$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $7a9bb54240f923b3$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $7a9bb54240f923b3$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $deXIn(buf, $7a9bb54240f923b3$var$core_md5);
};

});
parcelRegister("deXIn", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $9a3ae74be898f90a$require$Buffer = $8f5i0.Buffer;
'use strict';
var $9a3ae74be898f90a$var$intSize = 4;
var $9a3ae74be898f90a$var$zeroBuffer = new $9a3ae74be898f90a$require$Buffer($9a3ae74be898f90a$var$intSize);
$9a3ae74be898f90a$var$zeroBuffer.fill(0);
var $9a3ae74be898f90a$var$charSize = 8;
var $9a3ae74be898f90a$var$hashSize = 16;
function $9a3ae74be898f90a$var$toArray(buf) {
    if (buf.length % $9a3ae74be898f90a$var$intSize !== 0) {
        var len = buf.length + ($9a3ae74be898f90a$var$intSize - buf.length % $9a3ae74be898f90a$var$intSize);
        buf = $9a3ae74be898f90a$require$Buffer.concat([
            buf,
            $9a3ae74be898f90a$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $9a3ae74be898f90a$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($9a3ae74be898f90a$var$toArray(buf), buf.length * $9a3ae74be898f90a$var$charSize);
    buf = new $9a3ae74be898f90a$require$Buffer($9a3ae74be898f90a$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("jjat5", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $e0e7e96d1b82bb6b$require$Buffer = $8f5i0.Buffer;
'use strict';

var $bVy58 = parcelRequire("bVy58");

var $jR5J5 = parcelRequire("jR5J5");
function $e0e7e96d1b82bb6b$var$RIPEMD160() {
    $jR5J5.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$bVy58($e0e7e96d1b82bb6b$var$RIPEMD160, $jR5J5);
$e0e7e96d1b82bb6b$var$RIPEMD160.prototype._update = function() {
    var m = new Array(16);
    for(var i = 0; i < 16; ++i)m[i] = this._block.readInt32LE(i * 4);
    var al = this._a;
    var bl = this._b;
    var cl = this._c;
    var dl = this._d;
    var el = this._e;
    // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    // K = 0x00000000
    // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
    al = $e0e7e96d1b82bb6b$var$fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
    // K = 0x5a827999
    // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
    el = $e0e7e96d1b82bb6b$var$fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
    // K = 0x6ed9eba1
    // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
    dl = $e0e7e96d1b82bb6b$var$fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
    // K = 0x8f1bbcdc
    // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
    cl = $e0e7e96d1b82bb6b$var$fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    // K = 0xa953fd4e
    // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    bl = $e0e7e96d1b82bb6b$var$fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    al = $e0e7e96d1b82bb6b$var$fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);
    cl = $e0e7e96d1b82bb6b$var$rotl(cl, 10);
    el = $e0e7e96d1b82bb6b$var$fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);
    bl = $e0e7e96d1b82bb6b$var$rotl(bl, 10);
    dl = $e0e7e96d1b82bb6b$var$fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);
    al = $e0e7e96d1b82bb6b$var$rotl(al, 10);
    cl = $e0e7e96d1b82bb6b$var$fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);
    el = $e0e7e96d1b82bb6b$var$rotl(el, 10);
    bl = $e0e7e96d1b82bb6b$var$fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);
    dl = $e0e7e96d1b82bb6b$var$rotl(dl, 10);
    var ar = this._a;
    var br = this._b;
    var cr = this._c;
    var dr = this._d;
    var er = this._e;
    // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
    // K' = 0x50a28be6
    // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
    ar = $e0e7e96d1b82bb6b$var$fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
    // K' = 0x5c4dd124
    // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
    er = $e0e7e96d1b82bb6b$var$fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
    // K' = 0x6d703ef3
    // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
    dr = $e0e7e96d1b82bb6b$var$fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
    // K' = 0x7a6d76e9
    // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
    cr = $e0e7e96d1b82bb6b$var$fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    // K' = 0x00000000
    // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    br = $e0e7e96d1b82bb6b$var$fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    ar = $e0e7e96d1b82bb6b$var$fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);
    cr = $e0e7e96d1b82bb6b$var$rotl(cr, 10);
    er = $e0e7e96d1b82bb6b$var$fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);
    br = $e0e7e96d1b82bb6b$var$rotl(br, 10);
    dr = $e0e7e96d1b82bb6b$var$fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);
    ar = $e0e7e96d1b82bb6b$var$rotl(ar, 10);
    cr = $e0e7e96d1b82bb6b$var$fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);
    er = $e0e7e96d1b82bb6b$var$rotl(er, 10);
    br = $e0e7e96d1b82bb6b$var$fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);
    dr = $e0e7e96d1b82bb6b$var$rotl(dr, 10);
    // change state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$e0e7e96d1b82bb6b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $e0e7e96d1b82bb6b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $e0e7e96d1b82bb6b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $e0e7e96d1b82bb6b$var$fn1(a, b, c, d, e, m, k, s) {
    return $e0e7e96d1b82bb6b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $e0e7e96d1b82bb6b$var$fn2(a, b, c, d, e, m, k, s) {
    return $e0e7e96d1b82bb6b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $e0e7e96d1b82bb6b$var$fn3(a, b, c, d, e, m, k, s) {
    return $e0e7e96d1b82bb6b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $e0e7e96d1b82bb6b$var$fn4(a, b, c, d, e, m, k, s) {
    return $e0e7e96d1b82bb6b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $e0e7e96d1b82bb6b$var$fn5(a, b, c, d, e, m, k, s) {
    return $e0e7e96d1b82bb6b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $e0e7e96d1b82bb6b$var$RIPEMD160;

});
parcelRegister("jR5J5", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $e74768ae3ba84bb4$require$Buffer = $8f5i0.Buffer;
'use strict';

var $2fkCS = parcelRequire("2fkCS");
var $e74768ae3ba84bb4$require$Transform = $2fkCS.Transform;

var $bVy58 = parcelRequire("bVy58");
function $e74768ae3ba84bb4$var$HashBase(blockSize) {
    $e74768ae3ba84bb4$require$Transform.call(this);
    this._block = new $e74768ae3ba84bb4$require$Buffer(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$bVy58($e74768ae3ba84bb4$var$HashBase, $e74768ae3ba84bb4$require$Transform);
$e74768ae3ba84bb4$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        if (encoding !== 'buffer') chunk = new $e74768ae3ba84bb4$require$Buffer(chunk, encoding);
        this.update(chunk);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$e74768ae3ba84bb4$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this._digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$e74768ae3ba84bb4$var$HashBase.prototype.update = function(data, encoding) {
    if (!$e74768ae3ba84bb4$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
    if (this._finalized) throw new Error('Digest already called');
    if (!$e74768ae3ba84bb4$require$Buffer.isBuffer(data)) data = new $e74768ae3ba84bb4$require$Buffer(data, encoding || 'binary');
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$e74768ae3ba84bb4$var$HashBase.prototype._update = function(data) {
    throw new Error('_update is not implemented');
};
$e74768ae3ba84bb4$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    return digest;
};
$e74768ae3ba84bb4$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $e74768ae3ba84bb4$var$HashBase;

});


parcelRegister("bTeq7", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $8a8004575ee86032$require$Buffer = $BUCDt.Buffer;

var $foCvk = parcelRequire("foCvk");
var $8a8004575ee86032$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $8a8004575ee86032$var$useArrayBuffer = $8a8004575ee86032$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $8a8004575ee86032$var$isView = $8a8004575ee86032$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $8a8004575ee86032$require$Buffer.isBuffer(thing) || $8a8004575ee86032$var$useUint8Array && thing instanceof Uint8Array || $8a8004575ee86032$var$isView && $8a8004575ee86032$var$isView(thing)) return $foCvk(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("foCvk", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $02e47fdb124a8e6b$require$Buffer = $BUCDt.Buffer;

var $9TyQz = parcelRequire("9TyQz");

var $fVI18 = parcelRequire("fVI18");
var $02e47fdb124a8e6b$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $fVI18(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $02e47fdb124a8e6b$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $02e47fdb124a8e6b$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $02e47fdb124a8e6b$var$useFromArrayBuffer = $02e47fdb124a8e6b$var$useArrayBuffer && ($02e47fdb124a8e6b$require$Buffer.prototype instanceof Uint8Array || $02e47fdb124a8e6b$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $02e47fdb124a8e6b$require$Buffer) return data;
    if (typeof data === 'string') return $02e47fdb124a8e6b$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($02e47fdb124a8e6b$var$useArrayBuffer && $02e47fdb124a8e6b$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $02e47fdb124a8e6b$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($02e47fdb124a8e6b$var$useFromArrayBuffer) {
            var res = $02e47fdb124a8e6b$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $02e47fdb124a8e6b$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($02e47fdb124a8e6b$var$useUint8Array && data instanceof Uint8Array) return $02e47fdb124a8e6b$require$Buffer.from(data);
    var isArr = $9TyQz(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $02e47fdb124a8e6b$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $02e47fdb124a8e6b$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("9TyQz", function(module, exports) {
var $734447fac31c04ef$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $734447fac31c04ef$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("fVI18", function(module, exports) {
'use strict';

var $589A0 = parcelRequire("589A0");

var $9dGLi = parcelRequire("9dGLi");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $b98e52d3c9b611d6$var$$typedArrayBuffer = $9dGLi('TypedArray.prototype.buffer', true);

var $ghMok = parcelRequire("ghMok");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $b98e52d3c9b611d6$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$ghMok(x)) throw new $589A0('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("589A0", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("9dGLi", function(module, exports) {
'use strict';

var $2t5Qi = parcelRequire("2t5Qi");

var $54J2f = parcelRequire("54J2f");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $6b667f8ef77e5813$var$$indexOf = $54J2f([
    $2t5Qi('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $2t5Qi(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6b667f8ef77e5813$var$$indexOf(name, '.prototype.') > -1) return $54J2f(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("2t5Qi", function(module, exports) {
'use strict';
var $1cc2d2694852c096$var$undefined1;

var $a8Cx3 = parcelRequire("a8Cx3");

var $eYIES = parcelRequire("eYIES");

var $f5ze0 = parcelRequire("f5ze0");

var $66y3P = parcelRequire("66y3P");

var $bJA0T = parcelRequire("bJA0T");

var $icqcp = parcelRequire("icqcp");

var $589A0 = parcelRequire("589A0");

var $fosQf = parcelRequire("fosQf");

var $br1jH = parcelRequire("br1jH");

var $7FKqr = parcelRequire("7FKqr");

var $ezuuu = parcelRequire("ezuuu");

var $lH4lS = parcelRequire("lH4lS");

var $b0sLJ = parcelRequire("b0sLJ");

var $3s0o5 = parcelRequire("3s0o5");

var $aOHZk = parcelRequire("aOHZk");
var $1cc2d2694852c096$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1cc2d2694852c096$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1cc2d2694852c096$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $l12hX = parcelRequire("l12hX");

var $1MpNQ = parcelRequire("1MpNQ");
var $1cc2d2694852c096$var$throwTypeError = function() {
    throw new $589A0();
};
var $1cc2d2694852c096$var$ThrowTypeError = $l12hX ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1cc2d2694852c096$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $l12hX(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1cc2d2694852c096$var$throwTypeError;
        }
    }
}() : $1cc2d2694852c096$var$throwTypeError;

var $1cc2d2694852c096$var$hasSymbols = (parcelRequire("hKmqh"))();

var $3Y4sF = parcelRequire("3Y4sF");

var $hQcTz = parcelRequire("hQcTz");

var $54In5 = parcelRequire("54In5");

var $17kBB = parcelRequire("17kBB");

var $kIwJt = parcelRequire("kIwJt");
var $1cc2d2694852c096$var$needsEval = {};
var $1cc2d2694852c096$var$TypedArray = typeof Uint8Array === 'undefined' || !$3Y4sF ? undefined : $3Y4sF(Uint8Array);
var $1cc2d2694852c096$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1cc2d2694852c096$var$hasSymbols && $3Y4sF ? $3Y4sF([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1cc2d2694852c096$var$needsEval,
    '%AsyncGenerator%': $1cc2d2694852c096$var$needsEval,
    '%AsyncGeneratorFunction%': $1cc2d2694852c096$var$needsEval,
    '%AsyncIteratorPrototype%': $1cc2d2694852c096$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $eYIES,
    '%eval%': eval,
    '%EvalError%': $f5ze0,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1cc2d2694852c096$var$$Function,
    '%GeneratorFunction%': $1cc2d2694852c096$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1cc2d2694852c096$var$hasSymbols && $3Y4sF ? $3Y4sF($3Y4sF([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1cc2d2694852c096$var$hasSymbols || !$3Y4sF ? undefined : $3Y4sF(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $a8Cx3,
    '%Object.getOwnPropertyDescriptor%': $l12hX,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $66y3P,
    '%ReferenceError%': $bJA0T,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1cc2d2694852c096$var$hasSymbols || !$3Y4sF ? undefined : $3Y4sF(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1cc2d2694852c096$var$hasSymbols && $3Y4sF ? $3Y4sF(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1cc2d2694852c096$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $icqcp,
    '%ThrowTypeError%': $1cc2d2694852c096$var$ThrowTypeError,
    '%TypedArray%': $1cc2d2694852c096$var$TypedArray,
    '%TypeError%': $589A0,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fosQf,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $kIwJt,
    '%Function.prototype.apply%': $17kBB,
    '%Object.defineProperty%': $1MpNQ,
    '%Object.getPrototypeOf%': $hQcTz,
    '%Math.abs%': $br1jH,
    '%Math.floor%': $7FKqr,
    '%Math.max%': $ezuuu,
    '%Math.min%': $lH4lS,
    '%Math.pow%': $b0sLJ,
    '%Math.round%': $3s0o5,
    '%Math.sign%': $aOHZk,
    '%Reflect.getPrototypeOf%': $54In5
};
if ($3Y4sF) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1cc2d2694852c096$var$errorProto = $3Y4sF($3Y4sF(e));
    $1cc2d2694852c096$var$INTRINSICS['%Error.prototype%'] = $1cc2d2694852c096$var$errorProto;
}
var $1cc2d2694852c096$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1cc2d2694852c096$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1cc2d2694852c096$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1cc2d2694852c096$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3Y4sF) value = $3Y4sF(gen.prototype);
    }
    $1cc2d2694852c096$var$INTRINSICS[name] = value;
    return value;
};
var $1cc2d2694852c096$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $27LhK = parcelRequire("27LhK");

var $2Nbrd = parcelRequire("2Nbrd");
var $1cc2d2694852c096$var$$concat = $27LhK.call($kIwJt, Array.prototype.concat);
var $1cc2d2694852c096$var$$spliceApply = $27LhK.call($17kBB, Array.prototype.splice);
var $1cc2d2694852c096$var$$replace = $27LhK.call($kIwJt, String.prototype.replace);
var $1cc2d2694852c096$var$$strSlice = $27LhK.call($kIwJt, String.prototype.slice);
var $1cc2d2694852c096$var$$exec = $27LhK.call($kIwJt, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1cc2d2694852c096$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1cc2d2694852c096$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1cc2d2694852c096$var$stringToPath = function stringToPath(string) {
    var first = $1cc2d2694852c096$var$$strSlice(string, 0, 1);
    var last = $1cc2d2694852c096$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $icqcp('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $icqcp('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1cc2d2694852c096$var$$replace(string, $1cc2d2694852c096$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1cc2d2694852c096$var$$replace(subString, $1cc2d2694852c096$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1cc2d2694852c096$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2Nbrd($1cc2d2694852c096$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1cc2d2694852c096$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($2Nbrd($1cc2d2694852c096$var$INTRINSICS, intrinsicName)) {
        var value = $1cc2d2694852c096$var$INTRINSICS[intrinsicName];
        if (value === $1cc2d2694852c096$var$needsEval) value = $1cc2d2694852c096$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $589A0('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $icqcp('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $589A0('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $589A0('"allowMissing" argument must be a boolean');
    if ($1cc2d2694852c096$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $icqcp('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1cc2d2694852c096$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1cc2d2694852c096$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1cc2d2694852c096$var$$spliceApply(parts, $1cc2d2694852c096$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1cc2d2694852c096$var$$strSlice(part, 0, 1);
        var last = $1cc2d2694852c096$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $icqcp('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($2Nbrd($1cc2d2694852c096$var$INTRINSICS, intrinsicRealName)) value = $1cc2d2694852c096$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $589A0('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($l12hX && i + 1 >= parts.length) {
                var desc = $l12hX(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2Nbrd(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1cc2d2694852c096$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("a8Cx3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("eYIES", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("f5ze0", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("66y3P", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("bJA0T", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("icqcp", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("fosQf", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("br1jH", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("7FKqr", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("ezuuu", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("lH4lS", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("b0sLJ", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("3s0o5", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("aOHZk", function(module, exports) {
'use strict';

var $e1muJ = parcelRequire("e1muJ");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($e1muJ(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("e1muJ", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("l12hX", function(module, exports) {
'use strict';

var $a4kSh = parcelRequire("a4kSh");
var $f4cb776e38c5e7ab$require$$gOPD = $a4kSh;
if ($f4cb776e38c5e7ab$require$$gOPD) try {
    $f4cb776e38c5e7ab$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f4cb776e38c5e7ab$require$$gOPD = null;
}
module.exports = $f4cb776e38c5e7ab$require$$gOPD;

});
parcelRegister("a4kSh", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("1MpNQ", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $14be4a15244299c8$var$$defineProperty = Object.defineProperty || false;
if ($14be4a15244299c8$var$$defineProperty) try {
    $14be4a15244299c8$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $14be4a15244299c8$var$$defineProperty = false;
}
module.exports = $14be4a15244299c8$var$$defineProperty;

});

parcelRegister("hKmqh", function(module, exports) {
'use strict';
var $ceb820437e669df8$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7vje6 = parcelRequire("7vje6");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $ceb820437e669df8$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $ceb820437e669df8$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7vje6();
};

});
parcelRegister("7vje6", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3Y4sF", function(module, exports) {
'use strict';

var $54In5 = parcelRequire("54In5");

var $hQcTz = parcelRequire("hQcTz");

var $8SsyH = parcelRequire("8SsyH");
/** @type {import('.')} */ module.exports = $54In5 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $54In5(O);
} : $hQcTz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hQcTz(O);
} : $8SsyH ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $8SsyH(O);
} : null;

});
parcelRegister("54In5", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("hQcTz", function(module, exports) {
'use strict';

var $cirkj = parcelRequire("cirkj");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $cirkj.getPrototypeOf || null;

});
parcelRegister("cirkj", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});


parcelRegister("8SsyH", function(module, exports) {
'use strict';

var $54J2f = parcelRequire("54J2f");

var $1BQut = parcelRequire("1BQut");
var $67698502094088d3$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $67698502094088d3$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $67698502094088d3$var$desc = !!$67698502094088d3$var$hasProtoAccessor && $1BQut && $1BQut(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $67698502094088d3$var$$Object = Object;
var $67698502094088d3$var$$getPrototypeOf = $67698502094088d3$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $67698502094088d3$var$desc && typeof $67698502094088d3$var$desc.get === 'function' ? $54J2f([
    $67698502094088d3$var$desc.get
]) : typeof $67698502094088d3$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $67698502094088d3$var$$getPrototypeOf(value == null ? value : $67698502094088d3$var$$Object(value));
} : false;

});
parcelRegister("54J2f", function(module, exports) {
'use strict';

var $hoj3m = parcelRequire("hoj3m");

var $589A0 = parcelRequire("589A0");

var $kIwJt = parcelRequire("kIwJt");

var $imQYk = parcelRequire("imQYk");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $589A0('a function is required');
    return $imQYk($hoj3m, $kIwJt, args);
};

});
parcelRegister("hoj3m", function(module, exports) {
'use strict';

var $hiaGo = parcelRequire("hiaGo");
module.exports = Function.prototype.bind || $hiaGo;

});
parcelRegister("hiaGo", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $c96c677ff6bcd76d$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $c96c677ff6bcd76d$var$toStr = Object.prototype.toString;
var $c96c677ff6bcd76d$var$max = Math.max;
var $c96c677ff6bcd76d$var$funcType = '[object Function]';
var $c96c677ff6bcd76d$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $c96c677ff6bcd76d$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $c96c677ff6bcd76d$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $c96c677ff6bcd76d$var$toStr.apply(target) !== $c96c677ff6bcd76d$var$funcType) throw new TypeError($c96c677ff6bcd76d$var$ERROR_MESSAGE + target);
    var args = $c96c677ff6bcd76d$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $c96c677ff6bcd76d$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $c96c677ff6bcd76d$var$concatty(args, arguments));
    };
    var boundLength = $c96c677ff6bcd76d$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $c96c677ff6bcd76d$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("kIwJt", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("imQYk", function(module, exports) {
'use strict';

var $hoj3m = parcelRequire("hoj3m");

var $17kBB = parcelRequire("17kBB");

var $kIwJt = parcelRequire("kIwJt");

var $3LJ5S = parcelRequire("3LJ5S");
/** @type {import('./actualApply')} */ module.exports = $3LJ5S || $hoj3m.call($kIwJt, $17kBB);

});
parcelRegister("17kBB", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("3LJ5S", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});



parcelRegister("1BQut", function(module, exports) {
'use strict';

var $eO825 = parcelRequire("eO825");
var $12c1f6af9ffdba50$require$$gOPD = $eO825;
if ($12c1f6af9ffdba50$require$$gOPD) try {
    $12c1f6af9ffdba50$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $12c1f6af9ffdba50$require$$gOPD = null;
}
module.exports = $12c1f6af9ffdba50$require$$gOPD;

});
parcelRegister("eO825", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});




parcelRegister("27LhK", function(module, exports) {
'use strict';

var $7cuMj = parcelRequire("7cuMj");
module.exports = Function.prototype.bind || $7cuMj;

});
parcelRegister("7cuMj", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $53e1874ab4f870f0$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $53e1874ab4f870f0$var$toStr = Object.prototype.toString;
var $53e1874ab4f870f0$var$max = Math.max;
var $53e1874ab4f870f0$var$funcType = '[object Function]';
var $53e1874ab4f870f0$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $53e1874ab4f870f0$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $53e1874ab4f870f0$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $53e1874ab4f870f0$var$toStr.apply(target) !== $53e1874ab4f870f0$var$funcType) throw new TypeError($53e1874ab4f870f0$var$ERROR_MESSAGE + target);
    var args = $53e1874ab4f870f0$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $53e1874ab4f870f0$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $53e1874ab4f870f0$var$concatty(args, arguments));
    };
    var boundLength = $53e1874ab4f870f0$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $53e1874ab4f870f0$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("2Nbrd", function(module, exports) {
'use strict';
var $208907b957bb1692$var$call = Function.prototype.call;
var $208907b957bb1692$var$$hasOwn = Object.prototype.hasOwnProperty;

var $3uw9f = parcelRequire("3uw9f");
/** @type {import('.')} */ module.exports = $3uw9f.call($208907b957bb1692$var$call, $208907b957bb1692$var$$hasOwn);

});
parcelRegister("3uw9f", function(module, exports) {
'use strict';

var $lMfQ4 = parcelRequire("lMfQ4");
module.exports = Function.prototype.bind || $lMfQ4;

});
parcelRegister("lMfQ4", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $fdaa5df4be4dca7f$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $fdaa5df4be4dca7f$var$toStr = Object.prototype.toString;
var $fdaa5df4be4dca7f$var$max = Math.max;
var $fdaa5df4be4dca7f$var$funcType = '[object Function]';
var $fdaa5df4be4dca7f$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $fdaa5df4be4dca7f$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $fdaa5df4be4dca7f$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $fdaa5df4be4dca7f$var$toStr.apply(target) !== $fdaa5df4be4dca7f$var$funcType) throw new TypeError($fdaa5df4be4dca7f$var$ERROR_MESSAGE + target);
    var args = $fdaa5df4be4dca7f$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $fdaa5df4be4dca7f$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $fdaa5df4be4dca7f$var$concatty(args, arguments));
    };
    var boundLength = $fdaa5df4be4dca7f$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $fdaa5df4be4dca7f$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});





parcelRegister("ghMok", function(module, exports) {
'use strict';

var $9YAFO = parcelRequire("9YAFO");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$9YAFO(value);
};

});
parcelRegister("9YAFO", function(module, exports) {
'use strict';

var $jhglO = parcelRequire("jhglO");

var $eX9Ji = parcelRequire("eX9Ji");

var $1uRE5 = parcelRequire("1uRE5");

var $9dGLi = parcelRequire("9dGLi");

var $jIHq7 = parcelRequire("jIHq7");

var $3Y4sF = parcelRequire("3Y4sF");
var $74362a3fdf72fb2c$var$$toString = $9dGLi('Object.prototype.toString');

var $74362a3fdf72fb2c$var$hasToStringTag = (parcelRequire("2Vd1a"))();
var $74362a3fdf72fb2c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $74362a3fdf72fb2c$var$typedArrays = $eX9Ji();
var $74362a3fdf72fb2c$var$$slice = $9dGLi('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $74362a3fdf72fb2c$var$$indexOf = $9dGLi('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $74362a3fdf72fb2c$var$cache = {
    __proto__: null
};
if ($74362a3fdf72fb2c$var$hasToStringTag && $jIHq7 && $3Y4sF) $jhglO($74362a3fdf72fb2c$var$typedArrays, function(typedArray) {
    var arr = new $74362a3fdf72fb2c$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3Y4sF) {
        var proto = $3Y4sF(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $jIHq7(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3Y4sF(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $jIHq7(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $74362a3fdf72fb2c$var$cache['$' + typedArray] = $1uRE5(descriptor.get);
    }
});
else $jhglO($74362a3fdf72fb2c$var$typedArrays, function(typedArray) {
    var arr = new $74362a3fdf72fb2c$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $74362a3fdf72fb2c$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $1uRE5(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $74362a3fdf72fb2c$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $jhglO(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $74362a3fdf72fb2c$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $74362a3fdf72fb2c$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $74362a3fdf72fb2c$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $jhglO(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $74362a3fdf72fb2c$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $74362a3fdf72fb2c$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$74362a3fdf72fb2c$var$hasToStringTag) {
        /** @type {string} */ var tag = $74362a3fdf72fb2c$var$$slice($74362a3fdf72fb2c$var$$toString(value), 8, -1);
        if ($74362a3fdf72fb2c$var$$indexOf($74362a3fdf72fb2c$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $74362a3fdf72fb2c$var$trySlices(value);
    }
    if (!$jIHq7) return null;
     // unknown engine
    return $74362a3fdf72fb2c$var$tryTypedArrays(value);
};

});
parcelRegister("jhglO", function(module, exports) {
'use strict';

var $1Ez2N = parcelRequire("1Ez2N");
var $e08c49ced3e0edbb$var$toStr = Object.prototype.toString;
var $e08c49ced3e0edbb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $e08c49ced3e0edbb$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($e08c49ced3e0edbb$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $e08c49ced3e0edbb$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $e08c49ced3e0edbb$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($e08c49ced3e0edbb$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $e08c49ced3e0edbb$var$isArray(x) {
    return $e08c49ced3e0edbb$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$1Ez2N(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($e08c49ced3e0edbb$var$isArray(list)) $e08c49ced3e0edbb$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $e08c49ced3e0edbb$var$forEachString(list, iterator, receiver);
    else $e08c49ced3e0edbb$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("1Ez2N", function(module, exports) {
'use strict';
var $1344b5ecc680ed19$var$fnToStr = Function.prototype.toString;
var $1344b5ecc680ed19$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $1344b5ecc680ed19$var$badArrayLike;
var $1344b5ecc680ed19$var$isCallableMarker;
if (typeof $1344b5ecc680ed19$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $1344b5ecc680ed19$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $1344b5ecc680ed19$var$isCallableMarker;
        }
    });
    $1344b5ecc680ed19$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $1344b5ecc680ed19$var$reflectApply(function() {
        throw 42;
    }, null, $1344b5ecc680ed19$var$badArrayLike);
} catch (_) {
    if (_ !== $1344b5ecc680ed19$var$isCallableMarker) $1344b5ecc680ed19$var$reflectApply = null;
}
else $1344b5ecc680ed19$var$reflectApply = null;
var $1344b5ecc680ed19$var$constructorRegex = /^\s*class\b/;
var $1344b5ecc680ed19$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $1344b5ecc680ed19$var$fnToStr.call(value);
        return $1344b5ecc680ed19$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $1344b5ecc680ed19$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($1344b5ecc680ed19$var$isES6ClassFn(value)) return false;
        $1344b5ecc680ed19$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $1344b5ecc680ed19$var$toStr = Object.prototype.toString;
var $1344b5ecc680ed19$var$objectClass = '[object Object]';
var $1344b5ecc680ed19$var$fnClass = '[object Function]';
var $1344b5ecc680ed19$var$genClass = '[object GeneratorFunction]';
var $1344b5ecc680ed19$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $1344b5ecc680ed19$var$ddaClass2 = '[object HTML document.all class]';
var $1344b5ecc680ed19$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $1344b5ecc680ed19$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $1344b5ecc680ed19$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $1344b5ecc680ed19$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $1344b5ecc680ed19$var$all = document.all;
    if ($1344b5ecc680ed19$var$toStr.call($1344b5ecc680ed19$var$all) === $1344b5ecc680ed19$var$toStr.call(document.all)) $1344b5ecc680ed19$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($1344b5ecc680ed19$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $1344b5ecc680ed19$var$toStr.call(value);
            return (str === $1344b5ecc680ed19$var$ddaClass || str === $1344b5ecc680ed19$var$ddaClass2 || str === $1344b5ecc680ed19$var$ddaClass3 // opera 12.16
             || str === $1344b5ecc680ed19$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $1344b5ecc680ed19$var$reflectApply ? function isCallable(value) {
    if ($1344b5ecc680ed19$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $1344b5ecc680ed19$var$reflectApply(value, null, $1344b5ecc680ed19$var$badArrayLike);
    } catch (e) {
        if (e !== $1344b5ecc680ed19$var$isCallableMarker) return false;
    }
    return !$1344b5ecc680ed19$var$isES6ClassFn(value) && $1344b5ecc680ed19$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($1344b5ecc680ed19$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($1344b5ecc680ed19$var$hasToStringTag) return $1344b5ecc680ed19$var$tryFunctionObject(value);
    if ($1344b5ecc680ed19$var$isES6ClassFn(value)) return false;
    var strClass = $1344b5ecc680ed19$var$toStr.call(value);
    if (strClass !== $1344b5ecc680ed19$var$fnClass && strClass !== $1344b5ecc680ed19$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $1344b5ecc680ed19$var$tryFunctionObject(value);
};

});


parcelRegister("eX9Ji", function(module, exports) {
'use strict';

var $cyH2E = parcelRequire("cyH2E");
var $ae2e1f7c23bab8f6$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $cyH2E.length; i++)if (typeof $ae2e1f7c23bab8f6$var$g[$cyH2E[i]] === 'function') // @ts-expect-error
    out[out.length] = $cyH2E[i];
    return out;
};

});
parcelRegister("cyH2E", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("1uRE5", function(module, exports) {
'use strict';

var $44BgL = parcelRequire("44BgL");

var $iMltJ = parcelRequire("iMltJ");

var $54J2f = parcelRequire("54J2f");

var $2lBNf = parcelRequire("2lBNf");
module.exports = function callBind(originalFunction) {
    var func = $54J2f(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $44BgL(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($iMltJ) $iMltJ(module.exports, 'apply', {
    value: $2lBNf
});
else module.exports.apply = $2lBNf;

});
parcelRegister("44BgL", function(module, exports) {
'use strict';

var $l29PM = parcelRequire("l29PM");

var $d4spZ = parcelRequire("d4spZ");

var $2f74720fdea56314$var$hasDescriptors = (parcelRequire("6MlRm"))();

var $1NmyU = parcelRequire("1NmyU");

var $589A0 = parcelRequire("589A0");
var $2f74720fdea56314$var$$floor = $l29PM('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $589A0('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $2f74720fdea56314$var$$floor(length) !== length) throw new $589A0('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $1NmyU) {
        var desc = $1NmyU(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($2f74720fdea56314$var$hasDescriptors) $d4spZ(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $d4spZ(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("l29PM", function(module, exports) {
'use strict';
var $f50169bce45471d1$var$undefined1;

var $eYIES = parcelRequire("eYIES");

var $f5ze0 = parcelRequire("f5ze0");

var $66y3P = parcelRequire("66y3P");

var $bJA0T = parcelRequire("bJA0T");

var $icqcp = parcelRequire("icqcp");

var $589A0 = parcelRequire("589A0");

var $fosQf = parcelRequire("fosQf");
var $f50169bce45471d1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $f50169bce45471d1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $f50169bce45471d1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $f50169bce45471d1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($f50169bce45471d1$var$$gOPD) try {
    $f50169bce45471d1$var$$gOPD({}, '');
} catch (e) {
    $f50169bce45471d1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $f50169bce45471d1$var$throwTypeError = function() {
    throw new $589A0();
};
var $f50169bce45471d1$var$ThrowTypeError = $f50169bce45471d1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $f50169bce45471d1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $f50169bce45471d1$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $f50169bce45471d1$var$throwTypeError;
        }
    }
}() : $f50169bce45471d1$var$throwTypeError;

var $f50169bce45471d1$var$hasSymbols = (parcelRequire("ULQdv"))();

var $f50169bce45471d1$var$hasProto = (parcelRequire("bmQNJ"))();
var $f50169bce45471d1$var$getProto = Object.getPrototypeOf || ($f50169bce45471d1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $f50169bce45471d1$var$needsEval = {};
var $f50169bce45471d1$var$TypedArray = typeof Uint8Array === 'undefined' || !$f50169bce45471d1$var$getProto ? undefined : $f50169bce45471d1$var$getProto(Uint8Array);
var $f50169bce45471d1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $f50169bce45471d1$var$hasSymbols && $f50169bce45471d1$var$getProto ? $f50169bce45471d1$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $f50169bce45471d1$var$needsEval,
    '%AsyncGenerator%': $f50169bce45471d1$var$needsEval,
    '%AsyncGeneratorFunction%': $f50169bce45471d1$var$needsEval,
    '%AsyncIteratorPrototype%': $f50169bce45471d1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $eYIES,
    '%eval%': eval,
    '%EvalError%': $f5ze0,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $f50169bce45471d1$var$$Function,
    '%GeneratorFunction%': $f50169bce45471d1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $f50169bce45471d1$var$hasSymbols && $f50169bce45471d1$var$getProto ? $f50169bce45471d1$var$getProto($f50169bce45471d1$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$f50169bce45471d1$var$hasSymbols || !$f50169bce45471d1$var$getProto ? undefined : $f50169bce45471d1$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $66y3P,
    '%ReferenceError%': $bJA0T,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$f50169bce45471d1$var$hasSymbols || !$f50169bce45471d1$var$getProto ? undefined : $f50169bce45471d1$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $f50169bce45471d1$var$hasSymbols && $f50169bce45471d1$var$getProto ? $f50169bce45471d1$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $f50169bce45471d1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $icqcp,
    '%ThrowTypeError%': $f50169bce45471d1$var$ThrowTypeError,
    '%TypedArray%': $f50169bce45471d1$var$TypedArray,
    '%TypeError%': $589A0,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fosQf,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($f50169bce45471d1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $f50169bce45471d1$var$errorProto = $f50169bce45471d1$var$getProto($f50169bce45471d1$var$getProto(e));
    $f50169bce45471d1$var$INTRINSICS['%Error.prototype%'] = $f50169bce45471d1$var$errorProto;
}
var $f50169bce45471d1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $f50169bce45471d1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $f50169bce45471d1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $f50169bce45471d1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $f50169bce45471d1$var$getProto) value = $f50169bce45471d1$var$getProto(gen.prototype);
    }
    $f50169bce45471d1$var$INTRINSICS[name] = value;
    return value;
};
var $f50169bce45471d1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $6rFe4 = parcelRequire("6rFe4");

var $2Nbrd = parcelRequire("2Nbrd");
var $f50169bce45471d1$var$$concat = $6rFe4.call(Function.call, Array.prototype.concat);
var $f50169bce45471d1$var$$spliceApply = $6rFe4.call(Function.apply, Array.prototype.splice);
var $f50169bce45471d1$var$$replace = $6rFe4.call(Function.call, String.prototype.replace);
var $f50169bce45471d1$var$$strSlice = $6rFe4.call(Function.call, String.prototype.slice);
var $f50169bce45471d1$var$$exec = $6rFe4.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $f50169bce45471d1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $f50169bce45471d1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $f50169bce45471d1$var$stringToPath = function stringToPath(string) {
    var first = $f50169bce45471d1$var$$strSlice(string, 0, 1);
    var last = $f50169bce45471d1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $icqcp('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $icqcp('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $f50169bce45471d1$var$$replace(string, $f50169bce45471d1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $f50169bce45471d1$var$$replace(subString, $f50169bce45471d1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $f50169bce45471d1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($2Nbrd($f50169bce45471d1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $f50169bce45471d1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($2Nbrd($f50169bce45471d1$var$INTRINSICS, intrinsicName)) {
        var value = $f50169bce45471d1$var$INTRINSICS[intrinsicName];
        if (value === $f50169bce45471d1$var$needsEval) value = $f50169bce45471d1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $589A0('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $icqcp('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $589A0('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $589A0('"allowMissing" argument must be a boolean');
    if ($f50169bce45471d1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $icqcp('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $f50169bce45471d1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $f50169bce45471d1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $f50169bce45471d1$var$$spliceApply(parts, $f50169bce45471d1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $f50169bce45471d1$var$$strSlice(part, 0, 1);
        var last = $f50169bce45471d1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $icqcp('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($2Nbrd($f50169bce45471d1$var$INTRINSICS, intrinsicRealName)) value = $f50169bce45471d1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $589A0('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($f50169bce45471d1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $f50169bce45471d1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $2Nbrd(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $f50169bce45471d1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("ULQdv", function(module, exports) {
'use strict';
var $0aaa57584ce6425a$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fk5CS = parcelRequire("fk5CS");
module.exports = function hasNativeSymbols() {
    if (typeof $0aaa57584ce6425a$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $0aaa57584ce6425a$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fk5CS();
};

});
parcelRegister("fk5CS", function(module, exports) {
'use strict';
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bmQNJ", function(module, exports) {
'use strict';
var $846ab4ff8f5dda6f$var$test = {
    __proto__: null,
    foo: {}
};
var $846ab4ff8f5dda6f$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $846ab4ff8f5dda6f$var$test
    }).foo === $846ab4ff8f5dda6f$var$test.foo && !($846ab4ff8f5dda6f$var$test instanceof $846ab4ff8f5dda6f$var$$Object);
};

});

parcelRegister("6rFe4", function(module, exports) {
'use strict';

var $b1cxr = parcelRequire("b1cxr");
module.exports = Function.prototype.bind || $b1cxr;

});
parcelRegister("b1cxr", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $805983966770f015$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $805983966770f015$var$toStr = Object.prototype.toString;
var $805983966770f015$var$max = Math.max;
var $805983966770f015$var$funcType = '[object Function]';
var $805983966770f015$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $805983966770f015$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $805983966770f015$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $805983966770f015$var$toStr.apply(target) !== $805983966770f015$var$funcType) throw new TypeError($805983966770f015$var$ERROR_MESSAGE + target);
    var args = $805983966770f015$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $805983966770f015$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $805983966770f015$var$concatty(args, arguments));
    };
    var boundLength = $805983966770f015$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $805983966770f015$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});



parcelRegister("d4spZ", function(module, exports) {
'use strict';

var $iMltJ = parcelRequire("iMltJ");

var $icqcp = parcelRequire("icqcp");

var $589A0 = parcelRequire("589A0");

var $1NmyU = parcelRequire("1NmyU");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $589A0('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $589A0('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $589A0('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $589A0('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $589A0('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $589A0('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$1NmyU && $1NmyU(obj, property);
    if ($iMltJ) $iMltJ(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $icqcp('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("iMltJ", function(module, exports) {
'use strict';

var $l29PM = parcelRequire("l29PM");
/** @type {import('.')} */ var $dabd5ee5b34b7595$var$$defineProperty = $l29PM('%Object.defineProperty%', true) || false;
if ($dabd5ee5b34b7595$var$$defineProperty) try {
    $dabd5ee5b34b7595$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $dabd5ee5b34b7595$var$$defineProperty = false;
}
module.exports = $dabd5ee5b34b7595$var$$defineProperty;

});

parcelRegister("1NmyU", function(module, exports) {
'use strict';

var $l29PM = parcelRequire("l29PM");
var $14ebde634ae6e228$var$$gOPD = $l29PM('%Object.getOwnPropertyDescriptor%', true);
if ($14ebde634ae6e228$var$$gOPD) try {
    $14ebde634ae6e228$var$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $14ebde634ae6e228$var$$gOPD = null;
}
module.exports = $14ebde634ae6e228$var$$gOPD;

});


parcelRegister("6MlRm", function(module, exports) {
'use strict';

var $iMltJ = parcelRequire("iMltJ");
var $4ef82ea1d87e2745$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$iMltJ;
};
$4ef82ea1d87e2745$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$iMltJ) return null;
    try {
        return $iMltJ([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $4ef82ea1d87e2745$var$hasPropertyDescriptors;

});


parcelRegister("2lBNf", function(module, exports) {
'use strict';

var $hoj3m = parcelRequire("hoj3m");

var $17kBB = parcelRequire("17kBB");

var $imQYk = parcelRequire("imQYk");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $imQYk($hoj3m, $17kBB, arguments);
};

});


parcelRegister("jIHq7", function(module, exports) {
'use strict';

var $93fAr = parcelRequire("93fAr");
var $e5b3cec3a4717788$require$$gOPD = $93fAr;
if ($e5b3cec3a4717788$require$$gOPD) try {
    $e5b3cec3a4717788$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $e5b3cec3a4717788$require$$gOPD = null;
}
module.exports = $e5b3cec3a4717788$require$$gOPD;

});
parcelRegister("93fAr", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("2Vd1a", function(module, exports) {
'use strict';

var $fk5CS = parcelRequire("fk5CS");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $fk5CS() && !!Symbol.toStringTag;
};

});









parcelRegister("AW5CM", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $06f06c50d48c08ba$export$bdd223f16383713e; }, function (v) { return $06f06c50d48c08ba$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $06f06c50d48c08ba$export$26e5786e8ac8e530; }, function (v) { return $06f06c50d48c08ba$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $06f06c50d48c08ba$export$2f64596b8cbf08b4; }, function (v) { return $06f06c50d48c08ba$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $06f06c50d48c08ba$export$20533d26f07f1ee0; }, function (v) { return $06f06c50d48c08ba$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $06f06c50d48c08ba$export$12ada9414fbc594c; }, function (v) { return $06f06c50d48c08ba$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $06f06c50d48c08ba$export$2ce6d8d0e8b04e1a; }, function (v) { return $06f06c50d48c08ba$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $06f06c50d48c08ba$export$36b6d6ef312eab39; }, function (v) { return $06f06c50d48c08ba$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $06f06c50d48c08ba$export$f5e7e39d57cd9700; }, function (v) { return $06f06c50d48c08ba$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $06f06c50d48c08ba$export$dedd8dc3dc62b370; }, function (v) { return $06f06c50d48c08ba$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $06f06c50d48c08ba$export$58a258485f1e49f6; }, function (v) { return $06f06c50d48c08ba$export$58a258485f1e49f6 = v; });
var $06f06c50d48c08ba$export$bdd223f16383713e;
var $06f06c50d48c08ba$export$26e5786e8ac8e530;
var $06f06c50d48c08ba$export$2f64596b8cbf08b4;
var $06f06c50d48c08ba$export$20533d26f07f1ee0;
var $06f06c50d48c08ba$export$12ada9414fbc594c;
var $06f06c50d48c08ba$export$2ce6d8d0e8b04e1a;
var $06f06c50d48c08ba$export$36b6d6ef312eab39;
var $06f06c50d48c08ba$export$f5e7e39d57cd9700;
var $06f06c50d48c08ba$export$dedd8dc3dc62b370;
var $06f06c50d48c08ba$export$58a258485f1e49f6;

var $4mXlk = parcelRequire("4mXlk");

var $aLSU4 = parcelRequire("aLSU4");

var $5YlSp = parcelRequire("5YlSp");

var $hc1pA = parcelRequire("hc1pA");

var $eatyP = parcelRequire("eatyP");
function $06f06c50d48c08ba$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5YlSp[suite]) {
        keyLen = $5YlSp[suite].key;
        ivLen = $5YlSp[suite].iv;
    } else if ($hc1pA[suite]) {
        keyLen = $hc1pA[suite].key * 8;
        ivLen = $hc1pA[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $eatyP(password, false, keyLen, ivLen);
    return $06f06c50d48c08ba$var$createCipheriv(suite, keys.key, keys.iv);
}
function $06f06c50d48c08ba$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5YlSp[suite]) {
        keyLen = $5YlSp[suite].key;
        ivLen = $5YlSp[suite].iv;
    } else if ($hc1pA[suite]) {
        keyLen = $hc1pA[suite].key * 8;
        ivLen = $hc1pA[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $eatyP(password, false, keyLen, ivLen);
    return $06f06c50d48c08ba$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $06f06c50d48c08ba$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5YlSp[suite]) return $aLSU4.createCipheriv(suite, key, iv);
    if ($hc1pA[suite]) return new $4mXlk({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $06f06c50d48c08ba$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5YlSp[suite]) return $aLSU4.createDecipheriv(suite, key, iv);
    if ($hc1pA[suite]) return new $4mXlk({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $06f06c50d48c08ba$var$getCiphers() {
    return Object.keys($hc1pA).concat($aLSU4.getCiphers());
}
$06f06c50d48c08ba$export$bdd223f16383713e = $06f06c50d48c08ba$export$26e5786e8ac8e530 = $06f06c50d48c08ba$var$createCipher;
$06f06c50d48c08ba$export$2f64596b8cbf08b4 = $06f06c50d48c08ba$export$20533d26f07f1ee0 = $06f06c50d48c08ba$var$createCipheriv;
$06f06c50d48c08ba$export$12ada9414fbc594c = $06f06c50d48c08ba$export$2ce6d8d0e8b04e1a = $06f06c50d48c08ba$var$createDecipher;
$06f06c50d48c08ba$export$36b6d6ef312eab39 = $06f06c50d48c08ba$export$f5e7e39d57cd9700 = $06f06c50d48c08ba$var$createDecipheriv;
$06f06c50d48c08ba$export$dedd8dc3dc62b370 = $06f06c50d48c08ba$export$58a258485f1e49f6 = $06f06c50d48c08ba$var$getCiphers;

});
parcelRegister("4mXlk", function(module, exports) {

var $c7vVf = parcelRequire("c7vVf");

var $bNtrG = parcelRequire("bNtrG");

var $bVy58 = parcelRequire("bVy58");

var $BUCDt = parcelRequire("BUCDt");
var $32e73fccc7b83bb7$require$Buffer = $BUCDt.Buffer;
var $32e73fccc7b83bb7$var$modes = {
    'des-ede3-cbc': $bNtrG.CBC.instantiate($bNtrG.EDE),
    'des-ede3': $bNtrG.EDE,
    'des-ede-cbc': $bNtrG.CBC.instantiate($bNtrG.EDE),
    'des-ede': $bNtrG.EDE,
    'des-cbc': $bNtrG.CBC.instantiate($bNtrG.DES),
    'des-ecb': $bNtrG.DES
};
$32e73fccc7b83bb7$var$modes.des = $32e73fccc7b83bb7$var$modes['des-cbc'];
$32e73fccc7b83bb7$var$modes.des3 = $32e73fccc7b83bb7$var$modes['des-ede3-cbc'];
module.exports = $32e73fccc7b83bb7$var$DES;
$bVy58($32e73fccc7b83bb7$var$DES, $c7vVf);
function $32e73fccc7b83bb7$var$DES(opts) {
    $c7vVf.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $32e73fccc7b83bb7$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$32e73fccc7b83bb7$require$Buffer.isBuffer(key)) key = $32e73fccc7b83bb7$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $32e73fccc7b83bb7$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$32e73fccc7b83bb7$require$Buffer.isBuffer(iv)) iv = $32e73fccc7b83bb7$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$32e73fccc7b83bb7$var$DES.prototype._update = function(data) {
    return $32e73fccc7b83bb7$require$Buffer.from(this._des.update(data));
};
$32e73fccc7b83bb7$var$DES.prototype._final = function() {
    return $32e73fccc7b83bb7$require$Buffer.from(this._des.final());
};

});
parcelRegister("bNtrG", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $896b1c92743b1553$export$cc8859615686b300; }, function (v) { return $896b1c92743b1553$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $896b1c92743b1553$export$8ad3f227af08fcc5; }, function (v) { return $896b1c92743b1553$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $896b1c92743b1553$export$947646e34766044f; }, function (v) { return $896b1c92743b1553$export$947646e34766044f = v; });
var $896b1c92743b1553$export$eab97d15b1788b8d;
var $896b1c92743b1553$export$26e5786e8ac8e530;
var $896b1c92743b1553$export$cc8859615686b300;
var $896b1c92743b1553$export$8ad3f227af08fcc5;
var $896b1c92743b1553$export$947646e34766044f;
'use strict';

$896b1c92743b1553$export$eab97d15b1788b8d = (parcelRequire("dhdQu"));

$896b1c92743b1553$export$26e5786e8ac8e530 = (parcelRequire("g9UnC"));

$896b1c92743b1553$export$cc8859615686b300 = (parcelRequire("lsBPM"));

$896b1c92743b1553$export$8ad3f227af08fcc5 = (parcelRequire("8cmI2"));

$896b1c92743b1553$export$947646e34766044f = (parcelRequire("eJFU8"));

});
parcelRegister("dhdQu", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $9aa79a527df3f577$export$cfaef8ed399428b0; }, function (v) { return $9aa79a527df3f577$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $9aa79a527df3f577$export$a80c7deaea7cbd80; }, function (v) { return $9aa79a527df3f577$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $9aa79a527df3f577$export$ed7577ae6e1cd0ef; }, function (v) { return $9aa79a527df3f577$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $9aa79a527df3f577$export$5dcbef3aa594f567; }, function (v) { return $9aa79a527df3f577$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $9aa79a527df3f577$export$5bc8001ca71ed9c5; }, function (v) { return $9aa79a527df3f577$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $9aa79a527df3f577$export$3e714e2c5d5d8cb2; }, function (v) { return $9aa79a527df3f577$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $9aa79a527df3f577$export$94c3e544fd062b7f; }, function (v) { return $9aa79a527df3f577$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $9aa79a527df3f577$export$9f77e0932fb78f72; }, function (v) { return $9aa79a527df3f577$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $9aa79a527df3f577$export$d865ce2836f5927f; }, function (v) { return $9aa79a527df3f577$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $9aa79a527df3f577$export$95e62ad65da8b7d2; }, function (v) { return $9aa79a527df3f577$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $9aa79a527df3f577$export$209139ff098c441a; }, function (v) { return $9aa79a527df3f577$export$209139ff098c441a = v; });
var $9aa79a527df3f577$export$cfaef8ed399428b0;
var $9aa79a527df3f577$export$a80c7deaea7cbd80;
var $9aa79a527df3f577$export$ed7577ae6e1cd0ef;
var $9aa79a527df3f577$export$5dcbef3aa594f567;
var $9aa79a527df3f577$export$5bc8001ca71ed9c5;
var $9aa79a527df3f577$export$3e714e2c5d5d8cb2;
var $9aa79a527df3f577$export$94c3e544fd062b7f;
var $9aa79a527df3f577$export$9f77e0932fb78f72;
var $9aa79a527df3f577$export$d865ce2836f5927f;
var $9aa79a527df3f577$export$95e62ad65da8b7d2;
var $9aa79a527df3f577$export$209139ff098c441a;
'use strict';
$9aa79a527df3f577$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9aa79a527df3f577$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9aa79a527df3f577$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9aa79a527df3f577$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9aa79a527df3f577$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9aa79a527df3f577$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9aa79a527df3f577$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9aa79a527df3f577$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9aa79a527df3f577$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9aa79a527df3f577$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9aa79a527df3f577$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9aa79a527df3f577$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9aa79a527df3f577$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9aa79a527df3f577$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9aa79a527df3f577$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9aa79a527df3f577$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9aa79a527df3f577$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9aa79a527df3f577$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9aa79a527df3f577$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9aa79a527df3f577$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9aa79a527df3f577$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9aa79a527df3f577$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("g9UnC", function(module, exports) {
'use strict';

var $9EwBD = parcelRequire("9EwBD");
function $bc39387c794e8bb9$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $bc39387c794e8bb9$var$Cipher;
$bc39387c794e8bb9$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$bc39387c794e8bb9$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$bc39387c794e8bb9$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$bc39387c794e8bb9$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$bc39387c794e8bb9$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$bc39387c794e8bb9$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$bc39387c794e8bb9$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$bc39387c794e8bb9$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$bc39387c794e8bb9$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$bc39387c794e8bb9$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$bc39387c794e8bb9$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $9EwBD.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("9EwBD", function(module, exports) {
module.exports = $7071245598957408$var$assert;
function $7071245598957408$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7071245598957408$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("lsBPM", function(module, exports) {
'use strict';

var $9EwBD = parcelRequire("9EwBD");

var $bVy58 = parcelRequire("bVy58");

var $dhdQu = parcelRequire("dhdQu");

var $g9UnC = parcelRequire("g9UnC");
function $f9f98f90c1ec24ad$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f9f98f90c1ec24ad$var$DES(options) {
    $g9UnC.call(this, options);
    var state = new $f9f98f90c1ec24ad$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$bVy58($f9f98f90c1ec24ad$var$DES, $g9UnC);
module.exports = $f9f98f90c1ec24ad$var$DES;
$f9f98f90c1ec24ad$var$DES.create = function create(options) {
    return new $f9f98f90c1ec24ad$var$DES(options);
};
var $f9f98f90c1ec24ad$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f9f98f90c1ec24ad$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $9EwBD.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $dhdQu.readUInt32BE(key, 0);
    var kR = $dhdQu.readUInt32BE(key, 4);
    $dhdQu.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f9f98f90c1ec24ad$var$shiftTable[i >>> 1];
        kL = $dhdQu.r28shl(kL, shift);
        kR = $dhdQu.r28shl(kR, shift);
        $dhdQu.pc2(kL, kR, state.keys, i);
    }
};
$f9f98f90c1ec24ad$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dhdQu.readUInt32BE(inp, inOff);
    var r = $dhdQu.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dhdQu.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dhdQu.writeUInt32BE(out, l, outOff);
    $dhdQu.writeUInt32BE(out, r, outOff + 4);
};
$f9f98f90c1ec24ad$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f9f98f90c1ec24ad$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$9EwBD.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f9f98f90c1ec24ad$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dhdQu.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dhdQu.substitute(keyL, keyR);
        var f = $dhdQu.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dhdQu.rip(r, l, out, off);
};
$f9f98f90c1ec24ad$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dhdQu.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dhdQu.substitute(keyL, keyR);
        var f = $dhdQu.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dhdQu.rip(l, r, out, off);
};

});

parcelRegister("8cmI2", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $5f810f509270533c$export$f9bb8d20ccc7477a; }, function (v) { return $5f810f509270533c$export$f9bb8d20ccc7477a = v; });
var $5f810f509270533c$export$f9bb8d20ccc7477a;
'use strict';

var $9EwBD = parcelRequire("9EwBD");

var $bVy58 = parcelRequire("bVy58");
var $5f810f509270533c$var$proto = {};
function $5f810f509270533c$var$CBCState(iv) {
    $9EwBD.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $5f810f509270533c$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $bVy58(CBC, Base);
    var keys = Object.keys($5f810f509270533c$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $5f810f509270533c$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$5f810f509270533c$export$f9bb8d20ccc7477a = $5f810f509270533c$var$instantiate;
$5f810f509270533c$var$proto._cbcInit = function _cbcInit() {
    var state = new $5f810f509270533c$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$5f810f509270533c$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("eJFU8", function(module, exports) {
'use strict';

var $9EwBD = parcelRequire("9EwBD");

var $bVy58 = parcelRequire("bVy58");

var $g9UnC = parcelRequire("g9UnC");

var $lsBPM = parcelRequire("lsBPM");
function $aba5c605aa8f1d09$var$EDEState(type, key) {
    $9EwBD.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $lsBPM.create({
            type: 'encrypt',
            key: k1
        }),
        $lsBPM.create({
            type: 'decrypt',
            key: k2
        }),
        $lsBPM.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $lsBPM.create({
            type: 'decrypt',
            key: k3
        }),
        $lsBPM.create({
            type: 'encrypt',
            key: k2
        }),
        $lsBPM.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $aba5c605aa8f1d09$var$EDE(options) {
    $g9UnC.call(this, options);
    var state = new $aba5c605aa8f1d09$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$bVy58($aba5c605aa8f1d09$var$EDE, $g9UnC);
module.exports = $aba5c605aa8f1d09$var$EDE;
$aba5c605aa8f1d09$var$EDE.create = function create(options) {
    return new $aba5c605aa8f1d09$var$EDE(options);
};
$aba5c605aa8f1d09$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$aba5c605aa8f1d09$var$EDE.prototype._pad = $lsBPM.prototype._pad;
$aba5c605aa8f1d09$var$EDE.prototype._unpad = $lsBPM.prototype._unpad;

});



parcelRegister("aLSU4", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $7d78e1d779e88f47$export$2f64596b8cbf08b4; }, function (v) { return $7d78e1d779e88f47$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7d78e1d779e88f47$export$36b6d6ef312eab39; }, function (v) { return $7d78e1d779e88f47$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7d78e1d779e88f47$export$58a258485f1e49f6; }, function (v) { return $7d78e1d779e88f47$export$58a258485f1e49f6 = v; });
var $7d78e1d779e88f47$export$bdd223f16383713e;
var $7d78e1d779e88f47$export$26e5786e8ac8e530;
var $7d78e1d779e88f47$export$2f64596b8cbf08b4;
var $7d78e1d779e88f47$export$20533d26f07f1ee0;
var $7d78e1d779e88f47$export$12ada9414fbc594c;
var $7d78e1d779e88f47$export$2ce6d8d0e8b04e1a;
var $7d78e1d779e88f47$export$36b6d6ef312eab39;
var $7d78e1d779e88f47$export$f5e7e39d57cd9700;
var $7d78e1d779e88f47$export$dedd8dc3dc62b370;
var $7d78e1d779e88f47$export$58a258485f1e49f6;

var $cYWtd = parcelRequire("cYWtd");

var $jXxII = parcelRequire("jXxII");

var $fjA1s = parcelRequire("fjA1s");
function $7d78e1d779e88f47$var$getCiphers() {
    return Object.keys($fjA1s);
}
$7d78e1d779e88f47$export$bdd223f16383713e = $7d78e1d779e88f47$export$26e5786e8ac8e530 = $cYWtd.createCipher;
$7d78e1d779e88f47$export$2f64596b8cbf08b4 = $7d78e1d779e88f47$export$20533d26f07f1ee0 = $cYWtd.createCipheriv;
$7d78e1d779e88f47$export$12ada9414fbc594c = $7d78e1d779e88f47$export$2ce6d8d0e8b04e1a = $jXxII.createDecipher;
$7d78e1d779e88f47$export$36b6d6ef312eab39 = $7d78e1d779e88f47$export$f5e7e39d57cd9700 = $jXxII.createDecipheriv;
$7d78e1d779e88f47$export$dedd8dc3dc62b370 = $7d78e1d779e88f47$export$58a258485f1e49f6 = $7d78e1d779e88f47$var$getCiphers;

});
parcelRegister("cYWtd", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $9738719a5e1b6ff1$export$2f64596b8cbf08b4; }, function (v) { return $9738719a5e1b6ff1$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $9738719a5e1b6ff1$export$bdd223f16383713e; }, function (v) { return $9738719a5e1b6ff1$export$bdd223f16383713e = v; });
var $9738719a5e1b6ff1$export$2f64596b8cbf08b4;
var $9738719a5e1b6ff1$export$bdd223f16383713e;

var $5YlSp = parcelRequire("5YlSp");

var $ciBi5 = parcelRequire("ciBi5");

var $BUCDt = parcelRequire("BUCDt");
var $9738719a5e1b6ff1$require$Buffer = $BUCDt.Buffer;

var $gYoG2 = parcelRequire("gYoG2");

var $c7vVf = parcelRequire("c7vVf");

var $i0nyM = parcelRequire("i0nyM");

var $eatyP = parcelRequire("eatyP");

var $bVy58 = parcelRequire("bVy58");
function $9738719a5e1b6ff1$var$Cipher(mode, key, iv) {
    $c7vVf.call(this);
    this._cache = new $9738719a5e1b6ff1$var$Splitter();
    this._cipher = new $i0nyM.AES(key);
    this._prev = $9738719a5e1b6ff1$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$bVy58($9738719a5e1b6ff1$var$Cipher, $c7vVf);
$9738719a5e1b6ff1$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $9738719a5e1b6ff1$require$Buffer.concat(out);
};
var $9738719a5e1b6ff1$var$PADDING = $9738719a5e1b6ff1$require$Buffer.alloc(16, 0x10);
$9738719a5e1b6ff1$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($9738719a5e1b6ff1$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$9738719a5e1b6ff1$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $9738719a5e1b6ff1$var$Splitter() {
    this.cache = $9738719a5e1b6ff1$require$Buffer.allocUnsafe(0);
}
$9738719a5e1b6ff1$var$Splitter.prototype.add = function(data) {
    this.cache = $9738719a5e1b6ff1$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$9738719a5e1b6ff1$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$9738719a5e1b6ff1$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $9738719a5e1b6ff1$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $9738719a5e1b6ff1$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $9738719a5e1b6ff1$var$createCipheriv(suite, password, iv) {
    var config = $5YlSp[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $9738719a5e1b6ff1$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $9738719a5e1b6ff1$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $gYoG2(config.module, password, iv);
    else if (config.type === 'auth') return new $ciBi5(config.module, password, iv);
    return new $9738719a5e1b6ff1$var$Cipher(config.module, password, iv);
}
function $9738719a5e1b6ff1$var$createCipher(suite, password) {
    var config = $5YlSp[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $eatyP(password, false, config.key, config.iv);
    return $9738719a5e1b6ff1$var$createCipheriv(suite, keys.key, keys.iv);
}
$9738719a5e1b6ff1$export$2f64596b8cbf08b4 = $9738719a5e1b6ff1$var$createCipheriv;
$9738719a5e1b6ff1$export$bdd223f16383713e = $9738719a5e1b6ff1$var$createCipher;

});
parcelRegister("5YlSp", function(module, exports) {








var $4593868ec46f23e7$var$modeModules = {
    ECB: (parcelRequire("kQVsX")),
    CBC: (parcelRequire("fzzm5")),
    CFB: (parcelRequire("7pMoW")),
    CFB8: (parcelRequire("2S2jI")),
    CFB1: (parcelRequire("gL4dG")),
    OFB: (parcelRequire("04x3c")),
    CTR: (parcelRequire("asQnK")),
    GCM: (parcelRequire("asQnK"))
};

var $fjA1s = parcelRequire("fjA1s");
for(var $4593868ec46f23e7$var$key in $fjA1s)$fjA1s[$4593868ec46f23e7$var$key].module = $4593868ec46f23e7$var$modeModules[$fjA1s[$4593868ec46f23e7$var$key].mode];
module.exports = $fjA1s;

});
parcelRegister("kQVsX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f2e53d8a66ff83c7$export$5b0f6292f11d1d18; }, function (v) { return $f2e53d8a66ff83c7$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $f2e53d8a66ff83c7$export$e85a0c9a1067c5d3; }, function (v) { return $f2e53d8a66ff83c7$export$e85a0c9a1067c5d3 = v; });
var $f2e53d8a66ff83c7$export$5b0f6292f11d1d18;
var $f2e53d8a66ff83c7$export$e85a0c9a1067c5d3;
$f2e53d8a66ff83c7$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$f2e53d8a66ff83c7$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("fzzm5", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $b5658cb4e0c31552$export$5b0f6292f11d1d18; }, function (v) { return $b5658cb4e0c31552$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $b5658cb4e0c31552$export$e85a0c9a1067c5d3; }, function (v) { return $b5658cb4e0c31552$export$e85a0c9a1067c5d3 = v; });
var $b5658cb4e0c31552$export$5b0f6292f11d1d18;
var $b5658cb4e0c31552$export$e85a0c9a1067c5d3;

var $gJlgY = parcelRequire("gJlgY");
$b5658cb4e0c31552$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $gJlgY(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$b5658cb4e0c31552$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $gJlgY(out, pad);
};

});
parcelRegister("gJlgY", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $c2e1599f9324aeee$require$Buffer = $8f5i0.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $c2e1599f9324aeee$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("7pMoW", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $566069afc1da1982$export$5b0f6292f11d1d18; }, function (v) { return $566069afc1da1982$export$5b0f6292f11d1d18 = v; });
var $566069afc1da1982$export$5b0f6292f11d1d18;

var $BUCDt = parcelRequire("BUCDt");
var $566069afc1da1982$require$Buffer = $BUCDt.Buffer;

var $gJlgY = parcelRequire("gJlgY");
function $566069afc1da1982$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $gJlgY(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $566069afc1da1982$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$566069afc1da1982$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $566069afc1da1982$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $566069afc1da1982$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $566069afc1da1982$require$Buffer.concat([
                out,
                $566069afc1da1982$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $566069afc1da1982$require$Buffer.concat([
                out,
                $566069afc1da1982$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("2S2jI", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $21726c0b65bd2568$export$5b0f6292f11d1d18; }, function (v) { return $21726c0b65bd2568$export$5b0f6292f11d1d18 = v; });
var $21726c0b65bd2568$export$5b0f6292f11d1d18;

var $BUCDt = parcelRequire("BUCDt");
var $21726c0b65bd2568$require$Buffer = $BUCDt.Buffer;
function $21726c0b65bd2568$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $21726c0b65bd2568$require$Buffer.concat([
        self._prev.slice(1),
        $21726c0b65bd2568$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$21726c0b65bd2568$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $21726c0b65bd2568$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $21726c0b65bd2568$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("gL4dG", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c3344f0d4c7e1103$export$5b0f6292f11d1d18; }, function (v) { return $c3344f0d4c7e1103$export$5b0f6292f11d1d18 = v; });
var $c3344f0d4c7e1103$export$5b0f6292f11d1d18;

var $BUCDt = parcelRequire("BUCDt");
var $c3344f0d4c7e1103$require$Buffer = $BUCDt.Buffer;
function $c3344f0d4c7e1103$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $c3344f0d4c7e1103$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $c3344f0d4c7e1103$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $c3344f0d4c7e1103$require$Buffer.allocUnsafe(buffer.length);
    buffer = $c3344f0d4c7e1103$require$Buffer.concat([
        buffer,
        $c3344f0d4c7e1103$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$c3344f0d4c7e1103$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $c3344f0d4c7e1103$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $c3344f0d4c7e1103$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("04x3c", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $00da02faabb3f2c2$export$5b0f6292f11d1d18; }, function (v) { return $00da02faabb3f2c2$export$5b0f6292f11d1d18 = v; });
var $00da02faabb3f2c2$export$5b0f6292f11d1d18;

var $8f5i0 = parcelRequire("8f5i0");
var $00da02faabb3f2c2$require$Buffer = $8f5i0.Buffer;

var $gJlgY = parcelRequire("gJlgY");
function $00da02faabb3f2c2$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$00da02faabb3f2c2$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $00da02faabb3f2c2$require$Buffer.concat([
        self._cache,
        $00da02faabb3f2c2$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $gJlgY(chunk, pad);
};

});

parcelRegister("asQnK", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $79e526e3ba6ff486$export$5b0f6292f11d1d18; }, function (v) { return $79e526e3ba6ff486$export$5b0f6292f11d1d18 = v; });
var $79e526e3ba6ff486$export$5b0f6292f11d1d18;

var $gJlgY = parcelRequire("gJlgY");

var $BUCDt = parcelRequire("BUCDt");
var $79e526e3ba6ff486$require$Buffer = $BUCDt.Buffer;

var $1Mo3O = parcelRequire("1Mo3O");
function $79e526e3ba6ff486$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $1Mo3O(self._prev);
    return out;
}
var $79e526e3ba6ff486$var$blockSize = 16;
$79e526e3ba6ff486$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $79e526e3ba6ff486$var$blockSize);
    var start = self._cache.length;
    self._cache = $79e526e3ba6ff486$require$Buffer.concat([
        self._cache,
        $79e526e3ba6ff486$require$Buffer.allocUnsafe(chunkNum * $79e526e3ba6ff486$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $79e526e3ba6ff486$var$getBlock(self);
        var offset = start + i * $79e526e3ba6ff486$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $gJlgY(chunk, pad);
};

});
parcelRegister("1Mo3O", function(module, exports) {
function $14bcf007add7126e$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $14bcf007add7126e$var$incr32;

});


parcelRegister("fjA1s", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("ciBi5", function(module, exports) {

var $i0nyM = parcelRequire("i0nyM");

var $BUCDt = parcelRequire("BUCDt");
var $8f44179f98281126$require$Buffer = $BUCDt.Buffer;

var $c7vVf = parcelRequire("c7vVf");

var $bVy58 = parcelRequire("bVy58");

var $9dT8b = parcelRequire("9dT8b");

var $gJlgY = parcelRequire("gJlgY");

var $1Mo3O = parcelRequire("1Mo3O");
function $8f44179f98281126$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $8f44179f98281126$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $8f44179f98281126$require$Buffer.concat([
            iv,
            $8f44179f98281126$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $8f44179f98281126$require$Buffer.concat([
            iv,
            $8f44179f98281126$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $9dT8b(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($8f44179f98281126$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($8f44179f98281126$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $8f44179f98281126$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $8f44179f98281126$require$Buffer.from(self._finID);
    $1Mo3O(out);
    return out;
}
function $8f44179f98281126$var$StreamCipher(mode, key, iv, decrypt) {
    $c7vVf.call(this);
    var h = $8f44179f98281126$require$Buffer.alloc(4, 0);
    this._cipher = new $i0nyM.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $9dT8b(ck);
    iv = $8f44179f98281126$var$calcIv(this, iv, ck);
    this._prev = $8f44179f98281126$require$Buffer.from(iv);
    this._cache = $8f44179f98281126$require$Buffer.allocUnsafe(0);
    this._secCache = $8f44179f98281126$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$bVy58($8f44179f98281126$var$StreamCipher, $c7vVf);
$8f44179f98281126$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $8f44179f98281126$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$8f44179f98281126$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $gJlgY(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $8f44179f98281126$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$8f44179f98281126$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$8f44179f98281126$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$8f44179f98281126$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$8f44179f98281126$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $8f44179f98281126$var$StreamCipher;

});
parcelRegister("i0nyM", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $d1ba80941c41a2e3$export$b80fbe1c3a2b92b5; }, function (v) { return $d1ba80941c41a2e3$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $d1ba80941c41a2e3$export$b80fbe1c3a2b92b5;

var $BUCDt = parcelRequire("BUCDt");
var $d1ba80941c41a2e3$require$Buffer = $BUCDt.Buffer;
function $d1ba80941c41a2e3$var$asUInt32Array(buf) {
    if (!$d1ba80941c41a2e3$require$Buffer.isBuffer(buf)) buf = $d1ba80941c41a2e3$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $d1ba80941c41a2e3$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $d1ba80941c41a2e3$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $d1ba80941c41a2e3$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $d1ba80941c41a2e3$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $d1ba80941c41a2e3$var$AES(key) {
    this._key = $d1ba80941c41a2e3$var$asUInt32Array(key);
    this._reset();
}
$d1ba80941c41a2e3$var$AES.blockSize = 16;
$d1ba80941c41a2e3$var$AES.keySize = 32;
$d1ba80941c41a2e3$var$AES.prototype.blockSize = $d1ba80941c41a2e3$var$AES.blockSize;
$d1ba80941c41a2e3$var$AES.prototype.keySize = $d1ba80941c41a2e3$var$AES.keySize;
$d1ba80941c41a2e3$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $d1ba80941c41a2e3$var$G.SBOX[t >>> 24] << 24 | $d1ba80941c41a2e3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $d1ba80941c41a2e3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $d1ba80941c41a2e3$var$G.SBOX[t & 0xff];
            t ^= $d1ba80941c41a2e3$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $d1ba80941c41a2e3$var$G.SBOX[t >>> 24] << 24 | $d1ba80941c41a2e3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $d1ba80941c41a2e3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $d1ba80941c41a2e3$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $d1ba80941c41a2e3$var$G.INV_SUB_MIX[0][$d1ba80941c41a2e3$var$G.SBOX[tt >>> 24]] ^ $d1ba80941c41a2e3$var$G.INV_SUB_MIX[1][$d1ba80941c41a2e3$var$G.SBOX[tt >>> 16 & 0xff]] ^ $d1ba80941c41a2e3$var$G.INV_SUB_MIX[2][$d1ba80941c41a2e3$var$G.SBOX[tt >>> 8 & 0xff]] ^ $d1ba80941c41a2e3$var$G.INV_SUB_MIX[3][$d1ba80941c41a2e3$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$d1ba80941c41a2e3$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $d1ba80941c41a2e3$var$asUInt32Array(M);
    return $d1ba80941c41a2e3$var$cryptBlock(M, this._keySchedule, $d1ba80941c41a2e3$var$G.SUB_MIX, $d1ba80941c41a2e3$var$G.SBOX, this._nRounds);
};
$d1ba80941c41a2e3$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $d1ba80941c41a2e3$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$d1ba80941c41a2e3$var$AES.prototype.decryptBlock = function(M) {
    M = $d1ba80941c41a2e3$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $d1ba80941c41a2e3$var$cryptBlock(M, this._invKeySchedule, $d1ba80941c41a2e3$var$G.INV_SUB_MIX, $d1ba80941c41a2e3$var$G.INV_SBOX, this._nRounds);
    var buf = $d1ba80941c41a2e3$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$d1ba80941c41a2e3$var$AES.prototype.scrub = function() {
    $d1ba80941c41a2e3$var$scrubVec(this._keySchedule);
    $d1ba80941c41a2e3$var$scrubVec(this._invKeySchedule);
    $d1ba80941c41a2e3$var$scrubVec(this._key);
};
$d1ba80941c41a2e3$export$b80fbe1c3a2b92b5 = $d1ba80941c41a2e3$var$AES;

});

parcelRegister("9dT8b", function(module, exports) {

var $BUCDt = parcelRequire("BUCDt");
var $6b7017cc2f7b6351$require$Buffer = $BUCDt.Buffer;
var $6b7017cc2f7b6351$var$ZEROES = $6b7017cc2f7b6351$require$Buffer.alloc(16, 0);
function $6b7017cc2f7b6351$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $6b7017cc2f7b6351$var$fromArray(out) {
    var buf = $6b7017cc2f7b6351$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $6b7017cc2f7b6351$var$GHASH(key) {
    this.h = key;
    this.state = $6b7017cc2f7b6351$require$Buffer.alloc(16, 0);
    this.cache = $6b7017cc2f7b6351$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$6b7017cc2f7b6351$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$6b7017cc2f7b6351$var$GHASH.prototype._multiply = function() {
    var Vi = $6b7017cc2f7b6351$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $6b7017cc2f7b6351$var$fromArray(Zi);
};
$6b7017cc2f7b6351$var$GHASH.prototype.update = function(buf) {
    this.cache = $6b7017cc2f7b6351$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$6b7017cc2f7b6351$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($6b7017cc2f7b6351$require$Buffer.concat([
        this.cache,
        $6b7017cc2f7b6351$var$ZEROES
    ], 16));
    this.ghash($6b7017cc2f7b6351$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $6b7017cc2f7b6351$var$GHASH;

});


parcelRegister("gYoG2", function(module, exports) {

var $i0nyM = parcelRequire("i0nyM");

var $BUCDt = parcelRequire("BUCDt");
var $c5b5644d4d5bdb38$require$Buffer = $BUCDt.Buffer;

var $c7vVf = parcelRequire("c7vVf");

var $bVy58 = parcelRequire("bVy58");
function $c5b5644d4d5bdb38$var$StreamCipher(mode, key, iv, decrypt) {
    $c7vVf.call(this);
    this._cipher = new $i0nyM.AES(key);
    this._prev = $c5b5644d4d5bdb38$require$Buffer.from(iv);
    this._cache = $c5b5644d4d5bdb38$require$Buffer.allocUnsafe(0);
    this._secCache = $c5b5644d4d5bdb38$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$bVy58($c5b5644d4d5bdb38$var$StreamCipher, $c7vVf);
$c5b5644d4d5bdb38$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$c5b5644d4d5bdb38$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $c5b5644d4d5bdb38$var$StreamCipher;

});

parcelRegister("eatyP", function(module, exports) {

var $BUCDt = parcelRequire("BUCDt");
var $a508ee0374e1ba05$require$Buffer = $BUCDt.Buffer;

var $cqxFF = parcelRequire("cqxFF");
/* eslint-disable camelcase */ function $a508ee0374e1ba05$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$a508ee0374e1ba05$require$Buffer.isBuffer(password)) password = $a508ee0374e1ba05$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$a508ee0374e1ba05$require$Buffer.isBuffer(salt)) salt = $a508ee0374e1ba05$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $a508ee0374e1ba05$require$Buffer.alloc(keyLen);
    var iv = $a508ee0374e1ba05$require$Buffer.alloc(ivLen || 0);
    var tmp = $a508ee0374e1ba05$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cqxFF();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $a508ee0374e1ba05$var$EVP_BytesToKey;

});


parcelRegister("jXxII", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $e87daf28d71bc254$export$12ada9414fbc594c; }, function (v) { return $e87daf28d71bc254$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e87daf28d71bc254$export$36b6d6ef312eab39; }, function (v) { return $e87daf28d71bc254$export$36b6d6ef312eab39 = v; });
var $e87daf28d71bc254$export$12ada9414fbc594c;
var $e87daf28d71bc254$export$36b6d6ef312eab39;

var $ciBi5 = parcelRequire("ciBi5");

var $BUCDt = parcelRequire("BUCDt");
var $e87daf28d71bc254$require$Buffer = $BUCDt.Buffer;

var $5YlSp = parcelRequire("5YlSp");

var $gYoG2 = parcelRequire("gYoG2");

var $c7vVf = parcelRequire("c7vVf");

var $i0nyM = parcelRequire("i0nyM");

var $eatyP = parcelRequire("eatyP");

var $bVy58 = parcelRequire("bVy58");
function $e87daf28d71bc254$var$Decipher(mode, key, iv) {
    $c7vVf.call(this);
    this._cache = new $e87daf28d71bc254$var$Splitter();
    this._last = void 0;
    this._cipher = new $i0nyM.AES(key);
    this._prev = $e87daf28d71bc254$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$bVy58($e87daf28d71bc254$var$Decipher, $c7vVf);
$e87daf28d71bc254$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $e87daf28d71bc254$require$Buffer.concat(out);
};
$e87daf28d71bc254$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $e87daf28d71bc254$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$e87daf28d71bc254$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $e87daf28d71bc254$var$Splitter() {
    this.cache = $e87daf28d71bc254$require$Buffer.allocUnsafe(0);
}
$e87daf28d71bc254$var$Splitter.prototype.add = function(data) {
    this.cache = $e87daf28d71bc254$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$e87daf28d71bc254$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$e87daf28d71bc254$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $e87daf28d71bc254$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $e87daf28d71bc254$var$createDecipheriv(suite, password, iv) {
    var config = $5YlSp[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $e87daf28d71bc254$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $e87daf28d71bc254$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $gYoG2(config.module, password, iv, true);
    else if (config.type === 'auth') return new $ciBi5(config.module, password, iv, true);
    return new $e87daf28d71bc254$var$Decipher(config.module, password, iv);
}
function $e87daf28d71bc254$var$createDecipher(suite, password) {
    var config = $5YlSp[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $eatyP(password, false, config.key, config.iv);
    return $e87daf28d71bc254$var$createDecipheriv(suite, keys.key, keys.iv);
}
$e87daf28d71bc254$export$12ada9414fbc594c = $e87daf28d71bc254$var$createDecipher;
$e87daf28d71bc254$export$36b6d6ef312eab39 = $e87daf28d71bc254$var$createDecipheriv;

});


parcelRegister("hc1pA", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $c844a6f859f553f7$export$116f8a5cee447347; }, function (v) { return $c844a6f859f553f7$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $c844a6f859f553f7$export$7483c4066bfb7ae9; }, function (v) { return $c844a6f859f553f7$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $c844a6f859f553f7$export$e7a565d2e588bb06; }, function (v) { return $c844a6f859f553f7$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $c844a6f859f553f7$export$aaa2f54a426f3eb8; }, function (v) { return $c844a6f859f553f7$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $c844a6f859f553f7$export$eba20568dde4ada; }, function (v) { return $c844a6f859f553f7$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $c844a6f859f553f7$export$d3b5e5996938f5ae; }, function (v) { return $c844a6f859f553f7$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $c844a6f859f553f7$export$57c08356130bc99b; }, function (v) { return $c844a6f859f553f7$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $c844a6f859f553f7$export$c7169791d5c1e65d; }, function (v) { return $c844a6f859f553f7$export$c7169791d5c1e65d = v; });
var $c844a6f859f553f7$export$116f8a5cee447347;
var $c844a6f859f553f7$export$7483c4066bfb7ae9;
var $c844a6f859f553f7$export$e7a565d2e588bb06;
var $c844a6f859f553f7$export$aaa2f54a426f3eb8;
var $c844a6f859f553f7$export$eba20568dde4ada;
var $c844a6f859f553f7$export$d3b5e5996938f5ae;
var $c844a6f859f553f7$export$57c08356130bc99b;
var $c844a6f859f553f7$export$c7169791d5c1e65d;
$c844a6f859f553f7$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$c844a6f859f553f7$export$7483c4066bfb7ae9 = $c844a6f859f553f7$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$c844a6f859f553f7$export$aaa2f54a426f3eb8 = $c844a6f859f553f7$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$c844a6f859f553f7$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$c844a6f859f553f7$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$c844a6f859f553f7$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("fX8f5", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $b9d2c275f03a33df$export$971862a2fcb1bb40; }, function (v) { return $b9d2c275f03a33df$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $b9d2c275f03a33df$export$c6ff6a88acbeaf40; }, function (v) { return $b9d2c275f03a33df$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $b9d2c275f03a33df$export$fdc27893e98845cc; }, function (v) { return $b9d2c275f03a33df$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $b9d2c275f03a33df$export$6671fb9a1323bed; }, function (v) { return $b9d2c275f03a33df$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $b9d2c275f03a33df$export$d74daf141a551db; }, function (v) { return $b9d2c275f03a33df$export$d74daf141a551db = v; });
var $b9d2c275f03a33df$export$971862a2fcb1bb40;
var $b9d2c275f03a33df$export$c6ff6a88acbeaf40;
var $b9d2c275f03a33df$export$fdc27893e98845cc;
var $b9d2c275f03a33df$export$6671fb9a1323bed;
var $b9d2c275f03a33df$export$d74daf141a551db;

var $8f5i0 = parcelRequire("8f5i0");
var $b9d2c275f03a33df$require$Buffer = $8f5i0.Buffer;

var $lEUau = parcelRequire("lEUau");

var $3YQOl = parcelRequire("3YQOl");

var $d751U = parcelRequire("d751U");
function $b9d2c275f03a33df$var$getDiffieHellman(mod) {
    var prime = new $b9d2c275f03a33df$require$Buffer($3YQOl[mod].prime, 'hex');
    var gen = new $b9d2c275f03a33df$require$Buffer($3YQOl[mod].gen, 'hex');
    return new $d751U(prime, gen);
}
var $b9d2c275f03a33df$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $b9d2c275f03a33df$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($b9d2c275f03a33df$require$Buffer.isBuffer(enc) || $b9d2c275f03a33df$var$ENCODINGS[enc] === undefined) return $b9d2c275f03a33df$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $b9d2c275f03a33df$require$Buffer([
        2
    ]);
    if (!$b9d2c275f03a33df$require$Buffer.isBuffer(generator)) generator = new $b9d2c275f03a33df$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $d751U($lEUau(prime, generator), generator, true);
    if (!$b9d2c275f03a33df$require$Buffer.isBuffer(prime)) prime = new $b9d2c275f03a33df$require$Buffer(prime, enc);
    return new $d751U(prime, generator, true);
}
$b9d2c275f03a33df$export$971862a2fcb1bb40 = $b9d2c275f03a33df$export$c6ff6a88acbeaf40 = $b9d2c275f03a33df$export$fdc27893e98845cc = $b9d2c275f03a33df$var$getDiffieHellman;
$b9d2c275f03a33df$export$6671fb9a1323bed = $b9d2c275f03a33df$export$d74daf141a551db = $b9d2c275f03a33df$var$createDiffieHellman;

});
parcelRegister("lEUau", function(module, exports) {

var $9FI1O = parcelRequire("9FI1O");
module.exports = $fc48e741bd757e55$var$findPrime;
$fc48e741bd757e55$var$findPrime.simpleSieve = $fc48e741bd757e55$var$simpleSieve;
$fc48e741bd757e55$var$findPrime.fermatTest = $fc48e741bd757e55$var$fermatTest;

var $a6Jtu = parcelRequire("a6Jtu");
var $fc48e741bd757e55$var$TWENTYFOUR = new $a6Jtu(24);

var $33ypw = parcelRequire("33ypw");
var $fc48e741bd757e55$var$millerRabin = new $33ypw();
var $fc48e741bd757e55$var$ONE = new $a6Jtu(1);
var $fc48e741bd757e55$var$TWO = new $a6Jtu(2);
var $fc48e741bd757e55$var$FIVE = new $a6Jtu(5);
var $fc48e741bd757e55$var$SIXTEEN = new $a6Jtu(16);
var $fc48e741bd757e55$var$EIGHT = new $a6Jtu(8);
var $fc48e741bd757e55$var$TEN = new $a6Jtu(10);
var $fc48e741bd757e55$var$THREE = new $a6Jtu(3);
var $fc48e741bd757e55$var$SEVEN = new $a6Jtu(7);
var $fc48e741bd757e55$var$ELEVEN = new $a6Jtu(11);
var $fc48e741bd757e55$var$FOUR = new $a6Jtu(4);
var $fc48e741bd757e55$var$TWELVE = new $a6Jtu(12);
var $fc48e741bd757e55$var$primes = null;
function $fc48e741bd757e55$var$_getPrimes() {
    if ($fc48e741bd757e55$var$primes !== null) return $fc48e741bd757e55$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $fc48e741bd757e55$var$primes = res;
    return res;
}
function $fc48e741bd757e55$var$simpleSieve(p) {
    var primes = $fc48e741bd757e55$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $fc48e741bd757e55$var$fermatTest(p) {
    var red = $a6Jtu.mont(p);
    return $fc48e741bd757e55$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $fc48e741bd757e55$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $a6Jtu([
            0x8c,
            0x7b
        ]);
        else return new $a6Jtu([
            0x8c,
            0x27
        ]);
    }
    gen = new $a6Jtu(gen);
    var num, n2;
    while(true){
        num = new $a6Jtu($9FI1O(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($fc48e741bd757e55$var$ONE);
        if (!num.testn(1)) num.iadd($fc48e741bd757e55$var$TWO);
        if (!gen.cmp($fc48e741bd757e55$var$TWO)) while(num.mod($fc48e741bd757e55$var$TWENTYFOUR).cmp($fc48e741bd757e55$var$ELEVEN))num.iadd($fc48e741bd757e55$var$FOUR);
        else if (!gen.cmp($fc48e741bd757e55$var$FIVE)) while(num.mod($fc48e741bd757e55$var$TEN).cmp($fc48e741bd757e55$var$THREE))num.iadd($fc48e741bd757e55$var$FOUR);
        n2 = num.shrn(1);
        if ($fc48e741bd757e55$var$simpleSieve(n2) && $fc48e741bd757e55$var$simpleSieve(num) && $fc48e741bd757e55$var$fermatTest(n2) && $fc48e741bd757e55$var$fermatTest(num) && $fc48e741bd757e55$var$millerRabin.test(n2) && $fc48e741bd757e55$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("a6Jtu", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("fVZIf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("33ypw", function(module, exports) {

var $a6Jtu = parcelRequire("a6Jtu");

var $iWK6F = parcelRequire("iWK6F");
function $239c582699e739b2$var$MillerRabin(rand) {
    this.rand = rand || new $iWK6F.Rand();
}
module.exports = $239c582699e739b2$var$MillerRabin;
$239c582699e739b2$var$MillerRabin.create = function create(rand) {
    return new $239c582699e739b2$var$MillerRabin(rand);
};
$239c582699e739b2$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $a6Jtu(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$239c582699e739b2$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$239c582699e739b2$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $a6Jtu.mont(n);
    var rone = new $a6Jtu(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $a6Jtu(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$239c582699e739b2$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $a6Jtu.mont(n);
    var rone = new $a6Jtu(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $a6Jtu(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("iWK6F", function(module, exports) {
var $dcb168984cc5df6f$var$r;
module.exports = function rand(len) {
    if (!$dcb168984cc5df6f$var$r) $dcb168984cc5df6f$var$r = new $dcb168984cc5df6f$var$Rand(null);
    return $dcb168984cc5df6f$var$r.generate(len);
};
function $dcb168984cc5df6f$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $dcb168984cc5df6f$var$Rand;
$dcb168984cc5df6f$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$dcb168984cc5df6f$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $dcb168984cc5df6f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $dcb168984cc5df6f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $dcb168984cc5df6f$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $dcb168984cc5df6f$var$crypto = (parcelRequire("fVZIf"));
    if (typeof $dcb168984cc5df6f$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $dcb168984cc5df6f$var$Rand.prototype._rand = function _rand(n) {
        return $dcb168984cc5df6f$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("3YQOl", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("d751U", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $98bfd4a54a0148bc$require$Buffer = $8f5i0.Buffer;

var $a6Jtu = parcelRequire("a6Jtu");

var $33ypw = parcelRequire("33ypw");
var $98bfd4a54a0148bc$var$millerRabin = new $33ypw();
var $98bfd4a54a0148bc$var$TWENTYFOUR = new $a6Jtu(24);
var $98bfd4a54a0148bc$var$ELEVEN = new $a6Jtu(11);
var $98bfd4a54a0148bc$var$TEN = new $a6Jtu(10);
var $98bfd4a54a0148bc$var$THREE = new $a6Jtu(3);
var $98bfd4a54a0148bc$var$SEVEN = new $a6Jtu(7);

var $lEUau = parcelRequire("lEUau");

var $9FI1O = parcelRequire("9FI1O");
module.exports = $98bfd4a54a0148bc$var$DH;
function $98bfd4a54a0148bc$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$98bfd4a54a0148bc$require$Buffer.isBuffer(pub)) pub = new $98bfd4a54a0148bc$require$Buffer(pub, enc);
    this._pub = new $a6Jtu(pub);
    return this;
}
function $98bfd4a54a0148bc$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$98bfd4a54a0148bc$require$Buffer.isBuffer(priv)) priv = new $98bfd4a54a0148bc$require$Buffer(priv, enc);
    this._priv = new $a6Jtu(priv);
    return this;
}
var $98bfd4a54a0148bc$var$primeCache = {};
function $98bfd4a54a0148bc$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $98bfd4a54a0148bc$var$primeCache) return $98bfd4a54a0148bc$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$lEUau.simpleSieve || !$lEUau.fermatTest(prime) || !$98bfd4a54a0148bc$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $98bfd4a54a0148bc$var$primeCache[hex] = error;
        return error;
    }
    if (!$98bfd4a54a0148bc$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($98bfd4a54a0148bc$var$TWENTYFOUR).cmp($98bfd4a54a0148bc$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($98bfd4a54a0148bc$var$TEN);
            if (rem.cmp($98bfd4a54a0148bc$var$THREE) && rem.cmp($98bfd4a54a0148bc$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $98bfd4a54a0148bc$var$primeCache[hex] = error;
    return error;
}
function $98bfd4a54a0148bc$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $a6Jtu(prime);
    this._prime = $a6Jtu.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $98bfd4a54a0148bc$var$setPublicKey;
        this.setPrivateKey = $98bfd4a54a0148bc$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($98bfd4a54a0148bc$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $98bfd4a54a0148bc$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$98bfd4a54a0148bc$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $a6Jtu($9FI1O(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$98bfd4a54a0148bc$var$DH.prototype.computeSecret = function(other) {
    other = new $a6Jtu(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $98bfd4a54a0148bc$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $98bfd4a54a0148bc$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $98bfd4a54a0148bc$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$98bfd4a54a0148bc$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $98bfd4a54a0148bc$var$formatReturnValue(this._pub, enc);
};
$98bfd4a54a0148bc$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $98bfd4a54a0148bc$var$formatReturnValue(this._priv, enc);
};
$98bfd4a54a0148bc$var$DH.prototype.getPrime = function(enc) {
    return $98bfd4a54a0148bc$var$formatReturnValue(this.__prime, enc);
};
$98bfd4a54a0148bc$var$DH.prototype.getGenerator = function(enc) {
    return $98bfd4a54a0148bc$var$formatReturnValue(this._gen, enc);
};
$98bfd4a54a0148bc$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$98bfd4a54a0148bc$require$Buffer.isBuffer(gen)) gen = new $98bfd4a54a0148bc$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $a6Jtu(gen);
    return this;
};
function $98bfd4a54a0148bc$var$formatReturnValue(bn, enc) {
    var buf = new $98bfd4a54a0148bc$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("5z5tv", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $40d477cf866bb866$require$Buffer = $BUCDt.Buffer;

var $3KMVQ = parcelRequire("3KMVQ");

var $9Gfr3 = parcelRequire("9Gfr3");

var $bVy58 = parcelRequire("bVy58");

var $eMAzI = parcelRequire("eMAzI");

var $lIhmv = parcelRequire("lIhmv");

var $amrQM = parcelRequire("amrQM");
Object.keys($amrQM).forEach(function(key) {
    $amrQM[key].id = $40d477cf866bb866$require$Buffer.from($amrQM[key].id, 'hex');
    $amrQM[key.toLowerCase()] = $amrQM[key];
});
function $40d477cf866bb866$var$Sign(algorithm) {
    $9Gfr3.Writable.call(this);
    var data = $amrQM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $3KMVQ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$bVy58($40d477cf866bb866$var$Sign, $9Gfr3.Writable);
$40d477cf866bb866$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$40d477cf866bb866$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $40d477cf866bb866$require$Buffer.from(data, enc) : data);
    return this;
};
$40d477cf866bb866$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $eMAzI(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $40d477cf866bb866$var$Verify(algorithm) {
    $9Gfr3.Writable.call(this);
    var data = $amrQM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $3KMVQ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$bVy58($40d477cf866bb866$var$Verify, $9Gfr3.Writable);
$40d477cf866bb866$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$40d477cf866bb866$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $40d477cf866bb866$require$Buffer.from(data, enc) : data);
    return this;
};
$40d477cf866bb866$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $40d477cf866bb866$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $lIhmv(sigBuffer, hash, key, this._signType, this._tag);
};
function $40d477cf866bb866$var$createSign(algorithm) {
    return new $40d477cf866bb866$var$Sign(algorithm);
}
function $40d477cf866bb866$var$createVerify(algorithm) {
    return new $40d477cf866bb866$var$Verify(algorithm);
}
module.exports = {
    Sign: $40d477cf866bb866$var$createSign,
    Verify: $40d477cf866bb866$var$createVerify,
    createSign: $40d477cf866bb866$var$createSign,
    createVerify: $40d477cf866bb866$var$createVerify
};

});
parcelRegister("9Gfr3", function(module, exports) {

exports = module.exports = (parcelRequire("bT1Ex"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("iBvY4"));

exports.Duplex = (parcelRequire("9Q6qL"));

exports.Transform = (parcelRequire("a7ATh"));

exports.PassThrough = (parcelRequire("gzk1W"));

});
parcelRegister("bT1Ex", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3iXjX = parcelRequire("3iXjX");
'use strict';

var $cq1Gj = parcelRequire("cq1Gj");
/*</replacement>*/ module.exports = $8a761cfa46a7027a$var$Readable;

var $7ClTG = parcelRequire("7ClTG");
/*</replacement>*/ /*<replacement>*/ var $8a761cfa46a7027a$var$Duplex;
/*</replacement>*/ $8a761cfa46a7027a$var$Readable.ReadableState = $8a761cfa46a7027a$var$ReadableState;

var $cOXur = parcelRequire("cOXur");
var $8a761cfa46a7027a$require$EE = $cOXur.EventEmitter;
var $8a761cfa46a7027a$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $ieGkU = parcelRequire("ieGkU");

var $kxlf7 = parcelRequire("kxlf7");
var $8a761cfa46a7027a$require$Buffer = $kxlf7.Buffer;
var $8a761cfa46a7027a$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $8a761cfa46a7027a$var$_uint8ArrayToBuffer(chunk) {
    return $8a761cfa46a7027a$require$Buffer.from(chunk);
}
function $8a761cfa46a7027a$var$_isUint8Array(obj) {
    return $8a761cfa46a7027a$require$Buffer.isBuffer(obj) || obj instanceof $8a761cfa46a7027a$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $8a761cfa46a7027a$var$util = Object.create((parcelRequire("9wTlL")));

$8a761cfa46a7027a$var$util.inherits = (parcelRequire("bVy58"));

var $fVZIf = parcelRequire("fVZIf");
var $8a761cfa46a7027a$var$debug = void 0;
if ($fVZIf && $fVZIf.debuglog) $8a761cfa46a7027a$var$debug = $fVZIf.debuglog('stream');
else $8a761cfa46a7027a$var$debug = function() {};

var $eV67y = parcelRequire("eV67y");

var $ivLTH = parcelRequire("ivLTH");
var $8a761cfa46a7027a$var$StringDecoder;
$8a761cfa46a7027a$var$util.inherits($8a761cfa46a7027a$var$Readable, $ieGkU);
var $8a761cfa46a7027a$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $8a761cfa46a7027a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7ClTG(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $8a761cfa46a7027a$var$ReadableState(options, stream) {
    $8a761cfa46a7027a$var$Duplex = $8a761cfa46a7027a$var$Duplex || (parcelRequire("9Q6qL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $8a761cfa46a7027a$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $eV67y();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$8a761cfa46a7027a$var$StringDecoder) $8a761cfa46a7027a$var$StringDecoder = (parcelRequire("fgLo1")).StringDecoder;
        this.decoder = new $8a761cfa46a7027a$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8a761cfa46a7027a$var$Readable(options) {
    $8a761cfa46a7027a$var$Duplex = $8a761cfa46a7027a$var$Duplex || (parcelRequire("9Q6qL"));
    if (!(this instanceof $8a761cfa46a7027a$var$Readable)) return new $8a761cfa46a7027a$var$Readable(options);
    this._readableState = new $8a761cfa46a7027a$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $ieGkU.call(this);
}
Object.defineProperty($8a761cfa46a7027a$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$8a761cfa46a7027a$var$Readable.prototype.destroy = $ivLTH.destroy;
$8a761cfa46a7027a$var$Readable.prototype._undestroy = $ivLTH.undestroy;
$8a761cfa46a7027a$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8a761cfa46a7027a$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $8a761cfa46a7027a$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $8a761cfa46a7027a$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$8a761cfa46a7027a$var$Readable.prototype.unshift = function(chunk) {
    return $8a761cfa46a7027a$var$readableAddChunk(this, chunk, null, true, false);
};
function $8a761cfa46a7027a$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $8a761cfa46a7027a$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $8a761cfa46a7027a$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $8a761cfa46a7027a$require$Buffer.prototype) chunk = $8a761cfa46a7027a$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $8a761cfa46a7027a$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $8a761cfa46a7027a$var$addChunk(stream, state, chunk, false);
                    else $8a761cfa46a7027a$var$maybeReadMore(stream, state);
                } else $8a761cfa46a7027a$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $8a761cfa46a7027a$var$needMoreData(state);
}
function $8a761cfa46a7027a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $8a761cfa46a7027a$var$emitReadable(stream);
    }
    $8a761cfa46a7027a$var$maybeReadMore(stream, state);
}
function $8a761cfa46a7027a$var$chunkInvalid(state, chunk) {
    var er;
    if (!$8a761cfa46a7027a$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $8a761cfa46a7027a$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$8a761cfa46a7027a$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$8a761cfa46a7027a$var$Readable.prototype.setEncoding = function(enc) {
    if (!$8a761cfa46a7027a$var$StringDecoder) $8a761cfa46a7027a$var$StringDecoder = (parcelRequire("fgLo1")).StringDecoder;
    this._readableState.decoder = new $8a761cfa46a7027a$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $8a761cfa46a7027a$var$MAX_HWM = 0x800000;
function $8a761cfa46a7027a$var$computeNewHighWaterMark(n) {
    if (n >= $8a761cfa46a7027a$var$MAX_HWM) n = $8a761cfa46a7027a$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8a761cfa46a7027a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8a761cfa46a7027a$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$8a761cfa46a7027a$var$Readable.prototype.read = function(n) {
    $8a761cfa46a7027a$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $8a761cfa46a7027a$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8a761cfa46a7027a$var$endReadable(this);
        else $8a761cfa46a7027a$var$emitReadable(this);
        return null;
    }
    n = $8a761cfa46a7027a$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8a761cfa46a7027a$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $8a761cfa46a7027a$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8a761cfa46a7027a$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $8a761cfa46a7027a$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $8a761cfa46a7027a$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8a761cfa46a7027a$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $8a761cfa46a7027a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8a761cfa46a7027a$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $8a761cfa46a7027a$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $8a761cfa46a7027a$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8a761cfa46a7027a$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8a761cfa46a7027a$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $cq1Gj.nextTick($8a761cfa46a7027a$var$emitReadable_, stream);
        else $8a761cfa46a7027a$var$emitReadable_(stream);
    }
}
function $8a761cfa46a7027a$var$emitReadable_(stream) {
    $8a761cfa46a7027a$var$debug('emit readable');
    stream.emit('readable');
    $8a761cfa46a7027a$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8a761cfa46a7027a$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $cq1Gj.nextTick($8a761cfa46a7027a$var$maybeReadMore_, stream, state);
    }
}
function $8a761cfa46a7027a$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $8a761cfa46a7027a$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8a761cfa46a7027a$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$8a761cfa46a7027a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $8a761cfa46a7027a$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $3iXjX.stdout && dest !== $3iXjX.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $cq1Gj.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8a761cfa46a7027a$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8a761cfa46a7027a$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $8a761cfa46a7027a$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $8a761cfa46a7027a$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $8a761cfa46a7027a$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $8a761cfa46a7027a$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $8a761cfa46a7027a$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8a761cfa46a7027a$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($8a761cfa46a7027a$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $8a761cfa46a7027a$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8a761cfa46a7027a$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8a761cfa46a7027a$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $8a761cfa46a7027a$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8a761cfa46a7027a$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $8a761cfa46a7027a$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $8a761cfa46a7027a$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $8a761cfa46a7027a$var$flow(src);
        }
    };
}
$8a761cfa46a7027a$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $8a761cfa46a7027a$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$8a761cfa46a7027a$var$Readable.prototype.on = function(ev, fn) {
    var res = $ieGkU.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $cq1Gj.nextTick($8a761cfa46a7027a$var$nReadingNextTick, this);
            else if (state.length) $8a761cfa46a7027a$var$emitReadable(this);
        }
    }
    return res;
};
$8a761cfa46a7027a$var$Readable.prototype.addListener = $8a761cfa46a7027a$var$Readable.prototype.on;
function $8a761cfa46a7027a$var$nReadingNextTick(self1) {
    $8a761cfa46a7027a$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8a761cfa46a7027a$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $8a761cfa46a7027a$var$debug('resume');
        state.flowing = true;
        $8a761cfa46a7027a$var$resume(this, state);
    }
    return this;
};
function $8a761cfa46a7027a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $cq1Gj.nextTick($8a761cfa46a7027a$var$resume_, stream, state);
    }
}
function $8a761cfa46a7027a$var$resume_(stream, state) {
    if (!state.reading) {
        $8a761cfa46a7027a$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $8a761cfa46a7027a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8a761cfa46a7027a$var$Readable.prototype.pause = function() {
    $8a761cfa46a7027a$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $8a761cfa46a7027a$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $8a761cfa46a7027a$var$flow(stream) {
    var state = stream._readableState;
    $8a761cfa46a7027a$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8a761cfa46a7027a$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $8a761cfa46a7027a$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $8a761cfa46a7027a$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $8a761cfa46a7027a$var$kProxyEvents.length; n++)stream.on($8a761cfa46a7027a$var$kProxyEvents[n], this.emit.bind(this, $8a761cfa46a7027a$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $8a761cfa46a7027a$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($8a761cfa46a7027a$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$8a761cfa46a7027a$var$Readable._fromList = $8a761cfa46a7027a$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8a761cfa46a7027a$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $8a761cfa46a7027a$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8a761cfa46a7027a$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $8a761cfa46a7027a$var$copyFromBufferString(n, list) : $8a761cfa46a7027a$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8a761cfa46a7027a$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8a761cfa46a7027a$var$copyFromBuffer(n, list) {
    var ret = $8a761cfa46a7027a$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $8a761cfa46a7027a$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $cq1Gj.nextTick($8a761cfa46a7027a$var$endReadableNT, state, stream);
    }
}
function $8a761cfa46a7027a$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $8a761cfa46a7027a$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("cq1Gj", function(module, exports) {

var $3iXjX = parcelRequire("3iXjX");
'use strict';
module.exports = {
    nextTick: $90a937a1dd178dd8$var$nextTick
};
function $90a937a1dd178dd8$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $3iXjX.nextTick(fn);
        case 2:
            return $3iXjX.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $3iXjX.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $3iXjX.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $3iXjX.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("7ClTG", function(module, exports) {
var $58bd115874eab88a$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $58bd115874eab88a$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("ieGkU", function(module, exports) {

module.exports = (parcelRequire("cOXur")).EventEmitter;

});

parcelRegister("kxlf7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $8f5i0 = parcelRequire("8f5i0");
var $ef375e1910901613$var$Buffer = $8f5i0.Buffer;
// alternative to using Object.keys for old browsers
function $ef375e1910901613$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ef375e1910901613$var$Buffer.from && $ef375e1910901613$var$Buffer.alloc && $ef375e1910901613$var$Buffer.allocUnsafe && $ef375e1910901613$var$Buffer.allocUnsafeSlow) module.exports = $8f5i0;
else {
    // Copy properties from require('buffer')
    $ef375e1910901613$var$copyProps($8f5i0, module.exports);
    module.exports.Buffer = $ef375e1910901613$var$SafeBuffer;
}
function $ef375e1910901613$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ef375e1910901613$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$ef375e1910901613$var$copyProps($ef375e1910901613$var$Buffer, $ef375e1910901613$var$SafeBuffer);
$ef375e1910901613$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ef375e1910901613$var$Buffer(arg, encodingOrOffset, length);
};
$ef375e1910901613$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ef375e1910901613$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ef375e1910901613$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ef375e1910901613$var$Buffer(size);
};
$ef375e1910901613$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8f5i0.SlowBuffer(size);
};

});

parcelRegister("9wTlL", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $6f02099603174320$export$43bee75e5e14138e; }, function (v) { return $6f02099603174320$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $6f02099603174320$export$f9ce7b637dfbe238; }, function (v) { return $6f02099603174320$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $6f02099603174320$export$630801d484da15df; }, function (v) { return $6f02099603174320$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $6f02099603174320$export$bedb7023a7733221; }, function (v) { return $6f02099603174320$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $6f02099603174320$export$7e4aa119212bc614; }, function (v) { return $6f02099603174320$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $6f02099603174320$export$844ec244b1367d54; }, function (v) { return $6f02099603174320$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $6f02099603174320$export$a244864fd9645c7f; }, function (v) { return $6f02099603174320$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $6f02099603174320$export$fce6876652108ab; }, function (v) { return $6f02099603174320$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $6f02099603174320$export$49841c62b9eff15; }, function (v) { return $6f02099603174320$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $6f02099603174320$export$a6cdc56e425d0d0a; }, function (v) { return $6f02099603174320$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $6f02099603174320$export$871608497c498473; }, function (v) { return $6f02099603174320$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $6f02099603174320$export$e6127cc7fe7395c3; }, function (v) { return $6f02099603174320$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $6f02099603174320$export$f6e2535fb5126e54; }, function (v) { return $6f02099603174320$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $6f02099603174320$export$c3825b437cbdea5c; }, function (v) { return $6f02099603174320$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $6f02099603174320$export$a7884ebc965f8f54; }, function (v) { return $6f02099603174320$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $6f02099603174320$export$43bee75e5e14138e;
var $6f02099603174320$export$f9ce7b637dfbe238;
var $6f02099603174320$export$630801d484da15df;
var $6f02099603174320$export$bedb7023a7733221;
var $6f02099603174320$export$7e4aa119212bc614;
var $6f02099603174320$export$844ec244b1367d54;
var $6f02099603174320$export$a244864fd9645c7f;
var $6f02099603174320$export$fce6876652108ab;
var $6f02099603174320$export$49841c62b9eff15;
var $6f02099603174320$export$a6cdc56e425d0d0a;
var $6f02099603174320$export$871608497c498473;
var $6f02099603174320$export$e6127cc7fe7395c3;
var $6f02099603174320$export$f6e2535fb5126e54;
var $6f02099603174320$export$c3825b437cbdea5c;
var $6f02099603174320$export$a7884ebc965f8f54;
function $6f02099603174320$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $6f02099603174320$var$objectToString(arg) === '[object Array]';
}
$6f02099603174320$export$43bee75e5e14138e = $6f02099603174320$var$isArray;
function $6f02099603174320$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$6f02099603174320$export$f9ce7b637dfbe238 = $6f02099603174320$var$isBoolean;
function $6f02099603174320$var$isNull(arg) {
    return arg === null;
}
$6f02099603174320$export$630801d484da15df = $6f02099603174320$var$isNull;
function $6f02099603174320$var$isNullOrUndefined(arg) {
    return arg == null;
}
$6f02099603174320$export$bedb7023a7733221 = $6f02099603174320$var$isNullOrUndefined;
function $6f02099603174320$var$isNumber(arg) {
    return typeof arg === 'number';
}
$6f02099603174320$export$7e4aa119212bc614 = $6f02099603174320$var$isNumber;
function $6f02099603174320$var$isString(arg) {
    return typeof arg === 'string';
}
$6f02099603174320$export$844ec244b1367d54 = $6f02099603174320$var$isString;
function $6f02099603174320$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$6f02099603174320$export$a244864fd9645c7f = $6f02099603174320$var$isSymbol;
function $6f02099603174320$var$isUndefined(arg) {
    return arg === void 0;
}
$6f02099603174320$export$fce6876652108ab = $6f02099603174320$var$isUndefined;
function $6f02099603174320$var$isRegExp(re) {
    return $6f02099603174320$var$objectToString(re) === '[object RegExp]';
}
$6f02099603174320$export$49841c62b9eff15 = $6f02099603174320$var$isRegExp;
function $6f02099603174320$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$6f02099603174320$export$a6cdc56e425d0d0a = $6f02099603174320$var$isObject;
function $6f02099603174320$var$isDate(d) {
    return $6f02099603174320$var$objectToString(d) === '[object Date]';
}
$6f02099603174320$export$871608497c498473 = $6f02099603174320$var$isDate;
function $6f02099603174320$var$isError(e) {
    return $6f02099603174320$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$6f02099603174320$export$e6127cc7fe7395c3 = $6f02099603174320$var$isError;
function $6f02099603174320$var$isFunction(arg) {
    return typeof arg === 'function';
}
$6f02099603174320$export$f6e2535fb5126e54 = $6f02099603174320$var$isFunction;
function $6f02099603174320$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$6f02099603174320$export$c3825b437cbdea5c = $6f02099603174320$var$isPrimitive;

$6f02099603174320$export$a7884ebc965f8f54 = (parcelRequire("8f5i0")).Buffer.isBuffer;
function $6f02099603174320$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("eV67y", function(module, exports) {
'use strict';
function $adcb230468bd5389$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $kxlf7 = parcelRequire("kxlf7");
var $adcb230468bd5389$require$Buffer = $kxlf7.Buffer;

var $fVZIf = parcelRequire("fVZIf");
function $adcb230468bd5389$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $adcb230468bd5389$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $adcb230468bd5389$require$Buffer.alloc(0);
        var ret = $adcb230468bd5389$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $adcb230468bd5389$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($fVZIf && $fVZIf.inspect && $fVZIf.inspect.custom) module.exports.prototype[$fVZIf.inspect.custom] = function() {
    var obj = $fVZIf.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("ivLTH", function(module, exports) {
'use strict';

var $cq1Gj = parcelRequire("cq1Gj");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $d7a046ac44b52d32$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $cq1Gj.nextTick($d7a046ac44b52d32$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $cq1Gj.nextTick($d7a046ac44b52d32$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $cq1Gj.nextTick($d7a046ac44b52d32$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $cq1Gj.nextTick($d7a046ac44b52d32$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $d7a046ac44b52d32$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $d7a046ac44b52d32$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $d7a046ac44b52d32$var$destroy,
    undestroy: $d7a046ac44b52d32$var$undestroy
};

});

parcelRegister("9Q6qL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $cq1Gj = parcelRequire("cq1Gj");
/*</replacement>*/ /*<replacement>*/ var $729df563feb96097$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $729df563feb96097$var$Duplex;

/*<replacement>*/ var $729df563feb96097$var$util = Object.create((parcelRequire("9wTlL")));

$729df563feb96097$var$util.inherits = (parcelRequire("bVy58"));

var $bT1Ex = parcelRequire("bT1Ex");

var $iBvY4 = parcelRequire("iBvY4");
$729df563feb96097$var$util.inherits($729df563feb96097$var$Duplex, $bT1Ex);
// avoid scope creep, the keys array can then be collected
var $729df563feb96097$var$keys = $729df563feb96097$var$objectKeys($iBvY4.prototype);
for(var $729df563feb96097$var$v = 0; $729df563feb96097$var$v < $729df563feb96097$var$keys.length; $729df563feb96097$var$v++){
    var $729df563feb96097$var$method = $729df563feb96097$var$keys[$729df563feb96097$var$v];
    if (!$729df563feb96097$var$Duplex.prototype[$729df563feb96097$var$method]) $729df563feb96097$var$Duplex.prototype[$729df563feb96097$var$method] = $iBvY4.prototype[$729df563feb96097$var$method];
}
function $729df563feb96097$var$Duplex(options) {
    if (!(this instanceof $729df563feb96097$var$Duplex)) return new $729df563feb96097$var$Duplex(options);
    $bT1Ex.call(this, options);
    $iBvY4.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $729df563feb96097$var$onend);
}
Object.defineProperty($729df563feb96097$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $729df563feb96097$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $cq1Gj.nextTick($729df563feb96097$var$onEndNT, this);
}
function $729df563feb96097$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($729df563feb96097$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$729df563feb96097$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $cq1Gj.nextTick(cb, err);
};

});
parcelRegister("iBvY4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $cq1Gj = parcelRequire("cq1Gj");
/*</replacement>*/ module.exports = $d8b47adaba7179af$var$Writable;
/* <replacement> */ function $d8b47adaba7179af$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $d8b47adaba7179af$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $d8b47adaba7179af$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $d8b47adaba7179af$var$asyncWrite = (0, $cq1Gj.nextTick);
/*</replacement>*/ /*<replacement>*/ var $d8b47adaba7179af$var$Duplex;
/*</replacement>*/ $d8b47adaba7179af$var$Writable.WritableState = $d8b47adaba7179af$var$WritableState;

/*<replacement>*/ var $d8b47adaba7179af$var$util = Object.create((parcelRequire("9wTlL")));

$d8b47adaba7179af$var$util.inherits = (parcelRequire("bVy58"));

/*</replacement>*/ /*<replacement>*/ var $d8b47adaba7179af$var$internalUtil = {
    deprecate: (parcelRequire("iopiP"))
};

var $ieGkU = parcelRequire("ieGkU");

var $kxlf7 = parcelRequire("kxlf7");
var $d8b47adaba7179af$require$Buffer = $kxlf7.Buffer;
var $d8b47adaba7179af$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $d8b47adaba7179af$var$_uint8ArrayToBuffer(chunk) {
    return $d8b47adaba7179af$require$Buffer.from(chunk);
}
function $d8b47adaba7179af$var$_isUint8Array(obj) {
    return $d8b47adaba7179af$require$Buffer.isBuffer(obj) || obj instanceof $d8b47adaba7179af$var$OurUint8Array;
}

var $ivLTH = parcelRequire("ivLTH");
$d8b47adaba7179af$var$util.inherits($d8b47adaba7179af$var$Writable, $ieGkU);
function $d8b47adaba7179af$var$nop() {}

function $d8b47adaba7179af$var$WritableState(options, stream) {
    $d8b47adaba7179af$var$Duplex = $d8b47adaba7179af$var$Duplex || (parcelRequire("9Q6qL"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $d8b47adaba7179af$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $d8b47adaba7179af$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $d8b47adaba7179af$var$CorkedRequest(this);
}
$d8b47adaba7179af$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($d8b47adaba7179af$var$WritableState.prototype, 'buffer', {
            get: $d8b47adaba7179af$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $d8b47adaba7179af$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $d8b47adaba7179af$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($d8b47adaba7179af$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($d8b47adaba7179af$var$realHasInstance.call(this, object)) return true;
            if (this !== $d8b47adaba7179af$var$Writable) return false;
            return object && object._writableState instanceof $d8b47adaba7179af$var$WritableState;
        }
    });
} else $d8b47adaba7179af$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $d8b47adaba7179af$var$Writable(options) {
    $d8b47adaba7179af$var$Duplex = $d8b47adaba7179af$var$Duplex || (parcelRequire("9Q6qL"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$d8b47adaba7179af$var$realHasInstance.call($d8b47adaba7179af$var$Writable, this) && !(this instanceof $d8b47adaba7179af$var$Duplex)) return new $d8b47adaba7179af$var$Writable(options);
    this._writableState = new $d8b47adaba7179af$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $ieGkU.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$d8b47adaba7179af$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $d8b47adaba7179af$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $cq1Gj.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $d8b47adaba7179af$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $cq1Gj.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$d8b47adaba7179af$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $d8b47adaba7179af$var$_isUint8Array(chunk);
    if (isBuf && !$d8b47adaba7179af$require$Buffer.isBuffer(chunk)) chunk = $d8b47adaba7179af$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $d8b47adaba7179af$var$nop;
    if (state.ended) $d8b47adaba7179af$var$writeAfterEnd(this, cb);
    else if (isBuf || $d8b47adaba7179af$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $d8b47adaba7179af$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$d8b47adaba7179af$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$d8b47adaba7179af$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d8b47adaba7179af$var$clearBuffer(this, state);
    }
};
$d8b47adaba7179af$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $d8b47adaba7179af$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $d8b47adaba7179af$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($d8b47adaba7179af$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $d8b47adaba7179af$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $d8b47adaba7179af$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $d8b47adaba7179af$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $d8b47adaba7179af$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $d8b47adaba7179af$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $cq1Gj.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $cq1Gj.nextTick($d8b47adaba7179af$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $d8b47adaba7179af$var$finishMaybe(stream, state);
    }
}
function $d8b47adaba7179af$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $d8b47adaba7179af$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $d8b47adaba7179af$var$onwriteStateUpdate(state);
    if (er) $d8b47adaba7179af$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $d8b47adaba7179af$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d8b47adaba7179af$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $d8b47adaba7179af$var$asyncWrite($d8b47adaba7179af$var$afterWrite, stream, state, finished, cb);
        else $d8b47adaba7179af$var$afterWrite(stream, state, finished, cb);
    }
}
function $d8b47adaba7179af$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $d8b47adaba7179af$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $d8b47adaba7179af$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $d8b47adaba7179af$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $d8b47adaba7179af$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $d8b47adaba7179af$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $d8b47adaba7179af$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $d8b47adaba7179af$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$d8b47adaba7179af$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$d8b47adaba7179af$var$Writable.prototype._writev = null;
$d8b47adaba7179af$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $d8b47adaba7179af$var$endWritable(this, state, cb);
};
function $d8b47adaba7179af$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $d8b47adaba7179af$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $d8b47adaba7179af$var$finishMaybe(stream, state);
    });
}
function $d8b47adaba7179af$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $cq1Gj.nextTick($d8b47adaba7179af$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $d8b47adaba7179af$var$finishMaybe(stream, state) {
    var need = $d8b47adaba7179af$var$needFinish(state);
    if (need) {
        $d8b47adaba7179af$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $d8b47adaba7179af$var$endWritable(stream, state, cb) {
    state.ending = true;
    $d8b47adaba7179af$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $cq1Gj.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $d8b47adaba7179af$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($d8b47adaba7179af$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$d8b47adaba7179af$var$Writable.prototype.destroy = $ivLTH.destroy;
$d8b47adaba7179af$var$Writable.prototype._undestroy = $ivLTH.undestroy;
$d8b47adaba7179af$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("fgLo1", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $b1dd1b95725708d8$export$63a7aa211a91ed69; }, function (v) { return $b1dd1b95725708d8$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $b1dd1b95725708d8$export$63a7aa211a91ed69;
'use strict';

var $b9Dms = parcelRequire("b9Dms");
var $b1dd1b95725708d8$require$Buffer = $b9Dms.Buffer;
/*</replacement>*/ var $b1dd1b95725708d8$var$isEncoding = $b1dd1b95725708d8$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $b1dd1b95725708d8$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $b1dd1b95725708d8$var$normalizeEncoding(enc) {
    var nenc = $b1dd1b95725708d8$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($b1dd1b95725708d8$require$Buffer.isEncoding === $b1dd1b95725708d8$var$isEncoding || !$b1dd1b95725708d8$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$b1dd1b95725708d8$export$63a7aa211a91ed69 = $b1dd1b95725708d8$var$StringDecoder;
function $b1dd1b95725708d8$var$StringDecoder(encoding) {
    this.encoding = $b1dd1b95725708d8$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $b1dd1b95725708d8$var$utf16Text;
            this.end = $b1dd1b95725708d8$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $b1dd1b95725708d8$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $b1dd1b95725708d8$var$base64Text;
            this.end = $b1dd1b95725708d8$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $b1dd1b95725708d8$var$simpleWrite;
            this.end = $b1dd1b95725708d8$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $b1dd1b95725708d8$require$Buffer.allocUnsafe(nb);
}
$b1dd1b95725708d8$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$b1dd1b95725708d8$var$StringDecoder.prototype.end = $b1dd1b95725708d8$var$utf8End;
// Returns only complete characters in a Buffer
$b1dd1b95725708d8$var$StringDecoder.prototype.text = $b1dd1b95725708d8$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$b1dd1b95725708d8$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $b1dd1b95725708d8$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $b1dd1b95725708d8$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $b1dd1b95725708d8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b1dd1b95725708d8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $b1dd1b95725708d8$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $b1dd1b95725708d8$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $b1dd1b95725708d8$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $b1dd1b95725708d8$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $b1dd1b95725708d8$var$utf8Text(buf, i) {
    var total = $b1dd1b95725708d8$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $b1dd1b95725708d8$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $b1dd1b95725708d8$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $b1dd1b95725708d8$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $b1dd1b95725708d8$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $b1dd1b95725708d8$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $b1dd1b95725708d8$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $b1dd1b95725708d8$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("b9Dms", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $8f5i0 = parcelRequire("8f5i0");
var $81ef1149d5a252e6$var$Buffer = $8f5i0.Buffer;
// alternative to using Object.keys for old browsers
function $81ef1149d5a252e6$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($81ef1149d5a252e6$var$Buffer.from && $81ef1149d5a252e6$var$Buffer.alloc && $81ef1149d5a252e6$var$Buffer.allocUnsafe && $81ef1149d5a252e6$var$Buffer.allocUnsafeSlow) module.exports = $8f5i0;
else {
    // Copy properties from require('buffer')
    $81ef1149d5a252e6$var$copyProps($8f5i0, module.exports);
    module.exports.Buffer = $81ef1149d5a252e6$var$SafeBuffer;
}
function $81ef1149d5a252e6$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $81ef1149d5a252e6$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$81ef1149d5a252e6$var$copyProps($81ef1149d5a252e6$var$Buffer, $81ef1149d5a252e6$var$SafeBuffer);
$81ef1149d5a252e6$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $81ef1149d5a252e6$var$Buffer(arg, encodingOrOffset, length);
};
$81ef1149d5a252e6$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $81ef1149d5a252e6$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$81ef1149d5a252e6$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $81ef1149d5a252e6$var$Buffer(size);
};
$81ef1149d5a252e6$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8f5i0.SlowBuffer(size);
};

});



parcelRegister("a7ATh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $75e72c8ea9386cf3$var$Transform;

var $9Q6qL = parcelRequire("9Q6qL");

/*<replacement>*/ var $75e72c8ea9386cf3$var$util = Object.create((parcelRequire("9wTlL")));

$75e72c8ea9386cf3$var$util.inherits = (parcelRequire("bVy58"));
/*</replacement>*/ $75e72c8ea9386cf3$var$util.inherits($75e72c8ea9386cf3$var$Transform, $9Q6qL);
function $75e72c8ea9386cf3$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $75e72c8ea9386cf3$var$Transform(options) {
    if (!(this instanceof $75e72c8ea9386cf3$var$Transform)) return new $75e72c8ea9386cf3$var$Transform(options);
    $9Q6qL.call(this, options);
    this._transformState = {
        afterTransform: $75e72c8ea9386cf3$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $75e72c8ea9386cf3$var$prefinish);
}
function $75e72c8ea9386cf3$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $75e72c8ea9386cf3$var$done(_this, er, data);
    });
    else $75e72c8ea9386cf3$var$done(this, null, null);
}
$75e72c8ea9386cf3$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $9Q6qL.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$75e72c8ea9386cf3$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$75e72c8ea9386cf3$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$75e72c8ea9386cf3$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$75e72c8ea9386cf3$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $9Q6qL.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $75e72c8ea9386cf3$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("gzk1W", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $c0ff73cddcd6b0f1$var$PassThrough;

var $a7ATh = parcelRequire("a7ATh");

/*<replacement>*/ var $c0ff73cddcd6b0f1$var$util = Object.create((parcelRequire("9wTlL")));

$c0ff73cddcd6b0f1$var$util.inherits = (parcelRequire("bVy58"));
/*</replacement>*/ $c0ff73cddcd6b0f1$var$util.inherits($c0ff73cddcd6b0f1$var$PassThrough, $a7ATh);
function $c0ff73cddcd6b0f1$var$PassThrough(options) {
    if (!(this instanceof $c0ff73cddcd6b0f1$var$PassThrough)) return new $c0ff73cddcd6b0f1$var$PassThrough(options);
    $a7ATh.call(this, options);
}
$c0ff73cddcd6b0f1$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("eMAzI", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $ac31eb741f07f244$require$Buffer = $BUCDt.Buffer;

var $kJE7u = parcelRequire("kJE7u");

var $afDxt = parcelRequire("afDxt");

var $eSuvC = parcelRequire("eSuvC");
var $ac31eb741f07f244$require$EC = $eSuvC.ec;

var $8YhKY = parcelRequire("8YhKY");

var $jxwsS = parcelRequire("jxwsS");

var $hr1C4 = parcelRequire("hr1C4");
var $ac31eb741f07f244$var$RSA_PKCS1_PADDING = 1;
function $ac31eb741f07f244$var$sign(hash, key, hashType, signType, tag) {
    var priv = $jxwsS(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $ac31eb741f07f244$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $ac31eb741f07f244$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $ac31eb741f07f244$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $ac31eb741f07f244$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $afDxt(pad, priv);
    return out;
}
function $ac31eb741f07f244$var$ecSign(hash, priv) {
    var curveId = $hr1C4[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $ac31eb741f07f244$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $ac31eb741f07f244$require$Buffer.from(out.toDER());
}
function $ac31eb741f07f244$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $8YhKY(0);
    var k;
    var H = $ac31eb741f07f244$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $ac31eb741f07f244$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $ac31eb741f07f244$var$makeKey(q, kv, algo);
        r = $ac31eb741f07f244$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $8YhKY(0);
        }
    }
    return $ac31eb741f07f244$var$toDER(r, s);
}
function $ac31eb741f07f244$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $ac31eb741f07f244$require$Buffer.from(res);
}
function $ac31eb741f07f244$var$getKey(x, q, hash, algo) {
    x = $ac31eb741f07f244$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $ac31eb741f07f244$require$Buffer.alloc(q.byteLength() - x.length);
        x = $ac31eb741f07f244$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $ac31eb741f07f244$var$bits2octets(hash, q);
    var v = $ac31eb741f07f244$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $ac31eb741f07f244$require$Buffer.alloc(hlen);
    k = $kJE7u(algo, k).update(v).update($ac31eb741f07f244$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $kJE7u(algo, k).update(v).digest();
    k = $kJE7u(algo, k).update(v).update($ac31eb741f07f244$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $kJE7u(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $ac31eb741f07f244$var$bits2int(obits, q) {
    var bits = new $8YhKY(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $ac31eb741f07f244$var$bits2octets(bits, q) {
    bits = $ac31eb741f07f244$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $ac31eb741f07f244$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $ac31eb741f07f244$require$Buffer.alloc(q.byteLength() - out.length);
        out = $ac31eb741f07f244$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $ac31eb741f07f244$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $ac31eb741f07f244$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $kJE7u(algo, kv.k).update(kv.v).digest();
            t = $ac31eb741f07f244$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $ac31eb741f07f244$var$bits2int(t, q);
        kv.k = $kJE7u(algo, kv.k).update(kv.v).update($ac31eb741f07f244$require$Buffer.from([
            0
        ])).digest();
        kv.v = $kJE7u(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $ac31eb741f07f244$var$makeR(g, k, p, q) {
    return g.toRed($8YhKY.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $ac31eb741f07f244$var$sign;
module.exports.getKey = $ac31eb741f07f244$var$getKey;
module.exports.makeKey = $ac31eb741f07f244$var$makeKey;

});
parcelRegister("afDxt", function(module, exports) {
'use strict';

var $kyyOw = parcelRequire("kyyOw");

var $9FI1O = parcelRequire("9FI1O");

var $BUCDt = parcelRequire("BUCDt");
var $7769f9b03edee095$require$Buffer = $BUCDt.Buffer;
function $7769f9b03edee095$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $kyyOw($9FI1O(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $7769f9b03edee095$var$blind(priv) {
    var r = $7769f9b03edee095$var$getr(priv);
    var blinder = r.toRed($kyyOw.mont(priv.modulus)).redPow(new $kyyOw(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $7769f9b03edee095$var$crt(msg, priv) {
    var blinds = $7769f9b03edee095$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $kyyOw(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($kyyOw.mont(priv.prime1));
    var c2 = blinded.toRed($kyyOw.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($7769f9b03edee095$require$Buffer, 'be', len);
}
$7769f9b03edee095$var$crt.getr = $7769f9b03edee095$var$getr;
module.exports = $7769f9b03edee095$var$crt;

});
parcelRegister("kyyOw", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("fVZIf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("eSuvC", function(module, exports) {
'use strict';
var $ad4dc64d15960d15$var$elliptic = module.exports;

$ad4dc64d15960d15$var$elliptic.version = (parcelRequire("9YLpg")).version;

$ad4dc64d15960d15$var$elliptic.utils = (parcelRequire("pabd1"));

$ad4dc64d15960d15$var$elliptic.rand = (parcelRequire("iWK6F"));

$ad4dc64d15960d15$var$elliptic.curve = (parcelRequire("eYNEy"));

$ad4dc64d15960d15$var$elliptic.curves = (parcelRequire("7oKSI"));

// Protocols
$ad4dc64d15960d15$var$elliptic.ec = (parcelRequire("lvBqX"));

$ad4dc64d15960d15$var$elliptic.eddsa = (parcelRequire("2gr10"));

});
parcelRegister("9YLpg", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("pabd1", function(module, exports) {
'use strict';
var $04ba3b68a3bb0dd8$var$utils = module.exports;

var $a6Jtu = parcelRequire("a6Jtu");

var $9EwBD = parcelRequire("9EwBD");

var $14Nqj = parcelRequire("14Nqj");
$04ba3b68a3bb0dd8$var$utils.assert = $9EwBD;
$04ba3b68a3bb0dd8$var$utils.toArray = $14Nqj.toArray;
$04ba3b68a3bb0dd8$var$utils.zero2 = $14Nqj.zero2;
$04ba3b68a3bb0dd8$var$utils.toHex = $14Nqj.toHex;
$04ba3b68a3bb0dd8$var$utils.encode = $14Nqj.encode;
// Represent num in a w-NAF form
function $04ba3b68a3bb0dd8$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$04ba3b68a3bb0dd8$var$utils.getNAF = $04ba3b68a3bb0dd8$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $04ba3b68a3bb0dd8$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$04ba3b68a3bb0dd8$var$utils.getJSF = $04ba3b68a3bb0dd8$var$getJSF;
function $04ba3b68a3bb0dd8$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$04ba3b68a3bb0dd8$var$utils.cachedProperty = $04ba3b68a3bb0dd8$var$cachedProperty;
function $04ba3b68a3bb0dd8$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $04ba3b68a3bb0dd8$var$utils.toArray(bytes, 'hex') : bytes;
}
$04ba3b68a3bb0dd8$var$utils.parseBytes = $04ba3b68a3bb0dd8$var$parseBytes;
function $04ba3b68a3bb0dd8$var$intFromLE(bytes) {
    return new $a6Jtu(bytes, 'hex', 'le');
}
$04ba3b68a3bb0dd8$var$utils.intFromLE = $04ba3b68a3bb0dd8$var$intFromLE;

});
parcelRegister("14Nqj", function(module, exports) {
'use strict';
var $0c8c80a558d981ca$var$utils = module.exports;
function $0c8c80a558d981ca$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$0c8c80a558d981ca$var$utils.toArray = $0c8c80a558d981ca$var$toArray;
function $0c8c80a558d981ca$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$0c8c80a558d981ca$var$utils.zero2 = $0c8c80a558d981ca$var$zero2;
function $0c8c80a558d981ca$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $0c8c80a558d981ca$var$zero2(msg[i].toString(16));
    return res;
}
$0c8c80a558d981ca$var$utils.toHex = $0c8c80a558d981ca$var$toHex;
$0c8c80a558d981ca$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $0c8c80a558d981ca$var$toHex(arr);
    else return arr;
};

});


parcelRegister("eYNEy", function(module, exports) {
'use strict';
var $ae7d2f5e5e5ea745$var$curve = module.exports;

$ae7d2f5e5e5ea745$var$curve.base = (parcelRequire("3Vn62"));

$ae7d2f5e5e5ea745$var$curve.short = (parcelRequire("eY9Xt"));

$ae7d2f5e5e5ea745$var$curve.mont = (parcelRequire("93Ndg"));

$ae7d2f5e5e5ea745$var$curve.edwards = (parcelRequire("9NSy8"));

});
parcelRegister("3Vn62", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $pabd1 = parcelRequire("pabd1");
var $2db89c731b35c41e$var$getNAF = $pabd1.getNAF;
var $2db89c731b35c41e$var$getJSF = $pabd1.getJSF;
var $2db89c731b35c41e$var$assert = $pabd1.assert;
function $2db89c731b35c41e$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $a6Jtu(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $a6Jtu.red(conf.prime) : $a6Jtu.mont(this.p);
    // Useful for many curves
    this.zero = new $a6Jtu(0).toRed(this.red);
    this.one = new $a6Jtu(1).toRed(this.red);
    this.two = new $a6Jtu(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $a6Jtu(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2db89c731b35c41e$var$BaseCurve;
$2db89c731b35c41e$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$2db89c731b35c41e$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$2db89c731b35c41e$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2db89c731b35c41e$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2db89c731b35c41e$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2db89c731b35c41e$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2db89c731b35c41e$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2db89c731b35c41e$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$2db89c731b35c41e$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2db89c731b35c41e$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2db89c731b35c41e$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2db89c731b35c41e$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2db89c731b35c41e$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2db89c731b35c41e$var$BaseCurve.BasePoint = $2db89c731b35c41e$var$BasePoint;
$2db89c731b35c41e$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$2db89c731b35c41e$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2db89c731b35c41e$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $pabd1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2db89c731b35c41e$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2db89c731b35c41e$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$2db89c731b35c41e$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2db89c731b35c41e$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$2db89c731b35c41e$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $pabd1.encode(this._encode(compact), enc);
};
$2db89c731b35c41e$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2db89c731b35c41e$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2db89c731b35c41e$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2db89c731b35c41e$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2db89c731b35c41e$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2db89c731b35c41e$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eY9Xt", function(module, exports) {
'use strict';

var $pabd1 = parcelRequire("pabd1");

var $a6Jtu = parcelRequire("a6Jtu");

var $bVy58 = parcelRequire("bVy58");

var $3Vn62 = parcelRequire("3Vn62");
var $ae5e64c7b5dec0d6$var$assert = $pabd1.assert;
function $ae5e64c7b5dec0d6$var$ShortCurve(conf) {
    $3Vn62.call(this, 'short', conf);
    this.a = new $a6Jtu(conf.a, 16).toRed(this.red);
    this.b = new $a6Jtu(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$bVy58($ae5e64c7b5dec0d6$var$ShortCurve, $3Vn62);
module.exports = $ae5e64c7b5dec0d6$var$ShortCurve;
$ae5e64c7b5dec0d6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $a6Jtu(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $a6Jtu(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae5e64c7b5dec0d6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $a6Jtu(vec.a, 16),
            b: new $a6Jtu(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $a6Jtu.mont(num);
    var tinv = new $a6Jtu(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $a6Jtu(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $a6Jtu(1);
    var y1 = new $a6Jtu(0);
    var x2 = new $a6Jtu(0);
    var y2 = new $a6Jtu(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $a6Jtu(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae5e64c7b5dec0d6$var$Point(curve, x, y, isRed) {
    $3Vn62.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $a6Jtu(x, 16);
        this.y = new $a6Jtu(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$bVy58($ae5e64c7b5dec0d6$var$Point, $3Vn62.BasePoint);
$ae5e64c7b5dec0d6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae5e64c7b5dec0d6$var$Point(this, x, y, isRed);
};
$ae5e64c7b5dec0d6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae5e64c7b5dec0d6$var$Point.fromJSON(this, obj, red);
};
$ae5e64c7b5dec0d6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae5e64c7b5dec0d6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae5e64c7b5dec0d6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae5e64c7b5dec0d6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$ae5e64c7b5dec0d6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae5e64c7b5dec0d6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae5e64c7b5dec0d6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae5e64c7b5dec0d6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae5e64c7b5dec0d6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae5e64c7b5dec0d6$var$Point.prototype.mul = function mul(k) {
    k = new $a6Jtu(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae5e64c7b5dec0d6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae5e64c7b5dec0d6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae5e64c7b5dec0d6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae5e64c7b5dec0d6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae5e64c7b5dec0d6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae5e64c7b5dec0d6$var$JPoint(curve, x, y, z) {
    $3Vn62.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $a6Jtu(0);
    } else {
        this.x = new $a6Jtu(x, 16);
        this.y = new $a6Jtu(y, 16);
        this.z = new $a6Jtu(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$bVy58($ae5e64c7b5dec0d6$var$JPoint, $3Vn62.BasePoint);
$ae5e64c7b5dec0d6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae5e64c7b5dec0d6$var$JPoint(this, x, y, z);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae5e64c7b5dec0d6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $a6Jtu(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$ae5e64c7b5dec0d6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("93Ndg", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $bVy58 = parcelRequire("bVy58");

var $3Vn62 = parcelRequire("3Vn62");

var $pabd1 = parcelRequire("pabd1");
function $698a9187a39535ce$var$MontCurve(conf) {
    $3Vn62.call(this, 'mont', conf);
    this.a = new $a6Jtu(conf.a, 16).toRed(this.red);
    this.b = new $a6Jtu(conf.b, 16).toRed(this.red);
    this.i4 = new $a6Jtu(4).toRed(this.red).redInvm();
    this.two = new $a6Jtu(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$bVy58($698a9187a39535ce$var$MontCurve, $3Vn62);
module.exports = $698a9187a39535ce$var$MontCurve;
$698a9187a39535ce$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $698a9187a39535ce$var$Point(curve, x, z) {
    $3Vn62.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $a6Jtu(x, 16);
        this.z = new $a6Jtu(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$bVy58($698a9187a39535ce$var$Point, $3Vn62.BasePoint);
$698a9187a39535ce$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($pabd1.toArray(bytes, enc), 1);
};
$698a9187a39535ce$var$MontCurve.prototype.point = function point(x, z) {
    return new $698a9187a39535ce$var$Point(this, x, z);
};
$698a9187a39535ce$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $698a9187a39535ce$var$Point.fromJSON(this, obj);
};
$698a9187a39535ce$var$Point.prototype.precompute = function precompute() {
// No-op
};
$698a9187a39535ce$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$698a9187a39535ce$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $698a9187a39535ce$var$Point(curve, obj[0], obj[1] || curve.one);
};
$698a9187a39535ce$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$698a9187a39535ce$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$698a9187a39535ce$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$698a9187a39535ce$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$698a9187a39535ce$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$698a9187a39535ce$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$698a9187a39535ce$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$698a9187a39535ce$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$698a9187a39535ce$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$698a9187a39535ce$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$698a9187a39535ce$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("9NSy8", function(module, exports) {
'use strict';

var $pabd1 = parcelRequire("pabd1");

var $a6Jtu = parcelRequire("a6Jtu");

var $bVy58 = parcelRequire("bVy58");

var $3Vn62 = parcelRequire("3Vn62");
var $72330113e63ce98d$var$assert = $pabd1.assert;
function $72330113e63ce98d$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $3Vn62.call(this, 'edwards', conf);
    this.a = new $a6Jtu(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $a6Jtu(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $a6Jtu(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $72330113e63ce98d$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$bVy58($72330113e63ce98d$var$EdwardsCurve, $3Vn62);
module.exports = $72330113e63ce98d$var$EdwardsCurve;
$72330113e63ce98d$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$72330113e63ce98d$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$72330113e63ce98d$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$72330113e63ce98d$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $a6Jtu(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$72330113e63ce98d$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $a6Jtu(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$72330113e63ce98d$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $72330113e63ce98d$var$Point(curve, x, y, z, t) {
    $3Vn62.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $a6Jtu(x, 16);
        this.y = new $a6Jtu(y, 16);
        this.z = z ? new $a6Jtu(z, 16) : this.curve.one;
        this.t = t && new $a6Jtu(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$bVy58($72330113e63ce98d$var$Point, $3Vn62.BasePoint);
$72330113e63ce98d$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $72330113e63ce98d$var$Point.fromJSON(this, obj);
};
$72330113e63ce98d$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $72330113e63ce98d$var$Point(this, x, y, z, t);
};
$72330113e63ce98d$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $72330113e63ce98d$var$Point(curve, obj[0], obj[1], obj[2]);
};
$72330113e63ce98d$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$72330113e63ce98d$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$72330113e63ce98d$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$72330113e63ce98d$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$72330113e63ce98d$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$72330113e63ce98d$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$72330113e63ce98d$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$72330113e63ce98d$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$72330113e63ce98d$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$72330113e63ce98d$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$72330113e63ce98d$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$72330113e63ce98d$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$72330113e63ce98d$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$72330113e63ce98d$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$72330113e63ce98d$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$72330113e63ce98d$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$72330113e63ce98d$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$72330113e63ce98d$var$Point.prototype.toP = $72330113e63ce98d$var$Point.prototype.normalize;
$72330113e63ce98d$var$Point.prototype.mixedAdd = $72330113e63ce98d$var$Point.prototype.add;

});


parcelRegister("7oKSI", function(module, exports) {
'use strict';
var $562f23fdfa6b8e9c$var$curves = module.exports;

var $lcERW = parcelRequire("lcERW");

var $eYNEy = parcelRequire("eYNEy");

var $pabd1 = parcelRequire("pabd1");
var $562f23fdfa6b8e9c$var$assert = $pabd1.assert;
function $562f23fdfa6b8e9c$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $eYNEy.short(options);
    else if (options.type === 'edwards') this.curve = new $eYNEy.edwards(options);
    else this.curve = new $eYNEy.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $562f23fdfa6b8e9c$var$assert(this.g.validate(), 'Invalid curve');
    $562f23fdfa6b8e9c$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$562f23fdfa6b8e9c$var$curves.PresetCurve = $562f23fdfa6b8e9c$var$PresetCurve;
function $562f23fdfa6b8e9c$var$defineCurve(name, options) {
    Object.defineProperty($562f23fdfa6b8e9c$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $562f23fdfa6b8e9c$var$PresetCurve(options);
            Object.defineProperty($562f23fdfa6b8e9c$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$562f23fdfa6b8e9c$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $lcERW.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $lcERW.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $lcERW.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $lcERW.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $lcERW.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $lcERW.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$562f23fdfa6b8e9c$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $lcERW.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $562f23fdfa6b8e9c$var$pre;

try {
    $562f23fdfa6b8e9c$var$pre = (parcelRequire("3nkIq"));
} catch (e) {
    $562f23fdfa6b8e9c$var$pre = undefined;
}
$562f23fdfa6b8e9c$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $lcERW.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $562f23fdfa6b8e9c$var$pre
    ]
});

});
parcelRegister("lcERW", function(module, exports) {
var $f6fa6bad1cb7d443$var$hash = module.exports;

$f6fa6bad1cb7d443$var$hash.utils = (parcelRequire("lx1E5"));

$f6fa6bad1cb7d443$var$hash.common = (parcelRequire("c9G5Q"));

$f6fa6bad1cb7d443$var$hash.sha = (parcelRequire("dvVYa"));

$f6fa6bad1cb7d443$var$hash.ripemd = (parcelRequire("gl26m"));

$f6fa6bad1cb7d443$var$hash.hmac = (parcelRequire("jmrvq"));
// Proxy hash functions to the main object
$f6fa6bad1cb7d443$var$hash.sha1 = $f6fa6bad1cb7d443$var$hash.sha.sha1;
$f6fa6bad1cb7d443$var$hash.sha256 = $f6fa6bad1cb7d443$var$hash.sha.sha256;
$f6fa6bad1cb7d443$var$hash.sha224 = $f6fa6bad1cb7d443$var$hash.sha.sha224;
$f6fa6bad1cb7d443$var$hash.sha384 = $f6fa6bad1cb7d443$var$hash.sha.sha384;
$f6fa6bad1cb7d443$var$hash.sha512 = $f6fa6bad1cb7d443$var$hash.sha.sha512;
$f6fa6bad1cb7d443$var$hash.ripemd160 = $f6fa6bad1cb7d443$var$hash.ripemd.ripemd160;

});
parcelRegister("lx1E5", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $facdf4cbb24a63da$export$69f1b2dcda23c5f8; }, function (v) { return $facdf4cbb24a63da$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $facdf4cbb24a63da$export$45b10814cc054894; }, function (v) { return $facdf4cbb24a63da$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $facdf4cbb24a63da$export$7ea66e3774a60b67; }, function (v) { return $facdf4cbb24a63da$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $facdf4cbb24a63da$export$34a52f00f601f6f1; }, function (v) { return $facdf4cbb24a63da$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $facdf4cbb24a63da$export$812b0cbd5e8a72ab; }, function (v) { return $facdf4cbb24a63da$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $facdf4cbb24a63da$export$f24f9e11d63bb314; }, function (v) { return $facdf4cbb24a63da$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $facdf4cbb24a63da$export$b71357c7e07ca1f1; }, function (v) { return $facdf4cbb24a63da$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $facdf4cbb24a63da$export$2e58a4b541fdcbe8; }, function (v) { return $facdf4cbb24a63da$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $facdf4cbb24a63da$export$183b950bde9faab8; }, function (v) { return $facdf4cbb24a63da$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $facdf4cbb24a63da$export$4785c77169fea59e; }, function (v) { return $facdf4cbb24a63da$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $facdf4cbb24a63da$export$242a185dfcffac5b; }, function (v) { return $facdf4cbb24a63da$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $facdf4cbb24a63da$export$58c04ae0ae31877d; }, function (v) { return $facdf4cbb24a63da$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $facdf4cbb24a63da$export$d058ca695f8c6f11; }, function (v) { return $facdf4cbb24a63da$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $facdf4cbb24a63da$export$a1efd7fc3e986367; }, function (v) { return $facdf4cbb24a63da$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $facdf4cbb24a63da$export$bbfea4a2b5abaab4; }, function (v) { return $facdf4cbb24a63da$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $facdf4cbb24a63da$export$97ad4afc7de86152; }, function (v) { return $facdf4cbb24a63da$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $facdf4cbb24a63da$export$ce4673d9a79f6a4b; }, function (v) { return $facdf4cbb24a63da$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $facdf4cbb24a63da$export$786cc99fc6eedc0b; }, function (v) { return $facdf4cbb24a63da$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $facdf4cbb24a63da$export$45c59b9a1848dd0; }, function (v) { return $facdf4cbb24a63da$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $facdf4cbb24a63da$export$50d8f613e76d3034; }, function (v) { return $facdf4cbb24a63da$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $facdf4cbb24a63da$export$b8e83683c60ee162; }, function (v) { return $facdf4cbb24a63da$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $facdf4cbb24a63da$export$aeeb51790d1bcc4a; }, function (v) { return $facdf4cbb24a63da$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $facdf4cbb24a63da$export$bb7c616f719ad9c; }, function (v) { return $facdf4cbb24a63da$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $facdf4cbb24a63da$export$4d63290824f9d7df; }, function (v) { return $facdf4cbb24a63da$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $facdf4cbb24a63da$export$2f64ceb90ef28ea1; }, function (v) { return $facdf4cbb24a63da$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $facdf4cbb24a63da$export$8d2089d465f6d10d; }, function (v) { return $facdf4cbb24a63da$export$8d2089d465f6d10d = v; });
var $facdf4cbb24a63da$export$69f1b2dcda23c5f8;
var $facdf4cbb24a63da$export$45b10814cc054894;
var $facdf4cbb24a63da$export$7ea66e3774a60b67;
var $facdf4cbb24a63da$export$34a52f00f601f6f1;
var $facdf4cbb24a63da$export$812b0cbd5e8a72ab;
var $facdf4cbb24a63da$export$f24f9e11d63bb314;
var $facdf4cbb24a63da$export$b71357c7e07ca1f1;
var $facdf4cbb24a63da$export$2e58a4b541fdcbe8;
var $facdf4cbb24a63da$export$183b950bde9faab8;
var $facdf4cbb24a63da$export$4785c77169fea59e;
var $facdf4cbb24a63da$export$242a185dfcffac5b;
var $facdf4cbb24a63da$export$58c04ae0ae31877d;
var $facdf4cbb24a63da$export$d058ca695f8c6f11;
var $facdf4cbb24a63da$export$a1efd7fc3e986367;
var $facdf4cbb24a63da$export$bbfea4a2b5abaab4;
var $facdf4cbb24a63da$export$97ad4afc7de86152;
var $facdf4cbb24a63da$export$ce4673d9a79f6a4b;
var $facdf4cbb24a63da$export$786cc99fc6eedc0b;
var $facdf4cbb24a63da$export$45c59b9a1848dd0;
var $facdf4cbb24a63da$export$50d8f613e76d3034;
var $facdf4cbb24a63da$export$b8e83683c60ee162;
var $facdf4cbb24a63da$export$aeeb51790d1bcc4a;
var $facdf4cbb24a63da$export$bb7c616f719ad9c;
var $facdf4cbb24a63da$export$4d63290824f9d7df;
var $facdf4cbb24a63da$export$2f64ceb90ef28ea1;
var $facdf4cbb24a63da$export$8d2089d465f6d10d;
'use strict';

var $9EwBD = parcelRequire("9EwBD");

var $bVy58 = parcelRequire("bVy58");
$facdf4cbb24a63da$export$69f1b2dcda23c5f8 = $bVy58;
function $facdf4cbb24a63da$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $facdf4cbb24a63da$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($facdf4cbb24a63da$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$facdf4cbb24a63da$export$45b10814cc054894 = $facdf4cbb24a63da$var$toArray;
function $facdf4cbb24a63da$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $facdf4cbb24a63da$var$zero2(msg[i].toString(16));
    return res;
}
$facdf4cbb24a63da$export$7ea66e3774a60b67 = $facdf4cbb24a63da$var$toHex;
function $facdf4cbb24a63da$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$facdf4cbb24a63da$export$34a52f00f601f6f1 = $facdf4cbb24a63da$var$htonl;
function $facdf4cbb24a63da$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $facdf4cbb24a63da$var$htonl(w);
        res += $facdf4cbb24a63da$var$zero8(w.toString(16));
    }
    return res;
}
$facdf4cbb24a63da$export$812b0cbd5e8a72ab = $facdf4cbb24a63da$var$toHex32;
function $facdf4cbb24a63da$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$facdf4cbb24a63da$export$f24f9e11d63bb314 = $facdf4cbb24a63da$var$zero2;
function $facdf4cbb24a63da$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$facdf4cbb24a63da$export$b71357c7e07ca1f1 = $facdf4cbb24a63da$var$zero8;
function $facdf4cbb24a63da$var$join32(msg, start, end, endian) {
    var len = end - start;
    $9EwBD(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$facdf4cbb24a63da$export$2e58a4b541fdcbe8 = $facdf4cbb24a63da$var$join32;
function $facdf4cbb24a63da$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$facdf4cbb24a63da$export$183b950bde9faab8 = $facdf4cbb24a63da$var$split32;
function $facdf4cbb24a63da$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$facdf4cbb24a63da$export$4785c77169fea59e = $facdf4cbb24a63da$var$rotr32;
function $facdf4cbb24a63da$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$facdf4cbb24a63da$export$242a185dfcffac5b = $facdf4cbb24a63da$var$rotl32;
function $facdf4cbb24a63da$var$sum32(a, b) {
    return a + b >>> 0;
}
$facdf4cbb24a63da$export$58c04ae0ae31877d = $facdf4cbb24a63da$var$sum32;
function $facdf4cbb24a63da$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$facdf4cbb24a63da$export$d058ca695f8c6f11 = $facdf4cbb24a63da$var$sum32_3;
function $facdf4cbb24a63da$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$facdf4cbb24a63da$export$a1efd7fc3e986367 = $facdf4cbb24a63da$var$sum32_4;
function $facdf4cbb24a63da$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$facdf4cbb24a63da$export$bbfea4a2b5abaab4 = $facdf4cbb24a63da$var$sum32_5;
function $facdf4cbb24a63da$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$facdf4cbb24a63da$export$97ad4afc7de86152 = $facdf4cbb24a63da$var$sum64;
function $facdf4cbb24a63da$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$facdf4cbb24a63da$export$ce4673d9a79f6a4b = $facdf4cbb24a63da$var$sum64_hi;
function $facdf4cbb24a63da$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$facdf4cbb24a63da$export$786cc99fc6eedc0b = $facdf4cbb24a63da$var$sum64_lo;
function $facdf4cbb24a63da$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$facdf4cbb24a63da$export$45c59b9a1848dd0 = $facdf4cbb24a63da$var$sum64_4_hi;
function $facdf4cbb24a63da$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$facdf4cbb24a63da$export$50d8f613e76d3034 = $facdf4cbb24a63da$var$sum64_4_lo;
function $facdf4cbb24a63da$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$facdf4cbb24a63da$export$b8e83683c60ee162 = $facdf4cbb24a63da$var$sum64_5_hi;
function $facdf4cbb24a63da$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$facdf4cbb24a63da$export$aeeb51790d1bcc4a = $facdf4cbb24a63da$var$sum64_5_lo;
function $facdf4cbb24a63da$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$facdf4cbb24a63da$export$bb7c616f719ad9c = $facdf4cbb24a63da$var$rotr64_hi;
function $facdf4cbb24a63da$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$facdf4cbb24a63da$export$4d63290824f9d7df = $facdf4cbb24a63da$var$rotr64_lo;
function $facdf4cbb24a63da$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$facdf4cbb24a63da$export$2f64ceb90ef28ea1 = $facdf4cbb24a63da$var$shr64_hi;
function $facdf4cbb24a63da$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$facdf4cbb24a63da$export$8d2089d465f6d10d = $facdf4cbb24a63da$var$shr64_lo;

});

parcelRegister("c9G5Q", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $8d96fa21387aa23b$export$8687658379b577e6; }, function (v) { return $8d96fa21387aa23b$export$8687658379b577e6 = v; });
var $8d96fa21387aa23b$export$8687658379b577e6;
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $9EwBD = parcelRequire("9EwBD");
function $8d96fa21387aa23b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$8d96fa21387aa23b$export$8687658379b577e6 = $8d96fa21387aa23b$var$BlockHash;
$8d96fa21387aa23b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $lx1E5.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $lx1E5.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$8d96fa21387aa23b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $9EwBD(this.pending === null);
    return this._digest(enc);
};
$8d96fa21387aa23b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("dvVYa", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $9d6b231ec9fd3176$export$5091bdda49ba90f5; }, function (v) { return $9d6b231ec9fd3176$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $9d6b231ec9fd3176$export$97b70509d4e397ea; }, function (v) { return $9d6b231ec9fd3176$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $9d6b231ec9fd3176$export$bced8d2aada2d1c9; }, function (v) { return $9d6b231ec9fd3176$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $9d6b231ec9fd3176$export$612d47d55dedde45; }, function (v) { return $9d6b231ec9fd3176$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $9d6b231ec9fd3176$export$a888d2532e6dc7bb; }, function (v) { return $9d6b231ec9fd3176$export$a888d2532e6dc7bb = v; });
var $9d6b231ec9fd3176$export$5091bdda49ba90f5;
var $9d6b231ec9fd3176$export$97b70509d4e397ea;
var $9d6b231ec9fd3176$export$bced8d2aada2d1c9;
var $9d6b231ec9fd3176$export$612d47d55dedde45;
var $9d6b231ec9fd3176$export$a888d2532e6dc7bb;
'use strict';

$9d6b231ec9fd3176$export$5091bdda49ba90f5 = (parcelRequire("kUK8p"));

$9d6b231ec9fd3176$export$97b70509d4e397ea = (parcelRequire("7Jmkt"));

$9d6b231ec9fd3176$export$bced8d2aada2d1c9 = (parcelRequire("jfV9r"));

$9d6b231ec9fd3176$export$612d47d55dedde45 = (parcelRequire("lmlye"));

$9d6b231ec9fd3176$export$a888d2532e6dc7bb = (parcelRequire("9s14M"));

});
parcelRegister("kUK8p", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $c9G5Q = parcelRequire("c9G5Q");

var $hPUQF = parcelRequire("hPUQF");
var $f39cd2f68abcf19d$var$rotl32 = $lx1E5.rotl32;
var $f39cd2f68abcf19d$var$sum32 = $lx1E5.sum32;
var $f39cd2f68abcf19d$var$sum32_5 = $lx1E5.sum32_5;
var $f39cd2f68abcf19d$var$ft_1 = $hPUQF.ft_1;
var $f39cd2f68abcf19d$var$BlockHash = $c9G5Q.BlockHash;
var $f39cd2f68abcf19d$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $f39cd2f68abcf19d$var$SHA1() {
    if (!(this instanceof $f39cd2f68abcf19d$var$SHA1)) return new $f39cd2f68abcf19d$var$SHA1();
    $f39cd2f68abcf19d$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$lx1E5.inherits($f39cd2f68abcf19d$var$SHA1, $f39cd2f68abcf19d$var$BlockHash);
module.exports = $f39cd2f68abcf19d$var$SHA1;
$f39cd2f68abcf19d$var$SHA1.blockSize = 512;
$f39cd2f68abcf19d$var$SHA1.outSize = 160;
$f39cd2f68abcf19d$var$SHA1.hmacStrength = 80;
$f39cd2f68abcf19d$var$SHA1.padLength = 64;
$f39cd2f68abcf19d$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $f39cd2f68abcf19d$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $f39cd2f68abcf19d$var$sum32_5($f39cd2f68abcf19d$var$rotl32(a, 5), $f39cd2f68abcf19d$var$ft_1(s, b, c, d), e, W[i], $f39cd2f68abcf19d$var$sha1_K[s]);
        e = d;
        d = c;
        c = $f39cd2f68abcf19d$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $f39cd2f68abcf19d$var$sum32(this.h[0], a);
    this.h[1] = $f39cd2f68abcf19d$var$sum32(this.h[1], b);
    this.h[2] = $f39cd2f68abcf19d$var$sum32(this.h[2], c);
    this.h[3] = $f39cd2f68abcf19d$var$sum32(this.h[3], d);
    this.h[4] = $f39cd2f68abcf19d$var$sum32(this.h[4], e);
};
$f39cd2f68abcf19d$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lx1E5.toHex32(this.h, 'big');
    else return $lx1E5.split32(this.h, 'big');
};

});
parcelRegister("hPUQF", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $cfc34c07ab97f3ba$export$5a92649d7ddb9f63; }, function (v) { return $cfc34c07ab97f3ba$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $cfc34c07ab97f3ba$export$c6d0d020c3a6269; }, function (v) { return $cfc34c07ab97f3ba$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $cfc34c07ab97f3ba$export$eb90c27fca05f956; }, function (v) { return $cfc34c07ab97f3ba$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $cfc34c07ab97f3ba$export$14a4a98e063b1999; }, function (v) { return $cfc34c07ab97f3ba$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $cfc34c07ab97f3ba$export$d20cecfa1564c686; }, function (v) { return $cfc34c07ab97f3ba$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $cfc34c07ab97f3ba$export$44fd472a12fc6db; }, function (v) { return $cfc34c07ab97f3ba$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $cfc34c07ab97f3ba$export$1ed238bb6ea1dd47; }, function (v) { return $cfc34c07ab97f3ba$export$1ed238bb6ea1dd47 = v; });
var $cfc34c07ab97f3ba$export$5a92649d7ddb9f63;
var $cfc34c07ab97f3ba$export$c6d0d020c3a6269;
var $cfc34c07ab97f3ba$export$eb90c27fca05f956;
var $cfc34c07ab97f3ba$export$cc992891a14496a1;
var $cfc34c07ab97f3ba$export$14a4a98e063b1999;
var $cfc34c07ab97f3ba$export$d20cecfa1564c686;
var $cfc34c07ab97f3ba$export$44fd472a12fc6db;
var $cfc34c07ab97f3ba$export$1ed238bb6ea1dd47;
'use strict';

var $lx1E5 = parcelRequire("lx1E5");
var $cfc34c07ab97f3ba$var$rotr32 = $lx1E5.rotr32;
function $cfc34c07ab97f3ba$var$ft_1(s, x, y, z) {
    if (s === 0) return $cfc34c07ab97f3ba$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $cfc34c07ab97f3ba$var$p32(x, y, z);
    if (s === 2) return $cfc34c07ab97f3ba$var$maj32(x, y, z);
}
$cfc34c07ab97f3ba$export$5a92649d7ddb9f63 = $cfc34c07ab97f3ba$var$ft_1;
function $cfc34c07ab97f3ba$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$cfc34c07ab97f3ba$export$c6d0d020c3a6269 = $cfc34c07ab97f3ba$var$ch32;
function $cfc34c07ab97f3ba$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$cfc34c07ab97f3ba$export$eb90c27fca05f956 = $cfc34c07ab97f3ba$var$maj32;
function $cfc34c07ab97f3ba$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$cfc34c07ab97f3ba$export$cc992891a14496a1 = $cfc34c07ab97f3ba$var$p32;
function $cfc34c07ab97f3ba$var$s0_256(x) {
    return $cfc34c07ab97f3ba$var$rotr32(x, 2) ^ $cfc34c07ab97f3ba$var$rotr32(x, 13) ^ $cfc34c07ab97f3ba$var$rotr32(x, 22);
}
$cfc34c07ab97f3ba$export$14a4a98e063b1999 = $cfc34c07ab97f3ba$var$s0_256;
function $cfc34c07ab97f3ba$var$s1_256(x) {
    return $cfc34c07ab97f3ba$var$rotr32(x, 6) ^ $cfc34c07ab97f3ba$var$rotr32(x, 11) ^ $cfc34c07ab97f3ba$var$rotr32(x, 25);
}
$cfc34c07ab97f3ba$export$d20cecfa1564c686 = $cfc34c07ab97f3ba$var$s1_256;
function $cfc34c07ab97f3ba$var$g0_256(x) {
    return $cfc34c07ab97f3ba$var$rotr32(x, 7) ^ $cfc34c07ab97f3ba$var$rotr32(x, 18) ^ x >>> 3;
}
$cfc34c07ab97f3ba$export$44fd472a12fc6db = $cfc34c07ab97f3ba$var$g0_256;
function $cfc34c07ab97f3ba$var$g1_256(x) {
    return $cfc34c07ab97f3ba$var$rotr32(x, 17) ^ $cfc34c07ab97f3ba$var$rotr32(x, 19) ^ x >>> 10;
}
$cfc34c07ab97f3ba$export$1ed238bb6ea1dd47 = $cfc34c07ab97f3ba$var$g1_256;

});


parcelRegister("7Jmkt", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $jfV9r = parcelRequire("jfV9r");
function $5a0e0e79e03f6a46$var$SHA224() {
    if (!(this instanceof $5a0e0e79e03f6a46$var$SHA224)) return new $5a0e0e79e03f6a46$var$SHA224();
    $jfV9r.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$lx1E5.inherits($5a0e0e79e03f6a46$var$SHA224, $jfV9r);
module.exports = $5a0e0e79e03f6a46$var$SHA224;
$5a0e0e79e03f6a46$var$SHA224.blockSize = 512;
$5a0e0e79e03f6a46$var$SHA224.outSize = 224;
$5a0e0e79e03f6a46$var$SHA224.hmacStrength = 192;
$5a0e0e79e03f6a46$var$SHA224.padLength = 64;
$5a0e0e79e03f6a46$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $lx1E5.toHex32(this.h.slice(0, 7), 'big');
    else return $lx1E5.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("jfV9r", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $c9G5Q = parcelRequire("c9G5Q");

var $hPUQF = parcelRequire("hPUQF");

var $9EwBD = parcelRequire("9EwBD");
var $e04bc01bfe7e47da$var$sum32 = $lx1E5.sum32;
var $e04bc01bfe7e47da$var$sum32_4 = $lx1E5.sum32_4;
var $e04bc01bfe7e47da$var$sum32_5 = $lx1E5.sum32_5;
var $e04bc01bfe7e47da$var$ch32 = $hPUQF.ch32;
var $e04bc01bfe7e47da$var$maj32 = $hPUQF.maj32;
var $e04bc01bfe7e47da$var$s0_256 = $hPUQF.s0_256;
var $e04bc01bfe7e47da$var$s1_256 = $hPUQF.s1_256;
var $e04bc01bfe7e47da$var$g0_256 = $hPUQF.g0_256;
var $e04bc01bfe7e47da$var$g1_256 = $hPUQF.g1_256;
var $e04bc01bfe7e47da$var$BlockHash = $c9G5Q.BlockHash;
var $e04bc01bfe7e47da$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $e04bc01bfe7e47da$var$SHA256() {
    if (!(this instanceof $e04bc01bfe7e47da$var$SHA256)) return new $e04bc01bfe7e47da$var$SHA256();
    $e04bc01bfe7e47da$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $e04bc01bfe7e47da$var$sha256_K;
    this.W = new Array(64);
}
$lx1E5.inherits($e04bc01bfe7e47da$var$SHA256, $e04bc01bfe7e47da$var$BlockHash);
module.exports = $e04bc01bfe7e47da$var$SHA256;
$e04bc01bfe7e47da$var$SHA256.blockSize = 512;
$e04bc01bfe7e47da$var$SHA256.outSize = 256;
$e04bc01bfe7e47da$var$SHA256.hmacStrength = 192;
$e04bc01bfe7e47da$var$SHA256.padLength = 64;
$e04bc01bfe7e47da$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $e04bc01bfe7e47da$var$sum32_4($e04bc01bfe7e47da$var$g1_256(W[i - 2]), W[i - 7], $e04bc01bfe7e47da$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $9EwBD(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $e04bc01bfe7e47da$var$sum32_5(h, $e04bc01bfe7e47da$var$s1_256(e), $e04bc01bfe7e47da$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $e04bc01bfe7e47da$var$sum32($e04bc01bfe7e47da$var$s0_256(a), $e04bc01bfe7e47da$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $e04bc01bfe7e47da$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $e04bc01bfe7e47da$var$sum32(T1, T2);
    }
    this.h[0] = $e04bc01bfe7e47da$var$sum32(this.h[0], a);
    this.h[1] = $e04bc01bfe7e47da$var$sum32(this.h[1], b);
    this.h[2] = $e04bc01bfe7e47da$var$sum32(this.h[2], c);
    this.h[3] = $e04bc01bfe7e47da$var$sum32(this.h[3], d);
    this.h[4] = $e04bc01bfe7e47da$var$sum32(this.h[4], e);
    this.h[5] = $e04bc01bfe7e47da$var$sum32(this.h[5], f);
    this.h[6] = $e04bc01bfe7e47da$var$sum32(this.h[6], g);
    this.h[7] = $e04bc01bfe7e47da$var$sum32(this.h[7], h);
};
$e04bc01bfe7e47da$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lx1E5.toHex32(this.h, 'big');
    else return $lx1E5.split32(this.h, 'big');
};

});


parcelRegister("lmlye", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $9s14M = parcelRequire("9s14M");
function $f8cc5eaa36dca18f$var$SHA384() {
    if (!(this instanceof $f8cc5eaa36dca18f$var$SHA384)) return new $f8cc5eaa36dca18f$var$SHA384();
    $9s14M.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$lx1E5.inherits($f8cc5eaa36dca18f$var$SHA384, $9s14M);
module.exports = $f8cc5eaa36dca18f$var$SHA384;
$f8cc5eaa36dca18f$var$SHA384.blockSize = 1024;
$f8cc5eaa36dca18f$var$SHA384.outSize = 384;
$f8cc5eaa36dca18f$var$SHA384.hmacStrength = 192;
$f8cc5eaa36dca18f$var$SHA384.padLength = 128;
$f8cc5eaa36dca18f$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lx1E5.toHex32(this.h.slice(0, 12), 'big');
    else return $lx1E5.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("9s14M", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $c9G5Q = parcelRequire("c9G5Q");

var $9EwBD = parcelRequire("9EwBD");
var $6e179041cbf8ec02$var$rotr64_hi = $lx1E5.rotr64_hi;
var $6e179041cbf8ec02$var$rotr64_lo = $lx1E5.rotr64_lo;
var $6e179041cbf8ec02$var$shr64_hi = $lx1E5.shr64_hi;
var $6e179041cbf8ec02$var$shr64_lo = $lx1E5.shr64_lo;
var $6e179041cbf8ec02$var$sum64 = $lx1E5.sum64;
var $6e179041cbf8ec02$var$sum64_hi = $lx1E5.sum64_hi;
var $6e179041cbf8ec02$var$sum64_lo = $lx1E5.sum64_lo;
var $6e179041cbf8ec02$var$sum64_4_hi = $lx1E5.sum64_4_hi;
var $6e179041cbf8ec02$var$sum64_4_lo = $lx1E5.sum64_4_lo;
var $6e179041cbf8ec02$var$sum64_5_hi = $lx1E5.sum64_5_hi;
var $6e179041cbf8ec02$var$sum64_5_lo = $lx1E5.sum64_5_lo;
var $6e179041cbf8ec02$var$BlockHash = $c9G5Q.BlockHash;
var $6e179041cbf8ec02$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $6e179041cbf8ec02$var$SHA512() {
    if (!(this instanceof $6e179041cbf8ec02$var$SHA512)) return new $6e179041cbf8ec02$var$SHA512();
    $6e179041cbf8ec02$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $6e179041cbf8ec02$var$sha512_K;
    this.W = new Array(160);
}
$lx1E5.inherits($6e179041cbf8ec02$var$SHA512, $6e179041cbf8ec02$var$BlockHash);
module.exports = $6e179041cbf8ec02$var$SHA512;
$6e179041cbf8ec02$var$SHA512.blockSize = 1024;
$6e179041cbf8ec02$var$SHA512.outSize = 512;
$6e179041cbf8ec02$var$SHA512.hmacStrength = 192;
$6e179041cbf8ec02$var$SHA512.padLength = 128;
$6e179041cbf8ec02$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $6e179041cbf8ec02$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $6e179041cbf8ec02$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $6e179041cbf8ec02$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $6e179041cbf8ec02$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $6e179041cbf8ec02$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $6e179041cbf8ec02$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$6e179041cbf8ec02$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $9EwBD(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $6e179041cbf8ec02$var$s1_512_hi(eh, el);
        var c1_lo = $6e179041cbf8ec02$var$s1_512_lo(eh, el);
        var c2_hi = $6e179041cbf8ec02$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $6e179041cbf8ec02$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $6e179041cbf8ec02$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $6e179041cbf8ec02$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $6e179041cbf8ec02$var$s0_512_hi(ah, al);
        c0_lo = $6e179041cbf8ec02$var$s0_512_lo(ah, al);
        c1_hi = $6e179041cbf8ec02$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $6e179041cbf8ec02$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $6e179041cbf8ec02$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $6e179041cbf8ec02$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $6e179041cbf8ec02$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $6e179041cbf8ec02$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $6e179041cbf8ec02$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $6e179041cbf8ec02$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $6e179041cbf8ec02$var$sum64(this.h, 0, ah, al);
    $6e179041cbf8ec02$var$sum64(this.h, 2, bh, bl);
    $6e179041cbf8ec02$var$sum64(this.h, 4, ch, cl);
    $6e179041cbf8ec02$var$sum64(this.h, 6, dh, dl);
    $6e179041cbf8ec02$var$sum64(this.h, 8, eh, el);
    $6e179041cbf8ec02$var$sum64(this.h, 10, fh, fl);
    $6e179041cbf8ec02$var$sum64(this.h, 12, gh, gl);
    $6e179041cbf8ec02$var$sum64(this.h, 14, hh, hl);
};
$6e179041cbf8ec02$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lx1E5.toHex32(this.h, 'big');
    else return $lx1E5.split32(this.h, 'big');
};
function $6e179041cbf8ec02$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$s0_512_hi(xh, xl) {
    var c0_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $6e179041cbf8ec02$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $6e179041cbf8ec02$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$s0_512_lo(xh, xl) {
    var c0_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $6e179041cbf8ec02$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $6e179041cbf8ec02$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$s1_512_hi(xh, xl) {
    var c0_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $6e179041cbf8ec02$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$s1_512_lo(xh, xl) {
    var c0_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $6e179041cbf8ec02$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$g0_512_hi(xh, xl) {
    var c0_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $6e179041cbf8ec02$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$g0_512_lo(xh, xl) {
    var c0_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $6e179041cbf8ec02$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$g1_512_hi(xh, xl) {
    var c0_hi = $6e179041cbf8ec02$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $6e179041cbf8ec02$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $6e179041cbf8ec02$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6e179041cbf8ec02$var$g1_512_lo(xh, xl) {
    var c0_lo = $6e179041cbf8ec02$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $6e179041cbf8ec02$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $6e179041cbf8ec02$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("gl26m", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $be503cdbf373a9c6$export$d1cea0ee4e3f0d3e; }, function (v) { return $be503cdbf373a9c6$export$d1cea0ee4e3f0d3e = v; });
var $be503cdbf373a9c6$export$d1cea0ee4e3f0d3e;
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $c9G5Q = parcelRequire("c9G5Q");
var $be503cdbf373a9c6$var$rotl32 = $lx1E5.rotl32;
var $be503cdbf373a9c6$var$sum32 = $lx1E5.sum32;
var $be503cdbf373a9c6$var$sum32_3 = $lx1E5.sum32_3;
var $be503cdbf373a9c6$var$sum32_4 = $lx1E5.sum32_4;
var $be503cdbf373a9c6$var$BlockHash = $c9G5Q.BlockHash;
function $be503cdbf373a9c6$var$RIPEMD160() {
    if (!(this instanceof $be503cdbf373a9c6$var$RIPEMD160)) return new $be503cdbf373a9c6$var$RIPEMD160();
    $be503cdbf373a9c6$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$lx1E5.inherits($be503cdbf373a9c6$var$RIPEMD160, $be503cdbf373a9c6$var$BlockHash);
$be503cdbf373a9c6$export$d1cea0ee4e3f0d3e = $be503cdbf373a9c6$var$RIPEMD160;
$be503cdbf373a9c6$var$RIPEMD160.blockSize = 512;
$be503cdbf373a9c6$var$RIPEMD160.outSize = 160;
$be503cdbf373a9c6$var$RIPEMD160.hmacStrength = 192;
$be503cdbf373a9c6$var$RIPEMD160.padLength = 64;
$be503cdbf373a9c6$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $be503cdbf373a9c6$var$sum32($be503cdbf373a9c6$var$rotl32($be503cdbf373a9c6$var$sum32_4(A, $be503cdbf373a9c6$var$f(j, B, C, D), msg[$be503cdbf373a9c6$var$r[j] + start], $be503cdbf373a9c6$var$K(j)), $be503cdbf373a9c6$var$s[j]), E);
        A = E;
        E = D;
        D = $be503cdbf373a9c6$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $be503cdbf373a9c6$var$sum32($be503cdbf373a9c6$var$rotl32($be503cdbf373a9c6$var$sum32_4(Ah, $be503cdbf373a9c6$var$f(79 - j, Bh, Ch, Dh), msg[$be503cdbf373a9c6$var$rh[j] + start], $be503cdbf373a9c6$var$Kh(j)), $be503cdbf373a9c6$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $be503cdbf373a9c6$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $be503cdbf373a9c6$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $be503cdbf373a9c6$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $be503cdbf373a9c6$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $be503cdbf373a9c6$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $be503cdbf373a9c6$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$be503cdbf373a9c6$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $lx1E5.toHex32(this.h, 'little');
    else return $lx1E5.split32(this.h, 'little');
};
function $be503cdbf373a9c6$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $be503cdbf373a9c6$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $be503cdbf373a9c6$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $be503cdbf373a9c6$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $be503cdbf373a9c6$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $be503cdbf373a9c6$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $be503cdbf373a9c6$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("jmrvq", function(module, exports) {
'use strict';

var $lx1E5 = parcelRequire("lx1E5");

var $9EwBD = parcelRequire("9EwBD");
function $e185687e1799a6e9$var$Hmac(hash, key, enc) {
    if (!(this instanceof $e185687e1799a6e9$var$Hmac)) return new $e185687e1799a6e9$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($lx1E5.toArray(key, enc));
}
module.exports = $e185687e1799a6e9$var$Hmac;
$e185687e1799a6e9$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $9EwBD(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$e185687e1799a6e9$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$e185687e1799a6e9$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("3nkIq", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("lvBqX", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $gBHjH = parcelRequire("gBHjH");

var $pabd1 = parcelRequire("pabd1");

var $7oKSI = parcelRequire("7oKSI");

var $iWK6F = parcelRequire("iWK6F");
var $fa8987cb9fdcc002$var$assert = $pabd1.assert;

var $95lhu = parcelRequire("95lhu");

var $9urqU = parcelRequire("9urqU");
function $fa8987cb9fdcc002$var$EC(options) {
    if (!(this instanceof $fa8987cb9fdcc002$var$EC)) return new $fa8987cb9fdcc002$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $fa8987cb9fdcc002$var$assert(Object.prototype.hasOwnProperty.call($7oKSI, options), 'Unknown curve ' + options);
        options = $7oKSI[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $7oKSI.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $fa8987cb9fdcc002$var$EC;
$fa8987cb9fdcc002$var$EC.prototype.keyPair = function keyPair(options) {
    return new $95lhu(this, options);
};
$fa8987cb9fdcc002$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $95lhu.fromPrivate(this, priv, enc);
};
$fa8987cb9fdcc002$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $95lhu.fromPublic(this, pub, enc);
};
$fa8987cb9fdcc002$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $gBHjH({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $iWK6F(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $a6Jtu(2));
    for(;;){
        var priv = new $a6Jtu(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$fa8987cb9fdcc002$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($a6Jtu.isBN(msg) || typeof msg === 'number') {
        msg = new $a6Jtu(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $a6Jtu(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $a6Jtu(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$fa8987cb9fdcc002$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$a6Jtu.isBN(msg)) {
        $fa8987cb9fdcc002$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $fa8987cb9fdcc002$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$fa8987cb9fdcc002$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $fa8987cb9fdcc002$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $fa8987cb9fdcc002$var$assert(new $a6Jtu(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $gBHjH({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $a6Jtu(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $a6Jtu(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $9urqU({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$fa8987cb9fdcc002$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $9urqU(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$fa8987cb9fdcc002$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $fa8987cb9fdcc002$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $9urqU(signature, enc);
    var n = this.n;
    var e = new $a6Jtu(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$fa8987cb9fdcc002$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $9urqU(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("gBHjH", function(module, exports) {
'use strict';

var $lcERW = parcelRequire("lcERW");

var $14Nqj = parcelRequire("14Nqj");

var $9EwBD = parcelRequire("9EwBD");
function $c171b3d869893327$var$HmacDRBG(options) {
    if (!(this instanceof $c171b3d869893327$var$HmacDRBG)) return new $c171b3d869893327$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $14Nqj.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $14Nqj.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $14Nqj.toArray(options.pers, options.persEnc || 'hex');
    $9EwBD(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $c171b3d869893327$var$HmacDRBG;
$c171b3d869893327$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$c171b3d869893327$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $lcERW.hmac(this.hash, this.K);
};
$c171b3d869893327$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$c171b3d869893327$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $14Nqj.toArray(entropy, entropyEnc);
    add = $14Nqj.toArray(add, addEnc);
    $9EwBD(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$c171b3d869893327$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $14Nqj.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $14Nqj.encode(res, enc);
};

});

parcelRegister("95lhu", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $pabd1 = parcelRequire("pabd1");
var $69d516a5d3ffb6f2$var$assert = $pabd1.assert;
function $69d516a5d3ffb6f2$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $69d516a5d3ffb6f2$var$KeyPair;
$69d516a5d3ffb6f2$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $69d516a5d3ffb6f2$var$KeyPair) return pub;
    return new $69d516a5d3ffb6f2$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$69d516a5d3ffb6f2$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $69d516a5d3ffb6f2$var$KeyPair) return priv;
    return new $69d516a5d3ffb6f2$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$69d516a5d3ffb6f2$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$69d516a5d3ffb6f2$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$69d516a5d3ffb6f2$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$69d516a5d3ffb6f2$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $a6Jtu(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$69d516a5d3ffb6f2$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $69d516a5d3ffb6f2$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $69d516a5d3ffb6f2$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$69d516a5d3ffb6f2$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $69d516a5d3ffb6f2$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$69d516a5d3ffb6f2$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$69d516a5d3ffb6f2$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$69d516a5d3ffb6f2$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("9urqU", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $pabd1 = parcelRequire("pabd1");
var $6e8c3201ef611dc6$var$assert = $pabd1.assert;
function $6e8c3201ef611dc6$var$Signature(options, enc) {
    if (options instanceof $6e8c3201ef611dc6$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $6e8c3201ef611dc6$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $a6Jtu(options.r, 16);
    this.s = new $a6Jtu(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $6e8c3201ef611dc6$var$Signature;
function $6e8c3201ef611dc6$var$Position() {
    this.place = 0;
}
function $6e8c3201ef611dc6$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $6e8c3201ef611dc6$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$6e8c3201ef611dc6$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $pabd1.toArray(data, enc);
    var p = new $6e8c3201ef611dc6$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $6e8c3201ef611dc6$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $6e8c3201ef611dc6$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $6e8c3201ef611dc6$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $a6Jtu(r);
    this.s = new $a6Jtu(s);
    this.recoveryParam = null;
    return true;
};
function $6e8c3201ef611dc6$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$6e8c3201ef611dc6$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $6e8c3201ef611dc6$var$rmPadding(r);
    s = $6e8c3201ef611dc6$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $6e8c3201ef611dc6$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $6e8c3201ef611dc6$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $6e8c3201ef611dc6$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $pabd1.encode(res, enc);
};

});


parcelRegister("2gr10", function(module, exports) {
'use strict';

var $lcERW = parcelRequire("lcERW");

var $7oKSI = parcelRequire("7oKSI");

var $pabd1 = parcelRequire("pabd1");
var $1a62080affb0fa81$var$assert = $pabd1.assert;
var $1a62080affb0fa81$var$parseBytes = $pabd1.parseBytes;

var $Q3nkS = parcelRequire("Q3nkS");

var $hKYzk = parcelRequire("hKYzk");
function $1a62080affb0fa81$var$EDDSA(curve) {
    $1a62080affb0fa81$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $1a62080affb0fa81$var$EDDSA)) return new $1a62080affb0fa81$var$EDDSA(curve);
    curve = $7oKSI[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $lcERW.sha512;
}
module.exports = $1a62080affb0fa81$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $1a62080affb0fa81$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $1a62080affb0fa81$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $1a62080affb0fa81$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $1a62080affb0fa81$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$1a62080affb0fa81$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $pabd1.intFromLE(hash.digest()).umod(this.curve.n);
};
$1a62080affb0fa81$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $Q3nkS.fromPublic(this, pub);
};
$1a62080affb0fa81$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $Q3nkS.fromSecret(this, secret);
};
$1a62080affb0fa81$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $hKYzk) return sig;
    return new $hKYzk(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $1a62080affb0fa81$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$1a62080affb0fa81$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $pabd1.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $pabd1.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$1a62080affb0fa81$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$1a62080affb0fa81$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $pabd1.intFromLE(bytes);
};
$1a62080affb0fa81$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("Q3nkS", function(module, exports) {
'use strict';

var $pabd1 = parcelRequire("pabd1");
var $09c779b95e152b50$var$assert = $pabd1.assert;
var $09c779b95e152b50$var$parseBytes = $pabd1.parseBytes;
var $09c779b95e152b50$var$cachedProperty = $pabd1.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $09c779b95e152b50$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $09c779b95e152b50$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $09c779b95e152b50$var$parseBytes(params.pub);
}
$09c779b95e152b50$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $09c779b95e152b50$var$KeyPair) return pub;
    return new $09c779b95e152b50$var$KeyPair(eddsa, {
        pub: pub
    });
};
$09c779b95e152b50$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $09c779b95e152b50$var$KeyPair) return secret;
    return new $09c779b95e152b50$var$KeyPair(eddsa, {
        secret: secret
    });
};
$09c779b95e152b50$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$09c779b95e152b50$var$cachedProperty($09c779b95e152b50$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$09c779b95e152b50$var$KeyPair.prototype.sign = function sign(message) {
    $09c779b95e152b50$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$09c779b95e152b50$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$09c779b95e152b50$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $09c779b95e152b50$var$assert(this._secret, 'KeyPair is public only');
    return $pabd1.encode(this.secret(), enc);
};
$09c779b95e152b50$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $pabd1.encode(this.pubBytes(), enc);
};
module.exports = $09c779b95e152b50$var$KeyPair;

});

parcelRegister("hKYzk", function(module, exports) {
'use strict';

var $a6Jtu = parcelRequire("a6Jtu");

var $pabd1 = parcelRequire("pabd1");
var $ced5b7423e4838b0$var$assert = $pabd1.assert;
var $ced5b7423e4838b0$var$cachedProperty = $pabd1.cachedProperty;
var $ced5b7423e4838b0$var$parseBytes = $pabd1.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $ced5b7423e4838b0$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $ced5b7423e4838b0$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $ced5b7423e4838b0$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $ced5b7423e4838b0$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $a6Jtu) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$ced5b7423e4838b0$var$cachedProperty($ced5b7423e4838b0$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$ced5b7423e4838b0$var$cachedProperty($ced5b7423e4838b0$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$ced5b7423e4838b0$var$cachedProperty($ced5b7423e4838b0$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$ced5b7423e4838b0$var$cachedProperty($ced5b7423e4838b0$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$ced5b7423e4838b0$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$ced5b7423e4838b0$var$Signature.prototype.toHex = function toHex() {
    return $pabd1.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $ced5b7423e4838b0$var$Signature;

});



parcelRegister("8YhKY", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("fVZIf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("jxwsS", function(module, exports) {
'use strict';

var $jMn4v = parcelRequire("jMn4v");

var $eE0Rm = parcelRequire("eE0Rm");

var $6rsVl = parcelRequire("6rsVl");

var $aLSU4 = parcelRequire("aLSU4");

var $4tG8V = parcelRequire("4tG8V");

var $BUCDt = parcelRequire("BUCDt");
var $e39a483074508f87$require$Buffer = $BUCDt.Buffer;
function $e39a483074508f87$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $eE0Rm[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $4tG8V.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $aLSU4.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $e39a483074508f87$require$Buffer.concat(out);
}
function $e39a483074508f87$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$e39a483074508f87$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $e39a483074508f87$require$Buffer.from(buffer);
    var stripped = $6rsVl(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $jMn4v.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $jMn4v.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $jMn4v.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $jMn4v.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $jMn4v.EncryptedPrivateKey.decode(data, 'der');
            data = $e39a483074508f87$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $jMn4v.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $jMn4v.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $jMn4v.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $jMn4v.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $jMn4v.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $jMn4v.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $jMn4v.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $jMn4v.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$e39a483074508f87$var$parseKeys.signature = $jMn4v.signature;
module.exports = $e39a483074508f87$var$parseKeys;

});
parcelRegister("jMn4v", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $e6646594b425bf75$export$c98397a6eb8d0678; }, function (v) { return $e6646594b425bf75$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $e6646594b425bf75$export$f4aab6816f64fa6b; }, function (v) { return $e6646594b425bf75$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $e6646594b425bf75$export$4471f5c65d097c11; }, function (v) { return $e6646594b425bf75$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $e6646594b425bf75$export$ca8b6604d6ce14de; }, function (v) { return $e6646594b425bf75$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $e6646594b425bf75$export$8f54525b330fd87b; }, function (v) { return $e6646594b425bf75$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $e6646594b425bf75$export$23cd2842b44ca3e7; }, function (v) { return $e6646594b425bf75$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $e6646594b425bf75$export$245c9aaa9f5ce4ce; }, function (v) { return $e6646594b425bf75$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $e6646594b425bf75$export$8ad762e3e6399afe; }, function (v) { return $e6646594b425bf75$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $e6646594b425bf75$export$32ef6f92e22c6ab0; }, function (v) { return $e6646594b425bf75$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $e6646594b425bf75$export$c9cd164b539ebb63; }, function (v) { return $e6646594b425bf75$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $e6646594b425bf75$export$c98397a6eb8d0678;
var $e6646594b425bf75$export$f4aab6816f64fa6b;
var $e6646594b425bf75$export$4471f5c65d097c11;
var $e6646594b425bf75$export$ca8b6604d6ce14de;
var $e6646594b425bf75$export$8f54525b330fd87b;
var $e6646594b425bf75$export$23cd2842b44ca3e7;
var $e6646594b425bf75$export$245c9aaa9f5ce4ce;
var $e6646594b425bf75$export$8ad762e3e6399afe;
var $e6646594b425bf75$export$32ef6f92e22c6ab0;
var $e6646594b425bf75$export$c9cd164b539ebb63;
'use strict';

var $2ueZL = parcelRequire("2ueZL");

$e6646594b425bf75$export$c98397a6eb8d0678 = (parcelRequire("1TeGm"));
var $e6646594b425bf75$var$RSAPrivateKey = $2ueZL.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$e6646594b425bf75$export$f4aab6816f64fa6b = $e6646594b425bf75$var$RSAPrivateKey;
var $e6646594b425bf75$var$RSAPublicKey = $2ueZL.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$e6646594b425bf75$export$4471f5c65d097c11 = $e6646594b425bf75$var$RSAPublicKey;
var $e6646594b425bf75$var$AlgorithmIdentifier = $2ueZL.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $e6646594b425bf75$var$PublicKey = $2ueZL.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($e6646594b425bf75$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$e6646594b425bf75$export$ca8b6604d6ce14de = $e6646594b425bf75$var$PublicKey;
var $e6646594b425bf75$var$PrivateKeyInfo = $2ueZL.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($e6646594b425bf75$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$e6646594b425bf75$export$8f54525b330fd87b = $e6646594b425bf75$var$PrivateKeyInfo;
var $e6646594b425bf75$var$EncryptedPrivateKeyInfo = $2ueZL.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$e6646594b425bf75$export$23cd2842b44ca3e7 = $e6646594b425bf75$var$EncryptedPrivateKeyInfo;
var $e6646594b425bf75$var$DSAPrivateKey = $2ueZL.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$e6646594b425bf75$export$245c9aaa9f5ce4ce = $e6646594b425bf75$var$DSAPrivateKey;
$e6646594b425bf75$export$8ad762e3e6399afe = $2ueZL.define('DSAparam', function() {
    this['int']();
});
var $e6646594b425bf75$var$ECParameters = $2ueZL.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $e6646594b425bf75$var$ECPrivateKey = $2ueZL.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($e6646594b425bf75$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$e6646594b425bf75$export$32ef6f92e22c6ab0 = $e6646594b425bf75$var$ECPrivateKey;
$e6646594b425bf75$export$c9cd164b539ebb63 = $2ueZL.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("2ueZL", function(module, exports) {
var $1cfa03dee0dbea9f$var$asn1 = module.exports;

$1cfa03dee0dbea9f$var$asn1.bignum = (parcelRequire("a6Jtu"));

$1cfa03dee0dbea9f$var$asn1.define = (parcelRequire("lTkWA")).define;

$1cfa03dee0dbea9f$var$asn1.base = (parcelRequire("1kuIV"));

$1cfa03dee0dbea9f$var$asn1.constants = (parcelRequire("layxr"));

$1cfa03dee0dbea9f$var$asn1.decoders = (parcelRequire("7QUUr"));

$1cfa03dee0dbea9f$var$asn1.encoders = (parcelRequire("kH9JY"));

});
parcelRegister("lTkWA", function(module, exports) {

var $2ueZL = parcelRequire("2ueZL");

var $bVy58 = parcelRequire("bVy58");
var $fefefb0bfda330e7$var$api = module.exports;
$fefefb0bfda330e7$var$api.define = function define(name, body) {
    return new $fefefb0bfda330e7$var$Entity(name, body);
};
function $fefefb0bfda330e7$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$fefefb0bfda330e7$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("8hlVu")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $bVy58(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$fefefb0bfda330e7$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($2ueZL.decoders[enc]);
    return this.decoders[enc];
};
$fefefb0bfda330e7$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$fefefb0bfda330e7$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($2ueZL.encoders[enc]);
    return this.encoders[enc];
};
$fefefb0bfda330e7$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("8hlVu", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("1kuIV", function(module, exports) {
var $0f7f7dbf83b2461c$var$base = module.exports;

$0f7f7dbf83b2461c$var$base.Reporter = (parcelRequire("efDEV")).Reporter;

$0f7f7dbf83b2461c$var$base.DecoderBuffer = (parcelRequire("78uNn")).DecoderBuffer;

$0f7f7dbf83b2461c$var$base.EncoderBuffer = (parcelRequire("78uNn")).EncoderBuffer;

$0f7f7dbf83b2461c$var$base.Node = (parcelRequire("6paRr"));

});
parcelRegister("efDEV", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $a6013ae5a3bb9897$export$957313a2f485e5ed; }, function (v) { return $a6013ae5a3bb9897$export$957313a2f485e5ed = v; });
var $a6013ae5a3bb9897$export$957313a2f485e5ed;

var $bVy58 = parcelRequire("bVy58");
function $a6013ae5a3bb9897$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$a6013ae5a3bb9897$export$957313a2f485e5ed = $a6013ae5a3bb9897$var$Reporter;
$a6013ae5a3bb9897$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $a6013ae5a3bb9897$var$ReporterError;
};
$a6013ae5a3bb9897$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$a6013ae5a3bb9897$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$a6013ae5a3bb9897$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$a6013ae5a3bb9897$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$a6013ae5a3bb9897$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$a6013ae5a3bb9897$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$a6013ae5a3bb9897$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$a6013ae5a3bb9897$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$a6013ae5a3bb9897$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $a6013ae5a3bb9897$var$ReporterError;
    if (inherited) err = msg;
    else err = new $a6013ae5a3bb9897$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$a6013ae5a3bb9897$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $a6013ae5a3bb9897$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$bVy58($a6013ae5a3bb9897$var$ReporterError, Error);
$a6013ae5a3bb9897$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $a6013ae5a3bb9897$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("78uNn", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $53212b12a7dd1ee5$export$bf9f79cdc4a49163; }, function (v) { return $53212b12a7dd1ee5$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $53212b12a7dd1ee5$export$8ff24f7760c7a78e; }, function (v) { return $53212b12a7dd1ee5$export$8ff24f7760c7a78e = v; });
var $53212b12a7dd1ee5$export$bf9f79cdc4a49163;
var $53212b12a7dd1ee5$export$8ff24f7760c7a78e;

var $bVy58 = parcelRequire("bVy58");

var $1kuIV = parcelRequire("1kuIV");
var $53212b12a7dd1ee5$require$Reporter = $1kuIV.Reporter;

var $8f5i0 = parcelRequire("8f5i0");
var $53212b12a7dd1ee5$require$Buffer = $8f5i0.Buffer;
function $53212b12a7dd1ee5$var$DecoderBuffer(base, options) {
    $53212b12a7dd1ee5$require$Reporter.call(this, options);
    if (!$53212b12a7dd1ee5$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$bVy58($53212b12a7dd1ee5$var$DecoderBuffer, $53212b12a7dd1ee5$require$Reporter);
$53212b12a7dd1ee5$export$bf9f79cdc4a49163 = $53212b12a7dd1ee5$var$DecoderBuffer;
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $53212b12a7dd1ee5$require$Reporter.prototype.save.call(this)
    };
};
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $53212b12a7dd1ee5$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $53212b12a7dd1ee5$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $53212b12a7dd1ee5$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$53212b12a7dd1ee5$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $53212b12a7dd1ee5$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $53212b12a7dd1ee5$var$EncoderBuffer)) item = new $53212b12a7dd1ee5$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $53212b12a7dd1ee5$require$Buffer.byteLength(value);
    } else if ($53212b12a7dd1ee5$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$53212b12a7dd1ee5$export$8ff24f7760c7a78e = $53212b12a7dd1ee5$var$EncoderBuffer;
$53212b12a7dd1ee5$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $53212b12a7dd1ee5$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($53212b12a7dd1ee5$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("6paRr", function(module, exports) {

var $1kuIV = parcelRequire("1kuIV");
var $4a9d80a0cb1466e8$require$Reporter = $1kuIV.Reporter;

var $1kuIV = parcelRequire("1kuIV");
var $4a9d80a0cb1466e8$require$EncoderBuffer = $1kuIV.EncoderBuffer;

var $1kuIV = parcelRequire("1kuIV");
var $4a9d80a0cb1466e8$require$DecoderBuffer = $1kuIV.DecoderBuffer;

var $9EwBD = parcelRequire("9EwBD");
// Supported tags
var $4a9d80a0cb1466e8$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $4a9d80a0cb1466e8$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($4a9d80a0cb1466e8$var$tags);
// Overrided methods list
var $4a9d80a0cb1466e8$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $4a9d80a0cb1466e8$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $4a9d80a0cb1466e8$var$Node;
var $4a9d80a0cb1466e8$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$4a9d80a0cb1466e8$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $4a9d80a0cb1466e8$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$4a9d80a0cb1466e8$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $4a9d80a0cb1466e8$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$4a9d80a0cb1466e8$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $9EwBD(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $9EwBD.equal(state.children.length, 1, 'Root node can have only one child');
};
$4a9d80a0cb1466e8$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $9EwBD(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $9EwBD(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$4a9d80a0cb1466e8$var$overrided.forEach(function(method) {
    $4a9d80a0cb1466e8$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$4a9d80a0cb1466e8$var$tags.forEach(function(tag) {
    $4a9d80a0cb1466e8$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $9EwBD(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$4a9d80a0cb1466e8$var$Node.prototype.use = function use(item) {
    $9EwBD(item);
    var state = this._baseState;
    $9EwBD(state.use === null);
    state.use = item;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $9EwBD(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $9EwBD(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $9EwBD(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $9EwBD(state.key === null);
    state.key = newKey;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $9EwBD(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$4a9d80a0cb1466e8$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $9EwBD(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$4a9d80a0cb1466e8$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $4a9d80a0cb1466e8$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$4a9d80a0cb1466e8$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$4a9d80a0cb1466e8$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $9EwBD(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$4a9d80a0cb1466e8$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$4a9d80a0cb1466e8$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $4a9d80a0cb1466e8$require$EncoderBuffer(data, this.reporter);
};
$4a9d80a0cb1466e8$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$4a9d80a0cb1466e8$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $4a9d80a0cb1466e8$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$4a9d80a0cb1466e8$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $9EwBD(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$4a9d80a0cb1466e8$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$4a9d80a0cb1466e8$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$4a9d80a0cb1466e8$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("layxr", function(module, exports) {
var $f69552c0c3b65ad7$var$constants = module.exports;
// Helper
$f69552c0c3b65ad7$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$f69552c0c3b65ad7$var$constants.der = (parcelRequire("d9hFn"));

});
parcelRegister("d9hFn", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $9929d1cb49072c3e$export$3584c46ed60baee8; }, function (v) { return $9929d1cb49072c3e$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $9929d1cb49072c3e$export$f18596ef8d632e49; }, function (v) { return $9929d1cb49072c3e$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $9929d1cb49072c3e$export$2b067c6666111485; }, function (v) { return $9929d1cb49072c3e$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $9929d1cb49072c3e$export$f17df38a421ab9e3; }, function (v) { return $9929d1cb49072c3e$export$f17df38a421ab9e3 = v; });
var $9929d1cb49072c3e$export$3584c46ed60baee8;
var $9929d1cb49072c3e$export$f18596ef8d632e49;
var $9929d1cb49072c3e$export$2b067c6666111485;
var $9929d1cb49072c3e$export$f17df38a421ab9e3;

var $layxr = parcelRequire("layxr");
$9929d1cb49072c3e$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$9929d1cb49072c3e$export$f18596ef8d632e49 = $layxr._reverse($9929d1cb49072c3e$export$3584c46ed60baee8);
$9929d1cb49072c3e$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$9929d1cb49072c3e$export$f17df38a421ab9e3 = $layxr._reverse($9929d1cb49072c3e$export$2b067c6666111485);

});


parcelRegister("7QUUr", function(module, exports) {
var $5b7988c00486a75c$var$decoders = module.exports;

$5b7988c00486a75c$var$decoders.der = (parcelRequire("aQSyH"));

$5b7988c00486a75c$var$decoders.pem = (parcelRequire("cgWOc"));

});
parcelRegister("aQSyH", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $2ueZL = parcelRequire("2ueZL");
var $7e6914edebcf65b7$var$base = $2ueZL.base;
var $7e6914edebcf65b7$var$bignum = $2ueZL.bignum;
// Import DER constants
var $7e6914edebcf65b7$var$der = $2ueZL.constants.der;
function $7e6914edebcf65b7$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $7e6914edebcf65b7$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $7e6914edebcf65b7$var$DERDecoder;
$7e6914edebcf65b7$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $7e6914edebcf65b7$var$base.DecoderBuffer)) data = new $7e6914edebcf65b7$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $7e6914edebcf65b7$var$DERNode(parent) {
    $7e6914edebcf65b7$var$base.Node.call(this, 'der', parent);
}
$bVy58($7e6914edebcf65b7$var$DERNode, $7e6914edebcf65b7$var$base.Node);
$7e6914edebcf65b7$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $7e6914edebcf65b7$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $7e6914edebcf65b7$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $7e6914edebcf65b7$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$7e6914edebcf65b7$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $7e6914edebcf65b7$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $7e6914edebcf65b7$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$7e6914edebcf65b7$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $7e6914edebcf65b7$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$7e6914edebcf65b7$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $7e6914edebcf65b7$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $7e6914edebcf65b7$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $7e6914edebcf65b7$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $7e6914edebcf65b7$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("cgWOc", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $8f5i0 = parcelRequire("8f5i0");
var $8ef498d2b7d4d0da$require$Buffer = $8f5i0.Buffer;

var $aQSyH = parcelRequire("aQSyH");
function $8ef498d2b7d4d0da$var$PEMDecoder(entity) {
    $aQSyH.call(this, entity);
    this.enc = 'pem';
}
$bVy58($8ef498d2b7d4d0da$var$PEMDecoder, $aQSyH);
module.exports = $8ef498d2b7d4d0da$var$PEMDecoder;
$8ef498d2b7d4d0da$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $8ef498d2b7d4d0da$require$Buffer(base64, 'base64');
    return $aQSyH.prototype.decode.call(this, input, options);
};

});


parcelRegister("kH9JY", function(module, exports) {
var $f10f611078de710b$var$encoders = module.exports;

$f10f611078de710b$var$encoders.der = (parcelRequire("03OEN"));

$f10f611078de710b$var$encoders.pem = (parcelRequire("ghVgF"));

});
parcelRegister("03OEN", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $8f5i0 = parcelRequire("8f5i0");
var $00b793578ad272d5$require$Buffer = $8f5i0.Buffer;

var $2ueZL = parcelRequire("2ueZL");
var $00b793578ad272d5$var$base = $2ueZL.base;
// Import DER constants
var $00b793578ad272d5$var$der = $2ueZL.constants.der;
function $00b793578ad272d5$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $00b793578ad272d5$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $00b793578ad272d5$var$DEREncoder;
$00b793578ad272d5$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $00b793578ad272d5$var$DERNode(parent) {
    $00b793578ad272d5$var$base.Node.call(this, 'der', parent);
}
$bVy58($00b793578ad272d5$var$DERNode, $00b793578ad272d5$var$base.Node);
$00b793578ad272d5$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $00b793578ad272d5$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $00b793578ad272d5$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $00b793578ad272d5$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$00b793578ad272d5$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $00b793578ad272d5$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$00b793578ad272d5$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $00b793578ad272d5$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $00b793578ad272d5$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$00b793578ad272d5$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $00b793578ad272d5$var$two(date.getFullYear()),
        $00b793578ad272d5$var$two(date.getUTCMonth() + 1),
        $00b793578ad272d5$var$two(date.getUTCDate()),
        $00b793578ad272d5$var$two(date.getUTCHours()),
        $00b793578ad272d5$var$two(date.getUTCMinutes()),
        $00b793578ad272d5$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $00b793578ad272d5$var$two(date.getFullYear() % 100),
        $00b793578ad272d5$var$two(date.getUTCMonth() + 1),
        $00b793578ad272d5$var$two(date.getUTCDate()),
        $00b793578ad272d5$var$two(date.getUTCHours()),
        $00b793578ad272d5$var$two(date.getUTCMinutes()),
        $00b793578ad272d5$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$00b793578ad272d5$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$00b793578ad272d5$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$00b793578ad272d5$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $00b793578ad272d5$require$Buffer(numArray);
    }
    if ($00b793578ad272d5$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $00b793578ad272d5$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $00b793578ad272d5$require$Buffer(out));
};
$00b793578ad272d5$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$00b793578ad272d5$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$00b793578ad272d5$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $00b793578ad272d5$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($00b793578ad272d5$var$der.tagByName.hasOwnProperty(tag)) res = $00b793578ad272d5$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $00b793578ad272d5$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("ghVgF", function(module, exports) {

var $bVy58 = parcelRequire("bVy58");

var $03OEN = parcelRequire("03OEN");
function $bdbaa8178e16dbc7$var$PEMEncoder(entity) {
    $03OEN.call(this, entity);
    this.enc = 'pem';
}
$bVy58($bdbaa8178e16dbc7$var$PEMEncoder, $03OEN);
module.exports = $bdbaa8178e16dbc7$var$PEMEncoder;
$bdbaa8178e16dbc7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $03OEN.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("1TeGm", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $2ueZL = parcelRequire("2ueZL");
var $16065115a3350ebb$var$Time = $2ueZL.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $16065115a3350ebb$var$AttributeTypeValue = $2ueZL.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $16065115a3350ebb$var$AlgorithmIdentifier = $2ueZL.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $16065115a3350ebb$var$SubjectPublicKeyInfo = $2ueZL.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($16065115a3350ebb$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $16065115a3350ebb$var$RelativeDistinguishedName = $2ueZL.define('RelativeDistinguishedName', function() {
    this.setof($16065115a3350ebb$var$AttributeTypeValue);
});
var $16065115a3350ebb$var$RDNSequence = $2ueZL.define('RDNSequence', function() {
    this.seqof($16065115a3350ebb$var$RelativeDistinguishedName);
});
var $16065115a3350ebb$var$Name = $2ueZL.define('Name', function() {
    this.choice({
        rdnSequence: this.use($16065115a3350ebb$var$RDNSequence)
    });
});
var $16065115a3350ebb$var$Validity = $2ueZL.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($16065115a3350ebb$var$Time), this.key('notAfter').use($16065115a3350ebb$var$Time));
});
var $16065115a3350ebb$var$Extension = $2ueZL.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $16065115a3350ebb$var$TBSCertificate = $2ueZL.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($16065115a3350ebb$var$AlgorithmIdentifier), this.key('issuer').use($16065115a3350ebb$var$Name), this.key('validity').use($16065115a3350ebb$var$Validity), this.key('subject').use($16065115a3350ebb$var$Name), this.key('subjectPublicKeyInfo').use($16065115a3350ebb$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($16065115a3350ebb$var$Extension).optional());
});
var $16065115a3350ebb$var$X509Certificate = $2ueZL.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($16065115a3350ebb$var$TBSCertificate), this.key('signatureAlgorithm').use($16065115a3350ebb$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $16065115a3350ebb$var$X509Certificate;

});


parcelRegister("eE0Rm", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("6rsVl", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $4b0bb35c2b2c59d7$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $4b0bb35c2b2c59d7$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $4b0bb35c2b2c59d7$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $eatyP = parcelRequire("eatyP");

var $aLSU4 = parcelRequire("aLSU4");

var $BUCDt = parcelRequire("BUCDt");
var $4b0bb35c2b2c59d7$require$Buffer = $BUCDt.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($4b0bb35c2b2c59d7$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($4b0bb35c2b2c59d7$var$fullRegex);
        decrypted = $4b0bb35c2b2c59d7$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $4b0bb35c2b2c59d7$require$Buffer.from(match[2], 'hex');
        var cipherText = $4b0bb35c2b2c59d7$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $eatyP(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $aLSU4.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $4b0bb35c2b2c59d7$require$Buffer.concat(out);
    }
    var tag = key.match($4b0bb35c2b2c59d7$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("hr1C4", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("lIhmv", function(module, exports) {
'use strict';

var $BUCDt = parcelRequire("BUCDt");
var $fceb2cbe4785b4fb$require$Buffer = $BUCDt.Buffer;

var $8YhKY = parcelRequire("8YhKY");

var $eSuvC = parcelRequire("eSuvC");
var $fceb2cbe4785b4fb$require$EC = $eSuvC.ec;

var $jxwsS = parcelRequire("jxwsS");

var $hr1C4 = parcelRequire("hr1C4");
function $fceb2cbe4785b4fb$var$verify(sig, hash, key, signType, tag) {
    var pub = $jxwsS(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $fceb2cbe4785b4fb$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $fceb2cbe4785b4fb$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $fceb2cbe4785b4fb$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $fceb2cbe4785b4fb$require$Buffer.from(pad);
    var red = $8YhKY.mont(pub.modulus);
    sig = new $8YhKY(sig).toRed(red);
    sig = sig.redPow(new $8YhKY(pub.publicExponent));
    sig = $fceb2cbe4785b4fb$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $fceb2cbe4785b4fb$var$ecVerify(sig, hash, pub) {
    var curveId = $hr1C4[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $fceb2cbe4785b4fb$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $fceb2cbe4785b4fb$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $jxwsS.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $fceb2cbe4785b4fb$var$checkValue(s, q);
    $fceb2cbe4785b4fb$var$checkValue(r, q);
    var montp = $8YhKY.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $8YhKY(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $fceb2cbe4785b4fb$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $fceb2cbe4785b4fb$var$verify;

});


parcelRegister("ccnYK", function(module, exports) {

var $8f5i0 = parcelRequire("8f5i0");
var $8e1934b8cf85ba52$require$Buffer = $8f5i0.Buffer;

var $eSuvC = parcelRequire("eSuvC");

var $a6Jtu = parcelRequire("a6Jtu");
module.exports = function createECDH(curve) {
    return new $8e1934b8cf85ba52$var$ECDH(curve);
};
var $8e1934b8cf85ba52$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$8e1934b8cf85ba52$var$aliases.p224 = $8e1934b8cf85ba52$var$aliases.secp224r1;
$8e1934b8cf85ba52$var$aliases.p256 = $8e1934b8cf85ba52$var$aliases.secp256r1 = $8e1934b8cf85ba52$var$aliases.prime256v1;
$8e1934b8cf85ba52$var$aliases.p192 = $8e1934b8cf85ba52$var$aliases.secp192r1 = $8e1934b8cf85ba52$var$aliases.prime192v1;
$8e1934b8cf85ba52$var$aliases.p384 = $8e1934b8cf85ba52$var$aliases.secp384r1;
$8e1934b8cf85ba52$var$aliases.p521 = $8e1934b8cf85ba52$var$aliases.secp521r1;
function $8e1934b8cf85ba52$var$ECDH(curve) {
    this.curveType = $8e1934b8cf85ba52$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $eSuvC.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$8e1934b8cf85ba52$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$8e1934b8cf85ba52$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$8e1934b8cf85ba52$require$Buffer.isBuffer(other)) other = new $8e1934b8cf85ba52$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $8e1934b8cf85ba52$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$8e1934b8cf85ba52$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $8e1934b8cf85ba52$var$formatReturnValue(key, enc);
};
$8e1934b8cf85ba52$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $8e1934b8cf85ba52$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$8e1934b8cf85ba52$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$8e1934b8cf85ba52$require$Buffer.isBuffer(pub)) pub = new $8e1934b8cf85ba52$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$8e1934b8cf85ba52$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$8e1934b8cf85ba52$require$Buffer.isBuffer(priv)) priv = new $8e1934b8cf85ba52$require$Buffer(priv, enc);
    var _priv = new $a6Jtu(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $8e1934b8cf85ba52$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $8e1934b8cf85ba52$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $8e1934b8cf85ba52$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $8e1934b8cf85ba52$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("apyZB", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $794761ff7f595f8d$export$512823e338ddb1b7; }, function (v) { return $794761ff7f595f8d$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $794761ff7f595f8d$export$7efb24e2fddf99b9; }, function (v) { return $794761ff7f595f8d$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $794761ff7f595f8d$export$9d0e0c0c4a8d30f3; }, function (v) { return $794761ff7f595f8d$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $794761ff7f595f8d$export$b9d55ff329113abd; }, function (v) { return $794761ff7f595f8d$export$b9d55ff329113abd = v; });
var $794761ff7f595f8d$export$512823e338ddb1b7;
var $794761ff7f595f8d$export$7efb24e2fddf99b9;
var $794761ff7f595f8d$export$9d0e0c0c4a8d30f3;
var $794761ff7f595f8d$export$b9d55ff329113abd;

$794761ff7f595f8d$export$512823e338ddb1b7 = (parcelRequire("bg0Xc"));

$794761ff7f595f8d$export$7efb24e2fddf99b9 = (parcelRequire("cfng4"));
$794761ff7f595f8d$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $794761ff7f595f8d$export$512823e338ddb1b7(key, buf, true);
};
$794761ff7f595f8d$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $794761ff7f595f8d$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("bg0Xc", function(module, exports) {

var $jxwsS = parcelRequire("jxwsS");

var $9FI1O = parcelRequire("9FI1O");

var $3KMVQ = parcelRequire("3KMVQ");

var $1QFo6 = parcelRequire("1QFo6");

var $l27o1 = parcelRequire("l27o1");

var $a6Jtu = parcelRequire("a6Jtu");

var $7YId0 = parcelRequire("7YId0");

var $afDxt = parcelRequire("afDxt");

var $BUCDt = parcelRequire("BUCDt");
var $8321edc0bb81ea4e$require$Buffer = $BUCDt.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $jxwsS(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $8321edc0bb81ea4e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $8321edc0bb81ea4e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $a6Jtu(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $afDxt(paddedMsg, key);
    else return $7YId0(paddedMsg, key);
};
function $8321edc0bb81ea4e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3KMVQ('sha1').update($8321edc0bb81ea4e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $8321edc0bb81ea4e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $9FI1O(hLen);
    var maskedDb = $l27o1($8321edc0bb81ea4e$require$Buffer.concat([
        iHash,
        ps,
        $8321edc0bb81ea4e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $1QFo6(seed, dblen));
    var maskedSeed = $l27o1(seed, $1QFo6(maskedDb, hLen));
    return new $a6Jtu($8321edc0bb81ea4e$require$Buffer.concat([
        $8321edc0bb81ea4e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $8321edc0bb81ea4e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $8321edc0bb81ea4e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $8321edc0bb81ea4e$var$nonZero(k - mLen - 3);
    return new $a6Jtu($8321edc0bb81ea4e$require$Buffer.concat([
        $8321edc0bb81ea4e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $8321edc0bb81ea4e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $8321edc0bb81ea4e$var$nonZero(len) {
    var out = $8321edc0bb81ea4e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $9FI1O(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $9FI1O(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("1QFo6", function(module, exports) {

var $3KMVQ = parcelRequire("3KMVQ");

var $BUCDt = parcelRequire("BUCDt");
var $158ac0855d49b870$require$Buffer = $BUCDt.Buffer;
module.exports = function(seed, len) {
    var t = $158ac0855d49b870$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $158ac0855d49b870$var$i2ops(i++);
        t = $158ac0855d49b870$require$Buffer.concat([
            t,
            $3KMVQ('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $158ac0855d49b870$var$i2ops(c) {
    var out = $158ac0855d49b870$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("l27o1", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("7YId0", function(module, exports) {

var $a6Jtu = parcelRequire("a6Jtu");

var $BUCDt = parcelRequire("BUCDt");
var $5cf06df2206cc280$require$Buffer = $BUCDt.Buffer;
function $5cf06df2206cc280$var$withPublic(paddedMsg, key) {
    return $5cf06df2206cc280$require$Buffer.from(paddedMsg.toRed($a6Jtu.mont(key.modulus)).redPow(new $a6Jtu(key.publicExponent)).fromRed().toArray());
}
module.exports = $5cf06df2206cc280$var$withPublic;

});


parcelRegister("cfng4", function(module, exports) {

var $jxwsS = parcelRequire("jxwsS");

var $1QFo6 = parcelRequire("1QFo6");

var $l27o1 = parcelRequire("l27o1");

var $a6Jtu = parcelRequire("a6Jtu");

var $afDxt = parcelRequire("afDxt");

var $3KMVQ = parcelRequire("3KMVQ");

var $7YId0 = parcelRequire("7YId0");

var $BUCDt = parcelRequire("BUCDt");
var $8ea8ed559b321b16$require$Buffer = $BUCDt.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $jxwsS(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $a6Jtu(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $7YId0(new $a6Jtu(enc), key);
    else msg = $afDxt(enc, key);
    var zBuffer = $8ea8ed559b321b16$require$Buffer.alloc(k - msg.length);
    msg = $8ea8ed559b321b16$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $8ea8ed559b321b16$var$oaep(key, msg);
    else if (padding === 1) return $8ea8ed559b321b16$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $8ea8ed559b321b16$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3KMVQ('sha1').update($8ea8ed559b321b16$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $l27o1(maskedSeed, $1QFo6(maskedDb, hLen));
    var db = $l27o1(maskedDb, $1QFo6(seed, k - hLen - 1));
    if ($8ea8ed559b321b16$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $8ea8ed559b321b16$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $8ea8ed559b321b16$var$compare(a, b) {
    a = $8ea8ed559b321b16$require$Buffer.from(a);
    b = $8ea8ed559b321b16$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("crqwP", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $90ec95a8010041b1$export$bb1abf2ce84fc7e8; }, function (v) { return $90ec95a8010041b1$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $90ec95a8010041b1$export$2f7171e78e524d5e; }, function (v) { return $90ec95a8010041b1$export$2f7171e78e524d5e = v; });
var $90ec95a8010041b1$export$bb1abf2ce84fc7e8;
var $90ec95a8010041b1$export$2f7171e78e524d5e;

var $3iXjX = parcelRequire("3iXjX");
'use strict';
function $90ec95a8010041b1$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $BUCDt = parcelRequire("BUCDt");

var $9FI1O = parcelRequire("9FI1O");
var $90ec95a8010041b1$var$Buffer = $BUCDt.Buffer;
var $90ec95a8010041b1$var$kBufferMaxLength = $BUCDt.kMaxLength;
var $90ec95a8010041b1$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $90ec95a8010041b1$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $90ec95a8010041b1$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $90ec95a8010041b1$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $90ec95a8010041b1$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $90ec95a8010041b1$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $90ec95a8010041b1$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $90ec95a8010041b1$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($90ec95a8010041b1$var$crypto && $90ec95a8010041b1$var$crypto.getRandomValues || false) {
    $90ec95a8010041b1$export$bb1abf2ce84fc7e8 = $90ec95a8010041b1$var$randomFill;
    $90ec95a8010041b1$export$2f7171e78e524d5e = $90ec95a8010041b1$var$randomFillSync;
} else {
    $90ec95a8010041b1$export$bb1abf2ce84fc7e8 = $90ec95a8010041b1$var$oldBrowser;
    $90ec95a8010041b1$export$2f7171e78e524d5e = $90ec95a8010041b1$var$oldBrowser;
}
function $90ec95a8010041b1$var$randomFill(buf, offset, size, cb) {
    if (!$90ec95a8010041b1$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $90ec95a8010041b1$var$assertOffset(offset, buf.length);
    $90ec95a8010041b1$var$assertSize(size, offset, buf.length);
    return $90ec95a8010041b1$var$actualFill(buf, offset, size, cb);
}
function $90ec95a8010041b1$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $90ec95a8010041b1$var$crypto.getRandomValues(uint);
    if (cb) {
        $3iXjX.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $9FI1O(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $9FI1O(size);
    bytes.copy(buf, offset);
    return buf;
}
function $90ec95a8010041b1$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$90ec95a8010041b1$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $90ec95a8010041b1$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $90ec95a8010041b1$var$assertSize(size, offset, buf.length);
    return $90ec95a8010041b1$var$actualFill(buf, offset, size);
}

});


parcelRegister("8pbfm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3iXjX = parcelRequire("3iXjX");
var $61e961e9cc3be963$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $61e961e9cc3be963$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$61e961e9cc3be963$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($61e961e9cc3be963$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($61e961e9cc3be963$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($61e961e9cc3be963$var$isNull(x) || !$61e961e9cc3be963$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $61e961e9cc3be963$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($3iXjX.throwDeprecation) throw new Error(msg);
            else if ($3iXjX.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $61e961e9cc3be963$var$debugs = {};
var $61e961e9cc3be963$var$debugEnvRegex = /^$/;
var $61e961e9cc3be963$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$61e961e9cc3be963$var$debugs[set]) {
        if ($61e961e9cc3be963$var$debugEnvRegex.test(set)) {
            var pid = $3iXjX.pid;
            $61e961e9cc3be963$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $61e961e9cc3be963$var$debugs[set] = function() {};
    }
    return $61e961e9cc3be963$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $61e961e9cc3be963$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $61e961e9cc3be963$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($61e961e9cc3be963$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($61e961e9cc3be963$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($61e961e9cc3be963$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($61e961e9cc3be963$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($61e961e9cc3be963$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $61e961e9cc3be963$var$stylizeWithColor;
    return $61e961e9cc3be963$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $61e961e9cc3be963$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$61e961e9cc3be963$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$61e961e9cc3be963$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $61e961e9cc3be963$var$stylizeWithColor(str, styleType) {
    var style = $61e961e9cc3be963$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $61e961e9cc3be963$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $61e961e9cc3be963$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $61e961e9cc3be963$var$stylizeNoColor(str, styleType) {
    return str;
}
function $61e961e9cc3be963$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $61e961e9cc3be963$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $61e961e9cc3be963$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$61e961e9cc3be963$var$isString(ret)) ret = $61e961e9cc3be963$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $61e961e9cc3be963$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $61e961e9cc3be963$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($61e961e9cc3be963$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $61e961e9cc3be963$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($61e961e9cc3be963$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($61e961e9cc3be963$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($61e961e9cc3be963$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($61e961e9cc3be963$var$isError(value)) return $61e961e9cc3be963$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($61e961e9cc3be963$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($61e961e9cc3be963$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($61e961e9cc3be963$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($61e961e9cc3be963$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($61e961e9cc3be963$var$isError(value)) base = ' ' + $61e961e9cc3be963$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($61e961e9cc3be963$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $61e961e9cc3be963$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $61e961e9cc3be963$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $61e961e9cc3be963$var$reduceToSingleString(output, base, braces);
}
function $61e961e9cc3be963$var$formatPrimitive(ctx, value) {
    if ($61e961e9cc3be963$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($61e961e9cc3be963$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($61e961e9cc3be963$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($61e961e9cc3be963$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($61e961e9cc3be963$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $61e961e9cc3be963$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $61e961e9cc3be963$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($61e961e9cc3be963$var$hasOwnProperty(value, String(i))) output.push($61e961e9cc3be963$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($61e961e9cc3be963$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $61e961e9cc3be963$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$61e961e9cc3be963$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($61e961e9cc3be963$var$isNull(recurseTimes)) str = $61e961e9cc3be963$var$formatValue(ctx, desc.value, null);
            else str = $61e961e9cc3be963$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($61e961e9cc3be963$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $61e961e9cc3be963$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("br57J"));
function $61e961e9cc3be963$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $61e961e9cc3be963$var$isArray;
function $61e961e9cc3be963$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $61e961e9cc3be963$var$isBoolean;
function $61e961e9cc3be963$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $61e961e9cc3be963$var$isNull;
function $61e961e9cc3be963$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $61e961e9cc3be963$var$isNullOrUndefined;
function $61e961e9cc3be963$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $61e961e9cc3be963$var$isNumber;
function $61e961e9cc3be963$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $61e961e9cc3be963$var$isString;
function $61e961e9cc3be963$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $61e961e9cc3be963$var$isSymbol;
function $61e961e9cc3be963$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $61e961e9cc3be963$var$isUndefined;
function $61e961e9cc3be963$var$isRegExp(re) {
    return $61e961e9cc3be963$var$isObject(re) && $61e961e9cc3be963$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $61e961e9cc3be963$var$isRegExp;
module.exports.types.isRegExp = $61e961e9cc3be963$var$isRegExp;
function $61e961e9cc3be963$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $61e961e9cc3be963$var$isObject;
function $61e961e9cc3be963$var$isDate(d) {
    return $61e961e9cc3be963$var$isObject(d) && $61e961e9cc3be963$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $61e961e9cc3be963$var$isDate;
module.exports.types.isDate = $61e961e9cc3be963$var$isDate;
function $61e961e9cc3be963$var$isError(e) {
    return $61e961e9cc3be963$var$isObject(e) && ($61e961e9cc3be963$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $61e961e9cc3be963$var$isError;
module.exports.types.isNativeError = $61e961e9cc3be963$var$isError;
function $61e961e9cc3be963$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $61e961e9cc3be963$var$isFunction;
function $61e961e9cc3be963$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $61e961e9cc3be963$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("e9k8J"));
function $61e961e9cc3be963$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $61e961e9cc3be963$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $61e961e9cc3be963$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $61e961e9cc3be963$var$timestamp() {
    var d = new Date();
    var time = [
        $61e961e9cc3be963$var$pad(d.getHours()),
        $61e961e9cc3be963$var$pad(d.getMinutes()),
        $61e961e9cc3be963$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $61e961e9cc3be963$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $61e961e9cc3be963$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("bVy58"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$61e961e9cc3be963$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $61e961e9cc3be963$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $61e961e9cc3be963$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($61e961e9cc3be963$var$kCustomPromisifiedSymbol && original[$61e961e9cc3be963$var$kCustomPromisifiedSymbol]) {
        var fn = original[$61e961e9cc3be963$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $61e961e9cc3be963$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($61e961e9cc3be963$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $61e961e9cc3be963$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $61e961e9cc3be963$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $61e961e9cc3be963$var$kCustomPromisifiedSymbol;
function $61e961e9cc3be963$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $61e961e9cc3be963$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $3iXjX.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $3iXjX.nextTick($61e961e9cc3be963$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $61e961e9cc3be963$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $61e961e9cc3be963$var$callbackify;

});
parcelRegister("br57J", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $dqNDB = parcelRequire("dqNDB");

var $fmt0k = parcelRequire("fmt0k");

var $9YAFO = parcelRequire("9YAFO");

var $2Wugx = parcelRequire("2Wugx");
function $853630c77662c532$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $853630c77662c532$var$BigIntSupported = typeof BigInt !== 'undefined';
var $853630c77662c532$var$SymbolSupported = typeof Symbol !== 'undefined';
var $853630c77662c532$var$ObjectToString = $853630c77662c532$var$uncurryThis(Object.prototype.toString);
var $853630c77662c532$var$numberValue = $853630c77662c532$var$uncurryThis(Number.prototype.valueOf);
var $853630c77662c532$var$stringValue = $853630c77662c532$var$uncurryThis(String.prototype.valueOf);
var $853630c77662c532$var$booleanValue = $853630c77662c532$var$uncurryThis(Boolean.prototype.valueOf);
if ($853630c77662c532$var$BigIntSupported) var $853630c77662c532$var$bigIntValue = $853630c77662c532$var$uncurryThis(BigInt.prototype.valueOf);
if ($853630c77662c532$var$SymbolSupported) var $853630c77662c532$var$symbolValue = $853630c77662c532$var$uncurryThis(Symbol.prototype.valueOf);
function $853630c77662c532$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $dqNDB;
module.exports.isGeneratorFunction = $fmt0k;
module.exports.isTypedArray = $2Wugx;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $853630c77662c532$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $853630c77662c532$var$isPromise;
function $853630c77662c532$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $2Wugx(value) || $853630c77662c532$var$isDataView(value);
}
module.exports.isArrayBufferView = $853630c77662c532$var$isArrayBufferView;
function $853630c77662c532$var$isUint8Array(value) {
    return $9YAFO(value) === 'Uint8Array';
}
module.exports.isUint8Array = $853630c77662c532$var$isUint8Array;
function $853630c77662c532$var$isUint8ClampedArray(value) {
    return $9YAFO(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $853630c77662c532$var$isUint8ClampedArray;
function $853630c77662c532$var$isUint16Array(value) {
    return $9YAFO(value) === 'Uint16Array';
}
module.exports.isUint16Array = $853630c77662c532$var$isUint16Array;
function $853630c77662c532$var$isUint32Array(value) {
    return $9YAFO(value) === 'Uint32Array';
}
module.exports.isUint32Array = $853630c77662c532$var$isUint32Array;
function $853630c77662c532$var$isInt8Array(value) {
    return $9YAFO(value) === 'Int8Array';
}
module.exports.isInt8Array = $853630c77662c532$var$isInt8Array;
function $853630c77662c532$var$isInt16Array(value) {
    return $9YAFO(value) === 'Int16Array';
}
module.exports.isInt16Array = $853630c77662c532$var$isInt16Array;
function $853630c77662c532$var$isInt32Array(value) {
    return $9YAFO(value) === 'Int32Array';
}
module.exports.isInt32Array = $853630c77662c532$var$isInt32Array;
function $853630c77662c532$var$isFloat32Array(value) {
    return $9YAFO(value) === 'Float32Array';
}
module.exports.isFloat32Array = $853630c77662c532$var$isFloat32Array;
function $853630c77662c532$var$isFloat64Array(value) {
    return $9YAFO(value) === 'Float64Array';
}
module.exports.isFloat64Array = $853630c77662c532$var$isFloat64Array;
function $853630c77662c532$var$isBigInt64Array(value) {
    return $9YAFO(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $853630c77662c532$var$isBigInt64Array;
function $853630c77662c532$var$isBigUint64Array(value) {
    return $9YAFO(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $853630c77662c532$var$isBigUint64Array;
function $853630c77662c532$var$isMapToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object Map]';
}
$853630c77662c532$var$isMapToString.working = typeof Map !== 'undefined' && $853630c77662c532$var$isMapToString(new Map());
function $853630c77662c532$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $853630c77662c532$var$isMapToString.working ? $853630c77662c532$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $853630c77662c532$var$isMap;
function $853630c77662c532$var$isSetToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object Set]';
}
$853630c77662c532$var$isSetToString.working = typeof Set !== 'undefined' && $853630c77662c532$var$isSetToString(new Set());
function $853630c77662c532$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $853630c77662c532$var$isSetToString.working ? $853630c77662c532$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $853630c77662c532$var$isSet;
function $853630c77662c532$var$isWeakMapToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object WeakMap]';
}
$853630c77662c532$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $853630c77662c532$var$isWeakMapToString(new WeakMap());
function $853630c77662c532$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $853630c77662c532$var$isWeakMapToString.working ? $853630c77662c532$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $853630c77662c532$var$isWeakMap;
function $853630c77662c532$var$isWeakSetToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object WeakSet]';
}
$853630c77662c532$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $853630c77662c532$var$isWeakSetToString(new WeakSet());
function $853630c77662c532$var$isWeakSet(value) {
    return $853630c77662c532$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $853630c77662c532$var$isWeakSet;
function $853630c77662c532$var$isArrayBufferToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$853630c77662c532$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $853630c77662c532$var$isArrayBufferToString(new ArrayBuffer());
function $853630c77662c532$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $853630c77662c532$var$isArrayBufferToString.working ? $853630c77662c532$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $853630c77662c532$var$isArrayBuffer;
function $853630c77662c532$var$isDataViewToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object DataView]';
}
$853630c77662c532$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $853630c77662c532$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $853630c77662c532$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $853630c77662c532$var$isDataViewToString.working ? $853630c77662c532$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $853630c77662c532$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $853630c77662c532$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $853630c77662c532$var$isSharedArrayBufferToString(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $853630c77662c532$var$isSharedArrayBuffer(value) {
    if (typeof $853630c77662c532$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $853630c77662c532$var$isSharedArrayBufferToString.working === 'undefined') $853630c77662c532$var$isSharedArrayBufferToString.working = $853630c77662c532$var$isSharedArrayBufferToString(new $853630c77662c532$var$SharedArrayBufferCopy());
    return $853630c77662c532$var$isSharedArrayBufferToString.working ? $853630c77662c532$var$isSharedArrayBufferToString(value) : value instanceof $853630c77662c532$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $853630c77662c532$var$isSharedArrayBuffer;
function $853630c77662c532$var$isAsyncFunction(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $853630c77662c532$var$isAsyncFunction;
function $853630c77662c532$var$isMapIterator(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $853630c77662c532$var$isMapIterator;
function $853630c77662c532$var$isSetIterator(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $853630c77662c532$var$isSetIterator;
function $853630c77662c532$var$isGeneratorObject(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $853630c77662c532$var$isGeneratorObject;
function $853630c77662c532$var$isWebAssemblyCompiledModule(value) {
    return $853630c77662c532$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $853630c77662c532$var$isWebAssemblyCompiledModule;
function $853630c77662c532$var$isNumberObject(value) {
    return $853630c77662c532$var$checkBoxedPrimitive(value, $853630c77662c532$var$numberValue);
}
module.exports.isNumberObject = $853630c77662c532$var$isNumberObject;
function $853630c77662c532$var$isStringObject(value) {
    return $853630c77662c532$var$checkBoxedPrimitive(value, $853630c77662c532$var$stringValue);
}
module.exports.isStringObject = $853630c77662c532$var$isStringObject;
function $853630c77662c532$var$isBooleanObject(value) {
    return $853630c77662c532$var$checkBoxedPrimitive(value, $853630c77662c532$var$booleanValue);
}
module.exports.isBooleanObject = $853630c77662c532$var$isBooleanObject;
function $853630c77662c532$var$isBigIntObject(value) {
    return $853630c77662c532$var$BigIntSupported && $853630c77662c532$var$checkBoxedPrimitive(value, $853630c77662c532$var$bigIntValue);
}
module.exports.isBigIntObject = $853630c77662c532$var$isBigIntObject;
function $853630c77662c532$var$isSymbolObject(value) {
    return $853630c77662c532$var$SymbolSupported && $853630c77662c532$var$checkBoxedPrimitive(value, $853630c77662c532$var$symbolValue);
}
module.exports.isSymbolObject = $853630c77662c532$var$isSymbolObject;
function $853630c77662c532$var$isBoxedPrimitive(value) {
    return $853630c77662c532$var$isNumberObject(value) || $853630c77662c532$var$isStringObject(value) || $853630c77662c532$var$isBooleanObject(value) || $853630c77662c532$var$isBigIntObject(value) || $853630c77662c532$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $853630c77662c532$var$isBoxedPrimitive;
function $853630c77662c532$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($853630c77662c532$var$isArrayBuffer(value) || $853630c77662c532$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $853630c77662c532$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("dqNDB", function(module, exports) {
'use strict';

var $9c74351dbf3d7791$var$hasToStringTag = (parcelRequire("2Vd1a"))();

var $9dGLi = parcelRequire("9dGLi");
var $9c74351dbf3d7791$var$$toString = $9dGLi('Object.prototype.toString');
/** @type {import('.')} */ var $9c74351dbf3d7791$var$isStandardArguments = function isArguments(value) {
    if ($9c74351dbf3d7791$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $9c74351dbf3d7791$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $9c74351dbf3d7791$var$isLegacyArguments = function isArguments(value) {
    if ($9c74351dbf3d7791$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $9c74351dbf3d7791$var$$toString(value) !== '[object Array]' && 'callee' in value && $9c74351dbf3d7791$var$$toString(value.callee) === '[object Function]';
};
var $9c74351dbf3d7791$var$supportsStandardArguments = function() {
    return $9c74351dbf3d7791$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$9c74351dbf3d7791$var$isStandardArguments.isLegacyArguments = $9c74351dbf3d7791$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $9c74351dbf3d7791$var$supportsStandardArguments ? $9c74351dbf3d7791$var$isStandardArguments : $9c74351dbf3d7791$var$isLegacyArguments;

});

parcelRegister("fmt0k", function(module, exports) {
'use strict';

var $9dGLi = parcelRequire("9dGLi");

var $5XD4L = parcelRequire("5XD4L");
var $b2ef68c0d83d0d20$var$isFnRegex = $5XD4L(/^\s*(?:function)?\*/);

var $b2ef68c0d83d0d20$var$hasToStringTag = (parcelRequire("2Vd1a"))();

var $3Y4sF = parcelRequire("3Y4sF");
var $b2ef68c0d83d0d20$var$toStr = $9dGLi('Object.prototype.toString');
var $b2ef68c0d83d0d20$var$fnToStr = $9dGLi('Function.prototype.toString');
var $b2ef68c0d83d0d20$var$getGeneratorFunc = function() {
    if (!$b2ef68c0d83d0d20$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $b2ef68c0d83d0d20$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($b2ef68c0d83d0d20$var$isFnRegex($b2ef68c0d83d0d20$var$fnToStr(fn))) return true;
    if (!$b2ef68c0d83d0d20$var$hasToStringTag) {
        var str = $b2ef68c0d83d0d20$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3Y4sF) return false;
    if (typeof $b2ef68c0d83d0d20$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $b2ef68c0d83d0d20$var$getGeneratorFunc();
        $b2ef68c0d83d0d20$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $3Y4sF(generatorFunc) : false;
    }
    return $3Y4sF(fn) === $b2ef68c0d83d0d20$var$GeneratorFunction;
};

});
parcelRegister("5XD4L", function(module, exports) {
'use strict';

var $9dGLi = parcelRequire("9dGLi");

var $7y678 = parcelRequire("7y678");
var $4570c60f7ebb8f57$var$$exec = $9dGLi('RegExp.prototype.exec');

var $589A0 = parcelRequire("589A0");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$7y678(regex)) throw new $589A0('`regex` must be a RegExp');
    return function test(s) {
        return $4570c60f7ebb8f57$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("7y678", function(module, exports) {
'use strict';

var $9dGLi = parcelRequire("9dGLi");

var $57f073847cad5b3a$var$hasToStringTag = (parcelRequire("2Vd1a"))();

var $2Nbrd = parcelRequire("2Nbrd");

var $9ksyZ = parcelRequire("9ksyZ");
/** @type {import('.')} */ var $57f073847cad5b3a$var$fn;
if ($57f073847cad5b3a$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $57f073847cad5b3a$var$$exec = $9dGLi('RegExp.prototype.exec');
    /** @type {object} */ var $57f073847cad5b3a$var$isRegexMarker = {};
    var $57f073847cad5b3a$var$throwRegexMarker = function() {
        throw $57f073847cad5b3a$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $57f073847cad5b3a$var$badStringifier = {
        toString: $57f073847cad5b3a$var$throwRegexMarker,
        valueOf: $57f073847cad5b3a$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $57f073847cad5b3a$var$badStringifier[Symbol.toPrimitive] = $57f073847cad5b3a$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $57f073847cad5b3a$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $9ksyZ(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $2Nbrd(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $57f073847cad5b3a$var$$exec(value, /** @type {unknown} */ $57f073847cad5b3a$var$badStringifier);
        } catch (e) {
            return e === $57f073847cad5b3a$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $57f073847cad5b3a$var$$toString = $9dGLi('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $57f073847cad5b3a$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $57f073847cad5b3a$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $57f073847cad5b3a$var$$toString(value) === $57f073847cad5b3a$var$regexClass;
    };
}
module.exports = $57f073847cad5b3a$var$fn;

});
parcelRegister("9ksyZ", function(module, exports) {
'use strict';

var $8Qj84 = parcelRequire("8Qj84");
var $6cac23644ea5ff95$require$$gOPD = $8Qj84;
if ($6cac23644ea5ff95$require$$gOPD) try {
    $6cac23644ea5ff95$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6cac23644ea5ff95$require$$gOPD = null;
}
module.exports = $6cac23644ea5ff95$require$$gOPD;

});
parcelRegister("8Qj84", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});





parcelRegister("2Wugx", function(module, exports) {
'use strict';

var $9YAFO = parcelRequire("9YAFO");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$9YAFO(value);
};

});


parcelRegister("e9k8J", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});


parcelRegister("hWeHK", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");

var $5oDgH = parcelRequire("5oDgH");

var $b6JfC = parcelRequire("b6JfC");

var $eiKCl = parcelRequire("eiKCl");

var $1kiHH = parcelRequire("1kiHH");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $d0f342741f6b24e7$var$createInstance(defaultConfig) {
    var context = new $b6JfC(defaultConfig);
    var instance = $5oDgH($b6JfC.prototype.request, context);
    // Copy axios.prototype to instance
    $iQCVV.extend(instance, $b6JfC.prototype, context);
    // Copy context to instance
    $iQCVV.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $d0f342741f6b24e7$var$axios = $d0f342741f6b24e7$var$createInstance($1kiHH);
// Expose Axios class to allow class inheritance
$d0f342741f6b24e7$var$axios.Axios = $b6JfC;
// Factory for creating new instances
$d0f342741f6b24e7$var$axios.create = function create(instanceConfig) {
    return $d0f342741f6b24e7$var$createInstance($eiKCl($d0f342741f6b24e7$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$d0f342741f6b24e7$var$axios.Cancel = (parcelRequire("4x3tu"));

$d0f342741f6b24e7$var$axios.CancelToken = (parcelRequire("66FnF"));

$d0f342741f6b24e7$var$axios.isCancel = (parcelRequire("16J1K"));
// Expose all/spread
$d0f342741f6b24e7$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$d0f342741f6b24e7$var$axios.spread = (parcelRequire("irSj1"));
module.exports = $d0f342741f6b24e7$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $d0f342741f6b24e7$var$axios;

});
parcelRegister("iQCVV", function(module, exports) {
'use strict';

var $5oDgH = parcelRequire("5oDgH");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $db8b48a5f86788aa$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $db8b48a5f86788aa$var$isArray(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $db8b48a5f86788aa$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $db8b48a5f86788aa$var$isBuffer(val) {
    return val !== null && !$db8b48a5f86788aa$var$isUndefined(val) && val.constructor !== null && !$db8b48a5f86788aa$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $db8b48a5f86788aa$var$isArrayBuffer(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $db8b48a5f86788aa$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $db8b48a5f86788aa$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $db8b48a5f86788aa$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $db8b48a5f86788aa$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $db8b48a5f86788aa$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $db8b48a5f86788aa$var$isDate(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $db8b48a5f86788aa$var$isFile(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $db8b48a5f86788aa$var$isBlob(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $db8b48a5f86788aa$var$isFunction(val) {
    return $db8b48a5f86788aa$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $db8b48a5f86788aa$var$isStream(val) {
    return $db8b48a5f86788aa$var$isObject(val) && $db8b48a5f86788aa$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $db8b48a5f86788aa$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $db8b48a5f86788aa$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $db8b48a5f86788aa$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $db8b48a5f86788aa$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($db8b48a5f86788aa$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $db8b48a5f86788aa$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $db8b48a5f86788aa$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$db8b48a5f86788aa$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $db8b48a5f86788aa$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') result[key] = $db8b48a5f86788aa$var$deepMerge(result[key], val);
        else if (typeof val === 'object') result[key] = $db8b48a5f86788aa$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$db8b48a5f86788aa$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $db8b48a5f86788aa$var$extend(a, b, thisArg) {
    $db8b48a5f86788aa$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $5oDgH(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $db8b48a5f86788aa$var$isArray,
    isArrayBuffer: $db8b48a5f86788aa$var$isArrayBuffer,
    isBuffer: $db8b48a5f86788aa$var$isBuffer,
    isFormData: $db8b48a5f86788aa$var$isFormData,
    isArrayBufferView: $db8b48a5f86788aa$var$isArrayBufferView,
    isString: $db8b48a5f86788aa$var$isString,
    isNumber: $db8b48a5f86788aa$var$isNumber,
    isObject: $db8b48a5f86788aa$var$isObject,
    isUndefined: $db8b48a5f86788aa$var$isUndefined,
    isDate: $db8b48a5f86788aa$var$isDate,
    isFile: $db8b48a5f86788aa$var$isFile,
    isBlob: $db8b48a5f86788aa$var$isBlob,
    isFunction: $db8b48a5f86788aa$var$isFunction,
    isStream: $db8b48a5f86788aa$var$isStream,
    isURLSearchParams: $db8b48a5f86788aa$var$isURLSearchParams,
    isStandardBrowserEnv: $db8b48a5f86788aa$var$isStandardBrowserEnv,
    forEach: $db8b48a5f86788aa$var$forEach,
    merge: $db8b48a5f86788aa$var$merge,
    deepMerge: $db8b48a5f86788aa$var$deepMerge,
    extend: $db8b48a5f86788aa$var$extend,
    trim: $db8b48a5f86788aa$var$trim
};

});
parcelRegister("5oDgH", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("b6JfC", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");

var $7KX6E = parcelRequire("7KX6E");

var $3C6Ez = parcelRequire("3C6Ez");

var $e8ypY = parcelRequire("e8ypY");

var $eiKCl = parcelRequire("eiKCl");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $81635b2990ec525a$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $3C6Ez(),
        response: new $3C6Ez()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $81635b2990ec525a$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $eiKCl(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $e8ypY,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$81635b2990ec525a$var$Axios.prototype.getUri = function getUri(config) {
    config = $eiKCl(this.defaults, config);
    return $7KX6E(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$iQCVV.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $81635b2990ec525a$var$Axios.prototype[method] = function(url, config) {
        return this.request($iQCVV.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$iQCVV.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $81635b2990ec525a$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($iQCVV.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $81635b2990ec525a$var$Axios;

});
parcelRegister("7KX6E", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
function $5a5aad9497851613$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($iQCVV.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $iQCVV.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($iQCVV.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $iQCVV.forEach(val, function parseValue(v) {
                if ($iQCVV.isDate(v)) v = v.toISOString();
                else if ($iQCVV.isObject(v)) v = JSON.stringify(v);
                parts.push($5a5aad9497851613$var$encode(key) + '=' + $5a5aad9497851613$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("3C6Ez", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
function $2a1a14ebee1938c4$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $2a1a14ebee1938c4$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $2a1a14ebee1938c4$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $2a1a14ebee1938c4$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $iQCVV.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $2a1a14ebee1938c4$var$InterceptorManager;

});

parcelRegister("e8ypY", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");

var $8BCoK = parcelRequire("8BCoK");

var $16J1K = parcelRequire("16J1K");

var $1kiHH = parcelRequire("1kiHH");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a4ac82b6368d7f9d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a4ac82b6368d7f9d$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $8BCoK(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $iQCVV.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $iQCVV.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $1kiHH.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a4ac82b6368d7f9d$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $8BCoK(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$16J1K(reason)) {
            $a4ac82b6368d7f9d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $8BCoK(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("8BCoK", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $iQCVV.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("16J1K", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("1kiHH", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");

var $aDaPf = parcelRequire("aDaPf");
var $0f762ae3393d5e7e$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $0f762ae3393d5e7e$var$setContentTypeIfUnset(headers, value) {
    if (!$iQCVV.isUndefined(headers) && $iQCVV.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $0f762ae3393d5e7e$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("dwmpt"));
    return adapter;
}
var $0f762ae3393d5e7e$var$defaults = {
    adapter: $0f762ae3393d5e7e$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $aDaPf(headers, 'Accept');
            $aDaPf(headers, 'Content-Type');
            if ($iQCVV.isFormData(data) || $iQCVV.isArrayBuffer(data) || $iQCVV.isBuffer(data) || $iQCVV.isStream(data) || $iQCVV.isFile(data) || $iQCVV.isBlob(data)) return data;
            if ($iQCVV.isArrayBufferView(data)) return data.buffer;
            if ($iQCVV.isURLSearchParams(data)) {
                $0f762ae3393d5e7e$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($iQCVV.isObject(data)) {
                $0f762ae3393d5e7e$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$0f762ae3393d5e7e$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$iQCVV.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $0f762ae3393d5e7e$var$defaults.headers[method] = {};
});
$iQCVV.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $0f762ae3393d5e7e$var$defaults.headers[method] = $iQCVV.merge($0f762ae3393d5e7e$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $0f762ae3393d5e7e$var$defaults;

});
parcelRegister("aDaPf", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $iQCVV.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("dwmpt", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");

var $4lJSH = parcelRequire("4lJSH");

var $7KX6E = parcelRequire("7KX6E");

var $4V9FH = parcelRequire("4V9FH");

var $3n5Cs = parcelRequire("3n5Cs");

var $dzPyW = parcelRequire("dzPyW");

var $7dDIA = parcelRequire("7dDIA");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($iQCVV.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $4V9FH(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $7KX6E(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $3n5Cs(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $4lJSH(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($7dDIA('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($7dDIA('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($7dDIA(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($iQCVV.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("6PHxw"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $dzPyW(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $iQCVV.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$iQCVV.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("4lJSH", function(module, exports) {
'use strict';

var $7dDIA = parcelRequire("7dDIA");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($7dDIA('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("7dDIA", function(module, exports) {
'use strict';

var $3LalZ = parcelRequire("3LalZ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3LalZ(error, config, code, request, response);
};

});
parcelRegister("3LalZ", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("4V9FH", function(module, exports) {
'use strict';

var $kZkxi = parcelRequire("kZkxi");

var $68wzj = parcelRequire("68wzj");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$kZkxi(requestedURL)) return $68wzj(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("kZkxi", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("68wzj", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("3n5Cs", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $2747e0f5f7824d5c$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $iQCVV.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $iQCVV.trim(line.substr(0, i)).toLowerCase();
        val = $iQCVV.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $2747e0f5f7824d5c$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("dzPyW", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
module.exports = $iQCVV.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $iQCVV.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("6PHxw", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
module.exports = $iQCVV.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($iQCVV.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($iQCVV.isString(path)) cookie.push('path=' + path);
            if ($iQCVV.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("eiKCl", function(module, exports) {
'use strict';

var $iQCVV = parcelRequire("iQCVV");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'params',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'url',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'maxContentLength',
        'validateStatus',
        'maxRedirects',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath'
    ];
    $iQCVV.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
    });
    $iQCVV.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($iQCVV.isObject(config2[prop])) config[prop] = $iQCVV.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if ($iQCVV.isObject(config1[prop])) config[prop] = $iQCVV.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    $iQCVV.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $iQCVV.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== 'undefined') config[prop] = config2[prop];
        else if (typeof config1[prop] !== 'undefined') config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("4x3tu", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $34ccf07b49d710e4$var$Cancel(message) {
    this.message = message;
}
$34ccf07b49d710e4$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$34ccf07b49d710e4$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $34ccf07b49d710e4$var$Cancel;

});

parcelRegister("66FnF", function(module, exports) {
'use strict';

var $4x3tu = parcelRequire("4x3tu");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $472366f88ec3c241$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4x3tu(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $472366f88ec3c241$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $472366f88ec3c241$var$CancelToken.source = function source() {
    var cancel;
    var token = new $472366f88ec3c241$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $472366f88ec3c241$var$CancelToken;

});

parcelRegister("irSj1", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRegister("6jypm", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ var InvalidCharacterError = function(message) {
        this.message = message;
    };
    InvalidCharacterError.prototype = new Error;
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    var error = function(message) {
        // Note: the error messages used throughout this file match those used by
        // the native `atob`/`btoa` implementation in Chromium.
        throw new InvalidCharacterError(message);
    };
    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // http://whatwg.org/html/common-microsyntaxes.html#space-character
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
    // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396
    var decode = function(input) {
        input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
        var length = input.length;
        if (length % 4 == 0) {
            input = input.replace(/==?$/, '');
            length = input.length;
        }
        if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
        /[^+a-zA-Z0-9/]/.test(input)) error('Invalid character: the string to be decoded is not correctly encoded.');
        var bitCounter = 0;
        var bitStorage;
        var buffer;
        var output = '';
        var position = -1;
        while(++position < length){
            buffer = TABLE.indexOf(input.charAt(position));
            bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
            // Unless this is the first of a group of 4 characters…
            if (bitCounter++ % 4) // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
        return output;
    };
    // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
    var encode = function(input) {
        input = String(input);
        if (/[^\0-\xFF]/.test(input)) // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the Latin1 range.");
        var padding = input.length % 3;
        var output = '';
        var position = -1;
        var a;
        var b;
        var c;
        var d;
        var buffer;
        // Make sure any padding is handled outside of the loop.
        var length = input.length - padding;
        while(++position < length){
            // Read three bytes, i.e. 24 bits.
            a = input.charCodeAt(position) << 16;
            b = input.charCodeAt(++position) << 8;
            c = input.charCodeAt(++position);
            buffer = a + b + c;
            // Turn the 24 bits into four chunks of 6 bits each, and append the
            // matching character for each of them to the output.
            output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
        }
        if (padding == 2) {
            a = input.charCodeAt(position) << 8;
            b = input.charCodeAt(++position);
            buffer = a + b;
            output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
        } else if (padding == 1) {
            buffer = input.charCodeAt(position);
            output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
        }
        return output;
    };
    var base64 = {
        'encode': encode,
        'decode': decode,
        'version': '0.1.0'
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return base64;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = base64;
        else for(var key in base64)base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
    } else root.base64 = base64;
})(this);

});

parcelRegister("i250t", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        '\xAD': 'shy',
        '\u200C': 'zwnj',
        '\u200D': 'zwj',
        '\u200E': 'lrm',
        '\u2063': 'ic',
        '\u2062': 'it',
        '\u2061': 'af',
        '\u200F': 'rlm',
        '\u200B': 'ZeroWidthSpace',
        '\u2060': 'NoBreak',
        '\u0311': 'DownBreve',
        '\u20DB': 'tdot',
        '\u20DC': 'DotDot',
        '\t': 'Tab',
        '\n': 'NewLine',
        '\u2008': 'puncsp',
        '\u205F': 'MediumSpace',
        '\u2009': 'thinsp',
        '\u200A': 'hairsp',
        '\u2004': 'emsp13',
        '\u2002': 'ensp',
        '\u2005': 'emsp14',
        '\u2003': 'emsp',
        '\u2007': 'numsp',
        '\xA0': 'nbsp',
        '\u205F\u200A': 'ThickSpace',
        '\u203E': 'oline',
        '_': 'lowbar',
        '\u2010': 'dash',
        '\u2013': 'ndash',
        '\u2014': 'mdash',
        '\u2015': 'horbar',
        ',': 'comma',
        ';': 'semi',
        '\u204F': 'bsemi',
        ':': 'colon',
        '\u2A74': 'Colone',
        '!': 'excl',
        '\xA1': 'iexcl',
        '?': 'quest',
        '\xBF': 'iquest',
        '.': 'period',
        '\u2025': 'nldr',
        '\u2026': 'mldr',
        '\xB7': 'middot',
        '\'': 'apos',
        '\u2018': 'lsquo',
        '\u2019': 'rsquo',
        '\u201A': 'sbquo',
        '\u2039': 'lsaquo',
        '\u203A': 'rsaquo',
        '"': 'quot',
        '\u201C': 'ldquo',
        '\u201D': 'rdquo',
        '\u201E': 'bdquo',
        '\xAB': 'laquo',
        '\xBB': 'raquo',
        '(': 'lpar',
        ')': 'rpar',
        '[': 'lsqb',
        ']': 'rsqb',
        '{': 'lcub',
        '}': 'rcub',
        '\u2308': 'lceil',
        '\u2309': 'rceil',
        '\u230A': 'lfloor',
        '\u230B': 'rfloor',
        '\u2985': 'lopar',
        '\u2986': 'ropar',
        '\u298B': 'lbrke',
        '\u298C': 'rbrke',
        '\u298D': 'lbrkslu',
        '\u298E': 'rbrksld',
        '\u298F': 'lbrksld',
        '\u2990': 'rbrkslu',
        '\u2991': 'langd',
        '\u2992': 'rangd',
        '\u2993': 'lparlt',
        '\u2994': 'rpargt',
        '\u2995': 'gtlPar',
        '\u2996': 'ltrPar',
        '\u27E6': 'lobrk',
        '\u27E7': 'robrk',
        '\u27E8': 'lang',
        '\u27E9': 'rang',
        '\u27EA': 'Lang',
        '\u27EB': 'Rang',
        '\u27EC': 'loang',
        '\u27ED': 'roang',
        '\u2772': 'lbbrk',
        '\u2773': 'rbbrk',
        '\u2016': 'Vert',
        '\xA7': 'sect',
        '\xB6': 'para',
        '@': 'commat',
        '*': 'ast',
        '/': 'sol',
        'undefined': null,
        '&': 'amp',
        '#': 'num',
        '%': 'percnt',
        '\u2030': 'permil',
        '\u2031': 'pertenk',
        '\u2020': 'dagger',
        '\u2021': 'Dagger',
        '\u2022': 'bull',
        '\u2043': 'hybull',
        '\u2032': 'prime',
        '\u2033': 'Prime',
        '\u2034': 'tprime',
        '\u2057': 'qprime',
        '\u2035': 'bprime',
        '\u2041': 'caret',
        '`': 'grave',
        '\xB4': 'acute',
        '\u02DC': 'tilde',
        '^': 'Hat',
        '\xAF': 'macr',
        '\u02D8': 'breve',
        '\u02D9': 'dot',
        '\xA8': 'die',
        '\u02DA': 'ring',
        '\u02DD': 'dblac',
        '\xB8': 'cedil',
        '\u02DB': 'ogon',
        '\u02C6': 'circ',
        '\u02C7': 'caron',
        '\xB0': 'deg',
        '\xA9': 'copy',
        '\xAE': 'reg',
        '\u2117': 'copysr',
        '\u2118': 'wp',
        '\u211E': 'rx',
        '\u2127': 'mho',
        '\u2129': 'iiota',
        '\u2190': 'larr',
        '\u219A': 'nlarr',
        '\u2192': 'rarr',
        '\u219B': 'nrarr',
        '\u2191': 'uarr',
        '\u2193': 'darr',
        '\u2194': 'harr',
        '\u21AE': 'nharr',
        '\u2195': 'varr',
        '\u2196': 'nwarr',
        '\u2197': 'nearr',
        '\u2198': 'searr',
        '\u2199': 'swarr',
        '\u219D': 'rarrw',
        '\u219D\u0338': 'nrarrw',
        '\u219E': 'Larr',
        '\u219F': 'Uarr',
        '\u21A0': 'Rarr',
        '\u21A1': 'Darr',
        '\u21A2': 'larrtl',
        '\u21A3': 'rarrtl',
        '\u21A4': 'mapstoleft',
        '\u21A5': 'mapstoup',
        '\u21A6': 'map',
        '\u21A7': 'mapstodown',
        '\u21A9': 'larrhk',
        '\u21AA': 'rarrhk',
        '\u21AB': 'larrlp',
        '\u21AC': 'rarrlp',
        '\u21AD': 'harrw',
        '\u21B0': 'lsh',
        '\u21B1': 'rsh',
        '\u21B2': 'ldsh',
        '\u21B3': 'rdsh',
        '\u21B5': 'crarr',
        '\u21B6': 'cularr',
        '\u21B7': 'curarr',
        '\u21BA': 'olarr',
        '\u21BB': 'orarr',
        '\u21BC': 'lharu',
        '\u21BD': 'lhard',
        '\u21BE': 'uharr',
        '\u21BF': 'uharl',
        '\u21C0': 'rharu',
        '\u21C1': 'rhard',
        '\u21C2': 'dharr',
        '\u21C3': 'dharl',
        '\u21C4': 'rlarr',
        '\u21C5': 'udarr',
        '\u21C6': 'lrarr',
        '\u21C7': 'llarr',
        '\u21C8': 'uuarr',
        '\u21C9': 'rrarr',
        '\u21CA': 'ddarr',
        '\u21CB': 'lrhar',
        '\u21CC': 'rlhar',
        '\u21D0': 'lArr',
        '\u21CD': 'nlArr',
        '\u21D1': 'uArr',
        '\u21D2': 'rArr',
        '\u21CF': 'nrArr',
        '\u21D3': 'dArr',
        '\u21D4': 'iff',
        '\u21CE': 'nhArr',
        '\u21D5': 'vArr',
        '\u21D6': 'nwArr',
        '\u21D7': 'neArr',
        '\u21D8': 'seArr',
        '\u21D9': 'swArr',
        '\u21DA': 'lAarr',
        '\u21DB': 'rAarr',
        '\u21DD': 'zigrarr',
        '\u21E4': 'larrb',
        '\u21E5': 'rarrb',
        '\u21F5': 'duarr',
        '\u21FD': 'loarr',
        '\u21FE': 'roarr',
        '\u21FF': 'hoarr',
        '\u2200': 'forall',
        '\u2201': 'comp',
        '\u2202': 'part',
        '\u2202\u0338': 'npart',
        '\u2203': 'exist',
        '\u2204': 'nexist',
        '\u2205': 'empty',
        '\u2207': 'Del',
        '\u2208': 'in',
        '\u2209': 'notin',
        '\u220B': 'ni',
        '\u220C': 'notni',
        '\u03F6': 'bepsi',
        '\u220F': 'prod',
        '\u2210': 'coprod',
        '\u2211': 'sum',
        '+': 'plus',
        '\xB1': 'pm',
        '\xF7': 'div',
        '\xD7': 'times',
        '<': 'lt',
        '\u226E': 'nlt',
        '<\u20D2': 'nvlt',
        '=': 'equals',
        '\u2260': 'ne',
        '=\u20E5': 'bne',
        '\u2A75': 'Equal',
        '>': 'gt',
        '\u226F': 'ngt',
        '>\u20D2': 'nvgt',
        '\xAC': 'not',
        '|': 'vert',
        '\xA6': 'brvbar',
        '\u2212': 'minus',
        '\u2213': 'mp',
        '\u2214': 'plusdo',
        '\u2044': 'frasl',
        '\u2216': 'setmn',
        '\u2217': 'lowast',
        '\u2218': 'compfn',
        '\u221A': 'Sqrt',
        '\u221D': 'prop',
        '\u221E': 'infin',
        '\u221F': 'angrt',
        '\u2220': 'ang',
        '\u2220\u20D2': 'nang',
        '\u2221': 'angmsd',
        '\u2222': 'angsph',
        '\u2223': 'mid',
        '\u2224': 'nmid',
        '\u2225': 'par',
        '\u2226': 'npar',
        '\u2227': 'and',
        '\u2228': 'or',
        '\u2229': 'cap',
        '\u2229\uFE00': 'caps',
        '\u222A': 'cup',
        '\u222A\uFE00': 'cups',
        '\u222B': 'int',
        '\u222C': 'Int',
        '\u222D': 'tint',
        '\u2A0C': 'qint',
        '\u222E': 'oint',
        '\u222F': 'Conint',
        '\u2230': 'Cconint',
        '\u2231': 'cwint',
        '\u2232': 'cwconint',
        '\u2233': 'awconint',
        '\u2234': 'there4',
        '\u2235': 'becaus',
        '\u2236': 'ratio',
        '\u2237': 'Colon',
        '\u2238': 'minusd',
        '\u223A': 'mDDot',
        '\u223B': 'homtht',
        '\u223C': 'sim',
        '\u2241': 'nsim',
        '\u223C\u20D2': 'nvsim',
        '\u223D': 'bsim',
        '\u223D\u0331': 'race',
        '\u223E': 'ac',
        '\u223E\u0333': 'acE',
        '\u223F': 'acd',
        '\u2240': 'wr',
        '\u2242': 'esim',
        '\u2242\u0338': 'nesim',
        '\u2243': 'sime',
        '\u2244': 'nsime',
        '\u2245': 'cong',
        '\u2247': 'ncong',
        '\u2246': 'simne',
        '\u2248': 'ap',
        '\u2249': 'nap',
        '\u224A': 'ape',
        '\u224B': 'apid',
        '\u224B\u0338': 'napid',
        '\u224C': 'bcong',
        '\u224D': 'CupCap',
        '\u226D': 'NotCupCap',
        '\u224D\u20D2': 'nvap',
        '\u224E': 'bump',
        '\u224E\u0338': 'nbump',
        '\u224F': 'bumpe',
        '\u224F\u0338': 'nbumpe',
        '\u2250': 'doteq',
        '\u2250\u0338': 'nedot',
        '\u2251': 'eDot',
        '\u2252': 'efDot',
        '\u2253': 'erDot',
        '\u2254': 'colone',
        '\u2255': 'ecolon',
        '\u2256': 'ecir',
        '\u2257': 'cire',
        '\u2259': 'wedgeq',
        '\u225A': 'veeeq',
        '\u225C': 'trie',
        '\u225F': 'equest',
        '\u2261': 'equiv',
        '\u2262': 'nequiv',
        '\u2261\u20E5': 'bnequiv',
        '\u2264': 'le',
        '\u2270': 'nle',
        '\u2264\u20D2': 'nvle',
        '\u2265': 'ge',
        '\u2271': 'nge',
        '\u2265\u20D2': 'nvge',
        '\u2266': 'lE',
        '\u2266\u0338': 'nlE',
        '\u2267': 'gE',
        '\u2267\u0338': 'ngE',
        '\u2268\uFE00': 'lvnE',
        '\u2268': 'lnE',
        '\u2269': 'gnE',
        '\u2269\uFE00': 'gvnE',
        '\u226A': 'll',
        '\u226A\u0338': 'nLtv',
        '\u226A\u20D2': 'nLt',
        '\u226B': 'gg',
        '\u226B\u0338': 'nGtv',
        '\u226B\u20D2': 'nGt',
        '\u226C': 'twixt',
        '\u2272': 'lsim',
        '\u2274': 'nlsim',
        '\u2273': 'gsim',
        '\u2275': 'ngsim',
        '\u2276': 'lg',
        '\u2278': 'ntlg',
        '\u2277': 'gl',
        '\u2279': 'ntgl',
        '\u227A': 'pr',
        '\u2280': 'npr',
        '\u227B': 'sc',
        '\u2281': 'nsc',
        '\u227C': 'prcue',
        '\u22E0': 'nprcue',
        '\u227D': 'sccue',
        '\u22E1': 'nsccue',
        '\u227E': 'prsim',
        '\u227F': 'scsim',
        '\u227F\u0338': 'NotSucceedsTilde',
        '\u2282': 'sub',
        '\u2284': 'nsub',
        '\u2282\u20D2': 'vnsub',
        '\u2283': 'sup',
        '\u2285': 'nsup',
        '\u2283\u20D2': 'vnsup',
        '\u2286': 'sube',
        '\u2288': 'nsube',
        '\u2287': 'supe',
        '\u2289': 'nsupe',
        '\u228A\uFE00': 'vsubne',
        '\u228A': 'subne',
        '\u228B\uFE00': 'vsupne',
        '\u228B': 'supne',
        '\u228D': 'cupdot',
        '\u228E': 'uplus',
        '\u228F': 'sqsub',
        '\u228F\u0338': 'NotSquareSubset',
        '\u2290': 'sqsup',
        '\u2290\u0338': 'NotSquareSuperset',
        '\u2291': 'sqsube',
        '\u22E2': 'nsqsube',
        '\u2292': 'sqsupe',
        '\u22E3': 'nsqsupe',
        '\u2293': 'sqcap',
        '\u2293\uFE00': 'sqcaps',
        '\u2294': 'sqcup',
        '\u2294\uFE00': 'sqcups',
        '\u2295': 'oplus',
        '\u2296': 'ominus',
        '\u2297': 'otimes',
        '\u2298': 'osol',
        '\u2299': 'odot',
        '\u229A': 'ocir',
        '\u229B': 'oast',
        '\u229D': 'odash',
        '\u229E': 'plusb',
        '\u229F': 'minusb',
        '\u22A0': 'timesb',
        '\u22A1': 'sdotb',
        '\u22A2': 'vdash',
        '\u22AC': 'nvdash',
        '\u22A3': 'dashv',
        '\u22A4': 'top',
        '\u22A5': 'bot',
        '\u22A7': 'models',
        '\u22A8': 'vDash',
        '\u22AD': 'nvDash',
        '\u22A9': 'Vdash',
        '\u22AE': 'nVdash',
        '\u22AA': 'Vvdash',
        '\u22AB': 'VDash',
        '\u22AF': 'nVDash',
        '\u22B0': 'prurel',
        '\u22B2': 'vltri',
        '\u22EA': 'nltri',
        '\u22B3': 'vrtri',
        '\u22EB': 'nrtri',
        '\u22B4': 'ltrie',
        '\u22EC': 'nltrie',
        '\u22B4\u20D2': 'nvltrie',
        '\u22B5': 'rtrie',
        '\u22ED': 'nrtrie',
        '\u22B5\u20D2': 'nvrtrie',
        '\u22B6': 'origof',
        '\u22B7': 'imof',
        '\u22B8': 'mumap',
        '\u22B9': 'hercon',
        '\u22BA': 'intcal',
        '\u22BB': 'veebar',
        '\u22BD': 'barvee',
        '\u22BE': 'angrtvb',
        '\u22BF': 'lrtri',
        '\u22C0': 'Wedge',
        '\u22C1': 'Vee',
        '\u22C2': 'xcap',
        '\u22C3': 'xcup',
        '\u22C4': 'diam',
        '\u22C5': 'sdot',
        '\u22C6': 'Star',
        '\u22C7': 'divonx',
        '\u22C8': 'bowtie',
        '\u22C9': 'ltimes',
        '\u22CA': 'rtimes',
        '\u22CB': 'lthree',
        '\u22CC': 'rthree',
        '\u22CD': 'bsime',
        '\u22CE': 'cuvee',
        '\u22CF': 'cuwed',
        '\u22D0': 'Sub',
        '\u22D1': 'Sup',
        '\u22D2': 'Cap',
        '\u22D3': 'Cup',
        '\u22D4': 'fork',
        '\u22D5': 'epar',
        '\u22D6': 'ltdot',
        '\u22D7': 'gtdot',
        '\u22D8': 'Ll',
        '\u22D8\u0338': 'nLl',
        '\u22D9': 'Gg',
        '\u22D9\u0338': 'nGg',
        '\u22DA\uFE00': 'lesg',
        '\u22DA': 'leg',
        '\u22DB': 'gel',
        '\u22DB\uFE00': 'gesl',
        '\u22DE': 'cuepr',
        '\u22DF': 'cuesc',
        '\u22E6': 'lnsim',
        '\u22E7': 'gnsim',
        '\u22E8': 'prnsim',
        '\u22E9': 'scnsim',
        '\u22EE': 'vellip',
        '\u22EF': 'ctdot',
        '\u22F0': 'utdot',
        '\u22F1': 'dtdot',
        '\u22F2': 'disin',
        '\u22F3': 'isinsv',
        '\u22F4': 'isins',
        '\u22F5': 'isindot',
        '\u22F5\u0338': 'notindot',
        '\u22F6': 'notinvc',
        '\u22F7': 'notinvb',
        '\u22F9': 'isinE',
        '\u22F9\u0338': 'notinE',
        '\u22FA': 'nisd',
        '\u22FB': 'xnis',
        '\u22FC': 'nis',
        '\u22FD': 'notnivc',
        '\u22FE': 'notnivb',
        '\u2305': 'barwed',
        '\u2306': 'Barwed',
        '\u230C': 'drcrop',
        '\u230D': 'dlcrop',
        '\u230E': 'urcrop',
        '\u230F': 'ulcrop',
        '\u2310': 'bnot',
        '\u2312': 'profline',
        '\u2313': 'profsurf',
        '\u2315': 'telrec',
        '\u2316': 'target',
        '\u231C': 'ulcorn',
        '\u231D': 'urcorn',
        '\u231E': 'dlcorn',
        '\u231F': 'drcorn',
        '\u2322': 'frown',
        '\u2323': 'smile',
        '\u232D': 'cylcty',
        '\u232E': 'profalar',
        '\u2336': 'topbot',
        '\u233D': 'ovbar',
        '\u233F': 'solbar',
        '\u237C': 'angzarr',
        '\u23B0': 'lmoust',
        '\u23B1': 'rmoust',
        '\u23B4': 'tbrk',
        '\u23B5': 'bbrk',
        '\u23B6': 'bbrktbrk',
        '\u23DC': 'OverParenthesis',
        '\u23DD': 'UnderParenthesis',
        '\u23DE': 'OverBrace',
        '\u23DF': 'UnderBrace',
        '\u23E2': 'trpezium',
        '\u23E7': 'elinters',
        '\u2423': 'blank',
        '\u2500': 'boxh',
        '\u2502': 'boxv',
        '\u250C': 'boxdr',
        '\u2510': 'boxdl',
        '\u2514': 'boxur',
        '\u2518': 'boxul',
        '\u251C': 'boxvr',
        '\u2524': 'boxvl',
        '\u252C': 'boxhd',
        '\u2534': 'boxhu',
        '\u253C': 'boxvh',
        '\u2550': 'boxH',
        '\u2551': 'boxV',
        '\u2552': 'boxdR',
        '\u2553': 'boxDr',
        '\u2554': 'boxDR',
        '\u2555': 'boxdL',
        '\u2556': 'boxDl',
        '\u2557': 'boxDL',
        '\u2558': 'boxuR',
        '\u2559': 'boxUr',
        '\u255A': 'boxUR',
        '\u255B': 'boxuL',
        '\u255C': 'boxUl',
        '\u255D': 'boxUL',
        '\u255E': 'boxvR',
        '\u255F': 'boxVr',
        '\u2560': 'boxVR',
        '\u2561': 'boxvL',
        '\u2562': 'boxVl',
        '\u2563': 'boxVL',
        '\u2564': 'boxHd',
        '\u2565': 'boxhD',
        '\u2566': 'boxHD',
        '\u2567': 'boxHu',
        '\u2568': 'boxhU',
        '\u2569': 'boxHU',
        '\u256A': 'boxvH',
        '\u256B': 'boxVh',
        '\u256C': 'boxVH',
        '\u2580': 'uhblk',
        '\u2584': 'lhblk',
        '\u2588': 'block',
        '\u2591': 'blk14',
        '\u2592': 'blk12',
        '\u2593': 'blk34',
        '\u25A1': 'squ',
        '\u25AA': 'squf',
        '\u25AB': 'EmptyVerySmallSquare',
        '\u25AD': 'rect',
        '\u25AE': 'marker',
        '\u25B1': 'fltns',
        '\u25B3': 'xutri',
        '\u25B4': 'utrif',
        '\u25B5': 'utri',
        '\u25B8': 'rtrif',
        '\u25B9': 'rtri',
        '\u25BD': 'xdtri',
        '\u25BE': 'dtrif',
        '\u25BF': 'dtri',
        '\u25C2': 'ltrif',
        '\u25C3': 'ltri',
        '\u25CA': 'loz',
        '\u25CB': 'cir',
        '\u25EC': 'tridot',
        '\u25EF': 'xcirc',
        '\u25F8': 'ultri',
        '\u25F9': 'urtri',
        '\u25FA': 'lltri',
        '\u25FB': 'EmptySmallSquare',
        '\u25FC': 'FilledSmallSquare',
        '\u2605': 'starf',
        '\u2606': 'star',
        '\u260E': 'phone',
        '\u2640': 'female',
        '\u2642': 'male',
        '\u2660': 'spades',
        '\u2663': 'clubs',
        '\u2665': 'hearts',
        '\u2666': 'diams',
        '\u266A': 'sung',
        '\u2713': 'check',
        '\u2717': 'cross',
        '\u2720': 'malt',
        '\u2736': 'sext',
        '\u2758': 'VerticalSeparator',
        '\u27C8': 'bsolhsub',
        '\u27C9': 'suphsol',
        '\u27F5': 'xlarr',
        '\u27F6': 'xrarr',
        '\u27F7': 'xharr',
        '\u27F8': 'xlArr',
        '\u27F9': 'xrArr',
        '\u27FA': 'xhArr',
        '\u27FC': 'xmap',
        '\u27FF': 'dzigrarr',
        '\u2902': 'nvlArr',
        '\u2903': 'nvrArr',
        '\u2904': 'nvHarr',
        '\u2905': 'Map',
        '\u290C': 'lbarr',
        '\u290D': 'rbarr',
        '\u290E': 'lBarr',
        '\u290F': 'rBarr',
        '\u2910': 'RBarr',
        '\u2911': 'DDotrahd',
        '\u2912': 'UpArrowBar',
        '\u2913': 'DownArrowBar',
        '\u2916': 'Rarrtl',
        '\u2919': 'latail',
        '\u291A': 'ratail',
        '\u291B': 'lAtail',
        '\u291C': 'rAtail',
        '\u291D': 'larrfs',
        '\u291E': 'rarrfs',
        '\u291F': 'larrbfs',
        '\u2920': 'rarrbfs',
        '\u2923': 'nwarhk',
        '\u2924': 'nearhk',
        '\u2925': 'searhk',
        '\u2926': 'swarhk',
        '\u2927': 'nwnear',
        '\u2928': 'toea',
        '\u2929': 'tosa',
        '\u292A': 'swnwar',
        '\u2933': 'rarrc',
        '\u2933\u0338': 'nrarrc',
        '\u2935': 'cudarrr',
        '\u2936': 'ldca',
        '\u2937': 'rdca',
        '\u2938': 'cudarrl',
        '\u2939': 'larrpl',
        '\u293C': 'curarrm',
        '\u293D': 'cularrp',
        '\u2945': 'rarrpl',
        '\u2948': 'harrcir',
        '\u2949': 'Uarrocir',
        '\u294A': 'lurdshar',
        '\u294B': 'ldrushar',
        '\u294E': 'LeftRightVector',
        '\u294F': 'RightUpDownVector',
        '\u2950': 'DownLeftRightVector',
        '\u2951': 'LeftUpDownVector',
        '\u2952': 'LeftVectorBar',
        '\u2953': 'RightVectorBar',
        '\u2954': 'RightUpVectorBar',
        '\u2955': 'RightDownVectorBar',
        '\u2956': 'DownLeftVectorBar',
        '\u2957': 'DownRightVectorBar',
        '\u2958': 'LeftUpVectorBar',
        '\u2959': 'LeftDownVectorBar',
        '\u295A': 'LeftTeeVector',
        '\u295B': 'RightTeeVector',
        '\u295C': 'RightUpTeeVector',
        '\u295D': 'RightDownTeeVector',
        '\u295E': 'DownLeftTeeVector',
        '\u295F': 'DownRightTeeVector',
        '\u2960': 'LeftUpTeeVector',
        '\u2961': 'LeftDownTeeVector',
        '\u2962': 'lHar',
        '\u2963': 'uHar',
        '\u2964': 'rHar',
        '\u2965': 'dHar',
        '\u2966': 'luruhar',
        '\u2967': 'ldrdhar',
        '\u2968': 'ruluhar',
        '\u2969': 'rdldhar',
        '\u296A': 'lharul',
        '\u296B': 'llhard',
        '\u296C': 'rharul',
        '\u296D': 'lrhard',
        '\u296E': 'udhar',
        '\u296F': 'duhar',
        '\u2970': 'RoundImplies',
        '\u2971': 'erarr',
        '\u2972': 'simrarr',
        '\u2973': 'larrsim',
        '\u2974': 'rarrsim',
        '\u2975': 'rarrap',
        '\u2976': 'ltlarr',
        '\u2978': 'gtrarr',
        '\u2979': 'subrarr',
        '\u297B': 'suplarr',
        '\u297C': 'lfisht',
        '\u297D': 'rfisht',
        '\u297E': 'ufisht',
        '\u297F': 'dfisht',
        '\u299A': 'vzigzag',
        '\u299C': 'vangrt',
        '\u299D': 'angrtvbd',
        '\u29A4': 'ange',
        '\u29A5': 'range',
        '\u29A6': 'dwangle',
        '\u29A7': 'uwangle',
        '\u29A8': 'angmsdaa',
        '\u29A9': 'angmsdab',
        '\u29AA': 'angmsdac',
        '\u29AB': 'angmsdad',
        '\u29AC': 'angmsdae',
        '\u29AD': 'angmsdaf',
        '\u29AE': 'angmsdag',
        '\u29AF': 'angmsdah',
        '\u29B0': 'bemptyv',
        '\u29B1': 'demptyv',
        '\u29B2': 'cemptyv',
        '\u29B3': 'raemptyv',
        '\u29B4': 'laemptyv',
        '\u29B5': 'ohbar',
        '\u29B6': 'omid',
        '\u29B7': 'opar',
        '\u29B9': 'operp',
        '\u29BB': 'olcross',
        '\u29BC': 'odsold',
        '\u29BE': 'olcir',
        '\u29BF': 'ofcir',
        '\u29C0': 'olt',
        '\u29C1': 'ogt',
        '\u29C2': 'cirscir',
        '\u29C3': 'cirE',
        '\u29C4': 'solb',
        '\u29C5': 'bsolb',
        '\u29C9': 'boxbox',
        '\u29CD': 'trisb',
        '\u29CE': 'rtriltri',
        '\u29CF': 'LeftTriangleBar',
        '\u29CF\u0338': 'NotLeftTriangleBar',
        '\u29D0': 'RightTriangleBar',
        '\u29D0\u0338': 'NotRightTriangleBar',
        '\u29DC': 'iinfin',
        '\u29DD': 'infintie',
        '\u29DE': 'nvinfin',
        '\u29E3': 'eparsl',
        '\u29E4': 'smeparsl',
        '\u29E5': 'eqvparsl',
        '\u29EB': 'lozf',
        '\u29F4': 'RuleDelayed',
        '\u29F6': 'dsol',
        '\u2A00': 'xodot',
        '\u2A01': 'xoplus',
        '\u2A02': 'xotime',
        '\u2A04': 'xuplus',
        '\u2A06': 'xsqcup',
        '\u2A0D': 'fpartint',
        '\u2A10': 'cirfnint',
        '\u2A11': 'awint',
        '\u2A12': 'rppolint',
        '\u2A13': 'scpolint',
        '\u2A14': 'npolint',
        '\u2A15': 'pointint',
        '\u2A16': 'quatint',
        '\u2A17': 'intlarhk',
        '\u2A22': 'pluscir',
        '\u2A23': 'plusacir',
        '\u2A24': 'simplus',
        '\u2A25': 'plusdu',
        '\u2A26': 'plussim',
        '\u2A27': 'plustwo',
        '\u2A29': 'mcomma',
        '\u2A2A': 'minusdu',
        '\u2A2D': 'loplus',
        '\u2A2E': 'roplus',
        '\u2A2F': 'Cross',
        '\u2A30': 'timesd',
        '\u2A31': 'timesbar',
        '\u2A33': 'smashp',
        '\u2A34': 'lotimes',
        '\u2A35': 'rotimes',
        '\u2A36': 'otimesas',
        '\u2A37': 'Otimes',
        '\u2A38': 'odiv',
        '\u2A39': 'triplus',
        '\u2A3A': 'triminus',
        '\u2A3B': 'tritime',
        '\u2A3C': 'iprod',
        '\u2A3F': 'amalg',
        '\u2A40': 'capdot',
        '\u2A42': 'ncup',
        '\u2A43': 'ncap',
        '\u2A44': 'capand',
        '\u2A45': 'cupor',
        '\u2A46': 'cupcap',
        '\u2A47': 'capcup',
        '\u2A48': 'cupbrcap',
        '\u2A49': 'capbrcup',
        '\u2A4A': 'cupcup',
        '\u2A4B': 'capcap',
        '\u2A4C': 'ccups',
        '\u2A4D': 'ccaps',
        '\u2A50': 'ccupssm',
        '\u2A53': 'And',
        '\u2A54': 'Or',
        '\u2A55': 'andand',
        '\u2A56': 'oror',
        '\u2A57': 'orslope',
        '\u2A58': 'andslope',
        '\u2A5A': 'andv',
        '\u2A5B': 'orv',
        '\u2A5C': 'andd',
        '\u2A5D': 'ord',
        '\u2A5F': 'wedbar',
        '\u2A66': 'sdote',
        '\u2A6A': 'simdot',
        '\u2A6D': 'congdot',
        '\u2A6D\u0338': 'ncongdot',
        '\u2A6E': 'easter',
        '\u2A6F': 'apacir',
        '\u2A70': 'apE',
        '\u2A70\u0338': 'napE',
        '\u2A71': 'eplus',
        '\u2A72': 'pluse',
        '\u2A73': 'Esim',
        '\u2A77': 'eDDot',
        '\u2A78': 'equivDD',
        '\u2A79': 'ltcir',
        '\u2A7A': 'gtcir',
        '\u2A7B': 'ltquest',
        '\u2A7C': 'gtquest',
        '\u2A7D': 'les',
        '\u2A7D\u0338': 'nles',
        '\u2A7E': 'ges',
        '\u2A7E\u0338': 'nges',
        '\u2A7F': 'lesdot',
        '\u2A80': 'gesdot',
        '\u2A81': 'lesdoto',
        '\u2A82': 'gesdoto',
        '\u2A83': 'lesdotor',
        '\u2A84': 'gesdotol',
        '\u2A85': 'lap',
        '\u2A86': 'gap',
        '\u2A87': 'lne',
        '\u2A88': 'gne',
        '\u2A89': 'lnap',
        '\u2A8A': 'gnap',
        '\u2A8B': 'lEg',
        '\u2A8C': 'gEl',
        '\u2A8D': 'lsime',
        '\u2A8E': 'gsime',
        '\u2A8F': 'lsimg',
        '\u2A90': 'gsiml',
        '\u2A91': 'lgE',
        '\u2A92': 'glE',
        '\u2A93': 'lesges',
        '\u2A94': 'gesles',
        '\u2A95': 'els',
        '\u2A96': 'egs',
        '\u2A97': 'elsdot',
        '\u2A98': 'egsdot',
        '\u2A99': 'el',
        '\u2A9A': 'eg',
        '\u2A9D': 'siml',
        '\u2A9E': 'simg',
        '\u2A9F': 'simlE',
        '\u2AA0': 'simgE',
        '\u2AA1': 'LessLess',
        '\u2AA1\u0338': 'NotNestedLessLess',
        '\u2AA2': 'GreaterGreater',
        '\u2AA2\u0338': 'NotNestedGreaterGreater',
        '\u2AA4': 'glj',
        '\u2AA5': 'gla',
        '\u2AA6': 'ltcc',
        '\u2AA7': 'gtcc',
        '\u2AA8': 'lescc',
        '\u2AA9': 'gescc',
        '\u2AAA': 'smt',
        '\u2AAB': 'lat',
        '\u2AAC': 'smte',
        '\u2AAC\uFE00': 'smtes',
        '\u2AAD': 'late',
        '\u2AAD\uFE00': 'lates',
        '\u2AAE': 'bumpE',
        '\u2AAF': 'pre',
        '\u2AAF\u0338': 'npre',
        '\u2AB0': 'sce',
        '\u2AB0\u0338': 'nsce',
        '\u2AB3': 'prE',
        '\u2AB4': 'scE',
        '\u2AB5': 'prnE',
        '\u2AB6': 'scnE',
        '\u2AB7': 'prap',
        '\u2AB8': 'scap',
        '\u2AB9': 'prnap',
        '\u2ABA': 'scnap',
        '\u2ABB': 'Pr',
        '\u2ABC': 'Sc',
        '\u2ABD': 'subdot',
        '\u2ABE': 'supdot',
        '\u2ABF': 'subplus',
        '\u2AC0': 'supplus',
        '\u2AC1': 'submult',
        '\u2AC2': 'supmult',
        '\u2AC3': 'subedot',
        '\u2AC4': 'supedot',
        '\u2AC5': 'subE',
        '\u2AC5\u0338': 'nsubE',
        '\u2AC6': 'supE',
        '\u2AC6\u0338': 'nsupE',
        '\u2AC7': 'subsim',
        '\u2AC8': 'supsim',
        '\u2ACB\uFE00': 'vsubnE',
        '\u2ACB': 'subnE',
        '\u2ACC\uFE00': 'vsupnE',
        '\u2ACC': 'supnE',
        '\u2ACF': 'csub',
        '\u2AD0': 'csup',
        '\u2AD1': 'csube',
        '\u2AD2': 'csupe',
        '\u2AD3': 'subsup',
        '\u2AD4': 'supsub',
        '\u2AD5': 'subsub',
        '\u2AD6': 'supsup',
        '\u2AD7': 'suphsub',
        '\u2AD8': 'supdsub',
        '\u2AD9': 'forkv',
        '\u2ADA': 'topfork',
        '\u2ADB': 'mlcp',
        '\u2AE4': 'Dashv',
        '\u2AE6': 'Vdashl',
        '\u2AE7': 'Barv',
        '\u2AE8': 'vBar',
        '\u2AE9': 'vBarv',
        '\u2AEB': 'Vbar',
        '\u2AEC': 'Not',
        '\u2AED': 'bNot',
        '\u2AEE': 'rnmid',
        '\u2AEF': 'cirmid',
        '\u2AF0': 'midcir',
        '\u2AF1': 'topcir',
        '\u2AF2': 'nhpar',
        '\u2AF3': 'parsim',
        '\u2AFD': 'parsl',
        '\u2AFD\u20E5': 'nparsl',
        '\u266D': 'flat',
        '\u266E': 'natur',
        '\u266F': 'sharp',
        '\xA4': 'curren',
        '\xA2': 'cent',
        '$': 'dollar',
        '\xA3': 'pound',
        '\xA5': 'yen',
        '\u20AC': 'euro',
        '\xB9': 'sup1',
        '\xBD': 'half',
        '\u2153': 'frac13',
        '\xBC': 'frac14',
        '\u2155': 'frac15',
        '\u2159': 'frac16',
        '\u215B': 'frac18',
        '\xB2': 'sup2',
        '\u2154': 'frac23',
        '\u2156': 'frac25',
        '\xB3': 'sup3',
        '\xBE': 'frac34',
        '\u2157': 'frac35',
        '\u215C': 'frac38',
        '\u2158': 'frac45',
        '\u215A': 'frac56',
        '\u215D': 'frac58',
        '\u215E': 'frac78',
        '\uD835\uDCB6': 'ascr',
        '\uD835\uDD52': 'aopf',
        '\uD835\uDD1E': 'afr',
        '\uD835\uDD38': 'Aopf',
        '\uD835\uDD04': 'Afr',
        '\uD835\uDC9C': 'Ascr',
        '\xAA': 'ordf',
        '\xE1': 'aacute',
        '\xC1': 'Aacute',
        '\xE0': 'agrave',
        '\xC0': 'Agrave',
        '\u0103': 'abreve',
        '\u0102': 'Abreve',
        '\xE2': 'acirc',
        '\xC2': 'Acirc',
        '\xE5': 'aring',
        '\xC5': 'angst',
        '\xE4': 'auml',
        '\xC4': 'Auml',
        '\xE3': 'atilde',
        '\xC3': 'Atilde',
        '\u0105': 'aogon',
        '\u0104': 'Aogon',
        '\u0101': 'amacr',
        '\u0100': 'Amacr',
        '\xE6': 'aelig',
        '\xC6': 'AElig',
        '\uD835\uDCB7': 'bscr',
        '\uD835\uDD53': 'bopf',
        '\uD835\uDD1F': 'bfr',
        '\uD835\uDD39': 'Bopf',
        '\u212C': 'Bscr',
        '\uD835\uDD05': 'Bfr',
        '\uD835\uDD20': 'cfr',
        '\uD835\uDCB8': 'cscr',
        '\uD835\uDD54': 'copf',
        '\u212D': 'Cfr',
        '\uD835\uDC9E': 'Cscr',
        '\u2102': 'Copf',
        '\u0107': 'cacute',
        '\u0106': 'Cacute',
        '\u0109': 'ccirc',
        '\u0108': 'Ccirc',
        '\u010D': 'ccaron',
        '\u010C': 'Ccaron',
        '\u010B': 'cdot',
        '\u010A': 'Cdot',
        '\xE7': 'ccedil',
        '\xC7': 'Ccedil',
        '\u2105': 'incare',
        '\uD835\uDD21': 'dfr',
        '\u2146': 'dd',
        '\uD835\uDD55': 'dopf',
        '\uD835\uDCB9': 'dscr',
        '\uD835\uDC9F': 'Dscr',
        '\uD835\uDD07': 'Dfr',
        '\u2145': 'DD',
        '\uD835\uDD3B': 'Dopf',
        '\u010F': 'dcaron',
        '\u010E': 'Dcaron',
        '\u0111': 'dstrok',
        '\u0110': 'Dstrok',
        '\xF0': 'eth',
        '\xD0': 'ETH',
        '\u2147': 'ee',
        '\u212F': 'escr',
        '\uD835\uDD22': 'efr',
        '\uD835\uDD56': 'eopf',
        '\u2130': 'Escr',
        '\uD835\uDD08': 'Efr',
        '\uD835\uDD3C': 'Eopf',
        '\xE9': 'eacute',
        '\xC9': 'Eacute',
        '\xE8': 'egrave',
        '\xC8': 'Egrave',
        '\xEA': 'ecirc',
        '\xCA': 'Ecirc',
        '\u011B': 'ecaron',
        '\u011A': 'Ecaron',
        '\xEB': 'euml',
        '\xCB': 'Euml',
        '\u0117': 'edot',
        '\u0116': 'Edot',
        '\u0119': 'eogon',
        '\u0118': 'Eogon',
        '\u0113': 'emacr',
        '\u0112': 'Emacr',
        '\uD835\uDD23': 'ffr',
        '\uD835\uDD57': 'fopf',
        '\uD835\uDCBB': 'fscr',
        '\uD835\uDD09': 'Ffr',
        '\uD835\uDD3D': 'Fopf',
        '\u2131': 'Fscr',
        '\uFB00': 'fflig',
        '\uFB03': 'ffilig',
        '\uFB04': 'ffllig',
        '\uFB01': 'filig',
        'fj': 'fjlig',
        '\uFB02': 'fllig',
        '\u0192': 'fnof',
        '\u210A': 'gscr',
        '\uD835\uDD58': 'gopf',
        '\uD835\uDD24': 'gfr',
        '\uD835\uDCA2': 'Gscr',
        '\uD835\uDD3E': 'Gopf',
        '\uD835\uDD0A': 'Gfr',
        '\u01F5': 'gacute',
        '\u011F': 'gbreve',
        '\u011E': 'Gbreve',
        '\u011D': 'gcirc',
        '\u011C': 'Gcirc',
        '\u0121': 'gdot',
        '\u0120': 'Gdot',
        '\u0122': 'Gcedil',
        '\uD835\uDD25': 'hfr',
        '\u210E': 'planckh',
        '\uD835\uDCBD': 'hscr',
        '\uD835\uDD59': 'hopf',
        '\u210B': 'Hscr',
        '\u210C': 'Hfr',
        '\u210D': 'Hopf',
        '\u0125': 'hcirc',
        '\u0124': 'Hcirc',
        '\u210F': 'hbar',
        '\u0127': 'hstrok',
        '\u0126': 'Hstrok',
        '\uD835\uDD5A': 'iopf',
        '\uD835\uDD26': 'ifr',
        '\uD835\uDCBE': 'iscr',
        '\u2148': 'ii',
        '\uD835\uDD40': 'Iopf',
        '\u2110': 'Iscr',
        '\u2111': 'Im',
        '\xED': 'iacute',
        '\xCD': 'Iacute',
        '\xEC': 'igrave',
        '\xCC': 'Igrave',
        '\xEE': 'icirc',
        '\xCE': 'Icirc',
        '\xEF': 'iuml',
        '\xCF': 'Iuml',
        '\u0129': 'itilde',
        '\u0128': 'Itilde',
        '\u0130': 'Idot',
        '\u012F': 'iogon',
        '\u012E': 'Iogon',
        '\u012B': 'imacr',
        '\u012A': 'Imacr',
        '\u0133': 'ijlig',
        '\u0132': 'IJlig',
        '\u0131': 'imath',
        '\uD835\uDCBF': 'jscr',
        '\uD835\uDD5B': 'jopf',
        '\uD835\uDD27': 'jfr',
        '\uD835\uDCA5': 'Jscr',
        '\uD835\uDD0D': 'Jfr',
        '\uD835\uDD41': 'Jopf',
        '\u0135': 'jcirc',
        '\u0134': 'Jcirc',
        '\u0237': 'jmath',
        '\uD835\uDD5C': 'kopf',
        '\uD835\uDCC0': 'kscr',
        '\uD835\uDD28': 'kfr',
        '\uD835\uDCA6': 'Kscr',
        '\uD835\uDD42': 'Kopf',
        '\uD835\uDD0E': 'Kfr',
        '\u0137': 'kcedil',
        '\u0136': 'Kcedil',
        '\uD835\uDD29': 'lfr',
        '\uD835\uDCC1': 'lscr',
        '\u2113': 'ell',
        '\uD835\uDD5D': 'lopf',
        '\u2112': 'Lscr',
        '\uD835\uDD0F': 'Lfr',
        '\uD835\uDD43': 'Lopf',
        '\u013A': 'lacute',
        '\u0139': 'Lacute',
        '\u013E': 'lcaron',
        '\u013D': 'Lcaron',
        '\u013C': 'lcedil',
        '\u013B': 'Lcedil',
        '\u0142': 'lstrok',
        '\u0141': 'Lstrok',
        '\u0140': 'lmidot',
        '\u013F': 'Lmidot',
        '\uD835\uDD2A': 'mfr',
        '\uD835\uDD5E': 'mopf',
        '\uD835\uDCC2': 'mscr',
        '\uD835\uDD10': 'Mfr',
        '\uD835\uDD44': 'Mopf',
        '\u2133': 'Mscr',
        '\uD835\uDD2B': 'nfr',
        '\uD835\uDD5F': 'nopf',
        '\uD835\uDCC3': 'nscr',
        '\u2115': 'Nopf',
        '\uD835\uDCA9': 'Nscr',
        '\uD835\uDD11': 'Nfr',
        '\u0144': 'nacute',
        '\u0143': 'Nacute',
        '\u0148': 'ncaron',
        '\u0147': 'Ncaron',
        '\xF1': 'ntilde',
        '\xD1': 'Ntilde',
        '\u0146': 'ncedil',
        '\u0145': 'Ncedil',
        '\u2116': 'numero',
        '\u014B': 'eng',
        '\u014A': 'ENG',
        '\uD835\uDD60': 'oopf',
        '\uD835\uDD2C': 'ofr',
        '\u2134': 'oscr',
        '\uD835\uDCAA': 'Oscr',
        '\uD835\uDD12': 'Ofr',
        '\uD835\uDD46': 'Oopf',
        '\xBA': 'ordm',
        '\xF3': 'oacute',
        '\xD3': 'Oacute',
        '\xF2': 'ograve',
        '\xD2': 'Ograve',
        '\xF4': 'ocirc',
        '\xD4': 'Ocirc',
        '\xF6': 'ouml',
        '\xD6': 'Ouml',
        '\u0151': 'odblac',
        '\u0150': 'Odblac',
        '\xF5': 'otilde',
        '\xD5': 'Otilde',
        '\xF8': 'oslash',
        '\xD8': 'Oslash',
        '\u014D': 'omacr',
        '\u014C': 'Omacr',
        '\u0153': 'oelig',
        '\u0152': 'OElig',
        '\uD835\uDD2D': 'pfr',
        '\uD835\uDCC5': 'pscr',
        '\uD835\uDD61': 'popf',
        '\u2119': 'Popf',
        '\uD835\uDD13': 'Pfr',
        '\uD835\uDCAB': 'Pscr',
        '\uD835\uDD62': 'qopf',
        '\uD835\uDD2E': 'qfr',
        '\uD835\uDCC6': 'qscr',
        '\uD835\uDCAC': 'Qscr',
        '\uD835\uDD14': 'Qfr',
        '\u211A': 'Qopf',
        '\u0138': 'kgreen',
        '\uD835\uDD2F': 'rfr',
        '\uD835\uDD63': 'ropf',
        '\uD835\uDCC7': 'rscr',
        '\u211B': 'Rscr',
        '\u211C': 'Re',
        '\u211D': 'Ropf',
        '\u0155': 'racute',
        '\u0154': 'Racute',
        '\u0159': 'rcaron',
        '\u0158': 'Rcaron',
        '\u0157': 'rcedil',
        '\u0156': 'Rcedil',
        '\uD835\uDD64': 'sopf',
        '\uD835\uDCC8': 'sscr',
        '\uD835\uDD30': 'sfr',
        '\uD835\uDD4A': 'Sopf',
        '\uD835\uDD16': 'Sfr',
        '\uD835\uDCAE': 'Sscr',
        '\u24C8': 'oS',
        '\u015B': 'sacute',
        '\u015A': 'Sacute',
        '\u015D': 'scirc',
        '\u015C': 'Scirc',
        '\u0161': 'scaron',
        '\u0160': 'Scaron',
        '\u015F': 'scedil',
        '\u015E': 'Scedil',
        '\xDF': 'szlig',
        '\uD835\uDD31': 'tfr',
        '\uD835\uDCC9': 'tscr',
        '\uD835\uDD65': 'topf',
        '\uD835\uDCAF': 'Tscr',
        '\uD835\uDD17': 'Tfr',
        '\uD835\uDD4B': 'Topf',
        '\u0165': 'tcaron',
        '\u0164': 'Tcaron',
        '\u0163': 'tcedil',
        '\u0162': 'Tcedil',
        '\u2122': 'trade',
        '\u0167': 'tstrok',
        '\u0166': 'Tstrok',
        '\uD835\uDCCA': 'uscr',
        '\uD835\uDD66': 'uopf',
        '\uD835\uDD32': 'ufr',
        '\uD835\uDD4C': 'Uopf',
        '\uD835\uDD18': 'Ufr',
        '\uD835\uDCB0': 'Uscr',
        '\xFA': 'uacute',
        '\xDA': 'Uacute',
        '\xF9': 'ugrave',
        '\xD9': 'Ugrave',
        '\u016D': 'ubreve',
        '\u016C': 'Ubreve',
        '\xFB': 'ucirc',
        '\xDB': 'Ucirc',
        '\u016F': 'uring',
        '\u016E': 'Uring',
        '\xFC': 'uuml',
        '\xDC': 'Uuml',
        '\u0171': 'udblac',
        '\u0170': 'Udblac',
        '\u0169': 'utilde',
        '\u0168': 'Utilde',
        '\u0173': 'uogon',
        '\u0172': 'Uogon',
        '\u016B': 'umacr',
        '\u016A': 'Umacr',
        '\uD835\uDD33': 'vfr',
        '\uD835\uDD67': 'vopf',
        '\uD835\uDCCB': 'vscr',
        '\uD835\uDD19': 'Vfr',
        '\uD835\uDD4D': 'Vopf',
        '\uD835\uDCB1': 'Vscr',
        '\uD835\uDD68': 'wopf',
        '\uD835\uDCCC': 'wscr',
        '\uD835\uDD34': 'wfr',
        '\uD835\uDCB2': 'Wscr',
        '\uD835\uDD4E': 'Wopf',
        '\uD835\uDD1A': 'Wfr',
        '\u0175': 'wcirc',
        '\u0174': 'Wcirc',
        '\uD835\uDD35': 'xfr',
        '\uD835\uDCCD': 'xscr',
        '\uD835\uDD69': 'xopf',
        '\uD835\uDD4F': 'Xopf',
        '\uD835\uDD1B': 'Xfr',
        '\uD835\uDCB3': 'Xscr',
        '\uD835\uDD36': 'yfr',
        '\uD835\uDCCE': 'yscr',
        '\uD835\uDD6A': 'yopf',
        '\uD835\uDCB4': 'Yscr',
        '\uD835\uDD1C': 'Yfr',
        '\uD835\uDD50': 'Yopf',
        '\xFD': 'yacute',
        '\xDD': 'Yacute',
        '\u0177': 'ycirc',
        '\u0176': 'Ycirc',
        '\xFF': 'yuml',
        '\u0178': 'Yuml',
        '\uD835\uDCCF': 'zscr',
        '\uD835\uDD37': 'zfr',
        '\uD835\uDD6B': 'zopf',
        '\u2128': 'Zfr',
        '\u2124': 'Zopf',
        '\uD835\uDCB5': 'Zscr',
        '\u017A': 'zacute',
        '\u0179': 'Zacute',
        '\u017E': 'zcaron',
        '\u017D': 'Zcaron',
        '\u017C': 'zdot',
        '\u017B': 'Zdot',
        '\u01B5': 'imped',
        '\xFE': 'thorn',
        '\xDE': 'THORN',
        '\u0149': 'napos',
        '\u03B1': 'alpha',
        '\u0391': 'Alpha',
        '\u03B2': 'beta',
        '\u0392': 'Beta',
        '\u03B3': 'gamma',
        '\u0393': 'Gamma',
        '\u03B4': 'delta',
        '\u0394': 'Delta',
        '\u03B5': 'epsi',
        '\u03F5': 'epsiv',
        '\u0395': 'Epsilon',
        '\u03DD': 'gammad',
        '\u03DC': 'Gammad',
        '\u03B6': 'zeta',
        '\u0396': 'Zeta',
        '\u03B7': 'eta',
        '\u0397': 'Eta',
        '\u03B8': 'theta',
        '\u03D1': 'thetav',
        '\u0398': 'Theta',
        '\u03B9': 'iota',
        '\u0399': 'Iota',
        '\u03BA': 'kappa',
        '\u03F0': 'kappav',
        '\u039A': 'Kappa',
        '\u03BB': 'lambda',
        '\u039B': 'Lambda',
        '\u03BC': 'mu',
        '\xB5': 'micro',
        '\u039C': 'Mu',
        '\u03BD': 'nu',
        '\u039D': 'Nu',
        '\u03BE': 'xi',
        '\u039E': 'Xi',
        '\u03BF': 'omicron',
        '\u039F': 'Omicron',
        '\u03C0': 'pi',
        '\u03D6': 'piv',
        '\u03A0': 'Pi',
        '\u03C1': 'rho',
        '\u03F1': 'rhov',
        '\u03A1': 'Rho',
        '\u03C3': 'sigma',
        '\u03A3': 'Sigma',
        '\u03C2': 'sigmaf',
        '\u03C4': 'tau',
        '\u03A4': 'Tau',
        '\u03C5': 'upsi',
        '\u03A5': 'Upsilon',
        '\u03D2': 'Upsi',
        '\u03C6': 'phi',
        '\u03D5': 'phiv',
        '\u03A6': 'Phi',
        '\u03C7': 'chi',
        '\u03A7': 'Chi',
        '\u03C8': 'psi',
        '\u03A8': 'Psi',
        '\u03C9': 'omega',
        '\u03A9': 'ohm',
        '\u0430': 'acy',
        '\u0410': 'Acy',
        '\u0431': 'bcy',
        '\u0411': 'Bcy',
        '\u0432': 'vcy',
        '\u0412': 'Vcy',
        '\u0433': 'gcy',
        '\u0413': 'Gcy',
        '\u0453': 'gjcy',
        '\u0403': 'GJcy',
        '\u0434': 'dcy',
        '\u0414': 'Dcy',
        '\u0452': 'djcy',
        '\u0402': 'DJcy',
        '\u0435': 'iecy',
        '\u0415': 'IEcy',
        '\u0451': 'iocy',
        '\u0401': 'IOcy',
        '\u0454': 'jukcy',
        '\u0404': 'Jukcy',
        '\u0436': 'zhcy',
        '\u0416': 'ZHcy',
        '\u0437': 'zcy',
        '\u0417': 'Zcy',
        '\u0455': 'dscy',
        '\u0405': 'DScy',
        '\u0438': 'icy',
        '\u0418': 'Icy',
        '\u0456': 'iukcy',
        '\u0406': 'Iukcy',
        '\u0457': 'yicy',
        '\u0407': 'YIcy',
        '\u0439': 'jcy',
        '\u0419': 'Jcy',
        '\u0458': 'jsercy',
        '\u0408': 'Jsercy',
        '\u043A': 'kcy',
        '\u041A': 'Kcy',
        '\u045C': 'kjcy',
        '\u040C': 'KJcy',
        '\u043B': 'lcy',
        '\u041B': 'Lcy',
        '\u0459': 'ljcy',
        '\u0409': 'LJcy',
        '\u043C': 'mcy',
        '\u041C': 'Mcy',
        '\u043D': 'ncy',
        '\u041D': 'Ncy',
        '\u045A': 'njcy',
        '\u040A': 'NJcy',
        '\u043E': 'ocy',
        '\u041E': 'Ocy',
        '\u043F': 'pcy',
        '\u041F': 'Pcy',
        '\u0440': 'rcy',
        '\u0420': 'Rcy',
        '\u0441': 'scy',
        '\u0421': 'Scy',
        '\u0442': 'tcy',
        '\u0422': 'Tcy',
        '\u045B': 'tshcy',
        '\u040B': 'TSHcy',
        '\u0443': 'ucy',
        '\u0423': 'Ucy',
        '\u045E': 'ubrcy',
        '\u040E': 'Ubrcy',
        '\u0444': 'fcy',
        '\u0424': 'Fcy',
        '\u0445': 'khcy',
        '\u0425': 'KHcy',
        '\u0446': 'tscy',
        '\u0426': 'TScy',
        '\u0447': 'chcy',
        '\u0427': 'CHcy',
        '\u045F': 'dzcy',
        '\u040F': 'DZcy',
        '\u0448': 'shcy',
        '\u0428': 'SHcy',
        '\u0449': 'shchcy',
        '\u0429': 'SHCHcy',
        '\u044A': 'hardcy',
        '\u042A': 'HARDcy',
        '\u044B': 'ycy',
        '\u042B': 'Ycy',
        '\u044C': 'softcy',
        '\u042C': 'SOFTcy',
        '\u044D': 'ecy',
        '\u042D': 'Ecy',
        '\u044E': 'yucy',
        '\u042E': 'YUcy',
        '\u044F': 'yacy',
        '\u042F': 'YAcy',
        '\u2135': 'aleph',
        '\u2136': 'beth',
        '\u2137': 'gimel',
        '\u2138': 'daleth'
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': '&quot;',
        '&': '&amp;',
        '\'': '&#x27;',
        '<': '&lt;',
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        '>': '&gt;',
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        '`': '&#x60;'
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'abreve': '\u0103',
        'Abreve': '\u0102',
        'ac': '\u223E',
        'acd': '\u223F',
        'acE': '\u223E\u0333',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'acy': '\u0430',
        'Acy': '\u0410',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'af': '\u2061',
        'afr': '\uD835\uDD1E',
        'Afr': '\uD835\uDD04',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'alefsym': '\u2135',
        'aleph': '\u2135',
        'alpha': '\u03B1',
        'Alpha': '\u0391',
        'amacr': '\u0101',
        'Amacr': '\u0100',
        'amalg': '\u2A3F',
        'amp': '&',
        'AMP': '&',
        'and': '\u2227',
        'And': '\u2A53',
        'andand': '\u2A55',
        'andd': '\u2A5C',
        'andslope': '\u2A58',
        'andv': '\u2A5A',
        'ang': '\u2220',
        'ange': '\u29A4',
        'angle': '\u2220',
        'angmsd': '\u2221',
        'angmsdaa': '\u29A8',
        'angmsdab': '\u29A9',
        'angmsdac': '\u29AA',
        'angmsdad': '\u29AB',
        'angmsdae': '\u29AC',
        'angmsdaf': '\u29AD',
        'angmsdag': '\u29AE',
        'angmsdah': '\u29AF',
        'angrt': '\u221F',
        'angrtvb': '\u22BE',
        'angrtvbd': '\u299D',
        'angsph': '\u2222',
        'angst': '\xC5',
        'angzarr': '\u237C',
        'aogon': '\u0105',
        'Aogon': '\u0104',
        'aopf': '\uD835\uDD52',
        'Aopf': '\uD835\uDD38',
        'ap': '\u2248',
        'apacir': '\u2A6F',
        'ape': '\u224A',
        'apE': '\u2A70',
        'apid': '\u224B',
        'apos': '\'',
        'ApplyFunction': '\u2061',
        'approx': '\u2248',
        'approxeq': '\u224A',
        'aring': '\xE5',
        'Aring': '\xC5',
        'ascr': '\uD835\uDCB6',
        'Ascr': '\uD835\uDC9C',
        'Assign': '\u2254',
        'ast': '*',
        'asymp': '\u2248',
        'asympeq': '\u224D',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'awconint': '\u2233',
        'awint': '\u2A11',
        'backcong': '\u224C',
        'backepsilon': '\u03F6',
        'backprime': '\u2035',
        'backsim': '\u223D',
        'backsimeq': '\u22CD',
        'Backslash': '\u2216',
        'Barv': '\u2AE7',
        'barvee': '\u22BD',
        'barwed': '\u2305',
        'Barwed': '\u2306',
        'barwedge': '\u2305',
        'bbrk': '\u23B5',
        'bbrktbrk': '\u23B6',
        'bcong': '\u224C',
        'bcy': '\u0431',
        'Bcy': '\u0411',
        'bdquo': '\u201E',
        'becaus': '\u2235',
        'because': '\u2235',
        'Because': '\u2235',
        'bemptyv': '\u29B0',
        'bepsi': '\u03F6',
        'bernou': '\u212C',
        'Bernoullis': '\u212C',
        'beta': '\u03B2',
        'Beta': '\u0392',
        'beth': '\u2136',
        'between': '\u226C',
        'bfr': '\uD835\uDD1F',
        'Bfr': '\uD835\uDD05',
        'bigcap': '\u22C2',
        'bigcirc': '\u25EF',
        'bigcup': '\u22C3',
        'bigodot': '\u2A00',
        'bigoplus': '\u2A01',
        'bigotimes': '\u2A02',
        'bigsqcup': '\u2A06',
        'bigstar': '\u2605',
        'bigtriangledown': '\u25BD',
        'bigtriangleup': '\u25B3',
        'biguplus': '\u2A04',
        'bigvee': '\u22C1',
        'bigwedge': '\u22C0',
        'bkarow': '\u290D',
        'blacklozenge': '\u29EB',
        'blacksquare': '\u25AA',
        'blacktriangle': '\u25B4',
        'blacktriangledown': '\u25BE',
        'blacktriangleleft': '\u25C2',
        'blacktriangleright': '\u25B8',
        'blank': '\u2423',
        'blk12': '\u2592',
        'blk14': '\u2591',
        'blk34': '\u2593',
        'block': '\u2588',
        'bne': '=\u20E5',
        'bnequiv': '\u2261\u20E5',
        'bnot': '\u2310',
        'bNot': '\u2AED',
        'bopf': '\uD835\uDD53',
        'Bopf': '\uD835\uDD39',
        'bot': '\u22A5',
        'bottom': '\u22A5',
        'bowtie': '\u22C8',
        'boxbox': '\u29C9',
        'boxdl': '\u2510',
        'boxdL': '\u2555',
        'boxDl': '\u2556',
        'boxDL': '\u2557',
        'boxdr': '\u250C',
        'boxdR': '\u2552',
        'boxDr': '\u2553',
        'boxDR': '\u2554',
        'boxh': '\u2500',
        'boxH': '\u2550',
        'boxhd': '\u252C',
        'boxhD': '\u2565',
        'boxHd': '\u2564',
        'boxHD': '\u2566',
        'boxhu': '\u2534',
        'boxhU': '\u2568',
        'boxHu': '\u2567',
        'boxHU': '\u2569',
        'boxminus': '\u229F',
        'boxplus': '\u229E',
        'boxtimes': '\u22A0',
        'boxul': '\u2518',
        'boxuL': '\u255B',
        'boxUl': '\u255C',
        'boxUL': '\u255D',
        'boxur': '\u2514',
        'boxuR': '\u2558',
        'boxUr': '\u2559',
        'boxUR': '\u255A',
        'boxv': '\u2502',
        'boxV': '\u2551',
        'boxvh': '\u253C',
        'boxvH': '\u256A',
        'boxVh': '\u256B',
        'boxVH': '\u256C',
        'boxvl': '\u2524',
        'boxvL': '\u2561',
        'boxVl': '\u2562',
        'boxVL': '\u2563',
        'boxvr': '\u251C',
        'boxvR': '\u255E',
        'boxVr': '\u255F',
        'boxVR': '\u2560',
        'bprime': '\u2035',
        'breve': '\u02D8',
        'Breve': '\u02D8',
        'brvbar': '\xA6',
        'bscr': '\uD835\uDCB7',
        'Bscr': '\u212C',
        'bsemi': '\u204F',
        'bsim': '\u223D',
        'bsime': '\u22CD',
        'bsol': '\\',
        'bsolb': '\u29C5',
        'bsolhsub': '\u27C8',
        'bull': '\u2022',
        'bullet': '\u2022',
        'bump': '\u224E',
        'bumpe': '\u224F',
        'bumpE': '\u2AAE',
        'bumpeq': '\u224F',
        'Bumpeq': '\u224E',
        'cacute': '\u0107',
        'Cacute': '\u0106',
        'cap': '\u2229',
        'Cap': '\u22D2',
        'capand': '\u2A44',
        'capbrcup': '\u2A49',
        'capcap': '\u2A4B',
        'capcup': '\u2A47',
        'capdot': '\u2A40',
        'CapitalDifferentialD': '\u2145',
        'caps': '\u2229\uFE00',
        'caret': '\u2041',
        'caron': '\u02C7',
        'Cayleys': '\u212D',
        'ccaps': '\u2A4D',
        'ccaron': '\u010D',
        'Ccaron': '\u010C',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'ccirc': '\u0109',
        'Ccirc': '\u0108',
        'Cconint': '\u2230',
        'ccups': '\u2A4C',
        'ccupssm': '\u2A50',
        'cdot': '\u010B',
        'Cdot': '\u010A',
        'cedil': '\xB8',
        'Cedilla': '\xB8',
        'cemptyv': '\u29B2',
        'cent': '\xA2',
        'centerdot': '\xB7',
        'CenterDot': '\xB7',
        'cfr': '\uD835\uDD20',
        'Cfr': '\u212D',
        'chcy': '\u0447',
        'CHcy': '\u0427',
        'check': '\u2713',
        'checkmark': '\u2713',
        'chi': '\u03C7',
        'Chi': '\u03A7',
        'cir': '\u25CB',
        'circ': '\u02C6',
        'circeq': '\u2257',
        'circlearrowleft': '\u21BA',
        'circlearrowright': '\u21BB',
        'circledast': '\u229B',
        'circledcirc': '\u229A',
        'circleddash': '\u229D',
        'CircleDot': '\u2299',
        'circledR': '\xAE',
        'circledS': '\u24C8',
        'CircleMinus': '\u2296',
        'CirclePlus': '\u2295',
        'CircleTimes': '\u2297',
        'cire': '\u2257',
        'cirE': '\u29C3',
        'cirfnint': '\u2A10',
        'cirmid': '\u2AEF',
        'cirscir': '\u29C2',
        'ClockwiseContourIntegral': '\u2232',
        'CloseCurlyDoubleQuote': '\u201D',
        'CloseCurlyQuote': '\u2019',
        'clubs': '\u2663',
        'clubsuit': '\u2663',
        'colon': ':',
        'Colon': '\u2237',
        'colone': '\u2254',
        'Colone': '\u2A74',
        'coloneq': '\u2254',
        'comma': ',',
        'commat': '@',
        'comp': '\u2201',
        'compfn': '\u2218',
        'complement': '\u2201',
        'complexes': '\u2102',
        'cong': '\u2245',
        'congdot': '\u2A6D',
        'Congruent': '\u2261',
        'conint': '\u222E',
        'Conint': '\u222F',
        'ContourIntegral': '\u222E',
        'copf': '\uD835\uDD54',
        'Copf': '\u2102',
        'coprod': '\u2210',
        'Coproduct': '\u2210',
        'copy': '\xA9',
        'COPY': '\xA9',
        'copysr': '\u2117',
        'CounterClockwiseContourIntegral': '\u2233',
        'crarr': '\u21B5',
        'cross': '\u2717',
        'Cross': '\u2A2F',
        'cscr': '\uD835\uDCB8',
        'Cscr': '\uD835\uDC9E',
        'csub': '\u2ACF',
        'csube': '\u2AD1',
        'csup': '\u2AD0',
        'csupe': '\u2AD2',
        'ctdot': '\u22EF',
        'cudarrl': '\u2938',
        'cudarrr': '\u2935',
        'cuepr': '\u22DE',
        'cuesc': '\u22DF',
        'cularr': '\u21B6',
        'cularrp': '\u293D',
        'cup': '\u222A',
        'Cup': '\u22D3',
        'cupbrcap': '\u2A48',
        'cupcap': '\u2A46',
        'CupCap': '\u224D',
        'cupcup': '\u2A4A',
        'cupdot': '\u228D',
        'cupor': '\u2A45',
        'cups': '\u222A\uFE00',
        'curarr': '\u21B7',
        'curarrm': '\u293C',
        'curlyeqprec': '\u22DE',
        'curlyeqsucc': '\u22DF',
        'curlyvee': '\u22CE',
        'curlywedge': '\u22CF',
        'curren': '\xA4',
        'curvearrowleft': '\u21B6',
        'curvearrowright': '\u21B7',
        'cuvee': '\u22CE',
        'cuwed': '\u22CF',
        'cwconint': '\u2232',
        'cwint': '\u2231',
        'cylcty': '\u232D',
        'dagger': '\u2020',
        'Dagger': '\u2021',
        'daleth': '\u2138',
        'darr': '\u2193',
        'dArr': '\u21D3',
        'Darr': '\u21A1',
        'dash': '\u2010',
        'dashv': '\u22A3',
        'Dashv': '\u2AE4',
        'dbkarow': '\u290F',
        'dblac': '\u02DD',
        'dcaron': '\u010F',
        'Dcaron': '\u010E',
        'dcy': '\u0434',
        'Dcy': '\u0414',
        'dd': '\u2146',
        'DD': '\u2145',
        'ddagger': '\u2021',
        'ddarr': '\u21CA',
        'DDotrahd': '\u2911',
        'ddotseq': '\u2A77',
        'deg': '\xB0',
        'Del': '\u2207',
        'delta': '\u03B4',
        'Delta': '\u0394',
        'demptyv': '\u29B1',
        'dfisht': '\u297F',
        'dfr': '\uD835\uDD21',
        'Dfr': '\uD835\uDD07',
        'dHar': '\u2965',
        'dharl': '\u21C3',
        'dharr': '\u21C2',
        'DiacriticalAcute': '\xB4',
        'DiacriticalDot': '\u02D9',
        'DiacriticalDoubleAcute': '\u02DD',
        'DiacriticalGrave': '`',
        'DiacriticalTilde': '\u02DC',
        'diam': '\u22C4',
        'diamond': '\u22C4',
        'Diamond': '\u22C4',
        'diamondsuit': '\u2666',
        'diams': '\u2666',
        'die': '\xA8',
        'DifferentialD': '\u2146',
        'digamma': '\u03DD',
        'disin': '\u22F2',
        'div': '\xF7',
        'divide': '\xF7',
        'divideontimes': '\u22C7',
        'divonx': '\u22C7',
        'djcy': '\u0452',
        'DJcy': '\u0402',
        'dlcorn': '\u231E',
        'dlcrop': '\u230D',
        'dollar': '$',
        'dopf': '\uD835\uDD55',
        'Dopf': '\uD835\uDD3B',
        'dot': '\u02D9',
        'Dot': '\xA8',
        'DotDot': '\u20DC',
        'doteq': '\u2250',
        'doteqdot': '\u2251',
        'DotEqual': '\u2250',
        'dotminus': '\u2238',
        'dotplus': '\u2214',
        'dotsquare': '\u22A1',
        'doublebarwedge': '\u2306',
        'DoubleContourIntegral': '\u222F',
        'DoubleDot': '\xA8',
        'DoubleDownArrow': '\u21D3',
        'DoubleLeftArrow': '\u21D0',
        'DoubleLeftRightArrow': '\u21D4',
        'DoubleLeftTee': '\u2AE4',
        'DoubleLongLeftArrow': '\u27F8',
        'DoubleLongLeftRightArrow': '\u27FA',
        'DoubleLongRightArrow': '\u27F9',
        'DoubleRightArrow': '\u21D2',
        'DoubleRightTee': '\u22A8',
        'DoubleUpArrow': '\u21D1',
        'DoubleUpDownArrow': '\u21D5',
        'DoubleVerticalBar': '\u2225',
        'downarrow': '\u2193',
        'Downarrow': '\u21D3',
        'DownArrow': '\u2193',
        'DownArrowBar': '\u2913',
        'DownArrowUpArrow': '\u21F5',
        'DownBreve': '\u0311',
        'downdownarrows': '\u21CA',
        'downharpoonleft': '\u21C3',
        'downharpoonright': '\u21C2',
        'DownLeftRightVector': '\u2950',
        'DownLeftTeeVector': '\u295E',
        'DownLeftVector': '\u21BD',
        'DownLeftVectorBar': '\u2956',
        'DownRightTeeVector': '\u295F',
        'DownRightVector': '\u21C1',
        'DownRightVectorBar': '\u2957',
        'DownTee': '\u22A4',
        'DownTeeArrow': '\u21A7',
        'drbkarow': '\u2910',
        'drcorn': '\u231F',
        'drcrop': '\u230C',
        'dscr': '\uD835\uDCB9',
        'Dscr': '\uD835\uDC9F',
        'dscy': '\u0455',
        'DScy': '\u0405',
        'dsol': '\u29F6',
        'dstrok': '\u0111',
        'Dstrok': '\u0110',
        'dtdot': '\u22F1',
        'dtri': '\u25BF',
        'dtrif': '\u25BE',
        'duarr': '\u21F5',
        'duhar': '\u296F',
        'dwangle': '\u29A6',
        'dzcy': '\u045F',
        'DZcy': '\u040F',
        'dzigrarr': '\u27FF',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'easter': '\u2A6E',
        'ecaron': '\u011B',
        'Ecaron': '\u011A',
        'ecir': '\u2256',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'ecolon': '\u2255',
        'ecy': '\u044D',
        'Ecy': '\u042D',
        'eDDot': '\u2A77',
        'edot': '\u0117',
        'eDot': '\u2251',
        'Edot': '\u0116',
        'ee': '\u2147',
        'efDot': '\u2252',
        'efr': '\uD835\uDD22',
        'Efr': '\uD835\uDD08',
        'eg': '\u2A9A',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'egs': '\u2A96',
        'egsdot': '\u2A98',
        'el': '\u2A99',
        'Element': '\u2208',
        'elinters': '\u23E7',
        'ell': '\u2113',
        'els': '\u2A95',
        'elsdot': '\u2A97',
        'emacr': '\u0113',
        'Emacr': '\u0112',
        'empty': '\u2205',
        'emptyset': '\u2205',
        'EmptySmallSquare': '\u25FB',
        'emptyv': '\u2205',
        'EmptyVerySmallSquare': '\u25AB',
        'emsp': '\u2003',
        'emsp13': '\u2004',
        'emsp14': '\u2005',
        'eng': '\u014B',
        'ENG': '\u014A',
        'ensp': '\u2002',
        'eogon': '\u0119',
        'Eogon': '\u0118',
        'eopf': '\uD835\uDD56',
        'Eopf': '\uD835\uDD3C',
        'epar': '\u22D5',
        'eparsl': '\u29E3',
        'eplus': '\u2A71',
        'epsi': '\u03B5',
        'epsilon': '\u03B5',
        'Epsilon': '\u0395',
        'epsiv': '\u03F5',
        'eqcirc': '\u2256',
        'eqcolon': '\u2255',
        'eqsim': '\u2242',
        'eqslantgtr': '\u2A96',
        'eqslantless': '\u2A95',
        'Equal': '\u2A75',
        'equals': '=',
        'EqualTilde': '\u2242',
        'equest': '\u225F',
        'Equilibrium': '\u21CC',
        'equiv': '\u2261',
        'equivDD': '\u2A78',
        'eqvparsl': '\u29E5',
        'erarr': '\u2971',
        'erDot': '\u2253',
        'escr': '\u212F',
        'Escr': '\u2130',
        'esdot': '\u2250',
        'esim': '\u2242',
        'Esim': '\u2A73',
        'eta': '\u03B7',
        'Eta': '\u0397',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'euro': '\u20AC',
        'excl': '!',
        'exist': '\u2203',
        'Exists': '\u2203',
        'expectation': '\u2130',
        'exponentiale': '\u2147',
        'ExponentialE': '\u2147',
        'fallingdotseq': '\u2252',
        'fcy': '\u0444',
        'Fcy': '\u0424',
        'female': '\u2640',
        'ffilig': '\uFB03',
        'fflig': '\uFB00',
        'ffllig': '\uFB04',
        'ffr': '\uD835\uDD23',
        'Ffr': '\uD835\uDD09',
        'filig': '\uFB01',
        'FilledSmallSquare': '\u25FC',
        'FilledVerySmallSquare': '\u25AA',
        'fjlig': 'fj',
        'flat': '\u266D',
        'fllig': '\uFB02',
        'fltns': '\u25B1',
        'fnof': '\u0192',
        'fopf': '\uD835\uDD57',
        'Fopf': '\uD835\uDD3D',
        'forall': '\u2200',
        'ForAll': '\u2200',
        'fork': '\u22D4',
        'forkv': '\u2AD9',
        'Fouriertrf': '\u2131',
        'fpartint': '\u2A0D',
        'frac12': '\xBD',
        'frac13': '\u2153',
        'frac14': '\xBC',
        'frac15': '\u2155',
        'frac16': '\u2159',
        'frac18': '\u215B',
        'frac23': '\u2154',
        'frac25': '\u2156',
        'frac34': '\xBE',
        'frac35': '\u2157',
        'frac38': '\u215C',
        'frac45': '\u2158',
        'frac56': '\u215A',
        'frac58': '\u215D',
        'frac78': '\u215E',
        'frasl': '\u2044',
        'frown': '\u2322',
        'fscr': '\uD835\uDCBB',
        'Fscr': '\u2131',
        'gacute': '\u01F5',
        'gamma': '\u03B3',
        'Gamma': '\u0393',
        'gammad': '\u03DD',
        'Gammad': '\u03DC',
        'gap': '\u2A86',
        'gbreve': '\u011F',
        'Gbreve': '\u011E',
        'Gcedil': '\u0122',
        'gcirc': '\u011D',
        'Gcirc': '\u011C',
        'gcy': '\u0433',
        'Gcy': '\u0413',
        'gdot': '\u0121',
        'Gdot': '\u0120',
        'ge': '\u2265',
        'gE': '\u2267',
        'gel': '\u22DB',
        'gEl': '\u2A8C',
        'geq': '\u2265',
        'geqq': '\u2267',
        'geqslant': '\u2A7E',
        'ges': '\u2A7E',
        'gescc': '\u2AA9',
        'gesdot': '\u2A80',
        'gesdoto': '\u2A82',
        'gesdotol': '\u2A84',
        'gesl': '\u22DB\uFE00',
        'gesles': '\u2A94',
        'gfr': '\uD835\uDD24',
        'Gfr': '\uD835\uDD0A',
        'gg': '\u226B',
        'Gg': '\u22D9',
        'ggg': '\u22D9',
        'gimel': '\u2137',
        'gjcy': '\u0453',
        'GJcy': '\u0403',
        'gl': '\u2277',
        'gla': '\u2AA5',
        'glE': '\u2A92',
        'glj': '\u2AA4',
        'gnap': '\u2A8A',
        'gnapprox': '\u2A8A',
        'gne': '\u2A88',
        'gnE': '\u2269',
        'gneq': '\u2A88',
        'gneqq': '\u2269',
        'gnsim': '\u22E7',
        'gopf': '\uD835\uDD58',
        'Gopf': '\uD835\uDD3E',
        'grave': '`',
        'GreaterEqual': '\u2265',
        'GreaterEqualLess': '\u22DB',
        'GreaterFullEqual': '\u2267',
        'GreaterGreater': '\u2AA2',
        'GreaterLess': '\u2277',
        'GreaterSlantEqual': '\u2A7E',
        'GreaterTilde': '\u2273',
        'gscr': '\u210A',
        'Gscr': '\uD835\uDCA2',
        'gsim': '\u2273',
        'gsime': '\u2A8E',
        'gsiml': '\u2A90',
        'gt': '>',
        'Gt': '\u226B',
        'GT': '>',
        'gtcc': '\u2AA7',
        'gtcir': '\u2A7A',
        'gtdot': '\u22D7',
        'gtlPar': '\u2995',
        'gtquest': '\u2A7C',
        'gtrapprox': '\u2A86',
        'gtrarr': '\u2978',
        'gtrdot': '\u22D7',
        'gtreqless': '\u22DB',
        'gtreqqless': '\u2A8C',
        'gtrless': '\u2277',
        'gtrsim': '\u2273',
        'gvertneqq': '\u2269\uFE00',
        'gvnE': '\u2269\uFE00',
        'Hacek': '\u02C7',
        'hairsp': '\u200A',
        'half': '\xBD',
        'hamilt': '\u210B',
        'hardcy': '\u044A',
        'HARDcy': '\u042A',
        'harr': '\u2194',
        'hArr': '\u21D4',
        'harrcir': '\u2948',
        'harrw': '\u21AD',
        'Hat': '^',
        'hbar': '\u210F',
        'hcirc': '\u0125',
        'Hcirc': '\u0124',
        'hearts': '\u2665',
        'heartsuit': '\u2665',
        'hellip': '\u2026',
        'hercon': '\u22B9',
        'hfr': '\uD835\uDD25',
        'Hfr': '\u210C',
        'HilbertSpace': '\u210B',
        'hksearow': '\u2925',
        'hkswarow': '\u2926',
        'hoarr': '\u21FF',
        'homtht': '\u223B',
        'hookleftarrow': '\u21A9',
        'hookrightarrow': '\u21AA',
        'hopf': '\uD835\uDD59',
        'Hopf': '\u210D',
        'horbar': '\u2015',
        'HorizontalLine': '\u2500',
        'hscr': '\uD835\uDCBD',
        'Hscr': '\u210B',
        'hslash': '\u210F',
        'hstrok': '\u0127',
        'Hstrok': '\u0126',
        'HumpDownHump': '\u224E',
        'HumpEqual': '\u224F',
        'hybull': '\u2043',
        'hyphen': '\u2010',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'ic': '\u2063',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'icy': '\u0438',
        'Icy': '\u0418',
        'Idot': '\u0130',
        'iecy': '\u0435',
        'IEcy': '\u0415',
        'iexcl': '\xA1',
        'iff': '\u21D4',
        'ifr': '\uD835\uDD26',
        'Ifr': '\u2111',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'ii': '\u2148',
        'iiiint': '\u2A0C',
        'iiint': '\u222D',
        'iinfin': '\u29DC',
        'iiota': '\u2129',
        'ijlig': '\u0133',
        'IJlig': '\u0132',
        'Im': '\u2111',
        'imacr': '\u012B',
        'Imacr': '\u012A',
        'image': '\u2111',
        'ImaginaryI': '\u2148',
        'imagline': '\u2110',
        'imagpart': '\u2111',
        'imath': '\u0131',
        'imof': '\u22B7',
        'imped': '\u01B5',
        'Implies': '\u21D2',
        'in': '\u2208',
        'incare': '\u2105',
        'infin': '\u221E',
        'infintie': '\u29DD',
        'inodot': '\u0131',
        'int': '\u222B',
        'Int': '\u222C',
        'intcal': '\u22BA',
        'integers': '\u2124',
        'Integral': '\u222B',
        'intercal': '\u22BA',
        'Intersection': '\u22C2',
        'intlarhk': '\u2A17',
        'intprod': '\u2A3C',
        'InvisibleComma': '\u2063',
        'InvisibleTimes': '\u2062',
        'iocy': '\u0451',
        'IOcy': '\u0401',
        'iogon': '\u012F',
        'Iogon': '\u012E',
        'iopf': '\uD835\uDD5A',
        'Iopf': '\uD835\uDD40',
        'iota': '\u03B9',
        'Iota': '\u0399',
        'iprod': '\u2A3C',
        'iquest': '\xBF',
        'iscr': '\uD835\uDCBE',
        'Iscr': '\u2110',
        'isin': '\u2208',
        'isindot': '\u22F5',
        'isinE': '\u22F9',
        'isins': '\u22F4',
        'isinsv': '\u22F3',
        'isinv': '\u2208',
        'it': '\u2062',
        'itilde': '\u0129',
        'Itilde': '\u0128',
        'iukcy': '\u0456',
        'Iukcy': '\u0406',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'jcirc': '\u0135',
        'Jcirc': '\u0134',
        'jcy': '\u0439',
        'Jcy': '\u0419',
        'jfr': '\uD835\uDD27',
        'Jfr': '\uD835\uDD0D',
        'jmath': '\u0237',
        'jopf': '\uD835\uDD5B',
        'Jopf': '\uD835\uDD41',
        'jscr': '\uD835\uDCBF',
        'Jscr': '\uD835\uDCA5',
        'jsercy': '\u0458',
        'Jsercy': '\u0408',
        'jukcy': '\u0454',
        'Jukcy': '\u0404',
        'kappa': '\u03BA',
        'Kappa': '\u039A',
        'kappav': '\u03F0',
        'kcedil': '\u0137',
        'Kcedil': '\u0136',
        'kcy': '\u043A',
        'Kcy': '\u041A',
        'kfr': '\uD835\uDD28',
        'Kfr': '\uD835\uDD0E',
        'kgreen': '\u0138',
        'khcy': '\u0445',
        'KHcy': '\u0425',
        'kjcy': '\u045C',
        'KJcy': '\u040C',
        'kopf': '\uD835\uDD5C',
        'Kopf': '\uD835\uDD42',
        'kscr': '\uD835\uDCC0',
        'Kscr': '\uD835\uDCA6',
        'lAarr': '\u21DA',
        'lacute': '\u013A',
        'Lacute': '\u0139',
        'laemptyv': '\u29B4',
        'lagran': '\u2112',
        'lambda': '\u03BB',
        'Lambda': '\u039B',
        'lang': '\u27E8',
        'Lang': '\u27EA',
        'langd': '\u2991',
        'langle': '\u27E8',
        'lap': '\u2A85',
        'Laplacetrf': '\u2112',
        'laquo': '\xAB',
        'larr': '\u2190',
        'lArr': '\u21D0',
        'Larr': '\u219E',
        'larrb': '\u21E4',
        'larrbfs': '\u291F',
        'larrfs': '\u291D',
        'larrhk': '\u21A9',
        'larrlp': '\u21AB',
        'larrpl': '\u2939',
        'larrsim': '\u2973',
        'larrtl': '\u21A2',
        'lat': '\u2AAB',
        'latail': '\u2919',
        'lAtail': '\u291B',
        'late': '\u2AAD',
        'lates': '\u2AAD\uFE00',
        'lbarr': '\u290C',
        'lBarr': '\u290E',
        'lbbrk': '\u2772',
        'lbrace': '{',
        'lbrack': '[',
        'lbrke': '\u298B',
        'lbrksld': '\u298F',
        'lbrkslu': '\u298D',
        'lcaron': '\u013E',
        'Lcaron': '\u013D',
        'lcedil': '\u013C',
        'Lcedil': '\u013B',
        'lceil': '\u2308',
        'lcub': '{',
        'lcy': '\u043B',
        'Lcy': '\u041B',
        'ldca': '\u2936',
        'ldquo': '\u201C',
        'ldquor': '\u201E',
        'ldrdhar': '\u2967',
        'ldrushar': '\u294B',
        'ldsh': '\u21B2',
        'le': '\u2264',
        'lE': '\u2266',
        'LeftAngleBracket': '\u27E8',
        'leftarrow': '\u2190',
        'Leftarrow': '\u21D0',
        'LeftArrow': '\u2190',
        'LeftArrowBar': '\u21E4',
        'LeftArrowRightArrow': '\u21C6',
        'leftarrowtail': '\u21A2',
        'LeftCeiling': '\u2308',
        'LeftDoubleBracket': '\u27E6',
        'LeftDownTeeVector': '\u2961',
        'LeftDownVector': '\u21C3',
        'LeftDownVectorBar': '\u2959',
        'LeftFloor': '\u230A',
        'leftharpoondown': '\u21BD',
        'leftharpoonup': '\u21BC',
        'leftleftarrows': '\u21C7',
        'leftrightarrow': '\u2194',
        'Leftrightarrow': '\u21D4',
        'LeftRightArrow': '\u2194',
        'leftrightarrows': '\u21C6',
        'leftrightharpoons': '\u21CB',
        'leftrightsquigarrow': '\u21AD',
        'LeftRightVector': '\u294E',
        'LeftTee': '\u22A3',
        'LeftTeeArrow': '\u21A4',
        'LeftTeeVector': '\u295A',
        'leftthreetimes': '\u22CB',
        'LeftTriangle': '\u22B2',
        'LeftTriangleBar': '\u29CF',
        'LeftTriangleEqual': '\u22B4',
        'LeftUpDownVector': '\u2951',
        'LeftUpTeeVector': '\u2960',
        'LeftUpVector': '\u21BF',
        'LeftUpVectorBar': '\u2958',
        'LeftVector': '\u21BC',
        'LeftVectorBar': '\u2952',
        'leg': '\u22DA',
        'lEg': '\u2A8B',
        'leq': '\u2264',
        'leqq': '\u2266',
        'leqslant': '\u2A7D',
        'les': '\u2A7D',
        'lescc': '\u2AA8',
        'lesdot': '\u2A7F',
        'lesdoto': '\u2A81',
        'lesdotor': '\u2A83',
        'lesg': '\u22DA\uFE00',
        'lesges': '\u2A93',
        'lessapprox': '\u2A85',
        'lessdot': '\u22D6',
        'lesseqgtr': '\u22DA',
        'lesseqqgtr': '\u2A8B',
        'LessEqualGreater': '\u22DA',
        'LessFullEqual': '\u2266',
        'LessGreater': '\u2276',
        'lessgtr': '\u2276',
        'LessLess': '\u2AA1',
        'lesssim': '\u2272',
        'LessSlantEqual': '\u2A7D',
        'LessTilde': '\u2272',
        'lfisht': '\u297C',
        'lfloor': '\u230A',
        'lfr': '\uD835\uDD29',
        'Lfr': '\uD835\uDD0F',
        'lg': '\u2276',
        'lgE': '\u2A91',
        'lHar': '\u2962',
        'lhard': '\u21BD',
        'lharu': '\u21BC',
        'lharul': '\u296A',
        'lhblk': '\u2584',
        'ljcy': '\u0459',
        'LJcy': '\u0409',
        'll': '\u226A',
        'Ll': '\u22D8',
        'llarr': '\u21C7',
        'llcorner': '\u231E',
        'Lleftarrow': '\u21DA',
        'llhard': '\u296B',
        'lltri': '\u25FA',
        'lmidot': '\u0140',
        'Lmidot': '\u013F',
        'lmoust': '\u23B0',
        'lmoustache': '\u23B0',
        'lnap': '\u2A89',
        'lnapprox': '\u2A89',
        'lne': '\u2A87',
        'lnE': '\u2268',
        'lneq': '\u2A87',
        'lneqq': '\u2268',
        'lnsim': '\u22E6',
        'loang': '\u27EC',
        'loarr': '\u21FD',
        'lobrk': '\u27E6',
        'longleftarrow': '\u27F5',
        'Longleftarrow': '\u27F8',
        'LongLeftArrow': '\u27F5',
        'longleftrightarrow': '\u27F7',
        'Longleftrightarrow': '\u27FA',
        'LongLeftRightArrow': '\u27F7',
        'longmapsto': '\u27FC',
        'longrightarrow': '\u27F6',
        'Longrightarrow': '\u27F9',
        'LongRightArrow': '\u27F6',
        'looparrowleft': '\u21AB',
        'looparrowright': '\u21AC',
        'lopar': '\u2985',
        'lopf': '\uD835\uDD5D',
        'Lopf': '\uD835\uDD43',
        'loplus': '\u2A2D',
        'lotimes': '\u2A34',
        'lowast': '\u2217',
        'lowbar': '_',
        'LowerLeftArrow': '\u2199',
        'LowerRightArrow': '\u2198',
        'loz': '\u25CA',
        'lozenge': '\u25CA',
        'lozf': '\u29EB',
        'lpar': '(',
        'lparlt': '\u2993',
        'lrarr': '\u21C6',
        'lrcorner': '\u231F',
        'lrhar': '\u21CB',
        'lrhard': '\u296D',
        'lrm': '\u200E',
        'lrtri': '\u22BF',
        'lsaquo': '\u2039',
        'lscr': '\uD835\uDCC1',
        'Lscr': '\u2112',
        'lsh': '\u21B0',
        'Lsh': '\u21B0',
        'lsim': '\u2272',
        'lsime': '\u2A8D',
        'lsimg': '\u2A8F',
        'lsqb': '[',
        'lsquo': '\u2018',
        'lsquor': '\u201A',
        'lstrok': '\u0142',
        'Lstrok': '\u0141',
        'lt': '<',
        'Lt': '\u226A',
        'LT': '<',
        'ltcc': '\u2AA6',
        'ltcir': '\u2A79',
        'ltdot': '\u22D6',
        'lthree': '\u22CB',
        'ltimes': '\u22C9',
        'ltlarr': '\u2976',
        'ltquest': '\u2A7B',
        'ltri': '\u25C3',
        'ltrie': '\u22B4',
        'ltrif': '\u25C2',
        'ltrPar': '\u2996',
        'lurdshar': '\u294A',
        'luruhar': '\u2966',
        'lvertneqq': '\u2268\uFE00',
        'lvnE': '\u2268\uFE00',
        'macr': '\xAF',
        'male': '\u2642',
        'malt': '\u2720',
        'maltese': '\u2720',
        'map': '\u21A6',
        'Map': '\u2905',
        'mapsto': '\u21A6',
        'mapstodown': '\u21A7',
        'mapstoleft': '\u21A4',
        'mapstoup': '\u21A5',
        'marker': '\u25AE',
        'mcomma': '\u2A29',
        'mcy': '\u043C',
        'Mcy': '\u041C',
        'mdash': '\u2014',
        'mDDot': '\u223A',
        'measuredangle': '\u2221',
        'MediumSpace': '\u205F',
        'Mellintrf': '\u2133',
        'mfr': '\uD835\uDD2A',
        'Mfr': '\uD835\uDD10',
        'mho': '\u2127',
        'micro': '\xB5',
        'mid': '\u2223',
        'midast': '*',
        'midcir': '\u2AF0',
        'middot': '\xB7',
        'minus': '\u2212',
        'minusb': '\u229F',
        'minusd': '\u2238',
        'minusdu': '\u2A2A',
        'MinusPlus': '\u2213',
        'mlcp': '\u2ADB',
        'mldr': '\u2026',
        'mnplus': '\u2213',
        'models': '\u22A7',
        'mopf': '\uD835\uDD5E',
        'Mopf': '\uD835\uDD44',
        'mp': '\u2213',
        'mscr': '\uD835\uDCC2',
        'Mscr': '\u2133',
        'mstpos': '\u223E',
        'mu': '\u03BC',
        'Mu': '\u039C',
        'multimap': '\u22B8',
        'mumap': '\u22B8',
        'nabla': '\u2207',
        'nacute': '\u0144',
        'Nacute': '\u0143',
        'nang': '\u2220\u20D2',
        'nap': '\u2249',
        'napE': '\u2A70\u0338',
        'napid': '\u224B\u0338',
        'napos': '\u0149',
        'napprox': '\u2249',
        'natur': '\u266E',
        'natural': '\u266E',
        'naturals': '\u2115',
        'nbsp': '\xA0',
        'nbump': '\u224E\u0338',
        'nbumpe': '\u224F\u0338',
        'ncap': '\u2A43',
        'ncaron': '\u0148',
        'Ncaron': '\u0147',
        'ncedil': '\u0146',
        'Ncedil': '\u0145',
        'ncong': '\u2247',
        'ncongdot': '\u2A6D\u0338',
        'ncup': '\u2A42',
        'ncy': '\u043D',
        'Ncy': '\u041D',
        'ndash': '\u2013',
        'ne': '\u2260',
        'nearhk': '\u2924',
        'nearr': '\u2197',
        'neArr': '\u21D7',
        'nearrow': '\u2197',
        'nedot': '\u2250\u0338',
        'NegativeMediumSpace': '\u200B',
        'NegativeThickSpace': '\u200B',
        'NegativeThinSpace': '\u200B',
        'NegativeVeryThinSpace': '\u200B',
        'nequiv': '\u2262',
        'nesear': '\u2928',
        'nesim': '\u2242\u0338',
        'NestedGreaterGreater': '\u226B',
        'NestedLessLess': '\u226A',
        'NewLine': '\n',
        'nexist': '\u2204',
        'nexists': '\u2204',
        'nfr': '\uD835\uDD2B',
        'Nfr': '\uD835\uDD11',
        'nge': '\u2271',
        'ngE': '\u2267\u0338',
        'ngeq': '\u2271',
        'ngeqq': '\u2267\u0338',
        'ngeqslant': '\u2A7E\u0338',
        'nges': '\u2A7E\u0338',
        'nGg': '\u22D9\u0338',
        'ngsim': '\u2275',
        'ngt': '\u226F',
        'nGt': '\u226B\u20D2',
        'ngtr': '\u226F',
        'nGtv': '\u226B\u0338',
        'nharr': '\u21AE',
        'nhArr': '\u21CE',
        'nhpar': '\u2AF2',
        'ni': '\u220B',
        'nis': '\u22FC',
        'nisd': '\u22FA',
        'niv': '\u220B',
        'njcy': '\u045A',
        'NJcy': '\u040A',
        'nlarr': '\u219A',
        'nlArr': '\u21CD',
        'nldr': '\u2025',
        'nle': '\u2270',
        'nlE': '\u2266\u0338',
        'nleftarrow': '\u219A',
        'nLeftarrow': '\u21CD',
        'nleftrightarrow': '\u21AE',
        'nLeftrightarrow': '\u21CE',
        'nleq': '\u2270',
        'nleqq': '\u2266\u0338',
        'nleqslant': '\u2A7D\u0338',
        'nles': '\u2A7D\u0338',
        'nless': '\u226E',
        'nLl': '\u22D8\u0338',
        'nlsim': '\u2274',
        'nlt': '\u226E',
        'nLt': '\u226A\u20D2',
        'nltri': '\u22EA',
        'nltrie': '\u22EC',
        'nLtv': '\u226A\u0338',
        'nmid': '\u2224',
        'NoBreak': '\u2060',
        'NonBreakingSpace': '\xA0',
        'nopf': '\uD835\uDD5F',
        'Nopf': '\u2115',
        'not': '\xAC',
        'Not': '\u2AEC',
        'NotCongruent': '\u2262',
        'NotCupCap': '\u226D',
        'NotDoubleVerticalBar': '\u2226',
        'NotElement': '\u2209',
        'NotEqual': '\u2260',
        'NotEqualTilde': '\u2242\u0338',
        'NotExists': '\u2204',
        'NotGreater': '\u226F',
        'NotGreaterEqual': '\u2271',
        'NotGreaterFullEqual': '\u2267\u0338',
        'NotGreaterGreater': '\u226B\u0338',
        'NotGreaterLess': '\u2279',
        'NotGreaterSlantEqual': '\u2A7E\u0338',
        'NotGreaterTilde': '\u2275',
        'NotHumpDownHump': '\u224E\u0338',
        'NotHumpEqual': '\u224F\u0338',
        'notin': '\u2209',
        'notindot': '\u22F5\u0338',
        'notinE': '\u22F9\u0338',
        'notinva': '\u2209',
        'notinvb': '\u22F7',
        'notinvc': '\u22F6',
        'NotLeftTriangle': '\u22EA',
        'NotLeftTriangleBar': '\u29CF\u0338',
        'NotLeftTriangleEqual': '\u22EC',
        'NotLess': '\u226E',
        'NotLessEqual': '\u2270',
        'NotLessGreater': '\u2278',
        'NotLessLess': '\u226A\u0338',
        'NotLessSlantEqual': '\u2A7D\u0338',
        'NotLessTilde': '\u2274',
        'NotNestedGreaterGreater': '\u2AA2\u0338',
        'NotNestedLessLess': '\u2AA1\u0338',
        'notni': '\u220C',
        'notniva': '\u220C',
        'notnivb': '\u22FE',
        'notnivc': '\u22FD',
        'NotPrecedes': '\u2280',
        'NotPrecedesEqual': '\u2AAF\u0338',
        'NotPrecedesSlantEqual': '\u22E0',
        'NotReverseElement': '\u220C',
        'NotRightTriangle': '\u22EB',
        'NotRightTriangleBar': '\u29D0\u0338',
        'NotRightTriangleEqual': '\u22ED',
        'NotSquareSubset': '\u228F\u0338',
        'NotSquareSubsetEqual': '\u22E2',
        'NotSquareSuperset': '\u2290\u0338',
        'NotSquareSupersetEqual': '\u22E3',
        'NotSubset': '\u2282\u20D2',
        'NotSubsetEqual': '\u2288',
        'NotSucceeds': '\u2281',
        'NotSucceedsEqual': '\u2AB0\u0338',
        'NotSucceedsSlantEqual': '\u22E1',
        'NotSucceedsTilde': '\u227F\u0338',
        'NotSuperset': '\u2283\u20D2',
        'NotSupersetEqual': '\u2289',
        'NotTilde': '\u2241',
        'NotTildeEqual': '\u2244',
        'NotTildeFullEqual': '\u2247',
        'NotTildeTilde': '\u2249',
        'NotVerticalBar': '\u2224',
        'npar': '\u2226',
        'nparallel': '\u2226',
        'nparsl': '\u2AFD\u20E5',
        'npart': '\u2202\u0338',
        'npolint': '\u2A14',
        'npr': '\u2280',
        'nprcue': '\u22E0',
        'npre': '\u2AAF\u0338',
        'nprec': '\u2280',
        'npreceq': '\u2AAF\u0338',
        'nrarr': '\u219B',
        'nrArr': '\u21CF',
        'nrarrc': '\u2933\u0338',
        'nrarrw': '\u219D\u0338',
        'nrightarrow': '\u219B',
        'nRightarrow': '\u21CF',
        'nrtri': '\u22EB',
        'nrtrie': '\u22ED',
        'nsc': '\u2281',
        'nsccue': '\u22E1',
        'nsce': '\u2AB0\u0338',
        'nscr': '\uD835\uDCC3',
        'Nscr': '\uD835\uDCA9',
        'nshortmid': '\u2224',
        'nshortparallel': '\u2226',
        'nsim': '\u2241',
        'nsime': '\u2244',
        'nsimeq': '\u2244',
        'nsmid': '\u2224',
        'nspar': '\u2226',
        'nsqsube': '\u22E2',
        'nsqsupe': '\u22E3',
        'nsub': '\u2284',
        'nsube': '\u2288',
        'nsubE': '\u2AC5\u0338',
        'nsubset': '\u2282\u20D2',
        'nsubseteq': '\u2288',
        'nsubseteqq': '\u2AC5\u0338',
        'nsucc': '\u2281',
        'nsucceq': '\u2AB0\u0338',
        'nsup': '\u2285',
        'nsupe': '\u2289',
        'nsupE': '\u2AC6\u0338',
        'nsupset': '\u2283\u20D2',
        'nsupseteq': '\u2289',
        'nsupseteqq': '\u2AC6\u0338',
        'ntgl': '\u2279',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'ntlg': '\u2278',
        'ntriangleleft': '\u22EA',
        'ntrianglelefteq': '\u22EC',
        'ntriangleright': '\u22EB',
        'ntrianglerighteq': '\u22ED',
        'nu': '\u03BD',
        'Nu': '\u039D',
        'num': '#',
        'numero': '\u2116',
        'numsp': '\u2007',
        'nvap': '\u224D\u20D2',
        'nvdash': '\u22AC',
        'nvDash': '\u22AD',
        'nVdash': '\u22AE',
        'nVDash': '\u22AF',
        'nvge': '\u2265\u20D2',
        'nvgt': '>\u20D2',
        'nvHarr': '\u2904',
        'nvinfin': '\u29DE',
        'nvlArr': '\u2902',
        'nvle': '\u2264\u20D2',
        'nvlt': '<\u20D2',
        'nvltrie': '\u22B4\u20D2',
        'nvrArr': '\u2903',
        'nvrtrie': '\u22B5\u20D2',
        'nvsim': '\u223C\u20D2',
        'nwarhk': '\u2923',
        'nwarr': '\u2196',
        'nwArr': '\u21D6',
        'nwarrow': '\u2196',
        'nwnear': '\u2927',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'oast': '\u229B',
        'ocir': '\u229A',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ocy': '\u043E',
        'Ocy': '\u041E',
        'odash': '\u229D',
        'odblac': '\u0151',
        'Odblac': '\u0150',
        'odiv': '\u2A38',
        'odot': '\u2299',
        'odsold': '\u29BC',
        'oelig': '\u0153',
        'OElig': '\u0152',
        'ofcir': '\u29BF',
        'ofr': '\uD835\uDD2C',
        'Ofr': '\uD835\uDD12',
        'ogon': '\u02DB',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ogt': '\u29C1',
        'ohbar': '\u29B5',
        'ohm': '\u03A9',
        'oint': '\u222E',
        'olarr': '\u21BA',
        'olcir': '\u29BE',
        'olcross': '\u29BB',
        'oline': '\u203E',
        'olt': '\u29C0',
        'omacr': '\u014D',
        'Omacr': '\u014C',
        'omega': '\u03C9',
        'Omega': '\u03A9',
        'omicron': '\u03BF',
        'Omicron': '\u039F',
        'omid': '\u29B6',
        'ominus': '\u2296',
        'oopf': '\uD835\uDD60',
        'Oopf': '\uD835\uDD46',
        'opar': '\u29B7',
        'OpenCurlyDoubleQuote': '\u201C',
        'OpenCurlyQuote': '\u2018',
        'operp': '\u29B9',
        'oplus': '\u2295',
        'or': '\u2228',
        'Or': '\u2A54',
        'orarr': '\u21BB',
        'ord': '\u2A5D',
        'order': '\u2134',
        'orderof': '\u2134',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'origof': '\u22B6',
        'oror': '\u2A56',
        'orslope': '\u2A57',
        'orv': '\u2A5B',
        'oS': '\u24C8',
        'oscr': '\u2134',
        'Oscr': '\uD835\uDCAA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'osol': '\u2298',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'otimes': '\u2297',
        'Otimes': '\u2A37',
        'otimesas': '\u2A36',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'ovbar': '\u233D',
        'OverBar': '\u203E',
        'OverBrace': '\u23DE',
        'OverBracket': '\u23B4',
        'OverParenthesis': '\u23DC',
        'par': '\u2225',
        'para': '\xB6',
        'parallel': '\u2225',
        'parsim': '\u2AF3',
        'parsl': '\u2AFD',
        'part': '\u2202',
        'PartialD': '\u2202',
        'pcy': '\u043F',
        'Pcy': '\u041F',
        'percnt': '%',
        'period': '.',
        'permil': '\u2030',
        'perp': '\u22A5',
        'pertenk': '\u2031',
        'pfr': '\uD835\uDD2D',
        'Pfr': '\uD835\uDD13',
        'phi': '\u03C6',
        'Phi': '\u03A6',
        'phiv': '\u03D5',
        'phmmat': '\u2133',
        'phone': '\u260E',
        'pi': '\u03C0',
        'Pi': '\u03A0',
        'pitchfork': '\u22D4',
        'piv': '\u03D6',
        'planck': '\u210F',
        'planckh': '\u210E',
        'plankv': '\u210F',
        'plus': '+',
        'plusacir': '\u2A23',
        'plusb': '\u229E',
        'pluscir': '\u2A22',
        'plusdo': '\u2214',
        'plusdu': '\u2A25',
        'pluse': '\u2A72',
        'PlusMinus': '\xB1',
        'plusmn': '\xB1',
        'plussim': '\u2A26',
        'plustwo': '\u2A27',
        'pm': '\xB1',
        'Poincareplane': '\u210C',
        'pointint': '\u2A15',
        'popf': '\uD835\uDD61',
        'Popf': '\u2119',
        'pound': '\xA3',
        'pr': '\u227A',
        'Pr': '\u2ABB',
        'prap': '\u2AB7',
        'prcue': '\u227C',
        'pre': '\u2AAF',
        'prE': '\u2AB3',
        'prec': '\u227A',
        'precapprox': '\u2AB7',
        'preccurlyeq': '\u227C',
        'Precedes': '\u227A',
        'PrecedesEqual': '\u2AAF',
        'PrecedesSlantEqual': '\u227C',
        'PrecedesTilde': '\u227E',
        'preceq': '\u2AAF',
        'precnapprox': '\u2AB9',
        'precneqq': '\u2AB5',
        'precnsim': '\u22E8',
        'precsim': '\u227E',
        'prime': '\u2032',
        'Prime': '\u2033',
        'primes': '\u2119',
        'prnap': '\u2AB9',
        'prnE': '\u2AB5',
        'prnsim': '\u22E8',
        'prod': '\u220F',
        'Product': '\u220F',
        'profalar': '\u232E',
        'profline': '\u2312',
        'profsurf': '\u2313',
        'prop': '\u221D',
        'Proportion': '\u2237',
        'Proportional': '\u221D',
        'propto': '\u221D',
        'prsim': '\u227E',
        'prurel': '\u22B0',
        'pscr': '\uD835\uDCC5',
        'Pscr': '\uD835\uDCAB',
        'psi': '\u03C8',
        'Psi': '\u03A8',
        'puncsp': '\u2008',
        'qfr': '\uD835\uDD2E',
        'Qfr': '\uD835\uDD14',
        'qint': '\u2A0C',
        'qopf': '\uD835\uDD62',
        'Qopf': '\u211A',
        'qprime': '\u2057',
        'qscr': '\uD835\uDCC6',
        'Qscr': '\uD835\uDCAC',
        'quaternions': '\u210D',
        'quatint': '\u2A16',
        'quest': '?',
        'questeq': '\u225F',
        'quot': '"',
        'QUOT': '"',
        'rAarr': '\u21DB',
        'race': '\u223D\u0331',
        'racute': '\u0155',
        'Racute': '\u0154',
        'radic': '\u221A',
        'raemptyv': '\u29B3',
        'rang': '\u27E9',
        'Rang': '\u27EB',
        'rangd': '\u2992',
        'range': '\u29A5',
        'rangle': '\u27E9',
        'raquo': '\xBB',
        'rarr': '\u2192',
        'rArr': '\u21D2',
        'Rarr': '\u21A0',
        'rarrap': '\u2975',
        'rarrb': '\u21E5',
        'rarrbfs': '\u2920',
        'rarrc': '\u2933',
        'rarrfs': '\u291E',
        'rarrhk': '\u21AA',
        'rarrlp': '\u21AC',
        'rarrpl': '\u2945',
        'rarrsim': '\u2974',
        'rarrtl': '\u21A3',
        'Rarrtl': '\u2916',
        'rarrw': '\u219D',
        'ratail': '\u291A',
        'rAtail': '\u291C',
        'ratio': '\u2236',
        'rationals': '\u211A',
        'rbarr': '\u290D',
        'rBarr': '\u290F',
        'RBarr': '\u2910',
        'rbbrk': '\u2773',
        'rbrace': '}',
        'rbrack': ']',
        'rbrke': '\u298C',
        'rbrksld': '\u298E',
        'rbrkslu': '\u2990',
        'rcaron': '\u0159',
        'Rcaron': '\u0158',
        'rcedil': '\u0157',
        'Rcedil': '\u0156',
        'rceil': '\u2309',
        'rcub': '}',
        'rcy': '\u0440',
        'Rcy': '\u0420',
        'rdca': '\u2937',
        'rdldhar': '\u2969',
        'rdquo': '\u201D',
        'rdquor': '\u201D',
        'rdsh': '\u21B3',
        'Re': '\u211C',
        'real': '\u211C',
        'realine': '\u211B',
        'realpart': '\u211C',
        'reals': '\u211D',
        'rect': '\u25AD',
        'reg': '\xAE',
        'REG': '\xAE',
        'ReverseElement': '\u220B',
        'ReverseEquilibrium': '\u21CB',
        'ReverseUpEquilibrium': '\u296F',
        'rfisht': '\u297D',
        'rfloor': '\u230B',
        'rfr': '\uD835\uDD2F',
        'Rfr': '\u211C',
        'rHar': '\u2964',
        'rhard': '\u21C1',
        'rharu': '\u21C0',
        'rharul': '\u296C',
        'rho': '\u03C1',
        'Rho': '\u03A1',
        'rhov': '\u03F1',
        'RightAngleBracket': '\u27E9',
        'rightarrow': '\u2192',
        'Rightarrow': '\u21D2',
        'RightArrow': '\u2192',
        'RightArrowBar': '\u21E5',
        'RightArrowLeftArrow': '\u21C4',
        'rightarrowtail': '\u21A3',
        'RightCeiling': '\u2309',
        'RightDoubleBracket': '\u27E7',
        'RightDownTeeVector': '\u295D',
        'RightDownVector': '\u21C2',
        'RightDownVectorBar': '\u2955',
        'RightFloor': '\u230B',
        'rightharpoondown': '\u21C1',
        'rightharpoonup': '\u21C0',
        'rightleftarrows': '\u21C4',
        'rightleftharpoons': '\u21CC',
        'rightrightarrows': '\u21C9',
        'rightsquigarrow': '\u219D',
        'RightTee': '\u22A2',
        'RightTeeArrow': '\u21A6',
        'RightTeeVector': '\u295B',
        'rightthreetimes': '\u22CC',
        'RightTriangle': '\u22B3',
        'RightTriangleBar': '\u29D0',
        'RightTriangleEqual': '\u22B5',
        'RightUpDownVector': '\u294F',
        'RightUpTeeVector': '\u295C',
        'RightUpVector': '\u21BE',
        'RightUpVectorBar': '\u2954',
        'RightVector': '\u21C0',
        'RightVectorBar': '\u2953',
        'ring': '\u02DA',
        'risingdotseq': '\u2253',
        'rlarr': '\u21C4',
        'rlhar': '\u21CC',
        'rlm': '\u200F',
        'rmoust': '\u23B1',
        'rmoustache': '\u23B1',
        'rnmid': '\u2AEE',
        'roang': '\u27ED',
        'roarr': '\u21FE',
        'robrk': '\u27E7',
        'ropar': '\u2986',
        'ropf': '\uD835\uDD63',
        'Ropf': '\u211D',
        'roplus': '\u2A2E',
        'rotimes': '\u2A35',
        'RoundImplies': '\u2970',
        'rpar': ')',
        'rpargt': '\u2994',
        'rppolint': '\u2A12',
        'rrarr': '\u21C9',
        'Rrightarrow': '\u21DB',
        'rsaquo': '\u203A',
        'rscr': '\uD835\uDCC7',
        'Rscr': '\u211B',
        'rsh': '\u21B1',
        'Rsh': '\u21B1',
        'rsqb': ']',
        'rsquo': '\u2019',
        'rsquor': '\u2019',
        'rthree': '\u22CC',
        'rtimes': '\u22CA',
        'rtri': '\u25B9',
        'rtrie': '\u22B5',
        'rtrif': '\u25B8',
        'rtriltri': '\u29CE',
        'RuleDelayed': '\u29F4',
        'ruluhar': '\u2968',
        'rx': '\u211E',
        'sacute': '\u015B',
        'Sacute': '\u015A',
        'sbquo': '\u201A',
        'sc': '\u227B',
        'Sc': '\u2ABC',
        'scap': '\u2AB8',
        'scaron': '\u0161',
        'Scaron': '\u0160',
        'sccue': '\u227D',
        'sce': '\u2AB0',
        'scE': '\u2AB4',
        'scedil': '\u015F',
        'Scedil': '\u015E',
        'scirc': '\u015D',
        'Scirc': '\u015C',
        'scnap': '\u2ABA',
        'scnE': '\u2AB6',
        'scnsim': '\u22E9',
        'scpolint': '\u2A13',
        'scsim': '\u227F',
        'scy': '\u0441',
        'Scy': '\u0421',
        'sdot': '\u22C5',
        'sdotb': '\u22A1',
        'sdote': '\u2A66',
        'searhk': '\u2925',
        'searr': '\u2198',
        'seArr': '\u21D8',
        'searrow': '\u2198',
        'sect': '\xA7',
        'semi': ';',
        'seswar': '\u2929',
        'setminus': '\u2216',
        'setmn': '\u2216',
        'sext': '\u2736',
        'sfr': '\uD835\uDD30',
        'Sfr': '\uD835\uDD16',
        'sfrown': '\u2322',
        'sharp': '\u266F',
        'shchcy': '\u0449',
        'SHCHcy': '\u0429',
        'shcy': '\u0448',
        'SHcy': '\u0428',
        'ShortDownArrow': '\u2193',
        'ShortLeftArrow': '\u2190',
        'shortmid': '\u2223',
        'shortparallel': '\u2225',
        'ShortRightArrow': '\u2192',
        'ShortUpArrow': '\u2191',
        'shy': '\xAD',
        'sigma': '\u03C3',
        'Sigma': '\u03A3',
        'sigmaf': '\u03C2',
        'sigmav': '\u03C2',
        'sim': '\u223C',
        'simdot': '\u2A6A',
        'sime': '\u2243',
        'simeq': '\u2243',
        'simg': '\u2A9E',
        'simgE': '\u2AA0',
        'siml': '\u2A9D',
        'simlE': '\u2A9F',
        'simne': '\u2246',
        'simplus': '\u2A24',
        'simrarr': '\u2972',
        'slarr': '\u2190',
        'SmallCircle': '\u2218',
        'smallsetminus': '\u2216',
        'smashp': '\u2A33',
        'smeparsl': '\u29E4',
        'smid': '\u2223',
        'smile': '\u2323',
        'smt': '\u2AAA',
        'smte': '\u2AAC',
        'smtes': '\u2AAC\uFE00',
        'softcy': '\u044C',
        'SOFTcy': '\u042C',
        'sol': '/',
        'solb': '\u29C4',
        'solbar': '\u233F',
        'sopf': '\uD835\uDD64',
        'Sopf': '\uD835\uDD4A',
        'spades': '\u2660',
        'spadesuit': '\u2660',
        'spar': '\u2225',
        'sqcap': '\u2293',
        'sqcaps': '\u2293\uFE00',
        'sqcup': '\u2294',
        'sqcups': '\u2294\uFE00',
        'Sqrt': '\u221A',
        'sqsub': '\u228F',
        'sqsube': '\u2291',
        'sqsubset': '\u228F',
        'sqsubseteq': '\u2291',
        'sqsup': '\u2290',
        'sqsupe': '\u2292',
        'sqsupset': '\u2290',
        'sqsupseteq': '\u2292',
        'squ': '\u25A1',
        'square': '\u25A1',
        'Square': '\u25A1',
        'SquareIntersection': '\u2293',
        'SquareSubset': '\u228F',
        'SquareSubsetEqual': '\u2291',
        'SquareSuperset': '\u2290',
        'SquareSupersetEqual': '\u2292',
        'SquareUnion': '\u2294',
        'squarf': '\u25AA',
        'squf': '\u25AA',
        'srarr': '\u2192',
        'sscr': '\uD835\uDCC8',
        'Sscr': '\uD835\uDCAE',
        'ssetmn': '\u2216',
        'ssmile': '\u2323',
        'sstarf': '\u22C6',
        'star': '\u2606',
        'Star': '\u22C6',
        'starf': '\u2605',
        'straightepsilon': '\u03F5',
        'straightphi': '\u03D5',
        'strns': '\xAF',
        'sub': '\u2282',
        'Sub': '\u22D0',
        'subdot': '\u2ABD',
        'sube': '\u2286',
        'subE': '\u2AC5',
        'subedot': '\u2AC3',
        'submult': '\u2AC1',
        'subne': '\u228A',
        'subnE': '\u2ACB',
        'subplus': '\u2ABF',
        'subrarr': '\u2979',
        'subset': '\u2282',
        'Subset': '\u22D0',
        'subseteq': '\u2286',
        'subseteqq': '\u2AC5',
        'SubsetEqual': '\u2286',
        'subsetneq': '\u228A',
        'subsetneqq': '\u2ACB',
        'subsim': '\u2AC7',
        'subsub': '\u2AD5',
        'subsup': '\u2AD3',
        'succ': '\u227B',
        'succapprox': '\u2AB8',
        'succcurlyeq': '\u227D',
        'Succeeds': '\u227B',
        'SucceedsEqual': '\u2AB0',
        'SucceedsSlantEqual': '\u227D',
        'SucceedsTilde': '\u227F',
        'succeq': '\u2AB0',
        'succnapprox': '\u2ABA',
        'succneqq': '\u2AB6',
        'succnsim': '\u22E9',
        'succsim': '\u227F',
        'SuchThat': '\u220B',
        'sum': '\u2211',
        'Sum': '\u2211',
        'sung': '\u266A',
        'sup': '\u2283',
        'Sup': '\u22D1',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'supdot': '\u2ABE',
        'supdsub': '\u2AD8',
        'supe': '\u2287',
        'supE': '\u2AC6',
        'supedot': '\u2AC4',
        'Superset': '\u2283',
        'SupersetEqual': '\u2287',
        'suphsol': '\u27C9',
        'suphsub': '\u2AD7',
        'suplarr': '\u297B',
        'supmult': '\u2AC2',
        'supne': '\u228B',
        'supnE': '\u2ACC',
        'supplus': '\u2AC0',
        'supset': '\u2283',
        'Supset': '\u22D1',
        'supseteq': '\u2287',
        'supseteqq': '\u2AC6',
        'supsetneq': '\u228B',
        'supsetneqq': '\u2ACC',
        'supsim': '\u2AC8',
        'supsub': '\u2AD4',
        'supsup': '\u2AD6',
        'swarhk': '\u2926',
        'swarr': '\u2199',
        'swArr': '\u21D9',
        'swarrow': '\u2199',
        'swnwar': '\u292A',
        'szlig': '\xDF',
        'Tab': '\t',
        'target': '\u2316',
        'tau': '\u03C4',
        'Tau': '\u03A4',
        'tbrk': '\u23B4',
        'tcaron': '\u0165',
        'Tcaron': '\u0164',
        'tcedil': '\u0163',
        'Tcedil': '\u0162',
        'tcy': '\u0442',
        'Tcy': '\u0422',
        'tdot': '\u20DB',
        'telrec': '\u2315',
        'tfr': '\uD835\uDD31',
        'Tfr': '\uD835\uDD17',
        'there4': '\u2234',
        'therefore': '\u2234',
        'Therefore': '\u2234',
        'theta': '\u03B8',
        'Theta': '\u0398',
        'thetasym': '\u03D1',
        'thetav': '\u03D1',
        'thickapprox': '\u2248',
        'thicksim': '\u223C',
        'ThickSpace': '\u205F\u200A',
        'thinsp': '\u2009',
        'ThinSpace': '\u2009',
        'thkap': '\u2248',
        'thksim': '\u223C',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'tilde': '\u02DC',
        'Tilde': '\u223C',
        'TildeEqual': '\u2243',
        'TildeFullEqual': '\u2245',
        'TildeTilde': '\u2248',
        'times': '\xD7',
        'timesb': '\u22A0',
        'timesbar': '\u2A31',
        'timesd': '\u2A30',
        'tint': '\u222D',
        'toea': '\u2928',
        'top': '\u22A4',
        'topbot': '\u2336',
        'topcir': '\u2AF1',
        'topf': '\uD835\uDD65',
        'Topf': '\uD835\uDD4B',
        'topfork': '\u2ADA',
        'tosa': '\u2929',
        'tprime': '\u2034',
        'trade': '\u2122',
        'TRADE': '\u2122',
        'triangle': '\u25B5',
        'triangledown': '\u25BF',
        'triangleleft': '\u25C3',
        'trianglelefteq': '\u22B4',
        'triangleq': '\u225C',
        'triangleright': '\u25B9',
        'trianglerighteq': '\u22B5',
        'tridot': '\u25EC',
        'trie': '\u225C',
        'triminus': '\u2A3A',
        'TripleDot': '\u20DB',
        'triplus': '\u2A39',
        'trisb': '\u29CD',
        'tritime': '\u2A3B',
        'trpezium': '\u23E2',
        'tscr': '\uD835\uDCC9',
        'Tscr': '\uD835\uDCAF',
        'tscy': '\u0446',
        'TScy': '\u0426',
        'tshcy': '\u045B',
        'TSHcy': '\u040B',
        'tstrok': '\u0167',
        'Tstrok': '\u0166',
        'twixt': '\u226C',
        'twoheadleftarrow': '\u219E',
        'twoheadrightarrow': '\u21A0',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'uarr': '\u2191',
        'uArr': '\u21D1',
        'Uarr': '\u219F',
        'Uarrocir': '\u2949',
        'ubrcy': '\u045E',
        'Ubrcy': '\u040E',
        'ubreve': '\u016D',
        'Ubreve': '\u016C',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ucy': '\u0443',
        'Ucy': '\u0423',
        'udarr': '\u21C5',
        'udblac': '\u0171',
        'Udblac': '\u0170',
        'udhar': '\u296E',
        'ufisht': '\u297E',
        'ufr': '\uD835\uDD32',
        'Ufr': '\uD835\uDD18',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uHar': '\u2963',
        'uharl': '\u21BF',
        'uharr': '\u21BE',
        'uhblk': '\u2580',
        'ulcorn': '\u231C',
        'ulcorner': '\u231C',
        'ulcrop': '\u230F',
        'ultri': '\u25F8',
        'umacr': '\u016B',
        'Umacr': '\u016A',
        'uml': '\xA8',
        'UnderBar': '_',
        'UnderBrace': '\u23DF',
        'UnderBracket': '\u23B5',
        'UnderParenthesis': '\u23DD',
        'Union': '\u22C3',
        'UnionPlus': '\u228E',
        'uogon': '\u0173',
        'Uogon': '\u0172',
        'uopf': '\uD835\uDD66',
        'Uopf': '\uD835\uDD4C',
        'uparrow': '\u2191',
        'Uparrow': '\u21D1',
        'UpArrow': '\u2191',
        'UpArrowBar': '\u2912',
        'UpArrowDownArrow': '\u21C5',
        'updownarrow': '\u2195',
        'Updownarrow': '\u21D5',
        'UpDownArrow': '\u2195',
        'UpEquilibrium': '\u296E',
        'upharpoonleft': '\u21BF',
        'upharpoonright': '\u21BE',
        'uplus': '\u228E',
        'UpperLeftArrow': '\u2196',
        'UpperRightArrow': '\u2197',
        'upsi': '\u03C5',
        'Upsi': '\u03D2',
        'upsih': '\u03D2',
        'upsilon': '\u03C5',
        'Upsilon': '\u03A5',
        'UpTee': '\u22A5',
        'UpTeeArrow': '\u21A5',
        'upuparrows': '\u21C8',
        'urcorn': '\u231D',
        'urcorner': '\u231D',
        'urcrop': '\u230E',
        'uring': '\u016F',
        'Uring': '\u016E',
        'urtri': '\u25F9',
        'uscr': '\uD835\uDCCA',
        'Uscr': '\uD835\uDCB0',
        'utdot': '\u22F0',
        'utilde': '\u0169',
        'Utilde': '\u0168',
        'utri': '\u25B5',
        'utrif': '\u25B4',
        'uuarr': '\u21C8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'uwangle': '\u29A7',
        'vangrt': '\u299C',
        'varepsilon': '\u03F5',
        'varkappa': '\u03F0',
        'varnothing': '\u2205',
        'varphi': '\u03D5',
        'varpi': '\u03D6',
        'varpropto': '\u221D',
        'varr': '\u2195',
        'vArr': '\u21D5',
        'varrho': '\u03F1',
        'varsigma': '\u03C2',
        'varsubsetneq': '\u228A\uFE00',
        'varsubsetneqq': '\u2ACB\uFE00',
        'varsupsetneq': '\u228B\uFE00',
        'varsupsetneqq': '\u2ACC\uFE00',
        'vartheta': '\u03D1',
        'vartriangleleft': '\u22B2',
        'vartriangleright': '\u22B3',
        'vBar': '\u2AE8',
        'Vbar': '\u2AEB',
        'vBarv': '\u2AE9',
        'vcy': '\u0432',
        'Vcy': '\u0412',
        'vdash': '\u22A2',
        'vDash': '\u22A8',
        'Vdash': '\u22A9',
        'VDash': '\u22AB',
        'Vdashl': '\u2AE6',
        'vee': '\u2228',
        'Vee': '\u22C1',
        'veebar': '\u22BB',
        'veeeq': '\u225A',
        'vellip': '\u22EE',
        'verbar': '|',
        'Verbar': '\u2016',
        'vert': '|',
        'Vert': '\u2016',
        'VerticalBar': '\u2223',
        'VerticalLine': '|',
        'VerticalSeparator': '\u2758',
        'VerticalTilde': '\u2240',
        'VeryThinSpace': '\u200A',
        'vfr': '\uD835\uDD33',
        'Vfr': '\uD835\uDD19',
        'vltri': '\u22B2',
        'vnsub': '\u2282\u20D2',
        'vnsup': '\u2283\u20D2',
        'vopf': '\uD835\uDD67',
        'Vopf': '\uD835\uDD4D',
        'vprop': '\u221D',
        'vrtri': '\u22B3',
        'vscr': '\uD835\uDCCB',
        'Vscr': '\uD835\uDCB1',
        'vsubne': '\u228A\uFE00',
        'vsubnE': '\u2ACB\uFE00',
        'vsupne': '\u228B\uFE00',
        'vsupnE': '\u2ACC\uFE00',
        'Vvdash': '\u22AA',
        'vzigzag': '\u299A',
        'wcirc': '\u0175',
        'Wcirc': '\u0174',
        'wedbar': '\u2A5F',
        'wedge': '\u2227',
        'Wedge': '\u22C0',
        'wedgeq': '\u2259',
        'weierp': '\u2118',
        'wfr': '\uD835\uDD34',
        'Wfr': '\uD835\uDD1A',
        'wopf': '\uD835\uDD68',
        'Wopf': '\uD835\uDD4E',
        'wp': '\u2118',
        'wr': '\u2240',
        'wreath': '\u2240',
        'wscr': '\uD835\uDCCC',
        'Wscr': '\uD835\uDCB2',
        'xcap': '\u22C2',
        'xcirc': '\u25EF',
        'xcup': '\u22C3',
        'xdtri': '\u25BD',
        'xfr': '\uD835\uDD35',
        'Xfr': '\uD835\uDD1B',
        'xharr': '\u27F7',
        'xhArr': '\u27FA',
        'xi': '\u03BE',
        'Xi': '\u039E',
        'xlarr': '\u27F5',
        'xlArr': '\u27F8',
        'xmap': '\u27FC',
        'xnis': '\u22FB',
        'xodot': '\u2A00',
        'xopf': '\uD835\uDD69',
        'Xopf': '\uD835\uDD4F',
        'xoplus': '\u2A01',
        'xotime': '\u2A02',
        'xrarr': '\u27F6',
        'xrArr': '\u27F9',
        'xscr': '\uD835\uDCCD',
        'Xscr': '\uD835\uDCB3',
        'xsqcup': '\u2A06',
        'xuplus': '\u2A04',
        'xutri': '\u25B3',
        'xvee': '\u22C1',
        'xwedge': '\u22C0',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yacy': '\u044F',
        'YAcy': '\u042F',
        'ycirc': '\u0177',
        'Ycirc': '\u0176',
        'ycy': '\u044B',
        'Ycy': '\u042B',
        'yen': '\xA5',
        'yfr': '\uD835\uDD36',
        'Yfr': '\uD835\uDD1C',
        'yicy': '\u0457',
        'YIcy': '\u0407',
        'yopf': '\uD835\uDD6A',
        'Yopf': '\uD835\uDD50',
        'yscr': '\uD835\uDCCE',
        'Yscr': '\uD835\uDCB4',
        'yucy': '\u044E',
        'YUcy': '\u042E',
        'yuml': '\xFF',
        'Yuml': '\u0178',
        'zacute': '\u017A',
        'Zacute': '\u0179',
        'zcaron': '\u017E',
        'Zcaron': '\u017D',
        'zcy': '\u0437',
        'Zcy': '\u0417',
        'zdot': '\u017C',
        'Zdot': '\u017B',
        'zeetrf': '\u2128',
        'ZeroWidthSpace': '\u200B',
        'zeta': '\u03B6',
        'Zeta': '\u0396',
        'zfr': '\uD835\uDD37',
        'Zfr': '\u2128',
        'zhcy': '\u0436',
        'ZHcy': '\u0416',
        'zigrarr': '\u21DD',
        'zopf': '\uD835\uDD6B',
        'Zopf': '\u2124',
        'zscr': '\uD835\uDCCF',
        'Zscr': '\uD835\uDCB5',
        'zwj': '\u200D',
        'zwnj': '\u200C'
    };
    var decodeMapLegacy = {
        'aacute': '\xE1',
        'Aacute': '\xC1',
        'acirc': '\xE2',
        'Acirc': '\xC2',
        'acute': '\xB4',
        'aelig': '\xE6',
        'AElig': '\xC6',
        'agrave': '\xE0',
        'Agrave': '\xC0',
        'amp': '&',
        'AMP': '&',
        'aring': '\xE5',
        'Aring': '\xC5',
        'atilde': '\xE3',
        'Atilde': '\xC3',
        'auml': '\xE4',
        'Auml': '\xC4',
        'brvbar': '\xA6',
        'ccedil': '\xE7',
        'Ccedil': '\xC7',
        'cedil': '\xB8',
        'cent': '\xA2',
        'copy': '\xA9',
        'COPY': '\xA9',
        'curren': '\xA4',
        'deg': '\xB0',
        'divide': '\xF7',
        'eacute': '\xE9',
        'Eacute': '\xC9',
        'ecirc': '\xEA',
        'Ecirc': '\xCA',
        'egrave': '\xE8',
        'Egrave': '\xC8',
        'eth': '\xF0',
        'ETH': '\xD0',
        'euml': '\xEB',
        'Euml': '\xCB',
        'frac12': '\xBD',
        'frac14': '\xBC',
        'frac34': '\xBE',
        'gt': '>',
        'GT': '>',
        'iacute': '\xED',
        'Iacute': '\xCD',
        'icirc': '\xEE',
        'Icirc': '\xCE',
        'iexcl': '\xA1',
        'igrave': '\xEC',
        'Igrave': '\xCC',
        'iquest': '\xBF',
        'iuml': '\xEF',
        'Iuml': '\xCF',
        'laquo': '\xAB',
        'lt': '<',
        'LT': '<',
        'macr': '\xAF',
        'micro': '\xB5',
        'middot': '\xB7',
        'nbsp': '\xA0',
        'not': '\xAC',
        'ntilde': '\xF1',
        'Ntilde': '\xD1',
        'oacute': '\xF3',
        'Oacute': '\xD3',
        'ocirc': '\xF4',
        'Ocirc': '\xD4',
        'ograve': '\xF2',
        'Ograve': '\xD2',
        'ordf': '\xAA',
        'ordm': '\xBA',
        'oslash': '\xF8',
        'Oslash': '\xD8',
        'otilde': '\xF5',
        'Otilde': '\xD5',
        'ouml': '\xF6',
        'Ouml': '\xD6',
        'para': '\xB6',
        'plusmn': '\xB1',
        'pound': '\xA3',
        'quot': '"',
        'QUOT': '"',
        'raquo': '\xBB',
        'reg': '\xAE',
        'REG': '\xAE',
        'sect': '\xA7',
        'shy': '\xAD',
        'sup1': '\xB9',
        'sup2': '\xB2',
        'sup3': '\xB3',
        'szlig': '\xDF',
        'thorn': '\xFE',
        'THORN': '\xDE',
        'times': '\xD7',
        'uacute': '\xFA',
        'Uacute': '\xDA',
        'ucirc': '\xFB',
        'Ucirc': '\xDB',
        'ugrave': '\xF9',
        'Ugrave': '\xD9',
        'uml': '\xA8',
        'uuml': '\xFC',
        'Uuml': '\xDC',
        'yacute': '\xFD',
        'Yacute': '\xDD',
        'yen': '\xA5',
        'yuml': '\xFF'
    };
    var decodeMapNumeric = {
        '0': '\uFFFD',
        '128': '\u20AC',
        '130': '\u201A',
        '131': '\u0192',
        '132': '\u201E',
        '133': '\u2026',
        '134': '\u2020',
        '135': '\u2021',
        '136': '\u02C6',
        '137': '\u2030',
        '138': '\u0160',
        '139': '\u2039',
        '140': '\u0152',
        '142': '\u017D',
        '145': '\u2018',
        '146': '\u2019',
        '147': '\u201C',
        '148': '\u201D',
        '149': '\u2022',
        '150': '\u2013',
        '151': '\u2014',
        '152': '\u02DC',
        '153': '\u2122',
        '154': '\u0161',
        '155': '\u203A',
        '156': '\u0153',
        '158': '\u017E',
        '159': '\u0178'
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = '';
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError('character reference outside the permissible Unicode range');
            return '\uFFFD';
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError('disallowed character reference');
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError('disallowed character reference');
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return '&#x' + codePoint.toString(16).toUpperCase() + ';';
    };
    var decEscape = function(codePoint) {
        return '&#' + codePoint + ';';
    };
    var parseError = function(message) {
        throw Error('Parse error: ' + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError('forbidden code point');
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return '&' + encodeMap[symbol] + ';';
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;').replace(/&#x66;&#x6A;/g, '&fjlig;');
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return '&' + encodeMap[string] + ';'; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, '&nvgt;').replace(/&lt;\u20D2/g, '&nvlt;');
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return '&' + encodeMap[string] + ';';
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        'allowUnsafeSymbols': false,
        'encodeEverything': false,
        'strict': false,
        'useNamedReferences': false,
        'decimal': false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError('malformed character reference');
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == '=') parseError('`&` did not start a character reference');
                    return $0;
                } else {
                    if (strict) parseError('named character reference was not terminated by a semicolon');
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || '');
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError('character reference was not terminated by a semicolon');
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError('named character reference was not terminated by a semicolon');
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        'isAttributeValue': false,
        'strict': false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        'version': '1.2.0',
        'encode': encode,
        'decode': decode,
        'escape': escape,
        'unescape': decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("6nXoo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3iXjX = parcelRequire("3iXjX");
'use strict';

var $8pbfm = parcelRequire("8pbfm");
var $4a62f624b197532e$var$isString = function(x) {
    return typeof x === 'string';
};
// resolves . and .. elements in a path array with directory names there
// must be no slashes or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function $4a62f624b197532e$var$normalizeArray(parts, allowAboveRoot) {
    var res = [];
    for(var i = 0; i < parts.length; i++){
        var p = parts[i];
        // ignore empty parts
        if (!p || p === '.') continue;
        if (p === '..') {
            if (res.length && res[res.length - 1] !== '..') res.pop();
            else if (allowAboveRoot) res.push('..');
        } else res.push(p);
    }
    return res;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $4a62f624b197532e$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var $4a62f624b197532e$var$posix = {};
function $4a62f624b197532e$var$posixSplitPath(filename) {
    return $4a62f624b197532e$var$splitPathRe.exec(filename).slice(1);
}
// path.resolve([from ...], to)
// posix version
$4a62f624b197532e$var$posix.resolve = function() {
    var resolvedPath = '', resolvedAbsolute = false;
    for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? arguments[i] : $3iXjX.cwd();
        // Skip empty and invalid entries
        if (!$4a62f624b197532e$var$isString(path)) throw new TypeError('Arguments to path.resolve must be strings');
        else if (!path) continue;
        resolvedPath = path + '/' + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $4a62f624b197532e$var$normalizeArray(resolvedPath.split('/'), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};
// path.normalize(path)
// posix version
$4a62f624b197532e$var$posix.normalize = function(path) {
    var isAbsolute = $4a62f624b197532e$var$posix.isAbsolute(path), trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    path = $4a62f624b197532e$var$normalizeArray(path.split('/'), !isAbsolute).join('/');
    if (!path && !isAbsolute) path = '.';
    if (path && trailingSlash) path += '/';
    return (isAbsolute ? '/' : '') + path;
};
// posix version
$4a62f624b197532e$var$posix.isAbsolute = function(path) {
    return path.charAt(0) === '/';
};
// posix version
$4a62f624b197532e$var$posix.join = function() {
    var path = '';
    for(var i = 0; i < arguments.length; i++){
        var segment = arguments[i];
        if (!$4a62f624b197532e$var$isString(segment)) throw new TypeError('Arguments to path.join must be strings');
        if (segment) {
            if (!path) path += segment;
            else path += '/' + segment;
        }
    }
    return $4a62f624b197532e$var$posix.normalize(path);
};
// path.relative(from, to)
// posix version
$4a62f624b197532e$var$posix.relative = function(from, to) {
    from = $4a62f624b197532e$var$posix.resolve(from).substr(1);
    to = $4a62f624b197532e$var$posix.resolve(to).substr(1);
    function trim(arr) {
        var start = 0;
        for(; start < arr.length; start++){
            if (arr[start] !== '') break;
        }
        var end = arr.length - 1;
        for(; end >= 0; end--){
            if (arr[end] !== '') break;
        }
        if (start > end) return [];
        return arr.slice(start, end + 1);
    }
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
};
$4a62f624b197532e$var$posix._makeLong = function(path) {
    return path;
};
$4a62f624b197532e$var$posix.dirname = function(path) {
    var result = $4a62f624b197532e$var$posixSplitPath(path), root = result[0], dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
};
$4a62f624b197532e$var$posix.basename = function(path, ext) {
    var f = $4a62f624b197532e$var$posixSplitPath(path)[2];
    // TODO: make this comparison case-insensitive on windows?
    if (ext && f.substr(-1 * ext.length) === ext) f = f.substr(0, f.length - ext.length);
    return f;
};
$4a62f624b197532e$var$posix.extname = function(path) {
    return $4a62f624b197532e$var$posixSplitPath(path)[3];
};
$4a62f624b197532e$var$posix.format = function(pathObject) {
    if (!$8pbfm.isObject(pathObject)) throw new TypeError("Parameter 'pathObject' must be an object, not " + typeof pathObject);
    var root = pathObject.root || '';
    if (!$4a62f624b197532e$var$isString(root)) throw new TypeError("'pathObject.root' must be a string or undefined, not " + typeof pathObject.root);
    var dir = pathObject.dir ? pathObject.dir + $4a62f624b197532e$var$posix.sep : '';
    var base = pathObject.base || '';
    return dir + base;
};
$4a62f624b197532e$var$posix.parse = function(pathString) {
    if (!$4a62f624b197532e$var$isString(pathString)) throw new TypeError("Parameter 'pathString' must be a string, not " + typeof pathString);
    var allParts = $4a62f624b197532e$var$posixSplitPath(pathString);
    if (!allParts || allParts.length !== 4) throw new TypeError("Invalid path '" + pathString + "'");
    allParts[1] = allParts[1] || '';
    allParts[2] = allParts[2] || '';
    allParts[3] = allParts[3] || '';
    return {
        root: allParts[0],
        dir: allParts[0] + allParts[1].slice(0, allParts[1].length - 1),
        base: allParts[2],
        ext: allParts[3],
        name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
    };
};
$4a62f624b197532e$var$posix.sep = '/';
$4a62f624b197532e$var$posix.delimiter = ':';
module.exports = $4a62f624b197532e$var$posix;

});

parcelRegister("hz7bI", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $3iXjX = parcelRequire("3iXjX");
'use strict';
function $cc9b47eeabca47a3$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $cc9b47eeabca47a3$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $cc9b47eeabca47a3$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $cc9b47eeabca47a3$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $3iXjX.cwd();
                path = cwd;
            }
            $cc9b47eeabca47a3$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $cc9b47eeabca47a3$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $cc9b47eeabca47a3$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $cc9b47eeabca47a3$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $cc9b47eeabca47a3$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $cc9b47eeabca47a3$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $cc9b47eeabca47a3$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $cc9b47eeabca47a3$var$assertPath(from);
        $cc9b47eeabca47a3$var$assertPath(to);
        if (from === to) return '';
        from = $cc9b47eeabca47a3$var$posix.resolve(from);
        to = $cc9b47eeabca47a3$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $cc9b47eeabca47a3$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $cc9b47eeabca47a3$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $cc9b47eeabca47a3$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $cc9b47eeabca47a3$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $cc9b47eeabca47a3$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$cc9b47eeabca47a3$var$posix.posix = $cc9b47eeabca47a3$var$posix;
module.exports = $cc9b47eeabca47a3$var$posix;

});

parcelRegister("dFQuL", function(module, exports) {

$parcel$export(module.exports, "convert2nimn", function () { return $9f47d3296bd2242d$export$fa981bbccf843781; }, function (v) { return $9f47d3296bd2242d$export$fa981bbccf843781 = v; });
var $9f47d3296bd2242d$export$fa981bbccf843781;
'use strict';
const $9f47d3296bd2242d$var$char = function(a) {
    return String.fromCharCode(a);
};
const $9f47d3296bd2242d$var$chars = {
    nilChar: $9f47d3296bd2242d$var$char(176),
    missingChar: $9f47d3296bd2242d$var$char(201),
    nilPremitive: $9f47d3296bd2242d$var$char(175),
    missingPremitive: $9f47d3296bd2242d$var$char(200),
    emptyChar: $9f47d3296bd2242d$var$char(178),
    emptyValue: $9f47d3296bd2242d$var$char(177),
    boundryChar: $9f47d3296bd2242d$var$char(179),
    objStart: $9f47d3296bd2242d$var$char(198),
    arrStart: $9f47d3296bd2242d$var$char(204),
    arrayEnd: $9f47d3296bd2242d$var$char(185)
};
const $9f47d3296bd2242d$var$charsArr = [
    $9f47d3296bd2242d$var$chars.nilChar,
    $9f47d3296bd2242d$var$chars.nilPremitive,
    $9f47d3296bd2242d$var$chars.missingChar,
    $9f47d3296bd2242d$var$chars.missingPremitive,
    $9f47d3296bd2242d$var$chars.boundryChar,
    $9f47d3296bd2242d$var$chars.emptyChar,
    $9f47d3296bd2242d$var$chars.emptyValue,
    $9f47d3296bd2242d$var$chars.arrayEnd,
    $9f47d3296bd2242d$var$chars.objStart,
    $9f47d3296bd2242d$var$chars.arrStart
];
const $9f47d3296bd2242d$var$_e = function(node, e_schema, options) {
    if (typeof e_schema === 'string') {
        //premitive
        if (node && node[0] && node[0].val !== undefined) return $9f47d3296bd2242d$var$getValue(node[0].val, e_schema);
        else return $9f47d3296bd2242d$var$getValue(node, e_schema);
    } else {
        const hasValidData = $9f47d3296bd2242d$var$hasData(node);
        if (hasValidData === true) {
            let str = '';
            if (Array.isArray(e_schema)) {
                //attributes can't be repeated. hence check in children tags only
                str += $9f47d3296bd2242d$var$chars.arrStart;
                const itemSchema = e_schema[0];
                //var itemSchemaType = itemSchema;
                const arr_len = node.length;
                if (typeof itemSchema === 'string') for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $9f47d3296bd2242d$var$getValue(node[arr_i].val, itemSchema);
                    str = $9f47d3296bd2242d$var$processValue(str, r);
                }
                else for(let arr_i = 0; arr_i < arr_len; arr_i++){
                    const r = $9f47d3296bd2242d$var$_e(node[arr_i], itemSchema, options);
                    str = $9f47d3296bd2242d$var$processValue(str, r);
                }
                str += $9f47d3296bd2242d$var$chars.arrayEnd; //indicates that next item is not array item
            } else {
                //object
                str += $9f47d3296bd2242d$var$chars.objStart;
                const keys = Object.keys(e_schema);
                if (Array.isArray(node)) node = node[0];
                for(let i in keys){
                    const key = keys[i];
                    //a property defined in schema can be present either in attrsMap or children tags
                    //options.textNodeName will not present in both maps, take it's value from val
                    //options.attrNodeName will be present in attrsMap
                    let r;
                    if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) r = $9f47d3296bd2242d$var$_e(node.attrsMap[key], e_schema[key], options);
                    else if (key === options.textNodeName) r = $9f47d3296bd2242d$var$_e(node.val, e_schema[key], options);
                    else r = $9f47d3296bd2242d$var$_e(node.child[key], e_schema[key], options);
                    str = $9f47d3296bd2242d$var$processValue(str, r);
                }
            }
            return str;
        } else return hasValidData;
    }
};
const $9f47d3296bd2242d$var$getValue = function(a /*, type*/ ) {
    switch(a){
        case undefined:
            return $9f47d3296bd2242d$var$chars.missingPremitive;
        case null:
            return $9f47d3296bd2242d$var$chars.nilPremitive;
        case '':
            return $9f47d3296bd2242d$var$chars.emptyValue;
        default:
            return a;
    }
};
const $9f47d3296bd2242d$var$processValue = function(str, r) {
    if (!$9f47d3296bd2242d$var$isAppChar(r[0]) && !$9f47d3296bd2242d$var$isAppChar(str[str.length - 1])) str += $9f47d3296bd2242d$var$chars.boundryChar;
    return str + r;
};
const $9f47d3296bd2242d$var$isAppChar = function(ch) {
    return $9f47d3296bd2242d$var$charsArr.indexOf(ch) !== -1;
};
function $9f47d3296bd2242d$var$hasData(jObj) {
    if (jObj === undefined) return $9f47d3296bd2242d$var$chars.missingChar;
    else if (jObj === null) return $9f47d3296bd2242d$var$chars.nilChar;
    else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) return $9f47d3296bd2242d$var$chars.emptyChar;
    else return true;
}

var $2v1OG = parcelRequire("2v1OG");

var $7PKBV = parcelRequire("7PKBV");
var $9f47d3296bd2242d$require$buildOptions = $7PKBV.buildOptions;
const $9f47d3296bd2242d$var$convert2nimn = function(node, e_schema, options) {
    options = $9f47d3296bd2242d$require$buildOptions(options, $2v1OG.defaultOptions, $2v1OG.props);
    return $9f47d3296bd2242d$var$_e(node, e_schema, options);
};
$9f47d3296bd2242d$export$fa981bbccf843781 = $9f47d3296bd2242d$var$convert2nimn;

});
parcelRegister("2v1OG", function(module, exports) {

$parcel$export(module.exports, "defaultOptions", function () { return $1d1fe2c1761f1ba6$export$ba43bf67f3d48107; }, function (v) { return $1d1fe2c1761f1ba6$export$ba43bf67f3d48107 = v; });
$parcel$export(module.exports, "props", function () { return $1d1fe2c1761f1ba6$export$8128bb6492cf3de7; }, function (v) { return $1d1fe2c1761f1ba6$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "getTraversalObj", function () { return $1d1fe2c1761f1ba6$export$2ca3eb0a2f8a693a; }, function (v) { return $1d1fe2c1761f1ba6$export$2ca3eb0a2f8a693a = v; });
var $1d1fe2c1761f1ba6$export$ba43bf67f3d48107;
var $1d1fe2c1761f1ba6$export$8128bb6492cf3de7;
var $1d1fe2c1761f1ba6$export$2ca3eb0a2f8a693a;
'use strict';

var $7PKBV = parcelRequire("7PKBV");

var $7PKBV = parcelRequire("7PKBV");
var $1d1fe2c1761f1ba6$require$buildOptions = $7PKBV.buildOptions;

var $a1wAK = parcelRequire("a1wAK");
const $1d1fe2c1761f1ba6$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $7PKBV.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $1d1fe2c1761f1ba6$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    ignoreNameSpace: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseNodeValue: true,
    parseAttributeValue: false,
    arrayMode: false,
    trimValues: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    tagValueProcessor: function(a, tagName) {
        return a;
    },
    attrValueProcessor: function(a, attrName) {
        return a;
    },
    stopNodes: []
};
$1d1fe2c1761f1ba6$export$ba43bf67f3d48107 = $1d1fe2c1761f1ba6$var$defaultOptions;
const $1d1fe2c1761f1ba6$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'ignoreNameSpace',
    'allowBooleanAttributes',
    'parseNodeValue',
    'parseAttributeValue',
    'arrayMode',
    'trimValues',
    'cdataTagName',
    'cdataPositionChar',
    'tagValueProcessor',
    'attrValueProcessor',
    'parseTrueNumberOnly',
    'stopNodes'
];
$1d1fe2c1761f1ba6$export$8128bb6492cf3de7 = $1d1fe2c1761f1ba6$var$props;
/**
 * Trim -> valueProcessor -> parse value
 * @param {string} tagName
 * @param {string} val
 * @param {object} options
 */ function $1d1fe2c1761f1ba6$var$processTagValue(tagName, val, options) {
    if (val) {
        if (options.trimValues) val = val.trim();
        val = options.tagValueProcessor(val, tagName);
        val = $1d1fe2c1761f1ba6$var$parseValue(val, options.parseNodeValue, options.parseTrueNumberOnly);
    }
    return val;
}
function $1d1fe2c1761f1ba6$var$resolveNameSpace(tagname, options) {
    if (options.ignoreNameSpace) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
function $1d1fe2c1761f1ba6$var$parseValue(val, shouldParse, parseTrueNumberOnly) {
    if (shouldParse && typeof val === 'string') {
        let parsed;
        if (val.trim() === '' || isNaN(val)) parsed = val === 'true' ? true : val === 'false' ? false : val;
        else {
            if (val.indexOf('0x') !== -1) //support hexa decimal
            parsed = Number.parseInt(val, 16);
            else if (val.indexOf('.') !== -1) {
                parsed = Number.parseFloat(val);
                val = val.replace(/\.?0+$/, "");
            } else parsed = Number.parseInt(val, 10);
            if (parseTrueNumberOnly) parsed = String(parsed) === val ? parsed : val;
        }
        return parsed;
    } else {
        if ($7PKBV.isExist(val)) return val;
        else return '';
    }
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $1d1fe2c1761f1ba6$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');
function $1d1fe2c1761f1ba6$var$buildAttributesMap(attrStr, options) {
    if (!options.ignoreAttributes && typeof attrStr === 'string') {
        attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $7PKBV.getAllMatches(attrStr, $1d1fe2c1761f1ba6$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = $1d1fe2c1761f1ba6$var$resolveNameSpace(matches[i][1], options);
            if (attrName.length) {
                if (matches[i][4] !== undefined) {
                    if (options.trimValues) matches[i][4] = matches[i][4].trim();
                    matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                    attrs[options.attributeNamePrefix + attrName] = $1d1fe2c1761f1ba6$var$parseValue(matches[i][4], options.parseAttributeValue, options.parseTrueNumberOnly);
                } else if (options.allowBooleanAttributes) attrs[options.attributeNamePrefix + attrName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (options.attrNodeName) {
            const attrCollection = {};
            attrCollection[options.attrNodeName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $1d1fe2c1761f1ba6$var$getTraversalObj = function(xmlData, options) {
    xmlData = xmlData.replace(/(\r\n)|\n/, " ");
    options = $1d1fe2c1761f1ba6$require$buildOptions(options, $1d1fe2c1761f1ba6$var$defaultOptions, $1d1fe2c1761f1ba6$var$props);
    const xmlObj = new $a1wAK('!xml');
    let currentNode = xmlObj;
    let textData = "";
    //function match(xmlData){
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            if (xmlData[i + 1] === '/') {
                const closeIndex = $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                /* if (currentNode.parent) {
          currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue2(tagName, textData , options);
        } */ if (currentNode) {
                    if (currentNode.val) currentNode.val = $7PKBV.getValue(currentNode.val) + '' + $1d1fe2c1761f1ba6$var$processTagValue(tagName, textData, options);
                    else currentNode.val = $1d1fe2c1761f1ba6$var$processTagValue(tagName, textData, options);
                }
                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                    currentNode.child = [];
                    if (currentNode.attrsMap == undefined) currentNode.attrsMap = {};
                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, i - currentNode.startIndex - 1);
                }
                currentNode = currentNode.parent;
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') i = $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, "?>", i, "Pi Tag is not closed.");
            else if (xmlData.substr(i + 1, 3) === '!--') i = $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, "-->", i, "Comment is not closed.");
            else if (xmlData.substr(i + 1, 2) === '!D') {
                const closeIndex = $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, ">", i, "DOCTYPE is not closed.");
                const tagExp = xmlData.substring(i, closeIndex);
                if (tagExp.indexOf("[") >= 0) i = xmlData.indexOf("]>", i) + 1;
                else i = closeIndex;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                //considerations
                //1. CDATA will always have parent node
                //2. A tag with CDATA is not a leaf node so it's value would be string type.
                if (textData) {
                    currentNode.val = $7PKBV.getValue(currentNode.val) + '' + $1d1fe2c1761f1ba6$var$processTagValue(currentNode.tagname, textData, options);
                    textData = "";
                }
                if (options.cdataTagName) {
                    //add cdata node
                    const childNode = new $a1wAK(options.cdataTagName, currentNode, tagExp);
                    currentNode.addChild(childNode);
                    //for backtracking
                    currentNode.val = $7PKBV.getValue(currentNode.val) + options.cdataPositionChar;
                    //add rest value to parent node
                    if (tagExp) childNode.val = tagExp;
                } else currentNode.val = (currentNode.val || '') + (tagExp || '');
                i = closeIndex + 2;
            } else {
                const result = $1d1fe2c1761f1ba6$var$closingIndexForOpeningTag(xmlData, i + 1);
                let tagExp = result.data;
                const closeIndex = result.index;
                const separatorIndex = tagExp.indexOf(" ");
                let tagName = tagExp;
                if (separatorIndex !== -1) {
                    tagName = tagExp.substr(0, separatorIndex).trimRight();
                    tagExp = tagExp.substr(separatorIndex + 1);
                }
                if (options.ignoreNameSpace) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                //save text to parent node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') currentNode.val = $7PKBV.getValue(currentNode.val) + '' + $1d1fe2c1761f1ba6$var$processTagValue(currentNode.tagname, textData, options);
                }
                if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                    if (tagName[tagName.length - 1] === "/") {
                        tagName = tagName.substr(0, tagName.length - 1);
                        tagExp = tagName;
                    } else tagExp = tagExp.substr(0, tagExp.length - 1);
                    const childNode = new $a1wAK(tagName, currentNode, '');
                    if (tagName !== tagExp) childNode.attrsMap = $1d1fe2c1761f1ba6$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                } else {
                    const childNode = new $a1wAK(tagName, currentNode);
                    if (options.stopNodes.length && options.stopNodes.includes(childNode.tagname)) childNode.startIndex = closeIndex;
                    if (tagName !== tagExp) childNode.attrsMap = $1d1fe2c1761f1ba6$var$buildAttributesMap(tagExp, options);
                    currentNode.addChild(childNode);
                    currentNode = childNode;
                }
                textData = "";
                i = closeIndex;
            }
        } else textData += xmlData[i];
    }
    return xmlObj;
};
function $1d1fe2c1761f1ba6$var$closingIndexForOpeningTag(data, i) {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < data.length; index++){
        let ch = data[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === '>') return {
            data: tagExp,
            index: index
        };
        else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $1d1fe2c1761f1ba6$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
$1d1fe2c1761f1ba6$export$2ca3eb0a2f8a693a = $1d1fe2c1761f1ba6$var$getTraversalObj;

});
parcelRegister("7PKBV", function(module, exports) {

$parcel$export(module.exports, "isExist", function () { return $5b4173bb38ff8852$export$a5edf3f35b6dd392; }, function (v) { return $5b4173bb38ff8852$export$a5edf3f35b6dd392 = v; });
$parcel$export(module.exports, "isEmptyObject", function () { return $5b4173bb38ff8852$export$83b788b1a3698c03; }, function (v) { return $5b4173bb38ff8852$export$83b788b1a3698c03 = v; });
$parcel$export(module.exports, "merge", function () { return $5b4173bb38ff8852$export$4950aa0f605343fb; }, function (v) { return $5b4173bb38ff8852$export$4950aa0f605343fb = v; });
$parcel$export(module.exports, "getValue", function () { return $5b4173bb38ff8852$export$bf7199a9ebcb84a9; }, function (v) { return $5b4173bb38ff8852$export$bf7199a9ebcb84a9 = v; });
$parcel$export(module.exports, "buildOptions", function () { return $5b4173bb38ff8852$export$ecbd7d678ac4909b; }, function (v) { return $5b4173bb38ff8852$export$ecbd7d678ac4909b = v; });
$parcel$export(module.exports, "isName", function () { return $5b4173bb38ff8852$export$998d7ff9801e90bb; }, function (v) { return $5b4173bb38ff8852$export$998d7ff9801e90bb = v; });
$parcel$export(module.exports, "getAllMatches", function () { return $5b4173bb38ff8852$export$aaa9734c55cb7a19; }, function (v) { return $5b4173bb38ff8852$export$aaa9734c55cb7a19 = v; });
$parcel$export(module.exports, "nameRegexp", function () { return $5b4173bb38ff8852$export$e8f2644f7085b4b1; }, function (v) { return $5b4173bb38ff8852$export$e8f2644f7085b4b1 = v; });
var $5b4173bb38ff8852$export$a5edf3f35b6dd392;
var $5b4173bb38ff8852$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $5b4173bb38ff8852$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $5b4173bb38ff8852$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $5b4173bb38ff8852$export$ecbd7d678ac4909b;
var $5b4173bb38ff8852$export$998d7ff9801e90bb;
var $5b4173bb38ff8852$export$aaa9734c55cb7a19;
var $5b4173bb38ff8852$export$e8f2644f7085b4b1;
'use strict';
const $5b4173bb38ff8852$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $5b4173bb38ff8852$var$nameChar = $5b4173bb38ff8852$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $5b4173bb38ff8852$var$nameRegexp = '[' + $5b4173bb38ff8852$var$nameStartChar + '][' + $5b4173bb38ff8852$var$nameChar + ']*';
const $5b4173bb38ff8852$var$regexName = new RegExp('^' + $5b4173bb38ff8852$var$nameRegexp + '$');
const $5b4173bb38ff8852$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $5b4173bb38ff8852$var$isName = function(string) {
    const match = $5b4173bb38ff8852$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$5b4173bb38ff8852$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$5b4173bb38ff8852$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$5b4173bb38ff8852$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$5b4173bb38ff8852$export$bf7199a9ebcb84a9 = function(v) {
    if ($5b4173bb38ff8852$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$5b4173bb38ff8852$export$ecbd7d678ac4909b = function(options, defaultOptions, props) {
    var newOptions = {};
    if (!options) return defaultOptions; //if there are not options
    for(let i = 0; i < props.length; i++)if (options[props[i]] !== undefined) newOptions[props[i]] = options[props[i]];
    else newOptions[props[i]] = defaultOptions[props[i]];
    return newOptions;
};
$5b4173bb38ff8852$export$998d7ff9801e90bb = $5b4173bb38ff8852$var$isName;
$5b4173bb38ff8852$export$aaa9734c55cb7a19 = $5b4173bb38ff8852$var$getAllMatches;
$5b4173bb38ff8852$export$e8f2644f7085b4b1 = $5b4173bb38ff8852$var$nameRegexp;

});

parcelRegister("a1wAK", function(module, exports) {
'use strict';
module.exports = function(tagname, parent, val) {
    this.tagname = tagname;
    this.parent = parent;
    this.child = {}; //child tags
    this.attrsMap = {}; //attributes map
    this.val = val; //text only
    this.addChild = function(child) {
        if (Array.isArray(this.child[child.tagname])) //already presents
        this.child[child.tagname].push(child);
        else this.child[child.tagname] = [
            child
        ];
    };
};

});



parcelRegister("g0pSO", function(module, exports) {

$parcel$export(module.exports, "convertToJsonString", function () { return $ba70b94a058dd2e5$export$54ffaacfc0931fb0; }, function (v) { return $ba70b94a058dd2e5$export$54ffaacfc0931fb0 = v; });
var $ba70b94a058dd2e5$export$54ffaacfc0931fb0;
'use strict';

var $7PKBV = parcelRequire("7PKBV");

var $7PKBV = parcelRequire("7PKBV");
var $ba70b94a058dd2e5$require$buildOptions = $7PKBV.buildOptions;

var $2v1OG = parcelRequire("2v1OG");
//TODO: do it later
const $ba70b94a058dd2e5$var$convertToJsonString = function(node, options) {
    options = $ba70b94a058dd2e5$require$buildOptions(options, $2v1OG.defaultOptions, $2v1OG.props);
    options.indentBy = options.indentBy || '';
    return $ba70b94a058dd2e5$var$_cToJsonStr(node, options, 0);
};
const $ba70b94a058dd2e5$var$_cToJsonStr = function(node, options, level) {
    let jObj = '{';
    //traver through all the children
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        var tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj += '"' + tagname + '" : [ ';
            for(var tag in node.child[tagname])jObj += $ba70b94a058dd2e5$var$_cToJsonStr(node.child[tagname][tag], options) + ' , ';
            jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
        } else jObj += '"' + tagname + '" : ' + $ba70b94a058dd2e5$var$_cToJsonStr(node.child[tagname][0], options) + ' ,';
    }
    $7PKBV.merge(jObj, node.attrsMap);
    //add attrsMap as new children
    if ($7PKBV.isEmptyObject(jObj)) return $7PKBV.isExist(node.val) ? node.val : '';
    else {
        if ($7PKBV.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) jObj += '"' + options.textNodeName + '" : ' + $ba70b94a058dd2e5$var$stringval(node.val);
        }
    }
    //add value
    if (jObj[jObj.length - 1] === ',') jObj = jObj.substr(0, jObj.length - 2);
    return jObj + '}';
};
function $ba70b94a058dd2e5$var$stringval(v) {
    if (v === true || v === false || !isNaN(v)) return v;
    else return '"' + v + '"';
}
function $ba70b94a058dd2e5$var$indentate(options, level) {
    return options.indentBy.repeat(level);
}
$ba70b94a058dd2e5$export$54ffaacfc0931fb0 = $ba70b94a058dd2e5$var$convertToJsonString;

});

parcelRegister("eITKj", function(module, exports) {
'use strict';

var $7PKBV = parcelRequire("7PKBV");
var $02c422c0e89fdfa7$require$buildOptions = $7PKBV.buildOptions;
const $02c422c0e89fdfa7$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attrNodeName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataTagName: false,
    cdataPositionChar: '\\c',
    format: false,
    indentBy: '  ',
    supressEmptyNode: false,
    tagValueProcessor: function(a) {
        return a;
    },
    attrValueProcessor: function(a) {
        return a;
    }
};
const $02c422c0e89fdfa7$var$props = [
    'attributeNamePrefix',
    'attrNodeName',
    'textNodeName',
    'ignoreAttributes',
    'cdataTagName',
    'cdataPositionChar',
    'format',
    'indentBy',
    'supressEmptyNode',
    'tagValueProcessor',
    'attrValueProcessor'
];
function $02c422c0e89fdfa7$var$Parser(options) {
    this.options = $02c422c0e89fdfa7$require$buildOptions(options, $02c422c0e89fdfa7$var$defaultOptions, $02c422c0e89fdfa7$var$props);
    if (this.options.ignoreAttributes || this.options.attrNodeName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $02c422c0e89fdfa7$var$isAttribute;
    }
    if (this.options.cdataTagName) this.isCDATA = $02c422c0e89fdfa7$var$isCDATA;
    else this.isCDATA = function() {
        return false;
    };
    this.replaceCDATAstr = $02c422c0e89fdfa7$var$replaceCDATAstr;
    this.replaceCDATAarr = $02c422c0e89fdfa7$var$replaceCDATAarr;
    if (this.options.format) {
        this.indentate = $02c422c0e89fdfa7$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
    if (this.options.supressEmptyNode) {
        this.buildTextNode = $02c422c0e89fdfa7$var$buildEmptyTextNode;
        this.buildObjNode = $02c422c0e89fdfa7$var$buildEmptyObjNode;
    } else {
        this.buildTextNode = $02c422c0e89fdfa7$var$buildTextValNode;
        this.buildObjNode = $02c422c0e89fdfa7$var$buildObjectNode;
    }
    this.buildTextValNode = $02c422c0e89fdfa7$var$buildTextValNode;
    this.buildObjectNode = $02c422c0e89fdfa7$var$buildObjectNode;
}
$02c422c0e89fdfa7$var$Parser.prototype.parse = function(jObj) {
    return this.j2x(jObj, 0).val;
};
$02c422c0e89fdfa7$var$Parser.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    const keys = Object.keys(jObj);
    const len = keys.length;
    for(let i = 0; i < len; i++){
        const key = keys[i];
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        else if (jObj[key] instanceof Date) val += this.buildTextNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
            else if (this.isCDATA(key)) {
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAstr('', jObj[key]);
            } else //tag value
            if (key === this.options.textNodeName) {
                if (jObj[this.options.cdataTagName]) ;
                else val += this.options.tagValueProcessor('' + jObj[key]);
            } else val += this.buildTextNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            if (this.isCDATA(key)) {
                val += this.indentate(level);
                if (jObj[this.options.textNodeName]) val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                else val += this.replaceCDATAarr('', jObj[key]);
            } else {
                //nested nodes
                const arrLen = jObj[key].length;
                for(let j = 0; j < arrLen; j++){
                    const item = jObj[key][j];
                    if (typeof item === 'undefined') ;
                    else if (item === null) val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                    else if (typeof item === 'object') {
                        const result = this.j2x(item, level + 1);
                        val += this.buildObjNode(result.val, key, result.attrStr, level);
                    } else val += this.buildTextNode(item, key, '', level);
                }
            }
        } else //nested node
        if (this.options.attrNodeName && key === this.options.attrNodeName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += ' ' + Ks[j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[j]]) + '"';
        } else {
            const result = this.j2x(jObj[key], level + 1);
            val += this.buildObjNode(result.val, key, result.attrStr, level);
        }
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
function $02c422c0e89fdfa7$var$replaceCDATAstr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
    else return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
}
function $02c422c0e89fdfa7$var$replaceCDATAarr(str, cdata) {
    str = this.options.tagValueProcessor('' + str);
    if (this.options.cdataPositionChar === '' || str === '') return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
    else {
        for(let v in cdata)str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
        return str + this.newLine;
    }
}
function $02c422c0e89fdfa7$var$buildObjectNode(val, key, attrStr, level) {
    if (attrStr && !val.includes('<')) return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
    // + this.indentate(level)
    '</' + key + this.tagEndChar;
    else return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
    this.indentate(level) + '</' + key + this.tagEndChar;
}
function $02c422c0e89fdfa7$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $02c422c0e89fdfa7$var$buildTextValNode(val, key, attrStr, level) {
    return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
}
function $02c422c0e89fdfa7$var$buildEmptyTextNode(val, key, attrStr, level) {
    if (val !== '') return this.buildTextValNode(val, key, attrStr, level);
    else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
}
function $02c422c0e89fdfa7$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $02c422c0e89fdfa7$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
function $02c422c0e89fdfa7$var$isCDATA(name) {
    return name === this.options.cdataTagName;
}
//formatting
//indentation
//\n after each closing or self closing tag
module.exports = $02c422c0e89fdfa7$var$Parser;

});

parcelRegister("fGtTc", function(module, exports) {
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $b6b1f6a6d842b21c$require$encodePath = $aUV4R.encodePath;
var $b6b1f6a6d842b21c$require$joinURL = $aUV4R.joinURL;
var $b6b1f6a6d842b21c$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $b6b1f6a6d842b21c$require$request = $aUV4R.request;
const $b6b1f6a6d842b21c$var$NOOP = ()=>{};

function $b6b1f6a6d842b21c$var$createReadStream(filePath, options) {
    const Stream = (parcelRequire("2fkCS"));
    const PassThroughStream = Stream.PassThrough;
    const outStream = new PassThroughStream();
    $b6b1f6a6d842b21c$var$getFileStream(filePath, options).then((stream)=>{
        stream.pipe(outStream);
    }).catch((err)=>{
        outStream.emit("error", err);
    });
    return outStream;
}

function $b6b1f6a6d842b21c$var$createWriteStream(filePath, options, callback = $b6b1f6a6d842b21c$var$NOOP) {
    const Stream = (parcelRequire("2fkCS"));
    const PassThroughStream = Stream.PassThrough;
    const writeStream = new PassThroughStream();
    const headers = {};
    if (options.overwrite === false) headers["If-None-Match"] = "*";
    const requestOptions = {
        url: $b6b1f6a6d842b21c$require$joinURL(options.remoteURL, $b6b1f6a6d842b21c$require$encodePath(filePath)),
        method: "PUT",
        headers: headers,
        data: writeStream
    };
    $b6b1f6a6d842b21c$require$prepareRequestOptions(requestOptions, options);
    $b6b1f6a6d842b21c$require$request(requestOptions).then((response)=>{
        // Fire callback asynchronously to avoid errors
        setTimeout(callback, 0);
        return response;
    }).then($4Nbx7.handleResponseCode).catch((err)=>{
        writeStream.emit("error", err);
    });
    return writeStream;
}
function $b6b1f6a6d842b21c$var$getFileStream(filePath, options) {
    let rangeHeader;
    const headers = {};
    if (typeof options.range === "object" && typeof options.range.start === "number") {
        rangeHeader = "bytes=" + options.range.start + "-";
        if (typeof options.range.end === "number") rangeHeader += options.range.end;
        headers.Range = rangeHeader;
    }
    const requestOptions = {
        url: $b6b1f6a6d842b21c$require$joinURL(options.remoteURL, $b6b1f6a6d842b21c$require$encodePath(filePath)),
        method: "GET",
        headers: headers,
        responseType: "stream"
    };
    $b6b1f6a6d842b21c$require$prepareRequestOptions(requestOptions, options);
    return $b6b1f6a6d842b21c$require$request(requestOptions).then($4Nbx7.handleResponseCode).then((res)=>res.data);
}
module.exports = {
    createReadStream: $b6b1f6a6d842b21c$var$createReadStream,
    createWriteStream: $b6b1f6a6d842b21c$var$createWriteStream
};

});
parcelRegister("4Nbx7", function(module, exports) {
"use strict";

var $11YZg = parcelRequire("11YZg");
function $37d4af4a82160b45$var$handleResponseCode(response) {
    const status = parseInt(response.status, 10);
    let err;
    if (status >= 400) {
        err = new Error("Invalid response: " + status + " " + response.statusText);
        err.status = status;
        throw err;
    }
    return response;
}
function $37d4af4a82160b45$var$processGlobFilter(files, glob) {
    return files.filter((file)=>$11YZg(file.filename, glob, {
            matchBase: true
        }));
}
function $37d4af4a82160b45$var$processResponsePayload(response, data, isDetailed = false) {
    return isDetailed ? {
        data: data,
        headers: response.headers || {}
    } : data;
}
module.exports = {
    handleResponseCode: $37d4af4a82160b45$var$handleResponseCode,
    processGlobFilter: $37d4af4a82160b45$var$processGlobFilter,
    processResponsePayload: $37d4af4a82160b45$var$processResponsePayload
};

});
parcelRegister("11YZg", function(module, exports) {
module.exports = $0c053139fbc63362$var$minimatch;
$0c053139fbc63362$var$minimatch.Minimatch = $0c053139fbc63362$var$Minimatch;
var $0c053139fbc63362$var$path = {
    sep: '/'
};

try {
    $0c053139fbc63362$var$path = (parcelRequire("hz7bI"));
} catch (er) {}
var $0c053139fbc63362$var$GLOBSTAR = $0c053139fbc63362$var$minimatch.GLOBSTAR = $0c053139fbc63362$var$Minimatch.GLOBSTAR = {};

var $ezUqs = parcelRequire("ezUqs");
var $0c053139fbc63362$var$plTypes = {
    '!': {
        open: '(?:(?!(?:',
        close: '))[^/]*?)'
    },
    '?': {
        open: '(?:',
        close: ')?'
    },
    '+': {
        open: '(?:',
        close: ')+'
    },
    '*': {
        open: '(?:',
        close: ')*'
    },
    '@': {
        open: '(?:',
        close: ')'
    }
};
// any single thing other than /
// don't need to escape / when using new RegExp()
var $0c053139fbc63362$var$qmark = '[^/]';
// * => any number of characters
var $0c053139fbc63362$var$star = $0c053139fbc63362$var$qmark + '*?';
// ** when dots are allowed.  Anything goes, except .. and .
// not (^ or / followed by one or two dots followed by $ or /),
// followed by anything, any number of times.
var $0c053139fbc63362$var$twoStarDot = '(?:(?!(?:\\\/|^)(?:\\.{1,2})($|\\\/)).)*?';
// not a ^ or / followed by a dot,
// followed by anything, any number of times.
var $0c053139fbc63362$var$twoStarNoDot = '(?:(?!(?:\\\/|^)\\.).)*?';
// characters that need to be escaped in RegExp.
var $0c053139fbc63362$var$reSpecials = $0c053139fbc63362$var$charSet('().*{}+?[]^$\\!');
// "abc" -> { a:true, b:true, c:true }
function $0c053139fbc63362$var$charSet(s) {
    return s.split('').reduce(function(set, c) {
        set[c] = true;
        return set;
    }, {});
}
// normalizes slashes.
var $0c053139fbc63362$var$slashSplit = /\/+/;
$0c053139fbc63362$var$minimatch.filter = $0c053139fbc63362$var$filter;
function $0c053139fbc63362$var$filter(pattern, options) {
    options = options || {};
    return function(p, i, list) {
        return $0c053139fbc63362$var$minimatch(p, pattern, options);
    };
}
function $0c053139fbc63362$var$ext(a, b) {
    a = a || {};
    b = b || {};
    var t = {};
    Object.keys(b).forEach(function(k) {
        t[k] = b[k];
    });
    Object.keys(a).forEach(function(k) {
        t[k] = a[k];
    });
    return t;
}
$0c053139fbc63362$var$minimatch.defaults = function(def) {
    if (!def || !Object.keys(def).length) return $0c053139fbc63362$var$minimatch;
    var orig = $0c053139fbc63362$var$minimatch;
    var m = function minimatch(p, pattern, options) {
        return orig.minimatch(p, pattern, $0c053139fbc63362$var$ext(def, options));
    };
    m.Minimatch = function Minimatch(pattern, options) {
        return new orig.Minimatch(pattern, $0c053139fbc63362$var$ext(def, options));
    };
    return m;
};
$0c053139fbc63362$var$Minimatch.defaults = function(def) {
    if (!def || !Object.keys(def).length) return $0c053139fbc63362$var$Minimatch;
    return $0c053139fbc63362$var$minimatch.defaults(def).Minimatch;
};
function $0c053139fbc63362$var$minimatch(p, pattern, options) {
    if (typeof pattern !== 'string') throw new TypeError('glob pattern string required');
    if (!options) options = {};
    // shortcut: comments match nothing.
    if (!options.nocomment && pattern.charAt(0) === '#') return false;
    // "" only matches ""
    if (pattern.trim() === '') return p === '';
    return new $0c053139fbc63362$var$Minimatch(pattern, options).match(p);
}
function $0c053139fbc63362$var$Minimatch(pattern, options) {
    if (!(this instanceof $0c053139fbc63362$var$Minimatch)) return new $0c053139fbc63362$var$Minimatch(pattern, options);
    if (typeof pattern !== 'string') throw new TypeError('glob pattern string required');
    if (!options) options = {};
    pattern = pattern.trim();
    // windows support: need to use /, not \
    if ($0c053139fbc63362$var$path.sep !== '/') pattern = pattern.split($0c053139fbc63362$var$path.sep).join('/');
    this.options = options;
    this.set = [];
    this.pattern = pattern;
    this.regexp = null;
    this.negate = false;
    this.comment = false;
    this.empty = false;
    // make the set of regexps etc.
    this.make();
}
$0c053139fbc63362$var$Minimatch.prototype.debug = function() {};
$0c053139fbc63362$var$Minimatch.prototype.make = $0c053139fbc63362$var$make;
function $0c053139fbc63362$var$make() {
    // don't do it more than once.
    if (this._made) return;
    var pattern = this.pattern;
    var options = this.options;
    // empty patterns and comments match nothing.
    if (!options.nocomment && pattern.charAt(0) === '#') {
        this.comment = true;
        return;
    }
    if (!pattern) {
        this.empty = true;
        return;
    }
    // step 1: figure out negation, etc.
    this.parseNegate();
    // step 2: expand braces
    var set = this.globSet = this.braceExpand();
    if (options.debug) this.debug = console.error;
    this.debug(this.pattern, set);
    // step 3: now we have a set, so turn each one into a series of path-portion
    // matching patterns.
    // These will be regexps, except in the case of "**", which is
    // set to the GLOBSTAR object for globstar behavior,
    // and will not contain any / characters
    set = this.globParts = set.map(function(s) {
        return s.split($0c053139fbc63362$var$slashSplit);
    });
    this.debug(this.pattern, set);
    // glob --> regexps
    set = set.map(function(s, si, set) {
        return s.map(this.parse, this);
    }, this);
    this.debug(this.pattern, set);
    // filter out everything that didn't compile properly.
    set = set.filter(function(s) {
        return s.indexOf(false) === -1;
    });
    this.debug(this.pattern, set);
    this.set = set;
}
$0c053139fbc63362$var$Minimatch.prototype.parseNegate = $0c053139fbc63362$var$parseNegate;
function $0c053139fbc63362$var$parseNegate() {
    var pattern = this.pattern;
    var negate = false;
    var options = this.options;
    var negateOffset = 0;
    if (options.nonegate) return;
    for(var i = 0, l = pattern.length; i < l && pattern.charAt(i) === '!'; i++){
        negate = !negate;
        negateOffset++;
    }
    if (negateOffset) this.pattern = pattern.substr(negateOffset);
    this.negate = negate;
}
// Brace expansion:
// a{b,c}d -> abd acd
// a{b,}c -> abc ac
// a{0..3}d -> a0d a1d a2d a3d
// a{b,c{d,e}f}g -> abg acdfg acefg
// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
//
// Invalid sets are not expanded.
// a{2..}b -> a{2..}b
// a{b}c -> a{b}c
$0c053139fbc63362$var$minimatch.braceExpand = function(pattern, options) {
    return $0c053139fbc63362$var$braceExpand(pattern, options);
};
$0c053139fbc63362$var$Minimatch.prototype.braceExpand = $0c053139fbc63362$var$braceExpand;
function $0c053139fbc63362$var$braceExpand(pattern, options) {
    if (!options) {
        if (this instanceof $0c053139fbc63362$var$Minimatch) options = this.options;
        else options = {};
    }
    pattern = typeof pattern === 'undefined' ? this.pattern : pattern;
    if (typeof pattern === 'undefined') throw new TypeError('undefined pattern');
    if (options.nobrace || !pattern.match(/\{.*\}/)) // shortcut. no need to expand.
    return [
        pattern
    ];
    return $ezUqs(pattern);
}
// parse a component of the expanded set.
// At this point, no pattern may contain "/" in it
// so we're going to return a 2d array, where each entry is the full
// pattern, split on '/', and then turned into a regular expression.
// A regexp is made at the end which joins each array with an
// escaped /, and another full one which joins each regexp with |.
//
// Following the lead of Bash 4.1, note that "**" only has special meaning
// when it is the *only* thing in a path portion.  Otherwise, any series
// of * is equivalent to a single *.  Globstar behavior is enabled by
// default, and can be disabled by setting options.noglobstar.
$0c053139fbc63362$var$Minimatch.prototype.parse = $0c053139fbc63362$var$parse;
var $0c053139fbc63362$var$SUBPARSE = {};
function $0c053139fbc63362$var$parse(pattern, isSub) {
    if (pattern.length > 65536) throw new TypeError('pattern is too long');
    var options = this.options;
    // shortcuts
    if (!options.noglobstar && pattern === '**') return $0c053139fbc63362$var$GLOBSTAR;
    if (pattern === '') return '';
    var re = '';
    var hasMagic = !!options.nocase;
    var escaping = false;
    // ? => one single character
    var patternListStack = [];
    var negativeLists = [];
    var stateChar;
    var inClass = false;
    var reClassStart = -1;
    var classStart = -1;
    // . and .. never match anything that doesn't start with .,
    // even when options.dot is set.
    var patternStart = pattern.charAt(0) === '.' ? '' // anything
     : options.dot ? '(?!(?:^|\\\/)\\.{1,2}(?:$|\\\/))' : '(?!\\.)';
    var self = this;
    function clearStateChar() {
        if (stateChar) {
            // we had some state-tracking character
            // that wasn't consumed by this pass.
            switch(stateChar){
                case '*':
                    re += $0c053139fbc63362$var$star;
                    hasMagic = true;
                    break;
                case '?':
                    re += $0c053139fbc63362$var$qmark;
                    hasMagic = true;
                    break;
                default:
                    re += '\\' + stateChar;
                    break;
            }
            self.debug('clearStateChar %j %j', stateChar, re);
            stateChar = false;
        }
    }
    for(var i = 0, len = pattern.length, c; i < len && (c = pattern.charAt(i)); i++){
        this.debug('%s\t%s %s %j', pattern, i, re, c);
        // skip over any that are escaped.
        if (escaping && $0c053139fbc63362$var$reSpecials[c]) {
            re += '\\' + c;
            escaping = false;
            continue;
        }
        switch(c){
            case '/':
                // completely not allowed, even escaped.
                // Should already be path-split by now.
                return false;
            case '\\':
                clearStateChar();
                escaping = true;
                continue;
            // the various stateChar values
            // for the "extglob" stuff.
            case '?':
            case '*':
            case '+':
            case '@':
            case '!':
                this.debug('%s\t%s %s %j <-- stateChar', pattern, i, re, c);
                // all of those are literals inside a class, except that
                // the glob [!a] means [^a] in regexp
                if (inClass) {
                    this.debug('  in class');
                    if (c === '!' && i === classStart + 1) c = '^';
                    re += c;
                    continue;
                }
                // if we already have a stateChar, then it means
                // that there was something like ** or +? in there.
                // Handle the stateChar, then proceed with this one.
                self.debug('call clearStateChar %j', stateChar);
                clearStateChar();
                stateChar = c;
                // if extglob is disabled, then +(asdf|foo) isn't a thing.
                // just clear the statechar *now*, rather than even diving into
                // the patternList stuff.
                if (options.noext) clearStateChar();
                continue;
            case '(':
                if (inClass) {
                    re += '(';
                    continue;
                }
                if (!stateChar) {
                    re += '\\(';
                    continue;
                }
                patternListStack.push({
                    type: stateChar,
                    start: i - 1,
                    reStart: re.length,
                    open: $0c053139fbc63362$var$plTypes[stateChar].open,
                    close: $0c053139fbc63362$var$plTypes[stateChar].close
                });
                // negation is (?:(?!js)[^/]*)
                re += stateChar === '!' ? '(?:(?!(?:' : '(?:';
                this.debug('plType %j %j', stateChar, re);
                stateChar = false;
                continue;
            case ')':
                if (inClass || !patternListStack.length) {
                    re += '\\)';
                    continue;
                }
                clearStateChar();
                hasMagic = true;
                var pl = patternListStack.pop();
                // negation is (?:(?!js)[^/]*)
                // The others are (?:<pattern>)<type>
                re += pl.close;
                if (pl.type === '!') negativeLists.push(pl);
                pl.reEnd = re.length;
                continue;
            case '|':
                if (inClass || !patternListStack.length || escaping) {
                    re += '\\|';
                    escaping = false;
                    continue;
                }
                clearStateChar();
                re += '|';
                continue;
            // these are mostly the same in regexp and glob
            case '[':
                // swallow any state-tracking char before the [
                clearStateChar();
                if (inClass) {
                    re += '\\' + c;
                    continue;
                }
                inClass = true;
                classStart = i;
                reClassStart = re.length;
                re += c;
                continue;
            case ']':
                //  a right bracket shall lose its special
                //  meaning and represent itself in
                //  a bracket expression if it occurs
                //  first in the list.  -- POSIX.2 2.8.3.2
                if (i === classStart + 1 || !inClass) {
                    re += '\\' + c;
                    escaping = false;
                    continue;
                }
                // handle the case where we left a class open.
                // "[z-a]" is valid, equivalent to "\[z-a\]"
                if (inClass) {
                    // split where the last [ was, make sure we don't have
                    // an invalid re. if so, re-walk the contents of the
                    // would-be class to re-translate any characters that
                    // were passed through as-is
                    // TODO: It would probably be faster to determine this
                    // without a try/catch and a new RegExp, but it's tricky
                    // to do safely.  For now, this is safe and works.
                    var cs = pattern.substring(classStart + 1, i);
                    try {
                        RegExp('[' + cs + ']');
                    } catch (er) {
                        // not a valid class!
                        var sp = this.parse(cs, $0c053139fbc63362$var$SUBPARSE);
                        re = re.substr(0, reClassStart) + '\\[' + sp[0] + '\\]';
                        hasMagic = hasMagic || sp[1];
                        inClass = false;
                        continue;
                    }
                }
                // finish up the class.
                hasMagic = true;
                inClass = false;
                re += c;
                continue;
            default:
                // swallow any state char that wasn't consumed
                clearStateChar();
                if (escaping) // no need
                escaping = false;
                else if ($0c053139fbc63362$var$reSpecials[c] && !(c === '^' && inClass)) re += '\\';
                re += c;
        } // switch
    } // for
    // handle the case where we left a class open.
    // "[abc" is valid, equivalent to "\[abc"
    if (inClass) {
        // split where the last [ was, and escape it
        // this is a huge pita.  We now have to re-walk
        // the contents of the would-be class to re-translate
        // any characters that were passed through as-is
        cs = pattern.substr(classStart + 1);
        sp = this.parse(cs, $0c053139fbc63362$var$SUBPARSE);
        re = re.substr(0, reClassStart) + '\\[' + sp[0];
        hasMagic = hasMagic || sp[1];
    }
    // handle the case where we had a +( thing at the *end*
    // of the pattern.
    // each pattern list stack adds 3 chars, and we need to go through
    // and escape any | chars that were passed through as-is for the regexp.
    // Go through and escape them, taking care not to double-escape any
    // | chars that were already escaped.
    for(pl = patternListStack.pop(); pl; pl = patternListStack.pop()){
        var tail = re.slice(pl.reStart + pl.open.length);
        this.debug('setting tail', re, pl);
        // maybe some even number of \, then maybe 1 \, followed by a |
        tail = tail.replace(/((?:\\{2}){0,64})(\\?)\|/g, function(_, $1, $2) {
            if (!$2) // the | isn't already escaped, so escape it.
            $2 = '\\';
            // need to escape all those slashes *again*, without escaping the
            // one that we need for escaping the | character.  As it works out,
            // escaping an even number of slashes can be done by simply repeating
            // it exactly after itself.  That's why this trick works.
            //
            // I am sorry that you have to see this.
            return $1 + $1 + $2 + '|';
        });
        this.debug('tail=%j\n   %s', tail, tail, pl, re);
        var t = pl.type === '*' ? $0c053139fbc63362$var$star : pl.type === '?' ? $0c053139fbc63362$var$qmark : '\\' + pl.type;
        hasMagic = true;
        re = re.slice(0, pl.reStart) + t + '\\(' + tail;
    }
    // handle trailing things that only matter at the very end.
    clearStateChar();
    if (escaping) // trailing \\
    re += '\\\\';
    // only need to apply the nodot start if the re starts with
    // something that could conceivably capture a dot
    var addPatternStart = false;
    switch(re.charAt(0)){
        case '.':
        case '[':
        case '(':
            addPatternStart = true;
    }
    // Hack to work around lack of negative lookbehind in JS
    // A pattern like: *.!(x).!(y|z) needs to ensure that a name
    // like 'a.xyz.yz' doesn't match.  So, the first negative
    // lookahead, has to look ALL the way ahead, to the end of
    // the pattern.
    for(var n = negativeLists.length - 1; n > -1; n--){
        var nl = negativeLists[n];
        var nlBefore = re.slice(0, nl.reStart);
        var nlFirst = re.slice(nl.reStart, nl.reEnd - 8);
        var nlLast = re.slice(nl.reEnd - 8, nl.reEnd);
        var nlAfter = re.slice(nl.reEnd);
        nlLast += nlAfter;
        // Handle nested stuff like *(*.js|!(*.json)), where open parens
        // mean that we should *not* include the ) in the bit that is considered
        // "after" the negated section.
        var openParensBefore = nlBefore.split('(').length - 1;
        var cleanAfter = nlAfter;
        for(i = 0; i < openParensBefore; i++)cleanAfter = cleanAfter.replace(/\)[+*?]?/, '');
        nlAfter = cleanAfter;
        var dollar = '';
        if (nlAfter === '' && isSub !== $0c053139fbc63362$var$SUBPARSE) dollar = '$';
        var newRe = nlBefore + nlFirst + nlAfter + dollar + nlLast;
        re = newRe;
    }
    // if the re is not "" at this point, then we need to make sure
    // it doesn't match against an empty path part.
    // Otherwise a/* will match a/, which it should not.
    if (re !== '' && hasMagic) re = '(?=.)' + re;
    if (addPatternStart) re = patternStart + re;
    // parsing just a piece of a larger pattern.
    if (isSub === $0c053139fbc63362$var$SUBPARSE) return [
        re,
        hasMagic
    ];
    // skip the regexp for non-magical patterns
    // unescape anything in it, though, so that it'll be
    // an exact match against a file etc.
    if (!hasMagic) return $0c053139fbc63362$var$globUnescape(pattern);
    var flags = options.nocase ? 'i' : '';
    try {
        var regExp = new RegExp('^' + re + '$', flags);
    } catch (er) {
        // If it was an invalid regular expression, then it can't match
        // anything.  This trick looks for a character after the end of
        // the string, which is of course impossible, except in multi-line
        // mode, but it's not a /m regex.
        return new RegExp('$.');
    }
    regExp._glob = pattern;
    regExp._src = re;
    return regExp;
}
$0c053139fbc63362$var$minimatch.makeRe = function(pattern, options) {
    return new $0c053139fbc63362$var$Minimatch(pattern, options || {}).makeRe();
};
$0c053139fbc63362$var$Minimatch.prototype.makeRe = $0c053139fbc63362$var$makeRe;
function $0c053139fbc63362$var$makeRe() {
    if (this.regexp || this.regexp === false) return this.regexp;
    // at this point, this.set is a 2d array of partial
    // pattern strings, or "**".
    //
    // It's better to use .match().  This function shouldn't
    // be used, really, but it's pretty convenient sometimes,
    // when you just want to work with a regex.
    var set = this.set;
    if (!set.length) {
        this.regexp = false;
        return this.regexp;
    }
    var options = this.options;
    var twoStar = options.noglobstar ? $0c053139fbc63362$var$star : options.dot ? $0c053139fbc63362$var$twoStarDot : $0c053139fbc63362$var$twoStarNoDot;
    var flags = options.nocase ? 'i' : '';
    var re = set.map(function(pattern) {
        return pattern.map(function(p) {
            return p === $0c053139fbc63362$var$GLOBSTAR ? twoStar : typeof p === 'string' ? $0c053139fbc63362$var$regExpEscape(p) : p._src;
        }).join('\\\/');
    }).join('|');
    // must match entire pattern
    // ending in a * or ** will make it less strict.
    re = '^(?:' + re + ')$';
    // can match anything, as long as it's not this.
    if (this.negate) re = '^(?!' + re + ').*$';
    try {
        this.regexp = new RegExp(re, flags);
    } catch (ex) {
        this.regexp = false;
    }
    return this.regexp;
}
$0c053139fbc63362$var$minimatch.match = function(list, pattern, options) {
    options = options || {};
    var mm = new $0c053139fbc63362$var$Minimatch(pattern, options);
    list = list.filter(function(f) {
        return mm.match(f);
    });
    if (mm.options.nonull && !list.length) list.push(pattern);
    return list;
};
$0c053139fbc63362$var$Minimatch.prototype.match = $0c053139fbc63362$var$match;
function $0c053139fbc63362$var$match(f, partial) {
    this.debug('match', f, this.pattern);
    // short-circuit in the case of busted things.
    // comments, etc.
    if (this.comment) return false;
    if (this.empty) return f === '';
    if (f === '/' && partial) return true;
    var options = this.options;
    // windows: need to use /, not \
    if ($0c053139fbc63362$var$path.sep !== '/') f = f.split($0c053139fbc63362$var$path.sep).join('/');
    // treat the test path as a set of pathparts.
    f = f.split($0c053139fbc63362$var$slashSplit);
    this.debug(this.pattern, 'split', f);
    // just ONE of the pattern sets in this.set needs to match
    // in order for it to be valid.  If negating, then just one
    // match means that we have failed.
    // Either way, return on the first hit.
    var set = this.set;
    this.debug(this.pattern, 'set', set);
    // Find the basename of the path by looking for the last non-empty segment
    var filename;
    var i;
    for(i = f.length - 1; i >= 0; i--){
        filename = f[i];
        if (filename) break;
    }
    for(i = 0; i < set.length; i++){
        var pattern = set[i];
        var file = f;
        if (options.matchBase && pattern.length === 1) file = [
            filename
        ];
        var hit = this.matchOne(file, pattern, partial);
        if (hit) {
            if (options.flipNegate) return true;
            return !this.negate;
        }
    }
    // didn't get any hits.  this is success if it's a negative
    // pattern, failure otherwise.
    if (options.flipNegate) return false;
    return this.negate;
}
// set partial to true to test if, for example,
// "/a/b" matches the start of "/*/b/*/d"
// Partial means, if you run out of file before you run
// out of pattern, then that's fine, as long as all
// the parts match.
$0c053139fbc63362$var$Minimatch.prototype.matchOne = function(file, pattern, partial) {
    var options = this.options;
    this.debug('matchOne', {
        'this': this,
        file: file,
        pattern: pattern
    });
    this.debug('matchOne', file.length, pattern.length);
    for(var fi = 0, pi = 0, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++){
        this.debug('matchOne loop');
        var p = pattern[pi];
        var f = file[fi];
        this.debug(pattern, p, f);
        // should be impossible.
        // some invalid regexp stuff in the set.
        if (p === false) return false;
        if (p === $0c053139fbc63362$var$GLOBSTAR) {
            this.debug('GLOBSTAR', [
                pattern,
                p,
                f
            ]);
            // "**"
            // a/**/b/**/c would match the following:
            // a/b/x/y/z/c
            // a/x/y/z/b/c
            // a/b/x/b/x/c
            // a/b/c
            // To do this, take the rest of the pattern after
            // the **, and see if it would match the file remainder.
            // If so, return success.
            // If not, the ** "swallows" a segment, and try again.
            // This is recursively awful.
            //
            // a/**/b/**/c matching a/b/x/y/z/c
            // - a matches a
            // - doublestar
            //   - matchOne(b/x/y/z/c, b/**/c)
            //     - b matches b
            //     - doublestar
            //       - matchOne(x/y/z/c, c) -> no
            //       - matchOne(y/z/c, c) -> no
            //       - matchOne(z/c, c) -> no
            //       - matchOne(c, c) yes, hit
            var fr = fi;
            var pr = pi + 1;
            if (pr === pl) {
                this.debug('** at the end');
                // a ** at the end will just swallow the rest.
                // We have found a match.
                // however, it will not swallow /.x, unless
                // options.dot is set.
                // . and .. are *never* matched by **, for explosively
                // exponential reasons.
                for(; fi < fl; fi++){
                    if (file[fi] === '.' || file[fi] === '..' || !options.dot && file[fi].charAt(0) === '.') return false;
                }
                return true;
            }
            // ok, let's see if we can swallow whatever we can.
            while(fr < fl){
                var swallowee = file[fr];
                this.debug('\nglobstar while', file, fr, pattern, pr, swallowee);
                // XXX remove this slice.  Just pass the start index.
                if (this.matchOne(file.slice(fr), pattern.slice(pr), partial)) {
                    this.debug('globstar found match!', fr, fl, swallowee);
                    // found a match.
                    return true;
                } else {
                    // can't swallow "." or ".." ever.
                    // can only swallow ".foo" when explicitly asked.
                    if (swallowee === '.' || swallowee === '..' || !options.dot && swallowee.charAt(0) === '.') {
                        this.debug('dot detected!', file, fr, pattern, pr);
                        break;
                    }
                    // ** swallows a segment, and continue.
                    this.debug('globstar swallow a segment, and continue');
                    fr++;
                }
            }
            // no match was found.
            // However, in partial mode, we can't say this is necessarily over.
            // If there's more *pattern* left, then
            if (partial) {
                // ran out of file
                this.debug('\n>>> no match, partial?', file, fr, pattern, pr);
                if (fr === fl) return true;
            }
            return false;
        }
        // something other than **
        // non-magic patterns just have to match exactly
        // patterns with magic have been turned into regexps.
        var hit;
        if (typeof p === 'string') {
            if (options.nocase) hit = f.toLowerCase() === p.toLowerCase();
            else hit = f === p;
            this.debug('string match', p, f, hit);
        } else {
            hit = f.match(p);
            this.debug('pattern match', p, f, hit);
        }
        if (!hit) return false;
    }
    // Note: ending in / means that we'll get a final ""
    // at the end of the pattern.  This can only match a
    // corresponding "" at the end of the file.
    // If the file ends in /, then it can only match a
    // a pattern that ends in /, unless the pattern just
    // doesn't have any more for it. But, a/b/ should *not*
    // match "a/b/*", even though "" matches against the
    // [^/]*? pattern, except in partial mode, where it might
    // simply not be reached yet.
    // However, a/b/ should still satisfy a/*
    // now either we fell off the end of the pattern, or we're done.
    if (fi === fl && pi === pl) // ran out of pattern and filename at the same time.
    // an exact hit!
    return true;
    else if (fi === fl) // ran out of file, but still had pattern left.
    // this is ok if we're doing the match as part of
    // a glob fs traversal.
    return partial;
    else if (pi === pl) {
        // ran out of pattern, still have file left.
        // this is only acceptable if we're on the very last
        // empty segment of a file with a trailing slash.
        // a/* should match a/b/
        var emptyFileEnd = fi === fl - 1 && file[fi] === '';
        return emptyFileEnd;
    }
    // should be unreachable.
    throw new Error('wtf?');
};
// replace stuff like \* with *
function $0c053139fbc63362$var$globUnescape(s) {
    return s.replace(/\\(.)/g, '$1');
}
function $0c053139fbc63362$var$regExpEscape(s) {
    return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

});
parcelRegister("ezUqs", function(module, exports) {

var $3vBTv = parcelRequire("3vBTv");

var $4FV0I = parcelRequire("4FV0I");
module.exports = $02bd29b7fa08d179$var$expandTop;
var $02bd29b7fa08d179$var$escSlash = '\0SLASH' + Math.random() + '\0';
var $02bd29b7fa08d179$var$escOpen = '\0OPEN' + Math.random() + '\0';
var $02bd29b7fa08d179$var$escClose = '\0CLOSE' + Math.random() + '\0';
var $02bd29b7fa08d179$var$escComma = '\0COMMA' + Math.random() + '\0';
var $02bd29b7fa08d179$var$escPeriod = '\0PERIOD' + Math.random() + '\0';
function $02bd29b7fa08d179$var$numeric(str) {
    return parseInt(str, 10) == str ? parseInt(str, 10) : str.charCodeAt(0);
}
function $02bd29b7fa08d179$var$escapeBraces(str) {
    return str.split('\\\\').join($02bd29b7fa08d179$var$escSlash).split('\\{').join($02bd29b7fa08d179$var$escOpen).split('\\}').join($02bd29b7fa08d179$var$escClose).split('\\,').join($02bd29b7fa08d179$var$escComma).split('\\.').join($02bd29b7fa08d179$var$escPeriod);
}
function $02bd29b7fa08d179$var$unescapeBraces(str) {
    return str.split($02bd29b7fa08d179$var$escSlash).join('\\').split($02bd29b7fa08d179$var$escOpen).join('{').split($02bd29b7fa08d179$var$escClose).join('}').split($02bd29b7fa08d179$var$escComma).join(',').split($02bd29b7fa08d179$var$escPeriod).join('.');
}
// Basically just str.split(","), but handling cases
// where we have nested braced sections, which should be
// treated as individual members, like {a,{b,c},d}
function $02bd29b7fa08d179$var$parseCommaParts(str) {
    if (!str) return [
        ''
    ];
    var parts = [];
    var m = $4FV0I('{', '}', str);
    if (!m) return str.split(',');
    var pre = m.pre;
    var body = m.body;
    var post = m.post;
    var p = pre.split(',');
    p[p.length - 1] += '{' + body + '}';
    var postParts = $02bd29b7fa08d179$var$parseCommaParts(post);
    if (post.length) {
        p[p.length - 1] += postParts.shift();
        p.push.apply(p, postParts);
    }
    parts.push.apply(parts, p);
    return parts;
}
function $02bd29b7fa08d179$var$expandTop(str) {
    if (!str) return [];
    // I don't know why Bash 4.3 does this, but it does.
    // Anything starting with {} will have the first two bytes preserved
    // but *only* at the top level, so {},a}b will not expand to anything,
    // but a{},b}c will be expanded to [a}c,abc].
    // One could argue that this is a bug in Bash, but since the goal of
    // this module is to match Bash's rules, we escape a leading {}
    if (str.substr(0, 2) === '{}') str = '\\{\\}' + str.substr(2);
    return $02bd29b7fa08d179$var$expand($02bd29b7fa08d179$var$escapeBraces(str), true).map($02bd29b7fa08d179$var$unescapeBraces);
}
function $02bd29b7fa08d179$var$identity(e) {
    return e;
}
function $02bd29b7fa08d179$var$embrace(str) {
    return '{' + str + '}';
}
function $02bd29b7fa08d179$var$isPadded(el) {
    return /^-?0\d/.test(el);
}
function $02bd29b7fa08d179$var$lte(i, y) {
    return i <= y;
}
function $02bd29b7fa08d179$var$gte(i, y) {
    return i >= y;
}
function $02bd29b7fa08d179$var$expand(str, isTop) {
    var expansions = [];
    var m = $4FV0I('{', '}', str);
    if (!m || /\$$/.test(m.pre)) return [
        str
    ];
    var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
    var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
    var isSequence = isNumericSequence || isAlphaSequence;
    var isOptions = m.body.indexOf(',') >= 0;
    if (!isSequence && !isOptions) {
        // {a},b}
        if (m.post.match(/,(?!,).*\}/)) {
            str = m.pre + '{' + m.body + $02bd29b7fa08d179$var$escClose + m.post;
            return $02bd29b7fa08d179$var$expand(str);
        }
        return [
            str
        ];
    }
    var n;
    if (isSequence) n = m.body.split(/\.\./);
    else {
        n = $02bd29b7fa08d179$var$parseCommaParts(m.body);
        if (n.length === 1) {
            // x{{a,b}}y ==> x{a}y x{b}y
            n = $02bd29b7fa08d179$var$expand(n[0], false).map($02bd29b7fa08d179$var$embrace);
            if (n.length === 1) {
                var post = m.post.length ? $02bd29b7fa08d179$var$expand(m.post, false) : [
                    ''
                ];
                return post.map(function(p) {
                    return m.pre + n[0] + p;
                });
            }
        }
    }
    // at this point, n is the parts, and we know it's not a comma set
    // with a single entry.
    // no need to expand pre, since it is guaranteed to be free of brace-sets
    var pre = m.pre;
    var post = m.post.length ? $02bd29b7fa08d179$var$expand(m.post, false) : [
        ''
    ];
    var N;
    if (isSequence) {
        var x = $02bd29b7fa08d179$var$numeric(n[0]);
        var y = $02bd29b7fa08d179$var$numeric(n[1]);
        var width = Math.max(n[0].length, n[1].length);
        var incr = n.length == 3 ? Math.abs($02bd29b7fa08d179$var$numeric(n[2])) : 1;
        var test = $02bd29b7fa08d179$var$lte;
        var reverse = y < x;
        if (reverse) {
            incr *= -1;
            test = $02bd29b7fa08d179$var$gte;
        }
        var pad = n.some($02bd29b7fa08d179$var$isPadded);
        N = [];
        for(var i = x; test(i, y); i += incr){
            var c;
            if (isAlphaSequence) {
                c = String.fromCharCode(i);
                if (c === '\\') c = '';
            } else {
                c = String(i);
                if (pad) {
                    var need = width - c.length;
                    if (need > 0) {
                        var z = new Array(need + 1).join('0');
                        if (i < 0) c = '-' + z + c.slice(1);
                        else c = z + c;
                    }
                }
            }
            N.push(c);
        }
    } else N = $3vBTv(n, function(el) {
        return $02bd29b7fa08d179$var$expand(el, false);
    });
    for(var j = 0; j < N.length; j++)for(var k = 0; k < post.length; k++){
        var expansion = pre + N[j] + post[k];
        if (!isTop || isSequence || expansion) expansions.push(expansion);
    }
    return expansions;
}

});
parcelRegister("3vBTv", function(module, exports) {
module.exports = function(xs, fn) {
    var res = [];
    for(var i = 0; i < xs.length; i++){
        var x = fn(xs[i], i);
        if ($28e1a95dfd5087b8$var$isArray(x)) res.push.apply(res, x);
        else res.push(x);
    }
    return res;
};
var $28e1a95dfd5087b8$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("4FV0I", function(module, exports) {
'use strict';
module.exports = $367736e0b00087b6$var$balanced;
function $367736e0b00087b6$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $367736e0b00087b6$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $367736e0b00087b6$var$maybeMatch(b, str);
    var r = $367736e0b00087b6$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $367736e0b00087b6$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$367736e0b00087b6$var$balanced.range = $367736e0b00087b6$var$range;
function $367736e0b00087b6$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}

});




parcelRegister("aUV4R", function(module, exports) {
"use strict";

var $fUjfo = parcelRequire("fUjfo");

var $4GiWd = parcelRequire("4GiWd");

var $bDlIE = parcelRequire("bDlIE");

var $3eFSI = parcelRequire("3eFSI");
var $7f2b68bf1c62540a$require$merge = $3eFSI.merge;
const $7f2b68bf1c62540a$var$SEP_PATH_POSIX = "__PATH_SEPARATOR_POSIX__";
const $7f2b68bf1c62540a$var$SEP_PATH_WINDOWS = "__PATH_SEPARATOR_WINDOWS__";
/**
 * Encode a path for use with WebDAV servers
 * @param {String} path The path to encode
 * @returns {String} The encoded path (separators protected)
 */ function $7f2b68bf1c62540a$var$encodePath(path) {
    const replaced = path.replace(/\//g, $7f2b68bf1c62540a$var$SEP_PATH_POSIX).replace(/\\\\/g, $7f2b68bf1c62540a$var$SEP_PATH_WINDOWS);
    const formatted = encodeURIComponent(replaced);
    return formatted.split($7f2b68bf1c62540a$var$SEP_PATH_WINDOWS).join("\\\\").split($7f2b68bf1c62540a$var$SEP_PATH_POSIX).join("/");
}
/**
 * Join URL segments
 * @param  {...String} parts URL segments to join
 * @returns {String} A joined URL string
 */ function $7f2b68bf1c62540a$var$joinURL(...parts) {
    return $4GiWd(parts.reduce((output, nextPart, partIndex)=>{
        if (partIndex === 0 || nextPart !== "/" || nextPart === "/" && output[output.length - 1] !== "/") output.push(nextPart);
        return output;
    }, []));
}
/**
 * @typedef {Object} UserOptions
 * @property {Object=} httpAgent - HTTP agent instance
 * @property {Object=} httpsAgent - HTTPS agent instance
 * @property {Object=} headers - Set additional request headers
 * @property {Boolean=} withCredentials - Set whether or not credentials should
 * @property {Object|String|*=} data - Set additional body
 *  be included with the request. Defaults to value used by axios.
 */ /**
 * Process request options before being passed to Axios
 * @param {RequestOptions} requestOptions The request options object
 * @param {UserOptions} methodOptions Provided options (external)
 */ function $7f2b68bf1c62540a$var$prepareRequestOptions(requestOptions, methodOptions) {
    if (methodOptions.httpAgent) requestOptions.httpAgent = methodOptions.httpAgent;
    if (methodOptions.httpsAgent) requestOptions.httpsAgent = methodOptions.httpsAgent;
    if (methodOptions.data) requestOptions.data = methodOptions.data;
    if (methodOptions.headers && typeof methodOptions.headers === "object") requestOptions.headers = $7f2b68bf1c62540a$require$merge(requestOptions.headers || {}, methodOptions.headers);
    if (typeof methodOptions.withCredentials === "boolean") requestOptions.withCredentials = methodOptions.withCredentials;
    if (methodOptions.maxContentLength) requestOptions.maxContentLength = methodOptions.maxContentLength;
    if (methodOptions.onUploadProgress && typeof methodOptions.onUploadProgress === "function") requestOptions.onUploadProgress = methodOptions.onUploadProgress;
    if (methodOptions._digest) {
        requestOptions._digest = methodOptions._digest;
        requestOptions.validateStatus = (status)=>status >= 200 && status < 300 || status == 401;
    }
}
/**
 * @typedef {Object} RequestOptions
 * @property {String} url - The URL to request
 * @property {String} method - The method to use (eg. "POST")
 * @property {Object=} headers - Headers to set on the request
 * @property {Object=} httpAgent - A HTTP agent instance
 * @property {Object=} httpsAgent - A HTTPS agent interface
 * @property {Object|String|*=} data - Body data for the request
 */ /**
 * Make a request
 * This method can be patched by patching or plugging-in to the "request"
 * item using {@link https://github.com/perry-mitchell/hot-patcher HotPatcher}.
 * It uses {@link https://github.com/axios/axios Axios} by default.
 * @param {RequestOptions} requestOptions Options for the request
 * @returns {Promise.<Object>} A promise that resolves with a response object
 */ function $7f2b68bf1c62540a$var$request(requestOptions) {
    return $bDlIE(requestOptions);
}
module.exports = {
    axios: $fUjfo,
    encodePath: $7f2b68bf1c62540a$var$encodePath,
    joinURL: $7f2b68bf1c62540a$var$joinURL,
    prepareRequestOptions: $7f2b68bf1c62540a$var$prepareRequestOptions,
    request: $7f2b68bf1c62540a$var$request
};

});
parcelRegister("fUjfo", function(module, exports) {

module.exports = (parcelRequire("hWeHK"));

});

parcelRegister("4GiWd", function(module, exports) {
(function(name, context, definition) {
    if (0, module.exports) module.exports = definition();
    else if (typeof define === 'function' && define.amd) define(definition);
    else context[name] = definition();
})('urljoin', module.exports, function() {
    function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) return '';
        if (typeof strArray[0] !== 'string') throw new TypeError('Url must be a string. Received ' + strArray[0]);
        // If the first part is a plain protocol, we combine it with the next part.
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
        }
        // There must be two or three slashes in the file protocol, two slashes in anything else.
        if (strArray[0].match(/^file:\/\/\//)) strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
        else strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
        for(var i = 0; i < strArray.length; i++){
            var component = strArray[i];
            if (typeof component !== 'string') throw new TypeError('Url must be a string. Received ' + component);
            if (component === '') continue;
            if (i > 0) // Removing the starting slashes for each component but the first.
            component = component.replace(/^[\/]+/, '');
            if (i < strArray.length - 1) // Removing the ending slashes for each component but the last.
            component = component.replace(/[\/]+$/, '');
            else // For the last component we will combine multiple slashes to a single one.
            component = component.replace(/[\/]+$/, '/');
            resultArray.push(component);
        }
        var str = resultArray.join('/');
        // Each input component is now separated by a single slash except the possible first plain protocol part.
        // remove trailing slash before parameters or hash
        str = str.replace(/\/(\?|&|#[^!])/g, '$1');
        // replace ? in parameters with &
        var parts = str.split('?');
        str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
        return str;
    }
    return function() {
        var input;
        if (typeof arguments[0] === 'object') input = arguments[0];
        else input = [].slice.call(arguments);
        return normalize(input);
    };
});

});

parcelRegister("bDlIE", function(module, exports) {
"use strict";

var $fUjfo = parcelRequire("fUjfo");

var $3eFSI = parcelRequire("3eFSI");
var $87842f3162ae7669$require$merge = $3eFSI.merge;

var $iPEud = parcelRequire("iPEud");
var $87842f3162ae7669$require$getPatcher = $iPEud.getPatcher;

var $3FL1p = parcelRequire("3FL1p");
var $87842f3162ae7669$require$generateDigestAuthHeader = $3FL1p.generateDigestAuthHeader;
function $87842f3162ae7669$var$makeNonce() {
    const cnonceSize = 32;
    const nonceRaw = "abcdef0123456789";
    let uid = "";
    for(let i = 0; i < cnonceSize; ++i)uid += nonceRaw[Math.floor(Math.random() * nonceRaw.length)];
    return uid;
}
function $87842f3162ae7669$var$parseAuth(response, _digest) {
    const authHeader = response.headers["www-authenticate"] || "";
    if (authHeader.split(/\s/)[0].toLowerCase() !== "digest") return false;
    const re = /([a-z0-9_-]+)=(?:"([^"]+)"|([a-z0-9_-]+))/gi;
    for(;;){
        var match = re.exec(authHeader);
        if (!match) break;
        _digest[match[1]] = match[2] || match[3];
    }
    _digest.nc++;
    _digest.cnonce = $87842f3162ae7669$var$makeNonce();
    return true;
}
function $87842f3162ae7669$var$request(requestOptions) {
    return $87842f3162ae7669$require$getPatcher().patchInline("request", (options)=>$fUjfo(options), requestOptions);
}
function $87842f3162ae7669$var$fetch(requestOptions) {
    // Client not configured for digest authentication
    if (!requestOptions._digest) return $87842f3162ae7669$var$request(requestOptions);
     // Remove client's digest authentication object from request options
    const _digest = requestOptions._digest;
    delete requestOptions._digest; // If client is already using digest authentication, include the digest authorization header
    if (_digest.hasDigestAuth) requestOptions = $87842f3162ae7669$require$merge(requestOptions, {
        headers: {
            Authorization: $87842f3162ae7669$require$generateDigestAuthHeader(requestOptions, _digest)
        }
    });
     // Perform the request and handle digest authentication
    return $87842f3162ae7669$var$request(requestOptions).then(function(response) {
        if (response.status == 401) {
            _digest.hasDigestAuth = $87842f3162ae7669$var$parseAuth(response, _digest);
            if (_digest.hasDigestAuth) {
                requestOptions = $87842f3162ae7669$require$merge(requestOptions, {
                    headers: {
                        Authorization: $87842f3162ae7669$require$generateDigestAuthHeader(requestOptions, _digest)
                    }
                });
                return $87842f3162ae7669$var$request(requestOptions).then(function(response2) {
                    if (response2.status == 401) _digest.hasDigestAuth = false;
                    else _digest.nc++;
                    return response2;
                });
            }
        } else _digest.nc++;
        return response;
    });
}
module.exports = $87842f3162ae7669$var$fetch;

});
parcelRegister("3eFSI", function(module, exports) {
"use strict";
function $25b32ab509fd7378$var$clone(obj) {
    return $25b32ab509fd7378$var$isPlainObject(obj) ? Object.assign({}, obj) : Object.setPrototypeOf(Object.assign({}, obj), Object.getPrototypeOf(obj));
}
function $25b32ab509fd7378$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null || Object.prototype.toString.call(obj) != "[object Object]") // Not an object
    return false;
    if (Object.getPrototypeOf(obj) === null) return true;
    let proto = obj; // Find the prototype
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
function $25b32ab509fd7378$var$merge(...args) {
    let output = null, items = [
        ...args
    ];
    while(items.length > 0){
        const nextItem = items.shift();
        if (!output) output = $25b32ab509fd7378$var$clone(nextItem);
        else output = $25b32ab509fd7378$var$mergeObjects(output, nextItem);
    }
    return output;
}
function $25b32ab509fd7378$var$mergeObjects(obj1, obj2) {
    const output = $25b32ab509fd7378$var$clone(obj1);
    Object.keys(obj2).forEach((key)=>{
        if (!output.hasOwnProperty(key)) {
            output[key] = obj2[key];
            return;
        }
        if (Array.isArray(obj2[key])) output[key] = Array.isArray(output[key]) ? [
            ...output[key],
            ...obj2[key]
        ] : [
            ...obj2[key]
        ];
        else if (typeof obj2[key] === "object" && !!obj2[key]) output[key] = typeof output[key] === "object" && !!output[key] ? $25b32ab509fd7378$var$mergeObjects(output[key], obj2[key]) : $25b32ab509fd7378$var$clone(obj2[key]);
        else output[key] = obj2[key];
    });
    return output;
}
module.exports = {
    merge: $25b32ab509fd7378$var$merge
};

});

parcelRegister("iPEud", function(module, exports) {
"use strict";

var $127od = parcelRequire("127od");
let $db5c652bb06cd18f$var$__patcher = null;
/**
 * Get the HotPatcher instance for patching internal methods
 * @returns {HotPatcher} The internal HotPatcher instance
 */ function $db5c652bb06cd18f$var$getPatcher() {
    if (!$db5c652bb06cd18f$var$__patcher) $db5c652bb06cd18f$var$__patcher = new $127od();
    return $db5c652bb06cd18f$var$__patcher;
}
module.exports = {
    getPatcher: $db5c652bb06cd18f$var$getPatcher
};

});
parcelRegister("127od", function(module, exports) {

var $aJB9Q = parcelRequire("aJB9Q");
var $0c0bb5c22d260e58$require$sequence = $aJB9Q.sequence;
const $0c0bb5c22d260e58$var$HOT_PATCHER_TYPE = "@@HOTPATCHER";
const $0c0bb5c22d260e58$var$NOOP = ()=>{};
function $0c0bb5c22d260e58$var$createNewItem(method) {
    return {
        original: method,
        methods: [
            method
        ],
        final: false
    };
}
/**
 * Hot patching manager class
 */ class $0c0bb5c22d260e58$var$HotPatcher {
    /**
     * Configuration object reference
     * @type {Object}
     * @memberof HotPatcher
     * @readonly
     */ get configuration() {
        return this._configuration;
    }
    /**
     * The action to take when a non-set method is requested
     * Possible values: null/throw
     * @type {String}
     * @memberof HotPatcher
     */ get getEmptyAction() {
        return this.configuration.getEmptyAction;
    }
    set getEmptyAction(newAction) {
        this.configuration.getEmptyAction = newAction;
    }
    /**
     * Control another hot-patcher instance
     * Force the remote instance to use patched methods from calling instance
     * @param {HotPatcher} target The target instance to control
     * @param {Boolean=} allowTargetOverrides Allow the target to override patched methods on
     * the controller (default is false)
     * @memberof HotPatcher
     * @returns {HotPatcher} Returns self
     * @throws {Error} Throws if the target is invalid
     */ control(target, allowTargetOverrides = false) {
        if (!target || target.__type__ !== $0c0bb5c22d260e58$var$HOT_PATCHER_TYPE) throw new Error("Failed taking control of target HotPatcher instance: Invalid type or object");
        Object.keys(target.configuration.registry).forEach((foreignKey)=>{
            if (this.configuration.registry.hasOwnProperty(foreignKey)) {
                if (allowTargetOverrides) this.configuration.registry[foreignKey] = Object.assign({}, target.configuration.registry[foreignKey]);
            } else this.configuration.registry[foreignKey] = Object.assign({}, target.configuration.registry[foreignKey]);
        });
        target._configuration = this.configuration;
        return this;
    }
    /**
     * Execute a patched method
     * @param {String} key The method key
     * @param {...*} args Arguments to pass to the method (optional)
     * @memberof HotPatcher
     * @see HotPatcher#get
     * @returns {*} The output of the called method
     */ execute(key, ...args) {
        const method = this.get(key) || $0c0bb5c22d260e58$var$NOOP;
        return method(...args);
    }
    /**
     * Get a method for a key
     * @param {String} key The method key
     * @returns {Function|null} Returns the requested function or null if the function
     * does not exist and the host is configured to return null (and not throw)
     * @memberof HotPatcher
     * @throws {Error} Throws if the configuration specifies to throw and the method
     * does not exist
     * @throws {Error} Throws if the `getEmptyAction` value is invalid
     */ get(key) {
        const item = this.configuration.registry[key];
        if (!item) switch(this.getEmptyAction){
            case "null":
                return null;
            case "throw":
                throw new Error(`Failed handling method request: No method provided for override: ${key}`);
            default:
                throw new Error(`Failed handling request which resulted in an empty method: Invalid empty-action specified: ${this.getEmptyAction}`);
        }
        return $0c0bb5c22d260e58$require$sequence(...item.methods);
    }
    /**
     * Check if a method has been patched
     * @param {String} key The function key
     * @returns {Boolean} True if already patched
     * @memberof HotPatcher
     */ isPatched(key) {
        return !!this.configuration.registry[key];
    }
    /**
     * @typedef {Object} PatchOptions
     * @property {Boolean=} chain - Whether or not to allow chaining execution. Chained
     *  execution allows for attaching multiple callbacks to a key, where the callbacks
     *  will be executed in order of when they were patched (oldest to newest), the
     *  values being passed from one method to another.
     */ /**
     * Patch a method name
     * @param {String} key The method key to patch
     * @param {Function} method The function to set
     * @param {PatchOptions=} options Patch options
     * @memberof HotPatcher
     * @returns {HotPatcher} Returns self
     */ patch(key, method, { chain: chain = false } = {}) {
        if (this.configuration.registry[key] && this.configuration.registry[key].final) throw new Error(`Failed patching '${key}': Method marked as being final`);
        if (typeof method !== "function") throw new Error(`Failed patching '${key}': Provided method is not a function`);
        if (chain) {
            // Add new method to the chain
            if (!this.configuration.registry[key]) // New key, create item
            this.configuration.registry[key] = $0c0bb5c22d260e58$var$createNewItem(method);
            else // Existing, push the method
            this.configuration.registry[key].methods.push(method);
        } else // Replace the original
        if (this.isPatched(key)) {
            const { original: original } = this.configuration.registry[key];
            this.configuration.registry[key] = Object.assign($0c0bb5c22d260e58$var$createNewItem(method), {
                original: original
            });
        } else this.configuration.registry[key] = $0c0bb5c22d260e58$var$createNewItem(method);
        return this;
    }
    /**
     * Patch a method inline, execute it and return the value
     * Used for patching contents of functions. This method will not apply a patched
     * function if it has already been patched, allowing for external overrides to
     * function. It also means that the function is cached so that it is not
     * instantiated every time the outer function is invoked.
     * @param {String} key The function key to use
     * @param {Function} method The function to patch (once, only if not patched)
     * @param {...*} args Arguments to pass to the function
     * @returns {*} The output of the patched function
     * @memberof HotPatcher
     * @example
     *  function mySpecialFunction(a, b) {
     *      return hotPatcher.patchInline("func", (a, b) => {
     *          return a + b;
     *      }, a, b);
     *  }
     */ patchInline(key, method, ...args) {
        if (!this.isPatched(key)) this.patch(key, method);
        return this.execute(key, ...args);
    }
    /**
     * Patch a method (or methods) in sequential-mode
     * See `patch()` with the option `chain: true`
     * @see patch
     * @param {String} key The key to patch
     * @param {...Function} methods The methods to patch
     * @returns {HotPatcher} Returns self
     * @memberof HotPatcher
     */ plugin(key, ...methods) {
        methods.forEach((method)=>{
            this.patch(key, method, {
                chain: true
            });
        });
        return this;
    }
    /**
     * Restore a patched method if it has been overridden
     * @param {String} key The method key
     * @memberof HotPatcher
     */ restore(key) {
        if (!this.isPatched(key)) throw new Error(`Failed restoring method: No method present for key: ${key}`);
        else if (typeof this.configuration.registry[key].original !== "function") throw new Error(`Failed restoring method: Original method not found or of invalid type for key: ${key}`);
        this.configuration.registry[key].methods = [
            this.configuration.registry[key].original
        ];
    }
    /**
     * Set a method as being final
     * This sets a method as having been finally overridden. Attempts at overriding
     * again will fail with an error.
     * @param {String} key The key to make final
     * @memberof HotPatcher
     * @returns {HotPatcher} Returns self
     */ setFinal(key) {
        if (!this.configuration.registry.hasOwnProperty(key)) throw new Error(`Failed marking '${key}' as final: No method found for key`);
        this.configuration.registry[key].final = true;
        return this;
    }
    constructor(){
        this._configuration = {
            registry: {},
            getEmptyAction: "null"
        };
        this.__type__ = $0c0bb5c22d260e58$var$HOT_PATCHER_TYPE;
    }
}
module.exports = $0c0bb5c22d260e58$var$HotPatcher;

});
parcelRegister("aJB9Q", function(module, exports) {
function $7d0aee1d48e9c30c$var$sequence(...methods) {
    if (methods.length === 0) throw new Error("Failed creating sequence: No functions provided");
    return function __executeSequence(...args) {
        let result = args;
        const _this = this;
        while(methods.length > 0){
            const method = methods.shift();
            result = [
                method.apply(_this, result)
            ];
        }
        return result[0];
    };
}
module.exports = {
    sequence: $7d0aee1d48e9c30c$var$sequence
};

});



parcelRegister("3FL1p", function(module, exports) {
"use strict";

var $c3gFF = parcelRequire("c3gFF");
var $2ac9acfb3b3601c7$require$toBase64 = $c3gFF.toBase64;

var $7gdrr = parcelRequire("7gdrr");
var $2ac9acfb3b3601c7$require$md5 = $7gdrr.md5;
var $2ac9acfb3b3601c7$require$ha1Compute = $7gdrr.ha1Compute;
function $2ac9acfb3b3601c7$var$generateBasicAuthHeader(username, password) {
    const encoded = $2ac9acfb3b3601c7$require$toBase64(`${username}:${password}`);
    return `Basic ${encoded}`;
}
function $2ac9acfb3b3601c7$var$generateDigestAuthHeader(options, digest) {
    const url = options.url.replace("//", "");
    const uri = url.indexOf("/") == -1 ? "/" : url.slice(url.indexOf("/"));
    const method = options.method ? options.method.toUpperCase() : "GET";
    const qop = /(^|,)\s*auth\s*($|,)/.test(digest.qop) ? "auth" : false;
    const ncString = `00000000${digest.nc}`.slice(-8);
    const cnonce = digest.cnonce;
    const ha1 = $2ac9acfb3b3601c7$require$ha1Compute(digest.algorithm, digest.username, digest.realm, digest.password, digest.nonce, digest.cnonce);
    const ha2 = $2ac9acfb3b3601c7$require$md5(`${method}:${uri}`);
    const digestResponse = qop ? $2ac9acfb3b3601c7$require$md5(`${ha1}:${digest.nonce}:${ncString}:${digest.cnonce}:${qop}:${ha2}`) : $2ac9acfb3b3601c7$require$md5(`${ha1}:${digest.nonce}:${ha2}`);
    const authValues = {
        username: digest.username,
        realm: digest.realm,
        nonce: digest.nonce,
        uri: uri,
        qop: qop,
        response: digestResponse,
        nc: ncString,
        cnonce: digest.cnonce,
        algorithm: digest.algorithm,
        opaque: digest.opaque
    };
    const authHeader = [];
    for(var k in authValues)if (authValues[k]) {
        if (k === "qop" || k === "nc" || k === "algorithm") authHeader.push(`${k}=${authValues[k]}`);
        else authHeader.push(`${k}="${authValues[k]}"`);
    }
    return `Digest ${authHeader.join(", ")}`;
}
function $2ac9acfb3b3601c7$var$generateTokenAuthHeader(tokenInfo) {
    return `${tokenInfo.token_type} ${tokenInfo.access_token}`;
}
module.exports = {
    generateBasicAuthHeader: $2ac9acfb3b3601c7$var$generateBasicAuthHeader,
    generateTokenAuthHeader: $2ac9acfb3b3601c7$var$generateTokenAuthHeader,
    generateDigestAuthHeader: $2ac9acfb3b3601c7$var$generateDigestAuthHeader
};

});
parcelRegister("c3gFF", function(module, exports) {
"use strict";

var $6jypm = parcelRequire("6jypm");
var $8c62b258f2c29c7d$require$decode = $6jypm.decode;
var $8c62b258f2c29c7d$require$encode = $6jypm.encode;

function $8c62b258f2c29c7d$var$decodeHTMLEntities(str) {
    if (typeof WEB === "undefined") {
        // Node
        const he = (parcelRequire("i250t"));
        return he.decode(str);
    } else {
        // Nasty browser way
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    }
}
function $8c62b258f2c29c7d$var$fromBase64(str) {
    return $8c62b258f2c29c7d$require$decode(str);
}
function $8c62b258f2c29c7d$var$toBase64(str) {
    return $8c62b258f2c29c7d$require$encode(str);
}
module.exports = {
    decodeHTMLEntities: $8c62b258f2c29c7d$var$decodeHTMLEntities,
    fromBase64: $8c62b258f2c29c7d$var$fromBase64,
    toBase64: $8c62b258f2c29c7d$var$toBase64
};

});

parcelRegister("7gdrr", function(module, exports) {
"use strict";

var $4JjTn = parcelRequire("4JjTn");
var $5494743fc60c3c73$require$createHash = $4JjTn.createHash;
function $5494743fc60c3c73$var$md5(data) {
    return $5494743fc60c3c73$require$createHash("md5").update(data).digest("hex");
}
function $5494743fc60c3c73$var$ha1Compute(algorithm, user, realm, pass, nonce, cnonce) {
    const ha1 = $5494743fc60c3c73$var$md5(`${user}:${realm}:${pass}`);
    if (algorithm && algorithm.toLowerCase() === "md5-sess") return $5494743fc60c3c73$var$md5(`${ha1}:${nonce}:${cnonce}`);
    else return ha1;
}
module.exports = {
    md5: $5494743fc60c3c73$var$md5,
    ha1Compute: $5494743fc60c3c73$var$ha1Compute
};

});





parcelRegister("3lZeK", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("2XOL9"))($parcel$resolve("505mw")),
    (parcelRequire("47Hnn"))($parcel$resolve("gJ1S1"))
]).then(()=>parcelRequire('2noWC'));

});
parcelRegister("2XOL9", function(module, exports) {
"use strict";

var $AHQY1 = parcelRequire("AHQY1");
module.exports = $AHQY1(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("AHQY1", function(module, exports) {
"use strict";
var $06e56142bf42a7a0$var$cachedBundles = {};
var $06e56142bf42a7a0$var$cachedPreloads = {};
var $06e56142bf42a7a0$var$cachedPrefetches = {};
function $06e56142bf42a7a0$var$getCache(type) {
    switch(type){
        case 'preload':
            return $06e56142bf42a7a0$var$cachedPreloads;
        case 'prefetch':
            return $06e56142bf42a7a0$var$cachedPrefetches;
        default:
            return $06e56142bf42a7a0$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $06e56142bf42a7a0$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("47Hnn", function(module, exports) {
"use strict";

var $AHQY1 = parcelRequire("AHQY1");
module.exports = $AHQY1(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("b5KKm", function(module, exports) {
module.exports = $parcel$resolve("iGwMF");

});

parcelRegister("3EQio", function(module, exports) {

$parcel$export(module.exports, "withHotKeys", function () { return $2a9dac5d897c361a$export$78c5b43741a51568; });
$parcel$export(module.exports, "HotKeys", function () { return $2a9dac5d897c361a$export$17ad26dab665ba34; });
$parcel$export(module.exports, "GlobalHotKeys", function () { return $2a9dac5d897c361a$export$7652690506c04eee; });
$parcel$export(module.exports, "IgnoreKeys", function () { return $2a9dac5d897c361a$export$afa62f5ff9d30976; });
$parcel$export(module.exports, "ObserveKeys", function () { return $2a9dac5d897c361a$export$d6b93397957fdfae; });
$parcel$export(module.exports, "withIgnoreKeys", function () { return $2a9dac5d897c361a$export$5dd986d2ecb36864; });
$parcel$export(module.exports, "withObserveKeys", function () { return $2a9dac5d897c361a$export$24098f02422ef0fd; });
$parcel$export(module.exports, "configure", function () { return $2a9dac5d897c361a$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getApplicationKeyMap", function () { return $2a9dac5d897c361a$export$d6fde881824c0060; });
$parcel$export(module.exports, "recordKeyCombination", function () { return $2a9dac5d897c361a$export$ce83784ab2f84e89; });
/**
 * ISC License
 *
 * Copyright (c) 2018, Aleck Greenham
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */ 
var $7dzZ9 = parcelRequire("7dzZ9");

var $1bxDW = parcelRequire("1bxDW");
function $2a9dac5d897c361a$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2a9dac5d897c361a$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $2a9dac5d897c361a$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2a9dac5d897c361a$var$_typeof(obj);
}
function $2a9dac5d897c361a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a9dac5d897c361a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a9dac5d897c361a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a9dac5d897c361a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a9dac5d897c361a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2a9dac5d897c361a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a9dac5d897c361a$var$_extends() {
    $2a9dac5d897c361a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a9dac5d897c361a$var$_extends.apply(this, arguments);
}
function $2a9dac5d897c361a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $2a9dac5d897c361a$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $2a9dac5d897c361a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2a9dac5d897c361a$var$_setPrototypeOf(subClass, superClass);
}
function $2a9dac5d897c361a$var$_getPrototypeOf(o) {
    $2a9dac5d897c361a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a9dac5d897c361a$var$_getPrototypeOf(o);
}
function $2a9dac5d897c361a$var$_setPrototypeOf(o, p) {
    $2a9dac5d897c361a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a9dac5d897c361a$var$_setPrototypeOf(o, p);
}
function $2a9dac5d897c361a$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2a9dac5d897c361a$var$_construct(Parent, args, Class) {
    if ($2a9dac5d897c361a$var$isNativeReflectConstruct()) $2a9dac5d897c361a$var$_construct = Reflect.construct;
    else $2a9dac5d897c361a$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $2a9dac5d897c361a$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $2a9dac5d897c361a$var$_construct.apply(null, arguments);
}
function $2a9dac5d897c361a$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $2a9dac5d897c361a$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2a9dac5d897c361a$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$2a9dac5d897c361a$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $2a9dac5d897c361a$var$_construct(Class, arguments, $2a9dac5d897c361a$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $2a9dac5d897c361a$var$_setPrototypeOf(Wrapper, Class);
    };
    return $2a9dac5d897c361a$var$_wrapNativeSuper(Class);
}
function $2a9dac5d897c361a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2a9dac5d897c361a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a9dac5d897c361a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a9dac5d897c361a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a9dac5d897c361a$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $2a9dac5d897c361a$var$_assertThisInitialized(self);
}
function $2a9dac5d897c361a$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $2a9dac5d897c361a$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $2a9dac5d897c361a$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $2a9dac5d897c361a$var$_get = Reflect.get;
    else $2a9dac5d897c361a$var$_get = function _get(target, property, receiver) {
        var base = $2a9dac5d897c361a$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $2a9dac5d897c361a$var$_get(target, property, receiver || target);
}
function $2a9dac5d897c361a$var$_toConsumableArray(arr) {
    return $2a9dac5d897c361a$var$_arrayWithoutHoles(arr) || $2a9dac5d897c361a$var$_iterableToArray(arr) || $2a9dac5d897c361a$var$_nonIterableSpread();
}
function $2a9dac5d897c361a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $2a9dac5d897c361a$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $2a9dac5d897c361a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $2a9dac5d897c361a$var$dictionaryFrom(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : null;
    return a.reduce(function(a, c) {
        return a[c] = b || {
            value: c
        }, a;
    }, {});
}
var $2a9dac5d897c361a$var$_defaultConfiguration = {
    logLevel: "warn",
    defaultKeyEvent: "keydown",
    defaultComponent: "div",
    defaultTabIndex: "-1",
    ignoreTags: [
        "input",
        "select",
        "textarea"
    ],
    enableHardSequences: !1,
    ignoreKeymapAndHandlerChangesByDefault: !0,
    ignoreEventsCondition: function c(a) {
        var b = a.target;
        if (b && b.tagName) {
            var d = b.tagName.toLowerCase();
            return $2a9dac5d897c361a$var$Configuration.option("_ignoreTagsDict")[d] || b.isContentEditable;
        }
        return !1;
    },
    ignoreRepeatedEventsWhenKeyHeldDown: !0,
    simulateMissingKeyPressEvents: !0,
    stopEventPropagationAfterHandling: !0,
    stopEventPropagationAfterIgnoring: !0,
    allowCombinationSubmatches: !1,
    customKeyCodes: {}
}, $2a9dac5d897c361a$var$_configuration = $2a9dac5d897c361a$var$_objectSpread({}, $2a9dac5d897c361a$var$_defaultConfiguration);
$2a9dac5d897c361a$var$_configuration._ignoreTagsDict = $2a9dac5d897c361a$var$dictionaryFrom($2a9dac5d897c361a$var$_configuration.ignoreTags, !0);
var $2a9dac5d897c361a$var$Configuration = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a);
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "init",
            value: function e(a) {
                var b = this, c = a.ignoreTags, d = a.customKeyCodes;
                c && (a._ignoreTagsDict = $2a9dac5d897c361a$var$dictionaryFrom(a.ignoreTags)), d && (a._customKeyNamesDict = $2a9dac5d897c361a$var$dictionaryFrom(Object.values(a.customKeyCodes))), -1 !== [
                    "verbose",
                    "debug",
                    "info"
                ].indexOf(a.logLevel) && console.warn("React HotKeys: You have requested log level '".concat(a.logLevel, "' but for performance reasons, logging below severity level 'warning' is disabled in production. Please use the development build for complete logs.")), Object.keys(a).forEach(function(c) {
                    b.set(c, a[c]);
                });
            }
        },
        {
            key: "set",
            value: function c(a, b) {
                $2a9dac5d897c361a$var$_configuration[a] = b;
            }
        },
        {
            key: "reset",
            value: function b(a) {
                $2a9dac5d897c361a$var$_configuration[a] = $2a9dac5d897c361a$var$_defaultConfiguration[a];
            }
        },
        {
            key: "option",
            value: function b(a) {
                return $2a9dac5d897c361a$var$_configuration[a];
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$Logger = function() {
    function a() {
        var b = this, c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "warn";
        if ($2a9dac5d897c361a$var$_classCallCheck(this, a), $2a9dac5d897c361a$var$_defineProperty(this, "verbose", this.noop), $2a9dac5d897c361a$var$_defineProperty(this, "debug", this.noop), $2a9dac5d897c361a$var$_defineProperty(this, "info", this.noop), $2a9dac5d897c361a$var$_defineProperty(this, "warn", this.noop), $2a9dac5d897c361a$var$_defineProperty(this, "error", this.noop), this.logLevel = this.constructor.levels[c], this.logLevel >= this.constructor.levels.error) this.error = console.error;
        else return;
        if (this.logLevel >= this.constructor.levels.warn) this.warn = console.warn;
        else return;
        [
            "info",
            "debug",
            "verbose"
        ].some(function(a) {
            return !(b.logLevel >= b.constructor.levels[a]) || (b[a] = console.log, !1);
        });
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "noop",
            value: function a() {}
        }
    ]), a;
}();
$2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$Logger, "logIcons", [
    "\uD83D\uDCD5",
    "\uD83D\uDCD7",
    "\uD83D\uDCD8",
    "\uD83D\uDCD9"
]), $2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$Logger, "componentIcons", [
    "\uD83D\uDD3A",
    "\u2B50\uFE0F",
    "\uD83D\uDD37",
    "\uD83D\uDD36",
    "\u2B1B\uFE0F"
]), $2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$Logger, "eventIcons", [
    "\u2764\uFE0F",
    "\uD83D\uDC9A",
    "\uD83D\uDC99",
    "\uD83D\uDC9B",
    "\uD83D\uDC9C",
    "\uD83E\uDDE1"
]), $2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$Logger, "levels", {
    none: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4,
    verbose: 5
});
var $2a9dac5d897c361a$var$KeyEventType = {
    keydown: 0,
    keypress: 1,
    keyup: 2
};
var $2a9dac5d897c361a$var$ModifierFlagsDictionary = {
    Shift: [
        "shiftKey"
    ],
    Meta: [
        "metaKey"
    ],
    Control: [
        "ctrlKey"
    ],
    Alt: [
        "altKey"
    ]
};
var $2a9dac5d897c361a$var$ShiftedKeysDictionary = {
    "`": [
        "~"
    ],
    1: [
        "!"
    ],
    2: [
        "@",
        "\""
    ],
    3: [
        "#",
        "\xA3"
    ],
    4: [
        "$"
    ],
    5: [
        "%"
    ],
    6: [
        "^"
    ],
    7: [
        "&"
    ],
    8: [
        "*"
    ],
    9: [
        "("
    ],
    0: [
        ")"
    ],
    "-": [
        "_"
    ],
    "=": [
        "plus"
    ],
    ";": [
        ":"
    ],
    "'": [
        "\"",
        "@"
    ],
    ",": [
        "<"
    ],
    ".": [
        ">"
    ],
    "/": [
        "?"
    ],
    "\\": [
        "|"
    ],
    "[": [
        "{"
    ],
    "]": [
        "}"
    ],
    "#": [
        "~"
    ]
};
function $2a9dac5d897c361a$var$resolveShiftedAlias(a) {
    return $2a9dac5d897c361a$var$ShiftedKeysDictionary[a] || [
        1 === a.length ? a.toUpperCase() : a
    ];
}
function $2a9dac5d897c361a$var$hasKey(a, b) {
    return a.hasOwnProperty(b);
}
function $2a9dac5d897c361a$var$invertArrayDictionary(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
    return Object.keys(a).reduce(function(c, d) {
        var e = a[d];
        return e.forEach(function(a) {
            $2a9dac5d897c361a$var$hasKey(c, a) || (c[a] = []), c[a].push(d);
        }), b.includeOriginal && (!$2a9dac5d897c361a$var$hasKey(c, d) && (c[d] = []), c[d] = [].concat($2a9dac5d897c361a$var$_toConsumableArray(c[d]), $2a9dac5d897c361a$var$_toConsumableArray(e))), c;
    }, {});
}
var $2a9dac5d897c361a$var$UnshiftedKeysDictionary = $2a9dac5d897c361a$var$invertArrayDictionary($2a9dac5d897c361a$var$ShiftedKeysDictionary);
function $2a9dac5d897c361a$var$resolveUnshiftedAlias(a) {
    return $2a9dac5d897c361a$var$UnshiftedKeysDictionary[a] || [
        1 === a.length ? a.toLowerCase() : a
    ];
}
var $2a9dac5d897c361a$var$KeyOSAndLayoutAliasesDictionary = {};
var $2a9dac5d897c361a$var$KeyOSAndLayoutAliasesDictionary$1 = $2a9dac5d897c361a$var$invertArrayDictionary($2a9dac5d897c361a$var$KeyOSAndLayoutAliasesDictionary, {
    includeOriginal: !0
});
function $2a9dac5d897c361a$var$isString(a) {
    return "string" == typeof a;
}
function $2a9dac5d897c361a$var$stripSuperfluousWhitespace(a) {
    return $2a9dac5d897c361a$var$isString(a) ? a.trim().replace(/\s+/g, " ") : a;
}
var $2a9dac5d897c361a$var$MousetrapToReactKeyNamesDictionary = {
    tab: "Tab",
    capslock: "CapsLock",
    shift: "Shift",
    meta: "Meta",
    alt: "Alt",
    ctrl: "Control",
    space: " ",
    spacebar: " ",
    escape: "Escape",
    esc: "Escape",
    left: "ArrowLeft",
    right: "ArrowRight",
    up: "ArrowUp",
    down: "ArrowDown",
    return: "Enter",
    del: "Delete",
    command: "Meta",
    option: "Alt",
    enter: "Enter",
    backspace: "Backspace",
    ins: "Insert",
    pageup: "PageUp",
    pagedown: "PageDown",
    end: "End",
    home: "Home",
    contextmenu: "ContextMenu",
    numlock: "Clear"
};
var $2a9dac5d897c361a$var$KeyShorthandDictionary = {
    cmd: "Meta"
};
function $2a9dac5d897c361a$var$standardizeKeyName(a) {
    var b = a.toLowerCase();
    return $2a9dac5d897c361a$var$MousetrapToReactKeyNamesDictionary[b] || $2a9dac5d897c361a$var$KeyShorthandDictionary[b] || (a.match(/^f\d+$/) ? a.toUpperCase() : a);
}
var $2a9dac5d897c361a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
};
var $2a9dac5d897c361a$var$NonPrintableKeysDictionary = $2a9dac5d897c361a$var$dictionaryFrom(Object.values($2a9dac5d897c361a$var$translateToKey), !0);
function $2a9dac5d897c361a$var$isNonPrintableKeyName(a) {
    return !!$2a9dac5d897c361a$var$NonPrintableKeysDictionary[a];
}
function $2a9dac5d897c361a$var$isCustomKeyName(a) {
    return $2a9dac5d897c361a$var$Configuration.option("_customKeyNamesDict")[a];
}
function $2a9dac5d897c361a$var$isValidKey(a) {
    return $2a9dac5d897c361a$var$isNonPrintableKeyName(a) || String.fromCharCode(a.charCodeAt(0)) === a || $2a9dac5d897c361a$var$isCustomKeyName(a);
}
var $2a9dac5d897c361a$var$InvalidKeyNameError = function(a) {
    function b() {
        var a, c;
        $2a9dac5d897c361a$var$_classCallCheck(this, b);
        for(var d = arguments.length, e = Array(d), f = 0; f < d; f++)e[f] = arguments[f];
        return c = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, (a = $2a9dac5d897c361a$var$_getPrototypeOf(b)).call.apply(a, [
            this
        ].concat(e))), $2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(c)), "name", "InvalidKeyNameError"), c;
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), b;
}($2a9dac5d897c361a$var$_wrapNativeSuper(Error));
function $2a9dac5d897c361a$var$normalizedCombinationId(a) {
    return a.sort().join("+");
}
var $2a9dac5d897c361a$var$KeySequenceParser = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a);
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "parse",
            value: function k(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = $2a9dac5d897c361a$var$stripSuperfluousWhitespace(a), d = c.split(" ");
                try {
                    var e = d.slice(0, d.length - 1), f = d[d.length - 1], g = e.map(function(a) {
                        var c = $2a9dac5d897c361a$var$parseCombination(a, b);
                        return $2a9dac5d897c361a$var$normalizedCombinationId(Object.keys(c));
                    }).join(" "), h = $2a9dac5d897c361a$var$parseCombination(f, b), i = $2a9dac5d897c361a$var$normalizedCombinationId(Object.keys(h)), j = {
                        id: i,
                        keyDictionary: h,
                        keyEventType: b.keyEventType,
                        size: Object.keys(h).length
                    };
                    return {
                        sequence: {
                            prefix: g,
                            size: e.length + 1
                        },
                        combination: j
                    };
                } catch (a) {
                    return {
                        sequence: null,
                        combination: null
                    };
                }
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$parseCombination(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
    return a.replace(/^\+|(\s|[^+]\+)\+/, "$1plus").split("+").reduce(function(a, c) {
        var d = $2a9dac5d897c361a$var$standardizeKeyName(c);
        if (b.ensureValidKeys && !$2a9dac5d897c361a$var$isValidKey(d)) throw new $2a9dac5d897c361a$var$InvalidKeyNameError;
        return a[d] = !0, a;
    }, {});
}
var $2a9dac5d897c361a$var$AltedKeysDictionary = {
    "`": [
        "`"
    ],
    1: [
        "\xA1"
    ],
    2: [
        "\u2122"
    ],
    3: [
        "\xA3"
    ],
    4: [
        "\xA2"
    ],
    5: [
        "\u221E"
    ],
    6: [
        "\xA7"
    ],
    7: [
        "\xB6"
    ],
    8: [
        "\u2022"
    ],
    9: [
        "\xAA"
    ],
    0: [
        "\xBA"
    ],
    "-": [
        "\u2013"
    ],
    "=": [
        "\u2260"
    ],
    a: [
        "\xE5"
    ],
    b: [
        "\u222B"
    ],
    c: [
        "\xE7"
    ],
    d: [
        "\u2202"
    ],
    e: [
        "\xB4"
    ],
    f: [
        "\u0192"
    ],
    g: [
        "\xA9"
    ],
    h: [
        "\u02D9"
    ],
    i: [
        "\u02C6"
    ],
    j: [
        "\u2206"
    ],
    k: [
        "\u02DA"
    ],
    l: [
        "\xAC"
    ],
    m: [
        "\xB5"
    ],
    n: [
        "\u02DC"
    ],
    o: [
        "\xF8"
    ],
    p: [
        "\u03C0"
    ],
    q: [
        "\u0153"
    ],
    r: [
        "\xAE"
    ],
    s: [
        "\xDF"
    ],
    t: [
        "\u2020"
    ],
    u: [
        "\xA8"
    ],
    v: [
        "\u221A"
    ],
    w: [
        "\u2211"
    ],
    x: [
        "\u2248"
    ],
    y: [
        "\xA5"
    ],
    z: [
        "\u03A9"
    ],
    "[": [
        "\u201C"
    ],
    "]": [
        "\u2018"
    ],
    "\\": [
        "\xAB"
    ],
    "'": [
        "\xE6"
    ],
    ";": [
        "\u2026"
    ],
    ",": [
        "\u2264"
    ],
    ".": [
        "\u2265"
    ],
    "/": [
        "\xF7"
    ]
};
var $2a9dac5d897c361a$var$UnaltedKeysDictionary = $2a9dac5d897c361a$var$invertArrayDictionary($2a9dac5d897c361a$var$AltedKeysDictionary);
function $2a9dac5d897c361a$var$resolveUnaltedAlias(a) {
    return $2a9dac5d897c361a$var$UnaltedKeysDictionary[a] || [
        a
    ];
}
function $2a9dac5d897c361a$var$resolveAltedAlias(a) {
    return $2a9dac5d897c361a$var$AltedKeysDictionary[a] || [
        a
    ];
}
var $2a9dac5d897c361a$var$AltShiftedKeysDictionary = {
    "`": [
        "`"
    ],
    1: [
        "\u2044"
    ],
    2: [
        "\u20AC"
    ],
    3: [
        "\u2039"
    ],
    4: [
        "\u203A"
    ],
    5: [
        "\uFB01"
    ],
    6: [
        "\uFB02"
    ],
    7: [
        "\u2021"
    ],
    8: [
        "\xB0"
    ],
    9: [
        "\xB7"
    ],
    0: [
        "\u201A"
    ],
    "-": [
        "\u2014"
    ],
    "=": [
        "\xB1"
    ],
    a: [
        "\xC5"
    ],
    b: [
        "\u0131"
    ],
    c: [
        "\xC7"
    ],
    d: [
        "\xCE"
    ],
    e: [
        "\xB4"
    ],
    f: [
        "\xCF"
    ],
    g: [
        "\u02DD"
    ],
    h: [
        "\xD3"
    ],
    i: [
        "\u02C6"
    ],
    j: [
        "\xD4"
    ],
    k: [
        "\uF8FF"
    ],
    l: [
        "\xD2"
    ],
    m: [
        "\xC2"
    ],
    n: [
        "\u02DC"
    ],
    o: [
        "\xD8"
    ],
    p: [
        "\u03C0"
    ],
    q: [
        "\u0152"
    ],
    r: [
        "\u2030"
    ],
    s: [
        "\xCD"
    ],
    t: [
        "\xCE"
    ],
    u: [
        "\xA8"
    ],
    v: [
        "\u25CA"
    ],
    w: [
        "\u201E"
    ],
    x: [
        "\u02DB"
    ],
    y: [
        "\xC1"
    ],
    z: [
        "\xB8"
    ],
    "[": [
        "\u201D"
    ],
    "]": [
        "\u2019"
    ],
    "\\": [
        "\xBB"
    ],
    "'": [
        "\xC6"
    ],
    ";": [
        "\xDA"
    ],
    ",": [
        "\xAF"
    ],
    ".": [
        "\u02D8"
    ]
};
var $2a9dac5d897c361a$var$UnaltShiftedKeysDictionary = $2a9dac5d897c361a$var$invertArrayDictionary($2a9dac5d897c361a$var$AltShiftedKeysDictionary);
function $2a9dac5d897c361a$var$resolveUnaltShiftedAlias(a) {
    return $2a9dac5d897c361a$var$UnaltShiftedKeysDictionary[a] || $2a9dac5d897c361a$var$resolveUnshiftedAlias(a);
}
function $2a9dac5d897c361a$var$resolveAltShiftedAlias(a) {
    return $2a9dac5d897c361a$var$AltShiftedKeysDictionary[a] || [
        a
    ];
}
var $2a9dac5d897c361a$var$KeyCombinationSerializer = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a);
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "serialize",
            value: function f(a) {
                var b = a.Shift, c = a.Alt, d = {}, e = Object.keys(a).sort();
                return e.forEach(function(a) {
                    var e = [];
                    if (b) {
                        if (c) {
                            var f = $2a9dac5d897c361a$var$resolveUnaltShiftedAlias(a), g = $2a9dac5d897c361a$var$resolveAltShiftedAlias(a);
                            e = [].concat($2a9dac5d897c361a$var$_toConsumableArray(e), [
                                a
                            ], $2a9dac5d897c361a$var$_toConsumableArray(f), $2a9dac5d897c361a$var$_toConsumableArray(g));
                        } else {
                            var h = $2a9dac5d897c361a$var$resolveUnshiftedAlias(a), i = $2a9dac5d897c361a$var$resolveShiftedAlias(a);
                            e = [].concat($2a9dac5d897c361a$var$_toConsumableArray(e), [
                                a
                            ], $2a9dac5d897c361a$var$_toConsumableArray(h), $2a9dac5d897c361a$var$_toConsumableArray(i));
                        }
                    } else if (c) {
                        var j = $2a9dac5d897c361a$var$resolveUnaltedAlias(a), k = $2a9dac5d897c361a$var$resolveAltedAlias(a);
                        e = [].concat($2a9dac5d897c361a$var$_toConsumableArray(e), [
                            a
                        ], $2a9dac5d897c361a$var$_toConsumableArray(j), $2a9dac5d897c361a$var$_toConsumableArray(k));
                    } else {
                        e.push(a);
                        var m = $2a9dac5d897c361a$var$KeyOSAndLayoutAliasesDictionary$1[a];
                        m && (e = [].concat($2a9dac5d897c361a$var$_toConsumableArray(e), $2a9dac5d897c361a$var$_toConsumableArray(m)));
                    }
                    var l = Object.keys(d);
                    0 < l.length ? l.forEach(function(a) {
                        e.forEach(function(b) {
                            d[a + "+".concat(b)] = $2a9dac5d897c361a$var$_objectSpread({}, d[a], $2a9dac5d897c361a$var$_defineProperty({}, b, !0));
                        }), delete d[a];
                    }) : e.forEach(function(a) {
                        d[a] = $2a9dac5d897c361a$var$_defineProperty({}, a, !0);
                    });
                }), Object.values(d).map(function(a) {
                    return Object.keys(a).sort().join("+");
                });
            }
        },
        {
            key: "isValidKeySerialization",
            value: function b(a) {
                return !!(0 < a.length) && !!$2a9dac5d897c361a$var$KeySequenceParser.parse(a, {
                    ensureValidKeys: !0
                }).combination;
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$KeyEventSequenceIndex = {
    previous: 0,
    current: 1
};
function $2a9dac5d897c361a$var$resolveKeyAlias(a) {
    return $2a9dac5d897c361a$var$KeyOSAndLayoutAliasesDictionary$1[a] || [
        a
    ];
}
function $2a9dac5d897c361a$var$applicableAliasFunctions(a) {
    if (a.Shift) return a.Alt ? [
        $2a9dac5d897c361a$var$resolveAltShiftedAlias,
        $2a9dac5d897c361a$var$resolveUnaltShiftedAlias
    ] : [
        $2a9dac5d897c361a$var$resolveShiftedAlias,
        $2a9dac5d897c361a$var$resolveUnshiftedAlias
    ];
    if (a.Alt) return [
        $2a9dac5d897c361a$var$resolveAltedAlias,
        $2a9dac5d897c361a$var$resolveUnaltedAlias
    ];
    var b = function(a) {
        return [
            a
        ];
    };
    return [
        b,
        b
    ];
}
function $2a9dac5d897c361a$var$isUndefined(a) {
    return "undefined" == typeof a;
}
var $2a9dac5d897c361a$var$KeyEventState = {
    unseen: 0,
    seen: 1,
    simulated: 2
};
var $2a9dac5d897c361a$var$KeyEventStateArrayManager = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a);
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "newRecord",
            value: function d(a, b) {
                var c = [
                    $2a9dac5d897c361a$var$KeyEventState.unseen,
                    $2a9dac5d897c361a$var$KeyEventState.unseen,
                    $2a9dac5d897c361a$var$KeyEventState.unseen
                ];
                if (!$2a9dac5d897c361a$var$isUndefined(a)) for(var e = 0; e <= a; e++)c[e] = b;
                return c;
            }
        },
        {
            key: "setBit",
            value: function d(a, b, c) {
                return a[b] = c, a;
            }
        },
        {
            key: "clone",
            value: function d(a) {
                for(var b = this.newRecord(), c = 0; c < a.length; c++)b[c] = a[c];
                return b;
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$isObject(a) {
    return !Array.isArray(a) && "object" === $2a9dac5d897c361a$var$_typeof(a) && null !== a;
}
function $2a9dac5d897c361a$var$isEmpty(a) {
    return $2a9dac5d897c361a$var$isObject(a) ? 0 === Object.keys(a).length : !a || 0 === a.length;
}
function $2a9dac5d897c361a$var$size(a) {
    return $2a9dac5d897c361a$var$isObject(a) ? Object.keys(a).length : a.length;
}
var $2a9dac5d897c361a$var$KeyCombination = function() {
    function a() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._keys = b, this._includesKeyUp = !1, this._update();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getIds",
            value: function a() {
                return this._ids;
            }
        },
        {
            key: "getKeyAliases",
            value: function a() {
                return this._keyAliases;
            }
        },
        {
            key: "getNormalizedKeyName",
            value: function d(a) {
                var b = this._keys[a];
                if (b) return a;
                var c = this._keyAliases[a];
                return c ? c : a;
            }
        },
        {
            key: "getNumberOfKeys",
            value: function a() {
                return $2a9dac5d897c361a$var$size(this._keys);
            }
        },
        {
            key: "any",
            value: function a() {
                return 0 < Object.keys(this._getKeyStates()).length;
            }
        },
        {
            key: "isEnding",
            value: function a() {
                return this._includesKeyUp;
            }
        },
        {
            key: "hasEnded",
            value: function a() {
                return $2a9dac5d897c361a$var$isEmpty(this.keysStillPressedDict());
            }
        },
        {
            key: "addKey",
            value: function c(a, b) {
                this._setKeyState(a, [
                    $2a9dac5d897c361a$var$KeyEventStateArrayManager.newRecord(),
                    $2a9dac5d897c361a$var$KeyEventStateArrayManager.newRecord($2a9dac5d897c361a$var$KeyEventType.keydown, b)
                ]);
            }
        },
        {
            key: "setKeyState",
            value: function g(a, b, c) {
                var d = this._getKeyState(a);
                if (this.isKeyIncluded(a)) {
                    var e = $2a9dac5d897c361a$var$KeyEventStateArrayManager.clone(d[1]), f = $2a9dac5d897c361a$var$KeyEventStateArrayManager.clone(e);
                    $2a9dac5d897c361a$var$KeyEventStateArrayManager.setBit(f, b, c), this._setKeyState(a, [
                        e,
                        f
                    ]);
                } else this.addKey(a, c);
                b === $2a9dac5d897c361a$var$KeyEventType.keyup && (this._includesKeyUp = !0);
            }
        },
        {
            key: "forEachKey",
            value: function b(a) {
                return Object.keys(this._keys).forEach(a);
            }
        },
        {
            key: "some",
            value: function b(a) {
                return Object.keys(this._keys).some(a);
            }
        },
        {
            key: "getKeyDictionary",
            value: function a() {
                return $2a9dac5d897c361a$var$dictionaryFrom(Object.keys(this._getKeyStates()), !0);
            }
        },
        {
            key: "keysStillPressedDict",
            value: function b() {
                var a = this;
                return Object.keys(this._keys).reduce(function(_b, c) {
                    return a.isKeyStillPressed(c) && (_b[c] = a._getKeyState(c)), _b;
                }, {});
            }
        },
        {
            key: "isKeyIncluded",
            value: function b(a) {
                return !!this._getKeyState(a);
            }
        },
        {
            key: "isKeyStillPressed",
            value: function b(a) {
                return this.isEventTriggered(a, $2a9dac5d897c361a$var$KeyEventType.keypress) && !this.isKeyReleased(a);
            }
        },
        {
            key: "isKeyReleased",
            value: function b(a) {
                return this.isEventTriggered(a, $2a9dac5d897c361a$var$KeyEventType.keyup);
            }
        },
        {
            key: "isEventTriggered",
            value: function c(a, b) {
                return this._getKeyStateType(a, $2a9dac5d897c361a$var$KeyEventSequenceIndex.current, b);
            }
        },
        {
            key: "wasEventPreviouslyTriggered",
            value: function c(a, b) {
                return this._getKeyStateType(a, $2a9dac5d897c361a$var$KeyEventSequenceIndex.previous, b);
            }
        },
        {
            key: "isKeyPressSimulated",
            value: function b(a) {
                return this._isKeyEventSimulated(a, $2a9dac5d897c361a$var$KeyEventType.keypress);
            }
        },
        {
            key: "isKeyUpSimulated",
            value: function b(a) {
                return this._isKeyEventSimulated(a, $2a9dac5d897c361a$var$KeyEventType.keyup);
            }
        },
        {
            key: "describe",
            value: function a() {
                return this.getIds()[0];
            }
        },
        {
            key: "toJSON",
            value: function a() {
                return {
                    keys: this._getKeyStates(),
                    ids: this.getIds(),
                    keyAliases: this.getKeyAliases()
                };
            }
        },
        {
            key: "_getKeyStateType",
            value: function e(a, b, c) {
                var d = this._getKeyState(a);
                return d && d[b][c];
            }
        },
        {
            key: "_update",
            value: function a() {
                this._ids = $2a9dac5d897c361a$var$KeyCombinationSerializer.serialize(this._keys), this._keyAliases = $2a9dac5d897c361a$var$buildKeyAliases(this._keys);
            }
        },
        {
            key: "_isKeyEventSimulated",
            value: function c(a, b) {
                return this.isEventTriggered(a, b) === $2a9dac5d897c361a$var$KeyEventState.simulated;
            }
        },
        {
            key: "_getKeyStates",
            value: function a() {
                return this._keys;
            }
        },
        {
            key: "_getKeyState",
            value: function d(a) {
                var b = this._keys[a];
                if (b) return b;
                var c = this._keyAliases[a];
                if (c) return this._keys[c];
            }
        },
        {
            key: "_setKeyState",
            value: function d(a, b) {
                var c = this.getNormalizedKeyName(a);
                this._keys[c] = b, this._update();
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$buildKeyAliases(a) {
    return Object.keys(a).reduce(function(b, c) {
        return $2a9dac5d897c361a$var$resolveKeyAlias(c).forEach(function(d) {
            $2a9dac5d897c361a$var$applicableAliasFunctions(a).forEach(function(a) {
                a(d).forEach(function(a) {
                    (a !== c || c !== d) && (b[a] = c);
                });
            });
        }), b;
    }, {});
}
var $2a9dac5d897c361a$var$KeyHistory = function() {
    function a(b) {
        var c = b.maxLength, d = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null;
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._records = [], this._maxLength = c, d ? this._push(d) : this._push(new $2a9dac5d897c361a$var$KeyCombination);
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getMostRecentCombinations",
            value: function b(a) {
                return this._records.slice(-a, -1);
            }
        },
        {
            key: "any",
            value: function a() {
                return this._records.some(function(_a) {
                    return _a.any();
                });
            }
        },
        {
            key: "getLength",
            value: function a() {
                return this._records.length;
            }
        },
        {
            key: "getCurrentCombination",
            value: function a() {
                return this._records[this.getLength() - 1];
            }
        },
        {
            key: "addKeyToCurrentCombination",
            value: function d(a, b, c) {
                this._ensureInitialKeyCombination(), this.getCurrentCombination().setKeyState(a, b, c);
            }
        },
        {
            key: "setMaxLength",
            value: function b(a) {
                this._maxLength = a, this._trimHistory();
            }
        },
        {
            key: "startNewKeyCombination",
            value: function d(a, b) {
                this._ensureInitialKeyCombination();
                var c = new $2a9dac5d897c361a$var$KeyCombination(this.getCurrentCombination().keysStillPressedDict());
                c.addKey(a, b), this._push(c);
            }
        },
        {
            key: "toJSON",
            value: function a() {
                return this._records.map(function(_a) {
                    return _a.toJSON();
                });
            }
        },
        {
            key: "_ensureInitialKeyCombination",
            value: function a() {
                0 === this.getLength() && this._push(new $2a9dac5d897c361a$var$KeyCombination);
            }
        },
        {
            key: "_push",
            value: function b(a) {
                this._trimHistory(), this._records.push(a);
            }
        },
        {
            key: "_trimHistory",
            value: function a() {
                for(; this.getLength() > this._maxLength;)this._shift();
            }
        },
        {
            key: "_shift",
            value: function a() {
                this._records.shift();
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$Registry = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._registry = {};
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "get",
            value: function b(a) {
                return this._registry[a];
            }
        },
        {
            key: "set",
            value: function c(a, b) {
                this._registry[a] = b;
            }
        },
        {
            key: "remove",
            value: function b(a) {
                delete this._registry[a];
            }
        },
        {
            key: "toJSON",
            value: function a() {
                return this._registry;
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$arrayFrom(a) {
    return Array.isArray(a) ? a : a ? [
        a
    ] : [];
}
function $2a9dac5d897c361a$var$without(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [], c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {}, d = $2a9dac5d897c361a$var$dictionaryFrom($2a9dac5d897c361a$var$arrayFrom(b));
    return Array.isArray(a) ? a.reduce(function(a, b) {
        return d[b] && (c.stringifyFirst || d[b].value === b) || a.push(b), a;
    }, []) : $2a9dac5d897c361a$var$isObject(a) ? Object.keys(a).reduce(function(b, c) {
        return d[c] || (b[c] = a[c]), b;
    }, {}) : a;
}
var $2a9dac5d897c361a$var$ComponentTree = function(a) {
    function b() {
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).apply(this, arguments));
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "add",
            value: function d(a, c) {
                $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "set", this).call(this, a, {
                    childIds: [],
                    parentId: null,
                    keyMap: c
                });
            }
        },
        {
            key: "update",
            value: function e(a, c) {
                var d = $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "get", this).call(this, a);
                $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "set", this).call(this, a, $2a9dac5d897c361a$var$_objectSpread({}, d, {
                    keyMap: c
                }));
            }
        },
        {
            key: "setParent",
            value: function c(a, b) {
                this.get(a).parentId = b, this._addChildId(b, a);
            }
        },
        {
            key: "remove",
            value: function d(a) {
                var c = this._getParentId(a);
                this._removeChildId(c, a), $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "remove", this).call(this, a);
            }
        },
        {
            key: "_getParentId",
            value: function c(a) {
                var b = this.get(a);
                return b && b.parentId;
            }
        },
        {
            key: "_addChildId",
            value: function c(a, b) {
                this.get(a).childIds.push(b);
            }
        },
        {
            key: "_removeChildId",
            value: function d(a, b) {
                var c = this.get(a);
                c && (c.childIds = $2a9dac5d897c361a$var$without(c.childIds, b));
            }
        }
    ]), b;
}($2a9dac5d897c361a$var$Registry);
function $2a9dac5d897c361a$var$removeAtIndex(a, b) {
    return [].concat($2a9dac5d897c361a$var$_toConsumableArray(a.slice(0, b)), $2a9dac5d897c361a$var$_toConsumableArray(a.slice(b + 1)));
}
var $2a9dac5d897c361a$var$ComponentOptionsListIterator = function() {
    function a(b) {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._list = b, this._position = -1;
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getPosition",
            value: function a() {
                return this._position;
            }
        },
        {
            key: "getComponent",
            value: function a() {
                return this._list.getAtPosition(this.getPosition());
            }
        },
        {
            key: "next",
            value: function a() {
                return this.getPosition() + 1 < this._list.getLength() ? (this._position++, this.getComponent()) : null;
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$ComponentOptionsList = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._list = [], this._idToIndex = {}, this._longestSequence = 1, this._longestSequenceComponentId = null, this._keyMapEventRecord = $2a9dac5d897c361a$var$KeyEventStateArrayManager.newRecord();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getNewIterator",
            value: function a() {
                return new $2a9dac5d897c361a$var$ComponentOptionsListIterator(this);
            }
        },
        {
            key: "add",
            value: function g(a, b, c, d) {
                if (this.containsId(a)) return this.update(a, b, c, d);
                var e = this._build(a, b, c, d);
                this._list.push(e);
                var f = this._getLastIndex();
                return this._idToIndex[a] = f;
            }
        },
        {
            key: "containsId",
            value: function b(a) {
                return !!this.get(a);
            }
        },
        {
            key: "get",
            value: function b(a) {
                return this.getAtPosition(this.getIndexById(a));
            }
        },
        {
            key: "getIndexById",
            value: function b(a) {
                return this._idToIndex[a];
            }
        },
        {
            key: "update",
            value: function h(a, b, c, d) {
                var e = this._isUpdatingComponentWithLongestSequence(a), f = this.getLongestSequence(), g = this._build(a, b, c, d);
                e && g.sequenceLength !== f && (g.sequenceLength > f ? this._longestSequence = g.sequenceLength : this._recalculateLongestSequence()), this._list[this.getIndexById(a)] = g;
            }
        },
        {
            key: "remove",
            value: function c(a) {
                var b = this._isUpdatingComponentWithLongestSequence(a);
                this.removeAtPosition(this.getIndexById(a)), b && this._recalculateLongestSequence();
            }
        },
        {
            key: "any",
            value: function a() {
                return 0 !== this.getLength();
            }
        },
        {
            key: "isRoot",
            value: function b(a) {
                return this.getIndexById(a) >= this.getLength() - 1;
            }
        },
        {
            key: "getLongestSequence",
            value: function a() {
                return this._longestSequence;
            }
        },
        {
            key: "anyActionsForEventType",
            value: function b(a) {
                return !!this._keyMapEventRecord[a];
            }
        },
        {
            key: "getLength",
            value: function a() {
                return this._list.length;
            }
        },
        {
            key: "getAtPosition",
            value: function b(a) {
                return this._list[a];
            }
        },
        {
            key: "removeAtPosition",
            value: function b(a) {
                this._list = $2a9dac5d897c361a$var$removeAtIndex(this._list, a);
                for(var c = a; c < this.getLength();)this._idToIndex[this.getAtPosition(c).componentId] = c, c++;
            }
        },
        {
            key: "toJSON",
            value: function a() {
                return this._list;
            }
        },
        {
            key: "_getLastIndex",
            value: function a() {
                return this.getLength() - 1;
            }
        },
        {
            key: "_build",
            value: function i(a, b, c, d) {
                var e = this._applyHardSequences(b, c), f = e.keyMap, g = e.handlers, h = this._buildActionDictionary($2a9dac5d897c361a$var$_objectSpread({}, b, f), d, a);
                return {
                    actions: h,
                    handlers: g,
                    componentId: a,
                    options: d
                };
            }
        },
        {
            key: "_isUpdatingComponentWithLongestSequence",
            value: function b(a) {
                return a === this._getLongestSequenceComponentId();
            }
        },
        {
            key: "_getLongestSequenceComponentId",
            value: function a() {
                return this._longestSequenceComponentId;
            }
        },
        {
            key: "_recalculateLongestSequence",
            value: function d() {
                for(var e = this.getNewIterator(); e.next();){
                    var a = e.getComponent(), b = a.longestSequence, c = a.componentId;
                    b > this.getLongestSequence() && (this._longestSequenceComponentId = c, this._longestSequence = b);
                }
            }
        },
        {
            key: "_applyHardSequences",
            value: function c(a, b) {
                return $2a9dac5d897c361a$var$Configuration.option("enableHardSequences") ? Object.keys(b).reduce(function(_c, d) {
                    var e = !!a[d];
                    return !e && $2a9dac5d897c361a$var$KeyCombinationSerializer.isValidKeySerialization(d) && (_c.keyMap[d] = d), _c.handlers[d] = b[d], _c;
                }, {
                    keyMap: {},
                    handlers: {}
                }) : {
                    keyMap: a,
                    handlers: b
                };
            }
        },
        {
            key: "_buildActionDictionary",
            value: function e(a, b, c) {
                var d = this;
                return Object.keys(a).reduce(function(_e, f) {
                    var g = a[f], h = function() {
                        return $2a9dac5d897c361a$var$isObject(g) && $2a9dac5d897c361a$var$hasKey(g, "sequences") ? $2a9dac5d897c361a$var$arrayFrom(g.sequences) : $2a9dac5d897c361a$var$arrayFrom(g);
                    }();
                    return h.forEach(function(a) {
                        var g = $2a9dac5d897c361a$var$normalizeActionOptions(a, b), h = g.keySequence, i = g.keyEventType;
                        d._addActionOptions(_e, c, f, h, i);
                    }), _e;
                }, {});
            }
        },
        {
            key: "_addActionOptions",
            value: function i(a, b, c, d, e) {
                var f = $2a9dac5d897c361a$var$KeySequenceParser.parse(d, {
                    keyEventType: e
                }), g = f.sequence, h = f.combination;
                g.size > this.getLongestSequence() && (this._longestSequence = g.size, this._longestSequenceComponentId = b), this._keyMapEventRecord[e] = $2a9dac5d897c361a$var$KeyEventState.seen, a[c] || (a[c] = []), a[c].push($2a9dac5d897c361a$var$_objectSpread({
                    prefix: g.prefix,
                    actionName: c,
                    sequenceLength: g.size
                }, h));
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$normalizeActionOptions(a, b) {
    if ($2a9dac5d897c361a$var$isObject(a)) {
        var c = a.sequence, d = a.action;
        return {
            keySequence: c,
            keyEventType: $2a9dac5d897c361a$var$isUndefined(d) ? $2a9dac5d897c361a$var$KeyEventType[b.defaultKeyEvent] : $2a9dac5d897c361a$var$KeyEventType[d]
        };
    }
    return {
        keySequence: a,
        keyEventType: $2a9dac5d897c361a$var$KeyEventType[b.defaultKeyEvent]
    };
}
function $2a9dac5d897c361a$var$indexFromEnd(a, b) {
    return a[a.length - (b + 1)];
}
for(var $2a9dac5d897c361a$var$KeysWithKeyUpHiddenByCmd = {
    Enter: !0,
    Backspace: !0,
    ArrowRight: !0,
    ArrowLeft: !0,
    ArrowUp: !0,
    ArrowDown: !0,
    CapsLock: !0
}, $2a9dac5d897c361a$var$i = 1; 13 > $2a9dac5d897c361a$var$i; $2a9dac5d897c361a$var$i++)$2a9dac5d897c361a$var$KeysWithKeyUpHiddenByCmd["F".concat($2a9dac5d897c361a$var$i)] = !0;
function $2a9dac5d897c361a$var$keyupIsHiddenByCmd(a) {
    return 1 === a.length || $2a9dac5d897c361a$var$hasKey($2a9dac5d897c361a$var$KeysWithKeyUpHiddenByCmd, a);
}
var $2a9dac5d897c361a$var$KeyCombinationMatcher = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._actionConfigs = {}, this._order = null;
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "addMatch",
            value: function f(a, b) {
                if (this._includesMatcherForCombination(a.id)) {
                    var c = a.keyEventType, d = a.actionName, e = a.id;
                    this._addHandlerToActionConfig(e, {
                        keyEventType: c,
                        actionName: d,
                        handler: b
                    });
                } else this._addNewActionConfig(a, b);
            }
        },
        {
            key: "findMatch",
            value: function k(a, b, c) {
                this._order || this._setOrder();
                var d = !0, e = !1, f = void 0;
                try {
                    for(var g, h = this._order[Symbol.iterator](); !(d = (g = h.next()).done); d = !0){
                        var i = g.value, j = this._actionConfigs[i];
                        if (this._matchesActionConfig(a, b, c, j)) return j;
                    }
                } catch (a) {
                    e = !0, f = a;
                } finally{
                    try {
                        d || null == h.return || h.return();
                    } finally{
                        if (e) throw f;
                    }
                }
                return null;
            }
        },
        {
            key: "toJSON",
            value: function a() {
                return {
                    actionConfigs: this._actionConfigs,
                    order: this._order
                };
            }
        },
        {
            key: "_matchesActionConfig",
            value: function h(a, b, c, d) {
                if (!$2a9dac5d897c361a$var$canBeMatched(a, d)) return !1;
                var e = d.events[c];
                if (!e) return !1;
                var f = !1, g = Object.keys(d.keyDictionary).every(function(d) {
                    return !!a.isEventTriggered(d, c) && (b && b === a.getNormalizedKeyName(d) && (f = !a.wasEventPreviouslyTriggered(d, c)), !0);
                });
                return g && f;
            }
        },
        {
            key: "_setOrder",
            value: function b() {
                var a = Object.values(this._actionConfigs).reduce(function(a, b) {
                    var c = b.id, d = b.size;
                    return a[d] || (a[d] = []), a[d].push(c), a;
                }, {});
                this._order = Object.keys(a).sort(function(c, a) {
                    return a - c;
                }).reduce(function(_b, c) {
                    return _b.concat(a[c]);
                }, []);
            }
        },
        {
            key: "_addNewActionConfig",
            value: function j(a, b) {
                var c = a.prefix, d = a.sequenceLength, e = a.id, f = a.keyDictionary, g = a.size, h = a.keyEventType, i = a.actionName;
                this._setCombinationMatcher(e, {
                    prefix: c,
                    sequenceLength: d,
                    id: e,
                    keyDictionary: f,
                    size: g,
                    events: {}
                }), this._addHandlerToActionConfig(e, {
                    keyEventType: h,
                    actionName: i,
                    handler: b
                });
            }
        },
        {
            key: "_addHandlerToActionConfig",
            value: function g(a, b) {
                var c = b.keyEventType, d = b.actionName, e = b.handler, f = this._getCombinationMatcher(a);
                this._setCombinationMatcher(a, $2a9dac5d897c361a$var$_objectSpread({}, f, {
                    events: $2a9dac5d897c361a$var$_objectSpread({}, f.events, $2a9dac5d897c361a$var$_defineProperty({}, c, {
                        actionName: d,
                        handler: e
                    }))
                }));
            }
        },
        {
            key: "_setCombinationMatcher",
            value: function c(a, b) {
                this._actionConfigs[a] = b;
            }
        },
        {
            key: "_getCombinationMatcher",
            value: function b(a) {
                return this._actionConfigs[a];
            }
        },
        {
            key: "_includesMatcherForCombination",
            value: function b(a) {
                return !!this._getCombinationMatcher(a);
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$canBeMatched(a, b) {
    var c = $2a9dac5d897c361a$var$size(b.keyDictionary);
    return $2a9dac5d897c361a$var$Configuration.option("allowCombinationSubmatches") || $2a9dac5d897c361a$var$keyUpIsBeingHidden(a) ? a.getNumberOfKeys() >= c : a.getNumberOfKeys() === c;
}
function $2a9dac5d897c361a$var$keyUpIsBeingHidden(a) {
    return !!a.isKeyStillPressed("Meta") && a.some(function(a) {
        return $2a9dac5d897c361a$var$keyupIsHiddenByCmd(a);
    });
}
var $2a9dac5d897c361a$var$KeyHistoryMatcher = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._combinationMatchers = {}, this._eventRecord = $2a9dac5d897c361a$var$KeyEventStateArrayManager.newRecord();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "addMatch",
            value: function d(a, b) {
                var c = this._getOrCreateCombinationMatcher(a.prefix);
                c.addMatch(a, b), $2a9dac5d897c361a$var$KeyEventStateArrayManager.setBit(this._eventRecord, a.keyEventType, $2a9dac5d897c361a$var$KeyEventState.seen), (!this._longestSequence || this._longestSequence < a.sequenceLength) && (this._longestSequence = a.sequenceLength);
            }
        },
        {
            key: "findMatch",
            value: function e(a, b, c) {
                var d = this._findCombinationMatcher(a);
                return d ? d.findMatch(a.getCurrentCombination(), a.getCurrentCombination().getNormalizedKeyName(b), c) : null;
            }
        },
        {
            key: "hasMatchesForEventType",
            value: function b(a) {
                return !!this._eventRecord[a];
            }
        },
        {
            key: "getLongestSequence",
            value: function a() {
                return this._longestSequence;
            }
        },
        {
            key: "toJSON",
            value: function b() {
                var a = this;
                return Object.keys(this._combinationMatchers).reduce(function(_b, c) {
                    var d = a._combinationMatchers[c];
                    return _b[c] = d.toJSON(), _b;
                }, {});
            }
        },
        {
            key: "_getOrCreateCombinationMatcher",
            value: function b(a) {
                return this._combinationMatchers[a] || (this._combinationMatchers[a] = new $2a9dac5d897c361a$var$KeyCombinationMatcher), this._combinationMatchers[a];
            }
        },
        {
            key: "_findCombinationMatcher",
            value: function m(a) {
                var b = a.getMostRecentCombinations(this.getLongestSequence());
                if (0 === b.length) return this._combinationMatchers[""];
                for(var c = b.map(function(a) {
                    return a.getIds();
                }), d = c.map(function(a) {
                    return a.length;
                }), e = Array(c.length).fill(0), f = !1; !f;){
                    var g = e.map(function(a, b) {
                        return c[b][a];
                    }), h = g.join(" ");
                    if (this._combinationMatchers[h]) return this._combinationMatchers[h];
                    for(var i = 0, j = !0; j && i < e.length;){
                        var k = $2a9dac5d897c361a$var$indexFromEnd(e, i), l = (k + 1) % ($2a9dac5d897c361a$var$indexFromEnd(d, i) || 1);
                        e[e.length - (i + 1)] = l, j = 0 == l, j && i++;
                    }
                    f = i === e.length;
                }
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$ActionResolver = function() {
    function a(b) {
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._keyMapMatchers = [], this._unmatchedHandlerStatus = [], this._handlersDictionary = {}, this._keySequencesDictionary = {};
        for(var e = b.getNewIterator(); e.next();){
            var c = e.getComponent(), d = c.handlers;
            this._unmatchedHandlerStatus.push([
                Object.keys(d).length,
                {}
            ]), this._keyMapMatchers.push(new $2a9dac5d897c361a$var$KeyHistoryMatcher);
        }
        this._componentList = b, this._componentListIterator = b.getNewIterator();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getKeyHistoryMatcher",
            value: function b(a) {
                if (this._componentHasUnmatchedHandlers(a)) for(; this._componentListIterator.next();)this._addHandlersFromComponent(), this._addActionsFromComponent();
                return this._getKeyHistoryMatcher(a);
            }
        },
        {
            key: "componentHasActionsBoundToEventType",
            value: function c(a, b) {
                return this.getKeyHistoryMatcher(a).hasMatchesForEventType(b);
            }
        },
        {
            key: "findMatchingKeySequenceInComponent",
            value: function e(a, b, c, d) {
                return this.componentHasActionsBoundToEventType(a, d) ? this.getKeyHistoryMatcher(a).findMatch(b, c, d) : null;
            }
        },
        {
            key: "_getKeyHistoryMatcher",
            value: function b(a) {
                return this._keyMapMatchers[a];
            }
        },
        {
            key: "_addActionsFromComponent",
            value: function d() {
                var a = this, b = this._componentListIterator.getComponent(), c = b.actions;
                Object.keys(c).forEach(function(b) {
                    var d = a._getHandlers(b);
                    if (d) {
                        var e = d[0], f = a._componentList.getAtPosition(e).handlers[b], g = a._getKeyHistoryMatcher(e), h = c[b];
                        h.forEach(function(b) {
                            var c = [
                                b.prefix,
                                b.id
                            ].join(" ");
                            a._isClosestHandlerFound(c, b) || (g.addMatch(b, f), a._addKeySequence(c, [
                                e,
                                b.keyEventType
                            ]));
                        }), d.forEach(function(c) {
                            var d = a._getUnmatchedHandlerStatus(c);
                            d[1][b] || (d[1][b] = !0, d[0]--);
                        });
                    }
                });
            }
        },
        {
            key: "_getHandlers",
            value: function b(a) {
                return this._handlersDictionary[a];
            }
        },
        {
            key: "_addHandlersFromComponent",
            value: function d() {
                var a = this, b = this._componentListIterator.getComponent(), c = b.handlers;
                Object.keys(c).forEach(function(b) {
                    a._addHandler(b);
                });
            }
        },
        {
            key: "_addHandler",
            value: function b(a) {
                this._handlersDictionary[a] || (this._handlersDictionary[a] = []), this._handlersDictionary[a].push(this._componentListIterator.getPosition());
            }
        },
        {
            key: "_addKeySequence",
            value: function c(a, b) {
                this._keySequencesDictionary[a] || (this._keySequencesDictionary[a] = []), this._keySequencesDictionary[a].push(b);
            }
        },
        {
            key: "_componentHasUnmatchedHandlers",
            value: function b(a) {
                return 0 < this._getUnmatchedHandlerStatus(a)[0];
            }
        },
        {
            key: "_getUnmatchedHandlerStatus",
            value: function b(a) {
                return this._unmatchedHandlerStatus[a];
            }
        },
        {
            key: "_isClosestHandlerFound",
            value: function c(a, b) {
                return this._keySequencesDictionary[a] && this._keySequencesDictionary[a].some(function(a) {
                    return a[1] === b.keyEventType;
                });
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$copyAttributes(a, b, c) {
    return c.forEach(function(c) {
        $2a9dac5d897c361a$var$hasKey(a, c) && (b[c] = a[c]);
    }), b;
}
function $2a9dac5d897c361a$var$describeKeyEventType(a) {
    switch(parseInt(a, 10)){
        case 0:
            return "keydown";
        case 1:
            return "keypress";
        default:
            return "keyup";
    }
}
function $2a9dac5d897c361a$var$hasKeyPressEvent(a) {
    return !$2a9dac5d897c361a$var$isNonPrintableKeyName(a);
}
function $2a9dac5d897c361a$var$stateFromEvent(a) {
    return a.simulated ? $2a9dac5d897c361a$var$KeyEventState.simulated : $2a9dac5d897c361a$var$KeyEventState.seen;
}
var $2a9dac5d897c361a$var$SEQUENCE_ATTRIBUTES = [
    "sequence",
    "action"
], $2a9dac5d897c361a$var$KEYMAP_ATTRIBUTES = [
    "name",
    "description",
    "group"
], $2a9dac5d897c361a$var$AbstractKeyEventStrategy = function() {
    function a() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, c = 1 < arguments.length ? arguments[1] : void 0;
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this.logger = b.logger || new $2a9dac5d897c361a$var$Logger("warn"), this.componentId = -1, this.keyEventManager = c, this._componentTree = new $2a9dac5d897c361a$var$ComponentTree, this.rootComponentId = null, this._reset(), this.resetKeyHistory();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "_reset",
            value: function a() {
                this.componentList = new $2a9dac5d897c361a$var$ComponentOptionsList, this._initHandlerResolutionState();
            }
        },
        {
            key: "_newKeyHistory",
            value: function a() {
                return new $2a9dac5d897c361a$var$KeyHistory({
                    maxLength: this.componentList.getLongestSequence()
                });
            }
        },
        {
            key: "getKeyHistory",
            value: function a() {
                return this._keyHistory ? this._keyHistory : (this._keyHistory = this._newKeyHistory(), this._keyHistory);
            }
        },
        {
            key: "_initHandlerResolutionState",
            value: function a() {
                this._actionResolver = null;
            }
        },
        {
            key: "resetKeyHistory",
            value: function b() {
                var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                this.keypressEventsToSimulate = [], this.keyupEventsToSimulate = [], this._keyHistory = this.getKeyHistory().any() && !a.force ? new $2a9dac5d897c361a$var$KeyHistory({
                    maxLength: this.componentList.getLongestSequence()
                }, new $2a9dac5d897c361a$var$KeyCombination(this.getCurrentCombination().keysStillPressedDict())) : this._newKeyHistory();
            }
        },
        {
            key: "getApplicationKeyMap",
            value: function a() {
                return null === this.rootComponentId ? {} : this._buildApplicationKeyMap([
                    this.rootComponentId
                ], {});
            }
        },
        {
            key: "_buildApplicationKeyMap",
            value: function d(a, b) {
                var c = this;
                return a.forEach(function(a) {
                    var d = c._componentTree.get(a), e = d.childIds, f = d.keyMap;
                    f && Object.keys(f).forEach(function(a) {
                        var d = f[a];
                        b[a] = {}, $2a9dac5d897c361a$var$isObject(d) ? $2a9dac5d897c361a$var$hasKey(d, "sequences") ? ($2a9dac5d897c361a$var$copyAttributes(d, b[a], $2a9dac5d897c361a$var$KEYMAP_ATTRIBUTES), b[a].sequences = c._createSequenceFromConfig(d.sequences)) : ($2a9dac5d897c361a$var$copyAttributes(d, b[a], $2a9dac5d897c361a$var$KEYMAP_ATTRIBUTES), b[a].sequences = [
                            $2a9dac5d897c361a$var$copyAttributes(d, {}, $2a9dac5d897c361a$var$SEQUENCE_ATTRIBUTES)
                        ]) : b[a].sequences = c._createSequenceFromConfig(d);
                    }), c._buildApplicationKeyMap(e, b);
                }), b;
            }
        },
        {
            key: "_createSequenceFromConfig",
            value: function b(a) {
                return $2a9dac5d897c361a$var$arrayFrom(a).map(function(a) {
                    return $2a9dac5d897c361a$var$isObject(a) ? $2a9dac5d897c361a$var$copyAttributes(a, {}, $2a9dac5d897c361a$var$SEQUENCE_ATTRIBUTES) : {
                        sequence: a
                    };
                });
            }
        },
        {
            key: "registerKeyMap",
            value: function b(a) {
                return this.componentId += 1, this._componentTree.add(this.componentId, a), this.componentId;
            }
        },
        {
            key: "reregisterKeyMap",
            value: function c(a, b) {
                this._componentTree.update(a, b);
            }
        },
        {
            key: "registerComponentMount",
            value: function c(a, b) {
                $2a9dac5d897c361a$var$isUndefined(b) ? this.rootComponentId = a : this._componentTree.setParent(a, b);
            }
        },
        {
            key: "deregisterKeyMap",
            value: function b(a) {
                this._componentTree.remove(a), a === this.rootComponentId && (this.rootComponentId = null);
            }
        },
        {
            key: "_addComponent",
            value: function e(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0;
                this.componentList.add(a, b, c, d), this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence());
            }
        },
        {
            key: "_allKeysAreReleased",
            value: function a() {
                return this.getCurrentCombination().hasEnded();
            }
        },
        {
            key: "getCurrentCombination",
            value: function a() {
                return this.getKeyHistory().getCurrentCombination();
            }
        },
        {
            key: "_shouldSimulate",
            value: function e(a, b) {
                var c = $2a9dac5d897c361a$var$hasKeyPressEvent(b), d = this.getCurrentCombination();
                return a === $2a9dac5d897c361a$var$KeyEventType.keypress ? !c || c && d.isKeyStillPressed("Meta") : a === $2a9dac5d897c361a$var$KeyEventType.keyup && $2a9dac5d897c361a$var$keyupIsHiddenByCmd(b) && d.isKeyReleased("Meta");
            }
        },
        {
            key: "_cloneAndMergeEvent",
            value: function d(a, b) {
                var c = Object.keys($2a9dac5d897c361a$var$ModifierFlagsDictionary).reduce(function(b, c) {
                    return b[c] = a[c], b;
                }, {});
                return $2a9dac5d897c361a$var$_objectSpread({}, c, b);
            }
        },
        {
            key: "_callClosestMatchingHandler",
            value: function h(a, b, c, d, e) {
                for(this._actionResolver || (this._actionResolver = new $2a9dac5d897c361a$var$ActionResolver(this.componentList)); e <= d;){
                    var i = this._actionResolver.getKeyHistoryMatcher(e);
                    var f = this._actionResolver.findMatchingKeySequenceInComponent(e, this.getKeyHistory(), b, c), g = this.getCurrentCombination();
                    if (f) {
                        var j = f.events[c];
                        if ($2a9dac5d897c361a$var$Configuration.option("allowCombinationSubmatches")) var k = $2a9dac5d897c361a$var$KeyCombinationSerializer.serialize(f.keyDictionary);
                        return j.handler(a), this._stopEventPropagationAfterHandlingIfEnabled(a, e), !0;
                    }
                    this._actionResolver.componentHasActionsBoundToEventType(e, c);
                    e++;
                }
            }
        },
        {
            key: "_stopEventPropagationAfterHandlingIfEnabled",
            value: function c(a, b) {
                return !!$2a9dac5d897c361a$var$Configuration.option("stopEventPropagationAfterHandling") && (this._stopEventPropagation(a, b), !0);
            }
        },
        {
            key: "_stopEventPropagation",
            value: function a() {
                throw new Error("_stopEventPropagation must be overridden by a subclass");
            }
        },
        {
            key: "_checkForModifierFlagDiscrepancies",
            value: function e(a, b, c) {
                var d = this;
                Object.keys($2a9dac5d897c361a$var$ModifierFlagsDictionary).forEach(function(_e) {
                    if (b !== _e || c !== $2a9dac5d897c361a$var$KeyEventType.keyup) {
                        var f = d.getCurrentCombination(), g = f.isKeyStillPressed(_e);
                        $2a9dac5d897c361a$var$ModifierFlagsDictionary[_e].forEach(function(b) {
                            !1 === a[b] && g && f.setKeyState(_e, $2a9dac5d897c361a$var$KeyEventType.keyup, $2a9dac5d897c361a$var$stateFromEvent(a));
                        });
                    }
                });
            }
        },
        {
            key: "_logPrefix",
            value: function a() {}
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$KeyEventCounter = function() {
    function a() {
        $2a9dac5d897c361a$var$_classCallCheck(this, a);
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "getId",
            value: function a() {
                return $2a9dac5d897c361a$var$isUndefined(this._id) && (this._id = 0), this._id;
            }
        },
        {
            key: "incrementId",
            value: function a() {
                this._id = this.getId() + 1;
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$getEventCharCode(a) {
    var b, c = a.keyCode;
    return "charCode" in a ? (b = a.charCode, 0 === b && 13 === c && (b = 13)) : b = c, 10 === b && (b = 13), 32 <= b || 13 === b ? b : 0;
}
var $2a9dac5d897c361a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
};
function $2a9dac5d897c361a$var$reactsGetEventKey(a) {
    if (a.key) {
        var b = $2a9dac5d897c361a$var$normalizeKey[a.key] || a.key;
        if ("Unidentified" !== b) return b;
    }
    if ("keypress" === a.type) {
        var c = $2a9dac5d897c361a$var$getEventCharCode(a);
        return 13 === c ? "Enter" : String.fromCharCode(c);
    }
    return "keydown" === a.type || "keyup" === a.type ? $2a9dac5d897c361a$var$translateToKey[a.keyCode] || "Unidentified" : "";
}
function $2a9dac5d897c361a$var$getKeyName(a) {
    var b = function() {
        var b = $2a9dac5d897c361a$var$Configuration.option("customKeyCodes"), c = a.keyCode || a.charCode;
        return $2a9dac5d897c361a$var$hasKey(b, c) ? b[c] : a.nativeEvent ? a.key : $2a9dac5d897c361a$var$reactsGetEventKey(a);
    }();
    return "+" === b ? "plus" : b;
}
function $2a9dac5d897c361a$var$isCmdKey(a) {
    return "Meta" === a;
}
var $2a9dac5d897c361a$var$EventResponse = {
    unseen: 0,
    ignored: 1,
    seen: 2,
    recorded: 3,
    handled: 4
};
var $2a9dac5d897c361a$var$EventPropagator = function() {
    function a(b, c) {
        var d = c.logger, e = c.logPrefix;
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this._componentList = b, this._previousPropagation = null, this.logger = d, this._logPrefix = e, this._reset();
    }
    return $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "_reset",
            value: function a() {
                this._previousPosition = -1, this._position = -1, this._actionHandled = !1, this._ignoreEvent = !1, this._observeIgnoredEvents = !1, this._stopping = !1, this._componentId = null, this._key = null, this._type = null;
            }
        },
        {
            key: "isFirstPropagationStep",
            value: function b() {
                var a = this.getPreviousPosition();
                return -1 === a || a >= this._position;
            }
        },
        {
            key: "isForKey",
            value: function b(a) {
                return this._key === a;
            }
        },
        {
            key: "isForEventType",
            value: function b(a) {
                return this._type === a;
            }
        },
        {
            key: "startNewPropagationStep",
            value: function e(a, b, c, d) {
                return this._position = this._componentList.getIndexById(a), this._componentId = a, this.isFirstPropagationStep() && ($2a9dac5d897c361a$var$KeyEventCounter.incrementId(), this._key = b.key, this._type = d), !(b.repeat && $2a9dac5d897c361a$var$Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown")) || (this.ignoreEvent(b), !1);
            }
        },
        {
            key: "finishPropagationStep",
            value: function a() {
                this.isStopped() || this._componentList.isRoot(this._componentId) ? (this._previousPropagation = this._clone(), this._reset()) : this._previousPosition = this._position;
            }
        },
        {
            key: "getPreviousPropagation",
            value: function a() {
                return this._previousPropagation || (this._previousPropagation = this._clone({
                    copyState: !1
                })), this._previousPropagation;
            }
        },
        {
            key: "getPreviousPosition",
            value: function a() {
                return this._previousPosition;
            }
        },
        {
            key: "observeIgnoredEvents",
            value: function a() {
                this._observeIgnoredEvents = !0;
            }
        },
        {
            key: "ignoreEvent",
            value: function b(a) {
                return this.setIgnoreEvent(!0), !!(this.isIgnoringEvent() && $2a9dac5d897c361a$var$Configuration.option("stopEventPropagationAfterIgnoring")) && (this.stop(a), this.finishPropagationStep(), !0);
            }
        },
        {
            key: "setIgnoreEvent",
            value: function b(a) {
                this._ignoreEvent = a;
            }
        },
        {
            key: "isIgnoringEvent",
            value: function a() {
                return !this._observeIgnoredEvents && this._ignoreEvent;
            }
        },
        {
            key: "isStopped",
            value: function a() {
                return this._stopping;
            }
        },
        {
            key: "stop",
            value: function b(a) {
                return !this.isStopped() && (this._stopping = !0, a.simulated || a.stopPropagation(), !0);
            }
        },
        {
            key: "isPendingPropagation",
            value: function b() {
                var a = this.getPreviousPosition();
                return -1 !== a && a + 1 < this._position;
            }
        },
        {
            key: "isHandled",
            value: function a() {
                return this._actionHandled;
            }
        },
        {
            key: "setHandled",
            value: function a() {
                this._actionHandled = !0;
            }
        },
        {
            key: "_clone",
            value: function e() {
                var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, c = b.copyState, d = new a(this._componentList, {
                    logger: this.logger,
                    logPrefix: this._logPrefix
                });
                return (void 0 === c || c) && Object.assign(d, this), d;
            }
        }
    ]), a;
}();
var $2a9dac5d897c361a$var$FocusOnlyKeyEventStrategy = function(a) {
    function b() {
        var a, c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, d = 1 < arguments.length ? arguments[1] : void 0;
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), a = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).call(this, c, d)), a.focusTreeId = 0, a;
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "_reset",
            value: function a() {
                $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "_reset", this).call(this), this.keypressEventsToSimulate = [], this.focusTreeId += 1, this.eventPropagator = new $2a9dac5d897c361a$var$EventPropagator(this.componentList, {
                    logger: this.logger,
                    logPrefix: this._logPrefix.bind(this)
                });
            }
        },
        {
            key: "enableHotKeys",
            value: function e(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0;
                if (this.resetOnNextFocus && (this._reset(), this.resetOnNextFocus = !1), !this.componentList.containsId(a)) return this._addComponent(a, b, c, d), this.focusTreeId;
            }
        },
        {
            key: "updateEnabledHotKeys",
            value: function f(a, b) {
                var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}, e = 4 < arguments.length ? arguments[4] : void 0;
                a === this.focusTreeId && this.componentList.containsId(b) && (this.componentList.update(b, c, d, e), this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()), this._initHandlerResolutionState());
            }
        },
        {
            key: "disableHotKeys",
            value: function d(a, b) {
                this.resetOnNextFocus || (this.resetOnNextFocus = !0);
                var c = this.eventPropagator.isPendingPropagation();
                return c;
            }
        },
        {
            key: "handleKeydown",
            value: function j(a, b, c) {
                var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}, e = $2a9dac5d897c361a$var$getKeyName(a);
                if (b !== this.focusTreeId) return this.eventPropagator.ignoreEvent(a), !0;
                var f = this.eventPropagator.startNewPropagationStep(c, a, e, $2a9dac5d897c361a$var$KeyEventType.keydown);
                if (f) {
                    var g = this._howToHandleKeyEvent(a, b, c, e, d, $2a9dac5d897c361a$var$KeyEventType.keydown);
                    if (g === $2a9dac5d897c361a$var$EventResponse.handled) {
                        var h = $2a9dac5d897c361a$var$stateFromEvent(a), i = this.getCurrentCombination();
                        i.isKeyIncluded(e) || i.isEnding() ? this._startAndLogNewKeyCombination(e, b, c, h) : this._addToAndLogCurrentKeyCombination(e, $2a9dac5d897c361a$var$KeyEventType.keydown, b, c, h), this._callHandlerIfActionNotHandled(a, e, $2a9dac5d897c361a$var$KeyEventType.keydown, c, b);
                    }
                    return this._simulateKeyPressForNonPrintableKeys(a, e, b, c, d), this.eventPropagator.finishPropagationStep(), !1;
                }
            }
        },
        {
            key: "_howToHandleKeyEvent",
            value: function g(a, b, c, d, e, f) {
                if (this.eventPropagator.isFirstPropagationStep()) {
                    if (e.ignoreEventsCondition(a) && this.eventPropagator.ignoreEvent(a)) return this._eventIsToBeIgnored(a, c, d, f);
                    this._checkForModifierFlagDiscrepancies(a, d, f);
                } else if (this.eventPropagator.isIgnoringEvent()) return this._eventIsToBeIgnored(a, c, d, f);
                return $2a9dac5d897c361a$var$EventResponse.handled;
            }
        },
        {
            key: "_eventIsToBeIgnored",
            value: function e(a, b, c, d) {
                return $2a9dac5d897c361a$var$EventResponse.ignored;
            }
        },
        {
            key: "handleKeyPress",
            value: function j(a, b, c, d) {
                var e = $2a9dac5d897c361a$var$getKeyName(a), f = this.getCurrentCombination();
                if (f.isKeyPressSimulated(e)) return this.eventPropagator.ignoreEvent(a), !0;
                var g = this.eventPropagator.startNewPropagationStep(c, a, e, $2a9dac5d897c361a$var$KeyEventType.keypress);
                if (g) {
                    var h = b !== this.focusTreeId, i = this._howToHandleKeyEvent(a, b, c, e, d, $2a9dac5d897c361a$var$KeyEventType.keypress);
                    return this.eventPropagator.isFirstPropagationStep(c) && f.isKeyIncluded(e) && this._addToAndLogCurrentKeyCombination(e, $2a9dac5d897c361a$var$KeyEventType.keypress, b, c, $2a9dac5d897c361a$var$stateFromEvent(a)), i === $2a9dac5d897c361a$var$EventResponse.handled && this._callHandlerIfActionNotHandled(a, e, $2a9dac5d897c361a$var$KeyEventType.keypress, c, b), this.eventPropagator.finishPropagationStep(), h;
                }
            }
        },
        {
            key: "handleKeyUp",
            value: function j(a, b, c, d) {
                var e = $2a9dac5d897c361a$var$getKeyName(a), f = this.getCurrentCombination();
                if (f.isKeyUpSimulated(e)) return this.eventPropagator.ignoreEvent(a), !0;
                var g = this.eventPropagator.startNewPropagationStep(c, a, e, $2a9dac5d897c361a$var$KeyEventType.keyup);
                if (g) {
                    var h = b !== this.focusTreeId, i = this._howToHandleKeyEvent(a, b, c, e, d, $2a9dac5d897c361a$var$KeyEventType.keyup);
                    return this.eventPropagator.isFirstPropagationStep(c) && f.isKeyIncluded(e) && this._addToAndLogCurrentKeyCombination(e, $2a9dac5d897c361a$var$KeyEventType.keyup, b, c, $2a9dac5d897c361a$var$stateFromEvent(a)), i === $2a9dac5d897c361a$var$EventResponse.handled && this._callHandlerIfActionNotHandled(a, e, $2a9dac5d897c361a$var$KeyEventType.keyup, c, b), this._simulateKeyUpEventsHiddenByCmd(a, e, b, c, d), this.eventPropagator.finishPropagationStep(), h;
                }
            }
        },
        {
            key: "closeHangingKeyCombination",
            value: function d(a, b) {
                var c = this.getCurrentCombination();
                c.isKeyIncluded(a) && !c.isEventTriggered(a, b) && c.setKeyState(a, b, $2a9dac5d897c361a$var$KeyEventState.simulated);
            }
        },
        {
            key: "_simulateKeyPressForNonPrintableKeys",
            value: function f(a, b, c, d, e) {
                this._handleEventSimulation("keypressEventsToSimulate", "simulatePendingKeyPressEvents", this._shouldSimulate($2a9dac5d897c361a$var$KeyEventType.keypress, b), {
                    event: a,
                    key: b,
                    focusTreeId: c,
                    componentId: d,
                    options: e
                });
            }
        },
        {
            key: "_simulateKeyUpEventsHiddenByCmd",
            value: function g(a, b, c, d, e) {
                var f = this;
                $2a9dac5d897c361a$var$isCmdKey(b) && this.getCurrentCombination().forEachKey(function(b) {
                    $2a9dac5d897c361a$var$isCmdKey(b) || f._handleEventSimulation("keyupEventsToSimulate", "simulatePendingKeyUpEvents", f._shouldSimulate($2a9dac5d897c361a$var$KeyEventType.keyup, b), {
                        event: a,
                        key: b,
                        focusTreeId: c,
                        componentId: d,
                        options: e
                    });
                });
            }
        },
        {
            key: "_stopEventPropagation",
            value: function c(a, b) {
                this.eventPropagator.stop(a);
            }
        },
        {
            key: "getEventPropagator",
            value: function a() {
                return this.eventPropagator;
            }
        },
        {
            key: "_startAndLogNewKeyCombination",
            value: function e(a, b, c, d) {
                this.getKeyHistory().startNewKeyCombination(a, d);
            }
        },
        {
            key: "_addToAndLogCurrentKeyCombination",
            value: function f(a, b, c, d, e) {
                this.getKeyHistory().addKeyToCurrentCombination(a, b, e);
            }
        },
        {
            key: "_handleEventSimulation",
            value: function j(a, b, c, d) {
                var e = d.event, f = d.key, g = d.focusTreeId, h = d.componentId, i = d.options;
                if (c && $2a9dac5d897c361a$var$Configuration.option("simulateMissingKeyPressEvents")) {
                    var k = this._cloneAndMergeEvent(e, {
                        key: f,
                        simulated: !0
                    });
                    this[a].push({
                        event: k,
                        focusTreeId: g,
                        componentId: h,
                        options: i
                    });
                }
                (this.componentList.isRoot(h) || this.eventPropagator.isStopped()) && !this.keyEventManager.isGlobalListenersBound() && this[b]();
            }
        },
        {
            key: "simulatePendingKeyPressEvents",
            value: function a() {
                this._simulatePendingKeyEvents("keypressEventsToSimulate", "handleKeyPress");
            }
        },
        {
            key: "simulatePendingKeyUpEvents",
            value: function a() {
                this._simulatePendingKeyEvents("keyupEventsToSimulate", "handleKeyUp");
            }
        },
        {
            key: "_simulatePendingKeyEvents",
            value: function d(a, b) {
                var c = this;
                0 < this[a].length && $2a9dac5d897c361a$var$KeyEventCounter.incrementId(), this[a].forEach(function(a) {
                    var d = a.event, e = a.focusTreeId, f = a.componentId, g = a.options;
                    c[b](d, e, f, g);
                }), this[a] = [];
            }
        },
        {
            key: "_callHandlerIfActionNotHandled",
            value: function k(a, b, c, d, e) {
                var g = this.getCurrentCombination().describe();
                if (!this.componentList.anyActionsForEventType(c)) return void 0;
                if (this.eventPropagator.isHandled()) ;
                else {
                    var h = this.eventPropagator.getPreviousPosition(), i = this.componentList.getIndexById(d), j = this._callClosestMatchingHandler(a, b, c, i, -1 === h ? 0 : h);
                    j && this.eventPropagator.setHandled();
                }
            }
        },
        {
            key: "_logPrefix",
            value: function h(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = $2a9dac5d897c361a$var$Logger.logIcons, d = $2a9dac5d897c361a$var$Logger.eventIcons, e = $2a9dac5d897c361a$var$Logger.componentIcons, f = "HotKeys (";
                if (!1 !== b.focusTreeId) {
                    var i = $2a9dac5d897c361a$var$isUndefined(b.focusTreeId) ? this.focusTreeId : b.focusTreeId;
                    f += "F".concat(i).concat(c[i % c.length], "-");
                }
                if (!1 !== b.eventId) {
                    var j = $2a9dac5d897c361a$var$isUndefined(b.eventId) ? $2a9dac5d897c361a$var$KeyEventCounter.getId() : b.eventId;
                    f += "E".concat(j).concat(d[j % d.length], "-");
                }
                f += "C".concat(a).concat(e[a % e.length]);
                var g = this.componentList.getIndexById(a);
                return $2a9dac5d897c361a$var$isUndefined(g) || (f += "-P".concat(g).concat(e[g % e.length], ":")), "".concat(f, ")");
            }
        }
    ]), b;
}($2a9dac5d897c361a$var$AbstractKeyEventStrategy);
function $2a9dac5d897c361a$var$contains(a, b) {
    var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {};
    return Array.isArray(a) || $2a9dac5d897c361a$var$isString(a) ? c.stringifyFirst ? !$2a9dac5d897c361a$var$isUndefined(a.find(function(a) {
        return a.toString() === b.toString();
    })) : -1 !== a.indexOf(b) : $2a9dac5d897c361a$var$isObject(a) ? $2a9dac5d897c361a$var$hasKey(a, b) : c.stringifyFirst ? a.toString() === b.toString() : a === b;
}
function $2a9dac5d897c361a$var$capitalize(a) {
    return a.replace(/\b\w/g, function(a) {
        return a.toUpperCase();
    });
}
function $2a9dac5d897c361a$var$normalizeEventName(a) {
    return "".concat($2a9dac5d897c361a$var$capitalize(a.slice(0, 3))).concat($2a9dac5d897c361a$var$capitalize(a.slice(3)));
}
var $2a9dac5d897c361a$var$GlobalKeyEventStrategy = function(a) {
    function b() {
        var a, c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, d = 1 < arguments.length ? arguments[1] : void 0;
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), a = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).call(this, c, d)), a.listenersBound = !1, a.eventOptions = {
            ignoreEventsCondition: $2a9dac5d897c361a$var$Configuration.option("ignoreEventsCondition")
        }, a.listeners = {}, a;
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "enableHotKeys",
            value: function f(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0, e = 4 < arguments.length ? arguments[4] : void 0;
                this.eventOptions = e, this._addComponent(a, b, c, d), this._updateDocumentHandlers(), this._initHandlerResolutionState();
            }
        },
        {
            key: "updateEnabledHotKeys",
            value: function f(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0, e = 4 < arguments.length ? arguments[4] : void 0;
                this.eventOptions = e, this.componentList.update(a, b, c, d), this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()), this._updateDocumentHandlers(), this._initHandlerResolutionState();
            }
        },
        {
            key: "disableHotKeys",
            value: function b(a) {
                this.componentList.remove(a), this.getKeyHistory().setMaxLength(this.componentList.getLongestSequence()), this._updateDocumentHandlers(), this._initHandlerResolutionState();
            }
        },
        {
            key: "_updateDocumentHandlers",
            value: function c() {
                var a = this, b = this._listenersShouldBeBound();
                !this.listenersBound && b ? (Object.values($2a9dac5d897c361a$var$KeyEventType).forEach(function(b) {
                    var c = $2a9dac5d897c361a$var$describeKeyEventType(b);
                    document["on".concat(c)] = function(b) {
                        a.keyEventManager["handleGlobal".concat($2a9dac5d897c361a$var$normalizeEventName(c))](b);
                    };
                }), this.listenersBound = !0) : this.listenersBound && !b && (Object.values($2a9dac5d897c361a$var$KeyEventType).forEach(function(b) {
                    var c = $2a9dac5d897c361a$var$describeKeyEventType(b);
                    delete document["on".concat(c)];
                }), this.listenersBound = !1);
            }
        },
        {
            key: "_listenersShouldBeBound",
            value: function a() {
                return this.componentList.any() || this.listeners.keyCombination;
            }
        },
        {
            key: "handleKeydown",
            value: function f(a) {
                var b = $2a9dac5d897c361a$var$getKeyName(a);
                if (a.repeat && $2a9dac5d897c361a$var$Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown")) return !0;
                this._checkForModifierFlagDiscrepancies(a, b, $2a9dac5d897c361a$var$KeyEventType.keydown);
                var c = this._howReactAppRespondedTo(a, b, $2a9dac5d897c361a$var$KeyEventType.keydown);
                if (c === $2a9dac5d897c361a$var$EventResponse.unseen && this.eventOptions.ignoreEventsCondition(a)) return void 0;
                if (c !== $2a9dac5d897c361a$var$EventResponse.ignored) {
                    var d = $2a9dac5d897c361a$var$stateFromEvent(a), e = this.getCurrentCombination();
                    e.isKeyIncluded(b) || e.isEnding() ? this._startAndLogNewKeyCombination(b, d) : this._addToAndLogCurrentKeyCombination(b, $2a9dac5d897c361a$var$KeyEventType.keydown, d);
                }
                $2a9dac5d897c361a$var$contains([
                    $2a9dac5d897c361a$var$EventResponse.ignored,
                    $2a9dac5d897c361a$var$EventResponse.handled
                ], c) || this._callHandlerIfExists(a, b, $2a9dac5d897c361a$var$KeyEventType.keydown), this._simulateKeyPressForNonPrintableKeys(a, b);
            }
        },
        {
            key: "_howReactAppRespondedTo",
            value: function e(a, b, c) {
                var d = this.keyEventManager.reactAppHistoryWithEvent(b, c);
                return d === $2a9dac5d897c361a$var$EventResponse.handled || d === $2a9dac5d897c361a$var$EventResponse.ignored || d === $2a9dac5d897c361a$var$EventResponse.seen || $2a9dac5d897c361a$var$KeyEventCounter.incrementId(), d;
            }
        },
        {
            key: "handleKeyPress",
            value: function e(a) {
                var b = $2a9dac5d897c361a$var$getKeyName(a);
                if (a.repeat && $2a9dac5d897c361a$var$Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown")) return !0;
                var c = this.getCurrentCombination();
                if (c.isKeyPressSimulated(b)) return !0;
                var d = this._howReactAppRespondedTo(a, b, $2a9dac5d897c361a$var$KeyEventType.keypress);
                return c.isKeyIncluded(b) && this._addToAndLogCurrentKeyCombination(b, $2a9dac5d897c361a$var$KeyEventType.keypress, $2a9dac5d897c361a$var$stateFromEvent(a)), d === $2a9dac5d897c361a$var$EventResponse.unseen && (this.keyEventManager.closeHangingKeyCombination(b, $2a9dac5d897c361a$var$KeyEventType.keypress), this.eventOptions.ignoreEventsCondition(a)) ? void 0 : void (!$2a9dac5d897c361a$var$contains([
                    $2a9dac5d897c361a$var$EventResponse.ignored,
                    $2a9dac5d897c361a$var$EventResponse.handled
                ], d) && this._callHandlerIfExists(a, b, $2a9dac5d897c361a$var$KeyEventType.keypress));
            }
        },
        {
            key: "handleKeyUp",
            value: function e(a) {
                var b = $2a9dac5d897c361a$var$getKeyName(a), c = this.getCurrentCombination();
                if (c.isKeyUpSimulated(b)) return !0;
                var d = this._howReactAppRespondedTo(a, b, $2a9dac5d897c361a$var$KeyEventType.keyup);
                c.isKeyIncluded(b) && this._addToAndLogCurrentKeyCombination(b, $2a9dac5d897c361a$var$KeyEventType.keyup, $2a9dac5d897c361a$var$stateFromEvent(a)), d === $2a9dac5d897c361a$var$EventResponse.unseen ? (this.keyEventManager.closeHangingKeyCombination(b, $2a9dac5d897c361a$var$KeyEventType.keyup), this.eventOptions.ignoreEventsCondition(a) || !$2a9dac5d897c361a$var$contains([
                    $2a9dac5d897c361a$var$EventResponse.ignored,
                    $2a9dac5d897c361a$var$EventResponse.handled
                ], d) && this._callHandlerIfExists(a, b, $2a9dac5d897c361a$var$KeyEventType.keyup)) : !$2a9dac5d897c361a$var$contains([
                    $2a9dac5d897c361a$var$EventResponse.ignored,
                    $2a9dac5d897c361a$var$EventResponse.handled
                ], d) && this._callHandlerIfExists(a, b, $2a9dac5d897c361a$var$KeyEventType.keyup), this._simulateKeyUpEventsHiddenByCmd(a, b), this.listeners.keyCombination && this._allKeysAreReleased() && this.listeners.keyCombination({
                    keys: c.getKeyDictionary(),
                    id: c.describe()
                });
            }
        },
        {
            key: "_simulateKeyPressForNonPrintableKeys",
            value: function c(a, b) {
                this.keyEventManager.simulatePendingKeyPressEvents(), this._handleEventSimulation("handleKeyPress", this._shouldSimulate($2a9dac5d897c361a$var$KeyEventType.keypress, b), {
                    event: a,
                    key: b
                });
            }
        },
        {
            key: "_simulateKeyUpEventsHiddenByCmd",
            value: function d(a, b) {
                var c = this;
                $2a9dac5d897c361a$var$isCmdKey(b) && (this.keyEventManager.simulatePendingKeyUpEvents(), this.getCurrentCombination().forEachKey(function(b) {
                    $2a9dac5d897c361a$var$isCmdKey(b) || c._handleEventSimulation("handleKeyUp", c._shouldSimulate($2a9dac5d897c361a$var$KeyEventType.keyup, b), {
                        event: a,
                        key: b
                    });
                }));
            }
        },
        {
            key: "_startAndLogNewKeyCombination",
            value: function c(a, b) {
                this.getKeyHistory().startNewKeyCombination(a, b);
            }
        },
        {
            key: "_addToAndLogCurrentKeyCombination",
            value: function d(a, b, c) {
                this.getKeyHistory().addKeyToCurrentCombination(a, b, c);
            }
        },
        {
            key: "_handleEventSimulation",
            value: function f(a, b, c) {
                var d = c.event, e = c.key;
                if (b && $2a9dac5d897c361a$var$Configuration.option("simulateMissingKeyPressEvents")) {
                    var g = this._cloneAndMergeEvent(d, {
                        key: e,
                        simulated: !0
                    });
                    this[a](g);
                }
            }
        },
        {
            key: "_callHandlerIfExists",
            value: function f(a, b, c) {
                var e = this.getCurrentCombination().describe();
                return this.componentList.anyActionsForEventType(c) ? void this._callClosestMatchingHandler(a, b, c) : void 0;
            }
        },
        {
            key: "_callClosestMatchingHandler",
            value: function e(a, c, d) {
                for(var f, g = this.componentList.getNewIterator(); g.next();)if (f = $2a9dac5d897c361a$var$_get($2a9dac5d897c361a$var$_getPrototypeOf(b.prototype), "_callClosestMatchingHandler", this).call(this, a, c, d, g.getPosition(), 0), f) return void 0;
            }
        },
        {
            key: "_stopEventPropagation",
            value: function c(a, b) {
                a.simulated || a.stopPropagation();
            }
        },
        {
            key: "addKeyCombinationListener",
            value: function d(a) {
                var b = this, c = function() {
                    delete b.listeners.keyCombination;
                };
                return this.listeners.keyCombination = function(b) {
                    a(b), c();
                }, this._updateDocumentHandlers(), c;
            }
        },
        {
            key: "_logPrefix",
            value: function f(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = $2a9dac5d897c361a$var$Logger.eventIcons, d = $2a9dac5d897c361a$var$Logger.componentIcons, e = "HotKeys (GLOBAL";
                if (!1 !== b.eventId) {
                    var g = $2a9dac5d897c361a$var$isUndefined(b.eventId) ? $2a9dac5d897c361a$var$KeyEventCounter.getId() : b.eventId;
                    e = "".concat(e, "-E").concat(g).concat(c[g % c.length]);
                }
                return $2a9dac5d897c361a$var$isUndefined(a) ? "".concat(e, "):") : "".concat(e, "-C").concat(a).concat(d[a % d.length], "):");
            }
        }
    ]), b;
}($2a9dac5d897c361a$var$AbstractKeyEventStrategy);
function $2a9dac5d897c361a$var$isFromFocusOnlyComponent(a) {
    return !$2a9dac5d897c361a$var$isUndefined(a);
}
var $2a9dac5d897c361a$var$KeyEventManager = function() {
    function a() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        $2a9dac5d897c361a$var$_classCallCheck(this, a), this.logger = b.logger || new $2a9dac5d897c361a$var$Logger($2a9dac5d897c361a$var$Configuration.option("logLevel")), this._focusOnlyEventStrategy = new $2a9dac5d897c361a$var$FocusOnlyKeyEventStrategy({
            configuration: b,
            logger: this.logger
        }, this), this._globalEventStrategy = new $2a9dac5d897c361a$var$GlobalKeyEventStrategy({
            configuration: b,
            logger: this.logger
        }, this), this.mountedComponentsCount = 0;
    }
    return $2a9dac5d897c361a$var$_createClass(a, null, [
        {
            key: "getInstance",
            value: function c() {
                var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                return this.instance || (this.instance = new a(b)), this.instance;
            }
        },
        {
            key: "clear",
            value: function a() {
                delete this.instance;
            }
        }
    ]), $2a9dac5d897c361a$var$_createClass(a, [
        {
            key: "getApplicationKeyMap",
            value: function a() {
                return Object.assign(this._globalEventStrategy.getApplicationKeyMap(), this._focusOnlyEventStrategy.getApplicationKeyMap());
            }
        },
        {
            key: "registerKeyMap",
            value: function b() {
                var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                return this._focusOnlyEventStrategy.registerKeyMap(a);
            }
        },
        {
            key: "reregisterKeyMap",
            value: function c(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                this._focusOnlyEventStrategy.reregisterKeyMap(a, b);
            }
        },
        {
            key: "deregisterKeyMap",
            value: function b(a) {
                this._focusOnlyEventStrategy.deregisterKeyMap(a);
            }
        },
        {
            key: "registerComponentMount",
            value: function c(a, b) {
                return this._incrementComponentCount(), this._focusOnlyEventStrategy.registerComponentMount(a, b);
            }
        },
        {
            key: "registerComponentUnmount",
            value: function a() {
                this._decrementComponentCount();
            }
        },
        {
            key: "_incrementComponentCount",
            value: function c() {
                var a = this, b = this.mountedComponentsCount;
                this.mountedComponentsCount += 1, 0 === b && 1 === this.mountedComponentsCount && (window.onblur = function() {
                    return a._clearKeyHistory();
                });
            }
        },
        {
            key: "_decrementComponentCount",
            value: function b() {
                var a = this.mountedComponentsCount;
                this.mountedComponentsCount -= 1, 1 === a && 0 === this.mountedComponentsCount && delete window.onblur;
            }
        },
        {
            key: "_clearKeyHistory",
            value: function a() {
                this._focusOnlyEventStrategy.resetKeyHistory({
                    force: !0
                }), this._globalEventStrategy.resetKeyHistory({
                    force: !0
                });
            }
        },
        {
            key: "registerGlobalKeyMap",
            value: function b() {
                var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                return this._globalEventStrategy.registerKeyMap(a);
            }
        },
        {
            key: "registerGlobalComponentUnmount",
            value: function a() {
                this._decrementComponentCount();
            }
        },
        {
            key: "registerGlobalComponentMount",
            value: function c(a, b) {
                return this._incrementComponentCount(), this._globalEventStrategy.registerComponentMount(a, b);
            }
        },
        {
            key: "reregisterGlobalKeyMap",
            value: function c(a, b) {
                this._globalEventStrategy.reregisterKeyMap(a, b);
            }
        },
        {
            key: "deregisterGlobalKeyMap",
            value: function b(a) {
                this._globalEventStrategy.deregisterKeyMap(a);
            }
        },
        {
            key: "addKeyCombinationListener",
            value: function b(a) {
                return this._globalEventStrategy.addKeyCombinationListener(a);
            }
        },
        {
            key: "enableHotKeys",
            value: function e(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0;
                return this._focusOnlyEventStrategy.enableHotKeys(a, b, c, d);
            }
        },
        {
            key: "updateEnabledHotKeys",
            value: function f(a, b) {
                var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}, e = 4 < arguments.length ? arguments[4] : void 0;
                return this._focusOnlyEventStrategy.updateEnabledHotKeys(a, b, c, d, e);
            }
        },
        {
            key: "disableHotKeys",
            value: function c(a, b) {
                return this._focusOnlyEventStrategy.disableHotKeys(a, b);
            }
        },
        {
            key: "handleKeydown",
            value: function e(a, b, c, d) {
                if ($2a9dac5d897c361a$var$isFromFocusOnlyComponent(b)) return this._focusOnlyEventStrategy.handleKeydown(a, b, c, d);
            }
        },
        {
            key: "handleKeyPress",
            value: function e(a, b, c, d) {
                if ($2a9dac5d897c361a$var$isFromFocusOnlyComponent(b)) return this._focusOnlyEventStrategy.handleKeyPress(a, b, c, d);
            }
        },
        {
            key: "handleKeyUp",
            value: function e(a, b, c, d) {
                if ($2a9dac5d897c361a$var$isFromFocusOnlyComponent(b)) return this._focusOnlyEventStrategy.handleKeyUp(a, b, c, d);
            }
        },
        {
            key: "enableGlobalHotKeys",
            value: function f(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0, e = 4 < arguments.length ? arguments[4] : void 0;
                return this._globalEventStrategy.enableHotKeys(a, b, c, d, e);
            }
        },
        {
            key: "updateEnabledGlobalHotKeys",
            value: function f(a) {
                var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, d = 3 < arguments.length ? arguments[3] : void 0, e = 4 < arguments.length ? arguments[4] : void 0;
                return this._globalEventStrategy.updateEnabledHotKeys(a, b, c, d, e);
            }
        },
        {
            key: "disableGlobalHotKeys",
            value: function b(a) {
                return this._globalEventStrategy.disableHotKeys(a);
            }
        },
        {
            key: "handleGlobalKeyDown",
            value: function b(a) {
                return this._globalEventStrategy.handleKeydown(a);
            }
        },
        {
            key: "handleGlobalKeyPress",
            value: function b(a) {
                return this._globalEventStrategy.handleKeyPress(a);
            }
        },
        {
            key: "handleGlobalKeyUp",
            value: function b(a) {
                return this._globalEventStrategy.handleKeyUp(a);
            }
        },
        {
            key: "ignoreEvent",
            value: function b(a) {
                this._focusOnlyEventStrategy.getEventPropagator().ignoreEvent(a);
            }
        },
        {
            key: "observeIgnoredEvents",
            value: function b(a) {
                this._focusOnlyEventStrategy.getEventPropagator().observeIgnoredEvents(a);
            }
        },
        {
            key: "closeHangingKeyCombination",
            value: function c(a, b) {
                this._focusOnlyEventStrategy.closeHangingKeyCombination(a, b);
            }
        },
        {
            key: "reactAppHistoryWithEvent",
            value: function d(a, b) {
                var c = this._focusOnlyEventStrategy.eventPropagator.getPreviousPropagation();
                return c.isForKey(a) && c.isForEventType(b) ? c.isHandled() ? $2a9dac5d897c361a$var$EventResponse.handled : c.isIgnoringEvent() ? $2a9dac5d897c361a$var$EventResponse.ignored : $2a9dac5d897c361a$var$EventResponse.seen : $2a9dac5d897c361a$var$EventResponse.unseen;
            }
        },
        {
            key: "simulatePendingKeyPressEvents",
            value: function a() {
                this._focusOnlyEventStrategy.simulatePendingKeyPressEvents();
            }
        },
        {
            key: "simulatePendingKeyUpEvents",
            value: function a() {
                this._focusOnlyEventStrategy.simulatePendingKeyUpEvents();
            }
        },
        {
            key: "isGlobalListenersBound",
            value: function a() {
                return this._globalEventStrategy.listenersBound;
            }
        }
    ]), a;
}();
function $2a9dac5d897c361a$var$backwardsCompatibleContext(a, b) {
    var c = b.deprecatedAPI, d = c.contextTypes, e = c.childContextTypes, f = b.newAPI.contextType;
    if ("undefined" == typeof (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext) a.contextTypes = d, a.childContextTypes = e, a.prototype.getChildContext = function() {
        return this._childContext;
    };
    else {
        var g = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext(f);
        a.contextType = g, a.prototype._originalRender = a.prototype.render, a.prototype.render = function() {
            var a = this._originalRender();
            return a ? (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(g.Provider, {
                value: this._childContext
            }, a) : null;
        };
    }
    return a;
}
function $2a9dac5d897c361a$export$78c5b43741a51568(a) {
    function b(a, b) {
        return $2a9dac5d897c361a$var$_objectSpread({}, e[a] || {}, b[a] || {});
    }
    function c(a) {
        return b("handlers", a);
    }
    function d(a) {
        return b("keyMap", a);
    }
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, f = function(b) {
        function e(a) {
            var b;
            return $2a9dac5d897c361a$var$_classCallCheck(this, e), b = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(e).call(this, a)), b._handleFocus = b._handleFocus.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._handleBlur = b._handleBlur.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._handleKeyDown = b._handleKeyDown.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._handleKeyPress = b._handleKeyPress.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._handleKeyUp = b._handleKeyUp.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._componentIsFocused = b._componentIsFocused.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._id = $2a9dac5d897c361a$var$KeyEventManager.getInstance().registerKeyMap(a.keyMap), b._childContext = {
                hotKeysParentId: b._id
            }, b;
        }
        return $2a9dac5d897c361a$var$_inherits(e, b), $2a9dac5d897c361a$var$_createClass(e, [
            {
                key: "render",
                value: function i() {
                    var b = this.props, c = b.keyMap, d = b.handlers, e = b.allowChanges, f = b.root, g = $2a9dac5d897c361a$var$_objectWithoutProperties(b, [
                        "keyMap",
                        "handlers",
                        "allowChanges",
                        "root"
                    ]), h = {
                        onFocus: this._wrapFunction("onFocus", this._handleFocus),
                        onBlur: this._wrapFunction("onBlur", this._handleBlur),
                        tabIndex: $2a9dac5d897c361a$var$Configuration.option("defaultTabIndex")
                    };
                    return this._shouldBindKeyListeners() && (h.onKeyDown = this._handleKeyDown, h.onKeyPress = this._handleKeyPress, h.onKeyUp = this._handleKeyUp), (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(a, $2a9dac5d897c361a$var$_extends({
                        hotKeys: h
                    }, g));
                }
            },
            {
                key: "_shouldBindKeyListeners",
                value: function b() {
                    var a = d(this.props);
                    return !$2a9dac5d897c361a$var$isEmpty(a) || this.props.root || $2a9dac5d897c361a$var$Configuration.option("enableHardSequences") && this._handlersIncludeHardSequences(a, c(this.props));
                }
            },
            {
                key: "_handlersIncludeHardSequences",
                value: function c(a, b) {
                    return Object.keys(b).some(function(b) {
                        return !a[b] && $2a9dac5d897c361a$var$KeyCombinationSerializer.isValidKeySerialization(b);
                    });
                }
            },
            {
                key: "_wrapFunction",
                value: function d(a, b) {
                    var c = this;
                    return "function" == typeof this.props[a] ? function(_d) {
                        c.props[a](_d), b(_d);
                    } : b;
                }
            },
            {
                key: "_focusTreeIdsPush",
                value: function b(a) {
                    this._focusTreeIds || (this._focusTreeIds = []), this._focusTreeIds.push(a);
                }
            },
            {
                key: "_focusTreeIdsShift",
                value: function a() {
                    this._focusTreeIds && this._focusTreeIds.shift();
                }
            },
            {
                key: "_getFocusTreeId",
                value: function a() {
                    if (this._focusTreeIds) return this._focusTreeIds[0];
                }
            },
            {
                key: "componentDidUpdate",
                value: function e() {
                    var a = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
                    if (a.reregisterKeyMap(this._id, this.props.keyMap), this._componentIsFocused() && (this.props.allowChanges || !$2a9dac5d897c361a$var$Configuration.option("ignoreKeymapAndHandlerChangesByDefault"))) {
                        var b = this.props, c = b.keyMap, d = b.handlers;
                        a.updateEnabledHotKeys(this._getFocusTreeId(), this._id, c, d, this._getComponentOptions());
                    }
                }
            },
            {
                key: "_componentIsFocused",
                value: function a() {
                    return !0 === this._focused;
                }
            },
            {
                key: "componentDidMount",
                value: function c() {
                    var a = $2a9dac5d897c361a$var$KeyEventManager.getInstance(), b = this.context.hotKeysParentId;
                    a.registerComponentMount(this._id, b);
                }
            },
            {
                key: "_handleFocus",
                value: function e() {
                    if (this.props.onFocus) {
                        var a;
                        (a = this.props).onFocus.apply(a, arguments);
                    }
                    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance().enableHotKeys(this._id, d(this.props), c(this.props), this._getComponentOptions());
                    $2a9dac5d897c361a$var$isUndefined(b) || this._focusTreeIdsPush(b), this._focused = !0;
                }
            },
            {
                key: "componentWillUnmount",
                value: function b() {
                    var a = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
                    a.deregisterKeyMap(this._id), a.registerComponentUnmount(), this._handleBlur();
                }
            },
            {
                key: "_handleBlur",
                value: function c() {
                    if (this.props.onBlur) {
                        var a;
                        (a = this.props).onBlur.apply(a, arguments);
                    }
                    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance().disableHotKeys(this._getFocusTreeId(), this._id);
                    b || this._focusTreeIdsShift(), this._focused = !1;
                }
            },
            {
                key: "_handleKeyDown",
                value: function c(a) {
                    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance().handleKeydown(a, this._getFocusTreeId(), this._id, this._getEventOptions());
                    b && this._focusTreeIdsShift();
                }
            },
            {
                key: "_handleKeyPress",
                value: function c(a) {
                    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance().handleKeyPress(a, this._getFocusTreeId(), this._id, this._getEventOptions());
                    b && this._focusTreeIdsShift();
                }
            },
            {
                key: "_handleKeyUp",
                value: function c(a) {
                    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance().handleKeyUp(a, this._getFocusTreeId(), this._id, this._getEventOptions());
                    b && this._focusTreeIdsShift();
                }
            },
            {
                key: "_getComponentOptions",
                value: function a() {
                    return {
                        defaultKeyEvent: $2a9dac5d897c361a$var$Configuration.option("defaultKeyEvent")
                    };
                }
            },
            {
                key: "_getEventOptions",
                value: function a() {
                    return {
                        ignoreEventsCondition: $2a9dac5d897c361a$var$Configuration.option("ignoreEventsCondition")
                    };
                }
            }
        ]), e;
    }((0, $1bxDW.PureComponent));
    return $2a9dac5d897c361a$var$_defineProperty(f, "propTypes", {
        keyMap: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object,
        handlers: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object,
        onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).func,
        onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).func,
        allowChanges: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).bool,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).bool
    }), $2a9dac5d897c361a$var$backwardsCompatibleContext(f, {
        deprecatedAPI: {
            contextTypes: {
                hotKeysParentId: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number
            },
            childContextTypes: {
                hotKeysParentId: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number
            }
        },
        newAPI: {
            contextType: {
                hotKeysParentId: void 0
            }
        }
    });
}
var $2a9dac5d897c361a$var$HotKeysWrapper = function(a) {
    function b() {
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).apply(this, arguments));
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "render",
            value: function g() {
                var a = this.props, b = a.hotKeys, c = a.innerRef, d = a.component, e = $2a9dac5d897c361a$var$_objectWithoutProperties(a, [
                    "hotKeys",
                    "innerRef",
                    "component"
                ]), f = d || $2a9dac5d897c361a$var$Configuration.option("defaultComponent");
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(f, $2a9dac5d897c361a$var$_objectSpread({}, b, {
                    ref: c
                }, e));
            }
        }
    ]), b;
}((0, $1bxDW.Component)), $2a9dac5d897c361a$export$17ad26dab665ba34 = $2a9dac5d897c361a$export$78c5b43741a51568($2a9dac5d897c361a$var$HotKeysWrapper);
$2a9dac5d897c361a$export$17ad26dab665ba34.propTypes = {
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).func
    ])
};
var $2a9dac5d897c361a$var$GlobalHotKeys = function(a) {
    function b(a) {
        var c;
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), c = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).call(this, a)), c._id = $2a9dac5d897c361a$var$KeyEventManager.getInstance().registerGlobalKeyMap(a.keyMap), c._childContext = {
            globalHotKeysParentId: c._id
        }, c;
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "render",
            value: function a() {
                return this.props.children || null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function e() {
                var a = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
                if (a.reregisterGlobalKeyMap(this._id, this.props.keyMap), this.props.allowChanges || !$2a9dac5d897c361a$var$Configuration.option("ignoreKeymapAndHandlerChangesByDefault")) {
                    var b = this.props, c = b.keyMap, d = b.handlers;
                    a.updateEnabledGlobalHotKeys(this._id, c, d, this._getComponentOptions(), this._getEventOptions());
                }
            }
        },
        {
            key: "componentDidMount",
            value: function f() {
                var a = this.props, b = a.keyMap, c = a.handlers, d = this.context.globalHotKeysParentId, e = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
                e.registerGlobalComponentMount(this._id, d), e.enableGlobalHotKeys(this._id, b, c, this._getComponentOptions(), this._getEventOptions());
            }
        },
        {
            key: "componentWillUnmount",
            value: function b() {
                var a = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
                a.deregisterGlobalKeyMap(this._id), a.disableGlobalHotKeys(this._id), a.registerGlobalComponentUnmount();
            }
        },
        {
            key: "_getComponentOptions",
            value: function a() {
                return {
                    defaultKeyEvent: $2a9dac5d897c361a$var$Configuration.option("defaultKeyEvent")
                };
            }
        },
        {
            key: "_getEventOptions",
            value: function a() {
                return {
                    ignoreEventsCondition: $2a9dac5d897c361a$var$Configuration.option("ignoreEventsCondition")
                };
            }
        }
    ]), b;
}((0, $1bxDW.Component));
$2a9dac5d897c361a$var$_defineProperty($2a9dac5d897c361a$var$GlobalHotKeys, "propTypes", {
    keyMap: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object,
    handlers: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object,
    allowChanges: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).bool
});
var $2a9dac5d897c361a$export$7652690506c04eee = $2a9dac5d897c361a$var$backwardsCompatibleContext($2a9dac5d897c361a$var$GlobalHotKeys, {
    deprecatedAPI: {
        contextTypes: {
            globalHotKeysParentId: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number
        },
        childContextTypes: {
            globalHotKeysParentId: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number
        }
    },
    newAPI: {
        contextType: {
            globalHotKeysParentId: void 0
        }
    }
});
function $2a9dac5d897c361a$var$withHotKeysIgnoreOverride(a) {
    var b, c, d = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {
        only: [],
        except: []
    }, e = 2 < arguments.length ? arguments[2] : void 0;
    return c = b = function(b) {
        function c(a) {
            var b;
            return $2a9dac5d897c361a$var$_classCallCheck(this, c), b = $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(c).call(this, a)), b._handleKeyEvent = b._handleKeyEvent.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b._reloadDictionaries = b._reloadDictionaries.bind($2a9dac5d897c361a$var$_assertThisInitialized($2a9dac5d897c361a$var$_assertThisInitialized(b))), b;
        }
        return $2a9dac5d897c361a$var$_inherits(c, b), $2a9dac5d897c361a$var$_createClass(c, [
            {
                key: "render",
                value: function g() {
                    var b = this.props, c = b.only, d = b.except, e = $2a9dac5d897c361a$var$_objectWithoutProperties(b, [
                        "only",
                        "except"
                    ]), f = {
                        onKeyDown: this._handleKeyEvent,
                        onKeyPress: this._handleKeyEvent,
                        onKeyUp: this._handleKeyEvent,
                        onFocus: this._reloadDictionaries
                    };
                    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(a, $2a9dac5d897c361a$var$_extends({
                        hotKeys: f
                    }, e));
                }
            },
            {
                key: "_reloadDictionaries",
                value: function d() {
                    var a = this.props, b = a.only, c = a.except;
                    this._onlyDict = $2a9dac5d897c361a$var$keyDictionary(b), this._exceptDict = $2a9dac5d897c361a$var$keyDictionary(c);
                }
            },
            {
                key: "_shouldIgnoreEvent",
                value: function c(a) {
                    var b = a.key;
                    return $2a9dac5d897c361a$var$isEmpty(this._onlyDict) ? !!$2a9dac5d897c361a$var$isEmpty(this._exceptDict) || !$2a9dac5d897c361a$var$hasKey(this._exceptDict, b) : $2a9dac5d897c361a$var$isEmpty(this._exceptDict) ? $2a9dac5d897c361a$var$hasKey(this._onlyDict, b) : $2a9dac5d897c361a$var$hasKey(this._onlyDict, b) && !$2a9dac5d897c361a$var$hasKey(this._exceptDict, b);
                }
            },
            {
                key: "_handleKeyEvent",
                value: function b(a) {
                    this._shouldIgnoreEvent(a) && $2a9dac5d897c361a$var$KeyEventManager.getInstance()[e](a);
                }
            }
        ]), c;
    }((0, $1bxDW.PureComponent)), $2a9dac5d897c361a$var$_defineProperty(b, "propTypes", {
        only: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).string)
        ]),
        except: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).string)
        ])
    }), $2a9dac5d897c361a$var$_defineProperty(b, "defaultProps", d), c;
}
function $2a9dac5d897c361a$var$keyDictionary(a) {
    return $2a9dac5d897c361a$var$arrayFrom(a).reduce(function(a, b) {
        var c = $2a9dac5d897c361a$var$standardizeKeyName(b);
        if (!$2a9dac5d897c361a$var$isValidKey(c)) throw new $2a9dac5d897c361a$var$InvalidKeyNameError(b);
        return [
            $2a9dac5d897c361a$var$resolveAltShiftedAlias,
            $2a9dac5d897c361a$var$resolveUnaltShiftedAlias,
            $2a9dac5d897c361a$var$resolveShiftedAlias,
            $2a9dac5d897c361a$var$resolveUnshiftedAlias,
            $2a9dac5d897c361a$var$resolveAltedAlias,
            $2a9dac5d897c361a$var$resolveUnaltedAlias
        ].forEach(function(b) {
            a[b(c)] = !0;
        }), a;
    }, {});
}
var $2a9dac5d897c361a$var$IgnoreKeys = function(a) {
    function b() {
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).apply(this, arguments));
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "render",
            value: function e() {
                var a = this.props, b = a.hotKeys, c = $2a9dac5d897c361a$var$_objectWithoutProperties(a, [
                    "hotKeys"
                ]), d = c.component || $2a9dac5d897c361a$var$Configuration.option("defaultComponent");
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(d, $2a9dac5d897c361a$var$_objectSpread({}, b, c));
            }
        }
    ]), b;
}((0, $1bxDW.Component));
var $2a9dac5d897c361a$export$afa62f5ff9d30976 = $2a9dac5d897c361a$var$withHotKeysIgnoreOverride($2a9dac5d897c361a$var$IgnoreKeys, {}, "ignoreEvent");
var $2a9dac5d897c361a$var$ObserveKeys = function(a) {
    function b() {
        return $2a9dac5d897c361a$var$_classCallCheck(this, b), $2a9dac5d897c361a$var$_possibleConstructorReturn(this, $2a9dac5d897c361a$var$_getPrototypeOf(b).apply(this, arguments));
    }
    return $2a9dac5d897c361a$var$_inherits(b, a), $2a9dac5d897c361a$var$_createClass(b, [
        {
            key: "render",
            value: function e() {
                var a = this.props, b = a.hotKeys, c = $2a9dac5d897c361a$var$_objectWithoutProperties(a, [
                    "hotKeys"
                ]), d = c.component || $2a9dac5d897c361a$var$Configuration.option("defaultComponent");
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(d, $2a9dac5d897c361a$var$_objectSpread({}, b, c));
            }
        }
    ]), b;
}((0, $1bxDW.Component));
var $2a9dac5d897c361a$export$d6b93397957fdfae = $2a9dac5d897c361a$var$withHotKeysIgnoreOverride($2a9dac5d897c361a$var$ObserveKeys, {}, "observeIgnoredEvents");
function $2a9dac5d897c361a$export$5dd986d2ecb36864(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {
        only: [],
        except: []
    };
    return $2a9dac5d897c361a$var$withHotKeysIgnoreOverride(a, b, "ignoreEvent");
}
function $2a9dac5d897c361a$export$24098f02422ef0fd(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {
        only: [],
        except: []
    };
    return $2a9dac5d897c361a$var$withHotKeysIgnoreOverride(a, b, "observeIgnoredEvents");
}
function $2a9dac5d897c361a$export$8d21e34596265fa2() {
    var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    $2a9dac5d897c361a$var$Configuration.init(a);
}
function $2a9dac5d897c361a$export$d6fde881824c0060() {
    return $2a9dac5d897c361a$var$KeyEventManager.getInstance().getApplicationKeyMap();
}
function $2a9dac5d897c361a$export$ce83784ab2f84e89(a) {
    var b = $2a9dac5d897c361a$var$KeyEventManager.getInstance();
    return b.addKeyCombinationListener(a);
}

});

var $3864665696b41b22$exports = {};
$parcel$extendImportMap({
    "gJ1S1": "Landing.992226d5.js",
    "iGwMF": "organice.bfae1489.svg",
    "8tMmL": "screenshot-overview.3dbd476c.png",
    "cINkH": "screenshot-wide.d91d13f9.png",
    "20IY9": "bootstrap.bundle.min.60c2768d.js",
    "bYHEY": "all.min.34578c99.js",
    "505mw": "Landing.78150761.css",
    "i2fkr": "Metropolis-Thin.a2a87781.otf",
    "ggWWf": "Metropolis-ThinItalic.93b613eb.otf",
    "6sDIa": "Metropolis-ExtraLight.0263a1f2.otf",
    "aho4t": "Metropolis-ExtraLightItalic.0fc2c5f3.otf",
    "gvVjc": "Metropolis-Light.c17b47ee.otf",
    "4Y8F1": "Metropolis-LightItalic.a4278872.otf",
    "hCZ95": "Metropolis-Regular.75f206b3.otf",
    "lGu5p": "Metropolis-RegularItalic.1907d12e.otf",
    "5WDMr": "Metropolis-Medium.e65c5c57.otf",
    "ckSbP": "Metropolis-MediumItalic.dfca069e.otf",
    "hTvHx": "Metropolis-SemiBold.040bc3a3.otf",
    "lreN6": "Metropolis-SemiBoldItalic.9d80cbb9.otf",
    "jtyvt": "Metropolis-Bold.eba6d7cc.otf",
    "jntw5": "Metropolis-BoldItalic.a21325b5.otf",
    "lEmKR": "Metropolis-ExtraBold.ca9018c3.otf",
    "2fJTO": "Metropolis-ExtraBoldItalic.c7aadc6a.otf",
    "6ELuC": "Metropolis-Black.ff27d05a.otf",
    "fPZPf": "Metropolis-BlackItalic.fb6c9f19.otf",
    "edQdo": "dropbox.798441f6.svg",
    "gd84Y": "gitlab.32819d90.svg"
});

/* global module */ 
var $1bxDW = parcelRequire("1bxDW");
var $c63f56900e1488fc$exports = {};
'use strict';
function $c63f56900e1488fc$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c63f56900e1488fc$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c63f56900e1488fc$var$checkDCE();

$c63f56900e1488fc$exports = (parcelRequire("3y7YU"));





var $1bxDW = parcelRequire("1bxDW");

var $1bxDW = parcelRequire("1bxDW");
parcelRequire("7dzZ9");

var $1bxDW = parcelRequire("1bxDW");
var $668e8ea1a8dc4392$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext(null);
var $668e8ea1a8dc4392$export$2e2bcd8739ae039 = $668e8ea1a8dc4392$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $b731bdf3703ebdc8$var$defaultNoopBatch(callback) {
    callback();
}
var $b731bdf3703ebdc8$var$batch = $b731bdf3703ebdc8$var$defaultNoopBatch; // Allow injecting another batching function later
var $b731bdf3703ebdc8$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $b731bdf3703ebdc8$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $b731bdf3703ebdc8$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $b731bdf3703ebdc8$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var $9fc4ce3e6c783f10$var$nullListeners = {
    notify: function notify() {}
};
function $9fc4ce3e6c783f10$var$createListenerCollection() {
    var batch = (0, $b731bdf3703ebdc8$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $9fc4ce3e6c783f10$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscription(store, parentSub) {
        this.store = store;
        this.parentSub = parentSub;
        this.unsubscribe = null;
        this.listeners = $9fc4ce3e6c783f10$var$nullListeners;
        this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
    }
    var _proto = Subscription.prototype;
    _proto.addNestedSub = function addNestedSub(listener) {
        this.trySubscribe();
        return this.listeners.subscribe(listener);
    };
    _proto.notifyNestedSubs = function notifyNestedSubs() {
        this.listeners.notify();
    };
    _proto.handleChangeWrapper = function handleChangeWrapper() {
        if (this.onStateChange) this.onStateChange();
    };
    _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.unsubscribe);
    };
    _proto.trySubscribe = function trySubscribe() {
        if (!this.unsubscribe) {
            this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
            this.listeners = $9fc4ce3e6c783f10$var$createListenerCollection();
        }
    };
    _proto.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.listeners.clear();
            this.listeners = $9fc4ce3e6c783f10$var$nullListeners;
        }
    };
    return Subscription;
}();


function $10bb4a4d86cc6e39$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $1bxDW.useMemo)(function() {
        var subscription = new (0, $9fc4ce3e6c783f10$export$2e2bcd8739ae039)(store);
        subscription.onStateChange = subscription.notifyNestedSubs;
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $1bxDW.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $1bxDW.useEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $10bb4a4d86cc6e39$export$2e2bcd8739ae039 = $10bb4a4d86cc6e39$var$Provider;



var $kabSK = parcelRequire("kabSK");

var $1rbX6 = parcelRequire("1rbX6");

var $Sjkfs = parcelRequire("Sjkfs");

var $1bxDW = parcelRequire("1bxDW");

var $aI3q1 = parcelRequire("aI3q1");


var $1bxDW = parcelRequire("1bxDW");
var $0e4d3c7a7715ecdd$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $1bxDW.useLayoutEffect) : (0, $1bxDW.useEffect);



var $4b9e68ee872acbbf$var$EMPTY_ARRAY = [];
var $4b9e68ee872acbbf$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $4b9e68ee872acbbf$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $4b9e68ee872acbbf$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $4b9e68ee872acbbf$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $0e4d3c7a7715ecdd$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $4b9e68ee872acbbf$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $4b9e68ee872acbbf$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $4b9e68ee872acbbf$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $4b9e68ee872acbbf$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $1rbX6.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kabSK.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $1bxDW.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $1bxDW.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $1rbX6.default)(props, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $1bxDW.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $aI3q1.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $1bxDW.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $1bxDW.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $1bxDW.useMemo)(function() {
                if (!shouldHandleStateChanges) return $4b9e68ee872acbbf$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = new (0, $9fc4ce3e6c783f10$export$2e2bcd8739ae039)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $1bxDW.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kabSK.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $1bxDW.useReducer)($4b9e68ee872acbbf$var$storeStateUpdatesReducer, $4b9e68ee872acbbf$var$EMPTY_ARRAY, $4b9e68ee872acbbf$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $1bxDW.useRef)();
            var lastWrapperProps = (0, $1bxDW.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $1bxDW.useRef)();
            var renderIsScheduled = (0, $1bxDW.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $4b9e68ee872acbbf$var$useIsomorphicLayoutEffectWithArgs($4b9e68ee872acbbf$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $4b9e68ee872acbbf$var$useIsomorphicLayoutEffectWithArgs($4b9e68ee872acbbf$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $1bxDW.useMemo)(function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(WrappedComponent, (0, $kabSK.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $1bxDW.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(Connect, (0, $kabSK.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($Sjkfs)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($Sjkfs)))(Connect, WrappedComponent);
    };
}




var $kabSK = parcelRequire("kabSK");

var $1rbX6 = parcelRequire("1rbX6");

function $984355d9caeeb14b$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $984355d9caeeb14b$export$2e2bcd8739ae039(objA, objB) {
    if ($984355d9caeeb14b$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$984355d9caeeb14b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $8fd703cdeb22caeb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8fd703cdeb22caeb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fd703cdeb22caeb$export$2e2bcd8739ae039(o);
}



function $20474b3dc10bccbb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8fd703cdeb22caeb$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8fd703cdeb22caeb$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $765fec9ba745650a$export$2e2bcd8739ae039(t) {
    var i = (0, $20474b3dc10bccbb$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $8fd703cdeb22caeb$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $00a00a0abd9a584e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $765fec9ba745650a$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $16ab1b6720598e40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16ab1b6720598e40$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16ab1b6720598e40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $00a00a0abd9a584e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16ab1b6720598e40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $7bd5d83317c8c48a$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $7bd5d83317c8c48a$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $7bd5d83317c8c48a$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $7bd5d83317c8c48a$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $7bd5d83317c8c48a$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $7bd5d83317c8c48a$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $7bd5d83317c8c48a$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $7bd5d83317c8c48a$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
function $7bd5d83317c8c48a$var$kindOf(val) {
    var typeOfVal = typeof val;
    var miniKindOf, ctorName, isError, isDate;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $7bd5d83317c8c48a$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(1));
        return enhancer($7bd5d83317c8c48a$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$7bd5d83317c8c48a$var$isPlainObject(action)) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $7bd5d83317c8c48a$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$7bd5d83317c8c48a$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $7bd5d83317c8c48a$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$7bd5d83317c8c48a$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7bd5d83317c8c48a$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $7bd5d83317c8c48a$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $7bd5d83317c8c48a$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$7bd5d83317c8c48a$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $7bd5d83317c8c48a$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $7bd5d83317c8c48a$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $7bd5d83317c8c48a$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $7bd5d83317c8c48a$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $7bd5d83317c8c48a$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $7bd5d83317c8c48a$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $7bd5d83317c8c48a$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $7bd5d83317c8c48a$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $7bd5d83317c8c48a$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $7bd5d83317c8c48a$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $7bd5d83317c8c48a$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $7bd5d83317c8c48a$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $7bd5d83317c8c48a$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($7bd5d83317c8c48a$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $7bd5d83317c8c48a$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $16ab1b6720598e40$export$2e2bcd8739ae039)((0, $16ab1b6720598e40$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $7bd5d83317c8c48a$var$isCrushed() {}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $4ddd763435bdd4da$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $c17cf108c45c8030$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $2ac69ad2508f8850$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $4ddd763435bdd4da$export$2e2bcd8739ae039)(value)) (0, $c17cf108c45c8030$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $b08c3ea1bf1036a0$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $b08c3ea1bf1036a0$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $b08c3ea1bf1036a0$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b08c3ea1bf1036a0$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b08c3ea1bf1036a0$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $cd4a39932c7eaea4$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $b08c3ea1bf1036a0$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $cd4a39932c7eaea4$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $b08c3ea1bf1036a0$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $cd4a39932c7eaea4$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $b08c3ea1bf1036a0$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $7bd5d83317c8c48a$export$aea084d96e84da92)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $cd4a39932c7eaea4$export$2e2bcd8739ae039 = [
    $cd4a39932c7eaea4$export$a9f27b4b187c1166,
    $cd4a39932c7eaea4$export$ba20d1a7aa0c4a90,
    $cd4a39932c7eaea4$export$94a6e55709d4d961
];



function $477cbdc32a727b70$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $b08c3ea1bf1036a0$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $477cbdc32a727b70$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $b08c3ea1bf1036a0$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $477cbdc32a727b70$export$2e2bcd8739ae039 = [
    $477cbdc32a727b70$export$23fc470827b14aa,
    $477cbdc32a727b70$export$514bc8c1a53c1d66
];



var $kabSK = parcelRequire("kabSK");

function $aab4e56d0d9e83c4$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kabSK.default)({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function $aab4e56d0d9e83c4$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $aab4e56d0d9e83c4$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $aab4e56d0d9e83c4$export$5b105939c84b5234(mergeProps) : undefined;
}
function $aab4e56d0d9e83c4$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $aab4e56d0d9e83c4$export$691c327fc30bc857;
    } : undefined;
}
var $aab4e56d0d9e83c4$export$2e2bcd8739ae039 = [
    $aab4e56d0d9e83c4$export$d61b680184bc3f00,
    $aab4e56d0d9e83c4$export$a13ba70ef50dda6d
];



var $1rbX6 = parcelRequire("1rbX6");

function $b703d41e045df092$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $c17cf108c45c8030$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $b703d41e045df092$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $b703d41e045df092$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $b703d41e045df092$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $b703d41e045df092$var$verify(mergeProps, 'mergeProps', displayName);
}


function $da997de27a9f0614$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $da997de27a9f0614$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $da997de27a9f0614$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1rbX6.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $da997de27a9f0614$export$d20c0c2ca6eb2b6f : $da997de27a9f0614$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $3437c6fbf7b3faa7$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $3437c6fbf7b3faa7$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $3437c6fbf7b3faa7$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $4b9e68ee872acbbf$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $477cbdc32a727b70$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $cd4a39932c7eaea4$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $aab4e56d0d9e83c4$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $da997de27a9f0614$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $3437c6fbf7b3faa7$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $984355d9caeeb14b$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $984355d9caeeb14b$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $984355d9caeeb14b$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $1rbX6.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $3437c6fbf7b3faa7$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $3437c6fbf7b3faa7$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $3437c6fbf7b3faa7$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kabSK.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $3437c6fbf7b3faa7$export$2e2bcd8739ae039 = /*#__PURE__*/ $3437c6fbf7b3faa7$export$9f9feb656dec1fc4();




var $1bxDW = parcelRequire("1bxDW");


var $1bxDW = parcelRequire("1bxDW");

function $154e14e93cce4b20$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $1bxDW.useContext)((0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00));
    return contextValue;
}


function $519827293984fb6c$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00) ? (0, $154e14e93cce4b20$export$c1275ca9a6fd3ec5) : function() {
        return (0, $1bxDW.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $519827293984fb6c$export$6ccbb43953eebf8 = /*#__PURE__*/ $519827293984fb6c$export$671dba69185d0304();


function $3046378a5fefb10b$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00);
    var useStore = context === (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00) ? (0, $519827293984fb6c$export$6ccbb43953eebf8) : (0, $519827293984fb6c$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $3046378a5fefb10b$export$8ad76b76a4c905f8 = /*#__PURE__*/ $3046378a5fefb10b$export$bc9b55530897c558();



var $1bxDW = parcelRequire("1bxDW");




var $b7b90b00e04e051d$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $b7b90b00e04e051d$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $1bxDW.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $1bxDW.useMemo)(function() {
        return new (0, $9fc4ce3e6c783f10$export$2e2bcd8739ae039)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $1bxDW.useRef)();
    var latestSelector = (0, $1bxDW.useRef)();
    var latestStoreState = (0, $1bxDW.useRef)();
    var latestSelectedState = (0, $1bxDW.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) selectedState = selector(storeState);
        else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $0e4d3c7a7715ecdd$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $0e4d3c7a7715ecdd$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newSelectedState = latestSelector.current(store.getState());
                if (equalityFn(newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = newSelectedState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $b7b90b00e04e051d$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $668e8ea1a8dc4392$export$cc80c08dc91f1c00) ? (0, $154e14e93cce4b20$export$c1275ca9a6fd3ec5) : function() {
        return (0, $1bxDW.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $b7b90b00e04e051d$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $b7b90b00e04e051d$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $1bxDW.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $b7b90b00e04e051d$export$2105062e25df4afe = /*#__PURE__*/ $b7b90b00e04e051d$export$2b53f90d2bd1cbfb();




/* eslint-disable import/no-unresolved */ 



(0, $b731bdf3703ebdc8$export$4b9874722d0da7bc)((0, $c63f56900e1488fc$exports.unstable_batchedUpdates));



function $edf878fa3d3304da$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === 'function') return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $edf878fa3d3304da$var$thunk = $edf878fa3d3304da$var$createThunkMiddleware();
$edf878fa3d3304da$var$thunk.withExtraArgument = $edf878fa3d3304da$var$createThunkMiddleware;
var $edf878fa3d3304da$export$2e2bcd8739ae039 = $edf878fa3d3304da$var$thunk;


var $d81b80734fbc24a5$exports = {};

$parcel$export($d81b80734fbc24a5$exports, "parseFile", function () { return $d81b80734fbc24a5$export$f1c553d4f1a2351; });
$parcel$export($d81b80734fbc24a5$exports, "setOpennessState", function () { return $d81b80734fbc24a5$export$2d7d9f027d8bca74; });
$parcel$export($d81b80734fbc24a5$exports, "applyOpennessState", function () { return $d81b80734fbc24a5$export$74920e52f4af75df; });
$parcel$export($d81b80734fbc24a5$exports, "setLastSyncAt", function () { return $d81b80734fbc24a5$export$881bc3db7e40e575; });
$parcel$export($d81b80734fbc24a5$exports, "resetFileDisplay", function () { return $d81b80734fbc24a5$export$407c99dd8b6a5a6a; });
$parcel$export($d81b80734fbc24a5$exports, "widenHeader", function () { return $d81b80734fbc24a5$export$47fc6071254828da; });
$parcel$export($d81b80734fbc24a5$exports, "setPath", function () { return $d81b80734fbc24a5$export$1518ffc4a8ff94f2; });
$parcel$export($d81b80734fbc24a5$exports, "sync", function () { return $d81b80734fbc24a5$export$92d6409d68f0739a; });
$parcel$export($d81b80734fbc24a5$exports, "setOrgFileErrorMessage", function () { return $d81b80734fbc24a5$export$efc903f8ecc96b3d; });
$parcel$export($d81b80734fbc24a5$exports, "setDirty", function () { return $d81b80734fbc24a5$export$4447eddabc434410; });
$parcel$export($d81b80734fbc24a5$exports, "openHeader", function () { return $d81b80734fbc24a5$export$218961f78e7bc84e; });
$parcel$export($d81b80734fbc24a5$exports, "toggleHeaderOpened", function () { return $d81b80734fbc24a5$export$fa3ffca728e28c38; });
$parcel$export($d81b80734fbc24a5$exports, "selectHeader", function () { return $d81b80734fbc24a5$export$e0565e6fdebf8d2b; });
$parcel$export($d81b80734fbc24a5$exports, "setSelectedTableCellId", function () { return $d81b80734fbc24a5$export$e87683d26142c4fd; });
$parcel$export($d81b80734fbc24a5$exports, "setSelectedListItemId", function () { return $d81b80734fbc24a5$export$fd3fcc6c88d51a7d; });
$parcel$export($d81b80734fbc24a5$exports, "selectHeaderIndex", function () { return $d81b80734fbc24a5$export$f8eb2c0ccbbccbe1; });
$parcel$export($d81b80734fbc24a5$exports, "selectHeaderAndOpenParents", function () { return $d81b80734fbc24a5$export$a3eec7d6030b01df; });
$parcel$export($d81b80734fbc24a5$exports, "advanceTodoState", function () { return $d81b80734fbc24a5$export$d52a65249001b444; });
$parcel$export($d81b80734fbc24a5$exports, "setTodoState", function () { return $d81b80734fbc24a5$export$716d4b6fabec4e3a; });
$parcel$export($d81b80734fbc24a5$exports, "enterEditMode", function () { return $d81b80734fbc24a5$export$99a5c3ae2a16e7ed; });
$parcel$export($d81b80734fbc24a5$exports, "exitEditMode", function () { return $d81b80734fbc24a5$export$6104e3b4c48e4d36; });
$parcel$export($d81b80734fbc24a5$exports, "updateHeaderTitle", function () { return $d81b80734fbc24a5$export$8f4602b7cb85c3f6; });
$parcel$export($d81b80734fbc24a5$exports, "updateHeaderDescription", function () { return $d81b80734fbc24a5$export$40feb5309281ae20; });
$parcel$export($d81b80734fbc24a5$exports, "addHeader", function () { return $d81b80734fbc24a5$export$31d7f72bcc5bd8c8; });
$parcel$export($d81b80734fbc24a5$exports, "duplicateHeader", function () { return $d81b80734fbc24a5$export$618125dd560d6333; });
$parcel$export($d81b80734fbc24a5$exports, "createFirstHeader", function () { return $d81b80734fbc24a5$export$8b0d9a2124129ba7; });
$parcel$export($d81b80734fbc24a5$exports, "selectNextSiblingHeader", function () { return $d81b80734fbc24a5$export$b8295a7771533d34; });
$parcel$export($d81b80734fbc24a5$exports, "addHeaderAndEdit", function () { return $d81b80734fbc24a5$export$8132ad4391eb7de0; });
$parcel$export($d81b80734fbc24a5$exports, "selectNextVisibleHeader", function () { return $d81b80734fbc24a5$export$12e044de4c61a8c2; });
$parcel$export($d81b80734fbc24a5$exports, "selectPreviousVisibleHeader", function () { return $d81b80734fbc24a5$export$6e9ab9c1bead507a; });
$parcel$export($d81b80734fbc24a5$exports, "removeHeader", function () { return $d81b80734fbc24a5$export$d1dd841af70fe4d3; });
$parcel$export($d81b80734fbc24a5$exports, "moveHeaderUp", function () { return $d81b80734fbc24a5$export$79a81da0eac4bec9; });
$parcel$export($d81b80734fbc24a5$exports, "moveHeaderDown", function () { return $d81b80734fbc24a5$export$50662492c2b94a52; });
$parcel$export($d81b80734fbc24a5$exports, "moveHeaderToPosition", function () { return $d81b80734fbc24a5$export$acd474d24539fc90; });
$parcel$export($d81b80734fbc24a5$exports, "moveHeaderLeft", function () { return $d81b80734fbc24a5$export$9bc68a93e1257bc4; });
$parcel$export($d81b80734fbc24a5$exports, "moveHeaderRight", function () { return $d81b80734fbc24a5$export$1a52218923a01537; });
$parcel$export($d81b80734fbc24a5$exports, "moveSubtreeLeft", function () { return $d81b80734fbc24a5$export$c9fe9acb91c4c8f0; });
$parcel$export($d81b80734fbc24a5$exports, "moveSubtreeRight", function () { return $d81b80734fbc24a5$export$1e7956fd1c44b404; });
$parcel$export($d81b80734fbc24a5$exports, "refileSubtree", function () { return $d81b80734fbc24a5$export$8e9d83427b24822a; });
$parcel$export($d81b80734fbc24a5$exports, "addNote", function () { return $d81b80734fbc24a5$export$79159e21a6bceab7; });
$parcel$export($d81b80734fbc24a5$exports, "narrowHeader", function () { return $d81b80734fbc24a5$export$8185c23dcb1f0e0; });
$parcel$export($d81b80734fbc24a5$exports, "dirtyAction", function () { return $d81b80734fbc24a5$export$3394329df2111da4; });
$parcel$export($d81b80734fbc24a5$exports, "setSelectedDescriptionItemIndex", function () { return $d81b80734fbc24a5$export$e1a8b1c52b62343c; });
$parcel$export($d81b80734fbc24a5$exports, "setSelectedTableId", function () { return $d81b80734fbc24a5$export$bb889c933b04177; });
$parcel$export($d81b80734fbc24a5$exports, "addNewTableRow", function () { return $d81b80734fbc24a5$export$7cae8a62f493d901; });
$parcel$export($d81b80734fbc24a5$exports, "removeTableRow", function () { return $d81b80734fbc24a5$export$163255ef96b20fb2; });
$parcel$export($d81b80734fbc24a5$exports, "addNewTableColumn", function () { return $d81b80734fbc24a5$export$7ab7eb066062846f; });
$parcel$export($d81b80734fbc24a5$exports, "removeTableColumn", function () { return $d81b80734fbc24a5$export$e8d98b2fc68c6686; });
$parcel$export($d81b80734fbc24a5$exports, "moveTableRowDown", function () { return $d81b80734fbc24a5$export$4aba78fdf63069f3; });
$parcel$export($d81b80734fbc24a5$exports, "moveTableRowUp", function () { return $d81b80734fbc24a5$export$24d61201bca94a1e; });
$parcel$export($d81b80734fbc24a5$exports, "moveTableColumnLeft", function () { return $d81b80734fbc24a5$export$10d26cb5dfc56d08; });
$parcel$export($d81b80734fbc24a5$exports, "moveTableColumnRight", function () { return $d81b80734fbc24a5$export$2d24c1901a67e0af; });
$parcel$export($d81b80734fbc24a5$exports, "updateTableCellValue", function () { return $d81b80734fbc24a5$export$7f16bb82aa33d615; });
$parcel$export($d81b80734fbc24a5$exports, "insertCapture", function () { return $d81b80734fbc24a5$export$6d309cb89e0efb17; });
$parcel$export($d81b80734fbc24a5$exports, "insertCaptureFromHeader", function () { return $d81b80734fbc24a5$export$c64a0f6ff771ff28; });
$parcel$export($d81b80734fbc24a5$exports, "clearPendingCapture", function () { return $d81b80734fbc24a5$export$4191fada395b9eaf; });
$parcel$export($d81b80734fbc24a5$exports, "insertPendingCapture", function () { return $d81b80734fbc24a5$export$eccd488bbc07a831; });
$parcel$export($d81b80734fbc24a5$exports, "advanceCheckboxState", function () { return $d81b80734fbc24a5$export$67c8893c26def689; });
$parcel$export($d81b80734fbc24a5$exports, "updateListTitleValue", function () { return $d81b80734fbc24a5$export$49120ddd66561733; });
$parcel$export($d81b80734fbc24a5$exports, "updateListContentsValue", function () { return $d81b80734fbc24a5$export$2f9859c55269723a; });
$parcel$export($d81b80734fbc24a5$exports, "addNewListItem", function () { return $d81b80734fbc24a5$export$657dd7de9e3c731a; });
$parcel$export($d81b80734fbc24a5$exports, "selectNextSiblingListItem", function () { return $d81b80734fbc24a5$export$6e8bb94df7b20621; });
$parcel$export($d81b80734fbc24a5$exports, "addNewListItemAndEdit", function () { return $d81b80734fbc24a5$export$1237e513fcf0255f; });
$parcel$export($d81b80734fbc24a5$exports, "removeListItem", function () { return $d81b80734fbc24a5$export$b0f7d7f51fc9406a; });
$parcel$export($d81b80734fbc24a5$exports, "moveListItemUp", function () { return $d81b80734fbc24a5$export$bd631276cc4c58fd; });
$parcel$export($d81b80734fbc24a5$exports, "moveListItemDown", function () { return $d81b80734fbc24a5$export$390d7acb2b96bcbb; });
$parcel$export($d81b80734fbc24a5$exports, "moveListItemLeft", function () { return $d81b80734fbc24a5$export$8844464bf09616ec; });
$parcel$export($d81b80734fbc24a5$exports, "moveListItemRight", function () { return $d81b80734fbc24a5$export$12eb1b14e074a6b7; });
$parcel$export($d81b80734fbc24a5$exports, "moveListSubtreeLeft", function () { return $d81b80734fbc24a5$export$3b88d9219ca93e47; });
$parcel$export($d81b80734fbc24a5$exports, "moveListSubtreeRight", function () { return $d81b80734fbc24a5$export$3b9c326df9e2fd95; });
$parcel$export($d81b80734fbc24a5$exports, "setHeaderTags", function () { return $d81b80734fbc24a5$export$92bc85de99057d64; });
$parcel$export($d81b80734fbc24a5$exports, "reorderTags", function () { return $d81b80734fbc24a5$export$3ef4f30cf2ff5820; });
$parcel$export($d81b80734fbc24a5$exports, "reorderPropertyList", function () { return $d81b80734fbc24a5$export$49c84db8dca423dc; });
$parcel$export($d81b80734fbc24a5$exports, "updateTimestampWithId", function () { return $d81b80734fbc24a5$export$ccb2f2f45ccf6e73; });
$parcel$export($d81b80734fbc24a5$exports, "updatePlanningItemTimestamp", function () { return $d81b80734fbc24a5$export$ce2b24e6685d7b40; });
$parcel$export($d81b80734fbc24a5$exports, "addNewPlanningItem", function () { return $d81b80734fbc24a5$export$d517feb0e36376ff; });
$parcel$export($d81b80734fbc24a5$exports, "removePlanningItem", function () { return $d81b80734fbc24a5$export$962c84a23aaded5f; });
$parcel$export($d81b80734fbc24a5$exports, "removeTimestamp", function () { return $d81b80734fbc24a5$export$8144a1156e1fc1b3; });
$parcel$export($d81b80734fbc24a5$exports, "updatePropertyListItems", function () { return $d81b80734fbc24a5$export$30602d312260e3a; });
$parcel$export($d81b80734fbc24a5$exports, "setLogEntryStop", function () { return $d81b80734fbc24a5$export$e0cf4c247726959f; });
$parcel$export($d81b80734fbc24a5$exports, "createLogEntryStart", function () { return $d81b80734fbc24a5$export$f459875c7999031d; });
$parcel$export($d81b80734fbc24a5$exports, "updateLogEntryTime", function () { return $d81b80734fbc24a5$export$e6848e05aa9ac9c3; });
$parcel$export($d81b80734fbc24a5$exports, "setSearchFilterInformation", function () { return $d81b80734fbc24a5$export$21de7cfeca6a9e5b; });
$parcel$export($d81b80734fbc24a5$exports, "setShowClockDisplay", function () { return $d81b80734fbc24a5$export$737fa6ea2dea9d9c; });
$parcel$export($d81b80734fbc24a5$exports, "updateFileSettingFieldPathValue", function () { return $d81b80734fbc24a5$export$491f839f0847e33e; });
$parcel$export($d81b80734fbc24a5$exports, "reorderFileSetting", function () { return $d81b80734fbc24a5$export$1598048bf82d0a0a; });
$parcel$export($d81b80734fbc24a5$exports, "deleteFileSetting", function () { return $d81b80734fbc24a5$export$3056289a1346fb2; });
$parcel$export($d81b80734fbc24a5$exports, "addNewEmptyFileSetting", function () { return $d81b80734fbc24a5$export$dc769ee8acd95be2; });
$parcel$export($d81b80734fbc24a5$exports, "restoreFileSettings", function () { return $d81b80734fbc24a5$export$1b46013ba7966e2d; });
$parcel$export($d81b80734fbc24a5$exports, "saveBookmark", function () { return $d81b80734fbc24a5$export$9ca719fe1e80008c; });
$parcel$export($d81b80734fbc24a5$exports, "deleteBookmark", function () { return $d81b80734fbc24a5$export$136048bcb9946c75; });
$parcel$export($d81b80734fbc24a5$exports, "addNewFile", function () { return $d81b80734fbc24a5$export$87568492a59918e5; });

var $frurs = parcelRequire("frurs");

var $QHj9z = parcelRequire("QHj9z");
var $5624140532e76935$exports = {};

var $frurs = parcelRequire("frurs");

var $QHj9z = parcelRequire("QHj9z");
(function(d, f) {
    f($5624140532e76935$exports);
})(undefined, function(d) {
    "use strict";
    const f = {
        UNDO: "@@redux-undo/UNDO",
        REDO: "@@redux-undo/REDO",
        JUMP_TO_FUTURE: "@@redux-undo/JUMP_TO_FUTURE",
        JUMP_TO_PAST: "@@redux-undo/JUMP_TO_PAST",
        JUMP: "@@redux-undo/JUMP",
        CLEAR_HISTORY: "@@redux-undo/CLEAR_HISTORY"
    }, E = {
        undo () {
            return {
                type: f.UNDO
            };
        },
        redo () {
            return {
                type: f.REDO
            };
        },
        jumpToFuture (e) {
            return {
                type: f.JUMP_TO_FUTURE,
                index: e
            };
        },
        jumpToPast (e) {
            return {
                type: f.JUMP_TO_PAST,
                index: e
            };
        },
        jump (e) {
            return {
                type: f.JUMP,
                index: e
            };
        },
        clearHistory () {
            return {
                type: f.CLEAR_HISTORY
            };
        }
    };
    function _(e, t = []) {
        return Array.isArray(e) ? e : typeof e == "string" ? [
            e
        ] : t;
    }
    function R(e) {
        return typeof e.present < "u" && typeof e.future < "u" && typeof e.past < "u" && Array.isArray(e.future) && Array.isArray(e.past);
    }
    function F(e) {
        const t = _(e);
        return (n)=>t.indexOf(n.type) >= 0;
    }
    function j(e) {
        const t = _(e);
        return (n)=>t.indexOf(n.type) < 0;
    }
    function x(...e) {
        return e.reduce((t, n)=>(s, l, u)=>t(s, l, u) && n(s, l, u), ()=>!0);
    }
    function M(e) {
        const t = _(e);
        return (n)=>t.indexOf(n.type) >= 0 ? n.type : null;
    }
    function T(e, t, n, s = null) {
        return {
            past: e,
            present: t,
            future: n,
            group: s,
            _latestUnfiltered: t,
            index: e.length,
            limit: e.length + n.length + 1
        };
    }
    let U, a;
    const A = {
        prevState: "#9E9E9E",
        action: "#03A9F4",
        nextState: "#4CAF50"
    };
    function v() {
        a = {
            header: [],
            prev: [],
            action: [],
            next: [],
            msgs: []
        };
    }
    function I() {
        const { header: e, prev: t, next: n, action: s, msgs: l } = a;
        console.group ? (console.groupCollapsed(...e), console.log(...t), console.log(...s), console.log(...n), console.log(...l), console.groupEnd()) : (console.log(...e), console.log(...t), console.log(...s), console.log(...n), console.log(...l));
    }
    function O(e, t, n) {
        return [
            `%c${e}`,
            `color: ${t}; font-weight: bold`,
            n
        ];
    }
    function J(e, t) {
        v(), U && (console.group ? (a.header = [
            "%credux-undo",
            "font-style: italic",
            "action",
            e.type
        ], a.action = O("action", A.action, e), a.prev = O("prev history", A.prevState, t)) : (a.header = [
            "redux-undo action",
            e.type
        ], a.action = [
            "action",
            e
        ], a.prev = [
            "prev history",
            t
        ]));
    }
    function y(e) {
        U && (console.group ? a.next = O("next history", A.nextState, e) : a.next = [
            "next history",
            e
        ], I());
    }
    function p(...e) {
        U && (a.msgs = a.msgs.concat([
            ...e,
            `
`
        ]));
    }
    function b(e) {
        U = e;
    }
    function P(e, t) {
        const n = T([], e, []);
        return t && (n._latestUnfiltered = null), n;
    }
    function w(e, t, n, s) {
        const l = e.past.length + 1;
        p("inserting", t), p("new free: ", n - l);
        const { past: u, _latestUnfiltered: o } = e, c = n && n <= l, r = u.slice(c ? 1 : 0), i = o != null ? [
            ...r,
            o
        ] : r;
        return T(i, t, [], s);
    }
    function h(e, t) {
        if (t < 0 || t >= e.future.length) return e;
        const { past: n, future: s, _latestUnfiltered: l } = e, u = [
            ...n,
            l,
            ...s.slice(0, t)
        ], o = s[t], c = s.slice(t + 1);
        return T(u, o, c);
    }
    function H(e, t) {
        if (t < 0 || t >= e.past.length) return e;
        const { past: n, future: s, _latestUnfiltered: l } = e, u = n.slice(0, t), o = [
            ...n.slice(t + 1),
            l,
            ...s
        ], c = n[t];
        return T(u, c, o);
    }
    function S(e, t) {
        return t > 0 ? h(e, t - 1) : t < 0 ? H(e, e.past.length + t) : e;
    }
    function B(e, t) {
        return t.indexOf(e) > -1 ? e : !e;
    }
    function D(e, t = {}) {
        b(t.debug);
        const n = (0, $QHj9z._)((0, $frurs._)({
            limit: void 0,
            filter: ()=>!0,
            groupBy: ()=>null,
            undoType: f.UNDO,
            redoType: f.REDO,
            jumpToPastType: f.JUMP_TO_PAST,
            jumpToFutureType: f.JUMP_TO_FUTURE,
            jumpType: f.JUMP,
            neverSkipReducer: !1,
            ignoreInitialState: !1,
            syncFilter: !1
        }, t), {
            initTypes: _(t.initTypes, [
                "@@redux-undo/INIT"
            ]),
            clearHistoryType: _(t.clearHistoryType, [
                f.CLEAR_HISTORY
            ])
        }), s = n.neverSkipReducer ? (u, o, ...c)=>(0, $QHj9z._)((0, $frurs._)({}, u), {
                present: e(u.present, o, ...c)
            }) : (u)=>u;
        let l;
        return (u = l, o = {}, ...c)=>{
            J(o, u);
            let r = u;
            if (!l) {
                if (p("history is uninitialized"), u === void 0) {
                    const m = e(u, {
                        type: "@@redux-undo/CREATE_HISTORY"
                    }, ...c);
                    return r = P(m, n.ignoreInitialState), p("do not set initialState on probe actions"), y(r), r;
                } else R(u) ? (r = l = n.ignoreInitialState ? u : T(u.past, u.present, u.future), p("initialHistory initialized: initialState is a history", l)) : (r = l = P(u, n.ignoreInitialState), p("initialHistory initialized: initialState is not a history", l));
            }
            let i;
            switch(o.type){
                case void 0:
                    return r;
                case n.undoType:
                    return i = S(r, -1), p("perform undo"), y(i), s(i, o, ...c);
                case n.redoType:
                    return i = S(r, 1), p("perform redo"), y(i), s(i, o, ...c);
                case n.jumpToPastType:
                    return i = H(r, o.index), p(`perform jumpToPast to ${o.index}`), y(i), s(i, o, ...c);
                case n.jumpToFutureType:
                    return i = h(r, o.index), p(`perform jumpToFuture to ${o.index}`), y(i), s(i, o, ...c);
                case n.jumpType:
                    return i = S(r, o.index), p(`perform jump to ${o.index}`), y(i), s(i, o, ...c);
                case B(o.type, n.clearHistoryType):
                    return i = P(r.present, n.ignoreInitialState), p("perform clearHistory"), y(i), s(i, o, ...c);
                default:
                    if (i = e(r.present, o, ...c), n.initTypes.some((g)=>g === o.type)) return p("reset history due to init action"), y(l), l;
                    if (r._latestUnfiltered === i) return r;
                    if (typeof n.filter == "function" && !n.filter(o, i, r)) {
                        const g = T(r.past, i, r.future, r.group);
                        return n.syncFilter || (g._latestUnfiltered = r._latestUnfiltered), p("filter ignored action, not storing it in past"), y(g), g;
                    }
                    const m = n.groupBy(o, i, r);
                    if (m != null && m === r.group) {
                        const g = T(r.past, i, r.future, r.group);
                        return p("groupBy grouped the action with the previous action"), y(g), g;
                    }
                    return r = w(r, i, n.limit, m), p("inserted new state into history"), y(r), r;
            }
        };
    }
    d.ActionCreators = E, d.ActionTypes = f, d.combineFilters = x, d.default = D, d.excludeAction = j, d.groupByActionTypes = M, d.includeAction = F, d.isHistory = R, d.newHistory = T, d.parseActions = _, Object.defineProperties(d, {
        __esModule: {
            value: !0
        },
        [Symbol.toStringTag]: {
            value: "Module"
        }
    });
});



var $1X5R2 = parcelRequire("1X5R2");
var $1780206710f3c846$exports = {};

$parcel$export($1780206710f3c846$exports, "setLoadingMessage", function () { return $1780206710f3c846$export$b75e26cdc67a486a; });
$parcel$export($1780206710f3c846$exports, "hideLoadingMessage", function () { return $1780206710f3c846$export$80775798c6eb9d34; });
$parcel$export($1780206710f3c846$exports, "setIsLoading", function () { return $1780206710f3c846$export$9eaa806651dd33f0; });
$parcel$export($1780206710f3c846$exports, "setIsOnline", function () { return $1780206710f3c846$export$7c40ec7552034cd7; });
$parcel$export($1780206710f3c846$exports, "setDisappearingLoadingMessage", function () { return $1780206710f3c846$export$dcd62ed1bd1c13ec; });
$parcel$export($1780206710f3c846$exports, "setLastViewedFile", function () { return $1780206710f3c846$export$eb54a9b5d32e03d; });
$parcel$export($1780206710f3c846$exports, "restoreStaticFile", function () { return $1780206710f3c846$export$7b70d0006c6937c5; });
$parcel$export($1780206710f3c846$exports, "unloadStaticFile", function () { return $1780206710f3c846$export$c376ba4ed7d6ea1; });
$parcel$export($1780206710f3c846$exports, "setFontSize", function () { return $1780206710f3c846$export$c5b51da1f1e80706; });
$parcel$export($1780206710f3c846$exports, "setBulletStyle", function () { return $1780206710f3c846$export$4aa7f4aee137c00e; });
$parcel$export($1780206710f3c846$exports, "setShouldTapTodoToAdvance", function () { return $1780206710f3c846$export$e637bedbcb1d99eb; });
$parcel$export($1780206710f3c846$exports, "setAgendaDefaultDeadlineDelayUnit", function () { return $1780206710f3c846$export$a77dec68e1709431; });
$parcel$export($1780206710f3c846$exports, "setAgendaDefaultDeadlineDelayValue", function () { return $1780206710f3c846$export$2104f9eade1c8366; });
$parcel$export($1780206710f3c846$exports, "setEditorDescriptionHeightValue", function () { return $1780206710f3c846$export$91d212b4c2ea492a; });
$parcel$export($1780206710f3c846$exports, "setAgendaStartOnWeekday", function () { return $1780206710f3c846$export$4c4af1fe8269ccae; });
$parcel$export($1780206710f3c846$exports, "setShouldLiveSync", function () { return $1780206710f3c846$export$37be07c704d99c3c; });
$parcel$export($1780206710f3c846$exports, "setShowDeadlineDisplay", function () { return $1780206710f3c846$export$5c197882088ec7fb; });
$parcel$export($1780206710f3c846$exports, "setShouldSyncOnBecomingVisibile", function () { return $1780206710f3c846$export$4500bc1fc12baaca; });
$parcel$export($1780206710f3c846$exports, "setShouldShowTitleInOrgFile", function () { return $1780206710f3c846$export$abc24fbbfef45381; });
$parcel$export($1780206710f3c846$exports, "setShouldLogIntoDrawer", function () { return $1780206710f3c846$export$e1e6d996751fb1f4; });
$parcel$export($1780206710f3c846$exports, "setCloseSubheadersRecursively", function () { return $1780206710f3c846$export$e5e2421b7f9b8964; });
$parcel$export($1780206710f3c846$exports, "setShouldNotIndentOnExport", function () { return $1780206710f3c846$export$690c7575f3a79943; });
$parcel$export($1780206710f3c846$exports, "setShouldStoreSettingsInSyncBackend", function () { return $1780206710f3c846$export$bad93780d27506dd; });
$parcel$export($1780206710f3c846$exports, "setColorScheme", function () { return $1780206710f3c846$export$f2d00fe8ce80fd84; });
$parcel$export($1780206710f3c846$exports, "setTheme", function () { return $1780206710f3c846$export$2e49b867b7a0847c; });
$parcel$export($1780206710f3c846$exports, "setHasUnseenChangelog", function () { return $1780206710f3c846$export$a94b65b83df44181; });
$parcel$export($1780206710f3c846$exports, "setLastSeenChangelogHeader", function () { return $1780206710f3c846$export$881e6a033a29282a; });
$parcel$export($1780206710f3c846$exports, "setCustomKeybinding", function () { return $1780206710f3c846$export$9974be595dbac166; });
$parcel$export($1780206710f3c846$exports, "restoreBaseSettings", function () { return $1780206710f3c846$export$7027258f5f935b03; });
$parcel$export($1780206710f3c846$exports, "pushModalPage", function () { return $1780206710f3c846$export$8e611aa521a0a08b; });
$parcel$export($1780206710f3c846$exports, "popModalPage", function () { return $1780206710f3c846$export$4d24603a016fa6c3; });
$parcel$export($1780206710f3c846$exports, "clearModalStack", function () { return $1780206710f3c846$export$b5212ec6a6e9531e; });
$parcel$export($1780206710f3c846$exports, "activatePopup", function () { return $1780206710f3c846$export$ebfc6cde9af7602f; });
$parcel$export($1780206710f3c846$exports, "closePopup", function () { return $1780206710f3c846$export$e6889fb0929ccf91; });
$parcel$export($1780206710f3c846$exports, "setAgendaTimeframe", function () { return $1780206710f3c846$export$db71203757fe273d; });
$parcel$export($1780206710f3c846$exports, "setFinderTab", function () { return $1780206710f3c846$export$fd2f521ee5394b02; });
$parcel$export($1780206710f3c846$exports, "setPreferEditRawValues", function () { return $1780206710f3c846$export$23b56ce92307bb87; });
$parcel$export($1780206710f3c846$exports, "setOrgHabitShowAllToday", function () { return $1780206710f3c846$export$5b368dcdf2065092; });
$parcel$export($1780206710f3c846$exports, "setOrgHabitPrecedingDays", function () { return $1780206710f3c846$export$12effd122e8f64de; });
$parcel$export($1780206710f3c846$exports, "setOrgHabitFollowingDays", function () { return $1780206710f3c846$export$f0af1a82fba6cb87; });
$parcel$export($1780206710f3c846$exports, "updateNotificationSettingsFieldPathValue", function () { return $1780206710f3c846$export$a2a4779bb5290c99; });
$parcel$export($1780206710f3c846$exports, "addNewEmptyNotificationTagCadence", function () { return $1780206710f3c846$export$1cc0ace5276b4418; });
$parcel$export($1780206710f3c846$exports, "updateNotificationTagCadenceFieldPathValue", function () { return $1780206710f3c846$export$6fcad1eca5911490; });
$parcel$export($1780206710f3c846$exports, "deleteNotificationTagCadence", function () { return $1780206710f3c846$export$55abbd75662fafb7; });
$parcel$export($1780206710f3c846$exports, "reorderNotificationTagCadence", function () { return $1780206710f3c846$export$a6e4ea47c8aa5e07; });


var $frurs = parcelRequire("frurs");
var $3044e0bef3624137$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(global, factory) {
    $3044e0bef3624137$exports = factory();
})($3044e0bef3624137$exports, function() {
    'use strict';
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
        if (superClass) ctor.prototype = Object.create(superClass.prototype);
        ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    // Used for setting prototype methods that IE8 chokes on.
    var DELETE = 'delete';
    // Constants describing the size of trie nodes.
    var SHIFT = 5; // Resulted in best performance after ______?
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.
    var NOT_SET = {};
    // Boolean references, Rough equivalent of `bool &`.
    var CHANGE_LENGTH = {
        value: false
    };
    var DID_ALTER = {
        value: false
    };
    function MakeRef(ref) {
        ref.value = false;
        return ref;
    }
    function SetRef(ref) {
        ref && (ref.value = true);
    }
    // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.
    function OwnerID() {}
    // http://jsperf.com/copy-array-inline
    function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
        return newArr;
    }
    function ensureSize(iter) {
        if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
        return iter.size;
    }
    function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== 'number') {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
            if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
            index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue() {
        return true;
    }
    function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }
    function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */ var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
        this.next = next;
    }
    Iterator.prototype.toString = function() {
        return '[Iterator]';
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
        return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
        return this;
    };
    function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [
            k,
            v
        ];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
        };
        return iteratorResult;
    }
    function iteratorDone() {
        return {
            value: undefined,
            done: true
        };
    }
    function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === 'function';
    }
    function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    function isArrayLike(value) {
        return value && typeof value.length === 'number';
    }
    createClass(Seq, Iterable);
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
        return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
        return this;
    };
    Seq.prototype.toString = function() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, true);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
        return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
        return this;
    };
    IndexedSeq.prototype.toString = function() {
        return this.__toString('Seq [', ']');
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
        return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) return ii + 1;
        }
        return ii;
    };
    ArraySeq.prototype.__iterator = function(type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function() {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
        return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            var key = keys[reverse ? maxIndex - ii : ii];
            if (fn(object[key], key, this) === false) return ii + 1;
        }
        return ii;
    };
    ObjectSeq.prototype.__iterator = function(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function() {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    // # pragma Helper functions
    function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
        if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
        return seq;
    }
    function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) throw new TypeError('Expected Array or iterable object of values: ' + value);
        return seq;
    }
    function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
        if (!seq) throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
        return seq;
    }
    function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            for(var ii = 0; ii <= maxIndex; ii++){
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) return ii + 1;
            }
            return ii;
        }
        return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function() {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
        }
        return seq.__iteratorUncached(type, reverse);
    }
    function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, '', {
            '': json
        }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        if (isPlainObj(json)) return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        return json;
    }
    function fromJSDefault(json) {
        if (Array.isArray(json)) return IndexedSeq(json).map(fromJSDefault).toList();
        if (isPlainObj(json)) return KeyedSeq(json).map(fromJSDefault).toMap();
        return json;
    }
    function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */ function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
        if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
            if (!valueA || !valueB) return false;
        }
        if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) return true;
        return false;
    }
    function deepEqual(a, b) {
        if (a === b) return true;
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
        if (a.size === 0 && b.size === 0) return true;
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function(v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
            if (b.size === undefined) {
                if (typeof a.cacheResult === 'function') a.cacheResult();
            } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
            }
        }
        var allEqual = true;
        var bSize = b.__iterate(function(v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
            }
        });
        return allEqual && a.size === bSize;
    }
    createClass(Repeat, IndexedSeq);
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    Repeat.prototype.toString = function() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function() {
        return this;
    };
    Repeat.prototype.indexOf = function(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function(fn, reverse) {
        for(var ii = 0; ii < this.size; ii++){
            if (fn(this._value, ii, this) === false) return ii + 1;
        }
        return ii;
    };
    Repeat.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function() {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
    };
    Repeat.prototype.equals = function(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    var EMPTY_REPEAT;
    function invariant(condition, error) {
        if (!condition) throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    Range.prototype.toString = function() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(value, ii, this) === false) return ii + 1;
            value += reverse ? -step : step;
        }
        return ii;
    };
    Range.prototype.__iterator = function(type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function() {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
    };
    Range.prototype.equals = function(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
        throw TypeError('Abstract');
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {}
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {}
    createClass(SetCollection, Collection);
    function SetCollection() {}
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    };
    // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.
    function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }
    function hash(o) {
        if (o === false || o === null || o === undefined) return 0;
        if (typeof o.valueOf === 'function') {
            o = o.valueOf();
            if (o === false || o === null || o === undefined) return 0;
        }
        if (o === true) return 1;
        var type = typeof o;
        if (type === 'number') {
            if (o !== o || o === Infinity) return 0;
            var h = o | 0;
            if (h !== o) h ^= o * 0xFFFFFFFF;
            while(o > 0xFFFFFFFF){
                o /= 0xFFFFFFFF;
                h ^= o;
            }
            return smi(h);
        }
        if (type === 'string') return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        if (typeof o.hashCode === 'function') return o.hashCode();
        if (type === 'object') return hashJSObj(o);
        if (typeof o.toString === 'function') return hashString(o.toString());
        throw new Error('Value type ' + type + ' cannot be hashed.');
    }
    function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
            hash = hashString(string);
            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
            }
            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
        }
        return hash;
    }
    // http://jsperf.com/hashing-strings
    function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for(var ii = 0; ii < string.length; ii++)hash = 31 * hash + string.charCodeAt(ii) | 0;
        return smi(hash);
    }
    function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
            hash = weakMap.get(obj);
            if (hash !== undefined) return hash;
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) return hash;
        if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
            if (hash !== undefined) return hash;
            hash = getIENodeHash(obj);
            if (hash !== undefined) return hash;
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) objHashUID = 0;
        if (usingWeakMap) weakMap.set(obj, hash);
        else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
        else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
            'enumerable': false,
            'configurable': false,
            'writable': false,
            'value': hash
        });
        else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function() {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };
            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
        else throw new Error('Unable to set a non-enumerable property on object.');
        return hash;
    }
    // Get references to ES5 object methods.
    var isExtensible = Object.isExtensible;
    // True if Object.defineProperty works as expected. IE8 fails this test.
    var canDefineProperty = function() {
        try {
            Object.defineProperty({}, '@', {});
            return true;
        } catch (e) {
            return false;
        }
    }();
    // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.
    function getIENodeHash(node) {
        if (node && node.nodeType > 0) switch(node.nodeType){
            case 1:
                return node.uniqueID;
            case 9:
                return node.documentElement && node.documentElement.uniqueID;
        }
    }
    // If possible, use a WeakMap.
    var usingWeakMap = typeof WeakMap === 'function';
    var weakMap;
    if (usingWeakMap) weakMap = new WeakMap();
    var objHashUID = 0;
    var UID_HASH_KEY = '__immutablehash__';
    if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
        invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
    }
    createClass(Map, KeyedCollection);
    // @pragma Construction
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    Map.of = function() {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.setIn = function(keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function() {
            return v;
        });
    };
    Map.prototype.remove = function(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteIn = function(keyPath) {
        return this.updateIn(keyPath, function() {
            return NOT_SET;
        });
    };
    Map.prototype.update = function(k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([
            k
        ], notSetValue, updater);
    };
    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
        if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
    };
    Map.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.merge = function() {
        return mergeIntoMapWith(this, undefined, arguments);
    };
    Map.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
    };
    Map.prototype.mergeIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.mergeDeep = function() {
        return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map.prototype.mergeDeepIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.sort = function(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.withMutations = function(fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map.prototype.asImmutable = function() {
        return this.__ensureOwner();
    };
    Map.prototype.wasAltered = function() {
        return this.__altered;
    };
    Map.prototype.__iterator = function(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map.isMap = isMap;
    var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    // #pragma Trie Nodes
    function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) return; // undefined
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) return this;
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) return this;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        var newCount = this.count;
        if (!node) newCount++;
        else if (!newNode) {
            newCount--;
            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
            if (removed) return this;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [
                key,
                value
            ]);
        }
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) return this;
        SetRef(didAlter);
        if (removed) {
            SetRef(didChangeSize);
            return; // undefined
        }
        if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
            }
            return new ValueNode(ownerID, this.keyHash, [
                key,
                value
            ]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [
            key,
            value
        ]);
    };
    // #pragma Iterators
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
        var entries = this.entries;
        for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
        }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
        var nodes = this.nodes;
        for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
            var node = nodes[reverse ? maxIndex - ii : ii];
            if (node && node.iterate(fn, reverse) === false) return false;
        }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
        return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
        return {
            node: node,
            index: 0,
            __prev: prev
        };
    }
    function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
            if (v === NOT_SET) return map;
            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [
                [
                    k,
                    v
                ]
            ]);
        } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
            if (!didAlter.value) return map;
            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
            if (value === NOT_SET) return node;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [
                key,
                value
            ]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
            node.entry,
            entry
        ]);
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [
            mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
        ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
            node,
            newNode
        ] : [
            newNode,
            node
        ]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
        if (!ownerID) ownerID = new OwnerID();
        var node = new ValueNode(ownerID, hash(key), [
            key,
            value
        ]);
        for(var ii = 0; ii < entries.length; ii++){
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
            var node = nodes[ii];
            if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
            }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = KeyedIterable(value);
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
        return function(existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
        };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return collection;
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
        return collection.withMutations(function(collection) {
            var mergeIntoMap = merger ? function(value, key) {
                collection.update(key, NOT_SET, function(existing) {
                    return existing === NOT_SET ? value : merger(existing, value, key);
                });
            } : function(value, key) {
                collection.set(key, value);
            };
            for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoMap);
        });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, 'invalid keyPath');
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
    }
    function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
            newArray[ii] = val;
            after = -1;
        } else newArray[ii] = array[ii + after];
        return newArray;
    }
    function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
            array.pop();
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++){
            if (ii === idx) after = 1;
            newArray[ii] = array[ii + after];
        }
        return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection);
    // @pragma Construction
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    List.of = function() {
        return this(arguments);
    };
    List.prototype.toString = function() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.merge = function() {
        return mergeIntoListWith(this, undefined, arguments);
    };
    List.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
    };
    List.prototype.mergeDeep = function() {
        return mergeIntoListWith(this, deepMerger, arguments);
    };
    List.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List.prototype.setSize = function(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function(type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
    };
    List.prototype.__iterate = function(fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List.isList = isList;
    var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
    }
    // TODO: seems like these methods are very similar
    VNode.prototype.removeBefore = function(ownerID, level, index) {
        if (index === level ? 1 << level : this.array.length === 0) return this;
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) return new VNode([], ownerID);
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
            if (newChild === oldChild && removingFirst) return this;
        }
        if (removingFirst && !newChild) return this;
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
        if (newChild) editable.array[originIndex] = newChild;
        return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) return this;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
            if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) editable.array[sizeIndex] = newChild;
        return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;
            if (to > SIZE) to = SIZE;
            return function() {
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                return array && array[idx];
            };
        }
        function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;
            if (to > SIZE) to = SIZE;
            return function() {
                do {
                    if (values) {
                        var value = values();
                        if (value !== DONE) return value;
                        values = null;
                    }
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                }while (true);
            };
        }
    }
    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
    }
    var EMPTY_LIST;
    function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) return list;
        if (index >= list.size || index < 0) return list.withMutations(function(list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        if (!didAlter.value) return list;
        if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) return node;
        var newNode;
        if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
            if (newLowerNode === lowerNode) return node;
            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
        }
        if (nodeHas && node.array[idx] === value) return node;
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
        else newNode.array[idx] = value;
        return newNode;
    }
    function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) return node;
        return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
        if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;
            while(node && level > 0){
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
            }
            return node;
        }
    }
    function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) end = end | 0;
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) return list.clear();
        var newLevel = list._level;
        var newRoot = list._root;
        // New origin might need creating a higher root.
        var offsetShift = 0;
        while(newOrigin + offsetShift < 0){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                undefined,
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);
        // New size might need creating a higher root.
        while(newTailOffset >= 1 << newLevel + SHIFT){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
        }
        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;
            for(var level = newLevel; level > SHIFT; level -= SHIFT){
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
            }
            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }
        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
        // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0;
            // Identify the new top root node of the subtree of the old root.
            while(newRoot){
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
            }
            // Trim the new sides of the new root.
            if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
            }
        }
        if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = IndexedIterable(value);
            if (iter.size > maxSize) maxSize = iter.size;
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        if (maxSize > list.size) list = list.setSize(maxSize);
        return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap, Map);
    // @pragma Construction
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    OrderedMap.of = function() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
            if (!has) return omap;
            if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function(entry, idx) {
                    return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
        } else if (has) {
            if (v === list.get(i)[1]) return omap;
            newMap = map;
            newList = list.set(i, [
                k,
                v
            ]);
        } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [
                k,
                v
            ]);
        }
        if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
        }
        return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$0._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$0._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function(v, k) {
            return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
            return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
    };
    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
        if (this._useKeys) return this._iter.__iterator(type, reverse);
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function(v) {
            return fn(v, iterations++, this$0);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$0);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function() {
            return iterable;
        };
        flipSequence.reverse = function() {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()
            reversedSequence.flip = function() {
                return iterable.reverse();
            };
            return reversedSequence;
        };
        flipSequence.has = function(key) {
            return iterable.includes(key);
        };
        flipSequence.includes = function(key) {
            return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(k, v, this$0) !== false;
            }, reverse);
        };
        flipSequence.__iteratorUncached = function(type, reverse) {
            if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (!step.done) {
                        var k = step.value[0];
                        step.value[0] = step.value[1];
                        step.value[1] = k;
                    }
                    return step;
                });
            }
            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function(key) {
            return iterable.has(key);
        };
        mappedSequence.get = function(key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
        };
        mappedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
        };
        return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function() {
            return iterable;
        };
        if (iterable.flip) reversedSequence.flip = function() {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function() {
                return iterable.flip();
            };
            return flipSequence;
        };
        reversedSequence.get = function(key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function(key) {
            return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function(value) {
            return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(v, k, this$0);
            }, !reverse);
        };
        reversedSequence.__iterator = function(type, reverse) {
            return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
            filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };
            filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
        }
        filterSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            }, reverse);
            return iterations;
        };
        filterSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterations = 0;
            return new Iterator(function() {
                while(true){
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    var key = entry[0];
                    var value = entry[1];
                    if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
            });
        };
        return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                return a + 1;
            });
        });
        return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), function(a) {
                return a = a || [], a.push(isKeyedIter ? [
                    k,
                    v
                ] : v), a;
            });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function(arr) {
            return reify(iterable, coerce(arr));
        });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) {
            if (end === Infinity) end = originalSize;
            else end = end | 0;
        }
        if (wholeSlice(begin, end, originalSize)) return iterable;
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);
        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        var sliceSeq = makeSequence(iterable);
        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
        sliceSeq.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (sliceSize === 0) return 0;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
            });
            return iterations;
        };
        sliceSeq.__iteratorUncached = function(type, reverse) {
            if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
            // Don't bother instantiating parent iterator if taking 0.
            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
            var skipped = 0;
            var iterations = 0;
            return new Iterator(function() {
                while(skipped++ < resolvedBegin)iterator.next();
                if (++iterations > sliceSize) return iteratorDone();
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) return step;
                else if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
                else return iteratorValue(type, iterations - 1, step.value[1], step);
            });
        };
        return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });
            return iterations;
        };
        takeSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterating = true;
            return new Iterator(function() {
                if (!iterating) return iteratorDone();
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                    iterating = false;
                    return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            });
            return iterations;
        };
        skipSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var skipping = true;
            var iterations = 0;
            return new Iterator(function() {
                var step, k, v;
                do {
                    step = iterator.next();
                    if (step.done) {
                        if (useKeys || type === ITERATE_VALUES) return step;
                        else if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                        else return iteratorValue(type, iterations++, step.value[1], step);
                    }
                    var entry = step.value;
                    k = entry[0];
                    v = entry[1];
                    skipping && (skipping = predicate.call(context, v, k, this$0));
                }while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return skipSequence;
    }
    function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [
            iterable
        ].concat(values).map(function(v) {
            if (!isIterable(v)) v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
                v
            ]);
            else if (isKeyedIterable) v = KeyedIterable(v);
            return v;
        }).filter(function(v) {
            return v.size !== 0;
        });
        if (iters.length === 0) return iterable;
        if (iters.length === 1) {
            var singleton = iters[0];
            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) concatSeq = concatSeq.toKeyedSeq();
        else if (!isIndexed(iterable)) concatSeq = concatSeq.toSetSeq();
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function(sum, seq) {
            if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function(fn, reverse) {
            var iterations = 0;
            var stopped = false;
            function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function(v, k) {
                    if ((!depth || currentDepth < depth) && isIterable(v)) flatDeep(v, currentDepth + 1);
                    else if (fn(v, useKeys ? k : iterations++, this$0) === false) stopped = true;
                    return !stopped;
                }, reverse);
            }
            flatDeep(iterable, 0);
            return iterations;
        };
        flatSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(type, reverse);
            var stack = [];
            var iterations = 0;
            return new Iterator(function() {
                while(iterator){
                    var step = iterator.next();
                    if (step.done !== false) {
                        iterator = stack.pop();
                        continue;
                    }
                    var v = step.value;
                    if (type === ITERATE_ENTRIES) v = v[1];
                    if ((!depth || stack.length < depth) && isIterable(v)) {
                        stack.push(iterator);
                        iterator = v.__iterator(type, reverse);
                    } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
                return iteratorDone();
            });
        };
        return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function(v, k) {
            return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
    }
    function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);
            return iterations;
        };
        interposedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            var step;
            return new Iterator(function() {
                if (!step || iterations % 2) {
                    step = iterator.next();
                    if (step.done) return step;
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
        };
        return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function(v, k) {
            return [
                k,
                v,
                index++,
                mapper ? mapper(v, k, iterable) : v
            ];
        }).toArray();
        entries.sort(function(a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function(v, i) {
            entries[i].length = 2;
        } : function(v, i) {
            entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        if (mapper) {
            var entry = iterable.toSeq().map(function(v, k) {
                return [
                    v,
                    mapper(v, k, iterable)
                ];
            }).reduce(function(a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
        } else return iterable.reduce(function(a, b) {
            return maxCompare(comparator, a, b) ? b : a;
        });
    }
    function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function(i) {
            return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function(fn, reverse) {
            /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */ // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);
            var step;
            var iterations = 0;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
            return iterations;
        };
        zipSequence.__iteratorUncached = function(type, reverse) {
            var iterators = iters.map(function(i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function() {
                var steps;
                if (!isDone) {
                    steps = iterators.map(function(i) {
                        return i.next();
                    });
                    isDone = steps.some(function(s) {
                        return s.done;
                    });
                }
                if (isDone) return iteratorDone();
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                    return s.value;
                })));
            });
        };
        return zipSequence;
    }
    // #pragma Helper Functions
    function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
        if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
    function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
    }
    function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }
    function cacheResultThrough() {
        if (this._iter.cacheResult) {
            this._iter.cacheResult();
            this.size = this._iter.size;
            return this;
        } else return Seq.prototype.cacheResult.call(this);
    }
    function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) throw new TypeError('Expected iterable or array-like: ' + keyPath);
            iter = getIterator(Iterable(keyPath));
        }
        return iter;
    }
    createClass(Record, KeyedCollection);
    function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
            if (values instanceof RecordType) return values;
            if (!(this instanceof RecordType)) return new RecordType(values);
            if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
            }
            this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
    }
    Record.prototype.toString = function() {
        return this.__toString(recordName(this) + ' {', '}');
    };
    // @pragma Access
    Record.prototype.has = function(k) {
        return this._defaultValues.hasOwnProperty(k);
    };
    Record.prototype.get = function(k, notSetValue) {
        if (!this.has(k)) return notSetValue;
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    // @pragma Modification
    Record.prototype.clear = function() {
        if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record.prototype.set = function(k, v) {
        if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];
            if (v === defaultVal) return this;
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.remove = function(k) {
        if (!this.has(k)) return this;
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Record.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterator(type, reverse);
    };
    Record.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterate(fn, reverse);
    };
    Record.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
    }
    function recordName(record) {
        return record._name || record.constructor.name || 'Record';
    }
    function setProps(prototype, names) {
        try {
            names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
        // Object.defineProperty failed. Probably IE8.
        }
    }
    function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    }
    createClass(Set, SetCollection);
    // @pragma Construction
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    Set.of = function() {
        return this(arguments);
    };
    Set.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    Set.prototype.toString = function() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function(value) {
        return updateSet(this, this._map.set(value, true));
    };
    Set.prototype.remove = function(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function() {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetIterable(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (!iters.every(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (iters.some(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.merge = function() {
        return this.union.apply(this, arguments);
    };
    Set.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
    };
    Set.prototype.sort = function(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function(_, k) {
            return fn(k, k, this$0);
        }, reverse);
    };
    Set.prototype.__iterator = function(type, reverse) {
        return this._map.map(function(_, k) {
            return k;
        }).__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set.isSet = isSet;
    var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
        if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_SET;
    function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }
    createClass(OrderedSet, Set);
    // @pragma Construction
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    OrderedSet.of = function() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    OrderedSet.prototype.toString = function() {
        return this.__toString('OrderedSet {', '}');
    };
    function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack, IndexedCollection);
    // @pragma Construction
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack.of = function() {
        return this(arguments);
    };
    Stack.prototype.toString = function() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function() {
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function(iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) return this;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        });
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function() {
        return this.slice(1);
    };
    Stack.prototype.unshift = function() {
        return this.push.apply(this, arguments);
    };
    Stack.prototype.unshiftAll = function(iter) {
        return this.pushAll(iter);
    };
    Stack.prototype.shift = function() {
        return this.pop.apply(this, arguments);
    };
    Stack.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function(fn, reverse) {
        if (reverse) return this.reverse().__iterate(fn);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function(type, reverse) {
        if (reverse) return this.reverse().__iterator(type);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
   * Contributes additional methods to a constructor
   */ function mixin(ctor, methods) {
        var keyCopier = function(key) {
            ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
        // ### Conversion to other types
        toArray: function() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);
            this.valueSeq().__iterate(function(v, i) {
                array[i] = v;
            });
            return array;
        },
        toIndexedSeq: function() {
            return new ToIndexedSequence(this);
        },
        toJS: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJS === 'function' ? value.toJS() : value;
            }).__toJS();
        },
        toJSON: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
            }).__toJS();
        },
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, true);
        },
        toMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
        },
        toObject: function() {
            assertNotInfinite(this.size);
            var object = {};
            this.__iterate(function(v, k) {
                object[k] = v;
            });
            return object;
        },
        toOrderedMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
            return new ToSetSequence(this);
        },
        toSeq: function() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
            return '[Iterable]';
        },
        __toString: function(head, tail) {
            if (this.size === 0) return head + tail;
            return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
        },
        includes: function(searchValue) {
            return this.some(function(value) {
                return is(value, searchValue);
            });
        },
        entries: function() {
            return this.__iterator(ITERATE_ENTRIES);
        },
        every: function(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;
            this.__iterate(function(v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                    returnValue = false;
                    return false;
                }
            });
            return returnValue;
        },
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
        },
        forEach: function(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? '' + separator : ',';
            var joined = '';
            var isFirst = true;
            this.__iterate(function(v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : '';
            });
            return joined;
        },
        keys: function() {
            return this.__iterator(ITERATE_KEYS);
        },
        map: function(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;
            if (arguments.length < 2) useFirst = true;
            else reduction = initialReduction;
            this.__iterate(function(v, k, c) {
                if (useFirst) {
                    useFirst = false;
                    reduction = v;
                } else reduction = reducer.call(context, reduction, v, k, c);
            });
            return reduction;
        },
        reduceRight: function(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function() {
            return reify(this, reverseFactory(this, true));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function(predicate, context) {
            return !this.every(not(predicate), context);
        },
        sort: function(comparator) {
            return reify(this, sortFactory(this, comparator));
        },
        values: function() {
            return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods
        butLast: function() {
            return this.slice(0, -1);
        },
        isEmpty: function() {
            return this.size !== undefined ? this.size === 0 : !this.some(function() {
                return true;
            });
        },
        count: function(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function(grouper, context) {
            return countByFactory(this, grouper, context);
        },
        equals: function(other) {
            return deepEqual(this, other);
        },
        entrySeq: function() {
            var iterable = this;
            if (iterable._cache) // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
            entriesSequence.fromEntrySeq = function() {
                return iterable.toSeq();
            };
            return entriesSequence;
        },
        filterNot: function(predicate, context) {
            return this.filter(not(predicate), context);
        },
        findEntry: function(predicate, context, notSetValue) {
            var found = notSetValue;
            this.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    found = [
                        k,
                        v
                    ];
                    return false;
                }
            });
            return found;
        },
        findKey: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
        },
        findLast: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function() {
            return this.find(returnTrue);
        },
        flatMap: function(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function() {
            return new FromEntriesSequence(this);
        },
        get: function(searchKey, notSetValue) {
            return this.find(function(_, key) {
                return is(key, searchKey);
            }, undefined, notSetValue);
        },
        getIn: function(searchKeyPath, notSetValue) {
            var nested = this;
            // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {
            var iter = forceIterator(searchKeyPath);
            var step;
            while(!(step = iter.next()).done){
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) return notSetValue;
            }
            return nested;
        },
        groupBy: function(grouper, context) {
            return groupByFactory(this, grouper, context);
        },
        has: function(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function(iter) {
            iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
            return this.every(function(value) {
                return iter.includes(value);
            });
        },
        isSuperset: function(iter) {
            iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
            return iter.isSubset(this);
        },
        keyOf: function(searchValue) {
            return this.findKey(function(value) {
                return is(value, searchValue);
            });
        },
        keySeq: function() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function() {
            return this.toSeq().reverse().first();
        },
        lastKeyOf: function(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function(comparator) {
            return maxFactory(this, comparator);
        },
        maxBy: function(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
        },
        min: function(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function() {
            return this.slice(1);
        },
        skip: function(amount) {
            return this.slice(Math.max(0, amount));
        },
        skipLast: function(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function(predicate, context) {
            return this.skipWhile(not(predicate), context);
        },
        sortBy: function(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function(amount) {
            return this.slice(0, Math.max(0, amount));
        },
        takeLast: function(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function(predicate, context) {
            return this.takeWhile(not(predicate), context);
        },
        valueSeq: function() {
            return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
            return this.__hash || (this.__hash = hashIterable(this));
        }
    });
    // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
        return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
        // ### More sequential methods
        flip: function() {
            return reify(this, flipFactory(this));
        },
        mapEntries: function(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function(v, k) {
                return mapper.call(context, [
                    k,
                    v
                ], iterations++, this$0);
            }).fromEntrySeq());
        },
        mapKeys: function(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function(k, v) {
                return mapper.call(context, k, v, this$0);
            }).flip());
        }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
        return JSON.stringify(k) + ': ' + quoteString(v);
    };
    mixin(IndexedIterable, {
        // ### Conversion to other types
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        indexOf: function(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        lastIndexOf: function(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        reverse: function() {
            return reify(this, reverseFactory(this, false));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function(index, removeNum /*, ...values*/ ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);
            if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
            // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.
            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods
        findLastIndex: function(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        first: function() {
            return this.get(0);
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, false));
        },
        get: function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
                return key === index;
            }, undefined, notSetValue);
        },
        has: function(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function(separator) {
            return reify(this, interposeFactory(this, separator));
        },
        interleave: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);
            if (zipped.size) interleaved.size = zipped.size * iterables.length;
            return reify(this, interleaved);
        },
        keySeq: function() {
            return Range(0, this.size);
        },
        last: function() {
            return this.get(-1);
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function(zipper /*, ...iterables */ ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
        }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
        },
        includes: function(value) {
            return this.has(value);
        },
        // ### More sequential methods
        keySeq: function() {
            return this.valueSeq();
        }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes;
    // Mixin subclasses
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    // #pragma Helper functions
    function keyMapper(v, k) {
        return k;
    }
    function entryMapper(v, k) {
        return [
            k,
            v
        ];
    }
    function not(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    }
    function neg(predicate) {
        return function() {
            return -predicate.apply(this, arguments);
        };
    }
    function quoteString(value) {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    }
    function defaultZipper() {
        return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
        if (iterable.size === Infinity) return 0;
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function(v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
            h = 31 * h + hash(v) | 0;
        } : function(v) {
            h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
    }
    function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }
    var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
    };
    return Immutable;
});



var $1X5R2 = parcelRequire("1X5R2");
var $55c61384e4e198c2$exports = {};

var $55c61384e4e198c2$var$_ = (parcelRequire("krCrj")).runInContext();

$55c61384e4e198c2$exports = (parcelRequire("UF13C"))($55c61384e4e198c2$var$_, $55c61384e4e198c2$var$_);


var $53a31672b844dbfd$exports = {};
$53a31672b844dbfd$exports = "# organice will not reflow if there's hard-wrapped content\n# -*- eval: (auto-fill-mode 0) -*-\n\n* General\n\nAll user visible changes to organice will be documented in this file.\n\nWhen there are updates to the changelog, you will be notified and see a 'gift' icon appear on the top right corner.\n\n* [2026-09-10 Thu]\n** Added\n*** Web Push notifications for headings\n    - New Settings > Notifications area to enable reminders before SCHEDULED, DEADLINE, and active timestamps\n    - Each reminder type can be enabled and given its own lead time\n    - Tag cadences override the defaults for headings with a matching tag\n    - The feature is disabled when the browser does not support the Web Push API (or on iOS until organice is installed to the Home Screen)\n\n* [2026-07-09 Thu]\n** Fixed\n*** Default startup file setting\n    - Selecting a file to open on startup now automatically clears that option from other file settings\n    - PR: https://github.com/200ok-ch/organice/pull/1122\n\n* [2026-05-17 Sun]\n** Fixed\n*** Capture target file sync\n    - Fixed capture templates that target a startup-synced file so new entries are saved even while viewing another file\n    - PR: https://github.com/200ok-ch/organice/pull/1119\n\n* [2026-02-27 Fri]\n** Added\n*** Long-press drag and drop reordering for headers\n    - Long-press a header to drag and drop it with clear drop indicators on desktop and mobile\n    - Moving a parent header now keeps its subtree together and prevents dropping top-level headers into nested child lists\n    - PR: https://github.com/200ok-ch/organice/pull/1108\n\n* [2026-02-26 Thu]\n** Fixed\n*** Help/Sample modal for authenticated users\n    - Fixed an issue where clicking the question-mark help icon could show an empty Sample screen or get stuck on =Syncing ...=\n    - PR: https://github.com/200ok-ch/organice/pull/1106\n*** Unseen changelog gift icon in authenticated header\n    - Fixed the gift icon so opening changelog updates from the header renders the changelog modal correctly for logged-in users\n    - PR: https://github.com/200ok-ch/organice/pull/1107\n** Added\n*** Auto-continue lists with checkboxes in description editor\n    - When pressing Enter in an (unordered) checkbox list, the list\n      will be continued with a checkbox\n    - The new line has a checkbox with the same checked state as the\n      previous one (unchecked, checked, partially checked).\n\n    See [[https://orgmode.org/manual/Checkboxes.html][orgmode manual]] for more information on checkboxes.\n\n* [2026-02-12 Thu]\n\n** Changed\n\n*** Migrated search parser from pegjs to peggy\n    - pegjs is end of life (last commit 7+ years ago); peggy is the maintained fork\n    - PR: https://github.com/200ok-ch/organice/pull/1101\n\n** Added\n\n*** Auto-continue lists in description editor\n    - When editing a header description, pressing Enter after a list item (=- item= or =1. item=) automatically starts the next list item\n    - Ordered lists increment the number (=1.= → =2.= → =3.=)\n    - Pressing Enter on an empty list prefix removes it, exiting the list\n    - Works with both dash (=-=) and plus (=+=) unordered lists, and dot (=1.=) and paren (=1)=) ordered lists\n\n* [2026-02-11 Wed]\n\n** Added\n\n*** Harmonize modals for managing headers\n    - For capture templates, the '+' button or editing a header, now all modals have the same functionality\n    - Removes the old TitleEditorModal and DescriptionEditorModal components\n    - PR: https://github.com/200ok-ch/organice/pull/1099\n\n* [2026-02-10 Mon]\n\n** Fixed\n\n*** Theme/color scheme flash on startup\n    - Fixed a bug where the app would briefly show dark mode before switching to the configured light mode\n    - The color scheme is now applied immediately from localStorage before React renders, eliminating the visual flash\n\n*** Capture template crash when used before sync completes\n    - Fixed a crash where opening a capture template immediately after starting organice could cause the entire UI to go blank\n    - This happened because settings reloading from the sync backend regenerated template IDs, invalidating the open modal's reference\n\n* [2026-01-08 Thu]\n\n** Added\n\n*** UI for editing slash syntax in SCHEDULED timestamp repeaters\n    - When editing a SCHEDULED timestamp with a repeater, you can now set a deadline range using the slash syntax (e.g., =.+2d/3d=)\n    - This means \"do this task at most every 2 days, but at least every 3 days\"\n    - The slash UI only appears for SCHEDULED timestamps, not DEADLINE timestamps\n    - The deadline part can be removed by setting the value to 0\n    - Upstream documentation: https://orgmode.org/manual/Tracking-your-habits.html\n    - The parser already supported this syntax, but now you can edit it visually in the timestamp editor\n\n* [2026-01-07 Tue]\n\n** Added\n\n*** Org Habits consistency graph\n    - Visual consistency graph showing habit completion over time\n    - Color-coded status indicators matching Emacs org-mode:\n      - Green: Completed on this day\n      - Blue: Not due yet (in grace period)\n      - Yellow: Scheduled for this day, or due tomorrow\n      - Red: Overdue (you missed this day)\n    - Habits sorted before non-habits in agenda view\n    - Settings for graph configuration:\n      - Org habit preceding days (default: 21)\n      - Org habit following days (default: 7)\n      - Show all habits today\n    - Habits identified by =STYLE: habit= property\n    - Uses =:LOGBOOK:= entries to track completion history\n    - Automatically sets =LAST_REPEAT= property on completion\n\nSee the [[https://organice.200ok.ch/documentation.html#org_habits][documentation]] for more details on habit configuration and usage.\n\n** Fixed\n\n*** Settings reset to defaults when config file is missing fields\n\nBase settings (including Org habits settings) were being overwritten with =undefined= values when the sync backend config file didn't contain those fields. This happened when using an older config file or when settings were added after the initial config file was created.\n\nSettings now correctly persist from localStorage even when the config file is missing specific fields.\n\n*** PWA updates not applying on iOS Safari\n\nWhen deploying new versions of organice, iOS Safari users often didn't receive updates and had to remove/reinstall the PWA from their home screen.\n\nFixed by:\n- Adding =skipWaiting()= to force immediate service worker activation\n- Adding =clients.claim()= to ensure new service worker controls all clients immediately\n- Adding proper fetch event handler for cache-first strategy\n- Adding cache headers in =.htaccess= to prevent service worker file from being cached\n\n* [2025-12-01 Mon]\n\n** Added\n\n*** Add \"#\" and \"%\" as valid characters for tag searches\n\nPR: https://github.com/200ok-ch/organice/pull/1055\n\nThank you [[https://github.com/cperl82][cperl82]] for the PR🙏\n\n** Fixed\n\n*** Dropbox sorting\n\nThe old Dropbox sorting could do the wrong thing when the sort\ncomparator is called with the first argument being a file and the\nsecond argument being a folder.\n\nPR: https://github.com/200ok-ch/organice/pull/1054\n\nThank you [[https://github.com/cperl82][cperl82]] for the PR🙏\n\n*** On Chrome > 137: GitLab sign-in for private repository fails with \"Unexpected sign in error, please try again\"\n\nPR: https://github.com/200ok-ch/organice/pull/1061\n\nThank you [[github.com/mcwitt][mcwitt]] for the PR and [[https://github.com/dtvillafana][dtvillafana]] for support and testing🙏\n\n* [2025-10-22 Wed]\n\n** Changed\n\n*** \"Set scheduled datetime\" action uses two different icons\n\nIssue: https://github.com/200ok-ch/organice/issues/1052\n\n** Fixed\n\n*** Components/OrgFile/TimestampEditor: Incorrect Timestamp Format\n\nPR: https://github.com/200ok-ch/organice/pull/1053\nThank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-08-11 Mon]\n\n** Changed\n\n*** Refactored =TableEditorModal= from class to functional component\n\n- Converted TableEditorModal to a functional component for better maintainability\n- This refactor lays the groundwork for future table enhancements, including touch scrolling support\n- No functional changes to the TableEditorModal's behavior\n\nPR: https://github.com/200ok-ch/organice/pull/1043\nThank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-07-26 Sat]\n\n** Fixed\n\n*** Action Drawer buttons not clickable\n\nThe fix from yesterday introduced a regression. Now, we have a fix for\nthe regression and the initial bug report.\n\n* [2025-07-24 Thu]\n\n** Fixed\n\n*** Cannot open files at bottom of screen on mobile\n\n- Issue: https://github.com/200ok-ch/organice/issues/1044\n- Thank you [[https://github.com/chasecaleb][chasecaleb]] for the fix🙏\n\n* [2025-06-22 Sun]\n\n** Fixed\n\n*** When exporting to email, don't just export the selected headline, but sub-headlines\n\n** Added\n\n*** Users can now share their headlines (including sub-headlines) to any app - with a fallback to mail.\n\n- PR: https://github.com/200ok-ch/organice/pull/1036\n\n* [2025-06-18 Wed]\n\n** Fixed\n\n*** Made it harder to accidentally swipe left or right on headers\n\n- Changed swipe detection from fixed distance to relative distance (2x)\n- This reduces accidental swipes while maintaining intentional swipe functionality\n- PR: https://github.com/200ok-ch/organice/pull/1034\n- Thank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-06-06 Fri]\n\n** Fixed\n\n*** Repeater state changes will now always be filed to the correct header\n\n- =updatePlanningItemsWithRepeaters= now selects the header it intends to update\n\nPR: https://github.com/200ok-ch/organice/pull/1029\n\n* [2025-05-24 Sat]\n\n** Added\n*** Duplicate header via long-press on '+' icon\n\n- Long-pressing the '+' icon in the header action drawer now\n  duplicates the current header and its entire subtree.\n- Visual feedback for the long-press interaction has been\n  significantly enhanced with larger surrounding shadows for better\n  visibility, especially on touch devices.\n- Short-press on the '+' icon continues to add a new, empty header.\n\nPR: https://github.com/200ok-ch/organice/pull/1025\n\n** Fixed\n*** Table add/remove button inverted\n\nPR: https://github.com/200ok-ch/organice/pull/1024\n\n* [2025-05-22 Thu]\n\n** Changed\n\n*** Refactor and unify Docker setup for improved development and production builds\n\n  - Introduce a multi-stage =Dockerfile=. This file defines distinct\n    stages for =base=, =development=, =build=, and =production=,\n    ensuring optimized layers and dependencies.\n  - The production Docker image is lean, containing only necessary built assets and runtime dependencies.\n\nThis significantly simplifies Docker configuration management,\nenhances the developer experience when using Docker, and builds upon\nearlier work by @rogueai to create lean production images.\n\nThe PR is: https://github.com/200ok-ch/organice/pull/1023\n\n* [2025-05-06 Tue]\n\n** Added\n\n*** Add visual cue for overdue headers when displaying headers\n\n- Before this change: When enabling the setting \"Show Deadline\n  Display\", the respective deadline will be displayed on each header\n  line.\n- After this change, in the deadline will show in grey if not overdue\n  and in red if overdue.\n\nThis change was originally proposed and implemented by @dmorlitz:\nhttps://github.com/200ok-ch/organice/pull/970\n\nThe merged PR is: https://github.com/200ok-ch/organice/pull/1019\n\n** Fixed\n\n*** Resolved issue where search input field could scroll off-screen on iOS devices\n  - The search input in popups (like Search, Task List) will no longer\n    attempt to automatically focus on iOS. This prevents the field\n    from being pushed out of view by the virtual keyboard. iOS users\n    will now need to tap the input to activate it.\n  - On non-iOS platforms, the search input will now auto-focus with a\n    slight delay to improve usability.\n  - PR: https://github.com/200ok-ch/organice/pull/1018\n\n*** CI Tasks: docker build/push and deploy-prod\n\n- Building the docker image has been broken for some time.\n- Deploying to prod via CI had an issue since switching to parcel.\n\nBoth seem to be working as of commit\ne72d01081863e69f7410be87f09aeb2ac68e3c1d. There's no PR, because I\nmade these changes directly to the =master= branch, because these CI\ntasks should only run for production ready code.\n\n* [2025-04-11 Fri]\n\n** Changed\n\n*** Switch from CRA to parcel\n\nPR: https://github.com/200ok-ch/organice/pull/1014\n\nThis is a big one.\n\nWe've used Create React App as the main build tool which abstracted\nstuff like Babel config away from us. In a recent release, we upgraded\nfrom CRA v3 to v4 so we were able to upgrade some other dependencies.\nHowever, CRA is EOL:\nhttps://react.dev/blog/2025/02/14/sunsetting-create-react-app\n\n** Fixed\n\n- Upgrades: When upgrading from CRA v3 to v4, the upgrade process\n  broke. Clients that once started an old version of organice would\n  forever cache that one.\n  - Changing to Parcel (see above) also got rid of quite a bit of\n    complexity:\n    - Parcel has upstream capability to build scss which means we\n      could delete a good bit of code.\n    - Changelog Files are loaded not only at build time, but can be\n      changed while running the dev server.\n\n* [2025-04-05 Sat]\n\n** Fixed\n\n- Create a static =/manifest.json=\n  - This improves the PWA experience for people self hosting organice\n  - PR: https://github.com/200ok-ch/organice/pull/1013\n\n* [2025-04-04 Fri]\n\n** Fixed\n\n- Prevent accidental horizontal swipes during vertical scrolling on iOS\n  - Improved touch handling to detect vertical scrolling intent and prevent unwanted horizontal swipe actions\n  - PR: https://github.com/200ok-ch/organice/pull/1012\n\n* [2024-11-11 Mon]\n\n** Changed\n\n- No UI/UX changes, but lots of tooling upgrades\n- Major version technical upgrades\n  - nodejs (from 12 to 20)\n  - Create React App (from 3 to 4)\n  - eslint (from 6 to 7)\n  - node-sass to sass\n- Minor version technical upgrades\n  - redux-undo\n  - React\n\nPRs:\n\n- https://github.com/200ok-ch/organice/pull/1000\n- https://github.com/200ok-ch/organice/pull/999\n- https://github.com/200ok-ch/organice/pull/998\n\n* [2024-11-09 Sat]\n** Fixed\n\n- Prevent app crash when deleting a list item immediately after exiting edit mode\n  - PR: https://github.com/200ok-ch/organice/pull/996\n  - Thank you [[https://github.com/kjmatsuda][kjmatsuda]] for the PR🙏\n** Changed\n\n- doc: Clarify where to find docs (interactive tutorial vs. manual)\n  - PR: https://github.com/200ok-ch/organice/pull/991\n* [2024-09-19 Thu]\n\n** Added\n\n- Add a =flake.nix= file to provide a development shell for\n  [[https://nixos.org/][Nix]] users.\n  - PR: https://github.com/200ok-ch/organice/pull/987\n\n* [2023-11-15 Wed]\n\n** Added\n\n- Ability to print all content (including below the fold)\n  - PR: https://github.com/200ok-ch/organice/pull/969\n    \n* [2023-08-29 Tue]\n\n** Added\n\n- Capture template variable =%y= expanding to the raw year\n  - PR: https://github.com/200ok-ch/organice/pull/964\n\n** Fixed\n\n- Using a capture template that is available from all Org files, but should always capture to just one file (not necessarily the currently open one).\n  - PR: https://github.com/200ok-ch/organice/pull/965\n\n* [2023-04-11 Tue]\n\n** Changed\n\n- Ticking a checkbox should only tick the checkbox, not enable the list item manipulating functions from =handleListItemSelect=.\n  - Relevant discussion: https://github.com/200ok-ch/organice/discussions/950\n  - PR: https://github.com/200ok-ch/organice/pull/951\n\n* [2023-04-10 Mon]\n\n** Fixed\n- Color of unchecked checkbox in a list\n  - PR: https://github.com/200ok-ch/organice/pull/949\n\n* [2023-04-03 Mon]\n\n** Added\n\n- Implements list manipulation functions\n  - PR: https://github.com/200ok-ch/organice/pull/945\n  - Thank you [[https://github.com/kjmatsuda][kjmatsuda]] for the PR🙏\n    \n* [2023-01-28 Sat]\n\n** Fixed\n\n- On a header, don't cancel swipe due to vertical movements\n  - PR: https://github.com/200ok-ch/organice/pull/938\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n\n* [2023-01-09 Mon]\n\n** Fixed\n\n- Checking or unchecking a checkbox discards text with markup\n  - PR: https://github.com/200ok-ch/organice/pull/928\n  - Thank you [[https://github.com/saikiransathpadi][saikiransathpadi]] for the PR🙏\n\n- Don’t replace all leading =*= in the description\n  - Only when followed by a space, it would become a headline. Otherwise it’s markup for bold text.\n  - PR: https://github.com/200ok-ch/organice/pull/931\n\n* [2023-01-05 Thu]\n\n** Fixed\n\n- Deadline overlay UI improvements\n  - PR: https://github.com/200ok-ch/organice/pull/925\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n* [2023-01-04 Wed]\n\n** Added\n\n- Configuration option for a default Org file on startup.\n  - By default, when you start organice, it will display your root\n    file directory. If you prefer to display a specific Org file\n    instead, you can select it in the [[https://organice.200ok.ch/settings][file settings]].\n\n- Option to display DEADLINE values (near the clocking value) on each headline\n  - The default for this option is false - so there is no change to the default behavior - until you enable this option via Settings.\n  - PR: https://github.com/200ok-ch/organice/pull/891\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n** Fixed\n\n- Rotation of table editor icons to reflect their action.\n  - PR: https://github.com/200ok-ch/organice/pull/890\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n- Prevent the user from invalidating her Org file by entering a description that leads with =*=\n  - If the user starts any line with a =*=, wanting to start a new list, it is immediately converted to a =-=.\n  - PR: https://github.com/200ok-ch/organice/pull/920\n  - Thank you [[https://github.com/saikiransathpadi][saikiransathpadi]] for the PR🙏\n   \n\n** Changed\n\n- Disable auto-capitalization for search\n  - Before:\n    - When using the search or task list text inputs the Android/iOS keyboards automatically apply the shift key, meaning that the first character is capitalized.\n    - 99% of the time this is not what we want because:\n      - Having mixed case triggers a case sensitive search. This is quite confusing when I did not intentionally use capitalization, but it was added anyway. For example, I type \"and\", and it actually inputs and searches for \"And\", which yields no results.\n      - Many of the keywords in the search grammar are lower case, e.g., =deadline:=, =desc:=.\n  - Now: Auto-capitalization is turned off\n  - PR: https://github.com/200ok-ch/organice/pull/914\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n* [2022-12-03 Sat]\n** Fixed\n\n- Improve parser to read lines with multiple inline markup statements\n  - PR: https://github.com/200ok-ch/organice/pull/910\n  - Thank you [[https://github.com/lechten][lechten]] for the PR🙏\n\n* [2022-12-02 Fri]\n** Added\n- Filtering by description\n  - PR: https://github.com/200ok-ch/organice/pull/907\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n* [2022-11-02 Wed]\n** Fixed\n- Use correct HTML anchor tag inside public.html <noscript>\n  - PR: https://github.com/200ok-ch/organice/pull/902\n  - Thank you [[https://github.com/josephmturner][josephmturner]] for the PR🙏\n* [2022-07-08 Fri]\n** Fixed\n- When opening an Org file, show it from the top\n  - PR: https://github.com/200ok-ch/organice/pull/878\n- Changelog has a =Back= button in the HeaderBar\n  - PR: https://github.com/200ok-ch/organice/pull/882\n* [2022-07-06 Wed]\n** Fixed\n- Change log renders above previously opened view component\n  - PR: https://github.com/200ok-ch/organice/pull/869\n- Make HeaderBar sticky\n  - PR: https://github.com/200ok-ch/organice/pull/870\n* [2022-07-04 Mon]\n** Added\n- Setting to change textbox height in the description editor\n  - PR: https://github.com/200ok-ch/organice/pull/875\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n* [2022-06-30 Thu]\n** Changed\n- Upgrade Dropbox authentication flow: switch from OAuth to OAuth 2\n  and PKCE\n  - Rationale: Dropbox switched OAuth from long lived tokens to short\n    lived tokens.\n  - PR: https://github.com/200ok-ch/organice/pull/851\n* [2022-06-29 Wed]\n** Fixed\n- Undo looks like it is persisting changes, but it persisted old\n  state. Hence, reloading the file was bringing back the version of\n  the file before undoing.\n  - PR: https://github.com/200ok-ch/organice/pull/861\n** Changed\n- Simplify UX in task modal\n  - \"Change todo keyword set\" is now an explicit button. Also, it's\n    only shown when there is more than one todo keyword set configured\n    for the current Org file.\n  - Todo keywords can be selected and unselected on the same button.\n    No trash can necessary to unselect a todo keyword..\n  - PR: https://github.com/200ok-ch/organice/pull/862\n** Added\n- Ability to delete header from task modal.\n  - PR: https://github.com/200ok-ch/organice/pull/862\n* [2022-06-22 Wed]\n** Added\n- Ability to handle empty files\n  - This takes care of a big UX problem for users who solely rely on organice. So far, we've shown a parser error if the file is empty *or* if the file did not contain a headline.\n  - Now, if the user opens a file that is empty, or has no headlines, she will see the call to action to create a new headline.\n  - PR: https://github.com/200ok-ch/organice/pull/853\n* [2022-06-16 Thu]\n** Added\n- Capture template variables =%r= and =%R= expanding to raw timestamps\n  - PR: https://github.com/200ok-ch/organice/pull/838\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n* [2022-06-14 Tue]\n** Added\n- Create new file from file browser\n  - PR: https://github.com/200ok-ch/organice/pull/818\n* [2022-06-13 Mon]\n** Added\n\n- Specify default webDAV URL in .env file\n  - PR: https://github.com/200ok-ch/organice/pull/829\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n- Docker image recognizes env vars\n  - PR: https://github.com/200ok-ch/organice/pull/835\n  - see [[https://organice.200ok.ch/documentation.html#docker][doc]] for more information\n\n* [2022-06-03 Fri]\n** Removed\n- Google Drive support. This backend had a few issues:\n  1. We waited [[https://github.com/200ok-ch/organice/issues/127][for years for Google to put the Google Drive API into\n     production mode]]. Without that, only very few people were actually\n     allowed by Google to use organice with Google Drive. A lot of\n     time and effort went into this from quite a few of people. Even\n     Google employees tried to expedite from within Google, but to no\n     avail. The maintainers of organice gave up on this issue since\n     [[https://github.com/200ok-ch/organice/issues/127#issuecomment-655339244][July 2020 and announced]] that the support for Google Drive will be\n     removed unless someone steps up and takes over this task. Nobody\n     did in the two years since, so we're removing it.\n  2. [[https://github.com/200ok-ch/organice/issues/109][Replace integration of Google Drive through <script> include in index.html with NPM module]]\n  3. [[https://github.com/200ok-ch/organice/issues/107][Sign in to Google Drive from new versions of Chrome dysfunctional]]\n\n* [2022-06-01 Wed]\n** Added\n   - Proper Landing Page\n     - PR: https://github.com/200ok-ch/organice/pull/809\n* [2022-02-23 Wed]\n** Fixed\n   - [[https://organice.200ok.ch/documentation.html#in_buffer_settings][In-buffer settings]] can be in lowercase or uppercase. Before, they\n     had to be in uppercase.\n     - PR: https://github.com/200ok-ch/organice/pull/776\n   - Manifest for PWAs\n     - Before, the 'install' button did not appear for Android devices\n       and both Chrome and Firefox showed warnings for the manifest.\n     - Issue: https://github.com/200ok-ch/organice/issues/779\n     - PR: https://github.com/200ok-ch/organice/pull/781\n     - Thank you [[https://github.com/tbruckmaier][tbruckmaier]] for the PR🙏\n\n* [2021-12-09 Thu]\n** Fixed\n   - Title editor text loss.\n     - Since the introduction of the semantic Title editor on [2021-11-22 Mon], if you modified the text of a title and then click a todo, the todo keyword got saved which triggers a rerender before the text got saved. Therefore the text is reset to the state it was in when the title editor was opened.\n     - This is fixed, now.\n* [2021-12-05 Sun]\n** Added\n   - *EPIC* Bookmark functionality for search\n     - After entering a search string, you can bookmark it using the ⭐ button.\n     - Bookmarked search strings populate the suggestions if no search string is entered into the input field.\n     - Bookmarks are saved by context, so there are separate bookmarks for search, task-list, and refile.\n     - There are at most ten bookmarks for a context. Newly saved bookmarks are inserted at the top of the list. If the list gets too long, the last search strings are dropped. Duplicate bookmarks are dropped too. The list of bookmarks is ordered by last used.\n     - Bookmarks are unaware of file context. Therefore, you always have the same bookmarks.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/758\n* [2021-11-22 Mon]\n** Changed\n   - Title and Description fields are not edited as raw text by default.\n     - Instead, a semantic editor comes up when editing them.\n     - To edit raw values, click the 'edit' icon, again.\n   - Search and Task List open in one modal with tabs.\n     - Modal opens to \"Search\" by default, but remembers what was opened last.\n   - If there are open clocks, a third modal \"Clock List\" is added\n     that looks like \"Search\" for =clock:now= without the search input\n     field.\n   - Notes can be multi-line and are properly indented.\n* [2021-11-09 Tue]\n** Added\n   - Setting to respect OS light/dark-mode preferences\n     - organice already queried the OS for light/dark-mode preference. But changing the setting in organice would override the OS preference.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/749\n** Fixed\n   - Fix repeater adjusting time of date when using =.+=\n     - When repeaterUnit is not \"h\", hour and minutes are never touched.\n     - When repeaterUnit is \"h\", hour and minutes are set to n hour(s) from now (as it was already implemented before this fix).\n   - Relevant PR: https://github.com/200ok-ch/organice/pull/746\n* [2021-11-03 Wed]\n** Fixed\n   - Fix GitLab OAuth token refresh\n     - PR: https://github.com/200ok-ch/organice/pull/740\n     - Thank you [[https://github.com/chasecaleb][chasecaleb]] for the PR🙏\n* [2021-11-01 Mon]\n** Added\n   - *EPIC* Add GitLab as a sync back-end\n     - PR: https://github.com/200ok-ch/organice/pull/734\n     - Thank you [[https://github.com/chasecaleb][chasecaleb]] for the PR🙏\n* [2021-10-29 Fri]\n** Fixed\n   - Loading settings when using WebDAV as synchronization back-end\n     - PR: https://github.com/200ok-ch/organice/pull/727\n     - Thank you [[https://github.com/mcordell][mcordell]] for the PR🙏\n\n* [2021-05-16 Sun]\n** Added\n   - Parse and preserve habit timestamp ranges\n     - A timestamp may have minimum and maximum ranges specified by using the syntax =.+2d/3d=, which says that you want to do the task at least every three days, but at most every two days.\n     - Upstream documentation:\n       https://orgmode.org/manual/Tracking-your-habits.html\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/674\n     - Thank you [[https://github.com/tomonacci][tomonacci]] for the PR🙏\n\n* [2021-05-13 Thu]\n\n** Changed\n   - Agenda starts on Monday by default (as it does in Emacs Org mode)\n\n** Added\n   - Ability to set the \"Start of week for weekly agenda\" in the Settings\n     - Akin to the Emacs org mode variable =org-agenda-start-on-weekday=\n   - Relevant PRs:\n     - https://github.com/200ok-ch/organice/pull/676\n       - Thank you [[https://github.com/tomonacci][tomonacci]] for the PR🙏\n     - https://github.com/200ok-ch/organice/pull/677\n\n* [2020-12-29 Tue]\n** Added\n   - *EPIC*: Multiple file support\n     - Agenda, Search, Task List, Refile and Capture Templates have the ability to work on multiple files.\n     - You can adjust the behavior for these on a file per file basis by creating \"file settings\" in the settings menu.\n\n   - *EPIC*: Offline file support\n     - Every file opened in organice will automatically be cached on your device.\n     - When visiting the file, again, it will immediately be loaded from the local storage and then loaded from the remote back-end.\n     - That makes loading and switching between files instant _and_ gives you the ability to work on multiple files when being offline.\n\n   - Relevant PRs:\n     - https://github.com/200ok-ch/organice/pull/550\n     - https://github.com/200ok-ch/organice/pull/560\n     - https://github.com/200ok-ch/organice/pull/565\n     - https://github.com/200ok-ch/organice/pull/574\n     - https://github.com/200ok-ch/organice/pull/575\n     - https://github.com/200ok-ch/organice/pull/570\n     - https://github.com/200ok-ch/organice/pull/607\n\n* [2020-11-21 Sat]\n\n** Added\n   - When going to the Agenda view, the selected tab is persisted - meaning it will be pre-selected when you go to the Agenda next time.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/562\n\n** Fixed\n   - Having an active timestamp with a repeater was broken.\n     - When the TODO state changes for a header that has a repeater (either as SCHEDULED, DEADLINE or active timestamp), a log entry is written and the timestamp is updated.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/568\n   - Removing an active timestamp was broken.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/568\n\n* [2020-11-20 Fri]\n** Fixed\n   - organice understands =:PROPERTIES:= drawers and smartly parses the values in case one of the values is a timestamp.\n     - However, parsing all the values and saving the parsed result in any case will lead to wrong results. Most values of properties are just plain text and non-interactive things in Org mode.\n     - For example, a value like =something_with_underscores= would have been treated as 'underlined text' which doesn't make sense for a property drawer. When saving the value back, organice would have squashed the underlines.\n     - Now, the values are used and preserved as they are. Timestamps still work, of course.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/578\n* [2020-11-15 Sun]\n** Fixed\n   - When repeating a task, an active date timestamp was logged instead of an inactive datetime timestamp.\n\n* [2020-11-14 Sat]\n** Fixed\n   - The task list was not scrollable on Android.\n      - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/561][PR]] 🙏\n\n* [2020-11-08 Sun]\n** Changed\n   - Safeguard against selecting text by accident.\n      - Before this change, it was possible to select text when doing a 'swipe'.\n      - Now, selecting/copying text is only possible in 'edit mode', effectively safeguarding against accidentally selecting text.\n      - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/557][PR]] 🙏\n\n\n* [2020-11-06 Fri]\n** Added\n   - Additional themes. You now can choose between:\n     - Solarized\n     - One\n     - Gruvbox\n     - Smyck\n     - Code\n   - All of these are themes work in light and dark mode!\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/540][PR]] 🙏\n\n* [2020-11-01 Sun]\n\n** Changed\n   - We have enabled some default settings by default, because they are reasonable for a new user:\n     - =shouldStoreSettingsInSyncBackend=, because it enables using organice on multiple clients.\n     - =shouldLiveSync=, because it reduces the chance to have a conflict in the open Org file.\n     - =shouldSyncOnBecomingVisibile=, because it reduces the chance to have a conflict in the open Org file.\n   - =bulletStyle= is set to \"Fancy\", because it looks more visually pleasing than an asterisk (*) and hence makes organice look better on a first test run.\n   - If you personally do not want them enabled, you can disable them separately in the [[/settings][settings]] any time.\n\n** Fixed\n   - organice has various settings that the user can configure. Before manual configuration, there organice loads sane defaults. Loading and persisting some of these defaults was buggy before.\n     - Loading and persisting of defaults works now.\n     - Previously saved wrong values are removed from =localStorage= to reduce future bug potential.\n     - Changing this is - strictly speaking - not visible to the end-user, so it wouldn't ordinarily show up in this changelog. However, since it makes changes to the already saved settings (in cleaning up old faulty values), it theoretically could introduce a bug in the settings. Hence, the change is added to the changelog.\n     - Related PRs:\n       - https://github.com/200ok-ch/organice/pull/552\n       - https://github.com/200ok-ch/organice/pull/553\n       - https://github.com/200ok-ch/organice/pull/554\n* [2020-10-25 Sun]\n** Changed\n   - The 'focus header' feature is renamed.\n     - /Narrowing/ means focusing on this header, making the rest temporarily inaccessible.\n     - Canceling the narrowing, which makes all headers once again accessible, is called /widening/.\n* [2020-10-23 Fri]\n** Added\n   - Add 'dark mode' next to 'light mode' as a setting.\n     - Both themes are based on the popular [[https://ethanschoonover.com/solarized/][Solarized]] color palette.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/527][PR]] 🙏\n   - Add 'recursive clock times in search'.\n     - The =clock:= search term now includes headers that have time logged on their children.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/524][PR]] 🙏\n\n* [2020-10-20 Tue]\n** Added\n   - Add 'time range' queries to search for planning items (SCHEDULED and DEADLINE), plain active timestamps or clocked work time.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/505][PR]] 🙏\n* [2020-10-19 Mon]\n** Added\n   - When a header is focused, and the user uses the 'search' or 'task list' feature, then the searched header list is automatically narrowed to only subheaders of the originally focused header.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/517][PR]] 🙏\n* [2020-10-10 Sat]\n** Added\n   - Display time summaries for clock entries in each subtree\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/497][PR]] 🙏\n\n** Changed\n\n   - Improve header stickiness\n     - The header bar was not always sticky for longer documents and the therefore some functionality was hard to reach (the user had to scroll to the top to reach it).\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/499][PR]] 🙏\n\n* [2020-10-07 Wed]\n** Added\n\n   - Added Documentation on [[https://orgmode.org/manual/Repeated-tasks.html][repeaters]] and [[https://orgmode.org/manual/Deadlines-and-scheduling.html#Deadlines-and-scheduling][delays]] to =sample.org= and to mouseovers for the relevant buttons.\n\n* [2020-09-20 Sun]\n** Added\n\n   - Recognize US and Swiss phone numbers and make them clickable\n   - Next to 'canonical' phone numbers like +49123456789, also recognize:\n     - US phone numbers:\n       - 123-456-7890\n       - (123) 456-7890\n       - 123 456 7890\n       - 123.456.7890\n       - +91 (123) 456-7890\n     - Swiss phone numbers:\n       - 0783268674\n       - 078 326 86 74\n       - 041783268675\n       - 0041783268674\n       - +41783268676\n       - +41783268677\n\n* [2020-09-07 Mon]\n** Added\n   - Added the capability to chose the start screen when installing organice to the homescreen.\n     - More information on how to install organice like this, see https://organice.200ok.ch/documentation.html#installation\n* [2020-09-05 Sat]\n\n** Fixed\n  - Search and Todo List modals could be moved off screen on iOS since [2020-08-30 Sun]. The fix is to disable =autoFocus= on iOS. The rationale for that documented here: https://github.com/200ok-ch/organice/pull/462\n\n* [2020-08-30 Sun]\n\n** Added\n   - Add note to header (=M-x org-add-note=)\n     - This adds a button for taking notes to tasks (org-add-note). They will be prepended to the header contents after :PROPERTIES: and before the :LOGBOOK:\n   - Auto-focus filter input fields (search and task-list)\n\n* [2020-08-29 Sat]\n** Fixed\n   - If a user folds a header, all its subheaders should collapse as well, so that when the user reopens it, they stay closed.\n     - The previous behavior is buggy in a way that it keeps the subheaders open as they were, restoring their openness when the header is unfolded.\n     - The previous behavior is useful, though. So this change introduces a user setting to toggle the behaviour.\n   - Thank you [[https://github.com/necto][necto]] for your [[https://github.com/200ok-ch/organice/pull/440][PR]] 🙏\n\n* [2020-08-25 Tue]\n** Fixed\n   - Updating table cell values and removing table rows or colums was\n     not undoable\n     - Thank you [[https://github.com/necto][necto]] for your [[https://github.com/200ok-ch/organice/pull/432][PR]] 🙏\n\n* [2020-07-28 Tue]\n** Fixed\n   1. Sync stuck when working in the background\n     - When the user put organice into the background during a sync and comes back, organice was stuck in sync mode, but doesn't actually sync anymore. This means that any new changes to the Org file will not be persisted. This is due to mobile browsers cutting off most resources to browser apps in the background, so organice cannot guarantee that a sync happens properly in the background.\n     - It's not trivial to find out if the job is stuck\n       - Time is not a good indicator as bigger files on slower connections will always take longer.\n       - There's no JS API to reliably find out if the browser just got back from the background or is put into the foreground. The [[https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API][=visibilitychange= API]] just triggers for both these events.\n     - Hence, the implementation is generic in nature: Whenever the user hits the 'sync' button, an actual 'sync' is forced - even if organice thinks there's currently a sync in progress or that it should be debounced. That makes sense, because manual actions by the user should always be obeyed.\n     - Closes issue https://github.com/200ok-ch/organice/issues/252\n   - 2. On iOS >13.1, when organice is used in SPA mode (as a bookmark on the homescreen), and the user navigates away from the original bookmark, a huge URL Bar would show up with a \"Done\" button. This is a regression in how iOS handles full-screen SPAs. These are the relevant APIs:\n     - https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariHTMLRef/Articles/MetaTags.html\n     - https://developer.mozilla.org/en-US/docs/Web/Manifest/display\n   - 3. Feature detection for =crypto.subtle= module\n     - This is used for change detection in the changelog. The module is only available in secure contexts. Hence, when used locally and on a private IP range, depending on the browser, it might not be available.\n\n* [2020-07-08 Wed]\n** Added\n   - Allow template-variables in the header-path in a capture template\n     - Thank you [[https://github.com/jayesh-bhoot][jayesh-bhoot]] for your [[https://github.com/200ok-ch/organice/pull/387/][PR]] 🙏\n* [2020-06-14 Sun]\n** Added\n   - Allow capture templates to insert at beginning or end of file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/324][PR]] 🙏\n* [2020-06-05 Fri]\n** Fixed\n   - =file:= links are sanity checked before opened\n     - =file:= links opened in iOS from the PWA view will not open Mobile Safari\n     - Open issue: Some links will be opened as directories when the\n       link is not really going towards a directory.\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/311][PR]] 🙏\n\n* [2020-06-03 Wed]\n** Added\n   - =TODO= keyword sets can now be anywhere in the file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/310][PR]] 🙏\n* [2020-05-30 Sat]\n\n** Added\n   - Make local =file:...= links navigate to the relevant file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/307][PR]] 🙏\n\n* [2020-05-06 Wed]\n\n** Fixed\n   - Planning items now respect the new hard-indent setting.\n\n* [2020-05-05 Tue]\n\n** Fixed\n   - Append new tags correctly to title.\n     - If a header didn't have tags before, the first tags were\n       erroneously appended without a space.\n\n* [2020-04-06 Mon]\n\n** Added\n   - Support org-adapt-indentation\n     - By default, the metadata body (including deadlines and drawers) of an exported org heading is indented according to its level. If instead you prefer to keep your body text flush-left, i.e.{' '}\n     - Thank you [[https://github.com/cpbotha][cpbotha]] for your [[https://github.com/200ok-ch/organice/pull/272][PR]] 🙏\n\n* [2020-04-05 Sun]\n** Added\n   - Support for org-log-into-drawer TODO state logging\n     - Thank you [[https://github.com/cpbotha][cpbotha]] for your [[https://github.com/200ok-ch/organice/pull/271][PR]] 🙏\n** Fixed\n   - Settings screen has proper title and \"back\" button\n\n* [2020-03-27 Fri]\n** Fixed\n   - Help texts for widen/narrow were reversed\n     - Thank you [[https://github.com/obar][@obar]] for the [[https://github.com/200ok-ch/organice/pull/270][PR]] 🙏\n\n* [2020-02-29 Sat]\n\n** Fixed\n   - As a user, when I visit Search, Task List or Agenda whilst having\n     a dirty file, I'm not getting a pop up a dialogue notifying me\n     about unpushed changes\n\n* [2020-02-17 Mon]\n\n** Added\n   - *Headers with active timestamps in the header or description appear in agenda*\n\n** Fixed\n   - 'Insert timestamp' for headers and descriptions\n\n* [2020-02-09 Sun]\n\n** Added\n   - Comprehensive documentation: https://organice.200ok.ch/documentation.html\n     - You can find the link from the 'settings' screen or on top of\n       the readme.\n\n* [2020-01-27 Mon]\n\n** Fixed\n   - When editing a =:LOGBOOK:= drawer within a headers description,\n     the relevant logbook entries are updated (which might entail them\n     being deleted).\n\n* [2020-01-20 Mon]\n\n** Fixed\n   - When refiling a header, don't show subheaders in the refile drawer\n   - When doing a 'Search' or 'Refile', the action is reflected in the\n     name of the opening drawer.\n   - In the agenda view, fix relative time distance for future dates\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/240][PR]] 🙏\n\n* [2020-01-15 Wed]\n\n** Fixed\n   - Put Floating Action Button \"Move a header\" into the middle of the\n     screen, so that it has enough space to render all arrows on\n     mobile devices.\n\n* [2020-01-14 Tue]\n\n** Added\n   - Notify on changes for changelog\n     - This is done with a similar UX than other productivity apps\n       (like Slack) do it. The user will see a 'gift' icon whenever\n       there's a change to the changelog she has not seen, yet.\n\n* [2020-01-13 Mon]\n\n** Added\n   - \"Show Org filename in Header\" is configurable in settings and\n     off by default\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/229][PR]] 🙏\n\n** Fixed\n   - Show error message when using a capture template with a badly\n     configured header path\n\n* [2020-01-12 Sun]\n\n** Added\n   - Make HeaderBar sticky\n     - Making undo/redo, file browser and help always available\n       (before it was required to scroll all the way to the top)\n   - Deselect headline by clicking into the title (or empty space) in\n     the HeaderBar\n   - Show Org filename in Header\n\n** Fixed\n   - *Major synchronization improvements*\n     1. After undo/redo, synchronize Org file\n     2. Debounce Sync\n        1. When a user changes things quickly (which happens easily\n           when having 'live sync' enabled and using undo/redo for\n           example), multiple syncs ran in parallel. The back-ends\n           will either get confused or fail with errors (429 too many\n           write operations). In any case, likely the last written\n           state would not have been the state of the Org file in\n           organice.\n     3. Safeguard against concurrent sync requests to the back-end\n     4. In case of synchronization error, show the error to the user\n        and retry synchronization\n     5. Don't actually sync a whole Org file for an empty header.\n        When the user adds some data and triggers\n        UPDATE_HEADER_TITLE, then it makes sense to save it.\n\n* [2020-01-11 Sat]\n\n** Added\n   - All HeaderActionItems are undoable and redoable\n\n** Fixed\n   - Parsing planning items followed by a checkbox\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/222/files][PR]] 🙏\n* [2020-01-07 Tue]\n\n** Added\n   - *Refile*\n     - When reviewing the captured data, you may want to refile or to\n       copy some of the entries into a different list, for example\n       into a project.\n   - Add button in HeaderActionBar to open property editor\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/195][PR]] 🙏\n\n** Changed\n   - All HeaderActionDrawer actions have icons. The icons are\n     documented in sample.org and have a mouseover title.\n\n* [2020-01-04 Sat]\n\n** Added\n   - Ability to search headlines\n     - It has the same syntax as the search field in the Task List\n       feature\n\n** Fixed\n   - Sort order in Task List\n     - Tasks were only ordered by their planning item dates. This\n       implied that tasks that were long DONE would be shown first.\n     - Now, tasks in the Task list are sorted by state and then date.\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/207][PR]] 🙏\n\n\n* [2020-01-02 Thu]\n\n** Added\n   - Place cursor after the TODO keyword when creating a new header\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/193][PR]] 🙏\n   - Highlight verbatim markup\n\n** Changes\n   - Highlight cookies and cookie percentages according to Solarized\n     color scheme\n\n** Fixed\n   - Don't update search results when using an invalid search filter\n   - On mobile: Styling of Search / Task List drawer when searching all\n     headlines\n   - On mobile: Ability to scroll Search / Task List\n   - Teach #+TODO parser to understand (..) suffix\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/202][PR]] 🙏\n\n* [2020-01-01 Wed]\n\n** Added\n   - Support single- and double-quoted strings in the search filter\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/176][PR]] 🙏\n   - Trim whitespace for entered or updated headlines\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/177][PR]] 🙏\n\n** Fixed\n   - Capture templates in iOS 13.3 are positioned properly\n     - iOS 13 introduced a styling regression when setting focus\n       without user interaction. iOS 13.3 reverts to the way other\n       browsers do it.\n\n** Changed\n   - Revert \"Move HeaderActionDrawer before headline\"\n     - As per #188, the changes introduced in #100 didn't fare well\n       with the community. Hence, as a first step to improve UX,\n       we're reverting to the previous state.\n\n* [2019-12-31 Tue]\n\n** Added\n   - *Searching of headlines/todos with a composable query language*\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/154][PR]] 🙏\n   - Routing for Settings (/settings) and Sample (/sample)\n   - Routing for Agenda and TaskList\n\n** Changes\n   - The action for capture templates now uses a more idiomatic\n     'plus' icon instead of a 'list' icon\n\n* [2019-12-28 Sat]\n\n** Added\n   - Proper coloring of DONE todoKeywords from custom todo sequences\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/165][PR]]!\n   - Place TODO keyword of previous header in the new header\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/164][PR]]!\n\n** Changed\n   - Refactor current Org parser and regex\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/161][PR]]!\n\n* [2019-12-26 Thu]\n\n** Added\n\n   - \"Share\" button for headlines (sharing via email)\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/145][PR]]!\n   - Automatically render links for URLs with www prefix, but without\n     protocol\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/159][PR]]!\n\n* [2019-12-25 Wed]\n\n** Added\n\n   - Suggestion list for inputs in property editor\n     - To minimize typing and typos, add smart completion for property\n       names and values in the PropertyListEditorModal.\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/144][PR]]!\n\n* [2019-12-24 Tue]\n** Added\n\n   - *Automatically render links for URLs, e-mail addresses and phone\n     numbers*\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/147][PR]]!\n\n   - Suggestion list for inputs in tag editor\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/149][PR]]!\n\n* [2019-12-17 Tue]\n** Changed\n   - Improve webdav url input\n     - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/139][PR]]!\n** Fixed\n   - Make \"privacy policy\" sticky to the bottom of the landing page\n     - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/140][PR]]!\n\n* [2019-12-15 Sun]\n\n** Changed\n   - UX: Move Org header actions before selected headline\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/136][PR]]!\n\n** Fixed\n   - Android PWA implementation was broken (issue [[https://github.com/200ok-ch/organice/issues/134][#134]])\n     - It required two more icon sizes\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/135][PR]]!\n\n* [2019-12-10 Tue]\n\n** Added\n\n   - *Docker Support*\n   - The CI/CD workflow now also builds a Docker container which is\n     then published to\n     https://hub.docker.com/repository/docker/twohundredok/organice\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/133][PR]]!\n\n* [2019-12-08 Sun]\n\n** Added\n\n   - As a user, when I'm on a headline with a planning item (schedule\n     or deadline), I want to be able to remove it.\n\n* [2019-11-29 Fri]\n\n** Fixed\n\n   - Clicking the Timestamp in a TODO within the agenda toggles from\n     the date to a human readable timespan\n\n* [2019-11-27 Wed]\n\n** Added\n\n   - Instructions on configuring Nextcloud+haproxy to allow WebDAV\n   - Documentation on how to share from Nextcloud using WebDAV\n   - Thank you [[https://github.com/runejuhl][runejuhl]] for your [[https://github.com/200ok-ch/organice/pull/122][PR]]!\n\n* [2019-11-25 Mon]\n\n** Added\n   - Honor the 'nologrepeat' option\n     - It can be set via =#+STARTUP:= or as a property\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/119][PR]]!\n\n* [2019-11-22 Fri]\n\n** Fixed\n\n   - Handle non-clock entries in =:LOGBOOK:= drawers\n     - Fixes [[https://github.com/200ok-ch/organice/issues/111][issue #111]], [[https://github.com/200ok-ch/organice/issues/108][issue #108]] and [[https://github.com/200ok-ch/organice/issues/110][issue #110]]\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/112][PR]]!\n\n* [2019-11-21 Thu]\n\n** Fixed\n\n   - Safeguard against potential Dropbox SDK Bug\n     - More information in [[https://github.com/200ok-ch/organice/issues/108][issue #108]]\n\n* [2019-11-19 Tue]\n\n** Changed\n\n   - Don't put newlines after headers with no content, add newline at EOF\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/106][PR]]!\n\n* [2019-11-14 Thu]\n\n** Added\n\n   - *Clocking work time*\n     - Org mode allows you to clock the time you spend on specific\n       tasks in a project:\n       https://orgmode.org/manual/Clocking-Work-Time.html#Clocking-Work-Time\n     - organice is compatible with logbook clocking, now\n     - You can 'clock in' and 'clock out' to a header\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/103][PR]]!\n\n* [2019-10-31 Thu]\n\n** Fixed\n   - Keep all in-file settings and content lines from top of file\n     - Thank you [[https://github.com/andersjohansson][@andersjohansson]] for your [[https://github.com/200ok-ch/organice/pull/90][PR]]!\n\n* [2019-10-29 Tue]\n\n** Added\n   - Show login options as clickable links with cursor pointer\n   - Also improve wording with regards to login options\n     - Thank you [[https://github.com/rodrigomaia17][@rodrigomaia17]] for your [[https://github.com/200ok-ch/organice/pull/88][PR]]!\n\n\n* [2019-10-26 Sat]\n\n** Added\n   - *WebDAV as a sync backend!*\n     - Thank you [[https://github.com/TristanCacqueray][@TristanCacqueray]] for your [[https://github.com/200ok-ch/organice/pull/82][PR]]!\n\n   - As a user, when I swipe a header, I want the icon to contrast\n     the background, so that better see the action taken\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/78][PR]]!\n\n   - As a user, when I hover a clickable element, I want my cursor to\n   change, so that I can see that it is clickable.\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/79][PR]]!\n\n** Fixed\n   - Do not throw an error when clearing a planning item\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/81][PR]]!\n\n* [2019-10-02 Wed]\n\n** Fixed\n\n- On iOS 13, fix the regression which made capture input fields hide\n  under the keyboard\n  - More information and screenshots in the ticket: https://github.com/200ok-ch/organice/issues/46\n  - Turns out this issue is non trivial to fix and requires specific\n    rules for every size of iPhone. I tested against the Xs and 6s. If\n    you have a different form factor and the capture template input\n    screen looks off to you, please send me a screenshot of what it\n    looks like and I'll add the dimensions for your form factor right\n    away!\n\n* [2019-09-28 Sat]\n\n** Added\n\n- Implemented a =redo= Button next to the =undo= button\n\n* [2019-09-21 Sat]\n\n** Fixed\n\n- Parser bug which would interpret *bold* statements in the beginning\n  of a line as a header.\n- Parser bug which would delete newlines between headers and items\n\n** Changed\n\n- @MTrost [[https://github.com/200ok-ch/organice/pull/45][introduced]] a new testing library called [[https://testing-library.com/docs/intro][React Testing\n  Library]] which greatly simplified writing interaction tests.\n\n* [2019-09-19 Thu]\n\n** Changed\n\n- Constraining to a max width and centering for tablets and bigger\n\n* [2019-09-15 Sun]\n\n** Fixed\n\n- The 'Sync on application becoming visible' feature works on iOS and\n  Safari\n  - If enabled, the current org file is pulled from the sync backend\n    when the browser tab becomes visible. This prevents you from\n    having a stale file before starting to make changes to it.\n\n* [2019-09-08 Sun]\n** Added\n\n- Documented how to use organice from a bookmarklet using the capture\n  template feature\n\n* [2019-09-06 Fri]\n** Fixed\n\n- Removed Google Analytics tracking, because it has no place here\n\n* [2019-09-02 Mon]\n\n** Added\n\n- Configure Google Drive for the free community version of organice at\n  https://organice.200ok.ch\n- Documented SPA routing for self-hosting\n- Wrote and publicized a Privacy Policy\n\n* [2019-08-27 Tue]\n\n** Changed\n\n- Color scheme has been ported to the popular [[https://ethanschoonover.com/solarized/][Solarized]] (light mode)\n  - Whilst doing so, CSS variables have been introduced, so that\n    there's not a whole lot of repetition of magic rgb values going on\n  - The logo has been adapted, too\n- The landing page and settings screens have been de-cluttered\n\n* [2019-08-26 Mon]\n\n** Added\n\n- Continuous deployment: Merging to =master= triggers a build on CI\n  and when successful, it triggers a deploy to https://org.200ok.ch\n- Add a new temporary™ logo: [[file:public/organice.png][organice.png]]\n\n* [2019-08-25 Sun]\n\n** Added\n\n- Since we want organice to be a community driven project, we have added:\n  - [[file:CODE_OF_CONDUCT.org][Code of conduct]]\n  - [[file:CONTRIBUTING.org][Contributing guidelines]]\n\n- Add [[https://circleci.com/][CircleCI]] to run the tests on every commit\n  - They are also integrated as a check for PRs with the benefit that\n    contributors get automated feedback by running the regression test\n    suite.\n\n- Add [[https://greenkeeper.io][Greenkeeper]] for automated dependency management\n\n- Add [[https://codeclimate.com][Codeclimate]] for automated maintainability analysis\n\n** Changed\n\n- Upgraded to Node 12.9\n\n* [2019-08-12 Mon]\n\n** Changed\n\n- The default keybindings (when used from a desktop browser) are now\n  more in line with the defaults in Emacs itself\n\n** Fixed\n\n- The keybindings work on non-macOS operating systems\n\n* [2019-08-10 Sat]\n\n** Added\n\n- As a user, when in a directory listing, I want the folders and files\n  to be sorted alphabetically. Furthermore, I only want to see files\n  that organice can open (that is org and org archive files).\n- Note: This is only implemented for the Dropbox back-end at this time.\n\n** Changed\n\n- Filters files from a directory listing down to org files.\n- Sorts folders atop of files.\n- Sorts both folders and files alphabetically.\n\n\n* [2019-08-05 Mon]\n\n** Added\n\n- When the browser tab becomes visible, pull the latest version of the\n  Org file\n  - This is rather helpful when the app is used in production. Since\n    the production build supports loading the complete application and\n    org-file from cache, it can be open for a very long time. When the\n    org-file hasn't been pulled in a \"very long time\"™, then chances\n    are non-nil that the file has been changed by another client in\n    the meantime.\n  - Without this change, when the user opens the app after a while,\n    makes changes to the file and wants to sync to the back-end, there\n    might be the message \"Since you last pulled, a newer version of\n    the file has been pushed to the server.\". Now the user has two\n    conflicting versions of the same file and can only chose to keep\n    one (Which in itself is great UX and great error handling for\n    cases in which we do encounter a merge conflict, of course!).\n  - This situation is mitigated with this change. Now the user has the\n    option to enable \"Sync on application becoming visible\" which acts\n    similarly to \"Live Sync\". When the user opts to use this feature,\n    whenever the application gets pulled from the background or\n    started through the service worker, the first thing that happens\n    it that a new version of the org-file is pulled from the server.\n    It's therefore much harder for the user to create conflicts.\n\n* [2019-08-04 Sun]\n\n** Fixed\n\n- Parser doesn't break indentation of existing files in fewer places\n- Planning Items are formatted as in Emacs Org mode\n- Properties are formatted as in Emacs Org mode\n- Tags are formatted as in Emacs Org mode\n\n\n* [2019-08-03 Sat]\n\n** Added\n\n- Documented deployment options\n  - People have been asking for tighter access restrictions.\n  - Imo the best answer to that request is to make it as easy as\n    possible to host organice.\n  - There's myriads of good options, of course. I picked to document\n    two that will (potentially) be cost-free to the users and which\n    are very easy and quick to set up: Ftp and Heroku.\n\n** Fixed\n\n- Tests on =master= were red\n  - Partly due to obsolete tests\n  - Partly because tests weren't updated according to changes in the code\n";


function $d35da74b7b76c8e8$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $6b0383a7d85356ab$export$2e2bcd8739ae039(argument) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $392ad22eb31408d7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}





function $2da84375956e91f5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}




function $ec361b403d551435$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $392ad22eb31408d7$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $2da84375956e91f5$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastMonthNotFull = (0, $392ad22eb31408d7$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - isLastMonthNotFull); // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $6531a474c616ca8c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getTime() - dateRight.getTime();
}



function $464c0c1c0f310a71$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $6531a474c616ca8c$export$2e2bcd8739ae039)(dirtyDateLeft, dirtyDateRight) / 1000;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}


var $a51dbeadfe83d2dd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $a51dbeadfe83d2dd$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $a51dbeadfe83d2dd$var$formatDistanceLocale[token] === 'string') result = $a51dbeadfe83d2dd$var$formatDistanceLocale[token];
    else if (count === 1) result = $a51dbeadfe83d2dd$var$formatDistanceLocale[token].one;
    else result = $a51dbeadfe83d2dd$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}


function $c09496b97de1a0fe$export$2e2bcd8739ae039(args) {
    return function(dirtyOptions) {
        var options = dirtyOptions || {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $ab989c5e991eb086$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $ab989c5e991eb086$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $ab989c5e991eb086$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ab989c5e991eb086$var$formatLong = {
    date: (0, $c09496b97de1a0fe$export$2e2bcd8739ae039)({
        formats: $ab989c5e991eb086$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $c09496b97de1a0fe$export$2e2bcd8739ae039)({
        formats: $ab989c5e991eb086$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $c09496b97de1a0fe$export$2e2bcd8739ae039)({
        formats: $ab989c5e991eb086$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ab989c5e991eb086$export$2e2bcd8739ae039 = $ab989c5e991eb086$var$formatLong;


var $0c4121e8835f1a9a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $0c4121e8835f1a9a$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $0c4121e8835f1a9a$var$formatRelativeLocale[token];
}


function $360ba37c0db92978$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index];
    };
}


var $8c5abed9d128e397$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $8c5abed9d128e397$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ] // Note: in English, the names of days of the week and months are capitalized.
};
var $8c5abed9d128e397$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $8c5abed9d128e397$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $8c5abed9d128e397$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $8c5abed9d128e397$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $8c5abed9d128e397$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $8c5abed9d128e397$var$localize = {
    ordinalNumber: $8c5abed9d128e397$var$ordinalNumber,
    era: (0, $360ba37c0db92978$export$2e2bcd8739ae039)({
        values: $8c5abed9d128e397$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $360ba37c0db92978$export$2e2bcd8739ae039)({
        values: $8c5abed9d128e397$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $360ba37c0db92978$export$2e2bcd8739ae039)({
        values: $8c5abed9d128e397$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $360ba37c0db92978$export$2e2bcd8739ae039)({
        values: $8c5abed9d128e397$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $360ba37c0db92978$export$2e2bcd8739ae039)({
        values: $8c5abed9d128e397$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8c5abed9d128e397$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8c5abed9d128e397$export$2e2bcd8739ae039 = $8c5abed9d128e397$var$localize;


function $c0d6ee317392670b$export$2e2bcd8739ae039(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}


function $e75f69dbd1a22faf$export$2e2bcd8739ae039(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var value;
        if (Object.prototype.toString.call(parsePatterns) === '[object Array]') value = $e75f69dbd1a22faf$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        else value = $e75f69dbd1a22faf$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        value = args.valueCallback ? args.valueCallback(value) : value;
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
function $e75f69dbd1a22faf$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
}
function $e75f69dbd1a22faf$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
}


var $2ed45a28dcdc92f1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2ed45a28dcdc92f1$var$parseOrdinalNumberPattern = /\d+/i;
var $2ed45a28dcdc92f1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $2ed45a28dcdc92f1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $2ed45a28dcdc92f1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $2ed45a28dcdc92f1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2ed45a28dcdc92f1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $2ed45a28dcdc92f1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2ed45a28dcdc92f1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $2ed45a28dcdc92f1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $2ed45a28dcdc92f1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2ed45a28dcdc92f1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2ed45a28dcdc92f1$var$match = {
    ordinalNumber: (0, $c0d6ee317392670b$export$2e2bcd8739ae039)({
        matchPattern: $2ed45a28dcdc92f1$var$matchOrdinalNumberPattern,
        parsePattern: $2ed45a28dcdc92f1$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $e75f69dbd1a22faf$export$2e2bcd8739ae039)({
        matchPatterns: $2ed45a28dcdc92f1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ed45a28dcdc92f1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $e75f69dbd1a22faf$export$2e2bcd8739ae039)({
        matchPatterns: $2ed45a28dcdc92f1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ed45a28dcdc92f1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $e75f69dbd1a22faf$export$2e2bcd8739ae039)({
        matchPatterns: $2ed45a28dcdc92f1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ed45a28dcdc92f1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $e75f69dbd1a22faf$export$2e2bcd8739ae039)({
        matchPatterns: $2ed45a28dcdc92f1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ed45a28dcdc92f1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $e75f69dbd1a22faf$export$2e2bcd8739ae039)({
        matchPatterns: $2ed45a28dcdc92f1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2ed45a28dcdc92f1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2ed45a28dcdc92f1$export$2e2bcd8739ae039 = $2ed45a28dcdc92f1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $dd52022a91a8843b$var$locale = {
    code: 'en-US',
    formatDistance: (0, $a51dbeadfe83d2dd$export$2e2bcd8739ae039),
    formatLong: (0, $ab989c5e991eb086$export$2e2bcd8739ae039),
    formatRelative: (0, $0c4121e8835f1a9a$export$2e2bcd8739ae039),
    localize: (0, $8c5abed9d128e397$export$2e2bcd8739ae039),
    match: (0, $2ed45a28dcdc92f1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $dd52022a91a8843b$export$2e2bcd8739ae039 = $dd52022a91a8843b$var$locale;



function $cc4c989c9f6a2ae9$export$2e2bcd8739ae039(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (dirtyObject.hasOwnProperty(property)) target[property] = dirtyObject[property];
    return target;
}


function $c9d75dd1208d5741$export$2e2bcd8739ae039(dirtyObject) {
    return (0, $cc4c989c9f6a2ae9$export$2e2bcd8739ae039)({}, dirtyObject);
}


var $c5e277f645cadb59$var$MILLISECONDS_IN_MINUTE = 60000;
function $c5e277f645cadb59$var$getDateMillisecondsPart(date) {
    return date.getTime() % $c5e277f645cadb59$var$MILLISECONDS_IN_MINUTE;
}
function $c5e277f645cadb59$export$2e2bcd8739ae039(dirtyDate) {
    var date = new Date(dirtyDate.getTime());
    var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
    date.setSeconds(0, 0);
    var hasNegativeUTCOffset = baseTimezoneOffset > 0;
    var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? ($c5e277f645cadb59$var$MILLISECONDS_IN_MINUTE + $c5e277f645cadb59$var$getDateMillisecondsPart(date)) % $c5e277f645cadb59$var$MILLISECONDS_IN_MINUTE : $c5e277f645cadb59$var$getDateMillisecondsPart(date);
    return baseTimezoneOffset * $c5e277f645cadb59$var$MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}



var $b329683246a513c2$var$MINUTES_IN_DAY = 1440;
var $b329683246a513c2$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $b329683246a513c2$var$MINUTES_IN_MONTH = 43200;
var $b329683246a513c2$var$MINUTES_IN_TWO_MONTHS = 86400;
function $b329683246a513c2$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $dd52022a91a8843b$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $392ad22eb31408d7$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $c9d75dd1208d5741$export$2e2bcd8739ae039)(options);
    localizeOptions.addSuffix = Boolean(options.addSuffix);
    localizeOptions.comparison = comparison;
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $464c0c1c0f310a71$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $c5e277f645cadb59$export$2e2bcd8739ae039)(dateRight) - (0, $c5e277f645cadb59$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months; // 0 up to 2 mins
    if (minutes < 2) {
        if (options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', null, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        } // 2 mins up to 0.75 hrs
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
    else if (minutes < $b329683246a513c2$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
    } else if (minutes < $b329683246a513c2$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
    else if (minutes < $b329683246a513c2$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $b329683246a513c2$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
    } else if (minutes < $b329683246a513c2$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $b329683246a513c2$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $ec361b403d551435$export$2e2bcd8739ae039)(dateRight, dateLeft); // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $b329683246a513c2$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12); // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}



function $4713c3dd214d4e1e$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    return (0, $b329683246a513c2$export$2e2bcd8739ae039)(dirtyDate, Date.now(), dirtyOptions);
}


function $93e3437ae033fe8d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}





function $73a150425ace56c9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



function $cf42fc1e462fa1c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $73a150425ace56c9$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $96a8552fe912bf98$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $96a8552fe912bf98$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $96a8552fe912bf98$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $96a8552fe912bf98$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $96a8552fe912bf98$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $96a8552fe912bf98$var$timeLongFormatter(timePattern, formatLong));
}
var $96a8552fe912bf98$var$longFormatters = {
    p: $96a8552fe912bf98$var$timeLongFormatter,
    P: $96a8552fe912bf98$var$dateTimeLongFormatter
};
var $96a8552fe912bf98$export$2e2bcd8739ae039 = $96a8552fe912bf98$var$longFormatters;



var $c8606ddf62c3e3bd$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $c8606ddf62c3e3bd$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $c8606ddf62c3e3bd$export$c6cc36aa33304772(token) {
    return $c8606ddf62c3e3bd$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $c8606ddf62c3e3bd$export$c6b49d6dceb604a1(token) {
    return $c8606ddf62c3e3bd$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $c8606ddf62c3e3bd$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}








function $591ab89c7990a73b$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}



function $7cc9a78cab7559b1$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}





function $88d8b2bae71b236c$export$2e2bcd8739ae039(dirtyDate, dirtyDay, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}





function $728c6084cff599ce$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}







function $0b9d0e04cba31a0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $14462266bc0c0f5c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $6ae55699febb3b4e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $14462266bc0c0f5c$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $81f3bfad69fa8a98$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $81f3bfad69fa8a98$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)(date).getTime() - (0, $6ae55699febb3b4e$export$2e2bcd8739ae039)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $81f3bfad69fa8a98$var$MILLISECONDS_IN_WEEK) + 1;
}



function $08c76b01c36da266$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $81f3bfad69fa8a98$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}










function $5120207da2623051$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.firstWeekContainsDate);
    var year = (0, $7cc9a78cab7559b1$export$2e2bcd8739ae039)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(firstWeek, dirtyOptions);
    return date;
}



var $cea45f0b6b9cbc15$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $cea45f0b6b9cbc15$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5120207da2623051$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $cea45f0b6b9cbc15$var$MILLISECONDS_IN_WEEK) + 1;
}



function $62351801fe78f977$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $cea45f0b6b9cbc15$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}




var $1b6e65cf821838bd$var$MILLISECONDS_IN_HOUR = 3600000;
var $1b6e65cf821838bd$var$MILLISECONDS_IN_MINUTE = 60000;
var $1b6e65cf821838bd$var$MILLISECONDS_IN_SECOND = 1000;
var $1b6e65cf821838bd$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $1b6e65cf821838bd$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $1b6e65cf821838bd$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $1b6e65cf821838bd$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $1b6e65cf821838bd$var$MILLISECONDS_IN_HOUR + minutes * $1b6e65cf821838bd$var$MILLISECONDS_IN_MINUTE + seconds * $1b6e65cf821838bd$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $1b6e65cf821838bd$var$parseAnyDigitsSigned(string, valueCallback) {
    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $1b6e65cf821838bd$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $1b6e65cf821838bd$var$parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $1b6e65cf821838bd$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $1b6e65cf821838bd$var$parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $1b6e65cf821838bd$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $1b6e65cf821838bd$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $1b6e65cf821838bd$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1b6e65cf821838bd$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $1b6e65cf821838bd$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $1b6e65cf821838bd$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case 'G':
                case 'GG':
                case 'GGG':
                    return match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
                // A, B
                case 'GGGGG':
                    return match.era(string, {
                        width: 'narrow'
                    });
                // Anno Domini, Before Christ
                case 'GGGG':
                default:
                    return match.era(string, {
                        width: 'wide'
                    }) || match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'yy'
                };
            };
            switch(token){
                case 'y':
                    return $1b6e65cf821838bd$var$parseNDigits(4, string, valueCallback);
                case 'yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $1b6e65cf821838bd$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'YY'
                };
            };
            switch(token){
                case 'Y':
                    return $1b6e65cf821838bd$var$parseNDigits(4, string, valueCallback);
                case 'Yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = (0, $7cc9a78cab7559b1$export$2e2bcd8739ae039)(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $1b6e65cf821838bd$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(date, options);
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return (0, $591ab89c7990a73b$export$2e2bcd8739ae039)(date, options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'R') return $1b6e65cf821838bd$var$parseNDigitsSigned(4, string);
            return $1b6e65cf821838bd$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)(firstWeekOfYear);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'u') return $1b6e65cf821838bd$var$parseNDigitsSigned(4, string);
            return $1b6e65cf821838bd$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'Q':
                case 'QQ':
                    // 01, 02, 03, 04
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'Qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'QQQ':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'QQQQQ':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'QQQQ':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'q':
                case 'qq':
                    // 01, 02, 03, 04
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'qqq':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'qqqqq':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'qqqq':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'M':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'MM':
                    return $1b6e65cf821838bd$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Mo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'MMM':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // J, F, ..., D
                case 'MMMMM':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // January, February, ..., December
                case 'MMMM':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'L':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'LL':
                    return $1b6e65cf821838bd$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Lo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'LLL':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // J, F, ..., D
                case 'LLLLL':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // January, February, ..., December
                case 'LLLL':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'w':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.week, string);
                case 'wo':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $591ab89c7990a73b$export$2e2bcd8739ae039)((0, $62351801fe78f977$export$2e2bcd8739ae039)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'I':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.week, string);
                case 'Io':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $0b9d0e04cba31a0e$export$2e2bcd8739ae039)((0, $08c76b01c36da266$export$2e2bcd8739ae039)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'd':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.date, string);
                case 'do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $1b6e65cf821838bd$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $1b6e65cf821838bd$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $1b6e65cf821838bd$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'D':
                case 'DD':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.dayOfYear, string);
                case 'Do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $1b6e65cf821838bd$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case 'E':
                case 'EE':
                case 'EEE':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'EEEEE':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'EEEEEE':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'EEEE':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $88d8b2bae71b236c$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'e':
                case 'ee':
                    // 03
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'eo':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'eee':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'eeeee':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'eeeeee':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'eeee':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $88d8b2bae71b236c$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'c':
                case 'cc':
                    // 03
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'co':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'ccc':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // T
                case 'ccccc':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tu
                case 'cccccc':
                    return match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tuesday
                case 'cccc':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $88d8b2bae71b236c$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case 'i':
                case 'ii':
                    // 02
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
                // 2nd
                case 'io':
                    return match.ordinalNumber(string, {
                        unit: 'day'
                    });
                // Tue
                case 'iii':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // T
                case 'iiiii':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tu
                case 'iiiiii':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tuesday
                case 'iiii':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = (0, $728c6084cff599ce$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'a':
                case 'aa':
                case 'aaa':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($1b6e65cf821838bd$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'b':
                case 'bb':
                case 'bbb':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($1b6e65cf821838bd$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($1b6e65cf821838bd$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'h':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.hour12h, string);
                case 'ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'H':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.hour23h, string);
                case 'Ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'K':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.hour11h, string);
                case 'Ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'k':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.hour24h, string);
                case 'ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'm':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.minute, string);
                case 'mo':
                    return match.ordinalNumber(string, {
                        unit: 'minute'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case 's':
                    return $1b6e65cf821838bd$var$parseNumericPattern($1b6e65cf821838bd$var$numericPatterns.second, string);
                case 'so':
                    return match.ordinalNumber(string, {
                        unit: 'second'
                    });
                default:
                    return $1b6e65cf821838bd$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $1b6e65cf821838bd$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'X':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basicOptionalMinutes, string);
                case 'XX':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basic, string);
                case 'XXXX':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basicOptionalSeconds, string);
                case 'XXXXX':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'XXX':
                default:
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'x':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basicOptionalMinutes, string);
                case 'xx':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basic, string);
                case 'xxxx':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.basicOptionalSeconds, string);
                case 'xxxxx':
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'xxx':
                default:
                    return $1b6e65cf821838bd$var$parseTimezonePattern($1b6e65cf821838bd$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $1b6e65cf821838bd$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $1b6e65cf821838bd$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    }
};
var $1b6e65cf821838bd$export$2e2bcd8739ae039 = $1b6e65cf821838bd$var$parsers;



var $3b0472fc9ca892cd$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3b0472fc9ca892cd$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3b0472fc9ca892cd$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3b0472fc9ca892cd$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3b0472fc9ca892cd$var$doubleQuoteRegExp = /''/g;
var $3b0472fc9ca892cd$var$notWhitespaceRegExp = /\S/;
var $3b0472fc9ca892cd$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3b0472fc9ca892cd$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $dd52022a91a8843b$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale // If timezone isn't specified, it will be set to the system timezone
    };
    var setters = [
        {
            priority: $3b0472fc9ca892cd$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $3b0472fc9ca892cd$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($3b0472fc9ca892cd$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $96a8552fe912bf98$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
        }
        return substring;
    }).join('').match($3b0472fc9ca892cd$var$formattingTokensRegExp);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && (0, $c8606ddf62c3e3bd$export$c6b49d6dceb604a1)(token)) (0, $c8606ddf62c3e3bd$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && (0, $c8606ddf62c3e3bd$export$c6cc36aa33304772)(token)) (0, $c8606ddf62c3e3bd$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = (0, $1b6e65cf821838bd$export$2e2bcd8739ae039)[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === '*' && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($3b0472fc9ca892cd$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $3b0472fc9ca892cd$var$cleanEscapedString(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $3b0472fc9ca892cd$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = (0, $cf42fc1e462fa1c2$export$2e2bcd8739ae039)(date, (0, $c5e277f645cadb59$export$2e2bcd8739ae039)(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            (0, $cc4c989c9f6a2ae9$export$2e2bcd8739ae039)(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $3b0472fc9ca892cd$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $3b0472fc9ca892cd$var$cleanEscapedString(input) {
    return input.match($3b0472fc9ca892cd$var$escapedStringRegExp)[1].replace($3b0472fc9ca892cd$var$doubleQuoteRegExp, "'");
}


var $cbb57a1237e23d1f$export$2e2bcd8739ae039 = (()=>{
    let nextId = 1;
    return ()=>nextId++;
})();



var $1X5R2 = parcelRequire("1X5R2");





function $31308ca003123199$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




var $09555678f6e8ee02$var$MILLISECONDS_IN_HOUR = 3600000;
function $09555678f6e8ee02$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $73a150425ace56c9$export$2e2bcd8739ae039)(dirtyDate, amount * $09555678f6e8ee02$var$MILLISECONDS_IN_HOUR);
}




function $b83935a7f4bd66dd$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $76d9578e8d1d18d0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $31308ca003123199$export$2e2bcd8739ae039)(dirtyDate, days);
}




function $4aee9fad719a6cae$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b83935a7f4bd66dd$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



var $e6864c10d59179e3$var$MILLISECONDS_IN_MINUTE = 60000;
function $e6864c10d59179e3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $6531a474c616ca8c$export$2e2bcd8739ae039)(dirtyDateLeft, dirtyDateRight) / $e6864c10d59179e3$var$MILLISECONDS_IN_MINUTE;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}



function $9acc2ba9c7113fcc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(date);
}





function $f635f04a3e7c29ae$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}


/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $9ba4f055443bb9f3$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
            case 'aaa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $9ba4f055443bb9f3$export$2e2bcd8739ae039 = $9ba4f055443bb9f3$var$formatters;




var $61a414bed62b75c2$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $61a414bed62b75c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $61a414bed62b75c2$var$MILLISECONDS_IN_DAY) + 1;
}







var $40fb4ac8fc96e621$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
var $40fb4ac8fc96e621$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $7cc9a78cab7559b1$export$2e2bcd8739ae039)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $14462266bc0c0f5c$export$2e2bcd8739ae039)(date); // Padding
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $cea45f0b6b9cbc15$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $81f3bfad69fa8a98$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $61a414bed62b75c2$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $40fb4ac8fc96e621$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $9ba4f055443bb9f3$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $40fb4ac8fc96e621$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $40fb4ac8fc96e621$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $40fb4ac8fc96e621$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $40fb4ac8fc96e621$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $40fb4ac8fc96e621$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $40fb4ac8fc96e621$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(minutes, 2);
}
function $40fb4ac8fc96e621$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $40fb4ac8fc96e621$var$formatTimezone(offset, dirtyDelimiter);
}
function $40fb4ac8fc96e621$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $f635f04a3e7c29ae$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $40fb4ac8fc96e621$export$2e2bcd8739ae039 = $40fb4ac8fc96e621$var$formatters;







// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e0b180c9a12e7808$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e0b180c9a12e7808$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e0b180c9a12e7808$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e0b180c9a12e7808$var$doubleQuoteRegExp = /''/g;
var $e0b180c9a12e7808$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e0b180c9a12e7808$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $dd52022a91a8843b$export$2e2bcd8739ae039);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $9acc2ba9c7113fcc$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $c5e277f645cadb59$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $cf42fc1e462fa1c2$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e0b180c9a12e7808$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $96a8552fe912bf98$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($e0b180c9a12e7808$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e0b180c9a12e7808$var$cleanEscapedString(substring);
        var formatter = (0, $40fb4ac8fc96e621$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $c8606ddf62c3e3bd$export$c6b49d6dceb604a1)(substring)) (0, $c8606ddf62c3e3bd$export$8073c1ae88f0e727)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $c8606ddf62c3e3bd$export$c6cc36aa33304772)(substring)) (0, $c8606ddf62c3e3bd$export$8073c1ae88f0e727)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e0b180c9a12e7808$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e0b180c9a12e7808$var$cleanEscapedString(input) {
    return input.match($e0b180c9a12e7808$var$escapedStringRegExp)[1].replace($e0b180c9a12e7808$var$doubleQuoteRegExp, "'");
}



function $0e22728ab0704cbc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}



function $c155248bcea3fd42$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}



function $12b49ea8a8ce12d5$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $cb87cf201bc9e768$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}




function $810bafc1ae906176$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}




function $aa5a474e2d8b72f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $31308ca003123199$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $f6d160b0b3b3723c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $09555678f6e8ee02$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $ccb552dfa3d8b0af$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b83935a7f4bd66dd$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $a49a2aa8dc053503$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $76d9578e8d1d18d0$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $5c9e93ffb25b0026$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $4aee9fad719a6cae$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


const $e706118dde20dbed$export$96c990e4d9eca709 = (timestamp)=>{
    const { isActive: isActive, year: year, month: month, day: day, dayName: dayName, startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute, repeaterType: repeaterType, repeaterValue: repeaterValue, repeaterUnit: repeaterUnit, repeaterDeadlineValue: repeaterDeadlineValue, repeaterDeadlineUnit: repeaterDeadlineUnit, delayType: delayType, delayValue: delayValue, delayUnit: delayUnit } = timestamp.toJS();
    let timestampText = '';
    timestampText += isActive ? '<' : '[';
    timestampText += `${year}-${month}-${day}`;
    timestampText += !!dayName ? ` ${dayName}` : '';
    timestampText += !!startHour ? ` ${startHour}:${startMinute}` : '';
    timestampText += !!endHour ? `-${endHour}:${endMinute}` : '';
    timestampText += !!repeaterType ? ` ${repeaterType}${repeaterValue}${repeaterUnit}` : '';
    timestampText += !!repeaterType && !!repeaterDeadlineValue ? `/${repeaterDeadlineValue}${repeaterDeadlineUnit}` : '';
    timestampText += !!delayType ? ` ${delayType}${delayValue}${delayUnit}` : '';
    timestampText += isActive ? '>' : ']';
    return timestampText;
};
const $e706118dde20dbed$export$69ac1778977ccd3b = ({ isActive: isActive = true, withStartTime: withStartTime = false } = {})=>$e706118dde20dbed$export$84b4d45ad21bc6ff(new Date(), {
        isActive: isActive,
        withStartTime: withStartTime
    });
const $e706118dde20dbed$export$84b4d45ad21bc6ff = (time, { isActive: isActive = true, withStartTime: withStartTime = false } = {})=>{
    const timestamp = {
        isActive: isActive,
        year: (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'yyyy'),
        month: (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'MM'),
        day: (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'dd'),
        dayName: (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'eee'),
        startHour: null,
        startMinute: null,
        endHour: null,
        endMinute: null,
        repeaterType: null,
        repeaterValue: null,
        repeaterUnit: null,
        repeaterDeadlineValue: null,
        repeaterDeadlineUnit: null,
        delayType: null,
        delayValue: null,
        delayUnit: null
    };
    if (withStartTime) {
        timestamp.startHour = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'HH');
        timestamp.startMinute = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, 'mm');
    }
    return timestamp;
};
const $e706118dde20dbed$export$29bd541c4eb8fcfe = ({ isActive: isActive = true, withStartTime: withStartTime = false } = {})=>$e706118dde20dbed$export$d5283c9b29c6d6d0(new Date(), {
        isActive: isActive,
        withStartTime: withStartTime
    });
const $e706118dde20dbed$export$d5283c9b29c6d6d0 = (time, { isActive: isActive = true, withStartTime: withStartTime = false } = {})=>{
    const bracketPair = isActive ? '<>' : '[]';
    let formatString = 'yyyy-MM-dd eee';
    if (withStartTime) formatString += ' HH:mm';
    return `${bracketPair[0]}${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(time, formatString)}${bracketPair[1]}`;
};
const $e706118dde20dbed$export$77db66937f538459 = (timestamp)=>{
    const { year: year, month: month, day: day, startHour: startHour, startMinute: startMinute } = timestamp.toJS();
    let timestampString = `${year}-${month}-${day}`;
    if (startHour && startMinute) timestampString += ` ${startHour.padStart(2, '0')}:${startMinute}`;
    else timestampString += ' 12:00';
    return (0, $3b0472fc9ca892cd$export$2e2bcd8739ae039)(timestampString, 'yyyy-MM-dd HH:mm', new Date());
};
const $e706118dde20dbed$export$774686e7fdec6ef3 = (date, numUnits, timestampUnit)=>{
    switch(timestampUnit){
        case 'h':
            return (0, $09555678f6e8ee02$export$2e2bcd8739ae039)(date, numUnits);
        case 'd':
            return (0, $31308ca003123199$export$2e2bcd8739ae039)(date, numUnits);
        case 'w':
            return (0, $76d9578e8d1d18d0$export$2e2bcd8739ae039)(date, numUnits);
        case 'm':
            return (0, $b83935a7f4bd66dd$export$2e2bcd8739ae039)(date, numUnits);
        case 'y':
            return (0, $4aee9fad719a6cae$export$2e2bcd8739ae039)(date, numUnits);
        default:
            return date;
    }
};
const $e706118dde20dbed$export$8491aff2799e70c1 = (date, numUnits, timestampUnit)=>{
    switch(timestampUnit){
        case 'h':
            return (0, $f6d160b0b3b3723c$export$2e2bcd8739ae039)(date, numUnits);
        case 'd':
            return (0, $aa5a474e2d8b72f5$export$2e2bcd8739ae039)(date, numUnits);
        case 'w':
            return (0, $a49a2aa8dc053503$export$2e2bcd8739ae039)(date, numUnits);
        case 'm':
            return (0, $ccb552dfa3d8b0af$export$2e2bcd8739ae039)(date, numUnits);
        case 'y':
            return (0, $5c9e93ffb25b0026$export$2e2bcd8739ae039)(date, numUnits);
        default:
            return date;
    }
};
const $e706118dde20dbed$export$6f0394e8a403bab9 = (timestamp, currentDate)=>{
    if (!timestamp.get('repeaterType')) return timestamp;
    let newDate = null;
    switch(timestamp.get('repeaterType')){
        case '+':
            newDate = $e706118dde20dbed$export$774686e7fdec6ef3($e706118dde20dbed$export$77db66937f538459(timestamp), timestamp.get('repeaterValue'), timestamp.get('repeaterUnit'));
            break;
        case '++':
            newDate = $e706118dde20dbed$export$774686e7fdec6ef3($e706118dde20dbed$export$77db66937f538459(timestamp), timestamp.get('repeaterValue'), timestamp.get('repeaterUnit'));
            while((0, $12b49ea8a8ce12d5$export$2e2bcd8739ae039)(newDate, currentDate))newDate = $e706118dde20dbed$export$774686e7fdec6ef3(newDate, timestamp.get('repeaterValue'), timestamp.get('repeaterUnit'));
            break;
        case '.+':
            newDate = $e706118dde20dbed$export$774686e7fdec6ef3(currentDate, timestamp.get('repeaterValue'), timestamp.get('repeaterUnit'));
            if (timestamp.get('repeaterUnit') !== 'h') {
                let timestampDate = $e706118dde20dbed$export$77db66937f538459(timestamp);
                newDate = (0, $cb87cf201bc9e768$export$2e2bcd8739ae039)(newDate, (0, $0e22728ab0704cbc$export$2e2bcd8739ae039)(timestampDate));
                newDate = (0, $810bafc1ae906176$export$2e2bcd8739ae039)(newDate, (0, $c155248bcea3fd42$export$2e2bcd8739ae039)(timestampDate));
            }
            break;
        default:
            console.error(`Unrecognized timestamp repeater type: ${timestamp.get('repeaterType')}`);
            return timestamp;
    }
    timestamp = timestamp.set('day', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'dd')).set('dayName', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'eee')).set('month', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'MM')).set('year', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'yyyy'));
    if (timestamp.get('startHour') !== undefined && timestamp.get('startHour') !== null) timestamp = timestamp.set('startHour', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'HH')).set('startMinute', (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(newDate, 'mm'));
    return timestamp;
};
const $e706118dde20dbed$export$bd27f0b37191265b = (startTimestamp, endTimestamp)=>{
    let [start, end] = [
        startTimestamp,
        endTimestamp
    ].map($e706118dde20dbed$export$77db66937f538459);
    return $e706118dde20dbed$export$27b7cdf81b734544(start, end);
};
const $e706118dde20dbed$export$27b7cdf81b734544 = (start, end)=>{
    let pad = ' ';
    if (start > end) {
        pad = '-';
        [start, end] = [
            end,
            start
        ];
    }
    const minDiff = (0, $e6864c10d59179e3$export$2e2bcd8739ae039)(end, start);
    const hours = Math.floor(minDiff / 60);
    if (hours >= 10) pad = '';
    const minutes = minDiff % 60;
    const minutesText = minutes >= 10 ? minutes : `0${minutes}`;
    return `${pad}${hours}:${minutesText}`;
};
const $e706118dde20dbed$export$4251c173c1ee6069 = (millis)=>{
    if (millis === undefined) return '';
    return $e706118dde20dbed$export$27b7cdf81b734544(new Date(0), new Date(millis));
};


const $500d38b948046618$var$linkPartToRawText = (linkPart)=>{
    if (!!linkPart.getIn([
        'contents',
        'title'
    ])) return `[[${linkPart.getIn([
        'contents',
        'uri'
    ])}][${linkPart.getIn([
        'contents',
        'title'
    ])}]]`;
    else return `[[${linkPart.getIn([
        'contents',
        'uri'
    ])}]]`;
};
const $500d38b948046618$var$formattedAttributedStringText = (parts)=>{
    return parts.map((part)=>{
        switch(part.get('type')){
            case 'text':
                return part.get('contents');
            case 'link':
                if (part.getIn([
                    'contents',
                    'title'
                ])) return part.getIn([
                    'contents',
                    'title'
                ]);
                else return part.getIn([
                    'contents',
                    'uri'
                ]);
            case 'table':
                return '';
            default:
                return '';
        }
    }).join('');
};
const $500d38b948046618$var$tablePartToRawText = (tablePart)=>{
    const rowHeights = tablePart.get('contents').map((row)=>Math.max(...row.get('contents').map((cell)=>((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).countBy(cell.get('rawContents'))['\n'] || 0) + 1))).toJS();
    const columns = tablePart.getIn([
        'contents',
        0,
        'contents'
    ]);
    if (columns === undefined) return '';
    const numColumns = columns.size;
    const columnWidths = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(numColumns).map((columnIndex)=>Math.max(...tablePart.get('contents').map((row)=>{
            const content = row.getIn([
                'contents',
                columnIndex,
                'contents'
            ]);
            const formattedText = $500d38b948046618$var$formattedAttributedStringText(content);
            const lineLengths = formattedText.split('\n').map((line)=>line.trim().length);
            return Math.max(...lineLengths);
        })));
    const rowStrings = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).dropRight((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).flatten(tablePart.get('contents').map((row, rowIndex)=>{
        const rowHeight = rowHeights[rowIndex];
        const contentRows = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(rowHeight).map((lineIndex)=>row.get('contents').map((cell, columnIndex)=>{
                const content = cell.get('contents');
                const formattedText = $500d38b948046618$var$formattedAttributedStringText(content);
                const formattedLineLengths = formattedText.split('\n').map((line)=>line.trim().length);
                const line = (cell.get('rawContents').split('\n')[lineIndex] || '').trim();
                const padCount = columnWidths[columnIndex] - formattedLineLengths[lineIndex];
                return line + ' '.repeat(padCount);
            }).toJS().join(' | ')).map((contentRow)=>`| ${contentRow} |`);
        const separator = '|' + columnWidths.map((columnWidth)=>'-'.repeat(columnWidth + 2)).join('+') + '|';
        return contentRows.concat(separator);
    }).toJS()));
    return rowStrings.join('\n');
};
const $500d38b948046618$var$listPartToRawText = (listPart)=>{
    const bulletCharacter = listPart.get('bulletCharacter');
    let previousNumber = 0;
    return listPart.get('items').map((item)=>{
        const optionalLeadingSpace = !listPart.get('isOrdered') && bulletCharacter === '*' ? ' ' : '';
        const titleText = $500d38b948046618$export$2c44f25459bb5dc7(item.get('titleLine'));
        const contentText = $500d38b948046618$export$2c44f25459bb5dc7(item.get('contents'));
        const indentedContentText = contentText.split('\n').map((line)=>!!line.trim() ? `${optionalLeadingSpace}  ${line}` : '').join('\n');
        let listItemText = null;
        if (listPart.get('isOrdered')) {
            let number = ++previousNumber;
            let forceNumber = item.get('forceNumber');
            if (!!forceNumber) {
                number = forceNumber;
                previousNumber = number;
            }
            listItemText = `${number}${listPart.get('numberTerminatorCharacter')}`;
            if (!!forceNumber) listItemText += ` [@${forceNumber}]`;
            if (item.get('isCheckbox')) {
                const stateCharacter = {
                    checked: 'X',
                    unchecked: ' ',
                    partial: '-'
                }[item.get('checkboxState')];
                listItemText += ` [${stateCharacter}]`;
            }
            listItemText += ` ${titleText}`;
        } else {
            listItemText = `${optionalLeadingSpace}${bulletCharacter}`;
            if (item.get('isCheckbox')) {
                const stateCharacter = {
                    checked: 'X',
                    unchecked: ' ',
                    partial: '-'
                }[item.get('checkboxState')];
                listItemText += ` [${stateCharacter}]`;
            }
            listItemText += ` ${titleText}`;
        }
        if (!!contentText) listItemText += `\n${indentedContentText}`;
        return listItemText;
    }).join('\n');
};
const $500d38b948046618$var$timestampPartToRawText = (part)=>{
    let text = (0, $e706118dde20dbed$export$96c990e4d9eca709)(part.get('firstTimestamp'));
    if (part.get('secondTimestamp')) text += `--${(0, $e706118dde20dbed$export$96c990e4d9eca709)(part.get('secondTimestamp'))}`;
    return text;
};
const $500d38b948046618$var$inlineMarkUpToRawText = (part)=>{
    const markupTypeToRaw = {
        'inline-code': '~',
        bold: '*',
        italic: '/',
        strikethrough: '+',
        underline: '_',
        verbatim: '='
    };
    if (part.get('type') !== 'inline-markup' || !markupTypeToRaw[part.get('markupType')]) return part.get('content');
    return markupTypeToRaw[part.get('markupType')] + part.get('content') + markupTypeToRaw[part.get('markupType')];
};
const $500d38b948046618$export$2c44f25459bb5dc7 = (parts)=>{
    if (!parts) return '';
    const prevParts = parts.unshift(null);
    return parts.zip(prevParts).map(([part, prevPart])=>{
        let text = '';
        switch(part.get('type')){
            case 'text':
                text = part.get('contents');
                break;
            case 'inline-markup':
                text = $500d38b948046618$var$inlineMarkUpToRawText(part);
                break;
            case 'link':
                text = $500d38b948046618$var$linkPartToRawText(part);
                break;
            case 'fraction-cookie':
                text = `[${part.getIn([
                    'fraction',
                    0
                ]) || ''}/${part.getIn([
                    'fraction',
                    1
                ]) || ''}]`;
                break;
            case 'percentage-cookie':
                text = `[${part.get('percentage') || ''}%]`;
                break;
            case 'table':
                text = $500d38b948046618$var$tablePartToRawText(part);
                break;
            case 'list':
                text = $500d38b948046618$var$listPartToRawText(part);
                break;
            case 'timestamp':
                text = $500d38b948046618$var$timestampPartToRawText(part);
                break;
            case 'url':
            case 'www-url':
            case 'e-mail':
            case 'phone-number':
                text = part.get('content');
                break;
            default:
                console.error(`Unknown attributed string part type in attributedStringToRawText: ${part.get('type')}`);
        }
        let optionalNewlinePrefix = '';
        if (!!prevPart) {
            if ([
                'list',
                'table'
            ].includes(prevPart.get('type'))) optionalNewlinePrefix = '\n';
            else if (part.get('type') === 'list' && prevPart.get('type') === 'text' && !prevPart.get('contents').endsWith('\n')) optionalNewlinePrefix = '\n';
        }
        return optionalNewlinePrefix + text;
    }).join('');
};
const $500d38b948046618$export$907554d307802b74 = (header, includeStars)=>{
    // Remove stars afterwards if not includeStars - because of :tag: alignment
    let titleLine = '*'.repeat(header.nestingLevel);
    if (header.titleLine.todoKeyword) titleLine += ` ${header.titleLine.todoKeyword}`;
    titleLine += ` ${header.titleLine.rawTitle}`;
    if (header.titleLine.tags.length) {
        // TODO: filter()? Why would we add empty tags in the first place?
        let tagsString = `:${header.titleLine.tags.filter((x)=>x).join(':')}:`;
        if (!titleLine.match(/\s$/)) {
            // Insert as many spaces as orgmode auto-formatting does:
            let n = 77 - titleLine.length - tagsString.length;
            let space = ' '.repeat(n > 0 ? n : 1);
            titleLine += space;
        }
        titleLine += tagsString;
    }
    if (!includeStars) titleLine = titleLine.substring(1 + header.nestingLevel);
    return titleLine;
};
const $500d38b948046618$export$ab94703a73fe3ce = ({ headers: headers, linesBeforeHeadings: linesBeforeHeadings, dontIndent: dontIndent })=>{
    let configContent = linesBeforeHeadings.map((x)=>x + '\n').join('');
    const headerContent = headers.map((x)=>$500d38b948046618$export$5f409df9aafd0448(x, true, dontIndent)).join('');
    return configContent + headerContent;
};
const $500d38b948046618$export$5f409df9aafd0448 = (header, includeTitle, dontIndent)=>{
    // To simplify access to properties:
    const immutableHeader = header;
    header = header.toJS();
    // Pad things like planning items and tables appropriately
    // considering the nestingLevel of the header, unless that is explicitly disabled
    const indentation = dontIndent ? '' : ' '.repeat(header.nestingLevel + 1);
    let contents = '';
    if (includeTitle) contents += $500d38b948046618$export$907554d307802b74(header, true) + '\n';
    // Special case: do not render planning items that are normal active timestamps
    const planningItemsToRender = immutableHeader.get('planningItems').filter((0, $2ce140c2c56df8f2$export$dd50aa628860b07d)).toJS();
    if (planningItemsToRender.length) {
        const planningItemsContent = planningItemsToRender.map((planningItem)=>{
            const timestampString = (0, $e706118dde20dbed$export$96c990e4d9eca709)((0, $3044e0bef3624137$exports.fromJS)(planningItem.timestamp));
            return `${planningItem.type}: ${timestampString}`;
        }).join(' ').trimRight();
        contents += `${indentation}${planningItemsContent}\n`;
    }
    if (header.propertyListItems.length) {
        const propertyListItemsContent = header.propertyListItems.map((propertyListItem)=>{
            return `${indentation}:${propertyListItem.property}: ${$500d38b948046618$export$2c44f25459bb5dc7((0, $3044e0bef3624137$exports.fromJS)(propertyListItem.value))}`;
        }).join('\n');
        contents += `${indentation}:PROPERTIES:\n`;
        contents += `${propertyListItemsContent}\n`;
        contents += `${indentation}:END:\n`;
    }
    // Log notes come after properties and before logbook.
    contents += $500d38b948046618$export$2c44f25459bb5dc7((0, $3044e0bef3624137$exports.fromJS)(header.logNotes)).split('\n').map((line)=>line.trim() ? `${indentation}${line}` : '').join('\n');
    contents += header.logNotes.length ? '\n' : '';
    if (header.logBookEntries.length) {
        const logBookEntriesContent = header.logBookEntries.map((entry)=>{
            if (entry.raw !== undefined) return entry.raw ? `${indentation}${entry.raw}` : '';
            else if (entry.end === null) return `${indentation}CLOCK: ${(0, $e706118dde20dbed$export$96c990e4d9eca709)((0, $3044e0bef3624137$exports.fromJS)(entry.start))}`;
            else return `${indentation}CLOCK: ${(0, $e706118dde20dbed$export$96c990e4d9eca709)((0, $3044e0bef3624137$exports.fromJS)(entry.start))}--${(0, $e706118dde20dbed$export$96c990e4d9eca709)((0, $3044e0bef3624137$exports.fromJS)(entry.end))} => ${(0, $e706118dde20dbed$export$bd27f0b37191265b)((0, $3044e0bef3624137$exports.fromJS)(entry.start), (0, $3044e0bef3624137$exports.fromJS)(entry.end))}`;
        }).join('\n').trimRight();
        contents += `${indentation}:LOGBOOK:\n`;
        contents += `${logBookEntriesContent}\n`;
        contents += `${indentation}:END:\n`;
    }
    // A newline character belongs to its line, not to the next line.
    // Unless rawDescription === '', it must have a trailing newline character.
    let fixedRawDescription = header.rawDescription;
    if (header.rawDescription.match(/[^\n]$/)) fixedRawDescription = header.rawDescription + '\n';
    contents += fixedRawDescription;
    return contents;
};
/**
 * Get all nested sub-headers recursively
 * @param {Array} headers - All headers in the file
 * @param {string} headerId - ID of the parent header
 * @returns {Array} Array of all nested sub-headers
 */ const $500d38b948046618$var$getAllNestedSubheaders = (headers, headerId)=>{
    const directSubheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, headerId);
    let allSubheaders = directSubheaders;
    directSubheaders.forEach((subheader)=>{
        const nestedSubheaders = $500d38b948046618$var$getAllNestedSubheaders(headers, subheader.get('id'));
        allSubheaders = allSubheaders.concat(nestedSubheaders);
    });
    return allSubheaders;
};
const $500d38b948046618$export$3f9d8b89a1ac10e0 = (header, headers, options = {})=>{
    const { includeSubheaders: includeSubheaders = true, recursive: recursive = true, includeTitle: includeTitle = true, dontIndent: dontIndent = false } = options;
    let content = $500d38b948046618$export$5f409df9aafd0448(header, includeTitle, dontIndent);
    if (includeSubheaders) {
        const subheaders = recursive ? $500d38b948046618$var$getAllNestedSubheaders(headers, header.get('id')) : (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, header.get('id'));
        const subheaderContent = subheaders.map((subheader)=>$500d38b948046618$export$5f409df9aafd0448(subheader, true, dontIndent)).join('\n');
        if (subheaderContent) content += '\n' + subheaderContent;
    }
    return content;
};





var $1X5R2 = parcelRequire("1X5R2");
var $9dc26f2876ad96b9$export$2e2bcd8739ae039 = (templateString, customVariables = (0, $3044e0bef3624137$exports.Map)())=>{
    if (!templateString) return [
        '',
        null
    ];
    const substitutions = {
        '%t': `<${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee')}>`,
        '%T': `<${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee HH:mm')}>`,
        '%u': `[${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee')}]`,
        '%U': `[${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee HH:mm')}]`,
        '%r': `${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee')}`,
        '%R': `${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy-MM-dd eee HH:mm')}`,
        '%y': `${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy')}`
    };
    customVariables.entrySeq().forEach(([key, value])=>{
        substitutions[`%${key}`] = value;
    });
    let substitutedString = templateString;
    (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).entries(substitutions).forEach(([formatString, value])=>substitutedString = substitutedString.replace(RegExp(formatString, 'g'), value));
    const cursorIndex = substitutedString.includes('%?') ? substitutedString.indexOf('%?') : null;
    substitutedString = substitutedString.replace(/%\?/, '');
    return [
        substitutedString,
        cursorIndex
    ];
};



const $2ce140c2c56df8f2$export$33411e7e5f33b9f6 = 'organice_internal_';
function $2ce140c2c56df8f2$var$generateHash(list) {
    return new Promise((resolve, reject)=>{
        if (crypto.subtle) crypto.subtle.digest({
            name: 'SHA-256'
        }, new Uint8Array(list)).then((hashArray)=>{
            resolve((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).values(new Uint8Array(hashArray)).join(''));
        });
        else {
            console.warn('crypto.subtle module is not available, returning an empty bogus hash.');
            resolve('');
        }
    });
}
const $2ce140c2c56df8f2$export$4188a0eec4f54d73 = ()=>{
    return new Promise((resolve, reject)=>{
        $2ce140c2c56df8f2$var$generateHash((0, (/*@__PURE__*/$parcel$interopDefault($53a31672b844dbfd$exports))).split('').map((c)=>c.charCodeAt(0))).then((hash)=>{
            resolve(hash);
        });
    });
};
const $2ce140c2c56df8f2$export$f47efee791012c28 = (headers, headerId)=>{
    const headerIndex = $2ce140c2c56df8f2$export$ae033bfa76a45f2a(headers, headerId);
    return {
        headerIndex: headerIndex,
        header: headers.get(headerIndex)
    };
};
const $2ce140c2c56df8f2$export$ae033bfa76a45f2a = (headers, headerId)=>{
    return headers.findIndex((header)=>header.get('id') === headerId);
};
const $2ce140c2c56df8f2$export$afc3b74231ba89f6 = (headers, headerId)=>{
    return headers.get($2ce140c2c56df8f2$export$ae033bfa76a45f2a(headers, headerId));
};
const $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderIndex = (headers, headerIndex)=>{
    const header = headers.get(headerIndex);
    const afterHeaders = headers.slice(headerIndex + 1);
    const nextSiblingHeaderIndex = afterHeaders.findIndex((siblingHeader)=>{
        return siblingHeader.get('nestingLevel') <= header.get('nestingLevel');
    });
    if (nextSiblingHeaderIndex === -1) return [
        headerIndex + 1,
        headers.size
    ];
    else return [
        headerIndex + 1,
        headerIndex + 1 + nextSiblingHeaderIndex
    ];
};
const $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderId = (headers, headerId)=>{
    const headerIndex = $2ce140c2c56df8f2$export$ae033bfa76a45f2a(headers, headerId);
    return $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderIndex(headers, headerIndex);
};
const $2ce140c2c56df8f2$export$d879a100d1ae9dc1 = (headers, headerId)=>{
    let [begin, end] = $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderId(headers, headerId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(begin, end);
};
const $2ce140c2c56df8f2$export$b12986adc1c2ae0d = (headers, headerIndex)=>{
    let [begin, end] = $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderIndex(headers, headerIndex);
    return headers.slice(begin, end);
};
const $2ce140c2c56df8f2$export$b3626b65e5a2fa46 = (headers, headerId)=>{
    let [begin, end] = $2ce140c2c56df8f2$var$subheaderIndexRangeForHeaderId(headers, headerId);
    return headers.slice(begin, end);
};
const $2ce140c2c56df8f2$export$463ed61f10f49ed3 = (headers, headerId)=>$2ce140c2c56df8f2$export$b3626b65e5a2fa46(headers, headerId).size;
const $2ce140c2c56df8f2$export$36f39ceb003db0c6 = (headers, headerId)=>{
    const { header: header, headerIndex: headerIndex } = $2ce140c2c56df8f2$export$f47efee791012c28(headers, headerId);
    for(let i = headerIndex - 1; i >= 0; --i){
        const previousHeader = headers.get(i);
        if (previousHeader.get('nestingLevel') === header.get('nestingLevel') - 1) return previousHeader;
        if (previousHeader.get('nestingLevel') < header.get('nestingLevel')) return null;
    }
    return null;
};
const $2ce140c2c56df8f2$export$9b07717387b684b9 = (headers, headerId)=>{
    const parent = $2ce140c2c56df8f2$export$36f39ceb003db0c6(headers, headerId);
    if (!parent) return null;
    else return parent.get('id');
};
const $2ce140c2c56df8f2$export$ef31029008f7a87f = (headers, headerId)=>{
    const { header: header, headerIndex: headerIndex } = $2ce140c2c56df8f2$export$f47efee791012c28(headers, headerId);
    const previousHeaders = headers.slice(0, headerIndex);
    const parentHeader = previousHeaders.findLast((previousHeader)=>previousHeader.get('nestingLevel') < header.get('nestingLevel'));
    if (!parentHeader) return null;
    return parentHeader.get('id');
};
const $2ce140c2c56df8f2$export$5092be3f66c32d1 = (headers, headerIndex, property)=>{
    const headerProp = headers.getIn([
        headerIndex,
        'propertyListItems'
    ]).find((item)=>item.get('property') === property);
    if (headerProp) return headerProp.get('value');
    const parentId = $2ce140c2c56df8f2$export$ef31029008f7a87f(headers, headers.getIn([
        headerIndex,
        'id'
    ]));
    if (parentId) {
        const parentHeaderIndex = $2ce140c2c56df8f2$export$ae033bfa76a45f2a(headers, parentId);
        return $2ce140c2c56df8f2$export$5092be3f66c32d1(headers, parentHeaderIndex, property);
    }
    return null;
};
const $2ce140c2c56df8f2$export$b315472b90440d4b = (headers, headerIndex)=>{
    const nestingLevel = headers.getIn([
        headerIndex,
        'nestingLevel'
    ]);
    for(let i = headerIndex - 1; i >= 0; --i){
        const header = headers.get(i);
        if (header.get('nestingLevel') < nestingLevel) return null;
        if (header.get('nestingLevel') === nestingLevel) return i;
    }
    return null;
};
const $2ce140c2c56df8f2$var$isHeaderVisible = (headers, headerId)=>{
    const parentHeaderId = $2ce140c2c56df8f2$export$ef31029008f7a87f(headers, headerId);
    if (!parentHeaderId) return true;
    const parentHeader = $2ce140c2c56df8f2$export$afc3b74231ba89f6(headers, parentHeaderId);
    return parentHeader.get('opened') && $2ce140c2c56df8f2$var$isHeaderVisible(headers, parentHeader.get('id'));
};
const $2ce140c2c56df8f2$export$a960808ab77a8018 = (headers, headerIndex)=>{
    const followingHeaders = headers.slice(headerIndex + 1);
    return followingHeaders.find((header)=>$2ce140c2c56df8f2$var$isHeaderVisible(headers, header.get('id')));
};
const $2ce140c2c56df8f2$export$642b816205fa205f = (headers, headerIndex)=>{
    const previousHeaders = headers.slice(0, headerIndex).reverse();
    return previousHeaders.find((header)=>$2ce140c2c56df8f2$var$isHeaderVisible(headers, header.get('id')));
};
const $2ce140c2c56df8f2$export$3aff284a03c3dab2 = (state, headerId)=>{
    const parentHeaderId = $2ce140c2c56df8f2$export$9b07717387b684b9(state.get('headers'), headerId);
    if (parentHeaderId !== null) {
        const parentHeaderIndex = $2ce140c2c56df8f2$export$ae033bfa76a45f2a(state.get('headers'), parentHeaderId);
        state = state.setIn([
            'headers',
            parentHeaderIndex,
            'opened'
        ], true);
    }
    return state;
};
const $2ce140c2c56df8f2$export$580ddb2e4add8c37 = (headers)=>{
    let openedHeaders = [];
    for(let i = 0; i < headers.size; ++i){
        const header = headers.get(i);
        if (!header.get('opened')) continue;
        const title = header.getIn([
            'titleLine',
            'rawTitle'
        ]);
        const subheaders = $2ce140c2c56df8f2$export$b3626b65e5a2fa46(headers, header.get('id'));
        const openSubheaderPaths = $2ce140c2c56df8f2$export$580ddb2e4add8c37(subheaders);
        if (openSubheaderPaths.length > 0) openSubheaderPaths.forEach((openedSubheaderPath)=>{
            openedHeaders.push([
                title
            ].concat(openedSubheaderPath));
        });
        else openedHeaders.push([
            title
        ]);
        i += subheaders.size;
    }
    return openedHeaders;
};
const $2ce140c2c56df8f2$export$a741dccf9e227875 = (state)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const headerId = file.get('selectedHeaderId');
    const headers = file.get('headers');
    if (!headers) return null;
    const headerIdx = $2ce140c2c56df8f2$export$ae033bfa76a45f2a(headers, headerId);
    if (headerIdx === -1) return null;
    return file.getIn([
        'headers',
        headerIdx
    ]);
};
const $2ce140c2c56df8f2$export$250b3505fb888bc1 = (headers, headerPath)=>{
    if (headerPath.size === 0) return null;
    const firstHeader = headers.find((header)=>$2ce140c2c56df8f2$export$ef31029008f7a87f(headers, header.get('id')) === null && header.getIn([
            'titleLine',
            'rawTitle'
        ]).trim() === (0, $9dc26f2876ad96b9$export$2e2bcd8739ae039)(headerPath.first())[0].trim());
    if (!firstHeader) return null;
    if (headerPath.size === 1) return firstHeader;
    const subheaders = $2ce140c2c56df8f2$export$b3626b65e5a2fa46(headers, firstHeader.get('id'));
    return $2ce140c2c56df8f2$export$250b3505fb888bc1(subheaders, headerPath.rest());
};
const $2ce140c2c56df8f2$export$d5d9afe6a5747ace = (headers, headerPath, maxNestingLevel = 1)=>{
    if (headerPath.size === 0) return headers;
    const firstTitle = headerPath.first();
    const headerIndex = headers.findIndex((header)=>{
        const rawTitle = header.getIn([
            'titleLine',
            'rawTitle'
        ]);
        const nestingLevel = header.get('nestingLevel');
        return rawTitle === firstTitle && nestingLevel <= maxNestingLevel;
    });
    if (headerIndex === -1) return headers;
    headers = headers.update(headerIndex, (header)=>header.set('opened', true));
    let subheaders = $2ce140c2c56df8f2$export$b3626b65e5a2fa46(headers, headers.getIn([
        headerIndex,
        'id'
    ]));
    subheaders = $2ce140c2c56df8f2$export$d5d9afe6a5747ace(subheaders, headerPath.rest(), maxNestingLevel + 1);
    headers = headers.take(headerIndex + 1).concat(subheaders).concat(headers.takeLast(headers.size - (headerIndex + 1 + subheaders.size)));
    return headers;
};
const $2ce140c2c56df8f2$var$tablePartContainsCellId = (tablePart, cellId)=>tablePart.get('contents').some((row)=>row.get('contents').some((cell)=>cell.get('id') === cellId));
const $2ce140c2c56df8f2$var$doesAttributedStringContainTableCellId = (parts, cellId)=>parts.filter((part)=>[
            'table',
            'list'
        ].includes(part.get('type'))).some((part)=>part.get('type') === 'table' ? $2ce140c2c56df8f2$var$tablePartContainsCellId(part, cellId) : part.get('items').some((item)=>$2ce140c2c56df8f2$var$doesAttributedStringContainTableCellId(item.get('contents'), cellId)));
const $2ce140c2c56df8f2$export$6bbf84700621f2e9 = (headers, cellId)=>headers.find((header)=>$2ce140c2c56df8f2$var$doesAttributedStringContainTableCellId(header.get('description'), cellId));
const $2ce140c2c56df8f2$export$2a3d4cf94685aa4f = (parts, timestampId)=>parts.map((part, partIndex)=>{
        if (part.get('type') === 'timestamp' && part.get('id') === timestampId) return {
            path: [
                partIndex
            ],
            timestampPart: part
        };
        else if (part.get('type') === 'list') return part.get('items').map((item, itemIndex)=>{
            let pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(item.get('contents'), timestampId);
            if (pathAndPart) {
                const { path: path, timestampPart: timestampPart } = pathAndPart;
                return {
                    path: [
                        partIndex,
                        'items',
                        itemIndex,
                        'contents'
                    ].concat(path),
                    timestampPart: timestampPart
                };
            } else {
                let pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(item.get('titleLine'), timestampId);
                if (pathAndPart) {
                    const { path: path, timestampPart: timestampPart } = pathAndPart;
                    return {
                        path: [
                            partIndex,
                            'items',
                            itemIndex,
                            'titleLine'
                        ].concat(path),
                        timestampPart: timestampPart
                    };
                } else return null;
            }
        }).filter((result)=>result).first();
        else if (part.get('type') === 'table') return part.get('contents').map((row, rowIndex)=>{
            return row.get('contents').map((cell, cellIndex)=>{
                const pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(cell.get('contents'), timestampId);
                if (pathAndPart) {
                    const { path: path, timestampPart: timestampPart } = pathAndPart;
                    return {
                        path: [
                            partIndex,
                            'contents',
                            rowIndex,
                            'contents',
                            cellIndex,
                            'contents'
                        ].concat(path),
                        timestampPart: timestampPart
                    };
                } else return null;
            }).filter((result)=>result).first();
        }).filter((result)=>result).first();
        else return null;
    }).filter((result)=>result).first();
const $2ce140c2c56df8f2$export$6fe4e048ddeb0b7e = (listPart, itemId)=>listPart.get('items').some((item)=>item.get('id') === itemId);
const $2ce140c2c56df8f2$export$7e65e54aa094efde = (headers, listItemId)=>{
    const pathAndPart = $2ce140c2c56df8f2$export$ae49cfeed011a192(headers, listItemId);
    const headerIndex = pathAndPart.path[0];
    return headers.get(headerIndex);
};
const $2ce140c2c56df8f2$export$4af356fd6058e04a = (parts, listItemId)=>parts.map((part, partIndex)=>{
        if (part.get('type') === 'list') return part.get('items').map((item, itemIndex)=>{
            if (item.get('id') === listItemId) return {
                path: [
                    partIndex,
                    'items',
                    itemIndex
                ],
                listItemPart: item
            };
            else {
                const pathAndPart = $2ce140c2c56df8f2$export$4af356fd6058e04a(item.get('contents'), listItemId);
                if (pathAndPart) {
                    const { path: path, listItemPart: listItemPart } = pathAndPart;
                    return {
                        path: [
                            partIndex,
                            'items',
                            itemIndex,
                            'contents'
                        ].concat(path),
                        listItemPart: listItemPart
                    };
                } else return null;
            }
        }).filter((result)=>result).first();
        else return null;
    }).filter((result)=>result).first();
const $2ce140c2c56df8f2$export$91ae0cfb9ffc1 = (parts, cellId)=>parts.map((part, partIndex)=>{
        if (part.get('type') === 'table') {
            if ($2ce140c2c56df8f2$var$tablePartContainsCellId(part, cellId)) return {
                path: [
                    partIndex
                ],
                tablePart: part
            };
            else return null;
        } else if (part.get('type') === 'list') return part.get('items').map((item, itemIndex)=>{
            const pathAndPart = $2ce140c2c56df8f2$export$91ae0cfb9ffc1(item.get('contents'), cellId);
            if (pathAndPart) {
                const { path: path, tablePart: tablePart } = pathAndPart;
                return {
                    path: [
                        partIndex,
                        'items',
                        itemIndex,
                        'contents'
                    ].concat(path),
                    tablePart: tablePart
                };
            } else return null;
        }).filter((result)=>result).first();
        else return null;
    }).filter((result)=>result).first();
const $2ce140c2c56df8f2$export$9e0d80fb26e3046 = (headers, itemId)=>headers.map((header, headerIndex)=>{
        const pathAndPart = $2ce140c2c56df8f2$export$bac55365af8d291d(header.get('description'), itemId);
        if (!pathAndPart) return null;
        const { path: path, listPart: listPart } = pathAndPart;
        return {
            path: [
                headerIndex,
                'description'
            ].concat(path),
            listPart: listPart
        };
    }).filter((result)=>!!result).first();
const $2ce140c2c56df8f2$export$bac55365af8d291d = (parts, itemId)=>parts.map((part, partIndex)=>{
        if (part.get('type') === 'list') {
            if ($2ce140c2c56df8f2$export$6fe4e048ddeb0b7e(part, itemId)) return {
                path: [
                    partIndex
                ],
                listPart: part
            };
            else return part.get('items').map((item, itemIndex)=>{
                const pathAndPart = $2ce140c2c56df8f2$export$bac55365af8d291d(item.get('contents'), itemId);
                if (!!pathAndPart) {
                    const { path: path, listPart: listPart } = pathAndPart;
                    return {
                        path: [
                            partIndex,
                            'items',
                            itemIndex,
                            'contents'
                        ].concat(path),
                        listPart: listPart
                    };
                } else return null;
            }).filter((result)=>!!result).first();
        } else return null;
    }).filter((result)=>!!result).first();
const $2ce140c2c56df8f2$export$f89d291feb963fe7 = (headers, timestampId)=>{
    const makeResult = (headerIndex, pathAndPart, localPath)=>({
            path: [
                headerIndex,
                ...localPath
            ].concat(pathAndPart.path),
            timestampPart: pathAndPart.timestampPart
        });
    return headers.map((header, headerIndex)=>{
        let localPath = [
            'titleLine',
            'title'
        ];
        let pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(header.getIn(localPath), timestampId);
        if (pathAndPart) return makeResult(headerIndex, pathAndPart, localPath);
        localPath = [
            'description'
        ];
        pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(header.getIn(localPath), timestampId);
        if (pathAndPart) return makeResult(headerIndex, pathAndPart, localPath);
        localPath = [
            'logNotes'
        ];
        pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(header.getIn(localPath), timestampId);
        if (pathAndPart) return makeResult(headerIndex, pathAndPart, localPath);
        pathAndPart = header.get('propertyListItems').map((propertyListItem, propertyListItemIndex)=>{
            if (!propertyListItem.get('value')) return null;
            const plistPathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(propertyListItem.get('value'), timestampId);
            localPath = [
                'propertyListItems',
                propertyListItemIndex,
                'value'
            ];
            if (plistPathAndPart) return makeResult(headerIndex, plistPathAndPart, localPath);
            return null;
        }).filter((result)=>result).first();
        if (pathAndPart) return pathAndPart;
        return null;
    }).filter((result)=>result).first();
};
const $2ce140c2c56df8f2$export$ae49cfeed011a192 = (headers, listItemId)=>headers.map((header, headerIndex)=>{
        const pathAndPart = $2ce140c2c56df8f2$export$4af356fd6058e04a(header.get('description'), listItemId);
        if (!pathAndPart) return null;
        const { path: path, listItemPart: listItemPart } = pathAndPart;
        return {
            path: [
                headerIndex,
                'description'
            ].concat(path),
            listItemPart: listItemPart
        };
    }).filter((result)=>result).first();
const $2ce140c2c56df8f2$export$a326f44c5ee4109c = (headers, cellId)=>headers.map((header, headerIndex)=>{
        const pathAndPart = $2ce140c2c56df8f2$export$91ae0cfb9ffc1(header.get('description'), cellId);
        if (!pathAndPart) return null;
        const { path: path, tablePart: tablePart } = pathAndPart;
        return {
            path: [
                headerIndex,
                'description'
            ].concat(path),
            tablePart: tablePart
        };
    }).filter((result)=>result).first();
const $2ce140c2c56df8f2$export$9487685acf653331 = (headers, cellId, updaterCallbackGenerator)=>{
    const { path: path, tablePart: tablePart } = $2ce140c2c56df8f2$export$a326f44c5ee4109c(headers, cellId);
    const rowIndexContainingCellId = tablePart.get('contents').findIndex((row)=>row.get('contents').some((cell)=>cell.get('id') === cellId));
    const columnIndexContainingCellId = tablePart.getIn([
        'contents',
        rowIndexContainingCellId,
        'contents'
    ]).findIndex((cell)=>cell.get('id') === cellId);
    return headers.updateIn(path.concat([
        'contents'
    ]), updaterCallbackGenerator(rowIndexContainingCellId, columnIndexContainingCellId));
};
const $2ce140c2c56df8f2$export$6bfdd11774525e12 = (rows)=>rows.get(0).set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()).update('contents', (contents)=>contents.map((cell)=>cell.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()).set('contents', (0, $3044e0bef3624137$exports.List)()).set('rawContents', '')));
const $2ce140c2c56df8f2$export$47d4da7b3d2d7510 = ()=>(0, $3044e0bef3624137$exports.fromJS)({
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        contents: [],
        rawContents: ''
    });
const $2ce140c2c56df8f2$export$6c5e537b4cba77ad = ()=>(0, $3044e0bef3624137$exports.fromJS)({
        type: 'list',
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        items: [],
        bulletCharacter: '-',
        numberTerminatorCharacter: null,
        isOrdered: false
    });
const $2ce140c2c56df8f2$export$a4e7e51fe81bbd05 = (part)=>part.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()).set('items', new (0, $3044e0bef3624137$exports.List)());
const $2ce140c2c56df8f2$export$532acb76fbba39ec = ()=>(0, $3044e0bef3624137$exports.fromJS)({
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        titleLine: [],
        contents: [],
        forceNumber: null,
        isCheckbox: false
    });
const $2ce140c2c56df8f2$export$db600c451336e49b = (headers, listItemId)=>{
    const pathAndPart = $2ce140c2c56df8f2$export$ae49cfeed011a192(headers, listItemId);
    let { path: path } = pathAndPart;
    return headers.getIn(path.slice(0, path.length - 4));
};
const $2ce140c2c56df8f2$export$daeaec57af29be9 = (headers, listItemId, updaterCallbackGenerator)=>{
    const { path: path, listPart: listPart } = $2ce140c2c56df8f2$export$9e0d80fb26e3046(headers, listItemId);
    const itemIndexContainingId = listPart.get('items').findIndex((item)=>item.get('id') === listItemId);
    return headers.updateIn(path.concat([
        'items'
    ]), updaterCallbackGenerator(itemIndexContainingId));
};
const $2ce140c2c56df8f2$export$542d59a95b02bd6f = (parts, listItem, listPart = null)=>{
    if (parts.size === 0 || parts.last().get('type') !== 'list') {
        const insertIdx = parts.size;
        if (!!listPart) parts = parts.insert(insertIdx, $2ce140c2c56df8f2$export$a4e7e51fe81bbd05(listPart));
        else parts = parts.insert(insertIdx, $2ce140c2c56df8f2$export$6c5e537b4cba77ad());
    }
    return parts.map((part)=>{
        switch(part.get('type')){
            case 'list':
                return part.update('items', (items)=>items.push(listItem));
            default:
                return part;
        }
    });
};
const $2ce140c2c56df8f2$export$61bb2e0c32d3fd3b = (parts, timestampId)=>{
    if (!parts) return null;
    const pathAndPart = $2ce140c2c56df8f2$export$2a3d4cf94685aa4f(parts, timestampId);
    if (pathAndPart) return pathAndPart.timestampPart;
    else return null;
};
const $2ce140c2c56df8f2$export$f846250bab1767a = (headers, timestampId)=>headers.map((header)=>$2ce140c2c56df8f2$export$61bb2e0c32d3fd3b(header.getIn([
            'titleLine',
            'title'
        ]), timestampId) || $2ce140c2c56df8f2$export$61bb2e0c32d3fd3b(header.get('description'), timestampId) || $2ce140c2c56df8f2$export$61bb2e0c32d3fd3b(header.get('logNotes'), timestampId) || header.get('propertyListItems').map((propertyListItem)=>$2ce140c2c56df8f2$export$61bb2e0c32d3fd3b(propertyListItem.get('value'), timestampId)).filter((result)=>result).first()).find((result)=>result);
const $2ce140c2c56df8f2$export$587d51660e3dfec4 = (datetime)=>{
    return (0, $4713c3dd214d4e1e$export$2e2bcd8739ae039)(datetime, {
        addSuffix: true
    });
};
const $2ce140c2c56df8f2$export$2775d13f49f665b = (todoKeywordSets, keyword)=>todoKeywordSets.find((keywordSet)=>keywordSet.get('keywords').contains(keyword)) || todoKeywordSets.first();
const $2ce140c2c56df8f2$export$60678e145a879202 = (todoKeywordSets, keyword)=>$2ce140c2c56df8f2$export$2775d13f49f665b(todoKeywordSets, keyword).get('completedKeywords').includes(keyword);
const $2ce140c2c56df8f2$export$85c08d0e36dc9b2e = (headers)=>headers.flatMap((h)=>h.getIn([
            'titleLine',
            'tags'
        ])).toSet().sort();
const $2ce140c2c56df8f2$export$25128b086a978b1a = (headers)=>headers.map((h)=>{
        const propertyList = h.get('propertyListItems');
        return propertyList.map((property)=>{
            const prop = property.get('property');
            const valParts = property.get('value'); // lineParts, see parser
            const val = (0, $500d38b948046618$export$2c44f25459bb5dc7)(valParts);
            return [
                prop,
                val
            ];
        });
    }).filter((x)=>!x.isEmpty()).flatten();
const $2ce140c2c56df8f2$export$dc7a29fc539d16a4 = (allOrgProperties)=>allOrgProperties.map(([x])=>x).toSet().sort();
const $2ce140c2c56df8f2$export$dda9638442af5e1c = (allOrgProperties, propertyName)=>// toLowerCase() because property names (keys) are case-insensitive:
    // https://orgmode.org/manual/Property-Syntax.html
    allOrgProperties.filter(([x])=>x.toLowerCase() === propertyName.toLowerCase()).map(([_, y])=>y).toSet().sort();
const $2ce140c2c56df8f2$export$a5209cf0e5ae5860 = (header)=>header.get('rawDescription') || !header.get('planningItems').isEmpty() || !header.get('propertyListItems').isEmpty() || !header.get('logNotes').isEmpty() || !header.get('logBookEntries').isEmpty();
const $2ce140c2c56df8f2$export$f6a5d435cb1f7b7f = (todoKeywordSets)=>{
    return (todoKeyword)=>todoKeywordSets.some((x)=>x.get('completedKeywords').includes(todoKeyword));
};
const $2ce140c2c56df8f2$export$dd50aa628860b07d = (x)=>!x.get('type').startsWith('TIMESTAMP_');
const $2ce140c2c56df8f2$export$39a3e68e78f1544d = (planningItem)=>$2ce140c2c56df8f2$export$dd50aa628860b07d(planningItem) ? planningItem.get('type') : 'TIMESTAMP';
const $2ce140c2c56df8f2$export$c443a8c15d9ea88 = (state)=>{
    return state.get('todoKeywordSets').flatMap((todoKeywordSet)=>{
        return todoKeywordSet.get('keywords');
    }).toSet().toJS();
};
const $2ce140c2c56df8f2$export$cb89f492e03ac783 = /\.org(_archive)?$/;
const $2ce140c2c56df8f2$var$addBreadcrumbs = (headers, breadcrumbs, headerId)=>{
    const parent = $2ce140c2c56df8f2$export$36f39ceb003db0c6(headers, headerId);
    if (!parent) return breadcrumbs;
    breadcrumbs.unshift(parent.get('titleLine').get('rawTitle'));
    return $2ce140c2c56df8f2$var$addBreadcrumbs(headers, breadcrumbs, parent.get('id'));
};
const $2ce140c2c56df8f2$var$getBreadcrumbs = (headers, headerId)=>{
    return $2ce140c2c56df8f2$var$addBreadcrumbs(headers, [], headerId);
};
const $2ce140c2c56df8f2$export$5aab98689c4eaa9c = (allHeaders, path)=>{
    const allHeadersOfFile = allHeaders.get(path);
    let filename;
    if (path.startsWith($2ce140c2c56df8f2$export$33411e7e5f33b9f6)) filename = path.substring($2ce140c2c56df8f2$export$33411e7e5f33b9f6.length);
    else if (path.endsWith('.org')) filename = path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('.'));
    else filename = path.substring(path.lastIndexOf('/') + 1);
    return (header)=>{
        let breadcrumbs = $2ce140c2c56df8f2$var$getBreadcrumbs(allHeadersOfFile, header.get('id'));
        breadcrumbs.unshift(filename);
        const maxBreadcrumbLength = Math.max(3, Math.floor((80 - 3 * breadcrumbs.length) / breadcrumbs.length));
        breadcrumbs = breadcrumbs.map((b)=>b.length > maxBreadcrumbLength ? b.substr(0, maxBreadcrumbLength - 2) + '..' : b);
        return breadcrumbs.join(' > ');
    };
};
const $2ce140c2c56df8f2$export$71b553ef914ccf29 = (0, $55c61384e4e198c2$exports.curry)(({ filePath: filePath, headerIndex: headerIndex, descriptionItemIndex: descriptionItemIndex }, state)=>{
    return state.org.present.getIn([
        'files',
        filePath,
        'headers',
        headerIndex,
        'description',
        descriptionItemIndex
    ]);
});
const $2ce140c2c56df8f2$export$cf56cbc0015b9853 = (state)=>{
    const filePath = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        filePath
    ], (0, $3044e0bef3624137$exports.Map)());
    const headerIndex = file.get('selectedHeaderIndex');
    const descriptionItemIndex = file.get('selectedDescriptionItemIndex');
    return $2ce140c2c56df8f2$export$71b553ef914ccf29({
        filePath: filePath,
        headerIndex: headerIndex,
        descriptionItemIndex: descriptionItemIndex
    }, state);
};
const $2ce140c2c56df8f2$export$16d08c6bdc3d6518 = (0, $55c61384e4e198c2$exports.curry)(({ filePath: filePath, headerIndex: headerIndex, descriptionItemIndex: descriptionItemIndex, row: row, column: column }, state)=>{
    const table = $2ce140c2c56df8f2$export$71b553ef914ccf29({
        filePath: filePath,
        headerIndex: headerIndex,
        descriptionItemIndex: descriptionItemIndex
    }, state);
    return table.getIn([
        'contents',
        row,
        'contents',
        column
    ]);
});
const $2ce140c2c56df8f2$export$2b57a1f2af7b062c = {
    PRECEDING_DAYS: 21,
    FOLLOWING_DAYS: 7
};
const $2ce140c2c56df8f2$export$96f956050c634e56 = (header)=>{
    if (!header || !header.get('propertyListItems')) return false;
    return header.get('propertyListItems').some((item)=>{
        const prop = item.get('property');
        const value = item.get('value');
        return prop && prop.toLowerCase() === 'style' && value && value.some((v)=>v.get('type') === 'text' && v.get('contents').trim() === 'habit');
    });
};
const $2ce140c2c56df8f2$export$bd29749f2a066b44 = (timestamp)=>{
    if (!timestamp) return null;
    const repeaterType = timestamp.get('repeaterType');
    if (![
        '.+',
        '+',
        '++'
    ].includes(repeaterType)) return null; // Habits use one of the repeater types
    const repeaterUnit = timestamp.get('repeaterUnit');
    const validUnits = [
        'd',
        'w',
        'm',
        'y'
    ];
    if (!validUnits.includes(repeaterUnit)) return null; // Habits only work with days, weeks, months, years
    const convertToDays = (val, unit)=>{
        const v = parseInt(val, 10) || 0;
        switch(unit){
            case 'd':
                return v;
            case 'w':
                return v * 7;
            case 'm':
                return v * 30;
            case 'y':
                return v * 365;
            default:
                return v;
        }
    };
    const maxDays = convertToDays(timestamp.get('repeaterValue'), repeaterUnit) || 1;
    const deadlineValue = timestamp.get('repeaterDeadlineValue');
    const deadlineUnit = timestamp.get('repeaterDeadlineUnit') || repeaterUnit;
    const minDays = deadlineValue ? convertToDays(deadlineValue, deadlineUnit) : maxDays;
    return {
        minDays: minDays,
        maxDays: maxDays
    };
};
const $2ce140c2c56df8f2$export$e59613884f5c7e07 = (header)=>{
    if (!$2ce140c2c56df8f2$export$96f956050c634e56(header)) return false;
    // Habits need a scheduled date with a .+ repeater
    const planningItems = header.get('planningItems');
    if (!planningItems) return false;
    const scheduledItem = planningItems.find((item)=>item.get('type') === 'SCHEDULED');
    if (!scheduledItem) return false;
    const timestamp = scheduledItem.get('timestamp');
    return $2ce140c2c56df8f2$export$bd29749f2a066b44(timestamp) !== null;
};
const $2ce140c2c56df8f2$export$39832c1a28f48eff = (header)=>{
    if (!header) return [];
    const completionDates = [];
    const logNotes = header.get('logNotes');
    if (logNotes) // Parse log notes for state change entries.
    // We process the list items if they exist, or the raw text if it's just a string.
    logNotes.forEach((part)=>{
        if (part.get('type') === 'list') part.get('items').forEach((item)=>{
            const titleLine = item.get('titleLine');
            const raw = (0, $500d38b948046618$export$2c44f25459bb5dc7)(titleLine || (0, $3044e0bef3624137$exports.List)());
            // Match pattern: - State "DONE" from "TODO" [date]
            const stateChangeMatch = raw.match(/State\s+"([^"]+)"\s+from\s+"([^"]+)"\s+\[([^\]]+)\]/);
            if (stateChangeMatch) {
                const dateStr = stateChangeMatch[3];
                const date = $2ce140c2c56df8f2$var$parseHabitTimestamp(dateStr);
                if (date) completionDates.push(date);
            }
        });
        else if (part.get('type') === 'text') {
            const contents = part.get('contents');
            const lines = contents.split('\n');
            lines.forEach((line)=>{
                const stateChangeMatch = line.match(/State\s+"([^"]+)"\s+from\s+"([^"]+)"\s+\[([^\]]+)\]/);
                if (stateChangeMatch) {
                    const dateStr = stateChangeMatch[3];
                    const date = $2ce140c2c56df8f2$var$parseHabitTimestamp(dateStr);
                    if (date) completionDates.push(date);
                }
            });
        }
    });
    const logBookEntries = header.get('logBookEntries');
    if (logBookEntries) logBookEntries.forEach((entry)=>{
        const raw = entry.get('raw');
        if (raw) {
            // Match pattern: - State "DONE" from "TODO" [date]
            const stateChangeMatch = raw.match(/State\s+"([^"]+)"\s+from\s+"([^"]+)"\s+\[([^\]]+)\]/);
            if (stateChangeMatch) {
                const dateStr = stateChangeMatch[3];
                const date = $2ce140c2c56df8f2$var$parseHabitTimestamp(dateStr);
                if (date) completionDates.push(date);
            }
        }
    });
    return completionDates.sort((a, b)=>a - b);
};
/**
 * Parse a timestamp string from habit log entries.
 * Supports formats like: "2024-01-15 Mon 09:30" or "2024-01-15 Mon"
 *
 * @param {string} dateStr - Date string from log entry
 * @returns {Date|null} Parsed date or null
 */ const $2ce140c2c56df8f2$var$parseHabitTimestamp = (dateStr)=>{
    try {
        // Remove the day name (e.g. "Mon", "Tue") as date-fns v2 cannot parse 'eee' and 'yyyy' together
        // Pattern matches 3 letters surrounded by spaces or at end
        const cleanDateStr = dateStr.replace(/\s+[A-Za-z]{3}(\s+|$)/, ' ').trim();
        // Try with time first
        let date = (0, $3b0472fc9ca892cd$export$2e2bcd8739ae039)(cleanDateStr, 'yyyy-MM-dd HH:mm', new Date());
        if (!isNaN(date)) return date;
        // Try without time
        date = (0, $3b0472fc9ca892cd$export$2e2bcd8739ae039)(cleanDateStr, 'yyyy-MM-dd', new Date());
        if (!isNaN(date)) return date;
    } catch (e) {
    // Return null if parsing fails
    }
    return null;
};
const $2ce140c2c56df8f2$export$396767b392ddab91 = (header, viewDate = new Date(), options = {})=>{
    const { precedingDays: precedingDays = $2ce140c2c56df8f2$export$2b57a1f2af7b062c.PRECEDING_DAYS, followingDays: followingDays = $2ce140c2c56df8f2$export$2b57a1f2af7b062c.FOLLOWING_DAYS } = options;
    if (!$2ce140c2c56df8f2$export$e59613884f5c7e07(header)) return [];
    // Get the scheduled date and repeat info
    const planningItems = header.get('planningItems');
    const scheduledItem = planningItems.find((item)=>item.get('type') === 'SCHEDULED');
    const scheduledTimestamp = scheduledItem.get('timestamp');
    const repeatInfo = $2ce140c2c56df8f2$export$bd29749f2a066b44(scheduledTimestamp);
    const { minDays: minDays, maxDays: maxDays } = repeatInfo;
    // Get completion history
    const completionDates = $2ce140c2c56df8f2$export$39832c1a28f48eff(header);
    // Calculate the start date for the graph
    const startDate = new Date(viewDate);
    startDate.setDate(startDate.getDate() - precedingDays);
    // Calculate the end date for the graph
    const endDate = new Date(viewDate);
    endDate.setDate(endDate.getDate() + followingDays);
    // Generate data points for each day
    const dataPoints = [];
    const currentDate = new Date(startDate);
    while(currentDate <= endDate){
        const dataPoint = $2ce140c2c56df8f2$var$calculateDayStatus(currentDate, viewDate, scheduledTimestamp, minDays, maxDays, completionDates);
        dataPoints.push((0, $frurs._)({
            date: new Date(currentDate)
        }, dataPoint));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dataPoints;
};
/**
 * Calculate the status for a single day in the habit graph.
 *
 * Status values (matching Org mode colors):
 * - 'done': Task was completed on this day (green in org mode)
 * - 'missed': Task was not done and deadline passed (red)
 * - 'future': Not due yet (blue)
 * - 'due-soon': Due tomorrow (yellow)
 * - 'not-scheduled': Before the initial scheduled date
 * - 'overdue': Past the max deadline
 *
 * @param {Date} day - The day to calculate status for
 * @param {Date} today - The reference date (usually today)
 * @param {Map} scheduledTimestamp - The scheduled timestamp from the habit
 * @param {number} minDays - Minimum days between completions
 * @param {number} maxDays - Maximum days between completions
 * @param {Array<Date>} completionDates - Array of completion dates
 * @returns {Object} { status, scheduledDeadline }
 */ const $2ce140c2c56df8f2$var$calculateDayStatus = (day, today, scheduledTimestamp, minDays, maxDays, completionDates)=>{
    // Get the base scheduled date from the timestamp
    const baseScheduledDate = (0, $e706118dde20dbed$export$77db66937f538459)(scheduledTimestamp);
    // For the initial calculation, we need to find the most recent completion
    // before this day and calculate the expected schedule from there
    const sortedCompletions = [
        ...completionDates
    ].filter((d)=>d <= day).sort((a, b)=>b - a);
    const lastCompletion = sortedCompletions[0];
    let expectedDate;
    if (lastCompletion) {
        // Calculate when this task should be due based on last completion
        expectedDate = new Date(lastCompletion);
        expectedDate.setDate(expectedDate.getDate() + maxDays);
    } else // Use the original scheduled date
    expectedDate = new Date(baseScheduledDate);
    // Check if this day was a completion day
    const isCompleted = completionDates.some((d)=>$2ce140c2c56df8f2$var$isSameDay(d, day));
    if (isCompleted) return {
        status: 'done',
        scheduledDeadline: expectedDate
    };
    // Calculate the "not due yet" window
    // After completion, we're not due until minDays pass
    if (lastCompletion) {
        const notDueUntil = new Date(lastCompletion);
        notDueUntil.setDate(notDueUntil.getDate() + minDays);
        // Only return 'future' if day is BEFORE notDueUntil and NOT the expected deadline day
        if (!$2ce140c2c56df8f2$var$isSameDay(day, notDueUntil) && !$2ce140c2c56df8f2$var$isSameDay(day, expectedDate) && day < notDueUntil) return {
            status: 'future',
            scheduledDeadline: expectedDate
        };
    } else {
        // Before the first scheduled date (use isSameDay to handle time component issues)
        if (!$2ce140c2c56df8f2$var$isSameDay(day, baseScheduledDate) && day < baseScheduledDate) return {
            status: 'not-scheduled',
            scheduledDeadline: expectedDate
        };
        // In the grace period before first deadline (excluding expected deadline day)
        const gracePeriodEnd = new Date(baseScheduledDate);
        gracePeriodEnd.setDate(gracePeriodEnd.getDate() + minDays);
        if (!$2ce140c2c56df8f2$var$isSameDay(day, gracePeriodEnd) && !$2ce140c2c56df8f2$var$isSameDay(day, expectedDate) && day < gracePeriodEnd && day >= baseScheduledDate) return {
            status: 'future',
            scheduledDeadline: expectedDate
        };
    }
    // Check if deadline is today (due-soon) - must come before overdue check
    if ($2ce140c2c56df8f2$var$isSameDay(day, expectedDate) && day <= today) return {
        status: 'due-soon',
        scheduledDeadline: expectedDate
    };
    // Check if we're past the deadline
    if (day > expectedDate && !$2ce140c2c56df8f2$var$isSameDay(day, expectedDate)) return {
        status: 'overdue',
        scheduledDeadline: expectedDate
    };
    // Check if deadline is tomorrow
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    if ($2ce140c2c56df8f2$var$isSameDay(day, tomorrow)) return {
        status: 'due-soon',
        scheduledDeadline: expectedDate
    };
    // Within the valid window
    return {
        status: 'scheduled',
        scheduledDeadline: expectedDate
    };
};
/**
 * Check if two dates are the same day (ignoring time).
 */ const $2ce140c2c56df8f2$var$isSameDay = (date1, date2)=>{
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $2ce140c2c56df8f2$export$1cb5d406a94e1af2 = (header, afterDate = new Date())=>{
    if (!$2ce140c2c56df8f2$export$e59613884f5c7e07(header)) return null;
    const planningItems = header.get('planningItems');
    const scheduledItem = planningItems.find((item)=>item.get('type') === 'SCHEDULED');
    const scheduledTimestamp = scheduledItem.get('timestamp');
    const repeatInfo = $2ce140c2c56df8f2$export$bd29749f2a066b44(scheduledTimestamp);
    const { maxDays: maxDays } = repeatInfo;
    const completionDates = $2ce140c2c56df8f2$export$39832c1a28f48eff(header);
    const lastCompletion = completionDates.length > 0 ? completionDates[completionDates.length - 1] : null;
    const baseScheduledDate = (0, $e706118dde20dbed$export$77db66937f538459)(scheduledTimestamp);
    if (!lastCompletion) return baseScheduledDate > afterDate ? baseScheduledDate : null;
    // Calculate next deadline based on last completion
    const nextDeadline = new Date(lastCompletion);
    nextDeadline.setDate(nextDeadline.getDate() + maxDays);
    return nextDeadline > afterDate ? nextDeadline : null;
};


var $c5cc2143b5217600$exports = {};
$c5cc2143b5217600$exports = "# organice will not reflow if there's hard-wrapped content\n# -*- eval: (auto-fill-mode 0) -*-\n\n* General\n\nAll user visible changes to organice will be documented in this file.\n\nWhen there are updates to the changelog, you will be notified and see a 'gift' icon appear on the top right corner.\n\n* [2026-09-10 Thu]\n** Added\n*** Web Push notifications for headings\n    - New Settings > Notifications area to enable reminders before SCHEDULED, DEADLINE, and active timestamps\n    - Each reminder type can be enabled and given its own lead time\n    - Tag cadences override the defaults for headings with a matching tag\n    - The feature is disabled when the browser does not support the Web Push API (or on iOS until organice is installed to the Home Screen)\n\n* [2026-07-09 Thu]\n** Fixed\n*** Default startup file setting\n    - Selecting a file to open on startup now automatically clears that option from other file settings\n    - PR: https://github.com/200ok-ch/organice/pull/1122\n\n* [2026-05-17 Sun]\n** Fixed\n*** Capture target file sync\n    - Fixed capture templates that target a startup-synced file so new entries are saved even while viewing another file\n    - PR: https://github.com/200ok-ch/organice/pull/1119\n\n* [2026-02-27 Fri]\n** Added\n*** Long-press drag and drop reordering for headers\n    - Long-press a header to drag and drop it with clear drop indicators on desktop and mobile\n    - Moving a parent header now keeps its subtree together and prevents dropping top-level headers into nested child lists\n    - PR: https://github.com/200ok-ch/organice/pull/1108\n\n* [2026-02-26 Thu]\n** Fixed\n*** Help/Sample modal for authenticated users\n    - Fixed an issue where clicking the question-mark help icon could show an empty Sample screen or get stuck on =Syncing ...=\n    - PR: https://github.com/200ok-ch/organice/pull/1106\n*** Unseen changelog gift icon in authenticated header\n    - Fixed the gift icon so opening changelog updates from the header renders the changelog modal correctly for logged-in users\n    - PR: https://github.com/200ok-ch/organice/pull/1107\n** Added\n*** Auto-continue lists with checkboxes in description editor\n    - When pressing Enter in an (unordered) checkbox list, the list\n      will be continued with a checkbox\n    - The new line has a checkbox with the same checked state as the\n      previous one (unchecked, checked, partially checked).\n\n    See [[https://orgmode.org/manual/Checkboxes.html][orgmode manual]] for more information on checkboxes.\n\n* [2026-02-12 Thu]\n\n** Changed\n\n*** Migrated search parser from pegjs to peggy\n    - pegjs is end of life (last commit 7+ years ago); peggy is the maintained fork\n    - PR: https://github.com/200ok-ch/organice/pull/1101\n\n** Added\n\n*** Auto-continue lists in description editor\n    - When editing a header description, pressing Enter after a list item (=- item= or =1. item=) automatically starts the next list item\n    - Ordered lists increment the number (=1.= → =2.= → =3.=)\n    - Pressing Enter on an empty list prefix removes it, exiting the list\n    - Works with both dash (=-=) and plus (=+=) unordered lists, and dot (=1.=) and paren (=1)=) ordered lists\n\n* [2026-02-11 Wed]\n\n** Added\n\n*** Harmonize modals for managing headers\n    - For capture templates, the '+' button or editing a header, now all modals have the same functionality\n    - Removes the old TitleEditorModal and DescriptionEditorModal components\n    - PR: https://github.com/200ok-ch/organice/pull/1099\n\n* [2026-02-10 Mon]\n\n** Fixed\n\n*** Theme/color scheme flash on startup\n    - Fixed a bug where the app would briefly show dark mode before switching to the configured light mode\n    - The color scheme is now applied immediately from localStorage before React renders, eliminating the visual flash\n\n*** Capture template crash when used before sync completes\n    - Fixed a crash where opening a capture template immediately after starting organice could cause the entire UI to go blank\n    - This happened because settings reloading from the sync backend regenerated template IDs, invalidating the open modal's reference\n\n* [2026-01-08 Thu]\n\n** Added\n\n*** UI for editing slash syntax in SCHEDULED timestamp repeaters\n    - When editing a SCHEDULED timestamp with a repeater, you can now set a deadline range using the slash syntax (e.g., =.+2d/3d=)\n    - This means \"do this task at most every 2 days, but at least every 3 days\"\n    - The slash UI only appears for SCHEDULED timestamps, not DEADLINE timestamps\n    - The deadline part can be removed by setting the value to 0\n    - Upstream documentation: https://orgmode.org/manual/Tracking-your-habits.html\n    - The parser already supported this syntax, but now you can edit it visually in the timestamp editor\n\n* [2026-01-07 Tue]\n\n** Added\n\n*** Org Habits consistency graph\n    - Visual consistency graph showing habit completion over time\n    - Color-coded status indicators matching Emacs org-mode:\n      - Green: Completed on this day\n      - Blue: Not due yet (in grace period)\n      - Yellow: Scheduled for this day, or due tomorrow\n      - Red: Overdue (you missed this day)\n    - Habits sorted before non-habits in agenda view\n    - Settings for graph configuration:\n      - Org habit preceding days (default: 21)\n      - Org habit following days (default: 7)\n      - Show all habits today\n    - Habits identified by =STYLE: habit= property\n    - Uses =:LOGBOOK:= entries to track completion history\n    - Automatically sets =LAST_REPEAT= property on completion\n\nSee the [[https://organice.200ok.ch/documentation.html#org_habits][documentation]] for more details on habit configuration and usage.\n\n** Fixed\n\n*** Settings reset to defaults when config file is missing fields\n\nBase settings (including Org habits settings) were being overwritten with =undefined= values when the sync backend config file didn't contain those fields. This happened when using an older config file or when settings were added after the initial config file was created.\n\nSettings now correctly persist from localStorage even when the config file is missing specific fields.\n\n*** PWA updates not applying on iOS Safari\n\nWhen deploying new versions of organice, iOS Safari users often didn't receive updates and had to remove/reinstall the PWA from their home screen.\n\nFixed by:\n- Adding =skipWaiting()= to force immediate service worker activation\n- Adding =clients.claim()= to ensure new service worker controls all clients immediately\n- Adding proper fetch event handler for cache-first strategy\n- Adding cache headers in =.htaccess= to prevent service worker file from being cached\n\n* [2025-12-01 Mon]\n\n** Added\n\n*** Add \"#\" and \"%\" as valid characters for tag searches\n\nPR: https://github.com/200ok-ch/organice/pull/1055\n\nThank you [[https://github.com/cperl82][cperl82]] for the PR🙏\n\n** Fixed\n\n*** Dropbox sorting\n\nThe old Dropbox sorting could do the wrong thing when the sort\ncomparator is called with the first argument being a file and the\nsecond argument being a folder.\n\nPR: https://github.com/200ok-ch/organice/pull/1054\n\nThank you [[https://github.com/cperl82][cperl82]] for the PR🙏\n\n*** On Chrome > 137: GitLab sign-in for private repository fails with \"Unexpected sign in error, please try again\"\n\nPR: https://github.com/200ok-ch/organice/pull/1061\n\nThank you [[github.com/mcwitt][mcwitt]] for the PR and [[https://github.com/dtvillafana][dtvillafana]] for support and testing🙏\n\n* [2025-10-22 Wed]\n\n** Changed\n\n*** \"Set scheduled datetime\" action uses two different icons\n\nIssue: https://github.com/200ok-ch/organice/issues/1052\n\n** Fixed\n\n*** Components/OrgFile/TimestampEditor: Incorrect Timestamp Format\n\nPR: https://github.com/200ok-ch/organice/pull/1053\nThank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-08-11 Mon]\n\n** Changed\n\n*** Refactored =TableEditorModal= from class to functional component\n\n- Converted TableEditorModal to a functional component for better maintainability\n- This refactor lays the groundwork for future table enhancements, including touch scrolling support\n- No functional changes to the TableEditorModal's behavior\n\nPR: https://github.com/200ok-ch/organice/pull/1043\nThank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-07-26 Sat]\n\n** Fixed\n\n*** Action Drawer buttons not clickable\n\nThe fix from yesterday introduced a regression. Now, we have a fix for\nthe regression and the initial bug report.\n\n* [2025-07-24 Thu]\n\n** Fixed\n\n*** Cannot open files at bottom of screen on mobile\n\n- Issue: https://github.com/200ok-ch/organice/issues/1044\n- Thank you [[https://github.com/chasecaleb][chasecaleb]] for the fix🙏\n\n* [2025-06-22 Sun]\n\n** Fixed\n\n*** When exporting to email, don't just export the selected headline, but sub-headlines\n\n** Added\n\n*** Users can now share their headlines (including sub-headlines) to any app - with a fallback to mail.\n\n- PR: https://github.com/200ok-ch/organice/pull/1036\n\n* [2025-06-18 Wed]\n\n** Fixed\n\n*** Made it harder to accidentally swipe left or right on headers\n\n- Changed swipe detection from fixed distance to relative distance (2x)\n- This reduces accidental swipes while maintaining intentional swipe functionality\n- PR: https://github.com/200ok-ch/organice/pull/1034\n- Thank you [[https://github.com/vHugoObject][vHugoObject]] for the PR🙏\n\n* [2025-06-06 Fri]\n\n** Fixed\n\n*** Repeater state changes will now always be filed to the correct header\n\n- =updatePlanningItemsWithRepeaters= now selects the header it intends to update\n\nPR: https://github.com/200ok-ch/organice/pull/1029\n\n* [2025-05-24 Sat]\n\n** Added\n*** Duplicate header via long-press on '+' icon\n\n- Long-pressing the '+' icon in the header action drawer now\n  duplicates the current header and its entire subtree.\n- Visual feedback for the long-press interaction has been\n  significantly enhanced with larger surrounding shadows for better\n  visibility, especially on touch devices.\n- Short-press on the '+' icon continues to add a new, empty header.\n\nPR: https://github.com/200ok-ch/organice/pull/1025\n\n** Fixed\n*** Table add/remove button inverted\n\nPR: https://github.com/200ok-ch/organice/pull/1024\n\n* [2025-05-22 Thu]\n\n** Changed\n\n*** Refactor and unify Docker setup for improved development and production builds\n\n  - Introduce a multi-stage =Dockerfile=. This file defines distinct\n    stages for =base=, =development=, =build=, and =production=,\n    ensuring optimized layers and dependencies.\n  - The production Docker image is lean, containing only necessary built assets and runtime dependencies.\n\nThis significantly simplifies Docker configuration management,\nenhances the developer experience when using Docker, and builds upon\nearlier work by @rogueai to create lean production images.\n\nThe PR is: https://github.com/200ok-ch/organice/pull/1023\n\n* [2025-05-06 Tue]\n\n** Added\n\n*** Add visual cue for overdue headers when displaying headers\n\n- Before this change: When enabling the setting \"Show Deadline\n  Display\", the respective deadline will be displayed on each header\n  line.\n- After this change, in the deadline will show in grey if not overdue\n  and in red if overdue.\n\nThis change was originally proposed and implemented by @dmorlitz:\nhttps://github.com/200ok-ch/organice/pull/970\n\nThe merged PR is: https://github.com/200ok-ch/organice/pull/1019\n\n** Fixed\n\n*** Resolved issue where search input field could scroll off-screen on iOS devices\n  - The search input in popups (like Search, Task List) will no longer\n    attempt to automatically focus on iOS. This prevents the field\n    from being pushed out of view by the virtual keyboard. iOS users\n    will now need to tap the input to activate it.\n  - On non-iOS platforms, the search input will now auto-focus with a\n    slight delay to improve usability.\n  - PR: https://github.com/200ok-ch/organice/pull/1018\n\n*** CI Tasks: docker build/push and deploy-prod\n\n- Building the docker image has been broken for some time.\n- Deploying to prod via CI had an issue since switching to parcel.\n\nBoth seem to be working as of commit\ne72d01081863e69f7410be87f09aeb2ac68e3c1d. There's no PR, because I\nmade these changes directly to the =master= branch, because these CI\ntasks should only run for production ready code.\n\n* [2025-04-11 Fri]\n\n** Changed\n\n*** Switch from CRA to parcel\n\nPR: https://github.com/200ok-ch/organice/pull/1014\n\nThis is a big one.\n\nWe've used Create React App as the main build tool which abstracted\nstuff like Babel config away from us. In a recent release, we upgraded\nfrom CRA v3 to v4 so we were able to upgrade some other dependencies.\nHowever, CRA is EOL:\nhttps://react.dev/blog/2025/02/14/sunsetting-create-react-app\n\n** Fixed\n\n- Upgrades: When upgrading from CRA v3 to v4, the upgrade process\n  broke. Clients that once started an old version of organice would\n  forever cache that one.\n  - Changing to Parcel (see above) also got rid of quite a bit of\n    complexity:\n    - Parcel has upstream capability to build scss which means we\n      could delete a good bit of code.\n    - Changelog Files are loaded not only at build time, but can be\n      changed while running the dev server.\n\n* [2025-04-05 Sat]\n\n** Fixed\n\n- Create a static =/manifest.json=\n  - This improves the PWA experience for people self hosting organice\n  - PR: https://github.com/200ok-ch/organice/pull/1013\n\n* [2025-04-04 Fri]\n\n** Fixed\n\n- Prevent accidental horizontal swipes during vertical scrolling on iOS\n  - Improved touch handling to detect vertical scrolling intent and prevent unwanted horizontal swipe actions\n  - PR: https://github.com/200ok-ch/organice/pull/1012\n\n* [2024-11-11 Mon]\n\n** Changed\n\n- No UI/UX changes, but lots of tooling upgrades\n- Major version technical upgrades\n  - nodejs (from 12 to 20)\n  - Create React App (from 3 to 4)\n  - eslint (from 6 to 7)\n  - node-sass to sass\n- Minor version technical upgrades\n  - redux-undo\n  - React\n\nPRs:\n\n- https://github.com/200ok-ch/organice/pull/1000\n- https://github.com/200ok-ch/organice/pull/999\n- https://github.com/200ok-ch/organice/pull/998\n\n* [2024-11-09 Sat]\n** Fixed\n\n- Prevent app crash when deleting a list item immediately after exiting edit mode\n  - PR: https://github.com/200ok-ch/organice/pull/996\n  - Thank you [[https://github.com/kjmatsuda][kjmatsuda]] for the PR🙏\n** Changed\n\n- doc: Clarify where to find docs (interactive tutorial vs. manual)\n  - PR: https://github.com/200ok-ch/organice/pull/991\n* [2024-09-19 Thu]\n\n** Added\n\n- Add a =flake.nix= file to provide a development shell for\n  [[https://nixos.org/][Nix]] users.\n  - PR: https://github.com/200ok-ch/organice/pull/987\n\n* [2023-11-15 Wed]\n\n** Added\n\n- Ability to print all content (including below the fold)\n  - PR: https://github.com/200ok-ch/organice/pull/969\n    \n* [2023-08-29 Tue]\n\n** Added\n\n- Capture template variable =%y= expanding to the raw year\n  - PR: https://github.com/200ok-ch/organice/pull/964\n\n** Fixed\n\n- Using a capture template that is available from all Org files, but should always capture to just one file (not necessarily the currently open one).\n  - PR: https://github.com/200ok-ch/organice/pull/965\n\n* [2023-04-11 Tue]\n\n** Changed\n\n- Ticking a checkbox should only tick the checkbox, not enable the list item manipulating functions from =handleListItemSelect=.\n  - Relevant discussion: https://github.com/200ok-ch/organice/discussions/950\n  - PR: https://github.com/200ok-ch/organice/pull/951\n\n* [2023-04-10 Mon]\n\n** Fixed\n- Color of unchecked checkbox in a list\n  - PR: https://github.com/200ok-ch/organice/pull/949\n\n* [2023-04-03 Mon]\n\n** Added\n\n- Implements list manipulation functions\n  - PR: https://github.com/200ok-ch/organice/pull/945\n  - Thank you [[https://github.com/kjmatsuda][kjmatsuda]] for the PR🙏\n    \n* [2023-01-28 Sat]\n\n** Fixed\n\n- On a header, don't cancel swipe due to vertical movements\n  - PR: https://github.com/200ok-ch/organice/pull/938\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n\n* [2023-01-09 Mon]\n\n** Fixed\n\n- Checking or unchecking a checkbox discards text with markup\n  - PR: https://github.com/200ok-ch/organice/pull/928\n  - Thank you [[https://github.com/saikiransathpadi][saikiransathpadi]] for the PR🙏\n\n- Don’t replace all leading =*= in the description\n  - Only when followed by a space, it would become a headline. Otherwise it’s markup for bold text.\n  - PR: https://github.com/200ok-ch/organice/pull/931\n\n* [2023-01-05 Thu]\n\n** Fixed\n\n- Deadline overlay UI improvements\n  - PR: https://github.com/200ok-ch/organice/pull/925\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n* [2023-01-04 Wed]\n\n** Added\n\n- Configuration option for a default Org file on startup.\n  - By default, when you start organice, it will display your root\n    file directory. If you prefer to display a specific Org file\n    instead, you can select it in the [[https://organice.200ok.ch/settings][file settings]].\n\n- Option to display DEADLINE values (near the clocking value) on each headline\n  - The default for this option is false - so there is no change to the default behavior - until you enable this option via Settings.\n  - PR: https://github.com/200ok-ch/organice/pull/891\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n** Fixed\n\n- Rotation of table editor icons to reflect their action.\n  - PR: https://github.com/200ok-ch/organice/pull/890\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n- Prevent the user from invalidating her Org file by entering a description that leads with =*=\n  - If the user starts any line with a =*=, wanting to start a new list, it is immediately converted to a =-=.\n  - PR: https://github.com/200ok-ch/organice/pull/920\n  - Thank you [[https://github.com/saikiransathpadi][saikiransathpadi]] for the PR🙏\n   \n\n** Changed\n\n- Disable auto-capitalization for search\n  - Before:\n    - When using the search or task list text inputs the Android/iOS keyboards automatically apply the shift key, meaning that the first character is capitalized.\n    - 99% of the time this is not what we want because:\n      - Having mixed case triggers a case sensitive search. This is quite confusing when I did not intentionally use capitalization, but it was added anyway. For example, I type \"and\", and it actually inputs and searches for \"And\", which yields no results.\n      - Many of the keywords in the search grammar are lower case, e.g., =deadline:=, =desc:=.\n  - Now: Auto-capitalization is turned off\n  - PR: https://github.com/200ok-ch/organice/pull/914\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n* [2022-12-03 Sat]\n** Fixed\n\n- Improve parser to read lines with multiple inline markup statements\n  - PR: https://github.com/200ok-ch/organice/pull/910\n  - Thank you [[https://github.com/lechten][lechten]] for the PR🙏\n\n* [2022-12-02 Fri]\n** Added\n- Filtering by description\n  - PR: https://github.com/200ok-ch/organice/pull/907\n  - Thank you [[https://github.com/neildavidforrest][neildavidforrest]] for the PR🙏\n* [2022-11-02 Wed]\n** Fixed\n- Use correct HTML anchor tag inside public.html <noscript>\n  - PR: https://github.com/200ok-ch/organice/pull/902\n  - Thank you [[https://github.com/josephmturner][josephmturner]] for the PR🙏\n* [2022-07-08 Fri]\n** Fixed\n- When opening an Org file, show it from the top\n  - PR: https://github.com/200ok-ch/organice/pull/878\n- Changelog has a =Back= button in the HeaderBar\n  - PR: https://github.com/200ok-ch/organice/pull/882\n* [2022-07-06 Wed]\n** Fixed\n- Change log renders above previously opened view component\n  - PR: https://github.com/200ok-ch/organice/pull/869\n- Make HeaderBar sticky\n  - PR: https://github.com/200ok-ch/organice/pull/870\n* [2022-07-04 Mon]\n** Added\n- Setting to change textbox height in the description editor\n  - PR: https://github.com/200ok-ch/organice/pull/875\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n* [2022-06-30 Thu]\n** Changed\n- Upgrade Dropbox authentication flow: switch from OAuth to OAuth 2\n  and PKCE\n  - Rationale: Dropbox switched OAuth from long lived tokens to short\n    lived tokens.\n  - PR: https://github.com/200ok-ch/organice/pull/851\n* [2022-06-29 Wed]\n** Fixed\n- Undo looks like it is persisting changes, but it persisted old\n  state. Hence, reloading the file was bringing back the version of\n  the file before undoing.\n  - PR: https://github.com/200ok-ch/organice/pull/861\n** Changed\n- Simplify UX in task modal\n  - \"Change todo keyword set\" is now an explicit button. Also, it's\n    only shown when there is more than one todo keyword set configured\n    for the current Org file.\n  - Todo keywords can be selected and unselected on the same button.\n    No trash can necessary to unselect a todo keyword..\n  - PR: https://github.com/200ok-ch/organice/pull/862\n** Added\n- Ability to delete header from task modal.\n  - PR: https://github.com/200ok-ch/organice/pull/862\n* [2022-06-22 Wed]\n** Added\n- Ability to handle empty files\n  - This takes care of a big UX problem for users who solely rely on organice. So far, we've shown a parser error if the file is empty *or* if the file did not contain a headline.\n  - Now, if the user opens a file that is empty, or has no headlines, she will see the call to action to create a new headline.\n  - PR: https://github.com/200ok-ch/organice/pull/853\n* [2022-06-16 Thu]\n** Added\n- Capture template variables =%r= and =%R= expanding to raw timestamps\n  - PR: https://github.com/200ok-ch/organice/pull/838\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n\n* [2022-06-14 Tue]\n** Added\n- Create new file from file browser\n  - PR: https://github.com/200ok-ch/organice/pull/818\n* [2022-06-13 Mon]\n** Added\n\n- Specify default webDAV URL in .env file\n  - PR: https://github.com/200ok-ch/organice/pull/829\n  - Thank you [[https://github.com/dmorlitz][dmorlitz]] for the PR🙏\n- Docker image recognizes env vars\n  - PR: https://github.com/200ok-ch/organice/pull/835\n  - see [[https://organice.200ok.ch/documentation.html#docker][doc]] for more information\n\n* [2022-06-03 Fri]\n** Removed\n- Google Drive support. This backend had a few issues:\n  1. We waited [[https://github.com/200ok-ch/organice/issues/127][for years for Google to put the Google Drive API into\n     production mode]]. Without that, only very few people were actually\n     allowed by Google to use organice with Google Drive. A lot of\n     time and effort went into this from quite a few of people. Even\n     Google employees tried to expedite from within Google, but to no\n     avail. The maintainers of organice gave up on this issue since\n     [[https://github.com/200ok-ch/organice/issues/127#issuecomment-655339244][July 2020 and announced]] that the support for Google Drive will be\n     removed unless someone steps up and takes over this task. Nobody\n     did in the two years since, so we're removing it.\n  2. [[https://github.com/200ok-ch/organice/issues/109][Replace integration of Google Drive through <script> include in index.html with NPM module]]\n  3. [[https://github.com/200ok-ch/organice/issues/107][Sign in to Google Drive from new versions of Chrome dysfunctional]]\n\n* [2022-06-01 Wed]\n** Added\n   - Proper Landing Page\n     - PR: https://github.com/200ok-ch/organice/pull/809\n* [2022-02-23 Wed]\n** Fixed\n   - [[https://organice.200ok.ch/documentation.html#in_buffer_settings][In-buffer settings]] can be in lowercase or uppercase. Before, they\n     had to be in uppercase.\n     - PR: https://github.com/200ok-ch/organice/pull/776\n   - Manifest for PWAs\n     - Before, the 'install' button did not appear for Android devices\n       and both Chrome and Firefox showed warnings for the manifest.\n     - Issue: https://github.com/200ok-ch/organice/issues/779\n     - PR: https://github.com/200ok-ch/organice/pull/781\n     - Thank you [[https://github.com/tbruckmaier][tbruckmaier]] for the PR🙏\n\n* [2021-12-09 Thu]\n** Fixed\n   - Title editor text loss.\n     - Since the introduction of the semantic Title editor on [2021-11-22 Mon], if you modified the text of a title and then click a todo, the todo keyword got saved which triggers a rerender before the text got saved. Therefore the text is reset to the state it was in when the title editor was opened.\n     - This is fixed, now.\n* [2021-12-05 Sun]\n** Added\n   - *EPIC* Bookmark functionality for search\n     - After entering a search string, you can bookmark it using the ⭐ button.\n     - Bookmarked search strings populate the suggestions if no search string is entered into the input field.\n     - Bookmarks are saved by context, so there are separate bookmarks for search, task-list, and refile.\n     - There are at most ten bookmarks for a context. Newly saved bookmarks are inserted at the top of the list. If the list gets too long, the last search strings are dropped. Duplicate bookmarks are dropped too. The list of bookmarks is ordered by last used.\n     - Bookmarks are unaware of file context. Therefore, you always have the same bookmarks.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/758\n* [2021-11-22 Mon]\n** Changed\n   - Title and Description fields are not edited as raw text by default.\n     - Instead, a semantic editor comes up when editing them.\n     - To edit raw values, click the 'edit' icon, again.\n   - Search and Task List open in one modal with tabs.\n     - Modal opens to \"Search\" by default, but remembers what was opened last.\n   - If there are open clocks, a third modal \"Clock List\" is added\n     that looks like \"Search\" for =clock:now= without the search input\n     field.\n   - Notes can be multi-line and are properly indented.\n* [2021-11-09 Tue]\n** Added\n   - Setting to respect OS light/dark-mode preferences\n     - organice already queried the OS for light/dark-mode preference. But changing the setting in organice would override the OS preference.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/749\n** Fixed\n   - Fix repeater adjusting time of date when using =.+=\n     - When repeaterUnit is not \"h\", hour and minutes are never touched.\n     - When repeaterUnit is \"h\", hour and minutes are set to n hour(s) from now (as it was already implemented before this fix).\n   - Relevant PR: https://github.com/200ok-ch/organice/pull/746\n* [2021-11-03 Wed]\n** Fixed\n   - Fix GitLab OAuth token refresh\n     - PR: https://github.com/200ok-ch/organice/pull/740\n     - Thank you [[https://github.com/chasecaleb][chasecaleb]] for the PR🙏\n* [2021-11-01 Mon]\n** Added\n   - *EPIC* Add GitLab as a sync back-end\n     - PR: https://github.com/200ok-ch/organice/pull/734\n     - Thank you [[https://github.com/chasecaleb][chasecaleb]] for the PR🙏\n* [2021-10-29 Fri]\n** Fixed\n   - Loading settings when using WebDAV as synchronization back-end\n     - PR: https://github.com/200ok-ch/organice/pull/727\n     - Thank you [[https://github.com/mcordell][mcordell]] for the PR🙏\n\n* [2021-05-16 Sun]\n** Added\n   - Parse and preserve habit timestamp ranges\n     - A timestamp may have minimum and maximum ranges specified by using the syntax =.+2d/3d=, which says that you want to do the task at least every three days, but at most every two days.\n     - Upstream documentation:\n       https://orgmode.org/manual/Tracking-your-habits.html\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/674\n     - Thank you [[https://github.com/tomonacci][tomonacci]] for the PR🙏\n\n* [2021-05-13 Thu]\n\n** Changed\n   - Agenda starts on Monday by default (as it does in Emacs Org mode)\n\n** Added\n   - Ability to set the \"Start of week for weekly agenda\" in the Settings\n     - Akin to the Emacs org mode variable =org-agenda-start-on-weekday=\n   - Relevant PRs:\n     - https://github.com/200ok-ch/organice/pull/676\n       - Thank you [[https://github.com/tomonacci][tomonacci]] for the PR🙏\n     - https://github.com/200ok-ch/organice/pull/677\n\n* [2020-12-29 Tue]\n** Added\n   - *EPIC*: Multiple file support\n     - Agenda, Search, Task List, Refile and Capture Templates have the ability to work on multiple files.\n     - You can adjust the behavior for these on a file per file basis by creating \"file settings\" in the settings menu.\n\n   - *EPIC*: Offline file support\n     - Every file opened in organice will automatically be cached on your device.\n     - When visiting the file, again, it will immediately be loaded from the local storage and then loaded from the remote back-end.\n     - That makes loading and switching between files instant _and_ gives you the ability to work on multiple files when being offline.\n\n   - Relevant PRs:\n     - https://github.com/200ok-ch/organice/pull/550\n     - https://github.com/200ok-ch/organice/pull/560\n     - https://github.com/200ok-ch/organice/pull/565\n     - https://github.com/200ok-ch/organice/pull/574\n     - https://github.com/200ok-ch/organice/pull/575\n     - https://github.com/200ok-ch/organice/pull/570\n     - https://github.com/200ok-ch/organice/pull/607\n\n* [2020-11-21 Sat]\n\n** Added\n   - When going to the Agenda view, the selected tab is persisted - meaning it will be pre-selected when you go to the Agenda next time.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/562\n\n** Fixed\n   - Having an active timestamp with a repeater was broken.\n     - When the TODO state changes for a header that has a repeater (either as SCHEDULED, DEADLINE or active timestamp), a log entry is written and the timestamp is updated.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/568\n   - Removing an active timestamp was broken.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/568\n\n* [2020-11-20 Fri]\n** Fixed\n   - organice understands =:PROPERTIES:= drawers and smartly parses the values in case one of the values is a timestamp.\n     - However, parsing all the values and saving the parsed result in any case will lead to wrong results. Most values of properties are just plain text and non-interactive things in Org mode.\n     - For example, a value like =something_with_underscores= would have been treated as 'underlined text' which doesn't make sense for a property drawer. When saving the value back, organice would have squashed the underlines.\n     - Now, the values are used and preserved as they are. Timestamps still work, of course.\n     - Relevant PR: https://github.com/200ok-ch/organice/pull/578\n* [2020-11-15 Sun]\n** Fixed\n   - When repeating a task, an active date timestamp was logged instead of an inactive datetime timestamp.\n\n* [2020-11-14 Sat]\n** Fixed\n   - The task list was not scrollable on Android.\n      - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/561][PR]] 🙏\n\n* [2020-11-08 Sun]\n** Changed\n   - Safeguard against selecting text by accident.\n      - Before this change, it was possible to select text when doing a 'swipe'.\n      - Now, selecting/copying text is only possible in 'edit mode', effectively safeguarding against accidentally selecting text.\n      - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/557][PR]] 🙏\n\n\n* [2020-11-06 Fri]\n** Added\n   - Additional themes. You now can choose between:\n     - Solarized\n     - One\n     - Gruvbox\n     - Smyck\n     - Code\n   - All of these are themes work in light and dark mode!\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/540][PR]] 🙏\n\n* [2020-11-01 Sun]\n\n** Changed\n   - We have enabled some default settings by default, because they are reasonable for a new user:\n     - =shouldStoreSettingsInSyncBackend=, because it enables using organice on multiple clients.\n     - =shouldLiveSync=, because it reduces the chance to have a conflict in the open Org file.\n     - =shouldSyncOnBecomingVisibile=, because it reduces the chance to have a conflict in the open Org file.\n   - =bulletStyle= is set to \"Fancy\", because it looks more visually pleasing than an asterisk (*) and hence makes organice look better on a first test run.\n   - If you personally do not want them enabled, you can disable them separately in the [[/settings][settings]] any time.\n\n** Fixed\n   - organice has various settings that the user can configure. Before manual configuration, there organice loads sane defaults. Loading and persisting some of these defaults was buggy before.\n     - Loading and persisting of defaults works now.\n     - Previously saved wrong values are removed from =localStorage= to reduce future bug potential.\n     - Changing this is - strictly speaking - not visible to the end-user, so it wouldn't ordinarily show up in this changelog. However, since it makes changes to the already saved settings (in cleaning up old faulty values), it theoretically could introduce a bug in the settings. Hence, the change is added to the changelog.\n     - Related PRs:\n       - https://github.com/200ok-ch/organice/pull/552\n       - https://github.com/200ok-ch/organice/pull/553\n       - https://github.com/200ok-ch/organice/pull/554\n* [2020-10-25 Sun]\n** Changed\n   - The 'focus header' feature is renamed.\n     - /Narrowing/ means focusing on this header, making the rest temporarily inaccessible.\n     - Canceling the narrowing, which makes all headers once again accessible, is called /widening/.\n* [2020-10-23 Fri]\n** Added\n   - Add 'dark mode' next to 'light mode' as a setting.\n     - Both themes are based on the popular [[https://ethanschoonover.com/solarized/][Solarized]] color palette.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/527][PR]] 🙏\n   - Add 'recursive clock times in search'.\n     - The =clock:= search term now includes headers that have time logged on their children.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/524][PR]] 🙏\n\n* [2020-10-20 Tue]\n** Added\n   - Add 'time range' queries to search for planning items (SCHEDULED and DEADLINE), plain active timestamps or clocked work time.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/505][PR]] 🙏\n* [2020-10-19 Mon]\n** Added\n   - When a header is focused, and the user uses the 'search' or 'task list' feature, then the searched header list is automatically narrowed to only subheaders of the originally focused header.\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/517][PR]] 🙏\n* [2020-10-10 Sat]\n** Added\n   - Display time summaries for clock entries in each subtree\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/497][PR]] 🙏\n\n** Changed\n\n   - Improve header stickiness\n     - The header bar was not always sticky for longer documents and the therefore some functionality was hard to reach (the user had to scroll to the top to reach it).\n     - Thank you [[https://github.com/tarnung][tarnung]] for your [[https://github.com/200ok-ch/organice/pull/499][PR]] 🙏\n\n* [2020-10-07 Wed]\n** Added\n\n   - Added Documentation on [[https://orgmode.org/manual/Repeated-tasks.html][repeaters]] and [[https://orgmode.org/manual/Deadlines-and-scheduling.html#Deadlines-and-scheduling][delays]] to =sample.org= and to mouseovers for the relevant buttons.\n\n* [2020-09-20 Sun]\n** Added\n\n   - Recognize US and Swiss phone numbers and make them clickable\n   - Next to 'canonical' phone numbers like +49123456789, also recognize:\n     - US phone numbers:\n       - 123-456-7890\n       - (123) 456-7890\n       - 123 456 7890\n       - 123.456.7890\n       - +91 (123) 456-7890\n     - Swiss phone numbers:\n       - 0783268674\n       - 078 326 86 74\n       - 041783268675\n       - 0041783268674\n       - +41783268676\n       - +41783268677\n\n* [2020-09-07 Mon]\n** Added\n   - Added the capability to chose the start screen when installing organice to the homescreen.\n     - More information on how to install organice like this, see https://organice.200ok.ch/documentation.html#installation\n* [2020-09-05 Sat]\n\n** Fixed\n  - Search and Todo List modals could be moved off screen on iOS since [2020-08-30 Sun]. The fix is to disable =autoFocus= on iOS. The rationale for that documented here: https://github.com/200ok-ch/organice/pull/462\n\n* [2020-08-30 Sun]\n\n** Added\n   - Add note to header (=M-x org-add-note=)\n     - This adds a button for taking notes to tasks (org-add-note). They will be prepended to the header contents after :PROPERTIES: and before the :LOGBOOK:\n   - Auto-focus filter input fields (search and task-list)\n\n* [2020-08-29 Sat]\n** Fixed\n   - If a user folds a header, all its subheaders should collapse as well, so that when the user reopens it, they stay closed.\n     - The previous behavior is buggy in a way that it keeps the subheaders open as they were, restoring their openness when the header is unfolded.\n     - The previous behavior is useful, though. So this change introduces a user setting to toggle the behaviour.\n   - Thank you [[https://github.com/necto][necto]] for your [[https://github.com/200ok-ch/organice/pull/440][PR]] 🙏\n\n* [2020-08-25 Tue]\n** Fixed\n   - Updating table cell values and removing table rows or colums was\n     not undoable\n     - Thank you [[https://github.com/necto][necto]] for your [[https://github.com/200ok-ch/organice/pull/432][PR]] 🙏\n\n* [2020-07-28 Tue]\n** Fixed\n   1. Sync stuck when working in the background\n     - When the user put organice into the background during a sync and comes back, organice was stuck in sync mode, but doesn't actually sync anymore. This means that any new changes to the Org file will not be persisted. This is due to mobile browsers cutting off most resources to browser apps in the background, so organice cannot guarantee that a sync happens properly in the background.\n     - It's not trivial to find out if the job is stuck\n       - Time is not a good indicator as bigger files on slower connections will always take longer.\n       - There's no JS API to reliably find out if the browser just got back from the background or is put into the foreground. The [[https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API][=visibilitychange= API]] just triggers for both these events.\n     - Hence, the implementation is generic in nature: Whenever the user hits the 'sync' button, an actual 'sync' is forced - even if organice thinks there's currently a sync in progress or that it should be debounced. That makes sense, because manual actions by the user should always be obeyed.\n     - Closes issue https://github.com/200ok-ch/organice/issues/252\n   - 2. On iOS >13.1, when organice is used in SPA mode (as a bookmark on the homescreen), and the user navigates away from the original bookmark, a huge URL Bar would show up with a \"Done\" button. This is a regression in how iOS handles full-screen SPAs. These are the relevant APIs:\n     - https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariHTMLRef/Articles/MetaTags.html\n     - https://developer.mozilla.org/en-US/docs/Web/Manifest/display\n   - 3. Feature detection for =crypto.subtle= module\n     - This is used for change detection in the changelog. The module is only available in secure contexts. Hence, when used locally and on a private IP range, depending on the browser, it might not be available.\n\n* [2020-07-08 Wed]\n** Added\n   - Allow template-variables in the header-path in a capture template\n     - Thank you [[https://github.com/jayesh-bhoot][jayesh-bhoot]] for your [[https://github.com/200ok-ch/organice/pull/387/][PR]] 🙏\n* [2020-06-14 Sun]\n** Added\n   - Allow capture templates to insert at beginning or end of file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/324][PR]] 🙏\n* [2020-06-05 Fri]\n** Fixed\n   - =file:= links are sanity checked before opened\n     - =file:= links opened in iOS from the PWA view will not open Mobile Safari\n     - Open issue: Some links will be opened as directories when the\n       link is not really going towards a directory.\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/311][PR]] 🙏\n\n* [2020-06-03 Wed]\n** Added\n   - =TODO= keyword sets can now be anywhere in the file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/310][PR]] 🙏\n* [2020-05-30 Sat]\n\n** Added\n   - Make local =file:...= links navigate to the relevant file\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/307][PR]] 🙏\n\n* [2020-05-06 Wed]\n\n** Fixed\n   - Planning items now respect the new hard-indent setting.\n\n* [2020-05-05 Tue]\n\n** Fixed\n   - Append new tags correctly to title.\n     - If a header didn't have tags before, the first tags were\n       erroneously appended without a space.\n\n* [2020-04-06 Mon]\n\n** Added\n   - Support org-adapt-indentation\n     - By default, the metadata body (including deadlines and drawers) of an exported org heading is indented according to its level. If instead you prefer to keep your body text flush-left, i.e.{' '}\n     - Thank you [[https://github.com/cpbotha][cpbotha]] for your [[https://github.com/200ok-ch/organice/pull/272][PR]] 🙏\n\n* [2020-04-05 Sun]\n** Added\n   - Support for org-log-into-drawer TODO state logging\n     - Thank you [[https://github.com/cpbotha][cpbotha]] for your [[https://github.com/200ok-ch/organice/pull/271][PR]] 🙏\n** Fixed\n   - Settings screen has proper title and \"back\" button\n\n* [2020-03-27 Fri]\n** Fixed\n   - Help texts for widen/narrow were reversed\n     - Thank you [[https://github.com/obar][@obar]] for the [[https://github.com/200ok-ch/organice/pull/270][PR]] 🙏\n\n* [2020-02-29 Sat]\n\n** Fixed\n   - As a user, when I visit Search, Task List or Agenda whilst having\n     a dirty file, I'm not getting a pop up a dialogue notifying me\n     about unpushed changes\n\n* [2020-02-17 Mon]\n\n** Added\n   - *Headers with active timestamps in the header or description appear in agenda*\n\n** Fixed\n   - 'Insert timestamp' for headers and descriptions\n\n* [2020-02-09 Sun]\n\n** Added\n   - Comprehensive documentation: https://organice.200ok.ch/documentation.html\n     - You can find the link from the 'settings' screen or on top of\n       the readme.\n\n* [2020-01-27 Mon]\n\n** Fixed\n   - When editing a =:LOGBOOK:= drawer within a headers description,\n     the relevant logbook entries are updated (which might entail them\n     being deleted).\n\n* [2020-01-20 Mon]\n\n** Fixed\n   - When refiling a header, don't show subheaders in the refile drawer\n   - When doing a 'Search' or 'Refile', the action is reflected in the\n     name of the opening drawer.\n   - In the agenda view, fix relative time distance for future dates\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/240][PR]] 🙏\n\n* [2020-01-15 Wed]\n\n** Fixed\n   - Put Floating Action Button \"Move a header\" into the middle of the\n     screen, so that it has enough space to render all arrows on\n     mobile devices.\n\n* [2020-01-14 Tue]\n\n** Added\n   - Notify on changes for changelog\n     - This is done with a similar UX than other productivity apps\n       (like Slack) do it. The user will see a 'gift' icon whenever\n       there's a change to the changelog she has not seen, yet.\n\n* [2020-01-13 Mon]\n\n** Added\n   - \"Show Org filename in Header\" is configurable in settings and\n     off by default\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/229][PR]] 🙏\n\n** Fixed\n   - Show error message when using a capture template with a badly\n     configured header path\n\n* [2020-01-12 Sun]\n\n** Added\n   - Make HeaderBar sticky\n     - Making undo/redo, file browser and help always available\n       (before it was required to scroll all the way to the top)\n   - Deselect headline by clicking into the title (or empty space) in\n     the HeaderBar\n   - Show Org filename in Header\n\n** Fixed\n   - *Major synchronization improvements*\n     1. After undo/redo, synchronize Org file\n     2. Debounce Sync\n        1. When a user changes things quickly (which happens easily\n           when having 'live sync' enabled and using undo/redo for\n           example), multiple syncs ran in parallel. The back-ends\n           will either get confused or fail with errors (429 too many\n           write operations). In any case, likely the last written\n           state would not have been the state of the Org file in\n           organice.\n     3. Safeguard against concurrent sync requests to the back-end\n     4. In case of synchronization error, show the error to the user\n        and retry synchronization\n     5. Don't actually sync a whole Org file for an empty header.\n        When the user adds some data and triggers\n        UPDATE_HEADER_TITLE, then it makes sense to save it.\n\n* [2020-01-11 Sat]\n\n** Added\n   - All HeaderActionItems are undoable and redoable\n\n** Fixed\n   - Parsing planning items followed by a checkbox\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/222/files][PR]] 🙏\n* [2020-01-07 Tue]\n\n** Added\n   - *Refile*\n     - When reviewing the captured data, you may want to refile or to\n       copy some of the entries into a different list, for example\n       into a project.\n   - Add button in HeaderActionBar to open property editor\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/195][PR]] 🙏\n\n** Changed\n   - All HeaderActionDrawer actions have icons. The icons are\n     documented in sample.org and have a mouseover title.\n\n* [2020-01-04 Sat]\n\n** Added\n   - Ability to search headlines\n     - It has the same syntax as the search field in the Task List\n       feature\n\n** Fixed\n   - Sort order in Task List\n     - Tasks were only ordered by their planning item dates. This\n       implied that tasks that were long DONE would be shown first.\n     - Now, tasks in the Task list are sorted by state and then date.\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/207][PR]] 🙏\n\n\n* [2020-01-02 Thu]\n\n** Added\n   - Place cursor after the TODO keyword when creating a new header\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/193][PR]] 🙏\n   - Highlight verbatim markup\n\n** Changes\n   - Highlight cookies and cookie percentages according to Solarized\n     color scheme\n\n** Fixed\n   - Don't update search results when using an invalid search filter\n   - On mobile: Styling of Search / Task List drawer when searching all\n     headlines\n   - On mobile: Ability to scroll Search / Task List\n   - Teach #+TODO parser to understand (..) suffix\n     - Thank you [[https://github.com/aspiers][aspiers]] for your [[https://github.com/200ok-ch/organice/pull/202][PR]] 🙏\n\n* [2020-01-01 Wed]\n\n** Added\n   - Support single- and double-quoted strings in the search filter\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/176][PR]] 🙏\n   - Trim whitespace for entered or updated headlines\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/177][PR]] 🙏\n\n** Fixed\n   - Capture templates in iOS 13.3 are positioned properly\n     - iOS 13 introduced a styling regression when setting focus\n       without user interaction. iOS 13.3 reverts to the way other\n       browsers do it.\n\n** Changed\n   - Revert \"Move HeaderActionDrawer before headline\"\n     - As per #188, the changes introduced in #100 didn't fare well\n       with the community. Hence, as a first step to improve UX,\n       we're reverting to the previous state.\n\n* [2019-12-31 Tue]\n\n** Added\n   - *Searching of headlines/todos with a composable query language*\n     - Thank you [[https://github.com/schoettl][@schoettl]] for the [[https://github.com/200ok-ch/organice/pull/154][PR]] 🙏\n   - Routing for Settings (/settings) and Sample (/sample)\n   - Routing for Agenda and TaskList\n\n** Changes\n   - The action for capture templates now uses a more idiomatic\n     'plus' icon instead of a 'list' icon\n\n* [2019-12-28 Sat]\n\n** Added\n   - Proper coloring of DONE todoKeywords from custom todo sequences\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/165][PR]]!\n   - Place TODO keyword of previous header in the new header\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/164][PR]]!\n\n** Changed\n   - Refactor current Org parser and regex\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/161][PR]]!\n\n* [2019-12-26 Thu]\n\n** Added\n\n   - \"Share\" button for headlines (sharing via email)\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/145][PR]]!\n   - Automatically render links for URLs with www prefix, but without\n     protocol\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/159][PR]]!\n\n* [2019-12-25 Wed]\n\n** Added\n\n   - Suggestion list for inputs in property editor\n     - To minimize typing and typos, add smart completion for property\n       names and values in the PropertyListEditorModal.\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/144][PR]]!\n\n* [2019-12-24 Tue]\n** Added\n\n   - *Automatically render links for URLs, e-mail addresses and phone\n     numbers*\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/147][PR]]!\n\n   - Suggestion list for inputs in tag editor\n     - Thank you [[https://github.com/schoettl][schoettl]] for your [[https://github.com/200ok-ch/organice/pull/149][PR]]!\n\n* [2019-12-17 Tue]\n** Changed\n   - Improve webdav url input\n     - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/139][PR]]!\n** Fixed\n   - Make \"privacy policy\" sticky to the bottom of the landing page\n     - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/140][PR]]!\n\n* [2019-12-15 Sun]\n\n** Changed\n   - UX: Move Org header actions before selected headline\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/136][PR]]!\n\n** Fixed\n   - Android PWA implementation was broken (issue [[https://github.com/200ok-ch/organice/issues/134][#134]])\n     - It required two more icon sizes\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/135][PR]]!\n\n* [2019-12-10 Tue]\n\n** Added\n\n   - *Docker Support*\n   - The CI/CD workflow now also builds a Docker container which is\n     then published to\n     https://hub.docker.com/repository/docker/twohundredok/organice\n   - Thank you [[https://github.com/dotcs][dotcs]] for your [[https://github.com/200ok-ch/organice/pull/133][PR]]!\n\n* [2019-12-08 Sun]\n\n** Added\n\n   - As a user, when I'm on a headline with a planning item (schedule\n     or deadline), I want to be able to remove it.\n\n* [2019-11-29 Fri]\n\n** Fixed\n\n   - Clicking the Timestamp in a TODO within the agenda toggles from\n     the date to a human readable timespan\n\n* [2019-11-27 Wed]\n\n** Added\n\n   - Instructions on configuring Nextcloud+haproxy to allow WebDAV\n   - Documentation on how to share from Nextcloud using WebDAV\n   - Thank you [[https://github.com/runejuhl][runejuhl]] for your [[https://github.com/200ok-ch/organice/pull/122][PR]]!\n\n* [2019-11-25 Mon]\n\n** Added\n   - Honor the 'nologrepeat' option\n     - It can be set via =#+STARTUP:= or as a property\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/119][PR]]!\n\n* [2019-11-22 Fri]\n\n** Fixed\n\n   - Handle non-clock entries in =:LOGBOOK:= drawers\n     - Fixes [[https://github.com/200ok-ch/organice/issues/111][issue #111]], [[https://github.com/200ok-ch/organice/issues/108][issue #108]] and [[https://github.com/200ok-ch/organice/issues/110][issue #110]]\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/112][PR]]!\n\n* [2019-11-21 Thu]\n\n** Fixed\n\n   - Safeguard against potential Dropbox SDK Bug\n     - More information in [[https://github.com/200ok-ch/organice/issues/108][issue #108]]\n\n* [2019-11-19 Tue]\n\n** Changed\n\n   - Don't put newlines after headers with no content, add newline at EOF\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/106][PR]]!\n\n* [2019-11-14 Thu]\n\n** Added\n\n   - *Clocking work time*\n     - Org mode allows you to clock the time you spend on specific\n       tasks in a project:\n       https://orgmode.org/manual/Clocking-Work-Time.html#Clocking-Work-Time\n     - organice is compatible with logbook clocking, now\n     - You can 'clock in' and 'clock out' to a header\n     - Thank you [[https://github.com/jamesnvc][@jamesnvc]] for your [[https://github.com/200ok-ch/organice/pull/103][PR]]!\n\n* [2019-10-31 Thu]\n\n** Fixed\n   - Keep all in-file settings and content lines from top of file\n     - Thank you [[https://github.com/andersjohansson][@andersjohansson]] for your [[https://github.com/200ok-ch/organice/pull/90][PR]]!\n\n* [2019-10-29 Tue]\n\n** Added\n   - Show login options as clickable links with cursor pointer\n   - Also improve wording with regards to login options\n     - Thank you [[https://github.com/rodrigomaia17][@rodrigomaia17]] for your [[https://github.com/200ok-ch/organice/pull/88][PR]]!\n\n\n* [2019-10-26 Sat]\n\n** Added\n   - *WebDAV as a sync backend!*\n     - Thank you [[https://github.com/TristanCacqueray][@TristanCacqueray]] for your [[https://github.com/200ok-ch/organice/pull/82][PR]]!\n\n   - As a user, when I swipe a header, I want the icon to contrast\n     the background, so that better see the action taken\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/78][PR]]!\n\n   - As a user, when I hover a clickable element, I want my cursor to\n   change, so that I can see that it is clickable.\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/79][PR]]!\n\n** Fixed\n   - Do not throw an error when clearing a planning item\n     - Thank you [[https://github.com/ragone][@ragone]] for your [[https://github.com/200ok-ch/organice/pull/81][PR]]!\n\n* [2019-10-02 Wed]\n\n** Fixed\n\n- On iOS 13, fix the regression which made capture input fields hide\n  under the keyboard\n  - More information and screenshots in the ticket: https://github.com/200ok-ch/organice/issues/46\n  - Turns out this issue is non trivial to fix and requires specific\n    rules for every size of iPhone. I tested against the Xs and 6s. If\n    you have a different form factor and the capture template input\n    screen looks off to you, please send me a screenshot of what it\n    looks like and I'll add the dimensions for your form factor right\n    away!\n\n* [2019-09-28 Sat]\n\n** Added\n\n- Implemented a =redo= Button next to the =undo= button\n\n* [2019-09-21 Sat]\n\n** Fixed\n\n- Parser bug which would interpret *bold* statements in the beginning\n  of a line as a header.\n- Parser bug which would delete newlines between headers and items\n\n** Changed\n\n- @MTrost [[https://github.com/200ok-ch/organice/pull/45][introduced]] a new testing library called [[https://testing-library.com/docs/intro][React Testing\n  Library]] which greatly simplified writing interaction tests.\n\n* [2019-09-19 Thu]\n\n** Changed\n\n- Constraining to a max width and centering for tablets and bigger\n\n* [2019-09-15 Sun]\n\n** Fixed\n\n- The 'Sync on application becoming visible' feature works on iOS and\n  Safari\n  - If enabled, the current org file is pulled from the sync backend\n    when the browser tab becomes visible. This prevents you from\n    having a stale file before starting to make changes to it.\n\n* [2019-09-08 Sun]\n** Added\n\n- Documented how to use organice from a bookmarklet using the capture\n  template feature\n\n* [2019-09-06 Fri]\n** Fixed\n\n- Removed Google Analytics tracking, because it has no place here\n\n* [2019-09-02 Mon]\n\n** Added\n\n- Configure Google Drive for the free community version of organice at\n  https://organice.200ok.ch\n- Documented SPA routing for self-hosting\n- Wrote and publicized a Privacy Policy\n\n* [2019-08-27 Tue]\n\n** Changed\n\n- Color scheme has been ported to the popular [[https://ethanschoonover.com/solarized/][Solarized]] (light mode)\n  - Whilst doing so, CSS variables have been introduced, so that\n    there's not a whole lot of repetition of magic rgb values going on\n  - The logo has been adapted, too\n- The landing page and settings screens have been de-cluttered\n\n* [2019-08-26 Mon]\n\n** Added\n\n- Continuous deployment: Merging to =master= triggers a build on CI\n  and when successful, it triggers a deploy to https://org.200ok.ch\n- Add a new temporary™ logo: [[file:public/organice.png][organice.png]]\n\n* [2019-08-25 Sun]\n\n** Added\n\n- Since we want organice to be a community driven project, we have added:\n  - [[file:CODE_OF_CONDUCT.org][Code of conduct]]\n  - [[file:CONTRIBUTING.org][Contributing guidelines]]\n\n- Add [[https://circleci.com/][CircleCI]] to run the tests on every commit\n  - They are also integrated as a check for PRs with the benefit that\n    contributors get automated feedback by running the regression test\n    suite.\n\n- Add [[https://greenkeeper.io][Greenkeeper]] for automated dependency management\n\n- Add [[https://codeclimate.com][Codeclimate]] for automated maintainability analysis\n\n** Changed\n\n- Upgraded to Node 12.9\n\n* [2019-08-12 Mon]\n\n** Changed\n\n- The default keybindings (when used from a desktop browser) are now\n  more in line with the defaults in Emacs itself\n\n** Fixed\n\n- The keybindings work on non-macOS operating systems\n\n* [2019-08-10 Sat]\n\n** Added\n\n- As a user, when in a directory listing, I want the folders and files\n  to be sorted alphabetically. Furthermore, I only want to see files\n  that organice can open (that is org and org archive files).\n- Note: This is only implemented for the Dropbox back-end at this time.\n\n** Changed\n\n- Filters files from a directory listing down to org files.\n- Sorts folders atop of files.\n- Sorts both folders and files alphabetically.\n\n\n* [2019-08-05 Mon]\n\n** Added\n\n- When the browser tab becomes visible, pull the latest version of the\n  Org file\n  - This is rather helpful when the app is used in production. Since\n    the production build supports loading the complete application and\n    org-file from cache, it can be open for a very long time. When the\n    org-file hasn't been pulled in a \"very long time\"™, then chances\n    are non-nil that the file has been changed by another client in\n    the meantime.\n  - Without this change, when the user opens the app after a while,\n    makes changes to the file and wants to sync to the back-end, there\n    might be the message \"Since you last pulled, a newer version of\n    the file has been pushed to the server.\". Now the user has two\n    conflicting versions of the same file and can only chose to keep\n    one (Which in itself is great UX and great error handling for\n    cases in which we do encounter a merge conflict, of course!).\n  - This situation is mitigated with this change. Now the user has the\n    option to enable \"Sync on application becoming visible\" which acts\n    similarly to \"Live Sync\". When the user opts to use this feature,\n    whenever the application gets pulled from the background or\n    started through the service worker, the first thing that happens\n    it that a new version of the org-file is pulled from the server.\n    It's therefore much harder for the user to create conflicts.\n\n* [2019-08-04 Sun]\n\n** Fixed\n\n- Parser doesn't break indentation of existing files in fewer places\n- Planning Items are formatted as in Emacs Org mode\n- Properties are formatted as in Emacs Org mode\n- Tags are formatted as in Emacs Org mode\n\n\n* [2019-08-03 Sat]\n\n** Added\n\n- Documented deployment options\n  - People have been asking for tighter access restrictions.\n  - Imo the best answer to that request is to make it as easy as\n    possible to host organice.\n  - There's myriads of good options, of course. I picked to document\n    two that will (potentially) be cost-free to the users and which\n    are very easy and quick to set up: Ftp and Heroku.\n\n** Fixed\n\n- Tests on =master= were red\n  - Partly due to obsolete tests\n  - Partly because tests weren't updated according to changes in the code\n";


var $b9a0ebb62bc21257$exports = {};
$b9a0ebb62bc21257$exports = "# organice will not reflow if there's hard-wrapped content\n# -*- eval: (auto-fill-mode 0) -*-\n#+TODO: TODO | DONE\n#+TODO: START INPROGRESS STALLED | FINISHED\n\n* This is an actual org file - feel free to play around with it! (Don't worry about messing it up - your changes won't be saved, so just refresh the page to reset it)\n* Tap on any header to open it\nThis header has some description text and a couple subheaders. Look through the next few top level headers to learn more about organice.\n** This is a subheader\n** This is a subheader too!\n* Actions\n** Editing headers\nWhen you select a header, the \"header action drawer\" appears. The first two icons in this drawer edit the header and description respectively. Try editing this header.\n\nTitle and Description fields are not edited as raw text by default. Instead, a semantic editor comes up when editing them. To edit raw values, click the 'edit' icon, again.\n\nIf you want the \"header action drawer\" to disappear or to deselect the current header, tap onto the title (or empty space) in the application's headerbar.\n\n** All icons in the header action bar\n\n1. Pen: Edit header title\n2. Pen in square: Edit header description\n3. Tags: [[https://orgmode.org/manual/Tags.html][Modify tags]]\n4. Properties: [[https://orgmode.org/manual/Properties-and-columns.html][Modify properties]]\n5. Expand: [[https://orgmode.org/manual/Structure-editing.html][Narrow to subtree]] (/Narrowing/ means focusing on this header, making the rest temporarily inaccessible.)\n6. Plus: Create new header below. Long-pressing this icon duplicates the current header and its entire subtree, providing enhanced visual feedback with larger surrounding shadows. \n7. Mail: Share this header via email\n8. Calendar 1: [[https://orgmode.org/manual/Deadlines-and-scheduling.html][Set deadline datetime]]\n9. Calendar 2: [[https://orgmode.org/manual/Deadlines-and-scheduling.html][Set scheduled datetime]]\n10. Hourglass: [[https://orgmode.org/manual/Clocking-commands.html][Clock in and out (Start and stop the clock)]]\n11. File Export: [[https://orgmode.org/manual/Refile-and-copy.html][Refile this header to another header]]\n12. Add a note: Add a time-stamped note to the current header (=org-add-note=).\n\n** Todos [3/7] [42%]\nThis header has a few TODO items as subheaders.\n*** DONE Check out organice\n*** DONE Follow the organice tutorial\nThis interactive tutorial helps you get to know organice really quickly.\n*** TODO Learn how to use TODOs in organice\nTo advance the todo state of a header, swipe right on it until the background turns green.\n\nTry advancing the todo state of this header a few times!\n**** There's also a setting once you're signed in to enable tapping on the TODO label itself to advance the todo state. Its off by default because I thought the behavior would be confusing unless explained, but I recommend turning it on!\n*** START Investigate custom TODO states\norganice also supports [[http://orgmode.org/manual/Workflow-states.html#Workflow-states][custom todo states]] (if declared at the top of the file). Swipe right on this header a few times.\n\nNote that when the cycle restarts, it defaults to the first set of todo states. Manually edit the header to get back to a different todo state cycle (more on editing headers below!)\n*** FINISHED See that custom TODO states are colored correctly\nCustom =org-todo-keywords= keyword sequences can have finish states. They are colored appropriately. You can see that TODO and START headlines are colored red whereas DONE and FINISHED headlines are colored green.\n\n*** TODO If I have questions: Check out the documentation\norganice has solid documentation, including frequently asked questions: https://organice.200ok.ch/documentation.html\n*** TODO If I have further questions: Join the community chat\n#organice on IRC [[https://libera.chat/][Libera.Chat]], or [[https://matrix.to/#/!DfVpGxoYxpbfAhuimY:matrix.org?via=matrix.org&via=ungleich.ch][#organice:matrix.org]] on Matrix.\n\n** Tags\nThe next button in the header action drawer will bring up the tag editor.\n\nThis editor lets you add, modify, and reorder tags, as well as giving you easy access to all tags in the file.\n\nTry it out on these headers:\n*** Dogs\n**** Eloise                                        :cute:middleaged:tiny:dog:\n**** Clooney                                            :cute:young:tiny:dog:\n**** Murphy                                            :cute:young:small:dog:\n**** Starla                                             :cute:old:medium:dog:\n**** Rex                                                :cute:old:medium:dog:\n**** Maz                                          :cute:middleaged:large:dog:\n** Narrowing\nThe next button in the header action drawer \"narrows\" to a header, hiding all others and promoting it to the top level. Press the button again to \"widen\".\n\nNarrowing can make it easier to concentrate on a single heading or topic by eliminating clutter. It can also be used to limit the range of operation of a search command.\n\nThis is purely visual - your Org file isn't affected under the hood.\n\nExample: You can narrow on the \"Groceries\" list when you go to the grocery store. Give it a shot on this grocery list:\n*** Groceries\n- [ ] Mangoes\n- [ ] Dark chocolate\n- [ ] Carrots\n** Adding and removing headers\nTo add a new header, press the + button in the header action drawer\n\nTo remove a header, swipe left on the header until the background turns red.\n** Moving headers\nTo move a header, click on the four-way arrows button at the bottom of the screen with a header selected. 6 buttons will appear for moving headers.\n\nThe center 4 move the header up, down, left, and right. The 2 outermost buttons move the header and its entire nested subtree.\n\nYou can also long-press and drag headers directly in the list on desktop and mobile. Parent headers move together with their subheaders, and top-level headers can only be dropped between other top-level headers.\n\nGive them a try on these nested headers to get a feel for how they operate:\n*** A few of my favorite things:\n**** Food\n***** Chocolate\n****** Dark chocolate\n****** Milk chocolate\n****** Crispy chocolate\n***** Mangoes\n**** Text editors\n***** Emacs\n**** Mountain bikes\n***** Santa Cruz\n***** Trek\n***** Giant\n***** Specialized\n**** Dogs\n***** Eloise\n***** Maz\n***** Starla\n***** Rex\n***** Clooney\n** Syncing\nThe \"cloud\" button in the lower left hand corner syncs changes to your\nchosen sync service (Dropbox, GitLab, or WebDAV).\n\nIf there's a newer version on the server and no local changes, it'll pull.\n\nIf there's no newer version on the server and there are local changes, it'll push.\n\nOtherwise, it'll ask what you want to do.\n\nThis button isn't enabled in this demo :)\n\nIf you'd like to automatically push changes as you make them, you can enable \"Live sync\" in settings.\n** Undo / Redo\n   When you're signed in, you'll have =undo= and =redo= buttons in the\n   headerbar.\n* Tables\norganice has native support for viewing and editing tables.\n\nTry playing around with this one by first clicking on the table:\n\n| Dog name | Age | Weight (in lbs) | Parent   | Score (1-10) |\n|----------+-----+-----------------+----------+--------------|\n| Eloise   |   3 |             5.1 | Erin     |           15 |\n|----------+-----+-----------------+----------+--------------|\n| Starla   |  15 |              40 | Sarah S  |           15 |\n|----------+-----+-----------------+----------+--------------|\n| Rex      |  15 |              45 | Sarah S  |           15 |\n|----------+-----+-----------------+----------+--------------|\n| Maz      |   1 |              55 | Brittany |           15 |\n|----------+-----+-----------------+----------+--------------|\n| Clooney  | 0.1 |             4.8 | Sarah R  |           15 |\n|----------+-----+-----------------+----------+--------------|\n| Murphy   | 0.5 |              25 | Jordan   |           15 |\n\n** Table actions\nWhen a table is selected, the table editor is opened.\n\nBelow the table a table-specific action drawer appears.\n\nFor the icons to trigger any actions, you first need to select a table cell.\n\nThe leftmost icon allows you to edit a cell.\n\nIn the Middle, the top two icons let you add and remove rows. The bottom two icons let you add and remove columns.\n\nOn the right side, the four-way arrow buttons allow you to manipulate tables by moving rows and columns.\n\nPress up and down to move rows, and left and right to move columns.\n* Lists and checkboxes\norganice has native support for displaying plain lists and checkboxes.\n\nPlain:\n\n- Plain list item 1\n- Plain list item 2\n  - Sub item 1\n- Plain list item 3\n\nOrdered:\n\n1. Ordered Item 1\n2. Ordered Item 2\n   1. Sub item\n3. Ordered Item 2\n\nCheckboxes:\n\n- [-] 1 [1/2]\n  - [ ] 1.1 [0%]\n    - [ ] 1.1.1\n  - [X] 1. 2\n- [X] 2\n\n** Auto-continuation\n\nWhen editing a description, lists are automatically continued when you press Enter:\n\n- Type =- item= and press Enter → the next line starts with =- =\n- Type =1. item= and press Enter → the next line starts with =2. =\n\nTo stop the list, press Enter on an empty list prefix (the auto-generated =- = or =2. = is removed).\n\n** Editing workflow\n\nFirst, create the first list item by editing the description of a header. When you close the \"edit description\" modal, you can manipulate the list item with native list manipulation functions. The UX is analogous to manipulating a header. Here's what you can do:\n\n- Add new list item\n- Remove list item\n- Move list item up\n- Move list item down\n- Move list item left\n- Move list item right\n- Move list subtree left\n- Move list subtree right\n- Edit list item title\n- Edit list item contents\n\n** All icons in the list action bar\n\n1. Pen: Edit list item title\n2. Pen in square: Edit list item contents\n3. Plus: Create new list item below\n4. Cross: Delete list item\n\n* Timestamps\norganice has native support for displaying and editing [[https://orgmode.org/manual/Timestamps.html#Timestamps][timestamps]].\n\nTry tapping on the timestamps below to get a feel for the editor:\n\n<2018-09-17 Sun>\n\n[2018-09-17 Sun]\n\n[2018-09-17 Sun +1d]\n\n[2018-09-17 Sun 10:00-11:30]\n\n<2018-09-17 Sun>--<2018-09-25 Tue>\n\n** Habit tracking\n\norganice supports Emacs Org mode's habit tracking feature with a visual consistency graph. Habits are TODO items that you want to track consistently over time, like daily exercise or meditation.\n\n*** Creating a habit\n\nTo create a habit, add a =STYLE= property with the value =habit= to your TODO item:\n\n*** TODO Exercise\n    SCHEDULED: <2026-01-07 Wed .+1d>\n    :PROPERTIES:\n    :STYLE:    habit\n    :END:\n\nThe =.+= repeater means \"do this at least once per day\". When you mark it DONE, the date shifts from today (not from the original scheduled date). This means if you miss a few days, the habit stays overdue until you complete it.\n\n*** Understanding the consistency graph\n\nIn the agenda view, habits display a visual consistency graph below the title showing your completion history:\n\n- *Green*: You completed the habit on this day\n- *Blue*: Not due yet (in the grace period)\n- *Yellow*: Scheduled for this day, or due tomorrow\n- *Red*: Overdue (you missed this day)\n\nThe graph displays the configured number of preceding days (default: 21) and following days (default: 7).\n\n*** Example with completion history\n\nHere's a more complete example with a LOGBOOK showing when you completed the habit:\n\n*** TODO Meditate for 15 minutes\n    SCHEDULED: <2026-01-07 Wed .+1d>\n    :PROPERTIES:\n    :STYLE:    habit\n    :LAST_REPEAT: [2026-01-06 Tue 08:00]\n    :END:\n    :LOGBOOK:\n    - State \"DONE\"       from \"TODO\"       [2026-01-06 Tue 08:00]\n    - State \"DONE\"       from \"TODO\"       [2026-01-05 Mon 08:00]\n    - State \"DONE\"       from \"TODO\"       [2026-01-03 Sat 07:30]\n    :END:\n\nThe =LAST_REPEAT= property is automatically updated when you mark the habit as DONE, and the consistency graph uses your LOGBOOK entries to show which days you completed the habit.\n\n*** Habit frequency examples\n\n- Daily: =SCHEDULED: <2026-01-07 Wed .+1d>=\n- Every 2 days: =SCHEDULED: <2026-01-07 Wed .+2d>=\n- Weekly: =SCHEDULED: <2026-01-07 Wed .+1w>=\n\nSee the [[https://organice.200ok.ch/documentation.html#org_habits][documentation]] for more details on habit configuration.\n\n* Automatic/Implicit links\n\norganice recognizes various types of hyperlinks automatically which Emacs Org mode would not necessarily do. That makes sense, because mobile devices, or browsers, enable a different feature set.\n\nFor example, when you read this in organice, then the text https://organice.200ok.ch will implicitly be rendered as a clickable link (as it would be in Emacs Org mode). The same also works for other web links like www.200ok.ch, email addresses like info@200ok.ch, and different kinds of phone numbers. For these, Emacs Org mode doesn't create an explicit link, but organice can and does.\n\nInternational/US phone numbers:\n\n  - 123-456-7890\n  - (123) 456-7890\n  - 123 456 7890\n  - 123.456.7890\n  - +91 (123) 456-7890\n\nSwiss phone numbers:\n\n - 0783268674\n - 078 326 86 74\n - 041783268675\n - 0041783268674\n - +41783268676\n - +41783268677\n\n* Property lists\norganice has native support for viewing and editing [[https://orgmode.org/guide/Properties.html][property lists]]. To bring up an editor, expand the ~PROPERTIES~ drawer below and tap on any of the properties.\n** Example\n:PROPERTIES:\n:callsign: Maverick\n:eyewear: Aviators\n:launch-date: [1986-05-16 Fri]\n:END:\n* Planning\norganice has native support for adding and editing DEADLINE and SCHEDULED items. It also supports [[https://orgmode.org/manual/Repeated-tasks.html][repeaters]] and [[https://orgmode.org/manual/Deadlines-and-scheduling.html#Deadlines-and-scheduling][delays]]. Check out these examples:\n\n=DEADLINE= means that the task - most likely a TODO item, though not necessarily—is supposed to be finished on that date.\n\n=SCHEDULED= means that you are planning to start working on that task on the given date.\n\nScheduling an item should not be understood in the same way that we understand scheduling a meeting. Setting a date for a meeting is just a simple appointment, you can mark this entry with a simple plain timestamp, to get this item shown on the date where it applies.\n\n** Editing planning items in organice\n\nTo add a DEADLINE or SCHEDULED timestamp, tap a header to open the header action drawer, then use the calendar icons (see \"All icons in the header action bar\" above).\n\nTo *remove* a DEADLINE or SCHEDULED timestamp, open the timestamp editor and clear the date field. When the date is empty, the planning item is removed entirely.\n\nInside the timestamp editor, repeaters, delays, and time ranges each have a =+= button to add them and an =X= button to remove them.\n\n** An item with a deadline in the far future\n   DEADLINE: <2088-05-06 Thu>\n\nDeadlines and scheduled items produce entries in the agenda when they are over-due, so it is important to be able to mark such an entry as done once you have done so. When you mark a 'DEADLINE' or a 'SCHEDULED' with the TODO keyword 'DONE', it no longer produces entries in the agenda.\n** An item that is scheduled\n   SCHEDULED: <2018-10-18 Thu>\n** Doctors appointment <2020-10-07 Wed>\n\nFor simple appointments, it is enough to mark the entry with a simple plain timestamp. This will still show up in the agenda.\n\n** An item with both\n   DEADLINE: <2018-10-05 Fri> SCHEDULED: <2018-10-04 Thu>\n** TODO An item with a repeater - try swiping right to advance to the DONE state\n   DEADLINE: <2019-01-10 Thu +1w>\n   :PROPERTIES:\n   :LAST_REPEAT: [2019-01-03 Thu 15:35]\n   :END:\n\n   - State \"DONE\"       from \"TODO\"       [2019-01-03 Thu 15:35]\n\nThe =+1w= is a repeater; the intended interpretation is that the task has a deadline on '2019-01-10' and repeats itself every (one) week starting from that time. You can use yearly, monthly, weekly, daily and hourly repeat cookies by using the 'y', 'w', 'm', 'd' and 'h' letters.\n\n*** Types of repeaters\n\nThere are three types of repeaters in Org mode:\n\n**** + (plus repeater)\n\nShifts the date by a fixed amount from the /original/ date. If you miss deadlines, all missed instances appear in the agenda as overdue. This is useful for tasks that must happen on a specific schedule regardless of when you complete them.\n\nExample: =+1w= repeats exactly one week from the original date. If the deadline was Thursday and you complete it three weeks late on Wednesday, the next deadline will still be Thursday (one week after the original), which will appear as overdue.\n\n**** ++ (plus-plus repeater)\n\nShifts the date to a future occurrence, but preserves certain properties like the day of week. The date shifts by at least the specified amount, but also by as much as needed to get the date into the future.\n\nExample: =++1w= repeats weekly but stays on the same weekday. If the deadline is Sunday and you complete it on Saturday, the next deadline will be the next Sunday (preserving the Sunday schedule).\n\n**** .+ (dot repeater)\n\nShifts the date from /today/ when you mark the task DONE. This is the most common style for habits and tasks that should repeat a certain time after you last did them. If you miss days, the task stays overdue until you complete it.\n\nExample: =.+1d= means \"do this at least once per day.\" If you complete it today, the next deadline is tomorrow. If you miss three days and then complete it, the next deadline is still tomorrow (not three days from the original schedule).\n\n*** TODO Call kitchen trash\n    DEADLINE: <2019-02-11 Mon ++1w>\n    Marking this DONE shifts the date by at least one week, but also by as many weeks as it takes to get this date into the future. However, it stays on a Sunday, even if you called and marked it done on Saturday.\n\n*** TODO Check the batteries in the smoke detectors\n    DEADLINE: <2019-11-01 Fri .+1m>\n    Marking this DONE shifts the date to one month after today.\n** TODO An item with deadline and different lead time\n   DEADLINE: <2020-10-07 Wed>\n\nOn the deadline date, the task is listed in the agenda. In addition, the agenda for today carries a warning about the approaching or missed deadline, starting a defined time period before the due date (see settings \"Default DEADLINE warning period\"), and continuing until the entry is marked as done.\n\nYou can specify a different lead time for warnings for a specific deadlines using the following syntax. Here is an example with a warning period of 5 days 'DEADLINE: <2004-02-29 Sun -5d>'.\n\nIn case the task contains a repeater, the delay is considered to affect all occurrences; if you want the delay to only affect the first scheduled occurrence of the task, use '--5d' instead.\n\n\nIn the settings, there is an option to display deadline values on each headline.\n* Capture\norganice supports something like [[https://orgmode.org/manual/Capture.html][Org capture]] in the form of customizable, quickly accessible buttons for creating new headers.\n\nClick the button in the bottom right corner of the screen to see some examples. The first button, the lemon, will create a new entry in the \"Groceries\" list below this. The second button adds an entry to a more deeply nested header.\n\nOnce signed in, you can set up capture templates that specify header paths (and various other configurations). If the list is empty, the content will be inserted at the end of the file, or the beginning if the prepend option is selected. These capture templates will sync between your devices if you enable settings sync.\n** Groceries\n** Deeply\n*** Nested\n**** Headers\n***** Work\n****** Too!\n\n* Search / Task List / Clock List\n\nBelow, there is a button to open up a generic search and a task list. The modal opens \"Search\" by default, but remembers what was opened last. If there are open clocks, a third tab \"Clock List\" is added\n\nTap a header in the view to jump to it.\n\nUsing the filter input, you can search for headlines. Specifically, you can search for headline text, TODO keywords, tags, and [[https://orgmode.org/guide/Properties.html][orgmode properties]]. It also supports alternatives, and you can exclude headlines by negating a filter.\n\nWhen a header is narrowed, and the user uses the 'search' or 'task list' feature, then the searched header list is automatically narrowed to only subheaders of the originally narrowed header.\n\n** Bookmarks\n\nAfter entering a search string, you can bookmark it using the ⭐ button.\n\nBookmarked search strings populate the suggestions if no search string is entered into the input field.\n\nBookmarks are saved by context, so there are separate bookmarks for search, task-list, and refile.\n\nThere are at most ten bookmarks for a context. Newly saved bookmarks are inserted at the top of the list. If the list gets too long, the last search strings are dropped. Duplicate bookmarks are dropped too. The list of bookmarks is ordered by last used.\n\nBookmarks are unaware of file context. Therefore, you always have the same bookmarks.\n\n** Differences Search and Task List\n\n- In the task list, you can tap on the date to switch to a more readable relative date format.\n- The task list shows only tasks - i.e. headlines with a TODO keyword are displayed.\n  - The tasks will be sorted by state and then date.\n\n** Examples for the search syntax\n\nYou can simply search for\n\n=TODO check out organice|orgmode=\n\nto filter for tasks containing these words. The pipe symbol (|) is a logical /OR/. The filter is a smart-case search:\n\n- Lower-case words mean that the filter ignores the case.\n- If a word contains upper-case letters, the filter is case-sensitive.\n\nThe following example searches for headlines containing *START* or *FINISHED* keywords and the string \"states are\". You can also use single-quotes.\n\n=START|FINISHED \"states are\"=\n\nThe next example excludes *DONE* headlines but requires the tag *fun*.\n\n=-DONE  :fun=\n\nYou can exclude text strings, tags, and properties as well by prepending the minus sign (-).\n\nYou can search for headlines with defined properties:\n\n=TODO :blocked_by:  :assignee:nobody|none=\n\nThis filters headlines having a property *blocked_by* (with any value) and a property *assignee* with a value containing =nobody= or =none=.\n\nYou can also negate filters by prefixing them with =-=. For example, if you want to search for all headers that are not DONE:\n\n=-DONE=\n\nYou can also search time ranges on headers with planning items (SCHEDULED and DEADLINE), plain active timestamps or clocked work time.\n\nThe time related filters are:\n\n- =scheduled= (shorthand =sched=)\n- =deadline= (shorthand =dead=)\n- =clock=\n- =date=\n\n=date= is a shorthand to search for planning items (SCHEDULED and DEADLINE) and plain active timestamps at the same time.\n\nThese time related filters work on time ranges indicated by =START..END= where =START= and =END= support the following units:\n\n- =h=: Hours\n- =d=: Days\n- =w=: Weeks\n- =m=: Months\n- =y=: Years\n\n=START= and =END= can both be omitted to search for an infinite timespan into the past or future. Both can be used with digits to quantify the amount (i.e. =2w= for two weeks). For both, the digit can be omitted to refer to the calendar unit instead of a time duration (i.e. =w= is the current week using the [[https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system][Western Traditional]] system [from Sunday to Saturday]).\n\nThere are two special units that need no quantification:\n\n- =today=: Current date\n- =now=: Current time\n\nNext to units, =START= and =END= can also be expressed in dates like. Dates can be expressed by:\n\n- =YYYY= (i.e. 2020)\n- =YYYY-MM= (i.e. 2020-11)\n- =YYYY/MM= (i.e. 2020/11)\n- =YYYY.MM= (i.e. 2020.11)\n- =YYYYMM= (i.e. 202011)\n- =YYYY-MM-DD= (i.e. 2020-11-17)\n- =YYYY/MM/DD= (i.e. 2020/11/17)\n- =YYYY.MM.DD= (i.e. 2020.11.17)\n- =YYYYMMDD= (i.e. 20201117)\n\nSome examples on how to use time ranges:\n\n- =clock:..= searches for all items with time clocked. This includes headers that have time logged on their children.\n  - =clock:now= searches for currently clocked in headers.\n- =sched:w= searches for all scheduled items in the current week (same for other units).\n- =dead:..w= searches for all deadlines between now and the end of the week.\n- =date:today= searches for all planning items (scheduled and deadline items) as well as items with active timestamps.\n- =date:1w= (equivalent to =date:..1w=) searches from now to one week in the future.\n- =sched:2m..w= if both ends of the range are relative, they refer back to the current moment. So this searches for all scheduled items between two months before now to the end of the current week.\n\nNote that negating time ranges is not implemented.\n\nTo search for the description of your headlines, use =desc= or =description=:\n\n- =desc:\"search term\"=\n\nIf you want to search for multiple terms, you can combine them like so:\n\n- =desc:term_1 desc:term_2=\n\n\n** Auto-completion for filters\n\nYou probably noticed that organice provides suggestions for your filter. After space, =-=, =:=, and =|= you can tap on the completion – no need to type the tag, property, etc.\n\n** TODO Example with properties\t\t\t\t\t\t\t:fun:\n:PROPERTIES:\n:assignee: nobody\n:blocked_by: the others\n:END:\n\n* Agenda\norganice has a basic agenda view that you can access by tapping the calendar button at the bottom of the page.\n\nTap a header in this view to jump to it, and tap on the date to switch to a more readable relative date format.\n\nDue and overdue items with deadlines and a schedule show up on today's entry. Entries with just an active timestamp are shown only on exactly the day of the timestamp. Hence, a 'meeting' or an 'appointment' should get an active timestamp whereas a TODO often will be scheduled or even has a deadline.\n\nMore information on that in the [[https://orgmode.org/manual/Deadlines-and-Scheduling.html][org manual]].\n\nExamples:\n\n** TODO Check out the organice agenda view\nDEADLINE: <2018-09-10 Mon>\n** TODO Install organice to the homescreen on my mobile phone\nSCHEDULED: <2018-09-17 Mon>\n** This entry shows only exactly on <2020-02-17 Mon> in the agenda\n** This entry also only shows on exactly one day\n   <2020-02-17 Mon>\n* Syncing\norganice pulls down your org files from Dropbox, GitLab, or WebDAV. Click the \"Sign in\" button in the upper right hand corner to sign in with either of them and authenticate organice.\n\n** Backups\nThe first time you push changes from organice back up to your chosen sync service, organice will make a backup of the original file first. It'll be named {your-file-name}.organice-bak. Dropbox keeps a full version history of your files for you, but this is an additional precaution in case something goes wrong pushing the file back up.\n\nGenerally, when working with distributed Org files, we're recommending to put them under version control and to check for bugs and racing conditions between clients.\n\n* Multiple files\norganice supports using multiple files.\n\nDefault behaviour:\n\n- When you first open a file it is loaded from the backend. At this point the file is persisted to local storage. It will be loaded from there on future application starts. To ensure consistency whenever a file is opened it will be synced with the backend.\n- Agenda, Refile, Search and Task List by default show results from the currently viewed file.\n\nYou can adjust these defaults on a file per file basis by creating file settings in the [[/settings][settings menu]].\n\n* organice operates completely client side\nYou don't log in to organice directly because organice doesn't have a back end - it operates completely client side using Dropbox, GitLab, or WebDAV as back-ends for storage.\n* Capture URL params and Siri support\norganice supports a flexible mechanism for capturing using URL parameters. This mechanism integrates very nicely with the new [[https://support.apple.com/guide/shortcuts/welcome/ios][Siri Shortcuts]] feature in iOS 12, allowing you to use Siri to execute capture templates.\n\nYou can use [[https://www.icloud.com/shortcuts/14f91f8cf8f547a183a0734396240984][this sample Shortcut]] to get started with this right away in iOS 12. Open the link on your iOS device and click \"Get Shortcut\". Then open up the Shortcuts app and edit the template by following the directions in the comments. Then record a Siri trigger and you're good to go!\n\nAlternatively, you can take advantage of the URL parameters yourself to build your own custom capture mechanism. You can find more details about this in [[https://github.com/200ok-ch/organice/#capture-params-and-siri-support][the README file]].\n\n* Further questions?\n\nIf you've finished this interactive tutorial, but have further questions, we have you covered! There is additional [[https://organice.200ok.ch/documentation.html][documentation]] which contains more comprehensive and formal documentation, including installation instructions, deployment guides, contribution guidelines, and technical details about the project's architecture and development process. This file is aimed at both users seeking in-depth information and developers interested in contributing to the project.\n";


const $1780206710f3c846$export$b75e26cdc67a486a = (loadingMessage)=>({
        type: 'SET_LOADING_MESSAGE',
        loadingMessage: loadingMessage
    });
const $1780206710f3c846$export$80775798c6eb9d34 = ()=>({
        type: 'HIDE_LOADING_MESSAGE'
    });
const $1780206710f3c846$export$9eaa806651dd33f0 = (isLoading, path)=>({
        type: 'SET_IS_LOADING',
        isLoading: isLoading,
        path: path
    });
const $1780206710f3c846$export$7c40ec7552034cd7 = (online)=>({
        type: 'SET_IS_ONLINE',
        online: online
    });
const $1780206710f3c846$export$dcd62ed1bd1c13ec = (loadingMessage, delay)=>(dispatch)=>{
        dispatch($1780206710f3c846$export$b75e26cdc67a486a(loadingMessage));
        setTimeout(()=>dispatch($1780206710f3c846$export$80775798c6eb9d34()), delay);
    };
const $1780206710f3c846$export$eb54a9b5d32e03d = (lastViewedPath)=>({
        type: 'SET_LAST_VIEWED_FILE',
        lastViewedPath: lastViewedPath
    });
const $1780206710f3c846$export$7b70d0006c6937c5 = (staticFile, lastViewedFilePath)=>{
    return (dispatch)=>{
        dispatch($1780206710f3c846$export$eb54a9b5d32e03d(lastViewedFilePath));
        const fileContents = {
            changelog: (0, (/*@__PURE__*/$parcel$interopDefault($c5cc2143b5217600$exports))),
            sample: (0, (/*@__PURE__*/$parcel$interopDefault($b9a0ebb62bc21257$exports)))
        }[staticFile];
        const staticFilePath = (0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6) + staticFile;
        dispatch((0, $d81b80734fbc24a5$export$f1c553d4f1a2351)(staticFilePath, fileContents));
        dispatch((0, $d81b80734fbc24a5$export$1518ffc4a8ff94f2)(staticFilePath));
    };
};
const $1780206710f3c846$export$c376ba4ed7d6ea1 = ()=>{
    return (dispatch, getState)=>{
        dispatch((0, $d81b80734fbc24a5$export$407c99dd8b6a5a6a)());
        const path = getState().base.get('lastViewedPath');
        if (!!path) dispatch((0, $d81b80734fbc24a5$export$1518ffc4a8ff94f2)(path));
    };
};
const $1780206710f3c846$export$c5b51da1f1e80706 = (newFontSize)=>({
        type: 'SET_FONT_SIZE',
        newFontSize: newFontSize
    });
const $1780206710f3c846$export$4aa7f4aee137c00e = (newBulletStyle)=>({
        type: 'SET_BULLET_STYLE',
        newBulletStyle: newBulletStyle
    });
const $1780206710f3c846$export$e637bedbcb1d99eb = (newShouldTapTodoToAdvance)=>({
        type: 'SET_SHOULD_TAP_TODO_TO_ADVANCE',
        newShouldTapTodoToAdvance: newShouldTapTodoToAdvance
    });
const $1780206710f3c846$export$a77dec68e1709431 = (newAgendaDefaultDeadlineDelayUnit)=>({
        type: 'SET_AGENDA_DEFAULT_DEADLINE_DELAY_UNIT',
        newAgendaDefaultDeadlineDelayUnit: newAgendaDefaultDeadlineDelayUnit
    });
const $1780206710f3c846$export$2104f9eade1c8366 = (newAgendaDefaultDeadlineDelayValue)=>({
        type: 'SET_AGENDA_DEFAULT_DEADLINE_DELAY_VALUE',
        newAgendaDefaultDeadlineDelayValue: newAgendaDefaultDeadlineDelayValue
    });
const $1780206710f3c846$export$91d212b4c2ea492a = (newEditorDescriptionHeightValue)=>({
        type: 'SET_EDITOR_DESCRIPTION_HEIGHT_VALUE',
        newEditorDescriptionHeightValue: newEditorDescriptionHeightValue
    });
const $1780206710f3c846$export$4c4af1fe8269ccae = (newAgendaStartOnWeekday)=>({
        type: 'SET_AGENDA_START_ON_WEEKDAY',
        newAgendaStartOnWeekday: newAgendaStartOnWeekday
    });
const $1780206710f3c846$export$37be07c704d99c3c = (shouldLiveSync)=>({
        type: 'SET_SHOULD_LIVE_SYNC',
        shouldLiveSync: shouldLiveSync
    });
const $1780206710f3c846$export$5c197882088ec7fb = (showDeadlineDisplay)=>({
        type: 'SET_SHOW_DEADLINE_DISPLAY',
        showDeadlineDisplay: showDeadlineDisplay
    });
const $1780206710f3c846$export$4500bc1fc12baaca = (shouldSyncOnBecomingVisibile)=>({
        type: 'SET_SHOULD_SYNC_ON_BECOMING_VISIBLE',
        shouldSyncOnBecomingVisibile: shouldSyncOnBecomingVisibile
    });
const $1780206710f3c846$export$abc24fbbfef45381 = (shouldShowTitleInOrgFile)=>({
        type: 'SET_SHOULD_SHOW_TITLE_IN_ORG_FILE',
        shouldShowTitleInOrgFile: shouldShowTitleInOrgFile
    });
const $1780206710f3c846$export$e1e6d996751fb1f4 = (shouldLogIntoDrawer)=>({
        type: 'SET_SHOULD_LOG_INTO_DRAWER',
        shouldLogIntoDrawer: shouldLogIntoDrawer
    });
const $1780206710f3c846$export$e5e2421b7f9b8964 = (closeSubheadersRecursively)=>({
        type: 'SET_CLOSE_SUBHEADERS_RECURSIVELY',
        closeSubheadersRecursively: closeSubheadersRecursively
    });
const $1780206710f3c846$export$690c7575f3a79943 = (shouldNotIndentOnExport)=>({
        type: 'SET_SHOULD_NOT_INDENT_ON_EXPORT',
        shouldNotIndentOnExport: shouldNotIndentOnExport
    });
const $1780206710f3c846$export$bad93780d27506dd = (newShouldStoreSettingsInSyncBackend)=>{
    return (dispatch, getState)=>{
        dispatch({
            type: 'SET_SHOULD_STORE_SETTINGS_IN_SYNC_BACKEND',
            newShouldStoreSettingsInSyncBackend: newShouldStoreSettingsInSyncBackend
        });
        if (!newShouldStoreSettingsInSyncBackend) {
            const client = getState().syncBackend.get('client');
            switch(client.type){
                case 'Dropbox':
                case 'GitLab':
                case 'WebDAV':
                    client.deleteFile('/.organice-config.json').catch((doesFileNotExist, error)=>doesFileNotExist ? null : alert(`There was an error trying to delete the .organice-config.json file: ${error}`));
                    break;
                default:
            }
            window.previousSettingsFileContents = null;
        }
    };
};
const $1780206710f3c846$export$f2d00fe8ce80fd84 = (colorScheme)=>({
        type: 'SET_COLOR_SCHEME',
        colorScheme: colorScheme
    });
const $1780206710f3c846$export$2e49b867b7a0847c = (theme)=>({
        type: 'SET_THEME',
        theme: theme
    });
const $1780206710f3c846$export$a94b65b83df44181 = (newHasUnseenChangelog)=>({
        type: 'SET_HAS_UNSEEN_CHANGELOG',
        newHasUnseenChangelog: newHasUnseenChangelog
    });
const $1780206710f3c846$export$881e6a033a29282a = (newLastSeenChangelogHash)=>({
        type: 'SET_LAST_SEEN_CHANGELOG_HEADER',
        newLastSeenChangelogHash: newLastSeenChangelogHash
    });
const $1780206710f3c846$export$9974be595dbac166 = (keybindingName, keybinding)=>({
        type: 'SET_CUSTOM_KEYBINDING',
        keybindingName: keybindingName,
        keybinding: keybinding
    });
const $1780206710f3c846$export$7027258f5f935b03 = (newSettings)=>({
        type: 'RESTORE_BASE_SETTINGS',
        newSettings: newSettings
    });
const $1780206710f3c846$export$8e611aa521a0a08b = (modalPage)=>({
        type: 'PUSH_MODAL_PAGE',
        modalPage: modalPage
    });
const $1780206710f3c846$export$4d24603a016fa6c3 = ()=>({
        type: 'POP_MODAL_PAGE'
    });
const $1780206710f3c846$export$b5212ec6a6e9531e = ()=>({
        type: 'CLEAR_MODAL_STACK'
    });
const $1780206710f3c846$export$ebfc6cde9af7602f = (popupType, data)=>({
        type: 'ACTIVATE_POPUP',
        popupType: popupType,
        data: data
    });
const $1780206710f3c846$export$e6889fb0929ccf91 = ()=>({
        type: 'CLOSE_POPUP'
    });
const $1780206710f3c846$export$db71203757fe273d = (agendaTimeframe)=>(dispatch)=>dispatch({
            type: 'SET_AGENDA_TIMEFRAME',
            agendaTimeframe: agendaTimeframe
        });
const $1780206710f3c846$export$fd2f521ee5394b02 = (finderTab)=>(dispatch)=>dispatch({
            type: 'SET_FINDER_TAB',
            finderTab: finderTab
        });
const $1780206710f3c846$export$23b56ce92307bb87 = (preferEditRawValues)=>(dispatch)=>dispatch({
            type: 'PREFER_EDIT_RAW_VALUES',
            preferEditRawValues: preferEditRawValues
        });
const $1780206710f3c846$export$5b368dcdf2065092 = (orgHabitShowAllToday)=>(dispatch)=>dispatch({
            type: 'SET_ORG_HABIT_SHOW_ALL_TODAY',
            orgHabitShowAllToday: orgHabitShowAllToday
        });
const $1780206710f3c846$export$12effd122e8f64de = (orgHabitPrecedingDays)=>(dispatch)=>dispatch({
            type: 'SET_ORG_HABIT_PRECEDING_DAYS',
            orgHabitPrecedingDays: orgHabitPrecedingDays
        });
const $1780206710f3c846$export$f0af1a82fba6cb87 = (orgHabitFollowingDays)=>(dispatch)=>dispatch({
            type: 'SET_ORG_HABIT_FOLLOWING_DAYS',
            orgHabitFollowingDays: orgHabitFollowingDays
        });
const $1780206710f3c846$export$a2a4779bb5290c99 = (fieldPath, newValue)=>({
        type: 'UPDATE_NOTIFICATION_SETTINGS_FIELD_PATH_VALUE',
        fieldPath: fieldPath,
        newValue: newValue
    });
const $1780206710f3c846$export$1cc0ace5276b4418 = ()=>({
        type: 'ADD_NEW_EMPTY_NOTIFICATION_TAG_CADENCE'
    });
const $1780206710f3c846$export$6fcad1eca5911490 = (cadenceId, fieldPath, newValue)=>({
        type: 'UPDATE_NOTIFICATION_TAG_CADENCE_FIELD_PATH_VALUE',
        cadenceId: cadenceId,
        fieldPath: fieldPath,
        newValue: newValue
    });
const $1780206710f3c846$export$55abbd75662fafb7 = (cadenceId)=>({
        type: 'DELETE_NOTIFICATION_TAG_CADENCE',
        cadenceId: cadenceId
    });
const $1780206710f3c846$export$a6e4ea47c8aa5e07 = (fromIndex, toIndex)=>({
        type: 'REORDER_NOTIFICATION_TAG_CADENCE',
        fromIndex: fromIndex,
        toIndex: toIndex
    });







var $0a008ec384282745$export$2e2bcd8739ae039 = (0, $3044e0bef3624137$exports.fromJS)([
    {
        description: 'Groceries',
        headerPaths: [
            'Capture',
            'Groceries'
        ],
        iconName: 'lemon',
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        isAvailableInAllOrgFiles: false,
        letter: '',
        orgFilesWhereAvailable: [],
        shouldPrepend: false,
        template: '* TODO %?',
        isSample: true
    },
    {
        description: 'Deeply nested header',
        headerPaths: [
            'Capture',
            'Deeply',
            'Nested',
            'Headers',
            'Work',
            'Too!'
        ],
        iconName: 'fighter-jet',
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        isAvailableInAllOrgFiles: false,
        letter: '',
        orgFilesWhereAvailable: [],
        shouldPrepend: true,
        template: '* You can insert timestamps too! %T %?',
        isSample: true
    }
]);





function $06257fecbb2b5848$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $73a150425ace56c9$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}



function $4c410305d186c466$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



var $da634cb494a596a5$var$MILLISECONDS_IN_HOUR = 3600000;
var $da634cb494a596a5$var$MILLISECONDS_IN_MINUTE = 60000;
var $da634cb494a596a5$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $da634cb494a596a5$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $da634cb494a596a5$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $da634cb494a596a5$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $da634cb494a596a5$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $da634cb494a596a5$export$2e2bcd8739ae039(argument, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $da634cb494a596a5$var$DEFAULT_ADDITIONAL_DIGITS : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $da634cb494a596a5$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $da634cb494a596a5$var$parseYear(dateStrings.date, additionalDigits);
        date = $da634cb494a596a5$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (isNaN(date) || !date) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $da634cb494a596a5$var$parseTime(dateStrings.time);
        if (isNaN(time) || time === null) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $da634cb494a596a5$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        result.setFullYear(dirtyDate.getUTCFullYear());
        return result;
    }
    return new Date(timestamp + time + offset);
}
function $da634cb494a596a5$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($da634cb494a596a5$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) {
        dateStrings.date = null;
        timeString = array[0];
    } else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($da634cb494a596a5$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($da634cb494a596a5$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $da634cb494a596a5$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $da634cb494a596a5$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: null
    };
    var year = captures[1] && parseInt(captures[1]);
    var century = captures[2] && parseInt(captures[2]);
    return {
        year: century == null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $da634cb494a596a5$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var captures = dateString.match($da634cb494a596a5$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return null;
    var isWeekDate = !!captures[4];
    var dayOfYear = $da634cb494a596a5$var$parseDateUnit(captures[1]);
    var month = $da634cb494a596a5$var$parseDateUnit(captures[2]) - 1;
    var day = $da634cb494a596a5$var$parseDateUnit(captures[3]);
    var week = $da634cb494a596a5$var$parseDateUnit(captures[4]);
    var dayOfWeek = $da634cb494a596a5$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$da634cb494a596a5$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $da634cb494a596a5$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$da634cb494a596a5$var$validateDate(year, month, day) || !$da634cb494a596a5$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $da634cb494a596a5$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $da634cb494a596a5$var$parseTime(timeString) {
    var captures = timeString.match($da634cb494a596a5$var$timeRegex);
    if (!captures) return null; // Invalid ISO-formatted time
    var hours = $da634cb494a596a5$var$parseTimeUnit(captures[1]);
    var minutes = $da634cb494a596a5$var$parseTimeUnit(captures[2]);
    var seconds = $da634cb494a596a5$var$parseTimeUnit(captures[3]);
    if (!$da634cb494a596a5$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $da634cb494a596a5$var$MILLISECONDS_IN_HOUR + minutes * $da634cb494a596a5$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
}
function $da634cb494a596a5$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $da634cb494a596a5$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($da634cb494a596a5$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$da634cb494a596a5$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $da634cb494a596a5$var$MILLISECONDS_IN_HOUR + minutes * $da634cb494a596a5$var$MILLISECONDS_IN_MINUTE);
}
function $da634cb494a596a5$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $da634cb494a596a5$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $da634cb494a596a5$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100;
}
function $da634cb494a596a5$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($da634cb494a596a5$var$daysInMonths[month] || ($da634cb494a596a5$var$isLeapYearIndex(year) ? 29 : 28));
}
function $da634cb494a596a5$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($da634cb494a596a5$var$isLeapYearIndex(year) ? 366 : 365);
}
function $da634cb494a596a5$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $da634cb494a596a5$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $da634cb494a596a5$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



var $1X5R2 = parcelRequire("1X5R2");



var $1X5R2 = parcelRequire("1X5R2");


var $3e461505c3a6d1b3$exports = {};

$parcel$export($3e461505c3a6d1b3$exports, "addNewEmptyCaptureTemplate", function () { return $3e461505c3a6d1b3$export$62c886a308023068; });
$parcel$export($3e461505c3a6d1b3$exports, "updateTemplateFieldPathValue", function () { return $3e461505c3a6d1b3$export$2f8c0182cc1c1fe0; });
$parcel$export($3e461505c3a6d1b3$exports, "addNewTemplateOrgFileAvailability", function () { return $3e461505c3a6d1b3$export$a0e20b1c107af08e; });
$parcel$export($3e461505c3a6d1b3$exports, "removeTemplateOrgFileAvailability", function () { return $3e461505c3a6d1b3$export$ac9a383abb8a8318; });
$parcel$export($3e461505c3a6d1b3$exports, "addNewTemplateHeaderPath", function () { return $3e461505c3a6d1b3$export$8a4c429b57c7dfa9; });
$parcel$export($3e461505c3a6d1b3$exports, "removeTemplateHeaderPath", function () { return $3e461505c3a6d1b3$export$a3056284358cf1e; });
$parcel$export($3e461505c3a6d1b3$exports, "deleteTemplate", function () { return $3e461505c3a6d1b3$export$eaca1c6e4717fe30; });
$parcel$export($3e461505c3a6d1b3$exports, "restoreCaptureSettings", function () { return $3e461505c3a6d1b3$export$eb06449aae34f9da; });
$parcel$export($3e461505c3a6d1b3$exports, "reorderCaptureTemplate", function () { return $3e461505c3a6d1b3$export$e6b7d73046e81cf; });
const $3e461505c3a6d1b3$export$62c886a308023068 = ()=>({
        type: 'ADD_NEW_EMPTY_CAPTURE_TEMPLATE'
    });
const $3e461505c3a6d1b3$export$2f8c0182cc1c1fe0 = (templateId, fieldPath, newValue)=>({
        type: 'UPDATE_TEMPLATE_FIELD_PATH_VALUE',
        templateId: templateId,
        fieldPath: fieldPath,
        newValue: newValue
    });
const $3e461505c3a6d1b3$export$a0e20b1c107af08e = (templateId)=>({
        type: 'ADD_NEW_TEMPLATE_ORG_FILE_AVAILABILITY',
        templateId: templateId
    });
const $3e461505c3a6d1b3$export$ac9a383abb8a8318 = (templateId, orgFileAvailabilityIndex)=>({
        type: 'REMOVE_TEMPLATE_ORG_FILE_AVAILABILITY',
        templateId: templateId,
        orgFileAvailabilityIndex: orgFileAvailabilityIndex
    });
const $3e461505c3a6d1b3$export$8a4c429b57c7dfa9 = (templateId)=>({
        type: 'ADD_NEW_TEMPLATE_HEADER_PATH',
        templateId: templateId
    });
const $3e461505c3a6d1b3$export$a3056284358cf1e = (templateId, headerPathIndex)=>({
        type: 'REMOVE_TEMPLATE_HEADER_PATH',
        templateId: templateId,
        headerPathIndex: headerPathIndex
    });
const $3e461505c3a6d1b3$export$eaca1c6e4717fe30 = (templateId)=>({
        type: 'DELETE_TEMPLATE',
        templateId: templateId
    });
const $3e461505c3a6d1b3$export$eb06449aae34f9da = (newSettings)=>({
        type: 'RESTORE_CAPTURE_SETTINGS',
        newSettings: newSettings
    });
const $3e461505c3a6d1b3$export$e6b7d73046e81cf = (fromIndex, toIndex)=>({
        type: 'REORDER_CAPTURE_TEMPLATE',
        fromIndex: fromIndex,
        toIndex: toIndex
    });









var $b923a138d35cab06$var$MILLISECONDS_IN_MINUTE = 60000;
function $b923a138d35cab06$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $73a150425ace56c9$export$2e2bcd8739ae039)(dirtyDate, amount * $b923a138d35cab06$var$MILLISECONDS_IN_MINUTE);
}



function $06ce614ac4919c9e$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b923a138d35cab06$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


var $423a0a2872c44574$exports = {};
!function(e, t) {
    $423a0a2872c44574$exports = t();
}($423a0a2872c44574$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


const $fb511a1814e342c6$var$browser = (0, (/*@__PURE__*/$parcel$interopDefault($423a0a2872c44574$exports))).getParser(window.navigator.userAgent);
const $fb511a1814e342c6$export$44d852ebf3845577 = (()=>{
    return $fb511a1814e342c6$var$browser.satisfies({
        mobile: {
            safari: '>=13'
        }
    }) && $fb511a1814e342c6$var$browser.satisfies({
        mobile: {
            safari: '<13.0.4'
        }
    });
})();
const $fb511a1814e342c6$export$cfca147fb13c9ee6 = (()=>{
    return $fb511a1814e342c6$var$browser.getPlatformType() !== 'desktop';
})();
const $fb511a1814e342c6$export$41a665f744414057 = ()=>{
    return $fb511a1814e342c6$var$browser.getOS().name === 'iOS';
};
const $fb511a1814e342c6$export$57e21aa62f5b9ef8 = window.matchMedia ? window.matchMedia('(max-device-width: 812px) and (-webkit-device-pixel-ratio : 3)').matches : false;
const $fb511a1814e342c6$export$2c7a1692b3f9cee3 = window.matchMedia ? window.matchMedia('(min-device-width: 375px) and (-webkit-device-pixel-ratio : 2)').matches : false;
const $fb511a1814e342c6$export$b593c79fb91dd356 = 'standalone' in window.navigator && window.navigator.standalone;
function $fb511a1814e342c6$export$990c44ba2fbc4887() {
    return [
        90,
        -90
    ].includes(window.orientation);
}




const $ed01441649308ad3$export$4168ce9e9312545b = [
    'm',
    'h',
    'd',
    'w'
];
const $ed01441649308ad3$export$cce86e53d4e6e9b4 = {
    SCHEDULED: 'scheduled',
    DEADLINE: 'deadline',
    TIMESTAMP_TITLE: 'timestamp',
    TIMESTAMP_DESCRIPTION: 'timestamp'
};
const $ed01441649308ad3$var$TYPE_LABELS = {
    scheduled: 'SCHEDULED',
    deadline: 'DEADLINE',
    timestamp: 'Timestamp'
};
const $ed01441649308ad3$var$UNIT_LABELS = {
    m: [
        'minute',
        'minutes'
    ],
    h: [
        'hour',
        'hours'
    ],
    d: [
        'day',
        'days'
    ],
    w: [
        'week',
        'weeks'
    ]
};
const $ed01441649308ad3$export$742a6613cc93845e = (0, $3044e0bef3624137$exports.fromJS)({
    scheduled: {
        enabled: false,
        value: 15,
        unit: 'm'
    },
    deadline: {
        enabled: false,
        value: 1,
        unit: 'd'
    },
    timestamp: {
        enabled: false,
        value: 15,
        unit: 'm'
    }
});
const $ed01441649308ad3$export$c0d1f3814120bd33 = $ed01441649308ad3$export$742a6613cc93845e.merge((0, $3044e0bef3624137$exports.fromJS)({
    enabled: false,
    tagCadences: []
}));
const $ed01441649308ad3$export$ec849c9586573a82 = {
    tag: '',
    scheduled: {
        enabled: false,
        value: 15,
        unit: 'm'
    },
    deadline: {
        enabled: false,
        value: 1,
        unit: 'd'
    },
    timestamp: {
        enabled: false,
        value: 15,
        unit: 'm'
    }
};
const $ed01441649308ad3$export$579fdd47c8a73d75 = ()=>{
    if (typeof window === 'undefined' || !window.isSecureContext) return false;
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return false;
    if ((0, $fb511a1814e342c6$export$41a665f744414057)() && !(0, $fb511a1814e342c6$export$b593c79fb91dd356)) return false;
    return true;
};
const $ed01441649308ad3$export$7923a88bdb944eb9 = ()=>{
    if (typeof window === 'undefined' || !window.isSecureContext) return 'Notifications require a secure (HTTPS) connection.';
    if ((0, $fb511a1814e342c6$export$41a665f744414057)() && !(0, $fb511a1814e342c6$export$b593c79fb91dd356)) return 'On iOS, add organice to your Home Screen to enable notifications.';
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return 'Notifications are not supported in this browser.';
    return null;
};
const $ed01441649308ad3$export$d3a6fddecd4c7502 = (date, value, unit)=>{
    const amount = Number(value) || 0;
    switch(unit){
        case 'm':
            return (0, $06ce614ac4919c9e$export$2e2bcd8739ae039)(date, amount);
        case 'h':
            return (0, $f6d160b0b3b3723c$export$2e2bcd8739ae039)(date, amount);
        case 'd':
            return (0, $aa5a474e2d8b72f5$export$2e2bcd8739ae039)(date, amount);
        case 'w':
            return (0, $a49a2aa8dc053503$export$2e2bcd8739ae039)(date, amount);
        default:
            return date;
    }
};
const $ed01441649308ad3$export$cb7793c858e16c4b = (value, unit)=>{
    const amount = Number(value) || 0;
    const labels = $ed01441649308ad3$var$UNIT_LABELS[unit] || $ed01441649308ad3$var$UNIT_LABELS.m;
    return `${amount} ${amount === 1 ? labels[0] : labels[1]}`;
};
const $ed01441649308ad3$export$ef4e2dce1e4cf566 = (settingKey, eventDate, rule)=>{
    const label = $ed01441649308ad3$var$TYPE_LABELS[settingKey] || settingKey;
    const when = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(eventDate, 'yyyy-MM-dd eee HH:mm');
    const value = Number(rule.get('value')) || 0;
    if (value === 0) return `${label} now: ${when}`;
    return `${label} in ${$ed01441649308ad3$export$cb7793c858e16c4b(value, rule.get('unit'))}: ${when}`;
};
const $ed01441649308ad3$export$d7e67b113d33f7b0 = (header, notificationSettings)=>{
    const tags = header.getIn([
        'titleLine',
        'tags'
    ]) || (0, $3044e0bef3624137$exports.List)();
    const tagCadences = notificationSettings.get('tagCadences') || (0, $3044e0bef3624137$exports.List)();
    const matching = tagCadences.filter((cadence)=>{
        const tag = (cadence.get('tag') || '').trim();
        return tag && tags.includes(tag);
    });
    if (matching.size > 0) return matching;
    return (0, $3044e0bef3624137$exports.List)([
        notificationSettings
    ]);
};
const $ed01441649308ad3$var$GRACE_MS = 120000;
const $ed01441649308ad3$var$HORIZON_MS = 604800000;
const $ed01441649308ad3$export$3f42fefe1ac7e2e5 = (files, notificationSettings, now = new Date())=>{
    if (!notificationSettings || !notificationSettings.get('enabled')) return [];
    const events = [];
    (files || (0, $3044e0bef3624137$exports.Map)()).forEach((file, path)=>{
        if (!path || path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) return;
        const headers = file.get('headers') || (0, $3044e0bef3624137$exports.List)();
        const todoKeywordSets = file.get('todoKeywordSets');
        headers.forEach((header)=>{
            const todoKeyword = header.getIn([
                'titleLine',
                'todoKeyword'
            ]);
            if (todoKeyword && todoKeywordSets && (0, $2ce140c2c56df8f2$export$60678e145a879202)(todoKeywordSets, todoKeyword)) return;
            const ruleSets = $ed01441649308ad3$export$d7e67b113d33f7b0(header, notificationSettings);
            const planningItems = header.get('planningItems') || (0, $3044e0bef3624137$exports.List)();
            const title = (header.getIn([
                'titleLine',
                'rawTitle'
            ]) || '').trim() || 'Untitled';
            planningItems.forEach((item)=>{
                const settingKey = $ed01441649308ad3$export$cce86e53d4e6e9b4[item.get('type')];
                if (!settingKey) return;
                const timestamp = item.get('timestamp');
                if (!timestamp || timestamp.get('isActive') === false) return;
                const eventDate = (0, $e706118dde20dbed$export$77db66937f538459)(timestamp);
                ruleSets.forEach((ruleSet)=>{
                    const rule = ruleSet.get(settingKey);
                    if (!rule || !rule.get('enabled')) return;
                    const fireAt = $ed01441649308ad3$export$d3a6fddecd4c7502(eventDate, rule.get('value'), rule.get('unit'));
                    const delta = fireAt.getTime() - now.getTime();
                    if (delta < -$ed01441649308ad3$var$GRACE_MS || delta > $ed01441649308ad3$var$HORIZON_MS) return;
                    events.push({
                        id: `${path}:${header.get('id')}:${item.get('id')}:${settingKey}:${fireAt.getTime()}`,
                        fireAt: fireAt,
                        eventDate: eventDate,
                        title: title,
                        body: $ed01441649308ad3$export$ef4e2dce1e4cf566(settingKey, eventDate, rule),
                        path: path,
                        headerId: header.get('id'),
                        settingKey: settingKey
                    });
                });
            });
        });
    });
    events.sort((a, b)=>a.fireAt.getTime() - b.fireAt.getTime());
    return events;
};



const $18ca84fc585e0c6b$export$c43914e0cb16a981 = (()=>{
    try {
        localStorage.setItem('test', 'test');
        const localStorageRes = localStorage.getItem('test') === 'test';
        localStorage.removeItem('test');
        return localStorageRes && localStorage;
    } catch (e) {
        return false;
    }
})();
/**
 * GitLab doesn't allow updating a file that doesn't exist or creating one that already exists, so
 * need to figure out which to do.
 */ const $18ca84fc585e0c6b$var$updateConfigForGitLab = async (client, contents)=>{
    const filename = '/.organice-config.json';
    let exists = false;
    try {
        const existingContents = await client.getFileContents(filename);
        exists = true;
        // INFO: Not calling syncBackendClient.createFile is a
        // workaround for
        // https://github.com/200ok-ch/organice/issues/736
        if (existingContents === contents) return;
    } catch (e) {
    // Error is (presumably) because file doesn't exist. Unfortunately this isn't perfect because it
    // could have failed due to e.g. a network issue.
    }
    if (exists) await client.updateFile(filename, contents);
    else await client.createFile(filename, contents);
};
const $18ca84fc585e0c6b$var$debouncedPushConfigToSyncBackend = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).debounce((syncBackendClient, contents)=>{
    switch(syncBackendClient.type){
        case 'Dropbox':
        case 'WebDAV':
            syncBackendClient.createFile('/.organice-config.json', contents).catch((error)=>alert(`There was an error trying to push settings to your sync backend: ${error}`));
            break;
        case 'GitLab':
            $18ca84fc585e0c6b$var$updateConfigForGitLab(syncBackendClient, contents).catch((error)=>alert(`There was an error trying to push settings to your sync backend: ${error}`));
            break;
        default:
    }
}, 1000, {
    maxWait: 3000
});
const $18ca84fc585e0c6b$export$7e0d31ef2ab48b94 = [
    {
        category: 'base',
        name: 'fontSize',
        type: 'nullable'
    },
    {
        category: 'base',
        name: 'bulletStyle',
        type: 'nullable',
        default: 'Fancy'
    },
    {
        category: 'base',
        name: 'shouldTapTodoToAdvance',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'agendaDefaultDeadlineDelayUnit',
        type: 'nullable'
    },
    {
        category: 'base',
        name: 'agendaDefaultDeadlineDelayValue',
        type: 'nullable'
    },
    {
        category: 'base',
        name: 'editorDescriptionHeightValue',
        type: 'nullable',
        default: '8'
    },
    {
        category: 'base',
        name: 'agendaStartOnWeekday',
        type: 'nullable',
        default: 1
    },
    {
        category: 'base',
        name: 'shouldStoreSettingsInSyncBackend',
        type: 'boolean',
        default: true
    },
    {
        category: 'base',
        name: 'lastSeenChangelogHash',
        type: 'nullable'
    },
    {
        category: 'base',
        name: 'customKeybindings',
        type: 'json'
    },
    {
        category: 'base',
        name: 'shouldLiveSync',
        type: 'boolean',
        default: true
    },
    {
        category: 'base',
        name: 'showDeadlineDisplay',
        type: 'boolean',
        default: false
    },
    {
        category: 'base',
        name: 'shouldSyncOnBecomingVisibile',
        type: 'boolean',
        default: true
    },
    {
        category: 'base',
        name: 'shouldShowTitleInOrgFile',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'shouldLogIntoDrawer',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'closeSubheadersRecursively',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'shouldNotIndentOnExport',
        type: 'boolean'
    },
    {
        category: 'org',
        name: 'showClockDisplay',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'colorScheme',
        type: 'string',
        default: 'OS'
    },
    {
        category: 'base',
        name: 'theme',
        type: 'string',
        default: 'Solarized'
    },
    {
        category: 'capture',
        name: 'captureTemplates',
        type: 'json',
        default: (0, $3044e0bef3624137$exports.List)()
    },
    {
        category: 'org',
        name: 'fileSettings',
        type: 'json',
        default: (0, $3044e0bef3624137$exports.List)()
    },
    {
        category: 'base',
        name: 'agendaTimeframe',
        type: 'string',
        default: 'Week'
    },
    {
        category: 'base',
        name: 'preferEditRawValues',
        type: 'boolean'
    },
    {
        category: 'base',
        name: 'orgHabitShowAllToday',
        type: 'boolean',
        default: false
    },
    {
        category: 'base',
        name: 'orgHabitPrecedingDays',
        type: 'number',
        default: 21
    },
    {
        category: 'base',
        name: 'orgHabitFollowingDays',
        type: 'number',
        default: 7
    },
    {
        category: 'org',
        name: 'bookmarks',
        type: 'json',
        default: (0, $3044e0bef3624137$exports.Map)({
            search: (0, $3044e0bef3624137$exports.List)(),
            'task-list': (0, $3044e0bef3624137$exports.List)(),
            refile: (0, $3044e0bef3624137$exports.List)()
        })
    },
    {
        category: 'base',
        name: 'notificationSettings',
        type: 'json',
        default: (0, $ed01441649308ad3$export$c0d1f3814120bd33)
    }
];
const $18ca84fc585e0c6b$export$4e3c5bbf48fdd0a8 = ()=>{
    const opennessStateJSONString = localStorage.getItem('headerOpenness');
    return !!opennessStateJSONString ? JSON.parse(opennessStateJSONString) : null;
};
const $18ca84fc585e0c6b$var$getFieldsToPersist = (state, fields)=>{
    return fields.filter((field)=>!field.depreacted).filter((field)=>field.category === 'org').map((field)=>field.type === 'json' ? [
            field.name,
            JSON.stringify(state.org.present.get(field.name) || field.default || {})
        ] : [
            field.name,
            state.org.present.get(field.name)
        ]).concat($18ca84fc585e0c6b$export$7e0d31ef2ab48b94.filter((field)=>field.category !== 'org').map((field)=>{
        return field.type === 'json' ? [
            field.name,
            JSON.stringify(state[field.category].get(field.name) || field.default || {})
        ] : [
            field.name,
            state[field.category].get(field.name) || field.default
        ];
    }));
};
const $18ca84fc585e0c6b$var$getConfigFileContents = (fieldsToPersist)=>{
    return JSON.stringify((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).fromPairs(fieldsToPersist), null, 2);
};
const $18ca84fc585e0c6b$export$3a8fcddeef8103e7 = (state, config, category)=>{
    $18ca84fc585e0c6b$export$7e0d31ef2ab48b94.filter((field)=>field.category === category).forEach((field)=>{
        // Only set value if it exists in config to avoid overwriting localStorage values with undefined
        if (config[field.name] !== undefined) field.type === 'json' ? state = state.set(field.name, (0, $3044e0bef3624137$exports.fromJS)(JSON.parse(config[field.name]))) : state = state.set(field.name, config[field.name]);
    });
    return state;
};
const $18ca84fc585e0c6b$export$f51c3153230af0e7 = (state, config)=>{
    const captureTemplates = (0, $3044e0bef3624137$exports.fromJS)(JSON.parse(config.captureTemplates)).map((template)=>template.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()));
    return state.set('captureTemplates', captureTemplates);
};
const $18ca84fc585e0c6b$export$114310e82dd282e4 = (state, config)=>{
    const fileSettings = (0, $3044e0bef3624137$exports.fromJS)(JSON.parse(config.fileSettings)).map((setting)=>setting.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()));
    return state.set('fileSettings', fileSettings);
};
const $18ca84fc585e0c6b$var$getInitialStateWithDefaultValues = ()=>{
    let initialState = {
        syncBackend: (0, $3044e0bef3624137$exports.Map)(),
        org: {
            past: [],
            present: (0, $3044e0bef3624137$exports.Map)({
                files: (0, $3044e0bef3624137$exports.Map)(),
                fileSettings: [],
                opennessState: (0, $3044e0bef3624137$exports.Map)(),
                search: (0, $3044e0bef3624137$exports.Map)({
                    searchFilter: '',
                    searchFilterExpr: []
                }),
                bookmarks: (0, $3044e0bef3624137$exports.Map)({
                    search: (0, $3044e0bef3624137$exports.List)(),
                    'task-list': (0, $3044e0bef3624137$exports.List)(),
                    refile: (0, $3044e0bef3624137$exports.List)()
                })
            }),
            future: []
        },
        base: (0, $3044e0bef3624137$exports.Map)({
            isLoading: (0, $3044e0bef3624137$exports.Set)(),
            finderTab: 'Search'
        }),
        capture: (0, $3044e0bef3624137$exports.Map)()
    };
    $18ca84fc585e0c6b$export$7e0d31ef2ab48b94.forEach((field)=>{
        const value = field.default;
        if (field.category === 'org') initialState[field.category].present = initialState[field.category].present.set(field.name, value);
        else initialState[field.category] = initialState[field.category].set(field.name, value);
    });
    return initialState;
};
const $18ca84fc585e0c6b$var$loadContentFromLocalStorage = (initialState)=>{
    $18ca84fc585e0c6b$export$7e0d31ef2ab48b94.forEach((field)=>{
        let value = localStorage.getItem(field.name);
        if (field.type === 'nullable') {
            if (value === 'null') value = null;
        } else if (field.type === 'boolean') value = value === 'true';
        else if (field.type === 'number') {
            if (value) value = parseInt(value, 10);
        } else if (field.type === 'json') {
            if (!value) value = field.default || (0, $3044e0bef3624137$exports.Map)();
            else value = (0, $3044e0bef3624137$exports.fromJS)(JSON.parse(value));
        }
        // When nothing has been saved to localStorage before, keep the default.
        value = value || field.default;
        if (field.category === 'org') initialState[field.category].present = initialState[field.category].present.set(field.name, value);
        else initialState[field.category] = initialState[field.category].set(field.name, value);
    });
    // Assign new ids to the capture templates.
    if (initialState.capture.get('captureTemplates')) initialState.capture = initialState.capture.update('captureTemplates', (templates)=>templates.map((template)=>template.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)())));
    // Assign new ids to the file settings.
    if (initialState.org.present.get('fileSettings')) initialState.org.present = initialState.org.present.update('fileSettings', (settings)=>settings.map((setting)=>setting.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)())));
    // Assign new ids to notification tag cadences.
    if (initialState.base.getIn([
        'notificationSettings',
        'tagCadences'
    ])) initialState.base = initialState.base.updateIn([
        'notificationSettings',
        'tagCadences'
    ], (cadences)=>cadences.map((cadence)=>cadence.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)())));
    const opennessState = $18ca84fc585e0c6b$export$4e3c5bbf48fdd0a8();
    if (!!opennessState) initialState.org.present = initialState.org.present.set('opennessState', (0, $3044e0bef3624137$exports.fromJS)(opennessState));
    // Cache the config file contents locally so we don't overwrite on
    // initial page load.
    window.previousSettingsFileContents = $18ca84fc585e0c6b$var$getConfigFileContents($18ca84fc585e0c6b$var$getFieldsToPersist(initialState, $18ca84fc585e0c6b$export$7e0d31ef2ab48b94));
    return (0, $def57205f21f33f8$export$85176bedcdcc2b76)(initialState);
};
const $18ca84fc585e0c6b$export$6ac7cb0c13076777 = ()=>{
    let initialState = $18ca84fc585e0c6b$var$getInitialStateWithDefaultValues();
    return $18ca84fc585e0c6b$export$c43914e0cb16a981 ? $18ca84fc585e0c6b$var$loadContentFromLocalStorage(initialState) : initialState;
};
const $18ca84fc585e0c6b$export$79964713880960f6 = (dispatch, getState)=>{
    const syncBackendClient = getState().syncBackend.get('client');
    if (!syncBackendClient) return;
    let fileContentsPromise = null;
    switch(syncBackendClient.type){
        case 'Dropbox':
        case 'GitLab':
        case 'WebDAV':
            fileContentsPromise = syncBackendClient.getFileContents('/.organice-config.json');
            break;
        default:
    }
    fileContentsPromise.then((configFileContents)=>{
        try {
            let config;
            /* Rationale for the type check:
        When loading the settings file, `configFileContents` is
        sometimes already an object. Therefore, when JSON.parse is
        run, it throws an error which is silently swallowed by the
        catch below. This appears to be the cause of
        https:github.com/200ok-ch/organice/issues/472. Settings will
        never load from file and default config always loads.
        */ if (typeof configFileContents === 'string') config = JSON.parse(configFileContents);
            else config = configFileContents;
            dispatch((0, $1780206710f3c846$export$7027258f5f935b03)(config));
            dispatch((0, $3e461505c3a6d1b3$export$eb06449aae34f9da)(config));
            dispatch((0, $d81b80734fbc24a5$export$1b46013ba7966e2d)(config));
        } catch (_error) {
        // Something went wrong parsing the config file, but we don't care, we'll just
        // overwrite it with a good local copy.
        }
    }).catch(()=>{});
};
const $18ca84fc585e0c6b$export$92924a31c70e422 = (store)=>{
    if (!$18ca84fc585e0c6b$export$c43914e0cb16a981) return ()=>{};
    else return ()=>{
        const state = store.getState();
        const fieldsToPersist = $18ca84fc585e0c6b$var$getFieldsToPersist(state, $18ca84fc585e0c6b$export$7e0d31ef2ab48b94);
        fieldsToPersist.forEach(([name, value])=>{
            if (name && value) localStorage.setItem(name, value);
        });
        if (state.base.get('shouldStoreSettingsInSyncBackend')) {
            const settingsFileContents = $18ca84fc585e0c6b$var$getConfigFileContents(fieldsToPersist);
            if (window.previousSettingsFileContents !== settingsFileContents) $18ca84fc585e0c6b$var$debouncedPushConfigToSyncBackend(state.syncBackend.get('client'), settingsFileContents);
            window.previousSettingsFileContents = settingsFileContents;
        }
        const currentFilePath = state.org.present.get('path');
        const headers = state.org.present.getIn([
            'files',
            currentFilePath,
            'headers'
        ]);
        if (!!currentFilePath && headers) {
            const openHeaderPaths = (0, $2ce140c2c56df8f2$export$580ddb2e4add8c37)(headers);
            let opennessState = {};
            const opennessStateJSONString = localStorage.getItem('headerOpenness');
            if (opennessStateJSONString) opennessState = JSON.parse(opennessStateJSONString);
            opennessState[currentFilePath] = openHeaderPaths;
            localStorage.setItem('headerOpenness', JSON.stringify(opennessState));
        }
    };
};
const $18ca84fc585e0c6b$export$ca245e5e511e4680 = (field, value)=>{
    if (!$18ca84fc585e0c6b$export$c43914e0cb16a981) return;
    else localStorage.setItem(field, value);
};
const $18ca84fc585e0c6b$export$d80763eacb68b9dc = (field, nullable = false)=>{
    if (!$18ca84fc585e0c6b$export$c43914e0cb16a981) return null;
    else {
        const value = localStorage.getItem(field);
        if (nullable) return value === 'null' ? null : value;
        else return value;
    }
};



/* global process */ 

var $1X5R2 = parcelRequire("1X5R2");
var $5c14e4e12844f97a$exports = {};
/* eslint-disable */ // @generated by Peggy 5.0.6.
//
// https://peggyjs.org/
"use strict";
class $5c14e4e12844f97a$var$peg$SyntaxError extends SyntaxError {
    format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
            let src = null;
            const st = sources.find((s)=>s.source === this.location.source);
            if (st) src = st.text.split(/\r\n|\n|\r/g);
            const s = this.location.start;
            const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
            const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
            if (src) {
                const e = this.location.end;
                const filler = "".padEnd(offset_s.line.toString().length, " ");
                const line = src[s.line - 1];
                const last = s.line === e.line ? e.column : line.length + 1;
                const hatLen = last - s.column || 1;
                str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + "".padEnd(s.column - 1, " ") + "".padEnd(hatLen, "^");
            } else str += "\n at " + loc;
        }
        return str;
    }
    static buildMessage(expected, found) {
        function hex(ch) {
            return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s) {
            if (nonPrintable) return s.replace(nonPrintable, (ch)=>"\\u{" + hex(ch) + "}");
            return s;
        }
        function literalEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/"/g, "\\\"").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        function classEscape(s) {
            return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch)=>"\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch)=>"\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
            literal (expectation) {
                return "\"" + literalEscape(expectation.text) + "\"";
            },
            class (expectation) {
                const escapedParts = expectation.parts.map((part)=>Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part));
                return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
            },
            any () {
                return "any character";
            },
            end () {
                return "end of input";
            },
            other (expectation) {
                return expectation.description;
            }
        };
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            const descriptions = expected.map(describeExpectation);
            descriptions.sort();
            if (descriptions.length > 0) {
                let j = 1;
                for(let i = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
                descriptions.length = j;
            }
            switch(descriptions.length){
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? "\"" + literalEscape(found) + "\"" : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    }
    constructor(message, expected, found, location){
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
    }
}
function $5c14e4e12844f97a$var$peg$parse(input, options) {
    options = options !== undefined ? options : {};
    const peg$FAILED = {};
    const peg$source = options.grammarSource;
    const peg$startRuleFunctions = {
        Expression: peg$parseExpression
    };
    let peg$startRuleFunction = peg$parseExpression;
    const peg$c0 = "-";
    const peg$c1 = ":";
    const peg$c2 = "date:";
    const peg$c3 = "clock:";
    const peg$c4 = "sched:";
    const peg$c5 = "scheduled:";
    const peg$c6 = "dead:";
    const peg$c7 = "deadline:";
    const peg$c8 = "desc:";
    const peg$c9 = "description:";
    const peg$c10 = "..";
    const peg$c11 = "today";
    const peg$c12 = "now";
    const peg$c13 = "|";
    const peg$c14 = "'";
    const peg$c15 = "\"";
    const peg$r0 = /^[\-.\/]/;
    const peg$r1 = /^[hdwmy]/;
    const peg$r2 = /^[0-9]/;
    const peg$r3 = /^[^: \t|'"]/;
    const peg$r4 = /^[^']/;
    const peg$r5 = /^[^"]/;
    const peg$r6 = /^[^: \t]/;
    const peg$r7 = /^[a-zA-Z0-9_@#%]/;
    const peg$r8 = /^[ \t]/;
    const peg$e0 = peg$otherExpectation("filter expression");
    const peg$e1 = peg$otherExpectation("filter term");
    const peg$e2 = peg$literalExpectation("-", false);
    const peg$e3 = peg$otherExpectation("text filter term");
    const peg$e4 = peg$otherExpectation("tag filter term");
    const peg$e5 = peg$literalExpectation(":", false);
    const peg$e6 = peg$otherExpectation("property filter term");
    const peg$e7 = peg$otherExpectation("search outside of header");
    const peg$e8 = peg$literalExpectation("date:", false);
    const peg$e9 = peg$literalExpectation("clock:", false);
    const peg$e10 = peg$literalExpectation("sched:", false);
    const peg$e11 = peg$literalExpectation("scheduled:", false);
    const peg$e12 = peg$literalExpectation("dead:", false);
    const peg$e13 = peg$literalExpectation("deadline:", false);
    const peg$e14 = peg$literalExpectation("desc:", false);
    const peg$e15 = peg$literalExpectation("description:", false);
    const peg$e16 = peg$otherExpectation("moments and timeranges");
    const peg$e17 = peg$literalExpectation("..", false);
    const peg$e18 = peg$otherExpectation("moment");
    const peg$e19 = peg$literalExpectation("today", false);
    const peg$e20 = peg$literalExpectation("now", false);
    const peg$e21 = peg$classExpectation([
        "-",
        ".",
        "/"
    ], false, false, false);
    const peg$e22 = peg$classExpectation([
        "h",
        "d",
        "w",
        "m",
        "y"
    ], false, false, false);
    const peg$e23 = peg$otherExpectation("year");
    const peg$e24 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false, false);
    const peg$e25 = peg$otherExpectation("month");
    const peg$e26 = peg$otherExpectation("day");
    const peg$e27 = peg$otherExpectation("offset");
    const peg$e28 = peg$otherExpectation("alternatives");
    const peg$e29 = peg$literalExpectation("|", false);
    const peg$e30 = peg$otherExpectation("tag alternatives");
    const peg$e31 = peg$otherExpectation("string");
    const peg$e32 = peg$classExpectation([
        ":",
        " ",
        "\t",
        "|",
        "'",
        "\""
    ], true, false, false);
    const peg$e33 = peg$literalExpectation("'", false);
    const peg$e34 = peg$classExpectation([
        "'"
    ], true, false, false);
    const peg$e35 = peg$literalExpectation("\"", false);
    const peg$e36 = peg$classExpectation([
        "\""
    ], true, false, false);
    const peg$e37 = peg$otherExpectation("property name");
    const peg$e38 = peg$classExpectation([
        ":",
        " ",
        "\t"
    ], true, false, false);
    const peg$e39 = peg$otherExpectation("tag name");
    const peg$e40 = peg$classExpectation([
        [
            "a",
            "z"
        ],
        [
            "A",
            "Z"
        ],
        [
            "0",
            "9"
        ],
        "_",
        "@",
        "#",
        "%"
    ], false, false, false);
    const peg$e41 = peg$otherExpectation("whitespace");
    const peg$e42 = peg$classExpectation([
        " ",
        "\t"
    ], false, false, false);
    function peg$f0(head, tail) {
        return tail.reduce((result, element)=>{
            result.push(element[1]);
            return result;
        }, [
            head
        ]);
    }
    function peg$f1() {
        return [];
    }
    function peg$f2(a) {
        a.offset = location().start.offset;
        a.endOffset = location().end.offset;
        return a;
    }
    function peg$f3(a) {
        if (a.type === 'field' && a.field.type !== 'desc') throw {
            message: `can't negate timerange searches yet`
        };
        else {
            a.exclude = true;
            return a;
        }
    }
    function peg$f4(a) {
        a.exclude = false;
        return a;
    }
    function peg$f5(a) {
        let type = 'ignore-case';
        // It's hard to check for upper-case chars in JS.
        // Best approach: https://stackoverflow.com/a/31415820/999007
        // Simplest approach for now:
        if (text().match(/[A-Z]/)) type = 'case-sensitive';
        return {
            type: type,
            words: a
        };
    }
    function peg$f6(a) {
        return {
            type: 'tag',
            words: a
        };
    }
    function peg$f7(a, b) {
        return {
            type: 'property',
            property: a,
            words: b === null ? [
                ''
            ] : b
        };
    }
    function peg$f8(a) {
        return {
            type: 'field',
            field: {
                type: 'date',
                timerange: a
            }
        };
    }
    function peg$f9(a) {
        return {
            type: 'field',
            field: {
                type: 'clock',
                timerange: a
            }
        };
    }
    function peg$f10(a) {
        return {
            type: 'field',
            field: {
                type: 'scheduled',
                timerange: a
            }
        };
    }
    function peg$f11(a) {
        return {
            type: 'field',
            field: {
                type: 'deadline',
                timerange: a
            }
        };
    }
    function peg$f12(a) {
        return {
            type: 'field',
            field: {
                type: 'description',
                text: a
            }
        };
    }
    function peg$f13(a, b) {
        return {
            type: 'range',
            from: a,
            to: b
        };
    }
    function peg$f14(a) {
        return {
            type: 'range',
            from: a,
            to: null
        };
    }
    function peg$f15(a) {
        return {
            type: 'point',
            point: a
        };
    }
    function peg$f16(a) {
        return {
            type: 'range',
            from: null,
            to: a
        };
    }
    function peg$f17() {
        return {
            type: 'all'
        };
    }
    function peg$f18(a) {
        return {
            type: 'special',
            value: a
        };
    }
    function peg$f19(year, month, day) {
        return checkDate(year, month, day);
    }
    function peg$f20(year, month) {
        return checkMonth(year, month);
    }
    function peg$f21(year) {
        return {
            type: 'timestamp',
            year: parseInt(year),
            month: null,
            day: null
        };
    }
    function peg$f22(a) {
        return {
            type: 'unit',
            unit: a
        };
    }
    function peg$f23(a) {
        return a;
    }
    function peg$f24(a) {
        return a;
    }
    function peg$f25(a) {
        return a;
    }
    function peg$f26(a, b) {
        return {
            type: 'offset',
            value: parseInt(a),
            unit: b
        };
    }
    function peg$f27(head, tail) {
        return tail.reduce((result, element)=>{
            result.push(element[1]);
            return result;
        }, [
            head
        ]);
    }
    function peg$f28(head, tail) {
        return tail.reduce((result, element)=>{
            result.push(element[1]);
            return result;
        }, [
            head
        ]);
    }
    function peg$f29() {
        return text();
    }
    function peg$f30(a) {
        return a.join('');
    }
    function peg$f31(a) {
        return a.join('');
    }
    function peg$f32() {
        return text();
    }
    function peg$f33() {
        return text();
    }
    let peg$currPos = options.peg$currPos | 0;
    let peg$savedPos = peg$currPos;
    const peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ];
    let peg$maxFailPos = peg$currPos;
    let peg$maxFailExpected = options.peg$maxFailExpected || [];
    let peg$silentFails = options.peg$silentFails | 0;
    let peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === undefined) return "";
        return String.fromCodePoint(cp);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase,
            unicode: unicode
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p;
        if (details) return details;
        else {
            if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
            else {
                p = pos;
                while(!peg$posDetailsCache[--p]);
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && typeof peg$source.offset === "function") {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $5c14e4e12844f97a$var$peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $5c14e4e12844f97a$var$peg$SyntaxError($5c14e4e12844f97a$var$peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$parseExpression() {
        let s0, s1, s2, s3, s4, s5, s6;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parse_();
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parse_();
        }
        s2 = peg$parseLocationAnnotedTerm();
        if (s2 !== peg$FAILED) {
            s3 = [];
            s4 = peg$currPos;
            s5 = [];
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                s5.push(s6);
                s6 = peg$parse_();
            }
            else s5 = peg$FAILED;
            if (s5 !== peg$FAILED) {
                s6 = peg$parseLocationAnnotedTerm();
                if (s6 !== peg$FAILED) {
                    s5 = [
                        s5,
                        s6
                    ];
                    s4 = s5;
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
            } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
            }
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                    s5.push(s6);
                    s6 = peg$parse_();
                }
                else s5 = peg$FAILED;
                if (s5 !== peg$FAILED) {
                    s6 = peg$parseLocationAnnotedTerm();
                    if (s6 !== peg$FAILED) {
                        s5 = [
                            s5,
                            s6
                        ];
                        s4 = s5;
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
            }
            s4 = [];
            s5 = peg$parse_();
            while(s5 !== peg$FAILED){
                s4.push(s5);
                s5 = peg$parse_();
            }
            peg$savedPos = s0;
            s0 = peg$f0(s2, s3);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parse_();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parse_();
            }
            peg$savedPos = s0;
            s1 = peg$f1();
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e0);
        }
        return s0;
    }
    function peg$parseLocationAnnotedTerm() {
        let s0, s1;
        s0 = peg$currPos;
        s1 = peg$parseTerm();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f2(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseTerm() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c0;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e2);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsePlainTerm();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f3(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsePlainTerm();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f4(s1);
            }
            s0 = s1;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e1);
        }
        return s0;
    }
    function peg$parsePlainTerm() {
        let s0;
        s0 = peg$parseTermField();
        if (s0 === peg$FAILED) {
            s0 = peg$parseTermText();
            if (s0 === peg$FAILED) {
                s0 = peg$parseTermProp();
                if (s0 === peg$FAILED) s0 = peg$parseTermTag();
            }
        }
        return s0;
    }
    function peg$parseTermText() {
        let s0, s1;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseStringAlternatives();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f5(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e3);
        }
        return s0;
    }
    function peg$parseTermTag() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 58) {
            s1 = peg$c1;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseTagAlternatives();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f6(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e4);
        }
        return s0;
    }
    function peg$parseTermProp() {
        let s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 58) {
            s1 = peg$c1;
            peg$currPos++;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsePropertyName();
            if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s3 = peg$c1;
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e5);
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseStringAlternatives();
                    if (s4 === peg$FAILED) s4 = null;
                    peg$savedPos = s0;
                    s0 = peg$f7(s2, s4);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e6);
        }
        return s0;
    }
    function peg$parseTermField() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c2) {
            s1 = peg$c2;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e8);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parseTimeRange();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f8(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c3) {
                s1 = peg$c3;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e9);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseTimeRange();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f9(s2);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 6) === peg$c4) {
                    s1 = peg$c4;
                    peg$currPos += 6;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e10);
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 10) === peg$c5) {
                        s1 = peg$c5;
                        peg$currPos += 10;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e11);
                    }
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseTimeRange();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f10(s2);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 5) === peg$c6) {
                        s1 = peg$c6;
                        peg$currPos += 5;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e12);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 9) === peg$c7) {
                            s1 = peg$c7;
                            peg$currPos += 9;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e13);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseTimeRange();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f11(s2);
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 5) === peg$c8) {
                            s1 = peg$c8;
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e14);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 12) === peg$c9) {
                                s1 = peg$c9;
                                peg$currPos += 12;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$e15);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseTermText();
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f12(s2);
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e7);
        }
        return s0;
    }
    function peg$parseTimeRange() {
        let s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseMoment();
        if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c10) {
                s2 = peg$c10;
                peg$currPos += 2;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e17);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parseMoment();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f13(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseMoment();
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c10) {
                    s2 = peg$c10;
                    peg$currPos += 2;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e17);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f14(s1);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseMoment();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f15(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c10) {
                        s1 = peg$c10;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e17);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseMoment();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f16(s2);
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c10) {
                            s1 = peg$c10;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e17);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$f17();
                        }
                        s0 = s1;
                    }
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e16);
        }
        return s0;
    }
    function peg$parseMoment() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$parseTimeOffset();
        if (s0 === peg$FAILED) {
            s0 = peg$parseTimestamp();
            if (s0 === peg$FAILED) {
                s0 = peg$parseTimeUnit();
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$currPos;
                    if (input.substr(peg$currPos, 5) === peg$c11) {
                        s2 = peg$c11;
                        peg$currPos += 5;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e19);
                    }
                    if (s2 === peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c12) {
                            s2 = peg$c12;
                            peg$currPos += 3;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e20);
                        }
                    }
                    if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
                    else s1 = s2;
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$f18(s1);
                    }
                    s0 = s1;
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e18);
        }
        return s0;
    }
    function peg$parseTimestamp() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseYear();
        if (s1 !== peg$FAILED) {
            s2 = input.charAt(peg$currPos);
            if (peg$r0.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e21);
            }
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parseMonth();
            if (s3 !== peg$FAILED) {
                s4 = input.charAt(peg$currPos);
                if (peg$r0.test(s4)) peg$currPos++;
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e21);
                }
                if (s4 === peg$FAILED) s4 = null;
                s5 = peg$parseDay();
                if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f19(s1, s3, s5);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseYear();
            if (s1 !== peg$FAILED) {
                s2 = input.charAt(peg$currPos);
                if (peg$r0.test(s2)) peg$currPos++;
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e21);
                }
                if (s2 === peg$FAILED) s2 = null;
                s3 = peg$parseMonth();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f20(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseYear();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f21(s1);
                }
                s0 = s1;
            }
        }
        return s0;
    }
    function peg$parseTimeUnit() {
        let s0, s1;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r1.test(s1)) peg$currPos++;
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e22);
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f22(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseYear() {
        let s0, s1, s2, s3, s4, s5, s6;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$currPos;
        s3 = input.charAt(peg$currPos);
        if (peg$r2.test(s3)) peg$currPos++;
        else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e24);
        }
        if (s3 !== peg$FAILED) {
            s4 = input.charAt(peg$currPos);
            if (peg$r2.test(s4)) peg$currPos++;
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e24);
            }
            if (s4 !== peg$FAILED) {
                s5 = input.charAt(peg$currPos);
                if (peg$r2.test(s5)) peg$currPos++;
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e24);
                }
                if (s5 !== peg$FAILED) {
                    s6 = input.charAt(peg$currPos);
                    if (peg$r2.test(s6)) peg$currPos++;
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e24);
                    }
                    if (s6 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4,
                            s5,
                            s6
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
        else s1 = s2;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f23(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e23);
        }
        return s0;
    }
    function peg$parseMonth() {
        let s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$currPos;
        s3 = input.charAt(peg$currPos);
        if (peg$r2.test(s3)) peg$currPos++;
        else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e24);
        }
        if (s3 !== peg$FAILED) {
            s4 = input.charAt(peg$currPos);
            if (peg$r2.test(s4)) peg$currPos++;
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e24);
            }
            if (s4 !== peg$FAILED) {
                s3 = [
                    s3,
                    s4
                ];
                s2 = s3;
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
        else s1 = s2;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f24(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e25);
        }
        return s0;
    }
    function peg$parseDay() {
        let s0, s1, s2, s3, s4;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$currPos;
        s3 = input.charAt(peg$currPos);
        if (peg$r2.test(s3)) peg$currPos++;
        else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e24);
        }
        if (s3 !== peg$FAILED) {
            s4 = input.charAt(peg$currPos);
            if (peg$r2.test(s4)) peg$currPos++;
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e24);
            }
            if (s4 !== peg$FAILED) {
                s3 = [
                    s3,
                    s4
                ];
                s2 = s3;
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
        } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
        else s1 = s2;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f25(s1);
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e26);
        }
        return s0;
    }
    function peg$parseTimeOffset() {
        let s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r2.test(s3)) peg$currPos++;
        else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e24);
        }
        if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r2.test(s3)) peg$currPos++;
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e24);
            }
        }
        else s2 = peg$FAILED;
        if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
        else s1 = s2;
        if (s1 !== peg$FAILED) {
            s2 = input.charAt(peg$currPos);
            if (peg$r1.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e22);
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f26(s1, s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e27);
        }
        return s0;
    }
    function peg$parseStringAlternatives() {
        let s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseString();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 124) {
                s4 = peg$c13;
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e29);
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parseString();
                if (s5 !== peg$FAILED) {
                    s4 = [
                        s4,
                        s5
                    ];
                    s3 = s4;
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 124) {
                    s4 = peg$c13;
                    peg$currPos++;
                } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e29);
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parseString();
                    if (s5 !== peg$FAILED) {
                        s4 = [
                            s4,
                            s5
                        ];
                        s3 = s4;
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f27(s1, s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e28);
        }
        return s0;
    }
    function peg$parseTagAlternatives() {
        let s0, s1, s2, s3, s4, s5;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parseTagName();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 124) {
                s4 = peg$c13;
                peg$currPos++;
            } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e29);
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parseTagName();
                if (s5 !== peg$FAILED) {
                    s4 = [
                        s4,
                        s5
                    ];
                    s3 = s4;
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 124) {
                    s4 = peg$c13;
                    peg$currPos++;
                } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e29);
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parseTagName();
                    if (s5 !== peg$FAILED) {
                        s4 = [
                            s4,
                            s5
                        ];
                        s3 = s4;
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f28(s1, s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e30);
        }
        return s0;
    }
    function peg$parseString() {
        let s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r3.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e32);
        }
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r3.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e32);
            }
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f29();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c14;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e33);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = input.charAt(peg$currPos);
                if (peg$r4.test(s3)) peg$currPos++;
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e34);
                }
                if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = input.charAt(peg$currPos);
                    if (peg$r4.test(s3)) peg$currPos++;
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e34);
                    }
                }
                else s2 = peg$FAILED;
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s3 = peg$c14;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e33);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f30(s2);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 34) {
                    s1 = peg$c15;
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e35);
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = input.charAt(peg$currPos);
                    if (peg$r5.test(s3)) peg$currPos++;
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e36);
                    }
                    if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                        s2.push(s3);
                        s3 = input.charAt(peg$currPos);
                        if (peg$r5.test(s3)) peg$currPos++;
                        else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e36);
                        }
                    }
                    else s2 = peg$FAILED;
                    if (s2 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 34) {
                            s3 = peg$c15;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$e35);
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f31(s2);
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e31);
        }
        return s0;
    }
    function peg$parsePropertyName() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r6.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e38);
        }
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r6.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e38);
            }
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f32();
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e37);
        }
        return s0;
    }
    function peg$parseTagName() {
        let s0, s1, s2;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r7.test(s2)) peg$currPos++;
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e40);
        }
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r7.test(s2)) peg$currPos++;
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e40);
            }
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f33();
        }
        s0 = s1;
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e39);
        }
        return s0;
    }
    function peg$parse_() {
        let s0, s1;
        peg$silentFails++;
        s0 = input.charAt(peg$currPos);
        if (peg$r8.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e42);
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e41);
        }
        return s0;
    }
    const checkDate = (year, month, day)=>{
        const date = new Date(year + "-" + month + "-" + day);
        if (isNaN(date.valueOf())) throw {
            message: 'invalid date'
        };
        else return {
            type: 'timestamp',
            year: parseInt(year),
            month: parseInt(month),
            day: parseInt(day)
        };
    };
    const checkMonth = (year, month)=>{
        if (month >= 1 && month <= 12) return {
            type: 'timestamp',
            year: parseInt(year),
            month: parseInt(month),
            day: null
        };
        else throw {
            message: 'invalid month'
        };
    };
    peg$result = peg$startRuleFunction();
    const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
    function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
    if (options.peg$library) return /** @type {any} */ {
        peg$result: peg$result,
        peg$currPos: peg$currPos,
        peg$FAILED: peg$FAILED,
        peg$maxFailExpected: peg$maxFailExpected,
        peg$maxFailPos: peg$maxFailPos,
        peg$success: peg$success,
        peg$throw: peg$success ? undefined : peg$throw
    };
    if (peg$success) return peg$result;
    else peg$throw();
}
$5c14e4e12844f97a$exports = {
    StartRules: [
        "Expression"
    ],
    SyntaxError: $5c14e4e12844f97a$var$peg$SyntaxError,
    parse: $5c14e4e12844f97a$var$peg$parse
};


// Matcher



function $97e43c253919aede$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $5a81f4539ea0fdae$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(59, 59, 999);
    return date;
}



function $e707ab705f6be0e8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $fc9b987604e72358$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $79ee346c61196589$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $4554dc9bbab9791e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $d93b19c1870b5f11$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $9e259011028b352c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $f9da2e6a06649605$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $93e3437ae033fe8d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $fff698c205efc3e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}





const $2189696cf439a1f0$var$startOfDate = (from)=>{
    const temp = new Date();
    temp.setFullYear(from.year);
    if (from.month === null) return (0, $fff698c205efc3e7$export$2e2bcd8739ae039)(temp);
    else if (from.day === null) {
        temp.setMonth(from.month - 1);
        return (0, $9e259011028b352c$export$2e2bcd8739ae039)(temp);
    } else {
        temp.setMonth(from.month - 1);
        temp.setDate(from.day);
        return (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(temp);
    }
};
const $2189696cf439a1f0$var$endOfDate = (to)=>{
    const temp = new Date();
    temp.setFullYear(to.year);
    if (to.month === null) return (0, $79ee346c61196589$export$2e2bcd8739ae039)(temp);
    else if (to.day === null) {
        temp.setMonth(to.month - 1);
        return (0, $e707ab705f6be0e8$export$2e2bcd8739ae039)(temp);
    } else {
        temp.setMonth(to.month - 1);
        temp.setDate(to.day);
        return (0, $97e43c253919aede$export$2e2bcd8739ae039)(temp);
    }
};
const $2189696cf439a1f0$var$fromSpecial = (from)=>{
    const temp = new Date();
    if (from.value === 'now') return temp;
    else if (from.value === 'today') return (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(temp);
};
const $2189696cf439a1f0$var$toSpecial = (to)=>{
    const temp = new Date();
    if (to.value === 'now') return temp;
    else if (to.value === 'today') return (0, $97e43c253919aede$export$2e2bcd8739ae039)(temp);
};
const $2189696cf439a1f0$var$fromUnit = (date, unit)=>{
    const d = new Date(date);
    switch(unit){
        case 'h':
            return (0, $d93b19c1870b5f11$export$2e2bcd8739ae039)(d);
        case 'd':
            return (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(d);
        case 'w':
            return (0, $f9da2e6a06649605$export$2e2bcd8739ae039)(d);
        case 'm':
            return (0, $9e259011028b352c$export$2e2bcd8739ae039)(d);
        case 'y':
            return (0, $fff698c205efc3e7$export$2e2bcd8739ae039)(d);
        default:
            throw Error('unknown `unit` for timerange search');
    }
};
const $2189696cf439a1f0$var$toUnit = (date, unit)=>{
    const d = new Date(date);
    switch(unit){
        case 'h':
            return (0, $5a81f4539ea0fdae$export$2e2bcd8739ae039)(d);
        case 'd':
            return (0, $97e43c253919aede$export$2e2bcd8739ae039)(d);
        case 'w':
            return (0, $fc9b987604e72358$export$2e2bcd8739ae039)(d);
        case 'm':
            return (0, $e707ab705f6be0e8$export$2e2bcd8739ae039)(d);
        case 'y':
            return (0, $79ee346c61196589$export$2e2bcd8739ae039)(d);
        default:
            throw Error('unknown `unit` for timerange search');
    }
};
const $2189696cf439a1f0$var$resolveFrom = (from)=>{
    if (from === null) return new Date();
    else if (from.type === 'timestamp') return $2189696cf439a1f0$var$startOfDate(from);
    else if (from.type === 'special') return $2189696cf439a1f0$var$fromSpecial(from);
    else if (from.type === 'offset') return (0, $e706118dde20dbed$export$8491aff2799e70c1)(new Date(), from.value, from.unit);
    else if (from.type === 'unit') return $2189696cf439a1f0$var$fromUnit(new Date(), from.unit);
};
const $2189696cf439a1f0$var$resolveTo = (to)=>{
    if (to === null) return new Date();
    else if (to.type === 'timestamp') return $2189696cf439a1f0$var$endOfDate(to);
    else if (to.type === 'special') return $2189696cf439a1f0$var$toSpecial(to);
    else if (to.type === 'offset') return (0, $e706118dde20dbed$export$774686e7fdec6ef3)(new Date(), to.value, to.unit);
    else if (to.type === 'unit') return $2189696cf439a1f0$var$toUnit(new Date(), to.unit);
};
const $2189696cf439a1f0$var$isRelative = (moment)=>{
    return moment.type === 'offset' || moment.type === 'unit';
};
const $2189696cf439a1f0$export$3c27fa6f2514ec8d = (filterDescription)=>{
    const timeFilterDescription = filterDescription.field.timerange;
    let lower;
    let upper;
    if (timeFilterDescription.type === 'point') {
        const point = timeFilterDescription.point;
        if (point.type === 'offset') {
            lower = new Date();
            upper = (0, $e706118dde20dbed$export$774686e7fdec6ef3)(new Date(lower));
        } else {
            lower = $2189696cf439a1f0$var$resolveFrom(point);
            upper = $2189696cf439a1f0$var$resolveTo(point);
        }
        return (timestamp)=>lower <= (0, $e706118dde20dbed$export$77db66937f538459)(timestamp) && (0, $e706118dde20dbed$export$77db66937f538459)(timestamp) <= upper;
    } else if (timeFilterDescription.type === 'range') {
        const from = timeFilterDescription.from ? timeFilterDescription.from : {
            type: 'special',
            value: 'now'
        };
        const to = timeFilterDescription.to ? timeFilterDescription.to : {
            type: 'special',
            value: 'now'
        };
        let lower;
        let upper;
        if ($2189696cf439a1f0$var$isRelative(from) === $2189696cf439a1f0$var$isRelative(to)) {
            lower = $2189696cf439a1f0$var$resolveFrom(from);
            upper = $2189696cf439a1f0$var$resolveTo(to);
        } else if (from.type === 'offset') {
            upper = $2189696cf439a1f0$var$resolveTo(to);
            lower = (0, $e706118dde20dbed$export$8491aff2799e70c1)(new Date(upper), from.value, from.unit);
        } else if (to.type === 'offset') {
            lower = $2189696cf439a1f0$var$resolveFrom(from);
            upper = (0, $e706118dde20dbed$export$774686e7fdec6ef3)(new Date(lower), to.value, to.unit);
        } else if (from.type === 'unit') {
            upper = $2189696cf439a1f0$var$resolveTo(to);
            lower = $2189696cf439a1f0$var$fromUnit(upper, from.unit);
        } else if (to.type === 'unit') {
            lower = $2189696cf439a1f0$var$resolveFrom(from);
            upper = $2189696cf439a1f0$var$toUnit(lower, to.unit);
        } else throw Error('unable to construct timerangefilter');
        return (timestamp)=>lower <= (0, $e706118dde20dbed$export$77db66937f538459)(timestamp) && (0, $e706118dde20dbed$export$77db66937f538459)(timestamp) <= upper;
    } else if (timeFilterDescription.type === 'all') return (_)=>true;
    else throw Error('unable to construct timefilter');
};
const $2189696cf439a1f0$var$orChain = (source)=>(xs)=>xs.some((x)=>source.includes(x));
const $2189696cf439a1f0$var$orChainDate = (dates)=>(filter)=>dates.size !== 0 && dates.some((x)=>filter(x));
const $2189696cf439a1f0$export$b74c33566721f70f = (filterExpr)=>{
    const filterFilter = (type, exclude)=>(x)=>x.type === type && x.exclude === exclude;
    const words = (x)=>x.words;
    const wordsLowerCase = (x)=>x.words.map((y)=>y.toLowerCase());
    const filterTags = filterExpr.filter(filterFilter('tag', false)).map(words);
    const filterCS = filterExpr.filter(filterFilter('case-sensitive', false)).map(words);
    const filterIC = filterExpr.filter(filterFilter('ignore-case', false)).map(wordsLowerCase);
    const filterProps = filterExpr.filter(filterFilter('property', false)).map((x)=>[
            x.property,
            x.words
        ]);
    const filterField = filterExpr.filter(filterFilter('field', false));
    const filterDate = filterField.filter((f)=>f.field.type === 'date').map($2189696cf439a1f0$export$3c27fa6f2514ec8d);
    //const filterClock = filterField.filter((f) => f.field.type === 'clock').map(timeFilter);
    const filterSchedule = filterField.filter((f)=>f.field.type === 'scheduled').map($2189696cf439a1f0$export$3c27fa6f2514ec8d);
    const filterDeadline = filterField.filter((f)=>f.field.type === 'deadline').map($2189696cf439a1f0$export$3c27fa6f2514ec8d);
    const filterTagsExcl = filterExpr.filter(filterFilter('tag', true)).map(words);
    const filterCSExcl = filterExpr.filter(filterFilter('case-sensitive', true)).map(words);
    const filterICExcl = filterExpr.filter(filterFilter('ignore-case', true)).map(wordsLowerCase);
    const filterPropsExcl = filterExpr.filter(filterFilter('property', true)).map((x)=>[
            x.property,
            x.words
        ]);
    const filterDesc = filterField.filter((f)=>f.field.type === 'description' && f.field.text.type === 'ignore-case').map((x)=>x.field.text.words.map((y)=>y.toLowerCase()));
    const filterDescCS = filterField.filter((f)=>f.field.type === 'description' && f.field.text.type === 'case-sensitive').map((x)=>x.field.text.words);
    return (header)=>{
        const headLine = header.get('titleLine');
        const tags = headLine.get('tags');
        const todoKeyword = headLine.get('todoKeyword');
        const rawTitle = headLine.get('rawTitle');
        const headlineText = todoKeyword ? `${todoKeyword} ${rawTitle}` : rawTitle;
        const properties = header.get('propertyListItems').map((p)=>[
                p.get('property'),
                (0, $500d38b948046618$export$2c44f25459bb5dc7)(p.get('value'))
            ]);
        const planningItems = header.get('planningItems').filter((p)=>p.get('timestamp').get('isActive') === true);
        const dates = planningItems.map((p)=>p.get('timestamp'));
        const scheduleds = planningItems.filter((p)=>p.get('type') === 'SCHEDULED').map((p)=>p.get('timestamp'));
        const deadlines = planningItems.filter((p)=>p.get('type') === 'DEADLINE').map((p)=>p.get('timestamp'));
        var description = '';
        if (filterDesc.length > 0 || filterDescCS.length > 0) {
            const stripMarkup = (text)=>text.replace(/\*([\w]*)\*/, (match, p1, _, __)=>p1);
            description = stripMarkup(header.get('rawDescription'));
        }
        //const clocks = header
        //  .get('logBookEntries')
        //  .flatMap((l) => [l.get('start'), l.get('end')])
        //  .filter((t) => t !== undefined && t !== null);
        const propertyFilter = ([x, ys])=>!properties.filter(([key, val])=>{
                // Property names (keys) are case-insensitive
                // https://orgmode.org/manual/Property-Syntax.html
                const nameMatch = key.toLowerCase() === x.toLowerCase();
                const valueMatch = ys.some((y)=>val.includes(y));
                return nameMatch && valueMatch;
            }).isEmpty();
        return filterTags.every($2189696cf439a1f0$var$orChain(tags)) && filterCS.every($2189696cf439a1f0$var$orChain(headlineText)) && filterIC.every($2189696cf439a1f0$var$orChain(headlineText.toLowerCase())) && filterProps.every(propertyFilter) && filterDate.every($2189696cf439a1f0$var$orChainDate(dates)) && //filterClock.every(orChainDate(clocks)) &&
        filterSchedule.every($2189696cf439a1f0$var$orChainDate(scheduleds)) && filterDeadline.every($2189696cf439a1f0$var$orChainDate(deadlines)) && filterDesc.every($2189696cf439a1f0$var$orChain(description.toLowerCase())) && filterDescCS.every($2189696cf439a1f0$var$orChain(description)) && !filterTagsExcl.some($2189696cf439a1f0$var$orChain(tags)) && !filterCSExcl.some($2189696cf439a1f0$var$orChain(headlineText)) && !filterICExcl.some($2189696cf439a1f0$var$orChain(headlineText.toLowerCase())) && !filterPropsExcl.some(propertyFilter);
    };
};
const $2189696cf439a1f0$export$1538445f4477fe89 = (todoKeywords, tagNames, allProperties)=>(filterExpr, filterString, curserPosition)=>{
        const tagAndPropNames = [].concat(tagNames, (0, $2ce140c2c56df8f2$export$dc7a29fc539d16a4)((0, $3044e0bef3624137$exports.fromJS)(allProperties)).toJS().map((x)=>x + ':'));
        const logicalCursorPosition = filterExpr ? $2189696cf439a1f0$var$computeLogicalPosition(filterExpr, filterString, curserPosition) : null;
        const charBeforeCursor = filterString.charAt(curserPosition - 1);
        const charTwoBeforeCursor = curserPosition > 1 ? filterString.charAt(curserPosition - 2) : '';
        if (logicalCursorPosition === null) ;
        else if (logicalCursorPosition === $2189696cf439a1f0$var$SPACE_SURROUNDED) return todoKeywords;
        else if (logicalCursorPosition.type === 'case-sensitive') {
            if (charBeforeCursor.match(/[A-Z]/)) {
                const textBeforeCursor = charBeforeCursor;
                const filteredTodoKeywords = todoKeywords.filter((x)=>x.startsWith(textBeforeCursor)).map((x)=>x.substring(textBeforeCursor.length));
                if ([
                    ' ',
                    '',
                    '|',
                    '-'
                ].includes(charTwoBeforeCursor)) return filteredTodoKeywords;
            }
        } else if (logicalCursorPosition.type === 'ignore-case') {
            // A text filter starting with '-' turns into an exclude filter as soon as text is appended
            if (charBeforeCursor === '-' && [
                ' ',
                ''
            ].includes(charTwoBeforeCursor)) return todoKeywords;
            return [];
        } else if (logicalCursorPosition.type === 'tag') {
            // This case will likely not occur because ':' alone cannot be parsed
            if (charBeforeCursor === ':') return tagAndPropNames;
        } else if (logicalCursorPosition.type === 'property') {
            if (charBeforeCursor === ':') {
                if (charTwoBeforeCursor === ' ' || charTwoBeforeCursor === '') return tagAndPropNames;
                else {
                    // Either property name or text filter
                    const indexOfOtherColon = filterString.substring(0, curserPosition - 1).lastIndexOf(':');
                    const maybePropertyName = filterString.substring(indexOfOtherColon + 1, curserPosition - 1);
                    const quoteStringIfPossible = (x)=>{
                        if (x.match(/ /)) {
                            if (!x.match(/"/)) return [
                                `"${x}"`
                            ];
                            if (!x.match(/'/)) return [
                                `'${x}'`
                            ];
                            const match = x.match(/^[^ ]*/);
                            return [
                                match[0]
                            ];
                        }
                        return [
                            x
                        ];
                    };
                    if (indexOfOtherColon >= 0 && maybePropertyName.match(/^[^ ]+$/)) // No space in property name -> is property -> return values for that property
                    return (0, $2ce140c2c56df8f2$export$dda9638442af5e1c)((0, $3044e0bef3624137$exports.fromJS)(allProperties), maybePropertyName).flatMap(quoteStringIfPossible).toJS();
                }
            }
        }
        // If ':' or '|' is before cursor, the filter string is likely not
        // successfully parsed and therefore cannot be handled above.
        if (charBeforeCursor === ':') {
            if ([
                ' ',
                '',
                '-'
            ].includes(charTwoBeforeCursor)) return tagAndPropNames;
        } else if (charBeforeCursor === '|') {
            const indexOfOtherColon = filterString.substring(0, curserPosition).lastIndexOf(':');
            const maybeTagName = filterString.substring(indexOfOtherColon + 1, curserPosition - 1);
            if (indexOfOtherColon > -1 && !maybeTagName.match(/ /)) // No space characters between ':' and '|'  ->  '|' is in a tag filter
            return tagNames;
            else return todoKeywords;
        }
        return [];
    };
const $2189696cf439a1f0$export$59f905cb673d1966 = (todoKeywords, tagNames, allProperties)=>(filterExpr, filterString, curserPosition)=>{
        const completions = $2189696cf439a1f0$export$1538445f4477fe89(todoKeywords, tagNames, allProperties)(filterExpr, filterString, curserPosition);
        return completions.map((x)=>filterString.substring(0, curserPosition) + x + filterString.substring(curserPosition));
    };
const $2189696cf439a1f0$var$SPACE_SURROUNDED = ' ';
// Compute the logical curser position within the parsed filter expression.
// Return SPACE_SURROUNDED if the curser is inbetween two expressions and
// surrounded by spaces (begin and end of line count as space).
// Return the the filter term if the curser is in or at the edge of an filter term.
const $2189696cf439a1f0$var$computeLogicalPosition = (filterExpr, filterString, curserPosition)=>{
    if (filterExpr.length === 0) return $2189696cf439a1f0$var$SPACE_SURROUNDED;
    const tup = (x, y)=>({
            value: x,
            elem: y
        });
    const firstElem = {
        offset: -1,
        endOffset: -1
    };
    const { value: value } = filterExpr.reduce(({ value: value, elem: elem }, next)=>{
        if (elem === null) return tup(value, null); // short-circuit if already found
        if (curserPosition >= next.offset && curserPosition <= next.endOffset) return tup(next, null);
        if (curserPosition > elem.endOffset && curserPosition < next.offset) return tup($2189696cf439a1f0$var$SPACE_SURROUNDED, null);
        return tup(null, next);
    }, {
        value: null,
        elem: firstElem
    });
    if (curserPosition > filterExpr[filterExpr.length - 1].endOffset) return $2189696cf439a1f0$var$SPACE_SURROUNDED;
    return value;
};




const $80612bee79b4209b$export$9010d2e7e3057e30 = (header)=>{
    const logBookEntries = header.get('logBookEntries', []);
    const activeEntries = logBookEntries.filter((entry)=>entry.get('start') && !entry.get('end'));
    return activeEntries.size !== 0;
};
const $80612bee79b4209b$var$totalTimeLogged = (header)=>{
    const logBookEntries = header.get('logBookEntries', []);
    const times = logBookEntries.map((entry)=>entry.get('start') && entry.get('end') ? (0, $e706118dde20dbed$export$77db66937f538459)(entry.get('end')) - (0, $e706118dde20dbed$export$77db66937f538459)(entry.get('start')) : 0);
    const addedTimes = times.reduce((acc, val)=>acc + val, 0);
    return addedTimes;
};
const $80612bee79b4209b$export$25c848a8b4ee87fe = (filters, header)=>{
    const clocks = header.get('logBookEntries', []).map((l)=>[
            l.get('start'),
            l.get('end')
        ]).filter(([start, end])=>start && end).filter((ts)=>ts.some((t)=>filters.every((f)=>f(t))));
    const times = clocks.map(([start, end])=>(0, $e706118dde20dbed$export$77db66937f538459)(end) - (0, $e706118dde20dbed$export$77db66937f538459)(start));
    const addedTimes = times.reduce((acc, val)=>acc + val, 0);
    return addedTimes;
};
const $80612bee79b4209b$export$6750f19b5bb47320 = (headers)=>{
    if (!headers) return headers;
    const headersWithtotalTimeLogged = headers.map((header)=>header.set('totalTimeLogged', $80612bee79b4209b$var$totalTimeLogged(header)));
    const headersWithtotalTimeLoggedRecursive = headersWithtotalTimeLogged.map((header, index)=>{
        const subheaders = (0, $2ce140c2c56df8f2$export$b12986adc1c2ae0d)(headersWithtotalTimeLogged, index);
        const totalTimeLoggedRecursive = subheaders.reduce((acc, val)=>acc + val.get('totalTimeLogged'), header.get('totalTimeLogged'));
        return header.set('totalTimeLoggedRecursive', totalTimeLoggedRecursive);
    });
    return headersWithtotalTimeLoggedRecursive;
};
const $80612bee79b4209b$export$35b29c171a192292 = (filters, headers)=>{
    if (!headers) return headers;
    const headersWithtotalTimeLogged = headers.map((header)=>header.set('totalFilteredTimeLogged', $80612bee79b4209b$export$25c848a8b4ee87fe(filters, header)));
    const headersWithtotalTimeLoggedRecursive = headersWithtotalTimeLogged.map((header, index)=>{
        const subheaders = (0, $2ce140c2c56df8f2$export$b12986adc1c2ae0d)(headersWithtotalTimeLogged, index);
        const totalTimeLoggedRecursive = subheaders.reduce((acc, val)=>acc + val.get('totalFilteredTimeLogged'), header.get('totalFilteredTimeLogged'));
        return header.set('totalFilteredTimeLoggedRecursive', totalTimeLoggedRecursive);
    });
    return headersWithtotalTimeLoggedRecursive;
};







var $1X5R2 = parcelRequire("1X5R2");
// TODO: Extract all match groups of `beginningRegexp` (for example
// like `emailRegexp`), so that they can be documented and are less
// unwieldly.
const $1ad5549438f66e83$var$beginningRegexp = /(\[\[([^\]]*)\]\]|\[\[([^\]]*)\]\[([^\]]*)\]\])|(\[((\d*%)|(\d*\/\d*))\])|((^|\s|[({'"])([*/~=_+])([^\s,'](.*?))\11([\s\-.,:;!?'")}]?))/;
// Regexp taken from https://stackoverflow.com/a/3809435/999007
const $1ad5549438f66e83$var$httpUrlRegexp = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*))/;
// Regexp taken from https://stackoverflow.com/a/1373724/999007
const $1ad5549438f66e83$var$urlRegexp = /([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/;
const $1ad5549438f66e83$var$internationalPhoneRegexp = /((\+|00)\d{8,30})/;
// Regexp taken from https://stackoverflow.com/a/16699507/252585
const $1ad5549438f66e83$var$usPhoneRegexp = /((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4})/;
// Works for formatted mobile phone numbers like "078 326 86 74"
const $1ad5549438f66e83$var$swissPhoneRegexp1 = /(0[1-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2})/;
// Works for unformatted mobile phone numbers like "0783268674" and
// unformatted landline numbers like "041783268675"
const $1ad5549438f66e83$var$swissPhoneRegexp2 = /(0[0-9]{9,11})/;
const $1ad5549438f66e83$var$wwwUrlRegexp = /(www(\.[-_a-zA-Z0-9]+){2,}(\/[-_a-zA-Z0-9]+)*)/;
const $1ad5549438f66e83$var$timestampOptionalRepeaterOrDelayRegexp = /(?: (\+|\+\+|\.\+|-|--)(\d+)([hdwmy])(?:\/(\d+)([hdwmy]))?)?/;
const $1ad5549438f66e83$var$timestampRegex = new RegExp([
    /([<[])/,
    /(\d{4})-(\d{2})-(\d{2})/,
    /(?: ([^0-9\s]{1,9}))?/,
    /(?: ([012]?\d:[0-5]\d))?(?:-([012]?\d:[0-5]\d))?/,
    $1ad5549438f66e83$var$timestampOptionalRepeaterOrDelayRegexp,
    $1ad5549438f66e83$var$timestampOptionalRepeaterOrDelayRegexp,
    /[>\]]/
].map((re)=>re.source).join(''));
const $1ad5549438f66e83$var$markupAndCookieRegex = new RegExp([
    $1ad5549438f66e83$var$beginningRegexp.source,
    `(${$1ad5549438f66e83$var$timestampRegex.source}(?:--${$1ad5549438f66e83$var$timestampRegex.source})?)`,
    $1ad5549438f66e83$var$httpUrlRegexp.source,
    $1ad5549438f66e83$var$urlRegexp.source,
    $1ad5549438f66e83$var$internationalPhoneRegexp.source,
    $1ad5549438f66e83$var$usPhoneRegexp.source,
    $1ad5549438f66e83$var$swissPhoneRegexp1.source,
    $1ad5549438f66e83$var$swissPhoneRegexp2.source,
    $1ad5549438f66e83$var$wwwUrlRegexp.source
].join('|'), 'g');
// INFO: https://www.debuggex.com/ is a good tool to inspect how the
// matches work.
// console.log(markupAndCookieRegex);
const $1ad5549438f66e83$var$timestampFromRegexMatch = (match, partIndices)=>{
    const [typeBracket, year, month, day, dayName, timeStart, timeEnd, firstDelayRepeatType, firstDelayRepeatValue, firstDelayRepeatUnit, firstRepeaterDeadlineValue, firstRepeaterDeadlineUnit, secondDelayRepeatType, secondDelayRepeatValue, secondDelayRepeatUnit, secondRepeaterDeadlineValue, secondRepeaterDeadlineUnit] = partIndices.map((partIndex)=>match[partIndex]);
    if (!year) return null;
    const [startHour, startMinute] = !!timeStart ? timeStart.split(':') : [];
    const [endHour, endMinute] = !!timeEnd ? timeEnd.split(':') : [];
    let repeaterType, repeaterValue, repeaterUnit, repeaterDeadlineValue, repeaterDeadlineUnit;
    let delayType, delayValue, delayUnit;
    if ([
        '+',
        '++',
        '.+'
    ].includes(firstDelayRepeatType)) {
        repeaterType = firstDelayRepeatType;
        repeaterValue = firstDelayRepeatValue;
        repeaterUnit = firstDelayRepeatUnit;
        repeaterDeadlineValue = firstRepeaterDeadlineValue;
        repeaterDeadlineUnit = firstRepeaterDeadlineUnit;
    } else if ([
        '-',
        '--'
    ].includes(firstDelayRepeatType)) {
        delayType = firstDelayRepeatType;
        delayValue = firstDelayRepeatValue;
        delayUnit = firstDelayRepeatUnit;
    }
    if ([
        '+',
        '++',
        '.+'
    ].includes(secondDelayRepeatType)) {
        repeaterType = secondDelayRepeatType;
        repeaterValue = secondDelayRepeatValue;
        repeaterUnit = secondDelayRepeatUnit;
        repeaterDeadlineValue = secondRepeaterDeadlineValue;
        repeaterDeadlineUnit = secondRepeaterDeadlineUnit;
    } else if ([
        '-',
        '--'
    ].includes(secondDelayRepeatType)) {
        delayType = secondDelayRepeatType;
        delayValue = secondDelayRepeatValue;
        delayUnit = secondDelayRepeatUnit;
    }
    return {
        isActive: typeBracket === '<',
        year: year,
        month: month,
        day: day,
        dayName: dayName,
        startHour: startHour,
        startMinute: startMinute,
        endHour: endHour,
        endMinute: endMinute,
        repeaterType: repeaterType,
        repeaterValue: repeaterValue,
        repeaterUnit: repeaterUnit,
        delayType: delayType,
        delayValue: delayValue,
        delayUnit: delayUnit,
        repeaterDeadlineValue: repeaterDeadlineValue,
        repeaterDeadlineUnit: repeaterDeadlineUnit
    };
};
const $1ad5549438f66e83$export$4572e459442e282a = (rawText, { shouldAppendNewline: shouldAppendNewline = false } = {})=>{
    const matches = [];
    let match = $1ad5549438f66e83$var$markupAndCookieRegex.exec(rawText);
    while(match){
        if (!!match[2]) matches.push({
            type: 'link',
            rawText: match[0],
            uri: match[2],
            index: match.index
        });
        else if (!!match[3] && !!match[4]) matches.push({
            type: 'link',
            rawText: match[0],
            uri: match[3],
            title: match[4],
            index: match.index
        });
        else if (!!match[7]) {
            const percentCookieMatch = match[7].match(/(\d*)%/);
            matches.push({
                type: 'percentage-cookie',
                rawText: match[0],
                percentage: percentCookieMatch[1],
                index: match.index
            });
        } else if (!!match[8]) {
            const fractionCookieMatch = match[8].match(/(\d*)\/(\d*)/);
            matches.push({
                type: 'fraction-cookie',
                rawText: match[0],
                fraction: [
                    fractionCookieMatch[1],
                    fractionCookieMatch[2]
                ],
                index: match.index
            });
        } else if (!!match[11]) {
            const markupType = {
                '~': 'inline-code',
                '*': 'bold',
                '/': 'italic',
                '+': 'strikethrough',
                _: 'underline',
                '=': 'verbatim'
            }[match[11]];
            const markupPrefixLength = match[10].length;
            matches.push({
                type: 'inline-markup',
                rawText: match[0].substring(markupPrefixLength, match[12].length + 2 + markupPrefixLength),
                index: match.index + markupPrefixLength,
                content: match[12],
                markupType: markupType
            });
        } else if (!!match[15]) {
            const firstTimestamp = $1ad5549438f66e83$var$timestampFromRegexMatch(match, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(16, 33));
            const secondTimestamp = $1ad5549438f66e83$var$timestampFromRegexMatch(match, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(33, 50));
            matches.push({
                type: 'timestamp',
                rawText: match[0],
                index: match.index,
                firstTimestamp: firstTimestamp,
                secondTimestamp: secondTimestamp
            });
        } else if (!!match[50]) matches.push({
            type: 'url',
            rawText: match[0],
            index: match.index
        });
        else if (!!match[53]) matches.push({
            type: 'e-mail',
            rawText: match[0],
            index: match.index
        });
        else if (!!match[54] || !!match[56] || !!match[58] || !!match[59]) matches.push({
            type: 'phone-number',
            rawText: match[0],
            index: match.index
        });
        else if (!!match[60]) matches.push({
            type: 'www-url',
            rawText: match[0],
            index: match.index
        });
        match = $1ad5549438f66e83$var$markupAndCookieRegex.exec(rawText);
    }
    const lineParts = [];
    let startIndex = 0;
    matches.forEach((match)=>{
        let index = match.index;
        // Get the part before the first match:
        if (index !== startIndex) {
            const text = rawText.substring(startIndex, index);
            lineParts.push({
                type: 'text',
                contents: text
            });
        }
        // Get this match:
        const part = $1ad5549438f66e83$var$computeParseResults(rawText, match);
        lineParts.push(part);
        startIndex = match.index + match.rawText.length;
    });
    if (startIndex !== rawText.length || shouldAppendNewline) {
        const trailingText = rawText.substring(startIndex, rawText.length) + (shouldAppendNewline ? '\n' : '');
        lineParts.push({
            type: 'text',
            contents: trailingText
        });
    }
    return lineParts;
};
const $1ad5549438f66e83$var$computeParseResults = (rawText, match)=>{
    switch(match.type){
        case 'link':
            const linkPart = {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: 'link',
                contents: {
                    uri: match.uri
                }
            };
            if (match.title) linkPart.contents.title = match.title;
            return linkPart;
        case 'percentage-cookie':
            return {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: 'percentage-cookie',
                percentage: match.percentage
            };
        case 'fraction-cookie':
            return {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: 'fraction-cookie',
                fraction: match.fraction
            };
        case 'inline-markup':
            return {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: 'inline-markup',
                content: match.content,
                markupType: match.markupType
            };
        case 'timestamp':
            return {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: 'timestamp',
                firstTimestamp: match.firstTimestamp,
                secondTimestamp: match.secondTimestamp
            };
        case 'url':
        case 'www-url':
        case 'e-mail':
        case 'phone-number':
            return {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                type: match.type,
                content: match.rawText
            };
        default:
            throw Error('The regex parser parsed something but it is not converted to proper data structure.');
    }
};
const $1ad5549438f66e83$var$parseTable = (tableLines)=>{
    const table = {
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        type: 'table',
        contents: [
            []
        ],
        columnProperties: []
    };
    tableLines.map((line)=>line.trim()).forEach((line)=>{
        if (line.startsWith('|-')) table.contents.push([]);
        else {
            const lastRow = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).last(table.contents);
            const lineCells = line.substr(1, line.length - 2).split('|');
            if (lastRow.length === 0) lineCells.forEach((cell)=>lastRow.push(cell));
            else lineCells.forEach((cellContents, cellIndex)=>{
                lastRow[cellIndex] += `\n${cellContents}`;
            });
        }
    });
    // Parse the contents of each cell.
    table.contents = table.contents.map((row)=>({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
            contents: row.map((rawContents)=>({
                    id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                    contents: $1ad5549438f66e83$export$4572e459442e282a(rawContents, {
                        excludeCookies: true
                    }),
                    rawContents: rawContents
                }))
        }));
    // We sometimes end up with an extra, empty row - remove it if so.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).last(table.contents).contents.length === 0) table.contents = table.contents.slice(0, table.contents.length - 1);
    // Make sure each row has the same number of columns.
    const maxNumColumns = Math.max(...table.contents.map((row)=>row.contents.length));
    table.contents.forEach((row)=>{
        if (row.contents.length < maxNumColumns) (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(maxNumColumns - row.contents.length, ()=>{
            row.contents.push({
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                contents: [],
                rawContents: ''
            });
        });
    });
    return table;
};
const $1ad5549438f66e83$export$db8208116b0213ae = (rawText, { excludeContentElements: excludeContentElements = false } = {})=>{
    const lines = rawText.split('\n');
    const LIST_HEADER_REGEX = /^\s*([-+*]|(\d+(\.|\)))) (.*)/;
    let currentListHeaderNestingLevel = null;
    const rawLineParts = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).flatten(lines.map((line, lineIndex)=>{
        const numLeadingSpaces = line.match(/^( *)/)[0].length;
        if (currentListHeaderNestingLevel !== null && (numLeadingSpaces > currentListHeaderNestingLevel || !line.trim())) return [
            {
                type: 'raw-list-content',
                line: line
            }
        ];
        else {
            currentListHeaderNestingLevel = null;
            if (line.match(LIST_HEADER_REGEX) && !excludeContentElements) {
                currentListHeaderNestingLevel = numLeadingSpaces;
                return [
                    {
                        type: 'raw-list-header',
                        line: line
                    }
                ];
            } else if (line.trim().startsWith('|') && !excludeContentElements) return [
                {
                    type: 'raw-table',
                    line: line
                }
            ];
            else return $1ad5549438f66e83$export$4572e459442e282a(line, {
                shouldAppendNewline: lineIndex !== lines.length - 1,
                excludeCookies: true
            });
        }
    }));
    const processedLineParts = [];
    for(let partIndex = 0; partIndex < rawLineParts.length; ++partIndex){
        const linePart = rawLineParts[partIndex];
        if (linePart.type === 'raw-table') {
            const tableLines = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).takeWhile(rawLineParts.slice(partIndex), (part)=>part.type === 'raw-table').map((part)=>part.line);
            processedLineParts.push($1ad5549438f66e83$var$parseTable(tableLines));
            partIndex += tableLines.length - 1;
        } else if (linePart.type === 'raw-list-header') {
            const numLeadingSpaces = linePart.line.match(/^( *)/)[0].length;
            const contentLines = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).takeWhile(rawLineParts.slice(partIndex + 1), (part)=>part.type === 'raw-list-content').map((part)=>part.line).map((line)=>line.startsWith(' '.repeat(numLeadingSpaces + 2)) ? line.substr(numLeadingSpaces + 2) : line.substr(numLeadingSpaces + 1));
            if (contentLines[contentLines.length - 1] === '') contentLines[contentLines.length - 1] = ' ';
            const contents = $1ad5549438f66e83$export$db8208116b0213ae(contentLines.join('\n')).toJS();
            partIndex += contentLines.length;
            const isOrdered = !!linePart.line.match(/^\s*\d+[.)]/);
            // Remove the leading -, +, *, or number characters.
            let line = linePart.line.match(LIST_HEADER_REGEX)[4];
            let forceNumber = null;
            if (line.match(/^\s*\[@\d+\]/)) {
                forceNumber = line.match(/^\s*\[@(\d+)\]/)[1];
                line = line.replace(/^\s*\[@\d+\]\s*/, '');
            }
            let checkboxState = null;
            const isCheckbox = !!line.match(/^\s*\[[ X-]\]/);
            if (isCheckbox) {
                const stateCharacter = line.match(/^\s*\[([ X-])\]/)[1];
                checkboxState = ({
                    ' ': 'unchecked',
                    X: 'checked',
                    '-': 'partial'
                })[stateCharacter];
                line = line.replace(/^\s*\[[ X-]\]\s*/, '');
            }
            const newListItem = {
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                titleLine: $1ad5549438f66e83$export$4572e459442e282a(line),
                contents: contents,
                forceNumber: forceNumber,
                isCheckbox: isCheckbox,
                checkboxState: checkboxState
            };
            const lastIndex = processedLineParts.length - 1;
            if (lastIndex >= 0 && processedLineParts[lastIndex].type === 'list') processedLineParts[lastIndex].items.push(newListItem);
            else processedLineParts.push({
                type: 'list',
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                items: [
                    newListItem
                ],
                bulletCharacter: linePart.line.trim()[0],
                numberTerminatorCharacter: isOrdered ? linePart.line.match(/\s*\d+([.)])/)[1] : null,
                isOrdered: isOrdered
            });
        } else processedLineParts.push(linePart);
    }
    return (0, $3044e0bef3624137$exports.fromJS)(processedLineParts);
};
const $1ad5549438f66e83$export$e76afb10c2b4017f = (rawText)=>{
    const optionalSinglePlanningItemRegex = RegExp(`((DEADLINE|SCHEDULED|CLOSED):\\s*${$1ad5549438f66e83$var$asStrNoSlashs($1ad5549438f66e83$var$timestampRegex)})?`);
    // If there are any planning items, consume not more
    // than one newline after the last planning item.
    const planningRegex = $1ad5549438f66e83$var$concatRegexes(/^\s*/, optionalSinglePlanningItemRegex, /[ \t]*/, optionalSinglePlanningItemRegex, /[ \t]*/, optionalSinglePlanningItemRegex, /[ \t]*\n?/);
    const planningRegexCaptureGroupsOfType = [
        2,
        21,
        40
    ]; // depends on timestampRegex
    const planningMatch = rawText.match(planningRegex);
    const planningItems = (0, $3044e0bef3624137$exports.fromJS)(planningRegexCaptureGroupsOfType.map((planningTypeIndex)=>{
        const type = planningMatch[planningTypeIndex];
        if (!type) return null;
        const timestamp = $1ad5549438f66e83$var$timestampFromRegexMatch(planningMatch, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(planningTypeIndex + 1, planningTypeIndex + 1 + 17));
        return $1ad5549438f66e83$var$createOrUpdateTimestamp({
            type: type,
            timestamp: timestamp
        });
    }).filter((item)=>!!item));
    if (planningItems.size === 0) // If there are no matches for planning items, return the original rawText.
    return {
        planningItems: (0, $3044e0bef3624137$exports.fromJS)([]),
        strippedDescription: rawText
    };
    else {
        const remainingDescriptionWithoutPlanningItem = rawText.replace(planningRegex, '');
        return {
            planningItems: planningItems,
            strippedDescription: remainingDescriptionWithoutPlanningItem
        };
    }
};
const $1ad5549438f66e83$var$createOrUpdateTimestamp = ({ type: type, timestamp: timestamp, id: id })=>(0, $3044e0bef3624137$exports.fromJS)({
        type: type,
        timestamp: timestamp,
        id: id || (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
    });
const $1ad5549438f66e83$var$parsePropertyList = (rawText)=>{
    const lines = rawText.split('\n');
    const propertiesLineIndex = lines.findIndex((line)=>line.trim() === ':PROPERTIES:');
    const endLineIndex = lines.findIndex((line)=>line.trim() === ':END:');
    if (propertiesLineIndex === -1 || endLineIndex === -1 || !rawText.trim().startsWith(':PROPERTIES:')) return {
        propertyListItems: (0, $3044e0bef3624137$exports.List)(),
        strippedDescription: rawText
    };
    const propertyListItems = (0, $3044e0bef3624137$exports.fromJS)(lines.slice(propertiesLineIndex + 1, endLineIndex).map((line)=>{
        const match = line.match(/:([^\s]*):(?: (.*))?/);
        if (!match) return null;
        // Parse the properties value even though most values would
        // not need parsing. Only timestamps are interactive, the rest
        // will be saved as plain text.
        let value = !!match[2] ? $1ad5549438f66e83$export$4572e459442e282a(match[2]) : null;
        if (value && value[0].type !== 'timestamp') value = [
            {
                contents: match[2],
                type: 'text'
            }
        ];
        return {
            property: match[1],
            value: value,
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        };
    }).filter((result)=>!!result));
    return {
        propertyListItems: propertyListItems,
        strippedDescription: lines.slice(endLineIndex + 1).join('\n')
    };
};
const $1ad5549438f66e83$var$parseLogbook = (rawText)=>{
    const lines = rawText.split('\n');
    const logbookLineIndex = lines.findIndex((line)=>line.trim() === ':LOGBOOK:');
    const endLineIndex = lines.findIndex((line)=>line.trim() === ':END:');
    if (logbookLineIndex === -1 || endLineIndex === -1 || !rawText.trim().startsWith(':LOGBOOK:')) return {
        logBookEntries: (0, $3044e0bef3624137$exports.List)(),
        strippedDescription: rawText
    };
    const logBookEntryStartRegex = $1ad5549438f66e83$var$concatRegexes(/^CLOCK: /, $1ad5549438f66e83$var$timestampRegex, /$/);
    const logBookEntryFullRegex = $1ad5549438f66e83$var$concatRegexes(/^CLOCK: /, $1ad5549438f66e83$var$timestampRegex, '/--/', $1ad5549438f66e83$var$timestampRegex, /\s*=>\s*\S+$/);
    const logBookEntries = (0, $3044e0bef3624137$exports.fromJS)(lines.slice(logbookLineIndex + 1, endLineIndex).map((line)=>{
        const lineFullMatch = line.trim().match(logBookEntryFullRegex);
        if (lineFullMatch) return {
            start: $1ad5549438f66e83$var$timestampFromRegexMatch(lineFullMatch, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(1, 18)),
            end: $1ad5549438f66e83$var$timestampFromRegexMatch(lineFullMatch, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(18, 39)),
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        };
        const lineStartMatch = line.trim().match(logBookEntryStartRegex);
        if (lineStartMatch) return {
            start: $1ad5549438f66e83$var$timestampFromRegexMatch(lineStartMatch, (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(1, 18)),
            end: null,
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        };
        return {
            raw: line.trimLeft(),
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        };
    }));
    return {
        logBookEntries: logBookEntries,
        strippedDescription: lines.slice(endLineIndex + 1).join('\n')
    };
};
const $1ad5549438f66e83$export$f2cc323b1d315d59 = (rawText)=>{
    // Only parse log notes if a logbook exists. Otherwise, a list - log notes
    // or just a normal list - will go into the description.
    const lines = rawText.split('\n');
    const logbookLineIndex = lines.findIndex((line)=>line.trim() === ':LOGBOOK:');
    if (logbookLineIndex !== -1) return $1ad5549438f66e83$var$makeLogNotesResult(lines.slice(0, logbookLineIndex), lines.slice(logbookLineIndex));
    return $1ad5549438f66e83$var$makeLogNotesResult([], [
        rawText
    ]);
};
const $1ad5549438f66e83$export$e4e3239202b9ba49 = (rawText)=>{
    const planningItemsParse = $1ad5549438f66e83$export$e76afb10c2b4017f(rawText);
    const planningItems = planningItemsParse.planningItems;
    const propertyListParse = $1ad5549438f66e83$var$parsePropertyList(planningItemsParse.strippedDescription);
    // In Orgmode, notes are added below properties and before
    // logbook. However, logbook is added directly below properties if
    // it does not exist.
    const logNotes = $1ad5549438f66e83$export$f2cc323b1d315d59(propertyListParse.strippedDescription);
    const logBookParse = $1ad5549438f66e83$var$parseLogbook(logNotes.strippedDescription);
    return {
        planningItems: planningItems,
        propertyListItems: propertyListParse.propertyListItems,
        logNotes: logNotes.logNotes,
        logBookEntries: logBookParse.logBookEntries,
        strippedDescription: logBookParse.strippedDescription
    };
};
const $1ad5549438f66e83$export$1c435061882203a0 = (header, rawUnstrippedDescription)=>{
    const { planningItems: planningItems, propertyListItems: propertyListItems, logNotes: logNotes, logBookEntries: logBookEntries, strippedDescription: strippedDescription } = $1ad5549438f66e83$export$e4e3239202b9ba49(rawUnstrippedDescription);
    const parsedDescription = $1ad5549438f66e83$export$db8208116b0213ae(strippedDescription);
    const parsedTitle = header.getIn([
        'titleLine',
        'title'
    ]);
    const mergedPlanningItems = $1ad5549438f66e83$var$mergePlanningItems(planningItems, $1ad5549438f66e83$var$extractActiveTimestampsForPlanningItemsFromParse('TIMESTAMP_TITLE', parsedTitle), $1ad5549438f66e83$var$extractActiveTimestampsForPlanningItemsFromParse('TIMESTAMP_DESCRIPTION', parsedDescription), $1ad5549438f66e83$var$extractActiveTimestampsForPlanningItemsFromParse('TIMESTAMP_LOG_NOTES', logNotes));
    return header.set('rawDescription', strippedDescription).set('description', parsedDescription).set('planningItems', mergedPlanningItems).set('propertyListItems', propertyListItems).set('logNotes', logNotes).set('logBookEntries', logBookEntries);
};
const $1ad5549438f66e83$var$defaultKeywordSets = (0, $3044e0bef3624137$exports.fromJS)([
    {
        keywords: [
            'TODO',
            'DONE'
        ],
        completedKeywords: [
            'DONE'
        ],
        default: true
    }
]);
const $1ad5549438f66e83$export$48072ceac3aac428 = (titleLine, todoKeywordSets)=>{
    const allKeywords = todoKeywordSets.flatMap((todoKeywordSet)=>{
        return todoKeywordSet.get('keywords');
    });
    const todoKeyword = allKeywords.filter((keyword)=>titleLine.startsWith(keyword + ' ') || titleLine === keyword).first();
    let rawTitle = titleLine;
    if (todoKeyword) rawTitle = rawTitle.substr(todoKeyword.length + 1).trimStart();
    // Check for tags.
    let tags = [];
    if (rawTitle.trimRight().endsWith(':')) {
        const titleParts = rawTitle.trimRight().split(' ');
        const possibleTags = titleParts[titleParts.length - 1];
        if (/^:[^\s]+:$/.test(possibleTags)) {
            rawTitle = rawTitle.substr(0, rawTitle.length - possibleTags.length);
            tags = possibleTags.split(':').filter((tag)=>tag !== '');
        }
    }
    const title = $1ad5549438f66e83$export$4572e459442e282a(rawTitle);
    return (0, $3044e0bef3624137$exports.fromJS)({
        title: title,
        rawTitle: rawTitle,
        todoKeyword: todoKeyword,
        tags: tags
    });
};
const $1ad5549438f66e83$export$5f94661de2a01189 = (line, nestingLevel, todoKeywordSets)=>{
    if (todoKeywordSets.size === 0) todoKeywordSets = $1ad5549438f66e83$var$defaultKeywordSets;
    const titleLine = $1ad5549438f66e83$export$48072ceac3aac428(line, todoKeywordSets);
    return (0, $3044e0bef3624137$exports.fromJS)({
        titleLine: titleLine,
        rawDescription: '',
        description: [],
        opened: false,
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        nestingLevel: nestingLevel,
        planningItems: [],
        propertyListItems: [],
        logNotes: [],
        logBookEntries: []
    });
};
const $1ad5549438f66e83$var$concatRegexes = (...regexes)=>regexes.reduce((prev, curr)=>RegExp($1ad5549438f66e83$var$asStrNoSlashs(prev) + $1ad5549438f66e83$var$asStrNoSlashs(curr)));
// Converts RegExp or strings like '/regex/' to a string without these slashes.
const $1ad5549438f66e83$var$asStrNoSlashs = (regex)=>{
    const s = regex.toString();
    return s.substring(1, s.length - 1);
};
const $1ad5549438f66e83$export$c408aef82967a8ce = (rawText, todoKeywordSets)=>{
    // This function is currently only used for capture templates.
    // Hence, it's acceptable that it is opinionated on treating
    // whitespace.
    const titleLine = rawText.split('\n')[0].replace(/^\**\s*|\s*$/g, '');
    const descriptionText = rawText.split('\n').slice(1).join('\n');
    // TODO: possible addition: allow subheaders in description!
    const newHeader = $1ad5549438f66e83$export$5f94661de2a01189(titleLine, 1, todoKeywordSets);
    return $1ad5549438f66e83$export$1c435061882203a0(newHeader, descriptionText);
};
const $1ad5549438f66e83$export$1dd1002df0ea02b5 = (line)=>{
    const lowerLine = line.toLowerCase();
    return lowerLine.startsWith('#+todo: ') || lowerLine.startsWith('#+typ_todo: ') || lowerLine.startsWith('#+seq_todo: ');
};
const $1ad5549438f66e83$export$fbabeb6f13a461a5 = (line)=>{
    if (!$1ad5549438f66e83$export$1dd1002df0ea02b5(line)) return null;
    const keywordsString = line.substr(line.indexOf(':') + 2);
    const keywordTokens = keywordsString.split(/\s/);
    const keywords = keywordTokens.filter((keyword)=>keyword !== '|')// Remove fast access TODO states suffix from keyword, because
    // there's no UI to handle those in organice
    // https://orgmode.org/manual/Fast-access-to-TODO-states.html#Fast-access-to-TODO-states
    .map((keyword)=>keyword.replace(/\(.[!@]?(\/[!@])?\)$/, ''));
    const pipeIndex = keywordTokens.indexOf('|');
    const completedKeywords = pipeIndex >= 0 ? keywords.slice(pipeIndex) : [];
    return (0, $3044e0bef3624137$exports.fromJS)({
        keywords: keywords,
        completedKeywords: completedKeywords,
        configLine: line,
        default: false
    });
};
const $1ad5549438f66e83$export$5df6bc20c83fb9b0 = (lines)=>{
    let todoKeywordSets = (0, $3044e0bef3624137$exports.List)();
    let fileConfigLines = (0, $3044e0bef3624137$exports.List)();
    lines.forEach((line)=>{
        const newKeywordSet = $1ad5549438f66e83$export$fbabeb6f13a461a5(line);
        if (newKeywordSet) todoKeywordSets = todoKeywordSets.push(newKeywordSet);
        else if (line.startsWith('#+')) fileConfigLines = fileConfigLines.push(line);
    });
    if (todoKeywordSets.size === 0) todoKeywordSets = $1ad5549438f66e83$var$defaultKeywordSets;
    return {
        todoKeywordSets: todoKeywordSets,
        fileConfigLines: fileConfigLines
    };
};
const $1ad5549438f66e83$export$963b4932232d2b7e = (fileContents)=>{
    let headers = (0, $3044e0bef3624137$exports.List)();
    const lines = $1ad5549438f66e83$var$getLinesFromFileContents(fileContents);
    let linesBeforeHeadings = (0, $3044e0bef3624137$exports.List)();
    // This is the first pass over the whole file
    const { todoKeywordSets: todoKeywordSets, fileConfigLines: fileConfigLines } = $1ad5549438f66e83$export$5df6bc20c83fb9b0(lines);
    // This is the second pass over the whole file
    lines.forEach((line)=>{
        // A header has to start with at least one consecutive asterisk
        // followed by a blank
        if (line.match(/^\*+ /)) {
            const nestingLevel = $1ad5549438f66e83$var$computeNestingLevel(line);
            const title = line.substr(nestingLevel + 1);
            headers = headers.push($1ad5549438f66e83$export$5f94661de2a01189(title, nestingLevel, todoKeywordSets));
        } else if (headers.size === 0) linesBeforeHeadings = linesBeforeHeadings.push(line);
        else headers = headers.updateIn([
            headers.size - 1,
            'rawDescription'
        ], (rawDescription)=>{
            // In the beginning of the parseOrg function, the original
            // fileContent lines are split by '\n'. Therefore, the newline
            // has to be added again to the line:
            const lineToAdd = line + '\n';
            rawDescription = rawDescription ? rawDescription : '';
            return rawDescription + lineToAdd;
        });
    });
    headers = headers.map((header)=>{
        // Normally, rawDescription contains the "stripped" raw description text,
        // i.e. no log book, properties, or planning items.
        // In this case (parsing the complete org file), rawDescription contains
        // the full raw description text. Only after _updateHeaderFromDescription(),
        // the contents of rawDescription are correct.
        const description = header.get('rawDescription');
        return $1ad5549438f66e83$export$1c435061882203a0(header, description);
    });
    headers = (0, $80612bee79b4209b$export$6750f19b5bb47320)(headers);
    const activeClocks = (0, $3044e0bef3624137$exports.fromJS)(headers).filter((0, $80612bee79b4209b$export$9010d2e7e3057e30)).size;
    return (0, $3044e0bef3624137$exports.fromJS)({
        headers: headers,
        activeClocks: activeClocks,
        todoKeywordSets: todoKeywordSets,
        fileConfigLines: fileConfigLines,
        linesBeforeHeadings: linesBeforeHeadings
    });
};
const $1ad5549438f66e83$var$extractActiveTimestampsForPlanningItemsFromParse = (type, parsedData)=>{
    // planningItems only accept a single timestamp -> ignore second timestamp
    return parsedData.filter((x)=>x.get('type') === 'timestamp' && x.getIn([
            'firstTimestamp',
            'isActive'
        ])).map((x)=>$1ad5549438f66e83$var$createOrUpdateTimestamp({
            type: type,
            timestamp: x.get('firstTimestamp'),
            id: x.get('id')
        }));
};
// Merge planningItems from parsed title, description, and planning keywords.
const $1ad5549438f66e83$var$mergePlanningItems = (...planningItems)=>{
    return planningItems[0].concat(...planningItems.slice(1));
};
const $1ad5549438f66e83$export$ab9e75076ae489e3 = (planningItems, type, parsed)=>planningItems.filter((x)=>x.get('type') !== type).merge($1ad5549438f66e83$var$extractActiveTimestampsForPlanningItemsFromParse(type, parsed));
const $1ad5549438f66e83$export$cecff86f363267f8 = (header)=>{
    let items = header.get('planningItems');
    items = $1ad5549438f66e83$export$ab9e75076ae489e3(items, 'TIMESTAMP_TITLE', header.getIn([
        'titleLine',
        'title'
    ]));
    items = $1ad5549438f66e83$export$ab9e75076ae489e3(items, 'TIMESTAMP_DESCRIPTION', header.get('description'));
    items = $1ad5549438f66e83$export$ab9e75076ae489e3(items, 'TIMESTAMP_LOG_NOTES', header.get('logNotes'));
    return items;
};
const $1ad5549438f66e83$var$computeNestingLevel = (titleLineWithAsterisk)=>{
    const nestingLevel = titleLineWithAsterisk.indexOf(' ');
    if (nestingLevel === -1) return titleLineWithAsterisk.trimRight().length;
    return nestingLevel;
};
const $1ad5549438f66e83$var$getLinesFromFileContents = (fileContents)=>{
    // We expect a newline at EOF (from the last line of fileContents).
    // After split(), this results in an empty string at the last position of the
    // array => Remove that last array item.
    const lines = fileContents.split('\n');
    // Special case when last line did not end with a newline character:
    if (lines.length > 0 && lines[lines.length - 1] !== '') return lines;
    return lines.slice(0, lines.length - 1);
};
const $1ad5549438f66e83$var$makeLogNotesResult = (logNotesLines, strippedDescriptionLines)=>{
    const rawLogNotes = logNotesLines.join('\n');
    return {
        rawLogNotes: rawLogNotes,
        logNotes: $1ad5549438f66e83$export$db8208116b0213ae(rawLogNotes),
        strippedDescription: strippedDescriptionLines.join('\n')
    };
};






var $fkde6 = parcelRequire("fkde6");
const $2f905e7cf539a8bd$export$4b238655c5ca8d7b = (text, w)=>{
    return text.replace(new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, 'g'), '$1\n');
};
const $2f905e7cf539a8bd$export$32b5e5fecf41ac06 = ()=>{
    const history = (0, $fkde6.createBrowserHistory)();
    return !window.testRunner && history.location.pathname === '/' && !localStorage.authenticatedSyncService;
};



const $13082abb6c5d9476$export$f1c553d4f1a2351 = (state, action)=>{
    const { path: path, contents: contents } = action;
    const parsedFile = (0, $1ad5549438f66e83$export$963b4932232d2b7e)(contents);
    return state.setIn([
        'files',
        path,
        'headers'
    ], parsedFile.get('headers')).setIn([
        'files',
        path,
        'todoKeywordSets'
    ], parsedFile.get('todoKeywordSets')).setIn([
        'files',
        path,
        'fileConfigLines'
    ], parsedFile.get('fileConfigLines')).setIn([
        'files',
        path,
        'linesBeforeHeadings'
    ], parsedFile.get('linesBeforeHeadings')).setIn([
        'files',
        path,
        'activeClocks'
    ], parsedFile.get('activeClocks'));
};
const $13082abb6c5d9476$var$clearSearch = (state)=>state.setIn([
        'search',
        'filteredHeaders'
    ], null);
const $13082abb6c5d9476$var$openHeader = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    return state.setIn([
        'headers',
        headerIndex,
        'opened'
    ], true);
};
const $13082abb6c5d9476$var$toggleHeaderOpened = (state, action)=>{
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    const isOpened = header.get('opened');
    if (isOpened && state.get('narrowedHeaderId') === action.headerId) return state;
    if (isOpened && action.closeSubheadersRecursively) {
        const subheaderIndices = (0, $2ce140c2c56df8f2$export$d879a100d1ae9dc1)(headers, action.headerId);
        subheaderIndices.forEach((index)=>{
            state = state.setIn([
                'headers',
                index,
                'opened'
            ], false);
        });
    }
    return state.setIn([
        'headers',
        headerIndex,
        'opened'
    ], !isOpened);
};
const $13082abb6c5d9476$var$selectHeader = (state, action)=>{
    return state.set('selectedHeaderId', action.headerId);
};
const $13082abb6c5d9476$var$selectHeaderIndex = (state, action)=>{
    return state.set('selectedHeaderIndex', action.headerIndex);
};
const $13082abb6c5d9476$var$openParentsOfHeader = (state, action)=>{
    let headers = state.get('headers');
    const { headerId: headerId } = action;
    let parentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, headerId);
    while(!!parentHeaderId){
        const parentHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, parentHeaderId);
        headers = headers.setIn([
            parentHeaderIndex,
            'opened'
        ], true);
        parentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, parentHeaderId);
    }
    return state.set('headers', headers);
};
const $13082abb6c5d9476$var$updateCookiesInAttributedStringWithChildCompletionStates = (parts, completionStates)=>{
    const doneCount = completionStates.filter((isDone)=>isDone).length;
    const totalCount = completionStates.length;
    return parts.map((part)=>{
        switch(part.get('type')){
            case 'fraction-cookie':
                return part.set('fraction', (0, $3044e0bef3624137$exports.List)([
                    doneCount,
                    totalCount
                ]));
            case 'percentage-cookie':
                return part.set('percentage', Math.floor(doneCount / totalCount * 100));
            default:
                return part;
        }
    });
};
const $13082abb6c5d9476$var$updateCookiesOfHeaderWithId = (file, headerId)=>{
    const headers = file.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, headerId);
    const directChildren = [];
    for(let i = 0; i < subheaders.size; ++i){
        const subheader = subheaders.get(i);
        directChildren.push(subheader);
        const subheaderSubheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, subheader.get('id'));
        i += subheaderSubheaders.size;
    }
    let completionStates = directChildren.map((header)=>header.getIn([
            'titleLine',
            'todoKeyword'
        ])).filter((todoKeyword)=>!!todoKeyword).map((todoKeyword)=>(0, $2ce140c2c56df8f2$export$2775d13f49f665b)(file.get('todoKeywordSets'), todoKeyword).get('completedKeywords').contains(todoKeyword));
    // If there are no headers with possible completion states, check for plain lists instead.
    if (completionStates.length === 0) completionStates = headers.get(headerIndex).get('description').filter((part)=>part.get('type') === 'list').flatMap((listPart)=>listPart.get('items')).filter((item)=>item.get('isCheckbox')).map((item)=>item.get('checkboxState') === 'checked').toJS();
    return file.updateIn([
        'headers',
        headerIndex,
        'titleLine',
        'title'
    ], (title)=>$13082abb6c5d9476$var$updateCookiesInAttributedStringWithChildCompletionStates(title, completionStates)).updateIn([
        'headers',
        headerIndex,
        'titleLine'
    ], (titleLine)=>titleLine.set('rawTitle', (0, $500d38b948046618$export$2c44f25459bb5dc7)(titleLine.get('title'))));
};
const $13082abb6c5d9476$var$updateCookiesOfParentOfHeaderWithId = (file, headerId)=>{
    const parentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(file.get('headers'), headerId);
    if (!parentHeaderId) return file;
    return $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(file, parentHeaderId);
};
const $13082abb6c5d9476$var$advanceTodoState = (state, action)=>{
    const { headerId: headerId, logIntoDrawer: logIntoDrawer, timestamp: timestamp } = action;
    const existingHeaderId = headerId || state.get('selectedHeaderId');
    if (!existingHeaderId) return state;
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, existingHeaderId);
    const currentTodoState = header.getIn([
        'titleLine',
        'todoKeyword'
    ]);
    const currentTodoSet = (0, $2ce140c2c56df8f2$export$2775d13f49f665b)(state.get('todoKeywordSets'), currentTodoState);
    const currentStateIndex = currentTodoSet.get('keywords').indexOf(currentTodoState);
    const newStateIndex = currentStateIndex + 1;
    const newTodoState = currentTodoSet.get('keywords').get(newStateIndex) || '';
    const indexedPlanningItemsWithRepeaters = header.get('planningItems').map((planningItem, index)=>[
            planningItem,
            index
        ]).filter(([planningItem])=>!!planningItem.getIn([
            'timestamp',
            'repeaterType'
        ]));
    state = $13082abb6c5d9476$var$updateHeadlines({
        currentTodoSet: currentTodoSet,
        newTodoState: newTodoState,
        indexedPlanningItemsWithRepeaters: indexedPlanningItemsWithRepeaters,
        state: state,
        headerIndex: headerIndex,
        currentTodoState: currentTodoState,
        logIntoDrawer: logIntoDrawer,
        timestamp: timestamp
    });
    state = $13082abb6c5d9476$var$updateCookiesOfParentOfHeaderWithId(state, existingHeaderId);
    return state;
};
const $13082abb6c5d9476$var$setTodoState = (state, action)=>{
    const { headerId: headerId, logIntoDrawer: logIntoDrawer, newTodoState: newTodoState, timestamp: timestamp } = action;
    const existingHeaderId = headerId || state.get('selectedHeaderId');
    if (!existingHeaderId) return state;
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, existingHeaderId);
    const currentTodoState = header.getIn([
        'titleLine',
        'todoKeyword'
    ]);
    const currentTodoSet = (0, $2ce140c2c56df8f2$export$2775d13f49f665b)(state.get('todoKeywordSets'), currentTodoState);
    const newTodoSet = (0, $2ce140c2c56df8f2$export$2775d13f49f665b)(state.get('todoKeywordSets'), newTodoState);
    const isInSameTodoSet = currentTodoSet === newTodoSet;
    if (isInSameTodoSet) {
        const indexedPlanningItemsWithRepeaters = header.get('planningItems').map((planningItem, index)=>[
                planningItem,
                index
            ]).filter(([planningItem])=>!!planningItem.getIn([
                'timestamp',
                'repeaterType'
            ]));
        state = $13082abb6c5d9476$var$updateHeadlines({
            currentTodoSet: currentTodoSet,
            newTodoState: newTodoState,
            indexedPlanningItemsWithRepeaters: indexedPlanningItemsWithRepeaters,
            state: state,
            headerIndex: headerIndex,
            currentTodoState: currentTodoState,
            logIntoDrawer: logIntoDrawer,
            timestamp: timestamp
        });
    } else state = state.setIn([
        'headers',
        headerIndex,
        'titleLine',
        'todoKeyword'
    ], newTodoState);
    state = $13082abb6c5d9476$var$updateCookiesOfParentOfHeaderWithId(state, existingHeaderId);
    return state;
};
const $13082abb6c5d9476$var$enterEditMode = (state, action)=>state.set('editMode', action.editModeType);
const $13082abb6c5d9476$var$exitEditMode = (state)=>state.set('editMode', null);
const $13082abb6c5d9476$var$updateHeaderTitle = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const todoKeywordSets = state.get('todoKeywordSets');
    const newTitleLine = (0, $1ad5549438f66e83$export$48072ceac3aac428)(action.newRawTitle.trim(), todoKeywordSets);
    state = state.setIn([
        'headers',
        headerIndex,
        'titleLine'
    ], newTitleLine);
    state = state.updateIn([
        'headers',
        headerIndex,
        'planningItems'
    ], (planningItems)=>(0, $1ad5549438f66e83$export$ab9e75076ae489e3)(planningItems, 'TIMESTAMP_TITLE', newTitleLine.get('title')));
    return $13082abb6c5d9476$var$updateCookiesOfParentOfHeaderWithId(state, action.headerId);
};
const $13082abb6c5d9476$var$updateHeaderDescription = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    return state.updateIn([
        'headers',
        headerIndex
    ], (header)=>(0, $1ad5549438f66e83$export$1c435061882203a0)(header, action.newRawDescription));
};
const $13082abb6c5d9476$var$addHeader = (state, action)=>{
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    const todoKeyword = header.getIn([
        'titleLine',
        'todoKeyword'
    ]);
    const newHeader = (0, $1ad5549438f66e83$export$5f94661de2a01189)(todoKeyword ? todoKeyword + ' ' : '', header.get('nestingLevel'), state.get('todoKeywordSets'));
    if (action.headerId === state.get('narrowedHeaderId')) state = state.set('narrowedHeaderId', null);
    return state.update('headers', (headers)=>headers.insert(headerIndex + subheaders.size + 1, newHeader));
};
const $13082abb6c5d9476$var$duplicateHeader = (state, action)=>{
    const headers = state.get('headers');
    const { header: originalHeader, headerIndex: originalHeaderIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    if (!originalHeader) return state;
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    const headersToClone = [
        originalHeader
    ].concat(subheaders.toJS());
    const clonedHeaders = headersToClone.map((header)=>{
        // Deep clone and generate new ID
        return (0, $3044e0bef3624137$exports.fromJS)(header).set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)());
    });
    return state.update('headers', (headers)=>headers.splice(originalHeaderIndex + subheaders.size + 1, 0, ...clonedHeaders));
};
const $13082abb6c5d9476$var$createFirstHeader = (state)=>{
    let newHeader = (0, $1ad5549438f66e83$export$5f94661de2a01189)('First header', 1, state.get('todoKeywordSets'));
    let description = 'Extend the file from here';
    if (state.get('linesBeforeHeadings').size > 0) {
        description = state.get('linesBeforeHeadings').toJS().join('\n');
        state = state.set('linesBeforeHeadings', (0, $3044e0bef3624137$exports.List)());
    }
    newHeader = (0, $1ad5549438f66e83$export$1c435061882203a0)(newHeader, description);
    return state.update('headers', (headers)=>headers.insert(0, newHeader));
};
const $13082abb6c5d9476$var$selectNextSiblingHeader = (state, action)=>{
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    const nextSibling = headers.get(headerIndex + subheaders.size + 1);
    if (!nextSibling || nextSibling.get('nestingLevel') !== header.get('nestingLevel')) return state;
    return state.set('selectedHeaderId', nextSibling.get('id'));
};
const $13082abb6c5d9476$var$selectNextVisibleHeader = (state)=>{
    const headers = state.get('headers');
    if (state.get('selectedHeaderId') === undefined) return state.set('selectedHeaderId', headers.getIn([
        0,
        'id'
    ]));
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, state.get('selectedHeaderId'));
    const nextVisibleHeader = (0, $2ce140c2c56df8f2$export$a960808ab77a8018)(headers, headerIndex);
    if (!nextVisibleHeader) return state;
    return state.set('selectedHeaderId', nextVisibleHeader.get('id'));
};
const $13082abb6c5d9476$var$selectPreviousVisibleHeader = (state)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, state.get('selectedHeaderId'));
    const previousVisibleHeader = (0, $2ce140c2c56df8f2$export$642b816205fa205f)(headers, headerIndex);
    if (!previousVisibleHeader) return state;
    return state.set('selectedHeaderId', previousVisibleHeader.get('id'));
};
const $13082abb6c5d9476$var$removeHeader = (state, action)=>{
    let headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    const numHeadersToRemove = 1 + subheaders.size;
    const parentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, action.headerId);
    (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(numHeadersToRemove).forEach(()=>{
        headers = headers.delete(headerIndex);
    });
    if (action.headerId === state.get('narrowedHeaderId')) state = state.set('narrowedHeaderId', null);
    state = state.set('headers', headers);
    if (parentHeaderId) state = $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(state, parentHeaderId);
    return state;
};
const $13082abb6c5d9476$var$moveHeaderUp = (state, action)=>{
    let headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const previousSiblingIndex = (0, $2ce140c2c56df8f2$export$b315472b90440d4b)(headers, headerIndex);
    if (previousSiblingIndex === null) return state;
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(1 + subheaders.size).forEach(()=>{
        headers = headers.insert(previousSiblingIndex, headers.get(headerIndex + subheaders.size));
        headers = headers.delete(headerIndex + subheaders.size + 1);
    });
    return state.set('headers', headers);
};
const $13082abb6c5d9476$var$moveHeaderDown = (state, action)=>{
    let headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    const nextSiblingIndex = headerIndex + subheaders.size + 1;
    const nextSibling = headers.get(nextSiblingIndex);
    if (!nextSibling || nextSibling.get('nestingLevel') < header.get('nestingLevel')) return state;
    const nextSiblingSubheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, nextSibling.get('id'));
    (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).times(1 + nextSiblingSubheaders.size).forEach(()=>{
        headers = headers.insert(headerIndex, headers.get(nextSiblingIndex + nextSiblingSubheaders.size));
        headers = headers.delete(nextSiblingIndex + nextSiblingSubheaders.size + 1);
    });
    return state.set('headers', headers);
};
const $13082abb6c5d9476$var$moveHeaderToPosition = (state, action)=>{
    let headers = state.get('headers');
    const { sourceHeaderId: sourceHeaderId, targetHeaderId: targetHeaderId, position: position } = action;
    if (!sourceHeaderId || !targetHeaderId || sourceHeaderId === targetHeaderId) return state;
    const sourceHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, sourceHeaderId);
    const targetHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, targetHeaderId);
    if (sourceHeaderIndex < 0 || targetHeaderIndex < 0) return state;
    const sourceSubheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, sourceHeaderId);
    const sourceTreeSize = 1 + sourceSubheaders.size;
    const sourceTreeEndIndex = sourceHeaderIndex + sourceTreeSize - 1;
    if (targetHeaderIndex >= sourceHeaderIndex && targetHeaderIndex <= sourceTreeEndIndex) return state;
    const sourceTree = headers.slice(sourceHeaderIndex, sourceHeaderIndex + sourceTreeSize);
    headers = headers.splice(sourceHeaderIndex, sourceTreeSize);
    let insertionTargetIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, targetHeaderId);
    if (insertionTargetIndex < 0) return state;
    if (position === 'after') {
        const targetSubheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, targetHeaderId);
        insertionTargetIndex += 1 + targetSubheaders.size;
    }
    headers = headers.splice(insertionTargetIndex, 0, ...sourceTree.toArray());
    return state.set('headers', headers);
};
const $13082abb6c5d9476$var$moveHeaderLeft = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const previousParentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, action.headerId);
    state = $13082abb6c5d9476$var$shiftTreeNestingLevel({
        state: state,
        headerIndex: headerIndex
    }, '-');
    state = $13082abb6c5d9476$var$updateCookies(state, previousParentHeaderId, action);
    return state;
};
const $13082abb6c5d9476$var$moveHeaderRight = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const previousParentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, action.headerId);
    state = $13082abb6c5d9476$var$shiftTreeNestingLevel({
        state: state,
        headerIndex: headerIndex
    }, '+');
    state = (0, $2ce140c2c56df8f2$export$3aff284a03c3dab2)(state, action.headerId);
    state = $13082abb6c5d9476$var$updateCookies(state, previousParentHeaderId, action);
    return state;
};
const $13082abb6c5d9476$var$moveSubtreeLeft = (state, action)=>{
    const headers = state.get('headers');
    const { header: header, headerIndex: headerIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(headers, action.headerId);
    const previousParentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, action.headerId);
    if (header.get('nestingLevel') === 1) return state;
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    state = $13082abb6c5d9476$var$shiftTreeNestingLevel({
        state: state,
        headerIndex: headerIndex,
        subheaders: subheaders
    }, '-');
    state = $13082abb6c5d9476$var$updateCookies(state, previousParentHeaderId, action);
    return state;
};
const $13082abb6c5d9476$var$moveSubtreeRight = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    const previousParentHeaderId = (0, $2ce140c2c56df8f2$export$ef31029008f7a87f)(headers, action.headerId);
    const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers, action.headerId);
    state = $13082abb6c5d9476$var$shiftTreeNestingLevel({
        state: state,
        headerIndex: headerIndex,
        subheaders: subheaders
    }, '+');
    state = $13082abb6c5d9476$var$updateCookies(state, previousParentHeaderId, action);
    return (0, $2ce140c2c56df8f2$export$3aff284a03c3dab2)(state, action.headerId);
};
/**
 * Move an item in immutablejs Lists.
 * @param {list} List
 * @param {integer} fromIndex
 * @param {integer} toIndex
 * @param {any} integer
 */ const $13082abb6c5d9476$var$moveItemInFile = ({ fromList: fromList, fromIndex: fromIndex, toIndex: toIndex, item: item })=>{
    const targetItem = fromList.get(toIndex);
    fromList = fromList.delete(fromIndex);
    const targetIndex = fromList.indexOf(targetItem);
    fromList = fromList.insert(targetIndex + 1, item);
    return [
        fromList,
        fromList
    ];
};
const $13082abb6c5d9476$var$moveItemAcrossFiles = ({ fromList: fromList, fromIndex: fromIndex, toList: toList, toIndex: toIndex, item: item })=>{
    const targetItem = toList.get(toIndex);
    fromList = fromList.delete(fromIndex);
    const targetIndex = toList.indexOf(targetItem);
    toList = toList.insert(targetIndex + 1, item);
    return [
        fromList,
        toList
    ];
};
const $13082abb6c5d9476$var$refileSubtree = (state, action)=>{
    const { sourcePath: sourcePath, sourceHeaderId: sourceHeaderId, targetPath: targetPath, targetHeaderId: targetHeaderId } = action;
    const moveItem = sourcePath === targetPath ? $13082abb6c5d9476$var$moveItemInFile : $13082abb6c5d9476$var$moveItemAcrossFiles;
    let sourceHeaders = state.getIn([
        'files',
        sourcePath,
        'headers'
    ]);
    let targetHeaders = state.getIn([
        'files',
        targetPath,
        'headers'
    ]);
    let { header: sourceHeader, headerIndex: sourceHeaderIndex } = (0, $2ce140c2c56df8f2$export$f47efee791012c28)(sourceHeaders, sourceHeaderId);
    let targetHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(targetHeaders, targetHeaderId);
    let subheadersOfSourceHeader = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(sourceHeaders, sourceHeaderId);
    const nestingLevelSource = sourceHeaders.getIn([
        sourceHeaderIndex,
        'nestingLevel'
    ]);
    const nestingLevelTarget = targetHeaders.getIn([
        targetHeaderIndex,
        'nestingLevel'
    ]);
    // Indent the newly placed sourceheader so that it fits underneath the targetHeader
    sourceHeader = sourceHeader.set('nestingLevel', nestingLevelTarget + 1);
    // Put the sourceHeader into the right slot after the targetHeader
    [sourceHeaders, targetHeaders] = moveItem({
        fromList: sourceHeaders,
        fromIndex: sourceHeaderIndex,
        toList: targetHeaders,
        toIndex: targetHeaderIndex,
        item: sourceHeader
    });
    // Put the subheaders of the sourceHeader right after
    subheadersOfSourceHeader.forEach((subheader, index)=>{
        subheader = subheader.set('nestingLevel', // target
        // 1
        //   source
        //   2 (1)
        //     subheader
        //      3 (2)
        //       subheader
        //       4 (3)
        subheader.get('nestingLevel') - nestingLevelSource + nestingLevelTarget + 1);
        const fromIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(sourceHeaders, subheader.get('id'));
        targetHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(targetHeaders, targetHeaderId);
        const toIndex = targetHeaderIndex + index + 1;
        [sourceHeaders, targetHeaders] = moveItem({
            fromList: sourceHeaders,
            fromIndex: fromIndex,
            toList: targetHeaders,
            toIndex: toIndex,
            item: subheader
        });
    });
    state = state.setIn([
        'files',
        sourcePath,
        'headers'
    ], sourceHeaders);
    state = state.setIn([
        'files',
        targetPath,
        'headers'
    ], targetHeaders);
    state = state.updateIn([
        'files',
        sourcePath
    ], (file)=>$13082abb6c5d9476$var$updateCookies(file, sourceHeaderId, action));
    state = state.updateIn([
        'files',
        targetPath
    ], (file)=>$13082abb6c5d9476$var$updateCookies(file, targetHeaderId, action));
    return state;
};
// Add a log note to the selected header. This can be any type of log
// note as defined in the Emacs Org mode variable
// `org-log-note-headings`.
const $13082abb6c5d9476$var$addNoteGeneric = (state, action)=>{
    const { noteText: noteText } = action;
    const headerId = state.get('selectedHeaderId');
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, headerId);
    return state.updateIn([
        'headers',
        headerIndex
    ], (header)=>{
        const updatedHeader = header.update('logNotes', (logNotes)=>(0, $1ad5549438f66e83$export$db8208116b0213ae)(noteText + (logNotes.isEmpty() ? '\n' : '')).concat(logNotes));
        return updatedHeader.set('planningItems', (0, $1ad5549438f66e83$export$cecff86f363267f8)(updatedHeader));
    });
};
// See Emacs Org mode `org-add-note` (C-c C-z) and variable
// `org-log-note-headings`.
const $13082abb6c5d9476$var$addNote = (state, action)=>{
    const { inputText: inputText, currentDate: currentDate } = action;
    // Wrap line at 70 characters, see Emacs `fill-column` in "Insert
    // note" window (C-c C-z)
    const wrappedInput = (0, $2f905e7cf539a8bd$export$4b238655c5ca8d7b)(inputText, 70).replace(/\n(.)/g, '\n  $1');
    // Generate note based on a template string (as defined in Emacs Org
    // mode `org-log-note-headings`):
    const timestamp = (0, $e706118dde20dbed$export$d5283c9b29c6d6d0)(currentDate, {
        isActive: false,
        withStartTime: true
    });
    const noteText = `- Note taken on ${timestamp} \\\\\n  ${wrappedInput}`;
    return $13082abb6c5d9476$var$addNoteGeneric(state, {
        noteText: noteText
    });
};
const $13082abb6c5d9476$var$narrowHeader = (state, action)=>{
    return state.set('narrowedHeaderId', action.headerId);
};
const $13082abb6c5d9476$var$widenHeader = (state)=>state.set('narrowedHeaderId', null);
const $13082abb6c5d9476$var$applyOpennessState = (state, action)=>{
    const { path: path } = action;
    const opennessState = state.get('opennessState');
    if (!opennessState) return state;
    const fileOpennessState = opennessState.get(path);
    if (!fileOpennessState || fileOpennessState.size === 0) return state;
    let headers = state.getIn([
        'files',
        path,
        'headers'
    ]);
    fileOpennessState.forEach((openHeaderPath)=>{
        headers = (0, $2ce140c2c56df8f2$export$d5d9afe6a5747ace)(headers, openHeaderPath);
    });
    return state.setIn([
        'files',
        path,
        'headers'
    ], headers);
};
const $13082abb6c5d9476$var$setOpennessState = (state, action)=>{
    const { path: path, opennessState: opennessState } = action;
    return state.setIn([
        'opennessState',
        path
    ], (0, $3044e0bef3624137$exports.fromJS)(opennessState));
};
const $13082abb6c5d9476$var$setDirty = (state, action)=>state.set('isDirty', action.isDirty);
const $13082abb6c5d9476$var$setSelectedTableId = (state, action)=>state.set('selectedTableId', action.tableId);
const $13082abb6c5d9476$var$setSelectedDescriptionItemIndex = (state, action)=>state.set('selectedDescriptionItemIndex', action.itemIndex);
const $13082abb6c5d9476$var$setSelectedTableCellId = (state, action)=>state.set('selectedTableCellId', action.cellId);
const $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell = (state, cellId, header = null)=>{
    const headers = state.get('headers');
    if (!header) header = (0, $2ce140c2c56df8f2$export$6bbf84700621f2e9)(headers, cellId);
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, header.get('id'));
    return state.updateIn([
        'headers',
        headerIndex
    ], (header)=>header.set('rawDescription', (0, $500d38b948046618$export$2c44f25459bb5dc7)(header.get('description'))));
};
const $13082abb6c5d9476$var$addNewTableRow = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (rowIndex)=>(rows)=>rows.insert(rowIndex + 1, (0, $2ce140c2c56df8f2$export$6bfdd11774525e12)(rows))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$removeTableRow = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    const containingHeader = (0, $2ce140c2c56df8f2$export$6bbf84700621f2e9)(state.get('headers'), selectedTableCellId);
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (rowIndex)=>(rows)=>rows.delete(rowIndex)));
    state = state.set('selectedTableCellId', null);
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId, containingHeader);
};
const $13082abb6c5d9476$var$addNewTableColumn = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (_rowIndex, colIndex)=>(rows)=>rows.map((row)=>row.update('contents', (contents)=>contents.insert(colIndex + 1, (0, $2ce140c2c56df8f2$export$47d4da7b3d2d7510)())))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$removeTableColumn = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    const containingHeader = (0, $2ce140c2c56df8f2$export$6bbf84700621f2e9)(state.get('headers'), selectedTableCellId);
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (_rowIndex, colIndex)=>(rows)=>rows.map((row)=>row.update('contents', (contents)=>contents.delete(colIndex)))));
    state = state.set('selectedTableCellId', null);
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId, containingHeader);
};
const $13082abb6c5d9476$var$moveTableRowDown = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (rowIndex)=>(rows)=>rowIndex + 1 === rows.size ? rows : rows.insert(rowIndex, rows.get(rowIndex + 1)).delete(rowIndex + 2)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$moveTableRowUp = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (rowIndex)=>(rows)=>rowIndex === 0 ? rows : rows.insert(rowIndex - 1, rows.get(rowIndex)).delete(rowIndex + 1)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$moveTableColumnLeft = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (_rowIndex, columnIndex)=>(rows)=>columnIndex === 0 ? rows : rows.map((row)=>row.update('contents', (contents)=>contents.size === 0 ? contents : contents.insert(columnIndex - 1, contents.get(columnIndex)).delete(columnIndex + 1)))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$moveTableColumnRight = (state)=>{
    const selectedTableCellId = state.get('selectedTableCellId');
    if (!selectedTableCellId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, selectedTableCellId, (_rowIndex, columnIndex)=>(rows)=>columnIndex + 1 >= rows.getIn([
                    0,
                    'contents'
                ]).size ? rows : rows.map((row)=>row.update('contents', (contents)=>contents.size === 0 ? contents : contents.insert(columnIndex, contents.get(columnIndex + 1)).delete(columnIndex + 2)))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, selectedTableCellId);
};
const $13082abb6c5d9476$var$updateTableCellValue = (state, action)=>{
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$9487685acf653331)(headers, action.cellId, (rowIndex, colIndex)=>(rows)=>rows.updateIn([
                    rowIndex,
                    'contents',
                    colIndex
                ], (cell)=>cell.set('rawContents', action.newValue).set('contents', (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(action.newValue, {
                        excludeCookies: true
                    }))))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingTableCell(state, action.cellId);
};
const $13082abb6c5d9476$var$insertCapture = (state, action)=>{
    const headers = state.get('headers');
    const { template: template, content: content, shouldPrepend: shouldPrepend } = action;
    const { newIndex: newIndex, nestingLevel: nestingLevel, parentHeader: parentHeader } = $13082abb6c5d9476$var$insertCapturePosition(template, headers, shouldPrepend);
    if (newIndex === undefined) // Should never happen; see comment in insertCapturePosition below.
    return state;
    const newHeader = (0, $1ad5549438f66e83$export$c408aef82967a8ce)(content, state.get('todoKeywordSets')).set('nestingLevel', nestingLevel);
    state = state.update('headers', (headers)=>headers.insert(newIndex, newHeader));
    if (parentHeader !== undefined) // We inserted the new header under a parent rather than at the top or
    // bottom of the file.
    state = $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(state, parentHeader.get('id'));
    return state;
};
const $13082abb6c5d9476$var$insertCaptureFromHeader = (state, action)=>{
    const headers = state.get('headers');
    const { template: template, header: header, shouldPrepend: shouldPrepend } = action;
    const { newIndex: newIndex, nestingLevel: nestingLevel, parentHeader: parentHeader } = $13082abb6c5d9476$var$insertCapturePosition(template, headers, shouldPrepend);
    if (newIndex === undefined) return state;
    // Take the pre-parsed header and set its nesting level
    // Ensure it has a unique ID (generate one if not present)
    let newHeader = header.set('nestingLevel', nestingLevel);
    if (!newHeader.get('id')) newHeader = newHeader.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)());
    state = state.update('headers', (headers)=>headers.insert(newIndex, newHeader));
    if (parentHeader !== undefined) // We inserted the new header under a parent rather than at the top or
    // bottom of the file.
    state = $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(state, parentHeader.get('id'));
    return state;
};
const $13082abb6c5d9476$var$insertCapturePosition = (template, headers, shouldPrepend)=>{
    const headerPaths = template.get('headerPaths');
    if (headerPaths.size === 0) {
        if (shouldPrepend) // Insert at beginning of file
        return {
            newIndex: 0,
            nestingLevel: 1
        };
        else // Insert at end of file
        return {
            newIndex: headers.size + 1,
            nestingLevel: 1
        };
    }
    const parentHeader = (0, $2ce140c2c56df8f2$export$250b3505fb888bc1)(headers, headerPaths);
    if (parentHeader == null) // No parent header found.  In theory this shouldn't happen since
    // CaptureModal already checks whether a valid targetHeader can be
    // found if headerPaths is non-empty.
    return {};
    const parentHeaderIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, parentHeader.get('id'));
    const numSubheaders = (0, $2ce140c2c56df8f2$export$463ed61f10f49ed3)(headers, parentHeader.get('id'));
    const newIndex = parentHeaderIndex + 1 + (shouldPrepend ? 0 : numSubheaders);
    const nestingLevel = parentHeader.get('nestingLevel') + 1;
    return {
        newIndex: newIndex,
        nestingLevel: nestingLevel,
        parentHeader: parentHeader
    };
};
const $13082abb6c5d9476$var$clearPendingCapture = (state)=>state.set('pendingCapture', null);
const $13082abb6c5d9476$var$updateParentListCheckboxes = (state, itemPath)=>{
    const parentListItemPath = itemPath.slice(0, itemPath.length - 4);
    const parentListItem = state.getIn(parentListItemPath);
    if (!parentListItem.get('isCheckbox')) return state;
    const childrenCheckedStates = parentListItem.get('contents').filter((part)=>part.get('type') === 'list').flatMap((listPart)=>listPart.get('items').filter((item)=>item.get('isCheckbox')).map((checkboxItem)=>checkboxItem.get('checkboxState')));
    if (childrenCheckedStates.every((state)=>state === 'checked')) state = state.setIn(parentListItemPath.concat([
        'checkboxState'
    ]), 'checked');
    else if (childrenCheckedStates.every((state)=>state === 'unchecked')) state = state.setIn(parentListItemPath.concat([
        'checkboxState'
    ]), 'unchecked');
    else state = state.setIn(parentListItemPath.concat([
        'checkboxState'
    ]), 'partial');
    const childCompletionStates = childrenCheckedStates.map((state)=>{
        switch(state){
            case 'checked':
                return true;
            case 'unchecked':
                return false;
            case 'partial':
                return false;
            default:
                return false;
        }
    }).toJS();
    state = state.updateIn(parentListItemPath.concat('titleLine'), (titleLine)=>$13082abb6c5d9476$var$updateCookiesInAttributedStringWithChildCompletionStates(titleLine, childCompletionStates));
    return $13082abb6c5d9476$var$updateParentListCheckboxes(state, parentListItemPath);
};
const $13082abb6c5d9476$var$advanceCheckboxState = (state, action)=>{
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), action.listItemId);
    const { path: path, listItemPart: listItemPart } = pathAndPart;
    const hasDirectCheckboxChildren = listItemPart.get('contents').filter((part)=>part.get('type') === 'list').some((listPart)=>listPart.get('items').some((item)=>item.get('isCheckbox')));
    if (hasDirectCheckboxChildren) return state;
    const newCheckboxState = {
        checked: 'unchecked',
        unchecked: 'checked',
        partial: 'unchecked'
    }[listItemPart.get('checkboxState')];
    state = state.setIn([
        'headers'
    ].concat(path).concat([
        'checkboxState'
    ]), newCheckboxState);
    state = $13082abb6c5d9476$var$updateParentListCheckboxes(state, [
        'headers'
    ].concat(path));
    const headerIndex = path[0];
    state = $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(state, state.getIn([
        'headers',
        headerIndex,
        'id'
    ]));
    state = state.updateIn([
        'headers',
        headerIndex
    ], (header)=>header.set('rawDescription', (0, $500d38b948046618$export$2c44f25459bb5dc7)(header.get('description'))));
    return state;
};
const $13082abb6c5d9476$var$setSelectedListItemId = (state, action)=>state.set('selectedListItemId', action.listItemId);
const $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem = (state, listItemId, header = null)=>{
    let headerIndex = -1;
    const headers = state.get('headers');
    if (!header) {
        const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(headers, listItemId);
        headerIndex = pathAndPart.path[0];
    } else headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, header.get('id'));
    if (headerIndex >= 0) return state.updateIn([
        'headers',
        headerIndex
    ], (header)=>header.set('rawDescription', (0, $500d38b948046618$export$2c44f25459bb5dc7)(header.get('description'))));
    else return state;
};
const $13082abb6c5d9476$var$updateListTitleValue = (state, action)=>{
    const selectedListItemId = action.listItemId;
    if (!selectedListItemId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>items.updateIn([
                    itemIndex
                ], (item)=>item.set('titleLine', (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(action.newValue))))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$updateListContentsValue = (state, action)=>{
    const selectedListItemId = action.listItemId;
    if (!selectedListItemId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>items.updateIn([
                    itemIndex
                ], (item)=>item.set('contents', (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$db8208116b0213ae)(action.newValue))))));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$addNewListItem = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    let newItem = (0, $2ce140c2c56df8f2$export$532acb76fbba39ec)();
    if (pathAndPart.listItemPart.get('isCheckbox')) newItem = newItem.set('isCheckbox', true).set('checkboxState', 'unchecked');
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>items.insert(itemIndex + 1, newItem)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$selectNextSiblingListItem = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    let { path: path } = pathAndPart;
    path[path.length - 1] = path[path.length - 1] + 1;
    state = state.set('selectedListItemId', state.getIn([
        'headers'
    ].concat(path).concat('id')));
    return state;
};
const $13082abb6c5d9476$var$removeListItem = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const containingHeader = (0, $2ce140c2c56df8f2$export$7e65e54aa094efde)(state.get('headers'), selectedListItemId);
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>items.delete(itemIndex)));
    state = state.set('selectedListItemId', null);
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId, containingHeader);
};
const $13082abb6c5d9476$var$moveListItemUp = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>itemIndex === 0 ? items : items.insert(itemIndex - 1, items.get(itemIndex)).delete(itemIndex + 1)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$moveListItemDown = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>itemIndex + 1 === items.size ? items : items.insert(itemIndex, items.get(itemIndex + 1)).delete(itemIndex + 2)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$moveListItemLeft = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    const hasChildrenItem = pathAndPart.listItemPart.get('contents').filter((part)=>part.get('type') === 'list').some((listPart)=>listPart.get('items').size > 0);
    if (hasChildrenItem) return state;
    return $13082abb6c5d9476$var$moveListSubtreeLeft(state);
};
const $13082abb6c5d9476$var$moveListItemRight = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    let { path: path, listItemPart: selectedListItem } = pathAndPart;
    const listPart = state.getIn([
        'headers'
    ].concat(path.slice(0, path.length - 2)));
    const prevSiblingItemIndex = path[path.length - 1] - 1;
    if (prevSiblingItemIndex < 0) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>items.delete(itemIndex)));
    const prevSiblingItemContentsPath = [
        'headers'
    ].concat(path.slice(0, path.length - 1)).concat(prevSiblingItemIndex).concat('contents');
    const childrenListParts = selectedListItem.get('contents').filter((part)=>part.get('type') === 'list');
    selectedListItem = selectedListItem.update('contents', (contents)=>contents.filter((part)=>part.get('type') !== 'list'));
    state = state.updateIn(prevSiblingItemContentsPath, (contents)=>(0, $2ce140c2c56df8f2$export$542d59a95b02bd6f)(contents, selectedListItem, listPart));
    childrenListParts.map((listPart)=>listPart.get('items').forEach((item)=>{
            state = state.updateIn(prevSiblingItemContentsPath, (contents)=>(0, $2ce140c2c56df8f2$export$542d59a95b02bd6f)(contents, item, listPart));
        }));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$moveListSubtreeLeft = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    let { path: path, listItemPart: selectedListItem } = pathAndPart;
    const selectedListItemIndex = path[path.length - 1];
    if (path.filter((partOfPath)=>partOfPath === 'items').length < 2) return state;
    const parentListItem = (0, $2ce140c2c56df8f2$export$db600c451336e49b)(state.getIn([
        'headers'
    ]), selectedListItemId);
    parentListItem.get('contents').filter((part)=>part.get('type') === 'list').map((listPart)=>listPart.get('items').forEach((item, itemIndex)=>{
            if (itemIndex > selectedListItemIndex) selectedListItem = selectedListItem.update('contents', (contents)=>(0, $2ce140c2c56df8f2$export$542d59a95b02bd6f)(contents, item, listPart));
        }));
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, ()=>(items)=>items.filter((_item, index)=>index < selectedListItemIndex)));
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, parentListItem.get('id'), (itemIndex)=>(items)=>items.insert(itemIndex + 1, selectedListItem)));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$moveListSubtreeRight = (state)=>{
    const selectedListItemId = state.get('selectedListItemId');
    if (!selectedListItemId) return state;
    const pathAndPart = (0, $2ce140c2c56df8f2$export$ae49cfeed011a192)(state.get('headers'), selectedListItemId);
    const { path: path, listItemPart: selectedListItem } = pathAndPart;
    const listPart = state.getIn([
        'headers'
    ].concat(path.slice(0, path.length - 2)));
    const prevSiblingItemIndex = path[path.length - 1] - 1;
    if (prevSiblingItemIndex < 0) return state;
    state = state.update('headers', (headers)=>(0, $2ce140c2c56df8f2$export$daeaec57af29be9)(headers, selectedListItemId, (itemIndex)=>(items)=>itemIndex === 0 ? items : items.delete(itemIndex)));
    state = state.updateIn([
        'headers'
    ].concat(path.slice(0, path.length - 1)).concat(prevSiblingItemIndex).concat('contents'), (contents)=>(0, $2ce140c2c56df8f2$export$542d59a95b02bd6f)(contents, selectedListItem, listPart));
    return $13082abb6c5d9476$var$updateDescriptionOfHeaderContainingListItem(state, selectedListItemId);
};
const $13082abb6c5d9476$var$setLastSyncAt = (state, action)=>state.set('lastSyncAt', action.lastSyncAt);
const $13082abb6c5d9476$var$setHeaderTags = (state, action)=>{
    const headers = state.get('headers');
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(headers, action.headerId);
    if (headerIndex === -1) return state;
    return state.setIn([
        'headers',
        headerIndex,
        'titleLine',
        'tags'
    ], action.tags);
};
const $13082abb6c5d9476$var$reorderTags = (state, action)=>{
    const selectedHeaderId = state.get('selectedHeaderId');
    if (!selectedHeaderId) return state;
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), selectedHeaderId);
    return state.updateIn([
        'headers',
        headerIndex,
        'titleLine',
        'tags'
    ], (tags)=>tags.splice(action.fromIndex, 1).splice(action.toIndex, 0, tags.get(action.fromIndex)));
};
const $13082abb6c5d9476$var$reorderPropertyList = (state, action)=>{
    const headerId = action.headerId;
    if (!headerId) return state;
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), headerId);
    return state.updateIn([
        'headers',
        headerIndex,
        'propertyListItems'
    ], (propertyListItems)=>propertyListItems.splice(action.fromIndex, 1).splice(action.toIndex, 0, propertyListItems.get(action.fromIndex)));
};
const $13082abb6c5d9476$var$updateTimestampWithId = (state, action)=>{
    const pathAndPart = (0, $2ce140c2c56df8f2$export$f89d291feb963fe7)(state.get('headers'), action.timestampId);
    if (!pathAndPart) return state;
    const { path: path } = pathAndPart;
    const headerIndex = path[0];
    return state.setIn([
        'headers'
    ].concat(path), action.newTimestamp).updateIn([
        'headers',
        headerIndex
    ], (header)=>{
        const description = header.get('description');
        const title = header.getIn([
            'titleLine',
            'title'
        ]);
        return header.setIn([
            'titleLine',
            'rawTitle'
        ], (0, $500d38b948046618$export$2c44f25459bb5dc7)(title)).set('rawDescription', (0, $500d38b948046618$export$2c44f25459bb5dc7)(description)).set('planningItems', (0, $1ad5549438f66e83$export$cecff86f363267f8)(header));
    });
};
// This is for special planning items like SCHEDULED: and DEADLINE:; but not
// for normal active timestamps (which are also added to planning items).
const $13082abb6c5d9476$var$updatePlanningItemTimestamp = (state, action)=>{
    const { headerId: headerId, planningItemIndex: planningItemIndex, newTimestamp: newTimestamp } = action;
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), headerId);
    return state.setIn([
        'headers',
        headerIndex,
        'planningItems',
        planningItemIndex,
        'timestamp'
    ], newTimestamp);
};
const $13082abb6c5d9476$var$addNewPlanningItem = (state, action)=>{
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), action.headerId);
    const newPlanningItem = (0, $3044e0bef3624137$exports.fromJS)({
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        type: action.planningType,
        timestamp: (0, $e706118dde20dbed$export$84b4d45ad21bc6ff)(action.timestamp)
    });
    return state.updateIn([
        'headers',
        headerIndex,
        'planningItems'
    ], (planningItems)=>!!planningItems ? planningItems.push(newPlanningItem) : (0, $3044e0bef3624137$exports.List)([
            newPlanningItem
        ]));
};
const $13082abb6c5d9476$var$removePlanningItem = (state, action)=>{
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), action.headerId);
    const { planningItemIndex: planningItemIndex } = action;
    return state.removeIn([
        'headers',
        headerIndex,
        'planningItems',
        planningItemIndex
    ]);
};
const $13082abb6c5d9476$var$removeTimestamp = (state, action)=>{
    const { path: path } = (0, $2ce140c2c56df8f2$export$f89d291feb963fe7)(state.get('headers'), action.timestampId);
    // remove parsed timestamp
    state = state.removeIn([
        'headers',
        ...path
    ]);
    // in case this is an active timestamp, remove it from planning items.
    state = state.updateIn([
        'headers',
        path[0],
        'planningItems'
    ], (planningItems)=>planningItems.filter((item)=>item.get('id') !== action.timestampId));
    // rebuild text representation of header
    state = state.setIn([
        'headers',
        path[0],
        'titleLine',
        'rawTitle'
    ], (0, $500d38b948046618$export$2c44f25459bb5dc7)(state.getIn([
        'headers',
        path[0],
        'titleLine',
        'title'
    ])));
    state = state.setIn([
        'headers',
        path[0],
        'rawDescription'
    ], (0, $500d38b948046618$export$2c44f25459bb5dc7)(state.getIn([
        'headers',
        path[0],
        'description'
    ])));
    return state;
};
const $13082abb6c5d9476$export$30602d312260e3a = (state, action)=>{
    const headerIndex = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), action.headerId);
    return state.setIn([
        'headers',
        headerIndex,
        'propertyListItems'
    ], action.newPropertyListItems);
};
const $13082abb6c5d9476$export$e0cf4c247726959f = (state, action)=>{
    const { headerId: headerId, entryId: entryId, time: time } = action;
    const headerIdx = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), headerId);
    const entryIndex = state.getIn([
        'headers',
        headerIdx,
        'logBookEntries'
    ]).findIndex((entry)=>entry.get('id') === entryId);
    state = state.update('activeClocks', (i)=>i - 1);
    return state.setIn([
        'headers',
        headerIdx,
        'logBookEntries',
        entryIndex,
        'end'
    ], (0, $3044e0bef3624137$exports.fromJS)(time));
};
const $13082abb6c5d9476$export$f459875c7999031d = (state, action)=>{
    const { headerId: headerId, time: time } = action;
    const headerIdx = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), headerId);
    const newEntry = (0, $3044e0bef3624137$exports.fromJS)({
        id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
        start: time,
        end: null
    });
    state = state.update('activeClocks', (i)=>i + 1);
    return state.updateIn([
        'headers',
        headerIdx,
        'logBookEntries'
    ], (entries)=>!!entries ? entries.unshift(newEntry) : (0, $3044e0bef3624137$exports.List)([
            newEntry
        ]));
};
const $13082abb6c5d9476$export$e6848e05aa9ac9c3 = (state, action)=>{
    const { headerId: headerId, entryIndex: entryIndex, entryType: entryType, newTime: newTime } = action;
    const headerIdx = (0, $2ce140c2c56df8f2$export$ae033bfa76a45f2a)(state.get('headers'), headerId);
    return state.setIn([
        'headers',
        headerIdx,
        'logBookEntries',
        entryIndex,
        entryType
    ], (0, $3044e0bef3624137$exports.fromJS)(newTime));
};
const $13082abb6c5d9476$export$ac94e24c6e8885fa = (files, fileSettings, path, settingValue, includeByDefault)=>files.mapEntries(([filePath, file])=>[
            filePath,
            file.update('headers', (headers)=>{
                const fileSetting = fileSettings.find((setting)=>filePath === setting.get('path'));
                // always include the viewed file
                if (path === filePath) return headers;
                else if (fileSetting) {
                    if (fileSetting.get(settingValue)) return headers;
                    else return (0, $3044e0bef3624137$exports.List)();
                } else if (filePath.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) // never include static files
                return (0, $3044e0bef3624137$exports.List)();
                else // if no setting exists
                return includeByDefault ? headers : (0, $3044e0bef3624137$exports.List)();
            })
        ]);
const $13082abb6c5d9476$var$searchHeaders = ({ searchFilterExpr: searchFilterExpr = [], headersToSearch: headersToSearch, path: path })=>{
    let filteredHeaders;
    let nrOfHeadersToSearch = 200;
    const searchFilterFunction = (0, $2189696cf439a1f0$export$b74c33566721f70f)(searchFilterExpr);
    // search the current file first
    const headersFoundInCurrentFile = headersToSearch.get(path).filter(searchFilterFunction).take(nrOfHeadersToSearch);
    nrOfHeadersToSearch -= headersFoundInCurrentFile.count();
    filteredHeaders = (0, $3044e0bef3624137$exports.Map)().set(path, headersFoundInCurrentFile);
    // search rest of files until nrOfHeadersToDisplay results are found
    const filePathsToSearch = headersToSearch.keySeq().filter((p)=>p !== path);
    filePathsToSearch.forEach((filePath)=>{
        if (nrOfHeadersToSearch > 0) {
            const headersFoundInFile = headersToSearch.get(filePath).filter(searchFilterFunction).take(nrOfHeadersToSearch);
            nrOfHeadersToSearch -= headersFoundInFile.count();
            filteredHeaders = filteredHeaders.set(filePath, headersFoundInFile);
        }
    });
    return filteredHeaders;
};
const $13082abb6c5d9476$var$isActiveClockFilter = (clockFilter)=>clockFilter.field.timerange.type === 'point' && clockFilter.field.timerange.point.type === 'special' && clockFilter.field.timerange.point.value === 'now';
const $13082abb6c5d9476$export$21de7cfeca6a9e5b = (state, action)=>{
    const { searchFilter: searchFilter, cursorPosition: cursorPosition, context: context } = action;
    let files = state.get('files');
    state = state.asMutable();
    let searchFilterValid = true;
    let searchFilterExpr;
    try {
        searchFilterExpr = (0, (/*@__PURE__*/$parcel$interopDefault($5c14e4e12844f97a$exports))).parse(searchFilter);
        state.setIn([
            'search',
            'searchFilterExpr'
        ], searchFilterExpr);
    } catch (e) {
        // No need to print this parser exceptions. They are expected, see
        // *.grammar.pegjs. However, we don't need to update the filtered
        // headers when given an invalid search filter.
        searchFilterValid = false;
    }
    const path = state.get('path');
    const fileSettings = state.get('fileSettings');
    // Decide which files to include
    if (context === 'agenda') files = $13082abb6c5d9476$export$ac94e24c6e8885fa(files, fileSettings, path, 'includeInAgenda', false);
    else if (context === 'search') files = $13082abb6c5d9476$export$ac94e24c6e8885fa(files, fileSettings, path, 'includeInSearch', false);
    else if (context === 'task-list') files = $13082abb6c5d9476$export$ac94e24c6e8885fa(files, fileSettings, path, 'includeInTasklist', false);
    else if (context === 'refile') files = $13082abb6c5d9476$export$ac94e24c6e8885fa(files, fileSettings, path, 'includeInRefile', false);
     // there should not be another context, but if so use all files
    state.setIn([
        'search',
        'searchFilterValid'
    ], searchFilterValid);
    // Only run filter if a filter is given and parsing was successful
    if (searchFilterValid) {
        const headers = files.map((file)=>file.get('headers'));
        // show clocked times & sum if there is a clock search term
        const clockedTimeAndActiveClockFilters = searchFilterExpr.filter((f)=>f.type === 'field').filter((f)=>f.field.type === 'clock');
        const clockFilters = clockedTimeAndActiveClockFilters.filter((f)=>!$13082abb6c5d9476$var$isActiveClockFilter(f));
        // check for special case "clock:now" which searches active clocks
        const hasActiveClockFilter = clockedTimeAndActiveClockFilters.length !== clockFilters.length;
        const filterFunctions = clockFilters.map((0, $2189696cf439a1f0$export$3c27fa6f2514ec8d));
        const showClockedTimes = clockFilters.length !== 0;
        state.setIn([
            'search',
            'showClockedTimes'
        ], showClockedTimes);
        // Only search subheaders if a header is narrowed
        const narrowedHeaderId = state.getIn([
            'files',
            path,
            'narrowedHeaderId'
        ]);
        let headersToSearch;
        if (!narrowedHeaderId || context === 'refile') headersToSearch = headers;
        else headersToSearch = (0, $3044e0bef3624137$exports.Map)().set(path, (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers.get(path), narrowedHeaderId));
        if (hasActiveClockFilter) headersToSearch = headersToSearch.map((headersOfFile)=>headersOfFile.filter((0, $80612bee79b4209b$export$9010d2e7e3057e30)));
        // calculate relevant clocked times and total
        if (showClockedTimes) {
            headersToSearch = headersToSearch.map((headersOfFile)=>headersOfFile.map((header)=>header.set('totalFilteredTimeLogged', (0, $80612bee79b4209b$export$25c848a8b4ee87fe)(filterFunctions, header))));
            headersToSearch = headersToSearch.map((headersOfFile)=>(0, $80612bee79b4209b$export$35b29c171a192292)(filterFunctions, headersOfFile).filter((header)=>header.get('totalFilteredTimeLoggedRecursive') !== 0));
        }
        // perform the actual search
        let filteredHeaders = $13082abb6c5d9476$var$searchHeaders({
            searchFilterExpr: searchFilterExpr,
            headersToSearch: headersToSearch,
            path: path
        });
        if (showClockedTimes) {
            const clockedTime = filteredHeaders.map((headersOfFile)=>headersOfFile.reduce((acc, val)=>acc + val.get('totalFilteredTimeLogged'), 0)).toList().reduce((acc, val)=>acc + val, 0);
            state.setIn([
                'search',
                'clockedTime'
            ], clockedTime);
        }
        // Filter selectedHeader and its subheaders from `headers`,
        // because you don't want to refile a header to itself or to one
        // of its subheaders.
        if (context === 'refile') {
            const selectedHeaderId = state.getIn([
                'files',
                path,
                'selectedHeaderId'
            ]);
            const subheaders = (0, $2ce140c2c56df8f2$export$b3626b65e5a2fa46)(headers.get(path), selectedHeaderId);
            let filterIds = subheaders.map((s)=>s.get('id')).toJS();
            filterIds.push(selectedHeaderId);
            filteredHeaders = filteredHeaders.update(path, (headersOfFile)=>headersOfFile.filter((h)=>{
                    return !filterIds.includes(h.get('id'));
                }));
        }
        state.setIn([
            'search',
            'filteredHeaders'
        ], filteredHeaders);
    }
    state.setIn([
        'search',
        'searchFilter'
    ], searchFilter);
    let searchFilterSuggestions = [];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEmpty(searchFilter)) {
        // TODO: Currently only showing suggestions based on opened file.
        // Decide if they should be based on all files.
        const currentFile = files.get(path);
        const headersOfFile = currentFile.get('headers');
        const todoKeywords = (0, $2ce140c2c56df8f2$export$c443a8c15d9ea88)(currentFile);
        const tagNames = (0, $2ce140c2c56df8f2$export$85c08d0e36dc9b2e)(headersOfFile).toJS();
        const allProperties = (0, $2ce140c2c56df8f2$export$25128b086a978b1a)(headersOfFile).toJS();
        searchFilterSuggestions = (0, $2189696cf439a1f0$export$59f905cb673d1966)(todoKeywords, tagNames, allProperties)(searchFilterExpr, searchFilter, cursorPosition);
    }
    state.setIn([
        'search',
        'searchFilterSuggestions'
    ], searchFilterSuggestions);
    // update bookmarks to order them by 'last used'
    let bookmarks = state.getIn([
        'bookmarks',
        context
    ]);
    if (bookmarks.contains(searchFilter)) bookmarks = bookmarks.filter((x)=>x !== searchFilter).unshift(searchFilter).take(10);
    state.setIn([
        'bookmarks',
        context
    ], bookmarks);
    return state.asImmutable();
};
const $13082abb6c5d9476$var$setOrgFileErrorMessage = (state, action)=>state.set('orgFileErrorMessage', action.message);
const $13082abb6c5d9476$var$setPath = (state, action)=>state.set('path', action.path);
const $13082abb6c5d9476$var$setShowClockDisplay = (state, action)=>{
    if (action.showClockDisplay) state = state.update('headers', (0, $80612bee79b4209b$export$6750f19b5bb47320));
    return state.set('showClockDisplay', action.showClockDisplay);
};
const $13082abb6c5d9476$var$indexOfFileSettingWithId = (settings, settingId)=>settings.findIndex((setting)=>setting.get('id') === settingId);
const $13082abb6c5d9476$var$updateFileSettingFieldPathValue = (state, action)=>{
    const settingIndex = $13082abb6c5d9476$var$indexOfFileSettingWithId(state.get('fileSettings'), action.settingId);
    if (settingIndex !== -1 && action.newValue === true && (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEqual(action.fieldPath, [
        'defaultOnStartup'
    ])) return state.update('fileSettings', (settings)=>settings.map((setting, index)=>setting.set('defaultOnStartup', index === settingIndex)));
    return state.setIn([
        'fileSettings',
        settingIndex
    ].concat(action.fieldPath), action.newValue);
};
const $13082abb6c5d9476$var$reorderFileSetting = (state, action)=>state.update('fileSettings', (settings)=>settings.splice(action.fromIndex, 1).splice(action.toIndex, 0, settings.get(action.fromIndex)));
const $13082abb6c5d9476$var$deleteFileSetting = (state, action)=>{
    const settingIndex = $13082abb6c5d9476$var$indexOfFileSettingWithId(state.get('fileSettings'), action.settingId);
    return state.update('fileSettings', (settings)=>settings.delete(settingIndex));
};
const $13082abb6c5d9476$var$saveBookmark = (state, { context: context, bookmark: bookmark })=>{
    return state.updateIn([
        'bookmarks',
        context
    ], (bookmarks)=>bookmarks.filter((x)=>x !== bookmark).unshift(bookmark).take(10));
};
const $13082abb6c5d9476$var$deleteBookmark = (state, { context: context, bookmark: bookmark })=>{
    return state.updateIn([
        'bookmarks',
        context
    ], (bookmarks)=>bookmarks.filter((x)=>x !== bookmark).take(10));
};
const $13082abb6c5d9476$var$addNewFile = (state, { path: path, content: content })=>{
    const parsedFile = (0, $1ad5549438f66e83$export$963b4932232d2b7e)(content);
    return state.setIn([
        'files',
        path,
        'headers'
    ], parsedFile.get('headers')).setIn([
        'files',
        path,
        'todoKeywordSets'
    ], parsedFile.get('todoKeywordSets')).setIn([
        'files',
        path,
        'fileConfigLines'
    ], parsedFile.get('fileConfigLines')).setIn([
        'files',
        path,
        'linesBeforeHeadings'
    ], parsedFile.get('linesBeforeHeadings')).setIn([
        'files',
        path,
        'activeClocks'
    ], parsedFile.get('activeClocks')).setIn([
        'files',
        path,
        'isDirty'
    ], false);
};
const $13082abb6c5d9476$var$addNewEmptyFileSetting = (state)=>state.update('fileSettings', (settings)=>settings.push((0, $3044e0bef3624137$exports.fromJS)({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
            path: '',
            loadOnStartup: false,
            includeInAgenda: false,
            includeInSearch: false,
            includeInRefile: false,
            includeInTasklist: false
        })));
const $13082abb6c5d9476$var$restoreFileSettings = (state, action)=>{
    if (!action.newSettings) return state;
    return (0, $18ca84fc585e0c6b$export$114310e82dd282e4)(state, action.newSettings);
};
const $13082abb6c5d9476$var$reduceInFile = (state, action, path)=>(func, ...args)=>{
        return state.updateIn([
            'files',
            path
        ], (file)=>func(file ? file : (0, $3044e0bef3624137$exports.Map)(), action, ...args));
    };
const $13082abb6c5d9476$var$reducer = (state, action)=>{
    const path = state.get('path');
    const inFile = $13082abb6c5d9476$var$reduceInFile(state, action, path);
    switch(action.type){
        case 'PARSE_FILE':
            return $13082abb6c5d9476$export$f1c553d4f1a2351(state, action);
        case 'CLEAR_SEARCH':
            return $13082abb6c5d9476$var$clearSearch(state, action);
        case 'TOGGLE_HEADER_OPENED':
            return inFile($13082abb6c5d9476$var$toggleHeaderOpened);
        case 'OPEN_HEADER':
            return inFile($13082abb6c5d9476$var$openHeader);
        case 'SELECT_HEADER':
            return inFile($13082abb6c5d9476$var$selectHeader);
        case 'SELECT_HEADER_INDEX':
            return inFile($13082abb6c5d9476$var$selectHeaderIndex);
        case 'OPEN_PARENTS_OF_HEADER':
            return inFile($13082abb6c5d9476$var$openParentsOfHeader);
        case 'ADVANCE_TODO_STATE':
            return inFile($13082abb6c5d9476$var$advanceTodoState);
        case 'SET_TODO_STATE':
            return inFile($13082abb6c5d9476$var$setTodoState);
        case 'ENTER_EDIT_MODE':
            return inFile($13082abb6c5d9476$var$enterEditMode);
        case 'EXIT_EDIT_MODE':
            return inFile($13082abb6c5d9476$var$exitEditMode);
        case 'UPDATE_HEADER_TITLE':
            return inFile($13082abb6c5d9476$var$updateHeaderTitle);
        case 'UPDATE_HEADER_DESCRIPTION':
            return inFile($13082abb6c5d9476$var$updateHeaderDescription);
        case 'ADD_HEADER':
            return inFile($13082abb6c5d9476$var$addHeader);
        case 'DUPLICATE_HEADER':
            return inFile($13082abb6c5d9476$var$duplicateHeader);
        case 'CREATE_FIRST_HEADER':
            return inFile($13082abb6c5d9476$var$createFirstHeader);
        case 'SELECT_NEXT_SIBLING_HEADER':
            return inFile($13082abb6c5d9476$var$selectNextSiblingHeader);
        case 'SELECT_NEXT_VISIBLE_HEADER':
            return inFile($13082abb6c5d9476$var$selectNextVisibleHeader);
        case 'SELECT_PREVIOUS_VISIBLE_HEADER':
            return inFile($13082abb6c5d9476$var$selectPreviousVisibleHeader);
        case 'REMOVE_HEADER':
            return inFile($13082abb6c5d9476$var$removeHeader);
        case 'MOVE_HEADER_UP':
            return inFile($13082abb6c5d9476$var$moveHeaderUp);
        case 'MOVE_HEADER_DOWN':
            return inFile($13082abb6c5d9476$var$moveHeaderDown);
        case 'MOVE_HEADER_TO_POSITION':
            return inFile($13082abb6c5d9476$var$moveHeaderToPosition);
        case 'MOVE_HEADER_LEFT':
            return inFile($13082abb6c5d9476$var$moveHeaderLeft);
        case 'MOVE_HEADER_RIGHT':
            return inFile($13082abb6c5d9476$var$moveHeaderRight);
        case 'MOVE_SUBTREE_LEFT':
            return inFile($13082abb6c5d9476$var$moveSubtreeLeft);
        case 'MOVE_SUBTREE_RIGHT':
            return inFile($13082abb6c5d9476$var$moveSubtreeRight);
        case 'REFILE_SUBTREE':
            return $13082abb6c5d9476$var$refileSubtree(state, action);
        case 'HEADER_ADD_NOTE':
            return inFile($13082abb6c5d9476$var$addNote);
        case 'APPLY_OPENNESS_STATE':
            return $13082abb6c5d9476$var$applyOpennessState(state, action);
        case 'SET_OPENNESS_STATE':
            return $13082abb6c5d9476$var$setOpennessState(state, action);
        case 'SET_DIRTY':
            return action.path ? $13082abb6c5d9476$var$reduceInFile(state, action, action.path)($13082abb6c5d9476$var$setDirty) : inFile($13082abb6c5d9476$var$setDirty);
        case 'NARROW_HEADER':
            return inFile($13082abb6c5d9476$var$narrowHeader);
        case 'WIDEN_HEADER':
            return inFile($13082abb6c5d9476$var$widenHeader);
        case 'SET_SELECTED_DESCRIPTION_ITEM_INDEX':
            return inFile($13082abb6c5d9476$var$setSelectedDescriptionItemIndex);
        case 'SET_SELECTED_TABLE_ID':
            return inFile($13082abb6c5d9476$var$setSelectedTableId);
        case 'SET_SELECTED_TABLE_CELL_ID':
            return inFile($13082abb6c5d9476$var$setSelectedTableCellId);
        case 'ADD_NEW_TABLE_ROW':
            return inFile($13082abb6c5d9476$var$addNewTableRow);
        case 'REMOVE_TABLE_ROW':
            return inFile($13082abb6c5d9476$var$removeTableRow);
        case 'ADD_NEW_TABLE_COLUMN':
            return inFile($13082abb6c5d9476$var$addNewTableColumn);
        case 'REMOVE_TABLE_COLUMN':
            return inFile($13082abb6c5d9476$var$removeTableColumn);
        case 'MOVE_TABLE_ROW_DOWN':
            return inFile($13082abb6c5d9476$var$moveTableRowDown);
        case 'MOVE_TABLE_ROW_UP':
            return inFile($13082abb6c5d9476$var$moveTableRowUp);
        case 'MOVE_TABLE_COLUMN_LEFT':
            return inFile($13082abb6c5d9476$var$moveTableColumnLeft);
        case 'MOVE_TABLE_COLUMN_RIGHT':
            return inFile($13082abb6c5d9476$var$moveTableColumnRight);
        case 'UPDATE_TABLE_CELL_VALUE':
            return inFile($13082abb6c5d9476$var$updateTableCellValue);
        case 'INSERT_CAPTURE':
            return action.template.get('file') ? $13082abb6c5d9476$var$reduceInFile(state, action, action.template.get('file'))($13082abb6c5d9476$var$insertCapture) : inFile($13082abb6c5d9476$var$insertCapture);
        case 'INSERT_CAPTURE_FROM_HEADER':
            return action.template.get('file') ? $13082abb6c5d9476$var$reduceInFile(state, action, action.template.get('file'))($13082abb6c5d9476$var$insertCaptureFromHeader) : inFile($13082abb6c5d9476$var$insertCaptureFromHeader);
        case 'CLEAR_PENDING_CAPTURE':
            return $13082abb6c5d9476$var$clearPendingCapture(state, action);
        case 'ADVANCE_CHECKBOX_STATE':
            return inFile($13082abb6c5d9476$var$advanceCheckboxState);
        case 'SET_SELECTED_LIST_ITEM_ID':
            return inFile($13082abb6c5d9476$var$setSelectedListItemId);
        case 'UPDATE_LIST_TITLE_VALUE':
            return inFile($13082abb6c5d9476$var$updateListTitleValue);
        case 'UPDATE_LIST_CONTENTS_VALUE':
            return inFile($13082abb6c5d9476$var$updateListContentsValue);
        case 'ADD_NEW_LIST_ITEM':
            return inFile($13082abb6c5d9476$var$addNewListItem);
        case 'SELECT_NEXT_SIBLING_LIST_ITEM':
            return inFile($13082abb6c5d9476$var$selectNextSiblingListItem);
        case 'REMOVE_LIST_ITEM':
            return inFile($13082abb6c5d9476$var$removeListItem);
        case 'MOVE_LIST_ITEM_UP':
            return inFile($13082abb6c5d9476$var$moveListItemUp);
        case 'MOVE_LIST_ITEM_DOWN':
            return inFile($13082abb6c5d9476$var$moveListItemDown);
        case 'MOVE_LIST_ITEM_LEFT':
            return inFile($13082abb6c5d9476$var$moveListItemLeft);
        case 'MOVE_LIST_ITEM_RIGHT':
            return inFile($13082abb6c5d9476$var$moveListItemRight);
        case 'MOVE_LIST_SUBTREE_LEFT':
            return inFile($13082abb6c5d9476$var$moveListSubtreeLeft);
        case 'MOVE_LIST_SUBTREE_RIGHT':
            return inFile($13082abb6c5d9476$var$moveListSubtreeRight);
        case 'SET_LAST_SYNC_AT':
            return action.path ? $13082abb6c5d9476$var$reduceInFile(state, action, action.path)($13082abb6c5d9476$var$setLastSyncAt) : inFile($13082abb6c5d9476$var$setLastSyncAt);
        case 'SET_HEADER_TAGS':
            return inFile($13082abb6c5d9476$var$setHeaderTags);
        case 'REORDER_TAGS':
            return inFile($13082abb6c5d9476$var$reorderTags);
        case 'REORDER_PROPERTY_LIST':
            return inFile($13082abb6c5d9476$var$reorderPropertyList);
        case 'UPDATE_TIMESTAMP_WITH_ID':
            return inFile($13082abb6c5d9476$var$updateTimestampWithId);
        case 'UPDATE_PLANNING_ITEM_TIMESTAMP':
            return inFile($13082abb6c5d9476$var$updatePlanningItemTimestamp);
        case 'ADD_NEW_PLANNING_ITEM':
            return inFile($13082abb6c5d9476$var$addNewPlanningItem);
        case 'REMOVE_PLANNING_ITEM':
            return inFile($13082abb6c5d9476$var$removePlanningItem);
        case 'REMOVE_TIMESTAMP':
            return inFile($13082abb6c5d9476$var$removeTimestamp);
        case 'UPDATE_PROPERTY_LIST_ITEMS':
            return inFile($13082abb6c5d9476$export$30602d312260e3a);
        case 'SET_ORG_FILE_ERROR_MESSAGE':
            return $13082abb6c5d9476$var$setOrgFileErrorMessage(state, action);
        case 'SET_LOG_ENTRY_STOP':
            return inFile($13082abb6c5d9476$export$e0cf4c247726959f);
        case 'CREATE_LOG_ENTRY_START':
            return inFile($13082abb6c5d9476$export$f459875c7999031d);
        case 'UPDATE_LOG_ENTRY_TIME':
            return inFile($13082abb6c5d9476$export$e6848e05aa9ac9c3);
        case 'SET_SEARCH_FILTER_INFORMATION':
            return $13082abb6c5d9476$export$21de7cfeca6a9e5b(state, action);
        case 'SET_PATH':
            return $13082abb6c5d9476$var$setPath(state, action);
        case 'TOGGLE_CLOCK_DISPLAY':
            return $13082abb6c5d9476$var$setShowClockDisplay(state, action);
        case 'UPDATE_FILE_SETTING_FIELD_PATH_VALUE':
            return $13082abb6c5d9476$var$updateFileSettingFieldPathValue(state, action);
        case 'REORDER_FILE_SETTING':
            return $13082abb6c5d9476$var$reorderFileSetting(state, action);
        case 'DELETE_FILE_SETTING':
            return $13082abb6c5d9476$var$deleteFileSetting(state, action);
        case 'ADD_NEW_EMPTY_FILE_SETTING':
            return $13082abb6c5d9476$var$addNewEmptyFileSetting(state, action);
        case 'RESTORE_FILE_SETTINGS':
            return $13082abb6c5d9476$var$restoreFileSettings(state, action);
        case 'SAVE_BOOKMARK':
            return $13082abb6c5d9476$var$saveBookmark(state, action);
        case 'DELETE_BOOKMARK':
            return $13082abb6c5d9476$var$deleteBookmark(state, action);
        case 'ADD_NEW_FILE':
            return $13082abb6c5d9476$var$addNewFile(state, action);
        default:
            return state;
    }
};
var $13082abb6c5d9476$export$2e2bcd8739ae039 = (state = (0, $3044e0bef3624137$exports.Map)(), action)=>{
    const affectedFiles = $13082abb6c5d9476$export$39a2bc38700130e0(state, action);
    affectedFiles.forEach((path)=>{
        state = state.setIn([
            'files',
            path,
            'isDirty'
        ], true);
    });
    state = $13082abb6c5d9476$var$reducer(state, action);
    if (action.dirtying && state.get('showClockDisplay')) affectedFiles.forEach((path)=>{
        state = state.updateIn([
            'files',
            path,
            'headers'
        ], (0, $80612bee79b4209b$export$6750f19b5bb47320));
    });
    return state;
};
const $13082abb6c5d9476$export$39a2bc38700130e0 = (state, action)=>{
    if (action.dirtying) {
        if (action.type === 'REFILE_SUBTREE') return [
            action.sourcePath,
            action.targetPath
        ];
        else if (action.type === 'INSERT_CAPTURE' || action.type === 'INSERT_CAPTURE_FROM_HEADER') {
            const captureTarget = action.template.get('file');
            if (captureTarget) return [
                captureTarget
            ];
            else return [
                state.get('path')
            ];
        } else return [
            state.get('path')
        ];
    } else return [];
};
/**
 * Updates Headlines with the next todoKeyword `newTodoState`. Also
 * reschedules planning items with repeaters if applicable.
 * @param {any} currentTodoSet
 * @param {String} newTodoState
 * @param {any} indexedPlanningItemsWithRepeaters
 * @param {Object} state - redux state
 * @param {Number} headerIndex
 * @param {String} currentTodoState
 */ function $13082abb6c5d9476$var$updateHeadlines({ currentTodoSet: currentTodoSet, newTodoState: newTodoState, indexedPlanningItemsWithRepeaters: indexedPlanningItemsWithRepeaters, state: state, headerIndex: headerIndex, currentTodoState: currentTodoState, logIntoDrawer: logIntoDrawer, timestamp: timestamp }) {
    if (currentTodoSet.get('completedKeywords').includes(newTodoState) && indexedPlanningItemsWithRepeaters.size > 0) return $13082abb6c5d9476$var$updatePlanningItemsWithRepeaters({
        indexedPlanningItemsWithRepeaters: indexedPlanningItemsWithRepeaters,
        state: state,
        headerIndex: headerIndex,
        currentTodoSet: currentTodoSet,
        newTodoState: newTodoState,
        currentTodoState: currentTodoState,
        logIntoDrawer: logIntoDrawer,
        timestamp: timestamp
    });
    // Update simple headline (without repeaters)
    return state.setIn([
        'headers',
        headerIndex,
        'titleLine',
        'todoKeyword'
    ], newTodoState);
}
/**
 * Add a TODO state change log item either to the heading body or LOGBOOK drawer.
 *
 * @param {*} state
 * @param {*} headerIndex Index of header where the state change log item should be added.
 * @param {string} newTodoState New TODO state, e.g. DONE.
 * @param {string} currentTodoState Current TODO state, e.g. TODO or DONE.
 * @param {boolean} logIntoDrawer By default false, so add log messages as bullets into the body. If true, add into LOGBOOK drawer.
 */ function $13082abb6c5d9476$var$addTodoStateChangeLogItem(state, headerIndex, newTodoState, currentTodoState, logIntoDrawer, timestamp) {
    // This is how the TODO state change will be logged
    const inactiveTimestamp = (0, $e706118dde20dbed$export$d5283c9b29c6d6d0)(timestamp, {
        isActive: false,
        withStartTime: true
    });
    const newStateChangeLogText = `- State "${newTodoState}"       from "${currentTodoState}"       ${inactiveTimestamp}`;
    if (logIntoDrawer) {
        // Prepend this single item to the :LOGBOOK: drawer, same as org-log-into-drawer setting
        // https://www.gnu.org/software/emacs/manual/html_node/org/Tracking-TODO-state-changes.html
        const newEntry = (0, $3044e0bef3624137$exports.fromJS)({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
            raw: newStateChangeLogText
        });
        return state.updateIn([
            'headers',
            headerIndex,
            'logBookEntries'
        ], (entries)=>entries.unshift(newEntry));
    } else // When org-log-into-drawer not set, prepend state change log text to log notes
    return $13082abb6c5d9476$var$addNoteGeneric(state, {
        noteText: newStateChangeLogText
    });
}
function $13082abb6c5d9476$var$updatePlanningItemsWithRepeaters({ indexedPlanningItemsWithRepeaters: indexedPlanningItemsWithRepeaters, state: state, headerIndex: headerIndex, currentTodoSet: currentTodoSet, newTodoState: newTodoState, currentTodoState: currentTodoState, logIntoDrawer: logIntoDrawer, timestamp: timestamp }) {
    const headerId = state.getIn([
        'headers',
        headerIndex,
        'id'
    ]);
    state = $13082abb6c5d9476$var$selectHeader(state, {
        headerId: headerId
    });
    indexedPlanningItemsWithRepeaters.forEach(([planningItem, planningItemIndex])=>{
        const adjustedTimestamp = (0, $e706118dde20dbed$export$6f0394e8a403bab9)(planningItem.get('timestamp'), timestamp);
        state = state.setIn([
            'headers',
            headerIndex,
            'planningItems',
            planningItemIndex,
            'timestamp'
        ], adjustedTimestamp);
        // INFO: Active timestamps are now manually updated in place.
        // Rationale: The active timestamps in title and description are
        // added to `planningItems` on parse. Since there can be an
        // arbitrary amount of timestamps it makes sense not to have one
        // `planningItem` representing the title or the description. We
        // need to preserve the place of a timestamp in title/description
        // and we want to have it in a list of `planningItems`. So they
        // necessarily exist in more than one place. There might be a
        // cleaner solution where we store the timestamp only in one place
        // and use references to that place but I don't see any extra
        // benefit for what would be no negligible refactoring effort.
        // Scheduled / deadline timestamps on the other hand are part of
        // `rawDescription` but not of the parsed description. These
        // timestamps only exist in one place (`planningItems`) so
        // changing them there is visible and will be persisted.
        switch(planningItem.get('type')){
            case 'TIMESTAMP_TITLE':
                const titleIndex = state.getIn([
                    'headers',
                    headerIndex,
                    'titleLine',
                    'title'
                ]).findIndex((titlePart)=>planningItem.get('id') === titlePart.get('id'));
                state = state.setIn([
                    'headers',
                    headerIndex,
                    'titleLine',
                    'title',
                    titleIndex,
                    'firstTimestamp'
                ], adjustedTimestamp);
                state = state.setIn([
                    'headers',
                    headerIndex,
                    'titleLine',
                    'rawTitle'
                ], (0, $500d38b948046618$export$2c44f25459bb5dc7)(state.getIn([
                    'headers',
                    headerIndex,
                    'titleLine',
                    'title'
                ])));
                break;
            case 'TIMESTAMP_DESCRIPTION':
                const descriptionIndex = state.getIn([
                    'headers',
                    headerIndex,
                    'description'
                ]).findIndex((descriptionPart)=>planningItem.get('id') === descriptionPart.get('id'));
                state = state.setIn([
                    'headers',
                    headerIndex,
                    'description',
                    descriptionIndex,
                    'firstTimestamp'
                ], adjustedTimestamp);
                state = state.setIn([
                    'headers',
                    headerIndex,
                    'rawDescription'
                ], (0, $500d38b948046618$export$2c44f25459bb5dc7)(state.getIn([
                    'headers',
                    headerIndex,
                    'description'
                ])));
                break;
            default:
                break;
        }
    });
    state = state.setIn([
        'headers',
        headerIndex,
        'titleLine',
        'todoKeyword'
    ], currentTodoSet.get('keywords').first());
    if (!$13082abb6c5d9476$export$57385b3ba2438aba({
        state: state,
        headerIndex: headerIndex
    })) {
        const lastRepeatTimestamp = (0, $e706118dde20dbed$export$84b4d45ad21bc6ff)(timestamp, {
            isActive: false,
            withStartTime: true
        });
        const newLastRepeatValue = [
            {
                type: 'timestamp',
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
                firstTimestamp: lastRepeatTimestamp,
                secondTimestamp: null
            }
        ];
        state = state.updateIn([
            'headers',
            headerIndex,
            'propertyListItems'
        ], (propertyListItems)=>propertyListItems.some((item)=>item.get('property') === 'LAST_REPEAT') ? propertyListItems.map((item)=>item.get('property') === 'LAST_REPEAT' ? item.set('value', (0, $3044e0bef3624137$exports.fromJS)(newLastRepeatValue)) : item) : propertyListItems.push((0, $3044e0bef3624137$exports.fromJS)({
                property: 'LAST_REPEAT',
                value: newLastRepeatValue,
                id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
            })));
        state = $13082abb6c5d9476$var$addTodoStateChangeLogItem(state, headerIndex, newTodoState, currentTodoState, logIntoDrawer, timestamp);
    }
    return state;
}
function $13082abb6c5d9476$export$57385b3ba2438aba({ state: state, headerIndex: headerIndex }) {
    const startupOptNoLogRepeat = state.get('fileConfigLines').some((elt)=>elt.match(/^#\+STARTUP:.*nologrepeat.*/));
    const loggingProp = (0, $2ce140c2c56df8f2$export$5092be3f66c32d1)(state.get('headers'), headerIndex, 'LOGGING');
    return !!(startupOptNoLogRepeat || loggingProp && loggingProp.some((v)=>v.get('type') === 'text' && v.get('contents').match(/\s*nologrepeat\s*/)));
}
/**
 * Function wrapper around `updateCookiesOfHeaderWithId` and
 * `updateCookiesOfParentOfHeaderWithId`.
 */ function $13082abb6c5d9476$var$updateCookies(file, previousParentHeaderId, action) {
    file = $13082abb6c5d9476$var$updateCookiesOfHeaderWithId(file, previousParentHeaderId);
    file = $13082abb6c5d9476$var$updateCookiesOfParentOfHeaderWithId(file, action.headerId);
    return file;
}
/**
 * Helper function to calculate the new state when moving a header
 * (either with or without subheaders) to the left or right.
 * @param {Object} param0 - Current state
 * @param {Object} param0.state - Redux `state` object
 * @param {Object} param0.headerIndex - Position of relevant header object
 * @param {Object} param0.subheaders - List of subheaders of relevant header
 * @param {String} direction: Can be either '-' to move the header left
 * or '+' to move it right
 */ function $13082abb6c5d9476$var$shiftTreeNestingLevel({ state: state, headerIndex: headerIndex, subheaders: subheaders = [] }, direction = '-') {
    state = state.updateIn([
        'headers',
        headerIndex,
        'nestingLevel'
    ], calculateNestingLevel());
    subheaders.forEach((_, index)=>{
        state = state.updateIn([
            'headers',
            headerIndex + index + 1,
            'nestingLevel'
        ], calculateNestingLevel());
    });
    return state;
    function calculateNestingLevel() {
        return (nestingLevel)=>{
            if (direction === '-') // Don't move a header further to the left than the first
            // column
            return Math.max(nestingLevel - 1, 1);
            else return nestingLevel + 1;
        };
    }
}



const $def57205f21f33f8$export$3af8a27488c6f294 = (isDirty, path)=>{
    if (0, $18ca84fc585e0c6b$export$c43914e0cb16a981) {
        const filesDirty = JSON.parse(localStorage.getItem('isDirty')) || {};
        filesDirty[path] = isDirty;
        localStorage.setItem('isDirty', JSON.stringify(filesDirty));
    }
};
const $def57205f21f33f8$export$6c27afa905b55f50 = (path, contents)=>{
    if ((0, $18ca84fc585e0c6b$export$c43914e0cb16a981) && !path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) {
        let persistedFiles = JSON.parse(localStorage.getItem('persistedFiles'));
        persistedFiles = persistedFiles || {};
        localStorage.setItem('files__' + path, contents);
        persistedFiles[path] = (0, $06257fecbb2b5848$export$2e2bcd8739ae039)(new Date(), 5);
        localStorage.setItem('persistedFiles', JSON.stringify(persistedFiles));
    }
};
const $def57205f21f33f8$var$saveFunctionToDebounce = (state, path)=>{
    if ((0, $18ca84fc585e0c6b$export$c43914e0cb16a981) && !path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) {
        const persistedFiles = JSON.parse(localStorage.getItem('persistedFiles')) || {};
        const contents = (0, $500d38b948046618$export$ab94703a73fe3ce)({
            headers: state.org.present.getIn([
                'files',
                path,
                'headers'
            ]),
            linesBeforeHeadings: state.org.present.getIn([
                'files',
                path,
                'linesBeforeHeadings'
            ]),
            dontIndent: state.base.get('shouldNotIndentOnExport')
        });
        localStorage.setItem('files__' + path, contents);
        persistedFiles[path] = state.org.present.getIn([
            'files',
            path,
            'lastSyncAt'
        ]);
        localStorage.setItem('persistedFiles', JSON.stringify(persistedFiles));
    }
};
const $def57205f21f33f8$var$getDebouncedSaveFunction = ()=>(0, $1X5R2.debounce)($def57205f21f33f8$var$saveFunctionToDebounce, 3000, {
        leading: true,
        trailing: true
    });
const $def57205f21f33f8$var$debouncedSaveFunctions = {};
const $def57205f21f33f8$export$889e5a7ed78a67b3 = (state, path)=>{
    // to make sure no file is skipped when multiple files are dirty
    // a seperately debounced function is used per file
    let debouncedSaveFunction = $def57205f21f33f8$var$debouncedSaveFunctions[path];
    if (!debouncedSaveFunction) {
        $def57205f21f33f8$var$debouncedSaveFunctions[path] = $def57205f21f33f8$var$getDebouncedSaveFunction();
        debouncedSaveFunction = $def57205f21f33f8$var$debouncedSaveFunctions[path];
    }
    debouncedSaveFunction(state, path);
};
const $def57205f21f33f8$export$85176bedcdcc2b76 = (state)=>{
    if (0, $18ca84fc585e0c6b$export$c43914e0cb16a981) {
        const persistedFiles = JSON.parse(localStorage.getItem('persistedFiles')) || {};
        const isDirty = JSON.parse(localStorage.getItem('isDirty')) || {};
        Object.entries(persistedFiles).forEach(([path, lastSyncAt])=>{
            const contents = localStorage.getItem('files__' + path);
            if (contents) {
                state.org.present = state.org.present.update((org)=>(0, $13082abb6c5d9476$export$f1c553d4f1a2351)(org, {
                        path: path,
                        contents: contents
                    }));
                state.org.present = state.org.present.setIn([
                    'files',
                    path,
                    'lastSyncAt'
                ], (0, $da634cb494a596a5$export$2e2bcd8739ae039)(lastSyncAt));
                state.org.present = state.org.present.setIn([
                    'files',
                    path,
                    'isDirty'
                ], isDirty[path]);
            }
        });
    }
    return state;
};



const $d81b80734fbc24a5$export$f1c553d4f1a2351 = (path, contents)=>(dispatch)=>{
        if ((0, $18ca84fc585e0c6b$export$c43914e0cb16a981) && !path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) {
            (0, $def57205f21f33f8$export$6c27afa905b55f50)(path, contents);
            const opennessState = (0, $18ca84fc585e0c6b$export$4e3c5bbf48fdd0a8)();
            if (!!opennessState) dispatch($d81b80734fbc24a5$export$2d7d9f027d8bca74(path, opennessState[path]));
        }
        dispatch({
            type: 'PARSE_FILE',
            path: path,
            contents: contents
        });
        dispatch($d81b80734fbc24a5$export$74920e52f4af75df(path));
    };
const $d81b80734fbc24a5$export$881bc3db7e40e575 = (lastSyncAt, path)=>({
        type: 'SET_LAST_SYNC_AT',
        path: path,
        lastSyncAt: lastSyncAt
    });
const $d81b80734fbc24a5$export$407c99dd8b6a5a6a = ()=>{
    return (dispatch)=>{
        dispatch($d81b80734fbc24a5$export$47fc6071254828da());
        dispatch((0, $1780206710f3c846$export$e6889fb0929ccf91)());
        dispatch({
            type: 'CLEAR_SEARCH'
        });
        dispatch($d81b80734fbc24a5$export$1518ffc4a8ff94f2(null));
        dispatch((0, $5624140532e76935$exports.ActionCreators).clearHistory());
    };
};
const $d81b80734fbc24a5$var$getDebouncedSyncFunction = ()=>(0, $1X5R2.debounce)((dispatch, options)=>dispatch($d81b80734fbc24a5$var$doSync(options)), 3000, {
        leading: true,
        trailing: true
    });
const $d81b80734fbc24a5$var$debouncedSyncFunctions = {};
const $d81b80734fbc24a5$var$syncDebounced = (dispatch, getState, options)=>{
    // to make sure no file is skipped when multiple files are dirty
    // a seperately debounced function is used per file
    let filesToSync = [];
    if (options.path) filesToSync = [
        options.path
    ];
    else {
        // if no path is passed in, sync all dirty files
        const files = getState().org.present.get('files');
        filesToSync = files.keySeq().filter((path)=>files.getIn([
                path,
                'isDirty'
            ]));
    }
    filesToSync.forEach((path)=>{
        let debouncedSyncFunction = $d81b80734fbc24a5$var$debouncedSyncFunctions[path];
        if (!debouncedSyncFunction) {
            $d81b80734fbc24a5$var$debouncedSyncFunctions[path] = $d81b80734fbc24a5$var$getDebouncedSyncFunction();
            debouncedSyncFunction = $d81b80734fbc24a5$var$debouncedSyncFunctions[path];
        }
        debouncedSyncFunction(dispatch, (0, $QHj9z._)((0, $frurs._)({}, options), {
            path: path
        }));
    });
};
const $d81b80734fbc24a5$export$92d6409d68f0739a = (options)=>(dispatch, getState)=>{
        // Don't do anything if the browser is not online. When it gets back
        // from an offline state, a new `sync`action will be triggered then.
        if (getState().base.get('online')) {
            // If the user hits the 'sync' button, no matter if there's a sync
            // in progress or if the sync 'should' be debounced, listen to the
            // user and start a sync.
            if (options.forceAction === 'manual') {
                console.log('forcing sync');
                const files = getState().org.present.get('files');
                // sync all files on manual sync
                files.keySeq().forEach((path)=>dispatch($d81b80734fbc24a5$var$doSync((0, $QHj9z._)((0, $frurs._)({}, options), {
                        path: path
                    }))));
            } else $d81b80734fbc24a5$var$syncDebounced(dispatch, getState, options);
        }
    };
// doSync is the actual sync action synchronizing/persisting the Org
// file. When 'live sync' is enabled, there's potentially a quick
// succession of calls to 'sync' and therefore to the sync back-end
// happening. These calls need to be debounced. If there's a really
// succession of calls, only the first and last synchronization will
// happen.
// Note: This action is a redux-thunk action (because it returns a
// function). This function is defined every time it is called. Hence,
// wrapping it in `debounce` will not be good enough. Since it would
// be a new function every time, it would be called every time. The
// solution is to define an inner function `sync` outside of the
// wrapping function `syncDebounced`. This will actually debounce
// `doSync`, because the inner function `sync` will be created only
// once.
const $d81b80734fbc24a5$var$doSync = ({ forceAction: forceAction = null, successMessage: successMessage = 'Changes pushed', shouldSuppressMessages: shouldSuppressMessages = false, path: path } = {})=>(dispatch, getState)=>{
        const client = getState().syncBackend.get('client');
        const currentPath = getState().org.present.get('path');
        path = path || currentPath;
        if (!path || path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))) return;
        // Calls do `doSync` are already debounced using a timer, but on big
        // Org files or slow connections, it's still possible to have
        // concurrent requests to `doSync` which has no merit. When
        // `isLoading`, don't trigger another sync in parallel. Instead,
        // call `syncDebounced` and return immediately. This will
        // recursively enqueue the request to do a sync until the current
        // sync is finished. Since it's a debounced call, enqueueing it
        // recursively is efficient.
        // That is, unless the user manually hits the 'sync' button
        // (indicated by `forceAction === 'manual'`). Then, do what the user
        // requests.
        if (getState().base.get('isLoading').includes(path) && forceAction !== 'manual') {
            // Since there is a quick succession of debounced requests to
            // synchronize, the user likely is in a undo/redo workflow with
            // potential new changes to the Org file in between. In such a
            // situation, it is easy for the remote file to have a newer
            // `lastModifiedAt` date than the `lastSyncAt` date. Hence,
            // pushing is the right action - no need for the modal to ask the
            // user for her request to pull/push or cancel.
            dispatch($d81b80734fbc24a5$export$92d6409d68f0739a({
                forceAction: 'push'
            }));
            return;
        }
        if (!shouldSuppressMessages) dispatch((0, $1780206710f3c846$export$b75e26cdc67a486a)(`Syncing ...`));
        dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(true, path));
        dispatch($d81b80734fbc24a5$export$efc903f8ecc96b3d(null));
        client.getFileContentsAndMetadata(path).then(({ contents: contents, lastModifiedAt: lastModifiedAt })=>{
            const isDirty = getState().org.present.getIn([
                'files',
                path,
                'isDirty'
            ]);
            const lastServerModifiedAt = (0, $da634cb494a596a5$export$2e2bcd8739ae039)(lastModifiedAt);
            const lastSyncAt = getState().org.present.getIn([
                'files',
                path,
                'lastSyncAt'
            ]);
            if ((0, $4c410305d186c466$export$2e2bcd8739ae039)(lastSyncAt, lastServerModifiedAt) || forceAction === 'push') {
                if (isDirty) {
                    const contents = (0, $500d38b948046618$export$ab94703a73fe3ce)({
                        headers: getState().org.present.getIn([
                            'files',
                            path,
                            'headers'
                        ]),
                        linesBeforeHeadings: getState().org.present.getIn([
                            'files',
                            path,
                            'linesBeforeHeadings'
                        ]),
                        dontIndent: getState().base.get('shouldNotIndentOnExport')
                    });
                    client.updateFile(path, contents).then(()=>{
                        if (!shouldSuppressMessages) dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(successMessage, 2000));
                        else setTimeout(()=>dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)()), 2000);
                        dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
                        dispatch($d81b80734fbc24a5$export$4447eddabc434410(false, path));
                        dispatch($d81b80734fbc24a5$export$881bc3db7e40e575((0, $06257fecbb2b5848$export$2e2bcd8739ae039)(new Date(), 5), path));
                    }).catch((error)=>{
                        const err = `There was an error pushing the file ${path}: ${error.toString()}`;
                        console.error(err);
                        dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(err, 5000));
                        dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
                        dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
                        // Re-enqueue the file to be synchronized again
                        dispatch($d81b80734fbc24a5$export$92d6409d68f0739a({
                            path: path
                        }));
                    });
                } else {
                    if (!shouldSuppressMessages) dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)('Nothing to sync', 2000));
                    else setTimeout(()=>dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)()), 2000);
                    dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
                }
            } else if (isDirty && forceAction !== 'pull') {
                dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
                dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
                dispatch((0, $1780206710f3c846$export$ebfc6cde9af7602f)('sync-confirmation', {
                    lastServerModifiedAt: lastServerModifiedAt,
                    lastSyncAt: lastSyncAt,
                    path: path
                }));
            } else {
                dispatch($d81b80734fbc24a5$export$f1c553d4f1a2351(path, contents));
                dispatch($d81b80734fbc24a5$export$4447eddabc434410(false, path));
                dispatch($d81b80734fbc24a5$export$881bc3db7e40e575((0, $06257fecbb2b5848$export$2e2bcd8739ae039)(new Date(), 5), path));
                if (!shouldSuppressMessages) dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(`Latest version pulled: ${path}`, 2000));
                else setTimeout(()=>dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)()), 2000);
                dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
            }
        }).catch(()=>{
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
            dispatch($d81b80734fbc24a5$export$efc903f8ecc96b3d(`File ${path} not found`));
        });
    };
const $d81b80734fbc24a5$export$218961f78e7bc84e = (headerId)=>({
        type: 'OPEN_HEADER',
        headerId: headerId
    });
const $d81b80734fbc24a5$export$fa3ffca728e28c38 = (headerId, closeSubheadersRecursively)=>({
        type: 'TOGGLE_HEADER_OPENED',
        headerId: headerId,
        closeSubheadersRecursively: closeSubheadersRecursively
    });
const $d81b80734fbc24a5$export$e0565e6fdebf8d2b = (headerId)=>(dispatch)=>{
        dispatch({
            type: 'SELECT_HEADER',
            headerId: headerId
        });
        if (!!headerId) {
            dispatch($d81b80734fbc24a5$export$e87683d26142c4fd(null));
            dispatch($d81b80734fbc24a5$export$fd3fcc6c88d51a7d(null));
        }
    };
const $d81b80734fbc24a5$export$f8eb2c0ccbbccbe1 = (headerIndex)=>(dispatch)=>{
        dispatch({
            type: 'SELECT_HEADER_INDEX',
            headerIndex: headerIndex
        });
    };
const $d81b80734fbc24a5$export$1518ffc4a8ff94f2 = (path)=>(dispatch)=>{
        dispatch({
            type: 'SET_PATH',
            path: path
        });
        dispatch({
            type: (0, $5624140532e76935$exports.ActionTypes).CLEAR_HISTORY
        });
    };
const $d81b80734fbc24a5$export$a3eec7d6030b01df = (path, headerId)=>(dispatch)=>{
        dispatch($d81b80734fbc24a5$export$1518ffc4a8ff94f2(path));
        dispatch({
            type: 'OPEN_PARENTS_OF_HEADER',
            headerId: headerId
        });
        // select header after the file is displayed to allow the header to scroll into view
        setTimeout(()=>dispatch($d81b80734fbc24a5$export$e0565e6fdebf8d2b(headerId)), 0);
    };
const $d81b80734fbc24a5$export$d52a65249001b444 = (headerId, logIntoDrawer)=>({
        type: 'ADVANCE_TODO_STATE',
        headerId: headerId,
        logIntoDrawer: logIntoDrawer,
        dirtying: true,
        timestamp: new Date()
    });
const $d81b80734fbc24a5$export$716d4b6fabec4e3a = (headerId, newTodoState, logIntoDrawer)=>({
        type: 'SET_TODO_STATE',
        newTodoState: newTodoState,
        headerId: headerId,
        logIntoDrawer: logIntoDrawer,
        dirtying: true,
        timestamp: new Date()
    });
const $d81b80734fbc24a5$export$99a5c3ae2a16e7ed = (editModeType)=>({
        type: 'ENTER_EDIT_MODE',
        editModeType: editModeType
    });
const $d81b80734fbc24a5$export$6104e3b4c48e4d36 = ()=>({
        type: 'EXIT_EDIT_MODE'
    });
const $d81b80734fbc24a5$export$8f4602b7cb85c3f6 = (headerId, newRawTitle)=>({
        type: 'UPDATE_HEADER_TITLE',
        headerId: headerId,
        newRawTitle: newRawTitle,
        dirtying: true
    });
const $d81b80734fbc24a5$export$40feb5309281ae20 = (headerId, newRawDescription)=>({
        type: 'UPDATE_HEADER_DESCRIPTION',
        headerId: headerId,
        newRawDescription: newRawDescription,
        dirtying: true
    });
const $d81b80734fbc24a5$export$31d7f72bcc5bd8c8 = (headerId)=>({
        type: 'ADD_HEADER',
        headerId: headerId,
        // Performance optimization: Don't actually sync a whole Org file
        // for an empty header. When the user adds some data and triggers
        // UPDATE_HEADER_TITLE, then it makes sense to save it.
        dirtying: false
    });
const $d81b80734fbc24a5$export$618125dd560d6333 = (headerId)=>({
        type: 'DUPLICATE_HEADER',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$8b0d9a2124129ba7 = ()=>({
        type: 'CREATE_FIRST_HEADER',
        dirtying: true
    });
const $d81b80734fbc24a5$export$b8295a7771533d34 = (headerId)=>({
        type: 'SELECT_NEXT_SIBLING_HEADER',
        headerId: headerId
    });
const $d81b80734fbc24a5$export$8132ad4391eb7de0 = (headerId)=>(dispatch)=>{
        dispatch($d81b80734fbc24a5$export$31d7f72bcc5bd8c8(headerId));
        dispatch($d81b80734fbc24a5$export$b8295a7771533d34(headerId));
        dispatch((0, $1780206710f3c846$export$ebfc6cde9af7602f)('title-editor'));
    };
const $d81b80734fbc24a5$export$12e044de4c61a8c2 = (headerId)=>({
        type: 'SELECT_NEXT_VISIBLE_HEADER',
        headerId: headerId
    });
const $d81b80734fbc24a5$export$6e9ab9c1bead507a = (headerId)=>({
        type: 'SELECT_PREVIOUS_VISIBLE_HEADER',
        headerId: headerId
    });
const $d81b80734fbc24a5$export$d1dd841af70fe4d3 = (headerId)=>({
        type: 'REMOVE_HEADER',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$79a81da0eac4bec9 = (headerId)=>({
        type: 'MOVE_HEADER_UP',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$50662492c2b94a52 = (headerId)=>({
        type: 'MOVE_HEADER_DOWN',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$acd474d24539fc90 = (sourceHeaderId, targetHeaderId, position)=>({
        type: 'MOVE_HEADER_TO_POSITION',
        sourceHeaderId: sourceHeaderId,
        targetHeaderId: targetHeaderId,
        position: position,
        dirtying: true
    });
const $d81b80734fbc24a5$export$9bc68a93e1257bc4 = (headerId)=>({
        type: 'MOVE_HEADER_LEFT',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$1a52218923a01537 = (headerId)=>({
        type: 'MOVE_HEADER_RIGHT',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$c9fe9acb91c4c8f0 = (headerId)=>({
        type: 'MOVE_SUBTREE_LEFT',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$1e7956fd1c44b404 = (headerId)=>({
        type: 'MOVE_SUBTREE_RIGHT',
        headerId: headerId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$8e9d83427b24822a = (sourcePath, sourceHeaderId, targetPath, targetHeaderId)=>({
        type: 'REFILE_SUBTREE',
        sourcePath: sourcePath,
        sourceHeaderId: sourceHeaderId,
        targetPath: targetPath,
        targetHeaderId: targetHeaderId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$79159e21a6bceab7 = (inputText, currentDate)=>({
        type: 'HEADER_ADD_NOTE',
        inputText: inputText,
        currentDate: currentDate,
        dirtying: true
    });
const $d81b80734fbc24a5$export$8185c23dcb1f0e0 = (headerId)=>({
        type: 'NARROW_HEADER',
        headerId: headerId
    });
const $d81b80734fbc24a5$export$47fc6071254828da = ()=>({
        type: 'WIDEN_HEADER'
    });
const $d81b80734fbc24a5$export$2d7d9f027d8bca74 = (path, opennessState)=>({
        type: 'SET_OPENNESS_STATE',
        path: path,
        opennessState: opennessState
    });
const $d81b80734fbc24a5$export$74920e52f4af75df = (path)=>({
        type: 'APPLY_OPENNESS_STATE',
        path: path
    });
const $d81b80734fbc24a5$export$3394329df2111da4 = (isDirty, path)=>({
        type: 'SET_DIRTY',
        isDirty: isDirty,
        path: path
    });
const $d81b80734fbc24a5$export$4447eddabc434410 = (isDirty, path)=>(dispatch)=>{
        (0, $def57205f21f33f8$export$3af8a27488c6f294)(isDirty, path);
        dispatch($d81b80734fbc24a5$export$3394329df2111da4(isDirty, path));
    };
const $d81b80734fbc24a5$export$e1a8b1c52b62343c = (itemIndex)=>(dispatch)=>{
        dispatch({
            type: 'SET_SELECTED_DESCRIPTION_ITEM_INDEX',
            itemIndex: itemIndex
        });
    };
const $d81b80734fbc24a5$export$bb889c933b04177 = (tableId)=>(dispatch)=>{
        dispatch({
            type: 'SET_SELECTED_TABLE_ID',
            tableId: tableId
        });
    };
const $d81b80734fbc24a5$export$e87683d26142c4fd = (cellId)=>(dispatch)=>{
        dispatch({
            type: 'SET_SELECTED_TABLE_CELL_ID',
            cellId: cellId
        });
        if (!!cellId) dispatch($d81b80734fbc24a5$export$fd3fcc6c88d51a7d(null));
    };
const $d81b80734fbc24a5$export$7cae8a62f493d901 = ()=>({
        type: 'ADD_NEW_TABLE_ROW',
        dirtying: true
    });
const $d81b80734fbc24a5$export$163255ef96b20fb2 = ()=>({
        type: 'REMOVE_TABLE_ROW',
        dirtying: true
    });
const $d81b80734fbc24a5$export$7ab7eb066062846f = ()=>({
        type: 'ADD_NEW_TABLE_COLUMN',
        dirtying: true
    });
const $d81b80734fbc24a5$export$e8d98b2fc68c6686 = ()=>({
        type: 'REMOVE_TABLE_COLUMN',
        dirtying: true
    });
const $d81b80734fbc24a5$export$4aba78fdf63069f3 = ()=>({
        type: 'MOVE_TABLE_ROW_DOWN',
        dirtying: true
    });
const $d81b80734fbc24a5$export$24d61201bca94a1e = ()=>({
        type: 'MOVE_TABLE_ROW_UP',
        dirtying: true
    });
const $d81b80734fbc24a5$export$10d26cb5dfc56d08 = ()=>({
        type: 'MOVE_TABLE_COLUMN_LEFT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$2d24c1901a67e0af = ()=>({
        type: 'MOVE_TABLE_COLUMN_RIGHT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$7f16bb82aa33d615 = (cellId, newValue)=>({
        type: 'UPDATE_TABLE_CELL_VALUE',
        cellId: cellId,
        newValue: newValue,
        dirtying: true
    });
const $d81b80734fbc24a5$export$6d309cb89e0efb17 = (templateId, content, shouldPrepend)=>(dispatch, getState)=>{
        dispatch((0, $1780206710f3c846$export$e6889fb0929ccf91)());
        const template = getState().capture.get('captureTemplates').concat((0, $0a008ec384282745$export$2e2bcd8739ae039)).find((template)=>template.get('id') === templateId);
        dispatch({
            type: 'INSERT_CAPTURE',
            template: template,
            content: content,
            shouldPrepend: shouldPrepend,
            dirtying: true
        });
    };
const $d81b80734fbc24a5$export$c64a0f6ff771ff28 = (templateId, header, shouldPrepend)=>(dispatch, getState)=>{
        dispatch((0, $1780206710f3c846$export$e6889fb0929ccf91)());
        const template = getState().capture.get('captureTemplates').concat((0, $0a008ec384282745$export$2e2bcd8739ae039)).find((template)=>template.get('id') === templateId);
        const targetPath = template.get('file') || getState().org.present.get('path');
        dispatch({
            type: 'INSERT_CAPTURE_FROM_HEADER',
            template: template,
            header: header,
            shouldPrepend: shouldPrepend,
            dirtying: true
        });
        dispatch($d81b80734fbc24a5$export$92d6409d68f0739a({
            successMessage: 'Item captured',
            path: targetPath
        }));
    };
const $d81b80734fbc24a5$export$4191fada395b9eaf = ()=>({
        type: 'CLEAR_PENDING_CAPTURE'
    });
const $d81b80734fbc24a5$export$eccd488bbc07a831 = ()=>(dispatch, getState)=>{
        const path = getState().org.present.get('path');
        const pendingCapture = getState().org.present.get('pendingCapture');
        const templateName = pendingCapture.get('captureTemplateName');
        const captureContent = pendingCapture.get('captureContent');
        const customCaptureVariables = pendingCapture.get('customCaptureVariables');
        dispatch($d81b80734fbc24a5$export$4191fada395b9eaf());
        window.history.pushState({}, '', window.location.pathname);
        const template = getState().capture.get('captureTemplates').filter((template)=>template.get('isAvailableInAllOrgFiles') || template.get('orgFilesWhereAvailable').includes(getState().org.present.get('path'))).find((template)=>template.get('description').trim() === templateName.trim());
        if (!template) {
            dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(`Capture failed: "${templateName}" template not found or not available in this file`, 8000));
            return;
        }
        const targetPath = template.get('file') || path;
        const headerPaths = template.get('headerPaths');
        const targetHeaders = getState().org.present.getIn([
            'files',
            targetPath,
            'headers'
        ]);
        const targetHeader = targetHeaders && (0, $2ce140c2c56df8f2$export$250b3505fb888bc1)(targetHeaders, headerPaths);
        if (headerPaths.size > 0 && !targetHeader) {
            dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(`Capture failed: "${template.get('description')}" header path invalid in ${targetPath}`, 8000));
            return;
        }
        const [substitutedTemplate, initialCursorIndex] = (0, $9dc26f2876ad96b9$export$2e2bcd8739ae039)(template.get('template'), customCaptureVariables);
        const content = !!initialCursorIndex ? `${substitutedTemplate.substring(0, initialCursorIndex)}${captureContent}${substitutedTemplate.substring(initialCursorIndex)}` : `${substitutedTemplate}${captureContent}`;
        dispatch($d81b80734fbc24a5$export$6d309cb89e0efb17(template.get('id'), content, template.get('shouldPrepend')));
        dispatch($d81b80734fbc24a5$export$92d6409d68f0739a({
            successMessage: 'Item captured',
            path: targetPath
        }));
    };
const $d81b80734fbc24a5$export$67c8893c26def689 = (listItemId)=>({
        type: 'ADVANCE_CHECKBOX_STATE',
        listItemId: listItemId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$fd3fcc6c88d51a7d = (listItemId)=>(dispatch)=>{
        dispatch({
            type: 'SET_SELECTED_LIST_ITEM_ID',
            listItemId: listItemId
        });
        if (!!listItemId) {
            dispatch($d81b80734fbc24a5$export$e0565e6fdebf8d2b(null));
            dispatch($d81b80734fbc24a5$export$e87683d26142c4fd(null));
        }
    };
const $d81b80734fbc24a5$export$49120ddd66561733 = (listItemId, newValue)=>({
        type: 'UPDATE_LIST_TITLE_VALUE',
        listItemId: listItemId,
        newValue: newValue,
        dirtying: true
    });
const $d81b80734fbc24a5$export$2f9859c55269723a = (listItemId, newValue)=>({
        type: 'UPDATE_LIST_CONTENTS_VALUE',
        listItemId: listItemId,
        newValue: newValue,
        dirtying: true
    });
const $d81b80734fbc24a5$export$657dd7de9e3c731a = ()=>({
        type: 'ADD_NEW_LIST_ITEM',
        dirtying: true
    });
const $d81b80734fbc24a5$export$6e8bb94df7b20621 = ()=>({
        type: 'SELECT_NEXT_SIBLING_LIST_ITEM'
    });
const $d81b80734fbc24a5$export$1237e513fcf0255f = ()=>(dispatch)=>{
        dispatch($d81b80734fbc24a5$export$657dd7de9e3c731a());
        dispatch($d81b80734fbc24a5$export$6e8bb94df7b20621());
        dispatch($d81b80734fbc24a5$export$99a5c3ae2a16e7ed('list-title'));
    };
const $d81b80734fbc24a5$export$b0f7d7f51fc9406a = ()=>({
        type: 'REMOVE_LIST_ITEM',
        dirtying: true
    });
const $d81b80734fbc24a5$export$bd631276cc4c58fd = ()=>({
        type: 'MOVE_LIST_ITEM_UP',
        dirtying: true
    });
const $d81b80734fbc24a5$export$390d7acb2b96bcbb = ()=>({
        type: 'MOVE_LIST_ITEM_DOWN',
        dirtying: true
    });
const $d81b80734fbc24a5$export$8844464bf09616ec = ()=>({
        type: 'MOVE_LIST_ITEM_LEFT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$12eb1b14e074a6b7 = ()=>({
        type: 'MOVE_LIST_ITEM_RIGHT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$3b88d9219ca93e47 = ()=>({
        type: 'MOVE_LIST_SUBTREE_LEFT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$3b9c326df9e2fd95 = ()=>({
        type: 'MOVE_LIST_SUBTREE_RIGHT',
        dirtying: true
    });
const $d81b80734fbc24a5$export$92bc85de99057d64 = (headerId, tags)=>({
        type: 'SET_HEADER_TAGS',
        headerId: headerId,
        tags: tags,
        dirtying: true
    });
const $d81b80734fbc24a5$export$3ef4f30cf2ff5820 = (fromIndex, toIndex)=>({
        type: 'REORDER_TAGS',
        fromIndex: fromIndex,
        toIndex: toIndex,
        dirtying: true
    });
const $d81b80734fbc24a5$export$49c84db8dca423dc = (fromIndex, toIndex)=>(dispatch, getState)=>dispatch({
            type: 'REORDER_PROPERTY_LIST',
            fromIndex: fromIndex,
            toIndex: toIndex,
            headerId: getState().base.getIn([
                'activePopup',
                'data',
                'headerId'
            ]),
            dirtying: true
        });
const $d81b80734fbc24a5$export$ccb2f2f45ccf6e73 = (timestampId, newTimestamp)=>({
        type: 'UPDATE_TIMESTAMP_WITH_ID',
        timestampId: timestampId,
        newTimestamp: newTimestamp,
        dirtying: true
    });
const $d81b80734fbc24a5$export$ce2b24e6685d7b40 = (headerId, planningItemIndex, newTimestamp)=>({
        type: 'UPDATE_PLANNING_ITEM_TIMESTAMP',
        headerId: headerId,
        planningItemIndex: planningItemIndex,
        newTimestamp: newTimestamp,
        dirtying: true
    });
const $d81b80734fbc24a5$export$d517feb0e36376ff = (headerId, planningType)=>({
        type: 'ADD_NEW_PLANNING_ITEM',
        headerId: headerId,
        planningType: planningType,
        dirtying: true,
        timestamp: new Date()
    });
const $d81b80734fbc24a5$export$962c84a23aaded5f = (headerId, planningItemIndex)=>({
        type: 'REMOVE_PLANNING_ITEM',
        headerId: headerId,
        planningItemIndex: planningItemIndex,
        dirtying: true
    });
const $d81b80734fbc24a5$export$8144a1156e1fc1b3 = (headerId, timestampId)=>({
        type: 'REMOVE_TIMESTAMP',
        headerId: headerId,
        timestampId: timestampId,
        dirtying: true
    });
const $d81b80734fbc24a5$export$30602d312260e3a = (headerId, newPropertyListItems)=>({
        type: 'UPDATE_PROPERTY_LIST_ITEMS',
        headerId: headerId,
        newPropertyListItems: newPropertyListItems,
        dirtying: true
    });
const $d81b80734fbc24a5$export$efc903f8ecc96b3d = (message)=>({
        type: 'SET_ORG_FILE_ERROR_MESSAGE',
        message: message
    });
const $d81b80734fbc24a5$export$e0cf4c247726959f = (headerId, entryId, time)=>({
        type: 'SET_LOG_ENTRY_STOP',
        headerId: headerId,
        entryId: entryId,
        time: time,
        dirtying: true
    });
const $d81b80734fbc24a5$export$f459875c7999031d = (headerId, time)=>({
        type: 'CREATE_LOG_ENTRY_START',
        headerId: headerId,
        time: time,
        dirtying: true
    });
const $d81b80734fbc24a5$export$e6848e05aa9ac9c3 = (headerId, entryIndex, entryType, newTime)=>({
        type: 'UPDATE_LOG_ENTRY_TIME',
        headerId: headerId,
        entryIndex: entryIndex,
        entryType: entryType,
        newTime: newTime,
        dirtying: true
    });
const $d81b80734fbc24a5$export$21de7cfeca6a9e5b = (searchFilter, cursorPosition, context)=>({
        type: 'SET_SEARCH_FILTER_INFORMATION',
        searchFilter: searchFilter,
        cursorPosition: cursorPosition,
        context: context
    });
const $d81b80734fbc24a5$export$737fa6ea2dea9d9c = (showClockDisplay)=>({
        type: 'TOGGLE_CLOCK_DISPLAY',
        showClockDisplay: showClockDisplay
    });
const $d81b80734fbc24a5$export$491f839f0847e33e = (settingId, fieldPath, newValue)=>({
        type: 'UPDATE_FILE_SETTING_FIELD_PATH_VALUE',
        settingId: settingId,
        fieldPath: fieldPath,
        newValue: newValue
    });
const $d81b80734fbc24a5$export$1598048bf82d0a0a = (fromIndex, toIndex)=>({
        type: 'REORDER_FILE_SETTING',
        fromIndex: fromIndex,
        toIndex: toIndex
    });
const $d81b80734fbc24a5$export$3056289a1346fb2 = (settingId)=>({
        type: 'DELETE_FILE_SETTING',
        settingId: settingId
    });
const $d81b80734fbc24a5$export$dc769ee8acd95be2 = ()=>(dispatch)=>dispatch({
            type: 'ADD_NEW_EMPTY_FILE_SETTING'
        });
const $d81b80734fbc24a5$export$1b46013ba7966e2d = (newSettings)=>({
        type: 'RESTORE_FILE_SETTINGS',
        newSettings: newSettings
    });
const $d81b80734fbc24a5$export$9ca719fe1e80008c = (context, bookmark)=>({
        type: 'SAVE_BOOKMARK',
        context: context,
        bookmark: bookmark
    });
const $d81b80734fbc24a5$export$136048bcb9946c75 = (context, bookmark)=>({
        type: 'DELETE_BOOKMARK',
        context: context,
        bookmark: bookmark
    });
const $d81b80734fbc24a5$export$87568492a59918e5 = (path, content)=>({
        type: 'ADD_NEW_FILE',
        path: path,
        content: content
    });




var $ce97f17932af1d24$export$2e2bcd8739ae039 = (store)=>(next)=>(action)=>{
            // middleware is run before the reducer. to persist the result of the action,
            // save and sync are done in a callback so they happen after the state is changed
            setTimeout(()=>{
                let dirtyFiles = (0, $13082abb6c5d9476$export$39a2bc38700130e0)(store.getState().org.present, action);
                dirtyFiles.forEach((path)=>(0, $def57205f21f33f8$export$889e5a7ed78a67b3)(store.getState(), path));
                dirtyFiles.forEach((path)=>(0, $def57205f21f33f8$export$3af8a27488c6f294)(true, path));
                if (store.getState().base.get('shouldLiveSync')) dirtyFiles.forEach((path)=>store.dispatch((0, $d81b80734fbc24a5$export$92d6409d68f0739a)({
                        shouldSuppressMessages: true,
                        path: path
                    })));
            }, 0);
            return next(action);
        };


// The outer (store) => function is called once during applyMiddleware.
// Register the OS color scheme change listener here, not in the action handler.
var $167c32d7afe97d5a$export$2e2bcd8739ae039 = (store)=>{
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        const prefersColorSchemeMediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        if ('addEventListener' in prefersColorSchemeMediaQueryList) prefersColorSchemeMediaQueryList.addEventListener('change', ()=>{
            // Only react to OS changes when the user's setting is 'OS'.
            // If the user explicitly chose 'Light' or 'Dark', don't override their preference.
            const currentColorScheme = store.getState().base.get('colorScheme');
            if (currentColorScheme === 'OS') // Dispatch a dedicated action to trigger a re-render.
            // loadTheme() in Entry.render() will re-query the OS preference
            // via matchMedia and apply the correct colors.
            store.dispatch({
                type: 'OS_COLOR_SCHEME_CHANGED'
            });
        });
    }
    return (next)=>(action)=>next(action);
};





var $frurs = parcelRequire("frurs");




const $5f760f090c85e411$var$setLoadingMessage = (state, action)=>state.set('loadingMessage', action.loadingMessage);
const $5f760f090c85e411$var$hideLoadingMessage = (state)=>state.set('loadingMessage', null);
const $5f760f090c85e411$var$setFontSize = (state, action)=>state.set('fontSize', action.newFontSize);
const $5f760f090c85e411$var$setBulletStyle = (state, action)=>state.set('bulletStyle', action.newBulletStyle);
const $5f760f090c85e411$var$setShouldTapTodoToAdvance = (state, action)=>state.set('shouldTapTodoToAdvance', action.newShouldTapTodoToAdvance);
const $5f760f090c85e411$var$setAgendaDefaultDeadlineDelayUnit = (state, action)=>state.set('agendaDefaultDeadlineDelayUnit', action.newAgendaDefaultDeadlineDelayUnit);
const $5f760f090c85e411$var$setAgendaDefaultDeadlineDelayValue = (state, action)=>state.set('agendaDefaultDeadlineDelayValue', action.newAgendaDefaultDeadlineDelayValue);
const $5f760f090c85e411$var$setEditorDescriptionHeightValue = (state, action)=>state.set('editorDescriptionHeightValue', action.newEditorDescriptionHeightValue);
const $5f760f090c85e411$var$setAgendaStartOnWeekday = (state, action)=>state.set('agendaStartOnWeekday', action.newAgendaStartOnWeekday);
const $5f760f090c85e411$var$setShouldStoreSettingsInSyncBackend = (state, action)=>state.set('shouldStoreSettingsInSyncBackend', action.newShouldStoreSettingsInSyncBackend);
const $5f760f090c85e411$var$setShouldLiveSync = (state, action)=>state.set('shouldLiveSync', action.shouldLiveSync);
const $5f760f090c85e411$var$setShowDeadlineDisplay = (state, action)=>state.set('showDeadlineDisplay', action.showDeadlineDisplay);
const $5f760f090c85e411$var$setShouldSyncOnBecomingVisibile = (state, action)=>state.set('shouldSyncOnBecomingVisibile', action.shouldSyncOnBecomingVisibile);
const $5f760f090c85e411$var$setShouldShowTitleInOrgFile = (state, action)=>state.set('shouldShowTitleInOrgFile', action.shouldShowTitleInOrgFile);
const $5f760f090c85e411$var$setShouldLogIntoDrawer = (state, action)=>state.set('shouldLogIntoDrawer', action.shouldLogIntoDrawer);
const $5f760f090c85e411$var$setCloseSubheadersRecursively = (state, action)=>state.set('closeSubheadersRecursively', action.closeSubheadersRecursively);
/**
 * When enabled, keep all heading body text flush-left. When disabled (the
 * default) indent the body text of headings according to the nesting level of
 * the heading.
 */ const $5f760f090c85e411$var$setShouldNotIndentOnExport = (state, action)=>state.set('shouldNotIndentOnExport', action.shouldNotIndentOnExport);
const $5f760f090c85e411$var$setHasUnseenChangelog = (state, action)=>state.set('hasUnseenChangelog', action.newHasUnseenChangelog);
const $5f760f090c85e411$var$setLastSeenChangelogHeader = (state, action)=>state.set('lastSeenChangelogHash', action.newLastSeenChangelogHash);
const $5f760f090c85e411$var$setLastViewedFile = (state, action)=>state.set('lastViewedPath', action.lastViewedPath);
const $5f760f090c85e411$var$setCustomKeybinding = (state, action)=>{
    if (!state.get('customKeybindings')) state = state.set('customKeybindings', (0, $3044e0bef3624137$exports.Map)());
    return state.setIn([
        'customKeybindings',
        action.keybindingName
    ], action.keybinding);
};
const $5f760f090c85e411$var$assignNotificationCadenceIds = (state)=>{
    const cadences = state.getIn([
        'notificationSettings',
        'tagCadences'
    ]);
    if (!cadences) return state;
    return state.updateIn([
        'notificationSettings',
        'tagCadences'
    ], (cs)=>cs.map((cadence)=>cadence.set('id', (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)())));
};
const $5f760f090c85e411$var$ensureNotificationSettings = (state)=>{
    if (!state.get('notificationSettings')) return state.set('notificationSettings', (0, $ed01441649308ad3$export$c0d1f3814120bd33));
    return state;
};
const $5f760f090c85e411$var$indexOfCadenceWithId = (cadences, cadenceId)=>cadences.findIndex((cadence)=>cadence.get('id') === cadenceId);
const $5f760f090c85e411$var$updateNotificationSettingsFieldPathValue = (state, action)=>{
    state = $5f760f090c85e411$var$ensureNotificationSettings(state);
    return state.setIn([
        'notificationSettings'
    ].concat(action.fieldPath), action.newValue);
};
const $5f760f090c85e411$var$addNewEmptyNotificationTagCadence = (state)=>{
    state = $5f760f090c85e411$var$ensureNotificationSettings(state);
    if (!state.getIn([
        'notificationSettings',
        'tagCadences'
    ])) state = state.setIn([
        'notificationSettings',
        'tagCadences'
    ], (0, $3044e0bef3624137$exports.List)());
    return state.updateIn([
        'notificationSettings',
        'tagCadences'
    ], (cadences)=>cadences.push((0, $3044e0bef3624137$exports.fromJS)((0, $frurs._)({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        }, (0, $ed01441649308ad3$export$ec849c9586573a82)))));
};
const $5f760f090c85e411$var$updateNotificationTagCadenceFieldPathValue = (state, action)=>{
    state = $5f760f090c85e411$var$ensureNotificationSettings(state);
    const cadences = state.getIn([
        'notificationSettings',
        'tagCadences'
    ]) || (0, $3044e0bef3624137$exports.List)();
    const cadenceIndex = $5f760f090c85e411$var$indexOfCadenceWithId(cadences, action.cadenceId);
    if (cadenceIndex === -1) return state;
    return state.setIn([
        'notificationSettings',
        'tagCadences',
        cadenceIndex
    ].concat(action.fieldPath), action.newValue);
};
const $5f760f090c85e411$var$deleteNotificationTagCadence = (state, action)=>{
    const cadences = state.getIn([
        'notificationSettings',
        'tagCadences'
    ]);
    if (!cadences) return state;
    const cadenceIndex = $5f760f090c85e411$var$indexOfCadenceWithId(cadences, action.cadenceId);
    if (cadenceIndex === -1) return state;
    return state.updateIn([
        'notificationSettings',
        'tagCadences'
    ], (cs)=>cs.delete(cadenceIndex));
};
const $5f760f090c85e411$var$reorderNotificationTagCadence = (state, action)=>state.updateIn([
        'notificationSettings',
        'tagCadences'
    ], (cadences)=>cadences.splice(action.fromIndex, 1).splice(action.toIndex, 0, cadences.get(action.fromIndex)));
const $5f760f090c85e411$var$restoreBaseSettings = (state, action)=>{
    if (!action.newSettings) return state;
    return $5f760f090c85e411$var$assignNotificationCadenceIds((0, $18ca84fc585e0c6b$export$3a8fcddeef8103e7)(state, action.newSettings, 'base'));
};
const $5f760f090c85e411$var$pushModalPage = (state, action)=>state.update('modalPageStack', (stack)=>!!stack ? stack.push(action.modalPage) : (0, $3044e0bef3624137$exports.List)([
            action.modalPage
        ]));
const $5f760f090c85e411$var$popModalPage = (state)=>state.update('modalPageStack', (stack)=>!!stack ? stack.pop() : stack);
const $5f760f090c85e411$var$clearModalStack = (state)=>state.set('modalPageStack', (0, $3044e0bef3624137$exports.List)());
const $5f760f090c85e411$var$activatePopup = (state, action)=>{
    const { data: data, popupType: popupType } = action;
    // Remember active popup in URL state for popups that are uniquely
    // identifiable (aka not related to a single header like tags,
    // properties or timestamps).
    if ([
        'search',
        'task-list',
        'agenda'
    ].includes(popupType)) window.history.replaceState({}, '', `${window.location.pathname}#${popupType}`);
    return state.set('activePopup', (0, $3044e0bef3624137$exports.fromJS)({
        type: popupType,
        data: data
    }));
};
const $5f760f090c85e411$var$closePopup = (state)=>{
    window.history.replaceState('', document.title, window.location.pathname + window.location.search);
    return state.set('activePopup', null);
};
const $5f760f090c85e411$var$setIsLoading = (state, action)=>{
    if (action.isLoading) return state.update('isLoading', (isLoading)=>isLoading.add(action.path));
    else return state.update('isLoading', (isLoading)=>isLoading.delete(action.path));
};
const $5f760f090c85e411$var$setIsOnline = (state, action)=>{
    return state.set('online', action.online);
};
const $5f760f090c85e411$var$setAgendaTimeframe = (state, action)=>state.set('agendaTimeframe', action.agendaTimeframe);
const $5f760f090c85e411$var$setFinderTab = (state, action)=>state.set('finderTab', action.finderTab);
const $5f760f090c85e411$var$setPreferEditRawValues = (state, action)=>state.set('preferEditRawValues', action.preferEditRawValues);
const $5f760f090c85e411$var$setOrgHabitShowAllToday = (state, action)=>state.set('orgHabitShowAllToday', action.orgHabitShowAllToday);
const $5f760f090c85e411$var$setOrgHabitPrecedingDays = (state, action)=>state.set('orgHabitPrecedingDays', action.orgHabitPrecedingDays);
const $5f760f090c85e411$var$setOrgHabitFollowingDays = (state, action)=>state.set('orgHabitFollowingDays', action.orgHabitFollowingDays);
const $5f760f090c85e411$var$setColorScheme = (state, action)=>{
    return state.set('colorScheme', action.colorScheme);
};
const $5f760f090c85e411$var$osColorSchemeChanged = (state)=>{
    // Increment a counter to force a re-render in Entry (PureComponent).
    // The colorScheme value stays as 'OS'; loadTheme() re-queries the OS preference.
    return state.update('osColorSchemeChangeCount', (c)=>(c || 0) + 1);
};
const $5f760f090c85e411$var$setTheme = (state, action)=>{
    return state.set('theme', action.theme);
};
var /**
 * Reducer that is responsible for the "base" state slice.
 */ $5f760f090c85e411$export$2e2bcd8739ae039 = (state = (0, $3044e0bef3624137$exports.Map)(), action)=>{
    switch(action.type){
        case 'SET_LOADING_MESSAGE':
            return $5f760f090c85e411$var$setLoadingMessage(state, action);
        case 'HIDE_LOADING_MESSAGE':
            return $5f760f090c85e411$var$hideLoadingMessage(state, action);
        case 'SET_FONT_SIZE':
            return $5f760f090c85e411$var$setFontSize(state, action);
        case 'SET_BULLET_STYLE':
            return $5f760f090c85e411$var$setBulletStyle(state, action);
        case 'SET_SHOULD_TAP_TODO_TO_ADVANCE':
            return $5f760f090c85e411$var$setShouldTapTodoToAdvance(state, action);
        case 'SET_AGENDA_DEFAULT_DEADLINE_DELAY_UNIT':
            return $5f760f090c85e411$var$setAgendaDefaultDeadlineDelayUnit(state, action);
        case 'SET_AGENDA_DEFAULT_DEADLINE_DELAY_VALUE':
            return $5f760f090c85e411$var$setAgendaDefaultDeadlineDelayValue(state, action);
        case 'SET_EDITOR_DESCRIPTION_HEIGHT_VALUE':
            return $5f760f090c85e411$var$setEditorDescriptionHeightValue(state, action);
        case 'SET_AGENDA_START_ON_WEEKDAY':
            return $5f760f090c85e411$var$setAgendaStartOnWeekday(state, action);
        case 'SET_SHOULD_STORE_SETTINGS_IN_SYNC_BACKEND':
            return $5f760f090c85e411$var$setShouldStoreSettingsInSyncBackend(state, action);
        case 'SET_COLOR_SCHEME':
            return $5f760f090c85e411$var$setColorScheme(state, action);
        case 'OS_COLOR_SCHEME_CHANGED':
            return $5f760f090c85e411$var$osColorSchemeChanged(state);
        case 'SET_THEME':
            return $5f760f090c85e411$var$setTheme(state, action);
        case 'SET_SHOULD_LIVE_SYNC':
            return $5f760f090c85e411$var$setShouldLiveSync(state, action);
        case 'SET_SHOW_DEADLINE_DISPLAY':
            return $5f760f090c85e411$var$setShowDeadlineDisplay(state, action);
        case 'SET_SHOULD_SYNC_ON_BECOMING_VISIBLE':
            return $5f760f090c85e411$var$setShouldSyncOnBecomingVisibile(state, action);
        case 'SET_SHOULD_SHOW_TITLE_IN_ORG_FILE':
            return $5f760f090c85e411$var$setShouldShowTitleInOrgFile(state, action);
        case 'SET_SHOULD_LOG_INTO_DRAWER':
            return $5f760f090c85e411$var$setShouldLogIntoDrawer(state, action);
        case 'SET_CLOSE_SUBHEADERS_RECURSIVELY':
            return $5f760f090c85e411$var$setCloseSubheadersRecursively(state, action);
        case 'SET_SHOULD_NOT_INDENT_ON_EXPORT':
            return $5f760f090c85e411$var$setShouldNotIndentOnExport(state, action);
        case 'SET_HAS_UNSEEN_CHANGELOG':
            return $5f760f090c85e411$var$setHasUnseenChangelog(state, action);
        case 'SET_LAST_SEEN_CHANGELOG_HEADER':
            return $5f760f090c85e411$var$setLastSeenChangelogHeader(state, action);
        case 'SET_LAST_VIEWED_FILE':
            return $5f760f090c85e411$var$setLastViewedFile(state, action);
        case 'SET_CUSTOM_KEYBINDING':
            return $5f760f090c85e411$var$setCustomKeybinding(state, action);
        case 'RESTORE_BASE_SETTINGS':
            return $5f760f090c85e411$var$restoreBaseSettings(state, action);
        case 'PUSH_MODAL_PAGE':
            return $5f760f090c85e411$var$pushModalPage(state, action);
        case 'POP_MODAL_PAGE':
            return $5f760f090c85e411$var$popModalPage(state, action);
        case 'CLEAR_MODAL_STACK':
            return $5f760f090c85e411$var$clearModalStack(state, action);
        case 'ACTIVATE_POPUP':
            return $5f760f090c85e411$var$activatePopup(state, action);
        case 'CLOSE_POPUP':
            return $5f760f090c85e411$var$closePopup(state, action);
        case 'SET_IS_LOADING':
            return $5f760f090c85e411$var$setIsLoading(state, action);
        case 'SET_IS_ONLINE':
            return $5f760f090c85e411$var$setIsOnline(state, action);
        case 'SET_AGENDA_TIMEFRAME':
            return $5f760f090c85e411$var$setAgendaTimeframe(state, action);
        case 'SET_FINDER_TAB':
            return $5f760f090c85e411$var$setFinderTab(state, action);
        case 'PREFER_EDIT_RAW_VALUES':
            return $5f760f090c85e411$var$setPreferEditRawValues(state, action);
        case 'SET_ORG_HABIT_SHOW_ALL_TODAY':
            return $5f760f090c85e411$var$setOrgHabitShowAllToday(state, action);
        case 'SET_ORG_HABIT_PRECEDING_DAYS':
            return $5f760f090c85e411$var$setOrgHabitPrecedingDays(state, action);
        case 'SET_ORG_HABIT_FOLLOWING_DAYS':
            return $5f760f090c85e411$var$setOrgHabitFollowingDays(state, action);
        case 'UPDATE_NOTIFICATION_SETTINGS_FIELD_PATH_VALUE':
            return $5f760f090c85e411$var$updateNotificationSettingsFieldPathValue(state, action);
        case 'ADD_NEW_EMPTY_NOTIFICATION_TAG_CADENCE':
            return $5f760f090c85e411$var$addNewEmptyNotificationTagCadence(state, action);
        case 'UPDATE_NOTIFICATION_TAG_CADENCE_FIELD_PATH_VALUE':
            return $5f760f090c85e411$var$updateNotificationTagCadenceFieldPathValue(state, action);
        case 'DELETE_NOTIFICATION_TAG_CADENCE':
            return $5f760f090c85e411$var$deleteNotificationTagCadence(state, action);
        case 'REORDER_NOTIFICATION_TAG_CADENCE':
            return $5f760f090c85e411$var$reorderNotificationTagCadence(state, action);
        default:
            return state;
    }
};



const $c8075372c55e02a8$var$signOut = (state)=>state.set('isAuthenticated', false).set('client', null);
const $c8075372c55e02a8$var$setCurrentFileBrowserDirectoryListing = (state, action)=>state.set('currentFileBrowserDirectoryListing', (0, $3044e0bef3624137$exports.Map)({
        listing: action.directoryListing,
        hasMore: action.hasMore,
        additionalSyncBackendState: action.additionalSyncBackendState
    })).set('currentPath', action.path);
const $c8075372c55e02a8$var$setIsLoadingMoreDirectoryListing = (state, action)=>state.update('currentFileBrowserDirectoryListing', (currentFileBrowserDirectoryListing)=>!!currentFileBrowserDirectoryListing ? currentFileBrowserDirectoryListing : (0, $3044e0bef3624137$exports.Map)()).setIn([
        'currentFileBrowserDirectoryListing',
        'isLoadingMore'
    ], action.isLoadingMore);
var $c8075372c55e02a8$export$2e2bcd8739ae039 = (state = (0, $3044e0bef3624137$exports.Map)(), action)=>{
    switch(action.type){
        case 'SIGN_OUT':
            return $c8075372c55e02a8$var$signOut(state);
        case 'SET_CURRENT_FILE_BROWSER_DIRECTORY_LISTING':
            return $c8075372c55e02a8$var$setCurrentFileBrowserDirectoryListing(state, action);
        case 'SET_IS_LOADING_MORE_DIRECTORY_LISTING':
            return $c8075372c55e02a8$var$setIsLoadingMoreDirectoryListing(state, action);
        default:
            return state;
    }
};






const $e066ea2190f102e9$var$indexOfTemplateWithId = (templates, templateId)=>templates.findIndex((template)=>template.get('id') === templateId);
const $e066ea2190f102e9$var$addNewEmptyCaptureTemplate = (state)=>{
    if (!state.get('captureTemplates')) state = state.set('captureTemplates', (0, $3044e0bef3624137$exports.List)());
    return state.update('captureTemplates', (templates)=>templates.push((0, $3044e0bef3624137$exports.fromJS)({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
            description: '',
            letter: '',
            iconName: '',
            isAvailableInAllOrgFiles: true,
            file: '',
            orgFilesWhereAvailable: [
                ''
            ],
            headerPaths: [
                ''
            ],
            shouldPrepend: false,
            template: ''
        })));
};
const $e066ea2190f102e9$var$updateTemplateFieldPathValue = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.setIn([
        'captureTemplates',
        templateIndex
    ].concat(action.fieldPath), action.newValue);
};
const $e066ea2190f102e9$var$addNewTemplateOrgFileAvailability = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.updateIn([
        'captureTemplates',
        templateIndex,
        'orgFilesWhereAvailable'
    ], (orgFiles)=>orgFiles.push(''));
};
const $e066ea2190f102e9$var$removeTemplateOrgFileAvailability = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.updateIn([
        'captureTemplates',
        templateIndex,
        'orgFilesWhereAvailable'
    ], (orgFiles)=>orgFiles.delete(action.orgFileAvailabilityIndex));
};
const $e066ea2190f102e9$var$addNewTemplateHeaderPath = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.updateIn([
        'captureTemplates',
        templateIndex,
        'headerPaths'
    ], (headerPaths)=>headerPaths.push(''));
};
const $e066ea2190f102e9$var$removeTemplateHeaderPath = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.updateIn([
        'captureTemplates',
        templateIndex,
        'headerPaths'
    ], (headerPaths)=>headerPaths.delete(action.headerPathIndex));
};
const $e066ea2190f102e9$var$deleteTemplate = (state, action)=>{
    const templateIndex = $e066ea2190f102e9$var$indexOfTemplateWithId(state.get('captureTemplates'), action.templateId);
    return state.update('captureTemplates', (templates)=>templates.delete(templateIndex));
};
const $e066ea2190f102e9$var$restoreCaptureSettings = (state, action)=>{
    if (!action.newSettings) return state;
    return (0, $18ca84fc585e0c6b$export$f51c3153230af0e7)(state, action.newSettings);
};
const $e066ea2190f102e9$var$reorderCaptureTemplate = (state, action)=>state.update('captureTemplates', (templates)=>templates.splice(action.fromIndex, 1).splice(action.toIndex, 0, templates.get(action.fromIndex)));
var $e066ea2190f102e9$export$2e2bcd8739ae039 = (state = (0, $3044e0bef3624137$exports.Map)(), action)=>{
    switch(action.type){
        case 'ADD_NEW_EMPTY_CAPTURE_TEMPLATE':
            return $e066ea2190f102e9$var$addNewEmptyCaptureTemplate(state, action);
        case 'UPDATE_TEMPLATE_FIELD_PATH_VALUE':
            return $e066ea2190f102e9$var$updateTemplateFieldPathValue(state, action);
        case 'ADD_NEW_TEMPLATE_ORG_FILE_AVAILABILITY':
            return $e066ea2190f102e9$var$addNewTemplateOrgFileAvailability(state, action);
        case 'REMOVE_TEMPLATE_ORG_FILE_AVAILABILITY':
            return $e066ea2190f102e9$var$removeTemplateOrgFileAvailability(state, action);
        case 'ADD_NEW_TEMPLATE_HEADER_PATH':
            return $e066ea2190f102e9$var$addNewTemplateHeaderPath(state, action);
        case 'REMOVE_TEMPLATE_HEADER_PATH':
            return $e066ea2190f102e9$var$removeTemplateHeaderPath(state, action);
        case 'DELETE_TEMPLATE':
            return $e066ea2190f102e9$var$deleteTemplate(state, action);
        case 'RESTORE_CAPTURE_SETTINGS':
            return $e066ea2190f102e9$var$restoreCaptureSettings(state, action);
        case 'REORDER_CAPTURE_TEMPLATE':
            return $e066ea2190f102e9$var$reorderCaptureTemplate(state, action);
        default:
            return state;
    }
};



const $731c84596071103c$var$UNDOABLE_ACTIONS = [
    'ADD_HEADER',
    'REMOVE_HEADER',
    'MOVE_HEADER_UP',
    'MOVE_HEADER_DOWN',
    'MOVE_HEADER_TO_POSITION',
    'MOVE_HEADER_LEFT',
    'MOVE_HEADER_RIGHT',
    'MOVE_SUBTREE_LEFT',
    'MOVE_SUBTREE_RIGHT',
    'ADVANCE_TODO_STATE',
    'SET_TODO_STATE',
    'UPDATE_HEADER_TITLE',
    'UPDATE_HEADER_DESCRIPTION',
    'ADD_NEW_TABLE_ROW',
    'ADD_NEW_TABLE_COLUMN',
    'REMOVE_TABLE_ROW',
    'REMOVE_TABLE_COLUMN',
    'UPDATE_TABLE_CELL_VALUE',
    'MOVE_TABLE_ROW_DOWN',
    'MOVE_TABLE_ROW_UP',
    'MOVE_TABLE_COLUMN_LEFT',
    'MOVE_TABLE_COLUMN_RIGHT',
    'INSERT_CAPTURE',
    'REFILE_SUBTREE',
    'HEADER_ADD_NOTE',
    'SET_HEADER_TAGS',
    'UPDATE_PROPERTY_LIST_ITEMS',
    'ADD_NEW_PLANNING_ITEM',
    'REMOVE_PLANNING_ITEM',
    'CREATE_LOG_ENTRY_START',
    'SET_LOG_ENTRY_STOP',
    'ADD_NEW_LIST_ITEM',
    'REMOVE_LIST_ITEM',
    'MOVE_LIST_ITEM_UP',
    'MOVE_LIST_ITEM_DOWN',
    'MOVE_LIST_ITEM_LEFT',
    'MOVE_LIST_ITEM_RIGHT',
    'MOVE_LIST_SUBTREE_LEFT',
    'MOVE_LIST_SUBTREE_RIGHT'
];
// INFO: An `undo` in organice is always related to changing the Org
// file structure. Hence, it is necessary to trigger a `sync` action.
// This needs a little extra work, because this `sync` would result in
// a conflict: The state is now in the `past` the Org file has been
// synchronized in the `future`. Hence the `lastModifiedAt` timestamp
// will be in the future and organice won't see a reason to push. Even
// if we wanted to push, organice would show the 'conflict' modal,
// because the remote file is newer. For this reason, when doing an
// 'undo', organice will suppress this modal and 'force' a push. We
// don't want the user to need to understand that an 'undo' means
// moving to the past and the conflict has been created by herself in
// the future (which in real life might have been seconds ago).
// Implementation: Override the redux-undo `undo` and `redo` action creators. Additionally to the redux `undo`, they will force a sync, always.
(0, $5624140532e76935$exports.ActionCreators).undo = function() {
    return (dispatch)=>{
        dispatch({
            type: (0, $5624140532e76935$exports.ActionTypes).UNDO
        });
        dispatch((0, $d81b80734fbc24a5$export$4447eddabc434410)(true));
        dispatch((0, $d81b80734fbc24a5$export$92d6409d68f0739a)({
            forceAction: 'push'
        }));
    };
};
(0, $5624140532e76935$exports.ActionCreators).redo = function() {
    return (dispatch)=>{
        dispatch({
            type: (0, $5624140532e76935$exports.ActionTypes).REDO
        });
        dispatch((0, $d81b80734fbc24a5$export$4447eddabc434410)(true));
        dispatch((0, $d81b80734fbc24a5$export$92d6409d68f0739a)({
            forceAction: 'push'
        }));
    };
};
var $731c84596071103c$export$2e2bcd8739ae039 = (0, $7bd5d83317c8c48a$export$66e4520cdb265d18)({
    base: (0, $5f760f090c85e411$export$2e2bcd8739ae039),
    syncBackend: (0, $c8075372c55e02a8$export$2e2bcd8739ae039),
    org: (0, (/*@__PURE__*/$parcel$interopDefault($5624140532e76935$exports)))((0, $13082abb6c5d9476$export$2e2bcd8739ae039), {
        filter: (0, $5624140532e76935$exports.includeAction)($731c84596071103c$var$UNDOABLE_ACTIONS)
    }),
    capture: (0, $e066ea2190f102e9$export$2e2bcd8739ae039)
});


const $6f4738818a79416e$var$composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $7bd5d83317c8c48a$export$f672e0b6f7222cd7);
var $6f4738818a79416e$export$2e2bcd8739ae039 = (initialState)=>(0, $7bd5d83317c8c48a$export$f51a9068ac82ea43)((0, $731c84596071103c$export$2e2bcd8739ae039), initialState, $6f4738818a79416e$var$composeEnhancers((0, $7bd5d83317c8c48a$export$9ff26e0402cc7b7)((0, $edf878fa3d3304da$export$2e2bcd8739ae039), (0, $ce97f17932af1d24$export$2e2bcd8739ae039), (0, $167c32d7afe97d5a$export$2e2bcd8739ae039))));


const $4d1c34ada8668736$var$parseQueryString = (str)=>{
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^(\?|#|&)/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        key = decodeURIComponent(key);
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);
        if (ret[key] === undefined) ret[key] = val;
        else if (Array.isArray(ret[key])) ret[key].push(val);
        else ret[key] = [
            ret[key],
            val
        ];
    });
    return ret;
};
var $4d1c34ada8668736$export$2e2bcd8739ae039 = $4d1c34ada8668736$var$parseQueryString;




var $4037e5c1444ec9f6$export$2e2bcd8739ae039 = ()=>{
    if (!(0, $18ca84fc585e0c6b$export$c43914e0cb16a981)) return;
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;
    localStorage.setItem('dropboxAccessToken', accessToken);
    localStorage.removeItem('accessToken');
};



var $6fb425896e8b62cf$export$2e2bcd8739ae039 = ()=>{
    if (!(0, $18ca84fc585e0c6b$export$c43914e0cb16a981)) return;
    const shouldStoreSettingsInDropbox = localStorage.getItem('shouldStoreSettingsInDropbox');
    if (!shouldStoreSettingsInDropbox) return;
    localStorage.setItem('shouldStoreSettingsInSyncBackend', shouldStoreSettingsInDropbox);
    localStorage.removeItem('shouldStoreSettingsInDropbox');
};



var $756890b419df2153$export$2e2bcd8739ae039 = ()=>{
    if (!(0, $18ca84fc585e0c6b$export$c43914e0cb16a981)) return;
    Object.entries(localStorage).forEach(([k, v], _)=>{
        if ([
            'null',
            'undefined'
        ].includes(v)) {
            console.warn(`localStorage contains a bogus entry: '${k}': '${v}'`);
            console.warn('Deleting the bogus entry.');
            localStorage.removeItem(k);
        }
    });
};


var $b4cd3ce36352439b$export$2e2bcd8739ae039 = ()=>{
    (0, $4037e5c1444ec9f6$export$2e2bcd8739ae039)();
    (0, $6fb425896e8b62cf$export$2e2bcd8739ae039)();
    (0, $756890b419df2153$export$2e2bcd8739ae039)();
};



var $9zQbc = parcelRequire("9zQbc");

var $1bxDW = parcelRequire("1bxDW");

var $iZ4XC = parcelRequire("iZ4XC");

var $kabSK = parcelRequire("kabSK");



var $1bxDW = parcelRequire("1bxDW");
function $d037a9ec4120d05c$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $d037a9ec4120d05c$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $1bxDW.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var committed = (0, $1bxDW.useRef)(initial);
    var isInputMatch = Boolean(inputs && committed.current.inputs && $d037a9ec4120d05c$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = isInputMatch ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $1bxDW.useEffect)(function() {
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $d037a9ec4120d05c$export$33752cf3ee811995(callback, inputs) {
    return $d037a9ec4120d05c$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $d037a9ec4120d05c$export$1538c33de8887b59 = $d037a9ec4120d05c$export$b6feb8998cd9b342;
var $d037a9ec4120d05c$export$35808ee640e87ca7 = $d037a9ec4120d05c$export$33752cf3ee811995;



var $jbXRd = parcelRequire("jbXRd");
var $122e8d919897451e$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $122e8d919897451e$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $122e8d919897451e$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $122e8d919897451e$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $122e8d919897451e$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $122e8d919897451e$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $122e8d919897451e$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $122e8d919897451e$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $122e8d919897451e$var$noSpacing : _ref2$padding;
    var marginBox = $122e8d919897451e$export$4b834cebd9e5cebe($122e8d919897451e$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $122e8d919897451e$export$4b834cebd9e5cebe($122e8d919897451e$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $122e8d919897451e$export$4b834cebd9e5cebe($122e8d919897451e$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $122e8d919897451e$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $122e8d919897451e$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $jbXRd.default)(false);
    return result;
};
var $122e8d919897451e$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $122e8d919897451e$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $122e8d919897451e$var$shift(borderBox, change);
    return $122e8d919897451e$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $122e8d919897451e$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $122e8d919897451e$var$getWindowScroll();
    return $122e8d919897451e$export$cc800923e997bb8(original, scroll);
};
var $122e8d919897451e$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $122e8d919897451e$var$parse(styles.marginTop),
        right: $122e8d919897451e$var$parse(styles.marginRight),
        bottom: $122e8d919897451e$var$parse(styles.marginBottom),
        left: $122e8d919897451e$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $122e8d919897451e$var$parse(styles.paddingTop),
        right: $122e8d919897451e$var$parse(styles.paddingRight),
        bottom: $122e8d919897451e$var$parse(styles.paddingBottom),
        left: $122e8d919897451e$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $122e8d919897451e$var$parse(styles.borderTopWidth),
        right: $122e8d919897451e$var$parse(styles.borderRightWidth),
        bottom: $122e8d919897451e$var$parse(styles.borderBottomWidth),
        left: $122e8d919897451e$var$parse(styles.borderLeftWidth)
    };
    return $122e8d919897451e$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $122e8d919897451e$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $122e8d919897451e$export$b8dfc5d4e552b8e1(borderBox, styles);
};


function $b6d2d2472876f73f$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $b6d2d2472876f73f$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $b6d2d2472876f73f$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $b6d2d2472876f73f$export$2e2bcd8739ae039 = $b6d2d2472876f73f$var$memoizeOne;


var $34aef3fc575d5445$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $34aef3fc575d5445$export$2e2bcd8739ae039 = $34aef3fc575d5445$var$rafSchd;



var $5e954cbb8bebfdf5$var$isProduction = true;
var $5e954cbb8bebfdf5$var$spacesAndTabs = /[ \t]{2,}/g;
var $5e954cbb8bebfdf5$var$lineStartWithSpaces = /^[ \t]*/gm;
var $5e954cbb8bebfdf5$var$clean = function clean(value) {
    return value.replace($5e954cbb8bebfdf5$var$spacesAndTabs, ' ').replace($5e954cbb8bebfdf5$var$lineStartWithSpaces, '').trim();
};
var $5e954cbb8bebfdf5$var$getDevMessage = function getDevMessage(message) {
    return $5e954cbb8bebfdf5$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $5e954cbb8bebfdf5$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $5e954cbb8bebfdf5$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $5e954cbb8bebfdf5$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $5e954cbb8bebfdf5$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $5e954cbb8bebfdf5$var$log(type, message) {
    var _console;
    if ($5e954cbb8bebfdf5$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$5e954cbb8bebfdf5$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $5e954cbb8bebfdf5$var$getFormattedMessage(message));
}
var $5e954cbb8bebfdf5$var$warning = $5e954cbb8bebfdf5$var$log.bind(null, 'warn');
var $5e954cbb8bebfdf5$var$error = $5e954cbb8bebfdf5$var$log.bind(null, 'error');
function $5e954cbb8bebfdf5$var$noop() {}
function $5e954cbb8bebfdf5$var$getOptions(shared, fromBinding) {
    return (0, $kabSK.default)({}, shared, {}, fromBinding);
}
function $5e954cbb8bebfdf5$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $5e954cbb8bebfdf5$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $5e954cbb8bebfdf5$var$isProduction$1 = true;
var $5e954cbb8bebfdf5$var$prefix = 'Invariant failed';
function $5e954cbb8bebfdf5$var$RbdInvariant(message) {
    this.message = message;
}
$5e954cbb8bebfdf5$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $5e954cbb8bebfdf5$var$invariant(condition, message) {
    if (condition) return;
    if ($5e954cbb8bebfdf5$var$isProduction$1) throw new $5e954cbb8bebfdf5$var$RbdInvariant($5e954cbb8bebfdf5$var$prefix);
    else throw new $5e954cbb8bebfdf5$var$RbdInvariant($5e954cbb8bebfdf5$var$prefix + ": " + (message || ''));
}
var $5e954cbb8bebfdf5$var$ErrorBoundary = function(_React$Component) {
    (0, $iZ4XC.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $5e954cbb8bebfdf5$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $5e954cbb8bebfdf5$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $5e954cbb8bebfdf5$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $5e954cbb8bebfdf5$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Component);
var $5e954cbb8bebfdf5$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $5e954cbb8bebfdf5$var$position = function position(index) {
    return index + 1;
};
var $5e954cbb8bebfdf5$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $5e954cbb8bebfdf5$var$position(start.source.index) + "\n";
};
var $5e954cbb8bebfdf5$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $5e954cbb8bebfdf5$var$position(source.index);
    var endPosition = $5e954cbb8bebfdf5$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $5e954cbb8bebfdf5$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $5e954cbb8bebfdf5$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $5e954cbb8bebfdf5$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $5e954cbb8bebfdf5$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $5e954cbb8bebfdf5$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $5e954cbb8bebfdf5$var$position(source.index) + "\n";
};
var $5e954cbb8bebfdf5$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $5e954cbb8bebfdf5$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $5e954cbb8bebfdf5$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $5e954cbb8bebfdf5$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $5e954cbb8bebfdf5$var$returnedToStart(result.source) + "\n  ";
};
var $5e954cbb8bebfdf5$var$preset = {
    dragHandleUsageInstructions: $5e954cbb8bebfdf5$var$dragHandleUsageInstructions,
    onDragStart: $5e954cbb8bebfdf5$var$onDragStart,
    onDragUpdate: $5e954cbb8bebfdf5$var$onDragUpdate,
    onDragEnd: $5e954cbb8bebfdf5$var$onDragEnd
};
var $5e954cbb8bebfdf5$var$origin = {
    x: 0,
    y: 0
};
var $5e954cbb8bebfdf5$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $5e954cbb8bebfdf5$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $5e954cbb8bebfdf5$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $5e954cbb8bebfdf5$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $5e954cbb8bebfdf5$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $5e954cbb8bebfdf5$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $5e954cbb8bebfdf5$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $5e954cbb8bebfdf5$var$distance(target, point);
    }));
};
var $5e954cbb8bebfdf5$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $5e954cbb8bebfdf5$var$executeClip = function(frame, subject) {
    var result = (0, $122e8d919897451e$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $5e954cbb8bebfdf5$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $5e954cbb8bebfdf5$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $5e954cbb8bebfdf5$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $5e954cbb8bebfdf5$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $5e954cbb8bebfdf5$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $5e954cbb8bebfdf5$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $kabSK.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $5e954cbb8bebfdf5$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $5e954cbb8bebfdf5$var$executeClip(frame.pageMarginBox, target);
    return (0, $122e8d919897451e$export$4b834cebd9e5cebe)(target);
};
var $5e954cbb8bebfdf5$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $5e954cbb8bebfdf5$var$scroll(page.marginBox, frame);
    var increased = $5e954cbb8bebfdf5$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $5e954cbb8bebfdf5$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $5e954cbb8bebfdf5$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $5e954cbb8bebfdf5$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $5e954cbb8bebfdf5$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $5e954cbb8bebfdf5$var$negate(scrollDiff);
    var frame = (0, $kabSK.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $5e954cbb8bebfdf5$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $kabSK.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $5e954cbb8bebfdf5$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function $5e954cbb8bebfdf5$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $5e954cbb8bebfdf5$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $5e954cbb8bebfdf5$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $5e954cbb8bebfdf5$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $5e954cbb8bebfdf5$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $5e954cbb8bebfdf5$var$toDroppableMap = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $5e954cbb8bebfdf5$var$toDraggableMap = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $5e954cbb8bebfdf5$var$toDroppableList = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(droppables) {
    return $5e954cbb8bebfdf5$var$values(droppables);
});
var $5e954cbb8bebfdf5$var$toDraggableList = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(draggables) {
    return $5e954cbb8bebfdf5$var$values(draggables);
});
var $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $5e954cbb8bebfdf5$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $5e954cbb8bebfdf5$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $5e954cbb8bebfdf5$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $5e954cbb8bebfdf5$var$removeDraggableFromList = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $5e954cbb8bebfdf5$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $5e954cbb8bebfdf5$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $kabSK.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $5e954cbb8bebfdf5$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $5e954cbb8bebfdf5$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $5e954cbb8bebfdf5$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $5e954cbb8bebfdf5$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $5e954cbb8bebfdf5$var$noDisplacedBy = {
    point: $5e954cbb8bebfdf5$var$origin,
    value: 0
};
var $5e954cbb8bebfdf5$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $5e954cbb8bebfdf5$var$noImpact = {
    displaced: $5e954cbb8bebfdf5$var$emptyGroups,
    displacedBy: $5e954cbb8bebfdf5$var$noDisplacedBy,
    at: null
};
var $5e954cbb8bebfdf5$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $5e954cbb8bebfdf5$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $5e954cbb8bebfdf5$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $5e954cbb8bebfdf5$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $5e954cbb8bebfdf5$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $5e954cbb8bebfdf5$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $5e954cbb8bebfdf5$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $5e954cbb8bebfdf5$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $5e954cbb8bebfdf5$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $5e954cbb8bebfdf5$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $5e954cbb8bebfdf5$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $5e954cbb8bebfdf5$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $5e954cbb8bebfdf5$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $5e954cbb8bebfdf5$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $5e954cbb8bebfdf5$var$origin;
    return $5e954cbb8bebfdf5$var$offsetByPosition(target, displacement);
};
var $5e954cbb8bebfdf5$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $5e954cbb8bebfdf5$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $5e954cbb8bebfdf5$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $5e954cbb8bebfdf5$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $5e954cbb8bebfdf5$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $5e954cbb8bebfdf5$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $5e954cbb8bebfdf5$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $5e954cbb8bebfdf5$var$isVisible((0, $kabSK.default)({}, args, {
        isVisibleThroughFrameFn: $5e954cbb8bebfdf5$var$isPartiallyVisibleThroughFrame
    }));
};
var $5e954cbb8bebfdf5$var$isTotallyVisible = function isTotallyVisible(args) {
    return $5e954cbb8bebfdf5$var$isVisible((0, $kabSK.default)({}, args, {
        isVisibleThroughFrameFn: $5e954cbb8bebfdf5$var$isTotallyVisibleThroughFrame
    }));
};
var $5e954cbb8bebfdf5$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $5e954cbb8bebfdf5$var$isVisible((0, $kabSK.default)({}, args, {
        isVisibleThroughFrameFn: $5e954cbb8bebfdf5$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $5e954cbb8bebfdf5$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $5e954cbb8bebfdf5$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $122e8d919897451e$export$4b834cebd9e5cebe)((0, $122e8d919897451e$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $5e954cbb8bebfdf5$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $5e954cbb8bebfdf5$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $5e954cbb8bebfdf5$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $5e954cbb8bebfdf5$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $5e954cbb8bebfdf5$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $5e954cbb8bebfdf5$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $5e954cbb8bebfdf5$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $5e954cbb8bebfdf5$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $5e954cbb8bebfdf5$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $5e954cbb8bebfdf5$var$isHomeOf(draggable, destination);
    if (index == null) return $5e954cbb8bebfdf5$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $5e954cbb8bebfdf5$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $5e954cbb8bebfdf5$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $5e954cbb8bebfdf5$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $5e954cbb8bebfdf5$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $5e954cbb8bebfdf5$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $5e954cbb8bebfdf5$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $5e954cbb8bebfdf5$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $5e954cbb8bebfdf5$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $5e954cbb8bebfdf5$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $5e954cbb8bebfdf5$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $5e954cbb8bebfdf5$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $5e954cbb8bebfdf5$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $5e954cbb8bebfdf5$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $5e954cbb8bebfdf5$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $5e954cbb8bebfdf5$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($5e954cbb8bebfdf5$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $5e954cbb8bebfdf5$var$origin : $5e954cbb8bebfdf5$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $5e954cbb8bebfdf5$var$origin;
};
var $5e954cbb8bebfdf5$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $5e954cbb8bebfdf5$var$tryGetCombine(impact);
    !combine && $5e954cbb8bebfdf5$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $5e954cbb8bebfdf5$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $5e954cbb8bebfdf5$var$add(center, displaceBy);
};
var $5e954cbb8bebfdf5$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $5e954cbb8bebfdf5$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $5e954cbb8bebfdf5$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $5e954cbb8bebfdf5$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $5e954cbb8bebfdf5$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $5e954cbb8bebfdf5$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $5e954cbb8bebfdf5$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $5e954cbb8bebfdf5$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $5e954cbb8bebfdf5$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $5e954cbb8bebfdf5$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $5e954cbb8bebfdf5$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $5e954cbb8bebfdf5$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $5e954cbb8bebfdf5$var$patch(axis.line, moveInto.contentBox[axis.start] + $5e954cbb8bebfdf5$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $5e954cbb8bebfdf5$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $5e954cbb8bebfdf5$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $5e954cbb8bebfdf5$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($5e954cbb8bebfdf5$var$didStartAfterCritical(closestAfter, afterCritical)) return $5e954cbb8bebfdf5$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $122e8d919897451e$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $5e954cbb8bebfdf5$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($5e954cbb8bebfdf5$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $122e8d919897451e$export$cc800923e997bb8)(last.page, $5e954cbb8bebfdf5$var$negate(afterCritical.displacedBy.point));
        return $5e954cbb8bebfdf5$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $5e954cbb8bebfdf5$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $5e954cbb8bebfdf5$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $5e954cbb8bebfdf5$var$add(point, frame.scroll.diff.displacement);
};
var $5e954cbb8bebfdf5$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $5e954cbb8bebfdf5$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $5e954cbb8bebfdf5$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $5e954cbb8bebfdf5$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $5e954cbb8bebfdf5$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $5e954cbb8bebfdf5$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $5e954cbb8bebfdf5$var$scrollViewport = function(viewport, newScroll) {
    var diff = $5e954cbb8bebfdf5$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $5e954cbb8bebfdf5$var$negate(diff);
    var frame = (0, $122e8d919897451e$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $5e954cbb8bebfdf5$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $5e954cbb8bebfdf5$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $5e954cbb8bebfdf5$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $5e954cbb8bebfdf5$var$scrollViewport(viewport, $5e954cbb8bebfdf5$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $5e954cbb8bebfdf5$var$scrollDroppable(destination, $5e954cbb8bebfdf5$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $5e954cbb8bebfdf5$var$getDisplacementGroups({
        afterDragging: $5e954cbb8bebfdf5$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $5e954cbb8bebfdf5$var$getDisplacementGroups({
        afterDragging: $5e954cbb8bebfdf5$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $5e954cbb8bebfdf5$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $kabSK.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $5e954cbb8bebfdf5$var$withViewportDisplacement = function(viewport, point) {
    return $5e954cbb8bebfdf5$var$add(viewport.scroll.diff.displacement, point);
};
var $5e954cbb8bebfdf5$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $5e954cbb8bebfdf5$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $5e954cbb8bebfdf5$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $5e954cbb8bebfdf5$var$add(draggable.client.borderBox.center, offset);
};
var $5e954cbb8bebfdf5$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $5e954cbb8bebfdf5$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $5e954cbb8bebfdf5$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $5e954cbb8bebfdf5$var$isTotallyVisibleOnAxis(args) : $5e954cbb8bebfdf5$var$isTotallyVisible(args);
};
var $5e954cbb8bebfdf5$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $5e954cbb8bebfdf5$var$isHomeOf(draggable, destination);
    var impact = $5e954cbb8bebfdf5$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $5e954cbb8bebfdf5$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $5e954cbb8bebfdf5$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $5e954cbb8bebfdf5$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $5e954cbb8bebfdf5$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $5e954cbb8bebfdf5$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $5e954cbb8bebfdf5$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $5e954cbb8bebfdf5$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $5e954cbb8bebfdf5$var$invariant(false);
    return rect;
};
var $5e954cbb8bebfdf5$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $5e954cbb8bebfdf5$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $5e954cbb8bebfdf5$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $5e954cbb8bebfdf5$var$isPartiallyVisibleThroughFrame(viewport.frame)($5e954cbb8bebfdf5$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $5e954cbb8bebfdf5$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $5e954cbb8bebfdf5$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $5e954cbb8bebfdf5$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $5e954cbb8bebfdf5$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $5e954cbb8bebfdf5$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $5e954cbb8bebfdf5$var$getKnownActive(droppable)[axis.crossAxisStart] === $5e954cbb8bebfdf5$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $5e954cbb8bebfdf5$var$isWithin($5e954cbb8bebfdf5$var$getKnownActive(droppable)[axis.start], $5e954cbb8bebfdf5$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $5e954cbb8bebfdf5$var$getKnownActive(a)[axis.start] - $5e954cbb8bebfdf5$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $5e954cbb8bebfdf5$var$closest(pageBorderBoxCenter, $5e954cbb8bebfdf5$var$getCorners($5e954cbb8bebfdf5$var$getKnownActive(a)));
        var second = $5e954cbb8bebfdf5$var$closest(pageBorderBoxCenter, $5e954cbb8bebfdf5$var$getCorners($5e954cbb8bebfdf5$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $5e954cbb8bebfdf5$var$getKnownActive(a)[axis.start] - $5e954cbb8bebfdf5$var$getKnownActive(b)[axis.start];
    })[0];
};
var $5e954cbb8bebfdf5$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $5e954cbb8bebfdf5$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $5e954cbb8bebfdf5$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $5e954cbb8bebfdf5$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $5e954cbb8bebfdf5$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $5e954cbb8bebfdf5$var$offsetByPosition(original, $5e954cbb8bebfdf5$var$negate(afterCritical.displacedBy.point)) : original;
};
var $5e954cbb8bebfdf5$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $5e954cbb8bebfdf5$var$isTotallyVisible({
            target: $5e954cbb8bebfdf5$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $5e954cbb8bebfdf5$var$distance(pageBorderBoxCenter, $5e954cbb8bebfdf5$var$withDroppableDisplacement(destination, $5e954cbb8bebfdf5$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $5e954cbb8bebfdf5$var$distance(pageBorderBoxCenter, $5e954cbb8bebfdf5$var$withDroppableDisplacement(destination, $5e954cbb8bebfdf5$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $5e954cbb8bebfdf5$var$getDisplacedBy = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $5e954cbb8bebfdf5$var$patch(axis.line, displacement)
    };
});
var $5e954cbb8bebfdf5$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $5e954cbb8bebfdf5$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $5e954cbb8bebfdf5$var$patch(axis.line, needsToGrowBy);
};
var $5e954cbb8bebfdf5$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $kabSK.default)({}, frame, {
        scroll: (0, $kabSK.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $5e954cbb8bebfdf5$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$5e954cbb8bebfdf5$var$isHomeOf(draggable, droppable) && $5e954cbb8bebfdf5$var$invariant(false);
    !!droppable.subject.withPlaceholder && $5e954cbb8bebfdf5$var$invariant(false);
    var placeholderSize = $5e954cbb8bebfdf5$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $5e954cbb8bebfdf5$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $5e954cbb8bebfdf5$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $kabSK.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $5e954cbb8bebfdf5$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $5e954cbb8bebfdf5$var$withMaxScroll(frame, maxScroll);
    var subject = $5e954cbb8bebfdf5$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $kabSK.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $5e954cbb8bebfdf5$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $5e954cbb8bebfdf5$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $5e954cbb8bebfdf5$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $kabSK.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $5e954cbb8bebfdf5$var$invariant(false);
    var newFrame = $5e954cbb8bebfdf5$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $5e954cbb8bebfdf5$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $kabSK.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $5e954cbb8bebfdf5$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $5e954cbb8bebfdf5$var$emptyGroups,
            displacedBy: $5e954cbb8bebfdf5$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $5e954cbb8bebfdf5$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $5e954cbb8bebfdf5$var$isHomeOf(draggable, destination) ? destination : $5e954cbb8bebfdf5$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $5e954cbb8bebfdf5$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $5e954cbb8bebfdf5$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $5e954cbb8bebfdf5$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $5e954cbb8bebfdf5$var$emptyGroups,
        index: proposedIndex
    });
};
var $5e954cbb8bebfdf5$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $5e954cbb8bebfdf5$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $5e954cbb8bebfdf5$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $5e954cbb8bebfdf5$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $5e954cbb8bebfdf5$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $5e954cbb8bebfdf5$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $5e954cbb8bebfdf5$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $5e954cbb8bebfdf5$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $5e954cbb8bebfdf5$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $5e954cbb8bebfdf5$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $5e954cbb8bebfdf5$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $5e954cbb8bebfdf5$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $5e954cbb8bebfdf5$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $5e954cbb8bebfdf5$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $5e954cbb8bebfdf5$var$isPositionInFrame(frame) {
    var isWithinVertical = $5e954cbb8bebfdf5$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $5e954cbb8bebfdf5$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $5e954cbb8bebfdf5$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $5e954cbb8bebfdf5$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $5e954cbb8bebfdf5$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $5e954cbb8bebfdf5$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $5e954cbb8bebfdf5$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $5e954cbb8bebfdf5$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$5e954cbb8bebfdf5$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($5e954cbb8bebfdf5$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $5e954cbb8bebfdf5$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $5e954cbb8bebfdf5$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $5e954cbb8bebfdf5$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $122e8d919897451e$export$4b834cebd9e5cebe)($5e954cbb8bebfdf5$var$offsetByPosition(rect, point));
};
var $5e954cbb8bebfdf5$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $5e954cbb8bebfdf5$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $5e954cbb8bebfdf5$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $5e954cbb8bebfdf5$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $5e954cbb8bebfdf5$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $5e954cbb8bebfdf5$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $5e954cbb8bebfdf5$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $5e954cbb8bebfdf5$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $5e954cbb8bebfdf5$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $5e954cbb8bebfdf5$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $5e954cbb8bebfdf5$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $5e954cbb8bebfdf5$var$isHomeOf(draggable, destination)
    });
    return $5e954cbb8bebfdf5$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $5e954cbb8bebfdf5$var$combineThresholdDivisor = 4;
var $5e954cbb8bebfdf5$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $5e954cbb8bebfdf5$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $5e954cbb8bebfdf5$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $5e954cbb8bebfdf5$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $5e954cbb8bebfdf5$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $5e954cbb8bebfdf5$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $5e954cbb8bebfdf5$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $5e954cbb8bebfdf5$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $5e954cbb8bebfdf5$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $5e954cbb8bebfdf5$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $5e954cbb8bebfdf5$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $5e954cbb8bebfdf5$var$withDroppableScroll(destination, pageBorderBox);
    return $5e954cbb8bebfdf5$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $5e954cbb8bebfdf5$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $5e954cbb8bebfdf5$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $kabSK.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $5e954cbb8bebfdf5$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $5e954cbb8bebfdf5$var$whatIsDraggedOver(previousImpact);
    var now = $5e954cbb8bebfdf5$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $5e954cbb8bebfdf5$var$removePlaceholder(lastDroppable);
    return $5e954cbb8bebfdf5$var$patchDroppableMap(droppables, updated);
};
var $5e954cbb8bebfdf5$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $5e954cbb8bebfdf5$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $5e954cbb8bebfdf5$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($5e954cbb8bebfdf5$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $5e954cbb8bebfdf5$var$addPlaceholder(droppable, draggable, draggables);
    return $5e954cbb8bebfdf5$var$patchDroppableMap(cleaned, patched);
};
var $5e954cbb8bebfdf5$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $5e954cbb8bebfdf5$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $5e954cbb8bebfdf5$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $5e954cbb8bebfdf5$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $5e954cbb8bebfdf5$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $5e954cbb8bebfdf5$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $kabSK.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $5e954cbb8bebfdf5$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $5e954cbb8bebfdf5$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $kabSK.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $5e954cbb8bebfdf5$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $5e954cbb8bebfdf5$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $5e954cbb8bebfdf5$var$getDraggables$1(last.all, draggables);
    var displaced = $5e954cbb8bebfdf5$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $kabSK.default)({}, impact, {
        displaced: displaced
    });
};
var $5e954cbb8bebfdf5$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $5e954cbb8bebfdf5$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $5e954cbb8bebfdf5$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $5e954cbb8bebfdf5$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $5e954cbb8bebfdf5$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $5e954cbb8bebfdf5$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $5e954cbb8bebfdf5$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $5e954cbb8bebfdf5$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $5e954cbb8bebfdf5$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $5e954cbb8bebfdf5$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $5e954cbb8bebfdf5$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $5e954cbb8bebfdf5$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $5e954cbb8bebfdf5$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $5e954cbb8bebfdf5$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $5e954cbb8bebfdf5$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $5e954cbb8bebfdf5$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $5e954cbb8bebfdf5$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $5e954cbb8bebfdf5$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $5e954cbb8bebfdf5$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $5e954cbb8bebfdf5$var$start = function start(key) {};
var $5e954cbb8bebfdf5$var$finish = function finish(key) {};
var $5e954cbb8bebfdf5$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $122e8d919897451e$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $122e8d919897451e$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $kabSK.default)({}, draggable, {
        placeholder: (0, $kabSK.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $5e954cbb8bebfdf5$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $5e954cbb8bebfdf5$var$invariant(false);
    return frame;
};
var $5e954cbb8bebfdf5$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $5e954cbb8bebfdf5$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $5e954cbb8bebfdf5$var$add(windowScrollChange, droppableScrollChange);
        var moved = $5e954cbb8bebfdf5$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $5e954cbb8bebfdf5$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $5e954cbb8bebfdf5$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $5e954cbb8bebfdf5$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $kabSK.default)({}, state.dimensions.droppables, {}, $5e954cbb8bebfdf5$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $5e954cbb8bebfdf5$var$toDraggableMap($5e954cbb8bebfdf5$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $kabSK.default)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $5e954cbb8bebfdf5$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $5e954cbb8bebfdf5$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $5e954cbb8bebfdf5$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $5e954cbb8bebfdf5$var$finish();
    var draggingState = (0, $kabSK.default)({
        phase: 'DRAGGING'
    }, state, {
        phase: 'DRAGGING',
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $kabSK.default)({
        phase: 'DROP_PENDING'
    }, draggingState, {
        phase: 'DROP_PENDING',
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $5e954cbb8bebfdf5$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $5e954cbb8bebfdf5$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $5e954cbb8bebfdf5$var$patchDimensionMap(state.dimensions, updated);
    if (!$5e954cbb8bebfdf5$var$isSnapping(state) || isEnabledChanging) return $5e954cbb8bebfdf5$var$update({
        state: state,
        dimensions: dimensions
    });
    return $5e954cbb8bebfdf5$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $5e954cbb8bebfdf5$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $kabSK.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $5e954cbb8bebfdf5$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $5e954cbb8bebfdf5$var$reducer = function(state, action) {
    if (state === void 0) state = $5e954cbb8bebfdf5$var$idle;
    if (action.type === 'FLUSH') return (0, $kabSK.default)({}, $5e954cbb8bebfdf5$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $5e954cbb8bebfdf5$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $5e954cbb8bebfdf5$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $5e954cbb8bebfdf5$var$add(client.selection, viewport.scroll.initial),
                offset: $5e954cbb8bebfdf5$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $5e954cbb8bebfdf5$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $5e954cbb8bebfdf5$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $5e954cbb8bebfdf5$var$invariant(false);
        var _result = (0, $kabSK.default)({
            phase: 'COLLECTING'
        }, state, {
            phase: 'COLLECTING'
        });
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $5e954cbb8bebfdf5$var$invariant(false);
        return $5e954cbb8bebfdf5$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$5e954cbb8bebfdf5$var$isMovementAllowed(state) && $5e954cbb8bebfdf5$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($5e954cbb8bebfdf5$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $5e954cbb8bebfdf5$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $5e954cbb8bebfdf5$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $5e954cbb8bebfdf5$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $5e954cbb8bebfdf5$var$removeScrollJumpRequest(state);
        !$5e954cbb8bebfdf5$var$isMovementAllowed(state) && $5e954cbb8bebfdf5$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $5e954cbb8bebfdf5$var$scrollDroppable(target, newScroll);
        return $5e954cbb8bebfdf5$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$5e954cbb8bebfdf5$var$isMovementAllowed(state) && $5e954cbb8bebfdf5$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $5e954cbb8bebfdf5$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $5e954cbb8bebfdf5$var$invariant(false);
        var updated = (0, $kabSK.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $5e954cbb8bebfdf5$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$5e954cbb8bebfdf5$var$isMovementAllowed(state) && $5e954cbb8bebfdf5$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $5e954cbb8bebfdf5$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $5e954cbb8bebfdf5$var$invariant(false);
        var _updated = (0, $kabSK.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $5e954cbb8bebfdf5$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$5e954cbb8bebfdf5$var$isMovementAllowed(state) && $5e954cbb8bebfdf5$var$invariant(false);
        !state.isWindowScrollAllowed && $5e954cbb8bebfdf5$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($5e954cbb8bebfdf5$var$isEqual(state.viewport.scroll.current, _newScroll)) return $5e954cbb8bebfdf5$var$removeScrollJumpRequest(state);
        var _viewport = $5e954cbb8bebfdf5$var$scrollViewport(state.viewport, _newScroll);
        if ($5e954cbb8bebfdf5$var$isSnapping(state)) return $5e954cbb8bebfdf5$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $5e954cbb8bebfdf5$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$5e954cbb8bebfdf5$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($5e954cbb8bebfdf5$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $kabSK.default)({}, state.viewport, {
            scroll: (0, $kabSK.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $kabSK.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $5e954cbb8bebfdf5$var$invariant(false);
        var _result2 = $5e954cbb8bebfdf5$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $5e954cbb8bebfdf5$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $5e954cbb8bebfdf5$var$invariant(false);
        var newState = (0, $kabSK.default)({
            phase: 'DROP_PENDING'
        }, state, {
            phase: 'DROP_PENDING',
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $5e954cbb8bebfdf5$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $5e954cbb8bebfdf5$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $5e954cbb8bebfdf5$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $5e954cbb8bebfdf5$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $5e954cbb8bebfdf5$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $5e954cbb8bebfdf5$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $5e954cbb8bebfdf5$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($5e954cbb8bebfdf5$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
                dispatch($5e954cbb8bebfdf5$var$flush());
                dispatch($5e954cbb8bebfdf5$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $5e954cbb8bebfdf5$var$validateDimensions(critical, dimensions);
                dispatch($5e954cbb8bebfdf5$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $5e954cbb8bebfdf5$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $5e954cbb8bebfdf5$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $5e954cbb8bebfdf5$var$outOfTheWayTiming = $5e954cbb8bebfdf5$var$timings.outOfTheWay + "s " + $5e954cbb8bebfdf5$var$curves.outOfTheWay;
var $5e954cbb8bebfdf5$var$transitions = {
    fluid: "opacity " + $5e954cbb8bebfdf5$var$outOfTheWayTiming,
    snap: "transform " + $5e954cbb8bebfdf5$var$outOfTheWayTiming + ", opacity " + $5e954cbb8bebfdf5$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $5e954cbb8bebfdf5$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $5e954cbb8bebfdf5$var$outOfTheWayTiming,
    placeholder: "height " + $5e954cbb8bebfdf5$var$outOfTheWayTiming + ", width " + $5e954cbb8bebfdf5$var$outOfTheWayTiming + ", margin " + $5e954cbb8bebfdf5$var$outOfTheWayTiming
};
var $5e954cbb8bebfdf5$var$moveTo = function moveTo(offset) {
    return $5e954cbb8bebfdf5$var$isEqual(offset, $5e954cbb8bebfdf5$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $5e954cbb8bebfdf5$var$transforms = {
    moveTo: $5e954cbb8bebfdf5$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $5e954cbb8bebfdf5$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $5e954cbb8bebfdf5$var$combine.scale.drop + ")";
    }
};
var $5e954cbb8bebfdf5$var$minDropTime = $5e954cbb8bebfdf5$var$timings.minDropTime, $5e954cbb8bebfdf5$var$maxDropTime = $5e954cbb8bebfdf5$var$timings.maxDropTime;
var $5e954cbb8bebfdf5$var$dropTimeRange = $5e954cbb8bebfdf5$var$maxDropTime - $5e954cbb8bebfdf5$var$minDropTime;
var $5e954cbb8bebfdf5$var$maxDropTimeAtDistance = 1500;
var $5e954cbb8bebfdf5$var$cancelDropModifier = 0.6;
var $5e954cbb8bebfdf5$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $5e954cbb8bebfdf5$var$distance(current, destination);
    if (distance$1 <= 0) return $5e954cbb8bebfdf5$var$minDropTime;
    if (distance$1 >= $5e954cbb8bebfdf5$var$maxDropTimeAtDistance) return $5e954cbb8bebfdf5$var$maxDropTime;
    var percentage = distance$1 / $5e954cbb8bebfdf5$var$maxDropTimeAtDistance;
    var duration = $5e954cbb8bebfdf5$var$minDropTime + $5e954cbb8bebfdf5$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $5e954cbb8bebfdf5$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $5e954cbb8bebfdf5$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $5e954cbb8bebfdf5$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $5e954cbb8bebfdf5$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $5e954cbb8bebfdf5$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $5e954cbb8bebfdf5$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $5e954cbb8bebfdf5$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $kabSK.default)({}, lastImpact, {
        displaced: $5e954cbb8bebfdf5$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $5e954cbb8bebfdf5$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($5e954cbb8bebfdf5$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $5e954cbb8bebfdf5$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $5e954cbb8bebfdf5$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $5e954cbb8bebfdf5$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $5e954cbb8bebfdf5$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $5e954cbb8bebfdf5$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $5e954cbb8bebfdf5$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$5e954cbb8bebfdf5$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($5e954cbb8bebfdf5$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $5e954cbb8bebfdf5$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($5e954cbb8bebfdf5$var$animateDrop(args));
        };
    };
};
var $5e954cbb8bebfdf5$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $5e954cbb8bebfdf5$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $5e954cbb8bebfdf5$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($5e954cbb8bebfdf5$var$getWindowScroll());
    }
    var scheduled = (0, $34aef3fc575d5445$export$2e2bcd8739ae039)(updateScroll);
    var binding = $5e954cbb8bebfdf5$var$getWindowScrollBinding(scheduled);
    var unbind = $5e954cbb8bebfdf5$var$noop;
    function isActive() {
        return unbind !== $5e954cbb8bebfdf5$var$noop;
    }
    function start() {
        !!isActive() && $5e954cbb8bebfdf5$var$invariant(false);
        unbind = $5e954cbb8bebfdf5$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $5e954cbb8bebfdf5$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $5e954cbb8bebfdf5$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $5e954cbb8bebfdf5$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $5e954cbb8bebfdf5$var$scrollListener = function(store) {
    var listener = $5e954cbb8bebfdf5$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($5e954cbb8bebfdf5$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $5e954cbb8bebfdf5$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $5e954cbb8bebfdf5$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $5e954cbb8bebfdf5$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $5e954cbb8bebfdf5$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $5e954cbb8bebfdf5$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $5e954cbb8bebfdf5$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $5e954cbb8bebfdf5$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $5e954cbb8bebfdf5$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $5e954cbb8bebfdf5$var$withTimings = function withTimings(key, fn) {
    $5e954cbb8bebfdf5$var$start();
    fn();
    $5e954cbb8bebfdf5$var$finish();
};
var $5e954cbb8bebfdf5$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $5e954cbb8bebfdf5$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $5e954cbb8bebfdf5$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $5e954cbb8bebfdf5$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $5e954cbb8bebfdf5$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $5e954cbb8bebfdf5$var$invariant(false);
        $5e954cbb8bebfdf5$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $5e954cbb8bebfdf5$var$invariant(false);
        $5e954cbb8bebfdf5$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($5e954cbb8bebfdf5$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var data = $5e954cbb8bebfdf5$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $5e954cbb8bebfdf5$var$withTimings('onDragStart', function() {
                return $5e954cbb8bebfdf5$var$execute(getResponders().onDragStart, data, announce, $5e954cbb8bebfdf5$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $5e954cbb8bebfdf5$var$tryGetDestination(impact);
        var combine = $5e954cbb8bebfdf5$var$tryGetCombine(impact);
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var hasCriticalChanged = !$5e954cbb8bebfdf5$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$5e954cbb8bebfdf5$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$5e954cbb8bebfdf5$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $kabSK.default)({}, $5e954cbb8bebfdf5$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $5e954cbb8bebfdf5$var$withTimings('onDragUpdate', function() {
                return $5e954cbb8bebfdf5$var$execute(getResponders().onDragUpdate, data, announce, $5e954cbb8bebfdf5$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        dragging = null;
        $5e954cbb8bebfdf5$var$withTimings('onDragEnd', function() {
            return $5e954cbb8bebfdf5$var$execute(getResponders().onDragEnd, result, announce, $5e954cbb8bebfdf5$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $kabSK.default)({}, $5e954cbb8bebfdf5$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $5e954cbb8bebfdf5$var$responders = function(getResponders, announce) {
    var publisher = $5e954cbb8bebfdf5$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $5e954cbb8bebfdf5$var$invariant(false);
            store.dispatch($5e954cbb8bebfdf5$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $5e954cbb8bebfdf5$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($5e954cbb8bebfdf5$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $5e954cbb8bebfdf5$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $5e954cbb8bebfdf5$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $5e954cbb8bebfdf5$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($5e954cbb8bebfdf5$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $5e954cbb8bebfdf5$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $5e954cbb8bebfdf5$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($5e954cbb8bebfdf5$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $5e954cbb8bebfdf5$var$composeEnhancers = (0, $7bd5d83317c8c48a$export$f672e0b6f7222cd7);
var $5e954cbb8bebfdf5$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $7bd5d83317c8c48a$export$f51a9068ac82ea43)($5e954cbb8bebfdf5$var$reducer, $5e954cbb8bebfdf5$var$composeEnhancers((0, $7bd5d83317c8c48a$export$9ff26e0402cc7b7)($5e954cbb8bebfdf5$var$style(styleMarshal), $5e954cbb8bebfdf5$var$dimensionMarshalStopper(dimensionMarshal), $5e954cbb8bebfdf5$var$lift$1(dimensionMarshal), $5e954cbb8bebfdf5$var$drop$1, $5e954cbb8bebfdf5$var$dropAnimationFinish, $5e954cbb8bebfdf5$var$dropAnimationFlushOnScroll, $5e954cbb8bebfdf5$var$pendingDrop, $5e954cbb8bebfdf5$var$autoScroll(autoScroller), $5e954cbb8bebfdf5$var$scrollListener, $5e954cbb8bebfdf5$var$focus(focusMarshal), $5e954cbb8bebfdf5$var$responders(getResponders, announce))));
};
var $5e954cbb8bebfdf5$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $5e954cbb8bebfdf5$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $5e954cbb8bebfdf5$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $5e954cbb8bebfdf5$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($5e954cbb8bebfdf5$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $5e954cbb8bebfdf5$var$clean$1();
            $5e954cbb8bebfdf5$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $5e954cbb8bebfdf5$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $5e954cbb8bebfdf5$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $5e954cbb8bebfdf5$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $5e954cbb8bebfdf5$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $5e954cbb8bebfdf5$var$invariant(false);
    return doc;
};
var $5e954cbb8bebfdf5$var$getMaxWindowScroll = function() {
    var doc = $5e954cbb8bebfdf5$var$getDocumentElement();
    var maxScroll = $5e954cbb8bebfdf5$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $5e954cbb8bebfdf5$var$getViewport = function() {
    var scroll = $5e954cbb8bebfdf5$var$getWindowScroll();
    var maxScroll = $5e954cbb8bebfdf5$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $5e954cbb8bebfdf5$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $122e8d919897451e$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $5e954cbb8bebfdf5$var$origin,
                displacement: $5e954cbb8bebfdf5$var$origin
            }
        }
    };
    return viewport;
};
var $5e954cbb8bebfdf5$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $5e954cbb8bebfdf5$var$start();
    var viewport = $5e954cbb8bebfdf5$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $5e954cbb8bebfdf5$var$toDraggableMap(draggables),
        droppables: $5e954cbb8bebfdf5$var$toDroppableMap(droppables)
    };
    $5e954cbb8bebfdf5$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $5e954cbb8bebfdf5$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $5e954cbb8bebfdf5$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $5e954cbb8bebfdf5$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $5e954cbb8bebfdf5$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $5e954cbb8bebfdf5$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $5e954cbb8bebfdf5$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $5e954cbb8bebfdf5$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($5e954cbb8bebfdf5$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($5e954cbb8bebfdf5$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $5e954cbb8bebfdf5$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $5e954cbb8bebfdf5$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $5e954cbb8bebfdf5$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $5e954cbb8bebfdf5$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $5e954cbb8bebfdf5$var$getScrollableDroppables = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(droppables) {
    return $5e954cbb8bebfdf5$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $5e954cbb8bebfdf5$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $5e954cbb8bebfdf5$var$find($5e954cbb8bebfdf5$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $5e954cbb8bebfdf5$var$invariant(false);
        return $5e954cbb8bebfdf5$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $5e954cbb8bebfdf5$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $5e954cbb8bebfdf5$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $5e954cbb8bebfdf5$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $5e954cbb8bebfdf5$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $5e954cbb8bebfdf5$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $5e954cbb8bebfdf5$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $5e954cbb8bebfdf5$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $5e954cbb8bebfdf5$var$minScroll = 1;
var $5e954cbb8bebfdf5$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $5e954cbb8bebfdf5$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $5e954cbb8bebfdf5$var$minScroll;
    var percentageFromMaxScrollValueAt = $5e954cbb8bebfdf5$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $5e954cbb8bebfdf5$var$config.maxPixelScroll * $5e954cbb8bebfdf5$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $5e954cbb8bebfdf5$var$accelerateAt = $5e954cbb8bebfdf5$var$config.durationDampening.accelerateAt;
var $5e954cbb8bebfdf5$var$stopAt = $5e954cbb8bebfdf5$var$config.durationDampening.stopDampeningAt;
var $5e954cbb8bebfdf5$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $5e954cbb8bebfdf5$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $5e954cbb8bebfdf5$var$stopAt) return proposedScroll;
    if (runTime < $5e954cbb8bebfdf5$var$accelerateAt) return $5e954cbb8bebfdf5$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $5e954cbb8bebfdf5$var$getPercentage({
        startOfRange: $5e954cbb8bebfdf5$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $5e954cbb8bebfdf5$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $5e954cbb8bebfdf5$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $5e954cbb8bebfdf5$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($5e954cbb8bebfdf5$var$dampenValueByTime(scroll, dragStartTime), $5e954cbb8bebfdf5$var$minScroll);
};
var $5e954cbb8bebfdf5$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $5e954cbb8bebfdf5$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $5e954cbb8bebfdf5$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $5e954cbb8bebfdf5$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $5e954cbb8bebfdf5$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $5e954cbb8bebfdf5$var$clean$2 = $5e954cbb8bebfdf5$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $5e954cbb8bebfdf5$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $5e954cbb8bebfdf5$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $5e954cbb8bebfdf5$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $5e954cbb8bebfdf5$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $5e954cbb8bebfdf5$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $5e954cbb8bebfdf5$var$clean$2({
        x: x,
        y: y
    });
    if ($5e954cbb8bebfdf5$var$isEqual(required, $5e954cbb8bebfdf5$var$origin)) return null;
    var limited = $5e954cbb8bebfdf5$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $5e954cbb8bebfdf5$var$isEqual(limited, $5e954cbb8bebfdf5$var$origin) ? null : limited;
};
var $5e954cbb8bebfdf5$var$smallestSigned = $5e954cbb8bebfdf5$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $5e954cbb8bebfdf5$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $5e954cbb8bebfdf5$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($5e954cbb8bebfdf5$var$isEqual(overlap, $5e954cbb8bebfdf5$var$origin)) return null;
        return overlap;
    };
}();
var $5e954cbb8bebfdf5$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $5e954cbb8bebfdf5$var$smallestSigned(change);
    var overlap = $5e954cbb8bebfdf5$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $5e954cbb8bebfdf5$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $5e954cbb8bebfdf5$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $5e954cbb8bebfdf5$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$5e954cbb8bebfdf5$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $5e954cbb8bebfdf5$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $5e954cbb8bebfdf5$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $5e954cbb8bebfdf5$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $5e954cbb8bebfdf5$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$5e954cbb8bebfdf5$var$canScrollDroppable(droppable, change)) return null;
    return $5e954cbb8bebfdf5$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $5e954cbb8bebfdf5$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $5e954cbb8bebfdf5$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $5e954cbb8bebfdf5$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $5e954cbb8bebfdf5$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $5e954cbb8bebfdf5$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $5e954cbb8bebfdf5$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $5e954cbb8bebfdf5$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $5e954cbb8bebfdf5$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $5e954cbb8bebfdf5$var$getBestScrollableDroppable({
        center: center,
        destination: $5e954cbb8bebfdf5$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $5e954cbb8bebfdf5$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $5e954cbb8bebfdf5$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $34aef3fc575d5445$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $34aef3fc575d5445$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $5e954cbb8bebfdf5$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $5e954cbb8bebfdf5$var$start();
        !!dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $5e954cbb8bebfdf5$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $5e954cbb8bebfdf5$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $5e954cbb8bebfdf5$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $5e954cbb8bebfdf5$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$5e954cbb8bebfdf5$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $5e954cbb8bebfdf5$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $5e954cbb8bebfdf5$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $5e954cbb8bebfdf5$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$5e954cbb8bebfdf5$var$canScrollWindow(viewport, change)) return change;
        var overlap = $5e954cbb8bebfdf5$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $5e954cbb8bebfdf5$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $5e954cbb8bebfdf5$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $5e954cbb8bebfdf5$var$whatIsDraggedOver(state.impact);
        !destination && $5e954cbb8bebfdf5$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $5e954cbb8bebfdf5$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $5e954cbb8bebfdf5$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $5e954cbb8bebfdf5$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $5e954cbb8bebfdf5$var$prefix$1 = 'data-rbd';
var $5e954cbb8bebfdf5$var$dragHandle = function() {
    var base = $5e954cbb8bebfdf5$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $5e954cbb8bebfdf5$var$draggable = function() {
    var base = $5e954cbb8bebfdf5$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $5e954cbb8bebfdf5$var$droppable = function() {
    var base = $5e954cbb8bebfdf5$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $5e954cbb8bebfdf5$var$scrollContainer = {
    contextId: $5e954cbb8bebfdf5$var$prefix$1 + "-scroll-container-context-id"
};
var $5e954cbb8bebfdf5$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $5e954cbb8bebfdf5$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $5e954cbb8bebfdf5$var$noPointerEvents = 'pointer-events: none;';
var $5e954cbb8bebfdf5$var$getStyles$1 = function(contextId) {
    var getSelector = $5e954cbb8bebfdf5$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($5e954cbb8bebfdf5$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $5e954cbb8bebfdf5$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $5e954cbb8bebfdf5$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($5e954cbb8bebfdf5$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($5e954cbb8bebfdf5$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $5e954cbb8bebfdf5$var$getStyles(rules, 'always'),
        resting: $5e954cbb8bebfdf5$var$getStyles(rules, 'resting'),
        dragging: $5e954cbb8bebfdf5$var$getStyles(rules, 'dragging'),
        dropAnimating: $5e954cbb8bebfdf5$var$getStyles(rules, 'dropAnimating'),
        userCancel: $5e954cbb8bebfdf5$var$getStyles(rules, 'userCancel')
    };
};
var $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $1bxDW.useLayoutEffect) : (0, $1bxDW.useEffect);
var $5e954cbb8bebfdf5$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $5e954cbb8bebfdf5$var$invariant(false);
    return head;
};
var $5e954cbb8bebfdf5$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $5e954cbb8bebfdf5$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $1bxDW.useRef)(null);
    var dynamicRef = (0, $1bxDW.useRef)(null);
    var setDynamicStyle = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)((0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $5e954cbb8bebfdf5$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $5e954cbb8bebfdf5$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $5e954cbb8bebfdf5$var$invariant(false);
        var always = $5e954cbb8bebfdf5$var$createStyleEl(nonce);
        var dynamic = $5e954cbb8bebfdf5$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($5e954cbb8bebfdf5$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($5e954cbb8bebfdf5$var$prefix$1 + "-dynamic", contextId);
        $5e954cbb8bebfdf5$var$getHead().appendChild(always);
        $5e954cbb8bebfdf5$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $5e954cbb8bebfdf5$var$invariant(false);
                $5e954cbb8bebfdf5$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $5e954cbb8bebfdf5$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $5e954cbb8bebfdf5$var$isHtmlElement(el) {
    return el instanceof $5e954cbb8bebfdf5$var$getWindowFromEl(el).HTMLElement;
}
function $5e954cbb8bebfdf5$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $5e954cbb8bebfdf5$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $5e954cbb8bebfdf5$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $5e954cbb8bebfdf5$var$find(possible, function(el) {
        return el.getAttribute($5e954cbb8bebfdf5$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$5e954cbb8bebfdf5$var$isHtmlElement(handle)) return null;
    return handle;
}
function $5e954cbb8bebfdf5$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $1bxDW.useRef)({});
    var recordRef = (0, $1bxDW.useRef)(null);
    var restoreFocusFrameRef = (0, $1bxDW.useRef)(null);
    var isMountedRef = (0, $1bxDW.useRef)(false);
    var register = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $5e954cbb8bebfdf5$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($5e954cbb8bebfdf5$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $5e954cbb8bebfdf5$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $5e954cbb8bebfdf5$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $5e954cbb8bebfdf5$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $5e954cbb8bebfdf5$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $5e954cbb8bebfdf5$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $5e954cbb8bebfdf5$var$useRegistry() {
    var registry = (0, $d037a9ec4120d05c$export$1538c33de8887b59)($5e954cbb8bebfdf5$var$createRegistry, []);
    (0, $1bxDW.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $5e954cbb8bebfdf5$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext(null);
var $5e954cbb8bebfdf5$var$getBodyElement = function() {
    var body = document.body;
    !body && $5e954cbb8bebfdf5$var$invariant(false);
    return body;
};
var $5e954cbb8bebfdf5$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $5e954cbb8bebfdf5$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $5e954cbb8bebfdf5$var$useAnnouncer(contextId) {
    var id = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $1bxDW.useRef)(null);
    (0, $1bxDW.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        (0, $kabSK.default)(el.style, $5e954cbb8bebfdf5$var$visuallyHidden);
        $5e954cbb8bebfdf5$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $5e954cbb8bebfdf5$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $5e954cbb8bebfdf5$var$count = 0;
var $5e954cbb8bebfdf5$var$defaults = {
    separator: '::'
};
function $5e954cbb8bebfdf5$var$reset() {
    $5e954cbb8bebfdf5$var$count = 0;
}
function $5e954cbb8bebfdf5$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $5e954cbb8bebfdf5$var$defaults;
    return (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return "" + prefix + options.separator + $5e954cbb8bebfdf5$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $5e954cbb8bebfdf5$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $5e954cbb8bebfdf5$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $5e954cbb8bebfdf5$var$useUniqueId('hidden-text', {
        separator: '-'
    });
    var id = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $1bxDW.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = text;
        el.style.display = 'none';
        $5e954cbb8bebfdf5$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $5e954cbb8bebfdf5$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $5e954cbb8bebfdf5$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext(null);
var $5e954cbb8bebfdf5$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $5e954cbb8bebfdf5$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $5e954cbb8bebfdf5$var$getVersion = function getVersion(value) {
    var result = $5e954cbb8bebfdf5$var$semver.exec(value);
    !(result != null) && $5e954cbb8bebfdf5$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $5e954cbb8bebfdf5$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $5e954cbb8bebfdf5$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $5e954cbb8bebfdf5$var$getVersion(peerDepValue);
    var actual = $5e954cbb8bebfdf5$var$getVersion(actualValue);
    if ($5e954cbb8bebfdf5$var$isSatisfied(peerDep, actual)) return;
};
var $5e954cbb8bebfdf5$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $5e954cbb8bebfdf5$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $5e954cbb8bebfdf5$var$useDev(useHook) {}
function $5e954cbb8bebfdf5$var$useDevSetupWarning(fn, inputs) {
    $5e954cbb8bebfdf5$var$useDev(function() {
        (0, $1bxDW.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $5e954cbb8bebfdf5$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $5e954cbb8bebfdf5$var$useStartupValidation() {
    $5e954cbb8bebfdf5$var$useDevSetupWarning(function() {
        $5e954cbb8bebfdf5$var$checkReactVersion($5e954cbb8bebfdf5$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).version);
        $5e954cbb8bebfdf5$var$checkDoctype(document);
    }, []);
}
function $5e954cbb8bebfdf5$var$usePrevious(current) {
    var ref = (0, $1bxDW.useRef)(current);
    (0, $1bxDW.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $5e954cbb8bebfdf5$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $5e954cbb8bebfdf5$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $5e954cbb8bebfdf5$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $5e954cbb8bebfdf5$var$tab = 9;
var $5e954cbb8bebfdf5$var$enter = 13;
var $5e954cbb8bebfdf5$var$escape = 27;
var $5e954cbb8bebfdf5$var$space = 32;
var $5e954cbb8bebfdf5$var$pageUp = 33;
var $5e954cbb8bebfdf5$var$pageDown = 34;
var $5e954cbb8bebfdf5$var$end = 35;
var $5e954cbb8bebfdf5$var$home = 36;
var $5e954cbb8bebfdf5$var$arrowLeft = 37;
var $5e954cbb8bebfdf5$var$arrowUp = 38;
var $5e954cbb8bebfdf5$var$arrowRight = 39;
var $5e954cbb8bebfdf5$var$arrowDown = 40;
var $5e954cbb8bebfdf5$var$_preventedKeys;
var $5e954cbb8bebfdf5$var$preventedKeys = ($5e954cbb8bebfdf5$var$_preventedKeys = {}, $5e954cbb8bebfdf5$var$_preventedKeys[$5e954cbb8bebfdf5$var$enter] = true, $5e954cbb8bebfdf5$var$_preventedKeys[$5e954cbb8bebfdf5$var$tab] = true, $5e954cbb8bebfdf5$var$_preventedKeys);
var $5e954cbb8bebfdf5$var$preventStandardKeyEvents = function(event) {
    if ($5e954cbb8bebfdf5$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $5e954cbb8bebfdf5$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $5e954cbb8bebfdf5$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $5e954cbb8bebfdf5$var$primaryButton = 0;
var $5e954cbb8bebfdf5$var$sloppyClickThreshold = 5;
function $5e954cbb8bebfdf5$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $5e954cbb8bebfdf5$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $5e954cbb8bebfdf5$var$sloppyClickThreshold;
}
var $5e954cbb8bebfdf5$var$idle$1 = {
    type: 'IDLE'
};
function $5e954cbb8bebfdf5$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $5e954cbb8bebfdf5$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $5e954cbb8bebfdf5$var$invariant(false);
                var pending = phase.point;
                if (!$5e954cbb8bebfdf5$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $5e954cbb8bebfdf5$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $5e954cbb8bebfdf5$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $5e954cbb8bebfdf5$var$useMouseSensor(api) {
    var phaseRef = (0, $1bxDW.useRef)($5e954cbb8bebfdf5$var$idle$1);
    var unbindEventsRef = (0, $1bxDW.useRef)($5e954cbb8bebfdf5$var$noop);
    var startCaptureBinding = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $5e954cbb8bebfdf5$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $5e954cbb8bebfdf5$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $5e954cbb8bebfdf5$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $5e954cbb8bebfdf5$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $5e954cbb8bebfdf5$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $5e954cbb8bebfdf5$var$_scrollJumpKeys;
function $5e954cbb8bebfdf5$var$noop$1() {}
var $5e954cbb8bebfdf5$var$scrollJumpKeys = ($5e954cbb8bebfdf5$var$_scrollJumpKeys = {}, $5e954cbb8bebfdf5$var$_scrollJumpKeys[$5e954cbb8bebfdf5$var$pageDown] = true, $5e954cbb8bebfdf5$var$_scrollJumpKeys[$5e954cbb8bebfdf5$var$pageUp] = true, $5e954cbb8bebfdf5$var$_scrollJumpKeys[$5e954cbb8bebfdf5$var$home] = true, $5e954cbb8bebfdf5$var$_scrollJumpKeys[$5e954cbb8bebfdf5$var$end] = true, $5e954cbb8bebfdf5$var$_scrollJumpKeys);
function $5e954cbb8bebfdf5$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $5e954cbb8bebfdf5$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($5e954cbb8bebfdf5$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $5e954cbb8bebfdf5$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $5e954cbb8bebfdf5$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $5e954cbb8bebfdf5$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $1bxDW.useRef)($5e954cbb8bebfdf5$var$noop$1);
    var startCaptureBinding = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $5e954cbb8bebfdf5$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $5e954cbb8bebfdf5$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $5e954cbb8bebfdf5$var$bindEvents(window, $5e954cbb8bebfdf5$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $5e954cbb8bebfdf5$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $5e954cbb8bebfdf5$var$idle$2 = {
    type: 'IDLE'
};
var $5e954cbb8bebfdf5$var$timeForLongPress = 120;
var $5e954cbb8bebfdf5$var$forcePressThreshold = 0.15;
function $5e954cbb8bebfdf5$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $5e954cbb8bebfdf5$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $5e954cbb8bebfdf5$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $5e954cbb8bebfdf5$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $5e954cbb8bebfdf5$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $5e954cbb8bebfdf5$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $5e954cbb8bebfdf5$var$useMouseSensor$1(api) {
    var phaseRef = (0, $1bxDW.useRef)($5e954cbb8bebfdf5$var$idle$2);
    var unbindEventsRef = (0, $1bxDW.useRef)($5e954cbb8bebfdf5$var$noop);
    var getPhase = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $5e954cbb8bebfdf5$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($5e954cbb8bebfdf5$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $5e954cbb8bebfdf5$var$bindEvents(window, $5e954cbb8bebfdf5$var$getHandleBindings(args), options);
        var unbindWindow = $5e954cbb8bebfdf5$var$bindEvents(window, $5e954cbb8bebfdf5$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $5e954cbb8bebfdf5$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $5e954cbb8bebfdf5$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $5e954cbb8bebfdf5$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($5e954cbb8bebfdf5$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $5e954cbb8bebfdf5$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $5e954cbb8bebfdf5$var$useValidateSensorHooks(sensorHooks) {
    $5e954cbb8bebfdf5$var$useDev(function() {
        var previousRef = $5e954cbb8bebfdf5$var$usePrevious(sensorHooks);
        $5e954cbb8bebfdf5$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $5e954cbb8bebfdf5$var$invariant(false);
        });
    });
}
var $5e954cbb8bebfdf5$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $5e954cbb8bebfdf5$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($5e954cbb8bebfdf5$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $5e954cbb8bebfdf5$var$isAnInteractiveElement(parent, current.parentElement);
}
function $5e954cbb8bebfdf5$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$5e954cbb8bebfdf5$var$isHtmlElement(target)) return false;
    return $5e954cbb8bebfdf5$var$isAnInteractiveElement(draggable, target);
}
var $5e954cbb8bebfdf5$var$getBorderBoxCenterPosition = function(el) {
    return (0, $122e8d919897451e$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $5e954cbb8bebfdf5$var$isElement(el) {
    return el instanceof $5e954cbb8bebfdf5$var$getWindowFromEl(el).Element;
}
var $5e954cbb8bebfdf5$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $5e954cbb8bebfdf5$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $5e954cbb8bebfdf5$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$5e954cbb8bebfdf5$var$supportedMatchesName](selector)) return el;
    return $5e954cbb8bebfdf5$var$closestPonyfill(el.parentElement, selector);
}
function $5e954cbb8bebfdf5$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $5e954cbb8bebfdf5$var$closestPonyfill(el, selector);
}
function $5e954cbb8bebfdf5$var$getSelector(contextId) {
    return "[" + $5e954cbb8bebfdf5$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $5e954cbb8bebfdf5$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$5e954cbb8bebfdf5$var$isElement(target)) return null;
    var selector = $5e954cbb8bebfdf5$var$getSelector(contextId);
    var handle = $5e954cbb8bebfdf5$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$5e954cbb8bebfdf5$var$isHtmlElement(handle)) return null;
    return handle;
}
function $5e954cbb8bebfdf5$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $5e954cbb8bebfdf5$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($5e954cbb8bebfdf5$var$dragHandle.draggableId);
}
function $5e954cbb8bebfdf5$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $5e954cbb8bebfdf5$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $5e954cbb8bebfdf5$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $5e954cbb8bebfdf5$var$find(possible, function(el) {
        return el.getAttribute($5e954cbb8bebfdf5$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$5e954cbb8bebfdf5$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $5e954cbb8bebfdf5$var$preventDefault(event) {
    event.preventDefault();
}
function $5e954cbb8bebfdf5$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $5e954cbb8bebfdf5$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$5e954cbb8bebfdf5$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $5e954cbb8bebfdf5$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $5e954cbb8bebfdf5$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $5e954cbb8bebfdf5$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $5e954cbb8bebfdf5$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $5e954cbb8bebfdf5$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($5e954cbb8bebfdf5$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $5e954cbb8bebfdf5$var$invariant(false);
        }
        store.dispatch($5e954cbb8bebfdf5$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $5e954cbb8bebfdf5$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $5e954cbb8bebfdf5$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($5e954cbb8bebfdf5$var$drop({
                reason: reason
            }));
        }
        return (0, $kabSK.default)({
            isActive: function isActive() {
                return $5e954cbb8bebfdf5$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $34aef3fc575d5445$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $5e954cbb8bebfdf5$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $kabSK.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($5e954cbb8bebfdf5$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($5e954cbb8bebfdf5$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($5e954cbb8bebfdf5$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($5e954cbb8bebfdf5$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $5e954cbb8bebfdf5$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $5e954cbb8bebfdf5$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $5e954cbb8bebfdf5$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $5e954cbb8bebfdf5$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $5e954cbb8bebfdf5$var$defaultSensors = [
    $5e954cbb8bebfdf5$var$useMouseSensor,
    $5e954cbb8bebfdf5$var$useKeyboardSensor,
    $5e954cbb8bebfdf5$var$useMouseSensor$1
];
function $5e954cbb8bebfdf5$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $5e954cbb8bebfdf5$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $1bxDW.useState)(function() {
        return $5e954cbb8bebfdf5$var$create();
    })[0];
    var tryAbandonLock = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(draggableId) {
        return $5e954cbb8bebfdf5$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $5e954cbb8bebfdf5$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(event) {
        return $5e954cbb8bebfdf5$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== 'IDLE') store.dispatch($5e954cbb8bebfdf5$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $5e954cbb8bebfdf5$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $5e954cbb8bebfdf5$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $5e954cbb8bebfdf5$var$getStore(lazyRef) {
    !lazyRef.current && $5e954cbb8bebfdf5$var$invariant(false);
    return lazyRef.current;
}
function $5e954cbb8bebfdf5$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $1bxDW.useRef)(null);
    $5e954cbb8bebfdf5$var$useStartupValidation();
    var lastPropsRef = $5e954cbb8bebfdf5$var$usePrevious(props);
    var getResponders = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return $5e954cbb8bebfdf5$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $5e954cbb8bebfdf5$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $5e954cbb8bebfdf5$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $5e954cbb8bebfdf5$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(action) {
        $5e954cbb8bebfdf5$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return (0, $7bd5d83317c8c48a$export$aea084d96e84da92)({
            publishWhileDragging: $5e954cbb8bebfdf5$var$publishWhileDragging,
            updateDroppableScroll: $5e954cbb8bebfdf5$var$updateDroppableScroll,
            updateDroppableIsEnabled: $5e954cbb8bebfdf5$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $5e954cbb8bebfdf5$var$updateDroppableIsCombineEnabled,
            collectionStarting: $5e954cbb8bebfdf5$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $5e954cbb8bebfdf5$var$useRegistry();
    var dimensionMarshal = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$createAutoScroller((0, $kabSK.default)({
            scrollWindow: $5e954cbb8bebfdf5$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $7bd5d83317c8c48a$export$aea084d96e84da92)({
            move: $5e954cbb8bebfdf5$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $5e954cbb8bebfdf5$var$useFocusMarshal(contextId);
    var store = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return $5e954cbb8bebfdf5$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var current = $5e954cbb8bebfdf5$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($5e954cbb8bebfdf5$var$flush());
    }, []);
    var isDragging = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var state = $5e954cbb8bebfdf5$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(id) {
        return $5e954cbb8bebfdf5$var$canStartDrag($5e954cbb8bebfdf5$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return $5e954cbb8bebfdf5$var$isMovementAllowed($5e954cbb8bebfdf5$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $5e954cbb8bebfdf5$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $1bxDW.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $10bb4a4d86cc6e39$export$2e2bcd8739ae039), {
        context: $5e954cbb8bebfdf5$var$StoreContext,
        store: store
    }, props.children));
}
var $5e954cbb8bebfdf5$var$count$1 = 0;
function $5e954cbb8bebfdf5$var$reset$1() {
    $5e954cbb8bebfdf5$var$count$1 = 0;
}
function $5e954cbb8bebfdf5$var$useInstanceCount() {
    return (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return "" + $5e954cbb8bebfdf5$var$count$1++;
    }, []);
}
function $5e954cbb8bebfdf5$export$2bfe52350fc0150d() {
    $5e954cbb8bebfdf5$var$reset$1();
    $5e954cbb8bebfdf5$var$reset();
}
function $5e954cbb8bebfdf5$export$237bd83162c14364(props) {
    var contextId = $5e954cbb8bebfdf5$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $5e954cbb8bebfdf5$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $5e954cbb8bebfdf5$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $5e954cbb8bebfdf5$var$isScroll = $5e954cbb8bebfdf5$var$isEqual$1('scroll');
var $5e954cbb8bebfdf5$var$isAuto = $5e954cbb8bebfdf5$var$isEqual$1('auto');
var $5e954cbb8bebfdf5$var$isVisible$1 = $5e954cbb8bebfdf5$var$isEqual$1('visible');
var $5e954cbb8bebfdf5$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $5e954cbb8bebfdf5$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $5e954cbb8bebfdf5$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $5e954cbb8bebfdf5$var$isEither(overflow, $5e954cbb8bebfdf5$var$isScroll) || $5e954cbb8bebfdf5$var$isEither(overflow, $5e954cbb8bebfdf5$var$isAuto);
};
var $5e954cbb8bebfdf5$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $5e954cbb8bebfdf5$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $5e954cbb8bebfdf5$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$5e954cbb8bebfdf5$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $5e954cbb8bebfdf5$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $5e954cbb8bebfdf5$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $5e954cbb8bebfdf5$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $5e954cbb8bebfdf5$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $5e954cbb8bebfdf5$var$getEnv = function(start) {
    var closestScrollable = $5e954cbb8bebfdf5$var$getClosestScrollable(start);
    var isFixedOnPage = $5e954cbb8bebfdf5$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $5e954cbb8bebfdf5$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $5e954cbb8bebfdf5$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $5e954cbb8bebfdf5$var$origin,
                    displacement: $5e954cbb8bebfdf5$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $5e954cbb8bebfdf5$var$vertical : $5e954cbb8bebfdf5$var$horizontal;
    var subject = $5e954cbb8bebfdf5$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $5e954cbb8bebfdf5$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $122e8d919897451e$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $122e8d919897451e$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $122e8d919897451e$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $5e954cbb8bebfdf5$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $5e954cbb8bebfdf5$var$getClient(ref, closestScrollable);
    var page = (0, $122e8d919897451e$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $122e8d919897451e$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $122e8d919897451e$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $5e954cbb8bebfdf5$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $5e954cbb8bebfdf5$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $5e954cbb8bebfdf5$var$immediate = {
    passive: false
};
var $5e954cbb8bebfdf5$var$delayed = {
    passive: true
};
var $5e954cbb8bebfdf5$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $5e954cbb8bebfdf5$var$immediate : $5e954cbb8bebfdf5$var$delayed;
};
function $5e954cbb8bebfdf5$var$useRequiredContext(Context) {
    var result = (0, $1bxDW.useContext)(Context);
    !result && $5e954cbb8bebfdf5$var$invariant(false);
    return result;
}
var $5e954cbb8bebfdf5$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $5e954cbb8bebfdf5$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $1bxDW.useRef)(null);
    var appContext = $5e954cbb8bebfdf5$var$useRequiredContext($5e954cbb8bebfdf5$var$AppContext);
    var uniqueId = $5e954cbb8bebfdf5$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $5e954cbb8bebfdf5$var$usePrevious(args);
    var descriptor = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $1bxDW.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $5e954cbb8bebfdf5$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $5e954cbb8bebfdf5$var$origin;
        return $5e954cbb8bebfdf5$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return (0, $34aef3fc575d5445$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $5e954cbb8bebfdf5$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $5e954cbb8bebfdf5$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $5e954cbb8bebfdf5$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $5e954cbb8bebfdf5$var$invariant(false);
        var env = $5e954cbb8bebfdf5$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $5e954cbb8bebfdf5$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($5e954cbb8bebfdf5$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $5e954cbb8bebfdf5$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $5e954cbb8bebfdf5$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $5e954cbb8bebfdf5$var$invariant(false);
        return $5e954cbb8bebfdf5$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var closest = $5e954cbb8bebfdf5$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($5e954cbb8bebfdf5$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $5e954cbb8bebfdf5$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $5e954cbb8bebfdf5$var$invariant(false);
        var closest = $5e954cbb8bebfdf5$var$getClosestScrollableFromDrag(dragging);
        !closest && $5e954cbb8bebfdf5$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $5e954cbb8bebfdf5$var$noop$2() {}
var $5e954cbb8bebfdf5$var$empty = {
    width: 0,
    height: 0,
    margin: $5e954cbb8bebfdf5$var$noSpacing
};
var $5e954cbb8bebfdf5$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $5e954cbb8bebfdf5$var$empty;
    if (animate === 'close') return $5e954cbb8bebfdf5$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $5e954cbb8bebfdf5$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $5e954cbb8bebfdf5$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $5e954cbb8bebfdf5$var$transitions.placeholder : null
    };
};
function $5e954cbb8bebfdf5$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $1bxDW.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $1bxDW.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $1bxDW.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $5e954cbb8bebfdf5$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $5e954cbb8bebfdf5$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $5e954cbb8bebfdf5$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $5e954cbb8bebfdf5$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $5e954cbb8bebfdf5$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).memo($5e954cbb8bebfdf5$var$Placeholder);
var $5e954cbb8bebfdf5$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createContext(null);
function $5e954cbb8bebfdf5$var$checkIsValidInnerRef(el) {
    !(el && $5e954cbb8bebfdf5$var$isHtmlElement(el)) && $5e954cbb8bebfdf5$var$invariant(false);
}
function $5e954cbb8bebfdf5$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $5e954cbb8bebfdf5$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $5e954cbb8bebfdf5$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $5e954cbb8bebfdf5$var$invariant(false);
        !(typeof props.droppableId === 'string') && $5e954cbb8bebfdf5$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$5e954cbb8bebfdf5$var$isBoolean(props.isDropDisabled) && $5e954cbb8bebfdf5$var$invariant(false);
        !$5e954cbb8bebfdf5$var$isBoolean(props.isCombineEnabled) && $5e954cbb8bebfdf5$var$invariant(false);
        !$5e954cbb8bebfdf5$var$isBoolean(props.ignoreContainerClipping) && $5e954cbb8bebfdf5$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $5e954cbb8bebfdf5$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $5e954cbb8bebfdf5$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $5e954cbb8bebfdf5$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $5e954cbb8bebfdf5$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $5e954cbb8bebfdf5$var$invariant(false);
    }
];
function $5e954cbb8bebfdf5$var$useValidation(args) {
    $5e954cbb8bebfdf5$var$useDevSetupWarning(function() {
        $5e954cbb8bebfdf5$var$runChecks(args, $5e954cbb8bebfdf5$var$shared);
        if (args.props.mode === 'standard') $5e954cbb8bebfdf5$var$runChecks(args, $5e954cbb8bebfdf5$var$standard);
        if (args.props.mode === 'virtual') $5e954cbb8bebfdf5$var$runChecks(args, $5e954cbb8bebfdf5$var$virtual);
    });
}
var $5e954cbb8bebfdf5$var$AnimateInOut = function(_React$PureComponent) {
    (0, $iZ4XC.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).PureComponent);
var $5e954cbb8bebfdf5$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $5e954cbb8bebfdf5$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $5e954cbb8bebfdf5$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $5e954cbb8bebfdf5$var$transitions.snap;
    return $5e954cbb8bebfdf5$var$transitions.fluid;
};
var $5e954cbb8bebfdf5$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $5e954cbb8bebfdf5$var$combine.opacity.drop : $5e954cbb8bebfdf5$var$combine.opacity.combining;
};
var $5e954cbb8bebfdf5$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $5e954cbb8bebfdf5$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $5e954cbb8bebfdf5$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $5e954cbb8bebfdf5$var$transforms.drop(offset, isCombining) : $5e954cbb8bebfdf5$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $5e954cbb8bebfdf5$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $5e954cbb8bebfdf5$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $5e954cbb8bebfdf5$var$zIndexOptions.dropAnimating : $5e954cbb8bebfdf5$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $5e954cbb8bebfdf5$var$getSecondaryStyle(secondary) {
    return {
        transform: $5e954cbb8bebfdf5$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $5e954cbb8bebfdf5$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $5e954cbb8bebfdf5$var$getDraggingStyle(mapped) : $5e954cbb8bebfdf5$var$getSecondaryStyle(mapped);
}
function $5e954cbb8bebfdf5$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $5e954cbb8bebfdf5$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $122e8d919897451e$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $122e8d919897451e$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $5e954cbb8bebfdf5$var$useDraggablePublisher(args) {
    var uniqueId = $5e954cbb8bebfdf5$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $5e954cbb8bebfdf5$var$invariant(false);
        return $5e954cbb8bebfdf5$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $1bxDW.useRef)(entry);
    var isFirstPublishRef = (0, $1bxDW.useRef)(true);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $5e954cbb8bebfdf5$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $5e954cbb8bebfdf5$var$useValidation$1(props, contextId, getRef) {
    $5e954cbb8bebfdf5$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $5e954cbb8bebfdf5$var$invariant(false);
        !(typeof id === 'string') && $5e954cbb8bebfdf5$var$invariant(false);
        !$5e954cbb8bebfdf5$var$isInteger(props.index) && $5e954cbb8bebfdf5$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $5e954cbb8bebfdf5$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$5e954cbb8bebfdf5$var$findDragHandle(contextId, id) && $5e954cbb8bebfdf5$var$invariant(false);
    });
}
function $5e954cbb8bebfdf5$var$useClonePropValidation(isClone) {
    $5e954cbb8bebfdf5$var$useDev(function() {
        var initialRef = (0, $1bxDW.useRef)(isClone);
        $5e954cbb8bebfdf5$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $5e954cbb8bebfdf5$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $5e954cbb8bebfdf5$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $5e954cbb8bebfdf5$var$Draggable(props) {
    var ref = (0, $1bxDW.useRef)(null);
    var setRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $5e954cbb8bebfdf5$var$useRequiredContext($5e954cbb8bebfdf5$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $5e954cbb8bebfdf5$var$useRequiredContext($5e954cbb8bebfdf5$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $5e954cbb8bebfdf5$var$useValidation$1(props, contextId, getRef);
    $5e954cbb8bebfdf5$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $5e954cbb8bebfdf5$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: 'button',
            'aria-describedby': dragHandleUsageInstructionsId,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            draggable: false,
            onDragStart: $5e954cbb8bebfdf5$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        var style = $5e954cbb8bebfdf5$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $5e954cbb8bebfdf5$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $5e954cbb8bebfdf5$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $5e954cbb8bebfdf5$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $5e954cbb8bebfdf5$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $5e954cbb8bebfdf5$var$getDraggableSelector() {
    var memoizedOffset = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $5e954cbb8bebfdf5$var$whatIsDraggedOver(state.impact);
            var combineWith = $5e954cbb8bebfdf5$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $5e954cbb8bebfdf5$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $5e954cbb8bebfdf5$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $5e954cbb8bebfdf5$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $5e954cbb8bebfdf5$var$combine.opacity.drop : null,
                scale: _combineWith ? $5e954cbb8bebfdf5$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $5e954cbb8bebfdf5$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $5e954cbb8bebfdf5$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $5e954cbb8bebfdf5$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $5e954cbb8bebfdf5$var$getSecondarySnapshot(null)
    }
};
function $5e954cbb8bebfdf5$var$getSecondarySelector() {
    var memoizedOffset = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)($5e954cbb8bebfdf5$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($5e954cbb8bebfdf5$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $5e954cbb8bebfdf5$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $5e954cbb8bebfdf5$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $5e954cbb8bebfdf5$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $5e954cbb8bebfdf5$var$getDraggableSelector();
    var secondarySelector = $5e954cbb8bebfdf5$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $5e954cbb8bebfdf5$var$atRest;
    };
    return selector;
};
var $5e954cbb8bebfdf5$var$mapDispatchToProps = {
    dropAnimationFinished: $5e954cbb8bebfdf5$var$dropAnimationFinished
};
var $5e954cbb8bebfdf5$var$ConnectedDraggable = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($5e954cbb8bebfdf5$var$makeMapStateToProps, $5e954cbb8bebfdf5$var$mapDispatchToProps, null, {
    context: $5e954cbb8bebfdf5$var$StoreContext,
    pure: true,
    areStatePropsEqual: $5e954cbb8bebfdf5$var$isStrictEqual
})($5e954cbb8bebfdf5$var$Draggable);
function $5e954cbb8bebfdf5$var$PrivateDraggable(props) {
    var droppableContext = $5e954cbb8bebfdf5$var$useRequiredContext($5e954cbb8bebfdf5$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$ConnectedDraggable, props);
}
function $5e954cbb8bebfdf5$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$PrivateDraggable, (0, $kabSK.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $5e954cbb8bebfdf5$var$Droppable(props) {
    var appContext = (0, $1bxDW.useContext)($5e954cbb8bebfdf5$var$AppContext);
    !appContext && $5e954cbb8bebfdf5$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $1bxDW.useRef)(null);
    var placeholderRef = (0, $1bxDW.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $5e954cbb8bebfdf5$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $d037a9ec4120d05c$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $5e954cbb8bebfdf5$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $5e954cbb8bebfdf5$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $d037a9ec4120d05c$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($c63f56900e1488fc$exports))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($5e954cbb8bebfdf5$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $5e954cbb8bebfdf5$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $5e954cbb8bebfdf5$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $5e954cbb8bebfdf5$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $kabSK.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $b6d2d2472876f73f$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$5e954cbb8bebfdf5$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $5e954cbb8bebfdf5$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $5e954cbb8bebfdf5$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$5e954cbb8bebfdf5$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $5e954cbb8bebfdf5$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $5e954cbb8bebfdf5$var$whatIsDraggedOverFromResult(completed.result) === id, $5e954cbb8bebfdf5$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$5e954cbb8bebfdf5$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $5e954cbb8bebfdf5$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $5e954cbb8bebfdf5$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $5e954cbb8bebfdf5$var$updateViewportMaxScroll
};
function $5e954cbb8bebfdf5$var$getBody() {
    !document.body && $5e954cbb8bebfdf5$var$invariant(false);
    return document.body;
}
var $5e954cbb8bebfdf5$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $5e954cbb8bebfdf5$var$getBody
};
var $5e954cbb8bebfdf5$export$423ec2075359570a = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($5e954cbb8bebfdf5$var$makeMapStateToProps$1, $5e954cbb8bebfdf5$var$mapDispatchToProps$1, null, {
    context: $5e954cbb8bebfdf5$var$StoreContext,
    pure: true,
    areStatePropsEqual: $5e954cbb8bebfdf5$var$isStrictEqual
})($5e954cbb8bebfdf5$var$Droppable);
$5e954cbb8bebfdf5$export$423ec2075359570a.defaultProps = $5e954cbb8bebfdf5$var$defaultProps;




var $f257bd084a67bcde$exports = {};

$parcel$export($f257bd084a67bcde$exports, "signOut", function () { return $f257bd084a67bcde$export$b0ac3a1c242cb1ea; });
$parcel$export($f257bd084a67bcde$exports, "setCurrentFileBrowserDirectoryListing", function () { return $f257bd084a67bcde$export$6030e59027cfe97c; });
$parcel$export($f257bd084a67bcde$exports, "setIsLoadingMoreDirectoryListing", function () { return $f257bd084a67bcde$export$7026bb370907ccf6; });
$parcel$export($f257bd084a67bcde$exports, "getDirectoryListing", function () { return $f257bd084a67bcde$export$54f61a6f215b3a81; });
$parcel$export($f257bd084a67bcde$exports, "loadMoreDirectoryListing", function () { return $f257bd084a67bcde$export$75073871eb6a230a; });
$parcel$export($f257bd084a67bcde$exports, "pushBackup", function () { return $f257bd084a67bcde$export$4463ab184c19f1fc; });
$parcel$export($f257bd084a67bcde$exports, "downloadFile", function () { return $f257bd084a67bcde$export$bb3b75778e3e272; });
$parcel$export($f257bd084a67bcde$exports, "createFile", function () { return $f257bd084a67bcde$export$982c3a0b9a5cde94; });




/* global process */ var $64be5c4bade8e7bf$exports = {};
"use strict";
/**
 * An implementation of rfc6749#section-4.1 and rfc7636.
 */ var $64be5c4bade8e7bf$var$__extends = $64be5c4bade8e7bf$exports && $64be5c4bade8e7bf$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $64be5c4bade8e7bf$var$__assign = $64be5c4bade8e7bf$exports && $64be5c4bade8e7bf$exports.__assign || function() {
    $64be5c4bade8e7bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $64be5c4bade8e7bf$var$__assign.apply(this, arguments);
};
var $64be5c4bade8e7bf$var$__awaiter = $64be5c4bade8e7bf$exports && $64be5c4bade8e7bf$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $64be5c4bade8e7bf$var$__generator = $64be5c4bade8e7bf$exports && $64be5c4bade8e7bf$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $64be5c4bade8e7bf$var$__spreadArrays = $64be5c4bade8e7bf$exports && $64be5c4bade8e7bf$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($64be5c4bade8e7bf$exports, "__esModule", {
    value: true
});
/**
 * A list of OAuth2AuthCodePKCE errors.
 */ // To "namespace" all errors.
var $64be5c4bade8e7bf$var$ErrorOAuth2 = /** @class */ function() {
    function ErrorOAuth2() {}
    ErrorOAuth2.prototype.toString = function() {
        return 'ErrorOAuth2';
    };
    return ErrorOAuth2;
}();
$64be5c4bade8e7bf$exports.ErrorOAuth2 = $64be5c4bade8e7bf$var$ErrorOAuth2;
// For really unknown errors.
var $64be5c4bade8e7bf$var$ErrorUnknown = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorUnknown, _super);
    function ErrorUnknown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnknown.prototype.toString = function() {
        return 'ErrorUnknown';
    };
    return ErrorUnknown;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorUnknown = $64be5c4bade8e7bf$var$ErrorUnknown;
// Some generic, internal errors that can happen.
var $64be5c4bade8e7bf$var$ErrorNoAuthCode = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorNoAuthCode, _super);
    function ErrorNoAuthCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorNoAuthCode.prototype.toString = function() {
        return 'ErrorNoAuthCode';
    };
    return ErrorNoAuthCode;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorNoAuthCode = $64be5c4bade8e7bf$var$ErrorNoAuthCode;
var $64be5c4bade8e7bf$var$ErrorInvalidReturnedStateParam = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidReturnedStateParam, _super);
    function ErrorInvalidReturnedStateParam() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidReturnedStateParam.prototype.toString = function() {
        return 'ErrorInvalidReturnedStateParam';
    };
    return ErrorInvalidReturnedStateParam;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorInvalidReturnedStateParam = $64be5c4bade8e7bf$var$ErrorInvalidReturnedStateParam;
var $64be5c4bade8e7bf$var$ErrorInvalidJson = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidJson, _super);
    function ErrorInvalidJson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidJson.prototype.toString = function() {
        return 'ErrorInvalidJson';
    };
    return ErrorInvalidJson;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorInvalidJson = $64be5c4bade8e7bf$var$ErrorInvalidJson;
// Errors that occur across many endpoints
var $64be5c4bade8e7bf$var$ErrorInvalidScope = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidScope, _super);
    function ErrorInvalidScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidScope.prototype.toString = function() {
        return 'ErrorInvalidScope';
    };
    return ErrorInvalidScope;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorInvalidScope = $64be5c4bade8e7bf$var$ErrorInvalidScope;
var $64be5c4bade8e7bf$var$ErrorInvalidRequest = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidRequest, _super);
    function ErrorInvalidRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidRequest.prototype.toString = function() {
        return 'ErrorInvalidRequest';
    };
    return ErrorInvalidRequest;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorInvalidRequest = $64be5c4bade8e7bf$var$ErrorInvalidRequest;
var $64be5c4bade8e7bf$var$ErrorInvalidToken = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidToken, _super);
    function ErrorInvalidToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidToken.prototype.toString = function() {
        return 'ErrorInvalidToken';
    };
    return ErrorInvalidToken;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorInvalidToken = $64be5c4bade8e7bf$var$ErrorInvalidToken;
/**
 * Possible authorization grant errors given by the redirection from the
 * authorization server.
 */ var $64be5c4bade8e7bf$var$ErrorAuthenticationGrant = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorAuthenticationGrant, _super);
    function ErrorAuthenticationGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAuthenticationGrant.prototype.toString = function() {
        return 'ErrorAuthenticationGrant';
    };
    return ErrorAuthenticationGrant;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorAuthenticationGrant = $64be5c4bade8e7bf$var$ErrorAuthenticationGrant;
var $64be5c4bade8e7bf$var$ErrorUnauthorizedClient = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorUnauthorizedClient, _super);
    function ErrorUnauthorizedClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnauthorizedClient.prototype.toString = function() {
        return 'ErrorUnauthorizedClient';
    };
    return ErrorUnauthorizedClient;
}($64be5c4bade8e7bf$var$ErrorAuthenticationGrant);
$64be5c4bade8e7bf$exports.ErrorUnauthorizedClient = $64be5c4bade8e7bf$var$ErrorUnauthorizedClient;
var $64be5c4bade8e7bf$var$ErrorAccessDenied = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorAccessDenied, _super);
    function ErrorAccessDenied() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessDenied.prototype.toString = function() {
        return 'ErrorAccessDenied';
    };
    return ErrorAccessDenied;
}($64be5c4bade8e7bf$var$ErrorAuthenticationGrant);
$64be5c4bade8e7bf$exports.ErrorAccessDenied = $64be5c4bade8e7bf$var$ErrorAccessDenied;
var $64be5c4bade8e7bf$var$ErrorUnsupportedResponseType = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorUnsupportedResponseType, _super);
    function ErrorUnsupportedResponseType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedResponseType.prototype.toString = function() {
        return 'ErrorUnsupportedResponseType';
    };
    return ErrorUnsupportedResponseType;
}($64be5c4bade8e7bf$var$ErrorAuthenticationGrant);
$64be5c4bade8e7bf$exports.ErrorUnsupportedResponseType = $64be5c4bade8e7bf$var$ErrorUnsupportedResponseType;
var $64be5c4bade8e7bf$var$ErrorServerError = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorServerError, _super);
    function ErrorServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorServerError.prototype.toString = function() {
        return 'ErrorServerError';
    };
    return ErrorServerError;
}($64be5c4bade8e7bf$var$ErrorAuthenticationGrant);
$64be5c4bade8e7bf$exports.ErrorServerError = $64be5c4bade8e7bf$var$ErrorServerError;
var $64be5c4bade8e7bf$var$ErrorTemporarilyUnavailable = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorTemporarilyUnavailable, _super);
    function ErrorTemporarilyUnavailable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorTemporarilyUnavailable.prototype.toString = function() {
        return 'ErrorTemporarilyUnavailable';
    };
    return ErrorTemporarilyUnavailable;
}($64be5c4bade8e7bf$var$ErrorAuthenticationGrant);
$64be5c4bade8e7bf$exports.ErrorTemporarilyUnavailable = $64be5c4bade8e7bf$var$ErrorTemporarilyUnavailable;
/**
 * A list of possible access token response errors.
 */ var $64be5c4bade8e7bf$var$ErrorAccessTokenResponse = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorAccessTokenResponse, _super);
    function ErrorAccessTokenResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessTokenResponse.prototype.toString = function() {
        return 'ErrorAccessTokenResponse';
    };
    return ErrorAccessTokenResponse;
}($64be5c4bade8e7bf$var$ErrorOAuth2);
$64be5c4bade8e7bf$exports.ErrorAccessTokenResponse = $64be5c4bade8e7bf$var$ErrorAccessTokenResponse;
var $64be5c4bade8e7bf$var$ErrorInvalidClient = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidClient, _super);
    function ErrorInvalidClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidClient.prototype.toString = function() {
        return 'ErrorInvalidClient';
    };
    return ErrorInvalidClient;
}($64be5c4bade8e7bf$var$ErrorAccessTokenResponse);
$64be5c4bade8e7bf$exports.ErrorInvalidClient = $64be5c4bade8e7bf$var$ErrorInvalidClient;
var $64be5c4bade8e7bf$var$ErrorInvalidGrant = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorInvalidGrant, _super);
    function ErrorInvalidGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidGrant.prototype.toString = function() {
        return 'ErrorInvalidGrant';
    };
    return ErrorInvalidGrant;
}($64be5c4bade8e7bf$var$ErrorAccessTokenResponse);
$64be5c4bade8e7bf$exports.ErrorInvalidGrant = $64be5c4bade8e7bf$var$ErrorInvalidGrant;
var $64be5c4bade8e7bf$var$ErrorUnsupportedGrantType = /** @class */ function(_super) {
    $64be5c4bade8e7bf$var$__extends(ErrorUnsupportedGrantType, _super);
    function ErrorUnsupportedGrantType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedGrantType.prototype.toString = function() {
        return 'ErrorUnsupportedGrantType';
    };
    return ErrorUnsupportedGrantType;
}($64be5c4bade8e7bf$var$ErrorAccessTokenResponse);
$64be5c4bade8e7bf$exports.ErrorUnsupportedGrantType = $64be5c4bade8e7bf$var$ErrorUnsupportedGrantType;
/**
 * WWW-Authenticate error object structure for less error prone handling.
 */ var $64be5c4bade8e7bf$var$ErrorWWWAuthenticate = /** @class */ function() {
    function ErrorWWWAuthenticate() {
        this.realm = "";
        this.error = "";
    }
    return ErrorWWWAuthenticate;
}();
$64be5c4bade8e7bf$exports.ErrorWWWAuthenticate = $64be5c4bade8e7bf$var$ErrorWWWAuthenticate;
$64be5c4bade8e7bf$exports.RawErrorToErrorClassMap = {
    invalid_request: $64be5c4bade8e7bf$var$ErrorInvalidRequest,
    invalid_grant: $64be5c4bade8e7bf$var$ErrorInvalidGrant,
    unauthorized_client: $64be5c4bade8e7bf$var$ErrorUnauthorizedClient,
    access_denied: $64be5c4bade8e7bf$var$ErrorAccessDenied,
    unsupported_response_type: $64be5c4bade8e7bf$var$ErrorUnsupportedResponseType,
    invalid_scope: $64be5c4bade8e7bf$var$ErrorInvalidScope,
    server_error: $64be5c4bade8e7bf$var$ErrorServerError,
    temporarily_unavailable: $64be5c4bade8e7bf$var$ErrorTemporarilyUnavailable,
    invalid_client: $64be5c4bade8e7bf$var$ErrorInvalidClient,
    unsupported_grant_type: $64be5c4bade8e7bf$var$ErrorUnsupportedGrantType,
    invalid_json: $64be5c4bade8e7bf$var$ErrorInvalidJson,
    invalid_token: $64be5c4bade8e7bf$var$ErrorInvalidToken
};
/**
 * Translate the raw error strings returned from the server into error classes.
 */ function $64be5c4bade8e7bf$var$toErrorClass(rawError) {
    return new ($64be5c4bade8e7bf$exports.RawErrorToErrorClassMap[rawError] || $64be5c4bade8e7bf$var$ErrorUnknown)();
}
$64be5c4bade8e7bf$exports.toErrorClass = $64be5c4bade8e7bf$var$toErrorClass;
/**
 * A convience function to turn, for example, `Bearer realm="bity.com",
 * error="invalid_client"` into `{ realm: "bity.com", error: "invalid_client"
 * }`.
 */ function $64be5c4bade8e7bf$var$fromWWWAuthenticateHeaderStringToObject(a) {
    var obj = a.slice(7).replace(/"/g, '').split(', ').map(function(tokens) {
        var _a;
        var _b = tokens.split('='), k = _b[0], v = _b[1];
        return _a = {}, _a[k] = v, _a;
    }).reduce(function(a, c) {
        return $64be5c4bade8e7bf$var$__assign($64be5c4bade8e7bf$var$__assign({}, a), c);
    }, {});
    return {
        realm: obj.realm,
        error: obj.error
    };
}
$64be5c4bade8e7bf$exports.fromWWWAuthenticateHeaderStringToObject = $64be5c4bade8e7bf$var$fromWWWAuthenticateHeaderStringToObject;
/**
 * HTTP headers that we need to access.
 */ var $64be5c4bade8e7bf$var$HEADER_AUTHORIZATION = "Authorization";
var $64be5c4bade8e7bf$var$HEADER_WWW_AUTHENTICATE = "WWW-Authenticate";
/**
 * To store the OAuth client's data between websites due to redirection.
 */ $64be5c4bade8e7bf$exports.LOCALSTORAGE_ID = "oauth2authcodepkce";
$64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE = $64be5c4bade8e7bf$exports.LOCALSTORAGE_ID + "-state";
/**
 * The maximum length for a code verifier for the best security we can offer.
 * Please note the NOTE section of RFC 7636 § 4.1 - the length must be >= 43,
 * but <= 128, **after** base64 url encoding. This means 32 code verifier bytes
 * encoded will be 43 bytes, or 96 bytes encoded will be 128 bytes. So 96 bytes
 * is the highest valid value that can be used.
 */ $64be5c4bade8e7bf$exports.RECOMMENDED_CODE_VERIFIER_LENGTH = 96;
/**
 * A sensible length for the state's length, for anti-csrf.
 */ $64be5c4bade8e7bf$exports.RECOMMENDED_STATE_LENGTH = 32;
/**
 * Character set to generate code verifier defined in rfc7636.
 */ var $64be5c4bade8e7bf$var$PKCE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
/**
 * OAuth 2.0 client that ONLY supports authorization code flow, with PKCE.
 *
 * Many applications structure their OAuth usage in different ways. This class
 * aims to provide both flexible and easy ways to use this configuration of
 * OAuth.
 *
 * See `example.ts` for how you'd typically use this.
 *
 * For others, review this class's methods.
 */ var $64be5c4bade8e7bf$var$OAuth2AuthCodePKCE = /** @class */ function() {
    function OAuth2AuthCodePKCE(config) {
        this.state = {};
        this.config = config;
        this.recoverState();
        return this;
    }
    /**
     * Attach the OAuth logic to all fetch requests and translate errors (either
     * returned as json or through the WWW-Authenticate header) into nice error
     * classes.
     */ OAuth2AuthCodePKCE.prototype.decorateFetchHTTPClient = function(fetch1) {
        var _this = this;
        return function(url, config) {
            var rest = [];
            for(var _i = 2; _i < arguments.length; _i++)rest[_i - 2] = arguments[_i];
            if (!_this.state.isHTTPDecoratorActive) return fetch1.apply(void 0, $64be5c4bade8e7bf$var$__spreadArrays([
                url,
                config
            ], rest));
            return _this.getAccessToken().then(function(_a) {
                var token = _a.token;
                var configNew = Object.assign({}, config);
                if (!configNew.headers) configNew.headers = {};
                configNew.headers[$64be5c4bade8e7bf$var$HEADER_AUTHORIZATION] = "Bearer " + token.value;
                return fetch1.apply(void 0, $64be5c4bade8e7bf$var$__spreadArrays([
                    url,
                    configNew
                ], rest));
            }).then(function(res) {
                if (res.ok) return res;
                if (!res.headers.has($64be5c4bade8e7bf$var$HEADER_WWW_AUTHENTICATE.toLowerCase())) return res;
                var error = $64be5c4bade8e7bf$var$toErrorClass($64be5c4bade8e7bf$var$fromWWWAuthenticateHeaderStringToObject(res.headers.get($64be5c4bade8e7bf$var$HEADER_WWW_AUTHENTICATE.toLowerCase())).error);
                if (error instanceof $64be5c4bade8e7bf$var$ErrorInvalidToken) _this.config.onAccessTokenExpiry(function() {
                    return _this.exchangeRefreshTokenForAccessToken();
                });
                return Promise.reject(error);
            });
        };
    };
    /**
     * If there is an error, it will be passed back as a rejected Promise.
     * If there is no code, the user should be redirected via
     * [fetchAuthorizationCode].
     */ OAuth2AuthCodePKCE.prototype.isReturningFromAuthServer = function() {
        var error = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'error');
        if (error) return Promise.reject($64be5c4bade8e7bf$var$toErrorClass(error));
        var code = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'code');
        if (!code) return Promise.resolve(false);
        var state = JSON.parse(localStorage.getItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE) || '{}');
        var stateQueryParam = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, 'state');
        if (stateQueryParam !== state.stateQueryParam) {
            console.warn("state query string parameter doesn't match the one sent! Possible malicious activity somewhere.");
            return Promise.reject(new $64be5c4bade8e7bf$var$ErrorInvalidReturnedStateParam());
        }
        state.authorizationCode = code;
        state.hasAuthCodeBeenExchangedForAccessToken = false;
        localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        this.setState(state);
        return Promise.resolve(true);
    };
    /**
     * Fetch an authorization grant via redirection. In a sense this function
     * doesn't return because of the redirect behavior (uses `location.replace`).
     *
     * @param oneTimeParams A way to specify "one time" used query string
     * parameters during the authorization code fetching process, usually for
     * values which need to change at run-time.
     */ OAuth2AuthCodePKCE.prototype.fetchAuthorizationCode = function(oneTimeParams) {
        return $64be5c4bade8e7bf$var$__awaiter(this, void 0, void 0, function() {
            var _a, clientId, extraAuthorizationParams, redirectUrl, scopes, _b, codeChallenge, codeVerifier, stateQueryParam, url, extraParameters;
            return $64be5c4bade8e7bf$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.assertStateAndConfigArePresent();
                        _a = this.config, clientId = _a.clientId, extraAuthorizationParams = _a.extraAuthorizationParams, redirectUrl = _a.redirectUrl, scopes = _a.scopes;
                        return [
                            4 /*yield*/ ,
                            OAuth2AuthCodePKCE.generatePKCECodes()
                        ];
                    case 1:
                        _b = _c.sent(), codeChallenge = _b.codeChallenge, codeVerifier = _b.codeVerifier;
                        stateQueryParam = OAuth2AuthCodePKCE.generateRandomState($64be5c4bade8e7bf$exports.RECOMMENDED_STATE_LENGTH);
                        this.state = $64be5c4bade8e7bf$var$__assign($64be5c4bade8e7bf$var$__assign({}, this.state), {
                            codeChallenge: codeChallenge,
                            codeVerifier: codeVerifier,
                            stateQueryParam: stateQueryParam,
                            isHTTPDecoratorActive: true
                        });
                        localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
                        url = this.config.authorizationUrl + "?response_type=code&" + ("client_id=" + encodeURIComponent(clientId) + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("scope=" + encodeURIComponent(scopes.join(' ')) + "&") + ("state=" + stateQueryParam + "&") + ("code_challenge=" + encodeURIComponent(codeChallenge) + "&") + "code_challenge_method=S256";
                        if (extraAuthorizationParams || oneTimeParams) {
                            extraParameters = $64be5c4bade8e7bf$var$__assign($64be5c4bade8e7bf$var$__assign({}, extraAuthorizationParams), oneTimeParams);
                            url = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraParameters);
                        }
                        location.replace(url);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Tries to get the current access token. If there is none
     * it will fetch another one. If it is expired, it will fire
     * [onAccessTokenExpiry] but it's up to the user to call the refresh token
     * function. This is because sometimes not using the refresh token facilities
     * is easier.
     */ OAuth2AuthCodePKCE.prototype.getAccessToken = function() {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var onAccessTokenExpiry = this.config.onAccessTokenExpiry;
        var _a = this.state, accessToken = _a.accessToken, authorizationCode = _a.authorizationCode, explicitlyExposedTokens = _a.explicitlyExposedTokens, hasAuthCodeBeenExchangedForAccessToken = _a.hasAuthCodeBeenExchangedForAccessToken, refreshToken = _a.refreshToken, scopes = _a.scopes;
        if (!authorizationCode) return Promise.reject(new $64be5c4bade8e7bf$var$ErrorNoAuthCode());
        if (this.authCodeForAccessTokenRequest) return this.authCodeForAccessTokenRequest;
        if (!this.isAuthorized() || !hasAuthCodeBeenExchangedForAccessToken) {
            this.authCodeForAccessTokenRequest = this.exchangeAuthCodeForAccessToken();
            return this.authCodeForAccessTokenRequest;
        }
        // Depending on the server (and config), refreshToken may not be available.
        if (refreshToken && this.isAccessTokenExpired()) return onAccessTokenExpiry(function() {
            return _this.exchangeRefreshTokenForAccessToken();
        });
        return Promise.resolve({
            token: accessToken,
            explicitlyExposedTokens: explicitlyExposedTokens,
            scopes: scopes,
            refreshToken: refreshToken
        });
    };
    /**
     * Refresh an access token from the remote service.
     */ OAuth2AuthCodePKCE.prototype.exchangeRefreshTokenForAccessToken = function() {
        var _this = this;
        var _a;
        this.assertStateAndConfigArePresent();
        var _b = this.config, extraRefreshParams = _b.extraRefreshParams, clientId = _b.clientId, tokenUrl = _b.tokenUrl;
        var refreshToken = this.state.refreshToken;
        if (!refreshToken) console.warn('No refresh token is present.');
        var url = tokenUrl;
        var body = "grant_type=refresh_token&" + ("refresh_token=" + ((_a = refreshToken) === null || _a === void 0 ? void 0 : _a.value) + "&") + ("client_id=" + clientId);
        if (extraRefreshParams) body = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraRefreshParams);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(res) {
            return res.status >= 400 ? res.json().then(function(data) {
                return Promise.reject(data);
            }) : res.json();
        }).then(function(json) {
            var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
            var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
            var scopes = [];
            var tokensToExpose = {};
            var accessToken = {
                value: access_token,
                expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
            };
            _this.state.accessToken = accessToken;
            if (refresh_token) {
                var refreshToken_1 = {
                    value: refresh_token
                };
                _this.state.refreshToken = refreshToken_1;
            }
            if (explicitlyExposedTokens) {
                tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                    return [
                        tokenName,
                        json[tokenName]
                    ];
                }).filter(function(_a) {
                    var _ = _a[0], tokenValue = _a[1];
                    return tokenValue !== undefined;
                }));
                _this.state.explicitlyExposedTokens = tokensToExpose;
            }
            if (scope) {
                // Multiple scopes are passed and delimited by spaces,
                // despite using the singular name "scope".
                scopes = scope.split(' ');
                _this.state.scopes = scopes;
            }
            localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
            var accessContext = {
                token: accessToken,
                scopes: scopes
            };
            if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
            return accessContext;
        }).catch(function(data) {
            var onInvalidGrant = _this.config.onInvalidGrant;
            var error = data.error || 'There was a network error.';
            switch(error){
                case 'invalid_grant':
                    onInvalidGrant(function() {
                        return _this.fetchAuthorizationCode();
                    });
                    break;
                default:
                    break;
            }
            return Promise.reject($64be5c4bade8e7bf$var$toErrorClass(error));
        });
    };
    /**
     * Get the scopes that were granted by the authorization server.
     */ OAuth2AuthCodePKCE.prototype.getGrantedScopes = function() {
        return this.state.scopes;
    };
    /**
     * Signals if OAuth HTTP decorating should be active or not.
     */ OAuth2AuthCodePKCE.prototype.isHTTPDecoratorActive = function(isActive) {
        this.state.isHTTPDecoratorActive = isActive;
        localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
    };
    /**
     * Tells if the client is authorized or not. This means the client has at
     * least once successfully fetched an access token. The access token could be
     * expired.
     */ OAuth2AuthCodePKCE.prototype.isAuthorized = function() {
        return !!this.state.accessToken;
    };
    /**
     * Checks to see if the access token has expired.
     */ OAuth2AuthCodePKCE.prototype.isAccessTokenExpired = function() {
        var accessToken = this.state.accessToken;
        return Boolean(accessToken && new Date() >= new Date(accessToken.expiry));
    };
    /**
     * Resets the state of the client. Equivalent to "logging out" the user.
     */ OAuth2AuthCodePKCE.prototype.reset = function() {
        this.setState({});
        this.authCodeForAccessTokenRequest = undefined;
    };
    /**
     * If the state or config are missing, it means the client is in a bad state.
     * This should never happen, but the check is there just in case.
     */ OAuth2AuthCodePKCE.prototype.assertStateAndConfigArePresent = function() {
        if (!this.state || !this.config) {
            console.error('state:', this.state, 'config:', this.config);
            throw new Error('state or config is not set.');
        }
    };
    /**
     * Fetch an access token from the remote service. You may pass a custom
     * authorization grant code for any reason, but this is non-standard usage.
     */ OAuth2AuthCodePKCE.prototype.exchangeAuthCodeForAccessToken = function(codeOverride) {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var _a = this.state, _b = _a.authorizationCode, authorizationCode = _b === void 0 ? codeOverride : _b, _c = _a.codeVerifier, codeVerifier = _c === void 0 ? '' : _c;
        var _d = this.config, clientId = _d.clientId, onInvalidGrant = _d.onInvalidGrant, redirectUrl = _d.redirectUrl;
        if (!codeVerifier) console.warn('No code verifier is being sent.');
        else if (!authorizationCode) console.warn('No authorization grant code is being passed.');
        var url = this.config.tokenUrl;
        var body = "grant_type=authorization_code&" + ("code=" + encodeURIComponent(authorizationCode || '') + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("client_id=" + encodeURIComponent(clientId) + "&") + ("code_verifier=" + codeVerifier);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(res) {
            var jsonPromise = res.json().catch(function(_) {
                return {
                    error: 'invalid_json'
                };
            });
            if (!res.ok) return jsonPromise.then(function(_a) {
                var error = _a.error;
                switch(error){
                    case 'invalid_grant':
                        onInvalidGrant(function() {
                            return _this.fetchAuthorizationCode();
                        });
                        break;
                    default:
                        break;
                }
                return Promise.reject($64be5c4bade8e7bf$var$toErrorClass(error));
            });
            return jsonPromise.then(function(json) {
                var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
                var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
                var scopes = [];
                var tokensToExpose = {};
                _this.state.hasAuthCodeBeenExchangedForAccessToken = true;
                _this.authCodeForAccessTokenRequest = undefined;
                var accessToken = {
                    value: access_token,
                    expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
                };
                _this.state.accessToken = accessToken;
                if (refresh_token) {
                    var refreshToken = {
                        value: refresh_token
                    };
                    _this.state.refreshToken = refreshToken;
                }
                if (explicitlyExposedTokens) {
                    tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                        return [
                            tokenName,
                            json[tokenName]
                        ];
                    }).filter(function(_a) {
                        var _ = _a[0], tokenValue = _a[1];
                        return tokenValue !== undefined;
                    }));
                    _this.state.explicitlyExposedTokens = tokensToExpose;
                }
                if (scope) {
                    // Multiple scopes are passed and delimited by spaces,
                    // despite using the singular name "scope".
                    scopes = scope.split(' ');
                    _this.state.scopes = scopes;
                }
                localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
                var accessContext = {
                    token: accessToken,
                    scopes: scopes
                };
                if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
                return accessContext;
            });
        });
    };
    OAuth2AuthCodePKCE.prototype.recoverState = function() {
        this.state = JSON.parse(localStorage.getItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE) || '{}');
        return this;
    };
    OAuth2AuthCodePKCE.prototype.setState = function(state) {
        this.state = state;
        localStorage.setItem($64be5c4bade8e7bf$exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        return this;
    };
    /**
     * Implements *base64url-encode* (RFC 4648 § 5) without padding, which is NOT
     * the same as regular base64 encoding.
     */ OAuth2AuthCodePKCE.base64urlEncode = function(value) {
        var base64 = btoa(value);
        base64 = base64.replace(/\+/g, '-');
        base64 = base64.replace(/\//g, '_');
        base64 = base64.replace(/=/g, '');
        return base64;
    };
    /**
     * Extracts a query string parameter.
     */ OAuth2AuthCodePKCE.extractParamFromUrl = function(url, param) {
        var queryString = url.split('?');
        if (queryString.length < 2) return '';
        // Account for hash URLs that SPAs usually use.
        queryString = queryString[1].split('#');
        var parts = queryString[0].split('&').reduce(function(a, s) {
            return a.concat(s.split('='));
        }, []);
        if (parts.length < 2) return '';
        var paramIdx = parts.indexOf(param);
        return decodeURIComponent(paramIdx >= 0 ? parts[paramIdx + 1] : '');
    };
    /**
     * Converts the keys and values of an object to a url query string
     */ OAuth2AuthCodePKCE.objectToQueryString = function(dict) {
        return Object.entries(dict).map(function(_a) {
            var key = _a[0], val = _a[1];
            return key + "=" + encodeURIComponent(val);
        }).join('&');
    };
    /**
     * Generates a code_verifier and code_challenge, as specified in rfc7636.
     */ OAuth2AuthCodePKCE.generatePKCECodes = function() {
        var output = new Uint32Array($64be5c4bade8e7bf$exports.RECOMMENDED_CODE_VERIFIER_LENGTH);
        crypto.getRandomValues(output);
        var codeVerifier = OAuth2AuthCodePKCE.base64urlEncode(Array.from(output).map(function(num) {
            return $64be5c4bade8e7bf$var$PKCE_CHARSET[num % $64be5c4bade8e7bf$var$PKCE_CHARSET.length];
        }).join(''));
        return crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier)).then(function(buffer) {
            var hash = new Uint8Array(buffer);
            var binary = '';
            var hashLength = hash.byteLength;
            for(var i = 0; i < hashLength; i++)binary += String.fromCharCode(hash[i]);
            return binary;
        }).then(OAuth2AuthCodePKCE.base64urlEncode).then(function(codeChallenge) {
            return {
                codeChallenge: codeChallenge,
                codeVerifier: codeVerifier
            };
        });
    };
    /**
     * Generates random state to be passed for anti-csrf.
     */ OAuth2AuthCodePKCE.generateRandomState = function(lengthOfState) {
        var output = new Uint32Array(lengthOfState);
        crypto.getRandomValues(output);
        return Array.from(output).map(function(num) {
            return $64be5c4bade8e7bf$var$PKCE_CHARSET[num % $64be5c4bade8e7bf$var$PKCE_CHARSET.length];
        }).join('');
    };
    return OAuth2AuthCodePKCE;
}();
$64be5c4bade8e7bf$exports.OAuth2AuthCodePKCE = $64be5c4bade8e7bf$var$OAuth2AuthCodePKCE;





const $829b8feac63cffab$export$ffa9969dec63837 = ()=>{
    // Use promises as mutex to prevent concurrent token refresh attempts, which causes problems.
    // More info: https://github.com/BitySA/oauth2-auth-code-pkce/issues/29
    // TODO: remove this workaround if/when oauth2-auth-code-pkce fixes the issue.
    let expiryPromise;
    let invalidGrantPromise;
    return new (0, $64be5c4bade8e7bf$exports.OAuth2AuthCodePKCE)({
        authorizationUrl: 'https://gitlab.com/oauth/authorize',
        tokenUrl: 'https://gitlab.com/oauth/token',
        clientId: "ORGANICE_GITLAB_CLIENT_ID",
        redirectUrl: window.location.origin,
        scopes: [
            'api'
        ],
        extraAuthorizationParams: {
            clientSecret: "ORGANICE_GITLAB_SECRET"
        },
        onAccessTokenExpiry: async (refreshToken)=>{
            if (!expiryPromise) expiryPromise = refreshToken();
            const result = await expiryPromise;
            expiryPromise = undefined;
            return result;
        },
        onInvalidGrant: async (refreshAuthCodeOrToken)=>{
            if (!invalidGrantPromise) invalidGrantPromise = refreshAuthCodeOrToken();
            // This is a void promise, so don't need to return the result. Refer to the TypeScript source
            // of OAuth2AuthCodePKCE. Types are great.
            await invalidGrantPromise;
            invalidGrantPromise = undefined;
        }
    });
};
const $829b8feac63cffab$export$aa55a4a49c69d614 = (projectURL)=>{
    if (!projectURL) return;
    if (!projectURL.includes('://')) // URL() class requires protocol.
    projectURL = `https://${projectURL}`;
    try {
        const url = new URL(projectURL);
        const path = url.pathname.replace(/(^\/)|(\/$)/g, '');
        // Rough heuristic to check that url at least *potentially* refers
        // to a project. Reminder: a project path is not necessarily
        // /user/project because it may be under one or more groups such
        // as /user/group/subgroup/project.
        if (url.hostname === 'gitlab.com' && path.split('/').length > 1) return encodeURIComponent(path);
        else return undefined;
    } catch (e) {
        console.error('Error trying to get gitLab project_id from URL:');
        console.error(e);
        return undefined;
    }
};
const $829b8feac63cffab$export$b2d2b06d7e84c860 = (links)=>{
    if (!links) return {};
    // Based on https://stackoverflow.com/a/48109741
    return links.split(',').reduce((acc, link)=>{
        const match = link.match(/<(.*)>; rel="(\w*)"/);
        const url = match[1];
        const rel = match[2];
        acc[rel] = url;
        return acc;
    }, {});
};
const $829b8feac63cffab$export$ef6b3df672d6bc42 = (tree)=>{
    const isDirectory = (it)=>it.type === 'tree';
    return (0, $3044e0bef3624137$exports.fromJS)(tree.filter((it)=>isDirectory(it) || it.name.match((0, $2ce140c2c56df8f2$export$cb89f492e03ac783))).map((it)=>({
            id: it.id,
            name: it.name,
            // Organice requires a leading "/", whereas GitLab API doesn't
            // use one.
            path: `/${it.path}`,
            isDirectory: isDirectory(it)
        })).sort((a, b)=>{
        // Folders first.
        if (a.isDirectory && !b.isDirectory) return -1;
        else if (!a.isDirectory && b.isDirectory) return 1;
        else // Can't have same name, so don't need to check if
        // equal/return 0.
        return a.name > b.name ? 1 : -1;
    }));
};
const $829b8feac63cffab$var$API_URL = 'https://gitlab.com/api/v4';
var /**
 * GitLab sync backend, implemented using their REST API.
 *
 * @see https://docs.gitlab.com/ee/api/api_resources.html
 * @param {OAuth2AuthCodePKCE} oauthClient
 */ $829b8feac63cffab$export$2e2bcd8739ae039 = (oauthClient)=>{
    const decoratedFetch = oauthClient.decorateFetchHTTPClient(fetch);
    const getProjectApi = ()=>`${$829b8feac63cffab$var$API_URL}/projects/${(0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('gitLabProject')}`;
    const isSignedIn = async ()=>{
        if (!oauthClient.isAuthorized()) return false;
        // Verify that we have an OAuth token (and refresh if needed).
        // Don't care about return value, because the library handles
        // persisting for us.
        try {
            await oauthClient.getAccessToken();
            return true;
        } catch (e) {
            console.error('Error trying to get OAuth access token.');
            console.error(e);
            return false;
        }
    };
    /**
   * Check that project exists and user is *probably* able to commit
   * to it. This doesn't take branch protection into consideration, so
   * it's not perfect... but who uses protected branches for the org
   * files?
   *
   * This is separate from `isSignedIn` to avoid the overhead of
   * multiple API calls every time the page is loaded.
   */ const isProjectAccessible = async ()=>{
        // Check project exists and user is a member who can *probably*
        // commit.
        const [userResponse, membersResponse] = await Promise.all([
            // https://docs.gitlab.com/ee/api/users.html#list-current-user-for-normal-users
            decoratedFetch(`${$829b8feac63cffab$var$API_URL}/user`),
            // https://docs.gitlab.com/ee/api/members.html#list-all-members-of-a-group-or-project
            decoratedFetch(`${getProjectApi()}/members`)
        ]);
        if (!userResponse.ok || !membersResponse.ok) return false;
        const [user, members] = await Promise.all([
            userResponse.json(),
            membersResponse.json()
        ]);
        const matched = members.find((m)=>m.id === user.id);
        // Access levels:
        // https://docs.gitlab.com/ee/api/members.html#valid-access-levels
        // Permissions:
        // https://docs.gitlab.com/ee/user/permissions.html#project-members-permissions
        // 30 is developer, which is the minimum to commit to a
        // non-protected branch. If branch is protected then they still
        // might be be able to commit, but this is good enough.
        return matched && matched.access_level >= 30;
    };
    let cachedDefaultBranch;
    const getDefaultBranch = async ()=>{
        if (!cachedDefaultBranch) {
            // https://docs.gitlab.com/ee/api/projects.html#get-single-project
            const response = await decoratedFetch(getProjectApi());
            if (!response.ok) throw new Error(`Unexpected response from project API. Status code: ${response.status}`);
            const body = await response.json();
            cachedDefaultBranch = body.default_branch;
        }
        return cachedDefaultBranch;
    };
    const fetchDirectory = async (url)=>{
        const response = await decoratedFetch(url);
        if (!response.ok) throw new Error(`Unexpected response from directory API. Status code: ${response.status}`);
        const pages = $829b8feac63cffab$export$b2d2b06d7e84c860(response.headers.get('link'));
        const data = await response.json();
        return {
            listing: $829b8feac63cffab$export$ef6b3df672d6bc42(data),
            hasMore: !!pages.next,
            additionalSyncBackendState: (0, $3044e0bef3624137$exports.Map)({
                cursor: pages.next
            })
        };
    };
    const getDirectoryListing = async (path)=>{
        const params = new URLSearchParams({
            pagination: 'keyset',
            ref: await getDefaultBranch(),
            // Organice requires a leading "/", whereas GitLab API requires
            // there *not* be one.
            path: path.replace(/^\//, ''),
            per_page: 100
        });
        // https://docs.gitlab.com/ee/api/repositories.html#list-repository-tree
        return await fetchDirectory(`${getProjectApi()}/repository/tree?${params}`);
    };
    const getMoreDirectoryListing = async (additionalSyncBackendState)=>await fetchDirectory(additionalSyncBackendState.get('cursor'));
    const getRawFile = async (path)=>{
        const params = new URLSearchParams({
            ref: await getDefaultBranch()
        });
        const encodedPath = encodeURIComponent(path.replace(/^\//, ''));
        // https://docs.gitlab.com/ee/api/repository_files.html#get-raw-file-from-repository
        const response = await decoratedFetch(`${getProjectApi()}/repository/files/${encodedPath}/raw?${params}`);
        if (!response.ok) throw new Error(`Unexpected response from file API. Status code: ${response.status}`);
        return {
            contents: await response.text(),
            commit: response.headers.get('x-gitlab-last-commit-id')
        };
    };
    const getCommitDate = async (sha)=>{
        // https://docs.gitlab.com/ee/api/commits.html#get-a-single-commit
        const response = await decoratedFetch(`${getProjectApi()}/repository/commits/${sha}?stats=false`);
        if (!response.ok) throw new Error(`Unexpected response from commit API. Status code: ${response.status}`);
        const body = await response.json();
        // Dates are ISO-8601. Note: while commit date *should* generally
        // be the same as or later than the author date, that isn't
        // guaranteed since history can be rewritten at will. So we pick
        // the newer of the two.
        const committed = new Date(body.committed_date);
        const authored = new Date(body.authored_date);
        // Use Date objects for comparison, but need to return as strings.
        return committed > authored ? committed.toISOString() : authored.toISOString();
    };
    const getFileContentsAndMetadata = async (path)=>{
        const file = await getRawFile(path);
        return {
            contents: file.contents,
            lastModifiedAt: await getCommitDate(file.commit)
        };
    };
    // Parentheses are necessarily to await the actual promise. Yay,
    // foot-guns.
    const getFileContents = async (path)=>(await getRawFile(path)).contents;
    const doCommit = async (action)=>{
        const capitalizedAction = action.action.charAt(0).toUpperCase() + action.action.slice(1);
        // Two newlines because Git commits should have an empty line
        // between title and body.
        const message = `[organice] ${capitalizedAction} ${action.file_path}\n\n` + 'Automatic commit from organice app.';
        // It's also possible to modify files using the files API instead
        // of commits API. For this use case they're about equal, but I
        // picked commits because it doesn't require non-standard encoding
        // for file paths, whereas the files API requires URI encoding
        // plus converting period characters to %2E. Also, the commits API
        // is more flexible in case of future changes, since it allows
        // modifying multiple files at a time.
        //
        // https://docs.gitlab.com/ee/api/commits.html#create-a-commit-with-multiple-files-and-actions
        // https://docs.gitlab.com/ee/api/repository_files.html
        await decoratedFetch(`${getProjectApi()}/repository/commits`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                branch: await getDefaultBranch(),
                commit_message: message,
                // Organice only modifies a single file at a time, so only one action.
                actions: [
                    action
                ],
                stats: false
            })
        });
    };
    const createFile = async (path, content)=>{
        await doCommit({
            action: 'create',
            file_path: path.replace(/^\//, ''),
            content: content
        });
    };
    const updateFile = async (path, content)=>{
        await doCommit({
            action: 'update',
            file_path: path.replace(/^\//, ''),
            content: content
        });
    };
    const deleteFile = async (path)=>{
        await doCommit({
            action: 'delete',
            file_path: path.replace(/^\//, '')
        });
    };
    return {
        type: 'GitLab',
        isSignedIn: isSignedIn,
        isProjectAccessible: isProjectAccessible,
        getDirectoryListing: getDirectoryListing,
        getMoreDirectoryListing: getMoreDirectoryListing,
        updateFile: updateFile,
        createFile: createFile,
        getFileContentsAndMetadata: getFileContentsAndMetadata,
        getFileContents: getFileContents,
        deleteFile: deleteFile
    };
};




var $1X5R2 = parcelRequire("1X5R2");
var $2a0d35196a71eae5$exports = {};

var $3iXjX = parcelRequire("3iXjX");
'use strict';
var $2a0d35196a71eae5$var$isWindows = $3iXjX.platform === 'win32';
// Regex to split a windows path into into [dir, root, basename, name, ext]
var $2a0d35196a71eae5$var$splitWindowsRe = /^(((?:[a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?[\\\/]?)(?:[^\\\/]*[\\\/])*)((\.{1,2}|[^\\\/]+?|)(\.[^.\/\\]*|))[\\\/]*$/;
var $2a0d35196a71eae5$var$win32 = {};
function $2a0d35196a71eae5$var$win32SplitPath(filename) {
    return $2a0d35196a71eae5$var$splitWindowsRe.exec(filename).slice(1);
}
$2a0d35196a71eae5$var$win32.parse = function(pathString) {
    if (typeof pathString !== 'string') throw new TypeError("Parameter 'pathString' must be a string, not " + typeof pathString);
    var allParts = $2a0d35196a71eae5$var$win32SplitPath(pathString);
    if (!allParts || allParts.length !== 5) throw new TypeError("Invalid path '" + pathString + "'");
    return {
        root: allParts[1],
        dir: allParts[0] === allParts[1] ? allParts[0] : allParts[0].slice(0, -1),
        base: allParts[2],
        ext: allParts[4],
        name: allParts[3]
    };
};
// Split a filename into [dir, root, basename, name, ext], unix version
// 'root' is just a slash, or nothing.
var $2a0d35196a71eae5$var$splitPathRe = /^((\/?)(?:[^\/]*\/)*)((\.{1,2}|[^\/]+?|)(\.[^.\/]*|))[\/]*$/;
var $2a0d35196a71eae5$var$posix = {};
function $2a0d35196a71eae5$var$posixSplitPath(filename) {
    return $2a0d35196a71eae5$var$splitPathRe.exec(filename).slice(1);
}
$2a0d35196a71eae5$var$posix.parse = function(pathString) {
    if (typeof pathString !== 'string') throw new TypeError("Parameter 'pathString' must be a string, not " + typeof pathString);
    var allParts = $2a0d35196a71eae5$var$posixSplitPath(pathString);
    if (!allParts || allParts.length !== 5) throw new TypeError("Invalid path '" + pathString + "'");
    return {
        root: allParts[1],
        dir: allParts[0].slice(0, -1),
        base: allParts[2],
        ext: allParts[4],
        name: allParts[3]
    };
};
if ($2a0d35196a71eae5$var$isWindows) $2a0d35196a71eae5$exports = $2a0d35196a71eae5$var$win32.parse;
else /* posix */ $2a0d35196a71eae5$exports = $2a0d35196a71eae5$var$posix.parse;
$2a0d35196a71eae5$exports.posix = $2a0d35196a71eae5$var$posix.parse;
$2a0d35196a71eae5$exports.win32 = $2a0d35196a71eae5$var$win32.parse;


const $f257bd084a67bcde$export$b0ac3a1c242cb1ea = ()=>(dispatch, getState)=>{
        switch(getState().syncBackend.get('client', {}).type){
            case 'WebDAV':
                [
                    'Endpoint',
                    'Username',
                    'Password'
                ].forEach((e)=>{
                    (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('webdav' + e, null);
                });
                break;
            case 'Dropbox':
                // `dropboxAccessToken` is a legacy token that was relevant
                // prior to switching to OAuth 2 and PKCE. Still deleting it
                // here for a consistent state in users localStorage.
                (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('dropboxAccessToken', null);
                (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('dropboxRefreshToken', null);
                (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('codeVerifier', null);
                break;
            case 'GitLab':
                (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('gitLabProject', null);
                (0, $829b8feac63cffab$export$ffa9969dec63837)().reset();
                break;
            default:
        }
        (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('authenticatedSyncService', null);
        dispatch({
            type: 'SIGN_OUT'
        });
        dispatch((0, $1780206710f3c846$export$b5212ec6a6e9531e)());
        dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
        if (0, $18ca84fc585e0c6b$export$c43914e0cb16a981) localStorage.clear();
    };
const $f257bd084a67bcde$export$6030e59027cfe97c = (directoryListing, hasMore, additionalSyncBackendState, path)=>({
        type: 'SET_CURRENT_FILE_BROWSER_DIRECTORY_LISTING',
        directoryListing: directoryListing,
        hasMore: hasMore,
        additionalSyncBackendState: additionalSyncBackendState,
        path: path
    });
const $f257bd084a67bcde$export$7026bb370907ccf6 = (isLoadingMore)=>({
        type: 'SET_IS_LOADING_MORE_DIRECTORY_LISTING',
        isLoadingMore: isLoadingMore
    });
const $f257bd084a67bcde$export$54f61a6f215b3a81 = (path)=>(dispatch, getState)=>{
        dispatch((0, $1780206710f3c846$export$b75e26cdc67a486a)('Getting listing...'));
        const client = getState().syncBackend.get('client');
        client.getDirectoryListing(path).then(({ listing: listing, hasMore: hasMore, additionalSyncBackendState: additionalSyncBackendState })=>{
            dispatch($f257bd084a67bcde$export$6030e59027cfe97c(listing, hasMore, additionalSyncBackendState, path));
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
        }).catch((error)=>{
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            const error_summary = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).get(error, 'error.error_summary') || '';
            if ([
                400,
                401
            ].includes(error.status) || error_summary.includes('expired_access_token')) dispatch($f257bd084a67bcde$export$b0ac3a1c242cb1ea());
            else {
                alert('There was an error retrieving files!');
                console.error(error);
            }
        });
    };
const $f257bd084a67bcde$export$75073871eb6a230a = ()=>(dispatch, getState)=>{
        dispatch($f257bd084a67bcde$export$7026bb370907ccf6(true));
        const client = getState().syncBackend.get('client');
        const currentFileBrowserDirectoryListing = getState().syncBackend.get('currentFileBrowserDirectoryListing');
        client.getMoreDirectoryListing(currentFileBrowserDirectoryListing.get('additionalSyncBackendState')).then(({ listing: listing, hasMore: hasMore, additionalSyncBackendState: additionalSyncBackendState })=>{
            const extendedListing = currentFileBrowserDirectoryListing.get('listing').concat(listing);
            dispatch($f257bd084a67bcde$export$6030e59027cfe97c(extendedListing, hasMore, additionalSyncBackendState));
            dispatch($f257bd084a67bcde$export$7026bb370907ccf6(false));
        });
    };
const $f257bd084a67bcde$export$4463ab184c19f1fc = (pathOrFileId, contents)=>{
    return (dispatch, getState)=>{
        const client = getState().syncBackend.get('client');
        switch(client.type){
            case 'Dropbox':
            case 'WebDAV':
                client.createFile(`${pathOrFileId}.organice-bak`, contents);
                break;
            case 'GitLab':
                break;
            default:
        }
    };
};
const $f257bd084a67bcde$export$bb3b75778e3e272 = (path)=>{
    return (dispatch, getState)=>{
        dispatch((0, $1780206710f3c846$export$b75e26cdc67a486a)(`Downloading file ...`));
        getState().syncBackend.get('client').getFileContents(path).then((fileContents)=>{
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            dispatch($f257bd084a67bcde$export$4463ab184c19f1fc(path, fileContents));
            dispatch((0, $d81b80734fbc24a5$export$f1c553d4f1a2351)(path, fileContents));
            dispatch((0, $d81b80734fbc24a5$export$881bc3db7e40e575)((0, $06257fecbb2b5848$export$2e2bcd8739ae039)(new Date(), 5), path));
            dispatch((0, $d81b80734fbc24a5$export$4447eddabc434410)(false, path));
            dispatch((0, $5624140532e76935$exports.ActionCreators).clearHistory());
        }).catch(()=>{
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
            dispatch((0, $d81b80734fbc24a5$export$efc903f8ecc96b3d)(`File ${path} not found`));
        });
    };
};
/**
 * @param {String} path Returns the directory name of `path`.
 */ function $f257bd084a67bcde$var$dirName(path) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2a0d35196a71eae5$exports)))(path).dir;
}
const $f257bd084a67bcde$export$982c3a0b9a5cde94 = (path, content)=>{
    return (dispatch, getState)=>{
        dispatch((0, $1780206710f3c846$export$b75e26cdc67a486a)(`Creating file: ${path}`));
        getState().syncBackend.get('client').createFile(path, content).then(()=>{
            dispatch((0, $d81b80734fbc24a5$export$881bc3db7e40e575)((0, $06257fecbb2b5848$export$2e2bcd8739ae039)(new Date(), 5), path));
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            dispatch($f257bd084a67bcde$export$54f61a6f215b3a81($f257bd084a67bcde$var$dirName(path)));
        }).catch(()=>{
            dispatch((0, $1780206710f3c846$export$80775798c6eb9d34)());
            dispatch((0, $1780206710f3c846$export$9eaa806651dd33f0)(false, path));
            dispatch((0, $d81b80734fbc24a5$export$efc903f8ecc96b3d)(`File ${path} not found`));
        });
    };
};



/* global process */ 
var $1X5R2 = parcelRequire("1X5R2");


var $1044f5047434e84b$exports = {};

var $8f5i0 = parcelRequire("8f5i0");
var $1044f5047434e84b$require$Buffer = $8f5i0.Buffer;



!function(e, t) {
    t($1044f5047434e84b$exports);
}($1044f5047434e84b$exports, function(e) {
    "use strict";
    function t(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function r(e, t) {
        for(var r = 0; t.length > r; r++){
            var s = t[r];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function s(e, t, s) {
        return t && r(e.prototype, t), s && r(e, s), e;
    }
    function i(e) {
        return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function n(e, t) {
        return (n = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }
    function o(e, t, r) {
        return (o = a() ? Reflect.construct : function(e, t, r) {
            var s = [
                null
            ];
            s.push.apply(s, t);
            var i = new (Function.bind.apply(e, s));
            return r && n(i, r.prototype), i;
        }).apply(null, arguments);
    }
    function u(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return (u = function(e) {
            if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
            }
            function r() {
                return o(e, arguments, i(this).constructor);
            }
            return r.prototype = Object.create(e.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), n(r, e);
        })(e);
    }
    function c(e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? function(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }(e) : t;
    }
    var p = "app", l = "user", f = "team", m = "dropboxapi.com", h = "dropbox.com", d = {
        api: "api",
        notify: "bolt",
        content: "api-content"
    }, _ = {};
    function g(e) {
        var t = "000".concat(e.charCodeAt(0).toString(16)).slice(-4);
        return "\\u".concat(t);
    }
    _.accountSetProfilePhoto = function(e) {
        return this.request("account/set_profile_photo", e, "user", "api", "rpc", "account_info.write");
    }, _.authTokenFromOauth1 = function(e) {
        return this.request("auth/token/from_oauth1", e, "app", "api", "rpc", null);
    }, _.authTokenRevoke = function() {
        return this.request("auth/token/revoke", null, "user", "api", "rpc", null);
    }, _.checkApp = function(e) {
        return this.request("check/app", e, "app", "api", "rpc", null);
    }, _.checkUser = function(e) {
        return this.request("check/user", e, "user", "api", "rpc", "account_info.read");
    }, _.contactsDeleteManualContacts = function() {
        return this.request("contacts/delete_manual_contacts", null, "user", "api", "rpc", "contacts.write");
    }, _.contactsDeleteManualContactsBatch = function(e) {
        return this.request("contacts/delete_manual_contacts_batch", e, "user", "api", "rpc", "contacts.write");
    }, _.filePropertiesPropertiesAdd = function(e) {
        return this.request("file_properties/properties/add", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesPropertiesOverwrite = function(e) {
        return this.request("file_properties/properties/overwrite", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesPropertiesRemove = function(e) {
        return this.request("file_properties/properties/remove", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesPropertiesSearch = function(e) {
        return this.request("file_properties/properties/search", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filePropertiesPropertiesSearchContinue = function(e) {
        return this.request("file_properties/properties/search/continue", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filePropertiesPropertiesUpdate = function(e) {
        return this.request("file_properties/properties/update", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesTemplatesAddForTeam = function(e) {
        return this.request("file_properties/templates/add_for_team", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.filePropertiesTemplatesAddForUser = function(e) {
        return this.request("file_properties/templates/add_for_user", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesTemplatesGetForTeam = function(e) {
        return this.request("file_properties/templates/get_for_team", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.filePropertiesTemplatesGetForUser = function(e) {
        return this.request("file_properties/templates/get_for_user", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filePropertiesTemplatesListForTeam = function() {
        return this.request("file_properties/templates/list_for_team", null, "team", "api", "rpc", "files.team_metadata.write");
    }, _.filePropertiesTemplatesListForUser = function() {
        return this.request("file_properties/templates/list_for_user", null, "user", "api", "rpc", "files.metadata.read");
    }, _.filePropertiesTemplatesRemoveForTeam = function(e) {
        return this.request("file_properties/templates/remove_for_team", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.filePropertiesTemplatesRemoveForUser = function(e) {
        return this.request("file_properties/templates/remove_for_user", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filePropertiesTemplatesUpdateForTeam = function(e) {
        return this.request("file_properties/templates/update_for_team", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.filePropertiesTemplatesUpdateForUser = function(e) {
        return this.request("file_properties/templates/update_for_user", e, "user", "api", "rpc", "files.metadata.write");
    }, _.fileRequestsCount = function() {
        return this.request("file_requests/count", null, "user", "api", "rpc", "file_requests.read");
    }, _.fileRequestsCreate = function(e) {
        return this.request("file_requests/create", e, "user", "api", "rpc", "file_requests.write");
    }, _.fileRequestsDelete = function(e) {
        return this.request("file_requests/delete", e, "user", "api", "rpc", "file_requests.write");
    }, _.fileRequestsDeleteAllClosed = function() {
        return this.request("file_requests/delete_all_closed", null, "user", "api", "rpc", "file_requests.write");
    }, _.fileRequestsGet = function(e) {
        return this.request("file_requests/get", e, "user", "api", "rpc", "file_requests.read");
    }, _.fileRequestsListV2 = function(e) {
        return this.request("file_requests/list_v2", e, "user", "api", "rpc", "file_requests.read");
    }, _.fileRequestsList = function() {
        return this.request("file_requests/list", null, "user", "api", "rpc", "file_requests.read");
    }, _.fileRequestsListContinue = function(e) {
        return this.request("file_requests/list/continue", e, "user", "api", "rpc", "file_requests.read");
    }, _.fileRequestsUpdate = function(e) {
        return this.request("file_requests/update", e, "user", "api", "rpc", "file_requests.write");
    }, _.filesAlphaGetMetadata = function(e) {
        return this.request("files/alpha/get_metadata", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesAlphaUpload = function(e) {
        return this.request("files/alpha/upload", e, "user", "content", "upload", "files.content.write");
    }, _.filesCopyV2 = function(e) {
        return this.request("files/copy_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopy = function(e) {
        return this.request("files/copy", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyBatchV2 = function(e) {
        return this.request("files/copy_batch_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyBatch = function(e) {
        return this.request("files/copy_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyBatchCheckV2 = function(e) {
        return this.request("files/copy_batch/check_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyBatchCheck = function(e) {
        return this.request("files/copy_batch/check", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyReferenceGet = function(e) {
        return this.request("files/copy_reference/get", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCopyReferenceSave = function(e) {
        return this.request("files/copy_reference/save", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCreateFolderV2 = function(e) {
        return this.request("files/create_folder_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCreateFolder = function(e) {
        return this.request("files/create_folder", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCreateFolderBatch = function(e) {
        return this.request("files/create_folder_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesCreateFolderBatchCheck = function(e) {
        return this.request("files/create_folder_batch/check", e, "user", "api", "rpc", "files.content.write");
    }, _.filesDeleteV2 = function(e) {
        return this.request("files/delete_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesDelete = function(e) {
        return this.request("files/delete", e, "user", "api", "rpc", "files.content.write");
    }, _.filesDeleteBatch = function(e) {
        return this.request("files/delete_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesDeleteBatchCheck = function(e) {
        return this.request("files/delete_batch/check", e, "user", "api", "rpc", "files.content.write");
    }, _.filesDownload = function(e) {
        return this.request("files/download", e, "user", "content", "download", "files.content.read");
    }, _.filesDownloadZip = function(e) {
        return this.request("files/download_zip", e, "user", "content", "download", "files.content.read");
    }, _.filesExport = function(e) {
        return this.request("files/export", e, "user", "content", "download", "files.content.read");
    }, _.filesGetFileLockBatch = function(e) {
        return this.request("files/get_file_lock_batch", e, "user", "api", "rpc", "files.content.read");
    }, _.filesGetMetadata = function(e) {
        return this.request("files/get_metadata", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesGetPreview = function(e) {
        return this.request("files/get_preview", e, "user", "content", "download", "files.content.read");
    }, _.filesGetTemporaryLink = function(e) {
        return this.request("files/get_temporary_link", e, "user", "api", "rpc", "files.content.read");
    }, _.filesGetTemporaryUploadLink = function(e) {
        return this.request("files/get_temporary_upload_link", e, "user", "api", "rpc", "files.content.write");
    }, _.filesGetThumbnail = function(e) {
        return this.request("files/get_thumbnail", e, "user", "content", "download", "files.content.read");
    }, _.filesGetThumbnailV2 = function(e) {
        return this.request("files/get_thumbnail_v2", e, "app, user", "content", "download", "files.content.read");
    }, _.filesGetThumbnailBatch = function(e) {
        return this.request("files/get_thumbnail_batch", e, "user", "content", "rpc", "files.content.read");
    }, _.filesListFolder = function(e) {
        return this.request("files/list_folder", e, "app, user", "api", "rpc", "files.metadata.read");
    }, _.filesListFolderContinue = function(e) {
        return this.request("files/list_folder/continue", e, "app, user", "api", "rpc", "files.metadata.read");
    }, _.filesListFolderGetLatestCursor = function(e) {
        return this.request("files/list_folder/get_latest_cursor", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesListFolderLongpoll = function(e) {
        return this.request("files/list_folder/longpoll", e, "noauth", "notify", "rpc", "files.metadata.read");
    }, _.filesListRevisions = function(e) {
        return this.request("files/list_revisions", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesLockFileBatch = function(e) {
        return this.request("files/lock_file_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMoveV2 = function(e) {
        return this.request("files/move_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMove = function(e) {
        return this.request("files/move", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMoveBatchV2 = function(e) {
        return this.request("files/move_batch_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMoveBatch = function(e) {
        return this.request("files/move_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMoveBatchCheckV2 = function(e) {
        return this.request("files/move_batch/check_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesMoveBatchCheck = function(e) {
        return this.request("files/move_batch/check", e, "user", "api", "rpc", "files.content.write");
    }, _.filesPaperCreate = function(e) {
        return this.request("files/paper/create", e, "user", "api", "upload", "files.content.write");
    }, _.filesPaperUpdate = function(e) {
        return this.request("files/paper/update", e, "user", "api", "upload", "files.content.write");
    }, _.filesPermanentlyDelete = function(e) {
        return this.request("files/permanently_delete", e, "user", "api", "rpc", "files.permanent_delete");
    }, _.filesPropertiesAdd = function(e) {
        return this.request("files/properties/add", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesPropertiesOverwrite = function(e) {
        return this.request("files/properties/overwrite", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesPropertiesRemove = function(e) {
        return this.request("files/properties/remove", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesPropertiesTemplateGet = function(e) {
        return this.request("files/properties/template/get", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesPropertiesTemplateList = function() {
        return this.request("files/properties/template/list", null, "user", "api", "rpc", "files.metadata.read");
    }, _.filesPropertiesUpdate = function(e) {
        return this.request("files/properties/update", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesRestore = function(e) {
        return this.request("files/restore", e, "user", "api", "rpc", "files.content.write");
    }, _.filesSaveUrl = function(e) {
        return this.request("files/save_url", e, "user", "api", "rpc", "files.content.write");
    }, _.filesSaveUrlCheckJobStatus = function(e) {
        return this.request("files/save_url/check_job_status", e, "user", "api", "rpc", "files.content.write");
    }, _.filesSearch = function(e) {
        return this.request("files/search", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesSearchV2 = function(e) {
        return this.request("files/search_v2", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesSearchContinueV2 = function(e) {
        return this.request("files/search/continue_v2", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesTagsAdd = function(e) {
        return this.request("files/tags/add", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesTagsGet = function(e) {
        return this.request("files/tags/get", e, "user", "api", "rpc", "files.metadata.read");
    }, _.filesTagsRemove = function(e) {
        return this.request("files/tags/remove", e, "user", "api", "rpc", "files.metadata.write");
    }, _.filesUnlockFileBatch = function(e) {
        return this.request("files/unlock_file_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesUpload = function(e) {
        return this.request("files/upload", e, "user", "content", "upload", "files.content.write");
    }, _.filesUploadSessionAppendV2 = function(e) {
        return this.request("files/upload_session/append_v2", e, "user", "content", "upload", "files.content.write");
    }, _.filesUploadSessionAppend = function(e) {
        return this.request("files/upload_session/append", e, "user", "content", "upload", "files.content.write");
    }, _.filesUploadSessionFinish = function(e) {
        return this.request("files/upload_session/finish", e, "user", "content", "upload", "files.content.write");
    }, _.filesUploadSessionFinishBatch = function(e) {
        return this.request("files/upload_session/finish_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.filesUploadSessionFinishBatchV2 = function(e) {
        return this.request("files/upload_session/finish_batch_v2", e, "user", "api", "rpc", "files.content.write");
    }, _.filesUploadSessionFinishBatchCheck = function(e) {
        return this.request("files/upload_session/finish_batch/check", e, "user", "api", "rpc", "files.content.write");
    }, _.filesUploadSessionStart = function(e) {
        return this.request("files/upload_session/start", e, "user", "content", "upload", "files.content.write");
    }, _.filesUploadSessionStartBatch = function(e) {
        return this.request("files/upload_session/start_batch", e, "user", "api", "rpc", "files.content.write");
    }, _.paperDocsArchive = function(e) {
        return this.request("paper/docs/archive", e, "user", "api", "rpc", "files.content.write");
    }, _.paperDocsCreate = function(e) {
        return this.request("paper/docs/create", e, "user", "api", "upload", "files.content.write");
    }, _.paperDocsDownload = function(e) {
        return this.request("paper/docs/download", e, "user", "api", "download", "files.content.read");
    }, _.paperDocsFolderUsersList = function(e) {
        return this.request("paper/docs/folder_users/list", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsFolderUsersListContinue = function(e) {
        return this.request("paper/docs/folder_users/list/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsGetFolderInfo = function(e) {
        return this.request("paper/docs/get_folder_info", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsList = function(e) {
        return this.request("paper/docs/list", e, "user", "api", "rpc", "files.metadata.read");
    }, _.paperDocsListContinue = function(e) {
        return this.request("paper/docs/list/continue", e, "user", "api", "rpc", "files.metadata.read");
    }, _.paperDocsPermanentlyDelete = function(e) {
        return this.request("paper/docs/permanently_delete", e, "user", "api", "rpc", "files.permanent_delete");
    }, _.paperDocsSharingPolicyGet = function(e) {
        return this.request("paper/docs/sharing_policy/get", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsSharingPolicySet = function(e) {
        return this.request("paper/docs/sharing_policy/set", e, "user", "api", "rpc", "sharing.write");
    }, _.paperDocsUpdate = function(e) {
        return this.request("paper/docs/update", e, "user", "api", "upload", "files.content.write");
    }, _.paperDocsUsersAdd = function(e) {
        return this.request("paper/docs/users/add", e, "user", "api", "rpc", "sharing.write");
    }, _.paperDocsUsersList = function(e) {
        return this.request("paper/docs/users/list", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsUsersListContinue = function(e) {
        return this.request("paper/docs/users/list/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.paperDocsUsersRemove = function(e) {
        return this.request("paper/docs/users/remove", e, "user", "api", "rpc", "sharing.write");
    }, _.paperFoldersCreate = function(e) {
        return this.request("paper/folders/create", e, "user", "api", "rpc", "files.content.write");
    }, _.sharingAddFileMember = function(e) {
        return this.request("sharing/add_file_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingAddFolderMember = function(e) {
        return this.request("sharing/add_folder_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingCheckJobStatus = function(e) {
        return this.request("sharing/check_job_status", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingCheckRemoveMemberJobStatus = function(e) {
        return this.request("sharing/check_remove_member_job_status", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingCheckShareJobStatus = function(e) {
        return this.request("sharing/check_share_job_status", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingCreateSharedLink = function(e) {
        return this.request("sharing/create_shared_link", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingCreateSharedLinkWithSettings = function(e) {
        return this.request("sharing/create_shared_link_with_settings", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingGetFileMetadata = function(e) {
        return this.request("sharing/get_file_metadata", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingGetFileMetadataBatch = function(e) {
        return this.request("sharing/get_file_metadata/batch", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingGetFolderMetadata = function(e) {
        return this.request("sharing/get_folder_metadata", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingGetSharedLinkFile = function(e) {
        return this.request("sharing/get_shared_link_file", e, "user", "content", "download", "sharing.read");
    }, _.sharingGetSharedLinkMetadata = function(e) {
        return this.request("sharing/get_shared_link_metadata", e, "app, user", "api", "rpc", "sharing.read");
    }, _.sharingGetSharedLinks = function(e) {
        return this.request("sharing/get_shared_links", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFileMembers = function(e) {
        return this.request("sharing/list_file_members", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFileMembersBatch = function(e) {
        return this.request("sharing/list_file_members/batch", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFileMembersContinue = function(e) {
        return this.request("sharing/list_file_members/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFolderMembers = function(e) {
        return this.request("sharing/list_folder_members", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFolderMembersContinue = function(e) {
        return this.request("sharing/list_folder_members/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFolders = function(e) {
        return this.request("sharing/list_folders", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListFoldersContinue = function(e) {
        return this.request("sharing/list_folders/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListMountableFolders = function(e) {
        return this.request("sharing/list_mountable_folders", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListMountableFoldersContinue = function(e) {
        return this.request("sharing/list_mountable_folders/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListReceivedFiles = function(e) {
        return this.request("sharing/list_received_files", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListReceivedFilesContinue = function(e) {
        return this.request("sharing/list_received_files/continue", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingListSharedLinks = function(e) {
        return this.request("sharing/list_shared_links", e, "user", "api", "rpc", "sharing.read");
    }, _.sharingModifySharedLinkSettings = function(e) {
        return this.request("sharing/modify_shared_link_settings", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingMountFolder = function(e) {
        return this.request("sharing/mount_folder", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRelinquishFileMembership = function(e) {
        return this.request("sharing/relinquish_file_membership", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRelinquishFolderMembership = function(e) {
        return this.request("sharing/relinquish_folder_membership", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRemoveFileMember = function(e) {
        return this.request("sharing/remove_file_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRemoveFileMember2 = function(e) {
        return this.request("sharing/remove_file_member_2", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRemoveFolderMember = function(e) {
        return this.request("sharing/remove_folder_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingRevokeSharedLink = function(e) {
        return this.request("sharing/revoke_shared_link", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingSetAccessInheritance = function(e) {
        return this.request("sharing/set_access_inheritance", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingShareFolder = function(e) {
        return this.request("sharing/share_folder", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingTransferFolder = function(e) {
        return this.request("sharing/transfer_folder", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUnmountFolder = function(e) {
        return this.request("sharing/unmount_folder", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUnshareFile = function(e) {
        return this.request("sharing/unshare_file", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUnshareFolder = function(e) {
        return this.request("sharing/unshare_folder", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUpdateFileMember = function(e) {
        return this.request("sharing/update_file_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUpdateFolderMember = function(e) {
        return this.request("sharing/update_folder_member", e, "user", "api", "rpc", "sharing.write");
    }, _.sharingUpdateFolderPolicy = function(e) {
        return this.request("sharing/update_folder_policy", e, "user", "api", "rpc", "sharing.write");
    }, _.teamDevicesListMemberDevices = function(e) {
        return this.request("team/devices/list_member_devices", e, "team", "api", "rpc", "sessions.list");
    }, _.teamDevicesListMembersDevices = function(e) {
        return this.request("team/devices/list_members_devices", e, "team", "api", "rpc", "sessions.list");
    }, _.teamDevicesListTeamDevices = function(e) {
        return this.request("team/devices/list_team_devices", e, "team", "api", "rpc", "sessions.list");
    }, _.teamDevicesRevokeDeviceSession = function(e) {
        return this.request("team/devices/revoke_device_session", e, "team", "api", "rpc", "sessions.modify");
    }, _.teamDevicesRevokeDeviceSessionBatch = function(e) {
        return this.request("team/devices/revoke_device_session_batch", e, "team", "api", "rpc", "sessions.modify");
    }, _.teamFeaturesGetValues = function(e) {
        return this.request("team/features/get_values", e, "team", "api", "rpc", "team_info.read");
    }, _.teamGetInfo = function() {
        return this.request("team/get_info", null, "team", "api", "rpc", "team_info.read");
    }, _.teamGroupsCreate = function(e) {
        return this.request("team/groups/create", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsDelete = function(e) {
        return this.request("team/groups/delete", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsGetInfo = function(e) {
        return this.request("team/groups/get_info", e, "team", "api", "rpc", "groups.read");
    }, _.teamGroupsJobStatusGet = function(e) {
        return this.request("team/groups/job_status/get", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsList = function(e) {
        return this.request("team/groups/list", e, "team", "api", "rpc", "groups.read");
    }, _.teamGroupsListContinue = function(e) {
        return this.request("team/groups/list/continue", e, "team", "api", "rpc", "groups.read");
    }, _.teamGroupsMembersAdd = function(e) {
        return this.request("team/groups/members/add", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsMembersList = function(e) {
        return this.request("team/groups/members/list", e, "team", "api", "rpc", "groups.read");
    }, _.teamGroupsMembersListContinue = function(e) {
        return this.request("team/groups/members/list/continue", e, "team", "api", "rpc", "groups.read");
    }, _.teamGroupsMembersRemove = function(e) {
        return this.request("team/groups/members/remove", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsMembersSetAccessType = function(e) {
        return this.request("team/groups/members/set_access_type", e, "team", "api", "rpc", "groups.write");
    }, _.teamGroupsUpdate = function(e) {
        return this.request("team/groups/update", e, "team", "api", "rpc", "groups.write");
    }, _.teamLegalHoldsCreatePolicy = function(e) {
        return this.request("team/legal_holds/create_policy", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsGetPolicy = function(e) {
        return this.request("team/legal_holds/get_policy", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsListHeldRevisions = function(e) {
        return this.request("team/legal_holds/list_held_revisions", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsListHeldRevisionsContinue = function(e) {
        return this.request("team/legal_holds/list_held_revisions_continue", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsListPolicies = function(e) {
        return this.request("team/legal_holds/list_policies", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsReleasePolicy = function(e) {
        return this.request("team/legal_holds/release_policy", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLegalHoldsUpdatePolicy = function(e) {
        return this.request("team/legal_holds/update_policy", e, "team", "api", "rpc", "team_data.governance.write");
    }, _.teamLinkedAppsListMemberLinkedApps = function(e) {
        return this.request("team/linked_apps/list_member_linked_apps", e, "team", "api", "rpc", "sessions.list");
    }, _.teamLinkedAppsListMembersLinkedApps = function(e) {
        return this.request("team/linked_apps/list_members_linked_apps", e, "team", "api", "rpc", "sessions.list");
    }, _.teamLinkedAppsListTeamLinkedApps = function(e) {
        return this.request("team/linked_apps/list_team_linked_apps", e, "team", "api", "rpc", "sessions.list");
    }, _.teamLinkedAppsRevokeLinkedApp = function(e) {
        return this.request("team/linked_apps/revoke_linked_app", e, "team", "api", "rpc", "sessions.modify");
    }, _.teamLinkedAppsRevokeLinkedAppBatch = function(e) {
        return this.request("team/linked_apps/revoke_linked_app_batch", e, "team", "api", "rpc", "sessions.modify");
    }, _.teamMemberSpaceLimitsExcludedUsersAdd = function(e) {
        return this.request("team/member_space_limits/excluded_users/add", e, "team", "api", "rpc", "members.write");
    }, _.teamMemberSpaceLimitsExcludedUsersList = function(e) {
        return this.request("team/member_space_limits/excluded_users/list", e, "team", "api", "rpc", "members.read");
    }, _.teamMemberSpaceLimitsExcludedUsersListContinue = function(e) {
        return this.request("team/member_space_limits/excluded_users/list/continue", e, "team", "api", "rpc", "members.read");
    }, _.teamMemberSpaceLimitsExcludedUsersRemove = function(e) {
        return this.request("team/member_space_limits/excluded_users/remove", e, "team", "api", "rpc", "members.write");
    }, _.teamMemberSpaceLimitsGetCustomQuota = function(e) {
        return this.request("team/member_space_limits/get_custom_quota", e, "team", "api", "rpc", "members.read");
    }, _.teamMemberSpaceLimitsRemoveCustomQuota = function(e) {
        return this.request("team/member_space_limits/remove_custom_quota", e, "team", "api", "rpc", "members.write");
    }, _.teamMemberSpaceLimitsSetCustomQuota = function(e) {
        return this.request("team/member_space_limits/set_custom_quota", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersAddV2 = function(e) {
        return this.request("team/members/add_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersAdd = function(e) {
        return this.request("team/members/add", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersAddJobStatusGetV2 = function(e) {
        return this.request("team/members/add/job_status/get_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersAddJobStatusGet = function(e) {
        return this.request("team/members/add/job_status/get", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersDeleteProfilePhotoV2 = function(e) {
        return this.request("team/members/delete_profile_photo_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersDeleteProfilePhoto = function(e) {
        return this.request("team/members/delete_profile_photo", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersGetAvailableTeamMemberRoles = function() {
        return this.request("team/members/get_available_team_member_roles", null, "team", "api", "rpc", "members.read");
    }, _.teamMembersGetInfoV2 = function(e) {
        return this.request("team/members/get_info_v2", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersGetInfo = function(e) {
        return this.request("team/members/get_info", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersListV2 = function(e) {
        return this.request("team/members/list_v2", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersList = function(e) {
        return this.request("team/members/list", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersListContinueV2 = function(e) {
        return this.request("team/members/list/continue_v2", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersListContinue = function(e) {
        return this.request("team/members/list/continue", e, "team", "api", "rpc", "members.read");
    }, _.teamMembersMoveFormerMemberFiles = function(e) {
        return this.request("team/members/move_former_member_files", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersMoveFormerMemberFilesJobStatusCheck = function(e) {
        return this.request("team/members/move_former_member_files/job_status/check", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersRecover = function(e) {
        return this.request("team/members/recover", e, "team", "api", "rpc", "members.delete");
    }, _.teamMembersRemove = function(e) {
        return this.request("team/members/remove", e, "team", "api", "rpc", "members.delete");
    }, _.teamMembersRemoveJobStatusGet = function(e) {
        return this.request("team/members/remove/job_status/get", e, "team", "api", "rpc", "members.delete");
    }, _.teamMembersSecondaryEmailsAdd = function(e) {
        return this.request("team/members/secondary_emails/add", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSecondaryEmailsDelete = function(e) {
        return this.request("team/members/secondary_emails/delete", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSecondaryEmailsResendVerificationEmails = function(e) {
        return this.request("team/members/secondary_emails/resend_verification_emails", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSendWelcomeEmail = function(e) {
        return this.request("team/members/send_welcome_email", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetAdminPermissionsV2 = function(e) {
        return this.request("team/members/set_admin_permissions_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetAdminPermissions = function(e) {
        return this.request("team/members/set_admin_permissions", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetProfileV2 = function(e) {
        return this.request("team/members/set_profile_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetProfile = function(e) {
        return this.request("team/members/set_profile", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetProfilePhotoV2 = function(e) {
        return this.request("team/members/set_profile_photo_v2", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSetProfilePhoto = function(e) {
        return this.request("team/members/set_profile_photo", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersSuspend = function(e) {
        return this.request("team/members/suspend", e, "team", "api", "rpc", "members.write");
    }, _.teamMembersUnsuspend = function(e) {
        return this.request("team/members/unsuspend", e, "team", "api", "rpc", "members.write");
    }, _.teamNamespacesList = function(e) {
        return this.request("team/namespaces/list", e, "team", "api", "rpc", "team_data.member");
    }, _.teamNamespacesListContinue = function(e) {
        return this.request("team/namespaces/list/continue", e, "team", "api", "rpc", "team_data.member");
    }, _.teamPropertiesTemplateAdd = function(e) {
        return this.request("team/properties/template/add", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.teamPropertiesTemplateGet = function(e) {
        return this.request("team/properties/template/get", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.teamPropertiesTemplateList = function() {
        return this.request("team/properties/template/list", null, "team", "api", "rpc", "files.team_metadata.write");
    }, _.teamPropertiesTemplateUpdate = function(e) {
        return this.request("team/properties/template/update", e, "team", "api", "rpc", "files.team_metadata.write");
    }, _.teamReportsGetActivity = function(e) {
        return this.request("team/reports/get_activity", e, "team", "api", "rpc", "team_info.read");
    }, _.teamReportsGetDevices = function(e) {
        return this.request("team/reports/get_devices", e, "team", "api", "rpc", "team_info.read");
    }, _.teamReportsGetMembership = function(e) {
        return this.request("team/reports/get_membership", e, "team", "api", "rpc", "team_info.read");
    }, _.teamReportsGetStorage = function(e) {
        return this.request("team/reports/get_storage", e, "team", "api", "rpc", "team_info.read");
    }, _.teamTeamFolderActivate = function(e) {
        return this.request("team/team_folder/activate", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderArchive = function(e) {
        return this.request("team/team_folder/archive", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderArchiveCheck = function(e) {
        return this.request("team/team_folder/archive/check", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderCreate = function(e) {
        return this.request("team/team_folder/create", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderGetInfo = function(e) {
        return this.request("team/team_folder/get_info", e, "team", "api", "rpc", "team_data.content.read");
    }, _.teamTeamFolderList = function(e) {
        return this.request("team/team_folder/list", e, "team", "api", "rpc", "team_data.content.read");
    }, _.teamTeamFolderListContinue = function(e) {
        return this.request("team/team_folder/list/continue", e, "team", "api", "rpc", "team_data.content.read");
    }, _.teamTeamFolderPermanentlyDelete = function(e) {
        return this.request("team/team_folder/permanently_delete", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderRename = function(e) {
        return this.request("team/team_folder/rename", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTeamFolderUpdateSyncSettings = function(e) {
        return this.request("team/team_folder/update_sync_settings", e, "team", "api", "rpc", "team_data.content.write");
    }, _.teamTokenGetAuthenticatedAdmin = function() {
        return this.request("team/token/get_authenticated_admin", null, "team", "api", "rpc", "team_info.read");
    }, _.teamLogGetEvents = function(e) {
        return this.request("team_log/get_events", e, "team", "api", "rpc", "events.read");
    }, _.teamLogGetEventsContinue = function(e) {
        return this.request("team_log/get_events/continue", e, "team", "api", "rpc", "events.read");
    }, _.usersFeaturesGetValues = function(e) {
        return this.request("users/features/get_values", e, "user", "api", "rpc", "account_info.read");
    }, _.usersGetAccount = function(e) {
        return this.request("users/get_account", e, "user", "api", "rpc", "sharing.read");
    }, _.usersGetAccountBatch = function(e) {
        return this.request("users/get_account_batch", e, "user", "api", "rpc", "sharing.read");
    }, _.usersGetCurrentAccount = function() {
        return this.request("users/get_current_account", null, "user", "api", "rpc", "account_info.read");
    }, _.usersGetSpaceUsage = function() {
        return this.request("users/get_space_usage", null, "user", "api", "rpc", "account_info.read");
    };
    var q = function(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : m, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
        return r ? (t !== m && void 0 !== d[e] && (e = d[e], r = "-"), "https://".concat(e).concat(r).concat(t, "/2/")) : "https://".concat(t, "/2/");
    }, b = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h;
        return e !== h && (e = "meta-".concat(e)), "https://".concat(e, "/oauth2/authorize");
    }, v = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : m, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".", r = "api";
        return e !== m && (r = d[r], t = "-"), "https://".concat(r).concat(t).concat(e, "/oauth2/token");
    };
    function w(e) {
        return JSON.stringify(e).replace(/[\u007f-\uffff]/g, g);
    }
    function k(e) {
        return new Date(Date.now() + 1e3 * e);
    }
    function y() {
        return "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope || false || "undefined" != typeof window;
    }
    function A() {
        return "undefined" != typeof window;
    }
    function S() {
        return "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope;
    }
    function C(e) {
        return e.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    }
    var T, L, M, P = function(e) {
        !function(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && n(e, t);
        }(u, e);
        var r, s, o = (r = u, s = a(), function() {
            var e, t = i(r);
            if (s) {
                var n = i(this).constructor;
                e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);
            return c(this, e);
        });
        function u(e, r, s) {
            var i;
            return t(this, u), (i = o.call(this, "Response failed with a ".concat(e, " code"))).name = "DropboxResponseError", i.status = e, i.headers = r, i.error = s, i;
        }
        return u;
    }(u(Error)), R = function e(r, s, i) {
        t(this, e), this.status = r, this.headers = s, this.result = i;
    };
    function F(e) {
        return e.text().then(function(t) {
            var r;
            try {
                r = JSON.parse(t);
            } catch (e) {
                r = t;
            }
            throw new P(e.status, e.headers, r);
        });
    }
    function D(e) {
        return e.ok ? e.text().then(function(t) {
            var r;
            try {
                r = JSON.parse(t);
            } catch (e) {
                r = t;
            }
            return new R(e.status, e.headers, r);
        }) : F(e);
    }
    var G = [
        "legacy",
        "offline",
        "online"
    ], U = [
        "code",
        "token"
    ], x = [
        "none",
        "user",
        "team"
    ], E = function() {
        function e(r) {
            t(this, e), r = r || {}, A() ? (T = window.fetch.bind(window), L = window.crypto || window.msCrypto) : S() ? (T = self.fetch.bind(self), L = self.crypto) : (T = (parcelRequire("3Mgi6")), L = (parcelRequire("4JjTn"))), M = "undefined" == typeof TextEncoder ? (parcelRequire("8pbfm")).TextEncoder : TextEncoder, this.fetch = r.fetch || T, this.accessToken = r.accessToken, this.accessTokenExpiresAt = r.accessTokenExpiresAt, this.refreshToken = r.refreshToken, this.clientId = r.clientId, this.clientSecret = r.clientSecret, this.domain = r.domain, this.domainDelimiter = r.domainDelimiter, this.customHeaders = r.customHeaders, this.dataOnBody = r.dataOnBody;
        }
        return s(e, [
            {
                key: "setAccessToken",
                value: function(e) {
                    this.accessToken = e;
                }
            },
            {
                key: "getAccessToken",
                value: function() {
                    return this.accessToken;
                }
            },
            {
                key: "setClientId",
                value: function(e) {
                    this.clientId = e;
                }
            },
            {
                key: "getClientId",
                value: function() {
                    return this.clientId;
                }
            },
            {
                key: "setClientSecret",
                value: function(e) {
                    this.clientSecret = e;
                }
            },
            {
                key: "getClientSecret",
                value: function() {
                    return this.clientSecret;
                }
            },
            {
                key: "getRefreshToken",
                value: function() {
                    return this.refreshToken;
                }
            },
            {
                key: "setRefreshToken",
                value: function(e) {
                    this.refreshToken = e;
                }
            },
            {
                key: "getAccessTokenExpiresAt",
                value: function() {
                    return this.accessTokenExpiresAt;
                }
            },
            {
                key: "setAccessTokenExpiresAt",
                value: function(e) {
                    this.accessTokenExpiresAt = e;
                }
            },
            {
                key: "setCodeVerifier",
                value: function(e) {
                    this.codeVerifier = e;
                }
            },
            {
                key: "getCodeVerifier",
                value: function() {
                    return this.codeVerifier;
                }
            },
            {
                key: "generateCodeChallenge",
                value: function() {
                    var e, t = this, r = (new M).encode(this.codeVerifier);
                    if (A() || S()) return L.subtle.digest("SHA-256", r).then(function(r) {
                        var s = btoa(String.fromCharCode.apply(null, new Uint8Array(r)));
                        e = C(s).substr(0, 128), t.codeChallenge = e;
                    });
                    var s = L.createHash("sha256").update(r).digest();
                    return e = C(s), this.codeChallenge = e, Promise.resolve();
                }
            },
            {
                key: "generatePKCECodes",
                value: function() {
                    var e;
                    if (A() || S()) {
                        var t = new Uint8Array(128), r = L.getRandomValues(t);
                        e = C(btoa(r)).substr(0, 128);
                    } else e = C(L.randomBytes(128)).substr(0, 128);
                    return this.codeVerifier = e, this.generateCodeChallenge();
                }
            },
            {
                key: "getAuthenticationUrl",
                value: function(e, t) {
                    var r, s = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "token", n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "none", u = arguments.length > 6 && void 0 !== arguments[6] && arguments[6], c = this.getClientId(), p = b(this.domain);
                    if (!c) throw Error("A client id is required. You can set the client id using .setClientId().");
                    if ("code" !== i && !e) throw Error("A redirect uri is required.");
                    if (!U.includes(i)) throw Error("Authorization type must be code or token");
                    if (n && !G.includes(n)) throw Error("Token Access Type must be legacy, offline, or online");
                    if (a && !(a instanceof Array)) throw Error("Scope must be an array of strings");
                    if (!x.includes(o)) throw Error("includeGrantedScopes must be none, user, or team");
                    return r = "code" === i ? "".concat(p, "?response_type=code&client_id=").concat(c) : "".concat(p, "?response_type=token&client_id=").concat(c), e && (r += "&redirect_uri=".concat(e)), t && (r += "&state=".concat(t)), n && (r += "&token_access_type=".concat(n)), a && (r += "&scope=".concat(a.join(" "))), "none" !== o && (r += "&include_granted_scopes=".concat(o)), u ? this.generatePKCECodes().then(function() {
                        return r += "&code_challenge_method=S256", r += "&code_challenge=".concat(s.codeChallenge);
                    }) : Promise.resolve(r);
                }
            },
            {
                key: "getAccessTokenFromCode",
                value: function(e, t) {
                    var r = this.getClientId(), s = this.getClientSecret();
                    if (!r) throw Error("A client id is required. You can set the client id using .setClientId().");
                    var i = v(this.domain, this.domainDelimiter);
                    if (i += "?grant_type=authorization_code", i += "&code=".concat(t), i += "&client_id=".concat(r), s) i += "&client_secret=".concat(s);
                    else {
                        if (!this.codeVerifier) throw Error("You must use PKCE when generating the authorization URL to not include a client secret");
                        i += "&code_verifier=".concat(this.codeVerifier);
                    }
                    e && (i += "&redirect_uri=".concat(e));
                    return this.fetch(i, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }).then(function(e) {
                        return D(e);
                    });
                }
            },
            {
                key: "checkAndRefreshAccessToken",
                value: function() {
                    var e = this.getRefreshToken() && this.getClientId(), t = !this.getAccessTokenExpiresAt() || new Date(Date.now() + 3e5) >= this.getAccessTokenExpiresAt(), r = !this.getAccessToken();
                    return (t || r) && e ? this.refreshAccessToken() : Promise.resolve();
                }
            },
            {
                key: "refreshAccessToken",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, r = this.getClientId(), s = this.getClientSecret();
                    if (!r) throw Error("A client id is required. You can set the client id using .setClientId().");
                    if (t && !(t instanceof Array)) throw Error("Scope must be an array of strings");
                    var i = v(this.domain, this.domainDelimiter), n = {
                        headers: {
                            "Content-Type": "application/json"
                        },
                        method: "POST"
                    };
                    if (this.dataOnBody) {
                        var a = {
                            grant_type: "refresh_token",
                            client_id: r,
                            refresh_token: this.getRefreshToken()
                        };
                        s && (a.client_secret = s), t && (a.scope = t.join(" ")), n.body = a;
                    } else i += "?grant_type=refresh_token&refresh_token=".concat(this.getRefreshToken()), i += "&client_id=".concat(r), s && (i += "&client_secret=".concat(s)), t && (i += "&scope=".concat(t.join(" ")));
                    return this.fetch(i, n).then(function(e) {
                        return D(e);
                    }).then(function(t) {
                        e.setAccessToken(t.result.access_token), e.setAccessTokenExpiresAt(k(t.result.expires_in));
                    });
                }
            }
        ]), e;
    }(), B = "undefined" == typeof btoa ? function(e) {
        return $1044f5047434e84b$require$Buffer.from(e).toString("base64");
    } : btoa;
    e.Dropbox = function() {
        function e(r) {
            t(this, e), this.auth = (r = r || {}).auth ? r.auth : new E(r), this.fetch = r.fetch || this.auth.fetch, this.selectUser = r.selectUser, this.selectAdmin = r.selectAdmin, this.pathRoot = r.pathRoot, this.domain = r.domain || this.auth.domain, this.domainDelimiter = r.domainDelimiter || this.auth.domainDelimiter, this.customHeaders = r.customHeaders || this.auth.customHeaders, Object.assign(this, _);
        }
        return s(e, [
            {
                key: "request",
                value: function(e, t, r, s, i) {
                    switch(i){
                        case "rpc":
                            return this.rpcRequest(e, t, r, s);
                        case "download":
                            return this.downloadRequest(e, t, r, s);
                        case "upload":
                            return this.uploadRequest(e, t, r, s);
                        default:
                            throw Error("Invalid request style: ".concat(i));
                    }
                }
            },
            {
                key: "rpcRequest",
                value: function(e, t, r, s) {
                    var i = this;
                    return this.auth.checkAndRefreshAccessToken().then(function() {
                        var e = {
                            method: "POST",
                            body: t ? JSON.stringify(t) : null,
                            headers: {}
                        };
                        return t && (e.headers["Content-Type"] = "application/json"), i.setAuthHeaders(r, e), i.setCommonHeaders(e), e;
                    }).then(function(t) {
                        return i.fetch(q(s, i.domain, i.domainDelimiter) + e, t);
                    }).then(function(e) {
                        return D(e);
                    });
                }
            },
            {
                key: "downloadRequest",
                value: function(e, t, r, s) {
                    var i = this;
                    return this.auth.checkAndRefreshAccessToken().then(function() {
                        var e = {
                            method: "POST",
                            headers: {
                                "Dropbox-API-Arg": w(t)
                            }
                        };
                        return i.setAuthHeaders(r, e), i.setCommonHeaders(e), e;
                    }).then(function(t) {
                        return i.fetch(q(s, i.domain, i.domainDelimiter) + e, t);
                    }).then(function(e) {
                        return function(e) {
                            return e.ok ? new Promise(function(t) {
                                y() ? e.blob().then(function(e) {
                                    return t(e);
                                }) : e.buffer().then(function(e) {
                                    return t(e);
                                });
                            }).then(function(t) {
                                var r = JSON.parse(e.headers.get("dropbox-api-result"));
                                return y() ? r.fileBlob = t : r.fileBinary = t, new R(e.status, e.headers, r);
                            }) : F(e);
                        }(e);
                    });
                }
            },
            {
                key: "uploadRequest",
                value: function(e, t, r, s) {
                    var i = this;
                    return this.auth.checkAndRefreshAccessToken().then(function() {
                        var e = t.contents;
                        delete t.contents;
                        var s = {
                            body: e,
                            method: "POST",
                            headers: {
                                "Content-Type": "application/octet-stream",
                                "Dropbox-API-Arg": w(t)
                            }
                        };
                        return i.setAuthHeaders(r, s), i.setCommonHeaders(s), s;
                    }).then(function(t) {
                        return i.fetch(q(s, i.domain, i.domainDelimiter) + e, t);
                    }).then(function(e) {
                        return D(e);
                    });
                }
            },
            {
                key: "setAuthHeaders",
                value: function(e, t) {
                    if (e.split(",").length > 1) {
                        var r = e.replace(" ", "").split(",");
                        r.includes(l) && this.auth.getAccessToken() ? e = l : r.includes(f) && this.auth.getAccessToken() ? e = f : r.includes(p) && (e = p);
                    }
                    switch(e){
                        case p:
                            if (this.auth.clientId && this.auth.clientSecret) {
                                var s = B("".concat(this.auth.clientId, ":").concat(this.auth.clientSecret));
                                t.headers.Authorization = "Basic ".concat(s);
                            }
                            break;
                        case f:
                        case l:
                            this.auth.getAccessToken() && (t.headers.Authorization = "Bearer ".concat(this.auth.getAccessToken()));
                            break;
                        case "noauth":
                        case "cookie":
                            break;
                        default:
                            throw Error("Unhandled auth type: ".concat(e));
                    }
                }
            },
            {
                key: "setCommonHeaders",
                value: function(e) {
                    var t = this;
                    (this.selectUser && (e.headers["Dropbox-API-Select-User"] = this.selectUser), this.selectAdmin && (e.headers["Dropbox-API-Select-Admin"] = this.selectAdmin), this.pathRoot && (e.headers["Dropbox-API-Path-Root"] = this.pathRoot), this.customHeaders) && Object.keys(this.customHeaders).forEach(function(r) {
                        e.headers[r] = t.customHeaders[r];
                    });
                }
            }
        ]), e;
    }(), e.DropboxAuth = E, e.DropboxResponse = R, e.DropboxResponseError = P, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});




const $e81a3f4b139bb8ca$export$c000bb94a9c7754a = (listing)=>{
    const filteredListing = listing.filter((file)=>{
        // Show all folders
        if (file['.tag'] === 'folder') return true;
        // Filter out all non-org files
        return file.name.match((0, $2ce140c2c56df8f2$export$cb89f492e03ac783));
    });
    return filteredListing.sort((a, b)=>{
        // Folders before files
        if (a['.tag'] === 'folder' && b['.tag'] === 'file') return -1;
        else if (a['.tag'] === 'file' && b['.tag'] === 'folder') return 1;
        else // Sorth both folders and files alphabetically
        return a.name > b.name ? 1 : -1;
    });
};
function $e81a3f4b139bb8ca$var$getCodeFromUrl() {
    return (0, $4d1c34ada8668736$export$2e2bcd8739ae039)(window.location.search).code;
}
var $e81a3f4b139bb8ca$export$2e2bcd8739ae039 = ()=>{
    let dbxPromise;
    const isSignedIn = ()=>new Promise((resolve)=>resolve(true));
    const transformDirectoryListing = (listing)=>{
        const sortedListing = $e81a3f4b139bb8ca$export$c000bb94a9c7754a(listing);
        return (0, $3044e0bef3624137$exports.fromJS)(sortedListing.map((entry)=>({
                id: entry.id,
                name: entry.name,
                isDirectory: entry['.tag'] === 'folder',
                path: entry.path_display
            })));
    };
    const getDirectoryListing = (path)=>new Promise((resolve, reject)=>{
            dbxPromise.then((dbx)=>{
                dbx.filesListFolder({
                    path: path
                }).then((response)=>{
                    resolve({
                        listing: transformDirectoryListing(response.result.entries),
                        hasMore: response.result.has_more,
                        additionalSyncBackendState: (0, $3044e0bef3624137$exports.Map)({
                            cursor: response.result.cursor
                        })
                    });
                });
            }).catch(reject);
        });
    const getMoreDirectoryListing = (additionalSyncBackendState)=>{
        const cursor = additionalSyncBackendState.get('cursor');
        return new Promise((resolve, reject)=>dbxPromise.then((dbx)=>{
                dbx.filesListFolderContinue({
                    cursor: cursor
                }).then((response)=>resolve({
                        listing: transformDirectoryListing(response.result.entries),
                        hasMore: response.result.has_more,
                        additionalSyncBackendState: (0, $3044e0bef3624137$exports.Map)({
                            cursor: response.result.cursor
                        })
                    }));
            }));
    };
    const uploadFile = (path, contents)=>new Promise((resolve, reject)=>dbxPromise.then((dbx)=>{
                dbx.filesUpload({
                    path: path,
                    contents: contents,
                    mode: {
                        '.tag': 'overwrite'
                    },
                    autorename: true
                }).then(resolve).catch(reject);
            }));
    const updateFile = uploadFile;
    const createFile = uploadFile;
    const getFileContentsAndMetadata = (path)=>new Promise((resolve, reject)=>dbxPromise.then((dbx)=>{
                dbx.filesDownload({
                    path: path
                }).then((response)=>{
                    const reader = new FileReader();
                    reader.addEventListener('loadend', ()=>resolve({
                            contents: reader.result,
                            lastModifiedAt: response.result.server_modified
                        }));
                    reader.readAsText(response.result.fileBlob);
                }).catch((error)=>{
                    // INFO: It's possible organice is using the Dropbox API
                    // wrongly. In any case, for some files and only sometimes,
                    // when a file is requested, there's either:
                    //   - a 400 with a plain text error or
                    //   - a 409 with an embedded JSON error
                    //   - a 409 with a plain text error under `.error`
                    // coming back. Sometimes, there's even two API calls to
                    // `/download` happening at the same time (of types `json`
                    // and `octet-stream`) where one might fail and the other
                    // might prevail.
                    // More debug information in this issue:
                    // https://github.com/200ok-ch/organice/issues/108
                    const objectContainsTagErrorP = function() {
                        try {
                            return JSON.parse(error.error).error.path['.tag'] === 'not_found';
                        } catch (e) {
                            return false;
                        }
                    }();
                    if (typeof error === 'string' && error.match(/missing required field 'path'/) || objectContainsTagErrorP) reject();
                });
            }));
    const getFileContents = (path)=>{
        if ((0, $1X5R2.isEmpty)(path)) return Promise.reject('No path given');
        return new Promise((resolve, reject)=>getFileContentsAndMetadata(path).then(({ contents: contents })=>resolve(contents)).catch(reject));
    };
    const deleteFile = (path)=>new Promise((resolve, reject)=>dbxPromise.then((dbx)=>{
                dbx.filesDelete({
                    path: path
                }).then(resolve).catch((error)=>reject(error.error.error['.tag'] === 'path_lookup', error));
            }));
    /* Dropbox documentation on OAuth2 and PKCE:
   -  SDK Repo: https://github.com/dropbox/dropbox-sdk-js
  -  OAuth Guide: https://developers.dropbox.com/oauth-guide
  -  PKCE: What and Why?: https://dropbox.tech/developers/pkce--what-and-why-
  -  Single HTML file example: https://github.com/dropbox/dropbox-sdk-js/blob/main/examples/javascript/pkce-browser/index.html
  -  SDK Docs: https://dropbox.github.io/dropbox-sdk-js/index.html
  -  Migrating App Permissions and Access Tokens: https://dropbox.tech/developers/migrating-app-permissions-and-access-tokens */ const REDIRECT_URI = window.location.origin + '/';
    dbxPromise = new Promise((resolve, reject)=>{
        const dbx = new (0, $1044f5047434e84b$exports.Dropbox)({
            clientId: "ORGANICE_DROPBOX_CLIENT_ID",
            fetch: fetch.bind(window)
        });
        const dbxAuth = dbx.auth;
        if ($e81a3f4b139bb8ca$var$getCodeFromUrl()) {
            dbxAuth.setCodeVerifier((0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('codeVerifier'));
            dbxAuth.getAccessTokenFromCode(REDIRECT_URI, $e81a3f4b139bb8ca$var$getCodeFromUrl()).then((response)=>{
                dbxAuth.setRefreshToken(response.result.refresh_token);
                (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('dropboxRefreshToken', response.result.refresh_token);
                resolve(dbx);
            }).catch((error)=>{
                console.error(error);
            });
        } else {
            dbxAuth.setCodeVerifier((0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('codeVerifier'));
            dbxAuth.setRefreshToken((0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('dropboxRefreshToken'));
            resolve(dbx);
        }
    });
    return {
        type: 'Dropbox',
        isSignedIn: isSignedIn,
        getDirectoryListing: getDirectoryListing,
        getMoreDirectoryListing: getMoreDirectoryListing,
        updateFile: updateFile,
        createFile: createFile,
        getFileContentsAndMetadata: getFileContentsAndMetadata,
        getFileContents: getFileContents,
        deleteFile: deleteFile
    };
};



var $c038ec147a89b0f7$exports = {};
"use strict";

var $aUV4R = parcelRequire("aUV4R");
var $c038ec147a89b0f7$require$axios = $aUV4R.axios;
var $bf91db140ea2438d$exports = {};
"use strict";

var $3FL1p = parcelRequire("3FL1p");
var $d6e96d3b02fef0b7$exports = {};
"use strict";
var $091783985b327136$exports = {};
'use strict';
var $c2cb3155ad174c6a$exports = {};
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $c2cb3155ad174c6a$exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};


var $b03c20a937a86f97$exports = {};

$parcel$export($b03c20a937a86f97$exports, "stringify", function () { return $b03c20a937a86f97$export$fac44ee5b035f737; }, function (v) { return $b03c20a937a86f97$export$fac44ee5b035f737 = v; });
$parcel$export($b03c20a937a86f97$exports, "parse", function () { return $b03c20a937a86f97$export$98e6a39c04603d36; }, function (v) { return $b03c20a937a86f97$export$98e6a39c04603d36 = v; });
//
// Expose the module.
//
var $b03c20a937a86f97$export$fac44ee5b035f737;
var $b03c20a937a86f97$export$98e6a39c04603d36;
'use strict';
var $b03c20a937a86f97$var$has = Object.prototype.hasOwnProperty, $b03c20a937a86f97$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $b03c20a937a86f97$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $b03c20a937a86f97$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $b03c20a937a86f97$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $b03c20a937a86f97$var$decode(part[1]), value = $b03c20a937a86f97$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $b03c20a937a86f97$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($b03c20a937a86f97$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $b03c20a937a86f97$var$undef || isNaN(value))) value = '';
        key = $b03c20a937a86f97$var$encode(key);
        value = $b03c20a937a86f97$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$b03c20a937a86f97$export$fac44ee5b035f737 = $b03c20a937a86f97$var$querystringify;
$b03c20a937a86f97$export$98e6a39c04603d36 = $b03c20a937a86f97$var$querystring;


var $091783985b327136$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $091783985b327136$var$CRHTLF = /[\n\r\t]/g, $091783985b327136$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $091783985b327136$var$port = /:\d+$/, $091783985b327136$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $091783985b327136$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $091783985b327136$var$trimLeft(str) {
    return (str ? str : '').toString().replace($091783985b327136$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $091783985b327136$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $091783985b327136$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $091783985b327136$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $091783985b327136$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $091783985b327136$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $091783985b327136$var$Url(loc, {});
        for(key in $091783985b327136$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $091783985b327136$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $091783985b327136$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $091783985b327136$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $091783985b327136$var$extractProtocol(address, location) {
    address = $091783985b327136$var$trimLeft(address);
    address = address.replace($091783985b327136$var$CRHTLF, '');
    location = location || {};
    var match = $091783985b327136$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($091783985b327136$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $091783985b327136$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $091783985b327136$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $091783985b327136$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $091783985b327136$var$Url(address, location, parser) {
    address = $091783985b327136$var$trimLeft(address);
    address = address.replace($091783985b327136$var$CRHTLF, '');
    if (!(this instanceof $091783985b327136$var$Url)) return new $091783985b327136$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $091783985b327136$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $b03c20a937a86f97$exports.parse;
    location = $091783985b327136$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $091783985b327136$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $091783985b327136$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$091783985b327136$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $091783985b327136$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $091783985b327136$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$c2cb3155ad174c6a$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $091783985b327136$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $091783985b327136$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $b03c20a937a86f97$exports.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$c2cb3155ad174c6a$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($091783985b327136$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $091783985b327136$var$rules.length; i++){
        var ins = $091783985b327136$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $091783985b327136$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $091783985b327136$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $b03c20a937a86f97$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $091783985b327136$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $091783985b327136$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $091783985b327136$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$091783985b327136$var$Url.prototype = {
    set: $091783985b327136$var$set,
    toString: $091783985b327136$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$091783985b327136$var$Url.extractProtocol = $091783985b327136$var$extractProtocol;
$091783985b327136$var$Url.location = $091783985b327136$var$lolcation;
$091783985b327136$var$Url.trimLeft = $091783985b327136$var$trimLeft;
$091783985b327136$var$Url.qs = $b03c20a937a86f97$exports;
$091783985b327136$exports = $091783985b327136$var$Url;


function $d6e96d3b02fef0b7$var$extractURLPath(fullURL) {
    const url = new $091783985b327136$exports(fullURL);
    let urlPath = url.pathname;
    if (urlPath.length <= 0) urlPath = "/";
    return $d6e96d3b02fef0b7$var$normalisePath(urlPath);
}
function $d6e96d3b02fef0b7$var$normaliseHREF(href) {
    const normalisedHref = href.replace(/^https?:\/\/[^\/]+/, "");
    return normalisedHref;
}
function $d6e96d3b02fef0b7$var$normalisePath(pathStr) {
    let normalisedPath = pathStr;
    if (normalisedPath[0] !== "/") normalisedPath = "/" + normalisedPath;
    if (/^.+\/$/.test(normalisedPath)) normalisedPath = normalisedPath.substr(0, normalisedPath.length - 1);
    return decodeURIComponent(normalisedPath);
}
$d6e96d3b02fef0b7$exports = {
    extractURLPath: $d6e96d3b02fef0b7$var$extractURLPath,
    normaliseHREF: $d6e96d3b02fef0b7$var$normaliseHREF,
    normalisePath: $d6e96d3b02fef0b7$var$normalisePath
};



var $3eFSI = parcelRequire("3eFSI");
var $bf91db140ea2438d$require$merge = $3eFSI.merge;
var $64bd7a71bed5ad3e$exports = {};
"use strict";

var $6nXoo = parcelRequire("6nXoo");

var $3eFSI = parcelRequire("3eFSI");
var $64bd7a71bed5ad3e$require$merge = $3eFSI.merge;

var $4Nbx7 = parcelRequire("4Nbx7");
var $64bd7a71bed5ad3e$require$handleResponseCode = $4Nbx7.handleResponseCode;
var $64bd7a71bed5ad3e$require$processGlobFilter = $4Nbx7.processGlobFilter;
var $64bd7a71bed5ad3e$require$processResponsePayload = $4Nbx7.processResponsePayload;

var $64bd7a71bed5ad3e$require$normaliseHREF = $d6e96d3b02fef0b7$exports.normaliseHREF;
var $64bd7a71bed5ad3e$require$normalisePath = $d6e96d3b02fef0b7$exports.normalisePath;
var $b5645401b9d507eb$exports = {};
"use strict";
var $cfe100fd4d681161$export$98e6a39c04603d36;
var $cfe100fd4d681161$export$e4f0b40d01c251ab;
var $cfe100fd4d681161$export$2ca3eb0a2f8a693a;
var $cfe100fd4d681161$export$e31c2b05678acf26;
var $cfe100fd4d681161$export$54ffaacfc0931fb0;
var $cfe100fd4d681161$export$a22775fa5e2eebd9;
var $cfe100fd4d681161$export$30384b60aedf98a5;
var $cfe100fd4d681161$export$3a5cfc971f52ee31;
'use strict';
var $415e6197718a75c6$export$e31c2b05678acf26;
'use strict';

var $7PKBV = parcelRequire("7PKBV");
const $415e6197718a75c6$var$convertToJson = function(node, options) {
    const jObj = {};
    //when no child node or attr is present
    if ((!node.child || $7PKBV.isEmptyObject(node.child)) && (!node.attrsMap || $7PKBV.isEmptyObject(node.attrsMap))) return $7PKBV.isExist(node.val) ? node.val : '';
    else {
        //otherwise create a textnode if node has some text
        if ($7PKBV.isExist(node.val)) {
            if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
                if (options.arrayMode === "strict") jObj[options.textNodeName] = [
                    node.val
                ];
                else jObj[options.textNodeName] = node.val;
            }
        }
    }
    $7PKBV.merge(jObj, node.attrsMap, options.arrayMode);
    const keys = Object.keys(node.child);
    for(let index = 0; index < keys.length; index++){
        var tagname = keys[index];
        if (node.child[tagname] && node.child[tagname].length > 1) {
            jObj[tagname] = [];
            for(var tag in node.child[tagname])jObj[tagname].push($415e6197718a75c6$var$convertToJson(node.child[tagname][tag], options));
        } else {
            if (options.arrayMode === true) {
                const result = $415e6197718a75c6$var$convertToJson(node.child[tagname][0], options);
                if (typeof result === 'object') jObj[tagname] = [
                    result
                ];
                else jObj[tagname] = result;
            } else if (options.arrayMode === "strict") jObj[tagname] = [
                $415e6197718a75c6$var$convertToJson(node.child[tagname][0], options)
            ];
            else jObj[tagname] = $415e6197718a75c6$var$convertToJson(node.child[tagname][0], options);
        }
    }
    //add value
    return jObj;
};
$415e6197718a75c6$export$e31c2b05678acf26 = $415e6197718a75c6$var$convertToJson;



var $2v1OG = parcelRequire("2v1OG");

var $2v1OG = parcelRequire("2v1OG");

var $7PKBV = parcelRequire("7PKBV");
var $cfe100fd4d681161$require$buildOptions = $7PKBV.buildOptions;
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $0f2b7518ec43efbd$export$a22775fa5e2eebd9;
'use strict';

var $7PKBV = parcelRequire("7PKBV");
const $0f2b7518ec43efbd$var$defaultOptions = {
    allowBooleanAttributes: false
};
const $0f2b7518ec43efbd$var$props = [
    'allowBooleanAttributes'
];
$0f2b7518ec43efbd$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = $7PKBV.buildOptions(options, $0f2b7518ec43efbd$var$defaultOptions, $0f2b7518ec43efbd$var$props);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++)if (xmlData[i] === '<') {
        //starting of tag
        //read until you reach to '>' avoiding any '>' in attribute value
        i++;
        if (xmlData[i] === '?') {
            i = $0f2b7518ec43efbd$var$readPI(xmlData, ++i);
            if (i.err) return i;
        } else if (xmlData[i] === '!') {
            i = $0f2b7518ec43efbd$var$readCommentAndCDATA(xmlData, i);
            continue;
        } else {
            let closingTag = false;
            if (xmlData[i] === '/') {
                //closing tag
                closingTag = true;
                i++;
            }
            //read tagname
            let tagName = '';
            for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
            tagName = tagName.trim();
            //console.log(tagName);
            if (tagName[tagName.length - 1] === '/') {
                //self closing tag without attributes
                tagName = tagName.substring(0, tagName.length - 1);
                //continue;
                i--;
            }
            if (!$0f2b7518ec43efbd$var$validateTagName(tagName)) {
                let msg;
                if (tagName.trim().length === 0) msg = "There is an unnecessary space between tag name and backward slash '</ ..'.";
                else msg = "Tag '" + tagName + "' is an invalid name.";
                return $0f2b7518ec43efbd$var$getErrorObject('InvalidTag', msg, $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
            }
            const result = $0f2b7518ec43efbd$var$readAttributeStr(xmlData, i);
            if (result === false) return $0f2b7518ec43efbd$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
            let attrStr = result.value;
            i = result.index;
            if (attrStr[attrStr.length - 1] === '/') {
                //self closing tag
                attrStr = attrStr.substring(0, attrStr.length - 1);
                const isValid = $0f2b7518ec43efbd$var$validateAttributeString(attrStr, options);
                if (isValid === true) tagFound = true;
                else //the result from the nested function returns the position of the error within the attribute
                //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                //this gives us the absolute index in the entire xml, which we can use to find the line at last
                return $0f2b7518ec43efbd$var$getErrorObject(isValid.err.code, isValid.err.msg, $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
            } else if (closingTag) {
                if (!result.tagClosed) return $0f2b7518ec43efbd$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
                else if (attrStr.trim().length > 0) return $0f2b7518ec43efbd$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
                else {
                    const otg = tags.pop();
                    if (tagName !== otg) return $0f2b7518ec43efbd$var$getErrorObject('InvalidTag', "Closing tag '" + otg + "' is expected inplace of '" + tagName + "'.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
                    //when there are no more tags, we reached the root level.
                    if (tags.length == 0) reachedRoot = true;
                }
            } else {
                const isValid = $0f2b7518ec43efbd$var$validateAttributeString(attrStr, options);
                if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                //this gives us the absolute index in the entire xml, which we can use to find the line at last
                return $0f2b7518ec43efbd$var$getErrorObject(isValid.err.code, isValid.err.msg, $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                //if the root level has been reached before ...
                if (reachedRoot === true) return $0f2b7518ec43efbd$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
                else tags.push(tagName);
                tagFound = true;
            }
            //skip tag text value
            //It may include comments and CDATA value
            for(i++; i < xmlData.length; i++){
                if (xmlData[i] === '<') {
                    if (xmlData[i + 1] === '!') {
                        //comment or CADATA
                        i++;
                        i = $0f2b7518ec43efbd$var$readCommentAndCDATA(xmlData, i);
                        continue;
                    } else break;
                } else if (xmlData[i] === '&') {
                    const afterAmp = $0f2b7518ec43efbd$var$validateAmpersand(xmlData, i);
                    if (afterAmp == -1) return $0f2b7518ec43efbd$var$getErrorObject('InvalidChar', "char '&' is not expected.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
                    i = afterAmp;
                }
            } //end of reading tag text value
            if (xmlData[i] === '<') i--;
        }
    } else {
        if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') continue;
        return $0f2b7518ec43efbd$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
    }
    if (!tagFound) return $0f2b7518ec43efbd$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length > 0) return $0f2b7518ec43efbd$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags, null, 4).replace(/\r?\n/g, '') + "' found.", 1);
    return true;
};
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $0f2b7518ec43efbd$var$readPI(xmlData, i) {
    var start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        var tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $0f2b7518ec43efbd$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $0f2b7518ec43efbd$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
var $0f2b7518ec43efbd$var$doubleQuote = '"';
var $0f2b7518ec43efbd$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $0f2b7518ec43efbd$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $0f2b7518ec43efbd$var$doubleQuote || xmlData[i] === $0f2b7518ec43efbd$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) continue;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $0f2b7518ec43efbd$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $0f2b7518ec43efbd$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $7PKBV.getAllMatches(attrStr, $0f2b7518ec43efbd$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $0f2b7518ec43efbd$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $0f2b7518ec43efbd$var$getPositionFromMatch(attrStr, matches[i][0]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $0f2b7518ec43efbd$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $0f2b7518ec43efbd$var$getPositionFromMatch(attrStr, matches[i][0]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$0f2b7518ec43efbd$var$validateAttrName(attrName)) return $0f2b7518ec43efbd$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $0f2b7518ec43efbd$var$getPositionFromMatch(attrStr, matches[i][0]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $0f2b7518ec43efbd$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $0f2b7518ec43efbd$var$getPositionFromMatch(attrStr, matches[i][0]));
    }
    return true;
}
function $0f2b7518ec43efbd$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $0f2b7518ec43efbd$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $0f2b7518ec43efbd$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $0f2b7518ec43efbd$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber
        }
    };
}
function $0f2b7518ec43efbd$var$validateAttrName(attrName) {
    return $7PKBV.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $0f2b7518ec43efbd$var$validateTagName(tagname) {
    return $7PKBV.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $0f2b7518ec43efbd$var$getLineNumberForPosition(xmlData, index) {
    var lines = xmlData.substring(0, index).split(/\r?\n/);
    return lines.length;
}
//this function returns the position of the last character of match within attrStr
function $0f2b7518ec43efbd$var$getPositionFromMatch(attrStr, match) {
    return attrStr.indexOf(match) + match.length;
}


$cfe100fd4d681161$export$98e6a39c04603d36 = function(xmlData, options, validationOption) {
    if (validationOption) {
        if (validationOption === true) validationOption = {};
        const result = $0f2b7518ec43efbd$export$a22775fa5e2eebd9(xmlData, validationOption);
        if (result !== true) throw Error(result.err.msg);
    }
    options = $cfe100fd4d681161$require$buildOptions(options, $2v1OG.defaultOptions, $2v1OG.props);
    const traversableObj = $2v1OG.getTraversalObj(xmlData, options);
    //print(traversableObj, "  ");
    return $415e6197718a75c6$export$e31c2b05678acf26(traversableObj, options);
};

$cfe100fd4d681161$export$e4f0b40d01c251ab = (parcelRequire("dFQuL")).convert2nimn;
$cfe100fd4d681161$export$2ca3eb0a2f8a693a = $2v1OG.getTraversalObj;
$cfe100fd4d681161$export$e31c2b05678acf26 = $415e6197718a75c6$export$e31c2b05678acf26;

$cfe100fd4d681161$export$54ffaacfc0931fb0 = (parcelRequire("g0pSO")).convertToJsonString;
$cfe100fd4d681161$export$a22775fa5e2eebd9 = $0f2b7518ec43efbd$export$a22775fa5e2eebd9;

$cfe100fd4d681161$export$30384b60aedf98a5 = (parcelRequire("eITKj"));
$cfe100fd4d681161$export$3a5cfc971f52ee31 = function(xmlData, schema, options) {
    return $cfe100fd4d681161$export$e4f0b40d01c251ab($cfe100fd4d681161$export$2ca3eb0a2f8a693a(xmlData, options), schema, options);
};
function $cfe100fd4d681161$var$print(xmlNode, indentation) {
    if (xmlNode) {
        console.log(indentation + "{");
        console.log(indentation + "  \"tagName\": \"" + xmlNode.tagname + "\", ");
        if (xmlNode.parent) console.log(indentation + "  \"parent\": \"" + xmlNode.parent.tagname + "\", ");
        console.log(indentation + "  \"val\": \"" + xmlNode.val + "\", ");
        console.log(indentation + "  \"attrs\": " + JSON.stringify(xmlNode.attrsMap, null, 4) + ", ");
        if (xmlNode.child) {
            console.log(indentation + "\"child\": {");
            const indentation2 = indentation + indentation;
            Object.keys(xmlNode.child).forEach(function(key) {
                const node = xmlNode.child[key];
                if (Array.isArray(node)) {
                    console.log(indentation + "\"" + key + "\" :[");
                    node.forEach(function(item, index) {
                        //console.log(indentation + " \""+index+"\" : [")
                        $cfe100fd4d681161$var$print(item, indentation2);
                    });
                    console.log(indentation + "],");
                } else {
                    console.log(indentation + " \"" + key + "\" : {");
                    $cfe100fd4d681161$var$print(node, indentation2);
                    console.log(indentation + "},");
                }
            });
            console.log(indentation + "},");
        }
        console.log(indentation + "},");
    }
}


var $611c815cd99c7137$exports = {};
/**
* @license nested-property https://github.com/cosmosio/nested-property
*
* The MIT License (MIT)
*
* Copyright (c) 2014-2020 Olivier Scherrer <pode.fr@gmail.com>
*/ "use strict";
$611c815cd99c7137$exports = {
    set: $611c815cd99c7137$var$setNestedProperty,
    get: $611c815cd99c7137$var$getNestedProperty,
    has: $611c815cd99c7137$var$hasNestedProperty,
    hasOwn: function(object, property, options) {
        return this.has(object, property, options || {
            own: true
        });
    },
    isIn: $611c815cd99c7137$var$isInNestedProperty
};
/**
 * Get the property of an object nested in one or more objects
 * given an object such as a.b.c.d = 5, getNestedProperty(a, "b.c.d") will return 5.
 * @param {Object} object the object to get the property from
 * @param {String} property the path to the property as a string
 * @returns the object or the the property value if found
 */ function $611c815cd99c7137$var$getNestedProperty(object, property) {
    if (object && typeof object == "object") {
        if (typeof property == "string" && property !== "") {
            var split = property.split(".");
            return split.reduce(function(obj, prop) {
                return obj && obj[prop];
            }, object);
        } else if (typeof property == "number") return object[property];
        else return object;
    } else return object;
}
/**
 * Tell if a nested object has a given property (or array a given index)
 * given an object such as a.b.c.d = 5, hasNestedProperty(a, "b.c.d") will return true.
 * It also returns true if the property is in the prototype chain.
 * @param {Object} object the object to get the property from
 * @param {String} property the path to the property as a string
 * @param {Object} options:
 *  - own: set to reject properties from the prototype
 * @returns true if has (property in object), false otherwise
 */ function $611c815cd99c7137$var$hasNestedProperty(object, property, options) {
    options = options || {};
    if (object && typeof object == "object") {
        if (typeof property == "string" && property !== "") {
            var split = property.split(".");
            return split.reduce(function(obj, prop, idx, array) {
                if (idx == array.length - 1) {
                    if (options.own) return !!(obj && obj.hasOwnProperty(prop));
                    else return !!(obj !== null && typeof obj == "object" && prop in obj);
                }
                return obj && obj[prop];
            }, object);
        } else if (typeof property == "number") return property in object;
        else return false;
    } else return false;
}
/**
 * Set the property of an object nested in one or more objects
 * If the property doesn't exist, it gets created.
 * @param {Object} object
 * @param {String} property
 * @param value the value to set
 * @returns object if no assignment was made or the value if the assignment was made
 */ function $611c815cd99c7137$var$setNestedProperty(object, property, value) {
    if (object && typeof object == "object") {
        if (typeof property == "string" && property !== "") {
            var split = property.split(".");
            return split.reduce(function(obj, prop, idx) {
                var nextPropIsNumber = Number.isInteger(Number(split[idx + 1]));
                obj[prop] = obj[prop] || (nextPropIsNumber ? [] : {});
                if (split.length == idx + 1) obj[prop] = value;
                return obj[prop];
            }, object);
        } else if (typeof property == "number") {
            object[property] = value;
            return object[property];
        } else return object;
    } else return object;
}
/**
 * Tell if an object is on the path to a nested property
 * If the object is on the path, and the path exists, it returns true, and false otherwise.
 * @param {Object} object to get the nested property from
 * @param {String} property name of the nested property
 * @param {Object} objectInPath the object to check
 * @param {Object} options:
 *  - validPath: return false if the path is invalid, even if the object is in the path
 * @returns {boolean} true if the object is on the path
 */ function $611c815cd99c7137$var$isInNestedProperty(object, property, objectInPath, options) {
    options = options || {};
    if (object && typeof object == "object") {
        if (typeof property == "string" && property !== "") {
            var split = property.split("."), isIn = false, pathExists;
            pathExists = !!split.reduce(function(obj, prop) {
                isIn = isIn || obj === objectInPath || !!obj && obj[prop] === objectInPath;
                return obj && obj[prop];
            }, object);
            if (options.validPath) return isIn && pathExists;
            else return isIn;
        } else return false;
    } else return false;
}



var $c3gFF = parcelRequire("c3gFF");
var $b5645401b9d507eb$require$decodeHTMLEntities = $c3gFF.decodeHTMLEntities;
function $b5645401b9d507eb$var$getPropertyOfType(obj, prop, type) {
    const val = $611c815cd99c7137$exports.get(obj, prop);
    if (type === "array" && Array.isArray(val) === false) return [
        val
    ];
    else if (type === "object" && Array.isArray(val)) return val[0];
    return val;
}
function $b5645401b9d507eb$var$normaliseResponse(response) {
    const output = Object.assign({}, response);
    $611c815cd99c7137$exports.set(output, "propstat", $b5645401b9d507eb$var$getPropertyOfType(output, "propstat", "object"));
    $611c815cd99c7137$exports.set(output, "propstat.prop", $b5645401b9d507eb$var$getPropertyOfType(output, "propstat.prop", "object"));
    return output;
}
function $b5645401b9d507eb$var$normaliseResult(result) {
    const { multistatus: multistatus } = result;
    if (!multistatus) throw new Error("Invalid response: No root multistatus found");
    const output = {};
    output.multistatus = Array.isArray(multistatus) ? multistatus[0] : multistatus;
    $611c815cd99c7137$exports.set(output, "multistatus.response", $b5645401b9d507eb$var$getPropertyOfType(output, "multistatus.response", "array"));
    $611c815cd99c7137$exports.set(output, "multistatus.response", $611c815cd99c7137$exports.get(output, "multistatus.response").map((response)=>$b5645401b9d507eb$var$normaliseResponse(response)));
    return output;
}
function $b5645401b9d507eb$var$parseXML(xml) {
    return new Promise((resolve)=>{
        const result = $cfe100fd4d681161$export$98e6a39c04603d36(xml, {
            arrayMode: false,
            ignoreNameSpace: true // // We don't use the processors here as decoding is done manually
        });
        resolve($b5645401b9d507eb$var$normaliseResult(result));
    });
}

function $b5645401b9d507eb$var$prepareFileFromProps(props, rawFilename, isDetailed = false) {
    const path = (parcelRequire("6nXoo")); // Last modified time, raw size, item type and mime
    const { getlastmodified: lastMod = null, getcontentlength: rawSize = "0", resourcetype: resourceType = null, getcontenttype: mimeType = null, getetag: etag = null } = props;
    const type = resourceType && typeof resourceType === "object" && typeof resourceType.collection !== "undefined" ? "directory" : "file";
    const filename = $b5645401b9d507eb$require$decodeHTMLEntities(rawFilename);
    const stat = {
        filename: filename,
        basename: path.basename(filename),
        lastmod: lastMod,
        size: parseInt(rawSize, 10),
        type: type,
        etag: typeof etag === "string" ? etag.replace(/"/g, "") : null
    };
    if (type === "file") stat.mime = mimeType && typeof mimeType === "string" ? mimeType.split(";")[0] : "";
    if (isDetailed) stat.props = props;
    return stat;
}
function $b5645401b9d507eb$var$translateDiskSpace(value) {
    switch(value.toString()){
        case "-3":
            return "unlimited";
        case "-2":
        /* falls-through */ case "-1":
            // -1 is non-computed
            return "unknown";
        default:
            return parseInt(value, 10);
    }
}
$b5645401b9d507eb$exports = {
    parseXML: $b5645401b9d507eb$var$parseXML,
    prepareFileFromProps: $b5645401b9d507eb$var$prepareFileFromProps,
    translateDiskSpace: $b5645401b9d507eb$var$translateDiskSpace
};


var $64bd7a71bed5ad3e$require$parseXML = $b5645401b9d507eb$exports.parseXML;
var $64bd7a71bed5ad3e$require$prepareFileFromProps = $b5645401b9d507eb$exports.prepareFileFromProps;

var $aUV4R = parcelRequire("aUV4R");
var $64bd7a71bed5ad3e$require$encodePath = $aUV4R.encodePath;
var $64bd7a71bed5ad3e$require$joinURL = $aUV4R.joinURL;
var $64bd7a71bed5ad3e$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $64bd7a71bed5ad3e$require$request = $aUV4R.request;
function $64bd7a71bed5ad3e$var$getDirectoryContents(remotePath, options) {
    const requestOptions = {
        url: $64bd7a71bed5ad3e$require$joinURL(options.remoteURL, $64bd7a71bed5ad3e$require$encodePath(remotePath), "/"),
        method: "PROPFIND",
        headers: {
            Accept: "text/plain",
            Depth: options.deep ? "infinity" : 1
        },
        responseType: "text"
    };
    let response = null;
    $64bd7a71bed5ad3e$require$prepareRequestOptions(requestOptions, options);
    return $64bd7a71bed5ad3e$require$request(requestOptions).then($64bd7a71bed5ad3e$require$handleResponseCode).then((res)=>{
        response = res;
        return res.data;
    }).then($64bd7a71bed5ad3e$require$parseXML).then((result)=>$64bd7a71bed5ad3e$var$getDirectoryFiles(result, options.remotePath, remotePath, options.details)).then((files)=>$64bd7a71bed5ad3e$require$processResponsePayload(response, files, options.details)).then((files)=>options.glob ? $64bd7a71bed5ad3e$require$processGlobFilter(files, options.glob) : files);
}
function $64bd7a71bed5ad3e$var$getDirectoryFiles(result, serverBasePath, requestPath, isDetailed = false) {
    const remoteTargetPath = $6nXoo.join(serverBasePath, requestPath, "/");
    const serverBase = $6nXoo.join(serverBasePath, "/"); // Extract the response items (directory contents)
    const { multistatus: { response: responseItems } } = result;
    return responseItems // Filter out the item pointing to the current directory (not needed)
    .filter((item)=>{
        let href = item.href;
        href = $6nXoo.join($64bd7a71bed5ad3e$require$normalisePath($64bd7a71bed5ad3e$require$normaliseHREF(href)), "/");
        return href !== serverBase && href !== remoteTargetPath;
    }) // Map all items to a consistent output structure (results)
    .map((item)=>{
        // HREF is the file path (in full)
        const href = $64bd7a71bed5ad3e$require$normaliseHREF(item.href); // Each item should contain a stat object
        const { propstat: { prop: props } } = item; // Process the true full filename (minus the base server path)
        const filename = serverBase === "/" ? $64bd7a71bed5ad3e$require$normalisePath(href) : $64bd7a71bed5ad3e$require$normalisePath($6nXoo.relative(serverBase, href));
        return $64bd7a71bed5ad3e$require$prepareFileFromProps(props, filename, isDetailed);
    });
}
$64bd7a71bed5ad3e$exports = {
    getDirectoryContents: $64bd7a71bed5ad3e$var$getDirectoryContents
};


var $b891610f25a23914$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $b891610f25a23914$require$encodePath = $aUV4R.encodePath;
var $b891610f25a23914$require$joinURL = $aUV4R.joinURL;
var $b891610f25a23914$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $b891610f25a23914$require$request = $aUV4R.request;
function $b891610f25a23914$var$createDirectory(dirPath, options) {
    const requestOptions = {
        url: $b891610f25a23914$require$joinURL(options.remoteURL, $b891610f25a23914$require$encodePath(dirPath)),
        method: "MKCOL"
    };
    $b891610f25a23914$require$prepareRequestOptions(requestOptions, options);
    return $b891610f25a23914$require$request(requestOptions).then($4Nbx7.handleResponseCode);
}
$b891610f25a23914$exports = {
    createDirectory: $b891610f25a23914$var$createDirectory
};


var $15ebfff793d3528d$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");
var $15ebfff793d3528d$require$handleResponseCode = $4Nbx7.handleResponseCode;

var $aUV4R = parcelRequire("aUV4R");
var $15ebfff793d3528d$require$encodePath = $aUV4R.encodePath;
var $15ebfff793d3528d$require$joinURL = $aUV4R.joinURL;
var $15ebfff793d3528d$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $15ebfff793d3528d$require$request = $aUV4R.request;
function $15ebfff793d3528d$var$customRequest(remotePath, requestOptions, options) {
    if (!requestOptions.url) requestOptions.url = $15ebfff793d3528d$require$joinURL(options.remoteURL, $15ebfff793d3528d$require$encodePath(remotePath), "/");
    $15ebfff793d3528d$require$prepareRequestOptions(requestOptions, options);
    return $15ebfff793d3528d$require$request(requestOptions).then($15ebfff793d3528d$require$handleResponseCode);
}
$15ebfff793d3528d$exports = {
    customRequest: $15ebfff793d3528d$var$customRequest
};


var $cb903a46547b9122$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $cb903a46547b9122$require$encodePath = $aUV4R.encodePath;
var $cb903a46547b9122$require$joinURL = $aUV4R.joinURL;
var $cb903a46547b9122$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $cb903a46547b9122$require$request = $aUV4R.request;
function $cb903a46547b9122$var$deleteFile(filename, options) {
    const requestOptions = {
        url: $cb903a46547b9122$require$joinURL(options.remoteURL, $cb903a46547b9122$require$encodePath(filename)),
        method: "DELETE"
    };
    $cb903a46547b9122$require$prepareRequestOptions(requestOptions, options);
    return $cb903a46547b9122$require$request(requestOptions).then($4Nbx7.handleResponseCode);
}
$cb903a46547b9122$exports = {
    deleteFile: $cb903a46547b9122$var$deleteFile
};


var $181d2038742fb43a$exports = {};
"use strict";
var $a1cadbd4d349fa5b$exports = {};
"use strict";

var $3eFSI = parcelRequire("3eFSI");
var $a1cadbd4d349fa5b$require$merge = $3eFSI.merge;

var $4Nbx7 = parcelRequire("4Nbx7");
var $a1cadbd4d349fa5b$require$handleResponseCode = $4Nbx7.handleResponseCode;
var $a1cadbd4d349fa5b$require$processResponsePayload = $4Nbx7.processResponsePayload;

var $a1cadbd4d349fa5b$require$parseXML = $b5645401b9d507eb$exports.parseXML;
var $a1cadbd4d349fa5b$require$prepareFileFromProps = $b5645401b9d507eb$exports.prepareFileFromProps;


var $aUV4R = parcelRequire("aUV4R");
var $a1cadbd4d349fa5b$require$encodePath = $aUV4R.encodePath;
var $a1cadbd4d349fa5b$require$joinURL = $aUV4R.joinURL;
var $a1cadbd4d349fa5b$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $a1cadbd4d349fa5b$require$request = $aUV4R.request;
function $a1cadbd4d349fa5b$var$getStat(filename, options) {
    const requestOptions = {
        url: $a1cadbd4d349fa5b$require$joinURL(options.remoteURL, $a1cadbd4d349fa5b$require$encodePath(filename)),
        method: "PROPFIND",
        headers: {
            Accept: "text/plain",
            Depth: 0
        },
        responseType: "text"
    };
    let response = null;
    $a1cadbd4d349fa5b$require$prepareRequestOptions(requestOptions, options);
    return $a1cadbd4d349fa5b$require$request(requestOptions).then($a1cadbd4d349fa5b$require$handleResponseCode).then((res)=>{
        response = res;
        return res.data;
    }).then($a1cadbd4d349fa5b$require$parseXML).then((xml)=>$a1cadbd4d349fa5b$var$parseStat(xml, filename, options.details)).then((result)=>$a1cadbd4d349fa5b$require$processResponsePayload(response, result, options.details));
}
function $a1cadbd4d349fa5b$var$parseStat(result, filename, isDetailed = false) {
    let responseItem = null;
    try {
        responseItem = result.multistatus.response[0];
    } catch (e) {
    /* ignore */ }
    if (!responseItem) throw new Error("Failed getting item stat: bad response");
    const { propstat: { prop: props } } = responseItem;
    const filePath = $d6e96d3b02fef0b7$exports.normalisePath(filename);
    return $a1cadbd4d349fa5b$require$prepareFileFromProps(props, filePath, isDetailed);
}
$a1cadbd4d349fa5b$exports = {
    getStat: $a1cadbd4d349fa5b$var$getStat,
    parseStat: $a1cadbd4d349fa5b$var$parseStat
};


var $181d2038742fb43a$require$getStat = $a1cadbd4d349fa5b$exports.getStat;
function $181d2038742fb43a$var$pathExists(remotePath, options) {
    return $181d2038742fb43a$require$getStat(remotePath, options).then(()=>true).catch((err)=>{
        if (err.response && err.response.status === 404) return false;
        throw err;
    });
}
$181d2038742fb43a$exports = {
    pathExists: $181d2038742fb43a$var$pathExists
};


var $7c389480fd764824$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");
var $7c389480fd764824$require$handleResponseCode = $4Nbx7.handleResponseCode;
var $7c389480fd764824$require$processResponsePayload = $4Nbx7.processResponsePayload;

var $aUV4R = parcelRequire("aUV4R");
var $7c389480fd764824$require$encodePath = $aUV4R.encodePath;
var $7c389480fd764824$require$joinURL = $aUV4R.joinURL;
var $7c389480fd764824$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $7c389480fd764824$require$request = $aUV4R.request;

var $c3gFF = parcelRequire("c3gFF");
var $7c389480fd764824$require$fromBase64 = $c3gFF.fromBase64;
function $7c389480fd764824$var$getFileContentsBuffer(filePath, options) {
    const requestOptions = {
        url: $7c389480fd764824$require$joinURL(options.remoteURL, $7c389480fd764824$require$encodePath(filePath)),
        method: "GET",
        responseType: "arraybuffer"
    };
    $7c389480fd764824$require$prepareRequestOptions(requestOptions, options);
    return $7c389480fd764824$require$request(requestOptions).then($7c389480fd764824$require$handleResponseCode).then((res)=>$7c389480fd764824$require$processResponsePayload(res, res.data, options.details));
}
function $7c389480fd764824$var$getFileContentsString(filePath, options) {
    const requestOptions = {
        url: $7c389480fd764824$require$joinURL(options.remoteURL, $7c389480fd764824$require$encodePath(filePath)),
        method: "GET",
        responseType: "text"
    };
    $7c389480fd764824$require$prepareRequestOptions(requestOptions, options);
    return $7c389480fd764824$require$request(requestOptions).then($7c389480fd764824$require$handleResponseCode).then((res)=>$7c389480fd764824$require$processResponsePayload(res, res.data, options.details));
}
function $7c389480fd764824$var$getFileLink(filePath, options) {
    let url = $7c389480fd764824$require$joinURL(options.remoteURL, $7c389480fd764824$require$encodePath(filePath));
    const protocol = /^https:/i.test(url) ? "https" : "http";
    if (options.headers && options.headers.Authorization) {
        if (/^Basic /i.test(options.headers.Authorization) === false) throw new Error("Failed retrieving download link: Invalid authorisation method");
        const authPart = options.headers.Authorization.replace(/^Basic /i, "").trim();
        const authContents = $7c389480fd764824$require$fromBase64(authPart);
        url = url.replace(/^https?:\/\//, `${protocol}://${authContents}@`);
    }
    return url;
}
$7c389480fd764824$exports = {
    getFileContentsBuffer: $7c389480fd764824$var$getFileContentsBuffer,
    getFileContentsString: $7c389480fd764824$var$getFileContentsString,
    getFileLink: $7c389480fd764824$var$getFileLink
};


var $5d4bde8d3ea13c82$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");
var $5d4bde8d3ea13c82$require$handleResponseCode = $4Nbx7.handleResponseCode;
var $5d4bde8d3ea13c82$require$processResponsePayload = $4Nbx7.processResponsePayload;

var $aUV4R = parcelRequire("aUV4R");
var $5d4bde8d3ea13c82$require$encodePath = $aUV4R.encodePath;
var $5d4bde8d3ea13c82$require$joinURL = $aUV4R.joinURL;
var $5d4bde8d3ea13c82$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $5d4bde8d3ea13c82$require$request = $aUV4R.request;

var $5d4bde8d3ea13c82$require$parseXML = $b5645401b9d507eb$exports.parseXML;
var $5d4bde8d3ea13c82$require$translateDiskSpace = $b5645401b9d507eb$exports.translateDiskSpace;
function $5d4bde8d3ea13c82$var$getQuota(options) {
    const requestOptions = {
        url: $5d4bde8d3ea13c82$require$joinURL(options.remoteURL, "/"),
        method: "PROPFIND",
        headers: {
            Accept: "text/plain",
            Depth: 0
        },
        responseType: "text"
    };
    let response = null;
    $5d4bde8d3ea13c82$require$prepareRequestOptions(requestOptions, options);
    return $5d4bde8d3ea13c82$require$request(requestOptions).then($5d4bde8d3ea13c82$require$handleResponseCode).then((res)=>{
        response = res;
        return res.data;
    }).then($5d4bde8d3ea13c82$require$parseXML).then($5d4bde8d3ea13c82$var$parseQuota).then((result)=>$5d4bde8d3ea13c82$require$processResponsePayload(response, result, options.details));
}
function $5d4bde8d3ea13c82$var$parseQuota(result) {
    try {
        const [responseItem] = result.multistatus.response;
        const { propstat: { prop: { "quota-used-bytes": quotaUsed, "quota-available-bytes": quotaAvail } } } = responseItem;
        return typeof quotaUsed !== "undefined" && typeof quotaAvail !== "undefined" ? {
            used: parseInt(quotaUsed, 10),
            available: $5d4bde8d3ea13c82$require$translateDiskSpace(quotaAvail)
        } : null;
    } catch (err) {
    /* ignore */ }
    return null;
}
$5d4bde8d3ea13c82$exports = {
    getQuota: $5d4bde8d3ea13c82$var$getQuota
};


var $1ed2b6755db31ab7$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $1ed2b6755db31ab7$require$encodePath = $aUV4R.encodePath;
var $1ed2b6755db31ab7$require$joinURL = $aUV4R.joinURL;
var $1ed2b6755db31ab7$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $1ed2b6755db31ab7$require$request = $aUV4R.request;
function $1ed2b6755db31ab7$var$moveFile(filename, destination, options) {
    const requestOptions = {
        url: $1ed2b6755db31ab7$require$joinURL(options.remoteURL, $1ed2b6755db31ab7$require$encodePath(filename)),
        method: "MOVE",
        headers: {
            Destination: $1ed2b6755db31ab7$require$joinURL(options.remoteURL, $1ed2b6755db31ab7$require$encodePath(destination))
        }
    };
    $1ed2b6755db31ab7$require$prepareRequestOptions(requestOptions, options);
    return $1ed2b6755db31ab7$require$request(requestOptions).then($4Nbx7.handleResponseCode);
}
$1ed2b6755db31ab7$exports = {
    moveFile: $1ed2b6755db31ab7$var$moveFile
};


var $216543d4c10a9a86$exports = {};
"use strict";

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $216543d4c10a9a86$require$encodePath = $aUV4R.encodePath;
var $216543d4c10a9a86$require$joinURL = $aUV4R.joinURL;
var $216543d4c10a9a86$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $216543d4c10a9a86$require$request = $aUV4R.request;
function $216543d4c10a9a86$var$copyFile(filename, destination, options) {
    const requestOptions = {
        url: $216543d4c10a9a86$require$joinURL(options.remoteURL, $216543d4c10a9a86$require$encodePath(filename)),
        method: "COPY",
        headers: {
            Destination: $216543d4c10a9a86$require$joinURL(options.remoteURL, $216543d4c10a9a86$require$encodePath(destination))
        }
    };
    $216543d4c10a9a86$require$prepareRequestOptions(requestOptions, options);
    return $216543d4c10a9a86$require$request(requestOptions).then($4Nbx7.handleResponseCode);
}
$216543d4c10a9a86$exports = {
    copyFile: $216543d4c10a9a86$var$copyFile
};


var $18caac1d4459ac72$exports = {};
"use strict";

var $3eFSI = parcelRequire("3eFSI");
var $18caac1d4459ac72$require$merge = $3eFSI.merge;

var $4Nbx7 = parcelRequire("4Nbx7");

var $aUV4R = parcelRequire("aUV4R");
var $18caac1d4459ac72$require$encodePath = $aUV4R.encodePath;
var $18caac1d4459ac72$require$joinURL = $aUV4R.joinURL;
var $18caac1d4459ac72$require$prepareRequestOptions = $aUV4R.prepareRequestOptions;
var $18caac1d4459ac72$require$request = $aUV4R.request;

var $c3gFF = parcelRequire("c3gFF");
var $18caac1d4459ac72$require$fromBase64 = $c3gFF.fromBase64;
function $18caac1d4459ac72$var$getPutContentsDefaults() {
    return {
        headers: {
            "Content-Type": "application/octet-stream"
        },
        overwrite: true
    };
}

function $18caac1d4459ac72$var$putFileContents(filePath, data, options) {
    const headers = {
        "Content-Length": data.length
    };
    if (typeof WEB === "undefined") {
        // We're running under NodeJS, so it's safe to check if the
        // input is a stream
        const stream = (parcelRequire("2fkCS"));
        if (data instanceof stream.Readable) // Input was a stream, remove the content length as this
        // is not known yet
        delete headers["Content-Length"];
    }
    const putOptions = $18caac1d4459ac72$require$merge($18caac1d4459ac72$var$getPutContentsDefaults(), {
        headers: headers
    }, options || {});
    if (putOptions.overwrite === false) putOptions.headers["If-None-Match"] = "*";
    const requestOptions = {
        url: $18caac1d4459ac72$require$joinURL(options.remoteURL, $18caac1d4459ac72$require$encodePath(filePath)),
        method: "PUT",
        headers: putOptions.headers,
        data: data
    };
    $18caac1d4459ac72$require$prepareRequestOptions(requestOptions, options);
    return $18caac1d4459ac72$require$request(requestOptions).then($4Nbx7.handleResponseCode);
}
function $18caac1d4459ac72$var$getFileUploadLink(filePath, options) {
    let url = $18caac1d4459ac72$require$joinURL(options.remoteURL, $18caac1d4459ac72$require$encodePath(filePath));
    url += "?Content-Type=application/octet-stream";
    const protocol = /^https:/i.test(url) ? "https" : "http";
    if (options.headers && options.headers.Authorization) {
        if (/^Basic /i.test(options.headers.Authorization) === false) throw new Error("Failed retrieving download link: Invalid authorisation method");
        const authPart = options.headers.Authorization.replace(/^Basic /i, "").trim();
        const authContents = $18caac1d4459ac72$require$fromBase64(authPart);
        url = url.replace(/^https?:\/\//, `${protocol}://${authContents}@`);
    }
    return url;
}
$18caac1d4459ac72$exports = {
    getFileUploadLink: $18caac1d4459ac72$var$getFileUploadLink,
    putFileContents: $18caac1d4459ac72$var$putFileContents
};



const $bf91db140ea2438d$var$NOOP = ()=>{};


/**
 * Client adapter
 * @typedef {Object} ClientInterface
 */ /**
 * Options for creating a resource
 * @typedef {UserOptions} PutOptions
 * @property {Boolean=} overwrite - Whether or not to overwrite existing files (default: true)
 */ /**
 * Options with headers and format
 * @typedef {UserOptions} OptionsWithFormat
 * @property {String} format - The format to use (text/binary)
 * @property {Boolean=} details - Provided detailed response information, such as response
 *  headers (defaults to false). Only available on requests that return result data.
 */ /**
 * Options for methods that resturn responses
 * @typedef {UserOptions} OptionsForAdvancedResponses
 * @property {Boolean=} details - Provided detailed response information, such as response
 *  headers (defaults to false). Only available on requests that return result data.
 */ /**
 * @typedef {OptionsForAdvancedResponses} GetDirectoryContentsOptions
 * @property {Boolean=} deep - Return deep (infinite) items (default: false)
 * @property {String=} glob - Glob pattern for matching certain files
 */ /**
 * @typedef {Object} AuthToken
 * @property {String} token_type - The type of token (eg "Bearer")
 * @property {String} access_token - The token access code
 */ /**
 * @typedef {Object} CreateClientOptions
 * @property {String=} username - The username for authentication
 * @property {String=} password - The password for authentication
 * @property {http.Agent=} httpAgent - Override the HTTP Agent instance for requests
 * @property {https.Agent=} httpsAgent - Override the HTTPS Agent instance for requests
 * @property {AuthToken=} token - Optional OAuth token
 */ /**
 * A stat result
 * @typedef {Object} Stat
 * @property {String} filename The full path and filename of the remote item
 * @property {String} basename The base filename of the remote item, without the path
 * @property {String|null} lastmod The last modification date (eg. "Sun, 13 Mar 2016 04:23:32 GMT")
 * @property {Number} size The size of the remote item
 * @property {String} type The type of the item (file/directory)
 * @property {String=} mime The file mimetype (not present on directories)
 * @property {String|null} etag The ETag of the remote item (as supported by the server)
 * @property {Object=} props Additionally returned properties from the server, unprocessed, if
 *     `details: true` is specified in the options
 */ /**
 * Create a client adapter
 * @param {String} remoteURL The remote address of the webdav server
 * @param {CreateClientOptions=} opts Client options
 * @returns {ClientInterface} A new client interface instance
 * @memberof module:WebDAV
 * @example
 *  const createClient = require("webdav");
 *  const client = createClient(url, { username, password });
 *  client
 *      .getDirectoryContents("/")
 *      .then(contents => {
 *          console.log(contents);
 *      });
 * @example
 *  const createClient = require("webdav");
 *  const client = createClient(url, {
 *      token: { token_type: "Bearer", access_token: "tokenvalue" }
 *  });
 *  client
 *      .getDirectoryContents("/")
 *      .then(contents => {
 *          console.log(contents);
 *      });
 */ function $bf91db140ea2438d$var$createClient(remoteURL, opts = {}) {
    if (!opts || typeof opts !== "object") throw new Error("Options must be an object, if specified");
    const { username: username, password: password, httpAgent: httpAgent, httpsAgent: httpsAgent, token: token = null, digest: digest = false } = opts;
    const runtimeOptions = {
        headers: {},
        remotePath: $d6e96d3b02fef0b7$exports.extractURLPath(remoteURL),
        remoteURL: remoteURL,
        httpAgent: httpAgent,
        httpsAgent: httpsAgent
    }; // Configure auth
    if (digest) runtimeOptions._digest = {
        username: username,
        password: password,
        nc: 0,
        algorithm: "md5",
        hasDigestAuth: false
    };
    else if (username) runtimeOptions.headers.Authorization = $3FL1p.generateBasicAuthHeader(username, password);
    else if (token && typeof token === "object") runtimeOptions.headers.Authorization = $3FL1p.generateTokenAuthHeader(token);
    return {
        /**
     * Copy a remote item to another path
     * @param {String} remotePath The remote item path
     * @param {String} targetRemotePath The path file will be copied to
     * @param {UserOptions=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise} A promise that resolves once the request has completed
     * @example
     *      await client.copyFile("/photos/pic1.jpg", "/backup/pic1.jpg");
     */ copyFile: function copyFile(remotePath, targetRemotePath, options) {
            const copyOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $216543d4c10a9a86$exports.copyFile(remotePath, targetRemotePath, copyOptions);
        },
        /**
     * Create a directory
     * @param {String} dirPath The path to create
     * @param {UserOptions=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise} A promise that resolves when the remote path has been created
     * @example
     *      await client.createDirectory("/my/directory");
     */ createDirectory: function createDirectory(dirPath, options) {
            const createOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $b891610f25a23914$exports.createDirectory(dirPath, createOptions);
        },
        /**
     * Create a readable stream of a remote file
     * @param {String} remoteFilename The file to stream
     * @param {UserOptions=} options Options for the request
     * @memberof ClientInterface
     * @returns {Readable} A readable stream
     * @example
     *      const remote = client.createReadStream("/data.zip");
     *      remote.pipe(someWriteStream);
     */ createReadStream: function createReadStream(remoteFilename, options) {
            if (typeof WEB !== "undefined" && WEB === true) throw new Error("createReadStream not implemented in web environment");
            else {
                const createStream = (parcelRequire("fGtTc"));
                const createOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
                return createStream.createReadStream(remoteFilename, createOptions);
            }
        },
        /**
     * Create a writeable stream to a remote file
     * @param {String} remoteFilename The file to write to
     * @param {PutOptions=} options Options for the request
     * @param {Function=} callback Optional callback to fire
     *  once the request has finished
     * @memberof ClientInterface
     * @returns {Writeable} A writeable stream
     * @example
     *      const remote = client.createWriteStream("/data.zip");
     *      fs.createReadStream("~/myData.zip").pipe(remote);
     */ createWriteStream: function createWriteStream(remoteFilename, options, callback = $bf91db140ea2438d$var$NOOP) {
            if (typeof WEB !== "undefined" && WEB === true) throw new Error("createWriteStream not implemented in web environment");
            else {
                const createStream = (parcelRequire("fGtTc"));
                const createOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
                return createStream.createWriteStream(remoteFilename, createOptions, callback);
            }
        },
        /**
     * Send a custom request
     * @param {String} remotePath The remote path
     * @param {RequestOptions=}  requestOptions the request options
     * @param {Options=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise<Any>} A promise that resolves with response of the request
     * @example
     *      const contents = await client.customRequest("/alrighty.jpg", {
     *          method: "PROPFIND",
     *          headers: {
     *              Accept: "text/plain",
     *              Depth: 0
     *          },
     *          responseType: "text"
     *      });
     */ customRequest: function customRequest(remotePath, requestOptions, options) {
            const customOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $15ebfff793d3528d$exports.customRequest(remotePath, requestOptions, customOptions);
        },
        /**
     * Delete a remote file
     * @param {String} remotePath The remote path to delete
     * @param {UserOptions=} options The options for the request
     * @memberof ClientInterface
     * @returns {Promise} A promise that resolves when the remote file as been deleted
     * @example
     *      await client.deleteFile("/some/file.txt");
     */ deleteFile: function deleteFile(remotePath, options) {
            const deleteOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $cb903a46547b9122$exports.deleteFile(remotePath, deleteOptions);
        },
        /**
     * Check if a remote file or directory exists
     * @param {String} remotePath The remote path to check
     * @param {UserOptions=} options The options for the request
     * @memberof ClientInterface
     * @returns {Promise.<Boolean>} A promise that resolves with true if the path exists
     *  or false if it does not
     * @example
     *      if (await client.exists("/some-path/file.txt")) {
     *          // Do something
     *      }
     */ exists: function exists(remotePath, options) {
            const existsOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $181d2038742fb43a$exports.pathExists(remotePath, existsOptions);
        },
        /**
     * Get the contents of a remote directory
     * @param {String} remotePath The path to fetch the contents of
     * @param {GetDirectoryContentsOptions=} options Options for the remote the request
     * @returns {Promise.<Array.<Stat>>} A promise that resolves with an array of remote item stats
     * @memberof ClientInterface
     * @example
     *      const contents = await client.getDirectoryContents("/");
     */ getDirectoryContents: function getDirectoryContents(remotePath, options) {
            const getOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $64bd7a71bed5ad3e$exports.getDirectoryContents(remotePath, getOptions);
        },
        /**
     * Get the contents of a remote file
     * @param {String} remoteFilename The file to fetch
     * @param {OptionsWithFormat=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise.<Buffer|String>} A promise that resolves with the contents of the remote file
     * @example
     *      // Fetching data:
     *      const buff = await client.getFileContents("/image.png");
     *      // Fetching text:
     *      const txt = await client.getFileContents("/list.txt", { format: "text" });
     */ getFileContents: function getFileContents(remoteFilename, options) {
            const getOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            getOptions.format = getOptions.format || "binary";
            if ([
                "binary",
                "text"
            ].indexOf(getOptions.format) < 0) throw new Error("Unknown format: " + getOptions.format);
            return getOptions.format === "text" ? $7c389480fd764824$exports.getFileContentsString(remoteFilename, getOptions) : $7c389480fd764824$exports.getFileContentsBuffer(remoteFilename, getOptions);
        },
        /**
     * Get the download link of a remote file
     * Only supported for Basic authentication or unauthenticated connections.
     * @param {String} remoteFilename The file url to fetch
     * @param {UserOptions=} options Options for the request
     * @memberof ClientInterface
     * @returns {String} A download URL
     */ getFileDownloadLink: function getFileDownloadLink(remoteFilename, options) {
            const getOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $7c389480fd764824$exports.getFileLink(remoteFilename, getOptions);
        },
        /**
     * Get a file upload link
     * Only supported for Basic authentication or unauthenticated connections.
     * @param {String} remoteFilename The path of the remote file location
     * @param {PutOptions=} options The options for the request
     * @memberof ClientInterface
     * @returns {String} A upload URL
     */ getFileUploadLink: function getFileUploadLink(remoteFilename, options) {
            var putOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $18caac1d4459ac72$exports.getFileUploadLink(remoteFilename, putOptions);
        },
        /**
     * Get quota information
     * @param {OptionsForAdvancedResponses=} options Options for the request
     * @returns {Promise.<null|Object>} Returns null if failed, or an object with `used` and `available`
     * @memberof ClientInterface
     */ getQuota: function getQuota(options) {
            const getOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $5d4bde8d3ea13c82$exports.getQuota(getOptions);
        },
        /**
     * Move a remote item to another path
     * @param {String} remotePath The remote item path
     * @param {String} targetRemotePath The new path after moving
     * @param {UserOptions=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise} A promise that resolves once the request has completed
     * @example
     *      await client.moveFile("/sub/file.dat", "/another/dir/file.dat");
     */ moveFile: function moveFile(remotePath, targetRemotePath, options) {
            const moveOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $1ed2b6755db31ab7$exports.moveFile(remotePath, targetRemotePath, moveOptions);
        },
        /**
     * Write contents to a remote file path
     * @param {String} remoteFilename The path of the remote file
     * @param {String|Buffer} data The data to write
     * @param {PutOptions=} options The options for the request
     * @returns {Promise} A promise that resolves once the contents have been written
     * @memberof ClientInterface
     * @example
     *      await client.putFileContents("/dir/image.png", myImageBuffer);
     *      // Put contents without overwriting:
     *      await client.putFileContents("/dir/image.png", myImageBuffer, { overwrite: false });
     */ putFileContents: function putFileContents(remoteFilename, data, options) {
            const putOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $18caac1d4459ac72$exports.putFileContents(remoteFilename, data, putOptions);
        },
        /**
     * Stat a remote object
     * @param {String} remotePath The path of the item
     * @param {OptionsForAdvancedResponses=} options Options for the request
     * @memberof ClientInterface
     * @returns {Promise.<Stat>} A promise that resolves with the stat data
     */ stat: function stat(remotePath, options) {
            const getOptions = $bf91db140ea2438d$require$merge(runtimeOptions, options || {});
            return $a1cadbd4d349fa5b$exports.getStat(remotePath, getOptions);
        }
    };
}
$bf91db140ea2438d$exports = {
    createClient: $bf91db140ea2438d$var$createClient
};


var $c038ec147a89b0f7$require$createClient = $bf91db140ea2438d$exports.createClient;

var $iPEud = parcelRequire("iPEud");
var $c038ec147a89b0f7$require$getPatcher = $iPEud.getPatcher;
/**
 * @module WebDAV
 */ $c038ec147a89b0f7$exports = {
    axios: $c038ec147a89b0f7$require$axios,
    createClient: $c038ec147a89b0f7$require$createClient,
    getPatcher: $c038ec147a89b0f7$require$getPatcher
};



var $1X5R2 = parcelRequire("1X5R2");
const $bc2c83d4c6613e8d$export$c000bb94a9c7754a = (listing)=>{
    return listing.filter((file)=>{
        // Show all folders
        if (file.type === 'directory') return true;
        // And only file with the 'org' extension
        return file.basename.match(/org$|org_archive$/);
    }).sort((a, b)=>{
        // Folders before files
        if (a.type === 'directory' && b.type !== 'directory') return -1;
        else return a.basename > b.basename ? 1 : -1;
    });
};
var $bc2c83d4c6613e8d$export$2e2bcd8739ae039 = (url, login, password)=>{
    const webdavClient = (0, $c038ec147a89b0f7$exports.createClient)(url, {
        username: login,
        password: password
    });
    const isSignedIn = ()=>new Promise((resolve)=>{
            // There's no direct API to know if the login worked. So, let's
            // check if the root folder contents can be accessed.
            getDirectoryListing('/').then(()=>{
                resolve(true);
            }).catch((error)=>{
                console.error("Login didn't work, error: ", JSON.stringify(error));
                resolve(false);
            });
        });
    const transformDirectoryListing = (listing)=>{
        const sortedListing = $bc2c83d4c6613e8d$export$c000bb94a9c7754a(listing);
        return (0, $3044e0bef3624137$exports.fromJS)(sortedListing.map((entry)=>({
                id: entry.filename,
                name: entry.basename,
                isDirectory: entry.type === 'directory',
                path: entry.filename
            })));
    };
    const getDirectoryListing = (path)=>new Promise((resolve, reject)=>{
            webdavClient.getDirectoryContents(path).then((response)=>resolve({
                    listing: transformDirectoryListing(response)
                })).catch(reject);
        });
    const getMoreDirectoryListing = (_additionalSyncBackendState)=>{
        // TODO
        return new Promise((resolve, reject)=>resolve());
    };
    const uploadFile = (path, contents)=>new Promise((resolve, reject)=>webdavClient.putFileContents(path, contents, {
                overwrite: true
            }).then(resolve()).catch(reject));
    const updateFile = uploadFile;
    const createFile = uploadFile;
    const getFileContentsAndMetadata = (path)=>new Promise((resolve, reject)=>webdavClient.stat(path).then((stat)=>{
                webdavClient.getFileContents(path, {
                    format: 'text'
                }).then((response)=>{
                    resolve({
                        contents: response,
                        lastModifiedAt: new Date(Date.parse(stat.lastmod)).toISOString()
                    });
                }).catch((error)=>{
                    console.error(path, ': get file failed', error);
                    reject();
                });
            }).catch((error)=>{
                if (error && error.response && [
                    401,
                    403
                ].indexOf(error.response.status) !== -1) alert(login + '@' + url + ': ' + error.response.statusText);
                console.error(path, ': get stat failed', error);
                reject();
            }));
    const getFileContents = (path)=>{
        if ((0, $1X5R2.isEmpty)(path)) return Promise.reject('No path given');
        return new Promise((resolve, reject)=>getFileContentsAndMetadata(path).then(({ contents: contents })=>resolve(contents)).catch(reject));
    };
    const deleteFile = (path)=>new Promise((resolve, reject)=>webdavClient.deleteFile(path).then(resolve).catch((error)=>{
                if (error && error.response && error.response.status === 404) return;
                console.error(path, ': delete failed', error);
                reject();
            }));
    return {
        type: 'WebDAV',
        isSignedIn: isSignedIn,
        getDirectoryListing: getDirectoryListing,
        getMoreDirectoryListing: getMoreDirectoryListing,
        updateFile: updateFile,
        createFile: createFile,
        getFileContentsAndMetadata: getFileContentsAndMetadata,
        getFileContents: getFileContents,
        deleteFile: deleteFile
    };
};




// organice renders different kinds of components:
//  - Static pages like the landing page
//  - The actual application
// These components do not have many things in common, neither CSS,
// nor structure. See adr-002 for details <Turnout />
// ensures rendering either a static page or a dynamic application
// component.

var $1bxDW = parcelRequire("1bxDW");


var $3vC7t = parcelRequire("3vC7t");

var $1bxDW = parcelRequire("1bxDW");



var $3vC7t = parcelRequire("3vC7t");



var $1X5R2 = parcelRequire("1X5R2");
var $de7b5d8041e703b4$exports = {};
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === 'object') {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (0, $de7b5d8041e703b4$exports) {
        classNames.default = classNames;
        $de7b5d8041e703b4$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $1bxDW = parcelRequire("1bxDW");


var $1bxDW = parcelRequire("1bxDW");
var $6e8690452b6d1247$export$2e2bcd8739ae039 = ({ href: href, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
    }, children ? children : href);
};


const $b0ebeb906b6a375c$var$PrivacyPolicy = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "privacy-policy-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h1", null, "organice privacy policy"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Last updated: May 9th, 2020"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://200ok.ch/"
    }, "200ok llc"), " operates the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://organice.200ok.ch"
    }), " website and mobile apps."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Information Collection and Use")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Log Data")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer\u2019s Internet Protocol (\u201CIP\u201D) address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "User data")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "No user data, including user data from third-party services such as Dropbox will be stored or monitored by our Service. All access to user data is done through the proper APIs of the respective services, and all data is only processed by the browser. No data will be shared with any other service."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Cookies")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer\u2019s hard drive."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Our website uses these \u201Ccookies\u201D to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Service Providers")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "We may employ third-party companies and individuals due to the following reasons:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, "To facilitate our Service;"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, "To provide the Service on our behalf;"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, "To perform Service-related services; or"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, "To assist us in analyzing how our Service is used.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Security")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Links to Other Sites")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Children\u2019s Privacy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Changes to This Privacy Policy")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("strong", null, "Contact us")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "If you have any questions about this Privacy Policy, please", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: "mailto:info@200ok.ch"
    }, "contact us"), "."));
};
var $b0ebeb906b6a375c$export$2e2bcd8739ae039 = $b0ebeb906b6a375c$var$PrivacyPolicy;



var $1bxDW = parcelRequire("1bxDW");




var $9zQbc = parcelRequire("9zQbc");
var $3vC7t = parcelRequire("3vC7t");

var $b5KKm = parcelRequire("b5KKm");







var $1X5R2 = parcelRequire("1X5R2");

class $5b40eb0040d9e9a9$var$HeaderBar extends (0, $1bxDW.PureComponent) {
    getPathRoot() {
        const { location: { pathname: pathname } } = this.props;
        return pathname.split('/')[1];
    }
    getFilename() {
        const { location: { pathname: pathname } } = this.props;
        // only show a filename if it's a file and not a path
        if (pathname.includes('.org')) return pathname.substring(pathname.lastIndexOf('/') + 1, pathname.lastIndexOf('.'));
        else return '';
    }
    renderFileBrowserBackButton() {
        let backPath = 'Back';
        const fileParts = window.location.href.split('/').map((e)=>decodeURIComponent(e));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).includes(fileParts, 'files')) backPath = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).last(fileParts);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            onClick: ()=>{
                window.history.back();
            },
            className: "header-bar__back-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-chevron-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "header-bar__back-button__directory-path"
        }, backPath));
    }
    renderOrgFileBackButton() {
        const { location: { pathname: pathname } } = this.props;
        let filePath = pathname.substr(5);
        if (filePath.endsWith('/')) filePath = filePath.substring(0, filePath.length - 1);
        const pathParts = filePath.split('/');
        const directoryPath = pathParts.slice(0, pathParts.length - 1).join('/');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
            to: `/files${directoryPath}`,
            onClick: this.handleBackClick,
            className: "header-bar__back-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-chevron-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "header-bar__back-button__directory-path"
        }, "File browser"));
    }
    renderLogo() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-bar__logo-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("img", {
            className: "header-bar__logo",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b5KKm))),
            alt: "Logo",
            width: "30",
            height: "30"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "header-bar__app-name"
        }, "organice"));
    }
    renderHomeFileBackButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
            to: `/`,
            className: "header-bar__back-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-chevron-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "header-bar__back-button__directory-path"
        }, "Home"));
    }
    renderSignInBackButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
            to: `/`,
            className: "header-bar__back-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-chevron-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "header-bar__back-button__directory-path"
        }, "Home"));
    }
    handleBackClick() {
        this.props.base.popModalPage();
    }
    renderSettingsSubPageBackButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-bar__back-button",
            onClick: this.handleBackClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-chevron-left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "header-bar__back-button__directory-path"
        }, "Settings"));
    }
    renderBackButton() {
        const { activeModalPage: activeModalPage } = this.props;
        switch(activeModalPage){
            case 'changelog':
                return this.renderSettingsSubPageBackButton();
            case 'keyboard_shortcuts_editor':
                return this.renderSettingsSubPageBackButton();
            case 'capture_templates_editor':
                return this.renderSettingsSubPageBackButton();
            case 'file_settings_editor':
                return this.renderSettingsSubPageBackButton();
            case 'notifications_editor':
                return this.renderSettingsSubPageBackButton();
            case 'sample':
                return this.renderOrgFileBackButton();
            default:
        }
        switch(this.getPathRoot()){
            case '':
                return this.renderLogo();
            case 'files':
                return this.renderFileBrowserBackButton();
            case 'file':
                return this.renderOrgFileBackButton();
            case 'sample':
                return this.renderHomeFileBackButton();
            case 'sign_in':
                return this.renderSignInBackButton();
            case 'settings':
                return this.renderFileBrowserBackButton();
            case 'changelog':
                return this.renderFileBrowserBackButton();
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null);
        }
    }
    renderTitle() {
        const titleContainerWithText = (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "header-bar__title",
                onClick: this.handleHeaderBarTitleClick
            }, text);
        switch(this.props.activeModalPage){
            case 'changelog':
                return titleContainerWithText('Changelog');
            case 'settings':
                return titleContainerWithText('Settings');
            case 'keyboard_shortcuts_editor':
                return titleContainerWithText('Shortcuts');
            case 'capture_templates_editor':
                return titleContainerWithText('Capture');
            case 'file_settings_editor':
                return titleContainerWithText('Files');
            case 'notifications_editor':
                return titleContainerWithText('Notifications');
            case 'sample':
                return titleContainerWithText('Sample');
            default:
        }
        switch(this.getPathRoot()){
            case 'sample':
                return titleContainerWithText('Sample');
            case 'sign_in':
                return titleContainerWithText('Sign in');
            case 'settings':
                return titleContainerWithText('Settings');
            default:
        }
        return titleContainerWithText(this.props.shouldShowTitleInOrgFile ? this.getFilename() : '');
    }
    handleChangelogClick() {
        this.props.base.restoreStaticFile('changelog');
        this.props.base.pushModalPage('changelog');
    }
    handleModalPageDoneClick() {
        this.props.base.clearModalStack();
    }
    handleHeaderBarTitleClick() {
        this.props.org.selectHeader(null);
    }
    handleUndoClick() {
        if (this.props.isUndoEnabled) this.props.undo.undo();
    }
    handleRedoClick() {
        if (this.props.isRedoEnabled) this.props.undo.redo();
    }
    handleHelpClick() {
        this.props.base.restoreStaticFile('sample');
        this.props.base.pushModalPage('sample');
    }
    handleSettingsClick() {
        this.props.base.setLastViewedFile(this.props.path);
    }
    renderActions() {
        const { isAuthenticated: isAuthenticated, hasUnseenChangelog: hasUnseenChangelog, activeModalPage: activeModalPage, path: path, isUndoEnabled: isUndoEnabled, isRedoEnabled: isRedoEnabled } = this.props;
        if (!!activeModalPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-bar__actions",
            onClick: this.handleModalPageDoneClick
        }, "Done");
        else if (this.getPathRoot() !== 'settings') {
            const undoIconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-undo header-bar__actions__item', {
                'header-bar__actions__item--disabled': !isUndoEnabled
            });
            const redoIconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-redo header-bar__actions__item', {
                'header-bar__actions__item--disabled': !isRedoEnabled
            });
            const settingsIconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-cogs header-bar__actions__item');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "header-bar__actions"
            }, !isAuthenticated && this.getPathRoot() !== 'sign_in' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
                to: "/sign_in"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "header-bar__actions__item",
                title: "Sign in"
            }, "Sign in")), !isAuthenticated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
                href: "https://github.com/200ok-ch/organice"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: "fab fa-github header-bar__actions__item"
            })), isAuthenticated && !activeModalPage && !!path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: undoIconClassName,
                onClick: this.handleUndoClick,
                title: "Undo"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: redoIconClassName,
                onClick: this.handleRedoClick,
                title: "Redo"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: "fas fa-question-circle header-bar__actions__item",
                onClick: this.handleHelpClick,
                title: "Help"
            })), isAuthenticated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, hasUnseenChangelog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: "changelog-icon--has-unseen-changelog header-bar__actions__item fas fa-gift",
                onClick: this.handleChangelogClick,
                title: "Changelog"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
                to: "/settings",
                onClick: this.handleSettingsClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: settingsIconClassName,
                title: "Settings"
            }))));
        }
    }
    render() {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('header-bar', {
            'header-bar--with-logo': this.getPathRoot() === ''
        });
        // The LP does not show the HeaderBar
        if (!(0, $2f905e7cf539a8bd$export$32b5e5fecf41ac06)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: className
        }, this.renderBackButton(), this.renderTitle(), this.renderActions());
        return null;
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleChangelogClick',
            'handleModalPageDoneClick',
            'handleHeaderBarTitleClick',
            'handleBackClick',
            'handleUndoClick',
            'handleRedoClick',
            'handleHelpClick',
            'handleSettingsClick'
        ]);
    }
}
const $5b40eb0040d9e9a9$var$mapStateToProps = (state)=>{
    return {
        isAuthenticated: state.syncBackend.get('isAuthenticated'),
        hasUnseenChangelog: state.base.get('hasUnseenChangelog'),
        activeModalPage: state.base.get('modalPageStack', (0, $3044e0bef3624137$exports.List)()).last(),
        shouldShowTitleInOrgFile: state.base.get('shouldShowTitleInOrgFile'),
        path: state.org.present.get('path'),
        isUndoEnabled: state.org.past.length > 0,
        isRedoEnabled: state.org.future.length > 0,
        syncBackendType: state.syncBackend.get('client') && state.syncBackend.get('client').type
    };
};
const $5b40eb0040d9e9a9$var$mapDispatchToProps = (dispatch)=>{
    return {
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch),
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        undo: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)((0, $5624140532e76935$exports.ActionCreators), dispatch)
    };
};
var $5b40eb0040d9e9a9$export$2e2bcd8739ae039 = (0, $3vC7t.withRouter)((0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($5b40eb0040d9e9a9$var$mapStateToProps, $5b40eb0040d9e9a9$var$mapDispatchToProps)($5b40eb0040d9e9a9$var$HeaderBar));



var $1bxDW = parcelRequire("1bxDW");



var $9zQbc = parcelRequire("9zQbc");
// INFO: There's an <ActionDrawer> component within the <OrgFile>
// component, as well.

var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");




var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");
class $d6f16605fae97b87$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleClick() {
        const { onClick: onClick, isDisabled: isDisabled } = this.props;
        if (isDisabled) return;
        onClick();
    }
    render() {
        const { iconName: iconName, subIconName: subIconName, isDisabled: isDisabled, shouldRotateSubIcon: shouldRotateSubIcon, letter: letter, additionalClassName: additionalClassName, style: style, tooltip: tooltip, shouldSpinSubIcon: shouldSpinSubIcon, onRef: onRef } = this.props;
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('btn', 'btn--circle', 'action-drawer__btn', additionalClassName || '', {
            fas: !letter,
            'fa-lg': !letter,
            [`fa-${iconName}`]: !letter,
            'action-drawer__btn--with-sub-icon': !!subIconName,
            'btn--disabled': isDisabled,
            'action-drawer__btn--letter': !!letter
        });
        const subIconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas', 'fa-xs', `fa-${subIconName}`, 'action-drawer__btn__sub-icon', {
            'action-drawer__btn__sub-icon--rotated': shouldRotateSubIcon,
            'fa-spin': shouldSpinSubIcon
        });
        const { dataTestId: dataTestId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: className,
            onClick: this.handleClick,
            style: style,
            title: tooltip,
            ref: onRef,
            "data-testid": dataTestId
        }, !!letter && letter, !!subIconName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: subIconClassName
        }));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleClick'
        ]);
    }
}


const $591a9d6bfcf5d2f9$var$ensureCompleteFilename = (fileName)=>{
    return fileName.endsWith('.org') ? fileName : `${fileName}.org`;
};
const $591a9d6bfcf5d2f9$var$ActionDrawer = ({ org: org, files: files, syncBackend: syncBackend, path: path })=>{
    const handleAddNewOrgFileClick = ()=>{
        const content = '* First header\nExtend the file from here.';
        let fileName = prompt('New filename:');
        if (!fileName) return;
        fileName = $591a9d6bfcf5d2f9$var$ensureCompleteFilename(fileName);
        let newPath = `${path}/${fileName}`;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).includes(files, newPath)) alert('File already exists. Aborting.');
        else {
            syncBackend.createFile(newPath, content);
            org.addNewFile(newPath, content);
        }
    };
    const mainButtonStyle = {
        opacity: 1,
        position: 'relative',
        zIndex: 1
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "action-drawer-container nice-scroll"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "action-drawer__capture-buttons-container",
        style: {
            marginLeft: 'auto',
            marginRight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
        iconName: "plus",
        isDisabled: false,
        onClick: handleAddNewOrgFileClick,
        style: mainButtonStyle,
        tooltip: "Add new Org file"
    }))));
};
const $591a9d6bfcf5d2f9$var$mapStateToProps = (state)=>{
    const path = state.syncBackend.get('currentPath');
    let files = state.syncBackend.getIn([
        'currentFileBrowserDirectoryListing',
        'listing'
    ]);
    files = files ? files.map((e)=>e.get('id')).toJS() : [];
    return {
        path: path,
        files: files
    };
};
const $591a9d6bfcf5d2f9$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        syncBackend: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($f257bd084a67bcde$exports, dispatch)
    };
};
var $591a9d6bfcf5d2f9$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($591a9d6bfcf5d2f9$var$mapStateToProps, $591a9d6bfcf5d2f9$var$mapDispatchToProps)($591a9d6bfcf5d2f9$var$ActionDrawer);





const $baec0e505123760e$var$FileBrowser = ({ path: path, listing: listing, hasMore: hasMore, isLoadingMore: isLoadingMore, syncBackendType: syncBackendType, syncBackend: syncBackend })=>{
    (0, $1bxDW.useEffect)(()=>syncBackend.getDirectoryListing(path), [
        syncBackend,
        path
    ]);
    const handleLoadMoreClick = ()=>syncBackend.loadMoreDirectoryListing();
    const getParentDirectoryPath = ()=>{
        switch(syncBackendType){
            case 'Dropbox':
            case 'GitLab':
            case 'WebDAV':
                const pathParts = path.split('/');
                return pathParts.slice(0, pathParts.length - 1).join('/');
            default:
                return null;
        }
    };
    const isTopLevelDirectory = path === '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "file-browser-container"
    }, syncBackendType === 'Dropbox' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h3", {
        className: "file-browser__header"
    }, "Directory: ", isTopLevelDirectory ? '/' : path), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $591a9d6bfcf5d2f9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ul", {
        className: "file-browser__file-list"
    }, !isTopLevelDirectory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
        to: `/files${getParentDirectoryPath()}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
        className: "file-browser__file-list__element"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-folder file-browser__file-list__icon--directory"
    }), " ..")), (listing || []).map((file)=>{
        const isDirectory = file.get('isDirectory');
        const isBackupFile = file.get('name').endsWith('.organice-bak');
        const isOrgFile = file.get('name').endsWith('.org');
        const isSettingsFile = file.get('name') === '.organice-config.json';
        const iconClass = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('file-browser__file-list__icon fas', {
            'fa-folder': isDirectory,
            'file-browser__file-list__icon--directory': isDirectory,
            'fa-file': !isDirectory && !isBackupFile && !isSettingsFile,
            'file-browser__file-list__icon--not-org': !isOrgFile,
            'fa-copy': isBackupFile,
            'fa-cogs': isSettingsFile
        });
        if (file.get('isDirectory')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
            to: `/files${file.get('path')}`,
            key: file.get('id')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
            className: "file-browser__file-list__element"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: iconClass
        }), " ", file.get('name'), "/"));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
            to: `/file${file.get('path')}`,
            key: file.get('id')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
            className: "file-browser__file-list__element"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: iconClass
        }), " ", file.get('name')));
    }), hasMore && (isLoadingMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
        className: "file-browser__file-list__loading-more-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-spinner fa-lg fa-spin"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
        className: "file-browser__file-list__element file-browser__file-list__element--load-more-row",
        onClick: handleLoadMoreClick
    }, "Load more..."))));
};
const $baec0e505123760e$var$mapStateToProps = (state)=>{
    const currentFileBrowserDirectoryListing = state.syncBackend.get('currentFileBrowserDirectoryListing');
    return {
        syncBackendType: state.syncBackend.get('client').type,
        listing: !!currentFileBrowserDirectoryListing ? currentFileBrowserDirectoryListing.get('listing') : null,
        hasMore: !!currentFileBrowserDirectoryListing && currentFileBrowserDirectoryListing.get('hasMore'),
        isLoadingMore: !!currentFileBrowserDirectoryListing && currentFileBrowserDirectoryListing.get('isLoadingMore'),
        additionalSyncBackendState: !!currentFileBrowserDirectoryListing && currentFileBrowserDirectoryListing.get('additionalSyncBackendState')
    };
};
const $baec0e505123760e$var$mapDispatchToProps = (dispatch)=>{
    return {
        syncBackend: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($f257bd084a67bcde$exports, dispatch)
    };
};
var $baec0e505123760e$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($baec0e505123760e$var$mapStateToProps, $baec0e505123760e$var$mapDispatchToProps)($baec0e505123760e$var$FileBrowser);



var $1bxDW = parcelRequire("1bxDW");
var $28a04c32d72d17fb$export$1e511d4a378977f5;
var $28a04c32d72d17fb$export$ab7b018719e111db;
var $28a04c32d72d17fb$export$8e2db863497d88e8;
var $28a04c32d72d17fb$export$f55099f28d39dce4;
var $28a04c32d72d17fb$export$b36281d89752ae66;
var $28a04c32d72d17fb$export$7afd9c1079ecedf7;
var $28a04c32d72d17fb$export$5d0a73a0957eccf0;
var $28a04c32d72d17fb$export$e4c0b4e3a05535fb;
'use strict';
$28a04c32d72d17fb$export$1e511d4a378977f5 = true;
function $28a04c32d72d17fb$var$_interopRequire(obj) {
    return obj && obj.__esModule ? obj['default'] : obj;
}
var $e254916fd2aa6ce2$exports = {};
'use strict';
$e254916fd2aa6ce2$exports.__esModule = true;
var $e254916fd2aa6ce2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e254916fd2aa6ce2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e254916fd2aa6ce2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $e254916fd2aa6ce2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $e254916fd2aa6ce2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $dd4afc6884d91dc8$exports = {};
// currently used to initiate the velocity style object to 0
'use strict';
$dd4afc6884d91dc8$exports.__esModule = true;
$dd4afc6884d91dc8$exports['default'] = $dd4afc6884d91dc8$var$mapToZero;
function $dd4afc6884d91dc8$var$mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
$dd4afc6884d91dc8$exports = $dd4afc6884d91dc8$exports['default'];


var $e254916fd2aa6ce2$var$_mapToZero2 = $e254916fd2aa6ce2$var$_interopRequireDefault($dd4afc6884d91dc8$exports);
var $163d7142b2a13e82$exports = {};
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
'use strict';
$163d7142b2a13e82$exports.__esModule = true;
$163d7142b2a13e82$exports['default'] = $163d7142b2a13e82$var$stripStyle;
function $163d7142b2a13e82$var$stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
    }
    return ret;
}
$163d7142b2a13e82$exports = $163d7142b2a13e82$exports['default'];


var $e254916fd2aa6ce2$var$_stripStyle2 = $e254916fd2aa6ce2$var$_interopRequireDefault($163d7142b2a13e82$exports);
var $260cf949112ac9a5$exports = {};
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
$260cf949112ac9a5$exports.__esModule = true;
$260cf949112ac9a5$exports["default"] = $260cf949112ac9a5$var$stepper;
var $260cf949112ac9a5$var$reusedTuple = [
    0,
    0
];
function $260cf949112ac9a5$var$stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        $260cf949112ac9a5$var$reusedTuple[0] = destX;
        $260cf949112ac9a5$var$reusedTuple[1] = 0;
        return $260cf949112ac9a5$var$reusedTuple;
    }
    $260cf949112ac9a5$var$reusedTuple[0] = newX;
    $260cf949112ac9a5$var$reusedTuple[1] = newV;
    return $260cf949112ac9a5$var$reusedTuple;
}
$260cf949112ac9a5$exports = $260cf949112ac9a5$exports["default"]; // array reference around.


var $e254916fd2aa6ce2$var$_stepper4 = $e254916fd2aa6ce2$var$_interopRequireDefault($260cf949112ac9a5$exports);
var $7f2d9ca7b7ecdbc0$exports = {};
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $7f2d9ca7b7ecdbc0$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $7f2d9ca7b7ecdbc0$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $7f2d9ca7b7ecdbc0$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($7f2d9ca7b7ecdbc0$exports);


var $e254916fd2aa6ce2$var$_performanceNow2 = $e254916fd2aa6ce2$var$_interopRequireDefault($7f2d9ca7b7ecdbc0$exports);
var $ae114b000bc143b5$exports = {};
var $93714660ea7d6e40$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $93714660ea7d6e40$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $93714660ea7d6e40$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $93714660ea7d6e40$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($93714660ea7d6e40$exports);


var $ae114b000bc143b5$var$root = typeof window === 'undefined' ? $parcel$global : window, $ae114b000bc143b5$var$vendors = [
    'moz',
    'webkit'
], $ae114b000bc143b5$var$suffix = 'AnimationFrame', $ae114b000bc143b5$var$raf = $ae114b000bc143b5$var$root['request' + $ae114b000bc143b5$var$suffix], $ae114b000bc143b5$var$caf = $ae114b000bc143b5$var$root['cancel' + $ae114b000bc143b5$var$suffix] || $ae114b000bc143b5$var$root['cancelRequest' + $ae114b000bc143b5$var$suffix];
for(var $ae114b000bc143b5$var$i = 0; !$ae114b000bc143b5$var$raf && $ae114b000bc143b5$var$i < $ae114b000bc143b5$var$vendors.length; $ae114b000bc143b5$var$i++){
    $ae114b000bc143b5$var$raf = $ae114b000bc143b5$var$root[$ae114b000bc143b5$var$vendors[$ae114b000bc143b5$var$i] + 'Request' + $ae114b000bc143b5$var$suffix];
    $ae114b000bc143b5$var$caf = $ae114b000bc143b5$var$root[$ae114b000bc143b5$var$vendors[$ae114b000bc143b5$var$i] + 'Cancel' + $ae114b000bc143b5$var$suffix] || $ae114b000bc143b5$var$root[$ae114b000bc143b5$var$vendors[$ae114b000bc143b5$var$i] + 'CancelRequest' + $ae114b000bc143b5$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$ae114b000bc143b5$var$raf || !$ae114b000bc143b5$var$caf) {
    var $ae114b000bc143b5$var$last = 0, $ae114b000bc143b5$var$id = 0, $ae114b000bc143b5$var$queue = [], $ae114b000bc143b5$var$frameDuration = 1000 / 60;
    $ae114b000bc143b5$var$raf = function(callback) {
        if ($ae114b000bc143b5$var$queue.length === 0) {
            var _now = $93714660ea7d6e40$exports(), next = Math.max(0, $ae114b000bc143b5$var$frameDuration - (_now - $ae114b000bc143b5$var$last));
            $ae114b000bc143b5$var$last = next + _now;
            setTimeout(function() {
                var cp = $ae114b000bc143b5$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $ae114b000bc143b5$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($ae114b000bc143b5$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $ae114b000bc143b5$var$queue.push({
            handle: ++$ae114b000bc143b5$var$id,
            callback: callback,
            cancelled: false
        });
        return $ae114b000bc143b5$var$id;
    };
    $ae114b000bc143b5$var$caf = function(handle) {
        for(var i = 0; i < $ae114b000bc143b5$var$queue.length; i++)if ($ae114b000bc143b5$var$queue[i].handle === handle) $ae114b000bc143b5$var$queue[i].cancelled = true;
    };
}
$ae114b000bc143b5$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $ae114b000bc143b5$var$raf.call($ae114b000bc143b5$var$root, fn);
};
$ae114b000bc143b5$exports.cancel = function() {
    $ae114b000bc143b5$var$caf.apply($ae114b000bc143b5$var$root, arguments);
};
$ae114b000bc143b5$exports.polyfill = function(object) {
    if (!object) object = $ae114b000bc143b5$var$root;
    object.requestAnimationFrame = $ae114b000bc143b5$var$raf;
    object.cancelAnimationFrame = $ae114b000bc143b5$var$caf;
};


var $e254916fd2aa6ce2$var$_raf2 = $e254916fd2aa6ce2$var$_interopRequireDefault($ae114b000bc143b5$exports);
var $c1c91d64f6f26ede$exports = {};
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
'use strict';
$c1c91d64f6f26ede$exports.__esModule = true;
$c1c91d64f6f26ede$exports['default'] = $c1c91d64f6f26ede$var$shouldStopAnimation;
function $c1c91d64f6f26ede$var$shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
$c1c91d64f6f26ede$exports = $c1c91d64f6f26ede$exports['default'];


var $e254916fd2aa6ce2$var$_shouldStopAnimation2 = $e254916fd2aa6ce2$var$_interopRequireDefault($c1c91d64f6f26ede$exports);

var $1bxDW = parcelRequire("1bxDW");
var $e254916fd2aa6ce2$var$_react2 = $e254916fd2aa6ce2$var$_interopRequireDefault($1bxDW);

var $7dzZ9 = parcelRequire("7dzZ9");
var $e254916fd2aa6ce2$var$_propTypes2 = $e254916fd2aa6ce2$var$_interopRequireDefault($7dzZ9);
var $e254916fd2aa6ce2$var$msPerFrame = 1000 / 60;
var $e254916fd2aa6ce2$var$Motion = function(_React$Component) {
    $e254916fd2aa6ce2$var$_inherits(Motion, _React$Component);
    $e254916fd2aa6ce2$var$_createClass(Motion, null, [
        {
            key: 'propTypes',
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: $e254916fd2aa6ce2$var$_propTypes2['default'].objectOf($e254916fd2aa6ce2$var$_propTypes2['default'].number),
                style: $e254916fd2aa6ce2$var$_propTypes2['default'].objectOf($e254916fd2aa6ce2$var$_propTypes2['default'].oneOfType([
                    $e254916fd2aa6ce2$var$_propTypes2['default'].number,
                    $e254916fd2aa6ce2$var$_propTypes2['default'].object
                ])).isRequired,
                children: $e254916fd2aa6ce2$var$_propTypes2['default'].func.isRequired,
                onRest: $e254916fd2aa6ce2$var$_propTypes2['default'].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        $e254916fd2aa6ce2$var$_classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === 'number') {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = $e254916fd2aa6ce2$var$_extends({}, currentStyle);
                        currentVelocity = $e254916fd2aa6ce2$var$_extends({}, currentVelocity);
                        lastIdealStyle = $e254916fd2aa6ce2$var$_extends({}, lastIdealStyle);
                        lastIdealVelocity = $e254916fd2aa6ce2$var$_extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $e254916fd2aa6ce2$var$_raf2['default'](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if ($e254916fd2aa6ce2$var$_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || $e254916fd2aa6ce2$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $e254916fd2aa6ce2$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $e254916fd2aa6ce2$var$msPerFrame) * $e254916fd2aa6ce2$var$msPerFrame) / $e254916fd2aa6ce2$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $e254916fd2aa6ce2$var$msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === 'number') {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = $e254916fd2aa6ce2$var$_stepper4['default']($e254916fd2aa6ce2$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = $e254916fd2aa6ce2$var$_stepper4['default']($e254916fd2aa6ce2$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $e254916fd2aa6ce2$var$msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || $e254916fd2aa6ce2$var$_stripStyle2['default'](style);
        var currentVelocity = $e254916fd2aa6ce2$var$_mapToZero2['default'](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $e254916fd2aa6ce2$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = $e254916fd2aa6ce2$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $e254916fd2aa6ce2$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && $e254916fd2aa6ce2$var$_react2['default'].Children.only(renderedChildren);
    };
    return Motion;
}($e254916fd2aa6ce2$var$_react2['default'].Component);
$e254916fd2aa6ce2$exports['default'] = $e254916fd2aa6ce2$var$Motion;
$e254916fd2aa6ce2$exports = $e254916fd2aa6ce2$exports['default']; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)


$28a04c32d72d17fb$export$ab7b018719e111db = $28a04c32d72d17fb$var$_interopRequire($e254916fd2aa6ce2$exports);
var $da12645883368d5b$exports = {};
'use strict';
$da12645883368d5b$exports.__esModule = true;
var $da12645883368d5b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $da12645883368d5b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $da12645883368d5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $da12645883368d5b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $da12645883368d5b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $da12645883368d5b$var$_mapToZero2 = $da12645883368d5b$var$_interopRequireDefault($dd4afc6884d91dc8$exports);

var $da12645883368d5b$var$_stripStyle2 = $da12645883368d5b$var$_interopRequireDefault($163d7142b2a13e82$exports);

var $da12645883368d5b$var$_stepper4 = $da12645883368d5b$var$_interopRequireDefault($260cf949112ac9a5$exports);

var $da12645883368d5b$var$_performanceNow2 = $da12645883368d5b$var$_interopRequireDefault($7f2d9ca7b7ecdbc0$exports);

var $da12645883368d5b$var$_raf2 = $da12645883368d5b$var$_interopRequireDefault($ae114b000bc143b5$exports);

var $da12645883368d5b$var$_shouldStopAnimation2 = $da12645883368d5b$var$_interopRequireDefault($c1c91d64f6f26ede$exports);

var $1bxDW = parcelRequire("1bxDW");
var $da12645883368d5b$var$_react2 = $da12645883368d5b$var$_interopRequireDefault($1bxDW);

var $7dzZ9 = parcelRequire("7dzZ9");
var $da12645883368d5b$var$_propTypes2 = $da12645883368d5b$var$_interopRequireDefault($7dzZ9);
var $da12645883368d5b$var$msPerFrame = 1000 / 60;
function $da12645883368d5b$var$shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!$da12645883368d5b$var$_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var $da12645883368d5b$var$StaggeredMotion = function(_React$Component) {
    $da12645883368d5b$var$_inherits(StaggeredMotion, _React$Component);
    $da12645883368d5b$var$_createClass(StaggeredMotion, null, [
        {
            key: 'propTypes',
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: $da12645883368d5b$var$_propTypes2['default'].arrayOf($da12645883368d5b$var$_propTypes2['default'].objectOf($da12645883368d5b$var$_propTypes2['default'].number)),
                styles: $da12645883368d5b$var$_propTypes2['default'].func.isRequired,
                children: $da12645883368d5b$var$_propTypes2['default'].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        $da12645883368d5b$var$_classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === 'number') {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = $da12645883368d5b$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $da12645883368d5b$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $da12645883368d5b$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $da12645883368d5b$var$_extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $da12645883368d5b$var$_raf2['default'](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if ($da12645883368d5b$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $da12645883368d5b$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $da12645883368d5b$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $da12645883368d5b$var$msPerFrame) * $da12645883368d5b$var$msPerFrame) / $da12645883368d5b$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $da12645883368d5b$var$msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === 'number') {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $da12645883368d5b$var$_stepper4['default']($da12645883368d5b$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $da12645883368d5b$var$_stepper4['default']($da12645883368d5b$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $da12645883368d5b$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map($da12645883368d5b$var$_stripStyle2['default']);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return $da12645883368d5b$var$_mapToZero2['default'](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $da12645883368d5b$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = $da12645883368d5b$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $da12645883368d5b$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && $da12645883368d5b$var$_react2['default'].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}($da12645883368d5b$var$_react2['default'].Component);
$da12645883368d5b$exports['default'] = $da12645883368d5b$var$StaggeredMotion;
$da12645883368d5b$exports = $da12645883368d5b$exports['default']; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)


$28a04c32d72d17fb$export$8e2db863497d88e8 = $28a04c32d72d17fb$var$_interopRequire($da12645883368d5b$exports);
var $df9a6c6bc21ddf73$exports = {};
'use strict';
$df9a6c6bc21ddf73$exports.__esModule = true;
var $df9a6c6bc21ddf73$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $df9a6c6bc21ddf73$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $df9a6c6bc21ddf73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $df9a6c6bc21ddf73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $df9a6c6bc21ddf73$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $df9a6c6bc21ddf73$var$_mapToZero2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($dd4afc6884d91dc8$exports);

var $df9a6c6bc21ddf73$var$_stripStyle2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($163d7142b2a13e82$exports);

var $df9a6c6bc21ddf73$var$_stepper4 = $df9a6c6bc21ddf73$var$_interopRequireDefault($260cf949112ac9a5$exports);
var $7216ac5c69e2116a$exports = {};
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
'use strict';
$7216ac5c69e2116a$exports.__esModule = true;
$7216ac5c69e2116a$exports['default'] = $7216ac5c69e2116a$var$mergeDiff;
function $7216ac5c69e2116a$var$mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
$7216ac5c69e2116a$exports = $7216ac5c69e2116a$exports['default']; // to loop through and find a key's index each time), but I no longer care


var $df9a6c6bc21ddf73$var$_mergeDiff2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($7216ac5c69e2116a$exports);

var $df9a6c6bc21ddf73$var$_performanceNow2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($7f2d9ca7b7ecdbc0$exports);

var $df9a6c6bc21ddf73$var$_raf2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($ae114b000bc143b5$exports);

var $df9a6c6bc21ddf73$var$_shouldStopAnimation2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($c1c91d64f6f26ede$exports);

var $1bxDW = parcelRequire("1bxDW");
var $df9a6c6bc21ddf73$var$_react2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($1bxDW);

var $7dzZ9 = parcelRequire("7dzZ9");
var $df9a6c6bc21ddf73$var$_propTypes2 = $df9a6c6bc21ddf73$var$_interopRequireDefault($7dzZ9);
var $df9a6c6bc21ddf73$var$msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function $df9a6c6bc21ddf73$var$rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function $df9a6c6bc21ddf73$var$shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!$df9a6c6bc21ddf73$var$_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function $df9a6c6bc21ddf73$var$mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = $df9a6c6bc21ddf73$var$_mergeDiff2['default'](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if ($df9a6c6bc21ddf73$var$_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = $df9a6c6bc21ddf73$var$_mapToZero2['default'](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var $df9a6c6bc21ddf73$var$TransitionMotion = function(_React$Component) {
    $df9a6c6bc21ddf73$var$_inherits(TransitionMotion, _React$Component);
    $df9a6c6bc21ddf73$var$_createClass(TransitionMotion, null, [
        {
            key: 'propTypes',
            value: {
                defaultStyles: $df9a6c6bc21ddf73$var$_propTypes2['default'].arrayOf($df9a6c6bc21ddf73$var$_propTypes2['default'].shape({
                    key: $df9a6c6bc21ddf73$var$_propTypes2['default'].string.isRequired,
                    data: $df9a6c6bc21ddf73$var$_propTypes2['default'].any,
                    style: $df9a6c6bc21ddf73$var$_propTypes2['default'].objectOf($df9a6c6bc21ddf73$var$_propTypes2['default'].number).isRequired
                })),
                styles: $df9a6c6bc21ddf73$var$_propTypes2['default'].oneOfType([
                    $df9a6c6bc21ddf73$var$_propTypes2['default'].func,
                    $df9a6c6bc21ddf73$var$_propTypes2['default'].arrayOf($df9a6c6bc21ddf73$var$_propTypes2['default'].shape({
                        key: $df9a6c6bc21ddf73$var$_propTypes2['default'].string.isRequired,
                        data: $df9a6c6bc21ddf73$var$_propTypes2['default'].any,
                        style: $df9a6c6bc21ddf73$var$_propTypes2['default'].objectOf($df9a6c6bc21ddf73$var$_propTypes2['default'].oneOfType([
                            $df9a6c6bc21ddf73$var$_propTypes2['default'].number,
                            $df9a6c6bc21ddf73$var$_propTypes2['default'].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: $df9a6c6bc21ddf73$var$_propTypes2['default'].func.isRequired,
                willEnter: $df9a6c6bc21ddf73$var$_propTypes2['default'].func,
                willLeave: $df9a6c6bc21ddf73$var$_propTypes2['default'].func,
                didLeave: $df9a6c6bc21ddf73$var$_propTypes2['default'].func
            },
            enumerable: true
        },
        {
            key: 'defaultProps',
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return $df9a6c6bc21ddf73$var$_stripStyle2['default'](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        $df9a6c6bc21ddf73$var$_classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = $df9a6c6bc21ddf73$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === 'number') {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = $df9a6c6bc21ddf73$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $df9a6c6bc21ddf73$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $df9a6c6bc21ddf73$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $df9a6c6bc21ddf73$var$_extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: $df9a6c6bc21ddf73$var$_extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $df9a6c6bc21ddf73$var$_raf2['default'](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === 'function' ? propStyles($df9a6c6bc21ddf73$var$rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if ($df9a6c6bc21ddf73$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $df9a6c6bc21ddf73$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $df9a6c6bc21ddf73$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $df9a6c6bc21ddf73$var$msPerFrame) * $df9a6c6bc21ddf73$var$msPerFrame) / $df9a6c6bc21ddf73$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $df9a6c6bc21ddf73$var$msPerFrame);
                var _mergeAndSync2 = $df9a6c6bc21ddf73$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === 'number') {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $df9a6c6bc21ddf73$var$_stepper4['default']($df9a6c6bc21ddf73$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $df9a6c6bc21ddf73$var$_stepper4['default']($df9a6c6bc21ddf73$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $df9a6c6bc21ddf73$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return $df9a6c6bc21ddf73$var$_stripStyle2['default'](s.style);
        }) : defaultStyles.map(function(s) {
            return $df9a6c6bc21ddf73$var$_stripStyle2['default'](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return $df9a6c6bc21ddf73$var$_mapToZero2['default'](s.style);
        }) : defaultStyles.map(function(s) {
            return $df9a6c6bc21ddf73$var$_mapToZero2['default'](s.style);
        });
        var _mergeAndSync3 = $df9a6c6bc21ddf73$var$mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $df9a6c6bc21ddf73$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === 'function') this.unreadPropStyles = styles($df9a6c6bc21ddf73$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = $df9a6c6bc21ddf73$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            $df9a6c6bc21ddf73$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = $df9a6c6bc21ddf73$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && $df9a6c6bc21ddf73$var$_react2['default'].Children.only(renderedChildren);
    };
    return TransitionMotion;
}($df9a6c6bc21ddf73$var$_react2['default'].Component);
$df9a6c6bc21ddf73$exports['default'] = $df9a6c6bc21ddf73$var$TransitionMotion;
$df9a6c6bc21ddf73$exports = $df9a6c6bc21ddf73$exports['default']; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400


$28a04c32d72d17fb$export$f55099f28d39dce4 = $28a04c32d72d17fb$var$_interopRequire($df9a6c6bc21ddf73$exports);
var $4326115997ab1654$exports = {};
'use strict';
$4326115997ab1654$exports.__esModule = true;
var $4326115997ab1654$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$4326115997ab1654$exports['default'] = $4326115997ab1654$var$spring;
function $4326115997ab1654$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $6101b91f2aee1b61$exports = {};
"use strict";
$6101b91f2aee1b61$exports.__esModule = true;
$6101b91f2aee1b61$exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
$6101b91f2aee1b61$exports = $6101b91f2aee1b61$exports["default"];


var $4326115997ab1654$var$_presets2 = $4326115997ab1654$var$_interopRequireDefault($6101b91f2aee1b61$exports);
var $4326115997ab1654$var$defaultConfig = $4326115997ab1654$var$_extends({}, $4326115997ab1654$var$_presets2['default'].noWobble, {
    precision: 0.01
});
function $4326115997ab1654$var$spring(val, config) {
    return $4326115997ab1654$var$_extends({}, $4326115997ab1654$var$defaultConfig, config, {
        val: val
    });
}
$4326115997ab1654$exports = $4326115997ab1654$exports['default'];


$28a04c32d72d17fb$export$b36281d89752ae66 = $28a04c32d72d17fb$var$_interopRequire($4326115997ab1654$exports);

$28a04c32d72d17fb$export$7afd9c1079ecedf7 = $28a04c32d72d17fb$var$_interopRequire($6101b91f2aee1b61$exports);

$28a04c32d72d17fb$export$5d0a73a0957eccf0 = $28a04c32d72d17fb$var$_interopRequire($163d7142b2a13e82$exports);
var $6e52f3c8b890c173$exports = {};
'use strict';
$6e52f3c8b890c173$exports.__esModule = true;
$6e52f3c8b890c173$exports['default'] = $6e52f3c8b890c173$var$reorderKeys;
var $6e52f3c8b890c173$var$hasWarned = false;
function $6e52f3c8b890c173$var$reorderKeys() {}
$6e52f3c8b890c173$exports = $6e52f3c8b890c173$exports['default'];


$28a04c32d72d17fb$export$e4c0b4e3a05535fb = $28a04c32d72d17fb$var$_interopRequire($6e52f3c8b890c173$exports);



var $85c8f4ef3a726095$export$2e2bcd8739ae039 = ({ message: message })=>{
    const [shouldRenderIndicator, setShouldRenderIndicator] = (0, $1bxDW.useState)(true);
    const [lastMessage, setLastMessage] = (0, $1bxDW.useState)(message);
    (0, $1bxDW.useEffect)(()=>{
        if (!!message) {
            setLastMessage(message);
            setShouldRenderIndicator(true);
        }
    }, [
        message
    ]);
    const handleAnimationRest = ()=>{
        if (!!message) return;
        setShouldRenderIndicator(false);
        setLastMessage(null);
    };
    const handleClick = ()=>setShouldRenderIndicator(false);
    if (!shouldRenderIndicator) return null;
    const style = {
        opacity: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(!!message ? 0.9 : 0, {
            stiffness: 300
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
        style: style,
        onRest: handleAnimationRest
    }, (style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "loading-indicator",
            style: style,
            onClick: handleClick
        }, lastMessage));
};



var $1bxDW = parcelRequire("1bxDW");



var $3vC7t = parcelRequire("3vC7t");
var $089ff2866ffa338a$exports = {};
'use strict';

$089ff2866ffa338a$exports = (parcelRequire("3EQio"));




var $4E6oY = parcelRequire("4E6oY");

var $1bxDW = parcelRequire("1bxDW");




var $4E6oY = parcelRequire("4E6oY");
function $0e1ffa1ef15bdeb2$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $010bff5be43944bd$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $0e1ffa1ef15bdeb2$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $1bxDW = parcelRequire("1bxDW");



var $e736e5dad298f90b$exports = {};
'use strict';
var $beb8d9759ee68034$exports = {};
'use strict';
Object.defineProperty($beb8d9759ee68034$exports, "__esModule", {
    value: true
});
$beb8d9759ee68034$exports.Collapse = undefined;
var $beb8d9759ee68034$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $beb8d9759ee68034$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1bxDW = parcelRequire("1bxDW");
var $beb8d9759ee68034$var$_react2 = $beb8d9759ee68034$var$_interopRequireDefault($1bxDW);

var $7dzZ9 = parcelRequire("7dzZ9");
var $beb8d9759ee68034$var$_propTypes2 = $beb8d9759ee68034$var$_interopRequireDefault($7dzZ9);

function $beb8d9759ee68034$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $beb8d9759ee68034$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $beb8d9759ee68034$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $beb8d9759ee68034$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $beb8d9759ee68034$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $beb8d9759ee68034$var$SPRING_PRECISION = 1;
var $beb8d9759ee68034$var$WAITING = 'WAITING';
var $beb8d9759ee68034$var$RESIZING = 'RESIZING';
var $beb8d9759ee68034$var$RESTING = 'RESTING';
var $beb8d9759ee68034$var$IDLING = 'IDLING';
var $beb8d9759ee68034$var$noop = function noop() {
    return null;
};
var $beb8d9759ee68034$var$css = {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
};
var $beb8d9759ee68034$var$Collapse = $beb8d9759ee68034$exports.Collapse = function(_React$PureComponent) {
    $beb8d9759ee68034$var$_inherits(Collapse, _React$PureComponent);
    function Collapse(props) {
        $beb8d9759ee68034$var$_classCallCheck(this, Collapse);
        var _this = $beb8d9759ee68034$var$_possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
        $beb8d9759ee68034$var$_initialiseProps.call(_this);
        _this.state = {
            currentState: $beb8d9759ee68034$var$IDLING,
            from: 0,
            to: 0
        };
        return _this;
    }
    $beb8d9759ee68034$var$_createClass(Collapse, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, isOpened = _props.isOpened, forceInitialAnimation = _props.forceInitialAnimation, onRest = _props.onRest;
                if (isOpened) {
                    var to = this.getTo();
                    if (forceInitialAnimation) {
                        var from = this.wrapper.clientHeight;
                        this.setState({
                            currentState: $beb8d9759ee68034$var$RESIZING,
                            from: from,
                            to: to
                        });
                    } else this.setState({
                        currentState: $beb8d9759ee68034$var$IDLING,
                        from: to,
                        to: to
                    });
                }
                onRest();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.hasNestedCollapse) // For nested collapses we do not need to change to waiting state
                // and should keep `height:auto`
                // Because children will be animated and height will not jump anyway
                // See https://github.com/nkbt/react-collapse/issues/76 for more details
                {
                    if (nextProps.isOpened !== this.props.isOpened) // Still go to WAITING state if own isOpened was changed
                    this.setState({
                        currentState: $beb8d9759ee68034$var$WAITING
                    });
                } else if (this.state.currentState === $beb8d9759ee68034$var$IDLING && (nextProps.isOpened || this.props.isOpened)) this.setState({
                    currentState: $beb8d9759ee68034$var$WAITING
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(_, prevState) {
                var _props2 = this.props, isOpened = _props2.isOpened, onRest = _props2.onRest, onMeasure = _props2.onMeasure;
                if (this.state.currentState === $beb8d9759ee68034$var$IDLING) {
                    onRest();
                    return;
                }
                if (prevState.to !== this.state.to) onMeasure({
                    height: this.state.to,
                    width: this.content.clientWidth
                });
                var from = this.wrapper.clientHeight;
                var to = isOpened ? this.getTo() : 0;
                if (from !== to) {
                    this.setState({
                        currentState: $beb8d9759ee68034$var$RESIZING,
                        from: from,
                        to: to
                    });
                    return;
                }
                if (this.state.currentState === $beb8d9759ee68034$var$RESTING || this.state.currentState === $beb8d9759ee68034$var$WAITING) this.setState({
                    currentState: $beb8d9759ee68034$var$IDLING,
                    from: from,
                    to: to
                });
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                cancelAnimationFrame(this.raf);
            }
        },
        {
            key: 'render',
            value: function render() {
                return $beb8d9759ee68034$var$_react2.default.createElement($28a04c32d72d17fb$export$ab7b018719e111db, $beb8d9759ee68034$var$_extends({}, this.getMotionProps(), {
                    onRest: this.onRest,
                    children: this.renderContent
                }));
            }
        }
    ]);
    return Collapse;
}($beb8d9759ee68034$var$_react2.default.PureComponent);
$beb8d9759ee68034$var$Collapse.propTypes = {
    isOpened: $beb8d9759ee68034$var$_propTypes2.default.bool.isRequired,
    springConfig: $beb8d9759ee68034$var$_propTypes2.default.objectOf($beb8d9759ee68034$var$_propTypes2.default.number),
    forceInitialAnimation: $beb8d9759ee68034$var$_propTypes2.default.bool,
    hasNestedCollapse: $beb8d9759ee68034$var$_propTypes2.default.bool,
    fixedHeight: $beb8d9759ee68034$var$_propTypes2.default.number,
    theme: $beb8d9759ee68034$var$_propTypes2.default.objectOf($beb8d9759ee68034$var$_propTypes2.default.string),
    style: $beb8d9759ee68034$var$_propTypes2.default.object,
    onRender: $beb8d9759ee68034$var$_propTypes2.default.func,
    onRest: $beb8d9759ee68034$var$_propTypes2.default.func,
    onMeasure: $beb8d9759ee68034$var$_propTypes2.default.func,
    children: $beb8d9759ee68034$var$_propTypes2.default.node.isRequired
};
$beb8d9759ee68034$var$Collapse.defaultProps = {
    forceInitialAnimation: false,
    hasNestedCollapse: false,
    fixedHeight: -1,
    style: {},
    theme: $beb8d9759ee68034$var$css,
    onRender: $beb8d9759ee68034$var$noop,
    onRest: $beb8d9759ee68034$var$noop,
    onMeasure: $beb8d9759ee68034$var$noop
};
var $beb8d9759ee68034$var$_initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.onContentRef = function(content) {
        _this2.content = content;
    };
    this.onWrapperRef = function(wrapper) {
        _this2.wrapper = wrapper;
    };
    this.onRest = function() {
        _this2.raf = requestAnimationFrame(_this2.setResting);
    };
    this.setResting = function() {
        _this2.setState({
            currentState: $beb8d9759ee68034$var$RESTING
        });
    };
    this.getTo = function() {
        var fixedHeight = _this2.props.fixedHeight;
        return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
    };
    this.getWrapperStyle = function(height) {
        if (_this2.state.currentState === $beb8d9759ee68034$var$IDLING && _this2.state.to) {
            var fixedHeight = _this2.props.fixedHeight;
            if (fixedHeight > -1) return {
                overflow: 'hidden',
                height: fixedHeight
            };
            return {
                height: 'auto'
            };
        }
        if (_this2.state.currentState === $beb8d9759ee68034$var$WAITING && !_this2.state.to) return {
            overflow: 'hidden',
            height: 0
        };
        return {
            overflow: 'hidden',
            height: Math.max(0, height)
        };
    };
    this.getMotionProps = function() {
        var springConfig = _this2.props.springConfig;
        return _this2.state.currentState === $beb8d9759ee68034$var$IDLING ? {
            // When completely stable, instantly jump to the position
            defaultStyle: {
                height: _this2.state.to
            },
            style: {
                height: _this2.state.to
            }
        } : {
            // Otherwise, animate
            defaultStyle: {
                height: _this2.state.from
            },
            style: {
                height: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(_this2.state.to, $beb8d9759ee68034$var$_extends({
                    precision: $beb8d9759ee68034$var$SPRING_PRECISION
                }, springConfig))
            }
        };
    };
    this.renderContent = function(_ref) {
        var height = _ref.height;
        // eslint-disable-line
        var _props3 = _this2.props, _isOpened = _props3.isOpened, _springConfig = _props3.springConfig, _forceInitialAnimation = _props3.forceInitialAnimation, _hasNestedCollapse = _props3.hasNestedCollapse, _fixedHeight = _props3.fixedHeight, theme = _props3.theme, style = _props3.style, onRender = _props3.onRender, _onRest = _props3.onRest, _onMeasure = _props3.onMeasure, children = _props3.children, props = $beb8d9759ee68034$var$_objectWithoutProperties(_props3, [
            'isOpened',
            'springConfig',
            'forceInitialAnimation',
            'hasNestedCollapse',
            'fixedHeight',
            'theme',
            'style',
            'onRender',
            'onRest',
            'onMeasure',
            'children'
        ]);
        var _state = _this2.state, from = _state.from, to = _state.to;
        // DANGEROUS, use with caution, never do setState with it
        onRender({
            current: height,
            from: from,
            to: to
        });
        return $beb8d9759ee68034$var$_react2.default.createElement('div', $beb8d9759ee68034$var$_extends({
            ref: _this2.onWrapperRef,
            className: theme.collapse,
            style: $beb8d9759ee68034$var$_extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
        }, props), $beb8d9759ee68034$var$_react2.default.createElement('div', {
            ref: _this2.onContentRef,
            className: theme.content
        }, children));
    };
};


var $e736e5dad298f90b$var$Collapse = $beb8d9759ee68034$exports.Collapse;
var $52633679c6301097$exports = {};
'use strict';
Object.defineProperty($52633679c6301097$exports, "__esModule", {
    value: true
});
$52633679c6301097$exports.UnmountClosed = undefined;
var $52633679c6301097$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $52633679c6301097$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $1bxDW = parcelRequire("1bxDW");
var $52633679c6301097$var$_react2 = $52633679c6301097$var$_interopRequireDefault($1bxDW);

var $7dzZ9 = parcelRequire("7dzZ9");
var $52633679c6301097$var$_propTypes2 = $52633679c6301097$var$_interopRequireDefault($7dzZ9);

function $52633679c6301097$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52633679c6301097$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $52633679c6301097$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $52633679c6301097$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $52633679c6301097$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $52633679c6301097$var$UnmountClosed = $52633679c6301097$exports.UnmountClosed = function(_React$PureComponent) {
    $52633679c6301097$var$_inherits(UnmountClosed, _React$PureComponent);
    function UnmountClosed(props) {
        $52633679c6301097$var$_classCallCheck(this, UnmountClosed);
        var _this = $52633679c6301097$var$_possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
        _this.componentWillReceiveProps = function(_ref) {
            var isOpened = _ref.isOpened;
            if (!_this.props.isOpened && isOpened) _this.setState({
                forceInitialAnimation: true,
                shouldUnmount: false
            });
        };
        _this.onRest = function() {
            var _this$props = _this.props, isOpened = _this$props.isOpened, onRest = _this$props.onRest;
            if (!isOpened) _this.setState({
                shouldUnmount: true
            });
            if (onRest) onRest.apply(undefined, arguments);
        };
        _this.state = {
            shouldUnmount: !_this.props.isOpened,
            forceInitialAnimation: !_this.props.isOpened
        };
        return _this;
    }
    $52633679c6301097$var$_createClass(UnmountClosed, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, isOpened = _props.isOpened, _onRest = _props.onRest, props = $52633679c6301097$var$_objectWithoutProperties(_props, [
                    'isOpened',
                    'onRest'
                ]);
                var _state = this.state, forceInitialAnimation = _state.forceInitialAnimation, shouldUnmount = _state.shouldUnmount;
                return shouldUnmount ? null : $52633679c6301097$var$_react2.default.createElement($beb8d9759ee68034$exports.Collapse, $52633679c6301097$var$_extends({
                    forceInitialAnimation: forceInitialAnimation,
                    isOpened: isOpened,
                    onRest: this.onRest
                }, props));
            }
        }
    ]);
    return UnmountClosed;
}($52633679c6301097$var$_react2.default.PureComponent);
$52633679c6301097$var$UnmountClosed.propTypes = {
    isOpened: $52633679c6301097$var$_propTypes2.default.bool.isRequired,
    onRest: $52633679c6301097$var$_propTypes2.default.func
};


var $e736e5dad298f90b$var$UnmountClosed = $52633679c6301097$exports.UnmountClosed;
$e736e5dad298f90b$var$UnmountClosed.Collapse = $e736e5dad298f90b$var$Collapse;
$e736e5dad298f90b$var$UnmountClosed.UnmountClosed = $e736e5dad298f90b$var$UnmountClosed;
$e736e5dad298f90b$exports = $e736e5dad298f90b$var$UnmountClosed;







var $1X5R2 = parcelRequire("1X5R2");

var $1bxDW = parcelRequire("1bxDW");




var $1X5R2 = parcelRequire("1X5R2");






var $1bxDW = parcelRequire("1bxDW");



var $9zQbc = parcelRequire("9zQbc");
var $3vC7t = parcelRequire("3vC7t");


var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");


class $86f58ea7490ddba4$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    componentDidUpdate(prevProps) {
        const { subPartDataAndHandlers: { onTableCellValueUpdate: onTableCellValueUpdate, selectedTableCellId: selectedTableCellId, inTableEditMode: inTableEditMode } } = this.props;
        const { rawCellValues: rawCellValues } = this.state;
        if (prevProps.subPartDataAndHandlers.inTableEditMode && !inTableEditMode) {
            if (rawCellValues.has(selectedTableCellId)) onTableCellValueUpdate(selectedTableCellId, rawCellValues.get(selectedTableCellId));
        }
        if (this.props.table !== prevProps.table) this.setState({
            rawCellValues: this.generateCellValueMap(this.props.table)
        });
    }
    generateCellValueMap(table) {
        return (0, $3044e0bef3624137$exports.Map)(table.get('contents').map((row)=>row.get('contents').map((cell)=>[
                    cell.get('id'),
                    cell.get('rawContents')
                ])).flatten());
    }
    handleTableSelect(tableId) {
        this.props.subPartDataAndHandlers.onTableSelect(tableId, this.props.descriptionItemIndex);
    }
    render() {
        const { table: table } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("table", {
            className: "table-part",
            onClick: ()=>this.handleTableSelect(table.get('id'))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("tbody", null, table.get('contents').map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("tr", {
                key: row.get('id')
            }, row.get('contents').map((cell)=>{
                const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('table-part__cell');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("td", {
                    className: className,
                    key: cell.get('id')
                }, cell.get('contents').size > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
                    parts: cell.get('contents'),
                    subPartDataAndHandlers: this.props.subPartDataAndHandlers
                }) : '   ');
            }))))));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTableSelect'
        ]);
        this.state = {
            rawCellValues: this.generateCellValueMap(props.table),
            shouldIgnoreBlur: false
        };
    }
}



var $1bxDW = parcelRequire("1bxDW");




var $1bxDW = parcelRequire("1bxDW");

// Interpolates between two colors.
// colorA and colorB should be objects with keys {r, g, b, a}.
// interpolationFactor should be a number between 0 and 1 representing how far from colorA to
// colorB it should interpolate.
// An object with keys {r, g, b, a} will be returned.
const $e842057b65187aa8$export$ac51ceaa2f6fb770 = (colorA, colorB, interpolationFactor)=>{
    return {
        r: parseInt((colorB.r - colorA.r) * interpolationFactor + colorA.r, 10),
        g: parseInt((colorB.g - colorA.g) * interpolationFactor + colorA.g, 10),
        b: parseInt((colorB.b - colorA.b) * interpolationFactor + colorA.b, 10),
        a: (colorB.a - colorA.a) * interpolationFactor + colorA.a
    };
};
const $e842057b65187aa8$export$e132662b5f319046 = (r, g, b, a)=>{
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
};
const $e842057b65187aa8$export$c6a9dd29cb601e01 = (rgba)=>{
    return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
};
const $e842057b65187aa8$export$188cd14c846f1fb3 = (varName)=>{
    const varValue = getComputedStyle(document.documentElement).getPropertyValue(varName);
    if (varValue.charAt(0) === '#') {
        const hexValue = varValue.substring(1, 7);
        return $e842057b65187aa8$export$e132662b5f319046(parseInt(hexValue.substring(0, 2), 16), parseInt(hexValue.substring(2, 4), 16), parseInt(hexValue.substring(4, 6), 16), 1);
    } else {
        const rgbaValues = [
            ...varValue.matchAll(/[0-9.]+/g)
        ].map((a)=>+a[0]);
        if (rgbaValues.length === 3) return $e842057b65187aa8$export$e132662b5f319046(...rgbaValues, 0);
        else if (rgbaValues.length === 4) return $e842057b65187aa8$export$e132662b5f319046(...rgbaValues);
        else return $e842057b65187aa8$export$e132662b5f319046(0, 0, 0, 0);
    }
};
const $e842057b65187aa8$var$themes = {
    Solarized: {
        /* 
      https://ethanschoonover.com/solarized/ 
    */ Light: {
            '--base3': '#fdf6e3',
            '--base2': '#eee8d5',
            '--base1': '#93a1a1',
            '--base0': '#839496',
            // highlights
            '--base00': '#657b83',
            '--base01': '#586e75',
            '--base02': '#073642',
            '--base03': '#002b36',
            // shadows
            '--base0-soft': 'rgba(131, 148, 150, 0.75)',
            // highlighted backgrounds
            '--base1-soft': 'rgba(147, 161, 161, 0.4)',
            // header colors
            '--blue': '#268bd2',
            '--green': '#859900',
            '--cyan': '#2aa198',
            '--yellow': '#b58900',
            // additional colors
            '--orange': '#cb4b16',
            '--red': '#dc322f',
            '--magenta': '#d33682',
            '--violet': '#6c71c4',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        },
        Dark: {
            // backgrounds
            '--base3': '#002b36',
            '--base2': '#073642',
            '--base1': '#586e75',
            '--base0': '#657b83',
            // highlights
            '--base03': '#fdf6e3',
            '--base02': '#eee8d5',
            '--base01': '#93a1a1',
            '--base00': '#839496',
            // shadows
            '--base0-soft': 'rgba(0, 21, 27, 0.75)',
            // highlighted backgrounds
            '--base1-soft': 'rgba(0, 21, 27, 0.4)',
            // header colors
            '--blue': '#268bd2',
            '--green': '#859900',
            '--cyan': '#2aa198',
            '--yellow': '#b58900',
            // additional colors
            '--orange': '#cb4b16',
            '--red': '#dc322f',
            '--magenta': '#6c71c4',
            '--violet': '#d33682',
            // table highlight
            '--green-soft:': 'rgba(133, 153, 0, 0.28)'
        }
    },
    Gruvbox: {
        Light: {
            /*
        see https://github.com/morhetz/gruvbox for palette
        this theme uses the 'faded' version of the color palette
      */ // background and highlights
            '--base3': '#fbf1c7',
            // bg0
            '--base2': '#d5c4a1',
            // bg2
            '--base1': '#bdae93',
            // bg3
            '--base0': '#a89984',
            // bg4
            '--base00': '#7c6f64',
            // fg4
            '--base01': '#665c54',
            // fg3
            '--base02': '#504945',
            // fg2
            '--base03': '#282828',
            // fg0
            // transparent versions
            '--base0-soft': 'rgba(168, 153, 132, 0.75)',
            '--base1-soft': 'rgba(189, 174, 147, 0.4)',
            // header colors
            '--blue': '#076678',
            '--green': '#79740e',
            '--cyan': '#427b58',
            '--yellow': '#b57614',
            // additional colors
            '--orange': '#af3a03',
            '--red': '#9d0006',
            '--magenta': '#8f3f71',
            // faded purple
            '--violet': '#b16286',
            // neutral purple
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        },
        Dark: {
            /*
        see https://github.com/morhetz/gruvbox for palette
        this theme uses the 'neutral' version of the color palette
      */ // background and highlights
            '--base3': '#282828',
            // bg0
            '--base2': '#504945',
            // bg2
            '--base1': '#665c54',
            // bg3
            '--base0': '#7c6f64',
            // bg4
            '--base00': '#a89984',
            // fg4
            '--base01': '#bdae93',
            // fg3
            '--base02': '#d5c4a1',
            // fg2
            '--base03': '#fbf1c7',
            // fg0
            // transparent versions
            '--base0-soft': 'rgba(20, 20, 20, 0.75)',
            '--base1-soft': 'rgba(20, 20, 20, 0.4)',
            // header colors
            '--blue': '#458588',
            '--green': '#98971a',
            '--cyan': '#689d6a',
            '--yellow': '#d79921',
            // additional colors
            '--orange': '#d65d0e',
            '--red': '#cc241d',
            '--magenta': '#b16286',
            // neutral purple
            '--violet': '#d3869b',
            // bright purple
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        }
    },
    One: {
        Light: {
            /*
        adaptation of atom one light theme
        https://github.com/atom/atom/tree/master/packages/one-light-ui
      */ // background and highlights
            '--base03': '#383A42',
            '--base02': '#585A5F',
            '--base01': '#79797C',
            '--base00': '#999999',
            '--base0': '#A0A1A7',
            '--base1': '#C0C0C4',
            '--base2': '#DFE0E2',
            '--base3': '#FFFFFF',
            // transparent versions
            '--base0-soft': 'rgba(160, 161, 167, 0.75)',
            '--base1-soft': 'rgba(192, 192, 196, 0.4)',
            // header colors
            '--blue': '#1492ff',
            '--green': '#2db448',
            '--cyan': '#D831B0',
            // pink
            '--yellow': '#d5880b',
            // additional colors
            '--orange': '#f42a2a',
            //red
            '--red': '#f42a2a',
            '--magenta': 'hsl(208, 100%, 56%)',
            // blue
            '--violet': '#D831B0',
            // pink
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        },
        Dark: {
            /*
        adaptation of atom one dark theme
        https://github.com/atom/atom/tree/master/packages/one-dark-ui
      */ // background and highlights
            '--base03': '#abb2bf',
            '--base02': '#9198A5',
            '--base01': '#767D8A',
            '--base00': '#5c6370',
            '--base0': '#4c5263',
            '--base1': '#404553',
            '--base2': '#343944',
            '--base3': '#282c34',
            // transparent versions
            '--base0-soft': 'rgba(20, 22, 26, 0.75)',
            '--base1-soft': 'rgba(20, 22, 26, 0.4)',
            // header colors
            '--blue': 'rgb(100, 148, 237)',
            '--green': 'rgb(115, 201, 144)',
            '--cyan': 'rgb(204, 133, 51)',
            //orange
            '--yellow': 'rgb(226, 192, 141)',
            // additional colors
            '--orange': 'rgb(255, 99, 71)',
            //red
            '--red': '#D831B0',
            //pink
            '--magenta': 'rgb(0, 136, 255)',
            //blue
            '--violet': '#d33682',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        }
    },
    Smyck: {
        /*
      see http://color.smyck.org/ for palette
    */ Light: {
            // background and highlights
            '--base3': '#F7F7F7',
            '--base2': '#DFDFDF',
            '--base1': '#C8C8C8',
            '--base0': '#B0B0B0',
            '--base00': '#5D5D5D',
            '--base01': '#3E3E3E',
            '--base02': '#1F1F1F',
            '--base03': '#000000',
            // transparent versions
            '--base0-soft': 'rgba(176, 176, 176, 0.75)',
            '--base1-soft': 'rgba(200, 200, 200, 0.4)',
            // header colors
            '--blue': '#72B3CC',
            '--green': '#8EB33B',
            '--cyan': '#218693',
            '--yellow': '#D0B03C',
            // additional colors
            '--orange': '#C75646',
            '--red': '#E09690',
            '--magenta': '#77DFD8',
            '--violet': '#FBB1F9',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        },
        Dark: {
            // background and highlights
            '--base3': '#000000',
            '--base2': '#1F1F1F',
            '--base1': '#3E3E3E',
            '--base0': '#5D5D5D',
            '--base00': '#B0B0B0',
            '--base01': '#C8C8C8',
            '--base02': '#DFDFDF',
            '--base03': '#F7F7F7',
            // transparent versions
            '--base0-soft': 'rgba(31, 31, 31, 0.75)',
            '--base1-soft': 'rgba(31, 31, 31, 0.4)',
            // header colors
            '--blue': '#72B3CC',
            '--green': '#8EB33B',
            '--cyan': '#218693',
            '--yellow': '#D0B03C',
            // additional colors
            '--orange': '#C75646',
            '--red': '#E09690',
            '--magenta': '#77DFD8',
            '--violet': '#FBB1F9',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        }
    },
    Code: {
        Light: {
            /*
        a rough approximation of Light+ (default light theme of VS Code)
        https://github.com/microsoft/vscode/blob/master/extensions/theme-defaults/themes/dark_plus.json
      */ // backgrounds
            '--base3': '#FFFFFF',
            '--base2': '#DBDBDB',
            '--base1': '#B6B6B6',
            '--base0': '#929292',
            // highlights
            '--base00': '#6D6D6D',
            '--base01': '#494949',
            '--base02': '#242424',
            '--base03': '#000000',
            // shadows
            '--base0-soft': 'rgba(146, 146, 146, 0.75)',
            // highlighted backgrounds
            '--base1-soft': 'rgba(172, 172, 172, 0.4)',
            // header colors
            '--blue': '#0000ff',
            '--green': '#098658',
            '--cyan': '#267f99',
            '--yellow': '#795e26',
            // additional colors
            '--orange': '#ee0000',
            '--red': '#a31515',
            '--magenta': '#0070c1',
            '--violet': '#811f3f',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        },
        Dark: {
            /*
        a rough approximation of Dark+ (default dark theme of VS Code)
        https://github.com/microsoft/vscode/blob/master/extensions/theme-defaults/themes/dark_plus.json
      */ // backgrounds
            '--base3': '#1E1E1E',
            '--base2': '#2C2C32',
            '--base1': '#303036',
            '--base0': '#34343a',
            // highlights
            '--base00': '#C8C8C8',
            '--base01': '#cccccc',
            '--base02': '#D0D0D0',
            '--base03': '#D4D4D4',
            // shadows
            '--base0-soft': 'rgba(15, 15, 15, 0.75)',
            // highlighted backgrounds
            '--base1-soft': 'rgba(15, 15, 15, 0.4)',
            // header colors
            '--blue': 'rgb(79,193,255)',
            '--green': 'rgb(106, 153, 85)',
            '--cyan': '#ce9178',
            // orange (cyan is #4EC9B0)
            '--yellow': '#d7ba7d',
            // additional colors
            '--orange': '#d16969',
            // red
            '--red': '#d16969',
            '--magenta': '#569cd6',
            // light blue
            '--violet': '#C586C0',
            // table highlight
            '--green-soft': 'rgba(133, 153, 0, 0.28)'
        }
    }
};
const $e842057b65187aa8$export$a1d87755f3c9500d = (theme = 'Solarized', colorScheme = 'Light')=>{
    if (colorScheme === 'OS') {
        const osPreference = window.matchMedia('(prefers-color-scheme: dark)');
        if ('matches' in osPreference) colorScheme = osPreference.matches ? 'Dark' : 'Light';
        else colorScheme = 'Light';
    }
    const themeColors = $e842057b65187aa8$var$themes[theme][colorScheme];
    const style = document.documentElement.style;
    Object.entries(themeColors).forEach(([k, v])=>style.setProperty(k, v));
    // Cache resolved CSS variables so the inline script in index.html can
    // apply them before CSS loads on the next cold start (eliminates flash).
    try {
        localStorage.setItem('themeVariables', JSON.stringify(themeColors));
    } catch (_e) {
    // localStorage may be unavailable; ignore.
    }
    // set theme color on android
    document.querySelector('meta[name="theme-color"]').setAttribute('content', $e842057b65187aa8$var$themes[theme]['--base3']);
};



var $6bd4d2555b91416e$export$2e2bcd8739ae039 = ({ state: state, onClick: onClick })=>{
    const uncheckedColor = (0, $e842057b65187aa8$export$e132662b5f319046)(255, 255, 255, 1);
    const checkedColor = (0, $e842057b65187aa8$export$e132662b5f319046)(238, 232, 213, 1);
    const checkboxStyle = {
        colorFactor: (0, $28a04c32d72d17fb$export$b36281d89752ae66)({
            checked: 1,
            partial: 1,
            unchecked: 0
        }[state], {
            stiffness: 300
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
        style: checkboxStyle
    }, (style)=>{
        const backgroundColor = (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(uncheckedColor, checkedColor, style.colorFactor));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "checkbox",
            onClick: onClick,
            style: {
                backgroundColor: backgroundColor
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "checkbox__inner-container"
        }, state === 'checked' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-check"
        }), state === 'partial' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-minus"
        }), state === 'unchecked' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-square"
        })));
    });
};



var $1bxDW = parcelRequire("1bxDW");

var $def02ec529fb64d3$export$2e2bcd8739ae039 = ({ subPartDataAndHandlers: { onEnterListTitleEditMode: onEnterListTitleEditMode, onEnterListContentsEditMode: onEnterListContentsEditMode, onAddNewListItem: onAddNewListItem, onRemoveListItem: onRemoveListItem } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer__row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer__edit-icon-container",
        onClick: onEnterListTitleEditMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-pencil-alt fa-lg",
        title: "Edit list item title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
        className: "list-action-drawer__separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer__edit-icon-container",
        onClick: onEnterListContentsEditMode,
        title: "Edit list item contents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-edit fa-lg"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
        className: "list-action-drawer__separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer__edit-icon-container",
        onClick: onAddNewListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-plus fa-lg",
        "data-testid": "list-item-action-plus",
        title: "Create list item below"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
        className: "list-action-drawer__separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "list-action-drawer__edit-icon-container",
        onClick: onRemoveListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-times fa-lg",
        title: "Delete list item"
    }))));
};






var $1X5R2 = parcelRequire("1X5R2");


class $d5b76bc403c60098$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    componentDidUpdate(prevProps) {
        const { subPartDataAndHandlers: { onListTitleValueUpdate: onListTitleValueUpdate, onListContentsValueUpdate: onListContentsValueUpdate, inListTitleEditMode: inListTitleEditMode, inListContentsEditMode: inListContentsEditMode, selectedListItemId: selectedListItemId } } = this.props;
        const { listTitleValues: listTitleValues, listContentsValues: listContentsValues } = this.state;
        if (prevProps.subPartDataAndHandlers.inListTitleEditMode && !inListTitleEditMode) {
            if (listTitleValues.has(selectedListItemId)) onListTitleValueUpdate(selectedListItemId, listTitleValues.get(selectedListItemId));
        }
        const prevSelectedListItemId = prevProps.subPartDataAndHandlers.selectedListItemId;
        if (prevSelectedListItemId !== selectedListItemId && inListTitleEditMode && prevProps.subPartDataAndHandlers.inListTitleEditMode) {
            if (listTitleValues.has(prevSelectedListItemId) && (0, $2ce140c2c56df8f2$export$6fe4e048ddeb0b7e)(this.props.part, prevSelectedListItemId)) onListTitleValueUpdate(prevSelectedListItemId, listTitleValues.get(prevSelectedListItemId));
        }
        if (prevProps.subPartDataAndHandlers.inListContentsEditMode && !inListContentsEditMode) {
            if (listContentsValues.has(selectedListItemId)) onListContentsValueUpdate(selectedListItemId, listContentsValues.get(selectedListItemId));
        }
        if (prevSelectedListItemId !== selectedListItemId && inListContentsEditMode && prevProps.subPartDataAndHandlers.inListContentsEditMode) {
            if (listContentsValues.has(prevSelectedListItemId) && (0, $2ce140c2c56df8f2$export$6fe4e048ddeb0b7e)(this.props.part, prevSelectedListItemId)) onListContentsValueUpdate(prevSelectedListItemId, listContentsValues.get(prevSelectedListItemId));
        }
        if (this.props.part !== prevProps.part) {
            this.setState({
                listTitleValues: this.generateListTitleValueMap(this.props.part)
            });
            this.setState({
                listContentsValues: this.generateListContentsValueMap(this.props.part)
            });
        }
    }
    generateListTitleValueMap(part) {
        return (0, $3044e0bef3624137$exports.Map)(part.get('items').map((item)=>[
                item.get('id'),
                (0, $500d38b948046618$export$2c44f25459bb5dc7)(item.get('titleLine'))
            ]));
    }
    generateListContentsValueMap(part) {
        return (0, $3044e0bef3624137$exports.Map)(part.get('items').map((item)=>[
                item.get('id'),
                (0, $500d38b948046618$export$2c44f25459bb5dc7)(item.get('contents'))
            ]));
    }
    handleListItemSelect(itemId) {
        return ()=>this.props.subPartDataAndHandlers.onListItemSelect(itemId);
    }
    handleCheckboxClick(e, itemId) {
        // Ticking a checkbox should only tick the checkbox, not enable
        // the list item manipulating functions from
        // `handleListItemSelect`.
        // Relevant discussion:
        // https://github.com/200ok-ch/organice/discussions/950
        e.stopPropagation();
        return this.props.subPartDataAndHandlers.onCheckboxClick(itemId);
    }
    handleTextareaBlur() {
        setTimeout(()=>{
            if (!this.state.shouldIgnoreBlur) this.props.subPartDataAndHandlers.onExitListTitleEditMode();
            else this.setState({
                shouldIgnoreBlur: false
            });
        }, 0);
    }
    handleListTitleChange(event) {
        const { listTitleValues: listTitleValues } = this.state;
        const { subPartDataAndHandlers: { selectedListItemId: selectedListItemId } } = this.props;
        this.setState({
            listTitleValues: listTitleValues.set(selectedListItemId, event.target.value)
        });
    }
    handleListContentsChange(event) {
        const { listContentsValues: listContentsValues } = this.state;
        const { subPartDataAndHandlers: { selectedListItemId: selectedListItemId } } = this.props;
        this.setState({
            listContentsValues: listContentsValues.set(selectedListItemId, event.target.value)
        });
    }
    handleInsertTimestampListTitle() {
        // Clicking this button will unfocus the textarea, but we don't want to exit edit mode,
        // so instruct the blur handler to ignore the event.
        this.setState({
            shouldIgnoreBlur: true
        });
        const { listTitleValues: listTitleValues } = this.state;
        const { subPartDataAndHandlers: { selectedListItemId: selectedListItemId } } = this.props;
        const listTitleValue = listTitleValues.get(selectedListItemId);
        const insertionIndex = this.textarea.selectionStart;
        this.setState({
            listTitleValues: listTitleValues.set(selectedListItemId, listTitleValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + listTitleValue.substring(this.textarea.selectionEnd || insertionIndex))
        });
        this.textarea.focus();
    }
    handleInsertTimestampListContents() {
        this.setState({
            shouldIgnoreBlur: true
        });
        const { listContentsValues: listContentsValues } = this.state;
        const { subPartDataAndHandlers: { selectedListItemId: selectedListItemId } } = this.props;
        const listContentsValue = listContentsValues.get(selectedListItemId);
        const insertionIndex = this.textarea.selectionStart;
        this.setState({
            listContentsValues: listContentsValues.set(selectedListItemId, listContentsValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + listContentsValue.substring(this.textarea.selectionEnd || insertionIndex))
        });
        this.textarea.focus();
    }
    handleTextareaRef(textarea) {
        this.textarea = textarea;
    }
    renderContent() {
        const { part: part, subPartDataAndHandlers: { selectedListItemId: selectedListItemId, inListTitleEditMode: inListTitleEditMode, inListContentsEditMode: inListContentsEditMode, shouldDisableActions: shouldDisableActions } } = this.props;
        const { listTitleValues: listTitleValues, listContentsValues: listContentsValues } = this.state;
        return part.get('items').map((item)=>{
            const isItemSelected = item.get('id') === selectedListItemId;
            const lineContainerClass = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))({
                'list-part__not_checkbox-container': !item.get('isCheckbox'),
                'list-part__checkbox-container': item.get('isCheckbox'),
                'list-part__item--selected': isItemSelected
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", {
                key: item.get('id'),
                value: item.get('forceNumber')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: lineContainerClass,
                onClick: this.handleListItemSelect(item.get('id'))
            }, item.get('isCheckbox') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6bd4d2555b91416e$export$2e2bcd8739ae039), {
                onClick: (e)=>this.handleCheckboxClick(e, item.get('id')),
                state: item.get('checkboxState')
            }), isItemSelected && inListTitleEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "list-title-line__edit-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
                autoFocus: true,
                className: "textarea",
                "data-testid": "list-item-edit",
                rows: "3",
                ref: this.handleTextareaRef,
                value: listTitleValues.get(item.get('id')),
                onBlur: this.handleTextareaBlur,
                onChange: this.handleListTitleChange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "list-title-line__insert-timestamp-button",
                onClick: this.handleInsertTimestampListTitle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: "fas fa-plus insert-timestamp-icon"
            }), "Insert timestamp")) : listTitleValues.get(item.get('id')) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
                parts: item.get('titleLine'),
                subPartDataAndHandlers: this.props.subPartDataAndHandlers
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", null, "\xa0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
                isOpened: isItemSelected && !shouldDisableActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $def02ec529fb64d3$export$2e2bcd8739ae039), {
                subPartDataAndHandlers: this.props.subPartDataAndHandlers
            })), isItemSelected && inListContentsEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "list-contents__edit-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
                autoFocus: true,
                className: "textarea",
                rows: "8",
                ref: this.handleTextareaRef,
                value: listContentsValues.get(item.get('id')),
                onBlur: this.handleTextareaBlur,
                onChange: this.handleListContentsChange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "list-contents__insert-timestamp-button",
                onClick: this.handleInsertTimestampListContents
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                className: "fas fa-plus insert-timestamp-icon"
            }), "Insert timestamp")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
                parts: item.get('contents'),
                subPartDataAndHandlers: this.props.subPartDataAndHandlers
            }));
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, this.props.part.get('isOrdered') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ol", {
            className: "attributed-string__list-part attributed-string__list-part--ordered"
        }, this.renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ul", {
            className: "attributed-string__list-part"
        }, this.renderContent()));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleListItemSelect',
            'handleCheckboxClick',
            'handleTextareaBlur',
            'handleListTitleChange',
            'handleListContentsChange',
            'handleInsertTimestampListTitle',
            'handleInsertTimestampListContents',
            'handleTextareaRef'
        ]);
        this.state = {
            listTitleValues: this.generateListTitleValueMap(props.part),
            listContentsValues: this.generateListContentsValueMap(props.part),
            shouldIgnoreBlur: false
        };
    }
}



var $1bxDW = parcelRequire("1bxDW");


var $e118c199172b5c10$export$2e2bcd8739ae039 = ({ part: part, subPartDataAndHandlers: { onTimestampClick: onTimestampClick, shouldDisableActions: shouldDisableActions } })=>{
    const handleClick = ()=>shouldDisableActions ? void 0 : onTimestampClick(part.get('id'));
    const firstTimestamp = part.get('firstTimestamp');
    const secondTimestamp = part.get('secondTimestamp');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
        className: "attributed-string__timestamp-part",
        onClick: handleClick
    }, !!firstTimestamp && (0, $e706118dde20dbed$export$96c990e4d9eca709)(firstTimestamp), !!secondTimestamp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, '--', (0, $e706118dde20dbed$export$96c990e4d9eca709)(secondTimestamp)));
};






const $04ec35a24831438f$var$AttributedString = ({ org: org, parts: parts, subPartDataAndHandlers: subPartDataAndHandlers })=>{
    let className;
    let location = (0, $3vC7t.useLocation)();
    const renderLink = (part)=>{
        const id = part.get('id');
        const uri = part.getIn([
            'contents',
            'uri'
        ]);
        const title = part.getIn([
            'contents',
            'title'
        ]) || uri;
        let target = uri;
        if (uri.startsWith('file:')) {
            target = uri.substr(5);
            const isRelativeFileLink = !target.startsWith('/') && !target.startsWith('~');
            if (isRelativeFileLink) {
                // N.B. Later on we may improve this conditional by performing
                // an existence check on the backend if it allows that
                // operation.
                target = normalisePath(target);
                if (!target.includes('/../')) // Normalisation succeeded, so we can safely return a <Link>
                {
                    if (!uri.match((0, $2ce140c2c56df8f2$export$cb89f492e03ac783))) {
                        // Optimistically assume that the link is pointing to a
                        // directory.
                        target = target.replace(/^\/file\//, '/files/');
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
                            key: id,
                            to: target
                        }, title);
                    }
                }
            }
            target = target.replace(/^\/file\//, '/');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
                key: id,
                style: {
                    textDecoration: 'underline'
                },
                "data-target": target,
                onClick: ()=>org.setPath(target)
            }, title);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
            key: id,
            href: target
        }, title);
    };
    const normalisePath = (target)=>{
        let dir = location.pathname.match(/(.*)\//)[1];
        let normalised = target;
        while(normalised.startsWith('../')){
            if (!dir.match(/^\/file\/.+/)) // We're already at the top; can't break out of the area accessible
            // via HTTP, so just the original non-normalised path
            return target;
            normalised = normalised.substr(3);
            dir = dir.match(/(.*)\//)[1];
        }
        return dir + '/' + normalised;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", null, parts.map((part, index)=>{
        switch(part.get('type')){
            case 'text':
                return part.get('contents');
            case 'link':
                return renderLink(part);
            case 'percentage-cookie':
                className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('attributed-string__cookie-part', {
                    'attributed-string__cookie-part--complete': parseInt(part.get('percentage'), 10) === 100
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
                    key: part.get('id'),
                    className: className
                }, "[", part.get('percentage'), "%]");
            case 'fraction-cookie':
                className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('attributed-string__cookie-part', {
                    'attributed-string__cookie-part--complete': part.getIn([
                        'fraction',
                        0
                    ]) !== '' && part.getIn([
                        'fraction',
                        0
                    ]) === part.getIn([
                        'fraction',
                        1
                    ])
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
                    key: part.get('id'),
                    className: className
                }, "[", part.getIn([
                    'fraction',
                    0
                ]), "/", part.getIn([
                    'fraction',
                    1
                ]), "]");
            case 'table':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $86f58ea7490ddba4$export$2e2bcd8739ae039), {
                    key: part.get('id'),
                    table: part,
                    descriptionItemIndex: index,
                    subPartDataAndHandlers: subPartDataAndHandlers
                });
            case 'list':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d5b76bc403c60098$export$2e2bcd8739ae039), {
                    key: part.get('id'),
                    part: part,
                    subPartDataAndHandlers: subPartDataAndHandlers
                });
            case 'inline-markup':
                className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('attributed-string__inline-markup', `attributed-string__inline-markup--${part.get('markupType')}`);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
                    key: part.get('id'),
                    className: className
                }, part.get('content'));
            case 'timestamp':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e118c199172b5c10$export$2e2bcd8739ae039), {
                    key: part.get('id'),
                    part: part,
                    subPartDataAndHandlers: subPartDataAndHandlers
                });
            case 'url':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
                    href: part.get('content'),
                    key: part.get('id')
                }, part.get('content'));
            case 'www-url':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
                    href: `https://${part.get('content')}`,
                    key: part.get('id')
                }, part.get('content'));
            case 'e-mail':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
                    href: `mailto:${part.get('content')}`,
                    key: part.get('id')
                }, part.get('content'));
            case 'phone-number':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
                    href: `tel:${part.get('content')}`,
                    key: part.get('id')
                }, part.get('content'));
            default:
                console.error(`Unrecognized attributed string part type! ${part.get('type')}`);
                return '';
        }
    }));
};
const $04ec35a24831438f$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    };
};
var $04ec35a24831438f$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)(null, $04ec35a24831438f$var$mapDispatchToProps)($04ec35a24831438f$var$AttributedString);


class $50bbde6b70a077ee$var$TitleLine extends (0, $1bxDW.PureComponent) {
    storeContainerWidth() {
        if (this.containerDiv) this.setState({
            containerWidth: this.containerDiv.offsetWidth
        });
    }
    componentDidMount() {
        this.storeContainerWidth();
    }
    componentDidUpdate(prevProps) {
        const { header: header } = this.props;
        if (prevProps.header !== header) this.setState({
            titleValue: this.calculateRawTitle(header)
        }, ()=>this.storeContainerWidth());
    }
    calculateRawTitle(header) {
        return (0, $500d38b948046618$export$907554d307802b74)(header.toJS(), false);
    }
    handleTitleClick() {
        const { header: header, hasContent: hasContent, isSelected: isSelected, onClick: onClick, closeSubheadersRecursively: closeSubheadersRecursively } = this.props;
        if (!!onClick) onClick();
        else {
            if (hasContent && (!header.get('opened') || isSelected)) this.props.org.toggleHeaderOpened(header.get('id'), closeSubheadersRecursively);
            this.props.org.selectHeader(header.get('id'));
        }
    }
    handleTodoClick(event) {
        const { header: header, shouldTapTodoToAdvance: shouldTapTodoToAdvance, setShouldLogIntoDrawer: setShouldLogIntoDrawer, onClick: onClick } = this.props;
        if (!!onClick) {
            onClick();
            event.stopPropagation();
        } else {
            this.props.org.selectHeader(header.get('id'));
            if (shouldTapTodoToAdvance) this.props.org.advanceTodoState(null, setShouldLogIntoDrawer);
        }
    }
    handleTitleFieldClick(event) {
        event.stopPropagation();
    }
    handleTimestampClick(timestampId) {
        this.props.base.activatePopup('timestamp-editor', {
            headerId: this.props.header.get('id'),
            timestampId: timestampId
        });
    }
    render() {
        const { header: header, color: color, hasContent: hasContent, shouldDisableActions: shouldDisableActions, shouldDisableExplicitWidth: shouldDisableExplicitWidth, todoKeywordSets: todoKeywordSets, addition: addition, showDeadlineDisplay: showDeadlineDisplay, headerDeadlineMap: headerDeadlineMap, deadlineString: deadlineString, isOverdue: isOverdue } = this.props;
        const { containerWidth: containerWidth } = this.state;
        const isTodoKeywordInDoneState = (0, $2ce140c2c56df8f2$export$f6a5d435cb1f7b7f)(todoKeywordSets);
        const todoKeyword = header.getIn([
            'titleLine',
            'todoKeyword'
        ]);
        const titleStyle = {
            color: color,
            wordBreak: 'break-word'
        };
        const additionStyle = {
            color: color,
            minWidth: '5em',
            textAlign: 'right',
            marginRight: '2em',
            whiteSpace: 'nowrap'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "title-line",
            onClick: this.handleTitleClick,
            style: {
                width: shouldDisableExplicitWidth ? '' : containerWidth
            }
        }, !!todoKeyword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            // INFO: Instead of `todoKeyword.toLowerCase()` it would
            // be best to render todo-keyword--done if the keyword is
            // the last of a keywordSet. Then it would get rendered
            // with the appropriate color, no matter what the keyword
            // is.
            // Relevant issue: https://github.com/200ok-ch/organice/issues/16
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('todo-keyword', isTodoKeywordInDoneState(todoKeyword) ? 'todo-keyword--done-state' : null),
            onClick: this.handleTodoClick
        }, todoKeyword) : '', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            style: {
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "title-line-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            style: titleStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
            parts: header.getIn([
                'titleLine',
                'title'
            ]),
            subPartDataAndHandlers: {
                onTimestampClick: this.handleTimestampClick,
                shouldDisableActions: shouldDisableActions
            }
        }), !header.get('opened') && hasContent ? '...' : ''), addition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            style: additionStyle
        }, addition) : null, showDeadlineDisplay && headerDeadlineMap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('header-deadline', {
                'header-deadline--overdue': isOverdue
            })
        }, addition ? ' ' : '', deadlineString)), header.getIn([
            'titleLine',
            'tags'
        ]).size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, header.getIn([
            'titleLine',
            'tags'
        ]).toSet().toList().filter((tag)=>!!tag).map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "header-tag",
                key: tag
            }, tag)))));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTitleClick',
            'handleTodoClick',
            'handleTimestampClick'
        ]);
        this.state = {
            titleValue: this.calculateRawTitle(props.header),
            containerWidth: null,
            shouldIgnoreBlur: false
        };
    }
}
const $50bbde6b70a077ee$var$mapStateToProps = (state, ownProps)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ]);
    const selectedHeaderId = !!file ? file.get('selectedHeaderId') : null;
    return {
        setShouldLogIntoDrawer: state.base.get('shouldLogIntoDrawer'),
        shouldTapTodoToAdvance: state.base.get('shouldTapTodoToAdvance'),
        closeSubheadersRecursively: state.base.get('closeSubheadersRecursively'),
        isSelected: selectedHeaderId === ownProps.header.get('id'),
        todoKeywordSets: !!file ? file.get('todoKeywordSets') : null
    };
};
const $50bbde6b70a077ee$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $50bbde6b70a077ee$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($50bbde6b70a077ee$var$mapStateToProps, $50bbde6b70a077ee$var$mapDispatchToProps)($50bbde6b70a077ee$var$TitleLine);



var $1bxDW = parcelRequire("1bxDW");




var $1bxDW = parcelRequire("1bxDW");




var $1X5R2 = parcelRequire("1X5R2");
class $40f09f0c5363c6c9$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleTimestampClick(planningType, planningItemIndex) {
        return ()=>this.props.onClick(planningType, planningItemIndex);
    }
    render() {
        const { planningItems: planningItems } = this.props;
        const planningItemsToRender = planningItems.filter((x)=>(0, $2ce140c2c56df8f2$export$dd50aa628860b07d)(x));
        if (planningItemsToRender.isEmpty()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, planningItemsToRender.map((planningItem, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                key: planningItem.get('id'),
                className: "planning-items__item-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "planning-item__type"
            }, planningItem.get('type'), ": "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "planning-item__timestamp",
                onClick: this.handleTimestampClick(planningItem.get('type'), index)
            }, (0, $e706118dde20dbed$export$96c990e4d9eca709)(planningItem.get('timestamp'))))));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTimestampClick'
        ]);
    }
}



var $1bxDW = parcelRequire("1bxDW");


var $7586b731f4b9aeff$export$2e2bcd8739ae039 = ({ propertyListItems: propertyListItems, shouldDisableActions: shouldDisableActions, onTimestampClick: onTimestampClick, onEdit: onEdit })=>{
    const [isDrawerCollapsed, setIsDrawerCollapsed] = (0, $1bxDW.useState)(true);
    const handleCollapseToggle = ()=>setIsDrawerCollapsed(!isDrawerCollapsed);
    return propertyListItems.size === 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "property-list-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "property-list__property",
        onClick: handleCollapseToggle,
        "data-testid": "property-list-properties-toggle"
    }, ":PROPERTIES:", isDrawerCollapsed ? '...' : ''), !isDrawerCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, propertyListItems.map((propertyListItem, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "property-list__item-container",
            key: propertyListItem.get('id')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "property-list__property",
            onClick: shouldDisableActions ? null : onEdit,
            "data-testid": `property-list-item-property-${index}`
        }, ":", propertyListItem.get('property'), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "property-list__value",
            "data-testid": `property-list-item-value-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
            parts: propertyListItem.get('value') || [],
            subPartDataAndHandlers: {
                onTimestampClick: onTimestampClick,
                shouldDisableActions: shouldDisableActions
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "property-list__property",
        onClick: onEdit,
        "data-testid": "property-list-end"
    }, ":END:")));
};



var $1bxDW = parcelRequire("1bxDW");


var $74b251dad26a3e6b$export$2e2bcd8739ae039 = ({ logBookEntries: logBookEntries, onTimestampClick: onTimestampClick, shouldDisableActions: shouldDisableActions })=>{
    const [isDrawerCollapsed, setIsDrawerCollapsed] = (0, $1bxDW.useState)(true);
    const handleCollapseToggle = ()=>setIsDrawerCollapsed(!isDrawerCollapsed);
    const onClick = (entryIndex, type)=>()=>shouldDisableActions ? void 0 : onTimestampClick(entryIndex, type);
    return logBookEntries.size === 0 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "logbook-entries-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "logbook-entries__logbook",
        onClick: handleCollapseToggle
    }, ":LOGBOOK:", isDrawerCollapsed ? '...' : ''), !isDrawerCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, logBookEntries.map((entry, index)=>entry.get('raw') !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "logbook-entries__item-container",
            key: entry.get('id')
        }, entry.get('raw') || ' ') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "logbook-entries__item-container",
            key: entry.get('id')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "logbook-entries__item-clock"
        }, "CLOCK:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "logbook-entries__item-start",
            onClick: onClick(index, 'start')
        }, (0, $e706118dde20dbed$export$96c990e4d9eca709)(entry.get('start'))), entry.get('end') === null ? '' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, "--", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "logbook-entries__item-end",
            onClick: onClick(index, 'end')
        }, (0, $e706118dde20dbed$export$96c990e4d9eca709)(entry.get('end'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "logbook-entries__item-duration"
        }, '=>', " ", (0, $e706118dde20dbed$export$bd27f0b37191265b)(entry.get('start'), entry.get('end')))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "logbook-entries__logbook"
    }, ":END:")));
};



var $1X5R2 = parcelRequire("1X5R2");





class $6c6f167d8bb75d5e$var$HeaderContent extends (0, $1bxDW.PureComponent) {
    storeContainerWidth() {
        if (this.containerDiv) this.setState({
            containerWidth: this.containerDiv.offsetWidth
        });
    }
    componentDidMount() {
        this.storeContainerWidth();
    }
    componentDidUpdate(prevProps) {
        const { header: header } = this.props;
        if (prevProps.header !== header) this.setState({
            descriptionValue: this.calculateRawDescription(header)
        }, ()=>this.storeContainerWidth());
    }
    calculateRawDescription(header) {
        // This generates the text that appears in the description text field.
        const dontIndent = this.props.dontIndent;
        return (0, $500d38b948046618$export$5f409df9aafd0448)(header, false, dontIndent);
    }
    handleTableSelect(tableId, descriptionItemIndex) {
        this.props.org.selectHeader(this.props.header.get('id'));
        this.props.org.selectHeaderIndex(this.props.headerIndex);
        this.props.org.setSelectedDescriptionItemIndex(descriptionItemIndex);
        this.props.org.setSelectedTableId(tableId);
        this.props.base.activatePopup('table-editor');
    }
    handleCheckboxClick(listItemId) {
        this.props.org.advanceCheckboxState(listItemId);
    }
    handleListItemSelect(listItemId) {
        this.props.org.setSelectedListItemId(listItemId);
    }
    handleEnterListTitleEditMode() {
        this.props.org.enterEditMode('list-title');
    }
    handleExitListTitleEditMode() {
        this.props.org.exitEditMode();
    }
    handleListTitleValueUpdate(listItemId, newValue) {
        this.props.org.updateListTitleValue(listItemId, newValue);
    }
    handleEnterListContentsEditMode() {
        this.props.org.enterEditMode('list-contents');
    }
    handleExitListContentsEditMode() {
        this.props.org.exitEditMode();
    }
    handleListContentsValueUpdate(listItemId, newValue) {
        this.props.org.updateListContentsValue(listItemId, newValue);
    }
    handleAddNewListItem() {
        this.props.org.addNewListItemAndEdit();
    }
    handleRemoveListItem() {
        this.props.org.removeListItem();
    }
    handleTimestampClick(timestampId) {
        this.props.base.activatePopup('timestamp-editor', {
            timestampId: timestampId,
            headerId: this.props.header.get('id')
        });
    }
    handleLogEntryTimestampClick(headerId) {
        return (logEntryIndex, entryType)=>this.props.base.activatePopup('timestamp-editor', {
                headerId: headerId,
                logEntryIndex: logEntryIndex,
                entryType: entryType
            });
    }
    handleInsertTimestamp() {
        // Clicking this button will unfocus the textarea, but we don't want to exit edit mode,
        // so instruct the blur handler to ignore the event.
        this.setState({
            shouldIgnoreBlur: true
        });
        const { descriptionValue: descriptionValue } = this.state;
        const insertionIndex = this.textarea.selectionStart;
        this.setState({
            descriptionValue: descriptionValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + descriptionValue.substring(this.textarea.selectionEnd || insertionIndex)
        });
        this.textarea.focus();
    }
    handlePlanningItemTimestampClick(headerId) {
        return (planningType, planningItemIndex)=>{
            const popupType = {
                DEADLINE: 'deadline-editor',
                SCHEDULED: 'scheduled-editor'
            }[planningType] || 'timestamp-editor';
            this.props.base.activatePopup(popupType, {
                headerId: headerId,
                planningItemIndex: planningItemIndex
            });
        };
    }
    handlePropertyListEdit() {
        const { header: header } = this.props;
        this.props.base.activatePopup('property-list-editor', {
            headerId: header.get('id')
        });
    }
    render() {
        const { header: header, shouldDisableActions: shouldDisableActions, selectedListItemId: selectedListItemId, inListTitleEditMode: inListTitleEditMode, inListContentsEditMode: inListContentsEditMode } = this.props;
        const { containerWidth: containerWidth } = this.state;
        if (!header.get('opened')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-content-container nice-scroll",
            style: {
                width: containerWidth
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $40f09f0c5363c6c9$export$2e2bcd8739ae039), {
            planningItems: header.get('planningItems'),
            onClick: this.handlePlanningItemTimestampClick(header.get('id'))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $7586b731f4b9aeff$export$2e2bcd8739ae039), {
            propertyListItems: header.get('propertyListItems'),
            onTimestampClick: this.handleTimestampClick,
            shouldDisableActions: shouldDisableActions,
            onEdit: this.handlePropertyListEdit
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
            parts: header.get('logNotes'),
            subPartDataAndHandlers: {
                onTimestampClick: this.handleTimestampClick,
                shouldDisableActions: shouldDisableActions
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $74b251dad26a3e6b$export$2e2bcd8739ae039), {
            logBookEntries: header.get('logBookEntries'),
            onTimestampClick: this.handleLogEntryTimestampClick(header.get('id')),
            shouldDisableActions: shouldDisableActions
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
            parts: header.get('description'),
            subPartDataAndHandlers: {
                onTableSelect: shouldDisableActions ? undefined : this.handleTableSelect,
                onCheckboxClick: this.handleCheckboxClick,
                onListItemSelect: this.handleListItemSelect,
                onEnterListTitleEditMode: this.handleEnterListTitleEditMode,
                onExitListTitleEditMode: this.handleExitListTitleEditMode,
                onListTitleValueUpdate: this.handleListTitleValueUpdate,
                onEnterListContentsEditMode: this.handleEnterListContentsEditMode,
                onExitListContentsEditMode: this.handleExitListContentsEditMode,
                onListContentsValueUpdate: this.handleListContentsValueUpdate,
                onAddNewListItem: this.handleAddNewListItem,
                onRemoveListItem: this.handleRemoveListItem,
                selectedListItemId: selectedListItemId,
                inListTitleEditMode: inListTitleEditMode,
                inListContentsEditMode: inListContentsEditMode,
                onTimestampClick: this.handleTimestampClick,
                shouldDisableActions: shouldDisableActions
            }
        })));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTableSelect',
            'handleCheckboxClick',
            'handleListItemSelect',
            'handleEnterListTitleEditMode',
            'handleExitListTitleEditMode',
            'handleListTitleValueUpdate',
            'handleEnterListContentsEditMode',
            'handleExitListContentsEditMode',
            'handleListContentsValueUpdate',
            'handleAddNewListItem',
            'handleRemoveListItem',
            'handleTimestampClick',
            'handleLogEntryTimestampClick',
            'handleInsertTimestamp',
            'handlePlanningItemTimestampClick',
            'handlePropertyListEdit'
        ]);
        this.state = {
            descriptionValue: this.calculateRawDescription(props.header),
            containerWidth: null,
            shouldIgnoreBlur: false
        };
    }
}
const $6c6f167d8bb75d5e$var$mapStateToProps = (state, ownProps)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ]);
    const selectedHeaderId = !!file ? file.get('selectedHeaderId') : null;
    const editMode = !!file ? file.get('editMode') : null;
    return {
        isSelected: selectedHeaderId === ownProps.header.get('id'),
        dontIndent: state.base.get('shouldNotIndentOnExport'),
        selectedListItemId: !!file ? file.get('selectedListItemId') : null,
        inListTitleEditMode: editMode === 'list-title',
        inListContentsEditMode: editMode === 'list-contents'
    };
};
const $6c6f167d8bb75d5e$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $6c6f167d8bb75d5e$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($6c6f167d8bb75d5e$var$mapStateToProps, $6c6f167d8bb75d5e$var$mapDispatchToProps)($6c6f167d8bb75d5e$var$HeaderContent);



var $1bxDW = parcelRequire("1bxDW");

class $764ed7f3d7d08afb$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    // A nasty hack required to get click handling to work properly in Firefox. No idea why its
    // broken in the first place or why this fixes it.
    iconWithFFClickCatcher({ className: className, onClick: onClick, onLongPress: onLongPress, title: title, testId: testId = '' }) {
        const handleMouseDown = onLongPress ? (e)=>{
            this.isLongPressing = false;
            // Store reference to the target element to avoid React event pooling issues
            const targetElement = e.currentTarget;
            // Add visual feedback class immediately for better UX
            targetElement.classList.add('header-action-drawer__long-press-feedback');
            this.longPressTimer = setTimeout(()=>{
                this.isLongPressing = true;
                onLongPress(e);
                // Add success feedback class
                targetElement.classList.add('header-action-drawer__long-press-success');
            }, 600);
        } : undefined;
        const handleMouseUp = onLongPress ? (e)=>{
            if (this.longPressTimer) {
                clearTimeout(this.longPressTimer);
                this.longPressTimer = null;
            }
            // Remove visual feedback classes
            e.currentTarget.classList.remove('header-action-drawer__long-press-feedback');
            e.currentTarget.classList.remove('header-action-drawer__long-press-success');
        } : undefined;
        const handleMouseLeave = onLongPress ? (e)=>{
            if (this.longPressTimer) {
                clearTimeout(this.longPressTimer);
                this.longPressTimer = null;
            }
            // Remove visual feedback classes
            e.currentTarget.classList.remove('header-action-drawer__long-press-feedback');
            e.currentTarget.classList.remove('header-action-drawer__long-press-success');
        } : undefined;
        const handleClick = onClick ? (e)=>{
            // Only trigger regular click if it wasn't a long press
            if (!this.isLongPressing) onClick(e);
            this.isLongPressing = false;
        } : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            title: title,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            onMouseLeave: handleMouseLeave,
            onTouchStart: handleMouseDown,
            onTouchEnd: handleMouseUp,
            onTouchCancel: handleMouseLeave,
            className: "header-action-drawer__ff-click-catcher-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer__ff-click-catcher"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: className,
            "data-testid": testId
        }));
    }
    render() {
        const { onTitleClick: onTitleClick, onDescriptionClick: onDescriptionClick, onTagsClick: onTagsClick, onPropertiesClick: onPropertiesClick, isNarrowed: isNarrowed, onNarrow: onNarrow, onWiden: onWiden, onAddNewHeader: onAddNewHeader, onDeadlineClick: onDeadlineClick, onClockInOutClick: onClockInOutClick, onScheduledClick: onScheduledClick, hasActiveClock: hasActiveClock, onShareHeader: onShareHeader, onRefileHeader: onRefileHeader, onAddNote: onAddNote, onDuplicateHeader: onDuplicateHeader } = this.props;
        // Create a fallback function for onDuplicateHeader if not provided
        const handleDuplicateHeader = onDuplicateHeader || ((e)=>{
            // As a fallback, just call the regular add new header function
            if (onAddNewHeader) onAddNewHeader(e);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer-container",
            "data-testid": "header-action-drawer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer__row"
        }, this.iconWithFFClickCatcher({
            className: 'fas fa-pencil-alt fa-lg',
            onClick: onTitleClick,
            title: 'Edit header title',
            testId: 'drawer-action-edit-title'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-edit fa-lg',
            onClick: onDescriptionClick,
            title: 'Edit header description',
            testId: 'edit-header-title'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-tags fa-lg',
            onClick: onTagsClick,
            title: 'Modify tags',
            testId: 'drawer-action-tags'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-list fa-lg',
            onClick: onPropertiesClick,
            title: 'Modify properties',
            testId: 'drawer-action-properties'
        }), isNarrowed ? this.iconWithFFClickCatcher({
            className: 'fas fa-expand fa-lg',
            onClick: onWiden,
            title: 'Widen (Cancelling the narrowing.)'
        }) : this.iconWithFFClickCatcher({
            className: 'fas fa-compress fa-lg',
            onClick: onNarrow,
            testId: 'header-action-narrow',
            title: 'Narrow to subtree (focusing in on some portion of the buffer, making the rest temporarily inaccessible.)'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-plus fa-lg',
            onClick: onAddNewHeader,
            onLongPress: handleDuplicateHeader,
            testId: 'header-action-plus',
            title: 'Create new header below (long-press to duplicate current header)'
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer__row"
        }, this.iconWithFFClickCatcher({
            className: 'fas fa-share fa-lg',
            onClick: onShareHeader,
            testId: 'share',
            title: 'Share this header via email'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-calendar-check fa-lg',
            onClick: onDeadlineClick,
            testId: 'drawer-action-deadline',
            title: 'Set deadline datetime'
        }), this.iconWithFFClickCatcher({
            className: 'far fa-calendar-check fa-lg',
            onClick: onScheduledClick,
            testId: 'drawer-action-scheduled',
            title: 'Set scheduled datetime'
        }), hasActiveClock ? this.iconWithFFClickCatcher({
            className: 'fas fa-hourglass-end fa-lg',
            onClick: onClockInOutClick,
            testId: 'org-clock-out',
            title: 'Clock out (Stop the clock)'
        }) : this.iconWithFFClickCatcher({
            className: 'fas fa-hourglass-start fa-lg',
            onClick: onClockInOutClick,
            testId: 'org-clock-in',
            title: 'Clock in (Start the clock)'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-file-export fa-lg',
            onClick: onRefileHeader,
            testId: 'org-refile',
            title: 'Refile this header to another header'
        }), this.iconWithFFClickCatcher({
            className: 'far fa-sticky-note fa-lg',
            onClick: onAddNote,
            title: 'Add a note'
        })));
    }
    constructor(props){
        super(props);
        this.longPressTimer = null;
        this.isLongPressing = false;
    }
}






/**
 * Check if Web Share API is available
 * @returns {boolean} True if Web Share API is supported
 */ const $0db2d36de3ccad6e$export$c37129e465f64ef0 = ()=>{
    return navigator.share && typeof navigator.share === 'function';
};
const $0db2d36de3ccad6e$export$430c79cbb9440ff2 = async (options)=>{
    const { title: title, text: text, url: url, files: files } = options;
    if ($0db2d36de3ccad6e$export$c37129e465f64ef0()) try {
        const shareData = {};
        if (title) shareData.title = title;
        if (text) shareData.text = text;
        if (url) shareData.url = url;
        if (files) shareData.files = files;
        await navigator.share(shareData);
        return {
            success: true,
            method: 'web-share'
        };
    } catch (error) {
        if (error.name === 'AbortError') return {
            success: false,
            method: 'web-share',
            error: 'user-cancelled'
        };
    // Fall through to fallback
    }
    // Fallback to email
    return $0db2d36de3ccad6e$var$fallbackToEmail(options);
};
/**
 * Fallback to email sharing
 * @param {Object} options - Share options
 * @param {string} options.title - Title for the email subject
 * @param {string} options.text - Text content for the email body
 * @returns {Object} Result object
 */ const $0db2d36de3ccad6e$var$fallbackToEmail = ({ title: title, text: text })=>{
    const subject = title || 'Shared from organice';
    const body = text || '';
    const mailtoURI = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoURI);
    return {
        success: true,
        method: 'email'
    };
};
const $0db2d36de3ccad6e$export$e9a7bae78b887537 = (content, filename, mimeType = 'text/plain')=>{
    const blob = new Blob([
        content
    ], {
        type: mimeType
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};



class $38f508047dd35bec$var$Header extends (0, $1bxDW.PureComponent) {
    handleDragStartFromPending(dragX, targetElement) {
        this.handleDragStart(targetElement, dragX);
    }
    addGlobalDragHandlers() {
        // Begin listening for global mouse/touch events after dragging begins
        window.addEventListener('mousemove', this.globalMouseMoveHandler);
        window.addEventListener('mouseup', this.globalMouseUpHandler);
        window.addEventListener('touchmove', this.globalTouchMoveHandler);
        window.addEventListener('touchend', this.globalTouchEndHandler);
    }
    removeGlobalDragHandlers() {
        // Stop listening for global mouse/touch events after dragging ends
        window.removeEventListener('mousemove', this.globalMouseMoveHandler);
        window.removeEventListener('mouseup', this.globalMouseUpHandler);
        window.removeEventListener('touchmove', this.globalTouchMoveHandler);
        window.removeEventListener('touchend', this.globalTouchEndHandler);
    }
    componentDidMount() {
        if (this.containerDiv) this.setState({
            containerWidth: this.containerDiv.offsetWidth
        });
    }
    componentWillUnmount() {
        this.removeGlobalDragHandlers();
    }
    handleRef(containerDiv) {
        this.containerDiv = containerDiv;
        this.props.onRef(containerDiv);
    }
    handleDragStart(targetElement, dragX) {
        if (this.props.shouldDisableActions) return;
        if (!!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest('.table-part'))) return;
        this.setState({
            dragStartX: dragX
        });
    }
    handleDragMove(dragX) {
        if (this.state.dragStartX === null) return;
        if (!this.state.isDraggingFreely) {
            if (Math.abs(dragX - this.state.dragStartX) >= this.FREE_DRAG_ACTIVATION_DISTANCE) this.setState({
                isDraggingFreely: true
            });
        }
        this.setState({
            currentDragX: dragX
        });
    }
    handleDragEnd() {
        const { dragStartX: dragStartX, currentDragX: currentDragX } = this.state;
        if (!!dragStartX && !!currentDragX) {
            if (currentDragX >= 2 * dragStartX) this.props.org.advanceTodoState(this.props.header.get('id'), this.props.shouldLogIntoDrawer);
            if (dragStartX >= 2 * currentDragX) this.setState({
                isPlayingRemoveAnimation: true,
                heightBeforeRemove: this.containerDiv.offsetHeight
            });
        }
        this.setState({
            dragStartX: null,
            currentDragX: null,
            isDraggingFreely: false
        });
        this.removeGlobalDragHandlers();
    }
    handleDragCancel() {
        this.setState({
            dragStartX: null,
            currentDragX: null,
            isDraggingFreely: false
        });
        this.removeGlobalDragHandlers();
    }
    handleMouseDown(event) {
        this.pendingPointerStart = {
            x: event.clientX,
            y: event.clientY,
            target: event.target
        };
        this.props.onLongPressPointerStart(this.props.header.get('id'), event.clientX, event.clientY);
        this.addGlobalDragHandlers();
    }
    handleMouseMove(event) {
        if (this.props.isLongPressDragging) {
            this.pendingPointerStart = null;
            return;
        }
        if (this.pendingPointerStart && this.state.dragStartX === null) {
            this.handleDragStartFromPending(this.pendingPointerStart.x, this.pendingPointerStart.target);
            this.pendingPointerStart = null;
        }
        this.handleDragMove(event.clientX, event.clientY);
    }
    handleMouseUp() {
        this.pendingPointerStart = null;
        this.props.onLongPressPointerEnd();
        this.handleDragEnd();
    }
    handleTouchStart(event) {
        const touch = event.changedTouches[0];
        this.pendingPointerStart = {
            x: touch.clientX,
            y: touch.clientY,
            target: event.target
        };
        this.props.onLongPressPointerStart(this.props.header.get('id'), touch.clientX, touch.clientY);
        this.addGlobalDragHandlers();
        this.setState({
            touchStartY: touch.clientY
        });
    }
    handleTouchMove(event) {
        const touch = event.changedTouches[0];
        const currentY = touch.clientY;
        const currentX = touch.clientX;
        if (this.props.isLongPressDragging) {
            this.pendingPointerStart = null;
            return;
        }
        if (this.pendingPointerStart && this.state.dragStartX === null) {
            const verticalDistance = Math.abs(currentY - this.pendingPointerStart.y);
            const horizontalDistance = Math.abs(currentX - this.pendingPointerStart.x);
            if (verticalDistance > horizontalDistance && verticalDistance > 10) {
                this.pendingPointerStart = null;
                return;
            }
            if (horizontalDistance < 5) return;
            this.handleDragStartFromPending(this.pendingPointerStart.x, this.pendingPointerStart.target);
            this.pendingPointerStart = null;
        }
        // Detect if this is primarily a vertical scroll gesture
        // If the user is moving more vertically than horizontally, we should
        // cancel the horizontal drag to allow normal page scrolling
        if (this.state.touchStartY !== null && this.state.dragStartX !== null) {
            const verticalDistance = Math.abs(currentY - this.state.touchStartY);
            const horizontalDistance = Math.abs(currentX - this.state.dragStartX);
            // If vertical movement is significantly greater than horizontal movement,
            // cancel the drag operation to allow normal page scrolling
            // The threshold of 10px ensures small movements don't trigger cancellation
            if (verticalDistance > horizontalDistance && verticalDistance > 10) {
                this.handleDragCancel();
                return;
            }
        }
        this.handleDragMove(currentX, currentY);
    }
    handleTouchEnd() {
        this.pendingPointerStart = null;
        this.props.onLongPressPointerEnd();
        this.setState({
            touchStartY: null
        });
        this.handleDragEnd();
    }
    handleTouchCancel() {
        this.pendingPointerStart = null;
        this.props.onLongPressPointerEnd();
        this.setState({
            touchStartY: null
        });
        this.handleDragCancel();
    }
    handleHeaderClick(event) {
        const classList = event.target.classList;
        if (classList.contains('header') || classList.contains('header__bullet')) {
            const { header: header, hasContent: hasContent, isSelected: isSelected, closeSubheadersRecursively: closeSubheadersRecursively } = this.props;
            if (hasContent && (!header.get('opened') || isSelected)) this.props.org.toggleHeaderOpened(header.get('id'), closeSubheadersRecursively);
            this.props.org.selectHeader(header.get('id'));
        }
    }
    handleShowTitleModal() {
        this.props.base.activatePopup('title-editor');
    }
    handleShowDescriptionModal() {
        this.props.base.activatePopup('description-editor');
    }
    handleShowTagsModal() {
        this.props.base.activatePopup('tags-editor');
    }
    handleShowPropertyListEditorModal() {
        this.props.base.activatePopup('property-list-editor');
    }
    handleNarrow() {
        this.props.org.narrowHeader(this.props.header.get('id'));
    }
    handleWiden() {
        this.props.org.widenHeader();
    }
    handleAddNewHeader() {
        this.props.org.addHeaderAndEdit(this.props.header.get('id'));
    }
    handleDuplicateHeader() {
        this.props.org.duplicateHeader(this.props.header.get('id'));
    }
    handleRest() {
        if (this.state.isPlayingRemoveAnimation) this.props.org.removeHeader(this.props.header.get('id'));
    }
    handleDeadlineAndScheduledClick(planningType) {
        const { header: header } = this.props;
        const popupType = {
            DEADLINE: 'deadline-editor',
            SCHEDULED: 'scheduled-editor'
        }[planningType];
        const existingDeadlinePlanningItemIndex = header.get('planningItems', []).findIndex((planningItem)=>planningItem.get('type') === planningType);
        this.props.base.activatePopup(popupType, {
            headerId: header.get('id'),
            planningItemIndex: existingDeadlinePlanningItemIndex
        });
        this.props.org.openHeader(header.get('id'));
    }
    handleDeadlineClick() {
        this.handleDeadlineAndScheduledClick('DEADLINE');
    }
    handleClockInOutClick() {
        const { header: header } = this.props;
        const logBook = header.get('logBookEntries', []);
        const existingClockIndex = logBook.findIndex((entry)=>entry.get('end') === null);
        const now = (0, $e706118dde20dbed$export$69ac1778977ccd3b)({
            isActive: false,
            withStartTime: true
        });
        if (existingClockIndex !== -1) this.props.org.setLogEntryStop(header.get('id'), logBook.getIn([
            existingClockIndex,
            'id'
        ]), now);
        else this.props.org.createLogEntryStart(header.get('id'), now);
    }
    handleScheduledClick() {
        this.handleDeadlineAndScheduledClick('SCHEDULED');
    }
    handleShareHeaderClick() {
        const { header: header, headers: headers } = this.props;
        const titleLine = header.get('titleLine');
        const todoKeyword = titleLine.get('todoKeyword');
        const title = titleLine.get('rawTitle').trim();
        const fullTitle = todoKeyword ? `${todoKeyword} ${title}` : title;
        // Export header with all sub-headers
        const content = (0, $500d38b948046618$export$3f9d8b89a1ac10e0)(header, headers, {
            includeSubheaders: true,
            recursive: true,
            includeTitle: true,
            dontIndent: false
        });
        // Use Web Share API with fallback to email
        (0, $0db2d36de3ccad6e$export$430c79cbb9440ff2)({
            title: fullTitle,
            text: content
        });
    }
    handleAddNoteClick() {
        this.props.base.activatePopup('note-editor');
    }
    handlePopupClose() {
        this.props.base.closePopup();
    }
    handleRefileHeaderRequest() {
        this.props.base.activatePopup('refile');
    }
    render() {
        const { header: header, headerIndex: headerIndex, color: color, hasContent: hasContent, isSelected: isSelected, bulletStyle: bulletStyle, narrowedHeader: narrowedHeader, isNarrowed: isNarrowed, shouldDisableActions: shouldDisableActions, showClockDisplay: showClockDisplay, showDeadlineDisplay: showDeadlineDisplay } = this.props;
        const indentLevel = !!narrowedHeader ? header.get('nestingLevel') - narrowedHeader.get('nestingLevel') + 1 : header.get('nestingLevel');
        const headerDeadlineMap = header.get('planningItems').filter((p)=>p.get('type') === 'DEADLINE').map((p)=>p.get('timestamp')).get(0);
        let isOverdue = false;
        let deadlineString = '';
        if (showDeadlineDisplay && headerDeadlineMap) {
            const year = headerDeadlineMap.get('year');
            const month = headerDeadlineMap.get('month');
            const day = headerDeadlineMap.get('day');
            // Ensure parts are parsed as integers for Date constructor
            const deadlineDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Normalize today to midnight for date-only comparison
            isOverdue = deadlineDate < today;
            deadlineString = `${year}-${month}-${day}`;
        }
        const clockDisplayString = showClockDisplay && header.get('totalTimeLoggedRecursive') !== 0 ? (0, $e706118dde20dbed$export$4251c173c1ee6069)(header.get('totalTimeLoggedRecursive')) : '';
        const { dragStartX: dragStartX, currentDragX: currentDragX, isDraggingFreely: isDraggingFreely, isPlayingRemoveAnimation: isPlayingRemoveAnimation, containerWidth: containerWidth } = this.state;
        const marginLeft = !!dragStartX && !!currentDragX && isDraggingFreely ? currentDragX - dragStartX : isPlayingRemoveAnimation ? (0, $28a04c32d72d17fb$export$b36281d89752ae66)(-1 * containerWidth, {
            stiffness: 300
        }) : (0, $28a04c32d72d17fb$export$b36281d89752ae66)(0, {
            stiffness: 300
        });
        const style = {
            paddingLeft: 20 * indentLevel,
            marginLeft: marginLeft,
            heightFactor: isPlayingRemoveAnimation ? (0, $28a04c32d72d17fb$export$b36281d89752ae66)(0, {
                stiffness: 300
            }) : 1
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('header', {
            'header--selected': isSelected,
            'header--removing': isPlayingRemoveAnimation,
            'header--long-press-dragging': this.props.isDraggedForReorder,
            'header--reorder-drop-before': this.props.isReorderDropTarget && this.props.reorderDropPosition === 'before',
            'header--reorder-drop-after': this.props.isReorderDropTarget && this.props.reorderDropPosition === 'after'
        });
        const logBookEntries = header.get('logBookEntries').filter((entry)=>entry.get('raw') === undefined);
        const hasActiveClock = logBookEntries.size !== 0 && logBookEntries.filter((entry)=>!entry.get('end')).size !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
            style: style,
            onRest: this.handleRest
        }, (interpolatedStyle)=>{
            const swipedDistance = interpolatedStyle.marginLeft;
            const isLeftActionActivated = swipedDistance >= this.SWIPE_ACTION_ACTIVATION_DISTANCE;
            const isRightActionActivated = -1 * swipedDistance >= this.SWIPE_ACTION_ACTIVATION_DISTANCE;
            const leftActivatedBackgroundColor = (0, $e842057b65187aa8$export$e132662b5f319046)(0, 128, 0, 1);
            const rightActivatedBackgroundColor = (0, $e842057b65187aa8$export$e132662b5f319046)(255, 0, 0, 1);
            const disabledIconColor = (0, $e842057b65187aa8$export$e132662b5f319046)(0, 0, 0, 1);
            const activatedIconColor = (0, $e842057b65187aa8$export$e132662b5f319046)(255, 255, 255, 1);
            const leftSwipeActionContainerStyle = {
                width: interpolatedStyle.marginLeft,
                backgroundColorFactor: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isLeftActionActivated ? 1 : 0, {
                    stiffness: 300
                })
            };
            const rightSwipeActionContainerStyle = {
                width: -1 * interpolatedStyle.marginLeft,
                backgroundColorFactor: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isRightActionActivated ? 1 : 0, {
                    stiffness: 300
                })
            };
            const { heightFactor: heightFactor } = interpolatedStyle, headerStyle = (0, $010bff5be43944bd$export$71511d61b312f219)(interpolatedStyle, [
                "heightFactor"
            ]);
            if (isPlayingRemoveAnimation) headerStyle.height = this.state.heightBeforeRemove * heightFactor;
            if (this.props.isDraggedForReorder) {
                headerStyle.transform = `translateY(${this.props.reorderDragOffsetY}px)`;
                headerStyle.zIndex = 10;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: className,
                style: headerStyle,
                ref: this.handleRef,
                "data-header-id": header.get('id'),
                onClick: this.handleHeaderClick,
                onMouseDown: this.handleMouseDown,
                onTouchStart: this.handleTouchStart,
                onTouchCancel: this.handleTouchCancel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
                style: leftSwipeActionContainerStyle
            }, (leftInterpolatedStyle)=>{
                const leftStyle = {
                    width: leftInterpolatedStyle.width,
                    backgroundColor: (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(this.state.disabledBackgroundColor, leftActivatedBackgroundColor, leftInterpolatedStyle.backgroundColorFactor))
                };
                const leftIconStyle = {
                    display: swipedDistance > 30 ? '' : 'none',
                    color: (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(disabledIconColor, activatedIconColor, leftInterpolatedStyle.backgroundColorFactor))
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                    className: "left-swipe-action-container",
                    style: leftStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                    className: "fas fa-check swipe-action-container__icon swipe-action-container__icon--left",
                    style: leftIconStyle
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
                style: rightSwipeActionContainerStyle
            }, (rightInterpolatedStyle)=>{
                const rightStyle = {
                    width: rightInterpolatedStyle.width,
                    backgroundColor: (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(this.state.disabledBackgroundColor, rightActivatedBackgroundColor, rightInterpolatedStyle.backgroundColorFactor))
                };
                const rightIconStyle = {
                    display: -1 * swipedDistance > 30 ? '' : 'none',
                    color: (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(disabledIconColor, activatedIconColor, rightInterpolatedStyle.backgroundColorFactor))
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                    className: "right-swipe-action-container",
                    style: rightStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                    className: "fas fa-times swipe-action-container__icon swipe-action-container__icon--right",
                    style: rightIconStyle
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                style: {
                    marginLeft: -16,
                    color: color
                },
                className: "header__bullet"
            }, bulletStyle === 'Fancy' ? "\u25CF" : '*'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $50bbde6b70a077ee$export$2e2bcd8739ae039), {
                header: header,
                color: color,
                hasContent: hasContent,
                isSelected: isSelected,
                shouldDisableExplicitWidth: swipedDistance === 0,
                shouldDisableActions: shouldDisableActions,
                addition: clockDisplayString,
                showDeadlineDisplay: showDeadlineDisplay,
                headerDeadlineMap: headerDeadlineMap,
                deadlineString: deadlineString,
                isOverdue: isOverdue
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
                isOpened: isSelected && !shouldDisableActions,
                springConfig: {
                    stiffness: 300
                },
                style: {
                    marginRight: rightSwipeActionContainerStyle.width
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $764ed7f3d7d08afb$export$2e2bcd8739ae039), {
                onTitleClick: this.handleShowTitleModal,
                onDescriptionClick: this.handleShowDescriptionModal,
                isNarrowed: isNarrowed,
                onTagsClick: this.handleShowTagsModal,
                onPropertiesClick: this.handleShowPropertyListEditorModal,
                onNarrow: this.handleNarrow,
                onWiden: this.handleWiden,
                onAddNewHeader: this.handleAddNewHeader,
                onDeadlineClick: this.handleDeadlineClick,
                onClockInOutClick: this.handleClockInOutClick,
                onScheduledClick: this.handleScheduledClick,
                hasActiveClock: hasActiveClock,
                onShareHeader: this.handleShareHeaderClick,
                onRefileHeader: this.handleRefileHeaderRequest,
                onAddNote: this.handleAddNoteClick,
                onDuplicateHeader: this.handleDuplicateHeader
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6c6f167d8bb75d5e$export$2e2bcd8739ae039), {
                header: header,
                headerIndex: headerIndex,
                shouldDisableActions: shouldDisableActions
            }));
        });
    }
    constructor(props){
        super(props), (0, $4E6oY._)(this, "SWIPE_ACTION_ACTIVATION_DISTANCE", 80), (0, $4E6oY._)(this, "FREE_DRAG_ACTIVATION_DISTANCE", 10);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleRef',
            'handleMouseDown',
            'handleTouchStart',
            'handleTouchCancel',
            'handleHeaderClick',
            'handleShowTitleModal',
            'handleShowDescriptionModal',
            'handleShowTagsModal',
            'handleShowPropertyListEditorModal',
            'handleNarrow',
            'handleWiden',
            'handleAddNewHeader',
            'handleRest',
            'handleDeadlineClick',
            'handleClockInOutClick',
            'handleScheduledClick',
            'handleShareHeaderClick',
            'handleRefileHeaderRequest',
            'handleAddNoteClick',
            'handleDuplicateHeader',
            'handleDragStartFromPending'
        ]);
        this.state = {
            isDraggingFreely: false,
            dragStartX: null,
            currentDragX: null,
            containerWidth: null,
            isPlayingRemoveAnimation: false,
            heightBeforeRemove: null,
            disabledBackgroundColor: (0, $e842057b65187aa8$export$188cd14c846f1fb3)('--base3'),
            // Track vertical touch positions to detect vertical scrolling intent
            touchStartY: null
        };
        // Store member callbacks handling global mouse/touch events to be able to handle dragging
        // interactions outside of the current component.
        this.globalMouseMoveHandler = this.handleMouseMove.bind(this);
        this.globalMouseUpHandler = this.handleMouseUp.bind(this);
        this.globalTouchMoveHandler = this.handleTouchMove.bind(this);
        this.globalTouchEndHandler = this.handleTouchEnd.bind(this);
        this.pendingPointerStart = null;
    }
}
const $38f508047dd35bec$var$mapStateToProps = (state, ownProps)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const narrowedHeader = !!file.get('narrowedHeaderId') ? (0, $2ce140c2c56df8f2$export$afc3b74231ba89f6)(file.get('headers'), file.get('narrowedHeaderId')) : null;
    return {
        bulletStyle: state.base.get('bulletStyle'),
        shouldLogIntoDrawer: state.base.get('shouldLogIntoDrawer'),
        closeSubheadersRecursively: state.base.get('closeSubheadersRecursively'),
        narrowedHeader: narrowedHeader,
        isNarrowed: !!narrowedHeader && narrowedHeader.get('id') === ownProps.header.get('id'),
        showClockDisplay: state.org.present.get('showClockDisplay'),
        showDeadlineDisplay: state.base.get('showDeadlineDisplay'),
        headers: file.get('headers')
    };
};
const $38f508047dd35bec$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    });
var $38f508047dd35bec$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($38f508047dd35bec$var$mapStateToProps, $38f508047dd35bec$var$mapDispatchToProps)($38f508047dd35bec$var$Header);





var $1X5R2 = parcelRequire("1X5R2");


class $ec95309c06423ebf$var$HeaderList extends (0, $1bxDW.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.selectedHeaderId !== this.props.selectedHeaderId) {
            const selectedHeaderDiv = this.headerRefs[this.props.selectedHeaderId];
            if (!!selectedHeaderDiv) {
                const boundingRectangle = selectedHeaderDiv.getBoundingClientRect();
                const viewportHeight = document.documentElement.clientHeight;
                if (boundingRectangle.top > viewportHeight * 0.9 || boundingRectangle.bottom < 0) selectedHeaderDiv.scrollIntoView();
            }
        }
    }
    componentWillUnmount() {
        this.stopLongPressCandidate();
        this.stopAutoScrollLoop();
        this.pointerX = null;
        this.pointerY = null;
        this.removeWindowListeners();
    }
    addWindowListeners() {
        window.addEventListener('mousemove', this.handleWindowPointerMove);
        window.addEventListener('mouseup', this.handleWindowPointerEnd);
        window.addEventListener('touchmove', this.handleWindowPointerMove, {
            passive: false
        });
        window.addEventListener('touchend', this.handleWindowPointerEnd);
        window.addEventListener('touchcancel', this.handleWindowPointerEnd);
        document.addEventListener('mousemove', this.handleWindowPointerMove);
        document.addEventListener('mouseup', this.handleWindowPointerEnd);
        document.addEventListener('touchmove', this.handleWindowPointerMove, {
            passive: false
        });
        document.addEventListener('touchend', this.handleWindowPointerEnd);
        document.addEventListener('touchcancel', this.handleWindowPointerEnd);
    }
    removeWindowListeners() {
        window.removeEventListener('mousemove', this.handleWindowPointerMove);
        window.removeEventListener('mouseup', this.handleWindowPointerEnd);
        window.removeEventListener('touchmove', this.handleWindowPointerMove);
        window.removeEventListener('touchend', this.handleWindowPointerEnd);
        window.removeEventListener('touchcancel', this.handleWindowPointerEnd);
        document.removeEventListener('mousemove', this.handleWindowPointerMove);
        document.removeEventListener('mouseup', this.handleWindowPointerEnd);
        document.removeEventListener('touchmove', this.handleWindowPointerMove);
        document.removeEventListener('touchend', this.handleWindowPointerEnd);
        document.removeEventListener('touchcancel', this.handleWindowPointerEnd);
    }
    pointerCoordinatesFromEvent(event) {
        if (event.changedTouches && event.changedTouches[0]) return {
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        };
        if (event.touches && event.touches[0]) return {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY
        };
        if (typeof event.clientX === 'number' && typeof event.clientY === 'number') return {
            x: event.clientX,
            y: event.clientY
        };
        return null;
    }
    headerIdFromDatasetValue(datasetHeaderId) {
        const matchingHeader = this.props.headers.find((header)=>String(header.get('id')) === String(datasetHeaderId));
        return matchingHeader ? matchingHeader.get('id') : null;
    }
    nestingLevelOfHeaderId(headerId) {
        const matchingHeader = this.props.headers.find((header)=>header.get('id') === headerId);
        return matchingHeader ? matchingHeader.get('nestingLevel') : null;
    }
    dropTargetFromPointer(pointerX, pointerY, draggingHeaderId) {
        var _document_elementFromPoint;
        const draggingNestingLevel = this.nestingLevelOfHeaderId(draggingHeaderId);
        const headerElements = Array.from(document.querySelectorAll('.header[data-header-id]'));
        const candidateElements = headerElements.filter((headerElement)=>{
            const candidateHeaderId = this.headerIdFromDatasetValue(headerElement.dataset.headerId);
            return candidateHeaderId !== draggingHeaderId && this.nestingLevelOfHeaderId(candidateHeaderId) === draggingNestingLevel;
        });
        if (candidateElements.length === 0) return {
            targetHeaderId: null,
            dropPosition: null
        };
        const directHitElement = (_document_elementFromPoint = document.elementFromPoint(pointerX, pointerY)) === null || _document_elementFromPoint === void 0 ? void 0 : _document_elementFromPoint.closest('.header[data-header-id]');
        const directHitHeaderId = this.headerIdFromDatasetValue(directHitElement === null || directHitElement === void 0 ? void 0 : directHitElement.dataset.headerId);
        const directHitNestingLevel = this.nestingLevelOfHeaderId(directHitHeaderId);
        let targetElement = directHitElement && directHitHeaderId !== draggingHeaderId && directHitNestingLevel === draggingNestingLevel ? directHitElement : null;
        if (!targetElement) targetElement = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).minBy(candidateElements, (headerElement)=>{
            const rectangle = headerElement.getBoundingClientRect();
            const centerY = rectangle.top + rectangle.height / 2;
            return Math.abs(pointerY - centerY);
        });
        if (!targetElement) return {
            targetHeaderId: null,
            dropPosition: null
        };
        const targetHeaderId = this.headerIdFromDatasetValue(targetElement.dataset.headerId);
        const rectangle = targetElement.getBoundingClientRect();
        const dropPosition = pointerY < rectangle.top + rectangle.height / 2 ? 'before' : 'after';
        return {
            targetHeaderId: targetHeaderId,
            dropPosition: dropPosition
        };
    }
    handleWindowPointerMove(event) {
        const coordinates = this.pointerCoordinatesFromEvent(event);
        if (!coordinates) return;
        const { x: x, y: y } = coordinates;
        if (this.state.draggingHeaderId) {
            if (event.cancelable) event.preventDefault();
            this.updateDragState(x, y);
            return;
        }
        if (!this.longPressCandidate) return;
        this.longPressCandidate.currentX = x;
        this.longPressCandidate.currentY = y;
        const horizontalDistance = Math.abs(this.longPressCandidate.startX - x);
        const verticalDistance = Math.abs(this.longPressCandidate.startY - y);
        if (horizontalDistance > this.LONG_PRESS_CANCEL_DISTANCE || verticalDistance > this.LONG_PRESS_CANCEL_DISTANCE) {
            this.stopLongPressCandidate();
            this.removeWindowListeners();
        }
    }
    handleWindowPointerEnd(event) {
        const coordinates = this.pointerCoordinatesFromEvent(event || {});
        if (coordinates) {
            this.pointerX = coordinates.x;
            this.pointerY = coordinates.y;
        }
        this.stopLongPressCandidate();
        if (this.state.draggingHeaderId) this.finishDrag(true);
        this.removeWindowListeners();
    }
    stopLongPressCandidate() {
        this.longPressCandidate = null;
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
            this.longPressTimer = null;
        }
    }
    startDrag() {
        if (!this.longPressCandidate) return;
        this.setState({
            draggingHeaderId: this.longPressCandidate.headerId,
            draggingStartY: this.longPressCandidate.startY,
            currentPointerY: this.longPressCandidate.currentY,
            dropTargetHeaderId: null,
            dropPosition: null
        });
        this.pointerX = this.longPressCandidate.currentX;
        this.pointerY = this.longPressCandidate.currentY;
        this.stopLongPressCandidate();
        this.loopAutoScroll();
    }
    updateDragState(pointerX, pointerY) {
        this.pointerX = pointerX;
        this.pointerY = pointerY;
        const draggedHeaderId = this.state.draggingHeaderId;
        const { targetHeaderId: targetHeaderId, dropPosition: dropPosition } = this.dropTargetFromPointer(pointerX, pointerY, draggedHeaderId);
        if (!targetHeaderId) {
            this.setState({
                currentPointerY: pointerY,
                dropTargetHeaderId: null,
                dropPosition: null
            });
            return;
        }
        this.setState({
            currentPointerY: pointerY,
            dropTargetHeaderId: targetHeaderId,
            dropPosition: dropPosition
        });
    }
    finishDrag(shouldPersist = false) {
        const { draggingHeaderId: draggingHeaderId } = this.state;
        let { dropTargetHeaderId: dropTargetHeaderId, dropPosition: dropPosition } = this.state;
        if (shouldPersist && draggingHeaderId && this.pointerX !== null && this.pointerY !== null) {
            const latestDropTarget = this.dropTargetFromPointer(this.pointerX, this.pointerY, draggingHeaderId);
            dropTargetHeaderId = latestDropTarget.targetHeaderId;
            dropPosition = latestDropTarget.dropPosition;
        }
        if (shouldPersist && draggingHeaderId && dropTargetHeaderId && dropPosition) this.props.org.moveHeaderToPosition(draggingHeaderId, dropTargetHeaderId, dropPosition);
        this.stopAutoScrollLoop();
        this.pointerX = null;
        this.pointerY = null;
        this.setState({
            draggingHeaderId: null,
            draggingStartY: null,
            currentPointerY: null,
            dropTargetHeaderId: null,
            dropPosition: null
        });
    }
    loopAutoScroll() {
        this.stopAutoScrollLoop();
        const scroll = ()=>{
            if (!this.state.draggingHeaderId || this.pointerY === null) {
                this.autoScrollAnimationFrame = null;
                return;
            }
            const appRoot = document.querySelector('.App');
            if (!appRoot) {
                this.autoScrollAnimationFrame = requestAnimationFrame(scroll);
                return;
            }
            if (this.pointerY <= this.AUTO_SCROLL_MARGIN) appRoot.scrollTop -= this.AUTO_SCROLL_SPEED;
            else if (this.pointerY >= window.innerHeight - this.AUTO_SCROLL_MARGIN) appRoot.scrollTop += this.AUTO_SCROLL_SPEED;
            if (this.pointerX !== null && this.pointerY !== null) this.updateDragState(this.pointerX, this.pointerY);
            this.autoScrollAnimationFrame = requestAnimationFrame(scroll);
        };
        this.autoScrollAnimationFrame = requestAnimationFrame(scroll);
    }
    stopAutoScrollLoop() {
        if (this.autoScrollAnimationFrame) {
            cancelAnimationFrame(this.autoScrollAnimationFrame);
            this.autoScrollAnimationFrame = null;
        }
    }
    handleHeaderLongPressStart(headerId, pointerX, pointerY) {
        if (this.props.shouldDisableActions) return;
        this.stopLongPressCandidate();
        this.addWindowListeners();
        this.longPressCandidate = {
            headerId: headerId,
            startX: pointerX,
            startY: pointerY,
            currentX: pointerX,
            currentY: pointerY
        };
        this.longPressTimer = setTimeout(this.startDrag, this.LONG_PRESS_DELAY_MS);
    }
    handleHeaderLongPressEnd() {
        this.handleWindowPointerEnd();
    }
    handleHeaderRef(headerId) {
        return (div)=>this.headerRefs[headerId] = div;
    }
    render() {
        const { headers: headers, selectedHeaderId: selectedHeaderId, narrowedHeaderId: narrowedHeaderId, shouldDisableActions: shouldDisableActions } = this.props;
        const { draggingHeaderId: draggingHeaderId, draggingStartY: draggingStartY, currentPointerY: currentPointerY, dropTargetHeaderId: dropTargetHeaderId, dropPosition: dropPosition } = this.state;
        const headerRenderData = headers.map((header, index)=>{
            return {
                header: header,
                displayed: false,
                hasContent: (0, $2ce140c2c56df8f2$export$a5209cf0e5ae5860)(header),
                absoluteIndex: index
            };
        }).toArray();
        headerRenderData.forEach((headerRenderDatum, index)=>{
            const nestingLevel = headerRenderDatum.header.get('nestingLevel');
            const hasNoParents = headerRenderData.slice(0, index).every((previousRenderDatum)=>previousRenderDatum.header.get('nestingLevel') >= nestingLevel);
            if (hasNoParents) headerRenderDatum.displayed = true;
            const followingHeaders = headerRenderData.slice(index + 1);
            for(let followingHeaderIndex = 0; followingHeaderIndex < followingHeaders.length; ++followingHeaderIndex){
                const followingHeader = followingHeaders[followingHeaderIndex];
                if (followingHeader.header.get('nestingLevel') <= nestingLevel) break;
                headerRenderDatum.hasContent = true;
                followingHeader.displayed = headerRenderDatum.header.get('opened') && headerRenderDatum.displayed;
            }
        });
        if (!!narrowedHeaderId) {
            const narrowedHeaderIndex = headerRenderData.findIndex((headerRenderDatum)=>headerRenderDatum.header.get('id') === narrowedHeaderId);
            const previousHeaders = headerRenderData.slice(0, narrowedHeaderIndex);
            previousHeaders.forEach((headerRenderDatum)=>headerRenderDatum.displayed = false);
            const numSubheaders = (0, $2ce140c2c56df8f2$export$463ed61f10f49ed3)(headers, narrowedHeaderId);
            const followingHeaders = headerRenderData.slice(narrowedHeaderIndex + numSubheaders + 1);
            followingHeaders.forEach((headerRenderDatum)=>headerRenderDatum.displayed = false);
        }
        const headerColors = [
            'var(--blue)',
            'var(--green)',
            'var(--cyan)',
            'var(--yellow)',
            'var(--blue)',
            'var(--green)',
            'var(--cyan)',
            'var(--yellow)'
        ];
        const displayedHeaderRenderData = headerRenderData.filter((headerRenderDatum)=>headerRenderDatum.displayed);
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('header-list-container', {
            'header-list-container--narrowed': !!narrowedHeaderId,
            'header-list-container--reordering': !!draggingHeaderId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: className
        }, displayedHeaderRenderData.map((headerRenderDatum)=>{
            const header = headerRenderDatum.header;
            const headerIndex = headerRenderDatum.absoluteIndex;
            const color = headerColors[(header.get('nestingLevel') - 1) % headerColors.length];
            const headerId = header.get('id');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $38f508047dd35bec$export$2e2bcd8739ae039), {
                key: headerId,
                header: header,
                headerIndex: headerIndex,
                color: color,
                hasContent: headerRenderDatum.hasContent,
                isSelected: headerId === selectedHeaderId,
                onRef: this.handleHeaderRef(headerId),
                shouldDisableActions: shouldDisableActions,
                onLongPressPointerStart: this.handleHeaderLongPressStart,
                onLongPressPointerEnd: this.handleHeaderLongPressEnd,
                isLongPressDragging: !!draggingHeaderId,
                isDraggedForReorder: draggingHeaderId === headerId,
                reorderDragOffsetY: draggingHeaderId === headerId && draggingStartY !== null && currentPointerY !== null ? currentPointerY - draggingStartY : 0,
                isReorderDropTarget: dropTargetHeaderId === headerId,
                reorderDropPosition: dropPosition
            });
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            style: {
                height: '90px'
            }
        }));
    }
    constructor(props){
        super(props), (0, $4E6oY._)(this, "LONG_PRESS_DELAY_MS", 350), (0, $4E6oY._)(this, "LONG_PRESS_CANCEL_DISTANCE", 8), (0, $4E6oY._)(this, "AUTO_SCROLL_MARGIN", 80), (0, $4E6oY._)(this, "AUTO_SCROLL_SPEED", 18);
        this.headerRefs = {};
        this.longPressCandidate = null;
        this.longPressTimer = null;
        this.autoScrollAnimationFrame = null;
        this.pointerX = null;
        this.pointerY = null;
        this.state = {
            draggingHeaderId: null,
            draggingStartY: null,
            currentPointerY: null,
            dropTargetHeaderId: null,
            dropPosition: null
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleHeaderRef',
            'handleHeaderLongPressStart',
            'handleHeaderLongPressEnd',
            'handleWindowPointerMove',
            'handleWindowPointerEnd',
            'stopLongPressCandidate',
            'startDrag',
            'updateDragState',
            'finishDrag',
            'loopAutoScroll',
            'stopAutoScrollLoop'
        ]);
    }
}
const $ec95309c06423ebf$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    return {
        headers: file.get('headers', (0, $3044e0bef3624137$exports.List)()),
        selectedHeaderId: file.get('selectedHeaderId'),
        narrowedHeaderId: file.get('narrowedHeaderId')
    };
};
const $ec95309c06423ebf$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    });
var $ec95309c06423ebf$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($ec95309c06423ebf$var$mapStateToProps, $ec95309c06423ebf$var$mapDispatchToProps)($ec95309c06423ebf$var$HeaderList);



var $frurs = parcelRequire("frurs");

var $QHj9z = parcelRequire("QHj9z");

var $1bxDW = parcelRequire("1bxDW");











const $a04cb38b4aee684a$var$ActionDrawer = ({ org: org, selectedHeaderId: selectedHeaderId, base: base, staticFile: staticFile, captureTemplates: captureTemplates, path: path, selectedTableCellId: selectedTableCellId, selectedListItemId: selectedListItemId, isLoading: isLoading, online: online, shouldDisableSyncButtons: shouldDisableSyncButtons, activeClocks: activeClocks })=>{
    const [isDisplayingArrowButtons, setIsDisplayingArrowButtons] = (0, $1bxDW.useState)(false);
    const [isDisplayingCaptureButtons, setIsDisplayingCaptureButtons] = (0, $1bxDW.useState)(false);
    const mainArrowButton = (0, $1bxDW.useRef)(null);
    const mainArrowButtonBoundingRect = (0, $1bxDW.useMemo)(()=>!!mainArrowButton.current ? mainArrowButton.current.getBoundingClientRect() : null, [
        mainArrowButton
    ]);
    const handleUpClick = ()=>!!selectedHeaderId ? org.moveHeaderUp(selectedHeaderId) : !!selectedTableCellId ? org.moveTableRowUp() : org.moveListItemUp();
    const handleDownClick = ()=>!!selectedHeaderId ? org.moveHeaderDown(selectedHeaderId) : !!selectedTableCellId ? org.moveTableRowDown() : org.moveListItemDown();
    const handleLeftClick = ()=>!!selectedHeaderId ? org.moveHeaderLeft(selectedHeaderId) : !!selectedTableCellId ? org.moveTableColumnLeft() : org.moveListItemLeft();
    const handleRightClick = ()=>!!selectedHeaderId ? org.moveHeaderRight(selectedHeaderId) : !!selectedTableCellId ? org.moveTableColumnRight() : org.moveListItemRight();
    const handleMoveSubtreeLeftClick = ()=>!!selectedHeaderId ? org.moveSubtreeLeft(selectedHeaderId) : org.moveListSubtreeLeft();
    const handleMoveSubtreeRightClick = ()=>!!selectedHeaderId ? org.moveSubtreeRight(selectedHeaderId) : org.moveListSubtreeRight();
    const handleCaptureButtonClick = (template)=>()=>{
            setIsDisplayingCaptureButtons(false);
            base.activatePopup('capture', {
                templateId: template.get('id'),
                templateDescription: template.get('description')
            });
        };
    const getSampleCaptureTemplates = ()=>(0, $0a008ec384282745$export$2e2bcd8739ae039);
    const getAvailableCaptureTemplates = ()=>staticFile === 'sample' ? getSampleCaptureTemplates() : captureTemplates.filter((template)=>template.get('isAvailableInAllOrgFiles') || template.get('orgFilesWhereAvailable').map((availablePath)=>availablePath.trim().startsWith('/') ? availablePath.trim() : '/' + availablePath.trim()).includes((path || '').trim()));
    const handleSync = ()=>org.sync({
            forceAction: 'manual'
        });
    const handleMainArrowButtonClick = ()=>setIsDisplayingArrowButtons(!isDisplayingArrowButtons);
    const handleSearchButtonClick = ()=>{
        base.activatePopup('search');
    };
    const handleMainCaptureButtonClick = ()=>{
        if (!isDisplayingCaptureButtons && getAvailableCaptureTemplates().size === 0) {
            alert(`You don't have any capture templates set up for this file! Add some in Settings > Capture Templates`);
            return;
        }
        setIsDisplayingCaptureButtons(!isDisplayingCaptureButtons);
    };
    const renderCaptureButtons = ()=>{
        const availableCaptureTemplates = getAvailableCaptureTemplates();
        const baseCaptureButtonStyle = {
            position: 'absolute',
            zIndex: 0,
            left: 0,
            opacity: isDisplayingArrowButtons ? 0 : 1
        };
        if (!isDisplayingCaptureButtons) baseCaptureButtonStyle.boxShadow = 'none';
        const mainButtonStyle = {
            opacity: isDisplayingArrowButtons ? 0 : 1,
            position: 'relative',
            zIndex: 1
        };
        const animatedStyle = {
            bottom: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingCaptureButtons ? 70 : 0, {
                stiffness: 300
            })
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
            style: animatedStyle
        }, (style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "action-drawer__capture-buttons-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                iconName: isDisplayingCaptureButtons ? 'times' : 'plus',
                isDisabled: false,
                onClick: handleMainCaptureButtonClick,
                style: mainButtonStyle,
                dataTestId: "capture-main-button",
                tooltip: isDisplayingCaptureButtons ? 'Hide capture templates' : 'Show capture templates'
            }), availableCaptureTemplates.map((template, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                    key: template.get('id'),
                    letter: template.get('letter'),
                    iconName: template.get('iconName'),
                    isDisabled: false,
                    onClick: handleCaptureButtonClick(template),
                    style: (0, $QHj9z._)((0, $frurs._)({}, baseCaptureButtonStyle), {
                        bottom: style.bottom * (index + 1)
                    }),
                    dataTestId: `capture-template-${template.get('description').toLowerCase().replace(/\s+/g, '-')}`,
                    tooltip: `Activate "${template.get('description')}" capture template`
                }))));
    };
    const renderMovementButtons = ()=>{
        const baseArrowButtonStyle = {
            opacity: isDisplayingCaptureButtons ? 0 : 1
        };
        if (!isDisplayingArrowButtons) baseArrowButtonStyle.boxShadow = 'none';
        let centerXOffset = 0;
        if (!!mainArrowButtonBoundingRect) centerXOffset = window.screen.width / 2 - (mainArrowButtonBoundingRect.x + mainArrowButtonBoundingRect.width / 2);
        const animatedStyles = {
            centerXOffset: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingArrowButtons ? centerXOffset : 0, {
                stiffness: 300
            }),
            topRowYOffset: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingArrowButtons ? 150 : 0, {
                stiffness: 300
            }),
            bottomRowYOffset: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingArrowButtons ? 80 : 0, {
                stiffness: 300
            }),
            firstColumnXOffset: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingArrowButtons ? 70 : 0, {
                stiffness: 300
            }),
            secondColumnXOffset: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isDisplayingArrowButtons ? 140 : 0, {
                stiffness: 300
            })
        };
        let subIconNameStr = null;
        let tooltipUpStr = 'Move header up';
        let tooltipDownStr = 'Move header down';
        let tooltipLeftStr = 'Move header left';
        let tooltipRightStr = 'Move header right';
        if (!!selectedTableCellId) {
            subIconNameStr = 'table';
            tooltipUpStr = 'Move row up';
            tooltipDownStr = 'Move row down';
            tooltipLeftStr = 'Move column left';
            tooltipRightStr = 'Move column right';
        } else if (!!selectedListItemId) {
            subIconNameStr = 'list';
            tooltipUpStr = 'Move list up';
            tooltipDownStr = 'Move list down';
            tooltipLeftStr = 'Move list left';
            tooltipRightStr = 'Move list right';
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
            style: animatedStyles
        }, (style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "action-drawer__arrow-buttons-container",
                style: {
                    left: style.centerXOffset,
                    pointerEvents: isDisplayingCaptureButtons ? 'none' : 'all'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "arrow-up",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleUpClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.topRowYOffset
                }),
                tooltip: tooltipUpStr
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "arrow-down",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleDownClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.bottomRowYOffset
                }),
                tooltip: tooltipDownStr
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "arrow-left",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleLeftClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.bottomRowYOffset,
                    right: style.firstColumnXOffset
                }),
                tooltip: tooltipLeftStr
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "arrow-right",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleRightClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.bottomRowYOffset,
                    left: style.firstColumnXOffset
                }),
                tooltip: tooltipRightStr
            }), !selectedTableCellId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "chevron-left",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleMoveSubtreeLeftClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.bottomRowYOffset,
                    right: style.secondColumnXOffset
                }),
                tooltip: "Move entire subtree left"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                additionalClassName: "action-drawer__arrow-button",
                iconName: "chevron-right",
                subIconName: subIconNameStr,
                isDisabled: false,
                onClick: handleMoveSubtreeRightClick,
                style: (0, $QHj9z._)((0, $frurs._)({}, baseArrowButtonStyle), {
                    bottom: style.bottomRowYOffset,
                    left: style.secondColumnXOffset
                }),
                tooltip: "Move entire subtree right"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
                iconName: isDisplayingArrowButtons ? 'times' : 'arrows-alt',
                subIconName: subIconNameStr,
                additionalClassName: "action-drawer__main-arrow-button",
                isDisabled: false,
                onClick: handleMainArrowButtonClick,
                style: {
                    opacity: isDisplayingCaptureButtons ? 0 : 1,
                    pointerEvents: isDisplayingCaptureButtons ? 'none' : 'all'
                },
                tooltip: isDisplayingArrowButtons ? 'Hide movement buttons' : 'Show movement buttons',
                onRef: mainArrowButton
            })));
    };
    const handleAgendaClick = ()=>base.activatePopup('agenda');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "action-drawer-container nice-scroll"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
        iconName: "cloud",
        subIconName: "sync-alt",
        shouldSpinSubIcon: isLoading,
        isDisabled: shouldDisableSyncButtons || !online,
        onClick: handleSync,
        style: {
            opacity: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 0 : 1,
            pointerEvents: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 'none' : 'all'
        },
        tooltip: "Sync changes"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
        iconName: "calendar-alt",
        isDisabled: false,
        onClick: handleAgendaClick,
        style: {
            opacity: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 0 : 1,
            pointerEvents: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 'none' : 'all'
        },
        tooltip: "Show agenda"
    }), renderMovementButtons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
        iconName: 'search',
        isDisabled: false,
        onClick: handleSearchButtonClick,
        additionalClassName: activeClocks !== 0 ? 'active-clock-indicator' : undefined,
        style: {
            opacity: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 0 : 1,
            position: 'relative',
            zIndex: 1,
            pointerEvents: isDisplayingArrowButtons || isDisplayingCaptureButtons ? 'none' : 'all'
        },
        tooltip: "Show Search / Task List"
    }), renderCaptureButtons()));
};
const $a04cb38b4aee684a$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const files = state.org.present.get('files');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const fileSettings = state.org.present.get('fileSettings');
    const searchFiles = (0, $13082abb6c5d9476$export$ac94e24c6e8885fa)(files, fileSettings, path, 'includeInSearch', false);
    const activeClocks = Object.values(searchFiles.map((f)=>f.get('headers').size ? f.get('activeClocks') : 0).toJS()).reduce((acc, val)=>typeof val === 'number' ? acc + val : acc, 0);
    return {
        selectedHeaderId: file.get('selectedHeaderId'),
        isDirty: file.get('isDirty'),
        isNarrowedHeaderActive: !!file.get('narrowedHeaderId'),
        selectedTableCellId: file.get('selectedTableCellId'),
        selectedListItemId: file.get('selectedListItemId'),
        captureTemplates: state.capture.get('captureTemplates', (0, $3044e0bef3624137$exports.List)()),
        path: path,
        isLoading: !state.base.get('isLoading').isEmpty(),
        online: state.base.get('online'),
        activeClocks: activeClocks
    };
};
const $a04cb38b4aee684a$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        capture: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($3e461505c3a6d1b3$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $a04cb38b4aee684a$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($a04cb38b4aee684a$var$mapStateToProps, $a04cb38b4aee684a$var$mapDispatchToProps)($a04cb38b4aee684a$var$ActionDrawer);



var $1bxDW = parcelRequire("1bxDW");



var $b1933be4a43a85a4$export$2e2bcd8739ae039 = ({ lastServerModifiedAt: lastServerModifiedAt, lastSyncAt: lastSyncAt, path: path, onPull: onPull, onPush: onPush, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
        className: "sync-confirmation-modal__header"
    }, "Sync conflict"), "Since you last pulled ", path, ", a newer version of the file has been pushed to the server. The newer version is from:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "sync-confirmation-modal__last-sync-time"
    }, (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(lastServerModifiedAt, 'MMMM do, yyyy [at] h:mm:ss a'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "(", (0, $2ce140c2c56df8f2$export$587d51660e3dfec4)(lastServerModifiedAt), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "While your version is from:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "sync-confirmation-modal__last-sync-time"
    }, (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(lastSyncAt, 'MMMM do, yyyy [at] h:mm:ss a'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "(", (0, $2ce140c2c56df8f2$export$587d51660e3dfec4)(lastSyncAt), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "sync-confirmation-modal__buttons-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn sync-confirmation-modal__button",
        onClick: onPull
    }, "Pull latest version from server"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn sync-confirmation-modal__button",
        onClick: onPush
    }, "Overwrite server version"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn sync-confirmation-modal__button",
        onClick: onCancel
    }, "Cancel sync")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null));
};



var $1bxDW = parcelRequire("1bxDW");





var $1bxDW = parcelRequire("1bxDW");

var $1bxDW = parcelRequire("1bxDW");






var $1bxDW = parcelRequire("1bxDW");





const $2002947c2d00a053$var$getSelectedCellId = (0, $55c61384e4e198c2$exports.curry)((filePath, state)=>{
    return state.org.present.getIn([
        'files',
        filePath,
        'selectedTableCellId'
    ]);
});
const $2002947c2d00a053$var$CellEditContainer = ({ filePath: filePath, cellValue: cellValue, cellId: cellId })=>{
    const dispatch = (0, $3046378a5fefb10b$export$8ad76b76a4c905f8)();
    const selectedCellId = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($2002947c2d00a053$var$getSelectedCellId(filePath));
    const [isCellSelected, setIsCellSelected] = (0, $1bxDW.useState)(cellId == selectedCellId);
    const [currentCellValue, setCurrentCellValue] = (0, $1bxDW.useState)(cellValue);
    const [shouldIgnoreBlur, setShouldIgnoreBlur] = (0, $1bxDW.useState)(false);
    const textareaRef = (0, $1bxDW.useRef)(null);
    (0, $1bxDW.useEffect)(()=>{
        if (cellId == selectedCellId) setIsCellSelected(true);
        else {
            setIsCellSelected(false);
            handleTableCellValueUpdate(cellId, currentCellValue);
        }
    }, [
        selectedCellId,
        isCellSelected,
        cellId,
        currentCellValue
    ]);
    const handleTableCellValueUpdate = (cellId, newValue)=>{
        dispatch((0, $d81b80734fbc24a5$export$7f16bb82aa33d615)(cellId, newValue));
    };
    const handleExitTableEditMode = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$7f16bb82aa33d615)(cellId, currentCellValue));
        dispatch((0, $d81b80734fbc24a5$export$6104e3b4c48e4d36)());
    };
    const handleCellChange = (event)=>setCurrentCellValue(event.target.value);
    const handleInsertTimestamp = ()=>{
        setShouldIgnoreBlur(true);
        const insertionIndex = textareaRef.current.selectionStart;
        const newValue = currentCellValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + currentCellValue.substring(textareaRef.current.selectionEnd || insertionIndex);
        textareaRef.current.value = newValue;
        setCurrentCellValue(newValue);
        setShouldIgnoreBlur(false);
        textareaRef.current.focus();
    };
    const handleTextareaBlur = ()=>{
        if (!shouldIgnoreBlur) handleExitTableEditMode();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-cell__edit-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
        "data-testid": "edit-cell-container",
        autoFocus: true,
        className: "textarea",
        rows: "3",
        value: currentCellValue,
        onChange: handleCellChange,
        onBlur: handleTextareaBlur,
        ref: textareaRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-cell__insert-timestamp-button",
        onClick: handleInsertTimestamp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-plus insert-timestamp-icon"
    }), "Insert timestamp"));
};
var $2002947c2d00a053$export$2e2bcd8739ae039 = $2002947c2d00a053$var$CellEditContainer;






const $622bf201efc41170$var$getInTableEditMode = (0, $55c61384e4e198c2$exports.curry)((filePath, state)=>state.org.present.getIn([
        'files',
        filePath,
        'editMode'
    ]) === 'table');
const $622bf201efc41170$var$getSelectedCellId = (0, $55c61384e4e198c2$exports.curry)((filePath, state)=>{
    return state.org.present.getIn([
        'files',
        filePath,
        'selectedTableCellId'
    ]);
});
const $622bf201efc41170$var$TableCell = ({ props: { filePath: filePath, headerIndex: headerIndex, descriptionItemIndex: descriptionItemIndex, cellId: cellId, row: row, column: column } })=>{
    const dispatch = (0, $3046378a5fefb10b$export$8ad76b76a4c905f8)();
    const inTableEditMode = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($622bf201efc41170$var$getInTableEditMode(filePath));
    const selectedCellId = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($622bf201efc41170$var$getSelectedCellId(filePath));
    const [isCellSelected, setIsCellSelected] = (0, $1bxDW.useState)(cellId === selectedCellId);
    const tableCellGetter = (0, $2ce140c2c56df8f2$export$16d08c6bdc3d6518)({
        filePath: filePath,
        headerIndex: headerIndex,
        descriptionItemIndex: descriptionItemIndex,
        row: row,
        column: column
    });
    const cell = (0, $b7b90b00e04e051d$export$2105062e25df4afe)(tableCellGetter, (0, $3044e0bef3624137$exports.is));
    const cellContents = cell.get('contents');
    const cellRawContents = cell.get('rawContents');
    (0, $1bxDW.useEffect)(()=>{
        if (cellId == selectedCellId) setIsCellSelected(true);
        else setIsCellSelected(false);
    }, [
        selectedCellId,
        isCellSelected,
        cellId
    ]);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('table-part__cell', {
        'table-part__cell--selected': isCellSelected
    });
    const handleCellSelect = ()=>{
        setIsCellSelected(true);
        dispatch((0, $d81b80734fbc24a5$export$e87683d26142c4fd)(cellId));
    };
    const handleCheckboxClick = (listItemId)=>{
        dispatch((0, $d81b80734fbc24a5$export$67c8893c26def689)(listItemId));
    };
    const handleTimestampClick = (timestampId)=>{
        dispatch((0, $1780206710f3c846$export$ebfc6cde9af7602f)('timestamp-editor', {
            timestampId: timestampId
        }));
    };
    const subPartDataAndHandlers = {
        inTableEditMode: inTableEditMode,
        onCheckboxClick: handleCheckboxClick,
        onTimestampClick: handleTimestampClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("td", {
        className: className,
        key: cellId,
        onClick: handleCellSelect
    }, isCellSelected && inTableEditMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $2002947c2d00a053$export$2e2bcd8739ae039), {
        cellValue: cellRawContents,
        cellId: cellId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $04ec35a24831438f$export$2e2bcd8739ae039), {
        parts: cellContents,
        subPartDataAndHandlers: subPartDataAndHandlers
    }));
};
var $622bf201efc41170$export$2e2bcd8739ae039 = $622bf201efc41170$var$TableCell;



const $c064bf42ebb10574$var$Table = ({ props: { filePath: filePath, table: table, headerIndex: headerIndex, descriptionItemIndex: descriptionItemIndex } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("table", {
        className: "table-part"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("tbody", null, table.get('contents').map((row, rowIndex)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("tr", {
            key: row.get('id')
        }, row.get('contents').map((cell, columnIndex)=>{
            const cellId = cell.get('id');
            const cellProps = {
                filePath: filePath,
                headerIndex: headerIndex,
                descriptionItemIndex: descriptionItemIndex,
                cellId: cellId,
                row: rowIndex,
                column: columnIndex
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $622bf201efc41170$export$2e2bcd8739ae039), {
                key: cellId,
                props: cellProps
            });
        }));
    })));
};
var $c064bf42ebb10574$export$2e2bcd8739ae039 = $c064bf42ebb10574$var$Table;



var $1bxDW = parcelRequire("1bxDW");




const $90a8d5734c988473$var$getSelectedCellId = (0, $55c61384e4e198c2$exports.curry)((filePath, state)=>{
    return state.org.present.getIn([
        'files',
        filePath,
        'selectedTableCellId'
    ]);
});
const $90a8d5734c988473$var$TableActionButtons = ({ filePath: filePath })=>{
    const dispatch = (0, $3046378a5fefb10b$export$8ad76b76a4c905f8)();
    const selectedTableCellId = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($90a8d5734c988473$var$getSelectedCellId(filePath));
    const handleEnterTableEditMode = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$99a5c3ae2a16e7ed)('table'));
    };
    const handleAddNewTableRow = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$7cae8a62f493d901)());
    };
    const handleRemoveTableRow = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$163255ef96b20fb2)());
    };
    const handleAddNewTableColumn = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$7ab7eb066062846f)());
    };
    const handleRemoveTableColumn = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$e8d98b2fc68c6686)());
    };
    const handleUpClick = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$24d61201bca94a1e)());
    };
    const handleDownClick = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$4aba78fdf63069f3)());
    };
    const handleLeftClick = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$10d26cb5dfc56d08)());
    };
    const handleRightClick = ()=>{
        dispatch((0, $d81b80734fbc24a5$export$2d24c1901a67e0af)());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: " table-action-drawer__edit-icon-container",
        onClick: ()=>selectedTableCellId ? handleEnterTableEditMode() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "edit-cell-button",
        className: "fas fa-pencil-alt fa-lg"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer__sub-icon-container",
        onClick: ()=>selectedTableCellId ? handleAddNewTableColumn() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-plus fa-lg table-action-drawer__main-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "add-column-button",
        className: "fas fa-columns fa-sm table-action-drawer__sub-icon table-action-drawer__sub-icon--rotated"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer__sub-icon-container",
        onClick: ()=>selectedTableCellId ? handleRemoveTableColumn() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-times fa-lg table-action-drawer__main-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "delete-column-button",
        className: "fas fa-columns fa-sm table-action-drawer__sub-icon table-action-drawer__sub-icon--rotated"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer__sub-icon-container",
        onClick: ()=>selectedTableCellId ? handleAddNewTableRow() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-plus fa-lg table-action-drawer__main-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "add-row-button",
        className: "fas fa-columns fa-sm table-action-drawer__sub-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-drawer__sub-icon-container",
        onClick: ()=>selectedTableCellId ? handleRemoveTableRow() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-times fa-lg table-action-drawer__main-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "delete-row-button",
        className: "fas fa-columns fa-sm table-action-drawer__sub-icon"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-movement-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-movement__up",
        onClick: ()=>selectedTableCellId ? handleUpClick() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "up-button",
        className: "fas fa-arrow-up fa-lg table-action-drawer__main-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-movement__left",
        onClick: ()=>selectedTableCellId ? handleLeftClick() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "left-button",
        className: "fas fa-arrow-left fa-lg table-action-drawer__main-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-movement__right",
        onClick: ()=>selectedTableCellId ? handleRightClick() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "right-button",
        className: "fas fa-arrow-right fa-lg table-action-drawer__main-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "table-action-movement__down",
        onClick: ()=>selectedTableCellId ? handleDownClick() : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        "data-testid": "down-button",
        className: "fas fa-arrow-down fa-lg table-action-drawer__main-icon"
    })))));
};
var $90a8d5734c988473$export$2e2bcd8739ae039 = $90a8d5734c988473$var$TableActionButtons;




const $28186f79fa318d48$var$getFilePath = (state)=>state.org.present.get('path');
const $28186f79fa318d48$var$getFile = (0, $55c61384e4e198c2$exports.curry)((filePath, state)=>{
    return state.org.present.getIn([
        'files',
        filePath
    ], (0, $3044e0bef3624137$exports.Map)());
});
const $28186f79fa318d48$var$TableEditorModal = ()=>{
    const dispatch = (0, $3046378a5fefb10b$export$8ad76b76a4c905f8)();
    const filePath = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($28186f79fa318d48$var$getFilePath);
    const file = (0, $b7b90b00e04e051d$export$2105062e25df4afe)($28186f79fa318d48$var$getFile(filePath), (0, $3044e0bef3624137$exports.is));
    const headerIndex = file.get('selectedHeaderIndex');
    const descriptionItemIndex = file.get('selectedDescriptionItemIndex');
    const tableGetter = (0, $2ce140c2c56df8f2$export$71b553ef914ccf29)({
        filePath: filePath,
        headerIndex: headerIndex,
        descriptionItemIndex: descriptionItemIndex
    });
    const table = (0, $b7b90b00e04e051d$export$2105062e25df4afe)(tableGetter, (0, $3044e0bef3624137$exports.is));
    const tableProps = {
        filePath: filePath,
        table: table,
        headerIndex: headerIndex,
        descriptionItemIndex: descriptionItemIndex
    };
    const handlePopupClose = ()=>{
        dispatch((0, $1780206710f3c846$export$e6889fb0929ccf91)());
    };
    if (table.get('contents').size === 0 || table.getIn([
        'contents',
        0,
        'contents'
    ]).size === 0) handlePopupClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
        className: "drawer-modal__title"
    }, "Edit table"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        style: {
            overflowX: 'auto',
            overflowY: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $c064bf42ebb10574$export$2e2bcd8739ae039), {
        props: tableProps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $90a8d5734c988473$export$2e2bcd8739ae039), {
        filePath: filePath
    }));
};
var $28186f79fa318d48$export$2e2bcd8739ae039 = $28186f79fa318d48$var$TableEditorModal;



var $1bxDW = parcelRequire("1bxDW");




var $1bxDW = parcelRequire("1bxDW");



var $4E6oY = parcelRequire("4E6oY");

var $1bxDW = parcelRequire("1bxDW");

var $7dzZ9 = parcelRequire("7dzZ9");




var $37fd296033f3f5de$var$_React_PureComponent;
class $37fd296033f3f5de$export$2e2bcd8739ae039 extends ($37fd296033f3f5de$var$_React_PureComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).PureComponent) {
    render() {
        const { header: header, viewDate: viewDate, precedingDays: precedingDays, followingDays: followingDays } = this.props;
        const consistencyData = (0, $2ce140c2c56df8f2$export$396767b392ddab91)(header, viewDate, {
            precedingDays: precedingDays,
            followingDays: followingDays
        });
        if (!consistencyData || consistencyData.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "habit-consistency-graph"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "habit-consistency-graph__days"
        }, consistencyData.map((dayData)=>this.renderDay(dayData))));
    }
    renderDay(dayData) {
        const { date: date, status: status } = dayData;
        const { viewDate: viewDate } = this.props;
        const dayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('habit-consistency-graph__day', {
            'habit-consistency-graph__day--done': status === 'done',
            'habit-consistency-graph__day--future': status === 'future',
            'habit-consistency-graph__day--scheduled': status === 'scheduled',
            'habit-consistency-graph__day--overdue': status === 'overdue',
            'habit-consistency-graph__day--missed': status === 'missed',
            'habit-consistency-graph__day--due-soon': status === 'due-soon',
            'habit-consistency-graph__day--today': this.isToday(date, viewDate)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            key: date.getTime(),
            className: dayClassName,
            title: this.getDayTooltip(date, status)
        }, (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(date, 'EEE')[0]);
    }
    isToday(date, viewDate) {
        return date.getDate() === viewDate.getDate() && date.getMonth() === viewDate.getMonth() && date.getFullYear() === viewDate.getFullYear();
    }
    getDayTooltip(date, status) {
        const dateStr = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(date, 'MMM d, yyyy');
        const statusText = {
            done: 'Completed',
            future: 'Not due yet',
            scheduled: 'Scheduled',
            overdue: 'Overdue',
            missed: 'Missed',
            'due-soon': 'Due tomorrow',
            'not-scheduled': 'Not scheduled'
        }[status] || status;
        return `${dateStr}: ${statusText}`;
    }
}
(0, $4E6oY._)($37fd296033f3f5de$export$2e2bcd8739ae039, "propTypes", {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).object.isRequired,
    viewDate: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).instanceOf(Date),
    precedingDays: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number,
    followingDays: (0, (/*@__PURE__*/$parcel$interopDefault($7dzZ9))).number
});
(0, $4E6oY._)($37fd296033f3f5de$export$2e2bcd8739ae039, "defaultProps", {
    viewDate: new Date(),
    precedingDays: (0, $2ce140c2c56df8f2$export$2b57a1f2af7b062c).PRECEDING_DAYS,
    followingDays: (0, $2ce140c2c56df8f2$export$2b57a1f2af7b062c).FOLLOWING_DAYS
});






function $d7eab5c6f982de74$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}



function $582aaee3831e999d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    return (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate).getTime() < Date.now();
}



function $c923b251abd703dd$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $e481905941a70a00$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    return (0, $c923b251abd703dd$export$2e2bcd8739ae039)(dirtyDate, Date.now());
}



function $bd2f075b97b13dff$export$2e2bcd8739ae039(dirtyDate, dirtyInterval) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(2, arguments);
    var interval = dirtyInterval || {};
    var time = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}




class $baed86d27adb7132$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleHeaderClick(path, headerId) {
        return ()=>this.props.onHeaderClick(path, headerId);
    }
    render() {
        const { date: date, files: files, dateDisplayType: dateDisplayType, onToggleDateDisplayType: onToggleDateDisplayType, agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue, agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit, orgHabitShowAllToday: orgHabitShowAllToday, orgHabitPrecedingDays: orgHabitPrecedingDays, orgHabitFollowingDays: orgHabitFollowingDays } = this.props;
        const dateStart = (0, $4554dc9bbab9791e$export$2e2bcd8739ae039)(date);
        const dateEnd = (0, $97e43c253919aede$export$2e2bcd8739ae039)(date);
        const planningItemsAndHeaders = this.getPlanningItemsAndHeaders({
            files: files,
            date: date,
            agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue,
            agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit,
            dateStart: dateStart,
            dateEnd: dateEnd,
            orgHabitShowAllToday: orgHabitShowAllToday
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__title"
        }, (0, $e481905941a70a00$export$2e2bcd8739ae039)(date) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__today-indicator"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__title__day-name"
        }, (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(date, 'eeee')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__title__date"
        }, (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(date, 'MMMM do, yyyy'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__headers-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, planningItemsAndHeaders.map(([planningItem, header])=>{
            const planningItemDate = (0, $e706118dde20dbed$export$77db66937f538459)(planningItem.get('timestamp'));
            const hasTodoKeyword = !!header.getIn([
                'titleLine',
                'todoKeyword'
            ]);
            const dateClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('agenda-day__header-planning-date', {
                'agenda-day__header-planning-date--overdue': hasTodoKeyword && (0, $582aaee3831e999d$export$2e2bcd8739ae039)(planningItemDate)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                key: planningItem.get('id'),
                className: "agenda-day__header-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "agenda-day__header__planning-item-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "agenda-day__header-planning-type"
            }, (0, $2ce140c2c56df8f2$export$39a3e68e78f1544d)(planningItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: dateClassName,
                onClick: onToggleDateDisplayType
            }, dateDisplayType === 'absolute' ? (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(planningItemDate, 'MM/dd') : (0, $2ce140c2c56df8f2$export$587d51660e3dfec4)(planningItemDate), planningItem.getIn([
                'timestamp',
                'startHour'
            ]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(planningItemDate, 'h:mma')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "agenda-day__header__header-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $50bbde6b70a077ee$export$2e2bcd8739ae039), {
                header: header,
                color: "var(--base03)",
                hasContent: false,
                isSelected: false,
                shouldDisableActions: true,
                shouldDisableExplicitWidth: true,
                onClick: this.handleHeaderClick(header.get('path'), header.get('id'))
            }), (0, $2ce140c2c56df8f2$export$e59613884f5c7e07)(header) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $37fd296033f3f5de$export$2e2bcd8739ae039), {
                header: header,
                viewDate: date,
                precedingDays: orgHabitPrecedingDays,
                followingDays: orgHabitFollowingDays
            })));
        }))));
    }
    getPlanningItemsAndHeaders({ files: files, date: date, agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue, agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit, dateStart: dateStart, dateEnd: dateEnd, orgHabitShowAllToday: orgHabitShowAllToday }) {
        const headers = (0, $3044e0bef3624137$exports.List)().concat(...files.mapEntries(([path, file])=>[
                path,
                file.get('headers').map((header)=>header.set('path', path))
            ]).valueSeq());
        const todoKeywordSets = files.map((file)=>file.get('todoKeywordSets'));
        return headers.flatMap((header)=>{
            const planningItemsforDate = header.get('planningItems').filter((planningItem)=>{
                const timestamp = planningItem.get('timestamp');
                if (!timestamp.get('isActive')) return false;
                // Check if this is a habit using the utility function
                const headerIsHabit = (0, $2ce140c2c56df8f2$export$96f956050c634e56)(header);
                // When org-habit-show-all-today is enabled and viewing today:
                // Show ALL habits (even if not scheduled or completed)
                if (orgHabitShowAllToday && headerIsHabit && (0, $e481905941a70a00$export$2e2bcd8739ae039)(date)) return true;
                const planningItemDate = (0, $e706118dde20dbed$export$77db66937f538459)(timestamp);
                const todoKeyword = header.getIn([
                    'titleLine',
                    'todoKeyword'
                ]);
                const isCompletedTodo = todoKeyword && (0, $2ce140c2c56df8f2$export$60678e145a879202)(todoKeywordSets.get(header.get('path')), todoKeyword);
                if (isCompletedTodo) return false;
                switch(planningItem.get('type')){
                    case 'DEADLINE':
                        if ((0, $e481905941a70a00$export$2e2bcd8739ae039)(date)) {
                            if ((0, $12b49ea8a8ce12d5$export$2e2bcd8739ae039)(planningItemDate, new Date())) return true;
                            const [delayValue, delayUnit] = timestamp.get('delayType') ? [
                                timestamp.get('delayValue'),
                                timestamp.get('delayUnit')
                            ] : [
                                agendaDefaultDeadlineDelayValue,
                                agendaDefaultDeadlineDelayUnit
                            ];
                            const appearDate = (0, $e706118dde20dbed$export$8491aff2799e70c1)(planningItemDate, delayValue, delayUnit);
                            return (0, $4c410305d186c466$export$2e2bcd8739ae039)(date, appearDate) || (0, $d7eab5c6f982de74$export$2e2bcd8739ae039)(date, appearDate);
                        } else return (0, $bd2f075b97b13dff$export$2e2bcd8739ae039)(planningItemDate, {
                            start: dateStart,
                            end: dateEnd
                        });
                    case 'SCHEDULED':
                        let appearDate = planningItemDate;
                        if (timestamp.get('delayType')) {
                            const hasBeenRepeated = header.get('propertyListItems').some((propertyListItem)=>propertyListItem.get('property') === 'LAST_REPEAT');
                            if (timestamp.get('delayType') === '--' && !hasBeenRepeated) appearDate = (0, $e706118dde20dbed$export$774686e7fdec6ef3)(planningItemDate, timestamp.get('delayValue'), timestamp.get('delayUnit'));
                        }
                        if ((0, $e481905941a70a00$export$2e2bcd8739ae039)(date) && (0, $4c410305d186c466$export$2e2bcd8739ae039)(date, appearDate)) return true;
                        return (0, $bd2f075b97b13dff$export$2e2bcd8739ae039)(appearDate, {
                            start: dateStart,
                            end: dateEnd
                        });
                    default:
                        return (0, $bd2f075b97b13dff$export$2e2bcd8739ae039)(planningItemDate, {
                            start: dateStart,
                            end: dateEnd
                        });
                }
            });
            return planningItemsforDate.map((planningItem)=>[
                    planningItem,
                    header
                ]);
        }).sortBy(([planningItem, header])=>{
            const { startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute, month: month, day: day } = planningItem.get('timestamp').toJS();
            return [
                (0, $2ce140c2c56df8f2$export$96f956050c634e56)(header) ? 0 : 1,
                startHour ? 0 : 1,
                startHour,
                startMinute,
                endHour,
                endMinute,
                month,
                day
            ];
        });
    }
}



var $1bxDW = parcelRequire("1bxDW");


var $16ed2298da274255$export$2e2bcd8739ae039 = ({ buttons: buttons, titles: titles, values: values, selectedButton: selectedButton, useEqualWidthTabs: useEqualWidthTabs, onSelect: onSelect })=>{
    const handleButtonClick = (buttonName)=>()=>onSelect(buttonName);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('tab-buttons', {
        'tab-buttons--equal-width-tabs': useEqualWidthTabs
    });
    const style = {
        gridTemplateColumns: useEqualWidthTabs ? `repeat(${buttons.length}, 1fr)` : null
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: containerClassName,
        style: style
    }, buttons.map((buttonName, index)=>{
        const value = values ? values[index] : buttonName;
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('tab-buttons__btn', {
            'tab-buttons__btn--selected': value === selectedButton
        });
        // Optionally add a title
        let title = '';
        if (titles) title = titles[index];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            key: buttonName + index,
            title: title,
            className: className,
            onClick: handleButtonClick(value)
        }, buttonName);
    }));
};







var $1X5R2 = parcelRequire("1X5R2");


function $0b4d0bf535439960$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day;
}



function $19930013930adfc7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d35da74b7b76c8e8$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $6b0383a7d85356ab$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



// INFO: SearchModal, AgendaModal and TaskListModal are very similar
// in structure and partially in logic. When changing one, consider
// changing all.
function $43e02334516f8fa5$var$AgendaModal(props) {
    const { files: files, todoKeywordSets: todoKeywordSets, agendaTimeframe: agendaTimeframe, agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue, agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit, agendaStartOnWeekday: agendaStartOnWeekday, orgHabitShowAllToday: orgHabitShowAllToday, orgHabitPrecedingDays: orgHabitPrecedingDays, orgHabitFollowingDays: orgHabitFollowingDays } = props;
    const [selectedDate, setSelectedDate] = (0, $1bxDW.useState)(new Date());
    const [dateDisplayType, setDateDisplayType] = (0, $1bxDW.useState)('absolute');
    const weekStartsOn = agendaStartOnWeekday < 0 ? (0, $0b4d0bf535439960$export$2e2bcd8739ae039)(selectedDate) : agendaStartOnWeekday;
    function handleTimeframeTypeChange(agendaTimeframe) {
        props.base.setAgendaTimeframe(agendaTimeframe);
    }
    function handleNextDateClick() {
        switch(agendaTimeframe){
            case 'Day':
                setSelectedDate((0, $31308ca003123199$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            case 'Week':
                setSelectedDate((0, $76d9578e8d1d18d0$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            case 'Month':
                setSelectedDate((0, $b83935a7f4bd66dd$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            default:
                return '';
        }
    }
    function handleHeaderClick(path, headerId) {
        props.onClose();
        props.org.selectHeaderAndOpenParents(path, headerId);
    }
    function handlePreviousDateClick() {
        switch(agendaTimeframe){
            case 'Day':
                setSelectedDate((0, $aa5a474e2d8b72f5$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            case 'Week':
                setSelectedDate((0, $a49a2aa8dc053503$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            case 'Month':
                setSelectedDate((0, $ccb552dfa3d8b0af$export$2e2bcd8739ae039)(selectedDate, 1));
                break;
            default:
                return '';
        }
    }
    function handleToggleDateDisplayType() {
        setDateDisplayType(dateDisplayType === 'absolute' ? 'relative' : 'absolute');
    }
    function calculateTimeframeHeader() {
        switch(agendaTimeframe){
            case 'Day':
                return (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(selectedDate, 'MMMM do');
            case 'Week':
                const weekStart = (0, $f9da2e6a06649605$export$2e2bcd8739ae039)(selectedDate, {
                    weekStartsOn: weekStartsOn
                });
                const weekEnd = (0, $76d9578e8d1d18d0$export$2e2bcd8739ae039)(weekStart, 1);
                return `${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(weekStart, 'MMM do')} - ${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(weekEnd, 'MMM do')} (W${(0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(weekStart, 'w')})`;
            case 'Month':
                return (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(selectedDate, 'MMMM');
            default:
                return '';
        }
    }
    let dates = [];
    switch(agendaTimeframe){
        case 'Day':
            dates = [
                selectedDate
            ];
            break;
        case 'Week':
            const weekStart = (0, $f9da2e6a06649605$export$2e2bcd8739ae039)(selectedDate, {
                weekStartsOn: weekStartsOn
            });
            dates = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range(7).map((daysAfter)=>(0, $31308ca003123199$export$2e2bcd8739ae039)(weekStart, daysAfter));
            break;
        case 'Month':
            const monthStart = (0, $9e259011028b352c$export$2e2bcd8739ae039)(selectedDate);
            dates = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).range((0, $19930013930adfc7$export$2e2bcd8739ae039)(selectedDate)).map((daysAfter)=>(0, $31308ca003123199$export$2e2bcd8739ae039)(monthStart, daysAfter));
            break;
        default:
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
        className: "agenda__title"
    }, "Agenda"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda__tab-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'Day',
            'Week',
            'Month'
        ],
        selectedButton: agendaTimeframe,
        onSelect: handleTimeframeTypeChange,
        useEqualWidthTabs: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda__timeframe-header-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-chevron-left fa-lg",
        onClick: handlePreviousDateClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda__timeframe-header"
    }, calculateTimeframeHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-chevron-right fa-lg",
        onClick: handleNextDateClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda__days-container",
        style: (0, $fb511a1814e342c6$export$cfca147fb13c9ee6) ? undefined : {
            overflow: 'auto'
        }
    }, dates.map((date)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $baed86d27adb7132$export$2e2bcd8739ae039), {
            key: (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(date, 'yyyy MM dd'),
            date: date,
            files: files,
            onHeaderClick: handleHeaderClick,
            todoKeywordSets: todoKeywordSets,
            dateDisplayType: dateDisplayType,
            onToggleDateDisplayType: handleToggleDateDisplayType,
            agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue,
            agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit,
            orgHabitShowAllToday: orgHabitShowAllToday,
            orgHabitPrecedingDays: orgHabitPrecedingDays,
            orgHabitFollowingDays: orgHabitFollowingDays
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null));
}
const $43e02334516f8fa5$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ]);
    const allFiles = state.org.present.get('files');
    const fileSettings = state.org.present.get('fileSettings');
    const agendaStartOnWeekday = state.base.get('agendaStartOnWeekday');
    return {
        files: (0, $13082abb6c5d9476$export$ac94e24c6e8885fa)(allFiles, fileSettings, path, 'includeInAgenda', false),
        todoKeywordSets: !!file ? file.get('todoKeywordSets') : null,
        agendaTimeframe: state.base.get('agendaTimeframe'),
        agendaDefaultDeadlineDelayValue: state.base.get('agendaDefaultDeadlineDelayValue') || 5,
        agendaDefaultDeadlineDelayUnit: state.base.get('agendaDefaultDeadlineDelayUnit') || 'd',
        agendaStartOnWeekday: agendaStartOnWeekday == null ? 1 : +agendaStartOnWeekday,
        orgHabitShowAllToday: state.base.get('orgHabitShowAllToday'),
        orgHabitPrecedingDays: state.base.get('orgHabitPrecedingDays') || 21,
        orgHabitFollowingDays: state.base.get('orgHabitFollowingDays') || 7
    };
};
const $43e02334516f8fa5$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    });
var $43e02334516f8fa5$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($43e02334516f8fa5$var$mapStateToProps, $43e02334516f8fa5$var$mapDispatchToProps)($43e02334516f8fa5$var$AgendaModal);



var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");



var $1bxDW = parcelRequire("1bxDW");








function $ac83c3449b808737$var$HeaderListView(props) {
    const { context: context } = props;
    function handleHeaderClick(path, headerId) {
        return ()=>props.onHeaderClick(path, headerId);
    }
    // Populate filteredHeaders
    (0, $1bxDW.useEffect)(()=>{
        // No specific searchFilter and cursorPosition, but set the
        // context (like 'search' or 'refile')
        if (context === 'Clock List') props.org.setSearchFilterInformation('clock:now', 0, 'search');
        else props.org.setSearchFilterInformation('', 0, context);
    }, [
        context,
        props.org
    ]);
    const { headers: headers, allHeaders: allHeaders, showClockedTimes: showClockedTimes } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda-day__container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda-day__headers-container"
    }, Array.from(headers.entries(), ([path, headersOfFile])=>{
        const getBreadcrumbs = (0, $2ce140c2c56df8f2$export$5aab98689c4eaa9c)(allHeaders, path);
        return headersOfFile.map((header)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                key: header.get('id'),
                className: "agenda-day__header-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "search__breadcrumbs"
            }, getBreadcrumbs(header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "agenda-day__header__header-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $50bbde6b70a077ee$export$2e2bcd8739ae039), {
                header: header,
                color: "var(--base03)",
                hasContent: false,
                isSelected: false,
                shouldDisableActions: true,
                shouldDisableExplicitWidth: true,
                onClick: handleHeaderClick(path, header.get('id')),
                addition: showClockedTimes && header.get('totalFilteredTimeLoggedRecursive') !== 0 ? (0, $e706118dde20dbed$export$4251c173c1ee6069)(header.get('totalFilteredTimeLoggedRecursive')) : null
            })));
        });
    })));
}
const $ac83c3449b808737$var$mapStateToProps = (state)=>{
    const files = state.org.present.get('files');
    return {
        allHeaders: files.map((file)=>file.get('headers')),
        headers: state.org.present.getIn([
            'search',
            'filteredHeaders'
        ]) || (0, $3044e0bef3624137$exports.Map)(),
        showClockedTimes: state.org.present.getIn([
            'search',
            'showClockedTimes'
        ])
    };
};
const $ac83c3449b808737$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    });
var $ac83c3449b808737$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($ac83c3449b808737$var$mapStateToProps, $ac83c3449b808737$var$mapDispatchToProps)($ac83c3449b808737$var$HeaderListView);





// INFO: SearchModal, AgendaModal and TaskListModal are very similar
// in structure and partially in logic. When changing one, consider
// changing all.
function $8c0f5124fd4ee13d$var$SearchModal(props) {
    const [dateDisplayType, setdateDisplayType] = (0, $1bxDW.useState)('absolute');
    const searchInputRef = (0, $1bxDW.useRef)(null);
    const { searchFilter: searchFilter, searchFilterValid: searchFilterValid, searchFilterSuggestions: searchFilterSuggestions, allBookmarks: allBookmarks, context: context, showClockedTimes: showClockedTimes, clockedTime: clockedTime, activeClocks: activeClocks } = props;
    const bookmarks = allBookmarks.get(context);
    const bookmarkChosen = bookmarks.contains(searchFilter);
    const canSaveBookmark = searchFilterValid && searchFilter.length !== 0;
    function handleHeaderClick(path, headerId) {
        props.onClose(path, headerId);
    }
    function handleToggleDateDisplayType() {
        setdateDisplayType(dateDisplayType === 'absolute' ? 'relative' : 'absolute');
    }
    function handleFilterChange(event) {
        props.org.setSearchFilterInformation(event.target.value, event.target.selectionStart, context);
    }
    function onBookmarkButtonClick() {
        if (bookmarkChosen) props.org.deleteBookmark(context, searchFilter);
        else if (canSaveBookmark) props.org.saveBookmark(context, searchFilter);
    }
    // On iOS, directly using the `autoFocus` prop on an input can cause the
    // input field to scroll off-screen when a drawer/modal appears and the
    // virtual keyboard slides up. The browser's attempt to scroll the focused
    // input into view can miscalculate due to the simultaneous UI changes.
    //
    // To mitigate this:
    // 1. On non-iOS devices: We programmatically focus the input with a slight
    //    delay (150ms). This allows the UI and keyboard animations to settle.
    // 2. On iOS devices: We now avoid auto-focusing altogether. The user
    //    will need to tap the input field to activate it. This provides a
    //    more stable experience on iOS.
    (0, $1bxDW.useEffect)(()=>{
        if (!(0, $fb511a1814e342c6$export$41a665f744414057)() && searchInputRef.current && context !== 'Clock List' && !activeClocks) {
            const timerId = setTimeout(()=>{
                if (searchInputRef.current) searchInputRef.current.focus();
            }, 150);
            return ()=>clearTimeout(timerId);
        }
    }, [
        context,
        activeClocks
    ]); // Re-run if context or activeClocks changes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, context === 'search' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "task-list__modal-title_search"
    }, showClockedTimes ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
        title: "Sum of time logged on all search results directly (not including time logged on their children)"
    }, (0, $e706118dde20dbed$export$4251c173c1ee6069)(clockedTime)) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "task-list__modal-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
        className: "agenda__title"
    }, (0, $1X5R2.capitalize)(context))), activeClocks ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search-input-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search-input-line"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("datalist", {
        id: "task-list__datalist-filter"
    }, (searchFilter.length === 0 ? bookmarks : searchFilterSuggestions).map((string, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
            key: idx,
            value: string
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search__input-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "text",
        value: searchFilter,
        // Disable auto-capitalization for convenience (autoComplete must also be off to
        // achieve this on Android).
        ref: searchInputRef,
        autoCapitalize: "none",
        autoComplete: "off",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('textfield', 'task-list__filter-input', {
            'task-list__filter-input--invalid': !!searchFilter && !searchFilterValid
        }),
        placeholder: "e.g. -DONE doc|man :simple|easy :assignee:nobody|none",
        list: "task-list__datalist-filter",
        onChange: handleFilterChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-lg bookmark__icon ', {
            'fa-star': !bookmarkChosen,
            'fa-trash': bookmarkChosen,
            bookmark__icon__enabled: canSaveBookmark
        }),
        onClick: onBookmarkButtonClick
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "task-list__headers-container",
        // On mobile devices, the Drawer already handles the touch
        // event. Hence, scrolling within the Drawers container does
        // not work with the same event. Therefore, we're just opting
        // to scroll the whole drawer. That's not the best UX. And a
        // better CSS juggler than me is welcome to improve on it.
        style: (0, $fb511a1814e342c6$export$cfca147fb13c9ee6) ? undefined : {
            overflow: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $ac83c3449b808737$export$2e2bcd8739ae039), {
        onHeaderClick: handleHeaderClick,
        dateDisplayType: dateDisplayType,
        onToggleDateDisplayType: handleToggleDateDisplayType,
        context: activeClocks ? 'Clock List' : context
    })));
}
const $8c0f5124fd4ee13d$var$mapStateToProps = (state)=>{
    return {
        path: state.org.present.get('path'),
        searchFilter: state.org.present.getIn([
            'search',
            'searchFilter'
        ]),
        searchFilterValid: state.org.present.getIn([
            'search',
            'searchFilterValid'
        ]),
        searchFilterSuggestions: state.org.present.getIn([
            'search',
            'searchFilterSuggestions'
        ]) || [],
        allBookmarks: state.org.present.get('bookmarks'),
        showClockedTimes: state.org.present.getIn([
            'search',
            'showClockedTimes'
        ]),
        clockedTime: state.org.present.getIn([
            'search',
            'clockedTime'
        ])
    };
};
const $8c0f5124fd4ee13d$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    });
var $8c0f5124fd4ee13d$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($8c0f5124fd4ee13d$var$mapStateToProps, $8c0f5124fd4ee13d$var$mapDispatchToProps)($8c0f5124fd4ee13d$var$SearchModal);




var $1bxDW = parcelRequire("1bxDW");



var $68adb449c0c8875e$export$2e2bcd8739ae039 = ({ children: children, shouldIncludeCloseButton: shouldIncludeCloseButton, onClose: onClose, maxSize: maxSize = false })=>{
    const [isVisible, setIsVisible] = (0, $1bxDW.useState)(false);
    const [dragOffsetY, setDragOffsetY] = (0, $1bxDW.useState)(null);
    (0, $1bxDW.useLayoutEffect)(()=>{
        setIsVisible(true);
    }, []);
    const initialClientY = (0, $1bxDW.useRef)();
    const innerContainer = (0, $1bxDW.useRef)();
    const innerContainerHeight = (0, $1bxDW.useRef)();
    (0, $1bxDW.useLayoutEffect)(()=>{
        innerContainerHeight.current = innerContainer.current.offsetHeight;
    });
    const handleInnerContainerClick = (event)=>event.stopPropagation();
    const handleClose = ()=>setIsVisible(false);
    const handleAnimationRest = ()=>!isVisible && !!onClose ? onClose() : void 0;
    const handleTouchStart = (event)=>initialClientY.current = event.targetTouches[0].clientY;
    const handleTouchMove = (event)=>{
        if (event.target.classList.contains('drag-handle')) return;
        const isScrollingDown = initialClientY.current > event.targetTouches[0].clientY;
        if (isScrollingDown && innerContainer.current.scrollHeight - innerContainer.current.scrollTop <= innerContainer.current.clientHeight) event.preventDefault();
        else if (!isScrollingDown && innerContainer.current.scrollTop === 0) {
            event.preventDefault();
            setDragOffsetY(event.targetTouches[0].clientY - initialClientY.current);
        }
    };
    (0, $1bxDW.useEffect)(()=>{
        const endInnerContainerDrag = ()=>{
            setIsVisible(dragOffsetY <= innerContainerHeight.current * 0.3);
            setDragOffsetY(null);
        };
        const handleTouchEndOrCancel = ()=>endInnerContainerDrag();
        if (!!innerContainer.current) {
            // Super annoying logic for disabling scrolling of the body when a slide up is active.
            // Briefly: if we're already at the top of our Drawer and trying to scroll up, disable
            // scrolling. Likewise, if we're already at the bottom of our Drawer and trying to scroll
            // down, disable scrolling.
            innerContainer.current.addEventListener('touchstart', handleTouchStart);
            innerContainer.current.addEventListener('touchmove', handleTouchMove);
            innerContainer.current.addEventListener('touchend', handleTouchEndOrCancel);
            innerContainer.current.addEventListener('touchcancel', handleTouchEndOrCancel);
            // Tmp variable for cleanup. Otherwise the linter will complain
            // that the `current` value will change. It suggested this tmp
            // variable.
            const innerContainerCurrent = innerContainer.current;
            return ()=>{
                innerContainerCurrent.removeEventListener('touchstart', handleTouchStart);
                innerContainerCurrent.removeEventListener('touchmove', handleTouchMove);
                innerContainerCurrent.removeEventListener('touchend', handleTouchEndOrCancel);
                innerContainerCurrent.removeEventListener('touchcancel', handleTouchEndOrCancel);
            };
        } else return null;
    }, [
        innerContainer,
        dragOffsetY
    ]);
    const outerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('drawer-outer-container', {
        'drawer-outer-container--visible': isVisible
    });
    const innerStyle = {
        offsetY: dragOffsetY || (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isVisible ? 0 : innerContainerHeight.current || window.innerHeight, {
            stiffness: 300
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
        style: innerStyle,
        onRest: handleAnimationRest
    }, (style)=>{
        const interpolatedStyle = {
            transform: `translateY(${style.offsetY}px)`
        };
        // For maximized drawers, there's different rules:
        if (maxSize) {
            interpolatedStyle.height = '92%';
            interpolatedStyle.overflow = 'none';
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: outerClassName,
            onClick: !!onClose ? handleClose : null,
            "data-testid": "drawer-outer-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            onClick: handleInnerContainerClick,
            className: "drawer-inner-container nice-scroll",
            "data-testid": "drawer",
            ref: innerContainer,
            style: interpolatedStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "drawer__grabber"
        }), shouldIncludeCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "fas fa-times fa-lg drawer__close-button",
            onClick: handleClose
        }), children));
    });
};



var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");


var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");



var $1X5R2 = parcelRequire("1X5R2");

class $60587c8efcbcb82d$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    componentDidUpdate(prevProps) {
        if (!this.props.header || !prevProps.header) return;
        const prevTags = prevProps.header.getIn([
            'titleLine',
            'tags'
        ]);
        const currentTags = this.props.header.getIn([
            'titleLine',
            'tags'
        ]);
        if (prevTags.size === currentTags.size - 1 && currentTags.last() === '') {
            if (this.lastTextfield) this.lastTextfield.focus();
        }
    }
    handleTagChange(tagIndex) {
        return (event)=>{
            const tags = this.props.header.getIn([
                'titleLine',
                'tags'
            ]);
            this.props.onChange(tags.set(tagIndex, event.target.value.replace(/(\s+|:)/g, '')));
        };
    }
    handleRemoveTag(tagIndex) {
        return ()=>{
            const tags = this.props.header.getIn([
                'titleLine',
                'tags'
            ]);
            this.props.onChange(tags.delete(tagIndex));
        };
    }
    handleAddNewTag() {
        const tags = this.props.header.getIn([
            'titleLine',
            'tags'
        ]);
        this.props.onChange(tags.push(''));
    }
    handleExistingTagClick(newTag) {
        return ()=>{
            const tags = this.props.header.getIn([
                'titleLine',
                'tags'
            ]);
            if (tags.includes(newTag)) this.props.onChange(tags.filter((tag)=>tag !== newTag));
            else this.props.onChange(tags.push(newTag));
        };
    }
    render() {
        const { header: header } = this.props;
        const { allTags: allTags } = this.state;
        const headerTags = header.getIn([
            'titleLine',
            'tags'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "drawer-modal__title",
            "data-testid": "tags-editor-modal-title"
        }, "Edit tags"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("datalist", {
            id: "drawer-modal__datalist-tag-names"
        }, allTags.map((tagName, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
                key: idx,
                value: tagName
            }))), headerTags.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "no-tags-message"
        }, "This header doesn't have any tags.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "Click the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus"
        }), " button to add a new one, or choose from the list of all of your tags below.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$423ec2075359570a), {
            droppableId: "tags-editor-droppable",
            type: "TAG"
        }, (provided, _snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
                className: "tags-container",
                ref: provided.innerRef
            }, provided.droppableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, headerTags.map((tag, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$f2a139e5d18b9882), {
                    draggableId: `tag--${index}`,
                    index: index,
                    key: index
                }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('tag-container', {
                            'tag-container--dragging': snapshot.isDragging
                        }),
                        ref: provided.innerRef
                    }, provided.draggableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
                        type: "text",
                        className: "textfield tag-container__textfield",
                        value: tag,
                        onChange: this.handleTagChange(index),
                        ref: (textfield)=>this.lastTextfield = textfield,
                        list: "drawer-modal__datalist-tag-names"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                        className: "tag-container__actions-container"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                        className: "fas fa-times fa-lg",
                        onClick: this.handleRemoveTag(index)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", (0, $frurs._)({
                        className: "fas fa-bars fa-lg tag-container__drag-handle drag-handle"
                    }, provided.dragHandleProps)))))), provided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "tags-editor__add-new-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "fas fa-plus fa-lg btn btn--circle",
            onClick: this.handleAddNewTag,
            "data-testid": "tags-editor-add-button"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("hr", {
            className: "tags-editor__separator"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "tags-editor__title"
        }, "All tags"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "all-tags-container",
            "data-testid": "tags-editor-all-tags-container"
        }, allTags.filter((tag)=>!!tag).map((tag)=>{
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('all-tags__tag', {
                'all-tags__tag--in-use': headerTags.includes(tag)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: className,
                key: tag,
                onClick: this.handleExistingTagClick(tag),
                "data-testid": `tags-editor-tag-${tag}`,
                "data-in-use": headerTags.includes(tag) ? 'true' : 'false'
            }, tag);
        })));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleRemoveTag',
            'handleAddNewTag',
            'handleTagChange'
        ]);
        this.state = {
            allTags: props.allTags
        };
    }
}



var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");








var $1X5R2 = parcelRequire("1X5R2");

class $7c8044a0b3f9d2c8$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    componentDidUpdate(prevProps) {
        const prevItems = prevProps.propertyListItems;
        const currentItems = this.props.propertyListItems;
        if (prevItems.size === currentItems.size - 1 && currentItems.last().get('property') === '') {
            if (this.lastTextfield) this.lastTextfield.focus();
        }
    }
    handlePropertyChange(propertyListItemId) {
        return (event)=>{
            const propertyListItemIndex = this.props.propertyListItems.findIndex((propertyListItem)=>propertyListItem.get('id') === propertyListItemId);
            this.props.onChange(this.props.propertyListItems.setIn([
                propertyListItemIndex,
                'property'
            ], event.target.value));
        };
    }
    handleValueChange(propertyListItemId) {
        return (event)=>{
            const { propertyListItems: propertyListItems, onChange: onChange } = this.props;
            const propertyListItemIndex = propertyListItems.findIndex((propertyListItem)=>propertyListItem.get('id') === propertyListItemId);
            onChange(propertyListItems.setIn([
                propertyListItemIndex,
                'value'
            ], (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(event.target.value))));
        };
    }
    handleRemoveItem(propertyListItemId) {
        return ()=>this.props.onChange(this.props.propertyListItems.filter((propertyListItem)=>propertyListItem.get('id') !== propertyListItemId));
    }
    handleAddNewItem() {
        this.props.onChange(this.props.propertyListItems.push((0, $3044e0bef3624137$exports.fromJS)({
            property: '',
            value: '',
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)()
        })));
    }
    render() {
        const { propertyListItems: propertyListItems, allOrgProperties: allOrgProperties } = this.props;
        const allPropertyNames = (0, $2ce140c2c56df8f2$export$dc7a29fc539d16a4)(allOrgProperties);
        const propertyListItemsWithAllPropVals = propertyListItems.map((p)=>{
            const propertyName = p.get('property');
            const allPropertyValues = (0, $2ce140c2c56df8f2$export$dda9638442af5e1c)(allOrgProperties, propertyName);
            return [
                p,
                allPropertyValues
            ];
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "drawer-modal__title",
            "data-testid": "property-list-editor-title"
        }, "Edit property list"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("datalist", {
            id: "drawer-modal__datalist-property-names"
        }, allPropertyNames.map((propertyName, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
                key: idx,
                value: propertyName
            }))), propertyListItems.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "no-items-message",
            "data-testid": "property-list-editor-no-items"
        }, "There are no items in this property list.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "Click the ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus"
        }), " button to add a new one.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$423ec2075359570a), {
            droppableId: "property-list-editor-droppable",
            type: "PROPERTY-LIST"
        }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
                className: "property-list-editor__items-container",
                ref: provided.innerRef
            }, provided.droppableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, propertyListItemsWithAllPropVals.map(([propertyListItem, allPropertyValues], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$f2a139e5d18b9882), {
                    draggableId: `property-list-item--${index}`,
                    index: index,
                    key: propertyListItem.get('id')
                }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('property-list-editor__item-container', {
                            'property-list-editor__item-container--dragging': snapshot.isDragging
                        }),
                        ref: provided.innerRef
                    }, provided.draggableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                        className: "item__textfields-container"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
                        type: "text",
                        className: "textfield item-container__textfield",
                        value: propertyListItem.get('property'),
                        onChange: this.handlePropertyChange(propertyListItem.get('id')),
                        ref: (textfield)=>this.lastTextfield = textfield,
                        list: "drawer-modal__datalist-property-names",
                        "data-testid": `property-list-editor-property-name-${index}`
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
                        type: "text",
                        className: "textfield item-container__textfield",
                        value: (0, $500d38b948046618$export$2c44f25459bb5dc7)(propertyListItem.get('value')),
                        onChange: this.handleValueChange(propertyListItem.get('id')),
                        list: `drawer-modal__datalist-property-${index}-values`,
                        "data-testid": `property-list-editor-property-value-${index}`
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("datalist", {
                        id: `drawer-modal__datalist-property-${index}-values`
                    }, allPropertyValues.map((propertyValue, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
                            key: idx,
                            value: propertyValue
                        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                        className: "item-container__actions-container"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
                        className: "fas fa-times fa-lg",
                        onClick: this.handleRemoveItem(propertyListItem.get('id'))
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", (0, $frurs._)({
                        className: "fas fa-bars fa-lg item-container__drag-handle drag-handle"
                    }, provided.dragHandleProps)))))), provided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "property-list-editor__add-new-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "fas fa-plus fa-lg btn btn--circle",
            onClick: this.handleAddNewItem,
            "data-testid": "property-list-editor-add-button"
        })));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleAddNewItem'
        ]);
    }
}



var $1bxDW = parcelRequire("1bxDW");


var $1bxDW = parcelRequire("1bxDW");





var $1bxDW = parcelRequire("1bxDW");



var $a97aa5012fd62680$export$2e2bcd8739ae039 = ({ isEnabled: isEnabled, onToggle: onToggle })=>{
    const disabledColor = (0, $e842057b65187aa8$export$e132662b5f319046)(255, 255, 255, 1);
    const enabledColor = (0, $e842057b65187aa8$export$e132662b5f319046)(238, 232, 213, 1);
    const switchStyle = {
        colorFactor: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isEnabled ? 1 : 0, {
            stiffness: 300
        })
    };
    const grabberStyle = {
        marginLeft: (0, $28a04c32d72d17fb$export$b36281d89752ae66)(isEnabled ? 42 : 0, {
            stiffness: 300
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
        style: switchStyle
    }, (style)=>{
        const backgroundColor = (0, $e842057b65187aa8$export$c6a9dd29cb601e01)((0, $e842057b65187aa8$export$ac51ceaa2f6fb770)(disabledColor, enabledColor, style.colorFactor));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "switch",
            style: {
                backgroundColor: backgroundColor
            },
            onClick: onToggle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28a04c32d72d17fb$export$ab7b018719e111db), {
            style: grabberStyle
        }, (style)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                className: "switch__grabber",
                style: style
            })));
    });
};








var $1X5R2 = parcelRequire("1X5R2");


class $cc4fabf0a23bb031$var$TimestampEditor extends (0, $1bxDW.PureComponent) {
    handleActiveToggle() {
        this.props.onChange(this.props.timestamp.update('isActive', (isActive)=>!isActive));
    }
    handleDateChange(event, planningItemIndex, timestampId) {
        // The user deleted the timestamp
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEmpty(event.target.value)) {
            // It's a planning item and the parser knows which one.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isNumber(planningItemIndex)) {
                if (this.props.onRemovePlanningItem) // Capture mode: remove from local state via callback
                this.props.onRemovePlanningItem(planningItemIndex);
                else this.props.org.removePlanningItem(this.props.headerId, planningItemIndex);
            } else if ((0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isNumber(timestampId)) this.props.org.removeTimestamp(this.props.headerId, timestampId);
            if (this.props.activePopupType !== 'scheduled-editor' && this.props.activePopupType !== 'deadline-editor') // for scheduled timestamp and deadline the modal can be open when no timestamp exists
            this.props.onClose();
        } else {
            const { onChange: onChange, timestamp: timestamp } = this.props;
            const [newYear, newMonth, newDay, newDayName] = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)((0, $da634cb494a596a5$export$2e2bcd8739ae039)(event.target.value), 'yyyy MM dd eee').split(' ');
            onChange(timestamp.set('year', newYear).set('month', newMonth).set('day', newDay).set('dayName', newDayName));
        }
    }
    handleAddTime(startOrEnd) {
        return ()=>{
            const { onChange: onChange, timestamp: timestamp } = this.props;
            const [hourKey, minuteKey] = startOrEnd === 'start' ? [
                'startHour',
                'startMinute'
            ] : [
                'endHour',
                'endMinute'
            ];
            const [hour, minute] = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'HH:mm').split(':');
            onChange(timestamp.set(hourKey, hour).set(minuteKey, minute));
        };
    }
    handleRemoveTime(startOrEnd) {
        return ()=>{
            const { onChange: onChange, timestamp: timestamp } = this.props;
            const [hourKey, minuteKey] = startOrEnd === 'start' ? [
                'startHour',
                'startMinute'
            ] : [
                'endHour',
                'endMinute'
            ];
            onChange(timestamp.set(hourKey, null).set(minuteKey, null));
        };
    }
    handleTimeChange(startOrEnd) {
        return (event)=>{
            const { onChange: onChange, timestamp: timestamp } = this.props;
            const [hourKey, minuteKey] = startOrEnd === 'start' ? [
                'startHour',
                'startMinute'
            ] : [
                'endHour',
                'endMinute'
            ];
            const [hour, minute] = event.target.value.split(':');
            onChange(timestamp.set(hourKey, hour).set(minuteKey, minute));
        };
    }
    handleAddRepeater() {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterType', '+').set('repeaterValue', 1).set('repeaterUnit', 'h'));
    }
    handleRemoveRepeater() {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterType', null).set('repeaterValue', null).set('repeaterUnit', null).set('repeaterDeadlineValue', null).set('repeaterDeadlineUnit', null));
    }
    handleRepeaterTypeChange(newRepeaterType) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterType', newRepeaterType));
    }
    handleRepeaterValueChange(event) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterValue', event.target.value));
    }
    handleRepeaterUnitChange(newRepeaterUnit) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterUnit', newRepeaterUnit));
    }
    handleRepeaterDeadlineValueChange(event) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        const newValue = event.target.value;
        // If user enters 0 or clears the value, remove the deadline part
        if (newValue === '0' || newValue === '') {
            onChange(timestamp.set('repeaterDeadlineValue', null).set('repeaterDeadlineUnit', null));
            return;
        }
        // If setting a deadline value and no unit is set yet, default to 'd' (days)
        if (newValue && !timestamp.get('repeaterDeadlineUnit')) onChange(timestamp.set('repeaterDeadlineValue', newValue).set('repeaterDeadlineUnit', 'd'));
        else onChange(timestamp.set('repeaterDeadlineValue', newValue));
    }
    handleRepeaterDeadlineUnitChange(newRepeaterDeadlineUnit) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('repeaterDeadlineUnit', newRepeaterDeadlineUnit));
    }
    handleAddDelay() {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('delayType', '-').set('delayValue', 1).set('delayUnit', 'h'));
    }
    handleRemoveDelay() {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('delayType', null).set('delayValue', null).set('delayUnit', null));
    }
    handleDelayTypeChange(newDelayType) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('delayType', newDelayType));
    }
    handleDelayValueChange(event) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('delayValue', event.target.value));
    }
    handleDelayUnitChange(newDelayUnit) {
        const { onChange: onChange, timestamp: timestamp } = this.props;
        onChange(timestamp.set('delayUnit', newDelayUnit));
    }
    renderTimeField(label, timeKey, hour, minute, showRemoveButton = true) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-container timestamp-editor__field-container--inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field"
        }, !!hour ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "time",
            className: "timestamp-editor__time-input",
            value: `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`,
            onChange: this.handleTimeChange(timeKey)
        }), showRemoveButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-times fa-lg timestamp-editor__icon timestamp-editor__icon--remove",
            onClick: this.handleRemoveTime(timeKey)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus timestamp-editor__icon timestamp-editor__icon--add",
            onClick: this.handleAddTime(timeKey)
        })));
    }
    renderRepeater() {
        const { repeaterType: repeaterType, repeaterValue: repeaterValue, repeaterUnit: repeaterUnit, repeaterDeadlineValue: repeaterDeadlineValue, repeaterDeadlineUnit: repeaterDeadlineUnit } = this.props.timestamp.toJS();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, "Repeater"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field timestamp-editor__field--delay-repeater"
        }, !!repeaterType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__delay-repeater-type"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: [
                '+',
                '++',
                '.+'
            ],
            titles: [
                'Shift exactly the amount of time in the repeater (i.e. one month for +1m).',
                'Shift the date by as many intervals of the amount of time in the repeater (i.e. one or many months for for ++1m) as it takes to get this date into the future.',
                'Shift the date exactly the amount of time of the repeater relative to the time of the state change.'
            ],
            selectedButton: repeaterType || '+',
            onSelect: this.handleRepeaterTypeChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "number",
            min: "1",
            className: "textfield delay-repeater-value-input",
            value: repeaterValue || 1,
            onChange: this.handleRepeaterValueChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: [
                'h',
                'd',
                'w',
                'm',
                'y'
            ],
            titles: [
                'hours',
                'days',
                'weeks',
                'months',
                'years'
            ],
            selectedButton: repeaterUnit || 'h',
            onSelect: this.handleRepeaterUnitChange
        })), repeaterType && this.props.activePopupType === 'scheduled-editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "timestamp-editor__slash"
        }, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "number",
            min: "0",
            className: "textfield delay-repeater-value-input",
            value: repeaterDeadlineValue || '',
            onChange: this.handleRepeaterDeadlineValueChange,
            placeholder: "Optional deadline"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: [
                'h',
                'd',
                'w',
                'm',
                'y'
            ],
            titles: [
                'hours',
                'days',
                'weeks',
                'months',
                'years'
            ],
            selectedButton: repeaterDeadlineUnit || 'd',
            onSelect: this.handleRepeaterDeadlineUnitChange
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-times fa-lg timestamp-editor__icon timestamp-editor__icon--remove",
            onClick: this.handleRemoveRepeater
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus timestamp-editor__icon timestamp-editor__icon--add",
            onClick: this.handleAddRepeater
        })));
    }
    renderDelay() {
        const { delayType: delayType, delayValue: delayValue, delayUnit: delayUnit } = this.props.timestamp.toJS();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, "Delay"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field"
        }, !!delayType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__delay-repeater-type"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: [
                '-',
                '--'
            ],
            titles: [
                'Set a different lead time before the entry is put into the agenda.',
                "In case the task contains a repeater, the delay is considered to affect all occurrences; if you want the delay to only affect the first scheduled occurrence of the task, use '--' instead."
            ],
            selectedButton: delayType || '-',
            onSelect: this.handleDelayTypeChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "number",
            min: "1",
            className: "textfield delay-repeater-value-input",
            value: delayValue || 1,
            onChange: this.handleDelayValueChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: [
                'h',
                'd',
                'w',
                'm',
                'y'
            ],
            titles: [
                'hours',
                'days',
                'weeks',
                'months',
                'years'
            ],
            selectedButton: delayUnit || 'h',
            onSelect: this.handleDelayUnitChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-times fa-lg timestamp-editor__icon timestamp-editor__icon--remove",
            onClick: this.handleRemoveDelay
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus timestamp-editor__icon timestamp-editor__icon--add",
            onClick: this.handleAddDelay
        })));
    }
    createPlanningItem() {
        const { selectedHeaderId: selectedHeaderId, header: header, activePopupType: activePopupType, onCreatePlanningItem: onCreatePlanningItem } = this.props;
        const planningType = {
            'deadline-editor': 'DEADLINE',
            'scheduled-editor': 'SCHEDULED'
        }[activePopupType];
        if (onCreatePlanningItem) // Capture mode: add planning item to local state via callback
        onCreatePlanningItem(planningType);
        else {
            this.props.org.addNewPlanningItem(selectedHeaderId, planningType);
            this.props.base.activatePopup(activePopupType, {
                headerId: selectedHeaderId,
                planningItemIndex: header.get('planningItems').size
            });
        }
    }
    render() {
        const { timestamp: timestamp, timestampId: timestampId, planningItemIndex: planningItemIndex } = this.props;
        if (!timestamp) // for scheduled timestamp and deadline the modal can be opened when no timestamp exists
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, "Add Timestamp"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus timestamp-editor__icon timestamp-editor__icon--add",
            onClick: this.createPlanningItem
        })));
        const { isActive: isActive, year: year, month: month, day: day, startHour: startHour, startMinute: startMinute, endHour: endHour, endMinute: endMinute } = timestamp.toJS();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__render"
        }, (0, $e706118dde20dbed$export$96c990e4d9eca709)(timestamp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__date-time-fields-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-container timestamp-editor__field-container--inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, "Active"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: isActive,
            onToggle: this.handleActiveToggle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-container timestamp-editor__field-container--inline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field-title"
        }, "Date"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            "data-testid": "timestamp-selector",
            type: "date",
            className: "timestamp-editor__date-input",
            onChange: (event)=>this.handleDateChange(event, planningItemIndex, timestampId),
            // Needed for iOS due to React bug
            // https://github.com/facebook/react/issues/8938#issuecomment-519074141
            onFocus: (event)=>event.nativeEvent.target.defaultValue = '',
            value: `${year}-${month}-${day}`
        }))), this.renderTimeField('Start time', 'start', startHour, startMinute, !endHour), !!startHour && this.renderTimeField('End time', 'end', endHour, endMinute)), this.renderRepeater(), this.renderDelay());
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleActiveToggle',
            'handleDateChange',
            'handleAddRepeater',
            'handleRemoveRepeater',
            'handleRepeaterTypeChange',
            'handleRepeaterValueChange',
            'handleRepeaterUnitChange',
            'handleRepeaterDeadlineValueChange',
            'handleRepeaterDeadlineUnitChange',
            'handleAddDelay',
            'handleRemoveDelay',
            'handleDelayTypeChange',
            'handleDelayValueChange',
            'handleDelayUnitChange',
            'createPlanningItem'
        ]);
    }
}
const $cc4fabf0a23bb031$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const activePopup = state.base.get('activePopup');
    return {
        selectedHeaderId: file.get('selectedHeaderId'),
        header: (0, $2ce140c2c56df8f2$export$a741dccf9e227875)(state),
        activePopupType: !!activePopup ? activePopup.get('type') : null,
        activePopupData: !!activePopup ? activePopup.get('data') : null
    };
};
const $cc4fabf0a23bb031$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    });
var $cc4fabf0a23bb031$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($cc4fabf0a23bb031$var$mapStateToProps, $cc4fabf0a23bb031$var$mapDispatchToProps)($cc4fabf0a23bb031$var$TimestampEditor);



var $1X5R2 = parcelRequire("1X5R2");


class $f2d246257a5a5d13$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleChange(key) {
        return (newTimestamp)=>this.props.onChange(this.props.timestamp.set(key, newTimestamp));
    }
    handleAddEndTimestamp() {
        const { timestamp: timestamp } = this.props;
        const [year, month, day, dayName] = (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(new Date(), 'yyyy MM dd eee').split(' ');
        this.props.onChange(timestamp.set('secondTimestamp', (0, $3044e0bef3624137$exports.Map)({
            year: year,
            month: month,
            day: day,
            dayName: dayName,
            isActive: timestamp.getIn([
                'firstTimestamp',
                'isActive'
            ])
        })));
    }
    handleRemoveEndTimestamp() {
        this.props.onChange(this.props.timestamp.set('secondTimestamp', null));
    }
    render() {
        const { headerId: headerId, timestamp: timestamp, timestampId: timestampId, popupType: popupType, onClose: onClose, singleTimestampOnly: singleTimestampOnly, planningItemIndex: planningItemIndex } = this.props;
        const timestampTitles = {
            'timestamp-editor': 'Edit timestamp',
            'scheduled-editor': 'Edit scheduled timestamp',
            'deadline-editor': 'Edit deadline'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "timestamp-editor__title"
        }, timestampTitles[popupType]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $cc4fabf0a23bb031$export$2e2bcd8739ae039), {
            headerId: headerId,
            timestamp: timestamp && timestamp.get('firstTimestamp'),
            timestampId: timestampId,
            planningItemIndex: planningItemIndex,
            onClose: onClose,
            onChange: this.handleChange('firstTimestamp'),
            onCreatePlanningItem: this.props.onCreatePlanningItem,
            onRemovePlanningItem: this.props.onRemovePlanningItem
        }), !singleTimestampOnly && (!!timestamp.get('secondTimestamp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__separator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__separator__margin-line"
        }), "to", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__separator__margin-line"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $cc4fabf0a23bb031$export$2e2bcd8739ae039), {
            headerId: headerId,
            timestamp: timestamp.get('secondTimestamp'),
            timestampId: timestampId,
            onChange: this.handleChange('secondTimestamp')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn timestamp-editor__add-new-button",
            onClick: this.handleRemoveEndTimestamp
        }, "Remove end timestamp"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "timestamp-editor__button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn timestamp-editor__add-new-button",
            onClick: this.handleAddEndTimestamp
        }, "Add end timestamp"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleAddEndTimestamp',
            'handleRemoveEndTimestamp'
        ]);
    }
}



var $1bxDW = parcelRequire("1bxDW");






var $1X5R2 = parcelRequire("1X5R2");
class $be9324b6f9359222$var$NoteEditorModal extends (0, $1bxDW.PureComponent) {
    handleTextareaRef(textarea) {
        this.textarea = textarea;
    }
    addNote() {
        let { note: note } = this.state;
        if (note !== null) note = note.trim();
        if (!note) return;
        if (this.props.onAddNote) this.props.onAddNote(note, new Date());
        else this.props.org.addNote(note, new Date());
        this.setState({
            note: ''
        });
    }
    handleNoteFieldClick(event) {
        event.stopPropagation();
    }
    handleDescriptionChange(event) {
        this.setState({
            note: event.target.value
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "drawer-modal__title"
        }, "Add note"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Enter a note to add to the header:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
            autoFocus: true,
            className: "textarea drag-handle",
            "data-testid": "titleLineInput",
            rows: "3",
            ref: this.handleTextareaRef,
            value: this.state.note,
            onClick: this.handleNoteFieldClick,
            onChange: this.handleDescriptionChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn note-editor__done-btn",
            onClick: ()=>this.addNote()
        }, "Add"));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTextareaRef',
            'addNote',
            'handleDescriptionChange'
        ]);
        this.state = {
            allTags: props.allTags,
            note: ''
        };
    }
}
const $be9324b6f9359222$var$mapDispatchToProps = (dispatch)=>{
    return {
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch),
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    };
};
var $be9324b6f9359222$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)(null, $be9324b6f9359222$var$mapDispatchToProps)($be9324b6f9359222$var$NoteEditorModal);



var $1bxDW = parcelRequire("1bxDW");







var $1X5R2 = parcelRequire("1X5R2");

var $1bxDW = parcelRequire("1bxDW");

class $a04c09d3a2720657$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    // A nasty hack required to get click handling to work properly in Firefox. No idea why its
    // broken in the first place or why this fixes it.
    iconWithFFClickCatcher({ className: className, onClick: onClick, title: title, disabled: disabled, testId: testId = '' }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            title: title,
            onClick: !disabled ? onClick : undefined,
            className: "header-action-drawer__ff-click-catcher-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer__ff-click-catcher"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: className,
            "data-testid": testId
        }));
    }
    render() {
        const { onSwitch: onSwitch, onTitleClick: onTitleClick, onDescriptionClick: onDescriptionClick, onTagsClick: onTagsClick, onPropertiesClick: onPropertiesClick, onDeadlineClick: onDeadlineClick, onScheduledClick: onScheduledClick, onAddNote: onAddNote, onRemoveHeader: onRemoveHeader, activePopupType: activePopupType, editRawValues: editRawValues, setEditRawValues: setEditRawValues, restorePreferEditRawValues: restorePreferEditRawValues } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-action-drawer__row"
        }, this.iconWithFFClickCatcher({
            className: 'fas fa-pencil-alt fa-lg' + ('title-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: ()=>{
                if ('title-editor' === activePopupType) {
                    onSwitch();
                    setEditRawValues(!editRawValues);
                } else restorePreferEditRawValues();
                onTitleClick();
            },
            title: 'Edit title',
            testId: 'drawer-action-edit-title'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-edit fa-lg' + ('description-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: ()=>{
                if ('description-editor' === activePopupType) {
                    onSwitch();
                    setEditRawValues(!editRawValues);
                } else restorePreferEditRawValues();
                onDescriptionClick();
            },
            title: 'Edit description',
            testId: 'edit-header-title'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-tags fa-lg' + ('tags-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onTagsClick,
            title: 'Modify tags',
            disabled: 'tags-editor' === activePopupType,
            testId: 'drawer-action-tags'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-list fa-lg' + ('property-list-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onPropertiesClick,
            title: 'Modify properties',
            disabled: 'property-list-editor' === activePopupType,
            testId: 'drawer-action-properties'
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-calendar-check fa-lg' + ('deadline-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onDeadlineClick,
            title: 'Set deadline datetime',
            disabled: 'deadline-editor' === activePopupType,
            testId: 'drawer-action-deadline'
        }), this.iconWithFFClickCatcher({
            className: 'far fa-calendar-check fa-lg' + ('scheduled-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onScheduledClick,
            title: 'Set scheduled datetime',
            disabled: 'scheduled-editor' === activePopupType,
            testId: 'drawer-action-scheduled'
        }), this.iconWithFFClickCatcher({
            className: 'far fa-sticky-note fa-lg' + ('note-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onAddNote,
            title: 'Add a note',
            disabled: 'note-editor' === activePopupType
        }), this.iconWithFFClickCatcher({
            className: 'fas fa-trash fa-lg' + ('note-editor' === activePopupType ? ' drawer-action-button--selected' : ''),
            onClick: onRemoveHeader,
            title: 'Delete this header',
            disabled: 'note-editor' === activePopupType
        })));
    }
}



class $4746b61cd4c9d8b3$var$DrawerActionBar extends (0, $1bxDW.PureComponent) {
    handleShowTitleEditModal() {
        this.props.onSwitch();
        this.props.base.activatePopup('title-editor');
    }
    handleShowDescriptionEditModal() {
        this.props.onSwitch();
        if (!this.props.captureMode && this.props.selectedHeaderId) this.props.org.openHeader(this.props.selectedHeaderId);
        this.props.base.activatePopup('description-editor');
    }
    handleShowTagsModal() {
        this.props.onSwitch();
        this.props.base.activatePopup('tags-editor');
    }
    handleShowPropertyListEditorModal() {
        this.props.onSwitch();
        this.props.base.activatePopup('property-list-editor');
    }
    handleDeadlineAndScheduledClick(planningType) {
        const { captureMode: captureMode, captureHeader: captureHeader, header: header, selectedHeaderId: selectedHeaderId } = this.props;
        const activeHeader = captureMode ? captureHeader : header;
        const popupType = {
            DEADLINE: 'deadline-editor',
            SCHEDULED: 'scheduled-editor'
        }[planningType];
        const existingDeadlinePlanningItemIndex = activeHeader ? activeHeader.get('planningItems', []).findIndex((planningItem)=>planningItem.get('type') === planningType) : -1;
        this.props.base.activatePopup(popupType, {
            headerId: activeHeader ? activeHeader.get('id') : null,
            planningItemIndex: existingDeadlinePlanningItemIndex
        });
        if (!captureMode && selectedHeaderId) this.props.org.openHeader(selectedHeaderId);
    }
    handleShowDeadlineModal() {
        this.props.onSwitch();
        this.handleDeadlineAndScheduledClick('DEADLINE');
    }
    handleShowScheduledModal() {
        this.props.onSwitch();
        this.handleDeadlineAndScheduledClick('SCHEDULED');
    }
    handleShowNoteModal() {
        this.props.onSwitch();
        this.props.base.activatePopup('note-editor');
    }
    handleRemoveHeader() {
        if (this.props.captureMode) {
            // In capture mode, "delete" discards the capture by closing the popup
            this.props.base.closePopup();
            return;
        }
        this.props.base.closePopup();
        this.props.org.selectHeader(null);
        this.props.org.removeHeader(this.props.header.get('id'));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "static-action-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a04c09d3a2720657$export$2e2bcd8739ae039), {
            activePopupType: this.props.activePopupType,
            onSwitch: this.props.onSwitch,
            onTitleClick: this.handleShowTitleEditModal,
            onDescriptionClick: this.handleShowDescriptionEditModal,
            onTagsClick: this.handleShowTagsModal,
            onPropertiesClick: this.handleShowPropertyListEditorModal,
            onDeadlineClick: this.handleShowDeadlineModal,
            onScheduledClick: this.handleShowScheduledModal,
            onAddNote: this.handleShowNoteModal,
            onRemoveHeader: this.handleRemoveHeader,
            editRawValues: this.props.editRawValues,
            setEditRawValues: this.props.setEditRawValues,
            restorePreferEditRawValues: this.props.restorePreferEditRawValues
        }));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleShowTitleEditModal',
            'handleShowDescriptionEditModal',
            'handleShowTagsModal',
            'handleShowPropertyListEditorModal',
            'handleShowDeadlineModal',
            'handleShowScheduledModal',
            'handleShowNoteModal',
            'handleRemoveHeader'
        ]);
    }
}
const $4746b61cd4c9d8b3$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const activePopup = state.base.get('activePopup');
    return {
        selectedHeaderId: file.get('selectedHeaderId'),
        header: (0, $2ce140c2c56df8f2$export$a741dccf9e227875)(state),
        activePopupType: !!activePopup ? activePopup.get('type') : null
    };
};
const $4746b61cd4c9d8b3$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $4746b61cd4c9d8b3$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($4746b61cd4c9d8b3$var$mapStateToProps, $4746b61cd4c9d8b3$var$mapDispatchToProps)($4746b61cd4c9d8b3$var$DrawerActionBar);






const $9c898491955a8deb$export$c9955f88b8688002 = [
    'title-editor',
    'description-editor',
    'tags-editor',
    'property-list-editor',
    'timestamp-editor',
    'scheduled-editor',
    'deadline-editor',
    'note-editor'
];
class $9c898491955a8deb$var$UnifiedHeaderEditor extends (0, $1bxDW.PureComponent) {
    // --- Title editor methods ---
    handleTitleTextareaRef(textarea) {
        this.titleTextarea = textarea;
    }
    handleTitleTextareaFocus(event) {
        const { selectedHeader: selectedHeader } = this.props;
        if (!selectedHeader) return;
        const rawTitle = selectedHeader.getIn([
            'titleLine',
            'rawTitle'
        ]);
        if (rawTitle === '') {
            const text = event.target.value;
            event.target.selectionStart = text.length;
            event.target.selectionEnd = text.length;
        }
    }
    handleTitleChange(event) {
        const newTitle = event.target.value;
        const lastCharacter = newTitle[newTitle.length - 1];
        if (this.state.titleValue === newTitle.substring(0, newTitle.length - 1) && lastCharacter === '\n') {
            this.props.getPopupCloseAction('title-editor')(newTitle);
            return;
        }
        this.setState({
            titleValue: newTitle
        });
    }
    handleTitleFieldClick(event) {
        event.stopPropagation();
    }
    calculateRawTitle(header) {
        return (0, $500d38b948046618$export$907554d307802b74)(header.toJS(), false);
    }
    handleTitleInsertTimestamp(event) {
        const { titleValue: titleValue } = this.state;
        const insertionIndex = this.titleTextarea.selectionStart;
        this.setState({
            titleValue: titleValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + titleValue.substring(this.titleTextarea.selectionEnd || insertionIndex)
        });
        this.titleTextarea.focus();
        event.stopPropagation();
    }
    handleTitleTodoChange(newTodoKeyword) {
        const currentTodoKeyword = this.props.selectedHeader ? this.props.selectedHeader.getIn([
            'titleLine',
            'todoKeyword'
        ]) : undefined;
        const keyword = currentTodoKeyword === newTodoKeyword ? '' : newTodoKeyword;
        this.props.saveTitle(this.state.titleValue);
        this.props.handleTodoChange(keyword);
    }
    handleNextTodoKeywordSet() {
        const { todoKeywordSets: todoKeywordSets } = this.props;
        const newIndex = this.state.todoKeywordSetIndex + 1 !== todoKeywordSets.size ? this.state.todoKeywordSetIndex + 1 : 0;
        const newTodoKeywordSet = newIndex !== todoKeywordSets.size ? todoKeywordSets.get(newIndex) : todoKeywordSets.get(0);
        this.setState({
            todoKeywordSet: newTodoKeywordSet,
            todoKeywordSetIndex: newIndex
        });
    }
    // --- Description editor methods ---
    handleDescriptionTextareaRef(textarea) {
        this.descriptionTextarea = textarea;
    }
    calculateRawDescription(header) {
        const dontIndent = this.props.dontIndent;
        return (0, $500d38b948046618$export$5f409df9aafd0448)(header, false, dontIndent);
    }
    descriptionModifier(event) {
        const { target: { value: value } } = event;
        const eachValList = value.split('\n');
        eachValList.forEach((item, index)=>{
            if (item.startsWith('* ')) eachValList[index] = '- ' + item.slice(2);
        });
        return eachValList.join('\n');
    }
    handleDescriptionChange(event) {
        this.setState({
            descriptionValue: this.descriptionModifier(event)
        });
    }
    handleDescriptionKeyDown(event) {
        if (event.key !== 'Enter') return;
        const textarea = this.descriptionTextarea;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = textarea;
        const { descriptionValue: descriptionValue } = this.state;
        const textBeforeCursor = descriptionValue.substring(0, selectionStart);
        const lastNewlineIndex = textBeforeCursor.lastIndexOf('\n');
        const currentLine = textBeforeCursor.substring(lastNewlineIndex + 1);
        // Check for ordered list: "1. item" or "  2) item"
        const orderedMatch = currentLine.match(/^(\s*)(\d+)([.)]) (.*)$/);
        if (orderedMatch) {
            const [, indent, num, separator, content] = orderedMatch;
            event.preventDefault();
            if (content.trim() === '') {
                // Empty item — remove the prefix to exit list mode
                const lineStart = lastNewlineIndex + 1;
                const newValue = descriptionValue.substring(0, lineStart) + descriptionValue.substring(selectionStart);
                this.setState({
                    descriptionValue: newValue
                }, ()=>{
                    textarea.selectionStart = lineStart;
                    textarea.selectionEnd = lineStart;
                });
            } else {
                const nextNum = parseInt(num, 10) + 1;
                const prefix = '\n' + indent + nextNum + separator + ' ';
                const newValue = descriptionValue.substring(0, selectionStart) + prefix + descriptionValue.substring(selectionEnd);
                this.setState({
                    descriptionValue: newValue
                }, ()=>{
                    const newCursorPos = selectionStart + prefix.length;
                    textarea.selectionStart = newCursorPos;
                    textarea.selectionEnd = newCursorPos;
                });
            }
            return;
        }
        // Check for unordered list: "- item" or "  + item",
        // optionally followed by a checkbox ("[ ]", "[X], "[-]")
        const unorderedMatch = currentLine.match(/^(\s*)([-+]) (\[[-X ]] )?(.*)$/);
        if (unorderedMatch) {
            const [, indent, bullet, optionalCheckbox, content] = unorderedMatch;
            const checkbox = optionalCheckbox ? optionalCheckbox : '';
            event.preventDefault();
            if (content.trim() === '') {
                // Empty item — remove the prefix to exit list mode
                const lineStart = lastNewlineIndex + 1;
                const newValue = descriptionValue.substring(0, lineStart) + descriptionValue.substring(selectionStart);
                this.setState({
                    descriptionValue: newValue
                }, ()=>{
                    textarea.selectionStart = lineStart;
                    textarea.selectionEnd = lineStart;
                });
            } else {
                const prefix = '\n' + indent + bullet + ' ';
                const newValue = descriptionValue.substring(0, selectionStart) + prefix + checkbox + descriptionValue.substring(selectionEnd);
                this.setState({
                    descriptionValue: newValue
                }, ()=>{
                    const newCursorPos = selectionStart + prefix.length + checkbox.length;
                    textarea.selectionStart = newCursorPos;
                    textarea.selectionEnd = newCursorPos;
                });
            }
            return;
        }
    }
    handleDescriptionInsertTimestamp() {
        const { descriptionValue: descriptionValue } = this.state;
        const insertionIndex = this.descriptionTextarea.selectionStart;
        this.setState({
            descriptionValue: descriptionValue.substring(0, insertionIndex) + (0, $e706118dde20dbed$export$29bd541c4eb8fcfe)() + descriptionValue.substring(this.descriptionTextarea.selectionEnd || insertionIndex)
        });
        this.descriptionTextarea.focus();
    }
    // --- Lifecycle ---
    componentDidMount() {
        this.updateCloseActionAccessor();
        // Title textarea: ensure cursor is at end after mount
        if (this.props.activePopupType === 'title-editor' && this.titleTextarea) {
            const len = this.titleTextarea.value.length;
            this.titleTextarea.selectionStart = len;
            this.titleTextarea.selectionEnd = len;
        }
    }
    componentDidUpdate(prevProps) {
        const { selectedHeader: selectedHeader, editRawValues: editRawValues, activePopupType: activePopupType } = this.props;
        // Update close action accessor when sub-editor changes
        if (prevProps.activePopupType !== activePopupType) this.updateCloseActionAccessor();
        if (!selectedHeader) return;
        if (prevProps.selectedHeader !== selectedHeader || prevProps.editRawValues !== editRawValues) {
            if (activePopupType === 'title-editor') {
                this.setState({
                    titleValue: editRawValues ? this.calculateRawTitle(selectedHeader) : selectedHeader.getIn([
                        'titleLine',
                        'rawTitle'
                    ])
                });
                if (this.titleTextarea) this.titleTextarea.focus();
            }
            if (activePopupType === 'description-editor') {
                this.setState({
                    descriptionValue: editRawValues ? this.calculateRawDescription(selectedHeader) : selectedHeader.get('rawDescription')
                });
                if (this.descriptionTextarea) this.descriptionTextarea.focus();
            }
        }
    }
    updateCloseActionAccessor() {
        const { activePopupType: activePopupType, setPopupCloseActionValuesAccessor: setPopupCloseActionValuesAccessor } = this.props;
        if (activePopupType === 'title-editor') setPopupCloseActionValuesAccessor(()=>[
                this.state.titleValue
            ]);
        else if (activePopupType === 'description-editor') setPopupCloseActionValuesAccessor(()=>[
                this.state.descriptionValue
            ]);
    }
    // --- Render sub-editors ---
    renderTitleEditor() {
        const { editRawValues: editRawValues, selectedHeader: selectedHeader, todoKeywordSets: todoKeywordSets } = this.props;
        const { todoKeywordSet: todoKeywordSet, titleValue: titleValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "drawer-modal__title"
        }, editRawValues ? 'Edit full title' : 'Edit title'), editRawValues ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "todo-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: todoKeywordSet.get('keywords').filter((todo)=>todoKeywordSet.get('completedKeywords').filter((completed)=>todo === completed).size === 0),
            selectedButton: selectedHeader ? selectedHeader.getIn([
                'titleLine',
                'todoKeyword'
            ]) : undefined,
            onSelect: this.handleTitleTodoChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
            buttons: todoKeywordSet.get('completedKeywords').filter((todo)=>todo !== ''),
            selectedButton: selectedHeader ? selectedHeader.getIn([
                'titleLine',
                'todoKeyword'
            ]) : undefined,
            onSelect: this.handleTitleTodoChange
        }), todoKeywordSets.size > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn-passive",
            onClick: this.handleNextTodoKeywordSet,
            title: "Next keyword set"
        }, "Next set") : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "title-line__edit-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
            autoFocus: true,
            className: "textarea drag-handle",
            "data-testid": "titleLineInput",
            rows: "3",
            ref: this.handleTitleTextareaRef,
            value: titleValue,
            onFocus: this.handleTitleTextareaFocus,
            onChange: this.handleTitleChange,
            onClick: this.handleTitleFieldClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "title-line__insert-timestamp-button",
            onClick: this.handleTitleInsertTimestamp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus insert-timestamp-icon"
        }), "Insert timestamp")));
    }
    renderDescriptionEditor() {
        const { editRawValues: editRawValues } = this.props;
        const { descriptionValue: descriptionValue, editorDescriptionHeightValue: editorDescriptionHeightValue } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", {
            className: "drawer-modal__title"
        }, editRawValues ? 'Edit full description' : 'Edit description'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-content__edit-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
            autoFocus: true,
            className: "textarea drag-handle",
            "data-testid": "description-textarea",
            rows: (0, $fb511a1814e342c6$export$cfca147fb13c9ee6) ? '8' : editorDescriptionHeightValue,
            ref: this.handleDescriptionTextareaRef,
            value: descriptionValue,
            onChange: this.handleDescriptionChange,
            onKeyDown: this.handleDescriptionKeyDown
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "header-content__insert-timestamp-button",
            onClick: this.handleDescriptionInsertTimestamp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus insert-timestamp-icon"
        }), "Insert timestamp")));
    }
    renderSubEditor() {
        const { activePopupType: activePopupType, activePopupData: activePopupData, selectedHeader: selectedHeader, headers: headers, shouldDisableActions: shouldDisableActions, handleTagsChange: handleTagsChange, handlePropertyListItemsChange: handlePropertyListItemsChange, handleTimestampChange: handleTimestampChange, onCreatePlanningItem: onCreatePlanningItem, onRemovePlanningItem: onRemovePlanningItem, allTags: allTags, allOrgProperties: allOrgProperties, getPopupCloseAction: getPopupCloseAction } = this.props;
        switch(activePopupType){
            case 'title-editor':
                return this.renderTitleEditor();
            case 'description-editor':
                return this.renderDescriptionEditor();
            case 'tags-editor':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $60587c8efcbcb82d$export$2e2bcd8739ae039), {
                    header: selectedHeader,
                    allTags: allTags,
                    onChange: handleTagsChange
                });
            case 'property-list-editor':
                return selectedHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $7c8044a0b3f9d2c8$export$2e2bcd8739ae039), {
                    onChange: handlePropertyListItemsChange,
                    propertyListItems: selectedHeader.get('propertyListItems'),
                    allOrgProperties: allOrgProperties
                }) : null;
            case 'timestamp-editor':
            case 'scheduled-editor':
            case 'deadline-editor':
                let editingTimestamp = null;
                const captureMode = this.props.captureMode;
                const headerId = activePopupData.get('headerId');
                const resolvedHeader = captureMode ? selectedHeader : (0, $2ce140c2c56df8f2$export$afc3b74231ba89f6)(headers, headerId);
                if (activePopupData.get('timestampId')) editingTimestamp = captureMode ? null : (0, $2ce140c2c56df8f2$export$f846250bab1767a)(headers, activePopupData.get('timestampId'));
                else if (activePopupData.get('logEntryIndex') !== undefined) editingTimestamp = resolvedHeader ? (0, $3044e0bef3624137$exports.fromJS)({
                    firstTimestamp: resolvedHeader.getIn([
                        'logBookEntries',
                        activePopupData.get('logEntryIndex'),
                        activePopupData.get('entryType')
                    ])
                }) : null;
                else if (activePopupType !== 'scheduled-editor' && activePopupType !== 'deadline-editor' || activePopupData.get('planningItemIndex') !== -1) editingTimestamp = resolvedHeader ? (0, $3044e0bef3624137$exports.fromJS)({
                    firstTimestamp: resolvedHeader.getIn([
                        'planningItems',
                        activePopupData.get('planningItemIndex'),
                        'timestamp'
                    ])
                }) : null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $f2d246257a5a5d13$export$2e2bcd8739ae039), {
                    headerId: activePopupData.get('headerId'),
                    timestamp: editingTimestamp,
                    timestampId: activePopupData.get('timestampId'),
                    popupType: activePopupType,
                    planningItemIndex: activePopupData.get('planningItemIndex'),
                    singleTimestampOnly: !activePopupData.get('timestampId'),
                    onClose: getPopupCloseAction(activePopupType),
                    onChange: handleTimestampChange(activePopupData),
                    onCreatePlanningItem: onCreatePlanningItem,
                    onRemovePlanningItem: onRemovePlanningItem
                });
            case 'note-editor':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $be9324b6f9359222$export$2e2bcd8739ae039), {
                    shouldDisableActions: shouldDisableActions,
                    onAddNote: this.props.onAddNote
                });
            default:
                return null;
        }
    }
    render() {
        const { onSwitch: onSwitch, editRawValues: editRawValues, setEditRawValues: setEditRawValues, restorePreferEditRawValues: restorePreferEditRawValues, captureMode: captureMode, captureTemplate: captureTemplate, captureShouldPrepend: captureShouldPrepend, onCapture: onCapture, onTogglePrepend: onTogglePrepend, selectedHeader: selectedHeader } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "unified-header-editor",
            "data-testid": "unified-header-editor"
        }, captureMode && captureTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-header-bar",
            "data-testid": "capture-header-bar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-header-bar__template-info"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "capture-header-bar__letter"
        }, captureTemplate.get('letter')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "capture-header-bar__description",
            "data-testid": "capture-template-description"
        }, captureTemplate.get('description'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-header-bar__controls"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("label", {
            className: "capture-header-bar__prepend-toggle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "checkbox",
            checked: captureShouldPrepend,
            onChange: onTogglePrepend,
            "data-testid": "capture-prepend-checkbox"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", null, "Prepend")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn capture-header-bar__capture-btn",
            onClick: onCapture,
            "data-testid": "capture-confirm-button"
        }, "Capture"))), this.renderSubEditor(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $4746b61cd4c9d8b3$export$2e2bcd8739ae039), {
            onSwitch: onSwitch,
            editRawValues: editRawValues,
            setEditRawValues: setEditRawValues,
            restorePreferEditRawValues: restorePreferEditRawValues,
            captureMode: captureMode,
            captureHeader: captureMode ? selectedHeader : null
        }));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleTitleTextareaRef',
            'handleTitleTextareaFocus',
            'handleTitleChange',
            'handleTitleFieldClick',
            'handleTitleInsertTimestamp',
            'handleTitleTodoChange',
            'handleNextTodoKeywordSet',
            'handleDescriptionTextareaRef',
            'handleDescriptionChange',
            'handleDescriptionKeyDown',
            'handleDescriptionInsertTimestamp'
        ]);
        const header = props.selectedHeader;
        // Title editor state
        const todoKeywordSet = (0, $2ce140c2c56df8f2$export$2775d13f49f665b)(props.todoKeywordSets, header ? header.getIn([
            'titleLine',
            'todoKeyword'
        ]) : undefined);
        this.state = {
            todoKeywordSet: // Title state
            todoKeywordSet,
            todoKeywordSetIndex: props.todoKeywordSets ? props.todoKeywordSets.indexOf(todoKeywordSet) : 0,
            titleValue: header ? props.editRawValues ? this.calculateRawTitle(header) : header.getIn([
                'titleLine',
                'rawTitle'
            ]) : '',
            // Description state
            descriptionValue: header ? props.editRawValues ? this.calculateRawDescription(header) : header.get('rawDescription') : '',
            editorDescriptionHeightValue: props.editorDescriptionHeightValue ? props.editorDescriptionHeightValue : '8'
        };
    }
}
var $9c898491955a8deb$export$2e2bcd8739ae039 = $9c898491955a8deb$var$UnifiedHeaderEditor;








const $0c24bb96f7560fe9$var$DEFAULT_BINDINGS = [
    [
        'Select next header',
        'selectNextVisibleHeader',
        'ctrl+down'
    ],
    [
        'Select previous header',
        'selectPreviousVisibleHeader',
        'ctrl+up'
    ],
    [
        'Toggle header opened',
        'toggleHeaderOpened',
        'tab'
    ],
    [
        'Advance todo state',
        'advanceTodo',
        'alt+t'
    ],
    [
        'Edit title',
        'editTitle',
        'ctrl+h'
    ],
    [
        'Edit description',
        'editDescription',
        'ctrl+d'
    ],
    [
        'Exit edit mode',
        'exitEditMode',
        'alt+enter'
    ],
    [
        'Add header',
        'addHeader',
        'ctrl+enter'
    ],
    [
        'Remove header',
        'removeHeader',
        'backspace'
    ],
    [
        'Move header up',
        'moveHeaderUp',
        'alt+up'
    ],
    [
        'Move header down',
        'moveHeaderDown',
        'alt+down'
    ],
    [
        'Move header left',
        'moveHeaderLeft',
        'alt+shift+left'
    ],
    [
        'Move header right',
        'moveHeaderRight',
        'alt+shift+right'
    ],
    [
        'Undo',
        'undo',
        'ctrl+/'
    ]
];
const $0c24bb96f7560fe9$export$729b100309918d52 = (customKeybindings)=>$0c24bb96f7560fe9$var$DEFAULT_BINDINGS.map(([bindingName, _bindingAction, binding])=>[
            bindingName,
            customKeybindings.get(bindingName, binding)
        ]);
const $0c24bb96f7560fe9$export$857af33a4edfa392 = (customKeybindings)=>$0c24bb96f7560fe9$var$DEFAULT_BINDINGS.map(([bindingName, bindingAction, binding])=>[
            bindingAction,
            customKeybindings.get(bindingName, binding)
        ]);






/**
 * Determines which sub-editor should receive initial focus based on cursor position (%?) in template.
 *
 * @param {string} substitutedText - The template text after variable substitution (with %? removed)
 * @param {number|null} cursorIndex - Index where %? was located, or null if no %?
 * @returns {string} One of: 'title-editor', 'description-editor', 'property-list-editor', 'scheduled-editor', 'deadline-editor'
 */ const $830eba4c5da52c62$var$determineInitialSubEditor = (substitutedText, cursorIndex)=>{
    // Default to title editor if no cursor marker
    if (cursorIndex === null) return 'title-editor';
    // Find which line the cursor is on
    const textBeforeCursor = substitutedText.substring(0, cursorIndex);
    const lineNumber = (textBeforeCursor.match(/\n/g) || []).length;
    // Line 0 is the title line
    if (lineNumber === 0) return 'title-editor';
    // Get all lines to analyze context
    const lines = substitutedText.split('\n');
    // Check if cursor is within properties drawer
    let inPropertiesDrawer = false;
    for(let i = 0; i <= lineNumber && i < lines.length; i++){
        const line = lines[i].trim();
        if (line === ':PROPERTIES:') inPropertiesDrawer = true;
        else if (line === ':END:' && inPropertiesDrawer) // If we've passed :END:, we're no longer in properties
        {
            if (i < lineNumber) inPropertiesDrawer = false;
        }
    }
    if (inPropertiesDrawer) return 'property-list-editor';
    // Check if cursor is on a line with SCHEDULED: or DEADLINE:
    const currentLine = lines[lineNumber];
    if (currentLine && currentLine.trim().startsWith('SCHEDULED:')) return 'scheduled-editor';
    if (currentLine && currentLine.trim().startsWith('DEADLINE:')) return 'deadline-editor';
    // Otherwise, cursor is in description
    return 'description-editor';
};
const $830eba4c5da52c62$export$628a87ce9a4734a8 = (templateString, todoKeywordSets, customVariables = (0, $3044e0bef3624137$exports.Map)())=>{
    // Handle empty template
    if (!templateString || templateString.trim() === '') {
        const emptyHeader = (0, $1ad5549438f66e83$export$c408aef82967a8ce)('', todoKeywordSets);
        return {
            header: emptyHeader,
            initialSubEditor: 'title-editor',
            substitutedText: ''
        };
    }
    // Step 1: Substitute template variables
    const [substitutedText, cursorIndex] = (0, $9dc26f2876ad96b9$export$2e2bcd8739ae039)(templateString, customVariables);
    // Step 2: Parse into structured header
    const header = (0, $1ad5549438f66e83$export$c408aef82967a8ce)(substitutedText, todoKeywordSets);
    // Step 3: Determine which sub-editor should receive focus
    const initialSubEditor = $830eba4c5da52c62$var$determineInitialSubEditor(substitutedText, cursorIndex);
    return {
        header: header,
        initialSubEditor: initialSubEditor,
        substitutedText: substitutedText
    };
};







var $1X5R2 = parcelRequire("1X5R2");



var $1bxDW = parcelRequire("1bxDW");





var $1bxDW = parcelRequire("1bxDW");





var $1bxDW = parcelRequire("1bxDW");










function $24a4c1115bec7a0b$var$TaskListView(props) {
    function handleHeaderClick(path, headerId) {
        return ()=>props.onHeaderClick(path, headerId);
    }
    const { dateDisplayType: dateDisplayType, onToggleDateDisplayType: onToggleDateDisplayType, headersForFiles: headersForFiles, todoKeywordSetsForFiles: todoKeywordSetsForFiles } = props;
    // Populate filteredHeaders
    (0, $1bxDW.useEffect)(()=>{
        props.org.setSearchFilterInformation('', 0, 'task-list');
    }, [
        props.org
    ]);
    const planningItemsAndHeaders = getPlanningItemsAndHeaders({
        headersForFiles: headersForFiles,
        todoKeywordSetsForFiles: todoKeywordSetsForFiles
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda-day__container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda-day__headers-container"
    }, planningItemsAndHeaders.map(([planningItem, header])=>{
        const planningItemDate = planningItem ? (0, $e706118dde20dbed$export$77db66937f538459)(planningItem.get('timestamp')) : null;
        const hasTodoKeyword = !!header.getIn([
            'titleLine',
            'todoKeyword'
        ]);
        const dateClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('task-list__header-planning-date', {
            'task-list__header-planning-date--overdue': hasTodoKeyword && planningItem && (0, $582aaee3831e999d$export$2e2bcd8739ae039)(planningItemDate)
        });
        let planningInformation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null);
        if (planningItemDate) planningInformation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__header__planning-item-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "task-list__header-planning-type"
        }, (0, $2ce140c2c56df8f2$export$39a3e68e78f1544d)(planningItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: dateClassName,
            onClick: onToggleDateDisplayType
        }, dateDisplayType === 'absolute' ? (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(planningItemDate, 'MM/dd') : (0, $2ce140c2c56df8f2$export$587d51660e3dfec4)(planningItemDate), !!planningItem.getIn([
            'timestamp',
            'startHour'
        ]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), (0, $e0b180c9a12e7808$export$2e2bcd8739ae039)(planningItemDate, 'h:mma'))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            key: header.get('id'),
            className: "agenda-day__header-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "agenda-day__header__header-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $50bbde6b70a077ee$export$2e2bcd8739ae039), {
            header: header,
            color: "var(--base03)",
            hasContent: false,
            isSelected: false,
            shouldDisableActions: true,
            shouldDisableExplicitWidth: true,
            onClick: handleHeaderClick(header.get('path'), header.get('id'))
        }), planningInformation));
    })));
    // Doing this on every render of the TaskListView is potentially
    // inefficient and could be done in the reducer. However, doing it
    // on every update of the headers state when not even looking at the
    // Agenda is certainly more inefficient. Hence, we're doing it on
    // every render.
    function getPlanningItemsAndHeaders({ headersForFiles: headersForFiles, todoKeywordSetsForFiles: todoKeywordSetsForFiles }) {
        const headers = (0, $3044e0bef3624137$exports.List)().concat(...headersForFiles.mapEntries(([path, headersOfFile])=>[
                path,
                headersOfFile.map((header)=>header.set('path', path))
            ]).valueSeq());
        const isTodoKeywordInDoneState = todoKeywordSetsForFiles.map((todoKeywordSets)=>(0, $2ce140c2c56df8f2$export$f6a5d435cb1f7b7f)(todoKeywordSets));
        return headers.filter((header)=>header.getIn([
                'titleLine',
                'todoKeyword'
            ])).map((header)=>{
            const earliestPlanningItem = header.get('planningItems').sortBy($24a4c1115bec7a0b$var$getTimeFromPlanningItem).first();
            return [
                earliestPlanningItem,
                header
            ];
        }).sortBy(([planningItem, header])=>{
            const doneState = isTodoKeywordInDoneState.get(header.get('path'))(header.getIn([
                'titleLine',
                'todoKeyword'
            ]));
            const timeAsSortCriterion = planningItem ? $24a4c1115bec7a0b$var$getTimeFromPlanningItem(planningItem) : Number.MAX_SAFE_INTEGER; // Sort tasks without timestamp last
            const title = header.getIn([
                'titleLine',
                'rawTitle'
            ]);
            return [
                doneState,
                timeAsSortCriterion,
                title
            ];
        });
    }
}
const $24a4c1115bec7a0b$var$mapStateToProps = (state)=>{
    const files = state.org.present.get('files');
    return {
        // When no filtering has happened, yet (initial state), use all headers.
        headersForFiles: state.org.present.getIn([
            'search',
            'filteredHeaders'
        ]) || (0, $3044e0bef3624137$exports.Map)(),
        todoKeywordSetsForFiles: files.map((file)=>file.get('todoKeywordSets'))
    };
};
const $24a4c1115bec7a0b$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    });
const $24a4c1115bec7a0b$var$getTimeFromPlanningItem = (planningItem)=>(0, $e706118dde20dbed$export$77db66937f538459)(planningItem.get('timestamp')).getTime();
var $24a4c1115bec7a0b$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($24a4c1115bec7a0b$var$mapStateToProps, $24a4c1115bec7a0b$var$mapDispatchToProps)($24a4c1115bec7a0b$var$TaskListView);




// INFO: SearchModal, AgendaModal and TaskListModal are very similar
// in structure and partially in logic. When changing one, consider
// changing all.
function $26155fcc69394eab$var$TaskListModal(props) {
    const { searchFilter: searchFilter, searchFilterValid: searchFilterValid, searchFilterSuggestions: searchFilterSuggestions, bookmarks: bookmarks } = props;
    const bookmarkChosen = bookmarks.contains(searchFilter);
    const canSaveBookmark = searchFilterValid && searchFilter.length !== 0;
    const [dateDisplayType, setdateDisplayType] = (0, $1bxDW.useState)('absolute');
    function handleHeaderClick(path, headerId) {
        props.onClose();
        props.org.selectHeaderAndOpenParents(path, headerId);
    }
    function handleToggleDateDisplayType() {
        setdateDisplayType(dateDisplayType === 'absolute' ? 'relative' : 'absolute');
    }
    function handleFilterChange(event) {
        props.org.setSearchFilterInformation(event.target.value, event.target.selectionStart, 'task-list');
    }
    function onBookmarkButtonClick() {
        if (bookmarkChosen) props.org.deleteBookmark('task-list', searchFilter);
        else if (canSaveBookmark) props.org.saveBookmark('task-list', searchFilter);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "task-list__modal-title_search"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search-input-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search-input-line"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("datalist", {
        id: "task-list__datalist-filter"
    }, (searchFilter.length === 0 ? bookmarks : searchFilterSuggestions).map((string, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
            key: idx,
            value: string
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "search__input-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "text",
        value: searchFilter,
        // Rationale: See SearchModal: index.js
        autoFocus: !(0, $fb511a1814e342c6$export$41a665f744414057)(),
        // Disable auto-capitalization for convenience (autoComplete must also be off to
        // achieve this on Android).
        autoCapitalize: "none",
        autoComplete: "off",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('textfield', 'task-list__filter-input', {
            'task-list__filter-input--invalid': !!searchFilter && !searchFilterValid
        }),
        placeholder: "e.g. -DONE doc|man :simple|easy :assignee:nobody|none",
        list: "task-list__datalist-filter",
        onChange: handleFilterChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-lg bookmark__icon ', {
            'fa-star': !bookmarkChosen,
            'fa-trash': bookmarkChosen,
            bookmark__icon__enabled: canSaveBookmark
        }),
        onClick: onBookmarkButtonClick
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "task-list__headers-container",
        // On mobile devices, the Drawer already handles the touch
        // event. Hence, scrolling within the Drawers container does
        // not work with the same event. Therefore, we're just opting
        // to scroll the whole drawer. That's not the best UX. And a
        // better CSS juggler than me is welcome to improve on it.
        style: (0, $fb511a1814e342c6$export$cfca147fb13c9ee6) ? undefined : {
            overflow: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $24a4c1115bec7a0b$export$2e2bcd8739ae039), {
        onHeaderClick: handleHeaderClick,
        dateDisplayType: dateDisplayType,
        onToggleDateDisplayType: handleToggleDateDisplayType
    })));
}
const $26155fcc69394eab$var$mapStateToProps = (state)=>({
        searchFilter: state.org.present.getIn([
            'search',
            'searchFilter'
        ]) || '',
        searchFilterValid: state.org.present.getIn([
            'search',
            'searchFilterValid'
        ]),
        searchFilterSuggestions: state.org.present.getIn([
            'search',
            'searchFilterSuggestions'
        ]) || [],
        bookmarks: state.org.present.getIn([
            'bookmarks',
            'task-list'
        ])
    });
const $26155fcc69394eab$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    });
var $26155fcc69394eab$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($26155fcc69394eab$var$mapStateToProps, $26155fcc69394eab$var$mapDispatchToProps)($26155fcc69394eab$var$TaskListModal);






function $6d6c7565ea18d4da$var$FinderModal(props) {
    const { finderTab: finderTab, onClose: onClose, headers: headers, activeClocks: activeClocks } = props;
    function handleTabChange(finderTab) {
        props.base.setFinderTab(finderTab);
    }
    function renderTab(finderTab) {
        if (!activeClocks && finderTab === 'Clock List') {
            props.base.setFinderTab('Search');
            return;
        }
        switch(finderTab){
            case 'Search':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $8c0f5124fd4ee13d$export$2e2bcd8739ae039), {
                    context: "search",
                    onClose: onClose
                });
            case 'Task List':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $26155fcc69394eab$export$2e2bcd8739ae039), {
                    headers: headers,
                    onClose: onClose
                });
            case 'Clock List':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $8c0f5124fd4ee13d$export$2e2bcd8739ae039), {
                    activeClocks: activeClocks,
                    context: "search",
                    onClose: onClose
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", null, "Error");
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "agenda__tab-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: activeClocks ? [
            'Search',
            'Task List',
            'Clock List'
        ] : [
            'Search',
            'Task List'
        ],
        selectedButton: finderTab,
        onSelect: handleTabChange,
        useEqualWidthTabs: true
    })), renderTab(finderTab), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null));
}
const $6d6c7565ea18d4da$var$mapStateToProps = (state)=>{
    const path = state.org.present.get('path');
    const files = state.org.present.get('files');
    const fileSettings = state.org.present.get('fileSettings');
    const searchFiles = (0, $13082abb6c5d9476$export$ac94e24c6e8885fa)(files, fileSettings, path, 'includeInSearch', false);
    const activeClocks = Object.values(searchFiles.map((f)=>f.get('headers').size ? f.get('activeClocks') : 0).toJS()).reduce((acc, val)=>typeof val === 'number' ? acc + val : acc, 0);
    return {
        finderTab: state.base.get('finderTab'),
        activeClocks: activeClocks
    };
};
const $6d6c7565ea18d4da$var$mapDispatchToProps = (dispatch)=>({
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    });
var $6d6c7565ea18d4da$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($6d6c7565ea18d4da$var$mapStateToProps, $6d6c7565ea18d4da$var$mapDispatchToProps)($6d6c7565ea18d4da$var$FinderModal);


class $484aff953b4cb90f$var$OrgFile extends (0, $1bxDW.PureComponent) {
    componentDidMount() {
        const { staticFile: staticFile, path: path } = this.props;
        if (!!staticFile) {
            this.props.org.setPath((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6) + staticFile);
            if (staticFile === 'changelog') {
                this.props.base.setHasUnseenChangelog(false);
                (0, $2ce140c2c56df8f2$export$4188a0eec4f54d73)().then((hash)=>{
                    this.props.base.setLastSeenChangelogHeader(hash);
                });
            }
            setTimeout(()=>document.querySelector('.App').scrollTop = 0, 0);
        } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEmpty(path)) {
            const isFileLoaded = this.props.fileIsLoaded(path);
            if (isFileLoaded) this.props.org.sync({
                path: path,
                shouldSuppressMessages: true
            });
            else this.props.syncBackend.downloadFile(path);
            this.props.org.setPath(path);
            if (isFileLoaded && this.props.pendingCapture) this.props.org.insertPendingCapture();
        }
        this.activatePopup();
    }
    // If a fragment is set in the URL (by the activatePopup base
    // action), activate the appropriate pop-up
    activatePopup() {
        const urlFragment = window.location.hash.substr(1);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEmpty(urlFragment)) this.props.base.activatePopup(urlFragment);
    }
    componentWillUnmount() {
        const { staticFile: staticFile } = this.props;
        if (!!staticFile) this.props.base.unloadStaticFile();
        else this.props.org.resetFileDisplay();
    }
    componentDidUpdate(prevProps) {
        const { headers: headers, pendingCapture: pendingCapture, activePopupType: activePopupType, activePopupData: activePopupData } = this.props;
        if (!!pendingCapture && !!headers && headers.size > 0) this.props.org.insertPendingCapture();
        const { path: path } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEmpty(path) && !path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6)) && path !== prevProps.path) {
            this.props.syncBackend.downloadFile(path);
            this.props.org.setPath(path);
        }
        // Intercept capture popup activation and switch to capture mode
        if (activePopupType === 'capture' && prevProps.activePopupType !== 'capture') {
            const { captureTemplates: captureTemplates, todoKeywordSets: todoKeywordSets } = this.props;
            // Look up template by ID first, then fall back to matching by description
            const template = captureTemplates.find((template)=>template.get('id') === activePopupData.get('templateId')) || captureTemplates.find((template)=>template.get('description') === activePopupData.get('templateDescription'));
            if (!template) {
                this.props.base.closePopup();
                return;
            }
            // Get headers for capture target file
            const targetPath = template.get('file');
            targetPath;
            // Parse the template into structured fields
            const { header: header, initialSubEditor: initialSubEditor } = (0, $830eba4c5da52c62$export$628a87ce9a4734a8)(template.get('template'), todoKeywordSets, (0, $3044e0bef3624137$exports.Map)());
            // Store capture state first, then switch popup type in the callback
            // to ensure state is committed before the popup type triggers a re-render
            this.setState({
                captureMode: true,
                captureHeader: header,
                captureTemplate: template,
                captureShouldPrepend: template.get('shouldPrepend', false)
            }, ()=>{
                // Switch popup type to the initial sub-editor only after state is committed
                this.props.base.activatePopup(initialSubEditor);
            });
        }
    }
    componentDidCatch() {
        // TODO: Track the `error` into a bug tracker
        this.setState({
            hasUncaughtError: true
        });
    }
    handleSelectNextVisibleHeaderHotKey() {
        this.props.org.selectNextVisibleHeader();
    }
    handleSelectPreviousVisibleHeaderHotKey() {
        this.props.org.selectPreviousVisibleHeader();
    }
    handleToggleHeaderOpenedHotKey() {
        const { selectedHeaderId: selectedHeaderId, closeSubheadersRecursively: closeSubheadersRecursively } = this.props;
        if (selectedHeaderId) this.props.org.toggleHeaderOpened(selectedHeaderId, closeSubheadersRecursively);
    }
    handleAdvanceTodoHotKey() {
        this.props.org.advanceTodoState(null, this.props.shouldLogIntoDrawer);
    }
    handleEditTitleHotKey() {
        this.props.base.activatePopup('title-editor');
    }
    handleEditDescriptionHotKey() {
        this.props.base.activatePopup('description-editor');
    }
    handleExitEditModeHotKey() {
        const onClose = this.getPopupSwitchAction(this.props.activePopupType);
        onClose(...this.state.popupCloseActionValuesAccessor ? this.state.popupCloseActionValuesAccessor() : []);
        this.props.base.closePopup();
        this.container.focus();
    }
    handleAddHeaderHotKey() {
        this.props.org.addHeaderAndEdit(this.props.selectedHeaderId);
    }
    handleCreateFirstHeader() {
        this.props.org.createFirstHeader();
    }
    handleRemoveHeaderHotKey() {
        const { selectedHeaderId: selectedHeaderId } = this.props;
        this.props.org.selectNextSiblingHeader(selectedHeaderId);
        this.props.org.removeHeader(selectedHeaderId);
    }
    handleMoveHeaderUpHotKey() {
        this.props.org.moveHeaderUp(this.props.selectedHeaderId);
    }
    handleMoveHeaderDownHotKey() {
        this.props.org.moveHeaderDown(this.props.selectedHeaderId);
    }
    handleMoveHeaderLeftHotKey() {
        this.props.org.moveHeaderLeft(this.props.selectedHeaderId);
    }
    handleMoveHeaderRightHotKey() {
        this.props.org.moveHeaderRight(this.props.selectedHeaderId);
    }
    handleUndoHotKey() {
        this.props.undo.undo();
    }
    handleContainerRef(container) {
        this.container = container;
        if (this.container) this.container.focus();
    }
    handleCaptureFromEditor() {
        let { captureHeader: captureHeader, captureTemplate: captureTemplate, captureShouldPrepend: captureShouldPrepend } = this.state;
        if (!captureHeader || !captureTemplate) return;
        // Flush the current sub-editor's values to captureHeader before saving.
        const activePopupType = this.props.activePopupType;
        if (this.state.popupCloseActionValuesAccessor) {
            const values = this.state.popupCloseActionValuesAccessor();
            // Apply the values directly to captureHeader instead of going through setState
            if (activePopupType === 'title-editor' && values[0] !== undefined) {
                const titleValue = values[0];
                if (this.state.editRawValues) {
                    const newTitleLine = (0, $1ad5549438f66e83$export$48072ceac3aac428)(titleValue.trim(), this.props.todoKeywordSets);
                    captureHeader = captureHeader.set('titleLine', newTitleLine);
                } else captureHeader = captureHeader.setIn([
                    'titleLine',
                    'rawTitle'
                ], titleValue).setIn([
                    'titleLine',
                    'title'
                ], (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(titleValue)));
            } else if (activePopupType === 'description-editor' && values[0] !== undefined) captureHeader = (0, $1ad5549438f66e83$export$1c435061882203a0)(captureHeader, values[0]);
        }
        this.props.org.insertCaptureFromHeader(captureTemplate.get('id'), captureHeader, captureShouldPrepend);
        // Reset capture state
        this.setState({
            captureMode: false,
            captureHeader: null,
            captureTemplate: null,
            captureShouldPrepend: false
        });
    }
    saveCaptureTitle(titleValue) {
        // Use functional setState so this chains correctly with handleTodoChange
        this.setState((prevState)=>{
            const { captureHeader: captureHeader } = prevState;
            if (!captureHeader) return null;
            if (prevState.editRawValues) {
                if ((0, $500d38b948046618$export$907554d307802b74)(captureHeader.toJS(), false) !== titleValue) {
                    // Re-parse the full title line to extract TODO keyword, rawTitle, and tags
                    const newTitleLine = (0, $1ad5549438f66e83$export$48072ceac3aac428)(titleValue.trim(), this.props.todoKeywordSets);
                    return {
                        captureHeader: captureHeader.set('titleLine', newTitleLine)
                    };
                }
            } else {
                if (captureHeader.getIn([
                    'titleLine',
                    'rawTitle'
                ]) !== titleValue) return {
                    captureHeader: captureHeader.setIn([
                        'titleLine',
                        'rawTitle'
                    ], titleValue).setIn([
                        'titleLine',
                        'title'
                    ], (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(titleValue)))
                };
            }
            return null;
        });
    }
    handleCaptureTagsChange(newTags) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        this.setState({
            captureHeader: captureHeader.setIn([
                'titleLine',
                'tags'
            ], newTags)
        });
    }
    handleCapturePropertyListItemsChange(newPropertyListItems) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        this.setState({
            captureHeader: captureHeader.set('propertyListItems', newPropertyListItems)
        });
    }
    handleCaptureTimestampChange(popupData) {
        // Similar logic to handleTimestampChange but updates captureHeader state
        if (!!popupData.get('timestampId')) return (_newTimestamp)=>{
            // For captures, we don't have timestampId in description, only planning items
            console.warn('timestampId editing not supported in capture mode');
        };
        else if (popupData.get('logEntryIndex') !== undefined) return (_newTimestamp)=>{
            console.warn('logEntry editing not supported in capture mode');
        };
        else return (newTimestamp)=>{
            const { captureHeader: captureHeader } = this.state;
            if (!captureHeader) return;
            const planningItemIndex = popupData.get('planningItemIndex');
            this.setState({
                captureHeader: captureHeader.setIn([
                    'planningItems',
                    planningItemIndex,
                    'timestamp'
                ], newTimestamp.get('firstTimestamp'))
            });
        };
    }
    handleCaptureDescriptionChange(descriptionValue) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        if (this.state.editRawValues) this.setState({
            captureHeader: (0, $1ad5549438f66e83$export$1c435061882203a0)(captureHeader, descriptionValue)
        });
        else if (captureHeader.get('rawDescription') !== descriptionValue) this.setState({
            captureHeader: (0, $1ad5549438f66e83$export$1c435061882203a0)(captureHeader, descriptionValue)
        });
    }
    handleCaptureAddNote(inputText, currentDate) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        const wrappedInput = (0, $2f905e7cf539a8bd$export$4b238655c5ca8d7b)(inputText, 70).replace(/\n(.)/g, '\n  $1');
        const timestamp = (0, $e706118dde20dbed$export$d5283c9b29c6d6d0)(currentDate, {
            isActive: false,
            withStartTime: true
        });
        const noteText = `- Note taken on ${timestamp} \\\\\n  ${wrappedInput}`;
        const updatedHeader = captureHeader.update('logNotes', (logNotes)=>(0, $1ad5549438f66e83$export$db8208116b0213ae)(noteText + (logNotes.isEmpty() ? '\n' : '')).concat(logNotes));
        this.setState({
            captureHeader: updatedHeader.set('planningItems', (0, $1ad5549438f66e83$export$cecff86f363267f8)(updatedHeader))
        });
    }
    handleCaptureCreatePlanningItem(planningType) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        const newPlanningItem = (0, $3044e0bef3624137$exports.fromJS)({
            id: (0, $cbb57a1237e23d1f$export$2e2bcd8739ae039)(),
            type: planningType,
            timestamp: (0, $e706118dde20dbed$export$84b4d45ad21bc6ff)(new Date())
        });
        const updatedHeader = captureHeader.update('planningItems', (planningItems)=>planningItems ? planningItems.push(newPlanningItem) : (0, $3044e0bef3624137$exports.fromJS)([
                newPlanningItem
            ]));
        const newIndex = updatedHeader.get('planningItems').size - 1;
        this.setState({
            captureHeader: updatedHeader
        });
        // Re-open the popup with the new planning item index
        const popupType = {
            DEADLINE: 'deadline-editor',
            SCHEDULED: 'scheduled-editor'
        }[planningType];
        this.props.base.activatePopup(popupType, {
            headerId: captureHeader.get('id'),
            planningItemIndex: newIndex
        });
    }
    handleCaptureRemovePlanningItem(planningItemIndex) {
        const { captureHeader: captureHeader } = this.state;
        if (!captureHeader) return;
        this.setState({
            captureHeader: captureHeader.removeIn([
                'planningItems',
                planningItemIndex
            ])
        });
    }
    handlePopupClose() {
        this.props.base.closePopup();
    }
    handleSearchPopupClose(path, headerId) {
        this.props.base.closePopup();
        if (path && headerId) this.props.org.selectHeaderAndOpenParents(path, headerId);
    }
    handleRefilePopupClose(targetPath, targetHeaderId) {
        this.props.base.closePopup();
        // When the user closes the drawer without selecting a header, do
        // not trigger refiling.
        if (targetHeaderId) {
            const { loadedPath: loadedPath, selectedHeaderId: selectedHeaderId } = this.props;
            this.props.org.refileSubtree(loadedPath, selectedHeaderId, targetPath, targetHeaderId);
        }
    }
    saveTitle(titleValue) {
        const { selectedHeader: selectedHeader } = this.props;
        if (this.state.editRawValues) {
            if ((0, $500d38b948046618$export$907554d307802b74)(selectedHeader.toJS(), false) !== titleValue) this.props.org.updateHeaderTitle(selectedHeader.get('id'), titleValue);
        } else if (selectedHeader.getIn([
            'titleLine',
            'rawTitle'
        ]) !== titleValue) this.props.org.updateHeaderTitle(selectedHeader.get('id'), (0, $500d38b948046618$export$907554d307802b74)(selectedHeader.setIn([
            'titleLine',
            'rawTitle'
        ], titleValue).toJS(), false));
    }
    handleTitlePopupClose(titleValue) {
        this.saveTitle(titleValue);
        this.props.base.closePopup();
    }
    handleDescriptionPopupClose(descriptionValue) {
        const { selectedHeader: selectedHeader } = this.props;
        if (this.state.editRawValues) {
            if ((0, $500d38b948046618$export$5f409df9aafd0448)(selectedHeader, false, this.props.dontIndent) !== descriptionValue) this.props.org.updateHeaderDescription(selectedHeader.get('id'), descriptionValue);
        } else if (selectedHeader.get('rawDescription') !== descriptionValue) this.props.org.updateHeaderDescription(selectedHeader.get('id'), (0, $500d38b948046618$export$5f409df9aafd0448)(selectedHeader.set('rawDescription', descriptionValue), false, this.props.dontIndent));
        this.props.base.closePopup();
    }
    handleTablePopupClose() {
        this.props.base.closePopup();
        this.props.org.setSelectedDescriptionItemIndex(null);
        this.props.org.selectHeaderIndex(null);
        this.props.org.setSelectedTableCellId(null);
        this.props.org.setSelectedTableId(null);
    }
    handleSyncConfirmationPull(path) {
        this.props.org.sync({
            path: path,
            forceAction: 'pull'
        });
        this.props.base.closePopup();
    }
    handleSyncConfirmationPush(path) {
        this.props.org.sync({
            path: path,
            forceAction: 'push'
        });
        this.props.base.closePopup();
    }
    handleSyncConfirmationCancel() {
        this.props.base.closePopup();
    }
    handleTagsChange(newTags) {
        this.props.org.setHeaderTags(this.props.selectedHeaderId, newTags);
    }
    handlePropertyListItemsChange(newPropertyListItems) {
        this.props.org.updatePropertyListItems(this.props.selectedHeaderId, newPropertyListItems);
    }
    handleTimestampChange(popupData) {
        if (!!popupData.get('timestampId')) return (newTimestamp)=>this.props.org.updateTimestampWithId(popupData.get('timestampId'), newTimestamp);
        else if (popupData.get('logEntryIndex') !== undefined) return (newTimestamp)=>this.props.org.updateLogEntryTime(popupData.get('headerId'), popupData.get('logEntryIndex'), popupData.get('entryType'), newTimestamp.get('firstTimestamp'));
        else return (newTimestamp)=>this.props.org.updatePlanningItemTimestamp(popupData.get('headerId'), popupData.get('planningItemIndex'), newTimestamp.get('firstTimestamp'));
    }
    handleTodoChange(newTodoKeyword) {
        if (this.state.captureMode) {
            // Use functional setState to avoid race with saveCaptureTitle (called just before this)
            this.setState((prevState)=>{
                const { captureHeader: captureHeader } = prevState;
                if (!captureHeader) return null;
                return {
                    captureHeader: captureHeader.setIn([
                        'titleLine',
                        'todoKeyword'
                    ], newTodoKeyword || undefined)
                };
            });
            return;
        }
        this.props.org.setTodoState(this.props.selectedHeaderId, newTodoKeyword, this.props.shouldLogIntoDrawer);
    }
    getPopupSwitchAction(activePopupType) {
        if (this.state.captureMode) // In capture mode, save to local state instead of dispatching Redux actions
        switch(activePopupType){
            case 'title-editor':
                return (titleValue)=>{
                    if (titleValue !== undefined) this.saveCaptureTitle(titleValue);
                };
            case 'description-editor':
                return (descriptionValue)=>{
                    if (descriptionValue !== undefined) this.handleCaptureDescriptionChange(descriptionValue);
                };
            default:
                return ()=>{};
        }
        switch(activePopupType){
            case 'title-editor':
                return (titleValue)=>this.handleTitlePopupClose(titleValue);
            case 'description-editor':
                return (descriptionValue)=>this.handleDescriptionPopupClose(descriptionValue);
            default:
                return ()=>{};
        }
    }
    getPopupCloseAction(activePopupType) {
        if (this.state.captureMode) // In capture mode, save to local state instead of dispatching Redux actions
        switch(activePopupType){
            case 'title-editor':
                return (titleValue)=>{
                    if (titleValue !== undefined) this.setState((prevState)=>{
                        const { captureHeader: captureHeader, editRawValues: editRawValues } = prevState;
                        if (!captureHeader) return null;
                        let updatedHeader;
                        if (editRawValues) {
                            const newTitleLine = (0, $1ad5549438f66e83$export$48072ceac3aac428)(titleValue.trim(), this.props.todoKeywordSets);
                            updatedHeader = captureHeader.set('titleLine', newTitleLine);
                        } else updatedHeader = captureHeader.setIn([
                            'titleLine',
                            'rawTitle'
                        ], titleValue).setIn([
                            'titleLine',
                            'title'
                        ], (0, $3044e0bef3624137$exports.fromJS)((0, $1ad5549438f66e83$export$4572e459442e282a)(titleValue)));
                        return {
                            captureHeader: updatedHeader
                        };
                    }, ()=>{
                        this.handleCaptureFromEditor();
                    });
                    else this.handleCaptureFromEditor();
                };
            case 'description-editor':
                return (descriptionValue)=>{
                    if (descriptionValue !== undefined) this.handleCaptureDescriptionChange(descriptionValue);
                    this.props.base.closePopup();
                };
            default:
                return this.handlePopupClose;
        }
        switch(activePopupType){
            case 'search':
                return this.handleSearchPopupClose;
            case 'refile':
                return this.handleRefilePopupClose;
            case 'title-editor':
                return this.handleTitlePopupClose;
            case 'description-editor':
                return this.handleDescriptionPopupClose;
            case 'table-editor':
                return this.handleTablePopupClose;
            default:
                return this.handlePopupClose;
        }
    }
    getPopupMaxSize(activePopupType) {
        switch(activePopupType){
            case 'agenda':
            case 'task-list':
            case 'search':
            case 'refile':
                return true;
            default:
                return false;
        }
    }
    renderActivePopup(_setPopupCloseActionValuesAccessor) {
        const { activePopupType: activePopupType, activePopupData: activePopupData, headers: headers, shouldDisableActions: shouldDisableActions } = this.props;
        switch(activePopupType){
            case 'sync-confirmation':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $b1933be4a43a85a4$export$2e2bcd8739ae039), {
                    lastServerModifiedAt: activePopupData.get('lastServerModifiedAt'),
                    lastSyncAt: activePopupData.get('lastSyncAt'),
                    path: activePopupData.get('path'),
                    onPull: ()=>this.handleSyncConfirmationPull(activePopupData.get('path')),
                    onPush: ()=>this.handleSyncConfirmationPush(activePopupData.get('path')),
                    onCancel: this.handleSyncConfirmationCancel
                });
            case 'agenda':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $43e02334516f8fa5$export$2e2bcd8739ae039), {
                    headers: headers,
                    onClose: this.getPopupCloseAction(activePopupType)
                });
            case 'search':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6d6c7565ea18d4da$export$2e2bcd8739ae039), {
                    headers: headers,
                    onClose: this.getPopupCloseAction(activePopupType)
                });
            case 'refile':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $8c0f5124fd4ee13d$export$2e2bcd8739ae039), {
                    context: "refile",
                    onClose: this.getPopupCloseAction(activePopupType)
                });
            case 'table-editor':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $28186f79fa318d48$export$2e2bcd8739ae039), {
                    shouldDisableActions: shouldDisableActions
                });
            default:
                return null;
        }
    }
    // Some keyboard shortcuts only make sense when a header is selected and no popup is open
    checkPopupAndHeader(callback) {
        return (event)=>{
            if (this.props.selectedHeader && !this.props.activePopupType && !this.props.shouldDisableActions) callback(event);
        };
    }
    // Read only actions only need to be disabled when a popup is open
    checkPopup(callback) {
        return (event)=>{
            if (!this.props.activePopupType) callback(event);
        };
    }
    render() {
        const { headers: headers, linesBeforeHeadings: linesBeforeHeadings, shouldDisableDirtyIndicator: shouldDisableDirtyIndicator, shouldDisableSyncButtons: shouldDisableSyncButtons, shouldDisableActions: shouldDisableActions, isDirty: isDirty, parsingErrorMessage: parsingErrorMessage, path: path, staticFile: staticFile, customKeybindings: customKeybindings, orgFileErrorMessage: orgFileErrorMessage, activePopupType: activePopupType, activePopupData: activePopupData } = this.props;
        if (!path && !staticFile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
            to: "/files"
        });
        if (this.state.hasUncaughtError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "error-message-container"
        }, "Uh oh, you ran into a bug!", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "This was probably the result of an error in attempting to parse your org file. It'd be super helpful if you could", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
            href: "https://github.com/200ok-ch/organice/issues/new"
        }, "create an issue"), ' ', "(and include the org file if possible!)");
        if (!!orgFileErrorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "error-message-container"
        }, orgFileErrorMessage);
        if (!headers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null);
        const keyMap = (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).fromPairs((0, $0c24bb96f7560fe9$export$857af33a4edfa392)(customKeybindings));
        // Automatically call preventDefault on all the keyboard events that come through for
        // these hotkeys.
        const preventDefault = (callback)=>(event)=>{
                event.preventDefault();
                callback(event);
            };
        const handlers = {
            selectNextVisibleHeader: this.checkPopup(preventDefault(this.handleSelectNextVisibleHeaderHotKey)),
            selectPreviousVisibleHeader: this.checkPopup(preventDefault(this.handleSelectPreviousVisibleHeaderHotKey)),
            toggleHeaderOpened: this.checkPopup(preventDefault(this.handleToggleHeaderOpenedHotKey, true)),
            advanceTodo: this.checkPopupAndHeader(preventDefault(this.handleAdvanceTodoHotKey)),
            editTitle: this.checkPopupAndHeader(preventDefault(this.handleEditTitleHotKey)),
            editDescription: this.checkPopupAndHeader(preventDefault(this.handleEditDescriptionHotKey)),
            exitEditMode: preventDefault(this.handleExitEditModeHotKey),
            addHeader: this.checkPopupAndHeader(preventDefault(this.handleAddHeaderHotKey)),
            removeHeader: this.checkPopupAndHeader(preventDefault(this.handleRemoveHeaderHotKey, true)),
            moveHeaderUp: this.checkPopupAndHeader(preventDefault(this.handleMoveHeaderUpHotKey)),
            moveHeaderDown: this.checkPopupAndHeader(preventDefault(this.handleMoveHeaderDownHotKey)),
            moveHeaderLeft: this.checkPopupAndHeader(preventDefault(this.handleMoveHeaderLeftHotKey)),
            moveHeaderRight: this.checkPopupAndHeader(preventDefault(this.handleMoveHeaderRightHotKey)),
            undo: this.checkPopupAndHeader(preventDefault(this.handleUndoHotKey))
        };
        const setPopupCloseActionValuesAccessor = (v)=>{
            this.setState({
                popupCloseActionValuesAccessor: v
            });
        };
        // Check if this a legit Org file with content, just no headers
        const noHeadlineButContent = ()=>{
            return headers.size === 0 && linesBeforeHeadings.size > 0;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $089ff2866ffa338a$exports.GlobalHotKeys), {
            keyMap: keyMap,
            handlers: handlers
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "org-file-container",
            tabIndex: "-1",
            ref: this.handleContainerRef
        }, headers.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "org-file__parsing-error-message"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h3", null, "This file has no headlines"), !!parsingErrorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, parsingErrorMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, noHeadlineButContent() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Yes, your file has content. Do not worry, it is still there! "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "However, interacting with Org files in organice happens on a per headline basis. To use organice with this file, please create a new headline with the button below. The existing content is then put into the description of this new header.")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Interact with your file by creating the first headline."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn",
            onClick: this.handleCreateFirstHeader
        }, "Create headline")))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $ec95309c06423ebf$export$2e2bcd8739ae039), {
            shouldDisableActions: shouldDisableActions
        }), isDirty && !shouldDisableDirtyIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "dirty-indicator"
        }, "Unpushed changes"), !shouldDisableActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a04cb38b4aee684a$export$2e2bcd8739ae039), {
            shouldDisableSyncButtons: shouldDisableSyncButtons,
            staticFile: staticFile
        }), activePopupType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $68adb449c0c8875e$export$2e2bcd8739ae039), {
            onClose: ()=>{
                this.getPopupCloseAction(activePopupType)(...this.state.popupCloseActionValuesAccessor ? this.state.popupCloseActionValuesAccessor() : []);
                this.setState({
                    editRawValues: this.props.preferEditRawValues,
                    captureMode: false,
                    captureHeader: null,
                    captureTemplate: null,
                    captureShouldPrepend: false
                });
                this.container.focus();
            },
            maxSize: this.getPopupMaxSize(activePopupType)
        }, (0, $9c898491955a8deb$export$c9955f88b8688002).includes(activePopupType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9c898491955a8deb$export$2e2bcd8739ae039), {
            activePopupType: activePopupType,
            activePopupData: activePopupData,
            selectedHeader: this.state.captureMode ? this.state.captureHeader : this.props.selectedHeader,
            headers: headers,
            todoKeywordSets: this.props.todoKeywordSets,
            editRawValues: this.state.editRawValues,
            dontIndent: this.props.dontIndent,
            editorDescriptionHeightValue: this.props.editorDescriptionHeightValue,
            shouldDisableActions: shouldDisableActions,
            setPopupCloseActionValuesAccessor: setPopupCloseActionValuesAccessor,
            saveTitle: this.state.captureMode ? this.saveCaptureTitle : this.saveTitle,
            handleTodoChange: this.handleTodoChange,
            handleTagsChange: this.state.captureMode ? this.handleCaptureTagsChange : this.handleTagsChange,
            handlePropertyListItemsChange: this.state.captureMode ? this.handleCapturePropertyListItemsChange : this.handlePropertyListItemsChange,
            handleTimestampChange: this.state.captureMode ? this.handleCaptureTimestampChange : this.handleTimestampChange,
            onCreatePlanningItem: this.state.captureMode ? this.handleCaptureCreatePlanningItem : null,
            onRemovePlanningItem: this.state.captureMode ? this.handleCaptureRemovePlanningItem : null,
            allTags: (0, $2ce140c2c56df8f2$export$85c08d0e36dc9b2e)(headers),
            allOrgProperties: (0, $2ce140c2c56df8f2$export$25128b086a978b1a)(headers),
            getPopupCloseAction: this.getPopupCloseAction,
            onSwitch: ()=>{
                this.getPopupSwitchAction(activePopupType)(...this.state.popupCloseActionValuesAccessor ? this.state.popupCloseActionValuesAccessor() : []);
            },
            setEditRawValues: (editRawValues)=>this.setState({
                    editRawValues: editRawValues
                }),
            restorePreferEditRawValues: ()=>this.setState({
                    editRawValues: this.props.preferEditRawValues
                }),
            captureMode: this.state.captureMode,
            captureTemplate: this.state.captureTemplate,
            captureShouldPrepend: this.state.captureShouldPrepend,
            onAddNote: this.state.captureMode ? this.handleCaptureAddNote : null,
            onCapture: this.handleCaptureFromEditor,
            onTogglePrepend: ()=>this.setState({
                    captureShouldPrepend: !this.state.captureShouldPrepend
                })
        }) : this.renderActivePopup(setPopupCloseActionValuesAccessor)) : null));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleSelectNextVisibleHeaderHotKey',
            'handleSelectPreviousVisibleHeaderHotKey',
            'handleToggleHeaderOpenedHotKey',
            'handleAdvanceTodoHotKey',
            'handleEditTitleHotKey',
            'handleEditDescriptionHotKey',
            'handleExitEditModeHotKey',
            'handleAddHeaderHotKey',
            'handleCreateFirstHeader',
            'handleRemoveHeaderHotKey',
            'handleMoveHeaderUpHotKey',
            'handleMoveHeaderDownHotKey',
            'handleMoveHeaderLeftHotKey',
            'handleMoveHeaderRightHotKey',
            'handleUndoHotKey',
            'handleContainerRef',
            'handlePopupClose',
            'handleSearchPopupClose',
            'handleRefilePopupClose',
            'handleTitlePopupClose',
            'saveTitle',
            'handleTodoChange',
            'handleDescriptionPopupClose',
            'handleTablePopupClose',
            'handleSyncConfirmationPull',
            'handleSyncConfirmationPush',
            'handleSyncConfirmationCancel',
            'handleTagsChange',
            'handlePropertyListItemsChange',
            'handleTimestampChange',
            'getPopupCloseAction',
            'getPopupSwitchAction',
            'checkPopupAndHeader',
            'checkPopup',
            'handleCaptureFromEditor',
            'saveCaptureTitle',
            'handleCaptureTagsChange',
            'handleCapturePropertyListItemsChange',
            'handleCaptureTimestampChange',
            'handleCaptureDescriptionChange',
            'handleCaptureAddNote',
            'handleCaptureCreatePlanningItem',
            'handleCaptureRemovePlanningItem'
        ]);
        this.state = {
            hasUncaughtError: false,
            editRawValues: props.preferEditRawValues,
            captureMode: false,
            captureHeader: null,
            captureTemplate: null,
            captureShouldPrepend: false
        };
    }
}
const $484aff953b4cb90f$var$mapStateToProps = (state)=>{
    const files = state.org.present.get('files');
    const path = state.org.present.get('path');
    const loadedFiles = (0, $3044e0bef3624137$exports.Set).fromKeys(files);
    const fileIsLoaded = (path)=>loadedFiles.includes(path);
    const file = state.org.present.getIn([
        'files',
        path
    ], (0, $3044e0bef3624137$exports.Map)());
    const headers = file.get('headers');
    const linesBeforeHeadings = file.get('linesBeforeHeadings');
    const selectedHeaderId = file.get('selectedHeaderId', null);
    const activePopup = state.base.get('activePopup', (0, $3044e0bef3624137$exports.Map)());
    return {
        loadedPath: path,
        files: files,
        headers: headers,
        linesBeforeHeadings: linesBeforeHeadings,
        selectedHeaderId: selectedHeaderId,
        isDirty: file.get('isDirty'),
        fileIsLoaded: fileIsLoaded,
        selectedHeader: headers && headers.find((header)=>header.get('id') === selectedHeaderId),
        customKeybindings: state.base.get('customKeybindings'),
        dontIndent: state.base.get('shouldNotIndentOnExport'),
        shouldLogIntoDrawer: state.base.get('shouldLogIntoDrawer'),
        shouldLiveSync: state.base.get('shouldLiveSync'),
        showDeadlineDisplay: state.base.get('showDeadlineDisplay'),
        activePopupType: !!activePopup ? activePopup.get('type') : null,
        activePopupData: !!activePopup ? activePopup.get('data') : null,
        captureTemplates: state.capture.get('captureTemplates').concat((0, $0a008ec384282745$export$2e2bcd8739ae039)),
        pendingCapture: state.org.present.get('pendingCapture'),
        closeSubheadersRecursively: state.base.get('closeSubheadersRecursively'),
        orgFileErrorMessage: state.org.present.get('orgFileErrorMessage'),
        preferEditRawValues: state.base.get('preferEditRawValues'),
        todoKeywordSets: file.get('todoKeywordSets'),
        editorDescriptionHeightValue: state.base.get('editorDescriptionHeightValue')
    };
};
const $484aff953b4cb90f$var$mapDispatchToProps = (dispatch)=>{
    return {
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch),
        syncBackend: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($f257bd084a67bcde$exports, dispatch),
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        undo: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)((0, $5624140532e76935$exports.ActionCreators), dispatch),
        capture: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($3e461505c3a6d1b3$exports, dispatch)
    };
};
var $484aff953b4cb90f$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($484aff953b4cb90f$var$mapStateToProps, $484aff953b4cb90f$var$mapDispatchToProps)($484aff953b4cb90f$var$OrgFile);



var $1bxDW = parcelRequire("1bxDW");



var $9zQbc = parcelRequire("9zQbc");
var $3vC7t = parcelRequire("3vC7t");







const $2c39408185ce71f2$var$Settings = ({ fontSize: fontSize, bulletStyle: bulletStyle, shouldTapTodoToAdvance: shouldTapTodoToAdvance, shouldStoreSettingsInSyncBackend: shouldStoreSettingsInSyncBackend, shouldLiveSync: shouldLiveSync, showDeadlineDisplay: showDeadlineDisplay, shouldSyncOnBecomingVisibile: shouldSyncOnBecomingVisibile, shouldShowTitleInOrgFile: shouldShowTitleInOrgFile, shouldLogIntoDrawer: shouldLogIntoDrawer, closeSubheadersRecursively: closeSubheadersRecursively, shouldNotIndentOnExport: shouldNotIndentOnExport, editorDescriptionHeightValue: editorDescriptionHeightValue, agendaDefaultDeadlineDelayValue: agendaDefaultDeadlineDelayValue, agendaDefaultDeadlineDelayUnit: agendaDefaultDeadlineDelayUnit, agendaStartOnWeekday: agendaStartOnWeekday, hasUnseenChangelog: hasUnseenChangelog, syncBackend: syncBackend, preferEditRawValues: preferEditRawValues, showClockDisplay: showClockDisplay, orgHabitShowAllToday: orgHabitShowAllToday, orgHabitPrecedingDays: orgHabitPrecedingDays, orgHabitFollowingDays: orgHabitFollowingDays, colorScheme: colorScheme, theme: theme, base: base, org: org })=>{
    const history = (0, $3vC7t.useHistory)();
    // This looks like hardcoding where it would be possible to dispatch
    // on the `location.origin`, but here we assure that every instance
    // of organice has a valid link to documentation. Self-building does
    // not insure that, because building and hosting docs is not part of
    // the application itself.
    const documentationHost = window.location.origin.match(/staging.organice.200ok.ch/) ? 'https://staging.organice.200ok.ch' : 'https://organice.200ok.ch';
    const handleSignOutClick = ()=>{
        if (window.confirm('Are you sure you want to sign out?')) {
            syncBackend.signOut();
            history.push('/');
        }
    };
    const handleKeyboardShortcutsClick = ()=>base.pushModalPage('keyboard_shortcuts_editor');
    const handleCaptureTemplatesClick = ()=>base.pushModalPage('capture_templates_editor');
    const handleFileSettingsClick = ()=>base.pushModalPage('file_settings_editor');
    const handleNotificationsClick = ()=>base.pushModalPage('notifications_editor');
    const handleFontSizeChange = (newFontSize)=>base.setFontSize(newFontSize);
    const handleColorSchemeClick = (colorScheme)=>base.setColorScheme(colorScheme);
    const handleThemeClick = (theme)=>base.setTheme(theme);
    const handleBulletStyleChange = (newBulletStyle)=>base.setBulletStyle(newBulletStyle);
    const handleShouldTapTodoToAdvanceChange = ()=>base.setShouldTapTodoToAdvance(!shouldTapTodoToAdvance);
    const handleEditorDescriptionHeightValueChange = (event)=>base.setEditorDescriptionHeightValue(event.target.value);
    const handleAgendaDefaultDeadlineDelayValueChange = (event)=>base.setAgendaDefaultDeadlineDelayValue(event.target.value);
    const handleAgendaDefaultDeadlineDelayUnitChange = (newDelayUnit)=>base.setAgendaDefaultDeadlineDelayUnit(newDelayUnit);
    const handleAgendaStartOnWeekdayChange = (value)=>base.setAgendaStartOnWeekday(value);
    const handleShouldLiveSyncChange = ()=>base.setShouldLiveSync(!shouldLiveSync);
    const handleShowDeadlineDisplayChange = ()=>base.setShowDeadlineDisplay(!showDeadlineDisplay);
    const handleShouldSyncOnBecomingVisibleChange = ()=>base.setShouldSyncOnBecomingVisibile(!shouldSyncOnBecomingVisibile);
    const handleShouldShowTitleInOrgFile = ()=>base.setShouldShowTitleInOrgFile(!shouldShowTitleInOrgFile);
    const handleShouldLogIntoDrawer = ()=>base.setShouldLogIntoDrawer(!shouldLogIntoDrawer);
    const handleCloseSubheadersRecursively = ()=>base.setCloseSubheadersRecursively(!closeSubheadersRecursively);
    const handleShouldNotIndentOnExport = ()=>base.setShouldNotIndentOnExport(!shouldNotIndentOnExport);
    const handleShouldStoreSettingsInSyncBackendChange = ()=>base.setShouldStoreSettingsInSyncBackend(!shouldStoreSettingsInSyncBackend);
    const handleShowClockDisplayClick = ()=>org.setShowClockDisplay(!showClockDisplay);
    const handlePreferEditRawValues = ()=>base.setPreferEditRawValues(!preferEditRawValues);
    const handleOrgHabitShowAllToday = ()=>base.setOrgHabitShowAllToday(!orgHabitShowAllToday);
    const handleOrgHabitPrecedingDaysChange = (event)=>base.setOrgHabitPrecedingDays(parseInt(event.target.value, 10) || 0);
    const handleOrgHabitFollowingDaysChange = (event)=>base.setOrgHabitFollowingDays(parseInt(event.target.value, 10) || 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "settings-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Font size"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'Regular',
            'Large'
        ],
        selectedButton: fontSize,
        onSelect: handleFontSizeChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Color scheme"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'OS',
            'Light',
            'Dark'
        ],
        selectedButton: colorScheme,
        onSelect: handleColorSchemeClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Theme"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'Solarized',
            'One',
            'Gruvbox',
            'Smyck',
            'Code'
        ],
        selectedButton: theme,
        onSelect: handleThemeClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Bullet style"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'Classic',
            'Fancy'
        ],
        selectedButton: bulletStyle,
        onSelect: handleBulletStyleChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Tap TODO to advance state"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldTapTodoToAdvance,
        onToggle: handleShouldTapTodoToAdvanceChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Live sync", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "If enabled, changes are automatically pushed to the sync backend as you make them.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldLiveSync,
        onToggle: handleShouldLiveSyncChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Sync on application becoming visible", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "If enabled, the current org file is pulled from the sync backend when the browser tab becomes visible. This prevents you from having a stale file before starting to make changes to it.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldSyncOnBecomingVisibile,
        onToggle: handleShouldSyncOnBecomingVisibleChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Show Org filename as Title", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "When in an Org file view, it shows the filename in the HeaderBar.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldShowTitleInOrgFile,
        onToggle: handleShouldShowTitleInOrgFile
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Log into LOGBOOK drawer when item repeats", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "Log TODO state changes (currently only for repeating items) into the LOGBOOK drawer instead of into the body of the heading (default). See the Orgmode documentation on", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://www.gnu.org/software/emacs/manual/html_node/org/Tracking-TODO-state-changes.html"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "org-log-into-drawer")), ' ', "for more information.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldLogIntoDrawer,
        onToggle: handleShouldLogIntoDrawer
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "When folding a header, fold all subheaders too", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "When folding a header, fold recursively all its subheaders, so that when the header is reopened all subheaders are folded, regardless of their state prior to folding. This is the default in Emacs Org mode. If this turned off, the fold-state of the subheaders is preserved when the header is unfolded.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: closeSubheadersRecursively,
        onToggle: handleCloseSubheadersRecursively
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Disable hard indent on Org export", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "By default, the metadata body (including deadlines and drawers) of an exported org heading is indented according to its level. If instead you prefer to keep your body text flush-left, i.e.", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://orgmode.org/manual/Hard-indentation.html"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "(setq org-adapt-indentation nil)")), ", then activate this setting. The raw content text is left unchanged.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldNotIndentOnExport,
        onToggle: handleShouldNotIndentOnExport
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Store settings in sync backend", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "Store settings and keyboard shortcuts in a .organice-config.json file in your sync backend to sync between multiple devices.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: shouldStoreSettingsInSyncBackend,
        onToggle: handleShouldStoreSettingsInSyncBackendChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container setting-container--vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Default DEADLINE warning period"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "default-deadline-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "number",
        min: "0",
        className: "textfield default-deadline-value-textfield",
        value: agendaDefaultDeadlineDelayValue,
        onChange: handleAgendaDefaultDeadlineDelayValueChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: 'hdwmy'.split(''),
        selectedButton: agendaDefaultDeadlineDelayUnit,
        onSelect: handleAgendaDefaultDeadlineDelayUnitChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container setting-container--vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Description editor height"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "This setting controls the height of the description editor on computers only. The height will be limited to ensure that all buttons are always visible. On mobile devices this setting is ignored and the editor will always be 8 rows high."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "default-deadline-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "number",
        min: "2",
        className: "textfield default-deadline-value-textfield",
        value: editorDescriptionHeightValue,
        onChange: handleEditorDescriptionHeightValueChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Start of week for weekly agenda", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "Akin to", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://orgmode.org/manual/Weekly_002fdaily-agenda.html"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "org-agenda-start-on-weekday")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S',
            'Today'
        ],
        values: [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            -1
        ],
        titles: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        selectedButton: agendaStartOnWeekday,
        onSelect: handleAgendaStartOnWeekdayChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Show all habits today", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "When enabled, all habits are shown in today's agenda view, even if not scheduled or already marked as DONE today. Only applies to today's date in the agenda.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: orgHabitShowAllToday,
        onToggle: handleOrgHabitShowAllToday
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container setting-container--vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Habit consistency graph preceding days"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "The number of days before today that will be shown in the habit consistency graph."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "default-deadline-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "number",
        min: "0",
        className: "textfield default-deadline-value-textfield",
        value: orgHabitPrecedingDays,
        onChange: handleOrgHabitPrecedingDaysChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container setting-container--vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Habit consistency graph following days"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "The number of days after today that will be shown in the habit consistency graph."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "default-deadline-warning-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "number",
        min: "0",
        className: "textfield default-deadline-value-textfield",
        value: orgHabitFollowingDays,
        onChange: handleOrgHabitFollowingDaysChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Display time summaries", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "This puts overlays at the end of each headline, showing the total time recorded under that heading, including the time of any subheadings.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: showClockDisplay,
        onToggle: handleShowClockDisplayClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Show Deadline Display", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, "If enabled, the deadline will displayed on each header line.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: showDeadlineDisplay,
        onToggle: handleShowDeadlineDisplayChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label"
    }, "Prefer raw values", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "setting-label__description"
    }, 'When editing title or description of a header, you can switch between editing the text part or the full content (including text representation of todo keywords, tags, schedule items, properties etc.) by clicking the "edit title" or "edit description" icon in the popup. This option allows you to view the full content first instead of on a second click.')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: preferEditRawValues,
        onToggle: handlePreferEditRawValues
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "settings-buttons-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn",
        onClick: handleCaptureTemplatesClick
    }, "Capture templates"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn",
        onClick: handleKeyboardShortcutsClick
    }, "Keyboard shortcuts"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn",
        onClick: handleFileSettingsClick
    }, "File settings"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn",
        onClick: handleNotificationsClick
    }, "Notifications"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("hr", {
        className: "settings-button-separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
        to: "/changelog",
        className: "btn settings-btn"
    }, "Changelog", hasUnseenChangelog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "changelog-badge-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-gift"
    }), "\xa0 What's New?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.Link), {
        to: "/sample",
        className: "btn settings-btn"
    }, "Help"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: `${documentationHost}/documentation.html`
    }, "Documentation", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-external-link-alt fa-sm"
    })), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
        href: "https://github.com/200ok-ch/organice"
    }, "Github repo", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
        className: "fas fa-external-link-alt fa-sm"
    })), ' '), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("hr", {
        className: "settings-button-separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "btn settings-btn",
        onClick: handleSignOutClick
    }, "Sign out")));
};
const $2c39408185ce71f2$var$mapStateToProps = (state)=>{
    // The default values here only relate to the settings view. To set
    // defaults which get loaded on an initial run of organice, look at
    // `util/settings_persister.js::persistableFields`.
    const agendaStartOnWeekday = state.base.get('agendaStartOnWeekday');
    return {
        fontSize: state.base.get('fontSize') || 'Regular',
        bulletStyle: state.base.get('bulletStyle'),
        shouldTapTodoToAdvance: state.base.get('shouldTapTodoToAdvance'),
        editorDescriptionHeightValue: state.base.get('editorDescriptionHeightValue') || 8,
        agendaDefaultDeadlineDelayValue: state.base.get('agendaDefaultDeadlineDelayValue') || 5,
        agendaDefaultDeadlineDelayUnit: state.base.get('agendaDefaultDeadlineDelayUnit') || 'd',
        agendaStartOnWeekday: agendaStartOnWeekday == null ? 1 : +agendaStartOnWeekday,
        shouldStoreSettingsInSyncBackend: state.base.get('shouldStoreSettingsInSyncBackend'),
        shouldLiveSync: state.base.get('shouldLiveSync'),
        showDeadlineDisplay: state.base.get('showDeadlineDisplay'),
        shouldSyncOnBecomingVisibile: state.base.get('shouldSyncOnBecomingVisibile'),
        shouldShowTitleInOrgFile: state.base.get('shouldShowTitleInOrgFile'),
        shouldLogIntoDrawer: state.base.get('shouldLogIntoDrawer'),
        closeSubheadersRecursively: state.base.get('closeSubheadersRecursively'),
        shouldNotIndentOnExport: state.base.get('shouldNotIndentOnExport'),
        hasUnseenChangelog: state.base.get('hasUnseenChangelog'),
        showClockDisplay: state.org.present.get('showClockDisplay'),
        preferEditRawValues: state.base.get('preferEditRawValues'),
        orgHabitShowAllToday: state.base.get('orgHabitShowAllToday'),
        orgHabitPrecedingDays: state.base.get('orgHabitPrecedingDays') || 21,
        orgHabitFollowingDays: state.base.get('orgHabitFollowingDays') || 7,
        colorScheme: state.base.get('colorScheme'),
        theme: state.base.get('theme')
    };
};
const $2c39408185ce71f2$var$mapDispatchToProps = (dispatch)=>{
    return {
        syncBackend: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($f257bd084a67bcde$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch),
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    };
};
var $2c39408185ce71f2$export$2e2bcd8739ae039 = (0, $3vC7t.withRouter)((0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($2c39408185ce71f2$var$mapStateToProps, $2c39408185ce71f2$var$mapDispatchToProps)($2c39408185ce71f2$var$Settings));



var $1bxDW = parcelRequire("1bxDW");



var $3vC7t = parcelRequire("3vC7t");


var $1bxDW = parcelRequire("1bxDW");


var $1X5R2 = parcelRequire("1X5R2");

class $1e52d812a4a7b610$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    componentDidMount() {
        this.rebindArea.addEventListener('blur', ()=>this.setState({
                isEditMode: false
            }));
    }
    handleRebindClick() {
        this.setState({
            isEditMode: true
        });
        document.addEventListener('keypress', this.handleKeyPress);
    }
    handleKeyPress(event) {
        this.setState({
            isEditMode: false
        });
        document.removeEventListener('keypress', this.handleKeyPress);
        let key = null;
        if (event.code.startsWith('Key')) key = event.code.substr(3).toLowerCase();
        else if (event.code.startsWith('Digit')) key = event.code.substr(5);
        else key = ({
            Minus: '-',
            Equal: '=',
            Backspace: 'backspace',
            Enter: 'enter',
            Return: 'return',
            Tab: 'tab',
            BracketLeft: '[',
            BracketRight: ']',
            Semicolon: ';',
            Quote: '"',
            Backslash: '\\',
            Comma: ',',
            Period: '.',
            Slash: '/'
        })[event.code];
        if (!key) return;
        const modifiers = [
            [
                'ctrlKey',
                'ctrl'
            ],
            [
                'altKey',
                'alt'
            ],
            [
                'metaKey',
                'meta'
            ],
            [
                'shiftKey',
                'shift'
            ]
        ];
        const newModifiers = modifiers.filter(([modifier, _])=>event[modifier]).map(([_, symbol])=>symbol).join('+');
        const newBinding = `${newModifiers}${!!newModifiers ? '+' : ''}${key}`;
        this.props.onBindingChange(this.props.name, newBinding);
    }
    symbolizeKeybinding(binding) {
        if (!binding) return '';
        const replacements = [
            [
                'ctrl',
                '^'
            ],
            [
                'alt',
                "\u2325"
            ],
            [
                'option',
                "\u2325"
            ],
            [
                'command',
                "\u2318"
            ],
            [
                'meta',
                "\u2318"
            ],
            [
                'shift',
                "\u21E7"
            ],
            [
                'backspace',
                "\u232B"
            ],
            [
                'return',
                "\u23CE"
            ],
            [
                'enter',
                "\u23CE"
            ],
            [
                'left',
                "\u2190"
            ],
            [
                'right',
                "\u2192"
            ],
            [
                'up',
                "\u2191"
            ],
            [
                'down',
                "\u2193"
            ]
        ];
        return replacements.reduce((currentBinding, [name, symbol])=>currentBinding.replace(RegExp(`${name}\\+?`), symbol), binding);
    }
    render() {
        const { name: name, binding: binding } = this.props;
        const { isEditMode: isEditMode } = this.state;
        const rebindAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('keyboard-shortcut-container__shortcut-key', {
            'keyboard-shortcut-container__shortcut-key--edit-mode': isEditMode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "keyboard-shortcut-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "keyboard-shortcut-container__shortcut-name"
        }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: rebindAreaClassName,
            onClick: this.handleRebindClick,
            tabIndex: "-1",
            ref: (div)=>this.rebindArea = div
        }, isEditMode ? '...' : this.symbolizeKeybinding(binding)));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleRebindClick',
            'handleKeyPress'
        ]);
        this.state = {
            isEditMode: false
        };
    }
}





const $f26688d0a3e01ed8$var$KeyboardShortcutsEditor = ({ customKeybindings: customKeybindings, base: base })=>{
    const handleBindingChange = (bindingName, newBinding)=>{
        const alreadyInUseBinding = (0, $0c24bb96f7560fe9$export$729b100309918d52)(customKeybindings).filter(([_, binding])=>binding === newBinding)[0];
        if (!!alreadyInUseBinding) {
            alert(`That binding is already in use for "${alreadyInUseBinding[0]}"`);
            return;
        }
        base.setCustomKeybinding(bindingName, newBinding);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "keyboard-shortcuts-editor-container"
    }, (0, $0c24bb96f7560fe9$export$729b100309918d52)(customKeybindings).map(([name, binding])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1e52d812a4a7b610$export$2e2bcd8739ae039), {
            key: name,
            name: name,
            binding: binding,
            onBindingChange: handleBindingChange
        })));
};
const $f26688d0a3e01ed8$var$mapStateToProps = (state)=>{
    return {
        customKeybindings: state.base.get('customKeybindings') || (0, $3044e0bef3624137$exports.Map)()
    };
};
const $f26688d0a3e01ed8$var$mapDispatchToProps = (dispatch)=>{
    return {
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $f26688d0a3e01ed8$export$2e2bcd8739ae039 = (0, $3vC7t.withRouter)((0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($f26688d0a3e01ed8$var$mapStateToProps, $f26688d0a3e01ed8$var$mapDispatchToProps)($f26688d0a3e01ed8$var$KeyboardShortcutsEditor));



var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");






var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");







var $8904f66ac8633d23$export$2e2bcd8739ae039 = ({ template: template, index: index, onFieldPathUpdate: onFieldPathUpdate, onAddNewTemplateOrgFileAvailability: onAddNewTemplateOrgFileAvailability, onRemoveTemplateOrgFileAvailability: onRemoveTemplateOrgFileAvailability, onAddNewTemplateHeaderPath: onAddNewTemplateHeaderPath, onRemoveTemplateHeaderPath: onRemoveTemplateHeaderPath, onDeleteTemplate: onDeleteTemplate, syncBackendType: syncBackendType, loadedFilePaths: loadedFilePaths })=>{
    const [isCollapsed, setIsCollapsed] = (0, $1bxDW.useState)(!!template.get('description'));
    const handleHeaderBarClick = ()=>setIsCollapsed(!isCollapsed);
    const updateField = (fieldName)=>(event)=>onFieldPathUpdate(template.get('id'), [
                fieldName
            ], event.target.value);
    const toggleAvailabilityInAllOrgFiles = ()=>onFieldPathUpdate(template.get('id'), [
            'isAvailableInAllOrgFiles'
        ], !template.get('isAvailableInAllOrgFiles'));
    const togglePrepend = ()=>onFieldPathUpdate(template.get('id'), [
            'shouldPrepend'
        ], !template.get('shouldPrepend'));
    const handleAddNewOrgFileAvailability = ()=>{
        onAddNewTemplateOrgFileAvailability(template.get('id'));
    };
    const handleRemoveOrgFileAvailability = (index)=>()=>onRemoveTemplateOrgFileAvailability(template.get('id'), index);
    const handleOrgFileAvailabilityChange = (orgFileAvailabilityIndex)=>(event)=>onFieldPathUpdate(template.get('id'), [
                'orgFilesWhereAvailable',
                orgFileAvailabilityIndex
            ], event.target.value);
    const handleAddNewHeaderPath = ()=>onAddNewTemplateHeaderPath(template.get('id'));
    const handleRemoveHeaderPath = (headerPathIndex)=>()=>onRemoveTemplateHeaderPath(template.get('id'), headerPathIndex);
    const handleHeaderPathChange = (headerPathIndex)=>(event)=>onFieldPathUpdate(template.get('id'), [
                'headerPaths',
                headerPathIndex
            ], event.target.value);
    const handleDeleteClick = ()=>{
        if (window.confirm(`Are you sure you want to delete the "${template.get('description')}" template?`)) onDeleteTemplate(template.get('id'));
    };
    const renderDescriptionField = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Description:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "text",
            className: "textfield",
            value: template.get('description', ''),
            onChange: updateField('description')
        })));
    const renderIconField = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Letter:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "text",
            className: "textfield capture-template__letter-textfield",
            maxLength: "1",
            value: template.get('letter', ''),
            onChange: updateField('letter'),
            autoCapitalize: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field__or-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field__or-line"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field__or"
        }, "or"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field__or-line"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Icon name:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "text",
            className: "textfield",
            value: template.get('iconName'),
            onChange: updateField('iconName'),
            autoCapitalize: "none",
            autoCorrect: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "Instead of a letter, you can specify the name of any free Font Awesome icon (like lemon or calendar-plus) to use as the capture icon. You can search the available icons", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
            href: "https://fontawesome.com/icons?d=gallery&s=solid&m=free"
        }, "here"), "."));
    const renderOrgFileAvailability = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Available in all org files?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: template.get('isAvailableInAllOrgFiles'),
            onToggle: toggleAvailabilityInAllOrgFiles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "You can make this capture template available in all org files, or just the ones you specify.", syncBackendType === 'Dropbox' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, ' ', "Specify full paths starting from the root of your Dropbox, like", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "/org/todo.org"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
            isOpened: !template.get('isAvailableInAllOrgFiles'),
            springConfig: {
                stiffness: 300
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "multi-textfields-container"
        }, template.get('orgFilesWhereAvailable').map((orgFilePath, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                key: `org-file-availability-${index}`,
                className: "multi-textfield-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
                type: "text",
                placeholder: "e.g., /org/todo.org",
                className: "textfield multi-textfield-field",
                value: orgFilePath,
                onChange: handleOrgFileAvailabilityChange(index)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
                className: "fas fa-times fa-lg remove-multi-textfield-button",
                onClick: handleRemoveOrgFileAvailability(index)
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "add-new-multi-textfield-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "fas fa-plus add-new-multi-textfield-button",
            onClick: handleAddNewOrgFileAvailability
        }))));
    const renderFilePath = (template)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "File: "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("select", {
            onChange: updateField('file'),
            style: {
                width: '90%'
            }
        }, (loadedFilePaths.filter((path)=>(path === template.get('file', '')).length) !== 0 ? loadedFilePaths : [
            template.get('file'),
            ...loadedFilePaths
        ]).map((path)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
                key: path,
                value: path,
                selected: path === template.get('file')
            }, path)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "By default the file opened when capturing is the capture target. Select a specific file if you want this template to always capture to that file. Make sure the file is loaded for it to be selectable here. You might also consider to set the file to load on startup in the file settings so it's always available."));
    };
    const renderHeaderPaths = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field",
            style: {
                marginTop: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Header path")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "Specify the path to the header under which the new header should be filed. One header per textfield."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "multi-textfields-container"
        }, template.get('headerPaths').map((headerPath, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
                key: `header-path-${index}`,
                className: "multi-textfield-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
                type: "text",
                placeholder: "e.g., Todos",
                className: "textfield multi-textfield-field",
                value: headerPath,
                onChange: handleHeaderPathChange(index)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
                className: "fas fa-times fa-lg remove-multi-textfield-button",
                onClick: handleRemoveHeaderPath(index)
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "add-new-multi-textfield-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "fas fa-plus add-new-multi-textfield-button",
            onClick: handleAddNewHeaderPath
        })));
    const renderPrependField = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Prepend?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: template.get('shouldPrepend'),
            onToggle: togglePrepend
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "By default, new captured headers are appended to the specified header path. Enable this setting to prepend them instead."));
    const renderTemplateField = (template)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field",
            style: {
                marginTop: 7
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Template")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("textarea", {
            className: "textarea template-textarea",
            rows: "3",
            value: template.get('template'),
            onChange: updateField('template')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__help-text"
        }, "The template for creating the capture item. You can use the following template variables that will be expanded upon capture:", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%?"), " - Place the cursor here."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%t"), " - Timestamp, date only."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%T"), " - Timestamp, with date and time."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%u"), " - Inactive timestamp, date only."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%U"), " - Inactive timestamp, with date and time."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%r"), " - Raw timestamp, date only, no surrounding punctation.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, "Build custom expressions like", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "TODO Monthly - %?\\n DEADLINE: <%r .+1m>")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%R"), " - Raw timestamp, with date and time, no surrounding punctuation."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%y"), " - Raw year"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%", '<custom variable>'), " - A custom variable from a URL param capture. See", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $6e8690452b6d1247$export$2e2bcd8739ae039), {
            href: "https://organice.200ok.ch/documentation.html#capture_templates"
        }, "the README file"), ' ', "for more details.")), "You can also use ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%u"), " and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("code", null, "%t"), " as part of the header path."));
    const renderDeleteButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template__field-container capture-template__delete-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn settings-btn capture-template__delete-button",
            onClick: handleDeleteClick
        }, "Delete template"));
    const caretClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-2x fa-caret-right capture-template-container__header__caret', {
        'capture-template-container__header__caret--rotated': !isCollapsed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$f2a139e5d18b9882), {
        draggableId: `capture-template--${template.get('id')}`,
        index: index
    }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('capture-template-container', {
                'capture-template-container--dragging': snapshot.isDragging
            }),
            ref: provided.innerRef
        }, provided.draggableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template-container__header",
            onClick: handleHeaderBarClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: caretClassName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d6f16605fae97b87$export$2e2bcd8739ae039), {
            iconName: template.get('iconName'),
            letter: template.get('letter'),
            onClick: ()=>{},
            style: {
                marginRight: 20
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "capture-template-container__header__title"
        }, template.get('description')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", (0, $frurs._)({
            className: "fas fa-bars fa-lg capture-template-container__header__drag-handle"
        }, provided.dragHandleProps))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
            isOpened: !isCollapsed,
            springConfig: {
                stiffness: 300
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "capture-template-container__content"
        }, renderDescriptionField(template), renderIconField(template), renderOrgFileAvailability(template), renderFilePath(template), renderHeaderPaths(template), renderPrependField(template), renderTemplateField(template), renderDeleteButton()))));
};




const $2bd045ad55561335$var$CaptureTemplatesEditor = ({ captureTemplates: captureTemplates, syncBackendType: syncBackendType, capture: capture, loadedFilePaths: loadedFilePaths })=>{
    const handleAddNewTemplateClick = ()=>capture.addNewEmptyCaptureTemplate();
    const handleFieldPathUpdate = (templateId, fieldPath, newValue)=>capture.updateTemplateFieldPathValue(templateId, fieldPath, newValue);
    const handleAddNewTemplateOrgFileAvailability = (templateId)=>capture.addNewTemplateOrgFileAvailability(templateId);
    const handleRemoveTemplateOrgFileAvailability = (templateId, orgFileAvailabilityIndex)=>capture.removeTemplateOrgFileAvailability(templateId, orgFileAvailabilityIndex);
    const handleAddNewTemplateHeaderPath = (templateId)=>capture.addNewTemplateHeaderPath(templateId);
    const handleRemoveTemplateHeaderPath = (templateId, headerPathIndex)=>capture.removeTemplateHeaderPath(templateId, headerPathIndex);
    const handleDeleteTemplate = (templateId)=>capture.deleteTemplate(templateId);
    const handleReorderTemplate = (fromIndex, toIndex)=>capture.reorderCaptureTemplate(fromIndex, toIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$423ec2075359570a), {
        droppableId: "capture-templates-editor-droppable",
        type: "CAPTURE-TEMPLATE"
    }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            className: "capture-templates-container",
            ref: provided.innerRef
        }, provided.droppableProps), captureTemplates.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "no-capture-templates-message"
        }, "You don't currently have any capture templates - add one by pressing the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus"
        }), " button.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "Capture templates show up in the action drawer and give you quick access to creating new headers (like org-capture).") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, captureTemplates.map((template, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $8904f66ac8633d23$export$2e2bcd8739ae039), {
                key: template.get('id'),
                index: index,
                template: template,
                syncBackendType: syncBackendType,
                loadedFilePaths: loadedFilePaths,
                onFieldPathUpdate: handleFieldPathUpdate,
                onAddNewTemplateOrgFileAvailability: handleAddNewTemplateOrgFileAvailability,
                onRemoveTemplateOrgFileAvailability: handleRemoveTemplateOrgFileAvailability,
                onAddNewTemplateHeaderPath: handleAddNewTemplateHeaderPath,
                onRemoveTemplateHeaderPath: handleRemoveTemplateHeaderPath,
                onDeleteTemplate: handleDeleteTemplate,
                onReorder: handleReorderTemplate
            })), provided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "new-capture-template-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "fas fa-plus fa-lg btn btn--circle",
        onClick: handleAddNewTemplateClick
    })));
};
const $2bd045ad55561335$var$mapStateToProps = (state)=>{
    const loadedFilePaths = state.org.present.get('files', (0, $3044e0bef3624137$exports.List)()).keySeq().toJS().filter((path)=>!path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6)));
    loadedFilePaths.unshift('');
    return {
        captureTemplates: state.capture.get('captureTemplates', (0, $3044e0bef3624137$exports.List)()),
        syncBackendType: state.syncBackend.get('client').type,
        loadedFilePaths: loadedFilePaths
    };
};
const $2bd045ad55561335$var$mapDispatchToProps = (dispatch)=>{
    return {
        capture: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($3e461505c3a6d1b3$exports, dispatch)
    };
};
var $2bd045ad55561335$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($2bd045ad55561335$var$mapStateToProps, $2bd045ad55561335$var$mapDispatchToProps)($2bd045ad55561335$var$CaptureTemplatesEditor);



var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");






var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");





var $12e3458967bf1ac7$export$2e2bcd8739ae039 = ({ setting: setting, index: index, onFieldPathUpdate: onFieldPathUpdate, onDeleteSetting: onDeleteSetting, loadedFilepaths: loadedFilepaths, path: path })=>{
    const [isCollapsed, setIsCollapsed] = (0, $1bxDW.useState)(true);
    const handleHeaderBarClick = ()=>setIsCollapsed(!isCollapsed);
    const updateField = (fieldName)=>(event)=>onFieldPathUpdate(setting.get('id'), [
                fieldName
            ], event.target.value);
    const toggleDefaultOnStartup = ()=>onFieldPathUpdate(setting.get('id'), [
            'defaultOnStartup'
        ], !setting.get('defaultOnStartup'));
    const toggleLoadOnStartup = ()=>onFieldPathUpdate(setting.get('id'), [
            'loadOnStartup'
        ], !setting.get('loadOnStartup'));
    const toggleIncludeInAgenda = ()=>onFieldPathUpdate(setting.get('id'), [
            'includeInAgenda'
        ], !setting.get('includeInAgenda'));
    const toggleIncludeInSearch = ()=>onFieldPathUpdate(setting.get('id'), [
            'includeInSearch'
        ], !setting.get('includeInSearch'));
    const toggleIncludeInTasklist = ()=>onFieldPathUpdate(setting.get('id'), [
            'includeInTasklist'
        ], !setting.get('includeInTasklist'));
    const toggleIncludeInRefile = ()=>onFieldPathUpdate(setting.get('id'), [
            'includeInRefile'
        ], !setting.get('includeInRefile'));
    const handleDeleteClick = ()=>{
        if (window.confirm(`Are you sure you want to delete the settings for "${setting.get('path')}"?`)) onDeleteSetting(setting.get('id'));
    };
    const renderPathField = (setting)=>{
        if (setting.get('path') === '') updateField('path')({
            target: {
                value: path || loadedFilepaths[0]
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Path: "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("select", {
            onChange: updateField('path'),
            style: {
                width: '90%'
            }
        }, [
            setting.get('path'),
            ...loadedFilepaths
        ].map((path)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("option", {
                key: path,
                value: path
            }, path)))));
    };
    const renderOptionFields = (setting)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Is default file to load on startup?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('defaultOnStartup'),
            onToggle: toggleDefaultOnStartup
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, when you start organice, it will display your root file directory. If you prefer to display a specific Org file instead, enable this option. Enabling this option disables it for all other file settings.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Sync on startup?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('loadOnStartup'),
            onToggle: toggleLoadOnStartup
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, files are loaded from localStorage when available and are only synced when visited or when a sync is manually triggered. Enable this setting to always sync this file when opening organice.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Include in Agenda?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('includeInAgenda'),
            onToggle: toggleIncludeInAgenda
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, only the currently opened file is included in the agenda. Enable this setting to always include this file. The currently viewed file is always included.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Include in Search?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('includeInSearch'),
            onToggle: toggleIncludeInSearch
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, only the current viewed file is included in search. Enable this setting to always include this file. The currently loaded file is always included.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Include in Tasklist?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('includeInTasklist'),
            onToggle: toggleIncludeInTasklist
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, only the current viewed file is included in the tasklist. Enable this setting to always include this file. The currently loaded file is always included.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Include in Refile?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
            isEnabled: setting.get('includeInRefile'),
            onToggle: toggleIncludeInRefile
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__help-text"
        }, "By default, only the currently viewed file is available as a refile targets. Enable this setting to always include this file. The currently loaded file is always included.")));
    const renderDeleteButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting__field-container file-setting__delete-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn settings-btn file-setting__delete-button",
            onClick: handleDeleteClick
        }, "Delete setting"));
    const caretClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-2x fa-caret-right file-setting-container__header__caret', {
        'file-setting-container__header__caret--rotated': !isCollapsed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$f2a139e5d18b9882), {
        draggableId: `file-setting--${setting.get('path')}`,
        index: index
    }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('file-setting-container', {
                'file-setting-container--dragging': snapshot.isDragging
            }),
            ref: provided.innerRef
        }, provided.draggableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting-container__header",
            onClick: handleHeaderBarClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: caretClassName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting-icons"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('default-on-startup-icon', {
                'fas fa-bookmark fa-lg file-setting-icon': setting.get('defaultOnStartup')
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('load-on-startup-icon', {
                'fas fa-sync-alt fa-lg file-setting-icon': setting.get('loadOnStartup')
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))({
                'fas fa-calendar-alt fa-lg file-setting-icon': setting.get('includeInAgenda')
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))({
                'fas fa-search fa-lg file-setting-icon': setting.get('includeInSearch')
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))({
                'fas fa-tasks fa-lg file-setting-icon': setting.get('includeInTasklist')
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))({
                'fas fa-file-export fa-lg file-setting-icon': setting.get('includeInRefile')
            })
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "file_setting-container__header__title"
        }, setting.get('path')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", (0, $frurs._)({
            className: "fas fa-bars fa-lg file-setting-container__header__drag-handle"
        }, provided.dragHandleProps))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
            isOpened: !isCollapsed,
            springConfig: {
                stiffness: 300
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "file-setting-container__content"
        }, renderPathField(setting), renderOptionFields(setting), renderDeleteButton()))));
};




const $9a9478635bb2b437$var$FileSettingsEditor = ({ fileSettings: fileSettings, loadedFilepaths: loadedFilepaths, currentPathIfWithoutFileSetting: currentPathIfWithoutFileSetting, org: org })=>{
    const handleAddNewSettingClick = ()=>org.addNewEmptyFileSetting();
    const handleFieldPathUpdate = (settingId, fieldPath, newValue)=>org.updateFileSettingFieldPathValue(settingId, fieldPath, newValue);
    const handleDeleteSetting = (settingId)=>org.deleteFileSetting(settingId);
    const handleReorderSetting = (fromIndex, toIndex)=>org.reorderFileSetting(fromIndex, toIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$423ec2075359570a), {
        droppableId: "file-setting-editor-droppable",
        type: "FILE-SETTING"
    }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            className: "file-setting-container",
            ref: provided.innerRef
        }, provided.droppableProps), fileSettings.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "no-file-setting-message"
        }, "You don't currently have any file settings - add one by pressing the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus"
        }), " button.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "File settings allow you to configure how specific files are handeled when multiple files are loaded. Make sure a file is loaded to create a setting entry.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, fileSettings.map((setting, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $12e3458967bf1ac7$export$2e2bcd8739ae039), {
                key: setting.get('id'),
                index: index,
                setting: setting,
                path: currentPathIfWithoutFileSetting,
                loadedFilepaths: loadedFilepaths,
                onFieldPathUpdate: handleFieldPathUpdate,
                onDeleteSetting: handleDeleteSetting,
                onReorder: handleReorderSetting
            })), provided.placeholder))), loadedFilepaths.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "new-capture-template-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "fas fa-plus fa-lg btn btn--circle",
        onClick: handleAddNewSettingClick
    })));
};
const $9a9478635bb2b437$var$mapStateToProps = (state)=>{
    const path = state.base.get('lastViewedPath');
    const fileSettings = state.org.present.get('fileSettings', (0, $3044e0bef3624137$exports.List)());
    const existingSettings = fileSettings.map((setting)=>setting.get('path'));
    const paths = state.org.present.get('files', (0, $3044e0bef3624137$exports.List)()).keySeq();
    const currentPathIfWithoutFileSetting = !existingSettings.find((filePath)=>filePath === path) ? path : null;
    const loadedFilepaths = paths.filter((path)=>!path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6))).filter((path)=>!existingSettings.find((settingPath)=>settingPath === path)).toJS();
    return {
        fileSettings: fileSettings,
        loadedFilepaths: loadedFilepaths,
        currentPathIfWithoutFileSetting: currentPathIfWithoutFileSetting
    };
};
const $9a9478635bb2b437$var$mapDispatchToProps = (dispatch)=>{
    return {
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch)
    };
};
var $9a9478635bb2b437$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($9a9478635bb2b437$var$mapStateToProps, $9a9478635bb2b437$var$mapDispatchToProps)($9a9478635bb2b437$var$FileSettingsEditor);



var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");







var $1X5R2 = parcelRequire("1X5R2");

const $22559a246da289e5$var$SHOWN_KEY = 'organice.shownNotifications';
const $22559a246da289e5$var$MAX_TIMEOUT_MS = 2147483647;
const $22559a246da289e5$var$MAX_EVENTS = 50;
let $22559a246da289e5$var$timeoutIds = [];
const $22559a246da289e5$var$loadShown = ()=>{
    try {
        return JSON.parse(localStorage.getItem($22559a246da289e5$var$SHOWN_KEY) || '{}');
    } catch (e) {
        return {};
    }
};
const $22559a246da289e5$var$pruneShown = (shown, now)=>{
    const cutoff = now - 604800000;
    return Object.keys(shown).reduce((next, id)=>{
        if (shown[id] > cutoff) next[id] = shown[id];
        return next;
    }, {});
};
const $22559a246da289e5$var$markShown = (id)=>{
    try {
        const shown = $22559a246da289e5$var$pruneShown($22559a246da289e5$var$loadShown(), Date.now());
        shown[id] = Date.now();
        localStorage.setItem($22559a246da289e5$var$SHOWN_KEY, JSON.stringify(shown));
    } catch (e) {}
};
const $22559a246da289e5$var$hasBeenShown = (id)=>!!$22559a246da289e5$var$loadShown()[id];
const $22559a246da289e5$var$clearTimers = ()=>{
    $22559a246da289e5$var$timeoutIds.forEach((id)=>clearTimeout(id));
    $22559a246da289e5$var$timeoutIds = [];
};
const $22559a246da289e5$var$showNotification = async (event)=>{
    const options = {
        body: event.body,
        tag: event.id,
        renotify: true,
        data: {
            path: event.path,
            headerId: event.headerId
        },
        icon: '/organice-192x192.png'
    };
    try {
        const registration = await Promise.race([
            navigator.serviceWorker.ready,
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('timeout')), 500))
        ]);
        await registration.showNotification(event.title, options);
    } catch (e) {
        new Notification(event.title, options);
    }
};
const $22559a246da289e5$var$fireNotification = (event)=>{
    if ($22559a246da289e5$var$hasBeenShown(event.id)) return;
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    $22559a246da289e5$var$markShown(event.id);
    $22559a246da289e5$var$showNotification(event);
};
const $22559a246da289e5$var$syncSchedule = (state)=>{
    $22559a246da289e5$var$clearTimers();
    if (!(0, $ed01441649308ad3$export$579fdd47c8a73d75)() || Notification.permission !== 'granted') return;
    const settings = state.base.get('notificationSettings');
    const files = state.org.present.get('files');
    const events = (0, $ed01441649308ad3$export$3f42fefe1ac7e2e5)(files, settings, new Date()).slice(0, $22559a246da289e5$var$MAX_EVENTS);
    events.forEach((event)=>{
        if ($22559a246da289e5$var$hasBeenShown(event.id)) return;
        const delay = Math.max(0, event.fireAt.getTime() - Date.now());
        if (delay > $22559a246da289e5$var$MAX_TIMEOUT_MS) return;
        $22559a246da289e5$var$timeoutIds.push(setTimeout(()=>$22559a246da289e5$var$fireNotification(event), delay));
    });
};
const $22559a246da289e5$export$16e7a388eb6d6d1 = async ()=>{
    if (!(0, $ed01441649308ad3$export$579fdd47c8a73d75)()) return 'denied';
    if (Notification.permission === 'granted') return 'granted';
    if (Notification.permission === 'denied') return 'denied';
    return await Notification.requestPermission();
};
const $22559a246da289e5$export$9afcc1cbb81d94c6 = (store)=>{
    if (!(0, $ed01441649308ad3$export$579fdd47c8a73d75)()) return;
    const reschedule = (0, $1X5R2.debounce)(()=>{
        $22559a246da289e5$var$syncSchedule(store.getState());
    }, 1000);
    store.subscribe(reschedule);
    reschedule();
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') reschedule();
    });
};





var $1bxDW = parcelRequire("1bxDW");




var $d59d49549699e622$export$2e2bcd8739ae039 = ({ label: label, helpText: helpText, rule: rule, onToggle: onToggle, onValueChange: onValueChange, onUnitChange: onUnitChange })=>{
    if (!rule) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: !!rule.get('enabled'),
        onToggle: onToggle
    })), !!helpText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__help-text"
    }, helpText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
        isOpened: !!rule.get('enabled'),
        springConfig: {
            stiffness: 300
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-lead-time-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "number",
        min: "0",
        className: "textfield notification-lead-time-value-textfield",
        value: rule.get('value'),
        onChange: onValueChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $16ed2298da274255$export$2e2bcd8739ae039), {
        buttons: (0, $ed01441649308ad3$export$4168ce9e9312545b),
        titles: [
            'minutes',
            'hours',
            'days',
            'weeks'
        ],
        selectedButton: rule.get('unit'),
        onSelect: onUnitChange
    }))));
};



var $frurs = parcelRequire("frurs");

var $1bxDW = parcelRequire("1bxDW");





var $c02008489eab06c9$export$2e2bcd8739ae039 = ({ cadence: cadence, index: index, onFieldPathUpdate: onFieldPathUpdate, onDeleteCadence: onDeleteCadence })=>{
    const [isCollapsed, setIsCollapsed] = (0, $1bxDW.useState)(!!cadence.get('tag'));
    const handleHeaderBarClick = ()=>setIsCollapsed(!isCollapsed);
    const updateField = (fieldName)=>(event)=>onFieldPathUpdate(cadence.get('id'), [
                fieldName
            ], event.target.value);
    const toggleRule = (fieldName)=>()=>onFieldPathUpdate(cadence.get('id'), [
                fieldName,
                'enabled'
            ], !cadence.getIn([
                fieldName,
                'enabled'
            ]));
    const updateRuleValue = (fieldName)=>(event)=>onFieldPathUpdate(cadence.get('id'), [
                fieldName,
                'value'
            ], event.target.value);
    const updateRuleUnit = (fieldName)=>(newUnit)=>onFieldPathUpdate(cadence.get('id'), [
                fieldName,
                'unit'
            ], newUnit);
    const handleDeleteClick = ()=>{
        const tag = cadence.get('tag');
        const label = tag ? `:${tag}:` : 'this tag cadence';
        if (window.confirm(`Are you sure you want to delete ${label}?`)) onDeleteCadence(cadence.get('id'));
    };
    const caretClassName = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('fas fa-2x fa-caret-right notification-tag-cadence-container__header__caret', {
        'notification-tag-cadence-container__header__caret--rotated': !isCollapsed
    });
    const title = cadence.get('tag') ? `:${cadence.get('tag')}:` : 'New tag cadence';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$f2a139e5d18b9882), {
        draggableId: `notification-tag-cadence--${cadence.get('id')}`,
        index: index
    }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('notification-tag-cadence-container', {
                'notification-tag-cadence-container--dragging': snapshot.isDragging
            }),
            ref: provided.innerRef
        }, provided.draggableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-tag-cadence-container__header",
            onClick: handleHeaderBarClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: caretClassName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("span", {
            className: "notification-tag-cadence-container__header__title"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", (0, $frurs._)({
            className: "fas fa-bars fa-lg notification-tag-cadence-container__header__drag-handle"
        }, provided.dragHandleProps))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $e736e5dad298f90b$exports.UnmountClosed), {
            isOpened: !isCollapsed,
            springConfig: {
                stiffness: 300
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-tag-cadence-container__content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-setting__field-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-setting__field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Tag:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
            type: "text",
            className: "textfield",
            placeholder: "e.g., meeting",
            value: cadence.get('tag', ''),
            onChange: updateField('tag'),
            autoCapitalize: "none",
            autoCorrect: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-setting__help-text"
        }, "Headings with this tag use this cadence instead of the default reminders.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
            label: "Scheduled",
            rule: cadence.get('scheduled'),
            onToggle: toggleRule('scheduled'),
            onValueChange: updateRuleValue('scheduled'),
            onUnitChange: updateRuleUnit('scheduled')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
            label: "Deadline",
            rule: cadence.get('deadline'),
            onToggle: toggleRule('deadline'),
            onValueChange: updateRuleValue('deadline'),
            onUnitChange: updateRuleUnit('deadline')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
            label: "Timestamp",
            rule: cadence.get('timestamp'),
            onToggle: toggleRule('timestamp'),
            onValueChange: updateRuleValue('timestamp'),
            onUnitChange: updateRuleUnit('timestamp')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "notification-setting__field-container notification-tag-cadence__delete-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
            className: "btn settings-btn notification-tag-cadence__delete-button",
            onClick: handleDeleteClick
        }, "Delete cadence"))))));
};


const $b64ef66710bd46c2$var$NotificationsEditor = ({ notificationSettings: notificationSettings, base: base })=>{
    const settings = notificationSettings || (0, $ed01441649308ad3$export$c0d1f3814120bd33);
    const supported = (0, $ed01441649308ad3$export$579fdd47c8a73d75)();
    const disabledReason = (0, $ed01441649308ad3$export$7923a88bdb944eb9)();
    const tagCadences = settings.get('tagCadences', (0, $3044e0bef3624137$exports.List)());
    const handleEnabledToggle = async ()=>{
        if (settings.get('enabled')) {
            base.updateNotificationSettingsFieldPathValue([
                'enabled'
            ], false);
            return;
        }
        const permission = await (0, $22559a246da289e5$export$16e7a388eb6d6d1)();
        if (permission === 'granted') base.updateNotificationSettingsFieldPathValue([
            'enabled'
        ], true);
        else alert('Notifications permission was not granted. You can enable it later in your browser settings.');
    };
    const toggleRule = (fieldName)=>()=>base.updateNotificationSettingsFieldPathValue([
                fieldName,
                'enabled'
            ], !settings.getIn([
                fieldName,
                'enabled'
            ]));
    const updateRuleValue = (fieldName)=>(event)=>base.updateNotificationSettingsFieldPathValue([
                fieldName,
                'value'
            ], event.target.value);
    const updateRuleUnit = (fieldName)=>(newUnit)=>base.updateNotificationSettingsFieldPathValue([
                fieldName,
                'unit'
            ], newUnit);
    const handleAddNewCadenceClick = ()=>base.addNewEmptyNotificationTagCadence();
    const handleFieldPathUpdate = (cadenceId, fieldPath, newValue)=>base.updateNotificationTagCadenceFieldPathValue(cadenceId, fieldPath, newValue);
    const handleDeleteCadence = (cadenceId)=>base.deleteNotificationTagCadence(cadenceId);
    if (!supported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "no-notifications-message"
    }, disabledReason, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("br", null), "Notifications use the Web Push API and are disabled in this browser.");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notifications-editor-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notifications-editor-defaults"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__field-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, "Enable notifications"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $a97aa5012fd62680$export$2e2bcd8739ae039), {
        isEnabled: !!settings.get('enabled'),
        onToggle: handleEnabledToggle
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__help-text"
    }, 'Reminders are scheduled locally from currently loaded Org files and shown by your browser. Keep organice open (or installed as an app) so they can fire. Enable "Sync on startup" in File settings for files you want reminders from.')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
        label: "Scheduled",
        helpText: "Notify this long before a SCHEDULED timestamp.",
        rule: settings.get('scheduled'),
        onToggle: toggleRule('scheduled'),
        onValueChange: updateRuleValue('scheduled'),
        onUnitChange: updateRuleUnit('scheduled')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
        label: "Deadline",
        helpText: "Notify this long before a DEADLINE timestamp.",
        rule: settings.get('deadline'),
        onToggle: toggleRule('deadline'),
        onValueChange: updateRuleValue('deadline'),
        onUnitChange: updateRuleUnit('deadline')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $d59d49549699e622$export$2e2bcd8739ae039), {
        label: "Timestamp",
        helpText: "Notify this long before an active timestamp in a heading title or description.",
        rule: settings.get('timestamp'),
        onToggle: toggleRule('timestamp'),
        onValueChange: updateRuleValue('timestamp'),
        onUnitChange: updateRuleUnit('timestamp')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notifications-editor-section-title"
    }, "Tag cadences"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "notification-setting__help-text",
        style: {
            margin: '0 10px 10px'
        }
    }, "Headings with a matching tag use that cadence instead of the default reminders above. Add more than one cadence for the same tag to get multiple reminders."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$423ec2075359570a), {
        droppableId: "notification-tag-cadences-droppable",
        type: "NOTIFICATION-TAG-CADENCE"
    }, (provided)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", (0, $frurs._)({
            ref: provided.innerRef
        }, provided.droppableProps), tagCadences.size === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "no-notifications-message"
        }, "You don't currently have any tag cadences - add one by pressing the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("i", {
            className: "fas fa-plus"
        }), " button.") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, tagCadences.map((cadence, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $c02008489eab06c9$export$2e2bcd8739ae039), {
                key: cadence.get('id'),
                index: index,
                cadence: cadence,
                onFieldPathUpdate: handleFieldPathUpdate,
                onDeleteCadence: handleDeleteCadence
            })), provided.placeholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "new-capture-template-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("button", {
        className: "fas fa-plus fa-lg btn btn--circle",
        onClick: handleAddNewCadenceClick
    })));
};
const $b64ef66710bd46c2$var$mapStateToProps = (state)=>({
        notificationSettings: state.base.get('notificationSettings')
    });
const $b64ef66710bd46c2$var$mapDispatchToProps = (dispatch)=>({
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    });
var $b64ef66710bd46c2$export$2e2bcd8739ae039 = (0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($b64ef66710bd46c2$var$mapStateToProps, $b64ef66710bd46c2$var$mapDispatchToProps)($b64ef66710bd46c2$var$NotificationsEditor);






class $1b3a0533a26055d4$var$Entry extends (0, $1bxDW.PureComponent) {
    componentDidMount() {
        this.setChangelogUnseenChanges();
        this.props.filesToLoad.forEach((path)=>this.props.syncBackend.downloadFile(path));
        this.props.filesToSync.forEach((path)=>this.props.org.sync({
                path: path
            }));
    }
    // TODO: Should this maybe done on init of the application and not in the component?
    setChangelogUnseenChanges() {
        const { lastSeenChangelogHash: lastSeenChangelogHash, isAuthenticated: isAuthenticated } = this.props;
        (0, $2ce140c2c56df8f2$export$4188a0eec4f54d73)().then((changelogHash)=>{
            const hasChanged = isAuthenticated && lastSeenChangelogHash && !(0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).isEqual(changelogHash, lastSeenChangelogHash);
            this.props.base.setHasUnseenChangelog(hasChanged);
        });
    }
    componentDidUpdate() {
        this.shouldPromptWhenLeaving() ? window.onbeforeunload = ()=>true : window.onbeforeunload = undefined;
    }
    componentWillUnmount() {
        window.onbeforeunload = undefined;
    }
    renderChangelogFile() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $484aff953b4cb90f$export$2e2bcd8739ae039), {
            staticFile: "changelog",
            shouldDisableDirtyIndicator: true,
            shouldDisableActions: true,
            shouldDisableSyncButtons: false,
            parsingErrorMessage: "The contents of changelog.org couldn't be loaded. You probably forgot to set the environment variable - see the Development section of README.org for details!"
        });
    }
    renderSampleFile() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $484aff953b4cb90f$export$2e2bcd8739ae039), {
            staticFile: "sample",
            shouldDisableDirtyIndicator: true,
            shouldDisableActionDrawer: false,
            shouldDisableSyncButtons: true,
            parsingErrorMessage: "The contents of sample.org couldn't be loaded. You probably forgot to set the environment variable - see the Development section of README.org for details!"
        });
    }
    renderFileBrowser({ match: { params: { path: path = '' } } }) {
        if (!!path) path = '/' + path;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $baec0e505123760e$export$2e2bcd8739ae039), {
            path: path
        });
    }
    renderFile({ match: { params: { path: path } } }) {
        if (!!path) path = '/' + path;
        if (this.props.path && !this.props.path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6)) && this.props.path !== path) {
            this.props.org.sync({
                path: this.props.path
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
                push: true,
                to: '/file' + this.props.path
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $484aff953b4cb90f$export$2e2bcd8739ae039), {
            path: path,
            shouldDisableDirtyIndicator: false,
            shouldDisableActionDrawer: false,
            shouldDisableSyncButtons: false
        });
    }
    shouldPromptWhenLeaving() {
        return this.props.hasDirtyFiles;
    }
    render() {
        const { isAuthenticated: isAuthenticated, loadingMessage: loadingMessage, fontSize: fontSize, activeModalPage: activeModalPage, pendingCapture: pendingCapture, location: { pathname: pathname }, colorScheme: colorScheme, theme: theme, defaultFilePath: defaultFilePath } = this.props;
        (0, $e842057b65187aa8$export$a1d87755f3c9500d)(theme, colorScheme);
        const pendingCapturePath = !!pendingCapture && `/file${pendingCapture.get('capturePath')}`;
        const shouldRedirectToCapturePath = pendingCapturePath && pendingCapturePath !== pathname;
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($de7b5d8041e703b4$exports)))('App entry-container', {
            'entry-container--large-font': fontSize === 'Large'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5b40eb0040d9e9a9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $85c8f4ef3a726095$export$2e2bcd8739ae039), {
            message: loadingMessage
        }), isAuthenticated && ([
            'changelog',
            'keyboard_shortcuts_editor',
            'settings',
            'capture_templates_editor',
            'file_settings_editor',
            'notifications_editor',
            'sample'
        ].includes(activeModalPage) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Fragment), null, activeModalPage === 'keyboard_shortcuts_editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $f26688d0a3e01ed8$export$2e2bcd8739ae039), null), activeModalPage === 'capture_templates_editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $2bd045ad55561335$export$2e2bcd8739ae039), null), activeModalPage === 'file_settings_editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9a9478635bb2b437$export$2e2bcd8739ae039), null), activeModalPage === 'notifications_editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $b64ef66710bd46c2$export$2e2bcd8739ae039), null), activeModalPage === 'changelog' && this.renderChangelogFile(), activeModalPage === 'sample' && this.renderSampleFile()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Switch), null, shouldRedirectToCapturePath && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
            to: pendingCapturePath
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/privacy-policy",
            exact: true,
            component: (0, $b0ebeb906b6a375c$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/file/:path+",
            render: this.renderFile
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/files/:path*",
            render: this.renderFileBrowser
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/sample",
            exact: true,
            render: this.renderSampleFile
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/changelog",
            exact: true,
            render: this.renderChangelogFile
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
            path: "/settings",
            exact: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $2c39408185ce71f2$export$2e2bcd8739ae039), null)), defaultFilePath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
            to: defaultFilePath
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
            to: "/files"
        }))));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'renderChangelogFile',
            'renderSampleFile',
            'renderFileBrowser',
            'renderFile',
            'setChangelogUnseenChanges'
        ]);
    }
}
const $1b3a0533a26055d4$var$mapStateToProps = (state)=>{
    const files = state.org.present.get('files');
    const path = state.org.present.get('path');
    const defaultFilePath = state.org.present.get('fileSettings').filter((setting)=>setting.get('defaultOnStartup')).map((setting)=>`file${setting.get('path')}`).first();
    const filesToLoadOnStartup = state.org.present.get('fileSettings').filter((setting)=>setting.get('loadOnStartup')).map((setting)=>setting.get('path'));
    const loadedFiles = (0, $3044e0bef3624137$exports.Set).fromKeys(files);
    const fileIsLoaded = (path)=>loadedFiles.includes(path);
    const filesToLoad = filesToLoadOnStartup.filter((path)=>!fileIsLoaded(path));
    const filesToSync = filesToLoadOnStartup.filter((path)=>fileIsLoaded(path));
    const hasDirtyFiles = !!files.find((file)=>file.get('isDirty'));
    return {
        path: path,
        filesToLoad: filesToLoad,
        filesToSync: filesToSync,
        defaultFilePath: defaultFilePath,
        loadingMessage: state.base.get('loadingMessage'),
        isAuthenticated: state.syncBackend.get('isAuthenticated'),
        fontSize: state.base.get('fontSize'),
        lastSeenChangelogHash: state.base.get('lastSeenChangelogHash'),
        activeModalPage: state.base.get('modalPageStack', (0, $3044e0bef3624137$exports.List)()).last(),
        pendingCapture: state.org.present.get('pendingCapture'),
        hasDirtyFiles: hasDirtyFiles,
        colorScheme: state.base.get('colorScheme'),
        theme: state.base.get('theme'),
        osColorSchemeChangeCount: state.base.get('osColorSchemeChangeCount')
    };
};
const $1b3a0533a26055d4$var$mapDispatchToProps = (dispatch)=>{
    return {
        syncBackend: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($f257bd084a67bcde$exports, dispatch),
        org: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($d81b80734fbc24a5$exports, dispatch),
        base: (0, $7bd5d83317c8c48a$export$aea084d96e84da92)($1780206710f3c846$exports, dispatch)
    };
};
var $1b3a0533a26055d4$export$2e2bcd8739ae039 = (0, $3vC7t.withRouter)((0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($1b3a0533a26055d4$var$mapStateToProps, $1b3a0533a26055d4$var$mapDispatchToProps)($1b3a0533a26055d4$var$Entry));



/* global process */ 
var $1bxDW = parcelRequire("1bxDW");

var $9e6b91dde1a9931d$exports = {};
$9e6b91dde1a9931d$exports = $parcel$resolve("edQdo");


var $6ff50cb9fbe62746$exports = {};
$6ff50cb9fbe62746$exports = $parcel$resolve("gd84Y");






var $1X5R2 = parcelRequire("1X5R2");
function $884803c06292b999$var$WebDAVForm() {
    const [isVisible, setIsVisible] = (0, $1bxDW.useState)(false);
    const toggleVisible = ()=>setIsVisible(!isVisible);
    const [url, setUrl] = (0, $1bxDW.useState)("ORGANICE_WEBDAV_URL");
    const [username, setUsername] = (0, $1bxDW.useState)('');
    const [password, setPassword] = (0, $1bxDW.useState)('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        id: "webdavLogin"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("h2", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: "#webdav",
        onClick: toggleVisible,
        style: {
            textDecoration: 'none'
        }
    }, "WebDAV")), isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('authenticatedSyncService', 'WebDAV');
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('webdavEndpoint', url);
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('webdavUsername', username);
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('webdavPassword', password);
            window.location = window.location.origin + '/';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("label", {
        htmlFor: "input-webdav-url"
    }, "URL:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        id: "input-webdav-url",
        name: "url",
        type: "url",
        value: url,
        className: "textfield",
        onChange: (e)=>{
            setUrl(e.target.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("label", {
        htmlFor: "input-webdav-user"
    }, "Username:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        id: "input-webdav-user",
        type: "text",
        className: "textfield",
        value: username,
        onChange: (e)=>{
            setUsername(e.target.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("label", {
        htmlFor: "input-webdav-password"
    }, "Password:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        id: "input-webdav-password",
        type: "password",
        className: "textfield",
        value: password,
        onChange: (e)=>{
            setPassword(e.target.value);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "submit",
        value: "Sign-in"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, "Please make sure your WebDAV backend meets the requirements as documented", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: "https://organice.200ok.ch/documentation.html#faq_webdav",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "here"), ", especially", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: "https://organice.200ok.ch/documentation.html#webdav_cors",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "CORS"), ".")));
}
function $884803c06292b999$var$GitLab() {
    const [isVisible, setIsVisible] = (0, $1bxDW.useState)(false);
    const toggleVisible = ()=>setIsVisible(!isVisible);
    const defaultProject = 'https://gitlab.com/your/project';
    const [project, setProject] = (0, $1bxDW.useState)(defaultProject);
    const handleSubmit = (evt)=>{
        evt.preventDefault();
        const projectId = (0, $829b8feac63cffab$export$aa55a4a49c69d614)(project);
        if (projectId) {
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('authenticatedSyncService', 'GitLab');
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('gitLabProject', projectId);
            (0, $829b8feac63cffab$export$ffa9969dec63837)().fetchAuthorizationCode();
        } else alert('Project does not appear to be a valid gitlab.com URL');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
        href: "#gitlab",
        onClick: toggleVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6ff50cb9fbe62746$exports))),
        alt: "GitLab logo"
    })), isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("label", {
        htmlFor: "input-gitlab-project"
    }, "Project:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        id: "input-gitlab-project",
        type: "url",
        className: "textfield",
        placeholder: defaultProject,
        value: project,
        onChange: (e)=>setProject(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("input", {
        type: "submit",
        value: "Sign-in"
    })));
}
class $884803c06292b999$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleDropboxClick() {
        (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('authenticatedSyncService', 'Dropbox');
        const REDIRECT_URI = window.location.origin + '/';
        const dbxAuth = new (0, $1044f5047434e84b$exports.DropboxAuth)({
            clientId: "ORGANICE_DROPBOX_CLIENT_ID",
            fetch: fetch.bind(window)
        });
        dbxAuth.getAuthenticationUrl(REDIRECT_URI, undefined, 'code', 'offline', undefined, undefined, true).then((authUrl)=>{
            (0, $18ca84fc585e0c6b$export$ca245e5e511e4680)('codeVerifier', dbxAuth.codeVerifier);
            window.location.href = authUrl;
        }).catch((error)=>console.error(error));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "sync-service-sign-in-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", {
            className: "sync-service-sign-in__help-text"
        }, "organice syncs your files with Dropbox, GitLab, and WebDAV."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("p", {
            className: "sync-service-sign-in__help-text"
        }, "Click to sign in with:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "sync-service-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
            href: "#dropbox",
            onClick: this.handleDropboxClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9e6b91dde1a9931d$exports))),
            alt: "Dropbox logo",
            className: "dropbox-logo"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "sync-service-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($884803c06292b999$var$GitLab, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "sync-service-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($884803c06292b999$var$WebDAVForm, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("footer", null, "For questions regarding synchronization back-ends, please consult the", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("a", {
            href: "https://organice.200ok.ch/documentation.html#sync_backends",
            target: "_blank",
            rel: "noopener noreferrer"
        }, "documentation"), "."));
    }
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleDropboxClick'
        ]);
    }
}





// Lazy load Landing so its dependencies (FontAwesome JS) are not bundled into the main app.
// This prevents the FontAwesome JS from executing and freezing the main app on load.
// See: https://github.com/200ok-ch/organice/pull/1091
const $fc8285d5eaa9fbf2$var$Landing = /*#__PURE__*/ (0, $1bxDW.lazy)(()=>(parcelRequire("3lZeK")));
const $fc8285d5eaa9fbf2$var$Turnout = ({ isAuthenticated: isAuthenticated })=>{
    if (isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1b3a0533a26055d4$export$2e2bcd8739ae039), null);
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Switch), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
        path: "/privacy-policy",
        exact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "App entry-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5b40eb0040d9e9a9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $b0ebeb906b6a375c$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
        path: "/sample",
        exact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "App entry-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5b40eb0040d9e9a9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $484aff953b4cb90f$export$2e2bcd8739ae039), {
        staticFile: "sample",
        shouldDisableDirtyIndicator: true,
        shouldDisableActionDrawer: false,
        shouldDisableSyncButtons: true,
        parsingErrorMessage: "The contents of sample.org couldn't be loaded. You probably forgot to set the environment variable - see the Development section of README.org for details!"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
        path: "/sign_in",
        exact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "App entry-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5b40eb0040d9e9a9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $884803c06292b999$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Route), {
        path: "/",
        exact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $1bxDW.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
            className: "App landing-page"
        }, "Loading...")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement("div", {
        className: "App landing-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement($fc8285d5eaa9fbf2$var$Landing, null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $3vC7t.Redirect), {
        to: "/"
    })));
};
const $fc8285d5eaa9fbf2$var$mapStateToProps = (state)=>{
    return {
        isAuthenticated: state.syncBackend.get('isAuthenticated')
    };
};
var $fc8285d5eaa9fbf2$export$2e2bcd8739ae039 = (0, $3vC7t.withRouter)((0, $3437c6fbf7b3faa7$export$2e2bcd8739ae039)($fc8285d5eaa9fbf2$var$mapStateToProps)($fc8285d5eaa9fbf2$var$Turnout));



var $1X5R2 = parcelRequire("1X5R2");



function $7b04ed81e9069fb8$export$661beabea8a5bdf8(store) {
    // Is the user online when starting up the application?
    store.dispatch((0, $1780206710f3c846$export$7c40ec7552034cd7)(navigator.onLine));
    window.onoffline = function() {
        store.dispatch((0, $1780206710f3c846$export$7c40ec7552034cd7)(false));
    };
    window.ononline = function() {
        store.dispatch((0, $1780206710f3c846$export$7c40ec7552034cd7)(true));
        // Add grace period, because browsers might get the event `onLine`
        // too soon to actually do network requests.
        setTimeout(()=>{
            (0, $d81b80734fbc24a5$export$92d6409d68f0739a)({
                shouldSuppressMessages: true,
                forceAction: 'manual'
            })(store.dispatch, store.getState);
        }, 2000);
    };
}
function $7b04ed81e9069fb8$export$2d5f85a93406b01c(store) {
    const path = store.getState().org.present.get('path');
    const urlPathMatch = window.location.href.match(/.*file(\/.*)/);
    let urlPath = path;
    // The user has gone 'back' or 'forward' and is showing a 'file'
    // URL.
    if (urlPathMatch) urlPath = urlPathMatch[1];
    window.onpopstate = function() {
        // If the current 'path' in Redux is not the same as the one in
        // the URL.
        if (path !== urlPath) store.dispatch((0, $d81b80734fbc24a5$export$1518ffc4a8ff94f2)(path));
    };
}
// BEGIN: Sync on Becoming Visible
const $7b04ed81e9069fb8$var$dispatchSync = (store)=>{
    if (store.getState().syncBackend.get('client') && store.getState().base.get('shouldSyncOnBecomingVisibile')) {
        const path = store.getState().org.present.get('path');
        let filesToLoadOnStartup = store.getState().org.present.get('fileSettings').filter((setting)=>setting.get('loadOnStartup')).map((setting)=>setting.get('path'));
        if (path && !path.startsWith((0, $2ce140c2c56df8f2$export$33411e7e5f33b9f6)) && !filesToLoadOnStartup.find((filepath)=>path === filepath)) filesToLoadOnStartup = filesToLoadOnStartup.push(path);
        filesToLoadOnStartup.forEach((path)=>{
            (0, $d81b80734fbc24a5$export$92d6409d68f0739a)({
                path: path,
                shouldSuppressMessages: true
            })(store.dispatch, store.getState);
        });
    }
};
// The 'visibilitychange' event might get triggered in some browsers
// many times for one 'real' event of the browser becoming visible to
// the user. Debouncing through lodash ensures that it is called at
// maximum once every second.
const $7b04ed81e9069fb8$var$debouncedDispatchSync = (0, $1X5R2.debounce)($7b04ed81e9069fb8$var$dispatchSync, 1000);
// Dealing with vendor prefixes
function $7b04ed81e9069fb8$var$getHiddenProp() {
    const prefixes = [
        'webkit',
        'moz',
        'ms',
        'o'
    ];
    // if 'hidden' is natively supported just return it
    if ('hidden' in document) return 'hidden';
    // otherwise loop over all the known prefixes until we find one
    for(let i = 0; i < prefixes.length; i++){
        if (prefixes[i] + 'Hidden' in document) return prefixes[i] + 'Hidden';
    }
    // otherwise it's not supported
    return null;
}
function $7b04ed81e9069fb8$export$b505af49effafa20(store) {
    let visProp = $7b04ed81e9069fb8$var$getHiddenProp();
    if (visProp) {
        const evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange';
        document.addEventListener(evtname, ()=>$7b04ed81e9069fb8$var$debouncedDispatchSync(store));
    }
} // END: Sync on Becoming Visible




var $1X5R2 = parcelRequire("1X5R2");


// do handle hotkeys even if they come from within 'input', 'select' or 'textarea'
(0, $089ff2866ffa338a$exports.configure)({
    ignoreTags: []
});
const $f330655b63a50b1c$var$handleGitLabAuthResponse = async (oauthClient)=>{
    let success = false;
    try {
        success = await oauthClient.isReturningFromAuthServer();
        await oauthClient.getAccessToken();
    } catch (e) {
        success = false;
    }
    if (!success) {
        // Edge case: somehow OAuth success redirect occurred but there isn't a code in
        // the current location's search params. This /shouldn't/ happen in practice.
        alert('Unexpected sign in error, please try again');
        return;
    }
    const syncClient = (0, $829b8feac63cffab$export$2e2bcd8739ae039)(oauthClient);
    const isAccessible = await syncClient.isProjectAccessible();
    if (!isAccessible) alert('Failed to access GitLab project - is the URL correct?');
    else window.location.search = '';
};
class $f330655b63a50b1c$export$2e2bcd8739ae039 extends (0, $1bxDW.PureComponent) {
    handleDragEnd(result) {
        if (!result.destination) return;
        if (result.type === 'TAG') this.store.dispatch((0, $d81b80734fbc24a5$export$3ef4f30cf2ff5820)(result.source.index, result.destination.index));
        else if (result.type === 'PROPERTY-LIST') this.store.dispatch((0, $d81b80734fbc24a5$export$49c84db8dca423dc)(result.source.index, result.destination.index));
        else if (result.type === 'CAPTURE-TEMPLATE') this.store.dispatch((0, $3e461505c3a6d1b3$export$e6b7d73046e81cf)(result.source.index, result.destination.index));
        else if (result.type === 'FILE-SETTING') this.store.dispatch((0, $d81b80734fbc24a5$export$1598048bf82d0a0a)(result.source.index, result.destination.index));
        else if (result.type === 'NOTIFICATION-TAG-CADENCE') this.store.dispatch((0, $1780206710f3c846$export$a6e4ea47c8aa5e07)(result.source.index, result.destination.index));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $5e954cbb8bebfdf5$export$237bd83162c14364), {
            onDragEnd: this.handleDragEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $9zQbc.BrowserRouter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $10bb4a4d86cc6e39$export$2e2bcd8739ae039), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $fc8285d5eaa9fbf2$export$2e2bcd8739ae039), null))));
    }
    constructor(props){
        super(props);
        (0, $b4cd3ce36352439b$export$2e2bcd8739ae039)();
        const initialState = (0, $18ca84fc585e0c6b$export$6ac7cb0c13076777)();
        const authenticatedSyncService = (0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('authenticatedSyncService', true);
        let client = null;
        if (!!authenticatedSyncService) switch(authenticatedSyncService){
            case 'Dropbox':
                client = (0, $e81a3f4b139bb8ca$export$2e2bcd8739ae039)();
                initialState.syncBackend = (0, $3044e0bef3624137$exports.Map)({
                    isAuthenticated: true,
                    client: client
                });
                break;
            case 'GitLab':
                const gitlabOAuth = (0, $829b8feac63cffab$export$ffa9969dec63837)();
                if (gitlabOAuth.isAuthorized()) {
                    client = (0, $829b8feac63cffab$export$2e2bcd8739ae039)(gitlabOAuth);
                    initialState.syncBackend = (0, $3044e0bef3624137$exports.Map)({
                        isAuthenticated: true,
                        client: client
                    });
                } else $f330655b63a50b1c$var$handleGitLabAuthResponse(gitlabOAuth);
                break;
            case 'WebDAV':
                client = (0, $bc2c83d4c6613e8d$export$2e2bcd8739ae039)((0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('webdavEndpoint'), (0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('webdavUsername'), (0, $18ca84fc585e0c6b$export$d80763eacb68b9dc)('webdavPassword'));
                initialState.syncBackend = (0, $3044e0bef3624137$exports.Map)({
                    isAuthenticated: true,
                    client: client
                });
                break;
            default:
        }
        const queryStringContents = (0, $4d1c34ada8668736$export$2e2bcd8739ae039)(window.location.search);
        const { captureFile: captureFile, captureTemplateName: captureTemplateName, captureContent: captureContent } = queryStringContents;
        if (!!captureFile && !!captureTemplateName) {
            const capturePath = captureFile.startsWith('/') ? captureFile : `/${captureFile}`;
            const customCaptureVariables = (0, $3044e0bef3624137$exports.Map)(Object.entries(queryStringContents).map(([key, value])=>{
                const CUSTOM_VARIABLE_PREFIX = 'captureVariable_';
                if (key.startsWith(CUSTOM_VARIABLE_PREFIX)) return [
                    key.substring(CUSTOM_VARIABLE_PREFIX.length),
                    value
                ];
                return null;
            }).filter((item)=>!!item));
            initialState.org.present = initialState.org.present.set('pendingCapture', (0, $3044e0bef3624137$exports.Map)({
                capturePath: capturePath,
                captureTemplateName: captureTemplateName,
                captureContent: captureContent,
                customCaptureVariables: customCaptureVariables
            }));
        }
        this.store = (0, $6f4738818a79416e$export$2e2bcd8739ae039)(initialState);
        this.store.subscribe((0, $18ca84fc585e0c6b$export$92924a31c70e422)(this.store));
        if (!!client) client.isSignedIn().then((isSignedIn)=>{
            if (isSignedIn) (0, $18ca84fc585e0c6b$export$79964713880960f6)(this.store.dispatch, this.store.getState);
            else this.store.dispatch((0, $f257bd084a67bcde$export$b0ac3a1c242cb1ea)());
        });
        else if (!!this.store.getState().org.present.get('pendingCapture')) this.store.dispatch((0, $1780206710f3c846$export$dcd62ed1bd1c13ec)(`You need to sign in before you can use capture templates`, 5000));
        // Load static files.
        this.store.dispatch((0, $1780206710f3c846$export$7b70d0006c6937c5)('sample'));
        this.store.dispatch((0, $1780206710f3c846$export$7b70d0006c6937c5)('changelog'));
        (0, $7b04ed81e9069fb8$export$2d5f85a93406b01c)(this.store);
        (0, $7b04ed81e9069fb8$export$b505af49effafa20)(this.store);
        (0, $7b04ed81e9069fb8$export$661beabea8a5bdf8)(this.store);
        (0, $22559a246da289e5$export$9afcc1cbb81d94c6)(this.store);
        (0, (/*@__PURE__*/$parcel$interopDefault($1X5R2))).bindAll(this, [
            'handleDragEnd'
        ]);
    }
}


const $6a5f71e96e9836c3$var$rootElement = document.getElementById('root');
function $6a5f71e96e9836c3$var$render() {
    (0, (/*@__PURE__*/$parcel$interopDefault($c63f56900e1488fc$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1bxDW))).createElement((0, $f330655b63a50b1c$export$2e2bcd8739ae039), null), $6a5f71e96e9836c3$var$rootElement);
}
$6a5f71e96e9836c3$var$render();
// Remove Parcel error overlay for e2e testing
// See: https://github.com/parcel-bundler/parcel/issues/9738
// The overlay intercepts pointer events when running e2e tests after jest
if (typeof window !== 'undefined') {
    const removeParcelErrorOverlay = ()=>{
        const overlay = document.querySelector('parcel-error-overlay');
        if (overlay) overlay.remove();
    };
    // Remove immediately
    removeParcelErrorOverlay();
    // Watch for overlay being added
    const observer = new MutationObserver(()=>{
        removeParcelErrorOverlay();
    });
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}
// Enable Hot Module Replacement (full reload for ES modules)
if (null) null.accept();

})();
//# sourceMappingURL=public.a065fe3b.js.map
